(function () {
  'use strict';
  angular.module('app.restricted.licenses', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.licenses', {
      url: '/licenses',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/platform/licenses/license.html',
          controller: 'licenseController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('license_resource','GET')
        }
      }

    });

   // $translatePartialLoaderProvider.addPart('app/main/restricted/platform/licenses');


    // Navigation
    msNavigationServiceProvider.saveItem('Platform.licenses', {
      title: 'Licenses',
      icon: '',
      state: 'app.restricted.licenses',
      translate: 'NAVIGATION_LICENSES',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.licenses')
    .component('permissionListTemplate', {
      templateUrl: 'app/main/restricted/platform/licenses/tabs/templates/details/permission-component/permission.component.html',
      controller: permissionController,
      controllerAs: 'vm',
      bindings: {
        "permissionName": "<",
        "permissionSubItemName": "<",
        "permissionSubItem": "=",
        "permissionVisible": "=",
        "permissionItem": "=",
        "multiSession": "=",
        "showSubItem": "<",
        "isEdit": "<"
      }
    });

  /** @ngInject */
  function permissionController() {
    var vm = this;

    vm.changeParentItem = changeParentItem;
    vm.visibleChange = visibleChange;
    vm.isSubItem = isSubItem;


    function changeParentItem() {
      if (typeof vm.permissionSubItem === undefined) {
        console.log(typeof(vm.permissionSubItem));
      }
      else{
        if (vm.multiSession)
          vm.permissionSubItem = "1";
        else
        {
          if(vm.permissionSubItem)
            vm.permissionSubItem = vm.permissionItem;
        }
      }
    }

    function visibleChange() {
      vm.permissionItem = vm.permissionVisible;
      if (vm.permissionSubItem) {
        vm.permissionSubItem = vm.permissionVisible;
      }
    }

    function isSubItem() {
      return typeof vm.permissionSubItem !== undefined;
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.restricted.organization-manager', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.organization-manager', {
      url: '/organization-manager?rootId',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/reseller/organization-manager/organization.manager.html',
          controller: 'OrganizationManagerController as vm',
          resolve: {
            'resellers': ['Reseller', function (Reseller) {
              return  Reseller.getList();
            }],

            isViewAllowed: function(Auth){
               Auth.ActionResolver('reseller_resource','GET')
            }

          }
        }
      }
    });

    // Translation
  //  $translatePartialLoaderProvider.addPart('app/main/restricted/reseller/organization-manager');

    // Navigation
    msNavigationServiceProvider.saveItem('Reseller.organization-manager', {
      title: 'Organization Manager',
      icon: '',
      state: 'app.restricted.organization-manager',
      translate: 'NAVIGATION_ORG_MANAGER',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.organization-manager')
    .controller('affiliatedContactsDialogController',affiliatedContactsDialogController);
  
    /** @ngInject*/
    function affiliatedContactsDialogController($q, $scope, subscriber, organization, Subscriber, PersonalContacts, Group, OrgFriends, $mdDialog) {
      var vm = this;

      vm.affiliatedContactsPagination = "affiliatedContacts"
      vm.affiliatedTemplatesPagination = "affiliatedTemplats"
      vm.subscriber = subscriber;
      vm.organization = organization;
      vm.ok = ok;
      vm.cancel = cancel;

      vm.selectedTemplates = [];
      vm.unselectedTemplates = vm.contactTemplates;

      vm.loading = false;
      vm.allSubscribers = [];

      

      function getOrgFriends() {
        return new Promise(function (resolve, reject) {
          OrgFriends.getByOrgId(vm.organization._id)
            .then(function (resp) {
              vm.orgsFriends = resp;
              vm.orgsFriends.push(vm.organization)
              resolve();
            })
            .catch(function (e) {
              if (e.status !== 404) reject(e)
              else {
                vm.orgsFriends = [vm.orgsFriends];
                resolve();
              }
            });
        });
      }
  
      init();

      function init(){
        vm.loading = true;
        vm.contacts = [];
        vm.orgFriendsMap = [];
        var flowFunctionsArray = [];

        var PERMISSION_MASK_DISPATCHER = 0x80;
        vm.subscriber.dispathcer = (Boolean(vm.subscriber.permissions_mask & PERMISSION_MASK_DISPATCHER)) ? true : false;

        getOrgFriends().then(function(){
          vm.selectedDropDown = vm.orgsFriends[vm.orgsFriends.length - 1]._id;
          flowFunctionsArray.push(getTemplates(vm.subscriber.organization_id));

          vm.orgsFriends.map(function (org) {
            vm.orgFriendsMap[org._id] = org.name;
            flowFunctionsArray.push(getSubscribersByOrg(org._id));
          });

          $q.all(flowFunctionsArray)
            .then(function () {
              if (vm.subscriber._id) {
                PersonalContacts.getPersonalList(vm.subscriber._id)
                .then(function(resp){
                    vm.subscriber.contacts = resp.map(function (subscriber) {
                      return subscriber.contactUserId;
                    });
                    filterContacts();
                    vm.loading = false;
                  })
                  .catch(function(err){
                    vm.subscriber.contacts = [];
                    filterContacts();
                    vm.loading = false;
                  })
              }
              else {
                vm.unselectedContacts = vm.contacts;
                vm.loading = false;
              }
            })
            .catch(function (err) {
              vm.loading = false;
            })
          })
          .catch(function (err) {
            vm.loading = false;
          })
      }

      function getSubscribersByOrg(orgId) {
        return new Promise(function(resolve, reject){
          var PERMISSION_MASK_OFF_NET = 0x08;
          Subscriber.getListByOrganizationMultipleRequests(orgId)
            .then(function (resp) {
              vm.contacts[orgId] = resp.filter(function(contact){
                if (Boolean(contact.permissions_mask & PERMISSION_MASK_OFF_NET)) contact.offnet = true;
                if (contact._id != vm.subscriber._id) return contact;
              })
              vm.allSubscribers = vm.allSubscribers.concat(resp);
              resolve();
            })
            .catch(function (e) {
              if (e.status !== 404) reject(e);
              else resolve();
            })
        });
      }

      function filterContacts(){
        vm.selectedContacts = [], vm.unselectedContacts = [];
        for (var i in vm.contacts){
          var contacts = vm.contacts[i].filter(function (member) {
            // member.organization_name = (member.organization_id == vm.organization._id) ? $translate.instant("OWN") : vm.orgFriendsMap[member.organization_id];
            // member.no_icon = (member.organization_id == vm.organization._id) ? false : true;
            return vm.subscriber.contacts.indexOf(member.phone_number) !== -1;
          });
          vm.selectedContacts = vm.selectedContacts.concat(contacts);
          vm.unselectedContacts[i] = vm.contacts[i].filter(function (member) {
            //member.organization_name = (member.organization_id == vm.organization._id) ? $translate.instant("OWN") : vm.orgFriendsMap[member.organization_id];;
            return vm.subscriber.contacts.indexOf(member.phone_number) === -1;
          });
        }
      }

      function getTemplates(orgId) {
        return new Promise(function(resolve, reject){
          Group.getAllGroupList(orgId)
          .then(function(resp){
            vm.contactTemplates = resp.filter(function(group){
              return (group.type === 8 && group.cross_fleet == 1);
            });
            vm.selectedTemplates = [];
            vm.unselectedTemplates = vm.contactTemplates;
            resolve();
          })
          .catch(function(err){
            resolve();
          });
        })
      }

      function ok(){
        vm.loading = true;
        var personalContactsObj = vm.selectedContacts.map(function(subscriber){
          return {
            ownerUserId: vm.subscriber._id,
            contactUserId: subscriber.phone_number,
            name: subscriber.name
          }
        });
        var body = {};
        body.personalContacts = personalContactsObj;
        PersonalContacts.addUpdateBatch(vm.subscriber._id, body)
        .then(function () {
          $mdDialog.hide();
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
        })
        .finally(function () {
          vm.loading = false;
        });
      }

      function cancel() {
        $mdDialog.cancel();
      };
  

  }

})();
(function () {
  'use strict';

  angular.module('app.restricted.licenses')
    .controller('licenseDetailsController', licenseDetailsController);

  /** @ngInject*/
  function licenseDetailsController(license, allocationId, License, $mdDialog, $filter, Auth, ExceptionHandler, localStorageService, Subscriber, Group, $timeout, $q) {
    var vm = this;

    vm.license = license;
    vm.search = "";
    vm.initFromSubscriberPage = allocationId === null;
    vm.licenseId = allocationId || license._id;
    vm.license = allocationId ? license.licenseBundle : license;
    vm.fetchSubscribersFunc = allocationId ? Subscriber.getByAllocationId : Subscriber.getByBundleId;
    vm.loading = false;
    vm.allowCreate = Auth.isActionAllowed('license_resource','POST');
    vm.allowModify = Auth.isActionAllowed('license_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('license_resource','DELETE');

    vm.popupOverlayClass = "";
    vm.groups = [];
    vm.popupOverlayClass = "";
    vm.reverse = [];
    vm.allocations = [];
    vm.allocationsList = [];
    vm.subscribers = [];

    vm.permissionOptions = license.permissions ? license.permissions.toString(2) : '';
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;

    this.cancel = cancel;
    this.ok = ok;


    if(license.id){
      setDefaultPermissions();
    }

    //-----------------------------------------------//


    function setDefaultPermissions() {
      license.conference = {
        originate: true,
        terminate: true
      };

      license.adHoc = {
        originate: true,
        terminate: true

      };

      license.private = {
        originate: true,
        terminate: true
      };

      license.im = {
        originate: true,
        terminate: true

      };

      license.radio = true;

      license.gps = true;
      license.sos = true;
      license.startOffNet = true;
      //license.dispatcher = true;
      license.dispatcher = {
        dispatcher: true,
        multuSession: "1"
      };
      license.priorityCall = true;
      license.webDispatcher = true;
    }


    function addLicense(){
      // vm.loading = true;
      License.add(vm.license)
        .then(function (resp) {
          $mdDialog.hide(vm.license);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function updateLicense(){
      // vm.loading = true;
      License.update(vm.license)
        .then(function (resp) {
          $mdDialog.hide(vm.license);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }


    function cancel() {
      $mdDialog.cancel();
    }

    function ok() {
      vm.license._id ? updateLicense() : addLicense();
    }


  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.licenses')
    .component('permissionListConvert', {
      templateUrl: 'app/main/restricted/platform/licenses/tabs/convert/permission-component/permission.component.html',
      controller: permissionController,
      controllerAs: 'vm',
      bindings: {
        "permissionName": "<",
        "permissionSubItemName": "<",
        "permissionSubItem": "=",
        "permissionVisible": "=",
        "permissionItem": "=",
        "permissionParentItem": "=",
        "multiSession": "=",
        "showSubItem": "<",
        "isEdit": "<"
      }
    });

  /** @ngInject */
  function permissionController(Toast) {
    var vm = this;

    vm.changeParentItem = changeParentItem;
    vm.visibleChange = visibleChange;
    vm.isSubItem = isSubItem;
    vm.getCheckboxClass = getCheckboxClass;


    function getCheckboxClass() {
      // if(vm.permissionName  == 'Web Dispatcher')
      // {
      //   if((!vm.permissionParentItem) || (vm.permissionParentItem == 'undefined'))
      //     return 'greyBorder'
      //   else
      //     return '';
      // }
      // else  
      return '';
    };
    function changeParentItem() {
      if (vm.permissionName == 'Web Dispatcher') {
        if (vm.permissionParentItem) {
          Toast.showDispactherLicenseWarning();
          vm.permissionItem = false;
        }
      }



      if (vm.permissionName == 'Dispatcher') {
        if (vm.permissionParentItem) {
          Toast.showDispactherLicenseWarning();
          vm.permissionItem = false;
        }
      }

      if (vm.permissionSubItem === undefined) {
        console.log(typeof (vm.permissionSubItem));
      }
      else {
        if (vm.multiSession)
          vm.permissionSubItem = "1";
        else {
          if (vm.permissionSubItem)
            vm.permissionSubItem = vm.permissionItem;
        }
      }
    }

    function visibleChange() {
      vm.permissionItem = vm.permissionVisible;
      if (vm.permissionSubItem) {
        vm.permissionSubItem = vm.permissionVisible;
      }
    }

    function isSubItem() {
      return typeof vm.permissionSubItem !== undefined;
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.restricted.server-config', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.server-config', {
      url: '/config',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/platform/config/list.html',
          controller: 'ConfigController as vm'
        }
      },
      bodyClass: 'profile'
    });

    //$translatePartialLoaderProvider.addPart('app/main/restricted/platform/config');


    // Navigation
    msNavigationServiceProvider.saveItem('Platform.server-config', {
      title: 'ITO config',
      icon: '',
      state: 'app.restricted.server-config',
      translate: 'NAVIGATION_ITO_CONFIG',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.server-config')
    .controller('siteDetailsController', siteDetailsController);

  function siteDetailsController($mdDialog, ExceptionHandler, Site, Server, servers, site) {
    var vm = this;
    vm.site = site;
    vm.siteState = Site.getStateList();
    vm.siteType = Server.getTypeList();
    vm.activeServersList = [];
    vm.updateActiveServers = updateActiveServers;
    vm.fillServerData = fillServerData;


    Server.getList()
      .then(function (resp) {
        vm.site._id ? vm.servers = resp : vm.servers = servers;
        if(vm.site.activeServer) fillServerData();
      });


    function fillServerData(){
      var mainServer = vm.servers.filter(function(server){
        return server._id == vm.site.server1;
      })[0];

      vm.secondServerList = vm.servers.filter(function(server){
        return server.type == mainServer.type;
      });

      vm.site.type  = mainServer.type;
      vm.site.state = mainServer.state == 1 ? 1 : 3;

      if(!vm.site._id){
        vm.site.host = mainServer.host;
      }

    }

    function updateActiveServers(){
      vm.activeServersList[0] = vm.servers.filter(function(server){
        return server._id == vm.site.server1;
      })[0];
      vm.activeServersList[1] =  vm.servers.filter(function(server){
        return server._id == vm.site.server2;
      })[0];
    }

    function addSite(){
      Site.add(site)
        .then(function (resp) {
          $mdDialog.hide(vm.site);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
    }

    function updateSite(){
      Site.update(site)
        .then(function (resp) {
          $mdDialog.hide(vm.site);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
    }

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      vm.site.activeServer = vm.site.server1;
      vm.site._id ? updateSite() : addSite();
    };

  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.server-config')
    .controller('serverDetailsController', serverDetailsController);

  function serverDetailsController($mdDialog, ExceptionHandler, Server, server) {
    var vm = this;
    vm.syncServerState = syncServerState;
    vm.server = server;
    vm.serverType = Server.getTypeList();
    vm.serverState = Server.getStateList();
    vm.serverAdminState = Server.getAdminStateList();


    function syncServerState(){
       return vm.server.adminState == 2 ? vm.server.state = 20 : vm.server.state = 1;
    }

    function addServer(){
      Server.add(vm.server)
        .then(function (resp) {
          $mdDialog.hide(vm.server);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
    }

    function updateServer(){
      Server.update(vm.server)
        .then(function (resp) {
          $mdDialog.hide(vm.server);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
    }


    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      vm.server._id ? updateServer() : addServer();
    };

  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.server-config')
    .controller('configDetailsController', configDetailsController);

  function configDetailsController($mdDialog, param, Config,ExceptionHandler, $rootScope) {
    var vm = this;
    this.param = param;
    vm.flagSave = true;

    switch(vm.param.parameter_id){
      case(9015):
        vm.pattern = /^[01]$/;
        break;
      case(9022):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9029):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9030):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9033):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9036):
        vm.pattern = /^[01]$/;
        break;
      case(9037):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9038):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9039):
        vm.pattern = /^[01]$/;
        break;
      case(9040):
        vm.pattern = /^[01]$/;
        break;
      case(9041):
        vm.pattern = /^[01]$/;
        break;
      case(9042):
        vm.pattern = /^[01]$/;
        break;
      case(9043):
        vm.pattern = /^[01]$/;
        break;
      case(9044):
       vm.pattern = /^(?:[3-9]|[12][0-9])[0-9]*$/;
       break;
      case(9047):
        vm.pattern = /^[01]$/;
        break;
      case(9048):
        vm.pattern = /^[01]$/;
        break;
      case(9049):
        vm.pattern = /^[01]$/;
        break;
      case(9050):
        vm.pattern = /^[01]$/;
        break;
      case(9051):
        vm.pattern = /^[01]$/;
        break;
      case(9052):
        vm.pattern = /^[01]$/;
        break;
      case(9053):
        vm.pattern = /^[01]$/;
        break;
      case(9054):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9055):
        vm.pattern = /^[01]$/;
        break;
      case(9056):
        vm.pattern = /^[01]$/;
        break;
      case(9057):
        vm.pattern = /^[01]$/;
        break;
      case(9058):
        vm.pattern = /^[01]$/;
        break;
      case(9059):
        vm.pattern = /^[01]$/;
        break;
      case(9060):
        vm.pattern = /^[01]$/;
        break;
      case(9061):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9062):
        vm.pattern = /^[01]$/;
        break;
      case(9063):
        vm.pattern = /^[01]$/;
        break;
      case(9064):
        vm.pattern = /^[01]$/;
        break;
      case(9065):
        vm.pattern = /^[01]$/;
        break;
      case(9066):
        vm.pattern = /^[01]$/;
        break;
      case(9067):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9069):
        vm.pattern = /^(?:[3-9]|[12][0-9])[0-9]*$/;
        break;
      case(9070):
        vm.pattern = /^[01]$/;
        break;
      case(9071):
        vm.pattern = /^[01]$/;
        break;
      case(9072):
        vm.pattern = /^(?:[3-9]|[12][0-9])[0-9]*$/;
        break;
      case(9073):
        vm.pattern = /^(?:[3-9]|[12][0-9])[0-9]*$/;
        break;
      case(9074):
        vm.pattern = /^[01]$/;
        break;
      case(9075):
        vm.pattern = /^[01]$/;
        break;
      case(9076):
        vm.pattern = /^[01]$/;
        break;
      case(1): //recorder
        vm.pattern = /^(?:[3-9]|[12][0-9])[0-9]*$/;
        break;
      case(2): //recorder
        vm.pattern = /^(?:[3-9]|[12][0-9])[0-9]*$/;
        break;
      case(3):
        vm.pattern = /^[01]$/;
        break;
      case(4):
        vm.pattern = /^[01]$/;
        break;
      case(9082):
        vm.pattern =  /^[1234]$/;
        break;
      case(9083):
        vm.pattern = /^[01]$/;
        break;
      case(9085):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9086):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9087):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9088):
        vm.pattern = /^[1-9][0-9]*$/;
        break;
      case(9090):
        vm.pattern = /^(2[0-4]|1[0-9]|[1-9])$/;
        break;
      case(9091):
        vm.pattern = /^[01]$/;
        break;
      case(9092):
        vm.pattern = /^[01]$/;
        break;
      case(9093):
        vm.pattern = /^([1-9]|10)$/;
        break;
      case(9094):
        vm.pattern = /^[01]$/;
        break;
   }

   //^[1-9][0-9]*$


    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      vm.flagSave = false;
      // vm.loading = true;
      Config.update(vm.param)
        .then(function () {
          if(vm.param.name == 'PROV_SHOW_LOCATION_LIST')
            $rootScope.$emit('upadateLocationMenu');
          $mdDialog.hide(vm.param)
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.flagSave = true;
          // vm.loading = false;
        });

    };

  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.server-config')
    .controller('configAddDetailsController', configAddDetailsController);

  function configAddDetailsController($mdDialog, param, Config, Server,ExceptionHandler) {
    var vm = this;

    vm.param = param;
    vm.params =[];
    vm.paramsList = [];
    vm.valueTypes = [
      {
        _id: 1,
        name: "TEXT"
      },
      {
        _id: 2,
        name: "NUMBER"
      }
    ];

    //UI methods
    vm.selectDefaultParameter = selectDefaultParameter;


    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      vm.param.language_id = 1;
      vm.param.scope_mask = convertScopeToString(vm.param.scope);

      Config.add(vm.param)
        .then(function (resp) {
          $mdDialog.hide(vm.param);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })


    };

    ///////// ///////// /////////
    init();

    function init(){
      Config.getFilterList()
        .then(function(resp){
          vm.params = resp;

          vm.paramsList = getEmptyParamsList(vm.defaultParams, vm.params);
        });

      Server.getList()
        .then(function (resp) {
          vm.servers = resp;

          if(vm.site.active_server) fillServerData();
        });
    }


    function selectDefaultParameter(){

      if(vm.defaultParameterId){
        vm.defaultParameterId = parseInt(vm.defaultParameterId);

        vm.param = vm.defaultParams.filter(function(parameter){
          return parameter.parameter_id == vm.defaultParameterId;
        });

        vm.param = vm.param[0];

        vm.param.format == "TEXT" ? vm.param.format = 1 : vm.param.format = 2;
        vm.param.scope = convertScopeToObject(vm.param.scope_mask);

      }
    }


    function convertScopeToString(scope){
        var stringScope = "";
        scope.system ? stringScope += "T" : stringScope += "F";
        scope.site   ? stringScope += "T" : stringScope += "F";
        scope.server ? stringScope += "T" : stringScope += "F";
        return stringScope;
    }

    function convertScopeToObject(scope){
      if(scope.length == 3){
        var newScope = {};
        scope[0] == "T" ? newScope.system = true : newScope.system = false;
        scope[1] == "T" ? newScope.site = true   : newScope.site = false;
        scope[2] == "T" ? newScope.server = true : newScope.server = false;
        return newScope;
      }
    }

    function getHash(array){
      var hash = {};
      for (var i=0; i<array.length; i++){
        hash[ array[i] ] = true;
      }
      return hash;
    }

    function getParamsHash(array){
      var hash = {};
      for (var i=0; i<array.length; i++){
        hash[ array[i].name ] = array[i];
      }
      return hash;
    }

    function getParamsDifference(a, b){
      var hash = getHash(b);
      var diff = [];
      for (var i=0; i<a.length; i++){
        var value = a[i];
        if (!hash[value]){
          diff.push(value);
        }
      }
      return diff;
    }

    function getEmptyParamsList(defaultParams, setParams){
      var defaultParamNames = defaultParams.map(function(param){
        return param.name;
      });
      var setParamNames = setParams.map(function(param){
        return param.name;
      });

      var paramsHash = getParamsHash(defaultParams);
      var paramsEmpty = getParamsDifference(defaultParamNames,setParamNames);
      var paramsList = paramsEmpty.map(function(param){
        return paramsHash[param];
      });

      return paramsList;
    }


    vm.defaultParams =
      [
        {
          "server_id": "0",
          "parameter_id": 0,
          "value": "",
          "name": "NEW CUSTOM PARAMETER",
          "scope_mask": "TFF",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": 1,
          "pk_text.trim_text(hl.text,:b7)": null
        },

        {
          "server_id": "0",
          "parameter_id": 1,
          "value": "'4.2.00.01'",
          "name": "DB_VERSION",
          "scope_mask": "TFF",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 2,
          "value": "4.1.00.00",
          "name": "OLDEST_SUPPORTED_DB_VERSION_FOR_IPRS_SERVER",
          "scope_mask": "TFF",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3,
          "value": "4.1.00.00",
          "name": "OLDEST_SUPPORTED_DB_VERSION_FOR_MEDIATION_SERVER",
          "scope_mask": "TFF",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 4,
          "value": "4.1.00.00",
          "name": "OLDEST_SUPPORTED_DB_VERSION_FOR_MTVIEW_SERVER",
          "scope_mask": "TFF",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 5,
          "value": "4.1.00.00",
          "name": "OLDEST_SUPPORTED_DB_VERSION_FOR_XDMS",
          "scope_mask": "TFF",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 6,
          "value": "4.1.00.00",
          "name": "OLDEST_SUPPORTED_DB_VERSION_FOR_MOTOROLA_GW",
          "scope_mask": "TFF",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 7,
          "value": "4.1.00.00",
          "name": "OLDEST_SUPPORTED_DB_VERSION_FOR_NOKIA_GW",
          "scope_mask": "TFF",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 8,
          "value": "4.1.00.00",
          "name": "OLDEST_SUPPORTED_DB_VERSION_FOR_IMS_GW",
          "scope_mask": "TFF",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 9,
          "value": "4.1.00.00",
          "name": "OLDEST_SUPPORTED_DB_VERSION_FOR_GPS_SERVER",
          "scope_mask": "TFF",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 10,
          "value": "4.1.00.00",
          "name": "OLDEST_SUPPORTED_DB_VERSION_FOR_SOS_SERVER",
          "scope_mask": "TFF",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 301,
          "value": "540",
          "name": "KEEP_ALIVE_IDLE_INTERVAL",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 302,
          "value": "840",
          "name": "KEEP_ALIVE_IDLE_TIMEOUT",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 303,
          "value": "7",
          "name": "KEEP_ALIVE_FREQUENT_INTERVAL",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 304,
          "value": "30",
          "name": "KEEP_ALIVE_FREQUENT_TIMEOUT",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 305,
          "value": "10000",
          "name": "MAX_DISPATCHER_QUEUE",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 306,
          "value": "6",
          "name": "DISPATCHER_THREADS_COUNT",
          "scope_mask": "TTT",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 307,
          "value": "10000",
          "name": "DISPATCHER_SERVER_BUSY_INTERVAL",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 401,
          "value": "60",
          "name": "PTT_TIME_MAX_ALLOWED",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 402,
          "value": "10",
          "name": "NOT_KIDNAPPEDABLE_PERIOD",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 403,
          "value": "3",
          "name": "KIDNAP_PTT_DISABLED",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 501,
          "value": "40",
          "name": "PRIVATE_IDLE_TIMEOUT",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 502,
          "value": "40",
          "name": "GROUP_IDLE_TIMEOUT",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 601,
          "value": "TRUE",
          "name": "IS_ADHOC_SAFE_TALK",
          "scope_mask": "TFT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 602,
          "value": "TRUE",
          "name": "IS_PRIVATE_SAFE_TALK",
          "scope_mask": "TFT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 603,
          "value": "TRUE",
          "name": "IS_CONFERENCE_SAFE_TALK",
          "scope_mask": "TFT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 604,
          "value": "TRUE",
          "name": "IS_CHATROOM_SAFE_TALK",
          "scope_mask": "TFT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 701,
          "value": "TRUE",
          "name": "ARE_USERS_PRELOADED",
          "scope_mask": "TFT",
          "runtime_modifiable": 0,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 702,
          "value": "20",
          "name": "DORMANT_STORED_UPDATES_LIMIT",
          "scope_mask": "TFT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 801,
          "value": "65535",
          "name": "APPLICATION_LOG_CATEGORIES",
          "scope_mask": "TFT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 802,
          "value": "5",
          "name": "APPLICATION_LOG_LEVEL",
          "scope_mask": "TFT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 901,
          "value": "1000",
          "name": "ADHOC_SESSION_ID_RANGE_LOWER",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 902,
          "value": "100000",
          "name": "ADHOC_SESSION_ID_RANGE_UPPER",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 1001,
          "value": "14",
          "name": "TRANSPORT_PACKET_OVERHEAD",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 1101,
          "value": "6000",
          "name": "SESSION_COUNT_RISING_THRESHOLD",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 1102,
          "value": "4000",
          "name": "SESSION_COUNT_FALLING_THRESHOLD",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 1401,
          "value": "20",
          "name": "COM_SEQ_IDLE_TIME",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 1402,
          "value": "3",
          "name": "COM_SEQ_LOCAL_IDLE_TIME",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 1501,
          "value": "7",
          "name": "DIRECT_SESSION_UPDATE",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 1502,
          "value": "4",
          "name": "NUM_RETRIES",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 1503,
          "value": "1",
          "name": "NO_SESSION_ENA",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 1504,
          "value": "1",
          "name": "OUT_OF_SYNC_INTERVAL",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 2001,
          "value": "4",
          "name": "MAX_FAILED_PACKETS",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 2002,
          "value": "2",
          "name": "MAX_SILENCE",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 2003,
          "value": "25",
          "name": "NETWORK_SIGNAL_FLOOR",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 2004,
          "value": "15",
          "name": "PAGE_ME_TIMEOUT_MESSAGE",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 2005,
          "value": "60",
          "name": "USER_INACTIVITY",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 2006,
          "value": "50",
          "name": "RETRY_TIMER",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 2007,
          "value": "25003",
          "name": "CONFIG_DAEMON_PORT",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 2008,
          "value": "FALSE",
          "name": "ALLOW_PRIVATE_DIRECT",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3001,
          "value": "0",
          "name": "ACCT_SESSION_USERS_MODE",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3002,
          "value": "0",
          "name": "ACCT_COUNTERS_MODE",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3003,
          "value": "FALSE",
          "name": "ACCT_LOGOFF_ON_NO_CREDIT",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3004,
          "value": "TRUE",
          "name": "UNREGISTER_TO",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3005,
          "value": null,
          "name": "DISABLE_AUTH",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3006,
          "value": "3",
          "name": "WHO_CAN_ADD_TO_SB_SESSION",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3007,
          "value": "4",
          "name": "WHO_CAN_ADD_TO_NSB_SESSION",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3008,
          "value": "3",
          "name": "WHO_CAN_BE_ADDED_TO_SB_SESSION",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3009,
          "value": null,
          "name": "LICENSE",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3010,
          "value": null,
          "name": "LICENSE_SIGNATURE",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3011,
          "value": "90",
          "name": "LICENSE_LIMIT_THRESHOLD",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3012,
          "value": "90",
          "name": "LICENSE_EXPIRATION_THRESHOLD",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3013,
          "value": "TRUE",
          "name": "PAB_PAUSE_ON_AUDIO",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 3014,
          "value": "FALSE",
          "name": "KEEPALIVE_WHILE_LISTEN",
          "scope_mask": "TTF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 5001,
          "value": "30",
          "name": "RECOVERY_FLUSH_TIME",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 6000,
          "value": "999000000000000000",
          "name": "ID_ALLOC_RANGE_START",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 6001,
          "value": "999999999999999999",
          "name": "ID_ALLOC_RANGE_END",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 6002,
          "value": "24000",
          "name": "MEMBERS_COUNT_RISING_THRESHOLD",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 6003,
          "value": "12000",
          "name": "MEMBERS_COUNT_FALLING_THRESHOLD",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 7001,
          "value": "FALSE",
          "name": "MTVIEW_SRV_ENABLE_USER_WITH_RSRVD_ID",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 7002,
          "value": "FALSE",
          "name": "MTVIEW_SRV_ENFORCE_ORG_GROUP_UNIQUE_NAME",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 7003,
          "value": null,
          "name": "MTVIEW_SRV_EXT_WEB_AUTH_AND_AR",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 7004,
          "value": "0",
          "name": "MTVIEW_SRV_FIRST_ACCT_SITE_ID",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "NUMBER",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 7005,
          "value": "Have a nice day.",
          "name": "MTVIEW_SRV_MOTD",
          "scope_mask": "TTT",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        },
        {
          "server_id": "0",
          "parameter_id": 7007,
          "value": "test value",
          "name": "GRACE_PERIOD",
          "scope_mask": "TFF",
          "runtime_modifiable": 1,
          "_id": 1,
          "format": "TEXT",
          "pk_text.trim_text(pt.format,:b9)": null,
          "pk_text.trim_text(h.name,:b8)": "NO_HELP_STRING_AVAILABLE",
          "language_id": null,
          "pk_text.trim_text(hl.text,:b7)": null
        }
      ]
  }

})();

(function () {
  'use strict';
  angular.module('app.restricted.recording', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.recording', {
      url: '/recording',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/recording/recording.html',
          controller: 'RecordingController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('administration_resource','GET');
        }
      }
    });


    // Navigation
    msNavigationServiceProvider.saveItem('Organization.recording', {
      title: 'Recording',
      icon: '',
      state: 'app.restricted.recording',
      translate: 'NAVIGATION_RECORDING',
      weight: 6
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.recording')
    .controller('audioBackupPathDialogController', audioBackupPathDialogController);

  /** @ngInject*/
  function audioBackupPathDialogController($mdDialog, $filter, ExceptionHandler, AudioBackupPath, Context, localStorageService) {

    var vm = this;
    vm.flagSave = true;

    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;

    vm.minDate = new Date('01/01/2000');
    vm.monthFormat = buildLocaleProvider("MMM-YYYY");  
  
    function buildLocaleProvider(formatString) {
      return {
        formatDate: function(date) {
          if (date) return moment(date).format(formatString);
          else return null;
        },
        parseDate: function(dateString) {
          if (dateString) {
            var m = moment(dateString, formatString, true);
            return m.isValid() ? m.toDate() : new Date(NaN);
          } else return null;
        }
      };
    }

    this.close = close;
    this.ok = ok;
    this.setRecordsCount = setRecordsCount;

    vm.record = {};
    vm.record.organization_id = Context.getOrganizationId()

    function close() {
      $mdDialog.cancel();
    }

    function ok() {
      vm.flagSave = false;
      vm.record.path = vm.record.path.trim();
      if(!vm.record.path)
      {
        vm.flagSave = true;
        return false;
      }
      // vm.loading = true;
      vm.record.folder_date = $filter('date')(vm.record.folder_date, "MM-yyyy");

      AudioBackupPath.add(vm.record)
        .then(function (user) {
          $mdDialog.hide();
          // vm.loading = false;
        })
        .catch(function (e) {
          vm.flagSave = true;
          ExceptionHandler.show(e);
          // vm.loading = false;
        });

    }

    function setRecordsCount() {
      localStorageService.set('recordsCount', vm.recordsCount);
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.recording')
    .controller('adminRecordDialogController', adminRecordDialogController);

  /** @ngInject*/
  function adminRecordDialogController($mdDialog, ExceptionHandler, user, api, Context, Auth,$mdToast, Toast, AdminRecord, RecordWhiteList, localStorageService) {

    var vm = this;
    vm.flagSave = true;
    vm.allowCreate = Auth.isActionAllowed('administration_resource','POST');
    vm.allowModify = Auth.isActionAllowed('administration_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('administration_resource','DELETE');

    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;

    if(Auth.isRootAdmin()){
      vm.allowCreate = true;
      vm.allowModify = true;
      vm.allowDelete = true;

    }


    this.close = close;
    this.ok = ok;
    this.showPassword = showPassword;
    this.refreshActivities = refreshActivities;
    //this.initRoles = initRoles;
    this.user = user;
    this.setRecordsCount = setRecordsCount;

    vm.adminActivitiesPaginationClass = "adminActivitiesPagination_" + vm.user.admin_id;



    user.organization_id = Context.getOrganizationId()
    RecordWhiteList.getByOrgId(user.organization_id)
    .then(function (result) {
      (result[0] && result[0].force_strong_pass_for_reviewers) ?  vm.strongPassForReviewers =  true  : vm.strongPassForReviewers = false
      if (vm.strongPassForReviewers) {
        vm.showPassword()
      }
    })  .catch(function (e) {
      vm.strongPassForReviewers = false
    });


    function showPassword(){
      vm.user.changePassword = true;
      vm.user.rePassword = vm.user.password;
    }

    function close() {
      $mdDialog.cancel();
    }

    function ok() {
      vm.flagSave = false;
        // vm.loading = true;

      if (vm.user.admin_id) {
        var userFromParams = {
          admin_id: vm.user.admin_id,
          username: vm.user.username,
          player_client_version: vm.user.player_client_version,
        };
         if (vm.user.password && vm.user.password != '') {
           userFromParams.password = vm.user.password;
         }
         if(vm.user.changePassword){
           userFromParams.changePassword = true;
         }
        AdminRecord.update(userFromParams)
        .then(function (user) {
          $mdDialog.hide(user, vm.mode);
        })
        .catch(function (e) {
          vm.flagSave = true;
          ExceptionHandler.show(e);
        });
      }
      else {
        AdminRecord.add(vm.user)
        .then(function (user) {
          $mdDialog.hide(user, vm.mode);
        })
        .catch(function (e) {
          vm.flagSave = true;
          ExceptionHandler.show(e);
        });
      }
      // vm.loading = false;
    }

    function refreshActivities(){
      AdminRecord.getByAdminId(vm.user.admin_id)
        .then(function(res){
          vm.user = res;
        })
        .catch(function(err){
          ExceptionHandler.show(err);
        });
    }
  }

  function setRecordsCount(){
    localStorageService.set('recordsCount', vm.recordsCount);
   }

  
})();

(function () {
  angular.module('app.restricted.organization-manager')
    .controller('affiliatedDialogController', affiliatedDialogController);

  /** @ngInject*/
  function affiliatedDialogController($mdDialog, $translate,Context, Toast,Reseller,$timeout, $q, server, Subscriber,Group,organizationId,organization, PersonalContacts,ExceptionHandler,subscribers,OrgFriends) {
    var vm = this;
    vm.cancel = cancel;
    vm.changeContactTemplateList = changeContactTemplateList;
    vm.batchContactTemplateAssignment = batchContactTemplateAssignment;
    vm.server = server;
    vm.templateType = "Subscribers";
    vm.subscriberLength = 0;
    vm.affContactTemplates = [];
    vm.selectedContactTemplate = [];
    vm.notSelectedContactTemplate = [];
    vm.affNotSelectedSubscriber = [];
    vm.organizationId = organizationId;
    vm.organization = organization;
    vm.bulAffSubscribers = subscribers;
    vm.notSelectedAssignContactTemplate = [];
    vm.selectedSubscribers = [];
    vm.selectedAssignContactTemplate = [];
    vm.contactTemplatePaginationClass = "contactTemplatesPagination";

    init()

    function init() {
      OrgFriends.getByOrgId(vm.organizationId)
      .then(function (resp) {
        vm.bulkAffOrgsFriends = resp;
        vm.bulkAffOrgsFriends.push(vm.organization)
        vm.selectedDropDown = vm.bulkAffOrgsFriends[vm.bulkAffOrgsFriends.length - 1]._id;
        var flowFunctionsArrays = [];
        vm.members = [];
        vm.affContactTemplates = [];
        vm.contactTemplatesDrop = []
        vm.bulAffSubscribers = [];;
        vm.orgFriendsMap = [];
        vm.bulkAffOrgsFriends.map(function (org) {
          vm.orgFriendsMap[org._id] = org.name;
          flowFunctionsArrays.push(getContactTemplateByOrg(org._id));
          flowFunctionsArrays.push(getSubscribersByOrg(org._id));
        });

        $q.all(flowFunctionsArrays)
          .then(function () {
            vm.notSelectedAssignContactTemplate = vm.members;
            vm.affNotSelectedSubscriber = vm.members;
            vm.subscriberLength = vm.members.length;

            vm.contactTemplateLength = vm.affContactTemplates.length;
            vm.notSelectedContactTemplate = vm.affContactTemplates;
          })
          .catch(function (err) {
            ExceptionHandler.show(err);
          })
          .finally(function () {
            // vm.loading = false;
          });
      })
      .catch(function (e) {
        if (e.status !== 404) { ExceptionHandler.show(e) }
      });

    }
    function getSubscribersByOrg(orgId) {
      return new Promise(function(resolve, reject){
        var PERMISSION_MASK_OFF_NET = 0x08;
        Subscriber.getListByOrganizationMultipleRequests(orgId)
          .then(function (resp) {
            vm.members[orgId] = resp.map(function(member){
              if (Boolean(member.permissions_mask & PERMISSION_MASK_OFF_NET))
              {
                vm.bulAffSubscribers.push(member)
                member.offnet = true;
              }
              return member;
            })
            resolve();
          })
          .catch(function (e) {
            if (e.status !== 404) reject(e);
            else resolve();
          })
      });
    }
    function getContactTemplateByOrg(orgId){
      return new Promise(function(resolve, reject){
        Group.getAllGroupList(orgId)
          .then(function (resp) {
            vm.affContactTemplates[orgId] = resp.map(function(contact){
              if (contact.type == 8 && contact.cross_fleet == 1)
              { contact.offnet = true;
                vm.contactTemplatesDrop.push(contact)
              }
              return contact;
            })
           resolve();
          })
          .catch(function (e) {
            if (e.status === 404)
              resolve();
            else
            reject(e);
          });
      });
    }
    function changeContactTemplateList() {
      vm.resultContactTemplateLog = $translate.instant("CONTACT_TEMPLATE_TYPE") + ": " + (vm.templateType == "Subscribers" ? $translate.instant("BULK_CONTACT_TEMPLATE_SUBSCRIBERS") : $translate.instant("BULK_CONTACT_TEMPLATE_TEMPLATES"));
      vm.notSelectedAssignContactTemplate = [];
      vm.selectedAssignContactTemplate = [];
      if (vm.templateType == "Subscribers") {
        vm.notSelectedAssignContactTemplate = angular.copy(vm.affNotSelectedSubscriber);
        vm.selectedAssignContactTemplate = angular.copy(vm.selectedSubscribers);
        vm.assignLength = vm.subscriberLength;
      }
      else if (vm.templateType == "ContactTemplate") {
        vm.notSelectedAssignContactTemplate = angular.copy(vm.notSelectedContactTemplate);
        vm.selectedAssignContactTemplate = angular.copy(vm.selectedContactTemplate);
        vm.assignLength = vm.contactTemplateLength;
      }
    }
    function batchContactTemplateAssignment(type) {
      if (vm.selectedAssignContactTemplate.length) {
        // vm.loading = true;
        var assignmentFuncs = [];
        var errors = [];
        var allocatedCount = 0;

        vm.resultContactTemplateLog = [];
        vm.errorLog = [""];
        vm.subscribersProcessed = 0;
        vm.subscribersNotProcessed = 0;
        Subscriber.getListByGroup(vm.selectedContactTemplateId)
          .then(function (resp) {
            var newResp = resp.map(function (contact) {
              contact.phone_number = vm.bulAffSubscribers.filter(function (subs) {
                if (subs._id == contact._id)
                  return subs;
              })[0].phone_number;
              return contact;
            })
            if (vm.templateType == "Subscribers") {
              vm.selectedAssignContactTemplate.forEach(function (subscriber) {
                var assg = {
                  contactsTemplate: newResp,
                  subscriberId: subscriber._id,
                  phoneNumber: subscriber.phone_number,
                  assignmentDate: new Date(),
                  active: true
                };

                assignmentFuncs.push(addContactTemplateAllocationHandler.bind(null, assg));
              })
            }
            else {
              vm.selectedAssignContactTemplate.forEach(function (template) {
                Subscriber.getListByGroup(template._id)
                  .then(function (resp) {
                    resp.map(function (contact) {
                      var assg = {
                        contactsTemplate: newResp,
                        subscriberId: contact._id,
                        phoneNumber: vm.bulAffSubscribers.filter(function (subs) {
                          if (subs._id == contact._id)
                            return subs;
                        })[0].phone_number,
                        assignmentDate: new Date(),
                        active: true
                      };

                      assignmentFuncs.push(addContactTemplateAllocationHandler.bind(null, assg));
                      
                    })

                  })
              })
            }
            setTimeout(function() {
              if (type == "Add") {
                assignmentFuncs.push(function () {
                  // vm.loading = false;
                  vm.resultContactTemplateLog = $translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + (assignmentFuncs.length - 1 - errors.length);
                  Toast.showCustom($translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + (assignmentFuncs.length - 1 - errors.length));
    
                });
              } else {
                assignmentFuncs.push(function () {
                  // vm.loading = false;
                  vm.resultContactTemplateLog = $translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + (assignmentFuncs.length - 1 - errors.length);
                  Toast.showCustom($translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + (assignmentFuncs.length - 1 - errors.length));
    
                });
              }
            assignmentFuncs.reduce(function (soFar, f) {
              return soFar.then(f).catch(function (err) { errors.push(err) });
            }, $q.when([]))
            }, 1000);
          })

          

         
          // assignmentFuncs.reduce(function (soFar, f) {
          //   return soFar.then(f).catch(function (err) { errors.push(err) });
          // }, $q.when([]))
      }

      function addContactTemplateAllocationHandler(assg) {
        var deferred = $q.defer();
        // vm.loading = true;

        if (assg.contactsTemplate && assg.contactsTemplate.length > 0) {
          PersonalContacts.getPersonalList(assg.subscriberId)
            .then(function (contacts) {
              if (type == "Add") {
                var newContacts = contacts;
                for (var i in assg.contactsTemplate) {
                  if (contacts.filter(function (contact) { return contact.contactUserId === assg.contactsTemplate[i].phone_number; }).length == 0) {
                    if (assg.subscriberId != assg.contactsTemplate[i]._id)
                      newContacts.push({ contactUserId: assg.contactsTemplate[i].phone_number, name: assg.contactsTemplate[i].name, ownerUserId: assg.subscriberId });
                  }
                }
              }
              else {
                var newContacts = [];
                for (var i in contacts) {
                  if (contacts[i].contactUserId && assg.contactsTemplate.filter(function (contact) { return contacts[i].contactUserId === contact.phone_number; }).length == 0) {
                    newContacts.push(contacts[i]);
                  }
                }
              }

              var body = {};
              body.personalContacts = newContacts;
              PersonalContacts.addUpdateBatch(assg.subscriberId, body)
                .then(function () {
                  deferred.resolve();
                  vm.resultContactTemplateLog = "Processing... Done: " + allocatedCount++;
                })
                .catch(function (err) {
                  deferred.reject(err);
                  errors.push(err);
                  // vm.loading = false;
                });
            })
            .catch(function (err) {
              if (err.status == 404) {
                if (type == "Add") {
                  var body = {};
                  body.personalContacts = [];
                  assg.contactsTemplate.map(function (contact) {
                    if (contact._id != assg.subscriberId)
                      body.personalContacts.push({ contactUserId: contact.phone_number, name: contact.name, ownerUserId: assg.subscriberId });
                  });
                  PersonalContacts.addUpdateBatch(assg.subscriberId, body)
                    .then(function () {
                      deferred.resolve();
                      vm.resultContactTemplateLog = "Processing... Done: " + allocatedCount++;
                    })
                    .catch(function (err) {
                      deferred.reject(err);
                      errors.push(err);
                      // vm.loading = false;
                    });
                }
                else {
                  deferred.resolve();
                  vm.resultContactTemplateLog = "Processing... Done: " + allocatedCount++;
                }
              }
              else {
                deferred.reject(err);
                errors.push(err);
                // vm.loading = false;
              }
            });
        }
        else {
          deferred.resolve();
          vm.resultContactTemplateLog = "Processing... Done: " + allocatedCount++;
        }

        return deferred.promise;
      }

    }
    function cancel() {
      $mdDialog.cancel();
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.restricted.subscribers', ['datatables'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider, msApiProvider) {
    $stateProvider.state('app.restricted.subscribers', {
      url: '/subscribers',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/subscribers/subscribers.html',
          controller: 'SubscribersController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('subscriber_resource','GET')
        }
      }
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/restricted/organization/subscribers');

    //msApiProvider.register('subscribers', ['app/main/restricted/organization/subscribers/data/subscribers.json']);

    // Navigation
    msNavigationServiceProvider.saveItem('Organization.subscribers', {
      title: 'Subscribers',
      icon: '',
      state: 'app.restricted.subscribers',
      translate: 'NAVIGATION_SUBSCRIBERS',
      weight: 6
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.subscribers')
    .component('subscriberPermissionItem', {
      templateUrl: 'app/main/restricted/organization/subscribers/details/permission-component/permission.component.html',
      controller: permissionController,
      controllerAs: 'vm',
      bindings: {
        "permissionName": "<",
        "permissionSubItemName": "<",
        "permissionSubItem": "=",
        "permissionVisible": "=",
        "permissionItem": "=",
        "permissionParentItem": "=",
        "multiSession": "=",
        "showSubItem": "<",
        "isEdit": "<"
      }
    });

  /** @ngInject */
  function permissionController(Toast) {
    var vm = this;

    vm.changeParentItem = changeParentItem;
    vm.visibleChange = visibleChange;
    vm.isSubItem = isSubItem;
    vm.getCheckboxClass = getCheckboxClass;

    function getCheckboxClass() {
      // if(vm.permissionName  == 'Web Dispatcher')
      // {
      //   if((!vm.permissionParentItem) || (vm.permissionParentItem == 'undefined'))
      //     return 'greyBorder'
      //   else
      //     return '';
      // }
      // else  
      return '';
    };
    function changeParentItem() {
      if (vm.permissionName == 'Web Dispatcher') {
        if (vm.permissionParentItem) {
          Toast.showDispactherLicenseWarning();
          vm.permissionItem = false;
        }
      }

      if (vm.permissionName == 'Dispatcher') {
        if (vm.permissionParentItem) {
          Toast.showDispactherLicenseWarning();
          vm.permissionItem = false;
        }
      }

      if (vm.permissionSubItem === undefined) {
        // console.log(typeof(vm.permissionSubItem));
      }
      else {
        if (vm.multiSession)
          vm.permissionSubItem = "1";
        else {
          if (vm.permissionSubItem)
            vm.permissionSubItem = vm.permissionItem;
        }
      }
    }

    function visibleChange() {
      vm.permissionItem = vm.permissionVisible;
      if (vm.permissionSubItem) {
        vm.permissionSubItem = vm.permissionVisible;
      }
    }

    function isSubItem() {
      return typeof vm.permissionSubItem !== undefined;
    }
  }

})();
(function () {
  'use strict';
  angular.module('app.restricted.applicationLists', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.applicationLists', {
      url: '/applicationLists',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/application-lists/application.lists.html',
          controller: 'ApplicationListsController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('organization_resource','GET');
        }
      }
    });


    // Navigation
    msNavigationServiceProvider.saveItem('Organization.applicationLists', {
      title: 'ApplicationLists',
      icon: '',
      state: 'app.restricted.applicationLists',
      translate: "NAVIGATION_APPLICATION_LISTS",
      weight: 6
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.applicationLists')
    .controller('ApplicationListsDialogController',ApplicationListsDialogController);

  /**ngInject*/
  function ApplicationListsDialogController(Config, $mdDialog, $translate, $scope, $q, Toast, ExceptionHandler, organizationId, applications, application, applicationList, clone, edit, ApplicationList, editData, Auth, action) {
    var vm = this;

    vm.search = '';
    vm.applications = applications;
    vm.application = application;
    vm.applicationList = applicationList;
    vm.organizationId = organizationId;
    vm.clone = clone;
    vm.edit = edit;
    vm.editData = editData?editData:false;
    vm.action = action?action:false;
    vm.errorMessage = '';

    if (vm.application && vm.application.apk){
      vm.icon = vm.application.apk.stringIcon;
    }

    vm.addApplication = addApplication;
    vm.saveApplicationList = saveApplicationList;
    vm.cancel = cancel;
    vm.selectAll_io = selectAll_io;
    vm.selectAll_kiosk = selectAll_kiosk;
    vm.checkSelectAll = checkSelectAll;
    vm.allowModify = Auth.isActionAllowed('organization_resource', 'PUT');

    vm.loading = false;
    vm.packageDisable = false;
    vm.packageversionDisable = true;

    vm.icons = {
      "Dialer" : "icon-cellphone",
      "Contacts" : "icon-people",
      "Messages" : "icon-message",
      "Camera" : "icon-camera",
      "Gallery" : "icon-picture",
      "Settings" : "icon-cellphone-settings",
      "Browser" : "icon-internet-explorer",
      "Calculator" : "icon-calculator",
      "Calender" : "icon-calendar",
      "Email" : "icon-email",
      "Maps" : "icon-map",
      "Wi-Fi": "icon-wifi"
    }

    // console.log(vm.applications)
    if (vm.applicationList._id){
      ApplicationList.getApplicationList(vm.applicationList._id)
      .then(function(applicationList){
        vm.applicationList = applicationList[0];
        getConfig()
        .then(function(){
          init();
        })
        .catch(function(err){
          init();
        })
      });
    }
    else{
      getConfig()
      .then(function(){
        init();
      })
      .catch(function(err){
        init();
      })
    }

    function init(){
      vm.applications.default = vm.showDefaultApplications ? ApplicationList.getDefaultList() : [];
      vm.curApplications = angular.copy(vm.applications.default.concat(vm.applications.list));
      if (vm.curApplications && vm.applicationList){
        vm.curApplications.map(function(app){
          vm.applicationList.io_white_list && vm.applicationList.io_white_list.filter(function(io){
            if (app.package == io.package){
              app.io = true;
            }
          })
          vm.applicationList.kiosk_white_list && vm.applicationList.kiosk_white_list.filter(function(kiosk){
            if (app.package == kiosk.package){
              app.kiosk = true;
            }
          })
        })
      }
      vm.applicationList.io_white_list && vm.applicationList.io_white_list.length == vm.curApplications.length - vm.applications.default.length ? vm.select_all_io = true : vm.select_all_io = false;
      vm.applicationList.kiosk_white_list && vm.applicationList.kiosk_white_list.length == vm.curApplications.length ? vm.select_all_kiosk = true : vm.select_all_kiosk = false;
    }

    function getConfig(){
      var deferred = $q.defer();
      Config.getFilterList().then(function(resp){
        vm.configs = resp;

        vm.showDefaultApplications = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_DEFAULT_APPLICATION_LIST";
        });
        if (!vm.showDefaultApplications || !vm.showDefaultApplications[0].value || vm.showDefaultApplications[0].value == "0")
          vm.showDefaultApplications = false;
        else
          vm.showDefaultApplications = true;

        vm.showUsingMicrophone = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_APP_USING_MICROPHONE";
        });
        // console.log(vm.showUsingMicrophone)
        if (!vm.showUsingMicrophone || !vm.showUsingMicrophone[0].value || vm.showUsingMicrophone[0].value == "0")
          vm.showUsingMicrophone = false;
        else
          vm.showUsingMicrophone = true;

        deferred.resolve();
      })
      .catch(function(e){
        vm.showDefaultApplications = false;
        deferred.reject(e);
      });
      return deferred.promise;
    }

    $scope.getApplicationDetails = function(){
      // vm.appLoading = true;
      vm.packageversionDisable = true;
      if (application_file && application_file.files && application_file.files.length > 0){
        var fd = new FormData();
        fd.append('file', application_file.files[0]);
        ApplicationList.getApkPackage(fd)
        .then(function(result){
          if (!vm.application) vm.application = {};
          if (vm.edit){
            if(vm.application.package && vm.application.package != result.package){
              vm.packageDisable = true;
              // vm.appLoading = false;
              vm.errorMessage = $translate.instant("APPLICATION_UPDATE_PACKAGE_ERROR");
              //ExceptionHandler.show({data: {error: $translate.instant("APPLICATION_UPDATE_PACKAGE_ERROR")}});
            }
            else if(vm.application.apk && vm.application.apk.versionCode >= result.versionCode){
              vm.packageDisable = true;
              // vm.appLoading = false;
              vm.errorMessage = $translate.instant("APPLICATION_UPDATE_VERSION_ERROR");
              //ExceptionHandler.show({data: {error: $translate.instant("APPLICATION_UPDATE_VERSION_ERROR")}});
            }
            else{
                vm.application.package = result.package;
                vm.application.apk = result;
                vm.icon = result.stringIcon;
                vm.packageDisable = true;
                // vm.appLoading = false;
                vm.errorMessage = '';
              }
          }
          else{
            vm.application.package = result.package;
            vm.application.apk = result;
            vm.icon = result.stringIcon;
            vm.packageDisable = true;
            // vm.appLoading = false;
            vm.errorMessage = '';
          }
        })
        .catch(function(e){
          // vm.appLoading = false;
          vm.packageDisable = false;
          document.getElementById('application_file').value = '';
          vm.packageversionDisable = true;
          ExceptionHandler.showInfo($translate.instant('NOT_SUPPORTED'));
        });
      }
      else{
        // vm.appLoading = false;
        vm.packageDisable = false;
      }
    }

    function addApplication(application){
      // vm.appLoading = true;
      if (application.name && application.package){
        if (application.package.includes("?id=")){
          application.package = application.package.split("?id=")[1].split("&")[0];
        }

        if (application.package == "DEFAULT"){
          Toast.showAddApplicationReserverdError();
          // vm.appLoading = false;
        }
        else{
          if (application.apk || (application_file && application_file.files && application_file.files.length > 0))//add by APK
            var app = {"name" : application.name, "package" : application.package, 'description': application.description, 'apk': application.apk}
          else
            var app = {"name" : application.name, "package" : application.package, 'description': application.description}

          var exist = vm.applications.newList.filter(function(resp){
            return (resp.package == app.package)
          })[0]

          if (vm.edit || !exist){
            console.log(app)
            if (app.apk && (!vm.edit || (vm.edit && exist.apk && exist.apk.versionCode != app.apk.versionCode))){
              var fd = new FormData();
              fd.append('file', application_file.files[0]);
              ApplicationList.uploadApplication(fd)
              .then(function(result){
                if (vm.edit){
                  var index = vm.applications.newList.indexOf(exist);
                  vm.applications.newList[index] = app;
                  // vm.applications.newList.splice(vm.applications.newList.indexOf(exist), 1);
                  // vm.applications.newList.push(app);
                }
                else vm.applications.newList.push(app);
                vm.applications.appChanged = true;
                $mdDialog.cancel();
                Toast.showAddApplicationSuccess();
                // vm.appLoading = false;
              })
              .catch(function(e){
                Toast.showAddApplicationError();
                // vm.appLoading = false;
              });
            }
            else{
              if (vm.edit){
                var index = vm.applications.newList.indexOf(exist);
                  vm.applications.newList[index] = app;
                // vm.applications.newList.splice(vm.applications.newList.indexOf(exist), 1);
                // vm.applications.newList.push(app);
              }
              else vm.applications.newList.push(app);
              vm.applications.appChanged = true;
              $mdDialog.cancel();
              Toast.showAddApplicationUpdateSuccess();
              // vm.appLoading = false;
            }
          }
          else{
            Toast.showAddApplicationError();
            // vm.appLoading = false;
          }
        }
      }
        // vm.appLoading = false;
    }

    function saveApplicationList(){
      // vm.loading = true;
      var io_white_list = [];
      var kiosk_white_list = [];
      vm.applicationList.name = vm.applicationList.name.trim();
      if(vm.applicationList.name){
        vm.curApplications.map(function(app){
          var addApp = {"name" : app.name, "package" : app.package};
          if (app.apk)
            addApp.versionCode= app.apk.versionCode;
          if (app.io)
            io_white_list.push(addApp);
          if (app.kiosk)
            kiosk_white_list.push(addApp);
        })

        vm.applicationList.io_white_list = io_white_list;
        vm.applicationList.kiosk_white_list = kiosk_white_list;
        vm.applicationList.org_id = vm.organizationId;

        if (!vm.applicationList._id || clone){ //add new list
          ApplicationList.addApplicationList(vm.applicationList)
          .then(function(){
            // vm.loading = false;
            $mdDialog.hide();
          })
          .catch(function(e){
            // vm.loading = false;
            if(e.status !== 404){ ExceptionHandler.show(e) }
          });
        }
        else{ //update list
          ApplicationList.updateApplicationList(vm.applicationList._id, vm.applicationList)
          .then(function(){
            // vm.loading = false;
            // $mdDialog.cancel();
            $mdDialog.hide();
            Toast.showUpdate();
          })
          .catch(function(e){
            // vm.loading = false;
            if(e.status !== 404){ ExceptionHandler.show(e) }
          });
        }
      }
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function selectAll_io(check) {
      if (check){
        vm.curApplications.map(function(app){
          if (app.package != "DEFAULT")
            app.io = true;
        });
      }
      else{
        vm.curApplications.map(function(app){
          app.io = false;
        });
      }
    }

    function selectAll_kiosk(check) {
      if (check){
        vm.curApplications.map(function(app){
          app.kiosk = true;
        });
      }
      else{
        vm.curApplications.map(function(app){
          app.kiosk = false;
        });
      }
    }

    function checkSelectAll(list){
        if (list == "io"){
          var checked = vm.curApplications.filter(function(app){
            return (!app.io || app.io == false) && app.package != "DEFAULT";
          });
          if (!checked[0]) vm.select_all_io = true;
          else vm.select_all_io = false;
        }
        else if (list == "kiosk"){
          var checked = vm.curApplications.filter(function(app){
            return (!app.kiosk || app.kiosk == false);
          });
          if (!checked[0]) vm.select_all_kiosk = true;
          else vm.select_all_kiosk = false;
        }
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.reseller-manager', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.reseller-manager', {
      url: '/reseller-manager?rootId',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/reseller/reseller-manager/reseller.manager.html',
          controller: 'resellerManagerController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('reseller_resource','GET')
        }
      }
    });

    // Translation
   // $translatePartialLoaderProvider.addPart('app/main/restricted/reseller/reseller-manager');

    // Navigation
    msNavigationServiceProvider.saveItem('Reseller.reseller-manager', {
      title: 'Reseller Manager',
      icon: '',
      state: 'app.restricted.reseller-manager',
      translate: 'NAVIGATION_RESELLER_MANAGER',
      weight: 6
    });
  }
})();

(function () {
  angular.module('app.restricted.reseller-manager')
    .controller('resellerDialogController', resellerDialogController);

  /** @ngInject*/
  function resellerDialogController($mdDialog, $scope, $q, License,Toast, Reseller, reseller, localStorageService, Auth, Site, $timeout, ExceptionHandler, Role, api, Config, orderByFilter, CONSTANT, Branding, $rootScope) {
    var vm = this;
    vm.flagSave = true;

    vm.reseller = reseller;
    vm.sites = [];
    vm.services = CONSTANT.SERVICES_SMS.split(',');//['Nexmo', 'Partner'];
    vm.cancel = cancel;
    vm.ok = ok;
    // vm.setActiveAllocation = setActiveAllocation;  //shahar- remove license
    // vm.checkActiveAllocation = checkActiveAllocation;
    // vm.addDraftAllocation = addDraftAllocation;
    // vm.removeDraftAllocation = removeDraftAllocation;
    // vm.revokeAllocation = revokeAllocation;
    // vm.switchToAllocationTab = switchToAllocationTab;
    // vm.checkAvailableQuantity = checkAvailableQuantity;
    vm.onTabChanges = onTabChanges;
    vm.checkTabIndex = checkTabIndex;
    // vm.getParentAllocationIndex = getParentAllocationIndex;  //shahar- remove license
    // vm.undoAllocate = undoAllocate;
    // vm.editLicense = editLicense;
    vm.setRecordsCount = setRecordsCount;
    vm.saveOBrandingInfo = saveOBrandingInfo;
    vm.resetAllOverrideValues = resetAllOverrideValues;
    // vm.loading = true;
    vm.activeAllocation = "";

    vm.allowCreate = Auth.isActionAllowed('reseller_resource','POST');
    vm.allowModify = Auth.isActionAllowed('reseller_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('reseller_resource','DELETE');

    vm.enable_max_login_retries = false;
    vm.enable_password_expiration_days = false;

    vm.selectedTabIndex = 0;
    vm.showAllocationTab = false;
    vm.recordsCount = 25;
    //vm.draftLicenses = [];
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    //vm.sortAllocate = sortAllocate;

    vm.saveAllocate = [];
    vm.reverse = [];

    setResellers();

    // function switchToAllocationTab(){  //shahar- remove license
    //   vm.showAllocationTab = true;
    //   $timeout(function(){vm.selectedTabIndex = 2}, 300);

    // }
    // function setActiveAllocation(allocationId){
    //   vm.activeAllocation = allocationId;
    // }

    // function checkActiveAllocation(allocationId){
    //   return (allocationId == vm.activeAllocation);
    // }

    // function checkAvailableQuantity(available, allocate){
    //   return (allocate <= available);
    // }

    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    // function addDraftAllocation(allocation){  //shahar- remove license
    //   var newAllocation = angular.copy(allocation);
    //   var allocationIndex = getParentAllocationIndex(newAllocation);
    //   vm.parentLicenses[allocationIndex].availableQty -= newAllocation.setQty;
    //   vm.parentLicenses[allocationIndex].setQty = 0;

    //   if(newAllocation.setQty !=0 && newAllocation.setQty!=null){
    //     vm.draftLicenses.push(newAllocation);
    //     vm.saveAllocate[allocationIndex].isAllocate = true;
    //     vm.saveAllocate[allocationIndex].qty = newAllocation.setQty;
    //   }

    // }

    // function undoAllocate(allocation) {//shahar- remove license
    //   var allocationIndex = getParentAllocationIndex(allocation);
    //   allocation.setQty = vm.saveAllocate[allocationIndex].qty;
    //   removeDraftAllocation(allocation);
    //   vm.parentLicenses[allocationIndex].setQty = "";
    //   vm.saveAllocate[allocationIndex].isAllocate = false;
    //   vm.saveAllocate[allocationIndex].qty = 0;
    //   vm.activeAllocation = undefined;
    // }

    // function removeDraftAllocation(allocation){  //shahar- remove license
    //   var allocationIndex = vm.draftLicenses.indexOf(allocation);
    //   var parentAllocationIndex = getParentAllocationIndex(allocation);
    //   vm.parentLicenses[parentAllocationIndex].availableQty += allocation.setQty;
    //   vm.draftLicenses.splice(allocationIndex,1);
    // }

    // function getParentAllocationIndex(allocation){  //shahar- remove license
    //   for(var i=0; i<vm.parentLicenses.length; i++){
    //     if(vm.parentLicenses[i]._id === allocation._id){
    //       return i;
    //     }
    //   }
    // }

    // function allocate(allocation, orgId) {  //shahar- remove license
    //   var deferred = $q.defer();

    //   var alloc = {};

    //   alloc.parentResellerAllocation = allocation._id;
    //   alloc.licenseBundle = allocation.licenseBundle._id;
    //   alloc.licenseType = allocation.licenseType;
    //   alloc.initiateToOrgNodeId = orgId;
    //   alloc.expirationDate = allocation.expirationDate;
    //   alloc.expirationType = allocation.expirationType;
    //   alloc.active = allocation.active;
    //   alloc.qty = allocation.setQty;

    //   if (alloc.qty != '') {

    //     License.addAllocation(alloc)
    //       .then(function (resp) {
    //         console.log(resp);
    //         deferred.resolve(resp);
    //       })
    //       .catch(function (e) {
    //         ExceptionHandler.show(e);
    //         deferred.reject(e);
    //       });
    //   }else{
    //     deferred.reject("");
    //   }
    //   return deferred.promise;
    // }

    // function revokeAllocation(allocationId){  //shahar- remove license
    //   License.revokeAllocationAtReseller(allocationId)
    //     .then(function(resp){
    //       console.log(resp);
    //       Toast.showRevoke();
    //       setResellers();

    //     })
    //     .catch(function(e){
    //       if(e.data.msg === 'failed'){
    //         Toast.showFailedRevoke();
    //       }else{
    //         ExceptionHandler.show(e);
    //       }
    //     })
    // }

    function setResellers() {

      // License.getAllocationList(vm.reseller._id)
      //   .then(function (resp) {
      //     vm.licenses = resp;
      //   })
      //   .catch(function(e){
      //     ExceptionHandler.log(e);
      //   });

      // License.getAllocationList(vm.reseller.parentReseller)
      //   .then(function (resp) {
      //     vm.parentLicenses = resp;
      //     initSaveAllocateArray();
      //   })
      //   .catch(function(e){
      //     ExceptionHandler.log(e);
      //   });

      if (!vm.reseller.sms)
      {
        vm.reseller.sms = {};
        if (!vm.reseller.sms.service)
          vm.reseller.sms.service = "Nexmo";
      }
      
      vm.reseller._id ? vm.qty = vm.reseller.qty-vm.reseller.availble_qty + "/" + vm.reseller.qty : vm.qty = "0";
      vm.reseller._id ? vm.dispatcherqty = vm.reseller.dispatcher_qty-vm.reseller.dispatcher_availble_qty + "/" + vm.reseller.dispatcher_qty : vm.dispatcherqty = "0";

      vm.reseller.max_login_retries = vm.reseller.max_login_retries ? vm.reseller.max_login_retries.toString() : null;
      vm.reseller.password_expiration_days = vm.reseller.password_expiration_days ? vm.reseller.password_expiration_days.toString() : null;
      vm.enable_max_login_retries = vm.reseller.max_login_retries ? true : false;
      vm.enable_password_expiration_days = vm.reseller.password_expiration_days ? true : false;

      getConfig();
      getSites();
      getBranding();
    }

    function getConfig(){
      Config.getFilterList().then(function(resp){
        vm.configs = resp;

        var showSms = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_SMS";
        });
        if (!showSms || !showSms[0].value || showSms[0].value == "0")
          vm.showSms = false;
        else
          vm.showSms = true;

        vm.showLicenseAllocation = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_LICENSE_ALLOCATION";
        });
        
        if (!vm.showLicenseAllocation || !vm.showLicenseAllocation[0].value || vm.showLicenseAllocation[0].value == "0")
          vm.showLicenseAllocation = false;
        else
          vm.showLicenseAllocation = true;

        vm.showBranding = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_BRANDING";
        });
        
        if (!vm.showBranding || !vm.showBranding[0] || vm.showBranding[0].value == "0")
          vm.showBranding = false;
        else
          vm.showBranding = true;

        vm.showStrongAdministratorPass = vm.configs.filter(function (param) {
          return param.name == "PROV_SHOW_STRONG_ADMINISTRATOR_PASS";
        });
        if (!vm.showStrongAdministratorPass || !vm.showStrongAdministratorPass[0] || vm.showStrongAdministratorPass[0].value == "0")
          vm.showStrongAdministratorPass = false;
        else
          vm.showStrongAdministratorPass = true;

        vm.showMaxRetries = vm.configs.filter(function (param) {
          return param.name == "PROV_SHOW_BLOCK_RELEASE";
        });
        if (!vm.showMaxRetries || !vm.showMaxRetries[0] || vm.showMaxRetries[0].value == "0")
          vm.showMaxRetries = false;
        else
          vm.showMaxRetries = true;
  
        vm.showPasswordExpiration = vm.configs.filter(function (param) {
          return param.name == "PROV_SHOW_CHANGE_PASSWORD";
        });
        if (!vm.showPasswordExpiration || !vm.showPasswordExpiration[0] || vm.showPasswordExpiration[0].value == "0")
          vm.showPasswordExpiration = false;
        else
          vm.showPasswordExpiration = true;
      });
    }

    function getSites(){

      Site.getList()
        .then(function(resp){
          vm.sites = resp.filter(function(site){
            return site.type === 1;
          })
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function getBranding(){
      if(vm.reseller._id){
        Branding.getBrandingInfo(vm.reseller._id)
          .then(function(respBrand){
            vm.brand = respBrand;
          })
          .catch(function(e){
            if(e.status !== 404)
              ExceptionHandler.show(e);
          });


          var flowFunctionsArray = [];

          flowFunctionsArray.push(getBrandingImage(vm.reseller._id));
          flowFunctionsArray.push(getImage(vm.reseller._id, "Logo"));
          flowFunctionsArray.push(getImage(vm.reseller._id, "Splash"));
          flowFunctionsArray.push(getImage(vm.reseller._id, "CompanyName"));
          flowFunctionsArray.push(getImage(vm.reseller._id, "ManagementPortal"));
          
          $q.all(flowFunctionsArray)
          .then(function(){
          })
          .catch(function(err){
            ExceptionHandler.show(err);
          });
      }
    }

    function getBrandingImage(resellerId){
      var deferred = $q.defer();
      Branding.getBrandingImage(resellerId)
      .then(function(respBrandImg){
        vm.image="";
        if(typeof respBrandImg.image !== 'undefined'){
          vm.image = respBrandImg.image;
        }
        deferred.resolve();
      })
      .catch(function(e){
        deferred.reject(e);
      });
      return deferred.promise;
    }

    function getImage(resellerId, type){
      var deferred = $q.defer();
      Branding.getBrandingExtraImage(resellerId, type)
      .then(function(respBrandImg){
        if(typeof respBrandImg.image !== 'undefined'){
          if (type == "Logo")
            vm.image_mdc_logo = respBrandImg.image;
          else if (type == "Splash")
            vm.image_mdc_splash = respBrandImg.image;
          else if (type == "CompanyName")
            vm.image_mdc_companyName = respBrandImg.image;
          else if (type == "ManagementPortal")
            vm.management_portal_image = respBrandImg.image;
        }
        deferred.resolve();
      })
      .catch(function(e){
        deferred.reject(e);
      });
      return deferred.promise;
    }

    // function initSaveAllocateArray(){  //shahar- remove license
    //   for (var item in vm.parentLicenses) {
    //     vm.saveAllocate.push({isAllocate:false, qty:0});
    //   }
    // }

    function onTabChanges(index){
      vm.activeTab = index;
    }

    function checkTabIndex(index){
      return vm.activeTab == index;
    }

    function addReseller(){
      // vm.loading = true;
      Reseller.add(reseller)
        .then(function (resp) {

          //Add default reseller role
          var resellerAdminRole = {
            name: "Reseller Admin Role",
            orgNodeId: resp._id,
            permissions: Role.getResellerAdminPermissions()
          };
          addRole(resellerAdminRole);

          $mdDialog.hide(vm.reseller);

          // var allocationsArray = [];   // shahar- remove license

          // if(vm.draftLicenses.length>0){
          //   vm.draftLicenses.forEach(function(license){
          //     allocationsArray.push(allocate(license,resp._id));
          //   });

          //   $q.all(allocationsArray)
          //     .then(function(result){
          //       $mdDialog.hide(vm.reseller);
          //     })
          //     .catch(function(e){
          //       ExceptionHandler.show(e);
          //     })
          // }
          // else{
          //   $mdDialog.hide(vm.reseller);
          // }
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
          vm.flagSave = true;
        });
    }

    function updateReseller(){
      // vm.loading = true;
      Reseller.update(vm.reseller)
        .then(function(resp){
          $mdDialog.hide(vm.reseller);
          // if( vm.draftLicenses.length > 0){  //shahar- remove license
          //   var allocationsArray = [];
          //   vm.draftLicenses.forEach(function(license){
          //     allocationsArray.push(allocate(license,vm.reseller._id));
          //   });

          //   $q.all(allocationsArray)
          //     .then(function(result){
          //       $mdDialog.hide(vm.reseller);
          //     })
          //     .catch(function(e){
          //       ExceptionHandler.show(e);
          //     })
          // }
          // else{
          //   $mdDialog.hide(vm.reseller);
          // }
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.flagSave = true;
          // vm.loading = false;
        });
    }

    // function editLicense(license, allocationId) { //shahar- remove license
    //   var curRes = {};
    //   angular.copy(license, curRes);
    //   if (license.dispatcher.dispatcher === undefined){
    //     if (license.dispatcher == false)
    //     {
    //       license.dispatcher= {
    //         dispatcher: false,
    //         multiSession: "0"
    //       };
    //     }
    //     else
    //     {
    //       license.dispatcher= {
    //         dispatcher: true,
    //         multiSession: "1"
    //       };
    //     }
    // }

    //   $mdDialog.show({
    //     controller: 'licenseDetailsController as vm',
    //     templateUrl: 'app/main/restricted/platform/licenses/details/details.dialog.html',
    //     parent: angular.element(document.body),
    //     clickOutsideToClose: false,
    //     multiple: true,
    //     locals: {
    //       license: curRes,
    //       allocationId: allocationId
    //     }
    //   })

    // }

    function addRole(role){
      api.roles.newRole.save(role,
        function(resRole) {
          if (role.permissions.length) {
            api.roles.updateRole.put({ id: resRole._id }, { name: role.name, permissions: role.permissions, orgNodeId:role.orgNodeId }, function (role) {
            }, function (e) {
              vm.flagSave = true;
              ExceptionHandler.show(e);
            });
          }
        }, function (e) {
          vm.flagSave = true;
          ExceptionHandler.show(e);
        });
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function ok() {
      vm.flagSave = false;
      //Check if there are some values set to parent allocations and add them to drafts
      // if(vm.parentLicenses.length > 0){   //shahar- remove license
      //   vm.parentLicenses.forEach(function(parentAllocation){
      //     if(parentAllocation.setQty > 0) {
      //       if(parentAllocation.setQty < parentAllocation.availableQty){
      //         vm.draftLicenses.push(parentAllocation);
      //       }
      //     }
      //   });
      // }
      vm.reseller.crmId = vm.reseller.crmId.trim();
      vm.reseller.name = vm.reseller.name.trim();
      vm.reseller.max_login_retries = !vm.enable_max_login_retries ? null : vm.reseller.max_login_retries;
      vm.reseller.password_expiration_days = !vm.enable_password_expiration_days ? null : vm.reseller.password_expiration_days;

      if (!vm.reseller.max_login_retries || vm.reseller.max_login_retries == 0){
        vm.enable_max_login_retries = 0;
        vm.reseller.max_login_retries = null;
      }
      if (!vm.reseller.password_expiration_days || vm.reseller.password_expiration_days == 0){
        vm.enable_password_expiration_days = 0;
        vm.reseller.password_expiration_days = null;
      }
      
      if(vm.reseller.name && vm.reseller.crmId)
        vm.reseller._id ? updateReseller() : addReseller();
      else
        vm.flagSave = true;
    }

    // function sortAllocate(param){   //shahar- remove license
    //   vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
    //   vm.parentLicenses = orderByFilter(vm.parentLicenses,param,vm.reverse[param])
    // }

    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.licenses = orderByFilter(vm.licenses,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    function saveOBranding(){
      // vm.loading = true ;

      var flowFunctionsArray = [];

      if(file.files.length===0 && vm.brand.override_branding_image  && !vm.image)
        vm.brand.override_branding_image = false;
      if (file.files.length > 0)
        flowFunctionsArray.push(uploadBrandingImage(file, vm.reseller._id))

      if(file_mdc_logo.files.length===0 && vm.brand.override_mdc_logo_image  && !vm.image_mdc_logo)
        vm.brand.override_mdc_logo_image = false;
      if (file_mdc_logo.files.length > 0)
        flowFunctionsArray.push(uploadImage(file_mdc_logo, vm.reseller._id, "Logo"))

      if(file_mdc_splash.files.length===0 && vm.brand.override_mdc_splash_image  && !vm.image_mdc_splash)
        vm.brand.override_mdc_splash_image = false;
      if (file_mdc_splash.files.length > 0)
        flowFunctionsArray.push(uploadImage(file_mdc_splash, vm.reseller._id, "Splash"))

      if(file_mdc_companyName.files.length===0 && vm.brand.override_mdc_companyName_image  && !vm.image_mdc_companyName)
        vm.brand.override_mdc_companyName_image = false;
      if (file_mdc_companyName.files.length > 0)
        flowFunctionsArray.push(uploadImage(file_mdc_companyName, vm.reseller._id, "CompanyName"))

      if(management_portal_logo.files.length===0 && vm.brand.override_management_portal_image  && !vm.management_portal_image)
        vm.brand.override_management_portal_image = false;
      if (management_portal_logo.files.length > 0)
        flowFunctionsArray.push(uploadImage(management_portal_logo, vm.reseller._id, "ManagementPortal"))
        
      
      $q.all(flowFunctionsArray)
      .then(function(){
        $rootScope.$emit('upadatebranding');
        // vm.loading = false;
        Toast.showUpdate();
      })
      .catch(function(err){
        // vm.loading = false ;
        ExceptionHandler.show(err);
      });
    }

    function saveOBrandingInfo() {
      // vm.loading = true ;

      var regexp = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

      if (!vm.brand.name)
        vm.brand.override_branding_name = false;

      Branding.setBrandingInfo(vm.brand,vm.reseller._id)
        .then(function () {
          saveOBranding();
        })
        .catch(function(e){
          ExceptionHandler.show(e);
          // vm.loading = false ;
        });

    }

    function uploadBrandingImage(file, resellerId){
      var deferred = $q.defer();

      var fd = new FormData();
      fd.append('file', file.files[0]);
      
      Branding.setBrandingImage(fd, resellerId)
      .then(function(result){
        Branding.getBrandingImage(resellerId)
          .then(function(respBrandImg){
            vm.image = respBrandImg.image;
            deferred.resolve();
          })
          .catch(function(e){
            deferred.reject(e);
          });
      })
      .catch(function (e) {
        deferred.reject(e);
      });

      return deferred.promise;
    }

    function uploadImage(file, resellerId, type){
      var deferred = $q.defer();

      var fd = new FormData();
      fd.append('file', file.files[0]);
      
      Branding.setBrandingExtraImage(fd, resellerId, type)
      .then(function(result){
        Branding.getBrandingExtraImage(resellerId, type)
          .then(function(respBrandImg){
            if (type == "Logo")
              vm.image_mdc_logo = respBrandImg.image;
            else if (type == "Splash")
              vm.image_mdc_splash = respBrandImg.image;
            else if (type == "CompanyName")
              vm.image_mdc_companyName = respBrandImg.image;
            else if (type == "ManagementPortal")
              vm.management_portal_image = respBrandImg.image;
            deferred.resolve();
          })
          .catch(function(e){
            deferred.reject(e);
          });
      })
      .catch(function (e) {
        deferred.reject(e);
      });

      return deferred.promise;
    }


    function resetAllOverrideValues() {
      vm.brand.override_branding_name = false;
      vm.brand.override_branding_color1 = false;
      vm.brand.override_branding_color2 = false;
      vm.brand.override_branding_image = false;
      vm.brand.override_mdc_logo_image = false;
      vm.brand.override_mdc_splash_image = false;
      vm.brand.override_mdc_companyName_image = false;
      vm.brand.override_management_portal_image = false;
    }

    $scope.onUploadFile = function(elem){
      if (elem.files && elem.files.length > 0){
        var ext = elem.files[0].name.split('.');
        if (!elem.accept.includes(ext[ext.length-1])){
          if (elem.name == "file")
            vm.resellerFormBranding.file.$setValidity('validationError', false);
          if (elem.name == "file_mdc_logo")
            vm.resellerFormBranding.file_mdc_logo.$setValidity('validationError', false);
          if (elem.name == "file_mdc_splash")
            vm.resellerFormBranding.file_mdc_splash.$setValidity('validationError', false);
          if (elem.name == "file_mdc_companyName")
            vm.resellerFormBranding.file_mdc_companyName.$setValidity('validationError', false);
          if (elem.name == "file_management_portal")
            vm.resellerFormBranding.management_portal_logo.$setValidity('validationError', false);
        }
        else{
          if (elem.name == "file")
            vm.resellerFormBranding.file.$setValidity('validationError', true);
          if (elem.name == "file_mdc_logo")
            vm.resellerFormBranding.file_mdc_logo.$setValidity('validationError', true);
          if (elem.name == "file_mdc_splash")
            vm.resellerFormBranding.file_mdc_splash.$setValidity('validationError', true);
          if (elem.name == "file_mdc_companyName")
            vm.resellerFormBranding.file_mdc_companyName.$setValidity('validationError', true);
          if (elem.name == "file_management_portal")
            vm.resellerFormBranding.management_portal_logo.$setValidity('validationError', true);
        }
      }
      else{
        if (elem.name == "file")
            vm.resellerFormBranding.file.$setValidity('validationError', true);
          if (elem.name == "file_mdc_logo")
            vm.resellerFormBranding.file_mdc_logo.$setValidity('validationError', true);
          if (elem.name == "file_mdc_splash")
            vm.resellerFormBranding.file_mdc_splash.$setValidity('validationError', true);
          if (elem.name == "file_mdc_companyName")
            vm.resellerFormBranding.file_mdc_companyName.$setValidity('validationError', true);
          if (elem.name == "file_management_portal")
            vm.resellerFormBranding.management_portal_logo.$setValidity('validationError', true);
      }
    }

  }

})();

(function(){
  'use strict';

  angular.module('app.restricted.reseller-details', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.reseller-details', {
      url: '/reseller-details',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/reseller/reseller-details/reseller.details.html',
          controller: 'ResellerDetailsController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('reseller_resource','GET')
        }
      }
    });

    // Translation
   // $translatePartialLoaderProvider.addPart('app/main/restricted/reseller/reselle');

    // Navigation
    msNavigationServiceProvider.saveItem('Reseller.reseller-details', {
      title: 'Reseller details',
      icon: '',
      state: 'app.restricted.reseller-details',
      translate: 'NAVIGATION_RESELLER_DETAILS',
      weight: 6
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.reseller-details')
    .controller('resellerAllocationDialogController', resellerAllocationDialogController);

  /** @ngInject*/
  function resellerAllocationDialogController($mdDialog, License, Auth, allocation, ExceptionHandler) {
    var vm = this;

    vm.allocation = allocation;
    vm.cancel = cancel;
    vm.ok = ok;

    vm.allowCreate = Auth.isActionAllowed('reseller_resource','POST');
    vm.allowModify = Auth.isActionAllowed('reseller_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('reseller_resource','DELETE');

    //Stubs
    vm.lType = [
      {
        "id": 1,
        "name": "Demo"
      },
      {
        "id": 2,
        "name":"Trial"
      },
      {
        "id": 3,
        "name":"Commercial"
      }
    ];

    vm.rType = [
      {
        "id": 1,
        "name": "Perpetual"
      },
      {
        "id": 2,
        "name":"Recurrent"
      }
    ];

    init();

    function init() {

      License.getList()
        .then(function(resp){
          vm.bundles = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })

    }

    function cancel() {
      $mdDialog.cancel();
    }

    function ok() {
      vm.allocation.allocationDate = new Date();
      vm.allocation.active = true;
      vm.allocation.parentResellerAllocation = null;

      $mdDialog.hide(vm.allocation);
    }

  }

})();

(function () {
  angular.module('app.restricted.organization-manager')
    .controller('organizationDialogController', organizationDialogController)
    .filter('trustAsResourceUrl', ['$sce', function ($sce) {
        return function (val) {
            return $sce.trustAsResourceUrl(val);
        };
    }]);

  /** @ngInject*/
  function organizationDialogController($scope, $mdDialog, $filter, Role, $q, Toast, Organization, Subscriber, organization, resellerSite, Auth, Site, localStorageService, ExceptionHandler, $timeout, orderByFilter, Branding, $http, api, OrgFriends, RecordWhiteList, configs, Group,License,PersonalContacts,$translate, $location, $rootScope, ProgressCircularSer) {
    var vm = this;
    vm.flagSave = true;
    vm.disablebutton = false;
    vm.organization = organization;
    vm.cancel = cancel;
    vm.ok = ok;
    vm.image = null;
    vm.configs = configs;
    vm.search = '';
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.types = Group.getShortTypes();
    var date = new Date()
    vm.now = new Date(date.setDate(date.getDate() + 1));
    this.licensesTemplate = [];
    this.allLicensesTemplate = [];
    this.subscribers = [];
    this.subscribersNew = [];
    // vm.setActiveAllocation = setActiveAllocation;
    // vm.checkActiveAllocation = checkActiveAllocation;
    //vm.addDraftAllocation = addDraftAllocation;
    // vm.getParentAllocationIndex = getParentAllocationIndex;
    // vm.revokeAllocation = revokeAllocation;
    // vm.removeDraftAllocation = removeDraftAllocation;
    // vm.switchToAllocationTab = switchToAllocationTab;
    // vm.checkAvailableQuantity = checkAvailableQuantity;
    vm.onTabChanges = onTabChanges;
    vm.checkTabIndex = checkTabIndex;
    // vm.undoAllocate = undoAllocate;
    //vm.editLicense = editLicense;
    vm.loading = true;
    vm.sort = sort;
    //vm.sortAllocate = sortAllocate;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    vm.resetDate = resetDate;
    vm.saveOBranding = saveOBranding;
    vm.saveOBrandingInfo = saveOBrandingInfo;
    vm.saveOrgFriends = saveOrgFriends;
    vm.resetAllOverrideValues = resetAllOverrideValues;
    vm.uploadEncryptionFile = uploadEncryptionFile;
    vm.setEncryptionFile = setEncryptionFile;
    vm.setDefaultEncryptionFile = setDefaultEncryptionFile;
    vm.setEmptyEncryptionFile = setEmptyEncryptionFile;
    vm.uploadAndroidVersionFile = uploadAndroidVersionFile;
    vm.deleteAndroidVersionFile = deleteAndroidVersionFile;
    vm.uploadMDCVersionFile = uploadMDCVersionFile;
    vm.deleteMDCVersionFile = deleteMDCVersionFile;
    vm.addGroup = addGroup;
    vm.addAffContactTemplate = addAffContactTemplate;
    vm.editGroup = editGroup;
    vm.editContacts = editContacts;
    vm.removeGroup = removeGroup;
    vm.demoChecked = demoChecked;
    vm.saveOrganization = saveOrganization;
    vm.supportContactname = supportContactname;
    vm.saveSentinel = saveSentinel;
    vm.clearSentinel = clearSentinel;
    vm.image_mdc_logo = "";
    vm.image_mdc_splash = "";
    vm.image_mdc_companyName = "";
    vm.management_portal_image = "";
    vm.resultContactTempErrLog='';

    vm.affiliatedOrgsPagination = "affiliatedOrgs"
    vm.activeAllocation = "";
    vm.activeTab = 0;
    vm.isRootAdmin = Auth.isRootAdmin();
    vm.allowCreate = Auth.isActionAllowed('organization_resource', 'POST');
    vm.allowModify = Auth.isActionAllowed('organization_resource', 'PUT');
    vm.allowDelete = Auth.isActionAllowed('organization_resource', 'DELETE');

    vm.allowLicenseDelete = Auth.isActionAllowed('license_resource', 'DELETE');

    vm.allowModifyAudioRecorder = !Auth.isOrgAdmin();//Auth.isActionAllowed('reseller_resource','PUT');
    vm.isAdministrator = Auth.isAdministrator();
    vm.allowModifyCallLog = Auth.isActionAllowed('reseller_resource', 'PUT');
    vm.allowModifyAffiliatedOrgs = Auth.isActionAllowed('reseller_resource', 'PUT');

    vm.allowSetEncryption = Auth.isActionAllowed('organization_resource', 'HIMPACT');

    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;

    vm.allowCreateGroups = Auth.isActionAllowed('group_resource', 'POST');
    vm.allowModifyGroups = Auth.isActionAllowed('group_resource', 'PUT');
    vm.allowDeleteGroups = Auth.isActionAllowed('group_resource', 'DELETE');

    vm.enable_max_login_retries = false;
    vm.enable_password_expiration_days = false;

    vm.recordsCount = 25;

    vm.saveAllocate = [];
    vm.contactTemplates = [];
    vm.reverse = [];
    vm.currentEncStatus = {encFormat : '', encVersion: 0}
    //Start Bulk Aff Contact Template
    vm.changeContactTemplateList = changeContactTemplateList;
    vm.batchContactTemplateAssignment = batchContactTemplateAssignment;
    vm.templateType = "Subscribers";
    vm.subscriberLength = 0;
    vm.affContactTemplates = [];
    vm.selectedContactTemplate = [];
    vm.notSelectedContactTemplate = [];
    vm.affNotSelectedSubscriber = [];
    vm.backUpNonSelectedSub = [];
    vm.bulAffSubscribers =[];
    vm.notSelectedAssignContactTemplate = [];
    vm.selectedSubscribers = [];
    vm.selectedAssignContactTemplate = [];
    vm.ContactTemplateUser = [];
    vm.selectedContactTemplateUser = [];
    vm.contactTemplatePaginationClass = "contactTemplatesPagination";
    vm.TemplatePaginationClass = "templatesPagination";
    vm.recorder = "noRecord";
    
    //End Bulk Aff Contact Template
    init();

    function getRecordings() {
      return new Promise(function (resolve, reject) {
        if (vm.organization.isRecorded == 0) {
          vm.recorder = "noRecord";
          resolve();
        }
        else {
          vm.organization._id && RecordWhiteList.getByOrgId(vm.organization._id)
            .then(function (results) {
              if (!results.length) {
                vm.recorder = "noRecord";              
              }
              else {
                if (results[0].is_selective)
                  vm.recorder = "selective";
                else
                  vm.recorder = "allCalls";
              }
              resolve();
            })
            .catch(function (e) {
              vm.recorder = "noRecord";
              resolve();
            });
        }
      })
    }


    function getRecReviewersStrongPass() {
      return new Promise(function (resolve, reject) {
        vm.organization._id && RecordWhiteList.getByOrgId(vm.organization._id)
          .then(function (results) {
            if (!results.length) {
              vm.strongRecordingReviewersPass = false;
              resolve();
            }
            if(results[0])
            {
              if (results[0].force_strong_pass_for_reviewers)
                vm.strongRecordingReviewersPass = true
              else
                vm.strongRecordingReviewersPass = false
            }
            else
              vm.strongRecordingReviewersPass = false
            resolve();

          })
          .catch(function (e) {
            vm.strongRecordingReviewersPass = false
            resolve();
          });
      })
    }

    function getCurrentEncKeysStatus() {
      Organization.getOrganizationEncStatus(vm.organization._id)
      .then(function (resp) {
        convertEncKeysStatusToString(resp)
      })
      .catch(function (e) {
        ExceptionHandler.show(e.data);
      })
    }

    function convertEncKeysStatusToString(currentEncDetails) {
      vm.currentEncStatus.encVersion = currentEncDetails.encVersion
      switch (currentEncDetails.encFormat) {
        case 0:
          vm.currentEncStatus.encFormats = "Unknown"
          break
        case 1:
          vm.currentEncStatus.encFormat = "APP_ENCRYPTION_KEYS_CURRENT_STATUS_NO_KEYS"
          break
        case 2:
          vm.currentEncStatus.encFormat = "APP_ENCRYPTION_KEYS_CURRENT_STATUS_DEFAULT_KEYS"
          break
        case 3:
          vm.currentEncStatus.encFormat = "APP_ENCRYPTION_KEYS_CURRENT_STATUS_RANDOM_KEYS"
          break
        case 4:
          vm.currentEncStatus.encFormat = "APP_ENCRYPTION_KEYS_CURRENT_STATUS_UPLOAD_KEYS_FILE"
          break
        default:
          vm.currentEncStatus.encFormat = "Unknown"
          break
      }
      //$scope.vm.currentEncStatus.encFormat = $filter('translate')($scope.vm.currentEncStatus.encFormat);
    }
    function getSite() {
      return new Promise(function (resolve, reject) {
        Site.getList()
          .then(function (resp) {
            vm.sites = resp.filter(function (site) {
              site.iprs_public = site.iprs_public ? "(" + site.iprs_public + ")" : "";
              return site.type === 1;
            });
            resolve();
          })
          .catch(function (e) {
            reject(e);
          })
      });
    }

    function getBranding() {
      return new Promise(function (resolve, reject) {
        if (vm.organization.id) {
          Branding.getBrandingInfo(vm.organization.id)
            .then(function (respBrand) {
              vm.brand = respBrand;
            })
            .catch(function (e) {
              if (e.status !== 404) reject(e);
              else resolve();
            });

          if(vm.showBranding)
          {

            var flowFunctionsArray = [];

            flowFunctionsArray.push(getBrandingImage(vm.organization.id));
            flowFunctionsArray.push(getImage(vm.organization.id, "Logo"));
            flowFunctionsArray.push(getImage(vm.organization.id, "Splash"));
            flowFunctionsArray.push(getImage(vm.organization.id, "CompanyName"));
            flowFunctionsArray.push(getImage(vm.organization.id, "ManagementPortal"));
  
            $q.all(flowFunctionsArray)
              .then(function () {
                resolve();
              })
              .catch(function (e) {
                reject(e);
              });
          }
          else
          {
            resolve();
          }
        }
      });
    }

    function getSubscribers() {
      return new Promise(function(resolve, reject){
        Subscriber.getSubscriberDataByOrg(vm.organization._id)
          .then(function (resp) {
            vm.subscribers = resp;
            vm.customLicense=[];
            vm.loading = true;
            for(var i=0;i<vm.subscribers.length;i++)
            {
              if(!vm.allLicensesTemplate.includes(vm.subscribers[i].permissions_mask))
              {
                if(!vm.customLicense.includes(vm.subscribers[i].permissions_mask))
                {
                  vm.customLicense.push(vm.subscribers[i].permissions_mask);
                }
              }
              var flag=0;
              for(var j=0;j<vm.licensesTemplate.length;j++)
              {
                if(vm.licensesTemplate[j] == vm.subscribers[i].permissions_mask)
                    flag=1;
              }
              if(flag ==1)
              {
                vm.subscribersNew.push(vm.subscribers[i]);
              }
            }
            vm.notSelectedSubscriber = angular.copy(vm.subscribers);
            vm.customLicense.forEach(function(element){
                if(element)
                {
                  Subscriber.licenseIsOffNet(element).then(function(resp){
                    for(var p=0;p<vm.subscribers.length;p++)
                    {
                      if((resp.mask == vm.subscribers[p].permissions_mask) && resp.result == true)
                      {
                        vm.subscribersNew.push(vm.subscribers[p]);
                      }
                    }
                  });
                }
            });
            setTimeout(function() {
              vm.subscribers = vm.subscribersNew;
              vm.loading = false;
            }, 1000);
            resolve();
          })
          .catch(function (e) {
            if (e.status !== 404) reject(e);
            else resolve();
          })
      });
    }
    function getLicenseData(){
      License.getLicenseTemplates()
      .then(function(resp){
        for(var i=0;i<resp.length;i++)
          {
            var tempWord =resp[i].name;
            vm.allLicensesTemplate.push(resp[i].mask);
            var checkString = 'OffNet';
              if(tempWord.indexOf(checkString) != -1)
                vm.licensesTemplate.push(resp[i].mask);
          }
        // vm.showLoader = false ;
      })
      .catch(function(err){
        // vm.showLoader = false ;
      });
    }
    function getOrgFriends() {
      return new Promise(function (resolve, reject) {
        Organization.getListOrgByReseller(vm.organization.parentResellerId)
          .then(function (resp) {
            vm.orgs = resp;
            OrgFriends.getByOrgId(vm.organization._id)
              .then(function (resp) {

                vm.orgFriendsID = resp.map(function (orgs) {
                  return orgs._id;
                });
                filterMember();

                vm.orgsFriends = resp;
                vm.orgsFriends.push(vm.organization)

                resolve();
              })
              .catch(function (e) {
                if (e.status !== 404) reject(e)
                else {
                  vm.selectedOrgs = [];
                  vm.unselectedOrgs = vm.orgs.filter(function (org) {
                    return vm.organization._id != org._id;
                  });
                  resolve();
                }
              });
          })
          .catch(function (e) {
            if (e.status !== 404) reject(e);
            else resolve();
          });
      });
    }
    function getBulkAffContact() {
      return new Promise(function (resolve, reject) {
        OrgFriends.getByOrgId(vm.organization.id)
          .then(function (resp) {
            vm.bulkAffOrgsFriends = resp;
            vm.bulkAffOrgsFriends.push(vm.organization)
            vm.selectedDropDown = vm.bulkAffOrgsFriends[vm.bulkAffOrgsFriends.length - 1]._id;
            var flowFunctionsArrays = [];
            vm.members = [];
            vm.affContactTemplates = [];
            vm.contactTemplatesDrop = []
            vm.bulAffSubscribers = [];;
            vm.orgFriendsMap = [];
            vm.bulkAffOrgsFriends.map(function (org) {
              vm.orgFriendsMap[org._id] = org.name;
              flowFunctionsArrays.push(getContactTemplateByOrg(org._id));
              flowFunctionsArrays.push(getSubscribersByOrg(org._id));
            });

            $q.all(flowFunctionsArrays)
              .then(function () {
                vm.notSelectedAssignContactTemplate = vm.members;
                vm.affNotSelectedSubscriber = vm.members;
                vm.backUpNonSelectedSub = Object.assign([],vm.members);
                vm.subscriberLength = vm.members.length;

                vm.contactTemplateLength = vm.affContactTemplates.length;
                vm.notSelectedContactTemplate = vm.affContactTemplates;
                resolve();
              })
              .catch(function (err) {
                ExceptionHandler.show(err);
                resolve();
              })
              .finally(function () {
                vm.loading = false;
                resolve();
              });
          })
          .catch(function (e) {
            if (e.status !== 404) { ExceptionHandler.show(e) }
            resolve();
          });
      });
    }
    function getGroups() {
      return new Promise(function (resolve, reject) {
        var grpType=[1,2,8];
        var grpData=[];
        vm.affiliatedGroups=[];
        grpType.forEach(function(type){
          Group.groupListByType(vm.organization.id,type)
          .then(function (resp) {
            resp.filter(function (group) {
              if(group.cross_fleet == 1)
                vm.affiliatedGroups.push(group)
            });
            vm.contactTemplates = [];
            
            if (type == 8)
            {
              for (var i in resp) {
                vm.contactTemplates.push(resp[i]);
              }
            }
            if(type.length == 3)
            {
              vm.affiliatedGroups = vm.affiliatedGroups.map(function (group) {
                if (group.expiry_date) {
                  group.expiry_date = new Date(group.expiry_date);
                }
                return group;
              });              
              resolve();
            }
          })
          .catch(function (e) {
            reject(e);
          });
        });
        // Group.getAllGroupsList(vm.organization.id)
        //   .then(function (resp) {
        //     vm.affiliatedGroups = resp.filter(function (group) {
        //       return group.cross_fleet == 1;
        //     });
        //     vm.affiliatedGroups = vm.affiliatedGroups.map(function (group) {
        //       if (group.expiry_date) {
        //         group.expiry_date = new Date(group.expiry_date);
        //       }
        //       return group;
        //     })
        //     vm.contactTemplates = [];
        //     for (var i in resp) {
        //       if (resp[i].type == 8)
        //         vm.contactTemplates.push(resp[i]);
        //     }
        //     resolve();
        //   })
        //   .catch(function (e) {
        //     reject(e);
        //   });
      });
    }


    function init() {
      vm.brand = {}
      if (vm.organization._id && !vm.organization.site) {
        vm.organization.site = resellerSite;
      }

      if(vm.organization.creation_time){
        vm.organization.creation_time = $filter('date')(vm.organization.creation_time,'dd-MMM-yyyy HH:mm:ss');
      }

      if(vm.organization.supportContactFirst){
        vm.supportContactValue = true;
      }
      else
      {
        vm.supportContactValue = false;
      }

      if (vm.organization._id && !vm.organization.domain) {
        vm.organization.domain = vm.organization.adminSuffix || vm.organization.sipSuffix;
        if (!vm.organization.domain) vm.organization.domain = "domain_" + org.crmId + ".com";
      }

      if (vm.organization.isRecorded == undefined || vm.organization.isRecorded == null)
        vm.organization.isRecorded = 0;

      if (vm.organization._id) vm.oldOrganizationType = vm.organization.type;

      vm.organization.id = vm.organization._id;
      vm.organization.parentResellerId = vm.organization.parentReseller;
      vm.organization.draftLicenses = [];
      vm.organization._id ? vm.qty = vm.organization.qty - vm.organization.availble_qty + "/" + vm.organization.qty : vm.qty = "0";
      vm.organization._id ? vm.dispatcherqty = vm.organization.dispatcher_qty - vm.organization.dispatcher_availble_qty + "/" + vm.organization.dispatcher_qty : vm.dispatcherqty = "0";
      vm.organization.max_login_retries = vm.organization.max_login_retries ? vm.organization.max_login_retries.toString() : null;
      vm.organization.password_expiration_days = vm.organization.password_expiration_days ? vm.organization.password_expiration_days.toString() : null;
      vm.enable_max_login_retries = vm.organization.max_login_retries ? true : false;
      vm.enable_password_expiration_days = vm.organization.password_expiration_days ? true : false;

      vm.limitOrgFriends = vm.configs.filter(function (param) {
        return param.name === "PROV_LIMIT_ORGANIZATION_FRIENDS";
      });
      if (!vm.limitOrgFriends || !vm.limitOrgFriends[0] || !vm.limitOrgFriends[0].value)
        vm.limitOrgFriends = 10;
      else
        vm.limitOrgFriends = parseInt(vm.limitOrgFriends[0].value)

      vm.showOrgFriends = vm.configs.filter(function (param) {
        return param.name === "PROV_SHOW_ORGANIZATION_FRIENDS";
      });

      if (!vm.showOrgFriends || !vm.showOrgFriends[0] || vm.showOrgFriends[0].value == "0")
        vm.showOrgFriends = false;
      else
        vm.showOrgFriends = true;

      vm.showRecording = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_RECORDING";
      });

      if (!vm.showRecording || !vm.showRecording[0] || vm.showRecording[0].value == "0")
        vm.showRecording = false;
      else
        vm.showRecording = true;

      vm.showCallLog = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_CALL_LOG";
      });

      if (!vm.showCallLog || !vm.showCallLog[0] || vm.showCallLog[0].value == "0")
        vm.showCallLog = false;
      else
        vm.showCallLog = true;

      vm.showBranding = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_BRANDING";
      });

      if (!vm.showBranding || !vm.showBranding[0] || vm.showBranding[0].value == "0")
        vm.showBranding = false;
      else
        vm.showBranding = true;

      vm.showLicenseAllocation = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_LICENSE_ALLOCATION";
      });

      if (!vm.showLicenseAllocation || !vm.showLicenseAllocation[0].value || vm.showLicenseAllocation[0].value == "0")
        vm.showLicenseAllocation = false;
      else
        vm.showLicenseAllocation = true;

      vm.showEncryption = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_ENCRYPTION";
      });

      if (!vm.showEncryption || !vm.showEncryption[0] || vm.showEncryption[0].value == "0")
        vm.showEncryption = false;
      else
        vm.showEncryption = true;

      vm.showRandomEncryptionKeysButton = vm.configs.filter(function(param){
        return param.name == "PROV_SHOW_RANDOM_ENCRYPTION_KYES_BUTTON";
      });
      
      if (!vm.showRandomEncryptionKeysButton || !vm.showRandomEncryptionKeysButton[0] || vm.showRandomEncryptionKeysButton[0].value == "0")
        vm.showRandomEncryptionKeysButton = false;
      else
        vm.showRandomEncryptionKeysButton = true;

      vm.showUploadVersion = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_UPLOAD_VERSION";
      });

      if (!vm.showUploadVersion || !vm.showUploadVersion[0] || vm.showUploadVersion[0].value == "0")
        vm.showUploadVersion = false;
      else
        vm.showUploadVersion = true;

      vm.showAffiliatedGroup = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_AFFILIATED_GROUP";
      });

      if (!vm.showAffiliatedGroup || !vm.showAffiliatedGroup[0] || vm.showAffiliatedGroup[0].value == "0")
        vm.showAffiliatedGroup = false;
      else
        vm.showAffiliatedGroup = true;

      vm.showDemoOrganization = vm.configs.filter(function(param){
        return param.name == "PROV_SHOW_DEMO_ORGANIZATION";
      });
      if (!vm.showDemoOrganization || !vm.showDemoOrganization[0].value || vm.showDemoOrganization[0].value == "0")
        vm.showDemoOrganization = false;
      else
        vm.showDemoOrganization = true;

      vm.demo_duration = vm.configs.filter(function(param){
        return param.name == "PROV_DURATION_TIME_IN_DEMO";
      });
      if (!vm.demo_duration || !vm.demo_duration[0].value)
        vm.demo_duration = 30;
      else
        vm.demo_duration = vm.demo_duration[0].value


      vm.showStrongDispatchPass = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_STRONG_DISPATCH_PASS";
      });
      if (!vm.showStrongDispatchPass || !vm.showStrongDispatchPass[0] || vm.showStrongDispatchPass[0].value == "0")
        vm.showStrongDispatchPass = false;
      else
        vm.showStrongDispatchPass = true;


      vm.showStrongRecordingReviewersPass = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_STRONG_RECORDING_REVIEWERS_PASS";
      });
      if (!vm.showStrongRecordingReviewersPass || !vm.showStrongRecordingReviewersPass[0] || vm.showStrongRecordingReviewersPass[0].value == "0")
        vm.showStrongRecordingReviewersPass = false;
      else
        vm.showStrongRecordingReviewersPass = true;

      vm.showStrongAdministratorPass = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_STRONG_ADMINISTRATOR_PASS";
      });
      if (!vm.showStrongAdministratorPass || !vm.showStrongAdministratorPass[0] || vm.showStrongAdministratorPass[0].value == "0")
        vm.showStrongAdministratorPass = false;
      else
        vm.showStrongAdministratorPass = true;

      vm.showMaxRetries = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_BLOCK_RELEASE";
      });
      if (!vm.showMaxRetries || !vm.showMaxRetries[0] || vm.showMaxRetries[0].value == "0")
        vm.showMaxRetries = false;
      else
        vm.showMaxRetries = true;

      vm.showPasswordExpiration = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_CHANGE_PASSWORD";
      });
      if (!vm.showPasswordExpiration || !vm.showPasswordExpiration[0] || vm.showPasswordExpiration[0].value == "0")
        vm.showPasswordExpiration = false;
      else
        vm.showPasswordExpiration = true;

      vm.showMutedSubscriberGrp = vm.configs.filter(function (param) {
        return param.name == "PROV_SHOW_MUTED_SUBSCRIBER";
      });
      if (!vm.showMutedSubscriberGrp || !vm.showMutedSubscriberGrp[0] || vm.showMutedSubscriberGrp[0].value == "0")
        vm.showMutedSubscriberGrp = false;
      else
        vm.showMutedSubscriberGrp = true;      
      
      vm.showSentinelAddress = vm.configs.filter(function (param) {
        return param.name == "PROV_SENTINEL_TEST_ADDRESS";
      });
      if (!vm.showSentinelAddress || !vm.showSentinelAddress[0] || vm.showSentinelAddress[0].value == '')
        vm.showSentinelAddress = '';
      else
        vm.showSentinelAddress = vm.showSentinelAddress[0].value;
      
      vm.consturl = {};
      if(vm.showSentinelAddress)
        vm.consturl = new URL(vm.showSentinelAddress); 

        vm.domainIsUnique = vm.configs.filter(function (param) {
          return param.name == "PROV_ORGANIZATION_DOMAIN_UNIQUE";
        });
        if (!vm.domainIsUnique || !vm.domainIsUnique[0] || vm.domainIsUnique[0].value == "0")
          vm.domainIsUnique = false;
        else
          vm.domainIsUnique = true;

        vm.organization.domainIsUnique = vm.domainIsUnique;
      
      vm.groupNameLimit = vm.configs.filter(function(param){
        return param.name == "PROV_SUBSCRIBER_NAME_LIMIT";
      });        
      if (vm.groupNameLimit || vm.groupNameLimit[0])
        vm.groupNameLimit = vm.groupNameLimit[0].value;
      else
        vm.groupNameLimit = '12';
      
      vm.showLiveSentinel = vm.configs.filter(function (param) {
          return param.name == "PROV_SHOW_LIVE_SENTINEL_EVENT";
      });
      if (!vm.showLiveSentinel || !vm.showLiveSentinel[0] || vm.showLiveSentinel[0].value == "0")
        vm.showLiveSentinel = false;
      else
        vm.showLiveSentinel = true;
      
      vm.groupAssignLimit = vm.configs.filter(function(param){
        return param.name == "PROV_LIMIT_ASSIGNMNT_GR_CT";
      });        
      if (vm.groupAssignLimit || vm.groupAssignLimit[0])
        vm.groupAssignLimit = vm.groupAssignLimit[0].value;
      else
        vm.groupAssignLimit = 0;
      
        vm.groupAssignDispLimit = vm.configs.filter(function(param){
          return param.name == "PROV_LIMIT_ASSIGNMNT_PERSONAL_CONTACTS_TO_DISPATCHERS";
        });        
        if (vm.groupAssignDispLimit || vm.groupAssignDispLimit[0])
          vm.groupAssignDispLimit = vm.groupAssignDispLimit[0].value;
        else
          vm.groupAssignDispLimit = 0;
      
      if (vm.organization._id) {
        getCurrentEncKeysStatus()
        getSentinel();
      }

      var flowFunctionsArray = [];
      flowFunctionsArray.push(getSite());
      if (vm.organization.id) {
        flowFunctionsArray.push(getLicenseData());
        flowFunctionsArray.push(getRecordings());
        flowFunctionsArray.push(getRecReviewersStrongPass())
        flowFunctionsArray.push(getCurrentEncKeysStatus())
        if (vm.showBranding) flowFunctionsArray.push(getBranding());
        flowFunctionsArray.push(getOrgFriends());
        flowFunctionsArray.push(getBulkAffContact());
        flowFunctionsArray.push(getGroups());
        flowFunctionsArray.push(getSubscribers());
      }
      $q.all(flowFunctionsArray)
        .then(function () {
          vm.loading = false;
        })
        .catch(function (err) {
          ExceptionHandler.show(err);
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    function getBrandingImage(orgId) {
      var deferred = $q.defer();
      Branding.getBrandingImage(orgId)
        .then(function (respBrandImg) {
          vm.image = "";
          if (typeof respBrandImg.image !== 'undefined') {
            vm.image = respBrandImg.image;
          }
          deferred.resolve();
        })
        .catch(function (e) {
          deferred.reject(e);
        });
      return deferred.promise;
    }

    function getImage(orgId, type) {
      var deferred = $q.defer();
      Branding.getBrandingExtraImage(orgId, type)
      .then(function(respBrandImg){
        if(typeof respBrandImg.image !== 'undefined'){
          if (type == "Logo")
            vm.image_mdc_logo = respBrandImg.image;
          else if (type == "Splash")
            vm.image_mdc_splash = respBrandImg.image;
          else if (type == "CompanyName")
            vm.image_mdc_companyName = respBrandImg.image;
          else if (type == "ManagementPortal")
            vm.management_portal_image = respBrandImg.image;
        }
        deferred.resolve();
      })
      .catch(function(e){
        deferred.reject(e);
      });
      return deferred.promise;
    }

    function initSaveAllocateArray() {
      for (var item in vm.parentLicenses) {
        vm.saveAllocate.push({ isAllocate: false, qty: 0 });
      }
    }

    function switchToAllocationTab() {
      vm.showAllocationTab = true;
      $timeout(function () { vm.selectedTabIndex = 3 }, 500);

    }

    function setActiveAllocation(allocationId) {
      vm.activeAllocation = allocationId;
    }

    function checkActiveAllocation(allocationId) {
      return (allocationId == vm.activeAllocation);
    }

    function checkAvailableQuantity(available, allocate) {
      return (allocate <= available);
    }

    function setRecordsCount() {
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    function resetDate() {
      vm.organization.demo_expiration = undefined;
    }

    // function addDraftAllocation(allocation) {    //shahar- remove license
    //   var newAllocation = angular.copy(allocation);
    //   var allocationIndex = getParentAllocationIndex(newAllocation);
    //   vm.parentLicenses[allocationIndex].availableQty -= newAllocation.setQty;
    //   vm.parentLicenses[allocationIndex].setQty = 0;

    //   if (newAllocation.setQty != 0 && newAllocation.setQty!=null) {
    //     vm.organization.draftLicenses.push(newAllocation);
    //     vm.saveAllocate[allocationIndex].isAllocate = true;
    //     vm.saveAllocate[allocationIndex].qty = newAllocation.setQty;
    //    }
    // }

    // function undoAllocate(allocation) {
    //   var allocationIndex = getParentAllocationIndex(allocation);
    //   allocation.setQty = vm.saveAllocate[allocationIndex].qty;
    //   removeDraftAllocation(allocation);
    //   vm.parentLicenses[allocationIndex].setQty = "";
    //   vm.saveAllocate[allocationIndex].isAllocate = false;
    //   vm.saveAllocate[allocationIndex].qty = 0;
    //   vm.activeAllocation = undefined;
    // }

    // function removeDraftAllocation(allocation){
    //   var allocationIndex = vm.organization.draftLicenses.indexOf(allocation);
    //   var parentAllocationIndex = getParentAllocationIndex(allocation);
    //   vm.parentLicenses[parentAllocationIndex].availableQty += allocation.setQty;
    //   vm.organization.draftLicenses.splice(allocationIndex,1);

    // }

    // function getParentAllocationIndex(allocation){
    //   for(var i=0; i<vm.parentLicenses.length; i++){
    //     if(vm.parentLicenses[i]._id === allocation._id){
    //       return i;
    //     }
    //   }
    // }

    // function allocate(allocation, orgId){
    //   var deferred = $q.defer();

    //   var alloc = {};

    //   alloc.parentResellerAllocation = allocation._id;
    //   alloc.licenseBundle = allocation.licenseBundle._id;
    //   alloc.licenseType = allocation.licenseType;
    //   alloc.initiateToOrgNodeId = orgId;
    //   alloc.expirationDate = allocation.expirationDate;
    //   alloc.expirationType = allocation.expirationType;
    //   alloc.active = allocation.active;
    //   alloc.qty = allocation.setQty;

    //   License.addAllocation(alloc)
    //     .then(function(resp){
    //       console.log(resp);
    //       deferred.resolve(resp);
    //     })
    //     .catch(function(e){
    //      ExceptionHandler.show(e);
    //      deferred.reject(e);
    //     });

    //   return deferred.promise;
    // }

    // function revokeAllocation(allocationId){
    //   console.log(allocationId);

    //   License.revokeAllocation(allocationId)
    //     .then(function(resp){
    //       console.log(resp);
    //       License.getAllocationList(vm.organization._id)
    //         .then(function (resp) {
    //           vm.organization.licenses = resp;

    //         });

    //       License.getAllocationList(vm.organization.parentReseller)
    //         .then(function(resp){
    //         vm.parentLicenses = resp;
    //         });
    //         Toast.showRevoke();
    //     })
    //     .catch(function(e){
    //       if(e.data.msg === 'failed'){
    //         Toast.showFailedRevoke();
    //       }else{
    //         ExceptionHandler.show(e);
    //       }

    //     })
    // }

    function onTabChanges(index) {
      vm.activeTab = index;
    }

    function checkTabIndex(index) {
      return vm.activeTab == index;
    }

    function addOrganization() {
      vm.loading = true;
      Organization.add(vm.organization)
        .then(function (respOrg) {
          vm.loading = true;
          Role.addDefaultRoles(respOrg._id)
            .then(function (result) {
              if (result) {

                Role.defaultRolesActivityLog(respOrg._id)
                  .then(function (result3) {
                    vm.loading = false;

                    if (vm.recorder != "noRecord") {
                      if (vm.recorder == "selective")
                        var updateObject = {
                          orgId: respOrg._id,
                          is_selective: true
                        };
                      else
                        var updateObject = {
                          orgId: respOrg._id,
                          is_selective: false
                        };
                    if (vm.strongRecordingReviewersPass) {
                      updateObject.force_strong_pass_for_reviewers = true
                    } else {
                      updateObject.force_strong_pass_for_reviewers = false
                    }
                      RecordWhiteList.update(updateObject)
                        .then(function () {
                          $mdDialog.hide(respOrg);
                        })
                        .catch(function (e) {
                          vm.loading = false;
                          vm.flagSave = true;
                          ExceptionHandler.show(e);
                        });
                    }
                    else
                      $mdDialog.hide(respOrg);


                  })
                  .catch(function (e) {
                    vm.loading = false;
                    vm.flagSave = true;
                    ExceptionHandler.show(e);
                  })
              }

            })
            .catch(function (e) {
              vm.loading = false;
              vm.flagSave = true;
              ExceptionHandler.show(e);
            })


          // if (vm.organization.draftLicenses.length>0){   //shahar- remove license
          //   var allocationsArray = [];
          //   vm.organization.draftLicenses.forEach(function(license){
          //     allocationsArray.push(allocate(license, respOrg._id));
          //   });
          //   $q.all(allocationsArray)
          //     .then(function(result){
          //       $mdDialog.hide(respOrg);
          //     })
          //     .catch(function(e){
          //       ExceptionHandler.show(e);
          //     })
          // }
          // else{
          //   $mdDialog.hide(respOrg);
          // }
        })
        .catch(function (e) {
          vm.flagSave = true;
          vm.loading = false;
          ExceptionHandler.show(e);
        })
      /*.finally(function(){
        vm.loading = false;
      });*/
    }

    function updateOrganization() {
      vm.loading = true;
      Organization.update(vm.organization)
        .then(function (resp) {
          var updateObject  = {
            orgId: vm.organization._id
          }
          if (vm.recorder != "noRecord") {
            if (vm.recorder == "selective")
              updateObject["is_selective"] = true
            else
              updateObject["is_selective"] = false
          }
          if (vm.strongRecordingReviewersPass) {   
            updateObject["force_strong_pass_for_reviewers"] = true
          } else {
            updateObject["force_strong_pass_for_reviewers"] = false
          }
          if ( Object.keys(updateObject).length > 1) {
            RecordWhiteList.update(updateObject)
              .then(function () {
                $mdDialog.hide(vm.organization);
              })
              .catch(function (e) {
                ExceptionHandler.show(e);
              });
          }
          else
            $mdDialog.hide(vm.organization);
          // if(vm.organization.draftLicenses.length > 0) {   //shahar- remove license
          //   var allocationsArray = [];
          //   vm.organization.draftLicenses.forEach(function(license){
          //     allocationsArray.push(allocate(license,vm.organization._id));
          //   });
          //   $q.all(allocationsArray)
          //     .then(function(result){
          //       $mdDialog.hide(vm.organization);
          //     })
          //     .catch(function(e){
          //       ExceptionHandler.show(e);
          //     })
          // }
          // else{
          //   $mdDialog.hide(vm.organization);
          // }
        })
        .catch(function (e) {
          vm.flagSave = true;
          ExceptionHandler.show(e)
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    // function editLicense(license, allocationId) {  //shahar- 
    //   var curRes = {};
    //   angular.copy(license, curRes);
    //   if (license.dispatcher.dispatcher === undefined){
    //     if (license.dispatcher == false)
    //     {
    //       license.dispatcher= {
    //         dispatcher: false,
    //         multiSession: "0"
    //       };
    //     }
    //     else
    //     {
    //       license.dispatcher= {
    //         dispatcher: true,
    //         multiSession: "1"
    //       };
    //     }
    // }

    //   $mdDialog.show({
    //     controller: 'licenseDetailsController as vm',
    //     templateUrl: 'app/main/restricted/platform/licenses/details/details.dialog.html',
    //     parent: angular.element(document.body),
    //     clickOutsideToClose: false,
    //     multiple: true,
    //     locals: {
    //       license: curRes,
    //       allocationId: null
    //     }
    //   })

    // }

    function cancel() {
      $mdDialog.cancel();
    }

    function saveOBranding() {
      vm.loading = true;

      var flowFunctionsArray = [];

      if (file.files.length === 0 && vm.brand.override_branding_image && !vm.image)
        vm.brand.override_branding_image = false;
      if (file.files.length > 0)
        flowFunctionsArray.push(uploadBrandingImage(file, vm.organization.id))

      if (file_mdc_logo.files.length === 0 && vm.brand.override_mdc_logo_image && !vm.image_mdc_logo)
        vm.brand.override_mdc_logo_image = false;
      if (file_mdc_logo.files.length > 0)
        flowFunctionsArray.push(uploadImage(file_mdc_logo, vm.organization.id, "Logo"))

      if (file_mdc_splash.files.length === 0 && vm.brand.override_mdc_splash_image && !vm.image_mdc_splash)
        vm.brand.override_mdc_splash_image = false;
      if (file_mdc_splash.files.length > 0)
        flowFunctionsArray.push(uploadImage(file_mdc_splash, vm.organization.id, "Splash"))

      if (file_mdc_companyName.files.length === 0 && vm.brand.override_mdc_companyName_image && !vm.image_mdc_companyName)
        vm.brand.override_mdc_companyName_image = false;
      if (file_mdc_companyName.files.length > 0)
        flowFunctionsArray.push(uploadImage(file_mdc_companyName, vm.organization.id, "CompanyName"))

      if (management_portal_logo.files.length === 0 && vm.brand.override_management_portal_image && !vm.management_portal_image)
        vm.brand.override_management_portal_image = false;
      if (management_portal_logo.files.length > 0)
        flowFunctionsArray.push(uploadImage(management_portal_logo, vm.organization.id, "ManagementPortal"))


      $q.all(flowFunctionsArray)
        .then(function () {
          $rootScope.$emit('upadatebranding');
          vm.loading = false;
          Toast.showUpdate();
        })
        .catch(function (err) {
          vm.loading = false;
          ExceptionHandler.show(err);
        });
    }

    function saveOBrandingInfo() {
      vm.loading = true;

      var regexp = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

      if (!vm.brand.name)
        vm.brand.override_branding_name = false;

      Branding.setBrandingInfo(vm.brand, vm.organization.id)
        .then(function () {
          saveOBranding();
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
          vm.loading = false;
        });

    }

    function uploadBrandingImage(file, orgId) {
      var deferred = $q.defer();

      var fd = new FormData();
      fd.append('file', file.files[0]);

      Branding.setBrandingImage(fd, orgId)
        .then(function (result) {
          Branding.getBrandingImage(orgId)
            .then(function (respBrandImg) {
              vm.image = respBrandImg.image;
              deferred.resolve();
            })
            .catch(function (e) {
              deferred.reject(e);
            });
        })
        .catch(function (e) {
          deferred.reject(e);
        });

      return deferred.promise;
    }

    function uploadImage(file, orgId, type) {
      var deferred = $q.defer();

      var fd = new FormData();
      fd.append('file', file.files[0]);
      
      Branding.setBrandingExtraImage(fd, orgId, type)
      .then(function(result){
        Branding.getBrandingExtraImage(orgId, type)
          .then(function(respBrandImg){
            if (type == "Logo")
              vm.image_mdc_logo = respBrandImg.image;
            else if (type == "Splash")
              vm.image_mdc_splash = respBrandImg.image;
            else if (type == "CompanyName")
              vm.image_mdc_companyName = respBrandImg.image;
            else if (type == "ManagementPortal")
              vm.management_portal_image = respBrandImg.image;
            deferred.resolve();
          })
          .catch(function(e){
            deferred.reject(e);
          });
      })
      .catch(function (e) {
        deferred.reject(e);
      });

      return deferred.promise;
    }


    function resetAllOverrideValues() {
      vm.brand.override_branding_name = false;
      vm.brand.override_branding_color1 = false;
      vm.brand.override_branding_color2 = false;
      vm.brand.override_branding_image = false;
      vm.brand.override_mdc_logo_image = false;
      vm.brand.override_mdc_splash_image = false;
      vm.brand.override_mdc_companyName_image = false;
      vm.brand.override_management_portal_image = false;
    }

    $scope.onUploadFile = function (elem) {
      if (elem.files && elem.files.length > 0) {
        var ext = elem.files[0].name.split('.');
        if (!elem.accept.includes(ext[ext.length - 1])) {
          if (elem.name == "file")
            vm.organizationFormBranding.file.$setValidity('validationError', false);
          if (elem.name == "file_mdc_logo")
            vm.organizationFormBranding.file_mdc_logo.$setValidity('validationError', false);
          if (elem.name == "file_mdc_splash")
            vm.organizationFormBranding.file_mdc_splash.$setValidity('validationError', false);
          if (elem.name == "file_mdc_companyName")
            vm.organizationFormBranding.file_mdc_companyName.$setValidity('validationError', false);
          if (elem.name == "management_portal_logo")
            vm.organizationFormBranding.management_portal_logo.$setValidity('validationError', false);
        }
        else {
          if (elem.name == "file")
            vm.organizationFormBranding.file.$setValidity('validationError', true);
          if (elem.name == "file_mdc_logo")
            vm.organizationFormBranding.file_mdc_logo.$setValidity('validationError', true);
          if (elem.name == "file_mdc_splash")
            vm.organizationFormBranding.file_mdc_splash.$setValidity('validationError', true);
          if (elem.name == "file_mdc_companyName")
            vm.organizationFormBranding.file_mdc_companyName.$setValidity('validationError', true);
          if (elem.name == "management_portal_logo")
            vm.organizationFormBranding.management_portal_logo.$setValidity('validationError', true);
        }
      }
      else {
        if (elem.name == "file")
          vm.organizationFormBranding.file.$setValidity('validationError', true);
        if (elem.name == "file_mdc_logo")
          vm.organizationFormBranding.file_mdc_logo.$setValidity('validationError', true);
        if (elem.name == "file_mdc_splash")
          vm.organizationFormBranding.file_mdc_splash.$setValidity('validationError', true);
        if (elem.name == "file_mdc_companyName")
          vm.organizationFormBranding.file_mdc_companyName.$setValidity('validationError', true);
        if (elem.name == "management_portal_logo")
          vm.organizationFormBranding.management_portal_logo.$setValidity('validationError', true);
      }
    }

    function saveOrgFriends() {
      // vm.showLoader = true;
      var selectedFriends = {};
      selectedFriends.orgFriends = vm.selectedOrgs.map(function (org) {
        return org._id;
      });
      selectedFriends._id = vm.organization._id;
      OrgFriends.update(selectedFriends)
        .then(function () {
          Toast.showUpdate();
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
        })
        .finally(function () {
            $mdDialog.hide(vm.organization);
          getGroups().then(function () {
            // vm.showLoader = false;
          })
          .catch(function (err) {
            // vm.showLoader = false;
          });
        });
    }

    function filterMember() {
      vm.selectedOrgs = vm.orgs.filter(function (org) {
        return vm.orgFriendsID.indexOf(org._id) !== -1;
      });

      vm.unselectedOrgs = vm.orgs.filter(function (org) {
        return vm.orgFriendsID.indexOf(org._id) === -1 && vm.organization._id != org._id;
      });
    }
  
    function demoChecked(){
      if (vm.organization.type == 1 && vm.organization.demo_expiration == null){
        var date = new Date()
        vm.organization.demo_expiration = new Date(date.setDate(date.getDate() + Number(vm.demo_duration)))
      }
      if (vm.organization.type !== 1) {
        vm.resetDate()
      }
    }

    function ok() {
      if(!vm.organization.primary_site_id)
              vm.organization.primary_site_id = vm.organization.site;
            
      vm.flagSave = false;
      vm.organization.crmId = vm.organization.crmId.trim();
      vm.organization.name = vm.organization.name.trim();

      if (vm.recorder == "noRecord")
        vm.organization.isRecorded = 0;
      else
        vm.organization.isRecorded = 1;
      
      vm.organization.max_login_retries = !vm.enable_max_login_retries ? null : vm.organization.max_login_retries;
      vm.organization.password_expiration_days = !vm.enable_password_expiration_days ? null : vm.organization.password_expiration_days;

      if (!vm.organization.max_login_retries || vm.organization.max_login_retries == 0){
        vm.enable_max_login_retries = 0;
        vm.organization.max_login_retries = null;
      }
      if (!vm.organization.password_expiration_days || vm.organization.password_expiration_days == 0){
        vm.enable_password_expiration_days = 0;
        vm.organization.password_expiration_days = null;
      }
      if(vm.organization.name && vm.organization.crmId)
        vm.organization._id ? ((vm.organization.type == 1 && vm.oldOrganizationType == 0) ?  display_note_msg() : updateOrganization()) : (vm.organization.type == 1 ? display_note_msg() : addOrganization());
      else  
      vm.flagSave = true;
    }

    function display_note_msg(){
      if(vm.organization.demo_expiration) vm.demo_duration = Math.round((vm.organization.demo_expiration - new Date())/(24*60*60*1000));// 24*60*60*1000 is 1 day in ms 
      var confirm = Toast.getDemoOrganization(vm.demo_duration);

      $mdDialog.show(confirm)
        .then(function () {
          vm.organization._id ? updateOrganization() : addOrganization();
        })
        .catch(function(){
          vm.organization.type = 0;
          vm.organization._id ? updateOrganization() : addOrganization();
        })
    }

    // function sortAllocate(param){  //shahar- remove license
    //   vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
    //   vm.parentLicenses = orderByFilter(vm.parentLicenses,param,vm.reverse[param])
    // }

    function sort(param) {
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.organization.licenses = orderByFilter(vm.organization.licenses, param, vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param) {
      return vm.reverse[param] ? "up" : "down";
    }



    function uploadEncryptionFile() {
      if (!file1.files[0])
        Toast.showVersionFileEmpty();
      else {
        vm.disablebutton = true;
        vm.loading = true;
        var fd = new FormData();
        fd.append('file', file1.files[0]);
        Organization.uploadOrganizarionKeyFile(fd, vm.organization._id)
          .then(function () {
            convertEncKeysStatusToString({encFormat: 4, encVersion : vm.currentEncStatus.encVersion + 1 })
            Toast.showKeyFileUpdate();
            vm.disablebutton = false;
            vm.loading = false;
          })
          .catch(function (err) {
            ExceptionHandler.show(err);
            vm.disablebutton = false;
            vm.loading = false;
          })
      }
    }

    function setEncryptionFile() {
      vm.disablebutton = true;
      var confirm = Toast.getEncryptionKeysGenerationDialog()
      $mdDialog.show(confirm)
      .then(function () {
        Organization.setOrganizationKeyFile(false, vm.organization._id)
        .then(function () {
          convertEncKeysStatusToString({encFormat: 3, encVersion : vm.currentEncStatus.encVersion + 1})
          Toast.showKeyFileUpdate();
          vm.disablebutton = false;
        })
        .catch(function (err) {
          ExceptionHandler.show(err);
          vm.disablebutton = false;
        })
      })
      .catch(function () {
        vm.disablebutton = false;
      })
    }

    function setDefaultEncryptionFile() {
      vm.disablebutton = true;
      Organization.setOrganizationKeyFile(true, vm.organization._id)
        .then(function () {
          convertEncKeysStatusToString({encFormat:2 , encVersion : vm.currentEncStatus.encVersion + 1})
          Toast.showKeyFileUpdate();
          vm.disablebutton = false;
        })
        .catch(function (err) {
          ExceptionHandler.show(err);
          vm.disablebutton = false;
        })
    }

    function setEmptyEncryptionFile() {
      vm.disablebutton = true;
      Organization.setOrganizationEmptyKeyFile(vm.organization._id)
        .then(function () {
          convertEncKeysStatusToString({encFormat: 1, encVersion : vm.currentEncStatus.encVersion + 1 })
          Toast.showEmptyKeyFileUpdate();
          vm.disablebutton = false;
        })
        .catch(function (err) {
          ExceptionHandler.show(err);
          vm.disablebutton = false;
        })
    }

    function uploadAndroidVersionFile() {
      if (!fileAndroid.files[0])
        Toast.showVersionFileEmpty();
      else {
        vm.disablebutton = true;
        vm.loading = true;
        var fd = new FormData();
        fd.append('file', fileAndroid.files[0]);
        Organization.uploadVersionFile(fd, vm.organization._id, "Android")
          .then(function () {
            Toast.showVersionFileUpdate();
            vm.disablebutton = false;
            vm.loading = false;
            Branding.getBrandingInfo(vm.organization._id)
              .then(function (respBrand) {
                vm.brand = respBrand;
              });
          })
          .catch(function (err) {
            if (err.status !== 404)
              ExceptionHandler.show(err);
            vm.disablebutton = false;
            vm.loading = false;
          })
      }
    }

    function uploadMDCVersionFile() {
      if (!fileMDC.files[0])
        Toast.showVersionFileEmpty();
      else {
        vm.disablebutton = true;
        vm.loading = true;
        var fd = new FormData();
        fd.append('file', fileMDC.files[0]);
        Organization.uploadVersionFile(fd, vm.organization._id, "MDC2000")
          .then(function () {
            Toast.showVersionFileUpdate();
            vm.disablebutton = false;
            vm.loading = false;
            Branding.getBrandingInfo(vm.organization._id)
              .then(function (respBrand) {
                vm.brand = respBrand;
              });
          })
          .catch(function (err) {
            if (err.status !== 404)
              ExceptionHandler.show(err);
            vm.disablebutton = false;
            vm.loading = false;
          })
      }
    }

    function deleteAndroidVersionFile() {
      Organization.deleteVersionFile(vm.organization._id, "Android")
        .then(function () {
          Toast.showVersionFileDelete();
          vm.disablebutton = false;
          vm.loading = false;
          Branding.getBrandingInfo(vm.organization._id)
            .then(function (respBrand) {
              vm.brand = respBrand;
            });
        })
        .catch(function (err) {
          if (err.status !== 404)
            ExceptionHandler.show(err);
          vm.disablebutton = false;
          vm.loading = false;
        })
    }

    function deleteMDCVersionFile() {
      Organization.deleteVersionFile(vm.organization._id, "MDC2000")
        .then(function () {
          Toast.showVersionFileDelete();
          vm.disablebutton = false;
          vm.loading = false;
          Branding.getBrandingInfo(vm.organization._id)
            .then(function (respBrand) {
              vm.brand = respBrand;
            });
        })
        .catch(function (err) {
          if (err.status !== 404)
            ExceptionHandler.show(err);
          vm.disablebutton = false;
          vm.loading = false;
        })
    }

    function addGroup() {
      $mdDialog.show({
        controller: 'groupsDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/groups/details/groups.details.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        multiple: true,
        locals: {
          group: {
            organization: vm.organization.id,
            site: vm.organization.primary_site_id
          },
          organizationId: vm.organization.id,
          organization: vm.organization,
          showEmergencyGroup: false,
          showMutedSubscriberGrp: vm.showMutedSubscriberGrp,
          groupNameLimit: vm.groupNameLimit,
          crossFleet: true
        }
      }).then(function (result) {
        getGroups();
        vm.contactTemplatesDrop=[];
        vm.affContactTemplates[vm.organization.id]=[];
        vm.templateType = "Subscribers";
        getContactTemplateByOrg(vm.organization.id).then(function(){
          vm.changeContactTemplateList();
        });
        // getContactTemplateByOrg(vm.organization.id).then(function(){
        // var temp = [];
        // angular.forEach(vm.affContactTemplates[vm.organization.id], function(value, key) {
        //   var exists = false;
        //   angular.forEach(temp, function(val2, key) {
        //     if(angular.equals(value._id, val2._id)){ exists = true }; 
        //   });
        //   if(exists == false && value._id != "") { temp.push(value); }
        // });
        // vm.affContactTemplates[vm.organization.id] = temp;

        // // var temp2 = [];        
        // // angular.forEach(vm.contactTemplatesDrop, function(value, key) {
        // //   var exists = false;
        // //   angular.forEach(temp2, function(val2, key) {
        // //     if(angular.equals(value._id, val2._id)){ exists = true }; 
        // //   });
        // //   if(exists == false && value._id != "") { temp2.push(value); }
        // // });
        // // vm.contactTemplatesDrop = temp2;
        // })
        Toast.showAdd();
      });
    }

    function addAffContactTemplate() {
      var curSubscriber = {};
      $mdDialog.show({
        controller: 'affiliatedDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/reseller/organization-manager/details/affiliatedcontact/bulk-affiliated-contact.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        skipHide: true,
        multiple:true,
        locals: {
          server: 0,          
          organizationId: vm.organization.id,
          subscribers:vm.subscribers,
          organization: vm.organization
        }
      }).then(function () {
        
        // Toast.showUpdate();
      });
    }
    function editGroup(group) {
      var curGroup = {};
      angular.copy(group, curGroup); //
      curGroup.site = curGroup.primary_site_id;

      $mdDialog.show({
        controller: 'groupsDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/groups/details/groups.details.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        multiple: true,
        locals: {
          group: curGroup,
          organizationId: vm.organization.id,
          organization: vm.organization,
          showEmergencyGroup: vm.showEmergencyGroup,
          showMutedSubscriberGrp: vm.showMutedSubscriberGrp,
          groupNameLimit: vm.groupNameLimit,
          crossFleet: true
        }
      }).then(function () {
        getGroups();
        vm.contactTemplatesDrop=[];
        vm.affContactTemplates[vm.organization.id]=[];
        vm.templateType = "Subscribers";
        getContactTemplateByOrg(vm.organization.id).then(function(){
          vm.changeContactTemplateList();
        // var temp = [];
        // angular.forEach(vm.affContactTemplates[vm.organization.id], function(value, key) {
        //   var exists = false;
        //   angular.forEach(temp, function(val2, key) {
        //     if(angular.equals(value._id, val2._id)){ exists = true }; 
        //   });
        //   if(exists == false && value._id != "") { temp.push(value); }
        // });
        // vm.affContactTemplates[vm.organization.id] = temp;
        
        // var temp2 = []; 
        // console.log(vm.contactTemplatesDrop)       
        // angular.forEach(vm.contactTemplatesDrop, function(value, key) {
        //   var exists = false;
        //   angular.forEach(temp2, function(val2, key) {
        //     if(angular.equals(value._id, val2._id)){ exists = true }; 
        //   });
        //   if(exists == false && value._id != "") { temp2.push(value); }
        // });
        // console.log(temp2)
        // vm.contactTemplatesDrop = temp2;
         })
        Toast.showUpdate();
      });
    }

    function editContacts(subscriber) {
      var curSubscriber = {};
      angular.copy(subscriber, curSubscriber);

      $mdDialog.show({
        controller: 'affiliatedContactsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/reseller/organization-manager/details/tabs/affiliated-contacts/affiliated.contacts.main.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        multiple: true,
        locals: {
          subscriber: curSubscriber,
          organization: vm.organization
        }
      }).then(function () {
        //getGroups();
        Toast.showUpdate();
      });
    }

    function removeGroup(group) {
      var confirm;
      if (group.count){
        confirm = Toast.getDeleteWithMembersDialog();
       //Toast.showCustom($translate.instant("GROUPS_DELETE_WARNING"));
      }
      else {
        confirm = Toast.getDeleteDialog();
      }
        $mdDialog.show(confirm.multiple(true))
          .then(function () {
            Group.deleteItem(group._id)
              .then(function () {
                getGroups();
                if(group.type === 8){                  
                    vm.contactTemplatesDrop=[];
                    vm.affContactTemplates[vm.organization.id]=[];
                    vm.templateType = "Subscribers";
                    getContactTemplateByOrg(vm.organization.id).then(function(){
                      vm.changeContactTemplateList();
                    });
                }
                Toast.showDelete();
              })
              .catch(function(e){
                ExceptionHandler.show(e.data);
              });
          });
    }

    function saveOrganization(){
      (vm.organization.type == 1 && vm.oldOrganizationType == 0) ?  display_note_msg_for_branding() : updateOrganization_for_branding();
    }

    function display_note_msg_for_branding(){
      if(vm.organization.demo_expiration) vm.days = Math.round((vm.organization.demo_expiration - new Date())/(24*60*60*1000));// 24*60*60*1000 is 1 day in ms 
      else vm.days = vm.demo_duration;
      var confirm = Toast.getDemoOrganization(vm.days);

      $mdDialog.show(confirm)
        .then(function () {
          updateOrganization_for_branding();
        })
        .catch(function(){
          vm.organization.type = 0;
          updateOrganization_for_branding();
        })
    }

    function updateOrganization_for_branding(){
      vm.loading = true ;
      var updateObject = {
        orgId : vm.organization._id,
      }
      if (vm.strongRecordingReviewersPass) {   
        updateObject["force_strong_pass_for_reviewers"] = true
      } else {
        updateObject["force_strong_pass_for_reviewers"] = false
      }
      if (vm.recorder == "noRecord"){
        vm.organization.isRecorded = 0;
      }
      else{
        vm.organization.isRecorded = 1;
        if (vm.recorder == "selective")
          updateObject["is_selective"] = true
        else
          updateObject["is_selective"] = false
      }

      vm.organization.max_login_retries = !vm.enable_max_login_retries ? null : vm.organization.max_login_retries;
      vm.organization.password_expiration_days = !vm.enable_password_expiration_days ? null : vm.organization.password_expiration_days;

      if (!vm.organization.max_login_retries || vm.organization.max_login_retries == 0){
        vm.enable_max_login_retries = 0;
        vm.organization.max_login_retries = null;
      }
      if (!vm.organization.password_expiration_days || vm.organization.password_expiration_days == 0){
        vm.enable_password_expiration_days = 0;
        vm.organization.password_expiration_days = null;
      }
      

     RecordWhiteList.update(updateObject)
     .then(function () {
       Organization.update(vm.organization)
       .then(function(resp){
         vm.oldOrganizationType = vm.organization.type;
         if (!vm.organization.demo_expiration && vm.organization.type == 1){
           var date = new Date();
           vm.organization.demo_expiration = new Date(date.setDate(date.getDate() + Number(vm.demo_duration)));
         }
         Toast.showUpdate();
       })
       .catch(function(e){
         ExceptionHandler.show(e);
       })
       .finally(function(){
         if (!vm.organization.type || vm.organization.type == 0) vm.organization.demo_expiration = null;
        //  vm.showLoader = false;
         vm.loading = false ;
       });
     })
     .catch(function (e) {
       ExceptionHandler.show(e);
     });
    }

    function supportContactname(){      
      if(vm.organization.supportContactFirst)
      {
        vm.organization.supportContactFirst = vm.organization.supportContactFirst.trim()
      }
      if(vm.organization.supportContactLast)
      {
        vm.organization.supportContactLast = vm.organization.supportContactLast.trim()
      }
      if(vm.organization.supportContactFirst)
      {
        if(!vm.organization.supportContactLast)
        {
          vm.lastrequired = true;
        }
      }
      else{
        vm.lastrequired = false;
      }
      if(vm.organization.supportContactLast)
      {
        if(!vm.organization.supportContactFirst)
        {
          vm.Firstreq = true;
        }
      }
      else{
        vm.Firstreq = false;
      }
      if(vm.supportContactValue)
      {
        vm.Firstreq = true;
        vm.lastrequired = true;
      }
    }

    //Bulk Contact Template function Start 
    function getSubscribersByOrg(orgId) {
      return new Promise(function(resolve, reject){
        var PERMISSION_MASK_OFF_NET = 0x08;
        Subscriber.getSubscriberDataByOrg(orgId)
          .then(function (resp) {
            vm.members[orgId] = resp.map(function(member){
              if (Boolean(member.permissions_mask & PERMISSION_MASK_OFF_NET))
              {
                vm.bulAffSubscribers.push(member)
                member.offnet = true;
              }
              return member;
            })
            resolve();
          })
          .catch(function (e) {
            if (e.status !== 404) reject(e);
            else resolve();
          })
      });
    }
    function getContactTemplateByOrg(orgId){
      return new Promise(function(resolve, reject){
        Group.groupListByType(orgId,8)
          .then(function (resp) {
            vm.affContactTemplates[orgId] = resp.map(function(contact){
              if (contact.cross_fleet == 1)
              {
                contact.organization_id = orgId;
                contact.offnet = true;
                if(vm.organization.id == orgId )
                  vm.contactTemplatesDrop.push(contact)
                return contact;
              }
            })
           resolve();
          })
          .catch(function (e) {
            if (e.status === 404)
              resolve();
            else
            reject(e);
          });
          // Group.getAllGroupsList(orgId)
          // .then(function (resp) {
          //   vm.affContactTemplates[orgId] = resp.map(function(contact){
          //     if (contact.type == 8 && contact.cross_fleet == 1)
          //     { contact.offnet = true;
          //       vm.contactTemplatesDrop.push(contact)
          //     }
          //     return contact;
          //   })
          //  resolve();
          // })
          // .catch(function (e) {
          //   if (e.status === 404)
          //     resolve();
          //   else
          //   reject(e);
          // });
      });
    }
    function changeContactTemplateList() {
      vm.resultContactTemplateLog = $translate.instant("CONTACT_TEMPLATE_TYPE") + ": " + (vm.templateType == "Subscribers" ? $translate.instant("BULK_CONTACT_TEMPLATE_SUBSCRIBERS") : (vm.templateType == "ContactTemplate"? $translate.instant("BULK_CONTACT_TEMPLATE_TEMPLATES") : $translate.instant("BULK_CONTACT_TEMPLATE_SUB_TO_SUB")));
      vm.notSelectedAssignContactTemplate = [];
      vm.selectedAssignContactTemplate = [];
      vm.resultContactTempErrLog='';
      if (vm.templateType == "Subscribers") {
        vm.notSelectedAssignContactTemplate = Object.assign([],vm.backUpNonSelectedSub);
        vm.selectedAssignContactTemplate = angular.copy(vm.selectedSubscribers);
        vm.assignLength = vm.subscriberLength;
      }
      else if (vm.templateType == "ContactTemplate") {
        vm.notSelectedAssignContactTemplate = angular.copy(vm.notSelectedContactTemplate);
        vm.selectedAssignContactTemplate = angular.copy(vm.selectedContactTemplate);
        vm.assignLength = vm.contactTemplateLength;
      }
      else if (vm.templateType == "SubscriberToSub") {
        vm.notSelectedAssignContactTemplate = Object.assign([],vm.backUpNonSelectedSub);
        vm.ContactTemplateUser = Object.assign([],vm.backUpNonSelectedSub);
        vm.selectedAssignContactTemplate = angular.copy(vm.selectedSubscribers);
        vm.assignLength = vm.subscriberLength;
      }
    }
    function batchContactTemplateAssignment(type) {
      if (vm.selectedAssignContactTemplate.length) {
        vm.loading = true;
        var assignmentFuncs = [];
        var errors = [];
        var allocatedCount = 0;

        vm.resultContactTemplateLog='';
        vm.resultContactTempErrLog='';
        vm.errorLog = [""];
        vm.subscribersProcessed = 0;
        vm.subscribersNotProcessed = 0;
        
        $rootScope.loaderStateTotalCount= $rootScope.loaderStateTotalCount + 1;
        $rootScope.loaderStateCount= $rootScope.loaderStateCount + 1;
        $rootScope.$emit('loaderMainUpdatedValue');
        if(vm.templateType != "SubscriberToSub") {
          Subscriber.getListByGroup(vm.selectedContactTemplateId)
            .then(function (resp) {
              var newResp = resp.map(function (contact) {
                contact.phone_number = vm.bulAffSubscribers.filter(function (subs) {
                  if (subs._id == contact._id)
                    return subs;
                })[0].phone_number;
                return contact;
              })
              if (vm.templateType == "Subscribers") {
                vm.selectedAssignContactTemplate.forEach(function (subscriber) {
                  if(vm.organization._id != subscriber.organization_id)
                  {
                    var conList = newResp.filter(function (newr) { return ((newr.organization_id === subscriber.organization_id) || (vm.organization._id === newr.organization_id)); })
                    var assg = {
                      contactsTemplate: conList,
                      subscriberId: subscriber._id,
                      permissionsMask: subscriber.permissions_mask,
                      phoneNumber: subscriber.phone_number,
                      assignmentDate: new Date(),
                      active: true
                    };
                  }
                  if(vm.organization._id === subscriber.organization_id)
                  {
                    var assg = {
                      contactsTemplate: newResp,
                      subscriberId: subscriber._id,
                      permissionsMask: subscriber.permissions_mask,
                      phoneNumber: subscriber.phone_number,
                      assignmentDate: new Date(),
                      active: true
                    };
                  }
                  assignmentFuncs.push(addContactTemplateAllocationHandler.bind(null, assg));
                })
              }
              else {
                vm.selectedAssignContactTemplate.forEach(function (template) {
                  Subscriber.getListByFilterGroup(template._id)
                    .then(function (resp) {
                      resp.map(function (contact) {
                        var assg = {
                          contactsTemplate: newResp,
                          subscriberId: contact._id,
                          permissionsMask: contact.permissions_mask,
                          phoneNumber: vm.bulAffSubscribers.filter(function (subs) {
                            if (subs._id == contact._id)
                              return subs;
                          })[0].phone_number,
                          assignmentDate: new Date(),
                          active: true
                        };

                        assignmentFuncs.push(addContactTemplateAllocationHandler.bind(null, assg));
                        
                      })

                    })
                })
              }
              setTimeout(function() {
                if (type == "Add") {
                  assignmentFuncs.push(function () {
                    vm.loading = false;
                    vm.resultContactTemplateLog = $translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + (assignmentFuncs.length -1 - errors.length);
                    Toast.showCustom($translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + (assignmentFuncs.length - 1 - errors.length));
                    
                    $rootScope.loaderStateCount= 0;
                    $rootScope.loaderStatePercentage=100;
                    setTimeout(function(){
                      ProgressCircularSer.showProgress(false);
                    }, 500);
                    $rootScope.$emit('loaderMainUpdatedValue');
                  });
                } else {
                  assignmentFuncs.push(function () {
                    vm.loading = false;
                    vm.resultContactTemplateLog = $translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + (assignmentFuncs.length -1 - errors.length);
                    Toast.showCustom($translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + (assignmentFuncs.length - 1 - errors.length));
                    
                    $rootScope.loaderStateCount= 0;
                    $rootScope.loaderStatePercentage=100;
                    setTimeout(function(){
                      ProgressCircularSer.showProgress(false);
                    }, 500);
                    $rootScope.$emit('loaderMainUpdatedValue');
                  });
                }
                assignmentFuncs.reduce(function (soFar, f) {
                  return soFar.then(f).catch(function (err) { errors.push(err) });
                }, $q.when([]))
              }, 1000);
            })
        }
        else{
          // var newResp = vm.selectedContactTemplateUser.map(function (contact) {
          //   contact.phone_number = vm.bulAffSubscribers.filter(function (subs) {
          //     if (subs._id == contact._id)
          //       return subs;
          //   })[0].phone_number;
          //   return contact;
          // })
          // console.log(newResp)
          vm.selectedAssignContactTemplate.forEach(function (subscriber) {
            if(vm.organization._id != subscriber.organization_id)
            {
              var conList = vm.selectedContactTemplateUser.filter(function (newr) { return ((newr.organization_id === subscriber.organization_id) || (vm.organization._id === newr.organization_id)); })
              var assg = {
                contactsTemplate: conList,
                subscriberId: subscriber._id,
                phoneNumber: subscriber.phone_number,
                permissionsMask: subscriber.permissions_mask,
                assignmentDate: new Date(),
                active: true
              };
            }
            if(vm.organization._id === subscriber.organization_id)
            {
              var assg = {
                contactsTemplate: vm.selectedContactTemplateUser,
                subscriberId: subscriber._id,
                phoneNumber: subscriber.phone_number,
                permissionsMask: subscriber.permissions_mask,
                assignmentDate: new Date(),
                active: true
              };
            }
            assignmentFuncs.push(addContactTemplateAllocationHandler.bind(null, assg));
          })
          
          setTimeout(function() {
            if (type == "Add") {
              assignmentFuncs.push(function () {
                vm.loading = false;
                vm.resultContactTemplateLog = $translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + (assignmentFuncs.length -1 - errors.length);
                Toast.showCustom($translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + (assignmentFuncs.length -1 - errors.length));
                
                $rootScope.loaderStateCount= 0;
                $rootScope.loaderStatePercentage=100;
                setTimeout(function(){
                  ProgressCircularSer.showProgress(false);
                }, 500);
                $rootScope.$emit('loaderMainUpdatedValue');
              });
            } else {
              assignmentFuncs.push(function () {
                vm.loading = false;
                vm.resultContactTemplateLog = $translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + (assignmentFuncs.length -1 - errors.length);
                Toast.showCustom($translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + (assignmentFuncs.length -1 - errors.length));
                
                $rootScope.loaderStateCount= 0;
                $rootScope.loaderStatePercentage=100;
                setTimeout(function(){
                  ProgressCircularSer.showProgress(false);
                }, 500);
                $rootScope.$emit('loaderMainUpdatedValue');
              });
            }
            assignmentFuncs.reduce(function (soFar, f) {
              return soFar.then(f).catch(function (err) { errors.push(err) });
            }, $q.when([]))
          }, 1000);
        }
          

         
          // assignmentFuncs.reduce(function (soFar, f) {
          //   return soFar.then(f).catch(function (err) { errors.push(err) });
          // }, $q.when([]))
      }

      function addContactTemplateAllocationHandler(assg) {
        var deferred = $q.defer();
        vm.loading = true;

        if (assg.contactsTemplate && assg.contactsTemplate.length > 0) {
          PersonalContacts.getPersonalList(assg.subscriberId)
            .then(function (contacts) {
              if (type == "Add") {
                var newContacts = contacts;
                for (var i in assg.contactsTemplate) {
                  if (contacts.filter(function (contact) { return contact.contactUserId === assg.contactsTemplate[i].phone_number; }).length == 0) {
                    if (assg.subscriberId != assg.contactsTemplate[i]._id)
                      newContacts.push({ contactUserId: assg.contactsTemplate[i].phone_number, name: assg.contactsTemplate[i].name, ownerUserId: assg.subscriberId });
                  }
                }
              }
              else {
                var newContacts = [];
                for (var i in contacts) {
                  if (contacts[i].contactUserId && assg.contactsTemplate.filter(function (contact) { return contacts[i].contactUserId === contact.phone_number; }).length == 0) {
                    newContacts.push(contacts[i]);
                  }
                }
              }

              var body = {};
              Subscriber.isDispatcherUser(assg.permissionsMask).then(function(licenseRes){
                body.personalContacts = newContacts;
                if((licenseRes.result && vm.groupAssignDispLimit >= body.personalContacts.length) || (!licenseRes.result && vm.groupAssignLimit >= body.personalContacts.length))
                  {
                    PersonalContacts.addUpdateBatch(assg.subscriberId, body, assg.permissionsMask)
                      .then(function () {
                        deferred.resolve();
                        vm.resultContactTemplateLog = "Processing... Done: " + allocatedCount++;
                      }).catch(function (err) {
                        deferred.reject(err);
                        errors.push(err);
                        vm.loading = false;
                      });
                  }
                  else{  
                    vm.resultContactTempErrLog += assg.subscriberId + ', ';     
                    deferred.reject('Contact limit exceeded. Cannot add more than the configured limit!');
                    vm.loading = false;
                  }
              });
            })
            .catch(function (err) {
              if (err.status == 404) {
                if (type == "Add") {
                  var body = {};
                  body.personalContacts = [];
                  assg.contactsTemplate.map(function (contact) {
                    if (contact._id != assg.subscriberId)
                      body.personalContacts.push({ contactUserId: contact.phone_number, name: contact.name, ownerUserId: assg.subscriberId });
                  });
                  Subscriber.isDispatcherUser(assg.permissionsMask).then(function(licenseRes){
                      if((licenseRes.result && vm.groupAssignDispLimit >= body.personalContacts.length) || (!licenseRes.result && vm.groupAssignLimit >= body.personalContacts.length))
                      {
                        PersonalContacts.addUpdateBatch(assg.subscriberId, body, assg.permissionsMask)
                        .then(function () {
                          deferred.resolve();
                          vm.resultContactTemplateLog = "Processing... Done: " + allocatedCount++;
                        })
                        .catch(function (err) {
                          deferred.reject(err);
                          errors.push(err);
                          vm.loading = false;
                        });
                      }
                      else{  
                        assignmentFuncs.push(function () {
                          vm.loading = false;
                          vm.resultContactTempErrLog += assg.subscriberId+', ';
            
                        });
                        deferred.reject('Contact limit exceeded. Cannot add more than the configured limit!');
                        vm.loading = false;
                      }
                  });
                  
                }
                else {
                  deferred.resolve();
                  vm.resultContactTemplateLog = "Processing... Done: " + allocatedCount++;
                }
              }
              else {
                deferred.reject(err);
                errors.push(err);
                vm.loading = false;
              }
            });
        }
        else {
          deferred.resolve();
          vm.resultContactTemplateLog = "Processing... Done: " + allocatedCount++;
        }

        return deferred.promise;
      }

    }
    //Bulk Contact Template function End

    function saveSentinel(){
      if(vm.sentinel.path.charAt(0) != '/')
        vm.sentinel.path = '/'+vm.sentinel.path;

      if(vm.sentinel.host && vm.sentinel.port && vm.sentinel.path && !vm.orgSenForm.$invalid)
      {
        vm.sentinel.org_id = vm.organization._id;
        Organization.setSentinel(vm.sentinel).then(function (resp){
            Toast.showUpdate();
        }).catch(function (error){
          ExceptionHandler.show(error.data);
        })
      }
    }

    function clearSentinel(){
      Organization.removeSentinel(vm.organization._id).then(function (resp){
          Toast.showDelete();
          getSentinel();
      }).catch(function (error){
        ExceptionHandler.show(error.data);
      })
    }

    function getSentinel(){
        Organization.getSentinel(vm.organization._id).then(function (resp){
          if(resp != '')
          {
            vm.sentinel = resp;
            if(vm.sentinel.host)
              vm.iframeUrl = vm.sentinel.host+':'+vm.sentinel.port+vm.sentinel.path+'?org='+vm.organization._id;
            else
              vm.iframeUrl = "//" + $location.host() + ":3007/sentinel?org="+vm.organization._id;
          }
          else
            vm.sentinel ={};
        }).catch(function (err){
          vm.sentinel ={};
          ExceptionHandler.show(err.data);
        });
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.restricted.softwareManufacturers', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.software-manufacturers', {
      url: '/software-manufacturers',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/platform/software-manufacturers/software.manufacturers.html',
          controller: 'softwareManufacturersController as vm'
        }
      },
      resolve: {
        isRoot: function ($q, $state, $timeout, Auth) {
          var deferred = $q.defer();

          if (Auth.isRootAdmin()) {
            deferred.resolve();
          } else {
            $timeout(function () {
              $state.go('app.restricted.homepage')
            });
            deferred.reject();
          }

          return deferred.promise;
        }
      },
      bodyClass: 'profile'
    });

    //$translatePartialLoaderProvider.addPart('app/main/restricted/platform/software-manufacturers');


    // Navigation
    msNavigationServiceProvider.saveItem('Platform.software-manufacturers', {
      title: 'Software manufacturers',
      icon: '',
      state: 'app.restricted.software-manufacturers',
      translate: 'NAVIGATION_SOFT_MANUFACTURERS',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.softwareManufacturers')
    .controller('smDetailsController', smDetailsController);

  /** @ngInject*/
  function smDetailsController(softwareM, $mdDialog, Auth, Manufacturer, ExceptionHandler) {
    var vm = this;

    vm.softwareM = softwareM;
    vm.loading = true;
    vm.allowCreate = Auth.isActionAllowed('manufacturer_resource','POST');
    vm.allowModify = Auth.isActionAllowed('manufacturer_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('manufacturer_resource','DELETE');

    this.cancel = cancel;
    this.ok = ok;
    vm.loading = false;

    function addManufacturer(){
      vm.loading = true;
      Manufacturer.add(vm.softwareM)
        .then(function (resp) {
          $mdDialog.hide(vm.softwareM);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.loading = false;
        });
    }

    function updateManufacturer(){
      vm.loading = true;
      Manufacturer.update(vm.softwareM)
        .then(function (resp) {
          $mdDialog.hide(vm.softwareM);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.loading = false;
        });
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function ok() {
     vm.softwareM._id ? updateManufacturer() : addManufacturer();
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.devices', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.devices', {
      url: '/devices',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/platform/devices/list.html',
          controller: 'DevicesController as vm'
        }
      },
      resolve: {
        isRoot: function ($q, $state, $timeout, Auth) {
          var deferred = $q.defer();

          if (Auth.isRootAdmin()) {
            deferred.resolve();
          } else {
            $timeout(function () {
              $state.go('app.restricted.homepage')
            });
            deferred.reject();
          }

          return deferred.promise;
        }
      },
      bodyClass: 'profile'
    });

    //$translatePartialLoaderProvider.addPart('app/main/restricted/platform/devices');


    // Navigation
    msNavigationServiceProvider.saveItem('Platform.devices', {
      title: 'Devices',
      icon: '',
      state: 'app.restricted.devices',
      translate: 'NAVIGATION_DEVICES',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.devices')
    .controller('pttDeviceDialogController', deviceDialogController);

  function deviceDialogController($mdDialog, device, Device, PttDevice, ClientStore, ExceptionHandler) {
    var vm = this;
    this.device = device;
    vm.loading = true;
    vm.deviceName = function(a,b,c) {
      var reqId = vm.device.device_id;
      for (var i = 0; i < vm.deviceList.length; i++) {
        if(vm.deviceList[i]._id == reqId) {
          vm.device.name = vm.deviceList[i].name;
          break;
        }
      }
    };

    fillDeviceList();
    fillStoreList();

    function fillDeviceList() {
      Device.getList()
        .then(function (resp) {
          vm.deviceList = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        });
    }

    function fillStoreList(){
      ClientStore.getList()
        .then(function(resp){
          vm.storeList = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.loading = false;
        });
    }

    function addPttDevice(){
      vm.loading = true;
      PttDevice.add(vm.device)
        .then(function () {
          $mdDialog.hide(vm.device);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.loading = false;
        });
    }

    function updatePttDevice(){
      vm.loading = true;
      PttDevice.update(vm.device)
        .then(function () {
          $mdDialog.hide(vm.device);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.loading = false;
        });
    }

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      vm.device._id ? updatePttDevice() : addPttDevice();
    };

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.ptt-client-store', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.ptt-client-store', {
      url: '/ptt-client-store',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/platform/ptt-client-store/list.html',
          controller: 'PttStoreController as vm'
        }
      },
      bodyClass: 'profile'
    });

  //  $translatePartialLoaderProvider.addPart('app/main/restricted/platform/ptt-client-store');


    // Navigation
    msNavigationServiceProvider.saveItem('Platform.ptt-client-store', {
      title: 'PTT client store',
      icon: '',
      state: 'app.restricted.ptt-client-store',
      translate: 'NAVIGATION_PTT_CLIENT_STORE',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.ptt-client-store')
    .controller('pttStoreDialogController', deviceDialogController);

  function deviceDialogController($mdDialog, store, Device, ClientVersion, ClientStore, Manufacturer,ExceptionHandler) {
    var vm = this;
    this.store = store;
    vm.getClientVersions = getClientVersions;

   /* vm.versions = [
      {
        name: '1.1.0',
        _id: 1
      },
      {
        name: '1.2.0',
        _id: 2
      }
    ]; */

    vm.licenseTypes = [
      {
        name: 'Mobile',
        _id: 1
      },
      {
        name: 'PC',
        _id: 2
      }
    ];

    vm.loading = true;
    fillDeviceList();
    fillManufacturerList();
    getClientVersions();
    function getClientVersions(){
      ClientVersion.getByStoreId(vm.store._id).then(function(resp){
        vm.versions = resp;
      })
        .catch(function(err){
          ExceptionHandler(err);
        })
        .finally(function(){
          vm.loading = false;
        });

    }

    function fillDeviceList() {
      Device.getList()
        .then(function (resp) {
          vm.deviceList = resp;
        })
        .catch(function(e){
         ExceptionHandler(e);
        });
    }

    function fillManufacturerList() {
      Manufacturer.getSoftList()
        .then(function (resp) {
          vm.softwareMs = resp;
        })
        .catch(function(e){
         ExceptionHandler(e);
        });
    }

    function addClientStore(){
      vm.loading = true;
      ClientStore.add(vm.store)
        .then(function (resp) {
          $mdDialog.hide(vm.store);
        }).
      catch(function(e){
        ExceptionHandler.show(e);
      })
        .finally(function(){
          vm.loading = false;
        });
    }

    function updateClientStore(){
      vm.loading = true;
      ClientStore.update(vm.store)
        .then(function (resp) {
          $mdDialog.hide(vm.store);
        }).
      catch(function(e){
        ExceptionHandler.show(e);
      }).finally(function(){
          vm.loading = false;
      });
    }

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
     vm.store._id ? updateClientStore() : addClientStore();
    };

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.localization', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.localization', {
      url: '/localization',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/platform/localization/localization.html',
          controller: 'localizationController as vm'
        }
      }
    });

  //  $translatePartialLoaderProvider.addPart('app/main/restricted/platform/localization');


    // Navigation
    msNavigationServiceProvider.saveItem('Platform.localization', {
      title: 'Localization',
      icon: '',
      state: 'app.restricted.localization',
      translate: 'NAVIGATION_LOCALIZATION',
      weight: 6
    });
  }
})();

(function(){
  'use strict';

  angular.module('app.restricted.localization')
    .controller('localizationDialogController', localizationDialogController);

  function localizationDialogController($mdDialog, $q, translation,$resource,api, ExceptionHandler, Toast) {
    var vm = this;
    vm.translation = translation;
    vm.flags = ['ag', 'ai', 'al', 'am', 'ao', 'aq', 'ar', 'as', 'at', 'au', 'aw', 'ax', 'az', 'ba', 'bb', 'bd', 'be', 'bf', 'bg', 'bh', 'bi', 'bj', 'bl', 'bm', 'bn', 'bo', 'bq', 'br', 'bs', 'bt', 'bv', 'bw', 'by', 'bz', 'ca', 'cc', 'cd', 'cf', 'cg', 'ch', 'ci', 'ck', 'cl', 'cm', 'cn', 'co', 'cr', 'cu', 'cv', 'cw', 'cx', 'cy', 'cz', 'de', 'dj', 'dk', 'dm', 'do', 'dz', 'ec', 'ee', 'eg', 'eh', 'er', 'es', 'es-ct', 'et', 'eu', 'fi', 'fj', 'fk', 'fm', 'fo', 'fr', 'ga', 'gb', 'gb-eng', 'gb-nir', 'gb-sct', 'gb-wls', 'gd', 'ge', 'gf', 'gg', 'gh', 'gi', 'gl', 'gm', 'gn', 'gp', 'gq', 'gr', 'gs', 'gt', 'gu', 'gw', 'gy', 'hk', 'hm', 'hn', 'hr', 'ht', 'hu', 'id', 'ie', 'il', 'im', 'in', 'io', 'iq', 'ir', 'is', 'it', 'je', 'jm', 'jo', 'jp', 'ke', 'kg', 'kh', 'ki', 'km', 'kn', 'kp', 'kr', 'kw', 'ky', 'kz', 'la', 'lb', 'lc', 'li', 'lk', 'lr', 'ls', 'lt', 'lu', 'lv', 'ly', 'ma', 'mc', 'md', 'me', 'mf', 'mg', 'mh', 'mk', 'ml', 'mm', 'mn', 'mo', 'mp', 'mq', 'mr', 'ms', 'mt', 'mu', 'mv', 'mw', 'mx', 'my', 'mz', 'na', 'nc', 'ne', 'nf', 'ng', 'ni', 'nl', 'no', 'np', 'nr', 'nu', 'nz', 'om', 'pa', 'pe', 'pf', 'pg', 'ph', 'pk', 'pl', 'pm', 'pn', 'pr', 'ps', 'pt', 'pw', 'py', 'qa', 're', 'ro', 'rs', 'ru', 'rw', 'sa', 'sb', 'sc', 'sd', 'se', 'sg', 'sh', 'si', 'sj', 'sk', 'sl', 'sm', 'sn', 'so', 'sr', 'ss', 'st', 'sv', 'sx', 'sy', 'sz', 'tc', 'td', 'tf', 'tg', 'th', 'tj', 'tk', 'tl', 'tm', 'tn', 'to', 'tr', 'tt', 'tv', 'tw', 'tz', 'ua', 'ug', 'um', 'un', 'us', 'uy', 'uz', 'va', 'vc', 've', 'vg', 'vi', 'vn', 'vu', 'wf', 'ws', 'ye', 'yt', 'za', 'zm', 'zw', 'ad', 'ae', 'af'];
    vm.loading = false;

    init();

    function init(){
      getExport(vm.translation.code);
    }

    function getExport(code){
      vm.loading = true;
      var getTranslation = $resource('app/i18n/'+code+'.json');
      var translationVars = {};
      getTranslation.get({},function(response){
        translationVars =  response;
       formatToExport(translationVars).
         then(function(resp){
           vm.toExport = resp;
       });

      });
      vm.loading = false;
    }

    function formatToExport(translation){
      var deferred = $q.defer();
      var toExport = [];
      delete translation.$promise;
      delete translation.$resolved;

      var getSource = $resource('app/i18n/default/default.json');
      var source = {};
      getSource.get({},function(response) {
        source = response;
        delete source.$promise;
        delete source.$resolved;

        for(var key in source){
          if(source.hasOwnProperty(key)){
            if(!translation.hasOwnProperty(key)){
              translation[key] = null;
            }
            toExport.push( {k: key, v: translation[key]});
          }
        }
        deferred.resolve(toExport);
        vm.loading = false;
      }, function(err){
        vm.loading = false;
        deferred.reject(err);
      });
      return deferred.promise;
    }

    vm.streamingCallback = function() {
      if(vm.result && vm.result.filename.includes(".csv")){
        vm.resultLanguage = {};
        vm.result.map(function(label){
          var parsedLabel = label[0].split(",");
          if(parsedLabel[1]==="" || parsedLabel[1] === " "){
            vm.resultLanguage[parsedLabel[0]] = null;
          }
          else{
            vm.resultLanguage[parsedLabel[0]] = parsedLabel[1];
          }

        });

        api.translation.import.put({translationCode: vm.translation.code},vm.resultLanguage,
          function(resp) {
            Toast.showAdd();

          }, function (err) {
            ExceptionHandler.show(err);
          });


      }else{
        Toast.showBatchImportedFileErrorMsg();
        vm.loading = false;
      }
    };



    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      $mdDialog.hide(vm.translation, vm.mode);
    };

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.deviceManufacturers', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.devices-manufacturers', {
      url: '/devices-manufacturers',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/platform/devices-manufacturers/devices.manufacturers.html',
          controller: 'devicesManufacturersController as vm'
        }
      },
      bodyClass: 'profile',
      resolve: {
        isRoot: function ($q, $state, $timeout, Auth) {
          var deferred = $q.defer();

          if (Auth.isRootAdmin()) {
            deferred.resolve();
          } else {
            $timeout(function () {
              $state.go('app.restricted.homepage')
            });
            deferred.reject();
          }

          return deferred.promise;
        }
      }
    });

   // $translatePartialLoaderProvider.addPart('app/main/restricted/platform/devices-manufacturers');


    // Navigation
    msNavigationServiceProvider.saveItem('Platform.devices-manufacturers', {
      title: 'Devices manufacturers',
      icon: '',
      state: 'app.restricted.devices-manufacturers',
      translate: 'NAVIGATION_DEV_MANUFACTURERS',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.deviceManufacturers')
    .controller('dmDetailsController', dmDetailsController);

  /** @ngInject*/
  function dmDetailsController(deviceM, $mdDialog, ExceptionHandler, Manufacturer, Auth) {
    var vm = this;

    vm.deviceM = deviceM;
    // vm.loading = true;
    vm.allowCreate = Auth.isActionAllowed('manufacturer_resource','POST');
    vm.allowModify = Auth.isActionAllowed('manufacturer_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('manufacturer_resource','DELETE');

    this.cancel = cancel;
    this.ok = ok;
    // vm.loading = false;
    function addDeviceManufacturer(){
      // vm.loading = true;
      Manufacturer.add(vm.deviceM)
        .then(function (resp) {
          $mdDialog.hide(vm.deviceM);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function updateDeviceManufacturer(){
      // vm.loading = true;
      Manufacturer.update(vm.deviceM)
        .then(function (resp) {
          $mdDialog.hide(vm.deviceM);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function ok() {
      vm.deviceM._id ? updateDeviceManufacturer() : addDeviceManufacturer();
    }
  }
})();

(function(){
  'use strict';

  angular.module('app.restricted.devices')
    .controller('deviceDialogController', deviceDialogController);

  function deviceDialogController($mdDialog, ExceptionHandler, Device, device, Manufacturer, Auth) {
    var vm = this;
    vm.allowCreate = Auth.isActionAllowed('device_resource','POST');
    vm.allowModify = Auth.isActionAllowed('device_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('device_resource','DELETE');

    this.device = device;
    // vm.loading = true;
    fillDeviceList();

    function fillDeviceList() {
      Manufacturer.getDeviceList()
       .then(function (resp) {
       vm.categoryTypes = resp;
       })
        .catch(function(e){
          ExceptionHandler(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    vm.deviceTypes = [{
      id: 1,
      name: "PC"
    },
      {
        id: 2,
        name: "Mobile"
      }
    ];

    function addDevice(){
      // vm.loading = true;
      Device.add(device)
        .then(function (resp) {
          $mdDialog.hide(vm.device);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function updateDevice(){
      // vm.loading = true;
      Device.update(device)
        .then(function (resp) {
          $mdDialog.hide(vm.device);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      vm.device._id ? updateDevice() : addDevice();
    };

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.client-version', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.client-version', {
      url: '/client-version',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/platform/client-version/list.html',
          controller: 'ClientVersionController as vm'
        }
      },
      bodyClass: 'profile'
    });

    //$translatePartialLoaderProvider.addPart('app/main/restricted/platform/client-version');


    // Navigation
    msNavigationServiceProvider.saveItem('Platform.client-version', {
      title: 'Client version',
      icon: '',
      state: 'app.restricted.client-version',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.client-version')
    .controller('clientVersionDialogController', clientVersionDialogController);

  function clientVersionDialogController($mdDialog, ClientVersion, version, ClientStore, ExceptionHandler) {
    var vm = this;
    this.version = version;

    fillStoreList();

    function fillStoreList() {
      // vm.loading = true;
      ClientStore.getList()
        .then(function (resp) {
          vm.storeList = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }
    function addClientStore(){
      // vm.loading = true;
      ClientVersion.add(vm.version)
        .then(function (resp) {
          $mdDialog.hide();
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function updateClientStore(){
      // vm.loading = true;
      ClientVersion.update(vm.version)
        .then(function (resp) {
          $mdDialog.hide();
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });

    }

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      vm.version._id ? updateClientStore() : addClientStore();
    };

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.wfm', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider, msApiProvider) {
    $stateProvider.state('app.restricted.wfm', {
      url: '/wfm',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/wfm/wfm.html',
          controller: 'WFMController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('organization_resource','GET')
        }
      }
    });

    // Navigation
    msNavigationServiceProvider.saveItem('Organization.wfm', {
      title: 'WFM',
      icon: '',
      state: 'app.restricted.wfm',
      translate: 'NAVIGATION_WFM',
      weight: 6
    });
  }

})();

(function () {

    'use strict';

    angular.module('app.restricted.wfm')
    .controller('addNewWFMUserDialogController', addNewWFMUserDialogController);

    function addNewWFMUserDialogController(Context, $rootScope, ExceptionHandler, Toast, Auth, orderByFilter, $mdDialog, $filter, localStorageService, AdminRecord, RecordWhiteList, Subscriber, Wfm, Group, Organization, AudioBackupPath, Config) {
        var vm = this;
        vm.cancel = cancel;
        vm.ok = ok;
        vm.loading = true;
        vm.selectAll = selectAll;
        vm.unselectAll = unselectAll;
        vm.errorMsg = "";

        function cancel() {
            $mdDialog.cancel();
        }

        function ok() {
            vm.flagSave = false;
            
        }

        function selectAll() {
            vm.selectedUsers = vm.selectedUsers.concat(vm.unselectedUsers);
            vm.unselectedUsers = [];
        }
    
        function unselectAll() {
            vm.unselectedUsers = vm.unselectedUsers.concat(vm.selectedUsers);
            vm.selectedUsers = [];
        }
    }





}
)();
(function () {
  'use strict';

  angular.module('app.restricted.subscribers')
    .controller('SubscriberSendSmsController', SubscriberSendSmsController);



  /** @ngInject*/
  function SubscriberSendSmsController($mdDialog, Toast, Sms, Reseller, Context, Config, subscriber, server, Subscriber) {
    var vm = this;

    vm.sendSMS = sendSMS;
    vm.cancel = cancel;

    vm.subscriber = subscriber;
    vm.server = server;
    vm.keys = false;

    init()

    function init() {
      //server
      Config.getFilterList().then(function (resp) {
        vm.configs = resp;
        vm.server = vm.configs.filter(function (param) {
          return param.name == "PROV_IPRS_SERVER";
        });
        vm.server = vm.server[0].value;
      });

      //Keys
       Reseller.getById(Context.getLastResellerId()).then(function (resp) {
        vm.reseller = resp[0];
        if (vm.reseller && vm.reseller.sms && vm.reseller.sms.apiKey && vm.reseller.sms.apiSecret)
          vm.keys = true;
      });
      vm.resultLog = "";
    }


    /**
     * This functions builds the sms object acording to its type. 
     * @param {string} type 
     */
    function creatObjSms(type) {

      var sms = {};
      sms.phoneNumber = vm.subscriber.phone_number;
      sms.apiKey = vm.reseller.sms.apiKey;
      sms.apiSecret = vm.reseller.sms.apiSecret;
      sms.service = vm.reseller.sms.service;
      sms.ip = vm.reseller.sms.ip;
      sms.port = vm.reseller.sms.port;


      if (type == "Credentials") {
        sms.message = "getwml.aspx?uname=" + vm.subscriber.sip + "&pass=" + vm.subscriber.password;
      }
      else if (type == "CredentialsWithServer") {
        sms.message = "getwml.aspx?uname=" + vm.subscriber.sip + "&pass=" + vm.subscriber.password + "&server=" + vm.server
      }
      else if (type == "DownloadLink") {
        sms.message = "Download app from here:" + vm.sms.downloadLink;
      }
      else if (type == "Both") {
        sms.message = "getwml.aspx?uname=" + vm.subscriber.sip + "&pass=" + vm.subscriber.password + "&server=" + vm.server + "&url=" + vm.sms.downloadLink;
      }
      else if (type == "Message") {
        sms.message = vm.sms.msg;
      }

      return sms;
    }


    function sendSMS(type) {

        Subscriber.getById(vm.subscriber._id)
        .then(function (resp) {
          vm.subscriber.password = resp.password;
          if (!vm.subscriber.sip){
            vm.subscriber.sip = resp.sip;
            vm.subscriber.phone_number = vm.subscriber.sip.split("@")[0];
          }
          openSMSdialog(type);
        });
      // }
      // else
      //   openSMSdialog(type);
    }

    function openSMSdialog(type){
      var sms = creatObjSms(type);
      // vm.loading = true;
      var confirm = Toast.getSendSms(sms.message);

      $mdDialog.show(confirm)
        .then(function () {
          if (type == "Credentials") {
            Sms.sendSms(sms).then(function (res) {
              vm.resultLog = "Credentials were sent";
              // vm.loading = false;
            })
              .catch(function (err) {
                vm.resultLog = "Message was not sent- " + err.data.message;
                // vm.loading = false;
              });
          }
          else if (type == "CredentialsWithServer") {
            Sms.sendSms(sms).then(function (res) {
              vm.resultLog = "Credentials were sent";
              // vm.loading = false;
            })
              .catch(function (err) {
                vm.resultLog = "Message was not sent- " + err.data.message;
                // vm.loading = false;
              });
          }
          else if (type == "DownloadLink") {
            Sms.sendSms(sms).then(function (res) {
              vm.resultLog = "Download Link was sent";
              // vm.loading = false;
            })
              .catch(function (err) {
                vm.resultLog = "Message was not sent- " + err.data.message;
                // vm.loading = false;
              });
          }

          else if (type == "Both") {
            Sms.sendSms(sms).then(function (res) {
              vm.resultLog = "Download Link and Credentials were sent";
              // vm.loading = false;
            })
              .catch(function (err) {
                vm.resultLog = "Message was not sent- " + err.data.message;
                // vm.loading = false;
              });
          }

          else if (type == "Message") {
            Sms.sendSms(sms).then(function (res) {
              vm.resultLog = "Message was sent";
              // vm.loading = false;
            })
              .catch(function (err) {
                vm.resultLog = "Message was not sent- " + err.data.message;
                // vm.loading = false;
              });
          }
        })
        .catch(function () {
          // vm.loading = false;
        })
    }

    function cancel() {
      $mdDialog.cancel();
    }

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.subscribers')
    .controller('subscriberDialogController', subscriberDialogController);

  /** @ngInject*/
  function subscriberDialogController($mdDialog, $translate, $q, $timeout, Toast, $filter, api, ExceptionHandler, Subscriber, subscriber, PersonalContacts, organization, License, Group, PersonalGroup, Site, Auth, clone,Security, configs, activeTab, Config, ApplicationList, applicationLists, Organization, localStorageService, Fwrdgroup) {


    var vm = this;
    vm.flagSave = true;
    vm.clone = clone;
    vm.activeTab = activeTab || 0;
    vm.configs = configs;
    vm.currentConsoleType = 2;
    vm.isActionAllowed = Auth.isActionAllowed;
    vm.applicationLists = applicationLists;
    // vm.allocations = allocations;
    // vm.allocationsList = allocationsList;
    vm.allowCreate = Auth.isActionAllowed('subscriber_resource','POST');
    vm.allowModify = Auth.isActionAllowed('subscriber_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('subscriber_resource','DELETE');

    vm.allowReadGroups = Auth.isActionAllowed('group_resource','GET');
    vm.allowUpdateGroups = Auth.isActionAllowed('group_resource','PUT');

    vm.allowReadLicenses = Auth.isActionAllowed('license_resource','GET');
    vm.allowCreateLicenses= Auth.isActionAllowed('license_resource','POST');
    vm.allowLicenseDelete = Auth.isActionAllowed('license_resource','DELETE');

    vm.groupPaginationClass = "groupPagination";
    vm.contactPaginationClass = "contactPagination";
    vm.personalContactsPaginationClass = "personalContactsPagination";
    vm.subscriberListsPaginationClass = "subscriberListsPaginationClass";
    vm.personalGroupsPaginationClass = "personalGroupsPaginationClass";
    // vm.loading = true;
    // vm.activity_loading = false;

    vm.allowSms =  Auth.isActionAllowed('subscriber_resource','HIMPACT');
    vm.openSMSdialog = openSMSdialog;

    this.cancel = cancel;
    this.ok = ok;
    this.selectGroup = selectGroup;
    this.unselectGroup = unselectGroup;
    this.selectAll = selectAll;
    this.unselectAll = unselectAll;
    this.showPassword = showPassword;
    // this.filterBundles = filterBundles;   //shahar- remove license
    // this.clearBundlesFilter = clearBundlesFilter;
    // this.addAssignment = addAssignment;
    // this.selectAllocation = selectAllocation;
    // this.selectForRevokation = selectForRevocation;
    this.onTabChanges = onTabChanges;
    this.checkErrors = checkErrors;
    // this.showAllocationButton = showAllocationButton;
    // this.checkActiveAllocation = checkActiveAllocation;
    //this.editLicense = editLicense;
    this.showRole = showRole;
    this.showApplication = showApplication;
    this.generateSip = generateSip;
    this.checkDomain = checkDomain;
    this.getSecurityLog = getSecurityLog;
    this.checkDate = checkDate;
    this.chooseTemplate = chooseTemplate;
    this.chooseDefaultRadioGroup = chooseDefaultRadioGroup;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    vm.generateQrCode = generateQrCode;
    vm.enableTwoFactor = enableTwoFactor;
    vm.sort = sort;
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.search = '';
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.addButtonDisableFlag = false;

    vm.errorPersonalContactLimit = false;
    vm.errorGroupsLimit = false;
    vm.errorCGroupsLimit = false;
    vm.errorOCLLimit = false;

    vm.errorMsg = "";
    vm.affiliatedContacts = [];
    vm.duplicateRespPersonalCon = [];
    vm.tempAffiliatedGroups = [];
    vm.tempNonAffiliatedGroups = [];
    vm.licensesTemplate = [];
    this.allLicensesTemplate = [];
    vm.reverse = [];
    vm.now = new Date();
    getSubscribersList();

    vm.subscriber.startDate = new Date(new Date().setHours(0,0,0,0));
    vm.subscriber.endDate = new Date(new Date().setHours(23, 59, 59, 999));
    getSecurityLog();
    getLicenseData();
    function checkDate() {
      vm.subscriber.errMessage = '';

      if(vm.subscriber && vm.subscriber.endDate && vm.subscriber.startDate && vm.subscriber.startDate > vm.subscriber.endDate){
        vm.subscriber.errMessage = $translate.instant("DATES_ERROR");//'End Date should be greater than start date';
        return false;
      }else{
        vm.subscriber.errMessage = '';
        getSecurityLog();
      }
    }

    function checkErrors(){
      var error = true;
      vm.errorMsg = "";

      if (vm.rolesList && vm.rolesList.length == 0) vm.errorMsg = $translate.instant("SUBSCRIBERS_VALIDATION_CREATE_ROLE_ERROR");
      else if (vm.subscriber && vm.subscriber.adminrole_id == '0') vm.errorMsg = $translate.instant("SUBSCRIBERS_VALIDATION_SELECT_ROLE_ERROR");
      else if (vm.subscriber && !vm.subscriber.license) vm.errorMsg = $translate.instant("SUBSCRIBERS_VALIDATION_LICENSE_ASSIGNMENT_ERROR");
      else if (vm.subscriber && vm.subscriber.strongDispatchPass && vm.subscriber.license.dispatcher && ((vm.editSubscriberForm && vm.editSubscriberForm.password && vm.editSubscriberForm.password.$invalid)|| (vm.addSubscriberForm && vm.addSubscriberForm.password && vm.addSubscriberForm.password.$invalid))) vm.errorMsg = $translate.instant("SUBSCRIBERS_VALIDATION_STRONG_DISPATCH_PASS");
      else if (vm.errorGroupsLimit) vm.errorMsg = $translate.instant("SUBSCRIBERS_GROUPS_LIMIT_ERROR");
      else if (vm.errorCGroupsLimit) vm.errorMsg = $translate.instant("SUBSCRIBERS_GROUPS_LIMIT_ERROR");
      else if (vm.errorPersonalContactLimit) vm.errorMsg =  $translate.instant("SUBSCRIBERS_PERSONAL_GROUPS_LIMIT_ERROR");
      else if (vm.errorOCLLimit) vm.errorMsg =  $translate.instant("SUBSCRIBERS_OCL_LIMIT_ERROR");
      else error = false;
      return error;
    }

    //----------------------------------------------------------------------

    function getSecurityLog() {
      if(vm.subscriber && vm.subscriber.startDate && vm.subscriber.endDate){
        // vm.activity_loading = true;
        vm.securityList = [];
        var startDate = $filter('date')(vm.subscriber.startDate,'dd-MMM-yy');
        var endDate = $filter('date')(vm.subscriber.endDate,'dd-MMM-yy');

        Security.getSecurityLogByID(vm.subscriber._id, startDate.toString(), endDate.toString())
          .then(function(resp){
            vm.securityList = resp.results ? resp.results : [];
          })
          .catch(function(e){
            if(e.status !==404){
              ExceptionHandler.show(e);
            }
          })
          .finally(function(){
            // vm.activity_loading = false;
          });
        }else{
          vm.errMessage = $translate.instant("DATES_BLANK_ERROR");
        }


    }

    function checkIfMobile(id, phone){
      if (!phone) return false;
      else{
        if (id == phone) return false;
        else return true;
      }
    }
    function getSubscribersList(){
      vm.organization = organization;
      
      vm.subscriber = subscriber;
      vm.isOffnet=0;
      vm.subscriber.organization_id = parseInt(vm.subscriber.organization_id);
      vm.subscriber.strongDispatchPass = ((vm.subscriber.license && vm.subscriber.license.dispatcher) && vm.organization.strongDispatchPass) ? 1 : 0

      vm.securityList = [];

      vm.mobileUser = checkIfMobile(vm.subscriber._id, vm.subscriber.phone_number);
      //vm.subscriber.license = null; //license will be filled later from allocation

      if(vm.subscriber.adminrole_id === null) vm.subscriber.adminrole_id = 0;

      organization._id && Subscriber.getSubscriberListByOrg(organization._id)
      .then(function (resp) {
        vm.allSubscribers = resp;
        setPreData();
      })
      .catch(function(e){
        if(e.status !== 404){ ExceptionHandler.show(e) }
        else{
          setPreData();
        }
      });
    }

    function setPreData() {
      vm.bundleNames = [];

      var getLicenseTemplate = function(){
        var deferred = $q.defer();
        License.getLicenseTemplates()
        .then(function(resp){
          vm.licenseTemplates = resp;
          for (var i = 0; i < vm.licenseTemplates.length; i++){
            if (vm.licenseTemplates[i].mask == vm.subscriber.permissions_mask){
              vm.selectedTemplate = vm.licenseTemplates[i].name;
            }
            if (!vm.selectedTemplate)
              vm.selectedTemplate = null;
          }
          deferred.resolve();
        })
        .catch(function(e){
          deferred.resolve();
        });
        return deferred.promise;
      }

      var getApplicationList = function(){
        var deferred = $q.defer();
        var phoneNo = subscriber.phone_number?subscriber.phone_number:subscriber._id;
        ApplicationList.getSubscriberApplicationList(vm.organization._id, subscriber.phone_number)
        .then(function(app){
          vm.subscriber.application_id = app.application_list;
          deferred.resolve();
        })
        .catch(function(e){
          deferred.resolve();
        });
        return deferred.promise;
      }

      var getSite = function(){
        var deferred = $q.defer();
        Site.getList()
        .then(function(resp){
          vm.sites = resp;
          vm.sites = resp.filter(function(site) {
            site.iprs_public = site.iprs_public ? "(" + site.iprs_public  + ")" : "";
            return site.type === 1;
          });
          if(typeof vm.organization !== 'undefined'){
            if(vm.organization.primary_site_id && !vm.subscriber.primary_site_id){
              vm.subscriber.primary_site_id = vm.organization.primary_site_id.toString();
            }
            if(vm.organization.primary_site_id && !vm.subscriber.site){
              vm.subscriber.site = vm.organization.primary_site_id.toString();
            }
            if(vm.organization.site && !vm.subscriber.secondary_site_id){
              if(vm.organization.site)
                vm.subscriber.secondary_site_id = vm.organization.site.toString();
              else if(vm.organization.primary_site_id)
                vm.subscriber.secondary_site_id = vm.organization.primary_site_id.toString();
              else
                vm.subscriber.secondary_site_id = vm.subscriber.primary_site_id.toString();
            }
          }
            deferred.resolve();
        })
        .catch(function(e){
          deferred.resolve();
        });
        return deferred.promise;
      }

      var getRole = function(){
        var deferred = $q.defer();
        api.roles.listByOrg.query({nodeId: vm.subscriber.organization_id}, function(resp) {
          vm.rolesList = resp;
          deferred.resolve();
        },
        function(e){
          if (vm.subscriber.adminrole_id) vm.rolesList = [{name:"Unknown", _id: vm.subscriber.adminrole_id}];
          else vm.rolesList = [];
          deferred.resolve();
        });
        return deferred.promise;
      }

      var getGroups = function(orgId){
        var deferred = $q.defer();
        Group.getAllGroupList(orgId)
        .then(function(resp){
          return new Promise(function(resolve, reject) {
            vm.groups = resp.filter(function(group){
            return (group.type === 2 || group.type === 1);
            });
            vm.contacts = resp.filter(function (contact){
            return contact.type == 4;
            });
            vm.subscriberLists = resp.filter(function(group){
            return group.type === 8;
            });
            vm.emergencyGroups = resp.filter(function(group){
            return group.type === 9;
            });
            vm.forwardsGroups = resp.filter(function(group){
            return group.type === 10;
            });
            resolve();
          })
          .then(function(){
            var flowFunctionsArrayGroups = [];
            if (vm.showOcl) flowFunctionsArrayGroups.push(fillContactList());
            flowFunctionsArrayGroups.push(fillGroupList());
            flowFunctionsArrayGroups.push(getFwrdGroup()); 
            // flowFunctionsArrayGroups.push(fillSubscriberList());
            if (vm.showPersonalGroup) flowFunctionsArrayGroups.push(fillPersonalGroup());

            $q.all(flowFunctionsArrayGroups)
            .then(function(){
              deferred.resolve();
            })
            .catch(function(err){
              deferred.resolve();
            });
          });
        })
        .catch(function(err){
          deferred.resolve();
        });
      }

      var fillContactList = function() {
        var deferred = $q.defer();
        if(vm.subscriber._id){
          Group.getContactsFilteredBySubId(vm.subscriber._id)
            .then(function(resp){
              vm.subscriber.contacts = resp.map(function(contact){
                return contact._id;
              });
              vm.unselectedContacts = vm.contacts.filter(function (contact) {
                return vm.subscriber.contacts.indexOf(contact._id) === -1;
              });

              vm.selectedContacts = vm.contacts.filter(function (contact) {
                return (vm.subscriber.contacts.indexOf(contact._id) !== -1);
              });
              deferred.resolve();
            })
        }
        else{
          vm.unselectedContacts = vm.contacts;
          deferred.resolve();
        }
        return deferred.promise;
      }

      var getFwrdGroup = function() {
        vm.selectedFwrdGroup=[];
        var deferred = $q.defer();
        if(vm.subscriber._id){
          Fwrdgroup.getFwrdGroupBySubscriberId(vm.subscriber._id)
            .then(function(resp){
              vm.forwardsGroups.forEach(function(group){
                resp.forEach(function(list) {
                    if(list['to_char(fwrd_group_id)'] === group._id)
                          vm.selectedFwrdGroup.push(group)
                  });
              });
              deferred.resolve();
            })
        }
        else{
          deferred.resolve();
        }
        return deferred.promise;
      }

      var fillPersonalGroup = function(){
        var deferred = $q.defer();
        if(vm.subscriber._id){
          PersonalGroup.getByUserId(vm.subscriber._id)
            .then(function(resp){
              if (resp.length == 0){
                vm.subscriber.oldEmergencyGroup = null;
                vm.subscriber.emergencyGroup = [];
                vm.subscriber.emergencyGroup._id = null;
              }
              else{
                  if(!resp[0].personalgroup_mask || resp[0].personalgroup_mask==0){
                    vm.subscriber.oldEmergencyGroup = null;
                    vm.subscriber.emergencyGroup = [];
                    vm.subscriber.emergencyGroup._id = null;
                  }
                  else{
                    vm.subscriber.oldEmergencyGroup = resp[0];
                    vm.subscriber.emergencyGroup = resp[0];
                    var selectedEmergencyGroup = vm.emergencyGroups.filter(function(group){
                      if (vm.subscriber.emergencyGroup.personalgroup_mask==Number(group._id.substring(group._id.length - 10, group._id)))
                        return group;
                    })[0]
                    vm.subscriber.emergencyGroup.name = selectedEmergencyGroup.name;
                    vm.subscriber.emergencyGroup._id = selectedEmergencyGroup._id;
                  }
              }
            })
            .catch(function(e){
              if(e.status !== 404){ ExceptionHandler.show(e) }
              vm.subscriber.oldEmergencyGroup = null;
              vm.subscriber.emergencyGroup = [];
                vm.subscriber.emergencyGroup._id = null;

            })
            .finally(function(){
              deferred.resolve();
            });
        }
        else{
          vm.subscriber.oldEmergencyGroup = null;
          vm.subscriber.emergencyGroup = [];
          vm.subscriber.emergencyGroup._id = null;
          deferred.resolve();
        }
        return deferred.promise;
      }

      var checkOffnetOrnot= function(){
        var deferred = $q.defer();
        Subscriber.licenseIsOffNet(vm.subscriber.permissions_mask).then(function(resp){
        if(resp.result == true)
          vm.isOffnet = 1;
        });
      }

      var fillSubscriberList = function() {
        var deferred = $q.defer();
        vm.selectedSubscriberLists = [];
        // vm.unselectedSubscriberLists = vm.subscriberLists;
        // vm.unselectedSubscriberLists = vm.subscriberLists.filter(function (contactTemp) {
        //   return vm.subscriber.groups.indexOf(contactTemp._id) === -1;
        // });
        vm.unselectedSubscriberLists = vm.subscriberLists;
        // var offnetFlag=0;
        // for(var i=0;i<vm.licensesTemplate.length;i++)
        // {
        //   if(vm.licensesTemplate[i] == vm.subscriber.permissions_mask)
        //       offnetFlag = 1;
        // }
       
        vm.tempAffiliatedContact=[];
        vm.tempNonAffiliatedContact=[];
        for(var i=0;i<vm.unselectedSubscriberLists.length;i++)
        {
          if(vm.unselectedSubscriberLists[i].cross_fleet != 1)
              vm.tempNonAffiliatedContact.push(vm.unselectedSubscriberLists[i]);
        }
        if(vm.isOffnet != 1)
        {vm.unselectedSubscriberLists = vm.tempNonAffiliatedContact;}    

        // vm.selectedSubscriberLists = vm.subscriberLists.filter(function (contactTemp) {
        //   return vm.subscriber.groups.indexOf(contactTemp._id) !== -1;
        // });

        var affiliatedContacts = vm.allGCList.filter(function(subscriberContact){
          return (!(vm.subscriberLists.filter(function(contact){
            return (contact._id == subscriberContact._id)
          })[0]) && (subscriberContact.type == 8))
        })
        if (affiliatedContacts && affiliatedContacts.length > 0){
          getOrganizationsMap()
          .then(function(){
            var flowFunctionsArray = [];
            affiliatedContacts.map(function(contact){
              if(contact.organization_id != vm.subscriber.organization_id)
                flowFunctionsArray.push(getAffiliatedContact(contact._id));
            })
            $q.all(flowFunctionsArray)
            .then(function(){
              deferred.resolve();
            })
            .catch(function(err){
              ExceptionHandler.show(err);
            });
          })
        }
        else
          deferred.resolve();

        deferred.resolve();
        return deferred.promise;
      }
      
      function getOrganizationsMap(){
        var deferred = $q.defer();
        vm.organizationsMap = {};
        Organization.getListByReseller(vm.organization.parentReseller)
        .then(function(resp){
          resp.map(function(org){
            vm.organizationsMap[org._id] = org.name;
          });
          deferred.resolve();
        })
        .catch(function(err){
          deferred.reject();
        });

        return deferred.promise;
      }

      var getAffiliatedContact = function(contactId){  
        var deferred = $q.defer();
        Group.getById(contactId)
        .then(function(group){
          group.affiliated = true;
          group.organization_name = "Affiliated";//(group.organization_id == vm.subscriber.organization_id) ? "Own" : vm.organizationsMap[group.organization_id]
          vm.selectedSubscriberLists.push(group);
          deferred.resolve();
        })
        .catch(function(err){
          deferred.reject(err);
        })
        return deferred.promise;
      }
      var getAffiliatedGroup = function(groupId){
        var deferred = $q.defer();
        Group.getById(groupId)
        .then(function(group){
          group.affiliated = true;
          group.organization_name = "Affiliated";//(group.organization_id == vm.subscriber.organization_id) ? "Own" : vm.organizationsMap[group.organization_id]
          vm.selectedGroups.push(group);
          deferred.resolve();
        })
        .catch(function(err){
          deferred.reject(err);
        })
        return deferred.promise;
      }
      var fillGroupList = function(){
        var deferred = $q.defer();
        vm.radioGroups = vm.groups.filter(function(group){
          return group.type === 2;
        });
        if(vm.subscriber._id){
          var offnetFlag=0;
          Subscriber.licenseIsOffNet(vm.subscriber.permissions_mask).then(function(resp){
            if(resp.result == true)
                offnetFlag = 1;
          });
          Group.getGrpFilteredBySubscriberId(vm.subscriber._id)
            .then(function(resp){
              vm.subscriber.groups = resp.map(function(group){
                return group._id;
              });
              vm.allGCList= resp;
              fillSubscriberList()
              vm.unselectedGroups = vm.groups.filter(function (group) {
                return vm.subscriber.groups.indexOf(group._id) === -1;
              });

              
              
              // for(var i=0;i<vm.licensesTemplate.length;i++)
              // {
              //   if(vm.licensesTemplate[i] == vm.subscriber.permissions_mask)
              //       offnetFlag = 1;
              // }
              vm.tempAffiliatedGroups=[];
              vm.tempNonAffiliatedGroups=[];
              for(var i=0;i<vm.unselectedGroups.length;i++)
              {
                if(vm.unselectedGroups[i].cross_fleet != 1)
                    vm.tempNonAffiliatedGroups.push(vm.unselectedGroups[i]);
              }
              
              if(offnetFlag != 1)
                  vm.unselectedGroups = vm.tempNonAffiliatedGroups;


              vm.groups.filter(function (group) {
                group.affiliated = false;
                resp.filter(function(selGrp){
                    if(selGrp._id === group._id)
                    {
                      group.client_is_muted = selGrp.client_is_muted==1?true:false;
                        vm.selectedGroups.push(group);
                    }
                })
              });
              var affiliatedGroups = resp.filter(function(subscriberGroup){
                return (!(vm.groups.filter(function(group){
                      return (group._id == subscriberGroup._id)
                })[0]) && (subscriberGroup.type == 1 || subscriberGroup.type == 2))
              })
              if (affiliatedGroups && affiliatedGroups.length > 0){
                getOrganizationsMap()
                .then(function(){
                  var flowFunctionsArray = [];
                  affiliatedGroups.map(function(group){
                    if(group.organization_id != vm.subscriber.organization_id)
                      flowFunctionsArray.push(getAffiliatedGroup(group._id));
                  })
                  $q.all(flowFunctionsArray)
                  .then(function(){
                    deferred.resolve();
                  })
                  .catch(function(err){
                    ExceptionHandler.show(err);
                  });
                })
              }
              else
                deferred.resolve();
            })
        }
        else{
            vm.unselectedGroups = vm.groups;
            deferred.resolve();
        }
        return deferred.promise;
      }

      var fillPersonalContactsList = function(){
        var originSubscriber = {};
        angular.copy(vm.subscriber, originSubscriber)
        var deferred = $q.defer();
        vm.orgSubscribersList = vm.allSubscribers.filter(function(sub){
          return sub._id !== vm.subscriber._id;
        });
        vm.subscriberListMap = vm.allSubscribers.map(function(sub){
          if (sub._id !== vm.subscriber._id) return sub.phone_number;
        });

        if(vm.subscriber._id){
          PersonalContacts.getPersonalList(vm.subscriber._id)
            .then(function(resp){
              for(var i=0;i<resp.length;i++)
              {
                if(resp[i].name){
                  vm.duplicateRespPersonalCon.push(resp[i]);
                }
              }
              resp =vm.duplicateRespPersonalCon;              
              vm.subscriber.personalContacts = resp;
              var subscriberPersonalContactsId = resp.map(function(personalContact){
                return personalContact.contactUserId;
              });

              var affiliatedContactsId = subscriberPersonalContactsId;

              vm.unselectedPersonalContacts = vm.orgSubscribersList.filter(function (personalContact) {
                return subscriberPersonalContactsId.indexOf(personalContact.phone_number) === -1;
              });
              vm.selectedPersonalContacts =vm.subscriber.personalContacts.map(function(contact){
                  if(contact.contactUserId !== vm.subscriber._id)
                  {
                    var index = vm.subscriberListMap.indexOf(contact.contactUserId);
                    contact.phone_number = contact.contactUserId;
                    if (index != -1) contact.affiliated = false;
                    else{
                        contact.affiliated = true;
                        contact.no_icon = false;
                        contact.organization_name = "Affiliated"//vm.organizationsMap[group.organization_id]
                    }
                     return contact;
                  }
              })
              vm.affiliatedContacts = resp.filter(function(personalContact){
                return affiliatedContactsId.indexOf(personalContact.contactUserId) !== -1;
              });
            })
            .catch(function(e){
                vm.unselectedPersonalContacts = vm.orgSubscribersList;
                vm.selectedPersonalContacts = [];
            })
            .finally(function(){
              //when we create a user by cloning, we want to add the one we clone from him to the 'unselected Personal Contacts' of the new user
              if (vm.clone === true) {
                if (!vm.subscriber.personalContacts) vm.subscriber.personalContacts = [];
                vm.subscriber.personalContacts.push(originSubscriber)
                vm.unselectedPersonalContacts.push(originSubscriber)
              }
              deferred.resolve();
            });
        }
        else{
          vm.unselectedPersonalContacts = vm.orgSubscribersList;
          deferred.resolve();
        }
        return deferred.promise;
      }

      vm.showPersonalGroup = vm.configs.filter(function(param){
        return param.name == "PROV_SHOW_PERSONAL_GROUP";
      });

      if (!vm.showPersonalGroup || !vm.showPersonalGroup[0] || vm.showPersonalGroup[0].value == "0" || !vm.allowReadGroups)
        vm.showPersonalGroup = false;
      else{
        vm.showPersonalGroup = true;
      }

      var showSms = vm.configs.filter(function(param){
        return param.name == "PROV_SHOW_SMS";
      });
      if (!showSms || !showSms[0].value || showSms[0].value == "0")
        vm.showSms = false;
      else
        vm.showSms = true;

        vm.showApplicationList = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_APPLICATION_LIST";
        });

        if (!vm.showApplicationList || !vm.showApplicationList[0] || vm.showApplicationList[0].value == "0")
          vm.showApplicationList = false;
        else{
          vm.showApplicationList = true;
        }

        vm.showOcl = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_OCL";
        });

        if (!vm.showOcl || !vm.showOcl[0] || vm.showOcl[0].value == "0" || !vm.allowReadGroups)
          vm.showOcl = false;
        else{
          vm.showOcl = true;
        }

        vm.showChangePassword = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_CHANGE_PASSWORD";
        });
        if (!vm.showChangePassword || !vm.showChangePassword[0].value || vm.showChangePassword[0].value == "0")
          vm.showChangePassword = false;
        else
          vm.showChangePassword = true;

        vm.showIMSI2 = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_IMSI2";
        });
        if (!vm.showIMSI2 || !vm.showIMSI2[0].value || vm.showIMSI2[0].value == "0")
          vm.showIMSI2 = false;
        else
          vm.showIMSI2 = true;

        vm.showMutedSubscriberGrp = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_MUTED_SUBSCRIBER";
        });
        
        if (!vm.showMutedSubscriberGrp || !vm.showMutedSubscriberGrp[0] || vm.showMutedSubscriberGrp[0].value == "0")
          vm.showMutedSubscriberGrp = false;
        else
          vm.showMutedSubscriberGrp = true;

        vm.audioCodecCount = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_AUDIO_CODEC";
        });        
        if (vm.audioCodecCount || vm.audioCodecCount[0])
          vm.audioCodecCount = vm.audioCodecCount[0].value;
        else
          vm.audioCodecCount = '4';

        vm.subscriberNameLimit = vm.configs.filter(function(param){
          return param.name == "PROV_SUBSCRIBER_NAME_LIMIT";
        });        
        if (vm.subscriberNameLimit || vm.subscriberNameLimit[0])
          vm.subscriberNameLimit = vm.subscriberNameLimit[0].value;
        else
          vm.subscriberNameLimit = '12';

        vm.memberCountLimit = vm.configs.filter(function(param){
          return param.name == "PROV_LIMIT_GR_CT_OF_USER";
        });
        vm.memberCountLimit = vm.memberCountLimit[0].value;

        if(subscriber._id){
          vm.subscriber.creation_time = $filter('date')(vm.subscriber.creation_time,'dd/MMM/yy HH:mm:ss') || "Not Available";
          vm.subscriber.change_state_time = $filter('date')(vm.subscriber.change_state_time,'dd/MMM/yy HH:mm:ss') || "Not Available";
          vm.subscriber.last_password_change_timestamp = $filter('date')(vm.subscriber.last_password_change_timestamp,'dd/MMM/yy HH:mm:ss') || "Not Available";

          vm.subscriber.site = vm.subscriber.primary_site_id;

          if(vm.subscriber.sip){
            var sipArray = vm.subscriber.sip.split("@");
            if(isPhoneNumber(sipArray[0])){
              vm.subscriber.username = sipArray[0];
            }
            else{
              vm.subscriber.email = vm.subscriber.sip;
            }
          }
        vm.subscriber.runtime.lastRegistrationTime = $filter('date')(vm.subscriber.runtime.lastRegistrationTime,'dd/MMM/yy HH:mm:ss') || "Not Available";
        }
        var flowFunctionsArray = [];
        flowFunctionsArray.push(getLicenseTemplate());
        flowFunctionsArray.push(getApplicationList());
        flowFunctionsArray.push(getSite());
        flowFunctionsArray.push(getRole());   
        flowFunctionsArray.push(checkOffnetOrnot());   
        flowFunctionsArray.push(showQR());        

        if (vm.allowReadGroups){
          if (typeof vm.organization !== 'undefined') flowFunctionsArray.push(getGroups(vm.organization._id));
          else flowFunctionsArray.push(getGroups(vm.subscriber.organization_id));
        }
        flowFunctionsArray.push(fillPersonalContactsList());

        $q.all(flowFunctionsArray)
        .then(function(){
          $timeout(function () {
            // vm.loading = false;
          }, 1000)
        })
        .catch(function(err){
          ExceptionHandler.show(err);
        });

    }


    function chooseDefaultRadioGroup(){
      if (angular.isDefined(vm.subscriber.default_group_id ) && (vm.subscriber.default_group_id != null)) {
        var defaultRG;
        var dfg;
        defaultRG = vm.unselectedGroups.filter(function(x){
          return x._id === vm.subscriber.default_group_id
        });
        if (angular.isDefined(defaultRG[0])) {
          dfg = defaultRG[0];
          vm.unselectedGroups = vm.unselectedGroups.filter(function(ele) {return ele != dfg});
          vm.selectedGroups= vm.selectedGroups.concat([dfg]);
        }
      }
    }
    function chooseTemplate(templateName){
      vm.subscriber.license = (vm.licenseTemplates.filter(function (template) {
        return template.name == templateName;
      }))[0];
      vm.subscriber.strongDispatchPass = ((vm.subscriber.license && vm.subscriber.license.dispatcher) && vm.organization.strongDispatchPass) ? 1 : 0
      if (vm.subscriber.strongDispatchPass) {
        vm.showPassword()
      }
      //angular.copy(license, vm.subscriber.license);
    }

    function selectAll() {
      vm.selectedGroups = vm.selectedGroups.concat(vm.unselectedGroups);
      vm.unselectedGroups = [];
    }

    function unselectAll() {
      vm.unselectedGroups = vm.unselectedGroups.concat(vm.selectedGroups);
      vm.selectedGroups = [];
    }

    function selectGroup(group) {
      vm.selectedGroups.push(group);
      vm.unselectedGroups = vm.unselectedGroups.filter(function (curGroup) {
        return group.id !== curGroup.id;
      });
    }

    function unselectGroup(group) {
      vm.unselectedGroups.push(group);
      vm.selectedGroups = vm.selectedGroups.filter(function (curGroup) {
        return group.id !== curGroup.id;
      });
    }

    //Helper functions
    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }

    function onTabChanges(index){
      if (!vm.isActionAllowed('license_resource','GET') && index>1)
        index --;
      if (!vm.isActionAllowed('subscriber_resource','GET') && index>0)
        index --;
      if (!vm.isActionAllowed('group_resource','GET') && index>2)
        index -=3;

      // if(!vm.allowReadLicenses){   shahar- remove license
      //     if(index===3 || index===4 || index===5 || index===6){
      //       vm.activeTab = index - 1;
      //     }else{
      //       vm.activeTab = index;
      //     }
      // }else{
      //   vm.activeTab = index;
      // }

      if(index===8 || index=== 7){
        vm.addButtonDisableFlag = false;
      }else{
        vm.addButtonDisableFlag = true;
      }

      if (!vm.showOcl && index>=5)
        index --;

      // }
      vm.activeTab = index;

    }

    function showPassword() {
      vm.changePassword = true;
      vm.subscriber.rePassword = vm.subscriber.password;
    }

    function isPhoneNumber(username) {
      if(username){
        if(username.indexOf("@") !== -1){
          return /^\d+$/.test(username);
        }
        else{
          var usernameArray = username.split("@");
          return /^\d+$/.test(usernameArray[0]);
        }
      }
      else{
        return false;
      }
    }

    function checkDomain(){
      if(vm.organization.domain && vm.subscriber.sip){
        var sip = vm.subscriber.sip.split("@");
        var sipUsername = sip[0];
        var sipDomain = sip[1];

        sipUsername.indexOf("@") !== -1      ? vm.editSubscriberForm.name.$setValidity('atMark', false) : vm.editSubscriberForm.name.$setValidity('atMark', true);
        sipDomain !== vm.organization.domain ? vm.editSubscriberForm.name.$setValidity('domain', false) : vm.editSubscriberForm.name.$setValidity('domain', true);
      }
    }

    function validateUsername(){
      vm.addSubscriberForm.name.$setValidity('domain', true);
      vm.addSubscriberForm.name.$setValidity('atMark', true);

      
       if(vm.subscriber.username){
        if(vm.organization.domain && vm.subscriber.username.length >= vm.organization.domain.length){
          if(vm.subscriber.username.indexOf(vm.organization.domain) !== -1) {
            vm.addSubscriberForm.name.$setValidity('domain', false);
            return false;
          }
        }
        if(vm.subscriber.username.indexOf("@") !== -1) {
          vm.addSubscriberForm.name.$setValidity('atMark', false);
          return false;
        }
       }
       return true;
    }

    function generateSip(){
      if(vm.subscriber.username)
      {
        if(validateUsername(vm.subscriber.username)){
          vm.subscriber.sip = vm.subscriber.username.replace(/ /g,"_") + "@";
          if(vm.organization.domain){
            vm.subscriber.sip += vm.organization.domain;
          }
        }
        else{
          vm.subscriber.sip = null;
        }
  
        !isPhoneNumber(vm.subscriber.username) ? vm.subscriber.country = 2 : vm.subscriber.country = null;
      }
    }

    function openSMSdialog(subs) {
      var curSubscriber = {};
      angular.copy(subs, curSubscriber);
      $mdDialog.show({
        controller: 'SubscriberSendSmsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/subscribers/sms/subscriber.send.sms.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        skipHide: true,
        locals: {
          subscriber: curSubscriber,
          server: 0
        }
      }).then(function () {
    })
    }

    function showRole(roleId) {

      var currentRole = vm.rolesList.filter(function(role){
        return role._id === roleId;
      });

      var curRole = currentRole[0];

        $mdDialog.show({
          controller: 'roleDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/restricted/administration/roles/dialog/permList.tmpl.html',
          parent: angular.element(document.body),
          clickOutsideToClose:false,
          multiple: true,
          fullscreen: false,
          locals: {
            currentRole: curRole,
            currentProvPerm: null,
            LoginUserRoleId: null,
            editIsAdmin: false,
            edit: false,
            showCostPermissions: false,
            showSecurityMonitoring: null,
            rolePermissions: {},
            audioCodec: vm.audioCodecCount
          }
        })

    }

    //General controls
    function cancel() {
      $mdDialog.cancel();
    }

    function ok() {
      vm.flagSave = false;
      vm.affliLinse = false;
      vm.subscriber.name = vm.subscriber.name.trim();
      vm.subscriber.sip = vm.subscriber.sip.trim();
      if(!vm.subscriber.primary_site_id)
              vm.subscriber.primary_site_id = vm.organization.primary_site_id;

      if(!vm.subscriber.secondary_site_id)
      {
        if(vm.organization.site)
            vm.subscriber.secondary_site_id = vm.organization.site;
        else if(vm.organization.primary_site_id)
          vm.subscriber.secondary_site_id = vm.organization.primary_site_id;
        else if(vm.subscriber.primary_site_id)
          vm.subscriber.secondary_site_id = vm.subscriber.primary_site_id;
        else
        vm.subscriber.secondary_site_id = vm.subscriber.site;
      }
              

      //vm.saveButton.disabled(true);
      if (vm.subscriber.sip === vm.organization.domain)
        vm.subscriber.sip = undefined;

      if(vm.subscriber.license.startOffNet)
      {
            vm.affliLinse = true;
      }

      vm.subscriber.application_id = vm.subscriber.application_id || null;

      vm.subscriber.name = vm.subscriber.name.trim();
      if(vm.subscriber.username) vm.subscriber.username = vm.subscriber.username.trim();
      // vm.loading = true;
      if(vm.allowUpdateGroups) {
        var orgGroups = vm.selectedGroups.map(function (group) {
          if(vm.affliLinse)
          {
            return group._id;
          }
          else
          {
            if(!group.cross_fleet)
              return group._id;
          }          
        });
        vm.subscriber.groups = orgGroups.filter(function (group){
            if(group != undefined)
              return group
        });
         if (vm.subscriber.default_group_id && vm.subscriber.groups.indexOf(vm.subscriber.default_group_id) === -1) {
           vm.subscriber.groups.push(vm.subscriber.default_group_id);
         }
        if (vm.showOcl){
          var orgContacts = vm.selectedContacts.map(function (contact) {
            if(vm.affliLinse)
            {
              return contact._id;
            }
            else
            {
              if(!contact.cross_fleet)
                return contact._id;
            }    
          });
          vm.subscriber.orgContacts = orgContacts.filter(function (contact){
              if(contact != undefined)
                return contact
          });
        }
        var contactstempId = vm.selectedSubscriberLists.map(function (contact) {
           if(vm.affliLinse)
            {
              return contact._id;
            }
            else
            {
              if(!contact.cross_fleet)
                return contact._id;
            } 
        });
        setTimeout(function() {
          vm.subscriber.contacts= contactstempId.filter(function (contact){
              if(contact != undefined)
                return contact
          });
          // vm.subscriber.contacts =  vm.subscriber.contacts.concat(orgContemp);
        }, 400);
        vm.subscriber.mutedMembers=[];
        vm.subscriber.groups.map(function(element){
          vm.selectedGroups.filter(function(muted){
              if(muted._id == element)
              {
                var index = vm.selectedGroups.indexOf(muted);
                if(vm.selectedGroups[index].client_is_muted)
                vm.subscriber.mutedMembers.push(vm.selectedGroups[index].client_is_muted == true?1:0);
                else
                vm.subscriber.mutedMembers.push(0);
              }
          })
        });
      }
      
      vm.subscriber.personalContacts = vm.selectedPersonalContacts.map(function(subscriber){
        if(!vm.affliLinse)
        {
          if(subscriber.organization_name == 'Affiliated')
          {
            return null;
          }
          else
          {
            return {
              ownerUserId: vm.subscriber._id,
              contactUserId: subscriber.phone_number,
              name: subscriber.name
            }
          }

        }
        else{
          return {
            ownerUserId: vm.subscriber._id,
            contactUserId: subscriber.phone_number,
            name: subscriber.name
          }
        }
        
       
      });
      if (vm.showPersonalGroup && vm.subscriber.emergencyGroup){
        vm.subscriber.emergencyGroup = {
          _id: vm.subscriber.emergencyGroup._id
        };
      }
      vm.subscriber.permissions_mask = vm.subscriber.license.mask;
      // vm.subscriber.personalGroupContacts = vm.selectedPersonalGroupContacts.map(function(contact){
      //   return contact.phone_number;
      // });

      //Set active state to false for new subscribers
      if(!vm.subscriber._id) vm.subscriber.admin_state = 1;
      //Set phone
      if(!vm.subscriber._id || clone){
          isPhoneNumber(vm.subscriber.username) ? vm.subscriber.phone_number = vm.subscriber.username : vm.subscriber.phone_number = "0";
          isPhoneNumber(vm.subscriber.username) ? vm.subscriber.email = null : vm.subscriber.email = vm.subscriber.sip;
      }

      if(vm.subscriber.sip && vm.subscriber.name){
        if (vm.subscriber.license.dispatcher && vm.rolesList){
            var currentRole = vm.rolesList.filter(function(role){
              return role._id == vm.subscriber.adminrole_id;
            })[0];

            if (currentRole.permissions){
              var dispatcher_permissions = currentRole.permissions.filter(function(perm){
                  return perm.console_type == 3;
              });

              if (dispatcher_permissions.length == 0)
                display_warning_msg();
              else
                save_subscriber();
            }
            else
                save_subscriber();
        }
        else{
          save_subscriber();
        }
      }
      else
      vm.flagSave = true;
    }

    function save_subscriber(){
      if(vm.subscriber._id && !clone){

        setTimeout(function(){
          Subscriber.update(vm.subscriber)
          .then(function() {
            $mdDialog.hide(vm.subscriber);
          })
            .catch(function(e){
              vm.flagSave = true;
              // vm.loading = false;
              ExceptionHandler.show(e);

            })
        }, 1000);

      }
      else if (clone)
      {
        vm.subscriber._id = undefined;
        vm.subscriber.two_factor_secret = null;
        Subscriber.add(vm.subscriber)
          .then(function (resp) {
              $mdDialog.hide(vm.subscriber);
          })
          .catch(function(e){
            vm.flagSave = true;
            // vm.loading = false;
            ExceptionHandler.show(e);
          })
      }
      else{
        vm.subscriber.two_factor_secret = null;
        Subscriber.add(subscriber)
          .then(function (resp) {
              $mdDialog.hide(vm.subscriber);
          })
          .catch(function(e){
            vm.flagSave = true;
            // vm.loading = false;
            ExceptionHandler.show(e);
          })
      }
    }

    function display_warning_msg(){
      var confirm = Toast.getAddDispatcherUser();
      $mdDialog.show(confirm)
        .then(function () {
          save_subscriber();
        })
        .catch(function(){
          // vm.loading = false;
          vm.flagSave = true;
        })
    }
    function getLicenseData(){
      License.getLicenseTemplates()
      .then(function(resp){
        for(var i=0;i<resp.length;i++)
          {
            var tempWord =resp[i].name;
            var checkString = 'OffNet';
              if(tempWord.indexOf(checkString) != -1)
                vm.licensesTemplate.push(resp[i].mask);
          }
        vm.showLoader = false ;
      })
      .catch(function(err){
        vm.showLoader = false ;
      });
    }

    function sort(param) {
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
    }


    function enableTwoFactor(flag){
      Subscriber.enbleAuthentication(vm.subscriber._id,flag).then(function (resp) {
          vm.subscriber.two_factor_secret = resp.two_factor;
          showQR();
          if(flag == 0)
              Toast.showCustom($translate.instant("APP_QR_DISABLE_SUCCESS"))
          else if(flag == 1)
              Toast.showCustom($translate.instant("APP_QR_ENABLE_SUCCESS"))
          else if(flag == 2)
              Toast.showCustom($translate.instant("APP_QR_REGENERATE_SUCCESS"))
      }).catch(function(e){
        vm.flagSave = true;
        ExceptionHandler.show(e);
      })
    }
    /**
     * gets css-class to show icon near column header
     */
     function getSortingClass(param) {
      return vm.reverse[param] ? "up" : "down";
    }
    function setRecordsCount() {
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    function showApplication(applicationId) {

      var currentApplication = vm.applicationLists.filter(function(application){
        return application._id === applicationId;
      });
      var applicationList = currentApplication[0];
      var applications ={};
      ApplicationList.getApplicationsByOrg(vm.organization._id).then(function(applications){
        applications.list = (applications && applications.white_list) ? applications.white_list : [];
        applications.newList = angular.copy(applications.list);
        $mdDialog.show({
          controller: 'ApplicationListsDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/restricted/organization/application-lists/tabs/dialogs/application.lists.dialog.html',
          parent: angular.element(document.body),
          clickOutsideToClose:false,
          multiple: true,
          fullscreen: true,
          locals: {
            applicationList: applicationList,
            applications: applications,
            organizationId: vm.organization._id,
            application: {},
            clone: false,
            edit: false,
            editData: false,
            action: false
          }
        })
      })
      .catch(function(e){
        if(e.status !== 404){ ExceptionHandler.show(e) }
      });
    }

    function generateQrCode(flag){
      if(flag == 2)
      {
        var confirm = Toast.regenerateQr();
        $mdDialog.show(confirm)
        .then(function () {
          enableTwoFactor(2);
        })
        .catch(function(){
          vm.flagSave = true;
        })
      }
      if(flag == 0)
      {
        var confirm = Toast.disableQr();
        $mdDialog.show(confirm)
        .then(function () {
          enableTwoFactor(0);
        })
        .catch(function(){
          vm.flagSave = true;
        })
      }
    }
    function showQR(){
      if(vm.subscriber.two_factor_secret)
      {
        var byteArray = new Uint8Array(vm.subscriber.two_factor_secret.data);
        var hexArray = [];
        for (var i = 0; i < byteArray.length; i++) {
          var hexByte = byteArray[i].toString(16);
          if (hexByte.length < 2) hexByte = '0' + hexByte; // manual padStart
          hexArray.push(hexByte);
        }
        var hex = hexArray.join('');
        var byteString = hexToBase32(hex);
        generateQrs(byteString);
      }
    }
    function hexToBase32(hex) {
        var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
        var bytes = [];
        var hexPairs = hex.match(/.{1,2}/g);
        for (var i = 0; i < hexPairs.length; i++) {
          bytes.push(parseInt(hexPairs[i], 16));
        }
        var bits = '';
        for (var j = 0; j < bytes.length; j++) {
          var bin = bytes[j].toString(2);
          while (bin.length < 8) bin = '0' + bin; // manual padStart
          bits += bin;
        }
        var base32 = '';
        for (var k = 0; k < bits.length; k += 5) {
          var chunk = bits.substring(k, k + 5);
          while (chunk.length < 5) chunk += '0'; // padEnd for last chunk
          base32 += alphabet[parseInt(chunk, 2)];
        }
        return base32;
    }
     function generateQrs(userData){
      var deferred = $q.defer();
       var element = document.getElementById("authQrCode");
        if (element) {
          element.innerHTML = "";
        }
      setTimeout(function () {
          new QRCode(document.getElementById("authQrCode"), {
            text: 'otpauth://totp/MobileTornado?secret='+userData,
            width: 400,
            height: 400
          });
          document.getElementById("authQrCode").removeAttribute("title");
          deferred.resolve();
      }, 100);
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.subscribers')
    .controller('subscriberListDialogController', subscriberListDialogController);

  /** @ngInject*/
  function subscriberListDialogController($mdDialog, subscriberList, organizationId, Subscriber, Group, Auth, ExceptionHandler) {
    var vm = this;
    vm.flagSave = true;
    vm.allowCreate = Auth.isActionAllowed('group_resource','POST');
    vm.allowModify = Auth.isActionAllowed('group_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('group_resource','DELETE');

    vm.allowReadSubscribers = Auth.isActionAllowed('subscriber_resource','GET');
    // vm.loading = true ;
    vm.unselectedMembers = [];
    vm.selectedMembers = [];
    // vm.loading = true;
    this.subscriberList = subscriberList;
    this.organizationId = organizationId;
    this.cancel = cancel;
    this.ok = ok;

    prepareMembers();

    //-------------------------------------------------------------------

    function prepareMembers() {
      Subscriber.getListByOrganization(vm.organizationId)
        .then(function (resp) {
          vm.subscriberLists = resp;
          if(vm.subscriberList._id){
            Subscriber.getListByGroup(vm.subscriberList._id)
              .then(function(resp){
                vm.subscriberList.subscribers = resp.map(function(subscriber){
                  return subscriber._id;
                });
                filterMember();
              })
          }
          else{
            vm.unselectedMembers = vm.subscriberLists;
          }
        })
        .catch(function(e){
          if(e.status !== 404){ ExceptionHandler.show(e) }
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function filterMember(){
      vm.selectedMembers = vm.subscriberLists.filter(function (subscriberList) {
        return vm.subscriberList.subscribers.indexOf(subscriberList._id) !== -1;
      });

      vm.unselectedMembers = vm.subscriberLists.filter(function (subscriberList) {
        return vm.subscriberList.subscribers.indexOf(subscriberList._id) === -1;
      });
    }

    function addGroup(){
      var subscriberListSubscribers = vm.subscriberList.subscribers;
      // vm.loading = true;
      Group.add(subscriberList)
        .then(function () {
          //get list of all group to get the Proper Id of it
          Group.getSubscriberListsByOrgId(vm.organizationId)
            .then(function (resp) {
              var curSubscriberList = resp[resp.length-1];
              curSubscriberList.subscribers = subscriberListSubscribers;
              curSubscriberList.site = curSubscriberList.current_site_id;
              //Update with subscribers
              Group.update(curSubscriberList)
                .then(function(){
                  $mdDialog.hide();
                })
                .catch(function(e){
                  vm.flagSave = true;
                  ExceptionHandler.show(e);
                })
            })
            .catch(function(e){
              vm.flagSave = true;
              ExceptionHandler.show(e);
            })
        })
        .catch(function(e){
          vm.flagSave = true;
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function updateGroup(){
      // vm.loading = true;
      Group.update(vm.subscriberList)
        .then(function () {
          $mdDialog.hide();
        })
        .catch(function(e){
          vm.flagSave = true;
          ExceptionHandler.show(e);
        })
        .finally(function(){
        // vm.loading = false;
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function ok() {
      vm.flagSave = false;
      vm.subscriberList.subscribers = vm.selectedMembers.map(function (member) {
        return member._id
      });

      vm.subscriberList._id ? updateGroup() : addGroup();

    }

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.locationHistory', ['datatables'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider, msApiProvider) {
    $stateProvider.state('app.restricted.locationHistory', {
      url: '/locationHistory',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/locationHistory/locationHistory.html',
          controller: 'locationHistoryController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('organization_resource','GET')
        }
      }
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/restricted/organization/subscribers');

    //msApiProvider.register('subscribers', ['app/main/restricted/organization/subscribers/data/subscribers.json']);

    // Navigation
    msNavigationServiceProvider.saveItem('Organization.locationHistory', {
      title: 'locationHistory',
      icon: '',
      state: 'app.restricted.locationHistory',
      translate: 'NAVIGATION_LOCATION_HISTORY',
      weight: 6
    });
  }

})();

(function () {
  'use strict';
  angular.module('app.restricted.locationHistory')
    .controller('locationHistoryDialogController', locationHistoryDialogController);

  /** @ngInject*/
  function locationHistoryDialogController(session, localStorageService, $mdDialog, $filter) {


    var vm = this;
    vm.sessionData = session
    vm.loading = true;
    vm.search = '';
    vm.cancel = cancel;

    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCountDialog = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];
        
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    
     /**'
     * sort session list
     */
    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCountDialog);
     }
 
     /**
      * sort session list
      */
     function sort(param){
       vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
       vm.sessions = orderByFilter(vm.sessions,param,vm.reverse[param])
     }
     /**
      * gets css-class to show icon near column header
      */
     function getSortingClass(param){
       return vm.reverse[param] ? "up" : "down";
     }

     function cancel() {
      $mdDialog.cancel();
    }
 

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.groups', ['ngMessages'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider, msApiProvider) {
    $stateProvider.state('app.restricted.groups', {
      url: '/groups',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/groups/groups.html',
          controller: 'GroupsController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('group_resource','GET');
        }
      }
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/restricted/organization/groups');

    //msApiProvider.register('groups', ['app/main/restricted/organization/groups/data/groups.json']);

    // Navigation
    msNavigationServiceProvider.saveItem('Organization.groups', {
      title: 'Groups',
      icon: '',
      state: 'app.restricted.groups',
      translate: "NAVIGATION_GROUPS",
      weight: 6
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.groups')
    .controller('groupsDetailsController', groupsDetailsController);

  function groupsDetailsController($mdDialog, $mdToast, ExceptionHandler, group, showEmergencyGroup, showMutedSubscriberGrp, groupNameLimit, organizationId, organization, Site, Group, Subscriber, Auth, crossFleet, OrgFriends, $q, $translate, License,Fwrdgroup) {


    var vm = this;
    vm.flagSave = true;
    vm.readyToSave = true;
    this.group = group;
    this.organizationId = organizationId;
    this.organization = organization;
    this.selectedMembers = [];
    this.unselectedMembers = [];
    this.sites = [];
    this.showEmergencyGroup = showEmergencyGroup;
    this.showMutedSubscriberGrp = showMutedSubscriberGrp;
    this.groupNameLimit = groupNameLimit?groupNameLimit:12;
    this.crossFleet = crossFleet;
    this.licensesTemplate = [];
    this.unselectedMembersNew = [];
    this.allLicensesTemplate = [];
    vm.selectedMutedMembers = [];
    vm.selectedMutedMembers_id = [];
    vm.unselectedMutedMembers_id = [];
    vm.emergencyMember = (group && group.type == 9 )? 50:null;
    //this.notSelectedSubscribers = subscribers;
    this.groupTypes = Group.getGroupTypes();

    if (vm.crossFleet){
      var contactTypes = Group.getContactTypes();
      this.groupTypes.push(contactTypes.find(function(type){
        return (type.id == "8");
      }))
    }

    vm.affiliatedGroupSubscribersPagination = "affiliatedGroupSubscribers"
    vm.allowCreate = Auth.isActionAllowed('group_resource', 'POST');
    vm.allowModify = Auth.isActionAllowed('group_resource', 'PUT');
    vm.allowDelete = Auth.isActionAllowed('group_resource', 'DELETE');

    vm.allowReadSubscribers = Auth.isActionAllowed('subscriber_resource', 'GET');

    this.cancel = cancel;
    this.transferSubToMute = transferSubToMute;
    this.ok = ok;
    this.resetDate = resetDate;
    this.checkGroupType = checkGroupType;
    this.changeDropValue = changeDropValue;
    this.getAllGroupList = getAllGroupList;

    // vm.loading = true;

    vm.now = new Date();

    prepareMembers();
    selectDefaultSite();
    getLicenseData();
    getAllGroupList();
    //-------------------------------------------------------------------

    function prepareMembers() {
      //fix the select group type issue
      if (vm.group.type)
        vm.group.type = vm.group.type.toString();
      else if (!vm.group._id)
        vm.group.type = 2;  //default type

      vm.group.memberType = '1';
      Site.getList()
        .then(function (resp) {
          vm.sites = resp;
        })
        .catch(function (err) {
        });
    
      if (!crossFleet && !vm.group.cross_fleet) {
        Subscriber.getSubscriberDataByOrg(vm.organizationId)
          .then(function (resp) {
            vm.members = resp;
            if (vm.group._id) {
              if(vm.group.type == '10')
              {
                Fwrdgroup.getUserIds(vm.group._id)
                .then(function (result) {
                    vm.group.registersUser = result.map(function (subscriber) {
                      return subscriber._id;
                    });
                    filterMember();
                })
                .catch(function (e) {
                  if (e.status !== 404) { ExceptionHandler.show(e) }
                  else{
                    // vm.loading = false;
                  }
                })
                .finally(function () {
                  // vm.loading = false;
                });
                // vm.loading = false;
              }
              Subscriber.getListByFilterGroup(vm.group._id)
                .then(function (resp) {
                  vm.group.subscribers = resp.map(function (subscriber) {
                    return subscriber._id;
                  });
                  resp.map(function(member){
                    if(member.client_is_muted === 1)
                    {
                      vm.selectedMutedMembers_id.push(member._id)
                    }
                    else{
                      vm.unselectedMutedMembers_id.push(member._id)
                    }
                  })
                  filterMember();
                })
                .finally(function () {
                  // vm.loading = false;
                });
            }
            else {
              vm.unselectedMembers = vm.members;
              // vm.loading = false;
              vm.readyToSave = false;
            }
          })
          .catch(function (e) {
            if (e.status !== 404) { ExceptionHandler.show(e) }
          });
      }
      else {
        OrgFriends.getByOrgId(vm.organizationId)
          .then(function (resp) {
            vm.orgsFriends = resp;
            vm.orgsFriends.push(vm.organization)
            vm.selectedDropDown = vm.orgsFriends[vm.orgsFriends.length - 1]._id;
            var flowFunctionsArray = [];
            vm.members = [];
            vm.orgFriendsMap = [];
            vm.orgsFriends.map(function (org) {
              vm.orgFriendsMap[org._id] = org.name;
              flowFunctionsArray.push(getSubscribersByOrg(org._id));
            });

            $q.all(flowFunctionsArray)
              .then(function () {
                if (vm.group._id) {
                  if(vm.group.type == '10')
                  {
                    Fwrdgroup.getUserIds(vm.group._id)
                    .then(function (result) {
                        vm.group.registersUser = result.map(function (subscriber) {
                          return subscriber._id;
                        });
                        filterMember();
                    })
                    .catch(function (e) {
                      if (e.status !== 404) { ExceptionHandler.show(e) }
                      else{
                        // vm.loading = false;
                      }
                    })
                    .finally(function () {
                      // vm.loading = false;
                    });
                    // vm.loading = false;
                  }
                  Subscriber.getListByFilterGroup(vm.group._id)
                    .then(function (resp) {
                      vm.group.subscribers = resp.map(function (subscriber) {
                        return subscriber._id;
                      });
                      resp.map(function(member){
                        if(member.client_is_muted === 1)
                        {
                          vm.selectedMutedMembers_id.push(member._id)
                        }
                        else{
                          vm.unselectedMutedMembers_id.push(member._id)
                        }
                      })
                      filterMember();
                    })
                }
                else {
                  vm.unselectedMembers = vm.members;
                  vm.readyToSave = false;
                }
              })
              .catch(function (err) {
                ExceptionHandler.show(err);
              })
              .finally(function () {
                // vm.loading = false;
              });
          })
          .catch(function (e) {
            if (e.status !== 404) { ExceptionHandler.show(e) }
          });
      }
    }

    function getSubscribersByOrg(orgId) {
      return new Promise(function(resolve, reject){
        var PERMISSION_MASK_OFF_NET = 0x08;
        Subscriber.getSubscriberDataByOrg(orgId)
          .then(function (resp) {
            vm.members[orgId] = resp.map(function(member){
              if (Boolean(member.permissions_mask & PERMISSION_MASK_OFF_NET)) member.offnet = true;
              return member;
            })
            resolve();
          })
          .catch(function (e) {
            if (e.status !== 404) reject(e);
            else resolve();
          })
      });
    }

    function resetDate() {
      vm.group.expiry_date = undefined;
    }
    function checkGroupType(){
      if(vm.group.type == 9)
        vm.emergencyMember = 50;
      else
        vm.emergencyMember = null;

      if(vm.group.type == 8)
        vm.group.expiry_date = null
    }
    function selectDefaultSite() {
      if (vm.group.primary_site_id) {
        vm.group.site = vm.group.primary_site_id;
      }
      else if (vm.sites && vm.sites.length == 1) {
        vm.group.site = parseInt(vm.sites[0].id);
      }
    }

    function filterMember() {
      vm.totalSubscriber = vm.group.subscribers;
      vm.totalSubscriber = vm.totalSubscriber.concat(vm.group.registersUser);

      if (!vm.crossFleet && !vm.group.cross_fleet) {
        vm.selectedMembers = vm.members.filter(function (member) {
          return vm.group.subscribers.indexOf(member._id) !== -1;
        });
        vm.unselectedMembers = vm.members.filter(function (member) {
          return vm.totalSubscriber.indexOf(member._id) === -1;
        });
        vm.selectedMutedMembers = vm.members.filter(function (member) {
          return vm.selectedMutedMembers_id.indexOf(member._id) !== -1;
        });
        vm.unselectedMutedMembers = vm.members.filter(function (member) {
          return vm.unselectedMutedMembers_id.indexOf(member._id) !== -1;
        });
        if(vm.group.registersUser)
        {
          vm.selectedRegisterMembers = vm.members.filter(function (member) {
            return vm.group.registersUser.indexOf(member._id) !== -1;
          });
        }
        vm.readyToSave = false;
      }
      else {
        vm.selectedMembers = [], vm.unselectedMutedMembers = [], vm.tempUnselectedMembers = [], vm.unselectedMembers = [], vm.selectedMutedMembers = [],vm.unselectedMutedMembers = [], vm.selectedRegisterMembers=[];
                
        for (var i in vm.members){
          var members = vm.members[i].filter(function (member) {
            member.organization_name = (member.organization_id == vm.organization._id) ? $translate.instant("OWN") : vm.orgFriendsMap[member.organization_id];
            member.no_icon = (member.organization_id == vm.organization._id) ? false : true;
            return vm.group.subscribers.indexOf(member._id) !== -1;
          });
          vm.selectedMembers = vm.selectedMembers.concat(members);          
          var smMembers = vm.members[i].filter(function (member) {
            return vm.selectedMutedMembers_id.indexOf(member._id) !== -1;
          });
          vm.selectedMutedMembers = vm.selectedMutedMembers.concat(smMembers);
          var usMMembers = vm.members[i].filter(function (member) {
            return vm.unselectedMutedMembers_id.indexOf(member._id) !== -1;
          });
          vm.unselectedMutedMembers = vm.unselectedMutedMembers.concat(usMMembers);
          if(vm.group.registersUser)
          {
            var membersReg = vm.members[i].filter(function (member) {
              member.organization_name = (member.organization_id == vm.organization._id) ? $translate.instant("OWN") : vm.orgFriendsMap[member.organization_id];
              member.no_icon = (member.organization_id == vm.organization._id) ? false : true;
              return vm.group.registersUser.indexOf(member._id) !== -1;
            });
            vm.selectedRegisterMembers = vm.selectedRegisterMembers.concat(membersReg);
          }

          if (vm.crossFleet){
            vm.unselectedMembers[i] = vm.members[i].filter(function (member) {
              member.organization_name = (member.organization_id == vm.organization._id) ? $translate.instant("OWN") : vm.orgFriendsMap[member.organization_id];;
              return vm.totalSubscriber.indexOf(member._id) === -1;
            });
            vm.unselectedMutedMembers[i] = vm.members[i].filter(function (member) {
              member.organization_name = (member.organization_id == vm.organization._id) ? $translate.instant("OWN") : vm.orgFriendsMap[member.organization_id];;
              return vm.unselectedMutedMembers_id.indexOf(member._id) !== -1;
            });
          }
        } 
        if (!vm.crossFleet){
          vm.tempUnselectedMembers = vm.members[vm.organization._id].filter(function (member) {
            member.organization_name = $translate.instant("OWN");
            member.no_icon = false;
            return vm.totalSubscriber.indexOf(member._id) === -1;
          });
        }
        
        vm.customLicense=[];
        if(typeof(vm.unselectedMembers[vm.organizationId]) == "undefined")
        {
          vm.tempUnselectedMembers.forEach(function(element) {
            if(!vm.allLicensesTemplate.includes(element.permissions_mask))
              {
                if(!vm.customLicense.includes(element.permissions_mask))
                {
                  vm.customLicense.push(element.permissions_mask);
                }
              }
            var flag=0;
            for(var j=0; j<vm.licensesTemplate.length; j++){
              if(vm.licensesTemplate[j] == element.permissions_mask)
                  flag=1;
            }
            if(flag ==1)
              vm.unselectedMembersNew.push(element);
          });

          vm.customLicense.forEach(function(element){
            if(element)
            {
              Subscriber.licenseIsOffNet(element).then(function(resp){
                for(var p=0;p<vm.unselectedMembers.length;p++)
                {
                  if((resp.mask == vm.unselectedMembers[p].permissions_mask) && resp.result == true)
                  {
                    vm.unselectedMembersNew.push(vm.unselectedMembers[p]);
                  }
                }
              });
            }
          });          
          vm.unselectedMembers = vm.unselectedMembersNew;
        } 
        vm.readyToSave = false;
      }  
      
      // if(vm.unselectedMembers[0])
      // {
       
      // }
      // else {
        // for (var i in vm.unselectedMembers)
        // {
        //   var unMember = vm.unselectedMembers[i].filter(function (member) {
        //     return vm.licensesTemplate.indexOf(member.permissions_mask) !== -1;
        //   });
        //   vm.unselectedMembersNew = vm.unselectedMembersNew.concat(unMember); 
        // }
        // vm.unselectedMembers = vm.unselectedMembersNew;
        // console.log(vm.unselectedMembers)
      // }
     
    }
    function addGroup() {
      // vm.loading = true;
      if (vm.crossFleet) vm.group.cross_fleet = 1;
      if(vm.group.type == '10')
      {
        Fwrdgroup.add(vm.group).then(function () {
          $mdDialog.hide();
        })
        .catch(function (e) {
          vm.flagSave = true;
          ExceptionHandler.show(e);
        })
        .finally(function () {
          // vm.loading = false;
        });
      }
      else
      {
        Group.add(vm.group).then(function () {
          $mdDialog.hide();
        })
        .catch(function (e) {
          vm.flagSave = true;
          ExceptionHandler.show(e);
        })
        .finally(function () {
          // vm.loading = false;
        });
      }
    }

    function updateGroup() {
      // vm.loading = true;
      if (vm.crossFleet) vm.group.cross_fleet = 1;
      if(vm.group.type == '10')
      {
        Fwrdgroup.update(vm.group)
        .then(function () {
          // vm.loading = false;
          $mdDialog.hide();
        })
        .catch(function (e) {
          vm.flagSave = true;
          // vm.loading = false;
          ExceptionHandler.show(e);
        })
      }
      else
      {
        Group.update(vm.group)
        .then(function () {
          // vm.loading = false;
          $mdDialog.hide();
        })
        .catch(function (e) {
          vm.flagSave = true;
          // vm.loading = false;
          ExceptionHandler.show(e);
        })
      }
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function ok() {
      vm.flagSave = false;
      group.name = group.name.trim();
      vm.group.organization = vm.organizationId;
      vm.group.organization_id = vm.organizationId;
      if(!group.name)
      {
        vm.flagSave = true;
        return false;
      }

      if(!vm.group.primary_site_id)
            vm.group.primary_site_id = vm.group.site;

      if(!vm.group.secondary_site_id)
      {
        if(vm.organization.secondary_site_id)
            vm.group.secondary_site_id = vm.organization.secondary_site_id;
        else if(vm.organization.site)
            vm.group.secondary_site_id = vm.organization.site;
        else
            vm.group.secondary_site_id = vm.group.site;
      }
      if(vm.group.type == '10')
      {
        vm.group.registersUser = vm.selectedRegisterMembers.map(function (member) {
          return member._id
        });
      }
      vm.group.subscribers = vm.selectedMembers.map(function (member) {
        return member._id
      });
      vm.mutedMembers = vm.selectedMutedMembers.map(function (member) {
        return member._id
      });
      vm.group.mutedSubscribers=[];
      vm.group.mutedSubscribers = vm.selectedMembers.map(function (member) {
        if(vm.mutedMembers.indexOf(member._id) !== -1)
          return 1;
        else
          return 0;
      });

      if (vm.group.expiry_date) {
        vm.group.expiry_date = new Date(new Date(vm.group.expiry_date).setHours(23,59,59,0));
        //var offset = new Date().getTimezoneOffset();
        //vm.group.expiry_date.setHours(0 + (offset / 60));
      }

      vm.group._id ? updateGroup() : addGroup();
    }
    function transferSubToMute(){
      console.log('text');
    }
    function getLicenseData(){
      License.getLicenseTemplates()
      .then(function(resp){
        for(var i=0;i<resp.length;i++)
          {
            var tempWord =resp[i].name;
            vm.allLicensesTemplate.push(resp[i].mask);
            var checkString = 'OffNet';
              if(tempWord.indexOf(checkString) != -1)
                vm.licensesTemplate.push(resp[i].mask);
          }
        vm.showLoader = false ;
      })
      .catch(function(err){
        vm.showLoader = false ;
      });
    }
    function changeDropValue(){
      if(vm.group.type != 10)
      {
        if(vm.selectedRegisterMembers)
        {
          vm.unselectedMembers = vm.unselectedMembers.concat(vm.selectedRegisterMembers);
          vm.selectedRegisterMembers=[];
        }
      }
    }

    function getAllGroupList(){
      Group.getAllGroupList(vm.organizationId).then(function(resp){
        vm.grpList = resp;
        // console.log(vm.grpList)
      })
      .catch(function (e) {
        ExceptionHandler.show(e);
      })
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.subscribers')
    .controller('emergencyGroupDialogController', emergencyGroupDialogController);

  /** @ngInject*/
  function emergencyGroupDialogController($mdDialog, emergencyGroup, organizationId, Subscriber, Group, Auth, ExceptionHandler) {
    var vm = this;
    vm.flagSave = true;
    vm.allowCreate = Auth.isActionAllowed('group_resource','POST');
    vm.allowModify = Auth.isActionAllowed('group_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('group_resource','DELETE');

    vm.allowReadSubscribers = Auth.isActionAllowed('subscriber_resource','GET');
    // vm.loading = true ;
    vm.unselectedMembers = [];
    vm.selectedMembers = [];
    // vm.loading = true;
    this.emergencyGroup = emergencyGroup;
    this.organizationId = organizationId;
    this.cancel = cancel;
    this.ok = ok;

    prepareMembers();


    //-------------------------------------------------------------------

    function prepareMembers() {   
      Subscriber.getListByOrganization(vm.organizationId)
        .then(function (resp) {
          vm.emergencyGroups = resp;
          if(vm.emergencyGroup._id){
            Subscriber.getListByGroup(vm.emergencyGroup._id)
              .then(function(resp){
                vm.emergencyGroup.subscribers = resp.map(function(subscriber){
                  return subscriber._id;
                });
                filterMember();
              })
          }
          else{
            vm.unselectedMembers = vm.emergencyGroups;
          }
        })
        .catch(function(e){
          if(e.status !== 404){ ExceptionHandler.show(e) }
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function filterMember(){
      vm.selectedMembers = vm.emergencyGroups.filter(function (emergencyGroup) {
        return vm.emergencyGroup.subscribers.indexOf(emergencyGroup._id) !== -1;
      });

      vm.unselectedMembers = vm.emergencyGroups.filter(function (emergencyGroup) {
        return vm.emergencyGroup.subscribers.indexOf(emergencyGroup._id) === -1;
      });
    }

    function addGroup(){
      // vm.loading = true;
      Group.add(emergencyGroup)
        .then(function () {
          $mdDialog.hide();
        })
        .catch(function(e){
          vm.flagSave = true;
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function updateGroup(){
      // vm.loading = true;
      Group.update(vm.emergencyGroup)
        .then(function () {
          $mdDialog.hide();
        })
        .catch(function(e){
          vm.flagSave = true;
          ExceptionHandler.show(e);
        })
        .finally(function(){
        // vm.loading = false;
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function ok() {
      vm.flagSave = false;
      vm.emergencyGroup.subscribers = vm.selectedMembers.map(function (member) {
        return member._id
      });

      vm.emergencyGroup._id ? updateGroup() : addGroup();

    }

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.subscribers')
    .controller('contactDialogController', contactDialogController);

  /** @ngInject*/
  function contactDialogController($mdDialog, contact, showOCL, groupNameLimit, organizationId, Subscriber, Group, Auth, ExceptionHandler, License, OrgFriends, $translate) {
    var vm = this;
    vm.flagSave = true;
    vm.readyToSave = true;
    vm.allowCreate = Auth.isActionAllowed('group_resource','POST');
    vm.allowModify = Auth.isActionAllowed('group_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('group_resource','DELETE');

    this.contactTypes = Group.getContactTypes();

    vm.allowReadSubscribers = Auth.isActionAllowed('subscriber_resource','GET');
    // vm.loading = true ;
    vm.unselectedMembers = [];
    vm.selectedMembers = [];
    // vm.loading = true;
    this.contact = contact;
    this.organizationId = organizationId;
    this.cancel = cancel;
    this.ok = ok;
    this.showOCL = showOCL;
    this.groupNameLimit = groupNameLimit;
    this.licensesTemplate = [];
    this.allLicensesTemplate = [];
    this.unselectedMembersNew = [];
    this.selectedMembersNew = [];
    this.flowOrgFriendSubArray = [];
    this.orgFriendsMap = [];
    getOrgFriend();
    getLicenseData();
    getAllGroupList();

    //-------------------------------------------------------------------

    function prepareMembers() {
      vm.contact.memberType = '1';
      var valreturn ='';
      if(vm.contact.type)
        vm.contact.type = vm.contact.type.toString();
      else if (!vm.contact._id)
        vm.contact.type = 8;  //default type
      Subscriber.getSubscriberDataByOrg(vm.organizationId)
        .then(function (resp) {
          vm.contacts = resp;
          if(vm.contact._id){
            Subscriber.getListByFilterGroup(vm.contact._id)
              .then(function(resp){
                vm.contact.subscribers = resp.map(function(subscriber){
                  return subscriber._id;
                });
                valreturn = filterMember();
              })
          }
          else{
            vm.unselectedMembers = vm.contacts;
            vm.readyToSave = false;
          }
        })
        .catch(function(e){
          if(e.status !== 404){ ExceptionHandler.show(e) }
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function filterMember(){
      return new Promise(function(resolve, reject){
        // vm.loading = true;
        vm.unselectedMembersNew = [], vm.selectedMembersNew = [];
        vm.showAffiliatedGroup =false;
        if(vm.contact.cross_fleet != 1)
        {
          vm.selectedMembers = vm.contacts.filter(function (contact) {
            return vm.contact.subscribers.indexOf(contact._id) !== -1;
          });
          vm.unselectedMembers = vm.contacts.filter(function (contact) {
            return vm.contact.subscribers.indexOf(contact._id) === -1;
          });
          resolve('passed');
          // vm.loading = false;
          vm.readyToSave = false;
        }
        else{
          vm.selectedMembers = [], vm.unselectedMembers = [];
            var members = vm.contacts.filter(function (member) {
              member.organization_name = (member.organization_id == vm.organizationId) ? $translate.instant("OWN") : vm.orgFriendsMap[member.organization_id];
              member.no_icon = (member.organization_id == vm.organizationId) ? false : true;
              return vm.contact.subscribers.indexOf(member._id) !== -1;
            });
            vm.selectedMembers = vm.selectedMembers.concat(members);
            //Affilated org Contacts
            if(vm.orgMembers.length>0)
            {
              for(var i=0;i<vm.orgMembers.length;i++)
              {
                var members = vm.flowOrgFriendSubArray.filter(function (member) {
                  if(member.organization_id == vm.orgMembers[i]._id && member.isOffNet == true)
                  {
                    member.organization_name = (member.organization_id == vm.organizationId) ? $translate.instant("OWN") : vm.orgFriendsMap[member.organization_id];
                    member.no_icon = (member.organization_id == vm.organizationId) ? false : true;
                    return vm.contact.subscribers.indexOf(member._id) !== -1;
                  }
                });
                vm.selectedMembers = vm.selectedMembers.concat(members);

                // vm.unOrgMembers = vm.flowOrgFriendSubArray.filter(function (member) {
                //   if(member.organization_id == vm.orgMembers[i]._id)
                //   {
                //     member.organization_name = (member.organization_id == vm.organizationId) ? $translate.instant("OWN") : vm.orgFriendsMap[member.organization_id];;
                //     return vm.contact.subscribers.indexOf(member._id) === -1;
                //   }
                // });  
              }
            }
            

              vm.unselectedMembers = vm.contacts.filter(function (member) {
                if(member.isOffNet == true)
                {
                  member.organization_name = (member.organization_id == vm.organizationId) ? $translate.instant("OWN") : vm.orgFriendsMap[member.organization_id];;
                  return vm.contact.subscribers.indexOf(member._id) === -1;
                }
              });     
              // vm.unselectedMembers  = vm.unselectedMembers.concat(vm.unOrgMembers);   
            vm.showAffiliatedGroup =true;
            vm.readyToSave = false;
            
            // vm.customLicense=[];
            // for(var i=0;i<vm.selectedMembers.length;i++)
            // {
            //   if(!vm.allLicensesTemplate.includes(vm.selectedMembers[i].permissions_mask))
            //   {
            //     if(!vm.customLicense.includes(vm.selectedMembers[i].permissions_mask))
            //     {
            //       vm.customLicense.push(vm.selectedMembers[i].permissions_mask);
            //     }
            //   }
            //   var flag=0;
            //   for(var j=0; j<vm.licensesTemplate.length; j++){
            //     if(vm.licensesTemplate[j] == vm.selectedMembers[i].permissions_mask)
            //         flag=1;
            //   }
            //   if(flag ==1)
            //     vm.selectedMembersNew.push(vm.selectedMembers[i]);
            // }
            // vm.customLicenseUn=[];
            // for(var i=0;i<vm.unselectedMembers.length;i++)
            // {
            //   console.log(vm.unselectedMembers[i])
            //   if(!vm.allLicensesTemplate.includes(vm.unselectedMembers[i].permissions_mask))
            //   {
            //     if(!vm.customLicenseUn.includes(vm.unselectedMembers[i].permissions_mask))
            //     {
            //       vm.customLicenseUn.push(vm.unselectedMembers[i].permissions_mask);
            //     }
            //   }
            //   var flag=0;
            //   for(var j=0; j<vm.licensesTemplate.length; j++){
            //     if(vm.licensesTemplate[j] == vm.unselectedMembers[i].permissions_mask)
            //         flag=1;
            //   }
            //   if(flag ==1)
            //     vm.unselectedMembersNew.push(vm.unselectedMembers[i]);
            // }
            // vm.customLicense.forEach(function(element){
            //     if(element)
            //     {
            //       Subscriber.licenseIsOffNet(element).then(function(resp){
            //         for(var p=0;p<vm.selectedMembers.length;p++)
            //         {
            //           if((resp.mask == vm.selectedMembers[p].permissions_mask) && resp.result == true)
            //           {
            //             vm.selectedMembersNew.push(vm.selectedMembers[p]);
            //           }
            //         }
            //       });
            //     }
            // });
            // vm.customLicenseUn.forEach(function(element){
            //     if(element)
            //     {
            //       Subscriber.licenseIsOffNet(element).then(function(resp){
            //         for(var p=0;p<vm.unselectedMembers.length;p++)
            //         {
            //           if((resp.mask == vm.unselectedMembers[p].permissions_mask) && resp.result == true)
            //           {
            //             vm.unselectedMembersNew.push(vm.unselectedMembers[p]);
            //           }
            //         }
            //       });
            //     }
            // });
            resolve('passed');
            setTimeout(function() {
              // vm.selectedMembers = vm.selectedMembersNew;
              // vm.unselectedMembers = vm.unselectedMembersNew;
              // vm.loading = false;
            }, 1000);
        }
      });
      
        // vm.selectedMembers = vm.flowOrgFriendSubArray.filter(function (contact) {
        //   return vm.contact.subscribers.indexOf(contact._id) !== -1;
        // });
    
        
      
    }
    function getOrgFriend(){
      
      getSubscribersByOrg(vm.organizationId);
      if(vm.contact.cross_fleet == 1)
      {
        OrgFriends.getByOrgId(vm.organizationId)
        .then(function (resp) {
          // resp.push(vm.organization);          
          vm.orgMembers = resp;
            resp.map(function (org) {
              vm.orgFriendsMap[org._id] = org.name;
              getSubscribersByOrg(org._id);
              // console.log(org._id)
            });
        })
        .catch(function (e) {
          if (e.status !== 404) { ExceptionHandler.show(e) }  
        });
      }
     
    }
    function getSubscribersByOrg(orgId) {
       Subscriber.getSubscriberDataByOrg(orgId)
      .then(function (resp) {
        resp.map(function (org) {
          vm.flowOrgFriendSubArray.push(org);    
        });      
        // console.log('test')
        prepareMembers();
      })
      .catch(function (e) {
        // vm.loading = false;
      });
    }
    function addGroup(){
      // vm.loading = true;
      Group.add(contact)
        .then(function () {
          //get list of all group to get the Proper Id of it
          $mdDialog.hide();
        })
        .catch(function(e){
          vm.flagSave = true;
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function updateGroup(){
      // vm.loading = true;
      Group.update(vm.contact)
        .then(function () {
          $mdDialog.hide();
        })
        .catch(function(e){
          vm.flagSave = true;
          ExceptionHandler.show(e);
        })
        .finally(function(){
        // vm.loading = false;
      });
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function ok() {
      vm.flagSave = false;
      contact.name = contact.name.trim();
      vm.contact.organization_id = vm.organizationId;
      vm.contact.organization = vm.organizationId;
      if(!contact.name)
      {
        var error= {
          data:{
            error:'Name is Required'
          }
        }
        // ExceptionHandler.show(error);
        vm.flagSave = true;
        return false;
      }
      vm.contact.subscribers = vm.selectedMembers.map(function (member) {
        return member._id
      });
      vm.contact.mutedSubscribers=[];
      vm.contact.mutedSubscribers = vm.selectedMembers.map(function (member) {
          return 0;
      });

      vm.contact._id ? updateGroup() : addGroup();

    }
    function getLicenseData(){
      License.getLicenseTemplates()
      .then(function(resp){
        for(var i=0;i<resp.length;i++)
          {
            var tempWord =resp[i].name;
            vm.allLicensesTemplate.push(resp[i].mask);
            var checkString = 'OffNet';
              if(tempWord.indexOf(checkString) != -1)
                vm.licensesTemplate.push(resp[i].mask);
          }
        vm.showLoader = false ;
      })
      .catch(function(err){
        vm.showLoader = false ;
      });
    }
    function getAllGroupList(){
      Group.getAllGroupList(vm.organizationId).then(function(resp){
        vm.grpList = resp;
        // console.log(vm.grpList)
      })
      .catch(function (e) {
        ExceptionHandler.show(e);
      })
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.callLogs', ['datatables'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider, msApiProvider) {
    $stateProvider.state('app.restricted.callLogs', {
      url: '/callLogs',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/callLogs/callLogs.html',
          controller: 'CallLogsController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('organization_resource','GET')
        }
      }
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/restricted/organization/subscribers');

    //msApiProvider.register('subscribers', ['app/main/restricted/organization/subscribers/data/subscribers.json']);

    // Navigation
    msNavigationServiceProvider.saveItem('Organization.callLogs', {
      title: 'CallLogs',
      icon: '',
      state: 'app.restricted.callLogs',
      translate: 'NAVIGATION_CALL_LOGS',
      weight: 6
    });
  }

})();

(function () {
  'use strict';
  angular.module('app.restricted.callLogs')
    .controller('callLogsDialogController', callLogsDialogController);

  /** @ngInject*/
  function callLogsDialogController(session, localStorageService, $mdDialog) {


    var vm = this;
    vm.session = session
    vm.loading = true;
    vm.search = '';
    vm.cancel = cancel;

    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCountDialog = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];
        
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

     /**
     * sort session list
     */
    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCountDialog);
     }
 
     /**
      * sort session list
      */
     function sort(param){
       vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
       vm.sessions = orderByFilter(vm.sessions,param,vm.reverse[param])
     }
     /**
      * gets css-class to show icon near column header
      */
     function getSortingClass(param){
       return vm.reverse[param] ? "up" : "down";
     }

     function cancel() {
      $mdDialog.cancel();
    }
 

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.roles', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.roles', {
      url: '/roles',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/administration/roles/list.html',
          controller: 'RolesController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('administration_resource','GET')
        }
      },
      bodyClass: 'profile'
    });

    //$translatePartialLoaderProvider.addPart('app/main/restricted/administration/roles');


    // Navigation
    msNavigationServiceProvider.saveItem('Administration.roles', {
      title: 'Roles',
      icon: 'icon-account',
      state: 'app.restricted.roles',
      translate  : 'NAVIGATION_ROLES',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.roles')
    .controller('roleDialogController', roleDialogController);

  /** @ngInject*/
  function roleDialogController($mdDialog, ExceptionHandler, $filter, localStorageService, Role, orderByFilter, api, currentRole, currentProvPerm, LoginUserRoleId, editIsAdmin, edit, showCostPermissions, showSecurityMonitoring , rolePermissions, Security, Auth, Toast, $translate, audioCodec) {

    var vm = this;
    vm.flagSave = true;
    //this.checkErr = checkErr;
    this.checkErrForStartDate = checkErrForStartDate;
    this.getSecurityLog = getSecurityLog;
    vm.searchWeb = '';
    vm.searchDisp = '';
    vm.searchMob = '';
    vm.disable_view_group_members=false;
    vm.disable_audio_codec=false;
    vm.disable_disp_audio_codec=false;
    vm.currentRole = currentRole;
    vm.beforeChangeRole = Object.assign([],currentRole);
    vm.editIsAdmin = editIsAdmin;
    vm.rolePermissions = rolePermissions;
    vm.currentRole.updateMobileClients = false;
    vm.currentProvPerm = currentProvPerm;
    vm.LoginUserRoleId = LoginUserRoleId;
    vm.audioCodec = audioCodec?audioCodec:'4';
    vm.edit = edit;
    vm.showCostPermissions = showCostPermissions;
    vm.showSecurityMonitoring = showSecurityMonitoring;
    vm.currentConsoleType = 2;
    vm.resourcesList = [];
    vm.DISPLAY_AS_CHECKBOX = "checkbox";
    vm.DISPLAY_AS_SELECT = "select";
    vm.DISPLAY_AS_MULTISELECT = "multi";
    vm.DISPLAY_AS_MULTICHECKBOX = "multi-checkbox";
    vm.addButtonDisableFlag = false;
    vm.addMobileBottomBarFlag = false;
    vm.isPopupVisible = false;
    vm.now = new Date();
    vm.setDependencies = setDependencies;
    vm.permissionChanged = permissionChanged;
    vm.clickcheckBox = clickcheckBox;
    vm.trimValue = trimValue;
    vm.displayCostMsg = localStorageService.get('displayCostMsg-' + vm.currentRole._id) ? JSON.parse(localStorageService.get('displayCostMsg-' + vm.currentRole._id)) : true;

    vm.allowCreate = Auth.isActionAllowed('administration_resource','POST');

    if (!vm.allowCreate)
      vm.edit = false;

    vm.GROUPS_ORDER = [
                        {name:"Priority",count:0},
                        {name:"Availability",count:0},
                        {name:"Management",count:0},
                        {name:"Location and Emergency",count:0},
                        {name:"Call Features",count:0},
                        {name:"Messaging Features",count:0},
                        {name:"Look and Feel",count:0},
                      //"Presence and Connectivity",
                        {name:"Audio Settings",count:0},
                        {name:"Security Monitoring",count:0},
                        {name: "App Maintenance",count:0},
                        {name: "",count:0},
                      ];

  var dependenciesTopicsArray = ["enable_sos_resource", "man_down_resource", "personal_group_resource", "radio_channel_spare_resource", "im_capability_resource", "foreground_in_session_resource"]
  var dependenciesTopics = {"enable_sos_resource" : ["emergency_mode_ring_resource", "emergency_tone_duration_resource", "send_emergency_alert_resource"], "man_down_resource":["man_down_grace_time_resource", "man_down_sensitivity_resource"], "personal_group_resource": ["max_group_size_resource"], "radio_channel_spare_resource": ["enable_multi_channel_resource", "vibrate_on_group_resource"], "im_capability_resource": ["multimedia_messaging_resource", "im_broadcast_resource"], "foreground_in_session_resource":["foreground_on_any_call_resource"],}
  vm.dependenciesTopicsDisable = {};

  var cost_permissions= ['man_down_resource', 'multimedia_messaging_resource', 'enable_recording_resource', 'enable_multi_channel_resource', 'enable_encryption_resource', 'radio_sessions_resource', 'fences_limit_resource'];
  var translation_permissions = {'man_down_resource': 'Man Down', 'multimedia_messaging_resource': 'Multimedia messaging', 'enable_recording_resource': 'A replay of the last burst', 'enable_multi_channel_resource': 'Multi-Channel mode', 'enable_encryption_resource': 'Encryption', 'radio_sessions_resource': 'Radio Sessions', 'fences_limit_resource': 'Fences Limit'}

   init();
                      // console.log(vm.currentRole)
   vm.roles = {};

   vm.roles.startDate = new Date(new Date().setHours(0,0,0,0));
   vm.roles.endDate = new Date(new Date().setHours(23, 59, 59, 999));
   getSecurityLog();

  function init(){
    if(vm.currentRole.name == 'Lite Client' && !Auth.isRootAdmin())
    {
      vm.edit = false;
    }

    var delete_index_A, delete_index_B, delete_index_C;
    var roleP_delete_index_A, roleP_delete_index_B, roleP_delete_index_C;
    vm.currentRole.permissions.filter(function(perm, i){
      if (perm.resource_id == "radio_sessions_helper_A_resource") delete_index_A = i; //find index of "radio_sessions_helper_A_resource" 
      if (perm.resource_id == "radio_sessions_helper_B_resource") delete_index_B = i; //find index of "radio_sessions_helper_B_resource" 
      if (perm.resource_id == "radio_sessions_helper_C_resource") delete_index_C = i; //find index of "radio_sessions_helper_C_resource" 
      // vm.setDependencies(perm);
    });
    if(typeof(vm.rolePermissions['dispatcher']) != "undefined")
    {
      angular.forEach(vm.rolePermissions.dispatcher.topics, function(value, key) {
        if(value.resource_id == 'radio_sessions_helper_A_resource') roleP_delete_index_A = key;
        if(value.resource_id == 'radio_sessions_helper_B_resource') roleP_delete_index_B = key;
        if(value.resource_id == 'radio_sessions_helper_C_resource') roleP_delete_index_C = key;
      });
    }
    if(delete_index_A) vm.currentRole.permissions.splice(delete_index_A, 1); //delete "radio_sessions_helper_A_resource" from current permissions
    if (vm.rolePermissions && vm.rolePermissions.dispatcher && roleP_delete_index_A) delete vm.rolePermissions.dispatcher.topics[roleP_delete_index_A]; //delete "radio_sessions_helper_A_resource" from new permissions

    if (delete_index_B) vm.currentRole.permissions.splice(delete_index_A && (delete_index_A < delete_index_B) ? delete_index_B - 1 : delete_index_B, 1); //delete "radio_sessions_helper_B_resource" from current permissions
    if (vm.rolePermissions && vm.rolePermissions.dispatcher && roleP_delete_index_B) delete vm.rolePermissions.dispatcher.topics[roleP_delete_index_B]; //delete "radio_sessions_helper_B_resource" from new permissions

    if (delete_index_C){
      var i = 0;
      if (delete_index_A && delete_index_A < delete_index_C) i +=1;
      if (delete_index_B && delete_index_B < delete_index_C) i +=1;
      vm.currentRole.permissions.splice(delete_index_C - i, 1); //delete "radio_sessions_helper_C_resource" from current permissions
    }
    if (vm.rolePermissions && vm.rolePermissions.dispatcher && roleP_delete_index_C) delete vm.rolePermissions.dispatcher.topics[roleP_delete_index_C]; //delete "radio_sessions_helper_C_resource" from new permissions
   var AlwUserFlag=0;
    currentRole.permissions.find(function(obj){
      if( obj.resource_id === 'allow_view_group_members') 
      {
        AlwUserFlag = 1;
        if(obj.options.bit1.active)
          vm.disable_view_group_members = false;
        else
        {
          vm.disable_view_group_members = true;
          currentRole.permissions.find(function(obj1){
            if( obj1.resource_id === 'enable_edit_group_resource') 
              obj1.options.bit1.active = false;
          });
        }
      }
      if( obj.resource_id === 'audio_codec_automatic') 
      {
        AlwUserFlag = 1;
        if(!obj.options.bit1.active)
          vm.disable_audio_codec = false;
        else
        {
          vm.disable_audio_codec = true;
        }
      }
    });
    if(AlwUserFlag == 0)
    {
      currentRole.permissions.find(function(obj1) {
        if( obj1.resource_id === 'enable_edit_group_resource')
          {vm.disable_view_group_members = true; 
            obj1.options.bit1.active = false;
          }
        if( obj1.resource_id === 'audio_codec_automatic')
        {
          vm.disable_audio_codec = true; 
          obj1.options.bit1.active = true;
        }
      });
    }
    if(vm.showSecurityMonitoring == false)
    {
      vm.GROUPS_ORDER.forEach(function(perm, i){
        if(perm.name == 'Security Monitoring')
            vm.GROUPS_ORDER.splice(i, 1);
      });
    }
    setTimeout(function(){
      vm.isPopupVisible = false;
    }, 1000);
  }
  function clickcheckBox(perm,item){
    if(perm._id === 82)
    {
      if(item.id == 'bit0')
      {
        if(perm.selectedOptions.indexOf('bit0') !== -1)
        {
          vm.addMobileBottomBarFlag = true;
        }
        
      }
    }
  }
  function permissionChanged(perm){

    // if((perm.options.bit1.active || (perm.selected && perm.selected != "bit0"))){	
    //   vm.disable_view_group_members = false;	
    // }	
    // if((perm.options.bit1.active == false || (!perm.selected && perm.selected != "bit1")) && vm.currentRole.permissions[48].options.bit1.active == true){	
    //   vm.disable_view_group_members = false;
    // }	
    // else{	
    //   vm.disable_view_group_members = true;	
    //   vm.currentRole.permissions[38].options.bit1.active = false; //added static object id to disable "Group Creation & Management" when "Allow View Group Members" is not checked.	
    // }
    if(perm.resource_id === 'allow_view_group_members')
    {
      if(perm.options.bit1.active)
        vm.disable_view_group_members = false;
      else
      {
        vm.disable_view_group_members = true;
        currentRole.permissions.find(function(obj){
          if( obj.resource_id === 'enable_edit_group_resource') 
          {
            obj.options.bit1.active = false;
          }
        });
      }
    }
    if(perm.resource_id === 'audio_codec_automatic')
    {
      if(!perm.options.bit1.active)
        vm.disable_audio_codec = false;
      else
      {
        vm.disable_audio_codec = true;
      }
    }
    if(perm.resource_id === 'enable_edit_group_resource')
    {
      currentRole.permissions.find(function(obj) {
        if( obj.resource_id === 'allow_view_group_members') 
          {
            if(!obj.options.bit1.active)
            {
              vm.disable_view_group_members = true;
              perm.options.bit1.active = false;
            }
            else
              vm.disable_view_group_members = false;
          }
      });
    }
    if(perm._id === 82){
      if(perm.selectedOptions.indexOf('bit0') !== -1) {
        if(perm.selectedOptions.indexOf('bit4') !== -1)
        {
          perm.selectedOptions=[];
          perm.selectedOptions.push('bit0');
          perm.selectedOptions.push('bit4');
        }
        else
        {
          perm.selectedOptions=[];
          perm.selectedOptions.push('bit0')
        }
      }
      if(vm.addMobileBottomBarFlag == true)
      {
        if(perm.selectedOptions.indexOf('bit4') !== -1)
        {
          perm.selectedOptions=[];
          perm.selectedOptions.push('bit1');
          perm.selectedOptions.push('bit2');
          perm.selectedOptions.push('bit3');
          perm.selectedOptions.push('bit4');
        }
        else
        {
          perm.selectedOptions=[];
          perm.selectedOptions.push('bit1');
          perm.selectedOptions.push('bit2');
          perm.selectedOptions.push('bit3');
        }
      }
      vm.addMobileBottomBarFlag = false;
    }
    if(perm.resource_id ==="audio_codec_automatic")
    {
      
    }
    if (cost_permissions.includes(perm.resource_id))
        vm.isPopupVisible = true;
    if (cost_permissions.includes(perm.resource_id) && (perm.options.bit1.active || (perm.selected && perm.selected != "bit0")))
      vm.displayCostMsg = true;

  }

  function setDependencies(perm){
    if (dependenciesTopicsArray.includes(perm.resource_id)){
      var dependResources = dependenciesTopics[perm.resource_id];
      for (var i in dependResources){
        var dependResource = dependResources[i];
        if (perm.options.bit1.active || (perm.selected && perm.selected != "bit0")) vm.dependenciesTopicsDisable[dependResource] = false;
        else{
          vm.dependenciesTopicsDisable[dependResource] = true;
          var disablePerm = vm.currentRole.permissions.filter(function(perm2){
            if (perm2.resource_id == dependResource) return perm2;
          })[0];
          if (disablePerm){
            if (disablePerm.type == vm.DISPLAY_AS_CHECKBOX && disablePerm.options.bit1.active) disablePerm.options.bit1.active = false;
            if (disablePerm.type == vm.DISPLAY_AS_SELECT && disablePerm.selected != "bit0") disablePerm.selected = "bit0";
          }

        }
      }
    }
  }
    
    function checkErrForStartDate() {
      vm.roles.errMessage = '';

      if(vm.roles && vm.roles.endDate && vm.roles.startDate && vm.roles.startDate > vm.roles.endDate){
        vm.roles.errMessage = $translate.instant("DATES_ERROR");//'End Date should be greater than start date';
        return false;
      }else{
        vm.roles.errMessage = '';
        getSecurityLog();
      }

    }

    function getSecurityLog() {

      // vm.loading = true;
      var  startDate = $filter('date')(vm.roles.startDate,'dd-MMM-yy');
      var  endDate = $filter('date')(vm.roles.endDate,'dd-MMM-yy');

      Security.getSecurityLogByID(vm.currentRole._id, startDate.toString(), endDate.toString())
        .then(function(resp){
          vm.securityList = resp.results;
        })
        .catch(function(e){
          if(e.status !==404){
            ExceptionHandler.show(e);
          }
          vm.securityList=[];
        })
        .finally(function(){
          // vm.loading = false;
        });

        /*
      if(vm.subscriber.startDate != '' && vm.subscriber.endDate!=null){
        vm.loading = true;
        var startDate = $filter('date')(vm.subscriber.startDate,'dd-MMM-yy');
        var endDate = $filter('date')(vm.subscriber.endDate,'dd-MMM-yy');

        Security.getSecurityLogByID(vm.currentRole._id, startDate.toString(), endDate.toString())
          .then(function(resp){
            vm.securityList = resp.results;
          })
          .catch(function(e){
            if(e.status !==404){
              ExceptionHandler.show(e);
            }
          })
          .finally(function(){
            vm.loading = false;
          });
      }else{
        vm.subscriber.errMessage = 'Provide start date and end date';
      }
      */

    }

    // vm.isAdminResource = function(resource){
    //   if (resource == "is_admin_resource")
    //     return true
    // }

    vm.hide = function() {
      $mdDialog.hide();
    };
    vm.cancel = function() {
      $mdDialog.cancel();
    };

    vm.save = function() {
      vm.flagSave = false;
      vm.trimValue();
      if(vm.showCostPermissions && vm.displayCostMsg && vm.isPopupVisible){
        var message_permissions = "";
        vm.currentRole.permissions.filter(function(permission){
          if (cost_permissions.includes(permission.resource_id) && (permission.options && permission.options.bit1.active == true || (permission.selected && permission.selected != "bit0")))
          {
            message_permissions = (message_permissions == "") ? translation_permissions[permission.resource_id] : message_permissions + ', ' + translation_permissions[permission.resource_id]  
          }
        })
        if (message_permissions != "")
          display_warning_msg(message_permissions);
        else
          save_role();
      }
      else
        save_role();

    };

    function save_role() {
      if (vm.currentRole.newRole){
        api.roles.newRole.save(vm.currentRole,
          function(role) {
            vm.currentRole._id = role._id;
              updateRole(vm.currentRole);
              Toast.showAdd();
          }, function (e) {
            vm.flagSave = true;
            ExceptionHandler.show(e);
          });
      }
      else{
         updateRole(vm.currentRole);
      }
      localStorageService.set('displayCostMsg-' + vm.currentRole._id, "false")
    };

    function display_warning_msg(message_permissions){
      var confirm = Toast.getChargeRoles(message_permissions);
      $mdDialog.show(confirm)
        .then(function () {
          save_role();
        })
        .catch(function(){
          // vm.loading = false;
          vm.flagSave = true;
        })
    }

    function updateRole(currentRole){
      // vm.loading = true;
      if(currentRole.permissions){

        currentRole.permissions.forEach(function(perm) {
          if (perm.resource_id == "") {
            var permIndex = currentRole.permissions.indexOf(perm);
            currentRole.permissions.splice(permIndex, 1);
          }
        });

        currentRole.permissions.forEach(function(perm){

          perm.bit1 = false;
          perm.bit2 = false;
          perm.bit3 = false;
          perm.bit4 = false;
          perm.bit5 = false;
          perm.bit6 = false;
          perm.bit7 = false;
          perm.bit8 = false;
          perm.bit9 = false;
          perm.bit10 = false;
          perm.bit11 = false;
          perm.bit12 = false;
          perm.bit13 = false;
          perm.bit14 = false;
          perm.bit15 = false;
          perm.bit16 = false;

          //add Checkbox options
          if(perm.type === vm.DISPLAY_AS_CHECKBOX && perm.console_type == 4 && perm.options.bit1.active){
            perm.bit1 = true;
            vm.flagSave = true;
            return;
          }

          //Add multi-select options
          if(perm.selectedOptions){
            perm.selectedOptions.forEach(function(option){
                perm[option] = true;
            });
          }
          //Add select options
          if(perm.selected){
            perm[perm.selected] = true;
          }

          //Temporary fix for one checkbox Dispatcher topics
          if(perm.console_type === 3 &&
            (perm.resource_id === "branding_resource" ||
             perm.resource_id === "ambient_listening_resource" ||
             perm.resource_id === "show_map_resource" ||
             //perm.resource_id === "encryption_resource" ||
             perm.resource_id === "is_admin_resource" ||
             perm.resource_id === "block_user_ptt_resource" ||
             perm.resource_id === "device_info_resource")||
             perm.resource_id === "disable_modify_settings_resource"||
             perm.resource_id === "wfm_resource" || 
             perm.resource_id === "idle_time" ){
           perm.put_access = false;
           perm.patch_access = false;
          }

        });

        //Add topic to trigger polling procedure and update mobile clients
        currentRole.permissions.push({
          topic: 99,
          console_type: 4,
          resource_id: "update_mobile_clients_resource"
        });
        
        api.roles.updateRole.put({ id: currentRole._id }, { name: currentRole.name, permissions: currentRole.permissions, orgNodeId:currentRole.orgNodeId }, function (role) {
          $mdDialog.hide(vm.currentRole.newRole);
        }, function (e) {
          vm.flagSave = true;
          //  $mdDialog.hide();
          ExceptionHandler.show(e);
        });
      }
      else{
        vm.flagSave = true;
        ExceptionHandler.show({message: "No permissions added"});
      }
      // vm.loading = false;
    }

    vm.addNewPerm = function() {
      //vm.filterResourceList();
      vm.addButtonDisableFlag = true;
      var console_type_string = vm.currentConsoleType == 2 ? 'web' : vm.currentConsoleType == 3 ? 'dispatcher' : 'mobile';
      var resourceList = Object.values(vm.rolePermissions[console_type_string].topics);//vm.resourcesList[vm.currentConsoleType];
      
      for (var index in resourceList){
        var resource = resourceList[index];
        var usedPermissions = currentRole.permissions.filter(function(permission){
          return permission.resource_id === resource.resource_id && permission.console_type == vm.currentConsoleType;
        });
        var usedPermissionsRemove = currentRole.permissions.filter(function(permission){
          return permission.resource_id === resource.resource_id && permission.console_type == vm.currentConsoleType && permission.remove != resource.remove;
        });
        if (!usedPermissions || usedPermissions.length==0){
          currentRole.permissions.push(resource);
          //vm.setOptions(resource.resource_id);
        }
        if(usedPermissionsRemove.length != 0)
        {
          currentRole.permissions.find(function(obj){
            if( obj.resource_id === usedPermissionsRemove[0].resource_id) 
              obj.remove = false;
          });
        }
        if(resource.remove) resource.remove = false;
      }
      for(var i=1;i<=currentRole.permissions.length;i++)
      { 
        if( i<currentRole.permissions.length && vm.currentConsoleType === currentRole.permissions[i].console_type)
        {
          var tempResouce = currentRole.permissions[i-1];
          if(currentRole.permissions[i].above_element_id == 0 && vm.currentConsoleType == currentRole.permissions[i].console_type){
            var oneResource = currentRole.permissions[i];
            var odeleteIndex = currentRole.permissions.indexOf(currentRole.permissions[i]);
            currentRole.permissions.splice(odeleteIndex, 1);
            currentRole.permissions.splice(0, 0, oneResource);
          }
          else if(tempResouce._id != currentRole.permissions[i].above_element_id && tempResouce.console_type == currentRole.permissions[i].console_type)
          {
              
              var nextResource='';
              currentRole.permissions.find(function(obj){
                if( tempResouce._id == obj.above_element_id && tempResouce.console_type == obj.console_type) 
                    nextResource = obj;
              });
              if(nextResource != '')
              {
                var deleteIndex = currentRole.permissions.indexOf(nextResource);
                currentRole.permissions.splice(deleteIndex, 1);
                var nextIndex = currentRole.permissions.indexOf(tempResouce);
                currentRole.permissions.splice(nextIndex+1, 0, nextResource);
              }
          }
        }
      }
      var lastIndexArray = currentRole.permissions.length -1;
      if(currentRole.permissions[lastIndexArray].above_element_id == 0)
      {
        var changePos = currentRole.permissions[lastIndexArray];
        currentRole.permissions.splice(lastIndexArray, 1);
        currentRole.permissions.splice(0, 0, changePos);
      }
      else if(currentRole.permissions[lastIndexArray].above_element_id != currentRole.permissions[lastIndexArray-1]._id )
      {
        currentRole.permissions.forEach(function(element) {
          if(element._id === currentRole.permissions[lastIndexArray].above_element_id && currentRole.permissions[lastIndexArray].console_type === element.console_type)
          {
            var changePos = currentRole.permissions[lastIndexArray];
            var prevIndex =  currentRole.permissions.indexOf(element);
            currentRole.permissions.splice(lastIndexArray, 1);
            currentRole.permissions.splice(prevIndex+1, 0, changePos);
          }
        });


          
      }
      
      if(vm.showSecurityMonitoring == false)
      {
        vm.GROUPS_ORDER.forEach(function(perm, i){
          if(perm.name == 'Security Monitoring')
              vm.GROUPS_ORDER.splice(i, 1);
        });
      }
      checkAddButtonDisabled();

      // for (var index in resourceList)
      // {
      //   var resource = resourceList[index];
      //   var usedPermissions = currentRole.permissions.filter(function(permission){
      //     return permission.resource_id === resource.resource_id && permission.console_type == vm.currentConsoleType;
      //   });
      //   console.log(usedPermissions)
      //   if (!usedPermissions || usedPermissions.length==0){
      //       if(resource.above_element_id == 0)
      //       {
      //         if(resource.console_type == 2)
      //         {
      //           currentRole.permissions.splice(0, 0, resource);
      //         }
      //         else
      //         {
      //           var findLastResourseType = resource.console_type;
      //           var flag=0;
      //           currentRole.permissions.filter(function(position){
      //             if(position.console_type === findLastResourseType)
      //             {
      //               if(flag != 1)
      //               {
      //                 var FirstIndexForAdd = currentRole.permissions.indexOf(position);
      //                 currentRole.permissions.splice(FirstIndexForAdd, 0, resource);
      //                 flag=1;
      //               }
                   
      //             }
      //           });
      //         }
      //         // currentRole.permissions.push(resource);
      //       }
      //       else
      //       {
      //         debugger;
      //         var resourcePosition = resource.above_element_id;
      //         currentRole.permissions.filter(function(position){
      //           if(position._id === resourcePosition && position.console_type === resource.console_type)
      //           {
      //             var indexForAdd = currentRole.permissions.indexOf(position) + 1;
      //             currentRole.permissions.splice(indexForAdd, 0, resource);
      //           }
      //         });
      //       }
      //     // currentRole.permissions.push(resource);
      //   }
      // }
      // for (var index in resourceList){
      //   var resource = resourceList[index];
      //   var usedPermissions = currentRole.permissions.filter(function(permission){
      //     return permission.resource_id === resource.resource_id && permission.console_type == vm.currentConsoleType;
      //   });
      //   var usedPermissionsRemove = currentRole.permissions.filter(function(permission){
      //     return permission.resource_id === resource.resource_id && permission.console_type == vm.currentConsoleType && permission.remove != resource.remove;
      //   });
      //   if (!usedPermissions || usedPermissions.length==0){
      //     currentRole.permissions.push(resource);
      //     //vm.setOptions(resource.resource_id);
      //   }
      //   if(usedPermissionsRemove.length != 0)
      //   {
      //     currentRole.permissions.find(function(obj){
      //       if( obj.resource_id === usedPermissionsRemove[0].resource_id) 
      //         obj.remove = false;
      //     });
      //   }
      //   if(resource.remove) resource.remove = false;
      // }
      
      // console.log(currentRole.permissions)
      
    };


    vm.onMultiselectChanged =  function(ev){
      ev.stopPropagation();
    };

    vm.deactivateAddButton = function(){
      if (!vm.edit)
        return false;

      var usedPermissions = vm.currentRole.permissions.filter(function(permission){
        return permission.console_type === vm.currentConsoleType;
      });

      // if(vm.currentConsoleType === 4){
      //   return usedPermissions.length >= Object.keys(vm.rolePermissions["mobile"].topics).length;
      // }
      // else if(vm.currentConsoleType === 3){
      //   return usedPermissions.length >= Object.keys(vm.rolePermissions["dispatcher"].topics).length;
      // }
      // else{
      //   return usedPermissions.length >= Object.keys(vm.rolePermissions["web"].topics).length;
      // }
    };

    vm.checkDisabledOptionMobileValue = function(item){
      return (item.name === "Total Broadcast");
    };

    vm.checkDisabledOptionDispatcherValue = function(item){
      return (item.name === "Total Broadcast");
    };

    vm.checkDisabledAllowViewGroupMembers = function(item){	
      return true;	
    };

    vm.deletePermission = function(perm) {
      var permIndex = currentRole.permissions.indexOf(perm);
      // currentRole.permissions[permIndex].remove = true;
      if(currentRole.permissions[permIndex].get_access) delete currentRole.permissions[permIndex].get_access;
      if(currentRole.permissions[permIndex].post_access) delete currentRole.permissions[permIndex].post_access;
      if(currentRole.permissions[permIndex].put_access) delete currentRole.permissions[permIndex].put_access;
      if(currentRole.permissions[permIndex].delete_access) delete currentRole.permissions[permIndex].delete_access;
      if(currentRole.permissions[permIndex].batch_access) delete currentRole.permissions[permIndex].batch_access;
      if(currentRole.permissions[permIndex].himpact_access) delete currentRole.permissions[permIndex].himpact_access;
      if(currentRole.permissions[permIndex].selectedOptions) delete currentRole.permissions[permIndex].selectedOptions;
      if(currentRole.permissions[permIndex].selected) delete currentRole.permissions[permIndex].selected;
      if(currentRole.permissions[permIndex].hasOwnProperty('options')){
        if(currentRole.permissions[permIndex].options.hasOwnProperty('bit1'))
          if(currentRole.permissions[permIndex].options.bit1.active) delete currentRole.permissions[permIndex].options.bit1.active;
      }
      
      if(perm.resource_id === 'allow_view_group_members')
      {
        if(!perm.options.bit1.active)
        {
          vm.disable_view_group_members = true;
          currentRole.permissions.find(function(obj){
            if( obj.resource_id === 'enable_edit_group_resource') 
            {
              obj.options.bit1.active = false;
            }
          });
        }
      }
      currentRole.permissions.splice(permIndex, 1);
      checkAddButtonDisabled();
      //vm.filterResourceList();
    };

    vm.onTabChanges = function(consoleType){
      vm.currentConsoleType = consoleType;
      if(vm.currentConsoleType!==5){
        vm.addButtonDisableFlag = true;
      }else{
        vm.addButtonDisableFlag = false;
      }
      var groupLength=0;
      var console_type_string = vm.currentConsoleType == 2 ? 'web' : vm.currentConsoleType == 3 ? 'dispatcher' : 'mobile';
      if(typeof(vm.rolePermissions[console_type_string]) != "undefined")
      {
        var resourceList = Object.values(vm.rolePermissions[console_type_string].topics);
        for (var group in vm.GROUPS_ORDER){
          groupLength=0;
          resourceList.filter(function(permission){
            if(permission.group === vm.GROUPS_ORDER[group].name)groupLength++;
          });
          vm.GROUPS_ORDER[group].count = groupLength;
        }
      }
      else
        var resourceList = '';
      
      checkAddButtonDisabled()
    }
    function checkAddButtonDisabled(){
      var flag= 1;
        // currentRole.permissions.find(function(obj){
        //   if( obj.remove === true && obj.console_type === vm.currentConsoleType) 
        //   {
        //     flag = 1;
        //   }
        // });
        // if(flag == 1) vm.addButtonDisableFlag = true;
        // else vm.addButtonDisableFlag = false; 

        var console_type_string = vm.currentConsoleType == 2 ? 'web' : vm.currentConsoleType == 3 ? 'dispatcher' : 'mobile';
        var resourceLists= '';
        if(typeof(vm.rolePermissions[console_type_string]) != "undefined")
        { 
          resourceLists = Object.values(vm.rolePermissions[console_type_string].topics);//vm.resourcesList[vm.currentConsoleType];
        }
        else
          resourceLists = '';

        var currentlength = 0;
        currentRole.permissions.filter(function(permission){
            if(permission.console_type === vm.currentConsoleType ) {currentlength++}          
        });
        if(resourceLists.length === currentlength)flag = 0;
        
        if(flag == 1) vm.addButtonDisableFlag = true;
        else vm.addButtonDisableFlag = false; 
        
        if(vm.currentConsoleType === 5)
            vm.addButtonDisableFlag = false;
        // var flag= 0;
        // currentRole.permissions.find(function(obj){
        //   if( obj.remove === true) 
        //   {
        //     flag = 1;
        //   }
        // });
        // if(flag == 1) vm.addButtonDisableFlag = true;
        // else vm.addButtonDisableFlag = false;
    }
    // vm.isAdmin = function(perm,event){
    //   if (perm.resource_id == "is_admin_resource" && perm.get_access == true){
    //     var resourceList = Object.values(vm.rolePermissions["web"].topics)
    //     for (var resource in resourceList){
    //          var exist = false;
    //        for (var i = 0; i < vm.currentRole.permissions.length; i++){
    //            if (vm.currentRole.permissions[i].console_type == 2 && resourceList[resource].resource_id == vm.currentRole.permissions[i].resource_id){
    //               exist = true;
    //               vm.currentRole.permissions[i].get_access = true;
    //               vm.currentRole.permissions[i].post_access = true;
    //               vm.currentRole.permissions[i].put_access = true;
    //               vm.currentRole.permissions[i].delete_access = true;
    //               vm.currentRole.permissions[i].batch_access = true;
    //               vm.currentRole.permissions[i].himpact_access = true;
    //            }

    //        }
    //        if (!exist){
    //            vm.currentRole.permissions.push({});
    //            vm.currentRole.permissions[i].resource_id = resourceList[resource].resource_id;
    //            vm.currentRole.permissions[i].console_type = 2;
    //            vm.currentRole.permissions[i].name = resourceList[resource].name;
    //            vm.currentRole.permissions[i].get_access = true;
    //            vm.currentRole.permissions[i].post_access = true;
    //            vm.currentRole.permissions[i].put_access = true;
    //            vm.currentRole.permissions[i].delete_access = true;
    //            vm.currentRole.permissions[i].batch_access = true;
    //            vm.currentRole.permissions[i].himpact_access = true;
    //            i++;
    //        }
    //      }
    //   }
    //   if (perm.resource_id == "is_admin_resource" && event.target.checked == false){
    //     var resourceList = Object.values(vm.rolePermissions["web"].topics)
    //     for (var resource in resourceList){
    //          var exist = false;
    //        for (var i = 0; i < vm.currentRole.permissions.length; i++){
    //            if (vm.currentRole.permissions[i].console_type == 2 && resourceList[resource].resource_id == vm.currentRole.permissions[i].resource_id){
    //               exist = true;
    //               vm.currentRole.permissions[i].get_access = false;
    //               vm.currentRole.permissions[i].post_access = false;
    //               vm.currentRole.permissions[i].put_access = false;
    //               vm.currentRole.permissions[i].delete_access = false;
    //               vm.currentRole.permissions[i].batch_access = false;
    //               vm.currentRole.permissions[i].himpact_access = false;
    //            }

    //        }
    //        if (!exist){
    //            vm.currentRole.permissions.push({});
    //            vm.currentRole.permissions[i].resource_id = resourceList[resource].resource_id;
    //            vm.currentRole.permissions[i].console_type = 2;
    //            vm.currentRole.permissions[i].name = resourceList[resource].name;
    //            vm.currentRole.permissions[i].get_access = false;
    //            vm.currentRole.permissions[i].post_access = false;
    //            vm.currentRole.permissions[i].put_access = false;
    //            vm.currentRole.permissions[i].delete_access = false;
    //            vm.currentRole.permissions[i].batch_access = false;
    //            vm.currentRole.permissions[i].himpact_access = false;
    //            i++;
    //        }
    //      }
    //   }
    // };

    function trimValue(){
      vm.currentRole.name = vm.currentRole.name.trim()
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.administrators', [])
    .config(config);


  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.administrators', {
      url: '/admins',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/administration/administrators/list.html',
          controller: 'AdministratorsController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('administration_resource','GET')
        }
      },
      bodyClass: 'profile'
    });

    //$translatePartialLoaderProvider.addPart('app/main/restricted/administration/administrators');

    // Navigation
    msNavigationServiceProvider.saveItem('Administration.administrators', {
      title: 'Administrators',
      icon: 'icon-account',
      state: 'app.restricted.administrators',
      translate  : 'ADMINISTRATORS',
      weight: 6
    });

  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.administrators')
    .controller('adminDialogController', adminDialogController);

  /** @ngInject*/
  function adminDialogController($mdDialog, ExceptionHandler, user, strongAdminPassword, api, Context, Auth,$mdToast, Toast) {

    var vm = this;
    vm.flagSave = true;
    vm.allowCreate = Auth.isActionAllowed('administration_resource','POST');
    vm.allowModify = Auth.isActionAllowed('administration_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('administration_resource','DELETE');


    if(Auth.isRootAdmin()){
      vm.allowCreate = true;
      vm.allowModify = true;
      vm.allowDelete = true;

    }


    this.close = close;
    this.ok = ok;
    this.validate = validate;
    this.showPassword = showPassword;
    //this.initRoles = initRoles;
    // vm.loading = true;

    this.user = user;
    this.strongAdminPassword = strongAdminPassword;


    if (this.user.adminRoleId) {
      this.user.role = this.user.adminRoleId;
    }

    var currentState = Context.getState();
    currentState == "reseller" ? user.orgNodeId = Context.getResellerId() : user.orgNodeId = Context.getOrganizationId();
    currentState == "reseller" ? user.isReseller = true : user.isReseller = false;

    api.roles.listByOrg.query({nodeId: user.orgNodeId}, function(resp) {
      vm.adminRoles = resp;
      // vm.loading = false;

    });

    function showPassword(){
      vm.user.rePassword = vm.user.password;
    }

    function validate(){
      if(vm.user.name)
      {
        var string = vm.user.name.slice(0, vm.user.name.indexOf("@"));
        var format = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/;
        if(format.test(string))
        {
          vm.user.name= '';
        }
      }
      if(vm.user._id && vm.user.changePassword){
        if(vm.user.role && vm.user.name && vm.user.password && (vm.user.password === vm.user.rePassword) && vm.user.password.length>0 && vm.user.rePassword.length>0) return true;
      }
      else {
        if(typeof vm.user._id === 'undefined' && vm.user.password && vm.user.rePassword ){
          if(vm.user.role && vm.user.name && vm.user.password.length>0 && vm.user.rePassword.length>0 && (vm.user.password === vm.user.rePassword)) return true;
        }
        else{
          if(vm.user.role && vm.user.name && vm.user.password && vm.user._id) return true;
        }


      }
      return false;
    }

    function close() {
      $mdDialog.cancel();
    }

    function ok() {
      vm.flagSave = false;
        // vm.loading = true;
      if(!validate()){
        Toast.getEmtyErrorMsg("All fields are required");
        // vm.loading = false;
        vm.flagSave = true;
        return false;
      }

      if (vm.user._id) {
        var userFromParams = {
          _id: vm.user._id,
          email: vm.user.name,
          role: vm.user.role,
          isReseller : vm.user.isReseller,
          orgNodeId: vm.user.orgNodeId
        };
         if (vm.user.password && vm.user.password != '') {
           userFromParams.password = vm.user.password;
         }
         if(vm.user.changePassword){
           userFromParams.changePassword = true;
         }
        api.admins.updateUser.put({ id: vm.user._id }, userFromParams, function (user) {
          $mdDialog.hide(user, vm.mode);
        }, function (e) {
          vm.flagSave = true;
          ExceptionHandler.show(e);
        });
      }
      else {
        vm.user.email = vm.user.name;
        vm.user.isReseller = vm.user.isReseller;
        api.admins.newUser.save(vm.user, function (user) {
          $mdDialog.hide(user, vm.mode);
        }, function (e) {
          vm.flagSave = true;
          ExceptionHandler.show(e);
        });
      }
      // vm.loading = false;
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.reseller-manager')
    .controller('resellerManagerController', RMController);

  /** @ngInject */
  function RMController(Reseller, $mdDialog, $rootScope, Toast, ExceptionHandler, Context, Auth, orderByFilter, localStorageService, $timeout, Role, api, Config) {
    var vm = this;
   // var defaultId = '';
    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];

    vm.isActionNotAllowed = Auth.isActionNotAllowed;

    vm.allowCreate = Auth.isActionAllowed('reseller_resource','POST');
    vm.allowModify = Auth.isActionAllowed('reseller_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('reseller_resource','DELETE');

    vm.resellersList = [];
    vm.resellersData = [];
    vm.pageno = 1;

    vm.addReseller = addReseller;
    vm.editReseller = editReseller;
    vm.deleteReseller = deleteReseller;
    vm.checkResellerContext = checkResellerContext;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    vm.checkAvailableQuantity = checkAvailableQuantity;
    vm.checkDispatcherAvailableQuantity = checkDispatcherAvailableQuantity;
    vm.applyAllocation = applyAllocation;
    vm.addAllocation = addAllocation;
    vm.removeAllocation = removeAllocation;
    vm.applyDispatcherAllocation = applyDispatcherAllocation;
    vm.addDispatcherAllocation = addDispatcherAllocation;
    vm.removeDispatcherAllocation = removeDispatcherAllocation;
    vm.getData = getData;

    fillResellerList();
    //------------------------------------------------------//
    $rootScope.$$listeners.updatedResellerId =[];
    /**
     * fill subReseller list when customer choose reseller
     */
    $rootScope.$on('updatedResellerId', function () {
      fillResellerList();
    });

    /**
     * clear resellers list when customer choose organization
     */
    $rootScope.$on('updatedOrganizationId', function () {
      vm.resellers = [];
      // vm.resellersData = [];
      vm.resellerId = '';
    });

    /**
     * Fill list of resellers by current resellerId
     */
    function fillResellerList() {
      Config.getFilterList().then(function(resp){
        vm.configs = resp;
        vm.showLicenseAllocation = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_LICENSE_ALLOCATION";
        });
        if (!vm.showLicenseAllocation || !vm.showLicenseAllocation[0].value || vm.showLicenseAllocation[0].value == "0")
          vm.showLicenseAllocation = false;
        else
          vm.showLicenseAllocation = true;
        vm.resellerId = Context.getResellerId();
        if(vm.resellerId > 0)
        {
          //  vm.showLoader = true ;
        }
        vm.resellerId && Reseller.getListById(vm.resellerId)
          .then(function (list) {
            vm.resellers = list;
            // vm.resellersData = list;
            vm.parentResellerId = vm.resellers._id; //select main reseller
          // $rootScope.loadingProgress = true;
            Reseller.getById(vm.resellerId).then(function(resp){
              vm.reseller = resp[0];
              vm.allocateLimit = vm.reseller.availble_qty;
              vm.allocateDispatcherLimit = vm.reseller.dispatcher_availble_qty;
              vm.qty = vm.reseller.qty-vm.reseller.availble_qty + "/" + vm.reseller.qty;
              vm.dispatcherqty = vm.reseller.dispatcher_qty-vm.reseller.dispatcher_availble_qty + "/" + vm.reseller.dispatcher_qty;
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            });
          })
          .catch(function(e){
            vm.resellersData=[];
            // ExceptionHandler.show(e);
          })
        })
      .finally(function(){
        // vm.showLoader = false;
      });
    }
    function getData(pageno){ // This would fetch the data on page change.
        //In practice this should be in a factory.
        vm.pageno = pageno;
        vm.resellerId && Reseller.getResellersDataById(vm.resellerId,'NULL',vm.pageno,vm.recordsCount)
          .then(function (list) {
            vm.resellersData = list;
          })
          .catch(function(e){
            ExceptionHandler.show(e);
          })
        
    };
    function checkAvailableQuantity(){
      if (vm.reseller)
        return (vm.reseller.availble_qty > 0);
      else
        return false;
    }

    function checkDispatcherAvailableQuantity(){
      if (vm.reseller)
        return (vm.reseller.dispatcher_availble_qty > 0);
      else
        return false;
    }
    
    function applyAllocation(res){
      res.disableUserButton = true;
      if (res.setQty > 0){
        Reseller.allocation({parentId: vm.reseller._id, resellerId: res._id, qty: res.setQty})
        .then(function (resp) {
          vm.reseller.availble_qty = vm.reseller.availble_qty - res.setQty;
          res.qty = res.qty + res.setQty;
          res.availble_qty = res.availble_qty + res.setQty;
          res.setQty = "";
          vm.allocateLimit = vm.reseller.availble_qty;
          vm.qty = vm.reseller.qty-vm.reseller.availble_qty + "/" + vm.reseller.qty;
          vm.dispatcherqty = vm.reseller.dispatcher_qty-vm.reseller.dispatcher_availble_qty + "/" + vm.reseller.dispatcher_qty;
          res.disableUserButton = false;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
          res.disableUserButton = false;
        });
      }
      else if (res.setQty < 0){
        res.setQty = res.setQty * (-1);
        Reseller.deallocation({parentId: vm.reseller._id, resellerId: res._id, qty: res.setQty})
        .then(function (resp) {
          vm.reseller.availble_qty = vm.reseller.availble_qty + res.setQty;
          res.qty = res.qty - res.setQty;
          res.availble_qty = res.availble_qty - res.setQty;
          res.setQty = "";
          vm.allocateLimit = vm.reseller.availble_qty;
          vm.qty = vm.reseller.qty-vm.reseller.availble_qty + "/" + vm.reseller.qty;
          vm.dispatcherqty = vm.reseller.dispatcher_qty-vm.reseller.dispatcher_availble_qty + "/" + vm.reseller.dispatcher_qty;
          res.disableUserButton = false;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
          res.disableUserButton = false;
        });
      }
    }
    
    function addAllocation(res){
      Reseller.allocation({parentId: vm.reseller._id, resellerId: res._id, qty: res.setQty})
      .then(function (resp) {
        vm.reseller.availble_qty = vm.reseller.availble_qty - res.setQty;
        res.qty = res.qty + res.setQty;
        res.availble_qty = res.availble_qty + res.setQty;
        res.setQty = "";
      })
      .catch(function(e){
        ExceptionHandler.show(e);
      });
    }

    function removeAllocation(res){
      Reseller.deallocation({parentId: vm.reseller._id, resellerId: res._id, qty: res.removeQty})
      .then(function (resp) {
        vm.reseller.availble_qty = vm.reseller.availble_qty + res.removeQty;
        res.qty = res.qty - res.removeQty;
        res.availble_qty = res.availble_qty - res.removeQty;
        res.removeQty = "";
      })
      .catch(function(e){
        ExceptionHandler.show(e);
      });
    }

    function applyDispatcherAllocation(res){
      res.disableDispatcherButton = true;
      if (res.setDispatcherQty > 0){
        Reseller.allocation_dispatcher({parentId: vm.reseller._id, resellerId: res._id, qty: res.setDispatcherQty})
        .then(function (resp) {
          vm.reseller.dispatcher_availble_qty = vm.reseller.dispatcher_availble_qty - res.setDispatcherQty;
          res.dispatcher_qty = res.dispatcher_qty + res.setDispatcherQty;
          res.dispatcher_availble_qty = res.dispatcher_availble_qty + res.setDispatcherQty;
          res.setDispatcherQty = "";
          vm.allocateDispatcherLimit = vm.reseller.dispatcher_availble_qty;
          vm.qty = vm.reseller.qty-vm.reseller.availble_qty + "/" + vm.reseller.qty;
          vm.dispatcherqty = vm.reseller.dispatcher_qty-vm.reseller.dispatcher_availble_qty + "/" + vm.reseller.dispatcher_qty;
          res.disableDispatcherButton = false;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
          res.disableDispatcherButton = false;
        });
      }
      else if (res.setDispatcherQty < 0){
        res.setDispatcherQty = res.setDispatcherQty * (-1);
        Reseller.deallocation_dispatcher({parentId: vm.reseller._id, resellerId: res._id, qty: res.setDispatcherQty})
        .then(function (resp) {
          vm.reseller.dispatcher_availble_qty = vm.reseller.dispatcher_availble_qty + res.setDispatcherQty;
          res.dispatcher_qty = res.dispatcher_qty - res.setDispatcherQty;
          res.dispatcher_availble_qty = res.dispatcher_availble_qty - res.setDispatcherQty;
          res.setDispatcherQty = "";
          vm.allocateDispatcherLimit = vm.reseller.dispatcher_availble_qty;
          vm.qty = vm.reseller.qty-vm.reseller.availble_qty + "/" + vm.reseller.qty;
          vm.dispatcherqty = vm.reseller.dispatcher_qty-vm.reseller.dispatcher_availble_qty + "/" + vm.reseller.dispatcher_qty;
          res.disableDispatcherButton = false;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
          res.disableDispatcherButton = false;
        });
      }
    }

    function addDispatcherAllocation(res){
      Reseller.allocation_dispatcher({parentId: vm.reseller._id, resellerId: res._id, qty: res.setDispatcherQty})
      .then(function (resp) {
        vm.reseller.dispatcher_availble_qty = vm.reseller.dispatcher_availble_qty - res.setDispatcherQty;
        res.dispatcher_qty = res.dispatcher_qty + res.setDispatcherQty;
        res.dispatcher_availble_qty = res.dispatcher_availble_qty + res.setDispatcherQty;
        res.setDispatcherQty = "";
      })
      .catch(function(e){
        ExceptionHandler.show(e);
      });
    }

    function removeDispatcherAllocation(res){
      Reseller.deallocation_dispatcher({parentId: vm.reseller._id, resellerId: res._id, qty: res.removeDispatcherQty})
      .then(function (resp) {
        vm.reseller.dispatcher_availble_qty = vm.reseller.dispatcher_availble_qty + res.removeDispatcherQty;
        res.dispatcher_qty = res.dispatcher_qty - res.removeDispatcherQty;
        res.dispatcher_availble_qty = res.dispatcher_availble_qty - res.removeDispatcherQty;
        res.removeDispatcherQty = "";
      })
      .catch(function(e){
        ExceptionHandler.show(e);
      });
    }

    /**
     * sort subscriber list
     */
    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
      // getData(vm.pageno);
    }

    /**
     * sort reseller list
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.resellers = orderByFilter(vm.resellers,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }


    function addReseller() {
      $mdDialog.show({
        controller: 'resellerDialogController as vm',
        templateUrl: 'app/main/restricted/reseller/reseller-manager/details/reseller.details.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          reseller: {
            parentReseller: vm.resellerId
          }
        }
      })
        .then(function (reseller) {
            $rootScope.$emit("resellerListUpdated");
            //fillResellerList();
            Toast.showAdd();
      })
    }

    function editReseller(resellerId) {
      var curRes = {};
      var selectionText = "";
      if (window.getSelection) {
        selectionText = window.getSelection().toString();
      } else if (document.selection && document.selection.type != "Control") {
        selectionText = document.selection.createRange().text;
      }

      vm.popupOverlayClass = "show";
      $timeout(function(){vm.popupOverlayClass = ""},500);

      //angular.copy(reseller, curRes);
      Reseller.getById(resellerId)
        .then(function(resp){
          curRes = resp[0];

          $mdDialog.show({
            controller: 'resellerDialogController as vm',
            templateUrl: 'app/main/restricted/reseller/reseller-manager/details/reseller.details.dialog.html',
            parent: angular.element(document.body),
            multiple: true,
            clickOutsideToClose: false,
            locals: {
              reseller: curRes,
              parentResellerId: vm.parentResellerId
            }
          })
            .then(function (respReseller) {
                $rootScope.$emit("resellerListUpdated");
                //fillResellerList();
                Toast.showUpdate();
          })
        })
    }

    function deleteReseller(resellerId) {
      var confirm = Toast.getDeleteDialog();
      if(resellerId > 0){ 
        // vm.showLoader = true ;
      $mdDialog.show(confirm)
        .then(function () {
          Reseller.remove(resellerId)
            .then(function () {
              $rootScope.$emit("resellerListUpdated");
             //fillResellerList();
            //  getData(1);
              Toast.showDelete();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            });
        });
      }
    }


    function checkResellerContext(){
      var currentState = Context.getState();
      return currentState == "reseller";
    }


  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.reseller-details')
    .controller('ResellerDetailsController', resDetailsController);

  /**ngInject*/
  function resDetailsController(Context, $scope, $rootScope, $q, $translate, Toast, ExceptionHandler, License, Reseller, localStorageService, Auth, Site, orderByFilter, $mdDialog, $mdToast, Config, CONSTANT, Branding, $http) {
    var vm = this;

    //vm.licenses = [];
    vm.sites = [];
    vm.reseller = {};
    vm.activeTab = 0;
    vm.flagSave = true;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];
    vm.services = CONSTANT ? CONSTANT.SERVICES_SMS.split(',') : '';//['Nexmo', 'Partner'];

    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;

    vm.allowCreate = Auth.isActionAllowed('reseller_resource', 'POST');
    vm.allowModify = Auth.isActionAllowed('reseller_resource', 'PUT');
    vm.allowDelete = Auth.isActionAllowed('reseller_resource', 'DELETE');
    vm.isRootReseller = false;

    vm.enable_max_login_retries = false;
    vm.enable_password_expiration_days = false;

    vm.saveReseller = saveReseller;
    //vm.addAllocation = addAllocation;
    //vm.revokeAllocation = revokeAllocation;
    vm.isRootReseller = isRootReseller;
    vm.onTabChanges = onTabChanges;
    vm.checkTabIndex = checkTabIndex;
    vm.setRecordsCount = setRecordsCount;
    vm.saveOBrandingInfo = saveOBrandingInfo;
    vm.resetAllOverrideValues = resetAllOverrideValues;
    //vm.editLicense = editLicense;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;

    vm.resellerId = Context.getResellerId();
    if (vm.resellerId) {
      setResellerValue();
    }

    $rootScope.$$listeners.updatedResellerId = [];

    $rootScope.$on('updatedResellerId', function () {
      setResellerValue();
      init();
    });

    $rootScope.$on('clearResellerId', function () {
      vm.reseller = {};
    });

    init();
    //---------------------------------------------------------

    function init() {
      vm.resellerId = Context.getResellerId();
      vm.image = "";
      vm.image_mdc_logo = "";
      vm.image_mdc_splash = "";
      vm.image_mdc_companyName = "";
      vm.management_portal_image = "";
      vm.brand = {};
      if(!vm.services)
        {
          vm.services = CONSTANT.SERVICES_SMS.split(',');
        }
      getSites();
      getConfig();
      getBranding();
    }
    function saveReseller() {
      vm.flagSave = false;
      vm.reseller.max_login_retries = !vm.enable_max_login_retries ? null : vm.reseller.max_login_retries;
      vm.reseller.password_expiration_days = !vm.enable_password_expiration_days ? null : vm.reseller.password_expiration_days;

      if (!vm.reseller.max_login_retries || vm.reseller.max_login_retries == 0){
        vm.enable_max_login_retries = 0;
        vm.reseller.max_login_retries = null;
      }
      if (!vm.reseller.password_expiration_days || vm.reseller.password_expiration_days == 0){
        vm.enable_password_expiration_days = 0;
        vm.reseller.password_expiration_days = null;
      }

      Reseller.update(vm.reseller).then(function () {
        Toast.showUpdate();
        vm.flagSave = true;
      })
        .catch(function (e) {
          vm.flagSave = true;
          ExceptionHandler.show(e);
        });
    }

    function setResellerValue() {
      if (Context.getResellerId()){ 
        // vm.showLoader = true;
      }
      if (Context.getResellerId) {
        Reseller.getById(Context.getResellerId()).then(function (resp) {
          vm.reseller = resp[0];
          vm.qty = vm.reseller.qty - vm.reseller.availble_qty + "/" + vm.reseller.qty;
          vm.dispatcherqty = vm.reseller.dispatcher_qty - vm.reseller.dispatcher_availble_qty + "/" + vm.reseller.dispatcher_qty;
          if (!vm.reseller.sms) {
            vm.reseller.sms = {};
            if (!vm.reseller.sms.service)
              vm.reseller.sms.service = "Nexmo";
          }
          vm.reseller.max_login_retries = vm.reseller.max_login_retries ? vm.reseller.max_login_retries.toString() : null;
          vm.reseller.password_expiration_days = vm.reseller.password_expiration_days ? vm.reseller.password_expiration_days.toString() : null;

          vm.enable_max_login_retries = vm.reseller.max_login_retries ? true : false;
          vm.enable_password_expiration_days = vm.reseller.password_expiration_days ? true : false;
        })
          .catch(function (e) {
            ExceptionHandler.show(e);
          });
        //setLicense(Context.getResellerId());  //shahar- remove license
        // vm.showLoader = false;
      }
    }

    // function setLicense(resellerId){  //shahar- remove license
    //   License.getAllocationList(resellerId)
    //     .then(function (resp) {
    //       vm.licenses = resp;
    //       console.log(resp[0]._id);
    //     })
    //     .catch(function(e){
    //       ExceptionHandler.log(e);
    //     })
    //     .finally(function(){
    //       vm.showLoader = false;
    //     });
    // }

    function isRootReseller() {
      if (vm.reseller && vm.reseller.level == 1 && vm.reseller.parentReseller == null) {
        return true;
      }
      else {
        return false;
      }
    }
    // function addAllocation(){  //shahar- remove license
    //   $mdDialog.show({
    //     controller: 'resellerAllocationDialogController as vm',
    //     templateUrl: 'app/main/restricted/reseller/reseller-details/allocation/reseller.allocation.html',
    //     parent: angular.element(document.body),
    //     clickOutsideToClose: false,
    //     locals: {
    //       allocation: {
    //         initiateToOrgNodeId: vm.reseller._id
    //       }
    //     }
    //   }).then(function (allocation) {
    //         License.addAllocation(allocation)
    //           .then(function(resp){
    //             console.log(resp);
    //             setResellerValue();
    //             $mdToast.show(
    //               $mdToast.simple()
    //                 .textContent($translate.instant("LICENSE_TOAST_ALLOCATION_SUCCESS"))
    //                 .position("Top right")
    //                 .hideDelay(3000)
    //             );
    //         });

    //   })
    //     .catch(function(e){
    //       ExceptionHandler.show(e);
    //     })
    // }

    // function revokeAllocation(allocationId){  //shahar- remove license
    //   License.revokeAllocationAtReseller(allocationId)
    //     .then(function(resp){
    //       setResellerValue();
    //       Toast.showRevoke();
    //     })
    //     .catch(function(e){
    //       if(e.data.msg === 'failed'){
    //         Toast.showFailedRevoke();
    //       }else{
    //         ExceptionHandler.show(e);
    //       }
    //     })
    // }

    function getSites() {
      Site.getList()
        .then(function (resp) {
          vm.sites = resp;
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
          ExceptionHandler.log(e);
        });
    }

    function getConfig() {
      Config.getFilterList().then(function (resp) {
        vm.configs = resp;
        var showSms = vm.configs.filter(function (param) {
          return param.name == "PROV_SHOW_SMS";
        });
        if (!showSms || !showSms[0].value || showSms[0].value == "0")
          vm.showSms = false;
        else
          vm.showSms = true;

        vm.showLicenseAllocation = vm.configs.filter(function (param) {
          return param.name == "PROV_SHOW_LICENSE_ALLOCATION";
        });

        if (!vm.showLicenseAllocation || !vm.showLicenseAllocation[0].value || vm.showLicenseAllocation[0].value == "0")
          vm.showLicenseAllocation = false;
        else
          vm.showLicenseAllocation = true;

        vm.showBranding = vm.configs.filter(function (param) {
          return param.name == "PROV_SHOW_BRANDING";
        });

        if (!vm.showBranding || !vm.showBranding[0] || vm.showBranding[0].value == "0")
          vm.showBranding = false;
        else
          vm.showBranding = true;

        vm.showStrongAdministratorPass = vm.configs.filter(function (param) {
          return param.name == "PROV_SHOW_STRONG_ADMINISTRATOR_PASS";
        });
        if (!vm.showStrongAdministratorPass || !vm.showStrongAdministratorPass[0] || vm.showStrongAdministratorPass[0].value == "0")
          vm.showStrongAdministratorPass = false;
        else
          vm.showStrongAdministratorPass = true;

        vm.showMaxRetries = vm.configs.filter(function (param) {
          return param.name == "PROV_SHOW_BLOCK_RELEASE";
        });
        if (!vm.showMaxRetries || !vm.showMaxRetries[0] || vm.showMaxRetries[0].value == "0")
          vm.showMaxRetries = false;
        else
          vm.showMaxRetries = true;
  
        vm.showPasswordExpiration = vm.configs.filter(function (param) {
          return param.name == "PROV_SHOW_CHANGE_PASSWORD";
        });
        if (!vm.showPasswordExpiration || !vm.showPasswordExpiration[0] || vm.showPasswordExpiration[0].value == "0")
          vm.showPasswordExpiration = false;
        else
          vm.showPasswordExpiration = true;
      });
    }

    function getBranding() {
      if (vm.resellerId) {
        Branding.getBrandingInfo(vm.resellerId)
          .then(function (respBrand) {
            vm.brand = respBrand;
          })
          .catch(function (e) {
            if (e.status !== 404)
              ExceptionHandler.show(e);
          });


        var flowFunctionsArray = [];

        flowFunctionsArray.push(getBrandingImage(vm.resellerId));
        flowFunctionsArray.push(getImage(vm.resellerId, "Logo"));
        flowFunctionsArray.push(getImage(vm.resellerId, "Splash"));
        flowFunctionsArray.push(getImage(vm.resellerId, "CompanyName"));
        flowFunctionsArray.push(getImage(vm.resellerId, "ManagementPortal"));

        $q.all(flowFunctionsArray)
          .then(function () {
          })
          .catch(function (err) {
            ExceptionHandler.show(err);
          });
      }
    }

    function getBrandingImage(resellerId) {
      var deferred = $q.defer();
      Branding.getBrandingImage(resellerId)
        .then(function (respBrandImg) {
          vm.image = "";
          if (typeof respBrandImg.image !== 'undefined') {
            vm.image = respBrandImg.image;
          }
          deferred.resolve();
        })
        .catch(function (e) {
          deferred.reject(e);
        });
      return deferred.promise;
    }

    function getImage(resellerId, type) {
      var deferred = $q.defer();
      Branding.getBrandingExtraImage(resellerId, type)
        .then(function (respBrandImg) {
          if (typeof respBrandImg.image !== 'undefined') {
            if (type == "Logo")
              vm.image_mdc_logo = respBrandImg.image;
            else if (type == "Splash")
              vm.image_mdc_splash = respBrandImg.image;
            else if (type == "CompanyName")
              vm.image_mdc_companyName = respBrandImg.image;
            else if (type == "ManagementPortal")
              vm.management_portal_image = respBrandImg.image;
          }
          deferred.resolve();
        })
        .catch(function (e) {
          deferred.reject(e);
        });
      return deferred.promise;
    }


    function onTabChanges(index) {
      vm.activeTab = index;
    }

    function checkTabIndex(index) {
      return vm.activeTab == index;
    }

    function setRecordsCount() {
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    // function editLicense(license, allocationId) {   //shahar- remove license
    //   var curRes = {};
    //   angular.copy(license, curRes);
    //   if (curRes.licenseBundle.dispatcher.dispatcher === undefined){
    //     if (curRes.licenseBundle.dispatcher === false)
    //     {
    //       curRes.licenseBundle.dispatcher = {
    //         dispatcher: false,
    //         multiSession: "0"
    //       };
    //     }
    //     else
    //     {
    //       curRes.licenseBundle.dispatcher = {
    //         dispatcher: true,
    //         multiSession: "1"
    //       };
    //     }
    // }

    //   $mdDialog.show({
    //     controller: 'licenseDetailsController as vm',
    //     templateUrl: 'app/main/restricted/platform/licenses/details/details.dialog.html',
    //     parent: angular.element(document.body),
    //     clickOutsideToClose: false,
    //     multiple: true,
    //     locals: {
    //       license: curRes.licenseBundle,
    //       allocationId: null
    //     }
    //   })
    //     .then(function (respLicense) {
    //       angular.copy(respLicense, license);

    //     })

    // }

    function sort(param) {
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.licenses = orderByFilter(vm.licenses, param, vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param) {
      return vm.reverse[param] ? "up" : "down";
    }

    function saveOBranding() {
      // vm.loading = true;

      var flowFunctionsArray = [];

      if (file.files.length === 0 && vm.brand.override_branding_image && !vm.image)
        vm.brand.override_branding_image = false;
      if (file.files.length > 0)
        flowFunctionsArray.push(uploadBrandingImage(file, vm.resellerId))

      if (file_mdc_logo.files.length === 0 && vm.brand.override_mdc_logo_image && !vm.image_mdc_logo)
        vm.brand.override_mdc_logo_image = false;
      if (file_mdc_logo.files.length > 0)
        flowFunctionsArray.push(uploadImage(file_mdc_logo, vm.resellerId, "Logo"))

      if (file_mdc_splash.files.length === 0 && vm.brand.override_mdc_splash_image && !vm.image_mdc_splash)
        vm.brand.override_mdc_splash_image = false;
      if (file_mdc_splash.files.length > 0)
        flowFunctionsArray.push(uploadImage(file_mdc_splash, vm.resellerId, "Splash"))

      if (file_mdc_companyName.files.length === 0 && vm.brand.override_mdc_companyName_image && !vm.image_mdc_companyName)
        vm.brand.override_mdc_companyName_image = false;
      if (file_mdc_companyName.files.length > 0)
        flowFunctionsArray.push(uploadImage(file_mdc_companyName, vm.resellerId, "CompanyName"))

      if (management_portal_logo.files.length === 0 && vm.brand.override_management_portal_image && !vm.management_portal_image)
        vm.brand.override_management_portal_image = false;
      if (management_portal_logo.files.length > 0)
        flowFunctionsArray.push(uploadImage(management_portal_logo, vm.resellerId, "ManagementPortal"))


      $q.all(flowFunctionsArray)
        .then(function () {
          $rootScope.$emit('upadatebranding');
          // vm.loading = false;
          Toast.showUpdate();
        })
        .catch(function (err) {
          // vm.loading = false;
          ExceptionHandler.show(err);
        });
    }

    function saveOBrandingInfo() {
      // vm.loading = true;

      var regexp = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

      if (!vm.brand.name)
        vm.brand.override_branding_name = false;

      Branding.setBrandingInfo(vm.brand, vm.resellerId)
        .then(function () {
          saveOBranding();
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
          // vm.loading = false;
        });

    }

    function uploadBrandingImage(file, resellerId) {
      var deferred = $q.defer();

      var fd = new FormData();
      fd.append('file', file.files[0]);

      Branding.setBrandingImage(fd, resellerId)
        .then(function (result) {
          Branding.getBrandingImage(resellerId)
            .then(function (respBrandImg) {
              vm.image = respBrandImg.image;
              deferred.resolve();
            })
            .catch(function (e) {
              deferred.reject(e);
            });
        })
        .catch(function (e) {
          deferred.reject(e);
        });

      return deferred.promise;
    }

    function uploadImage(file, resellerId, type) {
      var deferred = $q.defer();

      var fd = new FormData();
      fd.append('file', file.files[0]);

      Branding.setBrandingExtraImage(fd, resellerId, type)
        .then(function (result) {
          Branding.getBrandingExtraImage(resellerId, type)
            .then(function (respBrandImg) {
              if (type == "Logo")
                vm.image_mdc_logo = respBrandImg.image;
              else if (type == "Splash")
                vm.image_mdc_splash = respBrandImg.image;
              else if (type == "CompanyName")
                vm.image_mdc_companyName = respBrandImg.image;
              else if (type == "ManagementPortal")
                vm.management_portal_image = respBrandImg.image;
              deferred.resolve();
            })
            .catch(function (e) {
              deferred.reject(e);
            });
        })
        .catch(function (e) {
          deferred.reject(e);
        });

      return deferred.promise;
    }


    function resetAllOverrideValues() {
      vm.brand.override_branding_name = false;
      vm.brand.override_branding_color1 = false;
      vm.brand.override_branding_color2 = false;
      vm.brand.override_branding_image = false;
      vm.brand.override_mdc_logo_image = false;
      vm.brand.override_mdc_splash_image = false;
      vm.brand.override_mdc_companyName_image = false;
      vm.brand.override_management_portal_image = false;
    }

    $scope.onUploadFile = function (elem) {
      if (elem.files && elem.files.length > 0) {
        var ext = elem.files[0].name.split('.');
        if (!elem.accept.includes(ext[ext.length - 1])) {
          if (elem.name == "file")
            vm.resellerFormBranding.file.$setValidity('validationError', false);
          if (elem.name == "file_mdc_logo")
            vm.resellerFormBranding.file_mdc_logo.$setValidity('validationError', false);
          if (elem.name == "file_mdc_splash")
            vm.resellerFormBranding.file_mdc_splash.$setValidity('validationError', false);
          if (elem.name == "file_mdc_companyName")
            vm.resellerFormBranding.file_mdc_companyName.$setValidity('validationError', false);
          if (elem.name == "file_management_portal")
            vm.resellerFormBranding.management_portal_logo.$setValidity('validationError', false);
        }
        else {
          if (elem.name == "file")
            vm.resellerFormBranding.file.$setValidity('validationError', true);
          if (elem.name == "file_mdc_logo")
            vm.resellerFormBranding.file_mdc_logo.$setValidity('validationError', true);
          if (elem.name == "file_mdc_splash")
            vm.resellerFormBranding.file_mdc_splash.$setValidity('validationError', true);
          if (elem.name == "file_mdc_companyName")
            vm.resellerFormBranding.file_mdc_companyName.$setValidity('validationError', true);
          if (elem.name == "file_management_portal")
            vm.resellerFormBranding.management_portal_logo.$setValidity('validationError', true);
        }
      }
      else {
        if (elem.name == "file")
          vm.resellerFormBranding.file.$setValidity('validationError', true);
        if (elem.name == "file_mdc_logo")
          vm.resellerFormBranding.file_mdc_logo.$setValidity('validationError', true);
        if (elem.name == "file_mdc_splash")
          vm.resellerFormBranding.file_mdc_splash.$setValidity('validationError', true);
        if (elem.name == "file_mdc_companyName")
          vm.resellerFormBranding.file_mdc_companyName.$setValidity('validationError', true);
        if (elem.name == "file_management_portal")
          vm.resellerFormBranding.management_portal_logo.$setValidity('validationError', true);
      }
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.organization-manager')
    .controller('OrganizationManagerController', OMController);
  /** @ngInject */
  function OMController(Organization, Reseller, $mdDialog, Toast, ExceptionHandler, Role, api, resellers, Context, $rootScope, Auth, orderByFilter, localStorageService, $timeout, Config) {
    var vm = this;
    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];
    vm.isActionNotAllowed = Auth.isActionNotAllowed;
    vm.allowCreate = Auth.isActionAllowed('organization_resource','POST');
    vm.allowModify = Auth.isActionAllowed('organization_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('organization_resource','DELETE');
    // Data
    vm.resellersList = resellers;
    vm.parentResellerId = vm.resellersList[0]._id;
    vm.resellerSite = vm.resellersList[0].site;
    vm.addOrganization = addOrganization;
    vm.editOrganization = editOrganization;
    vm.deleteOrganization = deleteOrganization;
    vm.checkResellerContext = checkResellerContext;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

    vm.checkAvailableQuantity = checkAvailableQuantity;
    vm.checkDispatcherAvailableQuantity = checkDispatcherAvailableQuantity;
    vm.addAllocation = addAllocation;
    vm.applyAllocation = applyAllocation;
    vm.removeAllocation = removeAllocation;
    vm.applyDispatcherAllocation = applyDispatcherAllocation;
    vm.addDispatcherAllocation = addDispatcherAllocation;
    vm.removeDispatcherAllocation = removeDispatcherAllocation;
    vm.setActiveAllocation = setActiveAllocation;
    vm.checkActiveAllocation = checkActiveAllocation;
    vm.activeAllocation = "";
    vm.secondary_site='';
    // vm.loading = true ;
    fillOrganizationList();
    getSecondarySiteId();

    //=================================================/
    $rootScope.$$listeners.updatedResellerId =[];
    /**
     * fill organization list when customer choose reseller
     */
    $rootScope.$on('updatedResellerId', function () {
      fillOrganizationList();
    });
    /**
     * Fill organization list by current reseller Id
     */
    function fillOrganizationList() {
      // vm.showLoader = true;
      // vm.loading = true;
      if(Context.getResellerId()!=''){
        Config.getFilterList().then(function(resp){
          vm.configs = resp;
          vm.showLicenseAllocation = vm.configs.filter(function(param){
            return param.name == "PROV_SHOW_LICENSE_ALLOCATION";
          });
          if (!vm.showLicenseAllocation || !vm.showLicenseAllocation[0].value || vm.showLicenseAllocation[0].value == "0")
            vm.showLicenseAllocation = false;
          else
            vm.showLicenseAllocation = true;

          vm.showDemoOrganization = vm.configs.filter(function(param){
            return param.name == "PROV_SHOW_DEMO_ORGANIZATION";
          });
          if (!vm.showDemoOrganization || !vm.showDemoOrganization[0].value || vm.showDemoOrganization[0].value == "0")
            vm.showDemoOrganization = false;
          else
            vm.showDemoOrganization = true;

          vm.parentResellerId = Context.getResellerId();
          if(vm.parentResellerId > 0) vm.showLoader = false;
          vm.parentResellerId && Organization.getListOrgByReseller(vm.parentResellerId)
            .then(function (resp) {
              vm.organisations = resp;
              sort(vm.sort('name'));
              if(vm.organisations.length>0)
              {
                vm.secondary_site = vm.organisations[0].site;
              }
              Reseller.getById(vm.parentResellerId).then(function(resp){
                vm.reseller = resp[0];
                vm.allocateLimit = vm.reseller.availble_qty;
                vm.allocateDispatcherLimit = vm.reseller.dispatcher_availble_qty;

                vm.qty = vm.reseller.qty-vm.reseller.availble_qty + "/" + vm.reseller.qty;
                vm.dispatcherqty = vm.reseller.dispatcher_qty-vm.reseller.dispatcher_availble_qty + "/" + vm.reseller.dispatcher_qty;

              })
              .catch(function(e){
                ExceptionHandler.show(e);
              });

            })
            .catch(function(e){
              ExceptionHandler.show(e);
            })
        })
        .finally(function(){
          // vm.showLoader = false;
          // vm.loading = false;
        });
      }else{
        // vm.showLoader = false;
        // vm.loading = false;
      }
    }
    /**
     * sort subscriber list
     */
    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }
    /**
     * sort subscriber list
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.organisations = orderByFilter(vm.organisations,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    function checkAvailableQuantity(){
      if (vm.reseller)
        return (vm.reseller.availble_qty > 0);
      else
        return false;
    }

    function checkDispatcherAvailableQuantity(){
      if (vm.reseller)
        return (vm.reseller.dispatcher_availble_qty > 0);
      else
        return false;
    }

    function setActiveAllocation(allocationId){
      vm.activeAllocation = allocationId;
    }

    function checkActiveAllocation(allocationId){
      return (allocationId == vm.activeAllocation);
    }

    function applyAllocation(org){
      org.disableUserButton = true;
      if (org.setQty > 0){
        Organization.allocation({resellerId: vm.reseller._id, organizationId: org._id, qty: org.setQty})
        .then(function (resp) {
          vm.reseller.availble_qty = vm.reseller.availble_qty - org.setQty
          org.qty = org.qty + org.setQty;
          org.availble_qty = org.availble_qty + org.setQty;
          org.setQty = "";
          vm.qty = vm.reseller.qty-vm.reseller.availble_qty + "/" + vm.reseller.qty;
          vm.dispatcherqty = vm.reseller.dispatcher_qty-vm.reseller.dispatcher_availble_qty + "/" + vm.reseller.dispatcher_qty;
          vm.allocateLimit = vm.reseller.availble_qty;
          org.disableUserButton = false;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
          org.disableUserButton = false;
        });
      }
      else if (org.setQty < 0){
        org.setQty = org.setQty * (-1);
        Organization.deallocation({resellerId: vm.reseller._id, organizationId: org._id, qty: org.setQty})
        .then(function (resp) {
          vm.reseller.availble_qty = vm.reseller.availble_qty + org.setQty;
          org.qty = org.qty - org.setQty;
          org.availble_qty = org.availble_qty - org.setQty;
          org.setQty = "";
          vm.qty = vm.reseller.qty-vm.reseller.availble_qty + "/" + vm.reseller.qty;
          vm.dispatcherqty = vm.reseller.dispatcher_qty-vm.reseller.dispatcher_availble_qty + "/" + vm.reseller.dispatcher_qty;
          vm.allocateLimit = vm.reseller.availble_qty;
          org.disableUserButton = false;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
          org.disableUserButton = false;
        });
      }
    }

    function addAllocation(org){
      Organization.allocation({resellerId: vm.reseller._id, organizationId: org._id, qty: org.setQty})
      .then(function (resp) {
        vm.reseller.availble_qty = vm.reseller.availble_qty - org.setQty
        org.qty = org.qty + org.setQty;
        org.availble_qty = org.availble_qty + org.setQty;
        org.setQty = "";
      })
      .catch(function(e){
        ExceptionHandler.show(e);
      });
    }

    function removeAllocation(org){
      Organization.deallocation({resellerId: vm.reseller._id, organizationId: org._id, qty: org.removeQty})
      .then(function (resp) {
        vm.reseller.availble_qty = vm.reseller.availble_qty + org.removeQty;
        org.qty = org.qty - org.removeQty;
        org.availble_qty = org.availble_qty - org.removeQty;
        org.removeQty = "";
      })
      .catch(function(e){
        ExceptionHandler.show(e);
      });
    }

    function applyDispatcherAllocation(org){
      org.disableDispatcherButton = true;
      if (org.setDispatcherQty > 0){
        Organization.allocation_dispatcher({resellerId: vm.reseller._id, organizationId: org._id, qty: org.setDispatcherQty})
        .then(function (resp) {
          vm.reseller.dispatcher_availble_qty = vm.reseller.dispatcher_availble_qty - org.setDispatcherQty
          org.dispatcher_qty = org.dispatcher_qty + org.setDispatcherQty;
          org.dispatcher_availble_qty = org.dispatcher_availble_qty + org.setDispatcherQty;
          org.setDispatcherQty = "";
          vm.qty = vm.reseller.qty-vm.reseller.availble_qty + "/" + vm.reseller.qty;
          vm.dispatcherqty = vm.reseller.dispatcher_qty-vm.reseller.dispatcher_availble_qty + "/" + vm.reseller.dispatcher_qty;
          vm.allocateDispatcherLimit = vm.reseller.dispatcher_availble_qty;
          org.disableDispatcherButton = false;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
          org.disableDispatcherButton = false;
        });
      }
      else if (org.setDispatcherQty < 0){
        org.setDispatcherQty = org.setDispatcherQty * (-1);
        Organization.deallocation_dispatcher({resellerId: vm.reseller._id, organizationId: org._id, qty: org.setDispatcherQty})
        .then(function (resp) {
          vm.reseller.dispatcher_availble_qty = vm.reseller.dispatcher_availble_qty + org.setDispatcherQty;
          org.dispatcher_qty = org.dispatcher_qty - org.setDispatcherQty;
          org.dispatcher_availble_qty = org.dispatcher_availble_qty - org.setDispatcherQty;
          org.setDispatcherQty = "";
          vm.qty = vm.reseller.qty-vm.reseller.availble_qty + "/" + vm.reseller.qty;
          vm.dispatcherqty = vm.reseller.dispatcher_qty-vm.reseller.dispatcher_availble_qty + "/" + vm.reseller.dispatcher_qty;
          vm.allocateDispatcherLimit = vm.reseller.dispatcher_availble_qty;
          org.disableDispatcherButton = false;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
          org.disableDispatcherButton = false;
        });
      }
    }

    function addDispatcherAllocation(org){
      Organization.allocation_dispatcher({resellerId: vm.reseller._id, organizationId: org._id, qty: org.setDispatcherQty})
      .then(function (resp) {
        vm.reseller.dispatcher_availble_qty = vm.reseller.dispatcher_availble_qty - org.setDispatcherQty
        org.dispatcher_qty = org.dispatcher_qty + org.setDispatcherQty;
        org.dispatcher_availble_qty = org.dispatcher_availble_qty + org.setDispatcherQty;
        org.setDispatcherQty = "";
      })
      .catch(function(e){
        ExceptionHandler.show(e);
      });
    }

    function removeDispatcherAllocation(org){
      Organization.deallocation_dispatcher({resellerId: vm.reseller._id, organizationId: org._id, qty: org.removeDispatcherQty})
      .then(function (resp) {
        vm.reseller.dispatcher_availble_qty = vm.reseller.dispatcher_availble_qty + org.removeDispatcherQty;
        org.dispatcher_qty = org.dispatcher_qty - org.removeDispatcherQty;
        org.dispatcher_availble_qty = org.dispatcher_availble_qty - org.removeDispatcherQty;
        org.removeDispatcherQty = "";
      })
      .catch(function(e){
        ExceptionHandler.show(e);
      });


      // vm.reseller.availble_qty = vm.reseller.availble_qty + org.removeQty;
      // Reseller.update(vm.reseller)
      // .then(function(){
      //   org.qty = org.qty - org.removeQty;
      //   org.availble_qty = org.availble_qty - org.removeQty;
      //   Organization.update(org)
      //   .then(function (resp) {
      //     org.removeQty = "";
      //   })
      //   .catch(function(e){
      //     ExceptionHandler.show(e);
      //   });
      // })
      // .catch(function(e){
      //   ExceptionHandler.show(e);
      // });
    }

    /**
     * clear organization list when customer choose organization on header menu
     */
    $rootScope.$on('updatedOrganizationId', function () {
      vm.organisations = [];
    });

    function getSecondarySiteId(){
      vm.secondary_site ='';
      if(vm.organisations)
      {
        vm.secondary_site = vm.organisations[0].site;
      }
      else
      {
        if(vm.resellersList[0].children.length > 0 && vm.resellersList[0].children[0] != '')
        {
          vm.secondary_site = vm.resellersList[0].children[0].site;
          // Organization.getListByReseller(vm.resellersList[0].children[0]._id).then(function(resp){
          //   vm.secondary_site = resp[0].site;
          // }).catch(function(e){
          //   ExceptionHandler.show(e);
          // });
        }
        else 
        {
          Organization.getListByReseller(vm.resellersList[0]._id).then(function(resp){
            if(resp.length > 0 && resp[0].site)
            vm.secondary_site = resp[0].site;
            else
            vm.secondary_site = vm.resellersList[0].site;
          }).catch(function(e){
            ExceptionHandler.show(e);
          });
        }
      }
    }

    function addOrganization() {
      if(!vm.secondary_site)
      {
        vm.secondary_site = vm.reseller.site;
      }
      if(vm.secondary_site !='')
      {
        $mdDialog.show({
          controller: 'organizationDialogController as vm',
          templateUrl: 'app/main/restricted/reseller/organization-manager/details/organization.details.dialog.html',
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          locals: {
            organization: {
              parentReseller: vm.parentResellerId,
              site: vm.reseller.site,
              secondary_site_id: vm.secondary_site
            },
            resellerSite:  vm.resellerSite,
            configs: vm.configs
          }
        }).then(function (organization) {
          $rootScope.$emit("updatedResellerIdFromSearch");
          //fillOrganizationList();

          //Add default organization roles
          // var orgAdminRole = {
          //   name: "Organization Admin Role",
          //   orgNodeId: organization._id,
          //   permissions: Role.getOrgAdminPermissions()
          // };
          // var orgViewerRole = {
          //   name: "Organization Viewer Role",
          //   orgNodeId: organization._id,
          //   permissions: Role.getOrgViewerPermissions()
          // };
          // var dispatcherRole = {
          //   name: "Dispatcher Role",
          //   orgNodeId: organization._id,
          //   permissions: Role.getDispatcherPermissions()
          // };
          // var superDispatcherRole = {
          //   name: "Super Dispatcher Role",
          //   orgNodeId: organization._id,
          //   permissions: Role.getSuperDispatcherPermissions()
          // };
          // var powerUserRole = {
          //   name: "Power Subscriber",
          //   orgNodeId: organization._id,
          //   permissions: Role.getPowerUserPermissions()
          // };
          // var screenlessUserRole = {
          //   name: "Screenless Subscriber",
          //   orgNodeId: organization._id,
          //   permissions: Role.getScreenlessUserPermissions()
          // };
          // var restrictedUserRole = {
          //   name: "Restricted Subscriber",
          //   orgNodeId: organization._id,
          //   permissions: Role.getRestrictedUserPermissions()
          // };
          // var regularUserRole = {
          //   name: "Regular Subscriber",
          //   orgNodeId: organization._id,
          //   permissions: Role.getRegularUserPermissions()
          // };
          // var regularEncryptedUserRole = {
          //   name: "Regular Encrypted Subscriber",
          //   orgNodeId: organization._id,
          //   permissions: Role.getRegularEncryptedUserPermissions()
          // };
          // var regularMultichannelUserRole = {
          //   name: "Regular Multichannel Subscriber",
          //   orgNodeId: organization._id,
          //   permissions: Role.getRegularMultichannelUserPermissions()
          // };
          // var regularSmartphoneUserRole = {
          //   name: "Regular Smartphone Subscriber",
          //   orgNodeId: organization._id,
          //   permissions: Role.getRegularSmartphoneUserPermissions()
          // };
          Toast.showAdd();
          /*Role.addDefaultRoles(organization._id)
            .then(function(result){
              console.log("Default 1st result : "+result);
              if(result){

                Role.defaultRolesActivityLog(organization._id)
                  .then(function(result3){
                    console.log("Default Activity log result : "+result3);
                    vm.loading = false;
                  })
                  .catch(function(e){
                    vm.loading = false;
                    ExceptionHandler.show(e);
                  })
              }

            })
            .catch(function(e){
              vm.loading = false;
              ExceptionHandler.show(e);
            })*/
          //api.roles.defaultRoles.save({organizationId: organization._id},{});

          // addRole(orgAdminRole);
          // addRole(orgViewerRole);
          // addRole(dispatcherRole);
          // addRole(superDispatcherRole);
          // addRole(powerUserRole);
          // addRole(screenlessUserRole);
          // addRole(restrictedUserRole);
          // addRole(regularUserRole);
          // addRole(regularEncryptedUserRole);
          // addRole(regularMultichannelUserRole);
          // addRole(regularSmartphoneUserRole);
        })      
      }
    }
    function editOrganization(organizationId) {
      var curOrg = {};
      vm.popupOverlayClass = "show";
      $timeout(function(){vm.popupOverlayClass = ""},500);
      //angular.copy(organization, curOrg);
      Organization.getById(organizationId, vm.parentResellerId)
        .then(function(resp){
          curOrg = resp;
          curOrg.secondary_site_id = curOrg.site;
          curOrg.site = curOrg.primary_site_id;
          if(curOrg.secondary_site_id =='')
              curOrg.secondary_site_id = curOrg.primary_site_id;
          $mdDialog.show({
            controller: 'organizationDialogController as vm',
            templateUrl: 'app/main/restricted/reseller/organization-manager/details/organization.details.dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
              organization: curOrg,
              parentResellerId: vm.parentResellerId,
              resellerSite:  vm.resellerSite,
              configs: vm.configs
            }
          }).then(function (respOrganization) {
            $rootScope.$emit("updatedResellerIdFromSearch");
            // fillOrganizationList();
            Toast.showUpdate();
          })
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        });
    }
    function deleteOrganization(organizationId) {
      var confirm = Toast.getDeleteDialog();
      $mdDialog.show(confirm)
        .then(function () {

          api.admins.listByOrg.query({nodeId: organizationId},
            function (resp) {
              vm.adminsList = resp;
              if(vm.adminsList.length>0){
                Toast.showDeleteFail();
              }else{
                Organization.remove(organizationId)
                  .then(function () {
                    $rootScope.$emit("resellerListUpdated");
                    fillOrganizationList();
                    Toast.showDelete();
                  })
                  .catch(function(e){
                    ExceptionHandler.show(e);
                  });

              }
            },
            function(e){
              ExceptionHandler.show(e);
            });

          /*Organization.remove(organizationId)
            .then(function () {
              $rootScope.$emit("resellerListUpdated");
              fillOrganizationList();
              Toast.showDelete();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            });*/
        })
    }
    function checkResellerContext(){
      var currentState = Context.getState();
      return currentState == "reseller";
    }
    function addRole(role){
      api.roles.newRole.save(role,
        function(resRole) {
          if (role.permissions.length) {
            api.roles.updateRole.put({ id: resRole._id }, { name: role.name, permissions: role.permissions, orgNodeId:role.orgNodeId }, function (role) {
            }, function (e) {
              ExceptionHandler.show(e);
            });
          }
        }, function (e) {
          ExceptionHandler.show(e);
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.softwareManufacturers')
    .controller('softwareManufacturersController', softwareManufacturersController);

  /** @ngInject*/
  function softwareManufacturersController($mdDialog, Toast, ExceptionHandler, Manufacturer, Auth, orderByFilter, localStorageService) {
    var vm = this,
      editDialogUrl = 'app/main/restricted/platform/software-manufacturers/details/details.html';

    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];

    vm.addSoftwareM = addSoftwareM;
    vm.editSoftwareM = editSoftwareM;
    vm.deleteSoftwareM = deleteSoftwareM;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

    vm.isActionNotAllowed = Auth.isActionNotAllowed;

    vm.allowCreate = Auth.isActionAllowed('manufacturer_resource','POST');
    vm.allowModify = Auth.isActionAllowed('manufacturer_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('manufacturer_resource','DELETE');

    fillList();
//---------------------------------------------------

    function fillList() {
      vm.showLoader = true ;
      Manufacturer.getSoftList()
        .then(function (resp) {
          vm.softwareMs = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.showLoader = false;
        });
    }

    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort items list
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.softwareMs = orderByFilter(vm.softwareMs,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    function addSoftwareM() {
      $mdDialog.show({
        controller: 'smDetailsController as vm',
        templateUrl: editDialogUrl,
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          softwareM: {
            kind: 'soft'
          }
        }
      }).then(function (softwareMs) {
        fillList();
        Toast.showAdd();
      })
    }

    function editSoftwareM(softwareMs) {
      var curRes = {};

      angular.copy(softwareMs, curRes);
      curRes.kind = 'soft';

      $mdDialog.show({
        controller: 'smDetailsController as vm',
        templateUrl: editDialogUrl,
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          softwareM: curRes
        }
      }).then(function (respSoftwareM) {
          fillList();
          Toast.showUpdate();
      })
    }

    function deleteSoftwareM(softwareMsId) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          Manufacturer.removeSoft(softwareMsId)
            .then(function () {
              fillList();
              Toast.showDelete();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            })
        });
    }

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.report', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.report', {
      url: '/report',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/platform/report/report.html',
          controller: 'reportController as vm'
        }
      }
    });


    // Navigation
    msNavigationServiceProvider.saveItem('Platform.report', {
      title: 'Report',
      icon: '',
      state: 'app.restricted.report',
      translate: 'NAVIGATION_REPORT',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.report')
    .controller('reportController', reportController);



  function reportController($q, $rootScope, Report, Auth, $filter, AdminRecord) {
    var vm = this;
    vm.getBillingReport = getBillingReport;
    vm.getSystemUsersReport = getSystemUsersReport;
    vm.getRecordingAdminReport = getRecordingAdminReport;

    // vm.loading = false;
    vm.isRootReseller = isRootReseller;

    vm.exportTypeBillingReport = vm.exportTypeUsersReport = vm.exportTypeRecordingAdminReport = "excel";

    var DEFAULT_DISPATCHER_RADIO_SESSIONS = 4;
    var PERMISSIONS_MASK_NONE                  = 0x00;
    var PERMISSIONS_MASK_START_CONFERENCE      = 0x01;
    var PERMISSIONS_MASK_START_ADHOC           = 0x02;
    var PERMISSIONS_MASK_START_PRIVATE         = 0x04;
    var PERMISSIONS_MASK_START_OFFNET          = 0x08;
    var PERMISSIONS_MASK_IM                    = 0x10;
    var PERMISSIONS_MASK_GPS                   = 0x20;
    var PERMISSIONS_MASK_SOS                   = 0x40;
    var PERMISSIONS_MASK_DISPATCHER            = 0x80;
    var PERMISSIONS_MASK_PRIORITY_CALL         = 0x200;
    var PERMISSIONS_MASK_RADIO_JOIN            = 0x400;
    var PERMISSIONS_MASK_TERMINATE_CONFERENCE  = 0x010000;
    var PERMISSIONS_MASK_TERMINATE_ADHOC       = 0x020000;
    var PERMISSIONS_MASK_TERMINATE_PRIVATE     = 0x040000;
    var PERMISSIONS_MASK_TERMINATE_IM          = 0x080000;
    var PERMISSIONS_MASK_WEB_DISPATCHER        = 0x100000;

    function isRootReseller(){
      return Auth.isRootAdmin();
    }

    function exportToExcel(xlsHeader, xlsRows, filename) {
      var createXLSLFormatObj = [];
  
      createXLSLFormatObj.push(xlsHeader);
      $.each(xlsRows, function(index, value) {
          var innerRowData = [];
          $.each(value, function(ind, val) {
  
              innerRowData.push(val);
          });
          createXLSLFormatObj.push(innerRowData);
      });

      var ws_name = "ExportSheet";
  
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
  
      /* Add worksheet to workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);

      /* Write workbook and Download */
      XLSX.writeFile(wb, filename);
    }

    function getBillingReport(){
      var deferred = $q.defer();
      // vm.loading = true;
      vm.timestamp = new Date(Date.now()).toISOString();
      vm.resultLog  = "Processing...";

      var decoratorsArray = [];

      decoratorsArray.push(getOrganizationsMap());
      decoratorsArray.push(getWfmUsersMap());
      decoratorsArray.push(getLwUsersMap());
      decoratorsArray.push(getUsersMap());
      decoratorsArray.push(getUsersRuntimeMap());
      decoratorsArray.push(getUsersClientIndentifierMap());
      decoratorsArray.push(getRolesMap());

      $q.all(decoratorsArray)
        .then(function(){
          convertMapUser().then(function(){
            collectDetails_billingReport()
            .then(function(){
              formatForExport_billingReport()
              .then(function(results){
                vm.resultLog  = "Done";
                if (vm.exportTypeBillingReport == "csv")
                  deferred.resolve(results);
                else{
                  var fileHeader = ['Phone#','License','ConcurrentChannels','Recording','Encryption','IsWFMUSER','IsLWUser','VideoEnable','DebriefCenterCapability','ManDown','Kiosk','AdminState','Demo','DemoExpirationDate(YYYY/MM/DD)','CreationTime(DD/MM/YYYY, HH:MI:SS)','OrgCRMID','OrgName','Reseller','LastRegistration(DD/MM/YYYY, HH:MI:SS)', 'ChangeStateTime(DD/MM/YYYY, HH:MI:SS)'];
                  var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy_HH-mm-ss") + "-BillingReport.xlsx";
                  exportToExcel(fileHeader, results, filename);
                }
              })
                .catch(function(err){
                  deferred.reject(err);
              })
            })
            .catch(function(err){
              deferred.reject(err);
            })
          })
          .catch(function(err){
            deferred.reject(err);
          })

        })
        .catch(function(err){
          deferred.reject(err);
        });

      return deferred.promise;
    }

    function getSystemUsersReport(){
      var deferred = $q.defer();
      // vm.loading = true;
      vm.timestamp = new Date(Date.now()).toISOString();
      vm.resultLog  = "Processing...";

      var decoratorsArray = [];

      decoratorsArray.push(getOrganizationsMap());
      decoratorsArray.push(getUsersMap());
      decoratorsArray.push(getUsersRuntimeMap());
      decoratorsArray.push(getUsersClientIndentifierMap());
      decoratorsArray.push(getRolesMap());

      $q.all(decoratorsArray)
        .then(function(){
          collectDetails_systemUsersReport()
          .then(function(){
            formatForExport_systemUsersReport()
            .then(function(results){
              vm.resultLog  = "Done";
              if (vm.exportTypeUsersReport == "csv")
                deferred.resolve(results);
              else{
                var fileHeader = ['Phone#','Name','OrgCRMID','OrgName','Reseller','License','ConcurrentChannels','Recording','AdminState','ProtocolVersion','AppVersion','State','ClientType','DeviceModel','APILevel','FWversion','CreationTime(DD/MMM/YYYY, HH:MI:SS)','LastRegistration(DD/MM/YYYY, HH:MI:SS)', 'ChangeStateTime(DD/MMM/YYYY, HH:MI:SS)'];
                var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy") + "-SystemUsersReport.xlsx";
                exportToExcel(fileHeader, results, filename);
              }
            })
              .catch(function(err){
                deferred.reject(err);
            })
          })
          .catch(function(err){
            deferred.reject(err);
          })

        })
        .catch(function(err){
          deferred.reject(err);
        });

      return deferred.promise;
    }

    function getRecordingAdminReport(){
      var deferred = $q.defer();
      // vm.loading = true;
      vm.timestamp = new Date(Date.now()).toISOString();
      vm.resultLog  = "Processing...";

      var decoratorsArray = [];

      decoratorsArray.push(getOrganizationsMap());
      decoratorsArray.push(getRecordingAdmins());

      $q.all(decoratorsArray)
        .then(function(){
          formatForExport_recordingAdminsReport()
          .then(function(results){
            vm.resultLog  = "Done";
            if (vm.exportTypeRecordingAdminReport == "csv")
                deferred.resolve(results);
              else{
                var fileHeader = ['RecordingAdmin', 'OrganizationName', 'OrganizationID', 'Reseller','PlayerClientVersion'];
                var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy_HH-mm-ss") + "-RecordingAdminsReport.xlsx";
                exportToExcel(fileHeader, results, filename);
              }
          })
            .catch(function(err){
              deferred.reject(err);
          })
        })
        .catch(function(err){
          deferred.reject(err);
        });

      return deferred.promise;
    }

    function getOrganizationsMap(){
      var deferred = $q.defer();

      Report.getOrgsMap()
      .then(function(resp){
        vm.organizationsMap = resp;
        deferred.resolve();
      })
      .catch(function(err){
        deferred.reject();
      });

      return deferred.promise;
    }

    function getRecordingAdmins(){
      var deferred = $q.defer();

      AdminRecord.getAll()
      .then(function(resp){
        vm.recordingAdmins = resp;
        deferred.resolve();
      })
      .catch(function(err){
        deferred.reject();
      });

      return deferred.promise;
    }

    function getUsersMap(){
      var deferred = $q.defer();

      Report.getUsersMap()
      .then(function(resp){
        vm.usersMap = resp;
        deferred.resolve();
      })
      .catch(function(err){
        deferred.reject();
      });

      return deferred.promise;
    }

    function getWfmUsersMap(){
      var deferred = $q.defer();

      Report.getWfmUsersMap().then(function(resp){
        vm.wfmUsersMap = resp;
        deferred.resolve();
      }).catch(function(err){
        deferred.reject();
      });

      return deferred.promise;
    }

    function getLwUsersMap(){
      var deferred = $q.defer();

      Report.getLwUsersMap().then(function(resp){
        vm.lwUsersMap = resp;
        deferred.resolve();
      }).catch(function(err){
        deferred.reject();
      });

      return deferred.promise;
    }

    function getUsersRuntimeMap(){
      var deferred = $q.defer();

      Report.getUsersRuntimeMap()
      .then(function(resp){
        vm.usersRuntimeMap = resp;
        deferred.resolve();
      })
      .catch(function(err){
        deferred.reject();
      });

      return deferred.promise;
    }

    function getUsersClientIndentifierMap(){
      var deferred = $q.defer();

      Report.getUsersClientIndentifierMap()
      .then(function(resp){
        vm.usersClientIndentifierMap = resp;
        deferred.resolve();
      })
      .catch(function(err){
        deferred.reject();
      });

      return deferred.promise;
    }

    function getRolesMap(){
      var deferred = $q.defer();

      Report.getRolesMap()
      .then(function(resp){
        vm.rolesMap = resp;
        deferred.resolve();
      })
      .catch(function(err){
        deferred.reject();
      });

      return deferred.promise;
    }

    function convertMaskToName(pmask){
      switch (pmask)
      {
        case undefined: return "UNKNOWN";
        case 0: return "NONE";
        case 7: return "PTT"; //PTT
        case 459783: return "PTT"; //PTT
        case 15: return "PTT (OffNet)"; //PTT (OffNet)
        case 459791: return "PTT (OffNet)"; //PTT (OffNet)
        case 23: return "PTM"; //PTM
        case 984087: return "PTM"; //PTM
        case 31: return "PTM (OffNet)"; //PTM (OffNet)
        case 984095: return "PTM (OffNet)"; //PTM (OffNet)
        case 87: return "PTA"; //PTA
        case 984151: return "PTA"; //PTA
        case 95: return "PTA (OffNet)"; //PTA (OffNet)
        case 984159: return "PTA (OffNet)"; //PTA (OffNet)
        case 55: return "PTL"; //PTL
        case 984119: return "PTL"; //PTL
        case 59: return "PTL (OffNet)"; //PTL (OffNet)
        case 984127: return "PTL (OffNet)"; //PTL (OffNet)
        case 119: return "ALL"; //ALL
        case 984183: return "ALL"; //ALL
        case 127: return "ALL (OffNet)"; //ALL (OffNet)
        case 984191: return "ALL (OffNet)"; //ALL (OffNet)
        case 247: return "Dispatcher"; //Dispatcher
        case 984311: return "Dispatcher"; //Dispatcher
        case 255: return "Dispatcher (OffNet)"; //Dispatcher (OffNet)
        case 984831: return "Dispatcher (OffNet)"; //Dispatcher (OffNet)
        case 984215: return "Lite Dispatcher"; //Lite Dispatcher
        case 2033271: return "Web Dispatcher"; //Web Dispatcher
        case 2033399: return "Web Dispatcher"; //Web Dispatcher
        default: return getLicenseFromMsak(pmask);
      }
  }

  function getLicenseFromMsak(pmask){
    if(Boolean(pmask & PERMISSIONS_MASK_DISPATCHER)){
      if(Boolean(pmask & PERMISSIONS_MASK_START_OFFNET))
        return "Dispatcher (OffNet)";
      else
        return "Dispatcher";
    }

    else if(Boolean(pmask & PERMISSIONS_MASK_SOS) && Boolean(pmask & PERMISSIONS_MASK_GPS)){
      if(Boolean(pmask & PERMISSIONS_MASK_START_OFFNET))
        return "ALL (OffNet)";
      else
        return "ALL";
    }

    else if(Boolean(pmask & PERMISSIONS_MASK_GPS)){
      if(Boolean(pmask & PERMISSIONS_MASK_START_OFFNET))
        return "PTL (OffNet)";
      else
        return "PTL";
    }

    else if(Boolean(pmask & PERMISSIONS_MASK_SOS)){
      if(Boolean(pmask & PERMISSIONS_MASK_START_OFFNET))
        return "PTA (OffNet)";
      else
        return "PTA";
    }

    else if(Boolean(pmask & PERMISSIONS_MASK_IM)){
      if(Boolean(pmask & PERMISSIONS_MASK_START_OFFNET))
        return "PTM (OffNet)";
      else
        return "PTM";
    }

    else if(Boolean(pmask & PERMISSIONS_MASK_WEB_DISPATCHER)){
      return "Web Dispatcher";
    }

    else{
      if(Boolean(pmask & PERMISSIONS_MASK_START_OFFNET))
        return "PTT (OffNet)";
      else
        return "PTT";
    }
  }

    function convertMapUser(){
      var deferred = $q.defer();
      vm.newUserMap={};
      var keys = Object.keys(vm.usersMap);
      var wfmKeys = Object.keys(vm.wfmUsersMap);
      var lwKeys = Object.keys(vm.lwUsersMap);
      keys.forEach(function(element) {
        if(vm.usersMap[element]._id)
        {
          vm.newUserMap[element]= vm.usersMap[element];
          if(wfmKeys.indexOf(vm.usersMap[element]._id) !== -1){
            vm.newUserMap[element].isWfmUsers = vm.wfmUsersMap[vm.usersMap[element]._id].isDeleted;
          }
          else
            vm.newUserMap[element].isWfmUsers = 'true';
  
          if(lwKeys.indexOf(vm.usersMap[element]._id) !== -1)
            vm.newUserMap[element].isLwUsers = vm.lwUsersMap[vm.usersMap[element]._id].isDeleted;
          else
            vm.newUserMap[element].isLwUsers = 'true';
        }
      });
      vm.usersMap = vm.newUserMap;
      
      deferred.resolve(vm.usersMap);
      return deferred.promise;
    }
    function collectDetails_billingReport(){
      var deferred = $q.defer();
      var usersKeys = Object.keys(vm.usersMap);
      for (var i = 0 ; i < usersKeys.length; i++){
        if (/^\d+$/.test(usersKeys[i])){   //check if key incluse only numbers
          if (vm.usersMap[usersKeys[i]].admin_state == 0)
            vm.usersMap[usersKeys[i]].admin_state = "Enabled";
          else
            vm.usersMap[usersKeys[i]].admin_state = "Disabled";

          if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id]){
            vm.usersMap[usersKeys[i]].demo = vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].type == 1 ? true : false;
            vm.usersMap[usersKeys[i]].demoExpiration = vm.usersMap[usersKeys[i]].demo ? vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].demo_expiration : "";
          } 
          else
            vm.usersMap[usersKeys[i]].demo = false;

          if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id])
            vm.usersMap[usersKeys[i]].path = vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].path;
          else
            vm.usersMap[usersKeys[i]].path = "UNKNOWN";

          if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id])
            vm.usersMap[usersKeys[i]].orgName = vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].name;
          else
            vm.usersMap[usersKeys[i]].orgName = "UNKNOWN";
        
          if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id])
            vm.usersMap[usersKeys[i]].orgCrmId = vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].crmId;
          else
            vm.usersMap[usersKeys[i]].orgCrmId = "UNKNOWN";

          vm.usersMap[usersKeys[i]].licenseName = convertMaskToName(vm.usersMap[usersKeys[i]].permissions_mask);
          
          if (vm.usersMap[usersKeys[i]].permissions_mask && Boolean(vm.usersMap[usersKeys[i]].permissions_mask & PERMISSIONS_MASK_DISPATCHER)){  //if user is dispatcher- check his radio sessions and encryption
            if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)] && vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].radioSessions){
              var addBits = 0;
              if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].radioSessionsHelperA) addBits += 16;
              if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].radioSessionsHelperB) addBits += 16;
              if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].radioSessionsHelperC) addBits += 16;
              vm.usersMap[usersKeys[i]].radioSessions = vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].radioSessions + addBits;
            } 
            else
              vm.usersMap[usersKeys[i]].radioSessions = DEFAULT_DISPATCHER_RADIO_SESSIONS;

            

            if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)] && vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].dis_enable_video_call)
              vm.usersMap[usersKeys[i]].VideoEnable = 1;
            else
              vm.usersMap[usersKeys[i]].VideoEnable = 0;

            if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)] && vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].dis_debrief_center_capa)
              vm.usersMap[usersKeys[i]].DebriefCenterCapability = 1;
            else
              vm.usersMap[usersKeys[i]].DebriefCenterCapability = 0;
            // if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)] && vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].encryption_dispatcher)
            //   vm.usersMap[usersKeys[i]].encryption = 1;
            // else
              vm.usersMap[usersKeys[i]].encryption = 0;
              vm.usersMap[usersKeys[i]].man_down = 0;
          }
          else{
            vm.usersMap[usersKeys[i]].radioSessions = 0;

            if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)] && vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].man_down)
              vm.usersMap[usersKeys[i]].man_down = 1;
            else
              vm.usersMap[usersKeys[i]].man_down = 0;

            if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)] && vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].encryption_client)
              vm.usersMap[usersKeys[i]].encryption = 1;
            else
              vm.usersMap[usersKeys[i]].encryption = 0;

            if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)] && vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].enable_video_call)
              vm.usersMap[usersKeys[i]].VideoEnable = 1;
            else
              vm.usersMap[usersKeys[i]].VideoEnable = 0;

            if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)] && vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].debrief_center_capa)
              vm.usersMap[usersKeys[i]].DebriefCenterCapability = 1;
            else
              vm.usersMap[usersKeys[i]].DebriefCenterCapability = 0;
          }

          if (vm.usersRuntimeMap[vm.usersMap[usersKeys[i]].phone_number]){
            vm.usersMap[usersKeys[i]].lastRegistrationTime = vm.usersRuntimeMap[vm.usersMap[usersKeys[i]].phone_number].lastRegistrationTime;
            vm.usersMap[usersKeys[i]].kiosk = vm.usersRuntimeMap[vm.usersMap[usersKeys[i]].phone_number].clientType == 'Kiosk' ? 1 : 0;
          }
          else{
          vm.usersMap[usersKeys[i]].lastRegistrationTime = "never";
          vm.usersMap[usersKeys[i]].kiosk = 0;
          }

          if (vm.usersClientIndentifierMap[vm.usersMap[usersKeys[i]].phone_number] && !vm.usersClientIndentifierMap[vm.usersMap[usersKeys[i]].phone_number].value.includes(vm.usersMap[usersKeys[i]].phone_number))
            vm.usersMap[usersKeys[i]].sip = vm.usersClientIndentifierMap[vm.usersMap[usersKeys[i]].phone_number].value;
          else
            vm.usersMap[usersKeys[i]].sip = vm.usersMap[usersKeys[i]].phone_number;

          if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id]){
            if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].is_recorded){
              if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].recording == 0)
                vm.usersMap[usersKeys[i]].recording = 0;
              else if(vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].recording){
                var isSelective = vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].recording.is_selective;
                if (isSelective){
                  var isSelected = vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].recording.subscribers.includes(vm.usersMap[usersKeys[i]].phone_number);
                  if (isSelected){
                    vm.usersMap[usersKeys[i]].recording = 1;
                    // if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)] && vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].recording)
                    //   vm.usersMap[usersKeys[i]].recording = 1;
                    // else
                    //   vm.usersMap[usersKeys[i]].recording = 0;
                  }
                  else
                    vm.usersMap[usersKeys[i]].recording = 0;
                }
                else{
                  vm.usersMap[usersKeys[i]].recording = 1;
                  // if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)] && vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].recording)
                  //     vm.usersMap[usersKeys[i]].recording = 1;
                  // else
                  //   vm.usersMap[usersKeys[i]].recording = 0;
                }
              }
              else 
                vm.usersMap[usersKeys[i]].recording = "UNKNOWN";
            }
            else
              vm.usersMap[usersKeys[i]].recording = 0;
          }
          else
            vm.usersMap[usersKeys[i]].recording = "UNKNOWN";
        }
      }
      deferred.resolve();
      return deferred.promise;           
    }

    function collectDetails_systemUsersReport(){
      var deferred = $q.defer();
      var usersKeys = Object.keys(vm.usersMap);
      for (var i = 0 ; i < usersKeys.length; i++){
        if (/^\d+$/.test(usersKeys[i])){   //check if key incluse only numbers
          if (vm.usersMap[usersKeys[i]].admin_state == 0)
            vm.usersMap[usersKeys[i]].admin_state = "Enabled";
          else
            vm.usersMap[usersKeys[i]].admin_state = "Disabled";

          if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id])
            vm.usersMap[usersKeys[i]].path = vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].path;
          else
            vm.usersMap[usersKeys[i]].path = "UNKNOWN";

          if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id])
            vm.usersMap[usersKeys[i]].orgName = vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].name;
          else
            vm.usersMap[usersKeys[i]].orgName = "UNKNOWN";
        
          if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id])
            vm.usersMap[usersKeys[i]].orgCrmId = vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].crmId;
          else
            vm.usersMap[usersKeys[i]].orgCrmId = "UNKNOWN";

          if (vm.usersMap[usersKeys[i]].permissions_mask)
            vm.usersMap[usersKeys[i]].licenseName = convertMaskToName(vm.usersMap[usersKeys[i]].permissions_mask);
          else
            vm.usersMap[usersKeys[i]].licenseName = "UNKNOWN";
          
          if (vm.usersMap[usersKeys[i]].permissions_mask && Boolean(vm.usersMap[usersKeys[i]].permissions_mask & PERMISSIONS_MASK_DISPATCHER)){  //if user is dispatcher- check his radio sessions
            if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)] && vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].radioSessions){
              var addBits = 0;
              if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].radioSessionsHelperA) addBits += 16;
              if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].radioSessionsHelperB) addBits += 16;
              if (vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].radioSessionsHelperC) addBits += 16;
              vm.usersMap[usersKeys[i]].radioSessions = vm.rolesMap[parseInt(vm.usersMap[usersKeys[i]].adminrole_id)].radioSessions + addBits;
            } 
            else
              vm.usersMap[usersKeys[i]].radioSessions = DEFAULT_DISPATCHER_RADIO_SESSIONS;
          }
          else
            vm.usersMap[usersKeys[i]].radioSessions = 0;

          if (vm.usersRuntimeMap[vm.usersMap[usersKeys[i]].phone_number]){
            vm.usersMap[usersKeys[i]].lastRegistrationTime = vm.usersRuntimeMap[vm.usersMap[usersKeys[i]].phone_number].lastRegistrationTime;
            vm.usersMap[usersKeys[i]].protocolVersion = vm.usersRuntimeMap[vm.usersMap[usersKeys[i]].phone_number].protocolVersion || "Not Available";
            vm.usersMap[usersKeys[i]].clientVersion = vm.usersRuntimeMap[vm.usersMap[usersKeys[i]].phone_number].clientVersion || "Not Available";
            vm.usersMap[usersKeys[i]].state = vm.usersRuntimeMap[vm.usersMap[usersKeys[i]].phone_number].state || "Not Available";
            vm.usersMap[usersKeys[i]].ClientType = vm.usersRuntimeMap[vm.usersMap[usersKeys[i]].phone_number].ClientType || "Not Available";
            vm.usersMap[usersKeys[i]].DeviceModel = vm.usersRuntimeMap[vm.usersMap[usersKeys[i]].phone_number].model_name || "Not Available";
            vm.usersMap[usersKeys[i]].APILevel = vm.usersRuntimeMap[vm.usersMap[usersKeys[i]].phone_number].os_version || "Not Available";
            vm.usersMap[usersKeys[i]].FWversion = vm.usersRuntimeMap[vm.usersMap[usersKeys[i]].phone_number].fw_version || "Not Available";
          }
          else{
            vm.usersMap[usersKeys[i]].lastRegistrationTime = "never";
            vm.usersMap[usersKeys[i]].protocolVersion = "Not Available";
            vm.usersMap[usersKeys[i]].clientVersion = "Not Available";
            vm.usersMap[usersKeys[i]].state = "Not Available";
            vm.usersMap[usersKeys[i]].ClientType = "Not Available";
            vm.usersMap[usersKeys[i]].DeviceModel = "Not Available";
            vm.usersMap[usersKeys[i]].APILevel = "Not Available";
            vm.usersMap[usersKeys[i]].FWversion = "Not Available";
          }

          if (vm.usersClientIndentifierMap[vm.usersMap[usersKeys[i]].phone_number] && !vm.usersClientIndentifierMap[vm.usersMap[usersKeys[i]].phone_number].value.includes(vm.usersMap[usersKeys[i]].phone_number))
            vm.usersMap[usersKeys[i]].sip = vm.usersClientIndentifierMap[vm.usersMap[usersKeys[i]].phone_number].value;
          else
            vm.usersMap[usersKeys[i]].sip = vm.usersMap[usersKeys[i]].phone_number;

          if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id]){
            if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].is_recorded){
              if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].recording == 0)
                vm.usersMap[usersKeys[i]].recording = 0;
              else if(vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].recording){
                if (vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].recording.is_selective){
                  var isSelected = vm.organizationsMap[vm.usersMap[usersKeys[i]].organization_id].recording.subscribers.includes(vm.usersMap[usersKeys[i]].phone_number);
                  if (isSelected)
                    vm.usersMap[usersKeys[i]].recording = 1;
                  else
                    vm.usersMap[usersKeys[i]].recording = 0;
                }
                else
                  vm.usersMap[usersKeys[i]].recording = 1;
              }
              else 
                vm.usersMap[usersKeys[i]].recording = "UNKNOWN";
            }
            else
              vm.usersMap[usersKeys[i]].recording = 0;
          }
          else
            vm.usersMap[usersKeys[i]].recording = "UNKNOWN";
        }
      }
      deferred.resolve();
      return deferred.promise;           
    }

    function formatForExport_billingReport(){
      var deferred = $q.defer();
      vm.exportSubscribers = [];

      var usersKeys = Object.keys(vm.usersMap);
      for (var i = 0 ; i < usersKeys.length; i++){
        if (/^\d+$/.test(usersKeys[i])){   //check if key incluse only numbers
          var subscriber = vm.usersMap[usersKeys[i]];
          var exportSubscriber = {
            phone: subscriber.sip,
            License: subscriber.licenseName,
            ConcurrentChannels: subscriber.radioSessions,
            Recording: subscriber.recording,
            Encryption: subscriber.encryption,
            IsWFMUSER: (subscriber.isWfmUsers == false)?1:0,
            IsLWUser: (subscriber.isLwUsers == false)?1:0,
            VideoEnable: subscriber.VideoEnable,
            DebriefCenterCapability: subscriber.DebriefCenterCapability,
            ManDown: subscriber.man_down,
            Kiosk: subscriber.kiosk,
            AdminState: subscriber.admin_state,
            Demo: subscriber.demo,
            DemoExpirationDate: $filter('date')(subscriber.demoExpiration, "yyyy/MM/dd") || "",
            CreationTime: $filter('date')(subscriber.creation_time, "yyyy/MM/dd, HH:mm:ss") || 0,
            OrgCRMID: subscriber.orgCrmId,
            OrgName: subscriber.orgName,
            Reseller: subscriber.path,
            LastRegistration: $filter('date')(subscriber.lastRegistrationTime, "yyyy/MM/dd, HH:mm:ss") || 0,
            ChangeStateTime: $filter('date')(subscriber.change_state_time, "yyyy/MM/dd, HH:mm:ss") || "Not Available"
          };
          vm.exportSubscribers.push(exportSubscriber);
        }
      }
      // vm.loading = false;
      deferred.resolve(vm.exportSubscribers);
      return deferred.promise;
    }

    function formatForExport_systemUsersReport(){
      var deferred = $q.defer();
      vm.exportSubscribers = [];

      var usersKeys = Object.keys(vm.usersMap);
      for (var i = 0 ; i < usersKeys.length; i++){
        if (/^\d+$/.test(usersKeys[i])){   //check if key incluse only numbers
          var subscriber = vm.usersMap[usersKeys[i]];
          var exportSubscriber = {
            phone: subscriber.sip,
            name: subscriber.name,
            OrgCRMID: subscriber.orgCrmId,
            OrgName: subscriber.orgName,
            Reseller: subscriber.path,
            License: subscriber.licenseName,
            ConcurrentChannels: subscriber.radioSessions,
            Recording: subscriber.recording,
            AdminState: subscriber.admin_state,
            ProtocolVersion: subscriber.protocolVersion,
            appVersion: subscriber.clientVersion,
            state: subscriber.state,
            ClientType: subscriber.clientType,
            DeviceModel: subscriber.DeviceModel,
            APILevel: subscriber.APILevel,
            FWversion: subscriber.FWversion,
            CreationTime: $filter('date')(subscriber.creation_time, "yyyy/MM/dd, HH:mm:ss") || 0,
            LastRegistration: $filter('date')(subscriber.lastRegistrationTime, "yyyy/MM/dd, HH:mm:ss") || 0,
            ChangeStateTime: $filter('date')(subscriber.change_state_time, "yyyy/MM/dd, HH:mm:ss") || "Not Available"
          };
          vm.exportSubscribers.push(exportSubscriber);
        }
      }
      // vm.loading = false;
      deferred.resolve(vm.exportSubscribers);
      return deferred.promise;
    }

    function formatForExport_recordingAdminsReport(){
      var deferred = $q.defer();
      vm.exportAdmins = [];

      for (var i = 0 ; i < vm.recordingAdmins.length; i++){
          var org = vm.organizationsMap[vm.recordingAdmins[i].organization_id];
          if (org){
            var exportAdmin = {
              RecordingAdmin: vm.recordingAdmins[i].username,
              OrganizationName: org.name,
              OrganizationID: org._id,
              Reseller: org.path,
              PlayerClientVersion: vm.recordingAdmins[i].player_client_version,
            };
            vm.exportAdmins.push(exportAdmin);
        }
      }
      // vm.loading = false;
      deferred.resolve(vm.exportAdmins);
      return deferred.promise;
    }


  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.ptt-devices', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.ptt-devices', {
      url: '/ptt-devices',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/platform/ptt-devices/list.html',
          controller: 'PttDevicesController as vm'
        }
      },
      bodyClass: 'profile'
    });

   // $translatePartialLoaderProvider.addPart('app/main/restricted/platform/ptt-devices');


    // Navigation
    msNavigationServiceProvider.saveItem('Platform.ptt-devices', {
      title: 'PTT Devices',
      icon: '',
      state: 'app.restricted.ptt-devices',
      translate: 'NAVIGATION_PTT_DEVICES',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.ptt-devices')
    .controller('PttDevicesController', DevicesController);

  /*@ngInject*/
  function DevicesController($mdDialog, Toast, ExceptionHandler, PttDevice, Auth, orderByFilter, localStorageService) {
    var vm = this;

    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];

    vm.deleteDevice = deleteDevice;
    vm.addDevice = addDevice;
    vm.editDevice = editDevice;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

    vm.isActionNotAllowed = Auth.isActionNotAllowed;

    fillDeviceList();
    //---------------------------------
    function fillDeviceList() {
      vm.showLoader = true;
      PttDevice.getList()
        .then(function (resp) {
          vm.devicesList = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.showLoader = false;
        });
    }

    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.devicesList = orderByFilter(vm.devicesList,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    function addDevice() {
      $mdDialog.show({
        controller: 'pttDeviceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/ptt-devices/details/details.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          device: {}
        }
      }).then(function (device) {
        fillDeviceList();
        Toast.showAdd();
      });
    }

    function editDevice(device) {
      var curDevice = {};

      angular.copy(device, curDevice);
      $mdDialog.show({
        controller: 'pttDeviceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/ptt-devices/details/details.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          device: curDevice
        }
      }).then(function (respDevice) {
        fillDeviceList();
        Toast.showUpdate();
      });
    }

    function deleteDevice(devId) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          PttDevice.deleteItem(devId)
            .then(function () {
              fillDeviceList();
              Toast.showDelete();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            })
        });
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.ptt-client-store')
    .controller('PttStoreController', PttStoreController);

  /*@ngInject*/
  function PttStoreController($mdDialog, $mdToast,  Toast, ExceptionHandler, Device, ClientStore, orderByFilter, localStorageService) {
    var vm = this;

    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];

    vm.deleteStore = deleteStore;
    vm.addStore = addStore;
    vm.editStore = editStore;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

    fillStoreList();
    //---------------------------------
    function fillStoreList() {
      vm.showLoader = true;
      ClientStore.getList()
        .then(function (resp) {
          vm.storeList = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.showLoader = false;
        });
    }

    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.storeList = orderByFilter(vm.storeList,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    function addStore() {
      $mdDialog.show({
        controller: 'pttStoreDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/ptt-client-store/details/details.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          store: {}
        }
      }).then(function (store) {
        fillStoreList();
        Toast.showAdd();
      })
    }

    function editStore(store) {
      var curStore = {};

      angular.copy(store, curStore);
      $mdDialog.show({
        controller: 'pttStoreDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/ptt-client-store/details/details.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          store: curStore
        }
      }).then(function (respStore) {
          fillStoreList();
          Toast.showUpdate();
      })
    }


    function deleteStore(devId) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          ClientStore.delete(devId)
            .then(function (resp) {
              fillStoreList();
              Toast.showDelete();
            }).
          catch(function(e){
            ExceptionHandler.show(e);
          })
        })
    }

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.move-organization', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.move-organization', {
      url: '/move-organization',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/platform/move-organization/move.organization.html',
          controller: 'moveOrganizationController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.isMigrationAllowed()
        }
      }
    });


    // Navigation
    msNavigationServiceProvider.saveItem('Platform.move-organization', {
      title: 'Move Organization',
      icon: '',
      state: 'app.restricted.move-organization',
      translate: 'NAVIGATION_MOVEORGANIZATION',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.move-organization')
    .controller('moveOrganizationController', moveOrganizationController);



  function moveOrganizationController($q, $rootScope, Reseller , Auth, $filter, Organization, ExceptionHandler, Toast) {
    var vm = this;
 

    // vm.loading = false;
    vm.isRootReseller = isRootReseller;
    vm.isOrgAdmin = Auth.isOrgAdmin();
    vm.moveResellerId;
    vm.parentPesellerId;
    vm.moveOrgResellerId;
    vm.moveOrgParentResellerId;
    vm.moveOrgId;
    vm.oldParentId;
    vm.nameofThat;
    vm.resellersList = [];
    vm.organizations = [];
    vm.loading = false;
    vm.chooseMoveReseller = chooseMoveReseller;
    vm.chooseParentReseller = chooseParentReseller;
    vm.transferReseller = transferReseller;
    vm.transferOrganization = transferOrganization;



    function isRootReseller(){
      return Auth.isRootAdmin();
    }
   
    fillResellerList();
     
    function fillResellerList() {
      Reseller.getList()
        .then(function (resp) {
          console.log(resp)
          angular.copy(resp, vm.resellersList);
         })
        .catch(function(e){
         ExceptionHandler.show(e);
        });
    }
    function chooseMoveReseller() {
      $rootScope.loadingProgress =  true ;
      vm.moveOrgResellerId && Organization.getParentList(vm.moveOrgResellerId)
      .then(function (resp) {
        angular.copy(resp, vm.organizations);
        vm.organizations = $filter('orderBy')(vm.organizations,'name');    
        // console.log(vm.organizations)    
      })
      .catch(function(e){
        console.log(e.data.error);
        console.log(e.status);
        console.log(e.statusText);
      });
      $rootScope.loadingProgress =  false ;
    }

    function chooseParentReseller() {
      $rootScope.loadingProgress =  true ;
      var flatResellers = [];
      getChildren(vm.resellersList, flatResellers);

      function getChildren(resList, flatResellers){
        resList.map(function(res){
          flatResellers.push(res);
          if(res && res.children) getChildren(res.children, flatResellers);
        });
        return flatResellers;
      }

      var curReseller = flatResellers.filter(function (reseller) {
        return reseller._id == vm.moveResellerId;
      })[0];
      vm.oldParentId = curReseller.parentReseller;
      vm.nameofThat = curReseller.name;
      $rootScope.loadingProgress =  false ;
    }

    function transferReseller(){
      if(vm.moveResellerId && vm.oldParentId && vm.parentPesellerId && vm.nameofThat)
      {
        if(vm.oldParentId != vm.parentPesellerId)
        {
          vm.loading = true;
          var data={
            resellerId : vm.moveResellerId,
            oldParentReseller : vm.oldParentId,
            targetReseller : vm.parentPesellerId,
            name : vm.nameofThat
          }
          Organization.transferReseller(data).then(function (resp){
            console.log(resp)
            $rootScope.$emit("resellerListUpdated");
            vm.loading = false;
            Toast.showUpdate();
            fillResellerList();
            vm.moveResellerId = '';
            vm.oldParentId = '';
            vm.parentPesellerId = '';
            vm.nameofThat = '';
          }).catch(function (error){
            console.log(error)
            vm.loading = false;
            ExceptionHandler.show(error);
          });
        }
        else
          Toast.showCustom('Old Parent Reseller & Transfer Reseller Id Same!');
      }
      else
        Toast.showCustom('Please Select Source Reseller & Destination Parent Reseller!');

      console.log(data)
    }

    function transferOrganization(){
      if(vm.moveOrgResellerId && vm.moveOrgId && vm.moveOrgParentResellerId)
      {
        if(vm.moveOrgResellerId != vm.moveOrgParentResellerId)
        {
          vm.loading = true;
          var data={
            resellerId : vm.moveOrgResellerId,
            orgId : vm.moveOrgId,
            targetReseller : vm.moveOrgParentResellerId
          }
          Organization.transferOrganization(data).then(function (resp){
            console.log(resp);
            $rootScope.$emit("updatedResellerIdFromSearch");
            vm.loading = false;
            Toast.showUpdate();
            fillResellerList();
            vm.moveOrgResellerId = '';
            vm.moveOrgId = '';
            vm.moveOrgParentResellerId = '';
            vm.nameofThat = '';
          }).catch(function (error){
            console.log(error)
            vm.loading = false;
            ExceptionHandler.show(error);
          });
        }
        else
          Toast.showCustom('Old Parent Reseller & Transfer Reseller Id Same!');
      }
      else
        Toast.showCustom('Please Select Source Reseller and Organization & Destination Parent Reseller!');
      // console.log(data)
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.localization')
    .controller('localizationController', localizationController);

  /** @ngInject*/
  function localizationController($mdDialog, $translate, Toast, Config,orderByFilter, ExceptionHandler, localStorageService) {
    var vm = this;

    vm.search = '';
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];

    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    //----------------------------------------------------//

    Config.getFilterList().then(function(resp){
      vm.configs = resp;
      vm.localizationConfig = vm.configs.filter(function(param){
        return param.name === "PROV_LOCALIZATION_CONFIG";
      });
      vm.localizationConfig = vm.localizationConfig[0];
      vm.languages = JSON.parse(vm.localizationConfig.value);

      vm.defaultLanguage = vm.configs.filter(function(param){
        return param.name === "PROV_DEFAULT_LANGUAGE";
      });
      vm.defaultLanguage = vm.defaultLanguage[0];
      for(var lang in vm.languages){
        if(vm.languages.hasOwnProperty(lang)){
          lang === vm.defaultLanguage.value ? vm.languages[lang].default = true : vm.languages[lang].default = false;
        }
      }

    });


    vm.updateLanguageConfig = function(){
      vm.localizationConfig.value = JSON.stringify(vm.languages);
      Config.update(vm.localizationConfig)
        .then(function () {
          //Toast.showUpdate();
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
    };

    vm.editTranslation = function(translation){
      $mdDialog.show({
        controller: 'localizationDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/localization/details/localization.details.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          translation: translation
        }
      }).then(function (translation) {
          vm.languages[translation.code] = translation;
          vm.updateLanguageConfig();
      });
    };

    vm.deleteTranslation = function(translation){
      if(typeof vm.languages[translation.code] !== 'undefined' && vm.languages[translation.code].default === true){
        Toast.showCustom($translate.instant("LOCALIZATION_REMOVE_DEFAULT_ERROR"));
      }
      else{
        delete vm.languages[translation.code];
        vm.updateLanguageConfig();
      }
    };

    vm.addTranslation = function(){
      $mdDialog.show({
        controller: 'localizationDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/localization/details/localization.details.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          translation: {}
        }
      }).then(function (translation) {
        if(vm.languages.hasOwnProperty(translation.code)){
          Toast.showCustom($translate.instant("LOCALIZATION_ADD_DUPLICATE_ERROR"));
        }
        else{
          vm.languages[translation.code] = translation;
          vm.updateLanguageConfig();
        }

      });
    };

    vm.changeActiveState = function(translation){
        vm.languages[translation.code] = translation;
        vm.updateLanguageConfig();
    };

    vm.changeDefault = function(translation){
      vm.defaultLanguage.value = translation.code;

      for(var lang in vm.languages){
        if(vm.languages.hasOwnProperty(lang)){
          if(lang !== translation.code){
            vm.languages[lang].default = false;
          }
        }
      }

      Config.update(vm.defaultLanguage)
        .then(function () {
          Toast.showUpdate();
        })
        .catch(function(e){
        })
    };

    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort items list
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.languages = orderByFilter(vm.languages,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.licenses')
    .controller('licenseController', licenseController);

  /** @ngInject*/
  function licenseController(License, $mdDialog, Auth, orderByFilter, localStorageService) {
    var vm = this;

    vm.licenseConvert = {};
    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];

    vm.editLicense = editLicense;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

    vm.allowCreate = Auth.isActionAllowed('license_resource','POST');
    vm.allowModify = Auth.isActionAllowed('license_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('license_resource','DELETE');
    
    vm.convertToMask = convertToMask;
    vm.convertToLicense = convertToLicense;

    setDefaultPermissions();
    fillList();

    //----------------------------------------------------//

    function fillList(){
      // vm.showLoader = true ;
      License.getLicenseTemplates()
      .then(function(resp){
        vm.licensesTemplate = resp;
        // vm.showLoader = false ;
      })
      .catch(function(err){
        // vm.showLoader = false ;
      });
      
    }

    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort items list
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.licenses = orderByFilter(vm.licenses,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    function editLicense(license) {
      var curRes = {};
      angular.copy(license, curRes);

      $mdDialog.show({
        controller: 'licenseDetailsController as vm',
        templateUrl: 'app/main/restricted/platform/licenses/tabs/templates/details/details.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        multiple: true,
        locals: {
          license: curRes,
          allocationId: null
        }
      }).then(function (respLicense) {
        //fillList();
        angular.copy(respLicense, license);
       // Toast.showUpdate();
      })

    }

    function setDefaultPermissions() {
      vm.licenseConvert.conference = {
        originate: false,
        terminate: false
      };

      vm.licenseConvert.adHoc = {
        originate: false,
        terminate: false

      };

      vm.licenseConvert.private = {
        originate: false,
        terminate: false
      };

      vm.licenseConvert.im = {
        originate: false,
        terminate: false

      };

      vm.licenseConvert.radio = false;

      vm.licenseConvert.gps = false;
      vm.licenseConvert.sos = false;
      vm.licenseConvert.startOffNet = false;
      //license.dispatcher = true;
      vm.licenseConvert.dispatcher = false;
      vm.licenseConvert.priorityCall = false;
    }

    function convertToMask(){
      License.getPermissionMask(vm.licenseConvert)
      .then (function(result){
        vm.mask = result.permission_mask;
      })
      .catch(function (err){
        vm.mask = 'UNKNOWN'
      });
    }

    function convertToLicense(){
      License.getLicense(vm.mask)
      .then (function(result){
        vm.licenseConvert = result.license;
      })
      .catch(function (err){
        vm.licenseConvert = {};
      });
    }

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.job', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.job', {
      url: '/job',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/platform/job/job.html',
          controller: 'jobController as vm'
        }
      }
    });

  //  $translatePartialLoaderProvider.addPart('app/main/restricted/platform/localization');


    // Navigation
    msNavigationServiceProvider.saveItem('Platform.job', {
      title: 'Job',
      icon: '',
      state: 'app.restricted.job',
      translate: 'NAVIGATION_JOB',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.job')
    .controller('jobController', jobController);

  /** @ngInject*/
  function jobController($mdDialog, $mdToast, Job, ExceptionHandler) {
    var vm = this;
    vm.getProvisioningLogs = getProvisioningLogs;
    vm.getGpsLogs = getGpsLogs;
    vm.getMongoLogs  = getMongoLogs;
    vm.runJob = runJob;

    //----------------------------------------------------//
    vm.logs = {
      provisioning: {},
      gps: {},
      mongo: {}
    };

    vm.logsMapping =  Job.getLogsMapping();

    function runJob(id){
      Job.runJob(id).then(function(resp){
        $mdToast.show(
          $mdToast.simple()
            .textContent("resp.message")
            .position("Top right")
            .hideDelay(3000)
        );
      })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
    }
    function getProvisioningLogs(){
      getProvisioningLog(vm.logsMapping.provisioning.init, "init");
      getProvisioningLog(vm.logsMapping.provisioning.run, "run");
      getProvisioningLog(vm.logsMapping.provisioning.license, "license");
      getProvisioningLog(vm.logsMapping.provisioning.dbInit, "dbInit");
      getProvisioningLog(vm.logsMapping.provisioning.dbIntegrity, "dbIntegrity");
    }
    function getGpsLogs(){
      getGpsLog(vm.logsMapping.gpsArchiver.init, "init");
      getGpsLog(vm.logsMapping.gpsArchiver.run, "run");
    }
    function getMongoLogs(){
      getMongoLog(vm.logsMapping.mongo.init, "init");
      getMongoLog(vm.logsMapping.mongo.run, "run");
    }

   /* function getNodeLogs(){
      getMongoLog(vm.logsMapping.node.debug, "debug");
      getMongoLog(vm.logsMapping.node.node, "node");
    }*/

    function getProvisioningLog(id, name){
      Job.getLog(id)
        .then(function(resp){
          vm.logs.provisioning[name] = resp.log;
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
        });
    }

    function getGpsLog(id, name){
      Job.getLog(id)
        .then(function(resp){
          vm.logs.gps[name] = resp.log;
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
        });
    }

    function getMongoLog(id, name){
      Job.getLog(id)
        .then(function(resp){
          vm.logs.mongo[name] = resp.log;
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.deviceManufacturers')
    .controller('devicesManufacturersController', devicesManufacturersController);

  /** @ngInject*/
  function devicesManufacturersController($mdDialog, Toast, ExceptionHandler, Manufacturer, Auth, localStorageService, orderByFilter) {
    var vm = this,
      editDialogUrl = 'app/main/restricted/platform/devices-manufacturers/details/details.html';

    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];

    vm.addDeviceM = addDeviceM;
    vm.editDeviceM = editDeviceM;
    vm.deleteDeviceM = deleteDeviceM;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

    vm.allowCreate = Auth.isActionAllowed('manufacturer_resource','POST');
    vm.allowModify = Auth.isActionAllowed('manufacturer_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('manufacturer_resource','DELETE');

    vm.isActionNotAllowed = Auth.isActionNotAllowed;

    fillList();
//---------------------------------------------------

    function fillList() {
      // vm.showLoader = true;
      Manufacturer.getDeviceList()
        .then(function (resp) {
          vm.deviceMs = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.showLoader = false;
        });
    }

    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort items list
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.deviceMs = orderByFilter(vm.deviceMs,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    function addDeviceM() {
      $mdDialog.show({
        controller: 'dmDetailsController as vm',
        templateUrl: editDialogUrl,
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          deviceM: {
            kind: 'device'
          }
        }
      }).then(function (deviceMs) {
        fillList();
        Toast.showAdd();
      })
    }

    function editDeviceM(deviceMs) {
      var curRes = {};

      angular.copy(deviceMs, curRes);

      $mdDialog.show({
        controller: 'dmDetailsController as vm',
        templateUrl: editDialogUrl,
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          deviceM: curRes
        }
      }).then(function (respDeviceM) {
        fillList();
        Toast.showUpdate();
      })
    }

    function deleteDeviceM(deviceMsId) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          Manufacturer.remove(deviceMsId)
            .then(function(){
              fillList();
             Toast.showDelete();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            })
        })

    }

  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.devices')
    .controller('DevicesController', DevicesController);

  /*@ngInject*/
  function DevicesController($mdDialog, Toast, ExceptionHandler, Device, Auth, orderByFilter, localStorageService) {
    var vm = this;

    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];

    vm.deleteDevice = deleteDevice;
    vm.addDevice = addDevice;
    vm.editDevice = editDevice;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

    vm.isActionAllowed = Auth.isActionAllowed;

    vm.allowCreate = Auth.isActionAllowed('device_resource','POST');
    vm.allowModify = Auth.isActionAllowed('device_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('device_resource','DELETE');

    fillDeviceList();
    //---------------------------------

    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort items list
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.devicesList = orderByFilter(vm.devicesList,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    function fillDeviceList() {
      // vm.showLoader = true ;
      Device.getList()
        .then(function (resp) {
          vm.devicesList = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.showLoader = false;
        });
    }

    function addDevice() {
      $mdDialog.show({
        controller: 'deviceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/devices/details/details.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          device: {}
        }
      })
        .then(function (device) {
          fillDeviceList();
          Toast.showAdd();
        })
    }

    function editDevice(device) {
      var curDevice = {};

      angular.copy(device, curDevice);
      $mdDialog.show({
        controller: 'deviceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/devices/details/details.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          device: curDevice
        }
      }).then(function (respDevice) {
        fillDeviceList();
        Toast.showUpdate();
      });
    }


    function deleteDevice(devId) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          Device.deleteItem(devId)
            .then(function () {
              fillDeviceList();
              Toast.showDelete();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            })
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.server-config')
    .controller('ConfigController', ConfigController);

  /*@ngInject*/
  function ConfigController($mdDialog, $mdToast, Toast, ExceptionHandler, Config, Site, Server, localStorageService,orderByFilter,Auth,Subscriber, Organization) {
    var vm = this;
    vm.searchConfig = '';
    vm.searchSite = '';
    vm.searchServer = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverseConfig = [];
    vm.reverseSite = [];
    vm.reverseServer = [];
    vm.setRecordsCount = setRecordsCount;

    vm.deleteConfig = deleteConfig;
    vm.addConfig = addConfig;
    vm.editConfig = editConfig;
    vm.sortConfig = sortConfig;
    vm.getConfigSortingClass = getConfigSortingClass;

    vm.isRootAdmin = Auth.isRootAdmin();
    vm.userOrgId =Auth.getUserResellerId();
    vm.save = save;
    vm.addSite = addSite;
    vm.editSite = editSite;
    vm.deleteSite = deleteSite;
    vm.getSiteStateById = getSiteStateById;
    vm.sortSites = sortSites;
    vm.getSiteSortingClass = getSiteSortingClass;

    vm.addServer = addServer;
    vm.editServer = editServer;
    vm.deleteServer = deleteServer;
    vm.getServerNameById = getServerNameById;
    vm.getServerStateById = getServerStateById;
    vm.getServerAdminStateById = getServerAdminStateById;
    vm.getServerTypeById = getServerTypeById;
    vm.sortServers = sortServers;
    vm.getServerSortingClass = getServerSortingClass;

    vm.serverType = Server.getTypeList();
    vm.serverState = Server.getStateList();
    vm.siteState = Site.getStateList();
    vm.license = null;

    function GetEnvConfigurations_XML() {
      Config.getEnvConfig().then(function (resp) {
        vm.license = resp;
      }).catch(function (e) {
        vm.license = null;
      })

    }
    GetEnvConfigurations_XML();

    fillConfigList();
    getSecondarySite();
    fillServerList();

    //---------------------------------
    function fillConfigList() {
      // vm.showLoader = true ;
      Config.getFilterList()
        .then(function (resp) {
          vm.parameters = resp;
          vm.customParameters = [];
          for (var i = 0; i < vm.parameters.length; i++) {
            if (vm.parameters[i].name.indexOf("PROV_") !== -1) {
              vm.customParameters.push(vm.parameters[i]);
              vm.parameters.slice(i, 1);
              if (vm.parameters.length - 1 === i) {
                vm.parameters.pop();
              }
            }
          }
          vm.showSecondarySite = resp.filter(function (param) {
            return param.name == "PROV_SHOW_SECONDARY_SITE";
          });

          if (!vm.showSecondarySite || !vm.showSecondarySite[0] || vm.showSecondarySite[0].value == "0")
            vm.showSecondarySite = false;
          else {
            vm.showSecondarySite = true;
          }
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
        })
        .finally(function () {
          // vm.showLoader = false;
        });
    }

    function addConfig() {
      $mdDialog.show({
        controller: 'configAddDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/config/tabs/general/details/add.details.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          param: {}
        }
      })
        .then(function (config) {
          fillConfigList();
          Toast.showAdd();
        })
    }

    function editConfig(param) {
      var curParam = {};

      angular.copy(param, curParam);
      $mdDialog.show({
        controller: 'configDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/config/tabs/general/details/details.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          param: curParam
        }
      }).then(function (respParam) {
        fillConfigList();
        Toast.showUpdate();
      });
    }

    function deleteConfig(paramId) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          Config.delete(paramId)
            .then(function () {
              fillConfigList();
              Toast.showDelete();
            })
            .catch(function (e) {
              ExceptionHandler.show(e);
            });
        })
    }

    function sortConfig(param) {
      vm.reverseConfig[param] ? vm.reverseConfig[param] = false : vm.reverseConfig[param] = true;
      vm.customParameters = orderByFilter(vm.customParameters, param, vm.reverseConfig[param])
    }

    function getConfigSortingClass(param) {
      return vm.reverseConfig[param] ? "up" : "down";
    }

    //----------------Sites-----------------
    function fillSiteList() {
      Site.getList()
        .then(function (resp) {
          vm.sites = resp;
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
        });
    }
    function getSecondarySite() {
      Organization.getListOrgByReseller(vm.userOrgId)
        .then(function (resp) {
          fillSiteList();
          if (resp != '')
            vm.secondarySiteId = resp[0].site.toString()
        })
        .catch(function (e) {
          // vm.showLoader = false;
          if (e.status !== 404) { ExceptionHandler.show(e) }
        });
    }

    function getAvailableServers() {
      var usedServers = {};
      for (var i = 0; i < vm.sites.length; i++) {
        usedServers[vm.sites[i].server1] = vm.sites[i].server1;
        usedServers[vm.sites[i].server2] = vm.sites[i].server2;
      }

      var notUsedServers = [];
      for (var i = 0; i < vm.servers.length; i++) {
        if (!usedServers.hasOwnProperty(vm.servers[i]._id)) {
          notUsedServers.push(vm.servers[i]);
        }
      }
      return notUsedServers;
    }

    function checkServerPairing(servers) {
      for (var i = 0; i < servers.length; i++) {
        for (var j = 0; j < servers.length; j++) {
          if (servers[j]._id == servers[i]._id) {
            continue;
          }
          else if (servers[j].type == servers[i].type) {
            return true;
          }
        }
      }
      return false;
    }

    function addSite() {
      var availableServers = getAvailableServers();
      if (checkServerPairing(availableServers)) {
        $mdDialog.show({
          controller: 'siteDetailsController',
          controllerAs: 'vm',
          templateUrl: 'app/main/restricted/platform/config/tabs/site/details/site.dialog.html',
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          locals: {
            servers: availableServers,
            site: {
              state: 0,
              controlPort: 25000,
              audioPort: 25001
            }
          }
        })
          .then(function (site) {
            fillSiteList();
            Toast.showAdd();
          })
      }
      else {
        $mdToast.show( //TODO: refactor this with translation
          $mdToast.simple()
            .textContent('At least 2 unused servers of same kind are needed')
            .position("Top right")
            .hideDelay(3000)
        );
      }

    }

    function editSite(site) {
      var curSite = {};
      angular.copy(site, curSite);
      var availableServers = getAvailableServers();

      $mdDialog.show({
        controller: 'siteDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/config/tabs/site/details/site.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          servers: availableServers,
          site: curSite
        }
      }).then(function (respSite) {
        fillSiteList();
        Toast.showUpdate();
      });
    }

    function deleteSite(siteId) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          Site.delete(siteId)
            .then(function () {
              fillSiteList();
              Toast.showDelete();
            })
            .catch(function (e) {
              ExceptionHandler.show(e);
            })
        })
    }

    function getSiteStateById(stateId) {
      var currentState = vm.siteState.filter(function (state) {
        return parseInt(state.id) == stateId;
      });
      return currentState[0].value || "UNKNOWN";
    }

    function sortSites(param) {
      vm.reverseSite[param] ? vm.reverseSite[param] = false : vm.reverseSite[param] = true;
      vm.sites = orderByFilter(vm.sites, param, vm.reverseSite[param])
    }

    function getSiteSortingClass(param) {
      return vm.reverseSite[param] ? "up" : "down";
    }


    //----------------Servers-----------------
    function fillServerList() {
      Server.getList()
        .then(function (resp) {
          vm.servers = resp;
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
        });
    }

    function addServer() {
      $mdDialog.show({
        controller: 'serverDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/config/tabs/server/details/server.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          server: {
            state: 1,
            adminState: 1
          }
        }
      })
        .then(function (server) {
          fillServerList();
          Toast.showAdd();
        })
    }

    function editServer(server) {
      var curServer = {};

      angular.copy(server, curServer);
      $mdDialog.show({
        controller: 'serverDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/config/tabs/server/details/server.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          server: curServer
        }
      }).then(function (respServer) {
        fillServerList();
        Toast.showUpdate();
      });
    }

    function deleteServer(serverId) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          Server.delete(serverId)
            .then(function () {
              fillServerList();
              Toast.showDelete();
            })
            .catch(function (e) {
              ExceptionHandler.show(e);
            })
        })
    }

    function getServerNameById(serverId) {
      if (vm.servers) {
        var currentServer = vm.servers.filter(function (server) {
          return parseInt(server._id) == serverId;
        });
        return currentServer[0].name;
      }
    }

    function getServerStateById(stateId) {
      var currentState = vm.serverState.filter(function (state) {
        return parseInt(state.id) == stateId;
      });
      return currentState[0].value;
    }

    function getServerAdminStateById(stateId) {
      return parseInt(stateId) === 1 ? "Up" : "Maintenance";
    }

    function getServerTypeById(typeId) {
      var currentType = vm.serverType.filter(function (type) {
        return parseInt(type.id) == typeId;
      });
      return currentType[0] ? currentType[0].value : "UNKNOWN";
    }

    function sortServers(param) {
      vm.reverseServer[param] ? vm.reverseServer[param] = false : vm.reverseServer[param] = true;
      vm.servers = orderByFilter(vm.servers, param, vm.reverseServer[param])
    }

    function getServerSortingClass(param) {
      return vm.reverseServer[param] ? "up" : "down";
    }

    function setRecordsCount() {
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    //Secondary Site Save
    function save() {
      Site.UPDATE_SECONDARY_SITE(vm.SecondarySite.site)
        .then(function (resp) {
          if (resp.I_SECONDARY_SITE_ID)
            vm.secondarySiteId = resp.I_SECONDARY_SITE_ID;
          // vm.showLoader = false;
          Toast.showUpdate();
        })
        .catch(function (e) {
          // vm.showLoader = false;
          if (e.status !== 404) { ExceptionHandler.show(e) }
        });

    }
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.client-version')
    .controller('ClientVersionController', ClientVersionController);

  /*@ngInject*/
  function ClientVersionController($mdDialog, Toast, ClientStore, ExceptionHandler, ClientVersion, orderByFilter, localStorageService) {
    var vm = this;

    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];

    vm.deleteClientVersion = deleteClientVersion;
    vm.addClientVersion = addClientVersion;
    vm.editClientVersion = editClientVersion;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    vm.getStoreName = getStoreName;
    fillList();
    getStores();
    //---------------------------------
    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort items list
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.clientVersions = orderByFilter(vm.clientVersions,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    function fillList() {
      // vm.showLoader = true ;
      ClientVersion.getList()
        .then(function (resp) {
          vm.clientVersions = resp;
          ClientStore.getList()
            .then(function (resp) {
              vm.storeList = resp;
              if(vm.storeList.length){
                vm.clientVersions.map(function(version){
                  version.name = vm.storeList.filter(function(store){
                    return store._id == version.clientSoftwareCategoryId;
                  })[0].name;
                })
              }
            });
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          // vm.showLoader = false;
        });
    }

    function getStores() {
      ClientStore.getList()
        .then(function (resp) {
          vm.storeList = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        });
    }

    function getStoreName(storeId) {
      var store = vm.storeList.filter(function(store){
        return store._id === storeId;
      });
      return store.name;
    }

    function addClientVersion() {
      $mdDialog.show({
        controller: 'clientVersionDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/client-version/details/details.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          version: {}
        }
      })
        .then(function (version) {
          fillList();
          Toast.showAdd();
        })
    }

    function editClientVersion(version) {
      var curVersion = {};

      angular.copy(version, curVersion);
      $mdDialog.show({
        controller: 'clientVersionDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/platform/client-version/details/details.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          version: curVersion
        }
      }).then(function (resp) {
        fillList();
        Toast.showUpdate();
      });
    }

    function deleteClientVersion(versionId) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          ClientVersion.delete(versionId)
            .then(function () {
              fillList();
              Toast.showDelete();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            });
        })
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.wfm')
    .controller('WFMController', WFMController);

  /**ngInject*/
  function WFMController(Context, $rootScope, ExceptionHandler, $q, Auth, orderByFilter, Toast, $document, localStorageService, AdminRecord, RecordWhiteList, Subscriber, Wfm, Group, Organization, AudioBackupPath, Config, $mdDialog) {
    var vm = this;
    vm.search = '';
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.organizationId = '';
    vm.sortIncidence = sortIncidence;
    vm.reverse = [];
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    vm.fillWFMSubscribersList = fillWFMSubscribersList
    vm.AttachWFMusers = AttachWFMusers;
    vm.selectedUsersAttachToWFM = []
    vm.WFMusersPaginationClass = "WFMusersPagination";
    vm.incidencesPaginationClass = "incidencesPaginationClass";
    vm.addIncidenseType = addIncidenseType;
    vm.deleteIncidenseType = deleteIncidenseType;
    vm.saveIncidenceTypes = saveIncidenceTypes;
    vm.defaultChange = defaultChange;
    this.addWFMuser = addWFMuser;
    vm.chosenUser;
    vm.isRootReseller = Auth.isRootAdmin();
    vm.allowCreate = Auth.isActionAllowed('organization_resource', 'POST');
    vm.allowModify = Auth.isActionAllowed('organization_resource', 'PUT');
    vm.allowDelete = Auth.isActionAllowed('organization_resource', 'DELETE');
    if (vm.isRootReseller) {
      vm.allowCreate = true;
      vm.allowModify = true;
      vm.allowDelete = true;
    }
    $rootScope.$$listeners.updatedOrganizationId = [];
    vm.organizationId = Context.getOrganizationId();
    if (vm.organizationId) {
      fillWFMSubscribersList();      
    }

    /**
     * fill subReseller list when customer choose reseller
     */
    $rootScope.$on('updatedOrganizationId', function () {
      vm.incidense_name = '';
      vm.organizationId = Context.getOrganizationId();
      if (vm.organizationId) {
        fillWFMSubscribersList();
      }
    });

    /**
     * clear subscribers list when customer choose reseller on header menu
     */
    $rootScope.$on('updatedResellerId', function () {
      vm.selectedUsersAttachToWFM = []
      vm.organizationId = '';
    });
  

    function sortIncidence(param) {
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.WFMIncidences.types = orderByFilter(vm.WFMIncidences.types, param, vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param) {
      return vm.reverse[param] ? "up" : "down";
    }

    /**
     * sort subscriber list
     */
    function setRecordsCount() {
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    function addWFMuser() { 
    
      Wfm.addUser({user_id: vm.chosenUser})
    }

    function getOrganizationSubscribers(){
      var deferred = $q.defer();
      vm.subscribers = [];
      vm.organizationId && Subscriber.getSubscriberDataByOrg(vm.organizationId)
      .then(function (resp) {
        vm.subscribers = resp;
        deferred.resolve();
      })
      .catch(function(e){
        if(e.status !== 404){ deferred.reject(); }
        else deferred.resolve();
      });
      return deferred.promise;
    }

    function getOrganizationWFMSubscribers(){
      var deferred = $q.defer();
      vm.WFMSubscribers = [];
      vm.organizationId && Wfm.wfmUsersByOrgID(vm.organizationId)
      .then(function (resp) {
        vm.WFMSubscribers = resp;
        deferred.resolve();
      })
      .catch(function(e){
        if(e.status !== 404){ deferred.reject(); }
        else deferred.resolve();
      });
      return deferred.promise;
    }

    function getOrganizationWFMIncidences(){
      var deferred = $q.defer();
      vm.WFMIncidences = [];
      vm.organizationId && Wfm.incidenceList(vm.organizationId)
      .then(function (resp) {
        var defaultTypes = Wfm.incidenceDefaultTypes();
        if (!resp || !resp.types || resp.types.length == 0){
          var types = defaultTypes.map(function(type){
            var defaultType = (type == "LOG") ? true : false;
            return {name: type, isDefault: defaultType, default_type: true}
          })
          vm.WFMIncidences = {
            types : types,
            org_id: vm.organizationId
          }
        }
        else{
          vm.WFMIncidences = resp;
          vm.WFMIncidences.types.filter(function(type){
            type.default_type = defaultTypes.includes(type.name)
          })
        }
        deferred.resolve();
      })
      .catch(function(e){
        if(e.status !== 404){ deferred.reject(); }
        else deferred.resolve();
      });
      return deferred.promise;
    }

    function fillWFMSubscribersList() {
      vm.organizationId = Context.getOrganizationId();
      if (vm.organizationId > 0)
      { vm.showLoader = true;
      }
      var flowFunctionsArray = [];
      flowFunctionsArray.push(getOrganizationSubscribers());
      flowFunctionsArray.push(getOrganizationWFMSubscribers());
      flowFunctionsArray.push(getOrganizationWFMIncidences());
      $q.all(flowFunctionsArray)
        .then(function(){
          var WFMsubscribersID = vm.WFMSubscribers.map(function (WFMsubscriber) {
            return WFMsubscriber.user_id;
          });

          vm.selectedWFMusers = vm.subscribers.filter(function (member) {
            return WFMsubscribersID.indexOf(member._id) !== -1;
          });
  
          vm.notSelectedWFMusers = vm.subscribers.filter(function (member) {
            return WFMsubscribersID.indexOf(member._id) === -1;
          });
          vm.WFMusersLength = vm.subscribers.length;
          vm.showLoader = false;
        })
        .catch(function(err){
          vm.showLoader = false;
          ExceptionHandler.show(err);
        });
    }

    function AttachWFMusers(){
      vm.showLoader = true;
      var WFMsubscribersID = vm.selectedWFMusers.map(function (member) {
        return member._id
      });
      vm.wfmOrg = {org_id: vm.organizationId, wfmUsers: WFMsubscribersID}
      Wfm.updateWfmList(vm.wfmOrg)
      .then(function () {
        vm.showLoader = false;
        Toast.showUpdate();
      })
      .catch(function (e) {
        vm.flagSave = true;
        vm.showLoader = false;
        ExceptionHandler.show(e);
      })
    }
    
    function deleteIncidenseType(incidense_name){
      var confirm = Toast.getDeleteDialog();
      console.log(vm.WFMIncidences)
      $mdDialog.show(confirm)
        .then(function () {
          var index = 0;
          vm.WFMIncidences.types.find(function(type, i){
            if (type.name == incidense_name){
              index = i
              return;
            };
          })
          vm.WFMIncidences.types.splice(index,1);

          Toast.showDelete();
        });
    }

    function addIncidenseType(incidense_name){
      var incidense_name = incidense_name.trim();
      var find = vm.WFMIncidences.types.find(function(type){
        return (type.name == incidense_name);
      })
      if(incidense_name =='')
      {
        vm.err = "Add incidence name"
      }
      else if (find) vm.err = "Incidence name already exist"
      else{
        vm.WFMIncidences.types.push({name: incidense_name, isDefault: false});
        vm.incidense_name = '';
        vm.err = '';
      }
    }

    function saveIncidenceTypes(){
      Wfm.updateWfmIncidenceTypes(vm.WFMIncidences)
      .then(function () {
        vm.showLoader = false;
        Toast.showUpdate();
      })
      .catch(function (e) {
        vm.flagSave = true;
        vm.showLoader = false;
        ExceptionHandler.show(e);
      })
    }

    function defaultChange(default_name, checked){
      if (checked){
        vm.WFMIncidences.types.filter(function(type){
          if (type.isDefault && type.name != default_name) type.isDefault = false;
        })
      }
      else{
        var isDefault = false;
        vm.WFMIncidences.types.filter(function(type){
          if (type.isDefault) isDefault = true;
        })
        if (!isDefault){
          vm.WFMIncidences.types.filter(function(type){
            if (type.name == "LOG") type.isDefault = true;
          })
        }
      }
    }
  }
}
)();
(function () {
  'use strict';

  angular.module('app.restricted.subscribers')
    .controller('SubscribersController', SubscribersController);



  /** @ngInject*/
  function SubscribersController($mdDialog, Toast, ExceptionHandler, localStorageService, Subscriber, Organization, Group, $rootScope, Context, Auth, orderByFilter, api, Config, $timeout, License, $filter, Sms, ApplicationList) {
    var vm = this;

    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;


    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
   // vm.resellersList = resellers;
    vm.organizationId = '';
    vm.popupOverlayClass = "";
    vm.reverse = [];
    // vm.allocations = [];   //shahar- remove license
    // vm.allocationsList = [];
    vm.bundleNames = [];
    vm.showLoader = false;
    vm.pageNo = 1;
    vm.licenseNo = 0;
    vm.adminRoleNo = 0;

    vm.allowCreate = Auth.isActionAllowed('subscriber_resource','POST');
    vm.allowModify = Auth.isActionAllowed('subscriber_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('subscriber_resource','DELETE');
    vm.allowSms =  Auth.isActionAllowed('subscriber_resource','HIMPACT');

    vm.allowBlockReleaseUser =  Auth.isActionAllowed('administration_resource','HIMPACT') && Auth.isAdministrator();
    
    vm.editSubscriber = editSubscriber;
    vm.releaseSubscriber = releaseSubscriber;
    vm.blockSubscriber = blockSubscriber;
    vm.removeSubscriber = removeSubscriber;
    vm.addSubscriber = addSubscriber;
    vm.cloneSubscriber = cloneSubscriber;
    vm.openSMSdialog = openSMSdialog;
    vm.changeActiveState = changeActiveState;
    vm.filterChange = filterChange;
    vm.filterRoleChange = filterRoleChange;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    vm.isMobileUser = isMobileUser;
    vm.getData = getData;
    vm.seachDataBox = seachDataBox;

    vm.isRootReseller = Auth.isRootAdmin();

    $rootScope.$$listeners.updatedOrganizationId =[];

    vm.organizationId = Context.getOrganizationId();
    if (vm.organizationId){
      fillSubscribersList();
      getDefaultRole();
      getLicenseTemplates();
      getOrgApplicationList();
    }
    //getLicenseAllocations();
    //================================================//
    /**
     * fill subReseller list when customer choose reseller
     */
    $rootScope.$on('updatedOrganizationId', function () {
      vm.organizationId = Context.getOrganizationId();
      if (vm.organizationId){
        vm.pageNo = 1;
        vm.licenseNo = 0;
        vm.adminRoleNo = 0;
        fillSubscribersList();
        getDefaultRole();
        getLicenseTemplates();
        getOrgApplicationList();
      }
      vm.filterTemplate = null;
      vm.filterRoleTemplate = null;
      vm.filterByName = '';
      // vm.filterChange(null);
      //getLicenseAllocations();
    });

    /**
     * clear subscribers list when customer choose reseller on header menu
     */
    $rootScope.$on('updatedResellerId', function () {
      vm.subscribers = [];
      vm.subData = [];
      vm.allSubscribers = [];
      vm.organizationId = '';
      vm.filterTemplate = null;
      vm.filterRoleTemplate = null;
      vm.filterByName = '';
      // vm.filterChange(null);
    });

    /**
     * sort subscriber list
     */
    function setRecordsCount(){
      vm.pageNo = 1 ;
     localStorageService.set('recordsCount', vm.recordsCount);
    //  getData(1);
    }

    /**
     * sort subscriber list
     */
    function sort(param){
      vm.filterByName = vm.reverse[param] ? "ASC" : "DESC";
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.subscribers = orderByFilter(vm.subscribers,param,vm.reverse[param])
      vm.subData.items = vm.subscribers;
      vm.pageno = 1;
      getData(1); 
      // vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      // vm.subscribers = orderByFilter(vm.subscribers,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }


    /**
     * fill list of subscribers by current context organizationID
     */
    function fillSubscribersList() {
      var date1 = new Date();

      vm.subscribers = [];
      vm.subData = [];
      vm.allSubscribers = [];
      var parentResellerId = Context.getLastResellerId();
      var organizationId = Context.getOrganizationId();

      Organization.getById(organizationId, parentResellerId)
        .then(function(resp){
          vm.organization = resp;
          vm.qty = vm.organization.qty-vm.organization.availble_qty + "/" + vm.organization.qty;
          vm.dispatcherqty = vm.organization.dispatcher_qty-vm.organization.dispatcher_availble_qty + "/" + vm.organization.dispatcher_qty;
          vm.maxLoginRetries = Number(vm.organization.max_login_retries);
          Config.getFilterList().then(function(resp){
            vm.configs = resp;
            vm.showLicenseAllocation = vm.configs.filter(function(param){
              return param.name == "PROV_SHOW_LICENSE_ALLOCATION";
            });
            if (!vm.showLicenseAllocation || !vm.showLicenseAllocation[0].value || vm.showLicenseAllocation[0].value == "0"){
              vm.showLicenseAllocation = false;
              vm.allowCreateLimit = true;
            }
            else{
              vm.showLicenseAllocation = true;
              vm.allowCreateLimit = (vm.organization.availble_qty > 0 || vm.organization.dispatcher_availble_qty > 0);//PARAMETER LICENSE SHAHAR
            }

            vm.changeStateHighImpact = vm.configs.filter(function(param){
              return param.name == "PROV_CHANGE_STATE_WITH_HIGH_IMPACT";
            });
            if (!vm.changeStateHighImpact || !vm.changeStateHighImpact[0].value || vm.changeStateHighImpact[0].value == "0")
              vm.allowChangeState = vm.allowModify;
            else
              vm.allowChangeState = vm.allowModify && Auth.isActionAllowed('organization_resource','HIMPACT');

            vm.showBlockRelease = vm.configs.filter(function(param){
              return param.name == "PROV_SHOW_BLOCK_RELEASE";
            });
            if (!vm.showBlockRelease || !vm.showBlockRelease[0].value || vm.showBlockRelease[0].value == "0")
              vm.showBlockRelease = false;
            else
              vm.showBlockRelease = vm.allowBlockReleaseUser;

            vm.showIMSI2 = vm.configs.filter(function(param){
              return param.name == "PROV_SHOW_IMSI2";
            });
            if (!vm.showIMSI2 || !vm.showIMSI2[0].value || vm.showIMSI2[0].value == "0")
              vm.showIMSI2 = false;
            else
              vm.showIMSI2 = true;
          });
        });

      vm.organizationId = Context.getOrganizationId();
      if(vm.organizationId > 0){
         vm.showLoader = true;
      }
      if(vm.pageNo == 0)
        vm.pageNo = 1;

       if(vm.filterByName == undefined)
          vm.filterByName = '';

      var passData={
        'organizationId':vm.organizationId,
        'search':'NULL',
        'licenseno':vm.licenseNo,
        'roleNo':vm.adminRoleNo,
        'pageNo':vm.pageNo,
        'pageSize':vm.recordsCount,
        'orderBy':vm.filterByName
      }
      vm.organizationId && Subscriber.getSubDataByOrg(passData)
        .then(function (resp) {
          vm.subData = resp;
          // vm.allSubscribers = resp;
          vm.subscribers = resp.items;
          vm.filterTemplate = null;
          vm.showLoader = false;
          var date2 = new Date();
          var timeDiff = Math.abs(date2.getTime() - date1.getTime());
          var diffHours = Math.ceil(timeDiff / (1000 * 3600));
        })
        .catch(function(e){
          vm.showLoader = false;
          if(e.status !== 404){ ExceptionHandler.show(e) }
        });
        // vm.organizationId && Subscriber.getSubscriberListByOrg(vm.organizationId)
        // .then(function (resp) {
        //   vm.subscribers = resp;
        //   vm.allSubscribers = resp;
        //   vm.filterTemplate = null;
        //   vm.showLoader = false;
        //   var date2 = new Date();
        //   var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        //   var diffHours = Math.ceil(timeDiff / (1000 * 3600));
        // })
        // .catch(function(e){
        //   vm.showLoader = false;
        //   if(e.status !== 404){ ExceptionHandler.show(e) }
        // });
    /*
      vm.organizationId && Group.getContactsByOrgId(vm.organizationId)
        .then(function(resp){
          vm.contacts = resp;
          console.log(resp.length);
        })
        .catch(function(e){
          console.log("contacts loading error");
        });
*/
      if(localStorageService.get('recordsCount')) vm.recordsCount = localStorageService.get('recordsCount');
    }

    function getData(pageno){ // This would fetch the data on page change.
        //In practice this should be in a factory.
        var searchF = 'NULL';
        if(vm.search == '')
          searchF = 'NULL';
        else
          searchF = vm.search;
        vm.pageno = pageno;
        vm.subData = {};
        var passData={
          'organizationId':vm.organizationId,
          'search':searchF,
          'licenseno':vm.licenseNo,
          'roleNo':vm.adminRoleNo,
          'pageNo':vm.pageno,
          'pageSize':vm.recordsCount,
          'orderBy':vm.filterByName
        }
        vm.organizationId && Subscriber.getSubDataByOrg(passData)
          .then(function (list) {
            vm.subData = list;
          })
          .catch(function(e){
            ExceptionHandler.show(e);
          })
        // vm.users = [];  $http.get("http://yourdomain/apiname/{itemsPerPage}/{pagenumber}").success(function(response){
        //     //ajax request to fetch data into vm.data
        //               vm.users = response.data;  // data to be displayed on current page.
        //     vm.total_count = response.total_count; // total data count.
        // });
    };
    function seachDataBox(){
      if(vm.search && vm.search.length > 31)
        Toast.getEmtyErrorMsg('This field is too long.');
      if(vm.search && vm.search.length >= 3)
        getData(1)
      if(!vm.search || vm.search.length == 0)
        getData(1)
    }
    function getSip(){
      vm.subscribers.map(function(subscriber){
        Subscriber.getById(subscriber._id)
        .then(function(subs){
          subscriber.sip = subs.sip;
        });
      })
    }

    function isMobileUser(id, phone) {
      if (!phone) return false;
      else{
        if (id == phone) return false;
        else return true;
      }
    }

    function getDefaultRole(){
      Config.getFilterList().then(function(resp){
        vm.configs = resp;
        var DefaultRoleName = vm.configs.filter(function(param){
          return param.name == "PROV_SUBSCRIBER_DEFAULT_ROLE";
        });
        DefaultRoleName = DefaultRoleName[0].value;
        api.roles.listByOrg.query({nodeId: vm.organizationId}, function(resp) {
          vm.roleListData = resp;
          vm.defaultAdminroleId = resp.filter(function(adminRole){
            return adminRole.name === DefaultRoleName;
          });
          if (!vm.defaultAdminroleId || vm.defaultAdminroleId && vm.defaultAdminroleId.length === 0){
              if(resp && resp.length > 0)
                  vm.defaultAdminroleId = resp[0]._id;
              else
                  vm.defaultAdminroleId = 0;
          }
          else
            vm.defaultAdminroleId = vm.defaultAdminroleId[0]._id;
        });
        var showSms = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_SMS";
        });
        if (!showSms || !showSms[0].value || showSms[0].value == "0")
          vm.showSms = false;
        else
          vm.showSms = true;
      });
    }

    function getOrgApplicationList(){
      var orgId = Context.getOrganizationId();
      vm.applicationLists = [{id: null, name: "None"}]
      ApplicationList.getApplicationListsByOrg(orgId)
      .then(function(applicationLists){
        vm.applicationLists = vm.applicationLists.concat(applicationLists);
      });
    }

    function getLicenseTemplates(){
      License.getLicenseTemplates()
      .then(function(resp){
        vm.licenseTemplates = resp;
      });
    }

    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }

    // function getLicenseAllocations(){   // shahar- remove license
    //   License.getAllocationList(vm.organizationId)
    //     .then(function(resp){
    //       vm.allocations = $filter('orderBy')(resp,'licenseBundle.name');
    //       vm.allocations = vm.allocations.filter(function(allocation){
    //         return allocation.availableQty > 0;
    //       });
    //       vm.allocations.map(function(allocation){
    //           vm.bundleNames.push(allocation.licenseBundle.name);
    //         });

    //       vm.bundleNames = vm.bundleNames.filter(onlyUnique);
    //       vm.allocationsList = vm.allocations;

    //     })
    //     .catch(function(e){
    //       ExceptionHandler.log(e);
    //     });
    // }

    function getSubscribers(){

    }

    function addSubscriber() {

      $mdDialog.show({
        controller: 'subscriberDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/subscribers/details/add.subscriber.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        fullscreen: true,
        locals: {
          subscriber: {
            organization_id: vm.organizationId,
            adminrole_id: vm.defaultAdminroleId
          },
          organization: vm.organization,
          contacts: vm.contacts,
          applicationLists: vm.applicationLists,
          // orgSubscribersList: vm.allSubscribers,
          clone: false,
          configs: vm.configs,
          // allocations: vm.allocations,   //shahar- remove license
          // allocationsList: vm.allocationsList,
          activeTab: 0
        }
      })
        .then(function () {
            // fillSubscribersList();
                getData(vm.pageNo);
            //getLicenseAllocations();  //shahar- remove license
            Toast.showAdd();
      })
    }

    function cloneSubscriber(subscriberId) {
      var curSubscriber = {};
      Subscriber.getById(subscriberId)
        .then(function(resp){
          angular.copy(resp, curSubscriber);
          $mdDialog.show({
            controller: 'subscriberDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/restricted/organization/subscribers/details/add.subscriber.dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            skipHide: true,
            locals: {
              subscriber: curSubscriber,
              organization: vm.organization,
              contacts: vm.contacts,
              applicationLists: vm.applicationLists,
              // orgSubscribersList: vm.allSubscribers,
              clone: true,
              configs: vm.configs,
              // allocations: vm.allocations,   //shahar- remove license
              // allocationsList: vm.allocationsList,
              activeTab: 0
            }
          }).then(function () {
            // fillSubscribersList();
            getData(vm.pageNo);
            //getLicenseAllocations();  //shahar- remove license
            Toast.showAdd();
          })
        })
    }

    function openSMSdialog(subs) {
      var curSubscriber = {};
      angular.copy(subs, curSubscriber);
      $mdDialog.show({
        controller: 'SubscriberSendSmsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/subscribers/sms/subscriber.send.sms.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        skipHide: true,
        locals: {
          subscriber: curSubscriber,
          server: 0
        }
      }).then(function () {
    })
    }

    function editSubscriber(subscriberId) {
      var curSubscriber = {};
      vm.popupOverlayClass = "show";
      $timeout(function(){vm.popupOverlayClass = ""},500);
      Subscriber.getById(subscriberId)
        .then(function(resp){
          angular.copy(resp, curSubscriber);
          $mdDialog.show({
            controller: 'subscriberDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/restricted/organization/subscribers/details/subscriber.dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            skipHide: true,
            locals: {
              subscriber: curSubscriber,
              organization: vm.organization,
              contacts: vm.contacts,
              applicationLists: vm.applicationLists,
              // orgSubscribersList: vm.allSubscribers,
              clone: false,
              configs: vm.configs,
              // allocations: vm.allocations,   //shahar- remove license
              // allocationsList: vm.allocationsList,
              activeTab: 0
            },
            onShowing: function(){

            },
            onComplete: function(){

            }
          }).then(function (resSubscriber) {
            vm.popupOverlayClass = "";
           // Subscriber.update(resSubscriber)
             // .then(function(){
                // fillSubscribersList();
                getData(vm.pageNo);
                //getLicenseAllocations();   //shahar- remove license
                Toast.showUpdate();
          }).catch(function(e){
            //getLicenseAllocations();   //shahar- remove license
          })
        })
    }

    function removeSubscriber(subscriberID) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          Subscriber.remove(subscriberID)
            .then(function () {
              // fillSubscribersList();
                getData(vm.pageNo);
              //getLicenseAllocations();  //shahar- remove license
              Toast.showDelete();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            })
        });
    }

    function releaseSubscriber(subscriber) {
      var confirm = Toast.getReleaseDialog();

      $mdDialog.show(confirm)
        .then(function () {
          Subscriber.release(subscriber._id)
            .then(function () {
              // fillSubscribersList();
                getData(vm.pageNo);
              Toast.showRelease();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            })
        });
    }

    function blockSubscriber(subscriber) {
      var confirm = Toast.getBlockDialog();

      $mdDialog.show(confirm)
        .then(function () {
          Subscriber.block(subscriber._id)
            .then(function () {
              // fillSubscribersList();
                getData(vm.pageNo);
              Toast.showBlock();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            })
        });
    }

    function changeActiveState(sub){

      sub.site = sub.primary_site_id;
      if(sub.adminrole_id === null) sub.adminrole_id = 0;
      Subscriber.changeActiveState(sub._id, sub.admin_state)
        .then(function(resp) {
          Toast.showChange();
          })
        .catch(function(e){
          sub.admin_state = 1;
          ExceptionHandler.show(e);
        })
    }

    function filterChange(license){
      vm.licenseNo = 0;
      if (license == 0){
        // vm.subscribers = [];
        // for (var i = 0; i < vm.allSubscribers.length; i++){
        //   vm.license = vm.licenseTemplates.filter(function (lic){
        //     return vm.allSubscribers[i].permissions_mask == lic.mask;
        //   });
        //   if (vm.license.length == 0)
        //     vm.subscribers.push(vm.allSubscribers[i])
        // }
      }
      else if (!license)
        vm.licenseNo = 0;
      else
        vm.licenseNo = license.mask;

        getData(1)
      // if (license == 0){
      //   vm.subscribers = [];
      //   for (var i = 0; i < vm.allSubscribers.length; i++){
      //     vm.license = vm.licenseTemplates.filter(function (lic){
      //       return vm.allSubscribers[i].permissions_mask == lic.mask;
      //     });
      //     if (vm.license.length == 0)
      //       vm.subscribers.push(vm.allSubscribers[i])
      //   }
      // }
      // else if (!license)
      //   vm.subscribers = vm.allSubscribers;
      // else
      //   vm.subscribers = vm.allSubscribers.filter(function (subs){
      //     return subs.permissions_mask == license.mask;
      //   });
    }

    function filterRoleChange(role){
      vm.filterRoleTemplate = 0;
      vm.adminRoleNo = 0;
      if (!role)
        vm.adminRoleNo = 0;
      else{
        vm.adminRoleNo = role._id;
        vm.filterRoleTemplate = role._id;
      }
        getData(1)
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.subscriberLists', ['datatables'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider, msApiProvider) {
    $stateProvider.state('app.restricted.subscriberLists', {
      url: '/subscriberLists',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/subscriberLists/subscriberLists.html',
          controller: 'SubscriberListsController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('group_resource','GET')
        }
      }
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/restricted/organization/subscriberLists');

    //msApiProvider.register('subscriberLists', ['app/main/restricted/organization/subscriberLists/data/data.json']);

    // Navigation
    msNavigationServiceProvider.saveItem('Organization.subscriberLists', {
      title: 'SubscriberLists',
      icon: '',
      state: 'app.restricted.subscriberLists',
      translate: 'NAVIGATION_CONTACTS_TEMPLATES',
      weight: 6
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.subscriberLists')
    .controller('SubscriberListsController', SubscriberListsController);

  /** @ngInject*/
  function SubscriberListsController($mdDialog, Toast, ExceptionHandler, Group, $rootScope, Context, Organization, Auth, localStorageService) {
    var vm = this;
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];

    vm.subscriberLists = [];
    vm.search = '';

    vm.editSubscriberList = editSubscriberList;
    vm.removeSubscriberList = removeSubscriberList;
    vm.addSubscriberList = addSubscriberList;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

    vm.isActionNotAllowed = Auth.isActionAllowed;

    vm.allowCreate = Auth.isActionAllowed('group_resource','POST');
    vm.allowModify = Auth.isActionAllowed('group_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('group_resource','DELETE');

    $rootScope.$$listeners.updatedOrganizationId =[];

    fillSubscriberLists();
//--------------------------------------------------------------------

    /**
     * fill SubscriberLists list when customer choose organization
     */
    $rootScope.$on('updatedOrganizationId', function () {
      fillSubscriberLists();
    });

    /**
     * clear SubscriberLists list when customer choose reseller on header menu
     */
    $rootScope.$on('updatedResellerId', function () {
      vm.subscriberLists = [];
      vm.organizationId = '';
    });

    /**
     * Fill SubscriberLists by  organization Id from current context
     */
    function fillSubscriberLists() {
      vm.parentResellerId = Context.getLastResellerId();
      vm.organizationId = Context.getOrganizationId();
      if(vm.organizationId > 0){ 
        vm.showLoader = true;
      }
      Organization.getById(vm.organizationId, vm.parentResellerId)
        .then(function(resp){
          vm.organization = resp;
        });

      vm.organizationId && Group.getSubscriberListsByOrgId(vm.organizationId)
        .then(function (resp) {
          vm.subscriberLists = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.showLoader = false;
        });
    }

    /**
     * set records count
     */
    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * @param: string
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.subscriberLists = orderByFilter(vm.subscriberLists,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    /**
     * addSubscriberList - call modal window ; add subscriberLists to list
     */
    function addSubscriberList() {
      $mdDialog.show({
        controller: 'subscriberListDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/subscriberLists/details/subscriberList.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          subscriberList: {
            organization: vm.organizationId,
            type: 8,
            site: vm.organization.site
          },
          organizationId: vm.organizationId
        }
      }).then(function () {
          fillSubscriberLists();
          Toast.showAdd();
        })
    }


    /**
     * editSubscriberList - call modal window ; save changes to list;
     * @param subscriberList
     */
    function editSubscriberList(subscriberList) {
      vm.loading = true ;
      var curSubscriberList = {};
      angular.copy(subscriberList, curSubscriberList); //
      curSubscriberList.site = curSubscriberList.primary_site_id;
      curSubscriberList.organization = curSubscriberList.organization_id;

      $mdDialog.show({
        controller: 'subscriberListDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/subscriberLists/details/subscriberList.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          subscriberList: curSubscriberList,
          organizationId: vm.organizationId
        }
      }).then(function () {
            fillSubscriberLists();
            Toast.showUpdate();
      });
    }

    /**
     * Remove SubscriberList by ID after approve it by modal Window
     * @param subscriberListID
     */
    function removeSubscriberList(subscriberListID) {
      var confirm = Toast.getDeleteDialog();
      $mdDialog.show(confirm)
        .then(function () {
          Group.deleteItem(subscriberListID)
            .then(function () {
              fillSubscriberLists();
              Toast.showDelete();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            });
        });
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.recording')
    .controller('RecordingController', recordingController);

  /**ngInject*/
  function recordingController(Context, $rootScope, ExceptionHandler, Toast, Auth, orderByFilter, $mdDialog, $filter ,localStorageService, AdminRecord, RecordWhiteList, Subscriber, Group, Organization, AudioBackupPath, Config) {
    var vm = this;

    vm.search = '';
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.reverse = [];

    vm.addAdmin = addAdmin;
    vm.editAdmin = editAdmin;
    vm.deleteUser = deleteUser;
    vm.addPath = addPath;
    vm.deletePath = deletePath;
    vm.sortAdmin = sortAdmin;
    vm.sortPath = sortPath;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    vm.saveWhiteList = saveWhiteList;
    vm.releaseAdmin = releaseAdmin;
    vm.blockAdmin = blockAdmin;

    vm.subscribersPaginationClass = "subscribersPagination";
    vm.groupsPaginationClass = "groupsPagination";
    vm.adminsPaginationClass = "adminsPagination";
    vm.pathsPaginationClass = "pathsPagination";

    vm.allowCreate = Auth.isActionAllowed('organization_resource', 'POST');
    vm.allowModify = Auth.isActionAllowed('organization_resource', 'PUT');
    vm.allowDelete = Auth.isActionAllowed('organization_resource', 'DELETE');

    vm.allowBlockReleaseUser =  Auth.isActionAllowed('administration_resource','HIMPACT') && Auth.isAdministrator();

    vm.isRootAdmin = Auth.isRootAdmin();
    if (vm.isRootAdmin) {
      vm.allowCreate = true;
      vm.allowModify = true;
      vm.allowDelete = true;
    }

    init();

    $rootScope.$$listeners.updatedOrganizationId = [];
    $rootScope.$$listeners.updatedResellerId = [];

    $rootScope.$on('updatedResellerId', function () {
      vm.organizationId = Context.getOrganizationId();
      vm.adminsList = [];
    });

    $rootScope.$on('updatedOrganizationId', function () {
      vm.adminsList = [];
      init();
    });

    function config() {
      Config.getFilterList().then(function (resp) {
        vm.showAudioBackupPath = resp.filter(function (param) {
          return param.name == "PROV_SHOW_AUDIO_BACKUP_PATHS";
        });

        if (!vm.showAudioBackupPath || !vm.showAudioBackupPath[0] || vm.showAudioBackupPath[0].value == "0" || !vm.isRootAdmin)
          vm.showAudioBackupPath = false;
        else {
          vm.showAudioBackupPath = true;
          fillPathList();
        }

        vm.showBlockRelease = resp.filter(function(param){
          return param.name == "PROV_SHOW_BLOCK_RELEASE";
        });
        if (!vm.showBlockRelease || !vm.showBlockRelease[0].value || vm.showBlockRelease[0].value == "0")
          vm.showBlockRelease = false;
        else
          vm.showBlockRelease = vm.allowBlockReleaseUser;

        vm.showChangePassword = resp.filter(function(param){
          return param.name == "PROV_SHOW_CHANGE_PASSWORD";
        });
        if (!vm.showChangePassword || !vm.showChangePassword[0].value || vm.showChangePassword[0].value == "0")
          vm.showChangePassword = false;
        else
          vm.showChangePassword = true;
      });
    }


    function init() {
      vm.organizationId = Context.getOrganizationId();
      if (vm.organizationId > 0) {
        // vm.showLoaderAdmin = true;
        // vm.showLoaderSubscribers = true;
        // vm.showLoaderGroups = true;
      }
      fillAdminList();
      config();
      vm.organizationId && Subscriber.getSubscriberDataByOrg(vm.organizationId)
        .then(function (resp) {
          vm.subscribers = resp;

          var parentResellerId = Context.getLastResellerId();
          Organization.getById(vm.organizationId, parentResellerId)
            .then(function (resp) {
              vm.maxLoginRetries = Number(resp.max_login_retries);
              if (resp.isRecorded == 1)
                vm.isRecoded = true;
              else
                vm.isRecoded = false;

              if (vm.isRecoded) {
                RecordWhiteList.getByOrgId(vm.organizationId)
                  .then(function (results) {
                    vm.whiteListRecord = results;
                    if (!vm.whiteListRecord.length) {
                      vm.isSelective = false;
                      vm.showWhiteListTabs = false;
                    }
                    else {
                      vm.isSelective = results[0].is_selective;
                      if (vm.isSelective) {
                        vm.showWhiteListTabs = true;
                        fillWhiteListGroups();
                        fillWhiteListSubscribers();
                      }
                      else
                        vm.showWhiteListTabs = false
                    }

                  })
                  .catch(function (e) {
                    ExceptionHandler.show(e)
                  })
              }
              else
                vm.showWhiteListTabs = false;
            })
            .catch(function (e) {
              ExceptionHandler.show(e);
              // vm.showLoaderAdmin = false;
              // vm.showLoaderSubscribers = false;
              // vm.showLoaderGroups = false;
            });

        })
        .catch(function (e) {
          if (e.status !== 404) { ExceptionHandler.show(e) }
          // vm.showLoaderAdmin = false;
          // vm.showLoaderSubscribers = false;
          // vm.showLoaderGroups = false;
        });
    }

    function fillAdminList() {
      vm.organizationId && AdminRecord.getByOrgId(vm.organizationId)
        .then(function (resp) {
          vm.adminsList = resp.map(function (admin) {
            admin.last_login_time =  $filter('date')(admin.last_login_time,'dd/MMM/yy HH:mm:ss') || "";
            admin.last_activity_time =  $filter('date')(admin.last_activity_time,'dd/MMM/yy HH:mm:ss') || "";
            admin.last_password_change_timestamp =  $filter('date')(admin.last_password_change_timestamp,'dd/MMM/yy HH:mm:ss') || "";
            return admin;
          });
          // vm.showLoaderAdmin = false;
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
          // vm.showLoaderAdmin = false;
        });
    }

    function fillPathList() {
      vm.organizationId && AudioBackupPath.getByOrgId(vm.organizationId)
        .then(function (resp) {
          vm.pathsList = resp.map(function (path) {
            var split = path.folder_date.split('-');
            path.folder_date = new Date(split[1] + '-' + split[0]);
            return path;
          });
          // vm.showLoaderPath = false;
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
          // vm.showLoaderPath = false;
        });
    }

    function fillWhiteListSubscribers() {
      if (!vm.whiteListRecord.length) {
        vm.notSelectedSubscribers = vm.subscribers;
      }
      else {
        var selectedSubscribersPhones = vm.whiteListRecord[0].subscribers;
        vm.selectedSubscribers = vm.subscribers.filter(function (sub) {
          return (selectedSubscribersPhones.indexOf(sub.phone_number) >= 0);
        });
        vm.notSelectedSubscribers = vm.subscribers.filter(function (sub) {
          return (selectedSubscribersPhones.indexOf(sub.phone_number) == -1);
        });
      }
      // vm.showLoaderSubscribers = false;
    }

    function fillWhiteListGroups() {
      vm.organizationId && Group.getByOrgId(vm.organizationId)
        .then(function (resp) {
          vm.groups = resp;
          if (!vm.whiteListRecord.length)
            vm.selectedGroups = vm.groups;
          else {
            var selectedGroupsId = vm.whiteListRecord[0].groups;
            vm.selectedGroups = vm.groups.filter(function (group) {
              return (selectedGroupsId.indexOf(group._id) >= 0);
            });
            vm.notSelectedGroups = vm.groups.filter(function (group) {
              return (selectedGroupsId.indexOf(group._id) == -1);
            });
          }
          // vm.showLoaderGroups = false;
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
        })
    }

    /**
     * set records count
     */
    function setRecordsCount() {
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort items list
     */
    function sortAdmin(param) {
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.adminsList = orderByFilter(vm.adminsList, param, vm.reverse[param])
    }

    function sortPath(param) {
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.pathsList = orderByFilter(vm.pathsList, param, vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param) {
      return vm.reverse[param] ? "up" : "down";
    }

    function onTabChanges(index) {
      vm.activeTab = index;
    }

    function deleteUser(userId) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          AdminRecord.deleteItem(userId)
            .then(function (resp) {
              fillAdminList();
              Toast.showDelete();
              // vm.showLoaderAdmin = false;
            })
            .catch(function (e) {
              // vm.showLoaderAdmin = false;
              ExceptionHandler.show(e);

            });
        })
    }

    function addAdmin() {
      $mdDialog.show({
        controller: 'adminRecordDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/recording/tabs/admin-record/dialog/admin.dialog.add.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          user: {}
        }
      })
        .then(function () {
          fillAdminList();
          Toast.showAdd();
        })
    }

    function editAdmin(userA) {

      AdminRecord.getByAdminId(userA.admin_id)
        .then(function (res) {
          if (res.activities) {
            res.activities = res.activities.map(function (u) {
              u.time = $filter('date')(u.time,'dd/MMM/yy HH:mm:ss') || "";
              return u;
            });
          }
          $mdDialog.show({
            controller: 'adminRecordDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/restricted/organization/recording/tabs/admin-record/dialog/admin.dialog.tabs.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
              user: res
            }
          })
            .then(function (user) {
              //angular.copy(user, userA);
              fillAdminList();
              Toast.showUpdate();
            })
        })
        .catch(function (err) {
          ExceptionHandler.show(err);
        });

    }

    function deletePath(userId) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          AudioBackupPath.deleteItem(userId)
            .then(function (resp) {
              fillPathList();
              Toast.showDelete();
              // vm.showLoaderPath = false;
            })
            .catch(function (e) {
              // vm.showLoaderPath = false;
              ExceptionHandler.show(e);

            });
        })
    }

    function addPath() {
      $mdDialog.show({
        controller: 'audioBackupPathDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/recording/tabs/audio-backup-path/dialog/audio.backup.path.dialog.add.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          user: {}
        }
      })
        .then(function () {
          fillPathList();
          Toast.showAdd();
        })
    }

    function saveWhiteList(type) {
      if (type == "subscribers") {
        // vm.showLoaderSubscribers = true;
        var selectedSubscribersPhone = vm.selectedSubscribers.map(function (subs) {
          return subs.phone_number;
        });
        var updateObject = {
          orgId: vm.organizationId,
          subscribers: selectedSubscribersPhone
        }
      }
      else if (type == "groups") {
        // vm.showLoaderGroups = true;
        var selectedGroupsId = vm.selectedGroups.map(function (group) {
          return group._id;
        });
        var updateObject = {
          orgId: vm.organizationId,
          groups: selectedGroupsId
        }
      }

      RecordWhiteList.update(updateObject)
        .then(function () {
          Toast.showUpdate();
          // vm.showLoaderSubscribers = false;
          // vm.showLoaderGroups = false;
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
          // vm.showLoaderSubscribers = false;
          // vm.showLoaderGroups = false;
        });
    }

    function releaseAdmin(user) {
      var confirm = Toast.getReleaseDialog();

      $mdDialog.show(confirm)
        .then(function () {
          AdminRecord.releaseAdmin(user.admin_id)
            .then(function () {
              fillAdminList();
              Toast.showRelease();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            })
        });
    }

    function blockAdmin(user) {
      var confirm = Toast.getBlockDialog();

      $mdDialog.show(confirm)
        .then(function () {
          AdminRecord.blockAdmin(user.admin_id)
            .then(function () {
              fillAdminList();
              Toast.showBlock();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            })
        });
    }

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.organization-friends', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.organization-friends', {
      url: '/organizationFriends',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/organization-friends/organization.friends.html',
          controller: 'OrganizationFriendsController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('organization_resource','GET');
        }
      }
    });


    // Navigation
    msNavigationServiceProvider.saveItem('Organization.organization-friends', {
      title: 'Organization friends',
      icon: '',
      state: 'app.restricted.organization-friends',
      translate: 'NAVIGATION_ORG_FRIENDS',
      weight: 6
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.organization-friends')
    .controller('OrganizationFriendsController', orgFriendsController);

  /**ngInject*/
  function orgFriendsController(Context, $rootScope, ExceptionHandler, Toast, Organization, Auth, OrgFriends, Config) {
    var vm = this;

    vm.licenses = [];
    vm.organization = {};
    vm.org = false;

    vm.isActionAllowed = Auth.isActionAllowed;

    //Security
    vm.allowCreate = Auth.isActionAllowed('organization_resource','POST');
    vm.allowModify = Auth.isActionAllowed('organization_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('organization_resource','DELETE');
    vm.allowReadLicenses = Auth.isActionAllowed('license_resource','GET');

    //Vm methods
    vm.saveOrgFriends = saveOrgFriends;
    vm.onTabChanges = onTabChanges;
    vm.showLoader = true;
    vm.org = false;
    vm.selectedOrgs = [];
    vm.unselectedOrgs = [];

    Config.getFilterList().then(function(resp){
      vm.configs = resp;
      vm.limitOrgFriends = vm.configs.filter(function(param){
        return param.name === "PROV_LIMIT_ORGANIZATION_FRIENDS";
      });
      if (!vm.limitOrgFriends || !vm.limitOrgFriends[0] || !vm.limitOrgFriends[0].value)
        vm.limitOrgFriends = 10;
      else
        vm.limitOrgFriends = parseInt(vm.limitOrgFriends[0].value)
    });

    isOrg();
    if (vm.org)
      prepareMembers();

    //Init
    if(Context.getOrganizationId()){
      isOrg();
      prepareMembers();
    }

    $rootScope.$on('updatedOrganizationId', function () {
      isOrg();
      prepareMembers();
    });

    $rootScope.$on('updatedResellerId', function () {
      isOrg();
      vm.selectedOrgs = [];
      vm.unselectedOrgs = [];
    });

    $rootScope.$on('clearResellerId', function () {
      isOrg();
      vm.selectedOrgs = [];
      vm.unselectedOrgs = [];
    });


    //---------------------------------------------------------

    function isOrg(){
      if (Context.getOrganizationId() && Context.getOrganizationId() != '')
        vm.org = true;
      else
        vm.org = false;
    }


    function saveOrgFriends(){
      vm.showLoader = true ;
      var selectedFriends= {};
      selectedFriends.orgFriends = vm.selectedOrgs.map(function(org){
        return org._id;
      });
      selectedFriends._id = Context.getOrganizationId();
      OrgFriends.update(selectedFriends)
        .then(function(){
          Toast.showUpdate();
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.showLoader = false;
        });
    }


    function onTabChanges(index){
      vm.activeTab = index;
    }


    function prepareMembers() {
      vm.showLoader = true;

      Organization.getListOrgByReseller(Context.getLastResellerId())
        .then(function (resp) {
          vm.orgs = resp;
          OrgFriends.getByOrgId(Context.getOrganizationId())
              .then(function(resp){
                vm.orgFriends = resp.map(function(orgs){
                  return orgs._id;
                });
                filterMember();
                vm.showLoader = false;
            })
            .catch(function(err){
                if(err.status !== 404){ ExceptionHandler.show(err) }
                vm.selectedOrgs = [];
                vm.unselectedOrgs = vm.orgs.filter(function (org) {
                  return Context.getOrganizationId() != org._id;
                });
                vm.showLoader = false;
            });


         // vm.group._id ?  filterMember() : vm.unselectedMembers = vm.members;
        })
        .catch(function(e){
          if(e.status !== 404){ ExceptionHandler.show(e) }
        })
        .finally(function(){
          vm.loading = false;
        });
    }

    function filterMember(){
      vm.selectedOrgs = vm.orgs.filter(function (org) {
        return vm.orgFriends.indexOf(org._id) !== -1;
      });

      vm.unselectedOrgs = vm.orgs.filter(function (org) {
        return vm.orgFriends.indexOf(org._id) === -1 && Context.getOrganizationId() != org._id;
      });
    }

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.organization-details', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.organization-details', {
      url: '/organization',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/organization-details/organization.details.html',
          controller: 'OrganizationDetailsController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('organization_resource','GET');
        }
      }
    });


    // Navigation
    msNavigationServiceProvider.saveItem('Organization.organization-details', {
      title: 'Organization details',
      icon: '',
      state: 'app.restricted.organization-details',
      translate: 'NAVIGATION_ORG_DETAILS',
      weight: 6
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.organization-details')
    .controller('OrganizationDetailsController',orgDetailsController)
    .filter('trustAsResourceUrl', ['$sce', function ($sce) {
        return function (val) {
            return $sce.trustAsResourceUrl(val);
        };
    }]);

  /**ngInject*/
  function orgDetailsController($scope, Context,$filter, $rootScope, ExceptionHandler, Toast, License, Organization, Site, Auth, orderByFilter, $mdDialog, Branding,  $http, api, RecordWhiteList, Config,  $q, $location) {
    var vm = this;

    vm.licenses = [];
    vm.organization = {};
    vm.sentinel = {};
    vm.reverse = [];
    vm.brand = {};
    vm.picFile =  null;
    vm.validateFlag =  false;
    vm.image =  null;
    vm.isActionAllowed = Auth.isActionAllowed;
    vm.disablebutton = false;
    var date = new Date()
    vm.now = new Date(date.setDate(date.getDate() + 1));
    
    //Security
    vm.isRootAdmin = Auth.isRootAdmin();
    vm.allowCreate = Auth.isActionAllowed('organization_resource','POST');
    vm.allowModify = Auth.isActionAllowed('organization_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('organization_resource','DELETE');
    vm.allowReadLicenses = Auth.isActionAllowed('license_resource','GET');

    vm.allowModifyAudioRecorder = !Auth.isOrgAdmin();//Auth.isActionAllowed('reseller_resource','PUT');
    vm.isAdministrator = Auth.isAdministrator();
    vm.allowModifyCallLog = Auth.isActionAllowed('reseller_resource','PUT');

    vm.allowSetEncryption = Auth.isActionAllowed('organization_resource','HIMPACT');

    vm.enable_max_login_retries = false;
    vm.enable_password_expiration_days = false;

    //Vm methods
    vm.saveOrganization = saveOrganization;
    //vm.revokeAllocation = revokeAllocation;
    vm.saveOBranding =  saveOBranding;
    vm.saveOBrandingInfo = saveOBrandingInfo;
    vm.resetAllOverrideValues = resetAllOverrideValues;
    vm.onTabChanges = onTabChanges;
    //vm.editLicense = editLicense;
    vm.showLoader = true;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.uploadEncryptionFile = uploadEncryptionFile;
    vm.setEncryptionFile = setEncryptionFile;
    vm.setDefaultEncryptionFile = setDefaultEncryptionFile;
    vm.setEmptyEncryptionFile = setEmptyEncryptionFile;
    vm.uploadAndroidVersionFile = uploadAndroidVersionFile;
    vm.uploadMDCVersionFile = uploadMDCVersionFile;
    vm.deleteAndroidVersionFile = deleteAndroidVersionFile;
    vm.deleteMDCVersionFile = deleteMDCVersionFile;
    vm.saveSentinel = saveSentinel;
    vm.clearSentinel = clearSentinel;
    vm.resetDate = resetDate;
    vm.demoChecked = demoChecked;
    vm.currentEncStatus = {encFormat : '', encVersion: 0}
    vm.iframeUrl='';
    
    //Init
    if(Context.getOrganizationId()){
      setOrganization();
    }

    $rootScope.$on('updatedOrganizationId', function () {
      setOrganization();
    });

    $rootScope.$on('updatedResellerId', function () {
      vm.organization = {};
      vm.sentinel = {};
      vm.brand = {};
    });

    $rootScope.$on('clearResellerId', function () {
      vm.organization = {};
      vm.sentinel = {};
      vm.brand = {};
    });

    function setOrganization() {
      vm.image = "";
      vm.image_mdc_logo="";
      vm.image_mdc_splash="";
      vm.image_mdc_companyName="";
      vm.management_portal_image="";
      var parentResellerId = Context.getLastResellerId();
      var organizationId = Context.getOrganizationId();
      vm.brand = {};
      if(organizationId > 0) {
        vm.showLoader = true;
      }
      vm.iframeUrl = "//" + $location.host() + ":3007/sentinel?org="+organizationId;

      Organization.getById(organizationId, parentResellerId)
        .then(function(resp){
          vm.organization = resp;
          vm.oldOrganizationType = vm.organization.type;
          vm.qty = vm.organization.qty-vm.organization.availble_qty + "/" + vm.organization.qty;
          vm.dispatcherqty = vm.organization.dispatcher_qty-vm.organization.dispatcher_availble_qty + "/" + vm.organization.dispatcher_qty;
          vm.organization.parentResellerId = vm.organization.parentReseller;
          vm.organization.site = vm.organization.primary_site_id.toString();
          vm.organization.max_login_retries = vm.organization.max_login_retries ? vm.organization.max_login_retries.toString() : null;
          vm.organization.password_expiration_days = vm.organization.password_expiration_days ? vm.organization.password_expiration_days.toString() : null;
          vm.enable_max_login_retries = vm.organization.max_login_retries ? true : false;
          vm.enable_password_expiration_days = vm.organization.password_expiration_days ? true : false;
          //setLicense(Context.getOrganizationId());   //remove license
        
          if(vm.organization.creation_time){
            vm.organization.creation_time = $filter('date')(vm.organization.creation_time,'dd-MMM-yyyy HH:mm:ss');
          }
          
          if (vm.organization.isRecorded == undefined || vm.organization.isRecorded == null)
          vm.organization.isRecorded = 0;
        
          vm.organization._id && RecordWhiteList.getByOrgId(vm.organization._id)
            .then(function(results){
              if (!results.length) {
                vm.recorder = "noRecord";
                vm.strongRecordingReviewersPass = false
              }
              else {
                if (results[0].force_strong_pass_for_reviewers)
                  vm.strongRecordingReviewersPass = true
                else
                  vm.strongRecordingReviewersPass = false
                if (vm.organization.isRecorded == 0)
                  vm.recorder = "noRecord";
                else if (results[0].is_selective)
                  vm.recorder = "selective";
                else
                  vm.recorder = "allCalls";
              }
            })
            .catch(function(e){
              vm.recorder = "noRecord";
              vm.strongRecordingReviewersPass = false
            });

            if (vm.organization._id) {
              getCurrentEncKeysStatus();
              getSentinel()
            }
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        });

        Config.getFilterList().then(function(resp){
          vm.configs = resp;
          
          vm.showRecording = vm.configs.filter(function(param){
            return param.name == "PROV_SHOW_RECORDING";
          });
          
          if (!vm.showRecording || !vm.showRecording[0] || vm.showRecording[0].value == "0")
            vm.showRecording = false;
          else
            vm.showRecording = true;

          vm.showCallLog = vm.configs.filter(function(param){
            return param.name == "PROV_SHOW_CALL_LOG";
          });
          
          if (!vm.showCallLog || !vm.showCallLog[0] || vm.showCallLog[0].value == "0")
            vm.showCallLog = false;
          else
            vm.showCallLog = true;
    
          vm.showBranding = vm.configs.filter(function(param){
            return param.name == "PROV_SHOW_BRANDING";
          });
          
          if (!vm.showBranding || !vm.showBranding[0] || vm.showBranding[0].value == "0")
            vm.showBranding = false;
          else
            vm.showBranding = true;

          vm.showLicenseAllocation = vm.configs.filter(function(param){
            return param.name == "PROV_SHOW_LICENSE_ALLOCATION";
          });
          
          if (!vm.showLicenseAllocation || !vm.showLicenseAllocation[0].value || vm.showLicenseAllocation[0].value == "0")
            vm.showLicenseAllocation = false;
          else
            vm.showLicenseAllocation = true;


          vm.showEncryption = vm.configs.filter(function(param){
            return param.name == "PROV_SHOW_ENCRYPTION";
          });

          if (!vm.showEncryption || !vm.showEncryption[0] || vm.showEncryption[0].value == "0")
            vm.showEncryption = false;
          else
            vm.showEncryption = true;

         vm.showRandomEncryptionKeysButton = vm.configs.filter(function(param){
           return param.name == "PROV_SHOW_RANDOM_ENCRYPTION_KYES_BUTTON";
         });
         
         if (!vm.showRandomEncryptionKeysButton || !vm.showRandomEncryptionKeysButton[0] || vm.showRandomEncryptionKeysButton[0].value == "0")
           vm.showRandomEncryptionKeysButton = false;
         else
           vm.showRandomEncryptionKeysButton = true;

            vm.showUploadVersion = vm.configs.filter(function(param){
              return param.name == "PROV_SHOW_UPLOAD_VERSION";
            });
            
            if (!vm.showUploadVersion || !vm.showUploadVersion[0] || vm.showUploadVersion[0].value == "0")
              vm.showUploadVersion = false;
            else
              vm.showUploadVersion = true;

            vm.showDemoOrganization = vm.configs.filter(function(param){
              return param.name == "PROV_SHOW_DEMO_ORGANIZATION";
            });
            if (!vm.showDemoOrganization || !vm.showDemoOrganization[0].value || vm.showDemoOrganization[0].value == "0")
              vm.showDemoOrganization = false;
            else
              vm.showDemoOrganization = true;

            vm.demo_duration = vm.configs.filter(function(param){
              return param.name == "PROV_DURATION_TIME_IN_DEMO";
            });
            if (!vm.demo_duration || !vm.demo_duration[0].value)
              vm.demo_duration = 30;
            else
              vm.demo_duration = vm.demo_duration[0].value

          vm.showStrongDispatchPass = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_STRONG_DISPATCH_PASS";
          });
          if (!vm.showStrongDispatchPass || !vm.showStrongDispatchPass[0] || vm.showStrongDispatchPass[0].value == "0")
            vm.showStrongDispatchPass = false;
          else
            vm.showStrongDispatchPass = true;

          vm.showStrongRecordingReviewersPass = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_STRONG_RECORDING_REVIEWERS_PASS";
          });
          if (!vm.showStrongRecordingReviewersPass || !vm.showStrongRecordingReviewersPass[0] || vm.showStrongRecordingReviewersPass[0].value == "0")
            vm.showStrongRecordingReviewersPass = false;
          else
            vm.showStrongRecordingReviewersPass = true;

          vm.showStrongAdministratorPass = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_STRONG_ADMINISTRATOR_PASS";
          });
          if (!vm.showStrongAdministratorPass || !vm.showStrongAdministratorPass[0] || vm.showStrongAdministratorPass[0].value == "0")
            vm.showStrongAdministratorPass = false;
          else
            vm.showStrongAdministratorPass = true;

          vm.showMaxRetries = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_BLOCK_RELEASE";
          });
          if (!vm.showMaxRetries || !vm.showMaxRetries[0] || vm.showMaxRetries[0].value == "0")
            vm.showMaxRetries = false;
          else
            vm.showMaxRetries = true;
      
          vm.showPasswordExpiration = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_CHANGE_PASSWORD";
          });
          if (!vm.showPasswordExpiration || !vm.showPasswordExpiration[0] || vm.showPasswordExpiration[0].value == "0")
            vm.showPasswordExpiration = false;
          else
            vm.showPasswordExpiration = true;
      
          vm.showSentinelAddress = vm.configs.filter(function (param) {
            return param.name == "PROV_SENTINEL_TEST_ADDRESS";
          });
          if (!vm.showSentinelAddress || !vm.showSentinelAddress[0] || vm.showSentinelAddress[0].value == '')
            vm.showSentinelAddress = '';
          else
            vm.showSentinelAddress = vm.showSentinelAddress[0].value;

            vm.consturl = new URL(vm.showSentinelAddress); 
      
          vm.showLiveSentinel = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_LIVE_SENTINEL_EVENT";
          });
          if (!vm.showLiveSentinel || !vm.showLiveSentinel[0] || vm.showLiveSentinel[0].value == "0")
            vm.showLiveSentinel = false;
          else
            vm.showLiveSentinel = true;;

             Branding.getBrandingInfo(organizationId)
          .then(function(respBrand){
            vm.brand = respBrand;
          })
          .catch(function(e){
            if(e.status !== 404)
              ExceptionHandler.show(e);
          });
          if(vm.showBranding)
          {
            var flowFunctionsArray = [];

              flowFunctionsArray.push(getBrandingImage(organizationId));
              flowFunctionsArray.push(getImage(organizationId, "Logo"));
              flowFunctionsArray.push(getImage(organizationId, "Splash"));
              flowFunctionsArray.push(getImage(organizationId, "CompanyName"));
              flowFunctionsArray.push(getImage(organizationId, "ManagementPortal"));
              
              $q.all(flowFunctionsArray)
              .then(function(){
              })
              .catch(function(err){
                ExceptionHandler.show(err);
              });
          }
          
            
        });

      Site.getList()
        .then(function(resp){
          vm.sites = resp.filter(function(site) {
            site.iprs_public = site.iprs_public ? "(" + site.iprs_public  + ")" : "";
            return site.type === 1;
          })
        })
        .catch(function(e){
          ExceptionHandler.log(e);
        })
        .finally(function(){
          vm.showLoader = false;
        });
    }

    function getBrandingImage(orgId){
      var deferred = $q.defer();
      Branding.getBrandingImage(orgId)
      .then(function(respBrandImg){
        vm.image="";
        if(typeof respBrandImg.image !== 'undefined'){
          vm.image = respBrandImg.image;
        }
        deferred.resolve();
      })
      .catch(function(e){
        deferred.reject(e);
      });
      return deferred.promise;
    }

    function getImage(orgId, type){
      var deferred = $q.defer();
      Branding.getBrandingExtraImage(orgId, type)
      .then(function(respBrandImg){
        if(typeof respBrandImg.image !== 'undefined'){
          if (type == "Logo")
            vm.image_mdc_logo = respBrandImg.image;
          else if (type == "Splash")
            vm.image_mdc_splash = respBrandImg.image;
          else if (type == "CompanyName")
            vm.image_mdc_companyName = respBrandImg.image;
          else if (type == "ManagementPortal")
            vm.management_portal_image = respBrandImg.image;
        }
        deferred.resolve();
      })
      .catch(function(e){
        deferred.reject(e);
      });
      return deferred.promise;
    }

    function demoChecked(){
      if (vm.organization.type == 1 && vm.organization.demo_expiration == null){
        var date = new Date()
        vm.organization.demo_expiration = new Date(date.setDate(date.getDate() + Number(vm.demo_duration)))
      }
      if (vm.organization.type !== 1) {
        vm.resetDate()
      }
    }

    function saveOrganization(){
      (vm.organization.type == 1 && vm.oldOrganizationType == 0) ?  display_note_msg() : updateOrganization();
    }

    function display_note_msg(){
      if(vm.organization.demo_expiration) vm.days = Math.round((vm.organization.demo_expiration - new Date())/(24*60*60*1000));// 24*60*60*1000 is 1 day in ms 
      else vm.days = vm.demo_duration;
      var confirm = Toast.getDemoOrganization(vm.days);

      $mdDialog.show(confirm)
        .then(function () {
          updateOrganization();
        })
        .catch(function(){
          vm.organization.type = 0;
          updateOrganization();
        })
    }

    function updateOrganization(){
      // vm.loading = true ;
      var updateObject = {
        orgId : vm.organization._id,
      }
      if (vm.strongRecordingReviewersPass) {   
        updateObject["force_strong_pass_for_reviewers"] = true
      } else {
        updateObject["force_strong_pass_for_reviewers"] = false
      }
      if (vm.recorder == "noRecord"){
        vm.organization.isRecorded = 0;
      }
      else{
        vm.organization.isRecorded = 1;
        if (vm.recorder == "selective")
          updateObject["is_selective"] = true
        else
          updateObject["is_selective"] = false
      }

      vm.organization.max_login_retries = !vm.enable_max_login_retries ? null : vm.organization.max_login_retries;
      vm.organization.password_expiration_days = !vm.enable_password_expiration_days ? null : vm.organization.password_expiration_days;

      if (!vm.organization.max_login_retries || vm.organization.max_login_retries == 0){
        vm.enable_max_login_retries = 0;
        vm.organization.max_login_retries = null;
      }
      if (!vm.organization.password_expiration_days || vm.organization.password_expiration_days == 0){
        vm.enable_password_expiration_days = 0;
        vm.organization.password_expiration_days = null;
      }
      

     RecordWhiteList.update(updateObject)
     .then(function () {
       Organization.update(vm.organization)
       .then(function(resp){
         vm.oldOrganizationType = vm.organization.type;
         if (!vm.organization.demo_expiration && vm.organization.type == 1){
           var date = new Date();
           vm.organization.demo_expiration = new Date(date.setDate(date.getDate() + Number(vm.demo_duration)));
         }
         Toast.showUpdate();
       })
       .catch(function(e){
         ExceptionHandler.show(e);
       })
       .finally(function(){
         if (!vm.organization.type || vm.organization.type == 0) vm.organization.demo_expiration = null;
         vm.showLoader = false;
        //  vm.loading = false ;
       });
     })
     .catch(function (e) {
       ExceptionHandler.show(e);
     });
    }

    function updateBrandingImage(image, org, type){
      var deferred = $q.defer();
      Branding.setBrandingImage(image, org, type)
      .then(function(result){
        deferred.resolve();
      })
      .catch(function (e) {
        deferred.reject(e);
      });

      return deferred.promise;
    }

    function saveOBranding(){
      // vm.loading = true ;

      var flowFunctionsArray = [];

      var organizationId = Context.getOrganizationId();

      if(file.files.length===0 && vm.brand.override_branding_image  && !vm.image)
        vm.brand.override_branding_image = false;
      if (file.files.length > 0)
        flowFunctionsArray.push(uploadBrandingImage(file, organizationId))

      if(file_mdc_logo.files.length===0 && vm.brand.override_mdc_logo_image  && !vm.image_mdc_logo)
        vm.brand.override_mdc_logo_image = false;
      if (file_mdc_logo.files.length > 0)
        flowFunctionsArray.push(uploadImage(file_mdc_logo, organizationId, "Logo"))

      if(file_mdc_splash.files.length===0 && vm.brand.override_mdc_splash_image  && !vm.image_mdc_splash)
        vm.brand.override_mdc_splash_image = false;
      if (file_mdc_splash.files.length > 0)
        flowFunctionsArray.push(uploadImage(file_mdc_splash, organizationId, "Splash"))

      if(file_mdc_companyName.files.length===0 && vm.brand.override_mdc_companyName_image  && !vm.image_mdc_companyName)
        vm.brand.override_mdc_companyName_image = false;
      if (file_mdc_companyName.files.length > 0)
        flowFunctionsArray.push(uploadImage(file_mdc_companyName, organizationId, "CompanyName"))

      if(management_portal_logo.files.length===0 && vm.brand.override_management_portal_image  && !vm.management_portal_image)
        vm.brand.override_management_portal_image = false;
      if (management_portal_logo.files.length > 0)
        flowFunctionsArray.push(uploadImage(management_portal_logo, organizationId, "ManagementPortal"))
        
      
      $q.all(flowFunctionsArray)
      .then(function(){
        $rootScope.$emit('upadatebranding');
        // vm.loading = false;
        Toast.showUpdate();
      })
      .catch(function(err){
        // vm.loading = false ;
        ExceptionHandler.show(err);
      });
    }

    function saveOBrandingInfo() {
      // vm.loading = true ;

      if (!vm.brand.name)
        vm.brand.override_branding_name = false;

      Branding.setBrandingInfo(vm.brand,Context.getOrganizationId())
        .then(function () {
          saveOBranding();
        })
        .catch(function(e){
          ExceptionHandler.show(e);
          // vm.loading = false ;
        });
    }

    function uploadBrandingImage(file, orgId){
      var deferred = $q.defer();

      var fd = new FormData();
      fd.append('file', file.files[0]);
      
      Branding.setBrandingImage(fd, orgId)
      .then(function(result){
        Branding.getBrandingImage(orgId)
          .then(function(respBrandImg){
            vm.image = respBrandImg.image;
            deferred.resolve();
          })
          .catch(function(e){
            deferred.reject(e);
          });
      })
      .catch(function (e) {
        deferred.reject(e);
      });

      return deferred.promise;
    }

    function uploadImage(file, orgId, type){
      var deferred = $q.defer();

      var fd = new FormData();
      fd.append('file', file.files[0]);
      
      Branding.setBrandingExtraImage(fd, orgId, type)
      .then(function(result){
        Branding.getBrandingExtraImage(orgId, type)
          .then(function(respBrandImg){
            if (type == "Logo")
              vm.image_mdc_logo = respBrandImg.image;
            else if (type == "Splash")
              vm.image_mdc_splash = respBrandImg.image;
            else if (type == "CompanyName")
              vm.image_mdc_companyName = respBrandImg.image;
            else if (type == "ManagementPortal")
              vm.management_portal_image = respBrandImg.image;
            deferred.resolve();
          })
          .catch(function(e){
            deferred.reject(e);
          });
      })
      .catch(function (e) {
        deferred.reject(e);
      });

      return deferred.promise;
    }


    function resetAllOverrideValues() {
      vm.brand.override_branding_name = false;
      vm.brand.override_branding_color1 = false;
      vm.brand.override_branding_color2 = false;
      vm.brand.override_branding_image = false;
      vm.brand.override_mdc_logo_image = false;
      vm.brand.override_mdc_splash_image = false;
      vm.brand.override_mdc_companyName_image = false;
    }

    $scope.onUploadFile = function(elem){
      if (elem.files && elem.files.length > 0){
        var ext = elem.files[0].name.split('.');
        if (!elem.accept.includes(ext[ext.length-1])){
          if (elem.name == "file")
            vm.organizationFormBranding.file.$setValidity('validationError', false);
          if (elem.name == "file_mdc_logo")
            vm.organizationFormBranding.file_mdc_logo.$setValidity('validationError', false);
          if (elem.name == "file_mdc_splash")
            vm.organizationFormBranding.file_mdc_splash.$setValidity('validationError', false);
          if (elem.name == "file_mdc_companyName")
            vm.organizationFormBranding.file_mdc_companyName.$setValidity('validationError', false);
          if (elem.name == "management_portal_logo")
            vm.organizationFormBranding.management_portal_logo.$setValidity('validationError', false);
        }
        else{
          if (elem.name == "file")
            vm.organizationFormBranding.file.$setValidity('validationError', true);
          if (elem.name == "file_mdc_logo")
            vm.organizationFormBranding.file_mdc_logo.$setValidity('validationError', true);
          if (elem.name == "file_mdc_splash")
            vm.organizationFormBranding.file_mdc_splash.$setValidity('validationError', true);
          if (elem.name == "file_mdc_companyName")
            vm.organizationFormBranding.file_mdc_companyName.$setValidity('validationError', true);
          if (elem.name == "management_portal_logo")
            vm.organizationFormBranding.management_portal_logo.$setValidity('validationError', true);
        }
      }
      else{
        if (elem.name == "file")
            vm.organizationFormBranding.file.$setValidity('validationError', true);
          if (elem.name == "file_mdc_logo")
            vm.organizationFormBranding.file_mdc_logo.$setValidity('validationError', true);
          if (elem.name == "file_mdc_splash")
            vm.organizationFormBranding.file_mdc_splash.$setValidity('validationError', true);
          if (elem.name == "file_mdc_companyName")
            vm.organizationFormBranding.file_mdc_companyName.$setValidity('validationError', true);
          if (elem.name == "management_portal_logo")
            vm.organizationFormBranding.management_portal_logo.$setValidity('validationError', true);
      }
    }

    // function setLicense(orgId){   //shahar- remove licenses
    //   if (vm.allowReadLicenses) {
    //     License.getAllocationList(orgId)
    //       .then(function (resp) {
    //         vm.licenses = resp;
    //       })
    //       .catch(function (e) {
    //         ExceptionHandler.show(e);
    //       });
    //   }
    // }

    // function revokeAllocation(allocationId){    /shahar- remove license
    //   console.log(allocationId);
    //   License.revokeAllocation(allocationId)
    //     .then(function(resp){
    //       console.log(resp);
    //       License.getAllocationList(Context.getOrganizationId())
    //         .then(function (respGetAll) {
    //           console.log( "get all function");
    //           console.log( respGetAll);
    //           vm.licenses = respGetAll;
    //           Toast.showRevoke();
    //         });

    //     })
    //     .catch(function(e){
    //       if(e.data.msg === 'failed'){
    //         Toast.showFailedRevoke();
    //       }else{
    //         ExceptionHandler.show(e);
    //       }
    //     });
    // }

    function onTabChanges(index){
      vm.activeTab = index;
    }

    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    // function editLicense(license, allocationId) {   //shahar- remove license
    //   var curRes = {};
    //   angular.copy(license, curRes);
    //   if (curRes.licenseBundle.dispatcher.dispatcher === undefined){
    //     if (curRes.licenseBundle.dispatcher === false)
    //     {
    //       curRes.licenseBundle.dispatcher = {
    //         dispatcher: false,
    //         multiSession: "0"
    //       };
    //     }
    //     else
    //     {
    //       curRes.licenseBundle.dispatcher = {
    //         dispatcher: true,
    //         multiSession: "1"
    //       };
    //     }
    //   }

    //   $mdDialog.show({
    //     controller: 'licenseDetailsController as vm',
    //     templateUrl: 'app/main/restricted/platform/licenses/details/details.dialog.html',
    //     parent: angular.element(document.body),
    //     clickOutsideToClose: false,
    //     multiple: true,
    //     locals: {
    //       license: curRes,
    //       allocationId: allocationId
    //     }
    //   })
    //     .then(function (respLicense) {
    //       angular.copy(respLicense, license);

    //     })

    // }

    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.licenses = orderByFilter(vm.licenses,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    function uploadEncryptionFile(){
      if (!file1.files[0])
        Toast.showVersionFileEmpty();
      else{
        vm.disablebutton = true;
        // vm.loading = true;
        var fd = new FormData();
        fd.append('file', file1.files[0]);
        Organization.uploadOrganizarionKeyFile(fd, vm.organization._id)
        .then(function(){
          convertEncKeysStatusToString({encFormat: 4, encVersion : vm.currentEncStatus.encVersion + 1 })
          Toast.showKeyFileUpdate();
          vm.disablebutton = false;
          // vm.loading = false;
        })
        .catch(function(err){
          ExceptionHandler.show(err);
          vm.disablebutton = false;
          // vm.loading = false;
        })
      }
    }

    function setEncryptionFile() {
      vm.disablebutton = true;
      // vm.loading = true;
      var confirm = Toast.getEncryptionKeysGenerationDialog()
      $mdDialog.show(confirm)
        .then(function () {
          Organization.setOrganizationKeyFile(false, vm.organization._id)
            .then(function () {
              convertEncKeysStatusToString({encFormat: 3, encVersion : vm.currentEncStatus.encVersion + 1})
              Toast.showKeyFileUpdate();
              vm.disablebutton = false;
              // vm.loading = false;
            })
            .catch(function (err) {
              ExceptionHandler.show(err);
              vm.disablebutton = false;
              // vm.loading = false;
            })
        })
        .catch(function () {
          vm.disablebutton = false;
        })
    }

    function setDefaultEncryptionFile(){
      vm.disablebutton = true;
      // vm.loading = true;
      Organization.setOrganizationKeyFile(true, vm.organization._id)
      .then(function(){
        convertEncKeysStatusToString({encFormat:2 , encVersion : vm.currentEncStatus.encVersion + 1})
        Toast.showKeyFileUpdate();
        vm.disablebutton = false;
        // vm.loading = false;
      })
      .catch(function(err){
        ExceptionHandler.show(err);
        vm.disablebutton = false;
        // vm.loading = false;
      })
    }
    
    function setEmptyEncryptionFile(){
      vm.disablebutton = true;
      // vm.loading = true;
      Organization.setOrganizationEmptyKeyFile(vm.organization._id)
      .then(function(){
        convertEncKeysStatusToString({encFormat: 1, encVersion : vm.currentEncStatus.encVersion + 1 })
        Toast.showEmptyKeyFileUpdate();
        vm.disablebutton = false;
        // vm.loading = false;
      })
      .catch(function(err){
        ExceptionHandler.show(err);
        vm.disablebutton = false;
        // vm.loading = false;
      })
    }

    function uploadAndroidVersionFile(){
      if (!fileAndroid.files[0])
        Toast.showVersionFileEmpty();
      else{
        vm.disablebutton = true;
        // vm.loading = true;
        var fd = new FormData();
        fd.append('file', fileAndroid.files[0]);
        Organization.uploadVersionFile(fd, vm.organization._id, "Android")
        .then(function(){
          Toast.showVersionFileUpdate();
          vm.disablebutton = false;
          // vm.loading = false;
          Branding.getBrandingInfo(vm.organization._id)
          .then(function(respBrand){
            vm.brand = respBrand;
          });
        })
        .catch(function(err){
          if(err.status !== 404)
            ExceptionHandler.show(err);
          vm.disablebutton = false;
          // vm.loading = false;
        })
      }
    }
    
    function uploadMDCVersionFile(){
      if (!fileMDC.files[0])
        Toast.showVersionFileEmpty();
      else{
        vm.disablebutton = true;
        // vm.loading = true;
        var fd = new FormData();
        fd.append('file', fileMDC.files[0]);
        Organization.uploadVersionFile(fd, vm.organization._id, "MDC2000")
        .then(function(){
          Toast.showVersionFileUpdate();
          vm.disablebutton = false;
          // vm.loading = false;
          Branding.getBrandingInfo(vm.organization._id)
            .then(function(respBrand){
              vm.brand = respBrand;
            });
        })
        .catch(function(err){
          if(err.status !== 404)
            ExceptionHandler.show(err);
          vm.disablebutton = false;
          // vm.loading = false;
        })
      }
    }

    function deleteAndroidVersionFile(){
      Organization.deleteVersionFile(vm.organization._id, "Android")
      .then(function(){
        Toast.showVersionFileDelete();
        vm.disablebutton = false;
        // vm.loading = false;
        Branding.getBrandingInfo(vm.organization._id)
        .then(function(respBrand){
          vm.brand = respBrand;
        });
      })
      .catch(function(err){
        if(err.status !== 404)
          ExceptionHandler.show(err);
        vm.disablebutton = false;
        // vm.loading = false;
      })
    }
    
    function deleteMDCVersionFile(){
      Organization.deleteVersionFile(vm.organization._id, "MDC2000")
      .then(function(){
        Toast.showVersionFileDelete();
        vm.disablebutton = false;
        // vm.loading = false;
        Branding.getBrandingInfo(vm.organization._id)
        .then(function(respBrand){
          vm.brand = respBrand;
        });
      })
      .catch(function(err){
        if(err.status !== 404)
          ExceptionHandler.show(err);
        vm.disablebutton = false;
        // vm.loading = false;
      })
    }

    function resetDate() {
      vm.organization.demo_expiration = undefined;
    }


    function getCurrentEncKeysStatus() {
      Organization.getOrganizationEncStatus(vm.organization._id)
        .then(function (resp) {
          convertEncKeysStatusToString(resp)
        })
        .catch(function (e) {
          ExceptionHandler.show(e.data);
        })
    }

    function convertEncKeysStatusToString(currentEncDetails) {
      vm.currentEncStatus.encVersion = currentEncDetails.encVersion
      switch (currentEncDetails.encFormat) {
        case 0:
          vm.currentEncStatus.encFormat = "Unknown"
          break
        case 1:
          vm.currentEncStatus.encFormat = "APP_ENCRYPTION_KEYS_CURRENT_STATUS_NO_KEYS"
          break
        case 2:
          vm.currentEncStatus.encFormat = "APP_ENCRYPTION_KEYS_CURRENT_STATUS_DEFAULT_KEYS"
          break
        case 3:
          vm.currentEncStatus.encFormat = "APP_ENCRYPTION_KEYS_CURRENT_STATUS_RANDOM_KEYS"
          break
        case 4:
          vm.currentEncStatus.encFormat = "APP_ENCRYPTION_KEYS_CURRENT_STATUS_UPLOAD_KEYS_FILE"
          break
        default:
          vm.currentEncStatus.encFormat = "Unknown"
          break
      }
      //vm.currentEncStatus.encFormat = $filter('translate')(vm.currentEncStatus.encFormat);
    }

    function saveSentinel(){      
      if(vm.sentinel.path.charAt(0) != '/')
        vm.sentinel.path = '/'+vm.sentinel.path;
      if(vm.sentinel.host && vm.sentinel.port && vm.sentinel.path && vm.orgSenForm.$valid)
      {
        vm.sentinel.org_id = vm.organization._id;
        Organization.setSentinel(vm.sentinel).then(function (resp){
            Toast.showUpdate();
        }).catch(function (error){
          ExceptionHandler.show(error.data);
        })
      }
    }

    function clearSentinel(){
      Organization.removeSentinel(vm.organization._id).then(function (resp){
          Toast.showDelete();
          getSentinel()
      }).catch(function (error){
        ExceptionHandler.show(error.data);
      })
    }

    function getSentinel(){
        Organization.getSentinel(vm.organization._id).then(function (resp){
          if(resp != ''){
            vm.sentinel = resp;
            if(vm.sentinel.host)
              vm.iframeUrl = vm.sentinel.host+':'+vm.sentinel.port+vm.sentinel.path+'?org='+vm.organization._id;
            else
              vm.iframeUrl = "//" + $location.host() + ":3007/sentinel?org="+vm.organization._id;
          }
          else
            vm.sentinel ={};
        }).catch(function (err){
          vm.sentinel ={};
          ExceptionHandler.show(err.data);
        });
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.locationHistory')
    .controller('locationHistoryController', LocationHistoryController);



  /** @ngInject*/
  function LocationHistoryController($mdDialog, $q, ExceptionHandler, localStorageService, locationHistory, Config, $rootScope, ProgressCircularSer, Context, orderByFilter, $timeout, $filter, $translate, Toast, Organization, OrgFriends, $scope) {
    var vm = this;

    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;

    vm.sessions = [];
    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.organizationId = '';
    vm.reverse = [];
    // vm.showLoader = false;

    vm.showSession = showSession;

    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    vm.checkDate = checkDate;
    vm.getSessionsByDates = getSessionsByDates;
    vm.loadMoreLogs = loadMoreLogs;
    vm.refreshCallLogs = refreshCallLogs;
    vm.searchCallLogs = searchCallLogs;
    vm.getData = getData;
    vm.errMessage = "";
    vm.filtered = false;
    vm.concateData = false;
    vm.startIndex = 0;
    vm.lastIndex = 100;
    vm.currentPage = 1;
    vm.dates = {};
    vm.exportTypeCallLog = "excel";
    vm.requestCounter = 0;

    vm.getExportCallLogs = getExportCallLogs;

    vm.organizationId = Context.getOrganizationId();

    $rootScope.$$listeners.updatedOrganizationId = [];

    vm.dates.startDate = new Date(new Date().setHours(0, 0, 0, 0));
    vm.dates.endDate = new Date(new Date().setHours(23, 59, 59, 999));
    vm.dates.now = new Date();
    vm.minDate = new Date('01/01/2000');
    vm.maxEndDate = vm.dates.startDate;
    vm.organizationNew = Organization;
    vm.parentAffOrgId = Context.getResellerId();
    vm.orgFriendsID = "0";
    if (vm.organizationId) getConfig();

    $rootScope.$on('updatedOrganizationId', function () {
      vm.sessions = [];
      vm.organizationId = Context.getOrganizationId();
      vm.dates = {};
      vm.dates.startDate = new Date(new Date().setHours(0, 0, 0, 0));
      vm.dates.endDate = new Date(new Date().setHours(23, 59, 59, 999));
      vm.dates.now = new Date();
      vm.maxEndDate = vm.dates.startDate;
      vm.parentAffOrgId = Context.getResellerId();
      if (vm.organizationId) getConfig();

    });

    /**
     * clear session list when customer choose reseller on header menu
     */
    $rootScope.$on('updatedResellerId', function () {
      vm.sessions = [];
      vm.organizationId = '';
      vm.dates = {};
      vm.parentAffOrgId = Context.getResellerId();
    });

    function getConfig() {
      Config.getFilterList().then(function (resp) {
        vm.configs = resp;
        vm.diffDays = vm.configs.filter(function (param) {
          return param.name == "PROV_LOCATION_HISTORY_DAYS";
        });
        vm.diffDays = vm.diffDays[0].value;
      })
        .catch(function (e) {
          vm.diffDays = 30;
        })
        .finally(function () {
          setTimeout(function () {
            setTimeout(function () {
              getSessionsByDates();
            }, 1800);
          }, 1000);
        });
    }

    /**
     * sort session list
     */
    function setRecordsCount() {
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort session list
     */
    function sort(param) {
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.sessions = orderByFilter(vm.sessions, param, vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param) {
      return vm.reverse[param] ? "up" : "down";
    }

    function showSession(session) {
      if(session && vm.dates && vm.dates.startDate && vm.dates.endDate)
      {
        var start = $filter('date')(vm.dates.startDate, 'dd-MMM-yyyy,');
        var end = $filter('date')(vm.dates.endDate, 'dd-MMM-yyyy,');
        locationHistory.getLocationbyUser(session.user_id, start, end).then(function (resp) {
          vm.sessionData = resp.map(function (s) {
              s.format_created_at = $filter('date')(s.created_at, 'dd-MMM-yyyy, HH:mm:ss');
              return s;
            });
          $mdDialog.show({
            controller: 'locationHistoryDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/restricted/organization/locationHistory/details/locationHistory.dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            skipHide: true,
            locals: {
              session: vm.sessionData,
            }
          })
        })
        .catch(function (e) {
          if (e.status !== 404) {
            ExceptionHandler.show(e);
            deferred.reject(e);
          }
        })
      }
    }

    function checkDate(id) {
      vm.errMessage = '';

      if (id == 0) { //start date was change
        var newMaxEndDate = new Date(vm.dates.startDate);
        var tempMaxEndDate = new Date(vm.dates.startDate);

        var lastDate = new Date(tempMaxEndDate.getFullYear(), tempMaxEndDate.getMonth() + 1, 0);
        newMaxEndDate.setDate(newMaxEndDate.getDate() + Number(vm.diffDays - 1));

        (newMaxEndDate < vm.dates.now) ? vm.maxEndDate = new Date(newMaxEndDate) : vm.maxEndDate = new Date(vm.dates.now);
        (newMaxEndDate < vm.dates.now || vm.dates.now > lastDate) ? ((newMaxEndDate > lastDate) ? vm.maxEndDate = new Date(lastDate) : vm.maxEndDate = new Date(newMaxEndDate)) : vm.maxEndDate = new Date(vm.dates.now);

        vm.dates.endDate = '';
      }
      else {
        setTimeout(function () {
          getSessionsByDates();
        }, 1800);
        vm.concateData = false;
        vm.startIndex = 0;
        $scope.sessionsRecords__currentPage = 1;
      }
    }

    function getSessionsByDates() {
      var deferred = $q.defer();
      setTimeout(function () {
        $rootScope.loaderState = true;
        $rootScope.$emit('loaderMainUpdatedValue');
      }, 2000);
      if (vm.dates && vm.dates.startDate && vm.dates.endDate) {
        if (vm.errMessage == '') {
          // vm.showLoader = true;
          vm.requestCounter++;
          if (vm.search == '')
            var seachVal = 'NULL';
          else
            var seachVal = vm.search;
          if (vm.concateData == false)
            vm.sessions = []


          vm.dates.startDate.setHours(0, 0, 0, 0);
          vm.dates.endDate.setHours(23, 59, 59, 999);


          // console.log(vm.dates);

          var start = $filter('date')(vm.dates.startDate, 'dd-MMM-yyyy,');
          var end = $filter('date')(vm.dates.endDate, 'dd-MMM-yyyy,');

          // console.log(start);
          // console.log(end);


          // console.log(new Date());

          // console.log(new Date().getTimezoneOffset());

          locationHistory.getLocationbyOrg(vm.organizationId, start, end).then(function (resp) {
            // vm.sessions = Object.assign([], resp);
            vm.filtered = true;
            var sessionData = resp.map(function (s) {
              {
                s.lastUpdateDate = $filter('date')(s.last_update_date, 'dd-MMM-yyyy, HH:mm:ss');
              }
              return s;
            });
            vm.sessions = Object.assign([], sessionData);
            deferred.resolve(vm.sessions);
          })
          .catch(function (e) {
            if (e.status !== 404) {
              ExceptionHandler.show(e);
              deferred.reject(e);
            }
          })
          .finally(function () {
            vm.requestCounter--;
            deferred.resolve(vm.sessions);
            // vm.showLoader = vm.requestCounter > 0 ? true : false;
          });
        }
      } else {
        vm.errMessage = $translate.instant("DATES_BLANK_ERROR");//'Provide start date and end date';
        deferred.reject(false);

      }
      return deferred.promise;

    }
    function loadMoreLogs() {
      vm.startIndex = vm.startIndex + vm.lastIndex;
      getSessionsByDates();
    }
    function refreshCallLogs() {
      vm.startIndex = 0;
      vm.concateData = false;
      $scope.sessionsRecords__currentPage = 1;
      getSessionsByDates();
    }
    function getData(pageNo) {
      var callFunCount = parseInt(vm.sessions.length / vm.recordsCount) + 1;
      if (pageNo == callFunCount) {
        vm.concateData = true;
        loadMoreLogs();
        // $scope.sessionsRecords__currentPage=1;
      }
    }
    function searchCallLogs() {
      vm.startIndex = 0;
      vm.concateData = false;
      $scope.sessionsRecords__currentPage = 1;
      getSessionsByDates();
    }

    function exportToExcel(xlsHeader, xlsRows, filename) {
      var createXLSLFormatObj = [];

      createXLSLFormatObj.push(xlsHeader);
      $.each(xlsRows, function (index, value) {
        var innerRowData = [];
        $.each(value, function (ind, val) {
          innerRowData.push(val);
        });
        createXLSLFormatObj.push(innerRowData);
      });

      var ws_name = "ExportSheet";

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);

      /* Add worksheet to workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);

      /* Write workbook and Download */
      XLSX.writeFile(wb, filename);
    }

    function formatForExportCallLogs(sessions) {
      var deferred = $q.defer();
      vm.exportBursts = [];

      for (var i = 0; i < sessions.length; i++) {
        if (!sessions[i].locations || sessions[i].locations.length == 0) {
          var exportBurst = {
            DisplayName: sessions[i].display_name,
            UserId: sessions[i].user_id,
            Latitude: "",
            Longitude: "",
            Accuracy: "",
            CreatedAt: ""
          };
          vm.exportBursts.push(exportBurst);
        }
        else {
          sessions[i].locations.map(function (location) {             
              var exportBurst = {
                UserName: sessions[i].display_name,
                UserId: sessions[i].user_id,
                Latitude: location.lat,
                Longitude: location.lon,
                Accuracy: location.accuracy,
                CreatedAt: $filter('date')(location.created_at, "dd-MMM-yyyy, HH:mm:ss")
              };
              vm.exportBursts.push(exportBurst);
          });
        }
      }
      deferred.resolve(vm.exportBursts);
      return deferred.promise;
    }

    function getExportCallLogs() {
      var deferred = $q.defer();
      // vm.showLoader = true;
      vm.timestamp = Date.now();

      var flowFunctionsArray = [];

      // vm.sessions.filter(function(session){
      //   flowFunctionsArray.push(getSessionBursts(session));
      // });

      // $q.all(flowFunctionsArray)
      // .then(function(){
      
      var start = $filter('date')(vm.dates.startDate, 'dd-MMM-yyyy,');
      var end = $filter('date')(vm.dates.endDate, 'dd-MMM-yyyy,');
      locationHistory.getAllLocationbyOrg(vm.organizationId, start, end).then(function (ress) {
        formatForExportCallLogs(ress)
          .then(function (results) {
            var excelRowLimit = 1048500;
            if (results.length >= excelRowLimit) {
              // Show modal confirmation
              $mdDialog.show(
                $mdDialog.confirm()
                  .title("Too much data for Excel")
                  .textContent("The data contains " + results.length +
                    "rows, which exceeds Excel’s maximum limit of 1,048,576 rows and cannot be exported. " +
                    "Would you like to download it as a CSV file instead?")
                  .ok("Yes, download CSV")
                  .cancel("No, cancel")
              ).then(function () {
                // User clicked YES - fallback to CSV
                deferred.resolve(results); // let caller export as CSV
              }, function () {
                // User clicked NO - just cancel
                deferred.reject("User canceled large export");
              });
            } else {
              // Within Excel safe limit - continue normal flow
              if (vm.exportTypeCallLog == "csv") {
                deferred.resolve(results);
              } else {
                var fileHeader = ['UserName', 'UserId', 'Latitude', 'Longitude', 'Accuracy', 'CreatedAt'];
                var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy", 'UTC') + "-" + vm.organizationId + "-LocationHistory.xlsx";
                exportToExcel(fileHeader, results, filename);
              }
            }
            // vm.showLoader = false;
          })
          .catch(function (err) {
            deferred.reject(err);
            // vm.showLoader = false;
          });
      });

      //});

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.groups')
    .controller('GroupsController', GroupsController);

  /** @ngInject*/
  function GroupsController($mdDialog, Toast, ExceptionHandler, Config, Group, Context, Organization,  $rootScope, Auth, orderByFilter, localStorageService, $translate, Fwrdgroup) {
    var vm = this;

    vm.organizationId = '';
    vm.groups = [];
    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];
    vm.types = Group.getShortTypes();

    vm.editGroup = editGroup;
    vm.removeGroup = removeGroup;
    vm.addGroup = addGroup;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

    vm.isActionNotAllowed = Auth.isActionNotAllowed;

    vm.allowCreate = Auth.isActionAllowed('group_resource','POST');
    vm.allowModify = Auth.isActionAllowed('group_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('group_resource','DELETE');

    $rootScope.$$listeners.updatedOrganizationId =[];

    $rootScope.$on('$translateChangeSuccess', function(event, current, previous) {
      vm.types = Group.getShortTypes();
  });

    config();

    //----------------------------------------------
    /**
     * fill groups list when customer choose organization
     */
    $rootScope.$on('updatedOrganizationId', function () {
      fillGroupList();
    });

    /**
     * clear contacts list when customer choose reseller on header menu
     */
    $rootScope.$on('updatedResellerId', function () {
      clearData()
    });

    function config(){
      Config.getFilterList().then(function(resp){
        vm.configs = resp;

          vm.showEmergencyGroup = vm.configs.filter(function(param){
            return param.name == "PROV_SHOW_PERSONAL_GROUP";
          });
          
          if (!vm.showEmergencyGroup || !vm.showEmergencyGroup[0] || vm.showEmergencyGroup[0].value == "0")
            vm.showEmergencyGroup = false;
          else
            vm.showEmergencyGroup = true;

          vm.showAffiliatedGroup = vm.configs.filter(function(param){
            return param.name == "PROV_SHOW_AFFILIATED_GROUP";
          });
          
          if (!vm.showAffiliatedGroup || !vm.showAffiliatedGroup[0] || vm.showAffiliatedGroup[0].value == "0")
            vm.showAffiliatedGroup = false;
          else
            vm.showAffiliatedGroup = true;

          vm.showMutedSubscriberGrp = vm.configs.filter(function(param){
            return param.name == "PROV_SHOW_MUTED_SUBSCRIBER";
          });
          
          if (!vm.showMutedSubscriberGrp || !vm.showMutedSubscriberGrp[0] || vm.showMutedSubscriberGrp[0].value == "0")
            vm.showMutedSubscriberGrp = false;
          else
            vm.showMutedSubscriberGrp = true;

          vm.groupNameLimit = vm.configs.filter(function(param){
            return param.name == "PROV_SUBSCRIBER_NAME_LIMIT";
          });        
          if (vm.groupNameLimit || vm.groupNameLimit[0])
            vm.groupNameLimit = vm.groupNameLimit[0].value;
          else
            vm.groupNameLimit = '12';

            fillGroupList();
      });
    }

    /**
     * Fill group list by  organization Id from current context
     */
    function fillGroupList() {
      vm.parentResellerId = Context.getLastResellerId();
      vm.organizationId = Context.getOrganizationId();
      if(vm.organizationId > 0)
      { 
        vm.showLoader = true;
      }
      vm.organizationId && Organization.getById(vm.organizationId, vm.parentResellerId)
        .then(function(resp){
          vm.organization = resp;
        })
        .catch(function(e){
          ExceptionHandler.log(e);
        });
        var grpType=[1,2];
        if(vm.showEmergencyGroup)
          grpType.push(9);

        vm.groups=[];
        var i=0;
        grpType.forEach(function(type){
          i++;
          vm.organizationId && Group.groupListByType(vm.organizationId,type)
          .then(function (resp) {
            resp.filter(function(group){
              if((!vm.showAffiliatedGroup && !group.cross_fleet) || (vm.showAffiliatedGroup))
                vm.groups.push(group);
              // return (group.type == 1 || group.type == 2 || group.type == 10 || (vm.showEmergencyGroup && group.type == 9)) && ((!vm.showAffiliatedGroup && !group.cross_fleet) || (vm.showAffiliatedGroup));
            });
          })
          .catch(function(e){
            ExceptionHandler.show(e);
          })
          .finally(function(){
            if(grpType.length == i)
            {
              vm.groups = vm.groups.map(function(group){
                if (group.expiry_date){
                  group.expiry_date =  new Date(group.expiry_date);
                }
                return group;
              });
              vm.showLoader = false;
            }
          });
        })
      // vm.organizationId && Group.getAllGroupsList(vm.organizationId)
      //   .then(function (resp) {
      //     vm.groups = resp.filter(function(group){
      //       return (group.type == 1 || group.type == 2 || (vm.showEmergencyGroup && group.type == 9)) && ((!vm.showAffiliatedGroup && !group.cross_fleet) || (vm.showAffiliatedGroup));
      //       // return (group.type == 1 || group.type == 2 || group.type == 10 || (vm.showEmergencyGroup && group.type == 9)) && ((!vm.showAffiliatedGroup && !group.cross_fleet) || (vm.showAffiliatedGroup));
      //     });
      //     vm.groups = vm.groups.map(function(group){
      //       if (group.expiry_date){
      //         group.expiry_date =  new Date(group.expiry_date);
      //       }
      //       return group;
      //     })
      //   })
      //   .catch(function(e){
      //     ExceptionHandler.show(e);
      //   })
      //   .finally(function(){
      //     vm.showLoader = false;
      //   });
    }

    /**
     * sort subscriber list
     */
    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort items list
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.groups = orderByFilter(vm.groups,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    /**
     * clear groups list and organizationId
     */
    function clearData() {
      vm.groups = [];
      vm.organizationId = '';
    }

    /**
     * addGroup - add group trow modal window
     */
    function addGroup() {
      $mdDialog.show({
        controller: 'groupsDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/groups/details/groups.details.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          group: {
            organization: vm.organizationId,
            site: vm.organization.primary_site_id
          },
          organizationId: vm.organizationId,
          organization: vm.organization,
          showEmergencyGroup: vm.showEmergencyGroup,
          showMutedSubscriberGrp: vm.showMutedSubscriberGrp,
          groupNameLimit: vm.groupNameLimit,
          crossFleet: false
        }
      }).then(function () {
        fillGroupList();
        Toast.showAdd();
      });
    }


    /**
     * editGroup - edit group trow modal window
     */
    function editGroup(group) {
      var curGroup = {};
      angular.copy(group, curGroup); //
      curGroup.site = curGroup.primary_site_id;

      $mdDialog.show({
        controller: 'groupsDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/groups/details/groups.details.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          group: curGroup,
          organizationId: vm.organizationId,
          organization: vm.organization,
          showEmergencyGroup: vm.showEmergencyGroup,
          showMutedSubscriberGrp: vm.showMutedSubscriberGrp,
          groupNameLimit: vm.groupNameLimit,
          crossFleet: false
        }
      }).then(function () {
          fillGroupList();
          Toast.showUpdate();
      });
    }

    /**
     * Remove group from list trow modal window
     * @param group
     */
    function removeGroup(group) {
      var confirm;
      if (group.count){
        confirm = Toast.getDeleteWithMembersDialog();
       //Toast.showCustom($translate.instant("GROUPS_DELETE_WARNING"));
      }
      else {
        confirm = Toast.getDeleteDialog();
      }
        $mdDialog.show(confirm)
          .then(function () {
            if(group.type == '10')
              {
                Fwrdgroup.deleteItem(group._id)
                .then(function () {
                  fillGroupList();
                  Toast.showDelete();
                })
                .catch(function(e){
                  ExceptionHandler.show(e);
                });
              }
            else{
              Group.deleteItem(group._id)
              .then(function () {
                fillGroupList();
                Toast.showDelete();
              })
              .catch(function(e){
                ExceptionHandler.show(e);
              });
            } 
          });


    }
  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.emergencyGroups', ['datatables'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider, msApiProvider) {
    $stateProvider.state('app.restricted.emergencyGroups', {
      url: '/emergencyGroups',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/emergency-group/emergency.group.html',
          controller: 'emergencyGroupsController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('group_resource','GET')
        }
      }
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/restricted/organization/subscriberLists');

    //msApiProvider.register('subscriberLists', ['app/main/restricted/organization/subscriberLists/data/data.json']);

    // Navigation
    msNavigationServiceProvider.saveItem('Organization.emergencyGroups', {
      title: 'emergencyGroups',
      icon: '',
      state: 'app.restricted.emergencyGroups',
      translate: 'NAVIGATION_EMERGENCY_GROUPS',
      weight: 6
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.emergencyGroups')
    .controller('emergencyGroupsController', emergencyGroupsController);

  /** @ngInject*/
  function emergencyGroupsController($mdDialog, Toast, ExceptionHandler, Group, $rootScope, Context, Organization, Auth, localStorageService) {
    var vm = this;
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];

    vm.emergencyGroups = [];
    vm.search = '';

    vm.editEmergencyGroup = editEmergencyGroup;
    vm.removeEmergencyGroup = removeEmergencyGroup;
    vm.addEmergencyGroup = addEmergencyGroup;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

    vm.isActionNotAllowed = Auth.isActionAllowed;

    vm.allowCreate = Auth.isActionAllowed('group_resource','POST');
    vm.allowModify = Auth.isActionAllowed('group_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('group_resource','DELETE');

    $rootScope.$$listeners.updatedOrganizationId =[];

    fillEmergencyGroups();
//--------------------------------------------------------------------

    /**
     * fill emergencyGroups list when customer choose organization
     */
    $rootScope.$on('updatedOrganizationId', function () {
      fillEmergencyGroups();
    });

    /**
     * clear emergencyGroups list when customer choose reseller on header menu
     */
    $rootScope.$on('updatedResellerId', function () {
      vm.emergencyGroups = [];
      vm.organizationId = '';
    });

    /**
     * Fill emergencyGroups by  organization Id from current context
     */
    function fillEmergencyGroups() {
      vm.parentResellerId = Context.getLastResellerId();
      vm.organizationId = Context.getOrganizationId();
      if(vm.organizationId > 0)
      {
        vm.showLoader = true;
      }
      Organization.getById(vm.organizationId, vm.parentResellerId)
        .then(function(resp){
          vm.organization = resp;
        });

      vm.organizationId && Group.getEmergencyGroupsByOrgId(vm.organizationId)
        .then(function (resp) {
          vm.emergencyGroups = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.showLoader = false;
        });
    }

    /**
     * set records count
     */
    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * @param: string
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.emergencyGroups = orderByFilter(vm.emergencyGroups,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    /**
     * addemergencyGroup - call modal window ; add emergencyGroups to list
     */
    function addEmergencyGroup() {
      $mdDialog.show({
        controller: 'emergencyGroupDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/emergency-group/details/emergency.group.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          emergencyGroup: {
            organization: vm.organizationId,
            type: 9,
            site: vm.organization.site
          },
          organizationId: vm.organizationId
        }
      }).then(function () {
          fillEmergencyGroups();
          Toast.showAdd();
        })
    }


    /**
     * editemergencyGroup - call modal window ; save changes to list;
     * @param emergencyGroup
     */
    function editEmergencyGroup(emergencyGroup) {
      vm.loading = true ;
      var curEmergencyGroup = {};
      angular.copy(emergencyGroup, curEmergencyGroup); //
      curEmergencyGroup.site = curEmergencyGroup.primary_site_id;
      curEmergencyGroup.organization = curEmergencyGroup.organization_id;

      $mdDialog.show({
        controller: 'emergencyGroupDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/emergency-group/details/emergency.group.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          emergencyGroup: curEmergencyGroup,
          organizationId: vm.organizationId
        }
      }).then(function () {
            fillEmergencyGroups();
            Toast.showUpdate();
      });
    }

    /**
     * Remove emergencyGroup by ID after approve it by modal Window
     * @param emergencyGroupID
     */
    function removeEmergencyGroup(emergencyGroupID) {
      var confirm = Toast.getDeleteDialog();
      $mdDialog.show(confirm)
        .then(function () {
          Group.deleteItem(emergencyGroupID)
            .then(function () {
              fillEmergencyGroups();
              Toast.showDelete();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            });
        });
    }

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.contacts', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider, msApiProvider) {
    $stateProvider.state('app.restricted.contacts', {
      url: '/contacts',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/contacts/contacts.html',
          controller: 'ContactsController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('group_resource','GET')
        }
      }
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/restricted/organization/contacts');

    //msApiProvider.register('contacts', ['app/main/restricted/organization/contacts/data/data.json']);

    // Navigation
    msNavigationServiceProvider.saveItem('Organization.contacts', {
      title: 'Contacts',
      icon: '',
      state: 'app.restricted.contacts',
      translate: 'NAVIGATION_CONTACTS',
      weight: 6
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.contacts')
    .controller('ContactsController', ContactsController);

  /** @ngInject*/
  function ContactsController($mdDialog, Toast, ExceptionHandler, Config, orderByFilter, Group, $rootScope, Context, Organization, Auth, localStorageService) {
    var vm = this;
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];

    vm.contacts = [];
    vm.search = '';

    vm.editContact = editContact;
    vm.removeContact = removeContact;
    vm.addContact = addContact;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

    vm.isActionNotAllowed = Auth.isActionAllowed;

    vm.types = Group.getShortTypes();

    vm.allowCreate = Auth.isActionAllowed('group_resource','POST');
    vm.allowModify = Auth.isActionAllowed('group_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('group_resource','DELETE');

    $rootScope.$$listeners.updatedOrganizationId =[];

    $rootScope.$on('$translateChangeSuccess', function(event, current, previous) {
      vm.types = Group.getShortTypes();
    });
    
    config();
    
//--------------------------------------------------------------------

    /**
     * fill contacts list when customer choose organization
     */
    $rootScope.$on('updatedOrganizationId', function () {
      fillContactList();
    });

    /**
     * clear contacts list when customer choose reseller on header menu
     */
    $rootScope.$on('updatedResellerId', function () {
      vm.contacts = [];
      vm.organizationId = '';
    });

    function config(){
      Config.getFilterList().then(function(resp){
        vm.configs = resp;

          vm.showOCL = vm.configs.filter(function(param){
            return param.name == "PROV_SHOW_OCL";
          });
          
          if (!vm.showOCL || !vm.showOCL[0] || vm.showOCL[0].value == "0")
            vm.showOCL = false;
          else
            vm.showOCL = true;

          vm.showAffiliatedContacts = vm.configs.filter(function(param){
            return param.name == "PROV_SHOW_AFFILIATED_GROUP";
          });
          
          if (!vm.showAffiliatedContacts || !vm.showAffiliatedContacts[0] || vm.showAffiliatedContacts[0].value == "0")
            vm.showAffiliatedContacts = false;
          else
            vm.showAffiliatedContacts = true;

          vm.groupNameLimit = vm.configs.filter(function(param){
            return param.name == "PROV_SUBSCRIBER_NAME_LIMIT";
          });        
          if (vm.groupNameLimit || vm.groupNameLimit[0])
            vm.groupNameLimit = vm.groupNameLimit[0].value;
          else
            vm.groupNameLimit = '12';

          fillContactList();
      });
    }

    /**
     * Fill contacts by  organization Id from current context
     */
    function fillContactList() {
      vm.parentResellerId = Context.getLastResellerId();
      vm.organizationId = Context.getOrganizationId();
      if(vm.organizationId > 0)
      { 
        vm.showLoader = true;
      }
      vm.organizationId && Organization.getById(vm.organizationId, vm.parentResellerId)
        .then(function(resp){
          vm.organization = resp;
        });

      vm.organizationId && Group.getAllGroupList(vm.organizationId)
        .then(function (resp) {
          vm.contacts = resp.filter(function(group){
            return ((vm.showOCL && group.type == 4) || group.type == 8)&& ((!vm.showAffiliatedContacts && !group.cross_fleet) || (vm.showAffiliatedContacts));
          });          
          // console.log(vm.contacts);
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
        .finally(function(){
          vm.showLoader = false;
        });
    }

    /**
     * set records count
     */
    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort items list
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.contacts = orderByFilter(vm.contacts,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    /**
     * addContact - call modal window ; add contact to list
     */
    function addContact() {
      var secondary_site_id;
      if(vm.organization.site)
        secondary_site_id = vm.organization.site
      else
        secondary_site_id = vm.organization.primary_site_id
      $mdDialog.show({
        controller: 'contactDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/contacts/details/contact.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          contact: {
            organization: vm.organizationId,
            site: vm.organization.primary_site_id,
            primary_site_id:vm.organization.primary_site_id,
            secondary_site_id:secondary_site_id
          },
          organizationId: vm.organizationId,
          showOCL: vm.showOCL,
          groupNameLimit: vm.groupNameLimit
        }
      }).then(function () {
          fillContactList();
          Toast.showAdd();
        })
    }


    /**
     * editContact - call modal window ; save changes to list;
     * @param contact
     */
    function editContact(contact) {
      vm.loading = true ;
      var curContact = {};
      angular.copy(contact, curContact); //
      curContact.site = curContact.primary_site_id;
      curContact.organization = curContact.organization_id;

      $mdDialog.show({
        controller: 'contactDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/contacts/details/contact.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          contact: curContact,
          organizationId: vm.organizationId,
          showOCL: vm.showOCL,
          groupNameLimit: vm.groupNameLimit
        }
      }).then(function () {
            fillContactList();
            Toast.showUpdate();
      });
    }

    /**
     * Remove contact by ID after approve it by modal Window
     * @param contactID
     */
    function removeContact(contactID) {
      var confirm = Toast.getDeleteDialog();
      $mdDialog.show(confirm)
        .then(function () {
          Group.deleteItem(contactID)
            .then(function () {
              fillContactList();
              Toast.showDelete();
            })
            .catch(function(e){
              ExceptionHandler.show(e);
            });
        });
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.callLogs')
    .controller('CallLogsController', CallLogsController);



  /** @ngInject*/
  function CallLogsController($mdDialog, $q, ExceptionHandler, localStorageService, CallLogs, Config, $rootScope, ProgressCircularSer, Context, orderByFilter, $timeout, $filter, $translate, Toast, Organization, OrgFriends, $scope) {
    var vm = this;

    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;

    vm.sessions = [];
    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.organizationId = '';
    vm.reverse = [];
    // vm.showLoader = false;

    vm.showSession = showSession;

    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    vm.checkDate = checkDate;
    vm.getSessionsByDates = getSessionsByDates;
    vm.loadMoreLogs = loadMoreLogs;
    vm.refreshCallLogs = refreshCallLogs;
    vm.searchCallLogs = searchCallLogs;
    vm.getData = getData;
    vm.errMessage = "";
    vm.filtered = false;
    vm.concateData = false;
    vm.startIndex = 0;
    vm.lastIndex = 100;
    vm.currentPage = 1;
    vm.dates = {};
    vm.exportTypeCallLog = "excel";
    vm.requestCounter = 0;

    vm.getExportCallLogs = getExportCallLogs;

    vm.organizationId = Context.getOrganizationId();

    $rootScope.$$listeners.updatedOrganizationId = [];

    vm.dates.startDate = new Date(new Date().setHours(0, 0, 0, 0));
    vm.dates.endDate = new Date(new Date().setHours(23, 59, 59, 999));
    vm.dates.now = new Date();
    vm.minDate = new Date('01/01/2000');
    vm.maxEndDate = vm.dates.startDate;
    vm.organizationNew = Organization;
    vm.parentAffOrgId = Context.getResellerId();
    vm.orgFriendsID = "0";
    if (vm.organizationId) getConfig();

    $scope.setCsvHeaders = function () {
      $scope.csvHeaders = [
        $translate.instant('SESSION_NAME'),
        $translate.instant('MISSED_CALL'),
        $translate.instant('SESSION_ID'),
        $translate.instant('SENDER_NAME'),
        $translate.instant('SENDER_ID'),
        $translate.instant('RECIPIENT_NAME'),
        $translate.instant('RECIPIENT_ID'),
        $translate.instant('SESSION_TYPE'),
        $translate.instant('SESSION_START_TIME'),
        $translate.instant('SESSION_END_TIME'),
        $translate.instant('BURST_TALKER_NAME'),
        $translate.instant('BURST_TALKER_ID'),
        $translate.instant('BURST_START_TIME'),
        $translate.instant('BURST_END_TIME'),
        $translate.instant('DURATION')
      ];
    };

    $scope.setCsvHeaders();

    $rootScope.$on('$translateChangeSuccess', function() {
      $scope.setCsvHeaders();
    });

    $rootScope.$on('updatedOrganizationId', function () {
      vm.sessions = [];
      vm.organizationId = Context.getOrganizationId();
      vm.dates = {};
      vm.dates.startDate = new Date(new Date().setHours(0, 0, 0, 0));
      vm.dates.endDate = new Date(new Date().setHours(23, 59, 59, 999));
      vm.dates.now = new Date();
      vm.maxEndDate = vm.dates.startDate;
      vm.parentAffOrgId = Context.getResellerId();
      if (vm.organizationId) getConfig();

    });

    /**
     * clear session list when customer choose reseller on header menu
     */
    $rootScope.$on('updatedResellerId', function () {
      vm.sessions = [];
      vm.organizationId = '';
      vm.dates = {};
      vm.parentAffOrgId = Context.getResellerId();
    });

    function getConfig() {
      Config.getFilterList().then(function (resp) {
        vm.configs = resp;
        vm.diffDays = vm.configs.filter(function (param) {
          return param.name == "PROV_CALL_LOG_DAYS";
        });
        vm.diffDays = vm.diffDays[0].value;
      })
        .catch(function (e) {
          vm.diffDays = 30;
        })
        .finally(function () {
          setTimeout(function () {
            vm.parentAffOrgId = Context.getLastResellerId();
            getOrgAffilatedOrg(vm.parentAffOrgId);
          }, 1000);
        });
    }

    /**
     * sort session list
     */
    function setRecordsCount() {
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort session list
     */
    function sort(param) {
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.sessions = orderByFilter(vm.sessions, param, vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param) {
      return vm.reverse[param] ? "up" : "down";
    }

    function showSession(session) {
      CallLogs.getBurstsByObjectIdAndTimes(session._id, vm.dates.startDate, vm.dates.endDate)
        .then(function (resp) {
          vm.session = resp.map(function (s) {
            s.format_start_time = $filter('date')(s.time_start, 'dd-MMM-yyyy, HH:mm:ss');

            s.format_end_time = $filter('date')(s.time_end, 'dd-MMM-yyyy, HH:mm:ss');
            return s;
          });
          vm.session.forEach(function (time) {
            if (time.duration == '00:00:00')
              time.duration = "00:00:01";
          });
          $mdDialog.show({
            controller: 'callLogsDialogController',
            controllerAs: 'vm',
            templateUrl: 'app/main/restricted/organization/callLogs/details/callLogs.dialog.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            skipHide: true,
            locals: {
              sessionId: session.session_id,
              session: vm.session
            }
          })
        })
    }

    function checkDate(id) {
      vm.errMessage = '';

      if (id == 0) { //start date was change
        var newMaxEndDate = new Date(vm.dates.startDate);
        var tempMaxEndDate = new Date(vm.dates.startDate);

        var lastDate = new Date(tempMaxEndDate.getFullYear(), tempMaxEndDate.getMonth() + 1, 0);
        newMaxEndDate.setDate(newMaxEndDate.getDate() + Number(vm.diffDays));

        (newMaxEndDate < vm.dates.now) ? vm.maxEndDate = new Date(newMaxEndDate) : vm.maxEndDate = new Date(vm.dates.now);
        
        vm.dates.endDate = '';
      }
      else {
        getOrgAffilatedOrg(vm.parentAffOrgId);
        vm.concateData = false;
        vm.startIndex = 0;
        $scope.sessionsRecords__currentPage = 1;
      }

      // if(vm.dates && vm.dates.endDate && vm.dates.startDate && vm.dates.startDate > vm.dates.endDate){
      //   vm.errMessage = $translate.instant("DATES_ERROR");//'End Date should be greater than start date';
      //   vm.sessions = [];
      //   return false;
      // }else{
      //   vm.errMessage = '';
      //   getSessionsByDates();
      // }
    }

    function getSessionsByDates(withburst) {
      var deferred = $q.defer();
      setTimeout(function () {
        $rootScope.loaderState = true;
        $rootScope.$emit('loaderMainUpdatedValue');
      }, 2000);
      if (vm.dates && vm.dates.startDate && vm.dates.endDate) {
        if (vm.errMessage == '') {
          // vm.showLoader = true;
          vm.requestCounter++;
          if (vm.search == '')
            var seachVal = 'NULL';
          else
            var seachVal = vm.search;
          if (vm.concateData == false)
            vm.sessions = []


          vm.dates.startDate.setHours(0, 0, 0, 0);
          vm.dates.endDate.setHours(23, 59, 59, 999);


          console.log(vm.dates);

          var start = $filter('date')(vm.dates.startDate, 'dd-MMM-yyyy,');
          var end = $filter('date')(vm.dates.endDate, 'dd-MMM-yyyy,');

          console.log(start);
          console.log(end);


          console.log(new Date());

          console.log(new Date().getTimezoneOffset());

          // var s = vm.dates.startDate.toUTCString()
          // var e = vm.dates.endDate.toUTCString()


          CallLogs.getSessionsByDates(vm.organizationId, start, end, vm.orgFriendsID, seachVal, vm.startIndex, vm.lastIndex, withburst, new Date().getTimezoneOffset())
            .then(function (resp) {
              var lastData = {};
              if (vm.concateData == false) {
                if (resp.length == vm.lastIndex) {
                  lastData = resp[vm.lastIndex - 1];
                  resp.push(lastData)
                }
              }
              var sessionData = resp.map(function (s) {
                s.format_start_time = $filter('date')(s.time_start, 'dd-MMM-yyyy, HH:mm:ss');
                s.format_end_time = $filter('date')(s.time_end, 'dd-MMM-yyyy, HH:mm:ss');
                return s;
              });

              if (vm.concateData == true) {
                vm.sessions = vm.sessions.concat(sessionData);
              }
              else {
                vm.sessions = Object.assign([], sessionData);
              }

              vm.filtered = true;
              // if (withburst) {
              //   getExportCallLogs().then(function (ress) {
              //     return deferred.promise;
              //   })
              // }
              // else {
              deferred.resolve(vm.sessions);
              // }


            })
            .catch(function (e) {
              if (e.status !== 404) {
                ExceptionHandler.show(e);
                deferred.reject(e);
              }
            })
            .finally(function () {
              vm.requestCounter--;
              deferred.resolve(vm.sessions);
              // vm.showLoader = vm.requestCounter > 0 ? true : false;
            });
        }
      } else {
        vm.errMessage = $translate.instant("DATES_BLANK_ERROR");//'Provide start date and end date';
        deferred.reject(false);

      }
      return deferred.promise;

    }
    function loadMoreLogs() {
      vm.startIndex = vm.startIndex + vm.lastIndex;
      getSessionsByDates(false);
    }
    function refreshCallLogs() {
      vm.startIndex = 0;
      vm.concateData = false;
      $scope.sessionsRecords__currentPage = 1;
      getSessionsByDates(false);
    }
    function getData(pageNo) {
      var callFunCount = parseInt(vm.sessions.length / vm.recordsCount) + 1;
      if (pageNo == callFunCount) {
        vm.concateData = true;
        loadMoreLogs();
        // $scope.sessionsRecords__currentPage=1;
      }
    }
    function searchCallLogs() {
      vm.startIndex = 0;
      vm.concateData = false;
      $scope.sessionsRecords__currentPage = 1;
      getSessionsByDates(false);
    }

    var getSessionBursts = function (session) {
      var deferred = $q.defer();
      CallLogs.getBurstsObjectId(session._id)
        .then(function (resp) {
          session.bursts = resp;
          deferred.resolve();
        })
        .catch(function (err) {
          deferred.reject(err);
        })
      return deferred.promise;
    }

    function secondsToHMS(secs) {
      function z(n) { return (n < 10 ? '0' : '') + n; }
      var sign = secs < 0 ? '-' : '';
      secs = Math.abs(secs);
      return sign + z(secs / 3600 | 0) + ':' + z((secs % 3600) / 60 | 0) + ':' + z(secs % 60);
    }

    function exportToExcel(xlsHeader, xlsRows, filename) {
      var createXLSLFormatObj = [];

      createXLSLFormatObj.push(xlsHeader);
      $.each(xlsRows, function (index, value) {
        var innerRowData = [];
        $.each(value, function (ind, val) {
          innerRowData.push(val);
        });
        createXLSLFormatObj.push(innerRowData);
      });

      var ws_name = "ExportSheet";

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);

      /* Add worksheet to workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);

      /* Write workbook and Download */
      XLSX.writeFile(wb, filename);
    }

    function formatForExportCallLogs(sessions) {
      var deferred = $q.defer();
      vm.exportBursts = [];

      for (var i = 0; i < sessions.length; i++) {
        if (!sessions[i].bursts || sessions[i].bursts.length == 0) {
          var exportBurst = {
            SessionName: sessions[i].session_name,
            MissedCall: "Yes",
            SessionId: sessions[i].session_id,
            SenderName: sessions[i].sender_name,
            SenderId: sessions[i].sender_id,
            RecipientName: sessions[i].recipient_name,
            RecipientId: sessions[i].recipient_id,
            SessionType: sessions[i].session_type_name,
            SessionStartTime: $filter('date')(sessions[i].time_start, "dd-MMM-yyyy, HH:mm:ss"),
            SessionEndTime: $filter('date')(sessions[i].time_end, "dd-MMM-yyyy, HH:mm:ss"),
            BurstTalkerName: "",
            BurstTalkerId: "",
            BurstStartTime: "",
            BurstEndTime: "",
            Duration: ""
          };
          vm.exportBursts.push(exportBurst);
        }
        else {

          var isBurstPresence = false;
          sessions[i].bursts.map(function (burst) {

            var dpStartTime = new Date(vm.dates.startDate).getTime();
            var dpEndTime = new Date(vm.dates.endDate).getTime();
            var burstStartTime = new Date(burst.time_start).getTime();
            var burstEndTime = new Date(burst.time_end).getTime();

            if (burstStartTime >= dpStartTime && burstEndTime <= dpEndTime) {
              isBurstPresence = true;
              if (burst.time_end == null) var diffTime = Date.now() - new Date(burst.time_start);
              else var diffTime = new Date(burst.time_end) - new Date(burst.time_start);
              var exportBurst = {
                SessionName: sessions[i].session_name,
                MissedCall: "No",
                SessionId: sessions[i].session_id,
                SenderName: sessions[i].sender_name,
                SenderId: sessions[i].sender_id,
                RecipientName: sessions[i].recipient_name,
                RecipientId: sessions[i].recipient_id,
                SessionType: sessions[i].session_type_name,
                SessionStartTime: $filter('date')(sessions[i].time_start, "dd-MMM-yyyy, HH:mm:ss"),
                SessionEndTime: $filter('date')(sessions[i].time_end, "dd-MMM-yyyy, HH:mm:ss"),
                BurstTalkerName: burst.talker_name,
                BurstTalkerId: burst.talker_id,
                BurstStartTime: $filter('date')(burst.time_start, "dd-MMM-yyyy, HH:mm:ss"),
                BurstEndTime: $filter('date')(burst.time_end, "dd-MMM-yyyy, HH:mm:ss"),
                Duration: secondsToHMS(diffTime / 1000)
              };
              vm.exportBursts.push(exportBurst);
            }
          });
          if (isBurstPresence == false) {
            var exportBurst = {
              SessionName: sessions[i].session_name,
              MissedCall: "No",
              SessionId: sessions[i].session_id,
              SenderName: sessions[i].sender_name,
              SenderId: sessions[i].sender_id,
              RecipientName: sessions[i].recipient_name,
              RecipientId: sessions[i].recipient_id,
              SessionType: sessions[i].session_type_name,
              SessionStartTime: $filter('date')(sessions[i].time_start, "dd-MMM-yyyy, HH:mm:ss"),
              SessionEndTime: $filter('date')(sessions[i].time_end, "dd-MMM-yyyy, HH:mm:ss"),
              BurstTalkerName: "",
              BurstTalkerId: "",
              BurstStartTime: "",
              BurstEndTime: "",
              Duration: ""
            };
            vm.exportBursts.push(exportBurst);
          }
        }
      }
      deferred.resolve(vm.exportBursts);
      return deferred.promise;

    }

    function getExportCallLogs() {
      var deferred = $q.defer();
      // vm.showLoader = true;
      vm.timestamp = Date.now();

      var flowFunctionsArray = [];

      // vm.sessions.filter(function(session){
      //   flowFunctionsArray.push(getSessionBursts(session));
      // });

      // $q.all(flowFunctionsArray)
      // .then(function(){
      getSessionsByDates(true).then(function (ress) {
        formatForExportCallLogs(vm.sessions)
          .then(function (results) {
            if (vm.exportTypeCallLog == "csv")
              deferred.resolve(results);
            else {
              var fileHeader = [
                $translate.instant('SESSION_NAME'),
                $translate.instant('MISSED_CALL'),
                $translate.instant('SESSION_ID'),
                $translate.instant('SENDER_NAME'),
                $translate.instant('SENDER_ID'),
                $translate.instant('RECIPIENT_NAME'),
                $translate.instant('RECIPIENT_ID'),
                $translate.instant('SESSION_TYPE'),
                $translate.instant('SESSION_START_TIME'),
                $translate.instant('SESSION_END_TIME'),
                $translate.instant('BURST_TALKER_NAME'),
                $translate.instant('BURST_TALKER_ID'),
                $translate.instant('BURST_START_TIME'),
                $translate.instant('BURST_END_TIME'),
                $translate.instant('DURATION')
              ];
              var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy", 'UTC') + "-" + vm.organizationId + "-callLog.xlsx";
              exportToExcel(fileHeader, results, filename);
            }
            // vm.showLoader = false;
          })
          .catch(function (err) {
            deferred.reject(err);
            // vm.showLoader = false;
          });
      })

      //});

      return deferred.promise;
    }
    function getOrgAffilatedOrg(affliOrg) {
      vm.orgFriendsID = '0';
      Organization.getListOrgByReseller(affliOrg)
        .then(function (resp) {
          vm.orgs = resp;
          OrgFriends.getByOrgId(vm.organizationId)
            .then(function (resp) {
              if (resp != '') {
                vm.orgFriendsID = resp.map(function (orgs) {
                  return orgs._id;
                });
                setTimeout(function () {
                  getSessionsByDates(false);
                }, 1800);
              }
              else {
                setTimeout(function () {
                  getSessionsByDates(false);
                }, 1800);
              }
            })
            .catch(function (e) {
            });
        })
        .catch(function (e) {
        });
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.batch', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider, msApiProvider) {
    $stateProvider.state('app.restricted.batch', {
      url: '/batch',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/organization/batch/batch.html',
          controller: 'BatchController as vm'
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('subscriber_resource','BATCH')
        }
      }
    });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/restricted/organization/contacts');

    //msApiProvider.register('contacts', ['app/main/restricted/organization/contacts/data/data.json']);

    // Navigation
    msNavigationServiceProvider.saveItem('Organization.batch', {
      title: 'Batch Operations',
      icon: '',
      state: 'app.restricted.batch',
      translate: 'NAVIGATION_BATCH',
      weight: 6
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.batch')
    .controller('BatchController', BatchController);



  function BatchController($mdDialog, $timeout, $q, $rootScope, $filter, $translate, Toast, api, Context, License, ExceptionHandler, Group, Site, Organization, Subscriber, Sms, Auth, Config, Reseller, CallLogs, AdminRecord, PersonalGroup, ApplicationList, PersonalContacts, Passwords, Fwrdgroup, $location, CONSTANT) {
    var vm = this;
    vm.getDetailedSubscribersList = getDetailedSubscribersList;
    vm.disableAllSubscribers = disableAllSubscribers;
    vm.deleteAllSubscribers = deleteAllSubscribers;
    vm.enableAllSubscribers = enableAllSubscribers;
    vm.exportQrCodes = exportQrCodes;
    this.chooseTemplateIterative = chooseTemplateIterative;
    //vm.onAllocationChange = onAllocationChange;
    vm.onRoleChange = onRoleChange;
    vm.onApplicationListChange = onApplicationListChange;
    vm.onEmergencyGroupChange = onEmergencyGroupChange;
    vm.onForwardGroupChange = onForwardGroupChange;
    //vm.onLicenseChange = onLicenseChange;
    //vm.batchLicenseAssignment = batchLicenseAssignment;  //shahar- remove license
    vm.batchRoleAssignment = batchRoleAssignment;
    vm.batchApplicationListAssignment = batchApplicationListAssignment;
    vm.batchEmergencyGroupAssignment = batchEmergencyGroupAssignment;
    vm.batchForwardGroupAssignment = batchForwardGroupAssignment;
    vm.batchContactTemplateAssignment = batchContactTemplateAssignment;
    vm.changeContactTemplateList = changeContactTemplateList;
    vm.batchLicenseAssignment = batchLicenseAssignment;
    vm.batchSms = batchSms;
    vm.batchDeleteAssignment = batchDeleteAssignment;
    vm.batchChangePasswordAssignment = batchChangePasswordAssignment;
    vm.getDetailedSubscribersList_runtime = getDetailedSubscribersList_runtime;
    vm.getDetailedCallLogs = getDetailedCallLogs;
    vm.changeDeleteInteractiveList = changeDeleteInteractiveList;
    vm.getDetailedAdminRecord = getDetailedAdminRecord;
    vm.downloadSampleFile = downloadSampleFile;
    vm.onTabChanges = onTabChanges;
    vm.downloadDeleteSampleFile = downloadDeleteSampleFile;
    vm.exportType = vm.exportTypeRuntime = vm.exportTypeCallLog = vm.exportTypeAdminRecord = "excel";
    vm.passType = "0";
    vm.LicenseLength = parseInt(10);

    vm.customLicense = 'CUSTOM';
    vm.isRootReseller = isRootReseller;
    $rootScope.$$listeners.updatedOrganizationId = [];

    vm.licensePaginationClass = "licensePagination";
    vm.rolePaginationClass = "rolePagination";
    vm.applicationListPaginationClass = "applicationListPagination";
    vm.emergencyGroupPaginationClass = "emergencyGroupsPagination";
    vm.forwardGroupPaginationClass = "forwardGroupsPagination";
    vm.contactTemplatePaginationClass = "contactTemplatesPagination";
    vm.deletePaginationClass = "deletePagination";
    vm.passwordPaginationClass = "passwordPagination";
    vm.smsPaginationClass = "smsPagination";
    vm.allowDeleteSubscribers = Auth.isActionAllowed('subscriber_resource', 'DELETE');
    vm.allowDeleteGroups = Auth.isActionAllowed('group_resource', 'DELETE');
    vm.allowDelete = vm.allowDeleteSubscribers || vm.allowDeleteGroups;
    vm.allowViewSubscriber = Auth.isActionAllowed('subscriber_resource', 'GET');
    vm.allowAddSubscriber = Auth.isActionAllowed('subscriber_resource', 'POST');
    vm.allowUpdateSubscriber = Auth.isActionAllowed('subscriber_resource', 'PUT');
    vm.allowModifySubscriber = Auth.isActionAllowed('subscriber_resource', 'PUT');
    vm.allowLicense = Auth.isActionAllowed('license_resource', 'DELETE');

    vm.allowModifyLicenses = Auth.isActionAllowed('license_resource', 'PUT');

    vm.allowModifyEmergencyGroup = Auth.isActionAllowed('group_resource', 'PUT');
    vm.allowModifyContactTemplate = Auth.isActionAllowed('group_resource', 'PUT');

    vm.allowSms = Auth.isActionAllowed('subscriber_resource', 'HIMPACT');
    vm.contactTemplateOperation = "Add";

    vm.generatePass = generatePass;
    // vm.bodyClass = $scope;

    vm.numberOfUserPassInArray = 10;
    vm.groupLimitAssignment;
    vm.hostUrl = '';
    vm.deleteMethod = 'byUsers';

    if (vm.allowDeleteSubscribers)
      vm.deleteType = "Subscribers";
    else if (vm.allowDeleteGroups)
      vm.deleteType = "Groups";

    vm.templateType = "Subscribers";

    vm.currentTab = 0;
    vm.exportFields = ['DisplayName', 'Password', 'PhoneNumber', 'SIP', 'IMSI', 'IMSI2', 'LicenseMask', 'DefaultRadioGroup', 'RadioGroups', 'RadioIsMuted', 'ConferenceGroups', 'ConferenceIsMuted', 'OrgContactList', 'EmergencyGroup', 'ResponceGroups', 'ContactsFromTemplate', 'BelongsToTemplate', 'AppProfile', 'RoleName', 'SubscriberState']
    // vm.exportFields = ['DisplayName','Password','PhoneNumber','SIP','IMSI','IMSI2','LicenseMask','DefaultRadioGroup','RadioGroups','ConferenceGroups','OrgContactList','EmergencyGroup','ResponceGroups','ForwardGroups','ContactsFromTemplate','BelongsToTemplate','RoleName','SubscriberState']
    vm.subscriberRuntimeFields = ['DisplayName', 'PhoneNumber', 'ProtocolVersion', 'AppVersion', 'clientType', 'State', 'Site', 'CreationTime', 'LastRegistrationTime', 'ChangeStateTime', 'DeviceModel', 'OStype', 'APILevel', 'MobileClientBrand', 'DeviceTotalMemory', 'Manufacturer', 'FWversion', 'AppBuildType', 'FCM'];
    vm.callLogFields = ['SessionName', 'MissedCall', 'SessionId', 'SenderName', 'SenderId', 'RecipientName', 'RecipientId', 'SessionType', 'SessionStartTime', 'SessionEndTime', 'BurstTalkerName', 'BurstTalkerId', 'BurstStartTime', 'BurstEndTime', 'Duration'];
    vm.adminRecordFields = ['EmailID', 'lastLoginTime', 'lastActivityTime', 'activityCommand', 'activitySessionName', 'activityUserName', 'activityTime', 'activityIp'];
    vm.importFields = { 'DisplayName': 'displayName', 'Password': 'password', 'PhoneNumber': 'phone', 'SIP': 'sip', 'IMSI': 'imsi', 'IMSI2': 'imsi2', 'LicenseMask': 'permissionMask', 'DefaultRadioGroup': 'defaultGroup', 'RadioGroups': 'radioGroups', 'RadioIsMuted': 'RadioIsMuted', 'ConferenceGroups': 'conferenceGroups', 'ConferenceIsMuted': 'ConferenceIsMuted', 'OrgContactList': 'ocl', 'EmergencyGroup': 'personalGroup', 'ResponceGroups': 'responceGroups', 'ContactsFromTemplate': 'assignedTemplates', 'BelongsToTemplate': 'contactTemplatesImport', 'AppProfile': 'appProfile', 'RoleName': 'roleName', 'SubscriberState': 'adminState' }
    vm.importDeleteFields = { 'PhoneNumber': 'phone', 'SIP': 'sip'}
    // vm.importFields = {'DisplayName':'displayName','Password':'password','PhoneNumber':'phone','SIP':'sip','IMSI':'imsi','IMSI2':'imsi2','LicenseMask':'permissionMask','DefaultRadioGroup':'defaultGroup','RadioGroups':'radioGroups','ConferenceGroups':'conferenceGroups','OrgContactList':'ocl','EmergencyGroup':'personalGroup','ForwardGroups':'forwardGroups','ResponceGroups':'responceGroups','ContactsFromTemplate':'assignedTemplates','BelongsToTemplate':'contactTemplatesImport','RoleName':'roleName','SubscriberState':'adminState'}

    init();

    vm.passType = "Show Div";


    $rootScope.$on('updatedOrganizationId', function () {
      init();
    });


    $rootScope.$on('updatedResellerId', function () {
      vm.organizationId = '';
      initParams();
    });

    function exportToExcel(xlsHeader, xlsRows, filename) {
      var createXLSLFormatObj = [];

      createXLSLFormatObj.push(xlsHeader);
      $.each(xlsRows, function (index, value) {
        var innerRowData = [];
        $.each(value, function (ind, val) {

          innerRowData.push(val);
        });
        createXLSLFormatObj.push(innerRowData);
      });

      var ws_name = "ExportSheet";

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);

      /* Add worksheet to workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);

      /* Write workbook and Download */
      XLSX.writeFile(wb, filename);
    }

    function initParams() {
      vm.subscriberLength = 0;
      vm.deleteLength = 0;
      vm.assignLength = 0;
      vm.customLicense = 'CUSTOM';
      vm.license = '';
      vm.roles = [];
      vm.deleteType = "Subscribers";
      vm.templateType = "Subscribers";
      vm.applicationLists = [];
      vm.emergencyGroups = [];
      // vm.forwardGroups = [];
      vm.contactTemplates = [];
      vm.licenseTemplates = [];
      vm.password = '';
      vm.rePassword = '';
      vm.resultLicensesLog = '';
      vm.resultRolesLog = '';
      vm.resultEmergencyGroupLog = '';
      vm.resultPasswordLog = '';
      vm.resultApplicationListLog = '';
      vm.resultLog = '';
      vm.passwordErrorLog = [];
      vm.selectedLicense = undefined;
      vm.sites = [];
      vm.groups = [];
      vm.countCheckGrops = [];
      vm.countCheckGropsName = [];
      vm.contacts = [];

      vm.subscribers = [];
      vm.selectedSubscribersSms = [];
      vm.selectedSubscribersRole = [];
      vm.selectedSubscribersLicense = [];
      vm.selectedSubscribersApplicationList = [];
      vm.selectedSubscribersEmergencyGroup = [];
      vm.selectedSubscribersForwardGroup = [];
      vm.selectedAssignContactTemplate = [];
      vm.selectedSubscriberPassword = [];
      vm.selectedDelete = [];
      vm.selectedSubscribers = [];
      vm.selectedGroups = [];
      vm.selectedOCL = [];
      vm.selectedEmergencyGroup = [];
      vm.selectedForwardGroup = [];
      vm.selectedContactTemplate = [];

      vm.notSelectedSubscriberRole = [];
      vm.notSelectedSubscriberLicense = [];
      vm.notSelectedSubscriberApplicationList = [];
      vm.notSelectedSubscriberEmergencyGroup = [];
      vm.notSelectedSubscriberForwardGroup = [];
      vm.notSelectedAssignContactTemplate = [];
      vm.notSelectedDelete = [];
      vm.notSelectedSubscriber = [];
      vm.notSelectedGroups = [];
      vm.notSelectedOCL = [];
      vm.notSelectedEmergencyGroup = [];
      vm.notSelectedForwardGroup = [];
      vm.notSelectedContactTemplate = [];

      vm.notSelectedMobile = [];
      vm.selectedEmergencyGroupId = null;
      vm.selectedForwardGroupId = null;
      vm.selectedApplicationListId = null;
      vm.encryptionKeyVal = null;
    }

    function init() {
      // vm.loading = true;
      initParams();
      vm.subscribers = [];
      vm.parentResellerId = Context.getLastResellerId();
      vm.organizationId = Context.getOrganizationId();
      vm.hostUrl = $location.protocol() + "://" + $location.host() + ":" + $location.port();
      var getOrganization = function () {
        var deferred = $q.defer();
        Organization.getById(vm.organizationId, vm.parentResellerId)
          .then(function (resp) {
            vm.organization = resp;
            deferred.resolve();
          })
          .catch(function (e) {
            deferred.reject(e);
          });
        return deferred.promise;
      }

      var getConfig = function () {
        var deferred = $q.defer();
        Config.getFilterList().then(function (resp) {
          vm.configs = resp;
          vm.server = vm.configs.filter(function (param) {
            return param.name == "PROV_IPRS_SERVER";
          });
          vm.server = vm.server[0].value;

          var showSms = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_SMS";
          });
          if (!showSms || !showSms[0].value || showSms[0].value == "0")
            vm.showSms = false;
          else
            vm.showSms = true;
          vm.showCallLog = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_CALL_LOG";
          });
          if (!vm.showCallLog || !vm.showCallLog[0].value || vm.showCallLog[0].value == "0")
            vm.showCallLog = false;
          else
            vm.showCallLog = true;

          vm.showAdminRecord = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_RECORDING";
          });
          if (!vm.showAdminRecord || !vm.showAdminRecord[0].value || vm.showAdminRecord[0].value == "0")
            vm.showAdminRecord = false;
          else
            vm.showAdminRecord = true;

          vm.showEmergencyGroup = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_PERSONAL_GROUP";
          });
          if (!vm.showEmergencyGroup || !vm.showEmergencyGroup[0].value || vm.showEmergencyGroup[0].value == "0")
            vm.showEmergencyGroup = false;
          else
            vm.showEmergencyGroup = true;

          vm.showApplicationList = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_APPLICATION_LIST";
          });
          if (!vm.showApplicationList || !vm.showApplicationList[0].value || vm.showApplicationList[0].value == "0")
            vm.showApplicationList = false;
          else
            vm.showApplicationList = true;

          vm.showOcl = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_OCL";
          });
          if (!vm.showOcl || !vm.showOcl[0].value || vm.showOcl[0].value == "0")
            vm.showOcl = false;
          else
            vm.showOcl = true;

          vm.changeStateHighImpact = vm.configs.filter(function (param) {
            return param.name == "PROV_CHANGE_STATE_WITH_HIGH_IMPACT";
          });
          if (!vm.changeStateHighImpact || !vm.changeStateHighImpact[0].value || vm.changeStateHighImpact[0].value == "0")
            vm.changeStateHighImpact = false;
          else
            vm.changeStateHighImpact = true;

          vm.showImsi2 = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_IMSI2";
          });
          if (!vm.showImsi2 || !vm.showImsi2[0].value || vm.showImsi2[0].value == "0")
            vm.showImsi2 = false;
          else
            vm.showImsi2 = true;

            vm.groupLimitAssignment = vm.configs.filter(function (param) {
              return param.name == "PROV_LIMIT_ASSIGNMNT_GR_CT";
            });
            if (!vm.groupLimitAssignment || !vm.groupLimitAssignment[0].value)
              vm.groupLimitAssignment = vm.groupLimitAssignment[0].value;
            else
              vm.groupLimitAssignment = vm.groupLimitAssignment[0].value;

          vm.isEnableQrLogin = vm.configs.filter(function (param) {
            return param.name == "PROV_SHOW_QR_CODE_LOGIN";
          });
          if (!vm.isEnableQrLogin || !vm.isEnableQrLogin[0].value || vm.isEnableQrLogin[0].value == "0")
            vm.isEnableQrLogin = false;
          else
            vm.isEnableQrLogin = true;
          
          deferred.resolve();
        })
          .catch(function (e) {
            deferred.reject(e);
          });
        return deferred.promise;
      }

      var getSubscriber = function () {
        var deferred = $q.defer();
        vm.subscribers = []
        vm.organizationId && Subscriber.getSubscriberDataByOrg(vm.organizationId)
          .then(function (resp) {
            vm.subscribers = resp;
            vm.subscribers.map(function (subscriber) {
              if (subscriber.phone_number && subscriber.phone_number.length < 13) {
                vm.notSelectedMobile.push(subscriber);
              }
            });
            vm.subscriberLength = vm.subscribers.length;
            vm.notSelectedSubscriberRole = angular.copy(vm.subscribers);
            vm.notSelectedSubscriberApplicationList = angular.copy(vm.subscribers);
            vm.notSelectedSubscriberEmergencyGroup = angular.copy(vm.subscribers);
            vm.notSelectedSubscriberForwardGroup = angular.copy(vm.subscribers);
            vm.notSelectedAssignContactTemplate = angular.copy(vm.subscribers);
            vm.notSelectedSubscriber = angular.copy(vm.subscribers);
            vm.selectedSubscriberDelete = [];
            vm.notSelectedSubscriberPassword = angular.copy(vm.subscribers);
            vm.notSelectedSubscriberLicense = angular.copy(vm.subscribers);

            Reseller.getById(vm.parentResellerId).then(function (resp) {
              vm.reseller = resp[0];
              if (vm.reseller && vm.reseller.sms && vm.reseller.sms.apiKey && vm.reseller.sms.apiSecret)
                vm.keys = true;
            });
            deferred.resolve();
          })
          .catch(function (e) {
            if (e.status === 404) {
              vm.subscribers = [];
              vm.subscribers.map(function (subscriber) {
                if (subscriber.phone_number && subscriber.phone_number.length < 13) {
                  vm.notSelectedMobile.push(subscriber);
                }
              });
              vm.subscriberLength = vm.subscribers.length;
              vm.notSelectedSubscriberRole = angular.copy(vm.subscribers);
              // console.log(vm.subscribers);
              vm.notSelectedSubscriberApplicationList = angular.copy(vm.subscribers);
              vm.notSelectedSubscriberEmergencyGroup = angular.copy(vm.subscribers);
              vm.notSelectedSubscriberForwardGroup = angular.copy(vm.subscribers);
              vm.notSelectedAssignContactTemplate = angular.copy(vm.subscribers);
              vm.notSelectedSubscriber = angular.copy(vm.subscribers);
              vm.selectedSubscriberDelete = [];
              vm.notSelectedSubscriberPassword = angular.copy(vm.subscribers);
              vm.notSelectedSubscriberLicense = angular.copy(vm.subscribers);
              deferred.resolve();

            } else {
              deferred.reject(e);
            }
          });
        return deferred.promise;
      }

      var getGroups = function () {
        var deferred = $q.defer();
        vm.organizationId && Group.getAllGroupList(vm.organizationId)
          .then(function (resp) {
            vm.groups = [];
            vm.ocl = [];
            vm.emergencyGroups = [];
            // vm.forwardGroups = [];
            vm.contactTemplates = [];
            for (var i in resp) {
              if (resp[i].type == 1 || resp[i].type == 2)
                vm.groups.push(resp[i]);
              else if (resp[i].type == 4)
                vm.ocl.push(resp[i]);
              else if (resp[i].type == 8)
                vm.contactTemplates.push(resp[i]);
              else if (resp[i].type == 9)
                vm.emergencyGroups.push(resp[i]);
              // else if (resp[i].type == 10)
              //   vm.forwardGroups.push(resp[i]);
            }
            vm.groupLength = vm.groups.length;
            vm.oclLength = vm.ocl.length;
            vm.emergencyGroupLength = vm.emergencyGroups.length;
            // vm.forwardGroupLength = vm.forwardGroups.length;
            vm.contactTemplateLength = vm.contactTemplates.length;
            vm.notSelectedGroups = angular.copy(vm.groups);
            vm.notSelectedOCL = angular.copy(vm.ocl);
            vm.notSelectedEmergencyGroup = angular.copy(vm.emergencyGroups);
            // vm.notSelectedForwardGroup = angular.copy(vm.forwardGroups);
            vm.notSelectedContactTemplate = angular.copy(vm.contactTemplates);
            vm.selectedGroups = [];
            vm.selectedOCL = [];
            vm.selectedEmergencyGroup = [];
            vm.selectedForwardGroup = [];
            vm.selectedContactTemplate = [];
            if(vm.contactTemplates.length < 1){
              // Toast.showCustom($translate.instant("BULK_CONTACT_TEMPLATE_TEMPLATES") +': '+ $translate.instant("APP_NO_RECORDS"));   
            }
            deferred.resolve();
          })
          .catch(function (e) {
            if (e.status === 404)
              deferred.resolve();
            else
              deferred.reject(e);
          });
        return deferred.promise;
      }

      var getRoles = function () {
        var deferred = $q.defer();
        vm.organizationId && api.roles.listByOrg.query({ nodeId: vm.organizationId }, function (resp) {
          vm.roles = resp;
          deferred.resolve();
        }, function (err) {
          vm.roles = [];
          deferred.resolve();
        });
        return deferred.promise;
      }

      var getApplicationLists = function () {
        var deferred = $q.defer();
        vm.organizationId && ApplicationList.getApplicationListsByOrg(vm.organizationId)
          .then(function (applicationLists) {
            vm.applicationLists = applicationLists;
            deferred.resolve();
          })
          .catch(function (e) {
            deferred.resolve();
          });
        return deferred.promise;
      }

      var getLicenses = function () {
        var deferred = $q.defer();
        License.getLicenseTemplates()
          .then(function (resp) {
            vm.licenseTemplates = resp;
            deferred.resolve();
          })
          .catch(function (e) {
            deferred.reject(e);
          });
        return deferred.promise;
      }

      var getEnvConfig = function () {
        var deferred = $q.defer();
        Config.getEnvConfig()
          .then(function (resp) {
            vm.encryptionKeyVal = resp.encryptionKey;
            deferred.resolve();
          })
          .catch(function (e) {
            deferred.reject(e);
          });
        return deferred.promise;
      }

      if (!vm.organizationId) {
        // vm.loading = false;
      }
      else {
        var flowFunctionsArray = [];
        flowFunctionsArray.push(getOrganization());
        flowFunctionsArray.push(getConfig());
        flowFunctionsArray.push(getSubscriber());
        flowFunctionsArray.push(getGroups());
        flowFunctionsArray.push(getRoles());
        flowFunctionsArray.push(getApplicationLists());
        flowFunctionsArray.push(getLicenses());
        flowFunctionsArray.push(getEnvConfig());

        $q.all(flowFunctionsArray)
          .then(function () {
            vm.allowChangeState = vm.changeStateHighImpact ? vm.allowModifySubscriber && Auth.isActionAllowed('organization_resource', 'HIMPACT') : vm.allowModifySubscriber;
            changeDeleteInteractiveList();
            changeContactTemplateList();
          })
          .catch(function (err) {
            // vm.loading = false;
            ExceptionHandler.show(err);
          });
      }

    }

    function onTabChanges(tab) {
      if (vm.currentTab == 0 && tab == 1)
        init();
      if (tab == 8 && vm.contactTemplates.length < 1)
      {
              Toast.showCustom($translate.instant("BULK_CONTACT_TEMPLATE_TEMPLATES") +': '+ $translate.instant("APP_NO_RECORDS")); 
      }
      vm.currentTab = tab;
    }

    function chooseTemplateIterative(templateName) {
      vm.license = (vm.licenseTemplates.filter(function (template) {
        vm.selectedLicense = templateName;
        return template.name == templateName;
      }))[0];
      if (templateName === 'CUSTOM') {
        vm.customLicense = templateName;

      }
    }

    function isRootReseller() {
      return Auth.isRootAdmin();
    }


    function disableAllSubscribers() {
      vm.loading = true;
      vm.errorLog = [];
      // vm.loading = true;
      var deferred = $q.defer();

      var confirm = Toast.getDisableAllSubscribers();
      $mdDialog.show(confirm)
        .then(function () {
          Subscriber.disable(vm.organizationId)
            .then(function (result) {
              Toast.showCustom("Disable all subscribers finished");
              deferred.resolve(result);
            })
            .catch(function (err) {
              vm.loading = false;
              Toast.showCustom("Disable all subscribers process failed");
              vm.errorLog.push(err);
              deferred.reject(err);
            })
            .finally(function () {
              vm.loading = false;
            });

          return deferred.promise;
        })
        .catch(function () {
          vm.loading = false;
        });

    }

    function enableAllSubscribers() {
      // vm.loading = true;
      vm.errorLog = [];
      // vm.loading = true;
      var deferred = $q.defer();

      var confirm = Toast.getEnableAllSubscribers();
      $mdDialog.show(confirm)
        .then(function () {
          Subscriber.checkUserByOrg(vm.organizationId).then(function (isValid){
            if(isValid.results)
            {
              Subscriber.enable(vm.organizationId)
              .then(function (result) {
                Toast.showCustom("Enable all subscribers finished");
                deferred.resolve(result);
              })
              .catch(function (err) {
                // vm.loading = false;
                Toast.showCustom("Enable all subscribers process failed");
                vm.errorLog.push(err);
                deferred.reject(err);
              })
              .finally(function () {
                // vm.loading = false;
              });
            }
            else{
                Toast.showCustom($translate.instant("UserLimitExceeded"));
                vm.resultLog = $translate.instant("UserLimitExceeded");
                deferred.reject($translate.instant("UserLimitExceeded"));
            }
          }).catch(function(err){

          });
          return deferred.promise;
        })
        .catch(function () {
          // vm.loading = false;
        });
    }


    // function deleteAllSubscribers() {
    //   // vm.loading = true;
    //   var deferred = $q.defer();
    //   vm.errorLog = [];
    //   var confirm = Toast.getDeleteDialog();
    //   $mdDialog.show(confirm)
    //     .then(function () {
    //       Subscriber.batchRemove(vm.organizationId, vm.subscribers)
    //         .then(function (result) {
    //           vm.resultLog = "Removed successfully ";
    //           Toast.showCustom("Removed all subscribers successfully");
    //           deferred.resolve(result);
    //         })
    //         .catch(function (err) {
    //           vm.resultLog = "Remove Failed ";
    //           // vm.loading = false;
    //           Toast.showCustom("Remove Failed");
    //           vm.errorLog.push(err);
    //           deferred.reject(err);
    //         })

    //         .finally(function () {
    //           // vm.loading = false;
    //           init();
    //         });
    //       return deferred.promise;
    //     })
    //     .catch(function () {
    //       // vm.loading = false;
    //     });

    // }
    function deleteAllSubscribers() {
      var resultData = [];
      var errors = [];
      var totalDeleteLen = vm.subscribers.length;
      function addDeleteAllocationHandler(dataarray) {
        var deferred = $q.defer();
        
        Subscriber.bulkRemoveAss(dataarray).then(function (result) {
          resultData = resultData.concat(result.passResult);
          deferred.resolve();
          if (result.passResult.length <= 50) {
            console.log('Inside')
            var successCount = 0;
            var failedCount = '';
            var message = ' ';
            resultData.forEach(function (element) {
              if (element.result == true) {
                successCount++;
              }
              else
                failedCount = failedCount + element.username + ', ';
            });
            if (failedCount != '')
              message = ' Failed: ' + failedCount;
            vm.resultLog = $translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + successCount + message + ' of '+ totalDeleteLen;
            if (successCount == totalDeleteLen){
              Toast.showCustom($translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + successCount);
              init();
            }
            // vm.loading = false;
          }
        })
        .catch(function (err) {
          errors.push(err);
          // vm.loading = false;
          deferred.resolve();
        });
        return deferred.promise;
      }

      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          //  vm.resultLog = [];
          vm.resultDeleteLog = 'Deleting..';
          vm.errorLog = [""];
          vm.subscribersProcessed = 0;
          vm.subscribersNotProcessed = 0;

          var temparray = [];
          var chunk = 50;
          for (var i = 0, j = vm.subscribers.length; i < j; i += chunk) {
            temparray.push(vm.subscribers.slice(i, i + chunk));
          }

          var batchAdd = temparray.map(function (chunk) {
              var payload = [];
              chunk.forEach(function(element) {
                var assg = {
                  item: element,
                  itemId: element._id,
                  assignmentDate: new Date(),
                  active: true,
                  organizationId: vm.organizationId
                };
                payload.push(assg);
              });
              return addDeleteAllocationHandler.bind(null, payload);
          });
            
          function batchAddLogResults() {
            // vm.loading = false;
            vm.resultLog = "Done. Not processed subscribers: " + vm.subscribersNotProcessed;
            init();
            Toast.showCustom("Deleting subscribers finished");
          }
    
          batchAdd.push(batchAddLogResults);
          batchAdd.reduce(function (previous, current) {
            return previous.then(current).catch(function (err) { /*vm.loading = false;*/ });
          }, $q.when());
        })
        .catch(function () {
          // vm.loading = false;
        })
    }

    function batchLicenseAssignment() {
      if (vm.selectedSubscribersLicense.length) {
        // vm.loading = true;
        var assignmentFuncs = [];
        var errors = 0;
        var bulkLicenseSubscriber = [];
        var arrayLength = 1;
        var startIndex = 1;
        var resultData = [];
        vm.allocatedCount = 0;
        vm.selectedLicense = vm.license;
        // vm.selectedSubscribersLicense.forEach(function(subscriber){
        //   var assg = {
        //     licenseAllocation: vm.selectedLicense,
        //     subscriberId: subscriber._id,
        //     assignmentDate:new Date(),
        //     active: true
        //   };
        //   bulkLicenseSubscriber.push(assg);
        //   // assignmentFuncs.push(addLicenseAllocationHandler.bind(null,assg));
        // })   
      }
      function addLicenseAllocationHandler(dataarray) {
        var deferred = $q.defer();
        Subscriber.changeBulkLicense(dataarray).then(function (result) {
              errors += result.passResult.length;
              vm.resultLicensesLog = "Processing: " + errors + " of " + vm.selectedSubscribersLicense.length;
              resultData = resultData.concat(result.passResult);
              setTimeout(function () {
                deferred.resolve();                
              }, 3000);
        }).catch(function (err) {
          // vm.loading = false;
            setTimeout(function () {
              deferred.resolve();                
            }, 3000);
        });
        return deferred.promise;
      }
      var confirm = Toast.getLicenseAssignment();

      $mdDialog.show(confirm)
        .then(function () {
          //  vm.resultLog = [];
          vm.resultLicensesLog = 'Processing...';
          vm.errorLog = [""];
          vm.subscribersProcessed = 0;
          vm.subscribersNotProcessed = 0;


          var temparray = [];
          var chunk = 10;
    
          for (var i = 0, j = vm.selectedSubscribersLicense.length; i < j; i += chunk) {
            console.log(vm.selectedSubscribersLicense.slice(i, i + chunk))
            temparray.push(vm.selectedSubscribersLicense.slice(i, i + chunk));
          }
    
          var LicensAdd = temparray.map(function (chunk) {
              bulkLicenseSubscriber = [];
              chunk.forEach(function(element) {
                var assg = {
                  licenseAllocation: vm.selectedLicense,
                  subscriberId: element._id,
                  assignmentDate: new Date(),
                  active: true
                };
                bulkLicenseSubscriber.push(assg);
              });
              return addLicenseAllocationHandler.bind(null, bulkLicenseSubscriber);
            
            // if (i / arrayLength == vm.numberOfUserPassInArray) {
            //   arrayLength++;
            //   startIndex += vm.numberOfUserPassInArray;
            // }
            // else if (i == vm.selectedSubscribersLicense.length) {
            //   arrayLength++;
            //   bulkLicenseSubscriber.push(assg);
            //   return addLicenseAllocationHandler.bind(null, bulkLicenseSubscriber);
            // }
            // else {
            //   bulkLicenseSubscriber.push(assg);
            // }
          });


          // for (var i = startIndex; i <= vm.selectedSubscribersLicense.length; i++) {
          //   var assg = {
          //     licenseAllocation: vm.selectedLicense,
          //     subscriberId: vm.selectedSubscribersLicense[i - 1]._id,
          //     assignmentDate: new Date(),
          //     active: true
          //   };
          //   if (i / arrayLength == vm.numberOfUserPassInArray) {
          //     arrayLength++;
          //     startIndex += vm.numberOfUserPassInArray;
          //     bulkLicenseSubscriber.push(assg);
          //     assignmentFuncs.push(addLicenseAllocationHandler.bind(null, bulkLicenseSubscriber));
          //     bulkLicenseSubscriber = [];
          //   }
          //   else if (i == vm.selectedSubscribersLicense.length) {
          //     arrayLength++;
          //     bulkLicenseSubscriber.push(assg);
          //     assignmentFuncs.push(addLicenseAllocationHandler.bind(null, bulkLicenseSubscriber));
          //     bulkLicenseSubscriber = [];
          //   }
          //   else {
          //     bulkLicenseSubscriber.push(assg);
          //   }
          // }
          // for (var p = 0; p < assignmentFuncs.length; p++) {
          //   await new Promise((resolve, reject) => {

          //     assignmentFuncs[p].then(function () {
          //       console.log(p)
          //       resolve(true);
          //       // var successCount=0;
          //       // var failedCount='';
          //       // var message= ' ';
          //       // console.log(resultData)
          //       // resultData.forEach(function(element){
          //       //     if(element.result == true)
          //       //         successCount++;
          //       //     else
          //       //     failedCount= failedCount+ element.username + ', ';
          //       // });
          //       // if(failedCount != '')
          //       //     message= 'Failed: '+failedCount;
          //       // vm.resultLicensesLog = $translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount +message;
          //       // Toast.showCustom($translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount);
          //     })
          //       .catch(function (err) {
          //         ExceptionHandler.show(err);
          //       })

          //   })

          // }
          //  async.waterfall(
          //   assignmentFuncs,
          //     function (err, results) {
          //       var successCount=0;
          //       var failedCount='';
          //       var message= ' ';
          //       console.log(resultData)
          //       resultData.forEach(function(element){
          //           if(element.result == true)
          //               successCount++;
          //           else
          //           failedCount= failedCount+ element.username + ', ';
          //       });
          //       if(failedCount != '')
          //           message= 'Failed: '+failedCount;
          //       vm.resultLicensesLog = $translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount +message;
          //       Toast.showCustom($translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount);
          //       vm.loading = false;
          //     }
          // );
          // $q.all(assignmentFuncs)
          //       .then(function () {

          // })
          // .catch(function (err) {
          //   ExceptionHandler.show(err);
          // })
          // .finally(function () {
          //   vm.loading = false;
          // }); 

          // assignmentFuncs.push(function () {
          //   // vm.loading = false;
          // });

          // assignmentFuncs.reduce(function (soFar, f) {
          //   return soFar.then(f).catch(function (err) { vm.passwordErrorLog.push(err) });
          // }, $q.when([]))


          function licensAddLogResults() {
            var successCount = 0;
            var failedCount = '';
            var message = ' ';
            resultData.forEach(function (element) {
              if (element.result == true)
                successCount++;
              else
                failedCount = failedCount + element.username + ', ';
            });
            if (failedCount != '')
              message = 'Failed: ' + failedCount;
            vm.resultLicensesLog = $translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount + message;
            Toast.showCustom($translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount);
    
          }
    
          LicensAdd.push(licensAddLogResults);
    
          LicensAdd.reduce(function (previous, current) {
            return previous.then(current).catch(function (err) { /*vm.loading = false;*/ });
          }, $q.when());

        })
        .catch(function () {
          // vm.loading = false;
        })

    }

    function batchRoleAssignment() {
      if (vm.selectedSubscribersRole.length) {
        // vm.loading = true;
        var assignmentFuncs = [];
        var bulkRoleSubscriber = [];
        var arrayLength = 1;
        var startIndex = 1;
        var resultData = [];
        vm.allocatedCount = 0;
        var errors = [];
        var allocatedCount = 0;
      }

      function addRoleAllocationHandler(dataarray) {
        var deferred = $q.defer();
        Subscriber.changeBulkRolePermission(dataarray).then(function (result) {
          deferred.resolve();
          resultData = resultData.concat(result.passResult);
          if (result.passResult.length <= vm.numberOfUserPassInArray) {
            var successCount = 0;
            var failedCount = '';
            var message = ' ';
            resultData.forEach(function (element) {
              if (element.result == true)
                successCount++;
              else
                failedCount = failedCount + element.username + ', ';
            });
            if (failedCount != '')
              message = ' Failed: ' + failedCount;
            vm.resultRolesLog = $translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount + message + ' Of '+ vm.selectedSubscribersRole.length;
            if (resultData.length == vm.selectedSubscribersRole.length)
              Toast.showCustom($translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount);
            // vm.loading = false;
          }

        }).catch(function (err) {
          // vm.loading = false;
          deferred.resolve();
        });
        return deferred.promise;
      }

      var confirm = Toast.getRoleAssignment();

      $mdDialog.show(confirm)
        .then(function () {
          //  vm.resultLog = [];
          vm.resultRolesLog = 'Processing...';
          vm.errorLog = [""];
          vm.subscribersProcessed = 0;
          vm.subscribersNotProcessed = 0;
          for (var i = startIndex; i <= vm.selectedSubscribersRole.length; i++) {
            var assg = {
              roleAllocation: vm.selectedRole._id,
              subscriberId: vm.selectedSubscribersRole[i - 1]._id,
              assignmentDate: new Date(),
              active: true
            };
            if (i / arrayLength == vm.numberOfUserPassInArray) {
              arrayLength++;
              startIndex += vm.numberOfUserPassInArray;
              bulkRoleSubscriber.push(assg);
              assignmentFuncs.push(addRoleAllocationHandler.bind(null, bulkRoleSubscriber));
              bulkRoleSubscriber = [];
            }
            else if (i == vm.selectedSubscribersRole.length) {
              arrayLength++;
              bulkRoleSubscriber.push(assg);
              assignmentFuncs.push(addRoleAllocationHandler.bind(null, bulkRoleSubscriber));
              bulkRoleSubscriber = [];
            }
            else {
              bulkRoleSubscriber.push(assg);
            }
          }
          assignmentFuncs.push(function () {
            // vm.loading = false;
          });

          assignmentFuncs.reduce(function (soFar, f) {
            return soFar.then(f).catch(function (err) { vm.passwordErrorLog.push(err) });
          }, $q.when([]))

        })
        .catch(function () {
          // vm.loading = false;
        })

    }

    function batchApplicationListAssignment() {
      // debugger
      var allocatedCount = 0;
      var arrayLength = 1;
      var startIndex = 1;
      var resultData = [];

      var confirm = Toast.getApplicationListAssignment();
      if (vm.selectedSubscribersApplicationList.length) {
        $mdDialog.show(confirm).then(function () {
          // vm.loading = true;
          vm.resultApplicationListLog = 'Processing...';
          vm.errorLog = [""];
          var bulkAddApplicationList = [];
          var bulkRemApplicationList = [];
          vm.subscribersProcessed = 0;
          vm.subscribersNotProcessed = 0;


          var assignmentFuncs = [];
          var errors = [];


          for (var i = startIndex; i <= vm.selectedSubscribersApplicationList.length; i++) {
            var assg = {
              listId: vm.selectedApplicationListId,
              subscriberId: vm.selectedSubscribersApplicationList[i - 1].phone_number,
              active: true
            };
            if (i / arrayLength == vm.numberOfUserPassInArray) {
              arrayLength++;
              startIndex += vm.numberOfUserPassInArray;
              if (vm.selectedApplicationListId)
                bulkAddApplicationList.push(assg);
              else
                bulkRemApplicationList.push(assg);

              if (bulkAddApplicationList.length > 0) {
                assignmentFuncs.push(addApplicationListAllocationHandler.bind(null, bulkAddApplicationList));
              }
              if (bulkRemApplicationList.length > 0) {
                assignmentFuncs.push(removeApplicationListAllocationHandler.bind(null, bulkRemApplicationList));
              }
              bulkAddApplicationList = [];
              bulkRemApplicationList = [];
            }
            else if (i == vm.selectedSubscribersApplicationList.length) {
              arrayLength++;
              if (vm.selectedApplicationListId)
                bulkAddApplicationList.push(assg);
              else
                bulkRemApplicationList.push(assg);

              if (bulkAddApplicationList.length > 0) {
                assignmentFuncs.push(addApplicationListAllocationHandler.bind(null, bulkAddApplicationList));
              }
              if (bulkRemApplicationList.length > 0) {
                assignmentFuncs.push(removeApplicationListAllocationHandler.bind(null, bulkRemApplicationList));
              }
              bulkAddApplicationList = [];
              bulkRemApplicationList = [];
            }
            else {
              if (vm.selectedApplicationListId)
                bulkAddApplicationList.push(assg);
              else
                bulkRemApplicationList.push(assg);
            }
          }
          assignmentFuncs.push(function () {
            // vm.loading = false;
          });

          assignmentFuncs.reduce(function (soFar, f) {
            return soFar.then(f).catch(function (err) { vm.passwordErrorLog.push(err) });
          }, $q.when([]))

        })
          .catch(function () {
            // vm.loading = false;
          })
      }

      function addApplicationListAllocationHandler(dataarray) {
        var deferred = $q.defer();
        // vm.loading = true;
        ApplicationList.changeBulkApplicationListToSubscriber(vm.organizationId, dataarray).then(function (result) {
          resultData = resultData.concat(result.passResult);
          deferred.resolve();
          if (result.passResult.length <= vm.numberOfUserPassInArray) {
            var successCount = 0;
            var failedCount = '';
            var message = ' ';
            resultData.forEach(function (element) {
              if (element.result == true)
                successCount++;
              else
                failedCount = failedCount + element.username + ', ';
            });
            if (failedCount != '')
              message = ' Failed: ' + failedCount;
            vm.resultApplicationListLog = $translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount + message +' of '+ vm.selectedSubscribersApplicationList.length;
            if (resultData.length == vm.selectedSubscribersApplicationList.length)
              Toast.showCustom($translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount);
            // vm.loading = false;
          }
        }).catch(function (err) {
          // vm.loading = false;
          deferred.resolve();
        });
        return deferred.promise;
      }

      function removeApplicationListAllocationHandler(dataarray) {
        var deferred = $q.defer();
        // vm.loading = true;
        ApplicationList.deleteBulkApplicationListToSubscriber(vm.organizationId, dataarray).then(function (result) {
          resultData = resultData.concat(result.passResult);
          deferred.resolve();
          if (result.passResult.length <= vm.numberOfUserPassInArray) {
            var successCount = 0;
            var failedCount = '';
            var message = ' ';
            resultData.forEach(function (element) {
              if (element.result == true)
                successCount++;
              else
                failedCount = failedCount + element.username + ', ';
            });
            if (failedCount != '')
              message = ' Failed: ' + failedCount;
            vm.resultApplicationListLog = $translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount + message +' of '+ vm.selectedSubscribersApplicationList.length;
            if (resultData.length == vm.selectedSubscribersApplicationList.length)
              Toast.showCustom($translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount);
            // vm.loading = false;
          }
        }).catch(function (err) {
          // vm.loading = false;
          deferred.resolve();
        });

        return deferred.promise;
      }

    }

    function batchForwardGroupAssignment() {
      vm.selectedForwardGroup.subscribers = vm.selectedSubscribersForwardGroup.map(function (member) {
        return member._id
      });
      vm.selectedForwardGroup.site = vm.selectedForwardGroup.primary_site_id;
      Fwrdgroup.update(vm.selectedForwardGroup).then(function () {
        Toast.showCustom($translate.instant("APP_TOAST_UPDATE_SUCCESS"));
      })
        .catch(function (e) {
          vm.flagSave = true;
          ExceptionHandler.show(e);
        })
        .finally(function () {
          // vm.loading = false;
        });
    }

    function batchEmergencyGroupAssignment() {
      if (vm.selectedSubscribersEmergencyGroup.length) {
        // vm.loading = true;
        var assignmentFuncs = [];
        var bulkSubEmerGrp = [];
        var arrayLength = 1;
        var startIndex = 1;
        var resultData = [];
        var errors = [];
        var allocatedCount = 0;

        // vm.selectedSubscribersEmergencyGroup.forEach(function (subscriber) {
        //   var assg = {
        //     emergencyGroupAllocation: vm.selectedEmergencyGroupId,
        //     subscriberId: subscriber._id,
        //     phoneNumber: subscriber.phone_number,
        //     assignmentDate: new Date(),
        //     active: true
        //   };

        //   bulkSubEmerGrp.push(assg);
        //   // assignmentFuncs.push(addEmergencyGroupAllocationHandler.bind(null,assg));
        // })
      }

      function addEmergencyGroupAllocationHandler(dataarray) {
        var deferred = $q.defer();
        PersonalGroup.changeBulkubEmerGrp(dataarray).then(function (result) {
          resultData = resultData.concat(result.passResult);
          deferred.resolve();
          if (result.passResult.length <= vm.numberOfUserPassInArray) {
            var successCount = 0;
            var failedCount = '';
            var message = ' ';
            resultData.forEach(function (element) {
              if (element.result == true)
                successCount++;
              else
                failedCount = failedCount + element.username + ', ';
            });
            if (failedCount != '')
              message = ' Failed: ' + failedCount;
            vm.resultEmergencyGroupLog = $translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount + message + ' of '+ vm.selectedSubscribersEmergencyGroup.length;
            if (resultData.length == vm.selectedSubscribersEmergencyGroup.length)
              Toast.showCustom($translate.instant("APP_TOAST_ALLOCATE_SUCCESS") + ": " + successCount);
            // vm.loading = false;
          }

        }).catch(function (err) {
          // vm.loading = false;
        });

        return deferred.promise;
      }

      var confirm = Toast.getEmergencyGroupAssignment();

      $mdDialog.show(confirm)
        .then(function () {
          //  vm.resultLog = [];
          vm.resultEmergencyGroupLog = 'Processing...';
          vm.errorLog = [""];
          vm.subscribersProcessed = 0;
          vm.subscribersNotProcessed = 0;
          for (var i = startIndex; i <= vm.selectedSubscribersEmergencyGroup.length; i++) {
            var assg = {
              emergencyGroupAllocation: vm.selectedEmergencyGroupId,
              subscriberId: vm.selectedSubscribersEmergencyGroup[i - 1]._id,
              phoneNumber: vm.selectedSubscribersEmergencyGroup[i - 1].phone_number,
              assignmentDate: new Date(),
              active: true,
              organizationId: vm.organizationId
            };
            if (i / arrayLength == vm.numberOfUserPassInArray) {
              arrayLength++;
              startIndex += vm.numberOfUserPassInArray;
              bulkSubEmerGrp.push(assg);
              assignmentFuncs.push(addEmergencyGroupAllocationHandler.bind(null, bulkSubEmerGrp));
              bulkSubEmerGrp = [];
            }
            else if (i == vm.selectedSubscribersEmergencyGroup.length) {
              arrayLength++;
              bulkSubEmerGrp.push(assg);
              assignmentFuncs.push(addEmergencyGroupAllocationHandler.bind(null, bulkSubEmerGrp));
              bulkSubEmerGrp = [];
            }
            else {
              bulkSubEmerGrp.push(assg);
            }
          }
          assignmentFuncs.push(function () {
            // vm.loading = false;

          });

          assignmentFuncs.reduce(function (soFar, f) {
            return soFar.then(f).catch(function (err) { vm.passwordErrorLog.push(err) });
          }, $q.when([]))

        })
        .catch(function () {
          // vm.loading = false;
        })

    }

    function changeContactTemplateList() {
      vm.resultContactTemplateLog = $translate.instant("CONTACT_TEMPLATE_TYPE") + ": " + (vm.templateType == "Subscribers" ? $translate.instant("BULK_CONTACT_TEMPLATE_SUBSCRIBERS") : $translate.instant("BULK_CONTACT_TEMPLATE_TEMPLATES"));
      vm.notSelectedAssignContactTemplate = [];
      vm.selectedAssignContactTemplate = [];
      if (vm.templateType == "Subscribers") {
        vm.notSelectedAssignContactTemplate = angular.copy(vm.notSelectedSubscriber);
        vm.selectedAssignContactTemplate = angular.copy(vm.selectedSubscribers);
        vm.assignLength = vm.subscriberLength;
      }
      else if (vm.templateType == "ContactTemplate") {
        vm.notSelectedAssignContactTemplate = angular.copy(vm.notSelectedContactTemplate);
        vm.selectedAssignContactTemplate = angular.copy(vm.selectedContactTemplate);
        vm.assignLength = vm.contactTemplateLength;
      }
    }

    function batchContactTemplateAssignment(type) {
      var index=1;
      if (vm.selectedAssignContactTemplate.length) {
        // vm.loading = true;
        var assignmentFuncs = [];
        var otherOrgSub = [];
        var errors = [];
        var allocatedCount = 0;
        var bulkAssg= {
          assignContactTemplateId: vm.selectedContactTemplateId,
          templateType: vm.templateType,
          subscriberArray: vm.selectedAssignContactTemplate,
          actionType: type,
          contactType: 'Normal',
          organizationId: vm.organizationId,
          assignmentDate: new Date(),
          active: true
        }
        
        // Subscriber.getListByGroup(vm.selectedContactTemplateId)
        //   .then(function (resp) {
        //     // console.log(resp)
        //     var newResp = resp.map(function (contact) {
        //       if (vm.organizationId == contact.organization_id) {
        //         contact.phone_number = vm.subscribers.filter(function (subs) {
        //           if (subs._id == contact._id)
        //             return subs;
        //         })[0].phone_number;
        //         return contact;
        //       }
        //       else {
        //         otherOrgSub.push(contact);
        //         return 0;
        //       }
        //     })
        //     var tempNewResp = newResp.filter(function (element) {
        //       return element != 0;
        //     })
        //     newResp = tempNewResp;
        //     // console.log(newResp);
        //     if (vm.templateType == "Subscribers") {
        //       vm.selectedAssignContactTemplate.forEach(function (subscriber) {
        //         if (subscriber.organization_id == vm.organizationId) {
        //           var assg = {
        //             contactsTemplate: newResp,
        //             subscriberId: subscriber._id,
        //             phoneNumber: subscriber.phone_number,
        //             assignmentDate: new Date(),
        //             active: true
        //           };
        //           // console.log('called sub')
        //           // console.log(assignmentFuncs)
        //           assignmentFuncs.push(addContactTemplateAllocationHandler.bind(null, assg));
        //         }
        //       })
        //     }
        //     else {
        //       vm.selectedAssignContactTemplate.forEach(function (template) {
        //         Subscriber.getListByGroup(template._id)
        //           .then(function (resp) {
        //             resp.map(function (contact) {
        //               if (contact.organization_id == vm.organizationId) {
        //                 var assg = {
        //                   contactsTemplate: newResp,
        //                   subscriberId: contact._id,
        //                   phoneNumber: vm.subscribers.filter(function (subs) {
        //                     if (subs._id == contact._id)
        //                       return subs;
        //                   })[0].phone_number,
        //                   assignmentDate: new Date(),
        //                   active: true
        //                 };
        //                 // console.log('called con')
        //                 // console.log(assignmentFuncs)
        //                 assignmentFuncs.push(addContactTemplateAllocationHandler.bind(null, assg));
        //               }
        //               else {
        //                 otherOrgSub.push(contact);
        //               }
        //             })

        //           })
        //       })
        //     }
        //   })
      }

      function addContactTemplateAllocationHandler(assg) {
        // var deferred = $q.defer();
        return new Promise(function(resolve, reject) {
        // vm.loading = true;
        // console.log(assg.contactsTemplate);
          if (assg.contactsTemplate && assg.contactsTemplate.length > 0) {
            PersonalContacts.getPersonalList(assg.subscriberId)
              .then(function (contacts) {
                if (type == "Add") {
                  var newContacts = contacts;
                  for (var i in assg.contactsTemplate) {
                    if (contacts.filter(function (contact) { return contact.contactUserId === assg.contactsTemplate[i].phone_number; }).length == 0) {
                      if (assg.subscriberId != assg.contactsTemplate[i]._id) {

                        newContacts.push(
                          {
                            contactUserId: assg.contactsTemplate[i].phone_number,
                            name: assg.contactsTemplate[i].name,
                            ownerUserId: assg.subscriberId
                          });
                      }
                    }
                  }
                }
                else {
                  var newContacts = [];
                  for (var i in contacts) {
                    if (contacts[i].contactUserId && assg.contactsTemplate.filter(function (contact) { return contacts[i].contactUserId === contact.phone_number; }).length == 0) {
                      newContacts.push(contacts[i]);
                    }
                  }
                }

                var body = {};
                body.personalContacts = newContacts;
                if(index == 1){
                }
                PersonalContacts.addUpdateBatch(assg.subscriberId, body)
                  .then(function () {
                    index++;
                    if(index-1 == assignmentFuncs.length){
                      if (type == "Add") {
                        // assignmentFuncs.push(function () {
                          // console.log(type);
                          // vm.loading = false;
                          var faildmesage = '';
                          var count = 0;
                          if (otherOrgSub.length > 0) {
                            otherOrgSub.forEach(function (element, index) {
                              count++;
                              faildmesage += element.name;
                              if (index + 1 != otherOrgSub.length) {
                                faildmesage += ', ';
                              }
                            });
                            faildmesage = ' & ' + count + ' ' + $translate.instant("AFFILLIATED_ORG_SUB_NOT_ADDED_MESSAGE") + ': ' + faildmesage;
                          }
                          vm.resultContactTemplateLog = $translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + (assignmentFuncs.length  - errors.length) + ' ' + faildmesage;
                          Toast.showCustom($translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + (assignmentFuncs.length  - errors.length));
            
                        // });
                      } else {
                        // assignmentFuncs.push(function () {
                          // console.log(type);
                          // vm.loading = false;
                          vm.resultContactTemplateLog = $translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + (assignmentFuncs.length  - errors.length);
                          Toast.showCustom($translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + (assignmentFuncs.length - errors.length));
            
                        // });
                      }
                    }
                    resolve();
                  })
                  .catch(function (err) {
                    index++;
                    reject(err);
                    errors.push(err);
                    // vm.loading = false;
                  });
              })
              .catch(function (err) {
                if (err.status == 404) {
                  if (type == "Add") {
                    var body = {};
                    body.personalContacts = [];
                    assg.contactsTemplate.map(function (contact) {
                      if (contact._id != assg.subscriberId)
                        body.personalContacts.push({ contactUserId: contact.phone_number, name: contact.name, ownerUserId: assg.subscriberId });
                    });
                    if(index == 1){
                    }
                    PersonalContacts.addUpdateBatch(assg.subscriberId, body)
                      .then(function () {
                        index++;
                      
                        if(index-1 == assignmentFuncs.length){
                            if (type == "Add") {
                              // assignmentFuncs.push(function () {
                                // console.log(type);
                                // vm.loading = false;
                                var faildmesage = '';
                                var count = 0;
                                if (otherOrgSub.length > 0) {
                                  otherOrgSub.forEach(function (element, index) {
                                    count++;
                                    faildmesage += element.name;
                                    if (index + 1 != otherOrgSub.length) {
                                      faildmesage += ', ';
                                    }
                                  });
                                  faildmesage = ' & ' + count + ' ' + $translate.instant("AFFILLIATED_ORG_SUB_NOT_ADDED_MESSAGE") + ': ' + faildmesage;
                                }
                                vm.resultContactTemplateLog = $translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + (assignmentFuncs.length  - errors.length) + ' ' + faildmesage;
                                Toast.showCustom($translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + (assignmentFuncs.length  - errors.length));
                  
                              // });
                            } else {
                              // assignmentFuncs.push(function () {
                                // console.log(type);
                                // vm.loading = false;
                                vm.resultContactTemplateLog = $translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + (assignmentFuncs.length  - errors.length);
                                Toast.showCustom($translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + (assignmentFuncs.length - errors.length));
                  
                              // });
                            }
                          }
                        resolve();
                      })
                      .catch(function (err) {
                        index++;
                        reject(err);
                        errors.push(err);
                        // vm.loading = false;
                      });
                  }
                  else {
                    index++;
                    if(index-1 == assignmentFuncs.length){
                      if (type == "Add") {
                        // assignmentFuncs.push(function () {
                          // console.log(type);
                          // vm.loading = false;
                          var faildmesage = '';
                          var count = 0;
                          if (otherOrgSub.length > 0) {
                            otherOrgSub.forEach(function (element, index) {
                              count++;
                              faildmesage += element.name;
                              if (index + 1 != otherOrgSub.length) {
                                faildmesage += ', ';
                              }
                            });
                            faildmesage = ' & ' + count + ' ' + $translate.instant("AFFILLIATED_ORG_SUB_NOT_ADDED_MESSAGE") + ': ' + faildmesage;
                          }
                          vm.resultContactTemplateLog = $translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + (assignmentFuncs.length  - errors.length) + ' ' + faildmesage;
                          Toast.showCustom($translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + (assignmentFuncs.length  - errors.length));
            
                        // });
                      } else {
                        // assignmentFuncs.push(function () {
                          // console.log(type);
                          // vm.loading = false;
                          vm.resultContactTemplateLog = $translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + (assignmentFuncs.length  - errors.length);
                          Toast.showCustom($translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + (assignmentFuncs.length - errors.length));
            
                        // });
                      }
                    }
                    resolve();
                    // vm.resultContactTemplateLog = "Processing... Done: " + allocatedCount++;
                  }
                }
                else {
                  index++;
                  reject(err);
                  errors.push(err);
                  // vm.loading = false;
                }
              });
          }
          else {
            index++;
            resolve();
            // vm.resultContactTemplateLog = "Processing... Done: " + allocatedCount++;
          }

        });
      }

      if (type == "Add")
        var confirm = Toast.getContactTemplateAssignmentAdd(vm.templateType);
      else
        var confirm = Toast.getContactTemplateAssignmentRemove(vm.templateType);
      $mdDialog.show(confirm)
        .then(function () {

          Subscriber.bulkUpdateContactTemplate(bulkAssg).then(function(result){
            var succesc=[];
            var faildC=[];
            var faildL=[];
            var faildmesage = '';
            result.passResult.forEach(function(element) {
                if(element.result == true)
                  succesc.push(element);
                else{
                  if(element.message == 'Contact limit exceeded. Cannot add more than the configured limit')
                    faildL.push(element)
                  else
                    faildC.push(element)
                }
            });
            if (faildC.length > 0) {
              faildC.forEach(function (element) {
                faildmesage += element.subscriber;
                if (index + 1 != faildC.length) {
                  faildmesage += ', ';
                }
              });
              faildmesage = ' & ' + faildC.length + ' ' + $translate.instant("AFFILLIATED_ORG_SUB_NOT_ADDED_MESSAGE") + ': ' + faildmesage;
            }
            if (faildL.length > 0) {
              var indexd =0;
              faildL.forEach(function (element) {
                faildmesage += element.subscriber;
                  faildmesage += ', ';
                
                indexd++;
              });
              faildmesage = ' ,Also ' + faildL.length + 'Contact limit exceeded. Cannot add more than the configured limit: ' + faildmesage;
            }
            if (type == "Add") {
              vm.resultContactTemplateLog = $translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + succesc.length + ' ' + faildmesage;
              Toast.showCustom($translate.instant("APP_TOAST_ADD_SUCCESS") + ": " + succesc.length);
            }
            else{
              vm.resultContactTemplateLog = $translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + succesc.length;
              Toast.showCustom($translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + succesc.length);
            }
          }).catch(function (err) {
            console.log(err);
            Toast.showCustom(err.data.exception);
          });


          //  vm.resultLog = [];
          vm.resultContactTemplateLog = 'Processing...';
          vm.errorLog = [""];
          vm.subscribersProcessed = 0;
          vm.subscribersNotProcessed = 0;
          vm.messageFlaf=true;
          function showLog() {
            // vm.loading = false;
            vm.resultContactTemplateLog = "Removed: " + vm.subscribersProcessed + ", errors: " + vm.subscribersNotProcessed;
            init();
          }
          setTimeout(function(){
            assignmentFuncs.reduce(function (soFar, f) { 
                       
              return soFar.then(f).catch(function (err) { errors.push(err) });
            }, $q.when([]))
          }, 5000);

        })
        .catch(function () {
          // vm.loading = false;
        })

    }

    function batchDeleteAssignment() {
      if (vm.selectedDelete.length) {
        // vm.loading = true;
        var assignmentFuncs = [];
        var bulkDelAssignment = [];
        var arrayLength = 1;
        var startIndex = 1;
        var resultData = [];
        var errors = [];
        var allocatedCount = 0;
        var totalDeleteLen = vm.selectedDelete.length;


      }

      function addDeleteAllocationHandler(dataarray) {
        var deferred = $q.defer();
        // vm.loading = true;

        if (vm.deleteType == "Subscribers") {
          Subscriber.bulkRemoveAss(dataarray).then(function (result) {
            resultData = resultData.concat(result.passResult);
            deferred.resolve();
            if (result.passResult.length <= vm.numberOfUserPassInArray) {
              var successCount = 0;
              var failedCount = '';
              var message = ' ';
              resultData.forEach(function (element) {
                if (element.result == true) {
                  successCount++;
                  vm.selectedSubscribers.splice(vm.selectedSubscribers.indexOf(element.subscriber), 1);
                  vm.selectedDelete.splice(vm.selectedDelete.indexOf(element.subscriber), 1);
                  vm.notSelectedSubscriber.splice(vm.notSelectedSubscriber.indexOf(element.subscriber), 1);
                }
                else
                  failedCount = failedCount + element.username + ', ';
              });
              if (failedCount != '')
                message = ' Failed: ' + failedCount;
              vm.resultDeleteLog = $translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + successCount + message + ' of '+ totalDeleteLen;
              if (successCount == totalDeleteLen){
                Toast.showCustom($translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + successCount);
                init();
              }
              // vm.loading = false;
            }
          })
            .catch(function (err) {
              errors.push(err);
              // vm.loading = false;
              deferred.resolve();
            });
        }
        else if (vm.deleteType == "ForwardGroup") {
          Fwrdgroup.bulkRemoveAss(dataarray).then(function (result) {
            resultData = resultData.concat(result.passResult);
            deferred.resolve();
            if (resultData.length <= vm.numberOfUserPassInArray) {
              var successCount = 0;
              var failedCount = '';
              var message = ' ';
              resultData.forEach(function (element) {
                if (element.result == true) {
                  successCount++;
                  vm.selectedForwardGroup.splice(vm.selectedForwardGroup.indexOf(element.subscriber), 1);
                  vm.selectedDelete.splice(vm.selectedDelete.indexOf(element.subscriber), 1);
                  vm.notSelectedForwardGroup.splice(vm.notSelectedForwardGroup.indexOf(element.subscriber), 1);
                }
                else
                  failedCount = failedCount + element.username + ', ';
              });
              if (failedCount != '')
                message = ' Failed: ' + failedCount;
              vm.resultDeleteLog = $translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + successCount + message + ' of '+ totalDeleteLen;
              if (successCount == totalDeleteLen){
                Toast.showCustom($translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + successCount);
                init();
              }
              // vm.loading = false;
            }
          })
            .catch(function (err) {
              errors.push(err);
              // vm.loading = false;
              deferred.resolve();
            });
        }
        else {
          Group.bulkRemoveAss(dataarray, vm.deleteType).then(function (result) {
            resultData = resultData.concat(result.passResult);
            deferred.resolve();
            if (result.passResult.length <= vm.numberOfUserPassInArray) {
              var successCount = 0;
              var failedCount = '';
              var message = ' ';
              resultData.forEach(function (element) {
                if (element.result == true) {
                  successCount++;
                  if (vm.deleteType == 'Groups') {
                    vm.selectedGroups.splice(vm.selectedGroups.indexOf(element.subscriber), 1);
                    vm.selectedDelete.splice(vm.selectedDelete.indexOf(element.subscriber), 1);
                    vm.notSelectedGroups.splice(vm.notSelectedGroups.indexOf(element.subscriber), 1);
                  }
                  else if (vm.deleteType == 'OCL') {
                    vm.selectedOCL.splice(vm.selectedOCL.indexOf(element.subscriber), 1);
                    vm.selectedDelete.splice(vm.selectedDelete.indexOf(element.subscriber), 1);
                    vm.notSelectedOCL.splice(vm.notSelectedOCL.indexOf(element.subscriber), 1);
                  }
                  else if (vm.deleteType == "EmergencyGroup") {
                    vm.selectedEmergencyGroup.splice(vm.selectedEmergencyGroup.indexOf(element.subscriber), 1);
                    vm.selectedDelete.splice(vm.selectedDelete.indexOf(element.subscriber), 1);
                    vm.notSelectedEmergencyGroup.splice(vm.notSelectedEmergencyGroup.indexOf(element.subscriber), 1);
                  }
                  else if (vm.deleteType == "ContactTemplate") {
                    vm.selectedContactTemplate.splice(vm.selectedContactTemplate.indexOf(element.subscriber), 1);
                    vm.selectedDelete.splice(vm.selectedDelete.indexOf(element.subscriber), 1);
                    vm.notSelectedContactTemplate.splice(vm.notSelectedContactTemplate.indexOf(element.subscriber), 1);
                  }
                }
                else
                  failedCount = failedCount + element.username + ', ';
              });
              if (failedCount != '')
                message = ' Failed: ' + failedCount;
              var tot = vm.selectedDelete.length+1;
              vm.resultDeleteLog = $translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + successCount + message + ' of '+ totalDeleteLen;
              if (successCount == totalDeleteLen){
                Toast.showCustom($translate.instant("APP_TOAST_DELETE_SUCCESS") + ": " + successCount);
                init();
              }
              // vm.loading = false;
            }
          })
            .catch(function (err) {
              // console.log(index);
              // deferred.reject(err);
              errors.push(err);
              // vm.loading = false;
              deferred.resolve();
            });

        }

        return deferred.promise;
      }

      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function () {
          //  vm.resultLog = [];
          vm.resultDeleteLog = 'Deleting..';
          vm.errorLog = [""];
          vm.subscribersProcessed = 0;
          vm.subscribersNotProcessed = 0;

          for (var i = startIndex; i <= vm.selectedDelete.length; i++) {
            var assg = {
              item: vm.selectedDelete[i - 1],
              itemId: vm.selectedDelete[i - 1]._id,
              assignmentDate: new Date(),
              active: true,
              organizationId: vm.organizationId,
            };
            if (i / arrayLength == vm.numberOfUserPassInArray) {
              arrayLength++;
              startIndex += vm.numberOfUserPassInArray;
              bulkDelAssignment.push(assg);
              assignmentFuncs.push(addDeleteAllocationHandler.bind(null, bulkDelAssignment));
              bulkDelAssignment = [];
            }
            else if (i == vm.selectedDelete.length) {
              arrayLength++;
              bulkDelAssignment.push(assg);
              assignmentFuncs.push(addDeleteAllocationHandler.bind(null, bulkDelAssignment));
              bulkDelAssignment = [];
            }
            else {
              bulkDelAssignment.push(assg);
            }
          }
          assignmentFuncs.push(function () {
            // vm.loading = false;
          });

          assignmentFuncs.reduce(function (soFar, f) {
            return soFar.then(f).catch(function (err) { vm.passwordErrorLog.push(err) });
          }, $q.when([]))

        })
        .catch(function () {
          // vm.loading = false;
        })

    }

    function changeDeleteInteractiveList() {
      vm.resultDeleteLog = $translate.instant("DELETE_INTERACTIVE_TYPE") + ": " + (vm.deleteType == "Subscribers" ? $translate.instant("DELETE_SUBSCRIBERS") : (vm.deleteType == "Groups" ? $translate.instant("DELETE_GROUPS") : (vm.deleteType == "OCL" ? $translate.instant("DELETE_OCL") : (vm.deleteType == "EmergencyGroup" ? $translate.instant("DELETE_EMERGENCY_GROUP") : (vm.deleteType == "ForwardGroup" ? $translate.instant("DELETE_FORWARD_GROUP") : $translate.instant("DELETE_CONTACT_TEMPLATE"))))));
      vm.notSelectedDelete = [];
      vm.selectedDelete = [];
      if (vm.deleteType == "Subscribers") {
        vm.notSelectedDelete = angular.copy(vm.notSelectedSubscriber);
        vm.selectedDelete = angular.copy(vm.selectedSubscribers);
        vm.deleteLength = vm.subscriberLength;
      }
      else if (vm.deleteType == "Groups") {
        vm.notSelectedDelete = angular.copy(vm.notSelectedGroups);
        vm.selectedDelete = angular.copy(vm.selectedGroups);
        vm.deleteLength = vm.groupLength;
      }
      else if (vm.deleteType == "OCL") {
        vm.notSelectedDelete = angular.copy(vm.notSelectedOCL);
        vm.selectedDelete = angular.copy(vm.selectedOCL);
        vm.deleteLength = vm.oclLength;
      }
      else if (vm.deleteType == "EmergencyGroup") {
        vm.notSelectedDelete = angular.copy(vm.notSelectedEmergencyGroup);
        vm.selectedDelete = angular.copy(vm.selectedEmergencyGroup);
        vm.deleteLength = vm.emergencyGroupLength;
      }
      else if (vm.deleteType == "ForwardGroup") {
        vm.notSelectedDelete = angular.copy(vm.notSelectedForwardGroup);
        vm.selectedDelete = angular.copy(vm.selectedForwardGroup);
        vm.deleteLength = vm.forwardGroupLength;
      }
      else if (vm.deleteType == "ContactTemplate") {
        vm.notSelectedDelete = angular.copy(vm.notSelectedContactTemplate);
        vm.selectedDelete = angular.copy(vm.selectedContactTemplate);
        vm.deleteLength = vm.contactTemplateLength;
      }
    }

    function batchChangePasswordAssignment() {
      if (vm.selectedSubscriberPassword.length) {
        // vm.loading = true;
        var assignmentFuncs = [];
        var bulkPasswordSubscriber = [];
        var arrayLength = 1;
        var startIndex = 1;
        var resultData = [];
        var allocatedCount = 0;

        var confirm = Toast.getChangePassword();
      }

      function changePasswordHandler(dataarray) {
        var deferred = $q.defer();
        Subscriber.changeBulkPassword(dataarray).then(function (result) {
          resultData = resultData.concat(result.passResult);
          deferred.resolve();
          if (result.passResult.length <= vm.numberOfUserPassInArray) {
            var successCount = 0;
            var failedCount = '';
            var message = ' ';
            resultData.forEach(function (element) {
              if (element.result == true)
                successCount++;
              else
                failedCount = failedCount + element.username + ', ';
            });
            if (failedCount != '')
              message = ' Failed: ' + failedCount;
            vm.resultPasswordLog = $translate.instant("APP_TOAST_UPDATE_SUCCESS") + ": " + successCount + message + ' of '+ vm.selectedSubscriberPassword.length;
            if (resultData.length == vm.selectedSubscriberPassword.length)
              Toast.showCustom($translate.instant("APP_TOAST_UPDATE_SUCCESS") + ": " + successCount);
            // vm.loading = false;

          }
        }).catch(function (err) {
          // vm.loading = false;
          deferred.resolve();
        });
        return deferred.promise;
      }


      $mdDialog.show(confirm)
        .then(function () {
          // vm.loading = true;
          vm.resultPasswordLog = "Processing... ";
          // vm.bodyClass.$resolve.$$state.self.bodyClass = 'disabledClick';
          for (var i = startIndex; i <= vm.selectedSubscriberPassword.length; i++) {
            var assg = {
              password: vm.passType == "Show Div" ? vm.password : generatePass(),
              subscriberId: vm.selectedSubscriberPassword[i - 1]._id,
              assignmentDate: new Date(),
              active: true
            };
            if (i / arrayLength == vm.numberOfUserPassInArray) {
              arrayLength++;
              startIndex += vm.numberOfUserPassInArray;
              bulkPasswordSubscriber.push(assg);
              assignmentFuncs.push(changePasswordHandler.bind(null, bulkPasswordSubscriber));
              bulkPasswordSubscriber = [];
            }
            else if (i == vm.selectedSubscriberPassword.length) {
              arrayLength++;
              bulkPasswordSubscriber.push(assg);
              assignmentFuncs.push(changePasswordHandler.bind(null, bulkPasswordSubscriber));
              bulkPasswordSubscriber = [];
            }
            else {
              bulkPasswordSubscriber.push(assg);
            }
          }


          assignmentFuncs.push(function () {
            // vm.loading = false;
          });

          assignmentFuncs.reduce(function (soFar, f) {
            return soFar.then(f).catch(function (err) { vm.passwordErrorLog.push(err) });
          }, $q.when([]))

          //  vm.resultLog = [];
          //  vm.resultPasswordLog = [];
          //  vm.passwordErrorLog = [""];
          //  vm.subscribersProcessed = 0;
          //  vm.subscribersNotProcessed = 0;



          //  assignmentFuncs.push(function(){
          //    vm.loading = false;
          //    vm.resultPasswordLog = $translate.instant("APP_TOAST_UPDATE_SUCCESS") + ": " + allocatedCount;
          //    Toast.showCustom($translate.instant("APP_TOAST_UPDATE_SUCCESS") + ": " + allocatedCount);

          // });

          // assignmentFuncs.reduce(function(soFar, f){
          //   return soFar.then(f).catch(function(err){vm.passwordErrorLog.push(err)});
          // }, $q.when([]))

        })
        .catch(function () {
          // vm.loading = false;
        })

    }

    function generatePass() {
      var password = Passwords.getPassword(10);
      return password
    }


    function batchSms(type) {
      if (vm.selectedSubscribersSms.length) {
        // vm.loading = true;
        var assignmentFuncs = [];
        var errors = [];
        var bulkSmsProv = [];
        var arrayLength = 1;
        var startIndex = 1;
        var resultData = [];
        var sendCount = 0;
        // console.log(vm.sms)
        // vm.selectedSubscribersSms.forEach(function (subscriber) {
        //   var assg = {
        //     itemname: subscriber.name,
        //     itemId: subscriber._id,
        //     phoneNumber: subscriber.phone_number,
        //     message: vm.sms ? vm.sms.msg ? vm.sms.msg : '' : '',
        //     apiKey: vm.reseller.sms.apiKey,
        //     apiSecret: vm.reseller.sms.apiSecret,
        //     service: vm.reseller.sms.service,
        //     ip: vm.reseller.sms.ip,
        //     port: vm.reseller.sms.port,
        //     downloadLink: vm.sms ? vm.sms.downloadLink ? vm.sms.downloadLink : '' : '',
        //     server: vm.server,
        //     assignmentDate: new Date(),
        //     active: true
        //   };
        //   bulkSmsProv.push(assg);
        //   // assignmentFuncs.push(addDeleteAllocationHandler.bind(null,assg));
        // })

        if (type == "Credentials") {
          vm.msg = "getwml.aspx?uname=XXXXX&pass=XXXXX"
        }
        else if (type == "CredentialsWithServer") {
          vm.msg = "getwml.aspx?uname=XXXXX&pass=XXXXX&server=XXXXX";
        }
        else if (type == "DownloadLink") {
          vm.msg = "Download app from here:" + vm.sms.downloadLink;
        }
        else if (type == "Both") {
          vm.msg = "getwml.aspx?uname=XXXXX&pass=XXXXX&server=XXXXX&url=" + vm.sms.downloadLink;
        }
        else if (type == "Message") {
          vm.msg = vm.sms.msg;
        }
        var confirm = Toast.getSendBulkSms(vm.msg);
      }

      function sendSMSHandler(dataarray) {
        var deferred = $q.defer();
        // vm.loading = true;
        Sms.changeBulkSendSms(dataarray, type).then(function (result) {
          resultData = resultData.concat(result.passResult);
          deferred.resolve();
          if (result.passResult.length <= vm.numberOfUserPassInArray) {
            var successCount = 0;
            var failedCount = '';
            var message = ' ';
            resultData.forEach(function (element) {
              if (element.result == true)
                successCount++;
              else
                failedCount = failedCount + element.username + ', ';
            });
            if (failedCount != '')
              message = ' Failed: ' + failedCount;
            vm.resultLog = "successfully sent: " + successCount + message + ' of '+vm.selectedSubscribersSms.length;
            if (resultData.length == vm.selectedSubscribersSms.length)
              Toast.showCustom("successfully sent: " + successCount);
            // vm.loading = false;
          }

        }).catch(function (err) {
          // vm.loading = false;
          deferred.resolve();
        });

        return deferred.promise;
      }

      setTimeout(function () {
        $mdDialog.show(confirm)
          .then(function () {
            vm.resultLog = 'Processing...';
            vm.errorLog = [];
            vm.subscribersProcessed = 0;
            vm.subscribersNotProcessed = 0;

            for (var i = startIndex; i <= vm.selectedSubscribersSms.length; i++) {
              var assg = {
                itemname: vm.selectedSubscribersSms[i - 1].name,
                itemId: vm.selectedSubscribersSms[i - 1]._id,
                phoneNumber: vm.selectedSubscribersSms[i - 1].phone_number,
                message: vm.sms ? vm.sms.msg ? vm.sms.msg : '' : '',
                apiKey: vm.reseller.sms.apiKey,
                apiSecret: vm.reseller.sms.apiSecret,
                service: vm.reseller.sms.service,
                ip: vm.reseller.sms.ip,
                port: vm.reseller.sms.port,
                downloadLink: vm.sms ? vm.sms.downloadLink ? vm.sms.downloadLink : '' : '',
                server: vm.server,
                assignmentDate: new Date(),
                active: true
              };
              if (i / arrayLength == vm.numberOfUserPassInArray) {
                arrayLength++;
                startIndex += vm.numberOfUserPassInArray;
                bulkSmsProv.push(assg);
                assignmentFuncs.push(sendSMSHandler.bind(null, bulkSmsProv));
                bulkSmsProv = [];
              }
              else if (i == vm.selectedSubscribersSms.length) {
                arrayLength++;
                bulkSmsProv.push(assg);
                assignmentFuncs.push(sendSMSHandler.bind(null, bulkSmsProv));
                bulkSmsProv = [];
              }
              else {
                bulkSmsProv.push(assg);
              }
            }

            assignmentFuncs.push(function () {
              // vm.loading = false;
            });

            assignmentFuncs.reduce(function (soFar, f) {
              return soFar.then(f).catch(function (err) { vm.passwordErrorLog.push(err) });
            }, $q.when([]))

          })
          .catch(function () {
            // vm.loading = false;
          })
      }, ((vm.selectedSubscribersSms.length / 2) * 100));

    }
    function getDetailedSubscribersList() {
      var deferred = $q.defer();
      // vm.loading = true;
      vm.timestamp = Date.now();

      getOrgSubscribers(vm.organizationId)
        .then(getOrgRoles)
        .then(getOrgGroups)
        .then(decorateSubscribers)
        .then(function (results) {
          if (!vm.showImsi2) {
            var index = vm.exportFields.indexOf("IMSI2");
            if (index >= 0)
              vm.exportFields.splice(index, 1);
          }
          if (vm.exportType == "csv")
            deferred.resolve(results);
          else {
            var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy") + "-" + vm.organization.name + ".xlsx";
            exportToExcel(vm.exportFields, results, filename);
          }
          // vm.loading = false;
        })
        .catch(function (err) {
          deferred.reject(err);
          // vm.loading = false;
        });

      return deferred.promise;
    }

    function getDetailedSubscribersList_runtime() {
      var deferred = $q.defer();
      // vm.loading = true;
      vm.timestamp = Date.now();

      getOrgSubscribers_runtime(vm.organizationId)
        .then(getSites)
        .then(decorateSubscribers_runtime)
        .then(function (results) {
          if (vm.exportTypeRuntime == "csv")
            deferred.resolve(results);
          else {
            var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy") + "-" + vm.organization.name + "-runtime.xlsx";
            exportToExcel(vm.subscriberRuntimeFields, results, filename);
          }
          // vm.loading = false;
        })
        .catch(function (err) {
          console.log(err);
          deferred.reject(err);
          // vm.loading = false;
        });

      return deferred.promise;
    }

    function getDetailedCallLogs() {
      var deferred = $q.defer();
      // vm.loading = true;
      vm.timestamp = Date.now();

      getOrgCallLogs(vm.organizationId)
        .then(decorate_callLogs)
        .then(function (results) {
          if (vm.exportTypeCallLog == "csv")
            deferred.resolve(results);
          else {
            var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy") + "-" + vm.organization.name + "-callLog.xlsx";
            exportToExcel(vm.callLogFields, results, filename);
          }
          // vm.loading = false;
        })
        .catch(function (err) {
          console.log(err);
          deferred.reject(err);
          // vm.loading = false;
        });

      return deferred.promise;
    }

    function getDetailedAdminRecord() {
      var deferred = $q.defer();
      // vm.loading = true;
      vm.timestamp = Date.now();

      getOrgAdminRecords(vm.organizationId)
        .then(decorate_adminRecords)
        .then(function (results) {
          if (vm.exportTypeAdminRecord == "csv")
            deferred.resolve(results);
          else {
            var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy") + "-" + vm.organization.name + "-adminRecords.xlsx";
            exportToExcel(vm.adminRecordFields, results, filename);
          }
          // vm.loading = false;
        })
        .catch(function (err) {
          console.log(err);
          deferred.reject(err);
          // vm.loading = false;
        });

      return deferred.promise;
    }


    function getSites() {
      var deferred = $q.defer();

      Site.getList()
        .then(function (resp) {
          vm.sites = resp;
          deferred.resolve();
        })
        .catch(function (err) {
          ExceptionHandler.show(e);
          deferred.reject(e);
        });

      return deferred.promise;
    }

    function getOrgSubscribers() {
      var deferred = $q.defer();
      vm.subscribers = []
      vm.organizationId && Subscriber.getListByOrganizationExport(vm.organizationId)
        .then(function (resp) {
          vm.subscribers = resp;
          deferred.resolve();
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
          deferred.reject(e);
        });

      return deferred.promise;
    }

    function getOrgSubscribers_runtime() {
      var deferred = $q.defer();
      vm.subscribers = []
      vm.organizationId && Subscriber.getListByOrganizationExportRuntime(vm.organizationId)
        .then(function (resp) {
          vm.subscribers = resp;
          deferred.resolve();
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
          deferred.reject(e);
        });

      return deferred.promise;
    }

    function getOrgCallLogs(orgID) {
      var deferred = $q.defer();

      CallLogs.getCallLogsByOrgID(vm.organizationId)
        .then(function (resp) {
          vm.sessions = resp;
          deferred.resolve();
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
          deferred.reject(e);
        });

      return deferred.promise;
    }

    function getOrgAdminRecords(orgID) {
      var deferred = $q.defer();

      AdminRecord.getByOrgId(vm.organizationId)
        .then(function (resp) {
          vm.adminsList = resp;
          deferred.resolve();
        })
        .catch(function (e) {
          ExceptionHandler.show(e);
          deferred.reject(e);
        });

      return deferred.promise;
    }

    function getOrgRoles() {
      var deferred = $q.defer();

      api.roles.listByOrg.query({ nodeId: vm.organizationId }, function (resp) {
        vm.roles = resp;
        deferred.resolve();
      });

      return deferred.promise;
    }

    function getOrgGroups() {
      var deferred = $q.defer();

      vm.organizationId && Group.getAllGroupList(vm.organizationId)
        .then(function (resp) {
          vm.countCheckGrops = Object.assign([],resp);
          vm.countCheckGropsName = resp.map(function(group){
            return group.name;
          });
          vm.groups = resp;
          deferred.resolve();

        })
        .catch(function (e) {
          ExceptionHandler.log(e);
          deferred.reject(e);
        });

      return deferred.promise;
    }

    function decorateSubscribers() {
      var decoratorsArray = [];
      var deferred = $q.defer();

      vm.subscribers.map(function (subscriber) {
        var decorator = decorateWithGroups(subscriber)
          .then(decorateWithPersonalGroup(subscriber, vm.emergencyGroups))
          .then(decorateWithDefaultGroupName(subscriber))
          .then(decorateWithRoleName(subscriber))
          .then(decorateWithApplicationName(subscriber))
        // .then(decorateWithLicenseName(subscriber));   //shahar- remove license
        decoratorsArray.push(decorator);
      });

      $q.all(decoratorsArray)
        .then(function (results) {
          formatForExport(results).then(function (results) {
            deferred.resolve(results);
          })
            .catch(function (err) {
              deferred.reject(err);
            })

        })
        .catch(function (err) {
          deferred.reject(err);
        });


      return deferred.promise;

    }

    function decorateSubscribers_runtime() {
      var deferred = $q.defer();
      var decoratorsArray = [];

      vm.subscribers.map(function (subscriber) {
        var decorator = decorateWithSiteName(subscriber);
        decoratorsArray.push(decorator);
      });

      $q.all(decoratorsArray)
        .then(function (results) {
          formatForExportRuntime(vm.subscribers).then(function (results) {
            vm.resultLog = "Done export subscribers status report";
            deferred.resolve(results);
          })
            .catch(function (err) {
              deferred.reject(err);
            })
        })
        .catch(function (err) {
          deferred.reject(err);
        });


      return deferred.promise;
    }

    function decorate_callLogs() {
      var deferred = $q.defer();

      formatForExportCallLogs(vm.sessions).then(function (results) {
        vm.resultLog = "Done export call log report";
        deferred.resolve(results);
      })
        .catch(function (err) {
          deferred.reject(err);
        })

      return deferred.promise;
    }

    function decorate_adminRecords() {
      var deferred = $q.defer();

      formatForExportAdminRecords(vm.adminsList).then(function (results) {
        vm.resultLog = "Done export admin record report";
        deferred.resolve(results);
      })
        .catch(function (err) {
          deferred.reject(err);
        })

      return deferred.promise;
    }

    function formatForExport(subscribers) {
      var deferred = $q.defer();
      vm.exportSubscribers = [];

      subscribers.map(function (subscriber) {
        if (subscriber.phone_number == subscriber._id) {
          subscriber.phone_number = "";
        }
        var exportSubscriber = {
          displayName: subscriber.name,
          password: subscriber.password,
          phone: subscriber.phone_number || "",
          sip: subscriber.sip || "",
          imsi: subscriber.imsi || "",
          imsi2: subscriber.imsi2 || "",
          licenseMask: subscriber.permissions_mask || "",
          defaultRadioGroup: subscriber.defaultGroupName || "",
          radioGroups: subscriber.radioGroups || "",
          RadioIsMuted: subscriber.radioGroupsMuted || "",
          conferenceGroups: subscriber.conferenceGroups || "",
          ConferenceIsMuted: subscriber.conferenceIsMuted || "",
          orgContactList: subscriber.ocl || "",
          emergencyGroup: subscriber.personalGroup || "",
          responceGroups: subscriber.emergencyGroups || "",
          // forwardGroups: subscriber.forwardGroups || "",
          assignedTemplates: "",
          contactTemplatesImport: subscriber.contactTemplates || "",
          appProfile: subscriber.appProfile || "",
          roleName: subscriber.adminrole_id || "",
          adminState: subscriber.admin_state != 1
        };
        if (!vm.showImsi2) delete exportSubscriber.imsi2;
        vm.exportSubscribers.push(exportSubscriber);
      });

      deferred.resolve(vm.exportSubscribers);
      return deferred.promise;

    }

    function formatForExportRuntime(subscribers) {
      var deferred = $q.defer();
      vm.exportSubscribers = [];
      subscribers.map(function (subscriber) {

        // if (subscriber.runtime.lastUpdateTime){
        //   var date = new Date(subscriber.runtime.lastUpdateTime);
        //   subscriber.runtime.lastUpdateTime = (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
        // }
        // else
        //   subscriber.runtime.lastUpdateTime = "Not Available";

        if (subscriber.phone_number == subscriber._id) {
          subscriber.phone_number = "";
        }

        var exportSubscriber = {
          displayName: subscriber.name,
          phone: subscriber.phone_number,
          protocolVersion: subscriber.runtime.protocolVersion || "Not Available",
          appVersion: subscriber.runtime.clientVersion || "Not Available",
          clientType: subscriber.runtime.clientType || "Not Available",
          state: subscriber.runtime.state || "Not Available",
          site: subscriber.site || "Not Available",
          creationTime: $filter('date')(subscriber.creation_time, "dd/MMM/yyyy, HH:mm:ss") || 0,
          lastRegistrationTime: $filter('date')(subscriber.runtime.lastRegistrationTime, "dd/MMM/yyyy, HH:mm:ss") || "Not Available",
          //lastUserClientUpdateTime: subscriber.runtime.lastUpdateTime || "Not Available",
          changeStateTime: $filter('date')(subscriber.change_state_time, "dd/MMM/yyyy, HH:mm:ss") || "Not Available",
          modelName: subscriber.runtime.model_name || "Not Available",
          OStype: subscriber.runtime.os_type || "Not Available",
          OSversion: subscriber.runtime.os_version || "Not Available",
          brand: subscriber.runtime.brand || "Not Available",
          deviceFreeMemory: subscriber.runtime.memory || "Not Available",
          manufacturer: subscriber.runtime.manufacture || "Not Available",
          fwVerison: subscriber.runtime.fw_version || "Not Available",
          build: subscriber.runtime.build_type || "Not Available",
          fcm: subscriber.runtime.fcm || "Not Available",
        };

        vm.exportSubscribers.push(exportSubscriber);
      });

      deferred.resolve(vm.exportSubscribers);
      return deferred.promise;
    }

    function secondsToHMS(secs) {
      function z(n) { return (n < 10 ? '0' : '') + n; }
      var sign = secs < 0 ? '-' : '';
      secs = Math.abs(secs);
      return sign + z(secs / 3600 | 0) + ':' + z((secs % 3600) / 60 | 0) + ':' + z(secs % 60);
    }

    function formatForExportCallLogs(sessions) {
      var deferred = $q.defer();
      vm.exportBursts = [];

      for (var i = 0; i < sessions.length; i++) {
        if (!sessions[i].bursts || sessions[i].bursts.length == 0) {
          var exportBurst = {
            SessionName: sessions[i].session_name,
            MissedCall: "Yes",
            SessionId: sessions[i].session_id,
            SenderName: sessions[i].sender_name,
            SenderId: sessions[i].sender_id,
            RecipientName: sessions[i].recipient_name,
            RecipientId: sessions[i].recipient_id,
            SessionType: sessions[i].session_type_name,
            SessionStartTime: $filter('date')(sessions[i].time_start, "dd/MMM/yyyy, HH:mm:ss"),
            SessionEndTime: $filter('date')(sessions[i].time_end, "dd/MMM/yyyy, HH:mm:ss"),
            BurstTalkerName: "",
            BurstTalkerId: "",
            BurstStartTime: "",
            BurstEndTime: ""
          };
          vm.exportBursts.push(exportBurst);
        }
        else {
          sessions[i].bursts.map(function (burst) {
            if (burst.time_end == null) var diffTime = Date.now() - new Date(burst.time_start);
            else var diffTime = new Date(burst.time_end) - new Date(burst.time_start);

            var exportBurst = {
              SessionName: sessions[i].session_name,
              MissedCall: "No",
              SessionId: sessions[i].session_id,
              SenderName: sessions[i].sender_name,
              SenderId: sessions[i].sender_id,
              RecipientName: sessions[i].recipient_name,
              RecipientId: sessions[i].recipient_id,
              SessionType: sessions[i].session_type_name,
              SessionStartTime: sessions[i].time_start ? $filter('date')(sessions[i].time_start, "dd/MMM/yyyy, HH:mm:ss") : "",
              SessionEndTime: sessions[i].time_end ? $filter('date')(sessions[i].time_end, "dd/MMM/yyyy, HH:mm:ss") : "",
              BurstTalkerName: burst.talker_name,
              BurstTalkerId: burst.talker_id,
              BurstStartTime: burst.time_start ? $filter('date')(burst.time_start, "dd/MMM/yyyy, HH:mm:ss") : "",
              BurstEndTime: burst.time_end ? $filter('date')(burst.time_end, "dd/MMM/yyyy, HH:mm:ss") : "",
              Duration: secondsToHMS(diffTime / 1000)
            };
            vm.exportBursts.push(exportBurst);
          });
        }
      }
      deferred.resolve(vm.exportBursts);
      return deferred.promise;

    }

    function formatForExportAdminRecords(admins) {
      var deferred = $q.defer();
      vm.exportAdmins = [];

      for (var i = 0; i < admins.length; i++) {
        if (admins[i].activities && admins[i].activities.length) {
          admins[i].activities.map(function (activity) {

            var exportAdmin = {
              Email: admins[i].username,
              lastLoginTime: admins[i].last_login_time ? $filter('date')(admins[i].last_login_time, "dd/MMM/yyyy, HH:mm:ss") : "",
              lastActivityTime: admins[i].last_activity_time ? $filter('date')(admins[i].last_activity_time, "dd/MMM/yyyy, HH:mm:ss") : "",
              activityCommand: activity.command,
              activitySessionName: activity.session_name,
              activityUserName: activity.user_name,
              activityTime: activity.time ? $filter('date')(activity.time, "dd/MMM/yyyy, HH:mm:ss") : "",
              activityIp: activity.ip,
            };

            vm.exportAdmins.push(exportAdmin);
          });
        }
        else {
          var exportAdmin = {
            Email: admins[i].username,
            lastLoginTime: $filter('date')(admins[i].last_login_time, "dd/MMM/yyyy, HH:mm:ss"),
            lastActivityTime: $filter('date')(admins[i].last_activity_time, "dd/MMM/yyyy, HH:mm:ss"),
            activityCommand: '',
            activitySessionName: '',
            activityUserName: '',
            activityTime: '',
            activityIp: '',
          };

          vm.exportAdmins.push(exportAdmin);
        }
      }
      deferred.resolve(vm.exportAdmins);
      return deferred.promise;

    }

    function decorateWithGroups(subscriber) {
      var deferred = $q.defer();
      subscriber.radioGroupsMuted = Object.assign([],subscriber.radioGroups);
      subscriber.conferenceIsMuted = Object.assign([],subscriber.conferenceGroups);

      subscriber.radioGroups = subscriber.radioGroups.map(function (group) {
        return group.name;
      });
      subscriber.radioGroups = subscriber.radioGroups.join(";");

      subscriber.radioGroupsMuted = subscriber.radioGroupsMuted.map(function (group) {
        return group.client_is_muted;
      });
      subscriber.radioGroupsMuted = subscriber.radioGroupsMuted.join(";");

      subscriber.conferenceGroups = subscriber.conferenceGroups.map(function (group) {
        return group.name;
      });
      subscriber.conferenceGroups = subscriber.conferenceGroups.join(";");

      subscriber.conferenceIsMuted = subscriber.conferenceIsMuted.map(function (group) {
        return group.client_is_muted;
      });
      subscriber.conferenceIsMuted = subscriber.conferenceIsMuted.join(";");

      subscriber.ocl = subscriber.ocl.map(function (group) {
        return group.name;
      });
      subscriber.ocl = subscriber.ocl.join(";");

      subscriber.emergencyGroups = subscriber.emergencyGroups.map(function (group) {
        return group.name;
      });
      subscriber.emergencyGroups = subscriber.emergencyGroups.join(";");
      // if(subscriber.forwardGroups)
      // {
      // subscriber.forwardGroups = subscriber.forwardGroups.map(function (group) {
      //   return group.name;
      // });
      // subscriber.forwardGroups = subscriber.forwardGroups.join(";");
      // }

      subscriber.contactTemplates = subscriber.contactTemplates.map(function (group) {
        return group.name;
      });
      subscriber.contactTemplates = subscriber.contactTemplates.join(";");

      deferred.resolve(subscriber);

      return deferred.promise;
    }

    function decorateWithPersonalGroup(subscriber, orgEmergencyGroups) {
      var deferred = $q.defer();

      if (subscriber.personalGroup) {
        subscriber.personalGroup = orgEmergencyGroups.filter(function (group) {
          return (Number(group._id.substring(group._id.length - 10, group._id.length)) == subscriber.personalGroup.personalgroup_mask);
        })
        if (subscriber.personalGroup.length > 0)
          subscriber.personalGroup = subscriber.personalGroup[0].name;
      }

      deferred.resolve(subscriber);

      return deferred.promise;
    }


    var decorateWithGroupId = function (group) {
      var deferred = $q.defer();

      for (var i = 0; i < vm.groups.length; i++) {
        if (group == vm.groups[i].name) {
          group = vm.groups[i]._id;
          deferred.resolve(group);
          break;
        }
      }


      return deferred.promise;
    };

    function decorateWithRadioGroupsIds(subscriber) {
      var deferred = $q.defer();
      subscriber.newRadioGroups = [];

      if (subscriber.radioGroups && subscriber.radioGroups.length) {
        subscriber.radioGroupIds = [];
        subscriber.radioGroups.map(function (group, index) {

          for (var i = 0; i < vm.groups.length; i++) {
            if (group == vm.groups[i].name && vm.groups[i].type == 2) {
              var groupVal = {
                id: vm.groups[i]._id,
                affilated: vm.groups[i].cross_fleet,
                client_is_muted: (subscriber.RadioIsMuted && subscriber.RadioIsMuted.length > index)?parseInt(isBinaryString(subscriber.RadioIsMuted[index])?subscriber.RadioIsMuted[index]:0):0
              }
              subscriber.radioGroupIds.push(groupVal);
              return group = vm.groups[i]._id;
            }
          }
          if (group.length > 12) {
            vm.validationErrors.push({ err: $translate.instant("GROUP_LIMIT_SIZE", $translate.instant("SUBSCRIBER")), subscriberId: subscriber.sip, groupName: group });
          }
          else
          {
            var newGp = {
              name:group,
              client_is_muted: (subscriber.RadioIsMuted && subscriber.RadioIsMuted.length > index)?parseInt(isBinaryString(subscriber.RadioIsMuted[index])?subscriber.RadioIsMuted[index]:0):0
            }
            subscriber.newRadioGroups.push(newGp);
          }
        });

        deferred.resolve(subscriber);
      }
      else {
        deferred.resolve(subscriber);
      }

      return deferred.promise;
    }

    function isBinaryString(str) {
      return /^[01]+$/.test(str);
    }

    function decorateWithForwardGroupsIds(subscriber) {
      var deferred = $q.defer();
      subscriber.newForwardGroups = [];

      if (subscriber.forwardGroups && subscriber.forwardGroups.length) {
        subscriber.ForwardGroupsIds = [];
        subscriber.forwardGroups.map(function (group) {
          for (var i = 0; i < vm.groups.length; i++) {
            if (group == vm.groups[i].name && vm.groups[i].type == 10) {
              subscriber.ForwardGroupsIds.push(vm.groups[i]._id);
              return group = vm.groups[i]._id;
            }
          }
          if (group.length > 12) {
            vm.validationErrors.push({ err: $translate.instant("GROUP_LIMIT_SIZE", $translate.instant("SUBSCRIBER")), subscriberId: subscriber.sip, groupName: group });
          }
          else
            subscriber.newForwardGroups.push(group);
        });

        deferred.resolve(subscriber);
      }
      else {
        deferred.resolve(subscriber);
      }

      return deferred.promise;
    }

    function decorateWithConferenceGroupsIds(subscriber) {
      var deferred = $q.defer();
      subscriber.newConferenceGroups = [];

      if (subscriber.conferenceGroups && subscriber.conferenceGroups.length) {
        subscriber.conferenceGroupIds = [];
        subscriber.conferenceGroups.map(function (group, index) {

          for (var i = 0; i < vm.groups.length; i++) {
            if (group == vm.groups[i].name && vm.groups[i].type == 1) {
              var conGroupVal = {
                id: vm.groups[i]._id,
                affilated: vm.groups[i].cross_fleet,
                client_is_muted: (subscriber.ConferenceIsMuted && subscriber.ConferenceIsMuted.length > index)?parseInt(isBinaryString(subscriber.ConferenceIsMuted[index])?subscriber.ConferenceIsMuted[index]:0):0
              }
              subscriber.conferenceGroupIds.push(conGroupVal);
              return group = vm.groups[i]._id;
            }
          }
          if (group.length > 12) {
            vm.validationErrors.push({ err: $translate.instant("GROUP_LIMIT_SIZE", $translate.instant("SUBSCRIBER")), subscriberId: subscriber.sip, groupName: group });
          }
          else
          {            
            var newGp = {
              name:group,
              client_is_muted: (subscriber.ConferenceIsMuted && subscriber.ConferenceIsMuted.length > index)?parseInt(isBinaryString(subscriber.ConferenceIsMuted[index])?subscriber.ConferenceIsMuted[index]:0):0
            }
            subscriber.newConferenceGroups.push(newGp);
          }
        });

        deferred.resolve(subscriber);
      }
      else {
        deferred.resolve(subscriber);
      }

      return deferred.promise;
    }

    function decorateWithEmergencyGroupsIds(subscriber) {
      var deferred = $q.defer();
      subscriber.newEmergencyGroups = [];

      if (subscriber.responceGroups && subscriber.responceGroups.length) {
        subscriber.emergencyGroupIds = [];
        subscriber.responceGroups.map(function (group) {

          for (var i = 0; i < vm.groups.length; i++) {
            if (group == vm.groups[i].name && vm.groups[i].type == 9) {
              var emeGroupVal = {
                id: vm.groups[i]._id,
                affilated: vm.groups[i].cross_fleet
              }
              subscriber.emergencyGroupIds.push(emeGroupVal);
              return group = vm.groups[i]._id;
            }
          }
          if (group.length > 12) {
            vm.validationErrors.push({ err: $translate.instant("GROUP_LIMIT_SIZE", $translate.instant("SUBSCRIBER")), subscriberId: subscriber.sip, groupName: group });
          }
          else
            subscriber.newEmergencyGroups.push(group);
        });

        deferred.resolve(subscriber);
      }
      else {
        deferred.resolve(subscriber);
      }

      return deferred.promise;
    }

    function decorateWithContactTemplatesIds(subscriber) {
      var deferred = $q.defer();
      subscriber.newContactTemplates = [];

      if (subscriber.contactTemplatesImport && subscriber.contactTemplatesImport.length) {
        subscriber.contactTemplatesIds = [];
        subscriber.contactTemplatesImport.map(function (group) {

          for (var i = 0; i < vm.groups.length; i++) {
            if (group == vm.groups[i].name && vm.groups[i].type == 8) {
              var conTempGroupVal = {
                id: vm.groups[i]._id,
                affilated: vm.groups[i].cross_fleet
              }
              subscriber.contactTemplatesIds.push(conTempGroupVal);
              return group = vm.groups[i]._id;
            }
          }
          if (group.length > 12) {
            vm.validationErrors.push({ err: $translate.instant("GROUP_LIMIT_SIZE", $translate.instant("SUBSCRIBER")), subscriberId: subscriber.sip, groupName: group });
          }
          else
            subscriber.newContactTemplates.push(group);
        });

        deferred.resolve(subscriber);
      }
      else {
        deferred.resolve(subscriber);
      }

      return deferred.promise;
    }

    function decorateWithOCLIds(subscriber) {
      var deferred = $q.defer();
      subscriber.newContacts = [];

      if (subscriber.ocl && subscriber.ocl.length) {
        subscriber.oclIds = [];
        subscriber.ocl.map(function (ocl) {

          for (var i = 0; i < vm.groups.length; i++) {
            if (ocl == vm.groups[i].name && vm.groups[i].type == 4) {
              var oclGroupVal = {
                id: vm.groups[i]._id,
                affilated: vm.groups[i].cross_fleet
              }
              subscriber.oclIds.push(oclGroupVal);
              return ocl = vm.groups[i]._id;
            }
          }
          if (ocl.length > 12) {
            vm.validationErrors.push({ err: $translate.instant("GROUP_LIMIT_SIZE", $translate.instant("SUBSCRIBER")), subscriberId: subscriber.sip, oclName: ocl });
          }
          else
            subscriber.newContacts.push(ocl);
        });

        deferred.resolve(subscriber);
      }
      else {
        deferred.resolve(subscriber);
      }

      return deferred.promise;
    }

    function decorateWithDefaultGroupName(subscriber) {
      var deferred = $q.defer();
      for (var i = 0; i < vm.groups.length; i++) {
        if (subscriber.default_group_id == vm.groups[i]._id) {
          subscriber.defaultGroupName = vm.groups[i].name;
          deferred.resolve(subscriber);
          break;
        }
      }
      return deferred.promise;
    }

    function decorateWithDefaultGroupId(subscriber) {
      var deferred = $q.defer();
      subscriber.default_group_id = subscriber.defaultGroup;
      for (var i = 0; i < vm.groups.length; i++) {
        if (subscriber.defaultGroup == vm.groups[i].name) {
          subscriber.default_group_id = vm.groups[i]._id;
          deferred.resolve(subscriber);
          break;
        }
      }
      return deferred.promise;
    }

    function decorateWithRoleName(subscriber) {
      var deferred = $q.defer();
      for (var i = 0; i < vm.roles.length; i++) {
        if (subscriber.adminrole_id == vm.roles[i]._id) {
          subscriber.adminrole_id = vm.roles[i].name;
          deferred.resolve(subscriber);
          break;
        }
      }
      return deferred.promise;
    }

    function decorateWithApplicationName(subscriber) {
      var deferred = $q.defer();
      if(subscriber.applicationList)
      {
        for (var i = 0; i < vm.applicationLists.length; i++) {
          if (subscriber.applicationList.application_list == vm.applicationLists[i]._id) {
            subscriber.appProfile = vm.applicationLists[i].name;
            deferred.resolve(subscriber);
            break;
          }
        }
      }
      return deferred.promise;
    }

    function decorateWithRoleId(subscriber) {
      var deferred = $q.defer();
      subscriber.adminrole_id = 0;
      for (var i = 0; i < vm.roles.length; i++) {
        if (subscriber.roleName == vm.roles[i].name) {
          subscriber.adminrole_id = vm.roles[i]._id;
          deferred.resolve(subscriber);
          break;
        }
      }
      return deferred.promise;
    }

    function decorateWithApplicationId(subscriber) {
      var deferred = $q.defer();
      if(subscriber.appProfile)
      {
        for (var i = 0; i < vm.applicationLists.length; i++) {
          if (subscriber.appProfile == vm.applicationLists[i].name) {
            subscriber.application_id = vm.applicationLists[i]._id;
            subscriber.appProfile = null;
            deferred.resolve(subscriber);
            break;
          }
        }
      }
      return deferred.promise;
    }

    function decorateWithSiteName(subscriber) {
      var deferred = $q.defer();

      for (var i = 0; i < vm.sites.length; i++) {
        if (subscriber.primary_site_id == vm.sites[i]._id) {
          subscriber.site = vm.sites[i].name;
          deferred.resolve(subscriber);
          break;
        }
      }

      return deferred.promise;
    }

    function decorateWithSiteId(subscriber) {
      var deferred = $q.defer();

      for (var i = 0; i < vm.sites.length; i++) {
        if (subscriber.site == vm.sites[i].name) {
          subscriber.site = vm.sites[i]._id;
          deferred.resolve(subscriber);
          break;
        }
      }

      return deferred.promise;
    }

    function getImportResults() {
      var deferred = $q.defer();
      if (vm.result && (vm.result.filename.includes(".csv") || vm.result.filename.includes(".xlsx"))) {
        if (vm.result.filename.includes(".csv")) var csv = true;
        else var csv = false
        var headers = csv ? Object.values(vm.result.shift()) : Object.keys(vm.result[0]);

        var resultSubscribers = [];
        try {
          var groupdata = '';
          vm.result.map(function (parsedSubscriber) {
            var newSubscriber = {};
            headers.forEach(function (key, i) { newSubscriber[vm.importFields[key]] = parsedSubscriber[csv ? i : key] });
            if(groupdata != '')
              groupdata +=';';
            groupdata += newSubscriber.radioGroups ? newSubscriber.radioGroups : null;
            // if(groupdata <= vm.groupLimitAssignment){
              newSubscriber.displayName = newSubscriber.displayName.trim();
              newSubscriber.password = newSubscriber.password.trim();
              newSubscriber.phone = newSubscriber.phone.trim();
              newSubscriber.sip = newSubscriber.sip.trim();
              newSubscriber.imsi = newSubscriber.imsi.trim();
              newSubscriber.imsi2 = newSubscriber.imsi2 ? newSubscriber.imsi2.trim() : '';
              newSubscriber.permissionMask = newSubscriber.permissionMask.trim();
              newSubscriber.defaultGroup = newSubscriber.defaultGroup.trim() == 0 ? null : newSubscriber.defaultGroup.trim();
              newSubscriber.radioGroups = newSubscriber.radioGroups ? newSubscriber.radioGroups.split(";") : null;
              newSubscriber.RadioIsMuted = newSubscriber.RadioIsMuted ? newSubscriber.RadioIsMuted.split(";") : null;
              newSubscriber.conferenceGroups = newSubscriber.conferenceGroups ? newSubscriber.conferenceGroups.split(";") : null;
              newSubscriber.ConferenceIsMuted = newSubscriber.ConferenceIsMuted ? newSubscriber.ConferenceIsMuted.split(";") : null;
              newSubscriber.ocl = newSubscriber.ocl ? newSubscriber.ocl.split(";") : null;
              newSubscriber.personalGroup = newSubscriber.personalGroup.trim();
              // newSubscriber.forwardGroups =  newSubscriber.forwardGroups ?  newSubscriber.forwardGroups.split(";") : null;
              newSubscriber.responceGroups = newSubscriber.responceGroups ? newSubscriber.responceGroups.split(";") : null;
              newSubscriber.assignedTemplates = newSubscriber.assignedTemplates ? newSubscriber.assignedTemplates.split(";") : null;
              newSubscriber.contactTemplatesImport = newSubscriber.contactTemplatesImport ? newSubscriber.contactTemplatesImport.split(";") : null;
              newSubscriber.roleName = newSubscriber.roleName.trim();
              newSubscriber.appProfile = newSubscriber.appProfile.trim();
              newSubscriber.adminState = newSubscriber.adminState.trim() === "TRUE" ? 0 : 1;
              newSubscriber.primary_site_id = vm.organization.primary_site_id;
              newSubscriber.site = vm.organization.site;
              
              if(newSubscriber.radioGroups)
              {
                newSubscriber.radioGroups.forEach(function (element) {
                  if(vm.countCheckGropsName.indexOf(element) !== -1)
                  {
                    vm.countCheckGrops = vm.countCheckGrops.filter(function (grpelement)  {
                        if(grpelement.name === element)
                            grpelement.count++;
                        return grpelement
                    });
                  }
                  else{
                    vm.countCheckGropsName.push(element);
                    var data ={
                      'name' : element,
                      'count': 1
                    }
                    vm.countCheckGrops.push(data);
                  }
                });
              }
              if(newSubscriber.conferenceGroups)
              {
                newSubscriber.conferenceGroups.forEach(function (element) {
                  if(vm.countCheckGropsName.indexOf(element) !== -1)
                  {
                    vm.countCheckGrops = vm.countCheckGrops.filter(function (grpelement) {
                        if(grpelement.name === element)
                            grpelement.count++;
                        return grpelement
                    });
                  }
                  else{
                    vm.countCheckGropsName.push(element);
                    var data ={
                      'name' : element,
                      'count': 1
                    }
                    vm.countCheckGrops.push(data);
                  }
                });
              }
              if(newSubscriber.ocl)
              {
                newSubscriber.ocl.forEach(function (element) {
                  if(vm.countCheckGropsName.indexOf(element) !== -1)
                  {
                    vm.countCheckGrops = vm.countCheckGrops.filter(function (grpelement) {
                        if(grpelement.name === element)
                            grpelement.count++;
                        return grpelement
                    });
                  }
                  else{
                    vm.countCheckGropsName.push(element);
                    var data ={
                      'name' : element,
                      'count': 1
                    }
                    vm.countCheckGrops.push(data);
                  }
                });
              }
              if(newSubscriber.responceGroups)
              {
                newSubscriber.responceGroups.forEach(function (element) {
                  if(vm.countCheckGropsName.indexOf(element) !== -1)
                  {
                    vm.countCheckGrops = vm.countCheckGrops.filter(function (grpelement) {
                        if(grpelement.name === element)
                            grpelement.count++;
                        return grpelement
                    });
                  }
                  else{
                    vm.countCheckGropsName.push(element);
                    var data ={
                      'name' : element,
                      'count': 1,
                      'type' : 9
                    }
                    vm.countCheckGrops.push(data);
                  }
                });
              }
              if(newSubscriber.contactTemplatesImport)
              {
                newSubscriber.contactTemplatesImport.forEach(function (element) {
                  if(vm.countCheckGropsName.indexOf(element) !== -1)
                  {
                    vm.countCheckGrops = vm.countCheckGrops.filter(function (grpelement) {
                        if(grpelement.name === element)
                            grpelement.count++;
                        return grpelement
                    });
                  }
                  else{
                    vm.countCheckGropsName.push(element);
                    var data ={
                      'name' : element,
                      'count': 1
                    }
                    vm.countCheckGrops.push(data);
                  }
                });
              }
              if (!vm.showImsi2) delete newSubscriber.imsi2;
  
              resultSubscribers.push(newSubscriber);
            // }
            // else{
            //   vm.resultLog = $translate.instant("GROUPS_API_LIMIT_ERROR")
            //   deferred.reject();
            // }
          });
          var answer = groupdata.split(';').filter(function(item, pos,self) {
            return self.indexOf(item) == pos;
         });
          deferred.resolve(resultSubscribers);
        }
        catch (err) {
          vm.resultLog = $translate.instant("INVALID_BULK_FILE_FORMAT")
          deferred.reject();
        }
      }
      else {
        Toast.showBatchImportedFileErrorMsg();
        deferred.reject();
      }
      return deferred.promise;
    }

    vm.streamingCallback = function () {
      // vm.loading = true;
      vm.errorLog = [];
      getOrgRoles()
        .then(getOrgGroups)
        .then(function () {
          getImportResults()
            .then(function (resultSubscribers) {
              var grpValidate = true;
              var grmNamee = '';
              vm.countCheckGrops.forEach(function (element) {
                // console.log(element.name)
                // console.log(element.count +' <= '+ vm.groupLimitAssignment)
                if(element.type && element.type == 9){
                  if(element.count > 50)
                  {
                    grmNamee = element.name;
                    grpValidate = false;
                  }
                }
                else{
                  console.log(element.count +' - '+ vm.groupLimitAssignment);
                  if(element.count > vm.groupLimitAssignment)
                  {
                    grmNamee = element.name;
                    grpValidate = false;
                  }
                }
              });
              if(grpValidate)              
              {
                var decoratorsArray = [];
                vm.validationErrors = [];

                getOrgGroups().then(function (results) {
                  resultSubscribers.map(function (subscriber) {
                    var decorator = decorateWithRadioGroupsIds(subscriber)
                      .then(decorateWithConferenceGroupsIds(subscriber))
                      // .then(decorateWithForwardGroupsIds(subscriber))
                      .then(decorateWithEmergencyGroupsIds(subscriber))
                      .then(decorateWithContactTemplatesIds(subscriber))
                      .then(decorateWithOCLIds(subscriber))
                      .then(decorateWithDefaultGroupId(subscriber))
                      .then(decorateWithRoleId(subscriber))
                      .then(decorateWithApplicationId(subscriber))
                    // .then(decorateWithLicenseId(subscriber));
                    decoratorsArray.push(decorator);
                  });
                  $q.all(decoratorsArray)
                    .then(function (results) {
                      formatForImport(results)
                        .then(function (results) {
                          bulkImport(results);
                        })
                    })
                    .catch(function (err) {
                      // vm.loading = false;
                    });
                })
                  .catch(function (err) {
                    // vm.loading = false;
                  })
              }
              else{
                vm.resultLog = $translate.instant("APP_OUT_OF_MEMBER", $translate.instant("GROUP"))+'- '+grmNamee
              }
            })
            .catch(function (err) {
              // vm.loading = false;
            });
        })
        .catch(function (err) {
          // vm.loading = false;
        })
    };
    function validateSip(sip, phone) {

      if (vm.organization.domain && sip.length >= vm.organization.domain.length) {
        if (!sip.endsWith('@' + vm.organization.domain)) {
          vm.validationErrors.push({ err: $translate.instant("API_ADD_ERROR", $translate.instant("SUBSCRIBER")), subscriberId: sip, exception: $translate.instant("SUBSCRIBERS_VALIDATION_ORG_DOMAIN_ERROR") + vm.organization.domain });
          return false;
        }

        // if(sip.indexOf("@") === -1) {
        //   vm.validationErrors.push({err: $translate.instant("API_ADD_ERROR", $translate.instant("SUBSCRIBER")), subscriberId: sip, exception:  $translate.instant("SUBSCRIBERS_VALIDATION_SIP_FORMAT_ERROR") });
        //   return false;
        // }

        if (isPhoneNumber(phone)) {
          var sipArray = sip.split("@");
          var sipUsername = sipArray[0];
          if (sipUsername !== phone) {
            vm.validationErrors.push({ err: $translate.instant("API_ADD_ERROR", $translate.instant("SUBSCRIBER")), subscriberId: sip, exception: $translate.instant("SUBSCRIBERS_VALIDATION_SIP_PHONE_ERROR") });
            return false;
          }
        }
      }
      else {
        vm.validationErrors.push({ err: $translate.instant("SUBSCRIBERS_VALIDATION_ADD_ERROR"), subscriberName: sip, exception: $translate.instant("SUBSCRIBERS_VALIDATION_SIP_FORMAT_ERROR") });
        return false;
      }

      return true;
    }

    function validateIMSI(imsi) {

      if (imsi && (!(/^\d+$/.test(imsi)) || imsi.length < 14 || imsi.length > 20)) {
        vm.validationErrors.push({ err: $translate.instant("SUBSCRIBERS_VALIDATION_ADD_ERROR"), subscriberName: imsi, exception: $translate.instant("SUBSCRIBERS_API_VALIDATION_IMSI_FORMAT_ERROR") });
        return false;
      }
      else
        return true;
    }

    function validateIMSI2(imsi2) {

      if (imsi2 && (!(/^\d+$/.test(imsi2)) || imsi2.length < 14 || imsi2.length > 20)) {
        vm.validationErrors.push({ err: $translate.instant("SUBSCRIBERS_VALIDATION_ADD_ERROR"), subscriberName: imsi2, exception: $translate.instant("SUBSCRIBERS_API_VALIDATION_IMSI_FORMAT_ERROR") });
        return false;
      }
      else
        return true;
    }

    function validateUsername(username, identifier) {
      if (vm.organization.domain && username) {
        if (username.indexOf("@") !== -1) {
          vm.validationErrors.push({ err: $translate.instant("API_ADD_ERROR"), subscriberId: identifier, exception: $translate.instant("SUBSCRIBERS_VALIDATION_AT_ERROR") });
          return false;
        }
        if (username.indexOf(vm.organization.domain) !== -1) {
          vm.validationErrors.push({ err: $translate.instant("API_ADD_ERROR"), subscriberId: identifier, exception: $translate.instant("SUBSCRIBERS_VALIDATION_USERNAME_ORG_DOMAIN_ERROR") });
          return false;
        }
      }
      else {
        vm.validationErrors.push({ err: $translate.instant("SUBSCRIBERS_VALIDATION_ADD_ERROR"), subscriberName: identifier, exception: $translate.instant("SUBSCRIBERS_VALIDATION_SIP_FORMAT_ERROR") });
        return false;
      }

      return true;
    }

    function formatForImport(subscribers) {
      var deferred = $q.defer();
      var importSubscribers = [];
      subscribers.map(function (subscriber) {
        if (subscriber.displayName.trim() != '') {
          subscriber.phone = subscriber.sip.split("@")[0];
          var importSubscriber = {
            name: subscriber.displayName.trim(),
            sip: subscriber.sip.trim(),
            imsi: subscriber.imsi.trim(),
            imsi2: subscriber.imsi2 ? subscriber.imsi2.trim() : '',
            organization_id: vm.organizationId,
            default_group_id: subscriber.default_group_id,
            admin_state: subscriber.adminState,
            password: subscriber.password.trim(),
            official_first_name: subscriber.displayName.trim(),
            permission_mask: parseInt(subscriber.permissionMask) || "0",
            phone_number: isPhoneNumber(subscriber.phone) ? subscriber.phone : "0",
            site: subscriber.site || null,
            primary_site_id: subscriber.primary_site_id || null,
            email: isPhoneNumber(subscriber.phone) ? null : subscriber.sip.trim(),
            adminrole_id: subscriber.adminrole_id,
            roleName: subscriber.roleName,
            //licenseAllocationId: subscriber.licenseAllocationId,
            radioGroups: subscriber.radioGroupIds,
            newRadioGroups: subscriber.newRadioGroups,
            newContacts: subscriber.newContacts,
            contacts: subscriber.oclIds,
            conferenceGroups: subscriber.conferenceGroupIds,
            newConferenceGroups: subscriber.newConferenceGroups,
            emergencyGroups: subscriber.emergencyGroupIds,
            // forwardGroups: subscriber.ForwardGroupsIds,
            newForwardGroups: subscriber.newForwardGroups,
            newEmergencyGroups: subscriber.newEmergencyGroups,
            assignedTemplates: subscriber.assignedTemplates,
            contactTemplates: subscriber.contactTemplatesIds,
            newContactTemplates: subscriber.newContactTemplates,
            personalGroup: subscriber.personalGroup,
            applicationList: subscriber.appProfile,
            application_id: subscriber.application_id
          };

          if (importSubscriber.sip == "")
            importSubscriber.sip = undefined;
          if (importSubscriber.imsi == "")
            importSubscriber.imsi = undefined;
          if (importSubscriber.imsi2 == "")
            importSubscriber.imsi2 = undefined;

          if (importSubscriber.sip) {
            if (validateSip(importSubscriber.sip, subscriber.phone) && validateUsername(importSubscriber.name, importSubscriber.sip) && validateIMSI(importSubscriber.imsi) && validateIMSI2(importSubscriber.imsi2)) {
              importSubscribers.push(importSubscriber);
            }
          }
          else
            vm.validationErrors.push({ err: $translate.instant("API_ADD_ERROR", $translate.instant("SUBSCRIBER")), subscriberId: importSubscriber.name, exception: "SIP field is require" });
        }
      });

      deferred.resolve(importSubscribers);
      return deferred.promise;
    }

    function bulkImport(subscribers) {

      vm.subscribersNotProcessed = 0;
      vm.subscribersProcessed = 0;
      vm.errorLog = [];

      if (vm.validationErrors.length > 0) {
        vm.errorLog = vm.validationErrors;
        vm.subscribersNotProcessed = vm.validationErrors.length;
        vm.validationErrors = [];
      }
      else {
        vm.errorLog = [];
      }

      var temparray = [];
      var chunk = 20;
      Subscriber.isCheckUserFlag(subscribers.length).then(function (isValid){
        if(isValid.results){
          for (var i = 0, j = subscribers.length; i < j; i += chunk) {
            temparray.push(subscribers.slice(i, i + chunk));
          }
          var batchAdd = temparray.map(function (chunk) {
            var payload = {
              subscribers: chunk
            };
              return batchAddHandler.bind(null, payload);
          });
          batchAdd.push(batchAddLogResults);
          batchAdd.reduce(function (previous, current) {
            return previous.then(current).catch(function (err) { /*vm.loading = false;*/ });
          }, $q.when());
        }
        else
        {
          vm.resultLog = $translate.instant("BulkUserLimitExceeded")
          Toast.showCustom($translate.instant("BulkUserLimitExceeded"));
          deferred.reject($translate.instant("BulkUserLimitExceeded"));
        }
      }).catch(function (err) {
        var deferred = $q.defer();
        // vm.loading = false;
        ExceptionHandler.show(err);
        deferred.reject(err);
      });
      

      

      function batchAddHandler(payload) {
        var deferred = $q.defer();

          Subscriber.batchAdd(payload)
            .then(function (results) {
              vm.subscribersProcessed += payload.subscribers.length;
              vm.resultLog = "Processing. Done " + vm.subscribersProcessed + " of " + subscribers.length;
              if (results.errorsList) {
                vm.errorLog = vm.errorLog.concat(results.errorsList);
                vm.subscribersNotProcessed += results.subscribersNotProcessed;
              }
              // setTimeout(function(){
                deferred.resolve();
              // }, 3000);
            })
            .catch(function (err) {
              // vm.loading = false;
              ExceptionHandler.show(err);
              deferred.reject(err);
            });
          return deferred.promise;
      }

      function batchAddLogResults() {
        // vm.loading = false;
        vm.resultLog = "Done. Not processed subscribers: " + vm.subscribersNotProcessed;
        init();

        Toast.showCustom("Adding subscribers finished");

      }

      

    }

    function isPhoneNumber(username) {
      if (username.indexOf("@") === -1) {
        return /^\d+$/.test(username);
      }
      else {
        return false;
      }
    }

    // function onAllocationChange(){
    //   vm.selectedAllocation = vm.licenses.filter(function(license){
    //     return license._id === vm.selectedAllocationId;
    //   })[0];
    //   console.log(vm.selectedAllocation);
    // }

    function onRoleChange() {
      vm.selectedRole = vm.roles.filter(function (role) {
        return role._id === vm.selectedRoleId;
      })[0];
    }

    function onApplicationListChange() {
      vm.selectedApplicationList = vm.applicationLists.filter(function (list) {
        return list._id === vm.selectedApplicationListId;
      })[0];

    }

    function onEmergencyGroupChange() {
      vm.selectedEmergencyGroup = vm.emergencyGroups.filter(function (group) {
        return group._id === vm.selectedEmergencyGroupId;
      })[0];
      vm.EmergencyGroupVal = vm.selectedEmergencyGroup ? true : false;
    }
    function onForwardGroupChange() {
      if (vm.selectedForwardGroupId != null && vm.selectedForwardGroupId != '') {
        // vm.loading = true;
        vm.selectedForwardGroup = vm.forwardGroups.filter(function (group) {
          return group._id === vm.selectedForwardGroupId;
        })[0];
        Fwrdgroup.getUserIds(vm.selectedForwardGroup._id)
          .then(function (result) {
            vm.tempsubscribers = result.map(function (subscriber) {
              return subscriber._id;
            });
            vm.selectedSubscribersForwardGroup = vm.subscribers.filter(function (member) {
              return vm.tempsubscribers.indexOf(member._id) !== -1;
            });

            vm.notSelectedSubscriberForwardGroup = vm.subscribers.filter(function (member) {
              return vm.tempsubscribers.indexOf(member._id) === -1;
            });
          })
          .catch(function (e) {
            if (e.status !== 404) {
              ExceptionHandler.show(e);
            }
            else {
              vm.selectedSubscribersForwardGroup = [];
              vm.notSelectedSubscriberForwardGroup = vm.subscribers;
            }
          })
          .finally(function () {
            // vm.loading = false;
          });
      }
      else {
        vm.selectedSubscribersForwardGroup = [];
        vm.notSelectedSubscriberForwardGroup = vm.subscribers;
      }

    }
    function downloadSampleFile(){
      const link = document.createElement('a');
      link.href = vm.hostUrl+'/assets/file/Subscriber_Import.xlsx';
      link.download = 'Subscriber_Import';
      link.target = '_blank';
      link.click();

      // var filename = "Subscriber_Import.xlsx";
      // exportToExcel(vm.exportFields, [], filename);

      // var fileName= '/assets/file/Subscriber_Import.xlsx';  
      // var data = new Blob([fileName], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      // XLSX.save(data, fileName); 
    }

    function getImportData() {
      var deferred = $q.defer();
      if (vm.resultData && (vm.resultData.filename.includes(".csv") || vm.resultData.filename.includes(".xlsx"))) {
        if (vm.resultData.filename.includes(".csv")) var csv = true;
        else var csv = false
        var headers = csv ? Object.values(vm.resultData.shift()) : Object.keys(vm.resultData[0]);

        var resultSubscribers = [];
        try {
          var groupdata = '';
          vm.resultData.map(function (parsedSubscriber) {
            var newSubscriber = {};
            headers.forEach(function (key, i) { newSubscriber[vm.importDeleteFields[key]] = parsedSubscriber[csv ? i : key] });
            if(groupdata != '')
              groupdata +=';';
            groupdata += newSubscriber.radioGroups ? newSubscriber.radioGroups : null;
            // if(groupdata <= vm.groupLimitAssignment){
              newSubscriber.phone = newSubscriber.phone.trim();
              newSubscriber.sip = newSubscriber.sip.trim();
                
              resultSubscribers.push(newSubscriber);
            // }
            // else{
            //   vm.resultLog = $translate.instant("GROUPS_API_LIMIT_ERROR")
            //   deferred.reject();
            // }
          });
          deferred.resolve(resultSubscribers);
        }
        catch (err) {
          vm.resultLog = $translate.instant("INVALID_BULK_FILE_FORMAT")
          deferred.reject();
        }
      }
      else {
        Toast.showBatchImportedFileErrorMsg();
        deferred.reject();
      }
      return deferred.promise;
    }

    function subFilter(subList, resultSubscribers){
      var deferred = $q.defer();
      var subDelData= [];
      var i=0;
      resultSubscribers.forEach(function (delD){
        subList.forEach(function (subD){
          i++;
          if(delD.phone == subD.phone_number || delD.sip == subD.sip)
          {
            subDelData.push(subD);
          }
          if(subList.length == i)
            deferred.resolve(subDelData);
        })
      });
      return deferred.promise;
    }
    vm.streamingDeleteCall = function(){
      getImportData().then(function (resultSubscribers) {
        Subscriber.getSubscriberListByOrg(vm.organizationId).then(function (subList){
          subFilter(subList, resultSubscribers).then(function (filterData){
            vm.selectedDelete = Object.assign([],filterData);
            batchDeleteAssignment()
          }).catch(function (errr){
            ExceptionHandler.show(errr);
          });
        }).catch(function (error){
          ExceptionHandler.show(error);
        })
        var deletedItem = [];
        // vm.subscribers.forEach
      }).catch(function (err){
        ExceptionHandler.show(err);
      })
    }
    function downloadDeleteSampleFile(){
      var fileHeader = ['PhoneNumber','SIP'];
      var filename = "Sample_File_For_Delete_Users.xlsx";
      var results = [];
      exportToExcel(fileHeader, results, filename);
    }
    
    function generateQrs(user){
      var deferred = $q.defer();
      setTimeout(function () {
          var userDatas={
            username: user.sip,
            password: xorEncrypt(user.password),
            server:vm.server
          }
          new QRCode(document.getElementById("qrcode-" + user._id ), {
            text: JSON.stringify(userDatas),
            width: 100,
            height: 100,
            useSVG: false,
            render: "canvas"
          });
          deferred.resolve();
      }, 100);
    }

    function exportToPDF(){
      var content = [];
      var tableRowsPerPage = 2;

      for (var i = 0; i < vm.rqUsers.length; i += 4) {
        var tableBody = [];

        for (var r = 0; r < tableRowsPerPage; r++) {
          var row = [];

          for (var c = 0; c < 2; c++) {
            var userIndex = i + r * 2 + c;
            var user = vm.rqUsers[userIndex];
            if (user) {
              var qrImg = document.querySelector('#qrcode-'+user._id+' img');
              if (qrImg && qrImg.src && qrImg.src.startsWith('data:image')) {
                row.push({
                  stack: [
                    { text: 'Name: '+user.name, alignment: 'center', margin: [0, 0, 0, 10] },
                    { image: qrImg.src, width: 230, alignment: 'center' }
                  ],
                  alignment: 'center',
                  margin: (r === 1) ? [0, 150, 0, 0] : [0, 0, 0, 0]
                });
              } else {
                row.push('');
              }
            } else {
              row.push('');
            }
          }
          tableBody.push(row);
        }

        content.push({
          table: {
            widths: ['*', '*'],
            body: tableBody
          },
          layout: 'noBorders'
        });

        if (i + 4 < vm.rqUsers.length) {
          content.push({ text: '', pageBreak: 'after' });
        }
      }

      var docDefinition = {
        content: content,
        pageOrientation: 'portrait',
        pageSize: 'A4',
        defaultStyle: {
          fontSize: 12
        }
      };

      pdfMake.createPdf(docDefinition).download(vm.organization.name+'_QR_Codes.pdf');
    }
    function generateAllQRCodes(users, callback) {
      users.forEach(function (user) {
        generateQrs(user); 
      });
      setTimeout(function () {
        callback(); 
      }, 2000);
    }
    function exportQrCodes(){
      var deferred = $q.defer();
      vm.timestamp = Date.now();
      var hexKey = vm.encryptionKeyVal;
      vm.keyBytes = [];
      for (var i = 0; i < hexKey.length; i += 2) {
        vm.keyBytes.push(parseInt(hexKey.substr(i, 2), 16));
      }
      vm.organizationId && Subscriber.getListByOrganization(vm.organizationId)
      .then(function (resp) {
          vm.rqUsers = resp;
          generateAllQRCodes(resp, function () {
            setTimeout(function () {
              exportToPDF();
            }, 2000);
          });
      })
      .catch(function (err) {
        deferred.reject(err);
      });

      return deferred.promise;
    }

    function xorEncrypt(input) {
      var encBytes = [];
      for (var j = 0; j < input.length; j++) {
        var pwdCharCode = input.charCodeAt(j);
        var keyByte = vm.keyBytes[j % vm.keyBytes.length];
        encBytes.push(pwdCharCode ^ keyByte);
      }

      var binaryString = String.fromCharCode.apply(null, encBytes);
      var base64Encoded = btoa(binaryString);

      return base64Encoded;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.applicationLists')
    .controller('ApplicationListsController',ApplicationListsController);

  /**ngInject*/
  function ApplicationListsController(Context, $mdDialog, $rootScope, localStorageService, ApplicationList, Toast, orderByFilter, ExceptionHandler, Auth, $filter, $q, $translate) {
    var vm = this;

    vm.search = '';
    vm.activeTab = 0;
    vm.organizationId = Context.getOrganizationId();
    vm.applications = {};
    vm.applications.list = [];
    vm.applications.newList = [];
    vm.applications.appChanged = false;
    vm.applicationLists = [];
    //vm.defaultList = [];
    vm.reverse = [];
    vm.showLoaderApplications = false;
    vm.showLoaderApplicationLists = false;
    vm.applicationsPaginationClass = "applicationsPaginationClass";
    vm.applicationListsPaginationClass = "applicationListsPaginationClass";
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.isRootReseller = Auth.isRootAdmin();
    vm.allowCreate = Auth.isActionAllowed('organization_resource', 'POST');
    vm.allowModify = Auth.isActionAllowed('organization_resource', 'PUT');
    vm.allowDelete = Auth.isActionAllowed('organization_resource', 'DELETE');
    if (vm.isRootReseller) {
      vm.allowCreate = true;
      vm.allowModify = true;
      vm.allowDelete = true;
    }

    vm.saveApplications = saveApplications;
    vm.addApplicationDialog = addApplicationDialog;
    vm.editApplicationDialog = editApplicationDialog;
    vm.deleteApplication = deleteApplication;
    vm.openApplicationListDialog = openApplicationListDialog;
    vm.deleteApplicationList = deleteApplicationList;
    //vm.addDefaultApplications = addDefaultApplications;
    vm.setRecordsCount = setRecordsCount;
    vm.onTabChanges = onTabChanges;
    vm.cancelApplicationChanges = cancelApplicationChanges;
    vm.sortApp = sortApp;
    vm.getSortAppClass = getSortAppClass;
    vm.getExportApplications = getExportApplications;
    vm.downloadAppSampleFile = downloadAppSampleFile;
    vm.exportType = "excel";
    vm.importAppFields = {'AppName': 'name', 'AppPackage': 'package', 'AppDescription': 'description'}
    // vm.icons = {
    //   "Dialer" : "icon-cellphone",
    //   "Contacts" : "icon-people",
    //   "Messages" : "icon-message",
    //   "Camera" : "icon-camera",
    //   "Gallery" : "icon-picture",
    //   "Settings" : "icon-cellphone-settings",
    //   "Browser" : "icon-internet-explorer",
    //   "Calculator" : "icon-calculator",
    //   "Calender" : "icon-calendar",
    //   "Email" : "icon-email",
    //   "Maps" : "icon-map",
    //   "Wifi": "icon-wifi"
    // }

    $rootScope.$on('updatedOrganizationId', function () {
      vm.organizationId = Context.getOrganizationId();
      init();
    });

    $rootScope.$on('updatedResellerId', function () {
    });

    init();

    function init(){
      // vm.showLoaderApplications = true;
      // vm.showLoaderApplicationLists = true;

      if (vm.organizationId){
        getApplicationsByOrg();
        getApplicationListsByOrg();
        //vm.defaultList = ApplicationList.getDefaultList();
      }
    }

    function getApplicationsByOrg(){
      ApplicationList.getApplicationsByOrg(vm.organizationId)
      .then(function(applications){
        vm.applications.list = (applications && applications.white_list) ? applications.white_list : [];
        vm.applications.newList = angular.copy(vm.applications.list);
        // vm.showLoaderApplications = false;
      })
      .catch(function(e){
        // vm.showLoaderApplications = false;
        if(e.status !== 404){ ExceptionHandler.show(e) }
      });
    }

    function getApplicationListsByOrg(){
      ApplicationList.getApplicationListsByOrg(vm.organizationId)
      .then(function(applicationLists){
        vm.applicationLists = applicationLists;
        // vm.showLoaderApplicationLists = false;
      })
      .catch(function(e){
        // vm.showLoaderApplicationLists = false;
        if(e.status !== 404){ ExceptionHandler.show(e) }
      });
    }
    //-------------------------------Sorting------------------------------------------------
    function sortApp(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.applications.newList = orderByFilter(vm.applications.newList,param,vm.reverse[param])
    }

    function getSortAppClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    //-------------------------------------------------------------------------------

    function saveApplications(){
      // vm.showLoaderApplications = true;
      ApplicationList.addUpdateApplications(vm.organizationId, vm.applications.newList)
      .then(function(){
        vm.applications.appChanged = false;
        vm.applications.list = angular.copy(vm.applications.newList);
        // vm.showLoaderApplications = false;
        Toast.showUpdate();
      })
      .catch(function(e){
        // vm.showLoaderApplications = false;
        if(e.status !== 404){ ExceptionHandler.show(e) }
      });
    }

    function cancelApplicationChanges(){
      vm.applications.newList = angular.copy(vm.applications.list);
      vm.applications.appChanged = false;
    }

    function addApplicationDialog(){
        $mdDialog.show({
          controller: 'ApplicationListsDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/restricted/organization/application-lists/tabs/dialogs/applications.add.dialog.html',
          parent: angular.element(document.body),
          clickOutsideToClose: false,
          locals: {
            applicationList: [],
            applications: vm.applications,
            organizationId: vm.organizationId,
            application: {},
            clone: false,
            edit: false,
            editData:true,
            action: false
          }
        })
        // .then(function () {
        //     fillSubscriberLists();
        //     Toast.showAdd();
        // })
    }

    function editApplicationDialog(application){
      $mdDialog.show({
        controller: 'ApplicationListsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/application-lists/tabs/dialogs/applications.add.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          applicationList: [],
          applications: vm.applications,
          organizationId: vm.organizationId,
          application: application,
          clone: false,
          edit: true,
          editData:true,
          action: false
        }
      })
      // .then(function () {
      //     fillSubscriberLists();
      //     Toast.showAdd();
      // })
  }

    function deleteApplication(application){
      var confirm = Toast.getMobileAppDeleteDialog();

      $mdDialog.show(confirm)
      .then(function () {
        var i = vm.applications.newList.indexOf(application);
        vm.applications.newList = vm.applications.newList.slice(0, i).concat(vm.applications.newList.slice(i+1, vm.applications.newList.length))
        vm.applications.appChanged = true;
        Toast.showApplicationRemove();
      })
      .catch(function(){
      });
    }

    function openApplicationListDialog(applicationList, clone, action) {

      if(applicationList === null){
        vm.applicationList = {
          name: null
        };
      }
      else{
        vm.applicationList = angular.copy(applicationList);
        if (clone)
          vm.applicationList.name = null;
      }
      $mdDialog.show({
        controller: 'ApplicationListsDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/organization/application-lists/tabs/dialogs/application.lists.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose:false,
        fullscreen: false,
        locals: {
          applicationList: vm.applicationList,
          applications: vm.applications,
          organizationId: vm.organizationId,
          application: {},
          clone: clone,
          edit: false,
          editData: true,
          action: action
        }
      })
      .then(function() {
        getApplicationListsByOrg();
        if (!vm.applicationList._id || clone)
          Toast.showAdd();
        else
          Toast.showUpdate();
      });
    }

    function deleteApplicationList(applicationListId){
      var confirm = Toast.getDeleteApplicationListDialog();

      $mdDialog.show(confirm)
       .then(function () {
          ApplicationList.deleteApplicationList(applicationListId)
          .then(function(){
            // vm.showLoaderApplicationLists = false;
            getApplicationListsByOrg();
            Toast.showDelete();
          })
          .catch(function(e){
            // vm.showLoaderApplicationLists = false;
            if(e.status !== 404){ ExceptionHandler.show(e) }
          });
        });
    }

    // function addDefaultApplications(){
    //   vm.defaultList.filter(function(addApp){
    //     var findApp = vm.applications.newList.filter(function(app){
    //       if (app.package == "DEFAULT" && app.name == addApp)
    //         return app;
    //     })[0]
    //     if (!findApp || findApp.length == 0)
    //       vm.applications.newList.push({name: addApp, package: "DEFAULT"});
    //   })
    //   vm.applications.appChanged = true;
    // }

    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    function onTabChanges(){
      var newTab = vm.activeTab;
      if (vm.activeTab != 0 && vm.applications.appChanged){
        vm.activeTab = 0;
        var confirm = Toast.getMoveTabsWithoutSaveApplications();

        $mdDialog.show(confirm)
        .then(function () {
          vm.applications.newList = angular.copy(vm.applications.list);
          vm.applications.appChanged = false;
          vm.activeTab = newTab;
        })
        .catch(function(){
          vm.activeTab = 0;
        });
      }
    }

    function getExportApplications() {
      var deferred = $q.defer();
      // vm.showLoader = true;
      vm.timestamp = Date.now();

      var flowFunctionsArray = [];

      formatForExportCallLogs(vm.applications.newList)
        .then(function (results) {
          if (vm.exportType == "csv")
            deferred.resolve(results);
          else {
            var fileHeader = ['AppId','AppName','AppPackage','AppVersion','AppDescription'];
            var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy", 'UTC') + "-" + vm.organizationId + "-applications.xlsx";
            exportToExcel(fileHeader, results, filename);
          }
          // vm.showLoader = false;
        })
        .catch(function (err) {
          deferred.reject(err);
          // vm.showLoader = false;
        });
      return deferred.promise;
    }
    function formatForExportCallLogs(applications) {
      var deferred = $q.defer();
      vm.exportApplications = [];

      for (var i = 0; i < applications.length; i++) {
          var exportApplication = {
            AppId: i+1,
            AppName: applications[i].name,
            AppPackage: applications[i].package,
            AppVersion: applications[i].apk ? applications[i].apk.versionCode : '',
            AppDescription: applications[i].description
          };
          vm.exportApplications.push(exportApplication);
        
      }
      deferred.resolve(vm.exportApplications);
      return deferred.promise;

    }
    function exportToExcel(xlsHeader, xlsRows, filename) {
      var createXLSLFormatObj = [];

      createXLSLFormatObj.push(xlsHeader);
      $.each(xlsRows, function (index, value) {
        var innerRowData = [];
        $.each(value, function (ind, val) {
          innerRowData.push(val);
        });
        createXLSLFormatObj.push(innerRowData);
      });

      var ws_name = "ExportSheet";

      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);

      /* Add worksheet to workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);

      /* Write workbook and Download */
      XLSX.writeFile(wb, filename);
    }
    function downloadAppSampleFile(){
      var fileHeader = ['AppName','AppPackage', 'AppDescription'];
      var filename = "Sample_File_For_Applications.xlsx";
      var results = [];
      exportToExcel(fileHeader, results, filename);
    }
    vm.streamingApplicationCall = function(){
      getImportData().then(function (resultSubscribers) {
        resultSubscribers.map(function(app){
          if(app.name != '')
          {
            var exist = vm.applications.newList.filter(function(resp){
              return (resp.package == app.package)
            })[0]
            if(!exist)
              vm.applications.newList.push(app)
          }
        });
        saveApplications();
      }).catch(function (err){
        ExceptionHandler.show(err);
      })
    }
    function getImportData() {
      var deferred = $q.defer();
      if (vm.resultData && (vm.resultData.filename.includes(".csv") || vm.resultData.filename.includes(".xlsx"))) {
        if (vm.resultData.filename.includes(".csv")) var csv = true;
        else var csv = false
        try {
          var headers = csv ? Object.values(vm.resultData.shift()) : Object.keys(vm.resultData[0]);
          var resultSubscribers = [];

          var groupdata = '';
          vm.resultData.map(function (parsedSubscriber) {
            var newSubscriber = {};
            headers.forEach(function (key, i) { newSubscriber[vm.importAppFields[key]] = parsedSubscriber[csv ? i : key] });
            if(groupdata != '')
              groupdata +=';';
            groupdata += newSubscriber.radioGroups ? newSubscriber.radioGroups : null;
            // if(groupdata <= vm.groupLimitAssignment){
              newSubscriber.name = newSubscriber.name.trim();
              newSubscriber.package = newSubscriber.package.trim();
              newSubscriber.description = newSubscriber.description.trim();
              resultSubscribers.push(newSubscriber);
          });
          deferred.resolve(resultSubscribers);
        }
        catch (err) {
          Toast.showCustom( $translate.instant("INVALID_BULK_FILE_FORMAT"))
          vm.resultLog = $translate.instant("INVALID_BULK_FILE_FORMAT")
          deferred.reject();
        }
      }
      else {
        Toast.showBatchImportedFileErrorMsg();
        deferred.reject();
      }
      return deferred.promise;
    }
  }
})();

(function () {

  angular.module('app.restricted.searchResult', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
    // State
    $stateProvider
      .state('app.restricted.searchResult', {
        url  : '/search',
        views: {
          'content@app.restricted': {
            templateUrl: 'app/main/restricted/general/searchPlatform/search.html',
            controller: 'searchPlatformController as vm'
          }
        },
        resolve: {
          SampleData: function (msApi) {
            //return msApi.resolve('sample@get');
          }
        }
      });


  }
})();


(function () {
  'use strict';

  angular.module('app.restricted.searchResult')
    .controller('searchPlatformController', searchPlatformController);


  /** @ngInject*/
  function searchPlatformController($mdDialog, Toast,$state, $q, ExceptionHandler, localStorageService, Subscriber, Organization, Group, $rootScope, Context, Auth, orderByFilter, api, Config, $timeout, License, $filter,toolbarFactory, ApplicationList) {

    var vm = this;
    vm.allowModifySubscriber = Auth.isActionAllowed('subscriber_resource','PUT');
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.search = '';
    vm.organizationId = '';
    vm.groups = [];
    vm.popupOverlayClass = "";
    vm.reverse = [];
    vm.allocations = [];
    vm.allocationsList = [];
    vm.bundleNames = [];
    vm.applicationLists = [];
    vm.showLoader = false;
    vm.subscribers =[];
    vm.loadTab = false;
    $rootScope.$$listeners.searchPlatformInit =[];

    $rootScope.$on('searchPlatformInit', function () {
      init();
    });


    vm.editSubscriber = editSubscriber;
    vm.editReseller = editReseller;
    vm.editOrganization = editOrganization;
    vm.changeActiveState = changeActiveState;

    init();


    function init(){

      Config.getFilterList().then(function(resp){
        vm.configs = resp;

      vm.changeStateHighImpact = vm.configs.filter(function(param){
        return param.name == "PROV_CHANGE_STATE_WITH_HIGH_IMPACT";
      });
      if (!vm.changeStateHighImpact || !vm.changeStateHighImpact[0].value || vm.changeStateHighImpact[0].value == "0")
        vm.allowChangeState = vm.allowModifySubscriber;
      else
        vm.allowChangeState = vm.allowModifySubscriber && Auth.isActionAllowed('organization_resource','HIMPACT');
      
        vm.showIMSI2 = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_IMSI2";
        });
        if (!vm.showIMSI2 || !vm.showIMSI2[0].value || vm.showIMSI2[0].value == "0")
          vm.showIMSI2 = false;
        else
          vm.showIMSI2 = true;
      });

      var searchText = toolbarFactory.getSearchText();
      if(searchText !== undefined && searchText.length > 0){
        // vm.loading = true;
      }
      vm.loadTab = false;
      Subscriber.getByUserId(searchText)
        .then(function(results){

          vm.subscribers = [];
          vm.loadTab = true;
          if(Auth.isOrgAdmin()){
            for(var i=0 ; i< results.length ; i++){
              if(results[i].organization_id === Context.getOrganizationId() ){
                vm.subscribers.push(results[i]);
              }

            }
          }else{
            vm.subscribers = results;
          }

        })
        .catch(function(e){
          if(e.status === 404){
            ExceptionHandler.log(e);
          }
          else{
            ExceptionHandler.show(e);
          }
        })
        .finally(function(){
          // vm.loading = false;
        });
    }

    function getGroups(organizationId){
      var deferred = $q.defer();

      organizationId && Group.getByOrgId(organizationId)
        .then(function(resp){
          vm.groups = resp;
          deferred.resolve();
        })
        .catch(function(e){
          vm.groups = [];
          deferred.resolve();
        });

      return deferred.promise;
    }

    function getOrganization(organizationId, parentResellerId){
      var deferred = $q.defer();

      Organization.getById(organizationId, parentResellerId)
      .then(function(resp){
          vm.organization = resp;
          deferred.resolve();
        })
        .catch(function(e){
          vm.organization = [];
          deferred.resolve();
        });

      return deferred.promise;
    }

    function getApplications(organizationId){
      var deferred = $q.defer();

      vm.applicationLists = [{id: null, name: "None"}]
      ApplicationList.getApplicationListsByOrg(organizationId)
      .then(function(applicationLists){
          vm.applicationLists = vm.applicationLists.concat(applicationLists);
          deferred.resolve();
        })
        .catch(function(e){
          deferred.resolve();
        });

      return deferred.promise;
    }

    function editSubscriber(subscriberId,parentResellerId,organizationId) {
      var curSubscriber = {};
      vm.popupOverlayClass = "show";
      $timeout(function(){vm.popupOverlayClass = ""},500);

      var flowFunctionsArray = [];
      flowFunctionsArray.push(getOrganization(organizationId, parentResellerId));
      // flowFunctionsArray.push(getGroups(organizationId));
      flowFunctionsArray.push(getApplications(organizationId));

       $q.all(flowFunctionsArray)
        .then(function(){
          var subscribers = [];
          // organizationId && Subscriber.getListByOrganization(organizationId)
          //   .then(function (resp) {
          //     subscribers = resp;
            organizationId && Subscriber.getById(subscriberId)
              .then(function(resp){
                angular.copy(resp, curSubscriber);
                $mdDialog.show({
                  controller: 'subscriberDialogController',
                  controllerAs: 'vm',
                  templateUrl: 'app/main/restricted/organization/subscribers/details/subscriber.dialog.html',
                  parent: angular.element(document.body),
                  clickOutsideToClose: false,
                  skipHide: true,
                  locals: {
                    subscriber: curSubscriber,
                    organization: vm.organization,
                    contacts: vm.contacts,
                    // groups: vm.groups,
                    applicationLists: vm.applicationLists,
                    // orgSubscribersList: subscribers,
                    clone: false,
                    // allocations: vm.allocations,
                    // allocationsList: vm.allocationsList,
                    configs: vm.configs,
                    activeTab: 0
                  },
                  onShowing: function(){

                  },
                  onComplete: function(){

                  }
                }).then(function (resSubscriber) {
                  vm.popupOverlayClass = "";
                  Toast.showUpdate();
                })
              })
            // })
            .catch(function(e){
              if(e.status !== 404){ ExceptionHandler.show(e) }
            });
        });

      /*License.getAllocationList(organizationId)
        .then(function(resp){
          vm.allocations = $filter('orderBy')(resp,'licenseBundle.name');
          vm.allocations = vm.allocations.filter(function(allocation){
            return allocation.availableQty > 0;
          });
          vm.allocations.map(function(allocation){
            vm.bundleNames.push(allocation.licenseBundle.name);
          });

          vm.bundleNames = vm.bundleNames.filter(onlyUnique);
          vm.allocationsList = vm.allocations;

        })
        .catch(function(e){
          ExceptionHandler.log(e);
        });*/

    }

    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }

    function changeActiveState(sub){

      sub.site = sub.primary_site_id;
      if(sub.adminrole_id === null) sub.adminrole_id = 0;

      Subscriber.update(sub)
        .then(function(resp) {
          Toast.showChange();
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        })
    }

    function editReseller(resellerId){
      Context.setResellerId(resellerId);
      $rootScope.$emit('updatedResellerIdFromSearch');
      $state.go('app.restricted.reseller-details');

    }

    function editOrganization(resellerId,orgId){
      Context.setResellerId(resellerId);
      $rootScope.$emit('updatedResellerIdFromSearch');
      
      Context.setOrganizationId(orgId);
      $rootScope.$emit('updatedOrganizationIdFromSearch');
      $state.go('app.restricted.organization-details');

    }


  }

})();

(function () {
  'use strict';
  angular.module('app.restricted.platform', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.restricted.platform', {
      url: '/platform',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/general/platform/platform.html',
          controller: 'platformController as vm'
        }
      },
      bodyClass: 'profile'
    });


    // Navigation
   /* msNavigationServiceProvider.saveItem('General.platform', {
      title: 'Search platform',
      icon: 'icon-account',
      state: 'app.restricted.platform',
      weight: 6
    });*/
  }
})();

(function(){
  'use strict';

  angular.module('app.restricted.platform')
    .controller('CustomerController', CustomerController);

  function CustomerController(){

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.dashboard', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.restricted.dashboard', {
      url: '/dashboard',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/general/dashboard/dashboard.html',
          controller: 'dashboardController as vm'
        }
      }
    });


    // Navigation
     msNavigationServiceProvider.saveItem('General.dashboard', {
     title: 'Dashboard',
     icon: 'icon-account',
     state: 'app.restricted.dashboard',
     weight: 6
     });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.dashboard')
    .controller('dashboardController', dashboardController);


  /**ngInject*/
  function dashboardController($rootScope, Context){
    var vm = this;

    if(Context.getOrganizationId()){
      vm.showResellerItems = false;
      vm.showOrganizationItems = true;
    }

    if(Context.getResellerId()){
      vm.showResellerItems = true;
      vm.showOrganizationItems = false;
    }

    $rootScope.$on('updatedResellerId', function(){
      vm.showOrganizationItems = false;
      vm.showResellerItems = true;
    });

    $rootScope.$on('updatedOrganizationId', function () {
      vm.showResellerItems = false;
      vm.showOrganizationItems = true;
    });


  }

})();

(function () {
  'use strict';
  angular.module('app.restricted.customer', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.restricted.customer', {
      url: '/customer',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/general/customer/customer.html',
          controller: 'CustomerController as vm'
        }
      },
      bodyClass: 'profile'
    });


    // Navigation
  /*  msNavigationServiceProvider.saveItem('General.customer', {
      title: 'Select Customer',
      icon: 'icon-account',
      state: 'app.restricted.customer',
      weight: 6
    });*/
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.customer')
    .controller('CustomerController', CustomerController);

  /*@ngInject*/
  function CustomerController($scope, $state) {

    var self = this;

    self.click = function (leaf) {
      if (leaf) {
        $state.go('app.restricted.organization-manager', {rootId: leaf.name})
      }

    };

    $scope.roleList1 = [
      {
        "name": "Prod",
        "id": "role1",
        "children": [
          {
            "name": "Default Reseller",
            "id": "role12", "children": [
            {
              "name": "subUser2-1",
              "id": "role121",
              "children": [
                {
                  "name": "subUser2-1-1",
                  "id": "role1211",
                  "children": [{
                    "name": "subUser2-12",
                    "id": "role1212",
                    "children": [
                      {
                        "name": "subUser2-1-12",
                        "id": "role12112",
                        "children": []
                      },
                      {
                        "name": "subUser2-1-22",
                        "id": "role12122",
                        "children": []
                      }
                    ]
                  }]
                },
                {
                  "name": "subUser2-1-2",
                  "id": "role1212",
                  "children": []
                }
              ]
            }
          ]
          },
          {
            "name": "Coop",
            "id": "role11",
            "children": []
          }
        ]
      }
    ];


  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.roles')
    .controller('RolesController', RolesController);

  /*@ngInject*/
  function RolesController($scope, api, $mdDialog, Role, Toast, ExceptionHandler, Context, Config, $rootScope, Auth, orderByFilter, localStorageService, $q, $filter, $translate) {

    var vm = this;
    vm.search = '';
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.reverse = [];
    vm.currentProvPerm = [];
    vm.downloadSelect = false;
    vm.downloadRoles = [];
    vm.selectedCount = 0;
    vm.DISPLAY_AS_CHECKBOX = "checkbox";

    vm.allowCreate = Auth.isActionAllowed('administration_resource','POST');
    vm.allowModify = Auth.isActionAllowed('administration_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('administration_resource','DELETE');


    if(Auth.isRootAdmin()){
      vm.allowCreate = true;
      vm.allowModify = true;
      vm.allowDelete = true;

    }

    // vm.newRole = {};
    vm.openPermissionsDialog = openPermissionsDialog;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    vm.getExportRoles = getExportRoles;
    vm.getExportRoleById = getExportRoleById;
    vm.downloadDeleteSampleFile = downloadDeleteSampleFile;
    vm.updateSelectedRow = updateSelectedRow;
    vm.exportType = "excel";
    vm.importRolesFields = { 'Type': 'console_type', 'SelectionType': 'type', 'Permission': 'name', 'View': 'get_access', 'Add': 'post_access', 'Modify': 'put_access', 'Delete': 'delete_access', 'BatchOperations': 'batch_access', 'HighImpact': 'himpact_access', 'Value': 'value'}

    init();
    config();

    /*********************************************************************/

    function init(){
      vm.nodeId = getNodeId();
      if(vm.nodeId){
        fillRolesList(vm.nodeId);
      }
      var LoginUser = Auth.getDecodedToken();
      vm.LoginUserRoleId = LoginUser.role;
      vm.LoginUserRole = LoginUser.perms;
      Role.getRolePermission().then(function(resp){
        vm.rolePermissions = resp;
        initCurrentProvPermsAndCheckIsAdmin();
        //isAdmin();
      });
    }

    function config(){
      Config.getFilterList().then(function(resp) {
        vm.configs = resp;
        vm.showCostPermissions = resp.filter(function(param){
          return param.name == "PROV_SHOW_COST_PERMISSIONS";
        });
        
        if (!vm.showCostPermissions || !vm.showCostPermissions[0] || vm.showCostPermissions[0].value == "0")
          vm.showCostPermissions = false;
        else{
          vm.showCostPermissions = true;
        }
        vm.showSecurityMonitoring = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_SECURITY_MONITORIG";
        });        
        if (!vm.showSecurityMonitoring || !vm.showSecurityMonitoring[0] || vm.showSecurityMonitoring[0].value == "0")
          vm.showSecurityMonitoring = false;
        else
          vm.showSecurityMonitoring = true;

        vm.audioCodecCount = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_AUDIO_CODEC";
        });        
        if (vm.audioCodecCount || vm.audioCodecCount[0])
          vm.audioCodecCount = vm.audioCodecCount[0].value;
        else
          vm.audioCodecCount = '4';

        vm.downloadLimitCount = vm.configs.filter(function(param){
          return param.name == "PROV_SHOW_ROLE_DOWNLOAD_LIMIT";
        });        
        if (vm.downloadLimitCount || vm.downloadLimitCount[0])
          vm.downloadLimitCount = vm.downloadLimitCount[0].value;
        else
          vm.downloadLimitCount = 5;
        
      });
    }

    function getNodeId(){
      var currentState = Context.getState();
      return currentState == "reseller" ?  Context.getResellerId() : Context.getOrganizationId();
    }

    $rootScope.$on('updatedResellerId', function () {
      fillRolesList(Context.getResellerId());
    });

    $rootScope.$on('updatedOrganizationId', function () {
      fillRolesList(Context.getOrganizationId());
    });

    function fillRolesList(nodeId){
      if(nodeId !=0)
      { 
        // vm.loading = true;
      }
      vm.nodeId = nodeId
      api.roles.listByOrg.query({nodeId: nodeId}, function(resp) {
        vm.rolesList = resp;
        // vm.loading = false;
      });
    }

    function initCurrentProvPermsAndCheckIsAdmin(){
      vm.currentProvPerm = [];
      vm.editIsAdmin = true;
      var numberResources = 0;
      var provResource = Object.values(vm.rolePermissions.web.topics).map(function(topic){
        return topic.resource_id;
      });
      for (var perm in vm.LoginUserRole){
        if (provResource.includes(vm.LoginUserRole[perm]._id)){
          vm.currentProvPerm[vm.LoginUserRole[perm]._id] = {};
          vm.currentProvPerm[vm.LoginUserRole[perm]._id].get_access = vm.LoginUserRole[perm].r_type.includes('GET');
          vm.currentProvPerm[vm.LoginUserRole[perm]._id].post_access = vm.LoginUserRole[perm].r_type.includes('POST');
          vm.currentProvPerm[vm.LoginUserRole[perm]._id].put_access = vm.LoginUserRole[perm].r_type.includes('PUT');
          vm.currentProvPerm[vm.LoginUserRole[perm]._id].delete_access = vm.LoginUserRole[perm].r_type.includes('DELETE');
          vm.currentProvPerm[vm.LoginUserRole[perm]._id].batch_access = vm.LoginUserRole[perm].r_type.includes('BATCH');
          vm.currentProvPerm[vm.LoginUserRole[perm]._id].patch_access = vm.LoginUserRole[perm].r_type.includes('PATCH');
          vm.currentProvPerm[vm.LoginUserRole[perm]._id].himpact_access = vm.LoginUserRole[perm].r_type.includes('HIMPACT');
        
          //isAdmin?
          numberResources ++;
          if (!vm.LoginUserRole[perm].r_type.includes("GET") || !vm.LoginUserRole[perm].r_type.includes("POST") || !vm.LoginUserRole[perm].r_type.includes("PUT") || !vm.LoginUserRole[perm].r_type.includes("PATCH") || !vm.LoginUserRole[perm].r_type.includes("DELETE") || !vm.LoginUserRole[perm].r_type.includes("BATCH") || !vm.LoginUserRole[perm].r_type.includes("HIMPACT")){
              vm.editIsAdmin = false;
          }
        }
      }
      if (numberResources !== provResource.length)
        vm.editIsAdmin = false;
    }

    // function isAdmin(){
    //   vm.editIsAdmin = true;
    //   var numberResources = 0;
    //   var provResource = vm.rolePermissions[2].topics.map(function(topic){
    //     return topic.resource_id;
    //   });
    //   for (var i = 0; i < vm.LoginUserRole.length; i++){
    //       if (provResource.includes(vm.LoginUserRole[i]._id)){
    //           numberResources ++;
    //           if (!vm.LoginUserRole[i].r_type.includes("GET") || !vm.LoginUserRole[i].r_type.includes("POST") || !vm.LoginUserRole[i].r_type.includes("PUT") || !vm.LoginUserRole[i].r_type.includes("PATCH") || !vm.LoginUserRole[i].r_type.includes("DELETE") || !vm.LoginUserRole[i].r_type.includes("BATCH") || !vm.LoginUserRole[i].r_type.includes("HIMPACT")){
    //               vm.editIsAdmin = false;
    //           }
    //       }
    //   }
    //   if (numberResources !== provResource.length)
    //     vm.editIsAdmin = false;
    // }

    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.rolesList = orderByFilter(vm.rolesList,param,vm.reverse[param])
    }

    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    vm.addNewRole = function() {
      // vm.loading = true;
      vm.newRole.orgNodeId = getNodeId();
      api.roles.newRole.save(vm.newRole,
        function(role) {
          init();
      }, function (e) {
          ExceptionHandler.show(e);
      })
       .finally(function(){
          // vm.loading = false;
       });
    };

    vm.deleteRole = function(roleId) {


      var nodeId = getNodeId();
      var confirm = Toast.getDeleteDialog();


      $mdDialog.show(confirm)
        .then(function() {
          // vm.loading = true;
          api.roles.deleteRoleByNode.delete({ id: roleId, nodeId: nodeId },
            function (resp) {
              if(resp.msg === 'Unable to delete the role. It is assigned to at least one user'){

                Toast.showDeleteFailed();
                // vm.loading = false;
              }else{
                init();
                Toast.showDelete();
                // vm.loading = false;
              }

          },
          function (e) {
            // vm.loading = false;
            if(typeof e.data.msg !== 'undefined' && e.data.msg === 'ROLE_API_DELETE_USED_ERROR') {
              Toast.showDeleteFailed();
            }
            else if(typeof e.data.msg !== 'undefined' && e.data.msg === 'ORA-06512'){
              Toast.showDeleteFailed();
            }else{
              ExceptionHandler.show(e);
            }

          }
        );
      });
    };

    function openPermissionsDialog(ev,role, clone) {

      if(role === null){
        vm.currentRole = {
          name: null,
          orgNodeId: getNodeId(),
          permissions: [],
          newRole: true
        };
      }
      else{
        if (clone==1){
          vm.currentRole = angular.copy(role);
          vm.currentRole.newRole = true;
        }
        else{
          vm.currentRole = angular.copy(role);
          vm.currentRole.newRole = false;
        }
      }

      $mdDialog.show({
        controller: 'roleDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/administration/roles/dialog/permList.tmpl.html',
        parent: angular.element(document.body),
        clickOutsideToClose:false,
        fullscreen: false,
        locals: {
          currentRole: vm.currentRole,
          currentProvPerm: vm.currentProvPerm,
          LoginUserRoleId: vm.LoginUserRoleId,
          editIsAdmin: vm.editIsAdmin,
          edit: true,
          showCostPermissions: vm.showCostPermissions,
          showSecurityMonitoring: vm.showSecurityMonitoring,
          rolePermissions: vm.rolePermissions,
          audioCodec: vm.audioCodecCount
        }
      })
      .then(function(data) {
        if(!data)
          Toast.showUpdate();
      }).finally(function(){
          init();
      });
    }

    
    function getExportRoles() {
      var deferred = $q.defer();
      // vm.showLoader = true;
      vm.timestamp = Date.now();



      vm.rolesList.forEach(function(role) {
        if(role.selected)
        {
          var wb = XLSX.utils.book_new();
          var newRoles=[];
          role.permissions.forEach(function(permission)  {
            var tempJson ={};
            if(permission.console_type  == 2){
              for (var key in permission) {
                if (permission.hasOwnProperty(key)) {
                  tempJson.Permission = permission['name'];
                  tempJson.SelectionType = 'Checkbox';
                  tempJson.Type = 'Provisioning';
                  
                  if(key == 'get_access')
                    tempJson.View = permission[key];
                  if(key == 'post_access')
                    tempJson.Add = permission[key];
                  if(key == 'put_access')
                    tempJson.Modify = permission[key] ;
                  if(key == 'delete_access')
                    tempJson.Delete = permission[key];
                  if(key == 'batch_access')
                    tempJson.BatchOperations = permission[key];
                  if(key == 'himpact_access')
                    tempJson.HighImpact = permission[key];
                }
              }
            }
            if(permission.console_type  == 3){
              for (var key in permission) {
                if (permission.hasOwnProperty(key) && permission.type == 'checkbox' && permission.get_access) {
                  if(key == 'name')
                    tempJson.Permission = permission[key];
                  if(key == 'type')
                    tempJson.SelectionType = 'Checkbox';
                  if(key == 'console_type')
                    tempJson.Type = 'Dispatcher';
                  if(key == 'get_access')
                    tempJson.Value = permission[key];
                }
                if (permission.hasOwnProperty(key) && permission.type == 'select' && permission.selected) {
                  if(key == 'name')
                    tempJson.Permission = permission[key];
                  if(key == 'type')
                    tempJson.SelectionType = 'Single';
                  if(key == 'console_type')
                    tempJson.Type = 'Dispatcher';
                  if(key == 'selected'){
                    var valname = permission[key];
                    tempJson.Value = permission.options[valname].name;
                  }
                }
                if (permission.hasOwnProperty(key) && permission.type == 'multi' && permission.selectedOptions.length > 0) {
                  if(key == 'name')
                    tempJson.Permission = permission[key]
                  if(key == 'type')
                    tempJson.SelectionType = 'Multi';
                  if(key == 'console_type')
                    tempJson.Type = 'Dispatcher';
                  if(key == 'selectedOptions'){
                    var valname = permission[key];
                    var val = '';
                    permission.selectedOptions.forEach(function(element){
                      val = val + permission.options[element].name + ', ';
                    });
                    tempJson.Value = val;
                  }
                }
              }
            }
            if(permission.console_type  == 4){
              for (var key in permission) {
                if (permission.hasOwnProperty(key) && permission.type == 'checkbox' && permission.options.bit1.active) {
                  if(key == 'name')
                    tempJson.Permission = permission[key];
                  if(key == 'type')
                    tempJson.SelectionType = 'Checkbox';
                  if(key == 'console_type')
                    tempJson.Type = 'Client';
                  if(key == 'options')
                    tempJson.Value = permission[key].bit1.active;
                }
                if (permission.hasOwnProperty(key) && permission.type == 'select' && permission.selected) {
                  if(key == 'name')
                    tempJson.Permission = permission[key];
                  if(key == 'type')
                    tempJson.SelectionType = 'Single';
                  if(key == 'console_type')
                    tempJson.Type = 'Client';
                  if(key == 'selected'){
                    var valname = permission[key];
                    tempJson.Value = permission.options[valname].name;
                  }
                }
                if (permission.hasOwnProperty(key) && permission.type == 'multi' && permission.selectedOptions.length > 0) {
                  if(key == 'name')
                    tempJson.Permission = permission[key];
                  if(key == 'type')
                    tempJson.SelectionType = 'Multi';
                  if(key == 'console_type')
                    tempJson.Type = 'Client';
                  if(key == 'selectedOptions'){
                    var valname = permission[key];
                    var val = '';
                    permission.selectedOptions.map(function(element){
                      val = val + permission.options[element].name + ', ';
                    });
                    tempJson.Value = val;
                  }
                }
              }
            }
            if(tempJson.Type)
              newRoles.push(tempJson)
          });
          var ws = XLSX.utils.json_to_sheet(newRoles);
          XLSX.utils.book_append_sheet(wb, ws, role.name.substring(0, 31));
          var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy", 'UTC') + "-" + role.name + "-Roles.xlsx";
          XLSX.writeFile(wb, filename);
        }
    });

      return deferred.promise;
    }

    function getExportRoleById(role) {
      // console.log(role)
      var deferred = $q.defer();
      // vm.showLoader = true;
      vm.timestamp = Date.now();


      var wb = XLSX.utils.book_new();

      // vm.rolesList.forEach(function(role) {
          var newRoles=[];
          role.permissions.forEach(function(permission)  {
            var tempJson ={};
            if(permission.console_type  == 2){
              for (var key in permission) {
                if (permission.hasOwnProperty(key)) {
                    tempJson.Permission = permission['name'];
                    tempJson.SelectionType = 'Checkbox';
                    tempJson.Type = 'Provisioning';
                    
                  if(key == 'get_access')
                    tempJson.View = permission[key];
                  if(key == 'post_access')
                    tempJson.Add = permission[key];
                  if(key == 'put_access')
                    tempJson.Modify = permission[key];
                  if(key == 'delete_access')
                    tempJson.Delete = permission[key];
                  if(key == 'batch_access')
                    tempJson.BatchOperations = permission[key];
                  if(key == 'himpact_access')
                    tempJson.HighImpact = permission[key];
                }
              }
            }
            if(permission.console_type  == 3){
              for (var key in permission) {
                if (permission.hasOwnProperty(key) && permission.type == 'checkbox' && permission.get_access) {
                  if(key == 'name')
                    tempJson.Permission = permission[key];
                  if(key == 'type')
                    tempJson.SelectionType = 'Checkbox';
                  if(key == 'console_type')
                    tempJson.Type = 'Dispatcher';
                  if(key == 'get_access')
                    tempJson.Value = permission[key];
                }
                if (permission.hasOwnProperty(key) && permission.type == 'select' && permission.selected) {
                  if(key == 'name')
                    tempJson.Permission = permission[key];
                  if(key == 'type')
                    tempJson.SelectionType = 'Single';
                  if(key == 'console_type')
                    tempJson.Type = 'Dispatcher';
                  if(key == 'selected'){
                    var valname = permission[key];
                    tempJson.Value = permission.options[valname].name;
                  }
                }
                if (permission.hasOwnProperty(key) && permission.type == 'multi' && permission.selectedOptions.length > 0) {
                  if(key == 'name')
                    tempJson.Permission = permission[key]
                  if(key == 'type')
                    tempJson.SelectionType = 'Multi';
                  if(key == 'console_type')
                    tempJson.Type = 'Dispatcher';
                  if(key == 'selectedOptions'){
                    var valname = permission[key];
                    var val = '';
                    permission.selectedOptions.forEach(function(element){
                      val = val + permission.options[element].name + ', ';
                    });
                    tempJson.Value = val;
                  }
                }
              }
            }
            if(permission.console_type  == 4){
              for (var key in permission) {
                if (permission.hasOwnProperty(key) && permission.type == 'checkbox' && permission.options.bit1.active) {
                  if(key == 'name')
                    tempJson.Permission = permission[key];
                  if(key == 'type')
                    tempJson.SelectionType = 'Checkbox';
                  if(key == 'console_type')
                    tempJson.Type = 'Client';
                  if(key == 'options')
                    tempJson.Value = permission[key].bit1.active;
                }
                if (permission.hasOwnProperty(key) && permission.type == 'select' && permission.selected) {
                  if(key == 'name')
                    tempJson.Permission = permission[key];
                  if(key == 'type')
                    tempJson.SelectionType = 'Single';
                  if(key == 'console_type')
                    tempJson.Type = 'Client';
                  if(key == 'selected'){
                    var valname = permission[key];
                    tempJson.Value = permission.options[valname].name;
                  }
                }
                if (permission.hasOwnProperty(key) && permission.type == 'multi' && permission.selectedOptions.length > 0) {
                  if(key == 'name')
                    tempJson.Permission = permission[key];
                  if(key == 'type')
                    tempJson.SelectionType = 'Multi';
                  if(key == 'console_type')
                    tempJson.Type = 'Client';
                  if(key == 'selectedOptions'){
                    var valname = permission[key];
                    var val = '';
                    permission.selectedOptions.map(function(element){
                      val = val + permission.options[element].name + ', ';
                    });
                    tempJson.Value = val;
                  }
                }
              }
            }
            if(tempJson.Type)
              newRoles.push(tempJson)
          });
          var ws = XLSX.utils.json_to_sheet(newRoles);
          XLSX.utils.book_append_sheet(wb, ws, role.name.substring(0, 31));
      // });
      var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy", 'UTC') + "-" + role.name + "-Role.xlsx";
       XLSX.writeFile(wb, filename);

      return deferred.promise;
    }
    function downloadDeleteSampleFile(){
      var deferred = $q.defer();
      // vm.showLoader = true;
      vm.timestamp = Date.now();


      var wb = XLSX.utils.book_new();
      // vm.rolesList.forEach(function(role) {
          var newRoles=[];
          var resourceList = Object.values(vm.rolePermissions["web"].topics);
          for(var i=0; i<= resourceList.length; i++){
            var tempJson ={};
            for (var key in resourceList[i]) {
              if (resourceList[i].hasOwnProperty(key)) {
                if(key == 'name'){                
                  tempJson.Type = 'Provisioning';
                  tempJson.SelectionType = 'Checkbox';
                  tempJson.Permission = resourceList[i][key];
                  tempJson.View = 'TRUE/ FALSE';
                  tempJson.Add = 'TRUE/ FALSE';
                  tempJson.Modify = 'TRUE/ FALSE';
                  tempJson.Delete = 'TRUE/ FALSE';
                  tempJson.BatchOperations = 'TRUE/ FALSE';
                  tempJson.HighImpact = 'TRUE/ FALSE';
                  tempJson.Value = '';
                  tempJson.Example = '';
                }
              }
            }
            if(tempJson.Type)
              newRoles.push(tempJson)
          };
          var dispatcherResList = Object.values(vm.rolePermissions["dispatcher"].topics);
          for(var i=0; i<= dispatcherResList.length; i++){
            var tempJson ={};
            for (var key in dispatcherResList[i]) {
              if(!(dispatcherResList[i].resource_id == 'radio_sessions_helper_A_resource' || dispatcherResList[i].resource_id == 'radio_sessions_helper_B_resource' || dispatcherResList[i].resource_id == 'radio_sessions_helper_C_resource'))
              {
                if (dispatcherResList[i].type == 'checkbox') {
                  if(key == 'name')
                    tempJson.Permission = dispatcherResList[i][key];
                  if(key == 'console_type')
                    tempJson.Type = 'Dispatcher';
                  
                  tempJson.Value = 'TRUE/ FALSE';
                  tempJson.SelectionType = 'Checkbox';
                }
                if (dispatcherResList[i].type == 'select') {
                  if(key == 'name')
                    tempJson.Permission = dispatcherResList[i][key];
                  if(key == 'console_type')
                    tempJson.Type = 'Dispatcher';
  
                  var disOptions = Object.values(dispatcherResList[i].options);
                  var optionList ='';
                  disOptions.forEach(function(element){
                    optionList += element.name+'/';
                  });
                  tempJson.Value = optionList;
                  tempJson.SelectionType = 'Single';
                }
                if (dispatcherResList[i].type == 'multi') {
                  if(key == 'name')
                    tempJson.Permission = dispatcherResList[i][key];
                  if(key == 'console_type')
                    tempJson.Type = 'Dispatcher';
  
                  var disOptions = Object.values(dispatcherResList[i].options);
                  var optionList ='';
                  disOptions.forEach(function(element){
                    optionList += element.name+'/';
                  });
                  tempJson.Value = optionList;
                  tempJson.SelectionType = 'Multi';
                  tempJson.Example = disOptions[0].name+','+disOptions[1].name;
                }
              }
            }
            if(tempJson.Type)
              newRoles.push(tempJson)
          };
          var mobileResList = Object.values(vm.rolePermissions["mobile"].topics);
          for(var i=0; i<= mobileResList.length; i++){
            var tempJson ={};
            for (var key in mobileResList[i]) {
              if (mobileResList[i].type == 'checkbox') {
                if(key == 'name')
                  tempJson.Permission = mobileResList[i][key];
                if(key == 'console_type')
                  tempJson.Type = 'Client';
                
                tempJson.Value = 'TRUE/ FALSE';
                tempJson.SelectionType = 'Checkbox';
              }
              if (mobileResList[i].type == 'select') {
                if(key == 'name')
                  tempJson.Permission = mobileResList[i][key];
                if(key == 'console_type')
                  tempJson.Type = 'Client';

                var disOptions = Object.values(mobileResList[i].options);
                var optionList ='';
                disOptions.forEach(function(element){
                  optionList += element.name+'/';
                });
                tempJson.Value = optionList;
                tempJson.SelectionType = 'Single';
              }
              if (mobileResList[i].type == 'multi') {
                if(key == 'name')
                  tempJson.Permission = mobileResList[i][key];
                if(key == 'console_type')
                  tempJson.Type = 'Client';

                var disOptions = Object.values(mobileResList[i].options);
                var optionList ='';
                disOptions.forEach(function(element){
                  optionList += element.name+'/';
                });
                tempJson.Value = optionList;
                tempJson.SelectionType = 'Multi';
                tempJson.Example = disOptions[0].name+','+disOptions[1].name;
              }
            }
            if(tempJson.Type)
              newRoles.push(tempJson)
          };
          var ws = XLSX.utils.json_to_sheet(newRoles);
          XLSX.utils.book_append_sheet(wb, ws, 'Add Role Name Here'.substring(0, 31));
      // });
      var filename = "Roles-Sample-File.xlsx";
       XLSX.writeFile(wb, filename);

      return deferred.promise;
    }
    vm.streamingRoleCall = function(){
      getImportData().then(function (resultSubscribers) {
        // Subscriber.getSubscriberListByOrg(vm.organizationId).then(function (subList){
          subFilter(vm.rolePermissions, resultSubscribers).then(function (filterData){
            var newRole ={
              'name':vm.roleName,
              'orgNodeId': vm.nodeId,
              'permissions': filterData
            }
            api.roles.newRole.save(newRole,function(role) {
              newRole._id = role._id;
                updateRole(newRole);
            }, function (e) {
              ExceptionHandler.show(e);
            });
            // vm.selectedDelete = Object.assign([],filterData);
            // batchDeleteAssignment()
          }).catch(function (errr){
            Toast.showCustom(errr)
            ExceptionHandler.show(errr);
          });
        // }).catch(function (error){
        //   ExceptionHandler.show(error);
        // })
        // var deletedItem = [];
        // // vm.subscribers.forEach
      }).catch(function (err){
        ExceptionHandler.show(err);
      })
    }
    function subFilter(roleList, resultSubscribers){
      var deferred = $q.defer();
      var subDelData= [];
      var i=0;
      var rowCount=0;
      resultSubscribers.forEach(function (delD){
        rowCount ++;
        var consoleType='';
        if(delD.console_type == 'Provisioning')
          consoleType = 'web'
        if(delD.console_type == 'Dispatcher')
          consoleType = 'dispatcher'
        if(delD.console_type == 'Client')
          consoleType = 'mobile'
        var resourceList = Object.values(roleList[consoleType].topics);
        resourceList.forEach(function (subD){
          if(delD.name == subD.name.trim() && delD.console_type == 'Provisioning')
          {
            i++;
            subD.get_access = (delD.get_access == 'TRUE'? true:false);
            subD.post_access = (delD.post_access == 'TRUE'? true:false);
            subD.put_access = (delD.put_access == 'TRUE'? true:false);
            subD.delete_access = (delD.delete_access == 'TRUE'? true:false);
            subD.batch_access = (delD.batch_access == 'TRUE'? true:false);
            subD.himpact_access = (delD.himpact_access == 'TRUE'? true:false);
            subDelData.push(subD);
          }
          if(delD.name == subD.name.trim() && delD.console_type == 'Dispatcher')
          {
            i++;
            if(delD.type == 'Checkbox')
            {
              subD.get_access = ((delD.value == 'TRUE')? true:false);
              subDelData.push(subD);
            }
            else if(delD.type == 'Single')
            {
              subD.selected = findKeyByName(delD.value, subD.options);
              subDelData.push(subD);              
            }
            else if(delD.type == 'Multi')
            {
              if(delD.value.indexOf(',') > -1) 
                {
                  var userData = delD.value.split(',')
                }
              else{ 
                var userData = [];
                userData.push(delD.value)
              };
              var finalValue = [];
              userData.forEach(function(element){
                if(element)
                  finalValue.push(findKeyByName(element, subD.options));
              });
              subD.selectedOptions = finalValue;
              subDelData.push(subD);
            }
          }
          if(delD.name == subD.name.trim() && delD.console_type == 'Client')
          {
            i++;
            if(delD.type == 'Checkbox')
            { 
              if(delD.value == 'TRUE')
                subD.options.bit1.active = true;
              else
                subD.options.bit1.active = false;
              
              subDelData.push(subD);
            }
            else if(delD.type == 'Single')
            {
              subD.selected = findKeyByName(delD.value, subD.options);
              subDelData.push(subD);              
            }
            else if(delD.type == 'Multi')
            {
              if(delD.value.indexOf(',') > -1) 
                {
                  var userData = delD.value.split(',')
                }
              else{ 
                var userData = [];
                userData.push(delD.value)
              };
              var finalValue = [];
              userData.forEach(function(element){
                if(element)
                  finalValue.push(findKeyByName(element, subD.options));
              });
              subD.selectedOptions = finalValue;
              subDelData.push(subD);
            }
          }         
        })
        if(resultSubscribers.length == subDelData.length)
          deferred.resolve(subDelData);
              
        if((rowCount == resultSubscribers.length) && (subDelData.length != rowCount))
          deferred.reject($translate.instant("INVALID_BULK_FILE_FORMAT"));
        
      });
      return deferred.promise;
    }
    function getImportData() {
      var deferred = $q.defer();
      if (vm.resultData && (vm.resultData.filename.includes(".xlsx"))) {
        if (vm.resultData.filename.includes(".csv")) var csv = true;
        else var csv = false
        if(vm.resultData[0])
        {
          var headers = csv ? Object.values(vm.resultData.shift()) : Object.keys(vm.resultData[0]);
          vm.roleName = vm.resultData.sheetname;
          var resultSubscribers = [];
          try {
            var groupdata = '';
            vm.resultData.map(function (parsedSubscriber) {
              var newSubscriber = {};
              headers.forEach(function (key, i) { newSubscriber[vm.importRolesFields[key]] = parsedSubscriber[csv ? i : key] });
              if(groupdata != '')
                groupdata +=';';
              groupdata += newSubscriber.radioGroups ? newSubscriber.radioGroups : null;
              // if(groupdata <= vm.groupLimitAssignment){
                newSubscriber.console_type = newSubscriber.console_type.trim();
                newSubscriber.type = newSubscriber.type.trim();
                newSubscriber.name = newSubscriber.name.trim();
                 newSubscriber.get_access = newSubscriber.get_access ? newSubscriber.get_access.trim():false;
                newSubscriber.post_access = newSubscriber.post_access ? newSubscriber.post_access.trim():false;
                newSubscriber.put_access = newSubscriber.put_access ? newSubscriber.put_access.trim():false;
                newSubscriber.delete_access = newSubscriber.delete_access ? newSubscriber.delete_access.trim():false;
                newSubscriber.batch_access = newSubscriber.batch_access ? newSubscriber.batch_access.trim():false;
                newSubscriber.himpact_access = newSubscriber.himpact_access ? newSubscriber.himpact_access.trim():false;
                newSubscriber.value = newSubscriber.value ? newSubscriber.value.trim():'';
                  
                resultSubscribers.push(newSubscriber);
              // }
              // else{
              //   vm.resultLog = $translate.instant("GROUPS_API_LIMIT_ERROR")
              //   deferred.reject();
              // }
            });
            deferred.resolve(resultSubscribers);
          }
          catch (err) {
            Toast.showCustom( $translate.instant("INVALID_BULK_FILE_FORMAT"))
            vm.resultLog = $translate.instant("INVALID_BULK_FILE_FORMAT")
            deferred.reject();
          }
        }
        else
        {
          Toast.showCustom( $translate.instant("APP_NO_RECORDS"))
          deferred.reject();
        }
      }
      else {
        Toast.showBatchImportedFileErrorMsg();
        deferred.reject();
      }
      return deferred.promise;
    }
    function findKeyByName(nameToFind, options) {
      // return Object.keys(options).find(key => options[key].name === nameToFind);
      return Object.keys(options).find(function(key) {
        return options[key].name.trim() === nameToFind.trim();
      });
    }
    function updateRole(currentRole){
      // vm.loading = true;
      if(currentRole.permissions){

        currentRole.permissions.forEach(function(perm) {
          if (perm.resource_id == "") {
            var permIndex = currentRole.permissions.indexOf(perm);
            currentRole.permissions.splice(permIndex, 1);
          }
        });

        currentRole.permissions.forEach(function(perm){

          perm.bit1 = false;
          perm.bit2 = false;
          perm.bit3 = false;
          perm.bit4 = false;
          perm.bit5 = false;
          perm.bit6 = false;
          perm.bit7 = false;
          perm.bit8 = false;
          perm.bit9 = false;
          perm.bit10 = false;
          perm.bit11 = false;
          perm.bit12 = false;
          perm.bit13 = false;
          perm.bit14 = false;
          perm.bit15 = false;
          perm.bit16 = false;

          //add Checkbox options
          if(perm.type === vm.DISPLAY_AS_CHECKBOX && perm.console_type == 4 && perm.options.bit1.active){
            perm.bit1 = true;
            vm.flagSave = true;
            return;
          }

          //Add multi-select options
          if(perm.selectedOptions){
            perm.selectedOptions.forEach(function(option){
                perm[option] = true;
            });
          }
          //Add select options
          if(perm.selected){
            perm[perm.selected] = true;
          }

          //Temporary fix for one checkbox Dispatcher topics
          if(perm.console_type === 3 &&
            (perm.resource_id === "branding_resource" ||
             perm.resource_id === "ambient_listening_resource" ||
             perm.resource_id === "show_map_resource" ||
             //perm.resource_id === "encryption_resource" ||
             perm.resource_id === "is_admin_resource" ||
             perm.resource_id === "block_user_ptt_resource" ||
             perm.resource_id === "device_info_resource")||
             perm.resource_id === "disable_modify_settings_resource"||
             perm.resource_id === "wfm_resource" || 
             perm.resource_id === "idle_time" ){
           perm.put_access = false;
           perm.patch_access = false;
          }

        });

        //Add topic to trigger polling procedure and update mobile clients
        currentRole.permissions.push({
          topic: 99,
          console_type: 4,
          resource_id: "update_mobile_clients_resource"
        });
        
        api.roles.updateRole.put({ id: currentRole._id }, { name: currentRole.name, permissions: currentRole.permissions, orgNodeId:currentRole.orgNodeId }, function (role) {
          Toast.showAdd();
          init();
        }, function (e) {
          vm.flagSave = true;
          ExceptionHandler.show(e);
        });
      }
      else{
        vm.flagSave = true;
        ExceptionHandler.show({message: "No permissions added"});
      }
      // vm.loading = false;
    }

    function updateSelectedRow(role){
      var selectedItems = vm.rolesList.filter(function(i) {
        return i.selected;
      }).length;
      if (selectedItems >= parseInt(vm.downloadLimitCount)+1) {
        role.selected = false;
      }
      vm.currentCount = selectedItems;      
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.administrators')
    .controller('AdministratorsController', AdministratorsController);

  /*@ngInject*/
  function AdministratorsController(api, $mdDialog, $filter, Config, Toast, Context, $rootScope, Auth, orderByFilter, ExceptionHandler, localStorageService, Organization, Reseller) {

    var vm = this,
      allAdmins;

    vm.search = '';
    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;
    vm.showId = localStorageService.get('showId') ? localStorageService.get('showId') : false;
    vm.reverse = [];

    vm.addAdmin = addAdmin;
    vm.editAdmin = editAdmin;
    vm.deleteUser = deleteUser;
    vm.releaseUser  = releaseUser;
    vm.blockUser = blockUser;
    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;

    vm.allowCreate = Auth.isActionAllowed('administration_resource','POST');
    vm.allowModify = Auth.isActionAllowed('administration_resource','PUT');
    vm.allowDelete = Auth.isActionAllowed('administration_resource','DELETE');

    vm.isRootAdmin = Auth.isRootAdmin();

    if(vm.isRootAdmin){
      vm.allowCreate = true;
      vm.allowModify = true;
      vm.allowDelete = true;
    }

    init();

    $rootScope.$$listeners.updatedOrganizationId =[];
    $rootScope.$$listeners.updatedResellerId =[];

    $rootScope.$on('updatedResellerId', function () {
      init();
    });

    $rootScope.$on('updatedOrganizationId', function () {
      init();
    });

    function config(currentState) {
      Config.getFilterList().then(function (resp) {
        vm.showBlockRelease = resp.filter(function(param){
          return param.name == "PROV_SHOW_BLOCK_RELEASE";
        });
        if (!vm.showBlockRelease || !vm.showBlockRelease[0].value || vm.showBlockRelease[0].value == "0")
          vm.showBlockRelease = false;
        else{
          var allowOrgNode = currentState == 'reseller' ? (Auth.isRootAdmin() ? true : (Context.getResellerId() == Auth.getUserResellerId()) ? false : true) : (Context.getOrganizationId() == Auth.getUserOrgId() ? false : true);
          vm.showBlockRelease = Auth.isActionAllowed('administration_resource','HIMPACT') && Auth.isAdministrator() && allowOrgNode;
        }
      
        vm.showChangePassword = resp.filter(function(param){
          return param.name == "PROV_SHOW_CHANGE_PASSWORD";
        });
        if (!vm.showChangePassword || !vm.showChangePassword[0].value || vm.showChangePassword[0].value == "0")
          vm.showChangePassword = false;
        else
          vm.showChangePassword = true;
      });
        
    }


    function init(){
      var currentState = Context.getState();
      if(currentState){
        if (currentState == "reseller"){
          fillAdminList(Context.getResellerId());
          getReseller();
        }
        else{
          fillAdminList(Context.getOrganizationId());
          getOrganization();
        }
        config(currentState);
      }
    }

    function fillAdminList(nodeId){
      api.admins.listByOrg.query({nodeId: nodeId},
        function (resp) {
          vm.adminsList = resp;
          allAdmins = vm.adminsList;

          if(vm.adminsList.length!=0){
            api.roles.listByOrg.query({nodeId: allAdmins[0].orgNodeId}, function(resp) {
              vm.adminRoles = resp;

              vm.adminsList.map(function(admin){
                var curRole = vm.adminRoles.filter(function(role){
                  return role._id == admin.adminRoleId;
                });
                if(curRole[0].name === undefined){
                  admin.roleName ='';
                }else{
                  admin.roleName = curRole[0].name;
                }
                admin.lastPasswordChangeTimestamp =  $filter('date')(admin.lastPasswordChangeTimestamp,'dd/MMM/yy HH:mm:ss') || "";

                // vm.showLoader = false;
              })
            })

          }

        },
        function(e){
          // vm.showLoader = false;
          ExceptionHandler.show(e);
        });
        /*.finally(function(){

        });*/
    }

    function getReseller(){
      Reseller.getById(Context.getResellerId()).then(function (resp) {
        if (resp && resp[0]){
          vm.strongAdminPassword = resp[0].strongAdministratorPass;
          vm.maxLoginRetries = Number(resp[0].max_login_retries);
        }
        else{
          vm.strongAdminPassword = 0;
          vm.maxLoginRetries = 0;
        }
      })
      .catch(function (e) {
        vm.strongAdminPassword = 0;
        vm.maxLoginRetries = 0;
      });
    }

    function getOrganization(){
      Organization.getById(Context.getOrganizationId(), Context.getLastResellerId()).then(function (resp) {
        if (resp){
          vm.strongAdminPassword = resp.strongAdministratorPass;
          vm.maxLoginRetries = Number(resp.max_login_retries);
        }
        else{
          vm.strongAdminPassword = 0;
          vm.maxLoginRetries = 0;
        }
      })
      .catch(function (e) {
        vm.strongAdminPassword = 0;
        vm.maxLoginRetries = 0;
      });
    }

    /**
     * set records count
     */
    function setRecordsCount(){
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort items list
     */
    function sort(param){
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.adminsList = orderByFilter(vm.adminsList,param,vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param){
      return vm.reverse[param] ? "up" : "down";
    }

    function deleteUser(userId) {
      var confirm = Toast.getDeleteDialog();

      $mdDialog.show(confirm)
        .then(function(){
          api.admins.deleteUser.delete({ id: userId },
            function (resp) {
              init();
              Toast.showDelete();
              // vm.showLoader = false;
            },
            function (e) {
              // vm.showLoader = false;
              ExceptionHandler.show(e);

            }

          )
      })

    }

    function releaseUser(admin) {
      var confirm = Toast.getReleaseDialog();

      $mdDialog.show(confirm)
        .then(function(){
          api.admins.releaseUser.put({ id: admin._id }, {}, function (user) {
            init();
            Toast.showRelease();
            // vm.showLoader = false;
          }, function (e) {
            // vm.showLoader = false;
            ExceptionHandler.show(e);
          });
      })

    }

    function blockUser(admin) {
      var confirm = Toast.getBlockDialog();

      $mdDialog.show(confirm)
        .then(function(){
          api.admins.blockUser.put({ id: admin._id }, {}, function (user) {
            init();
            Toast.showBlock();
            // vm.showLoader = false;
          }, function (e) {
            // vm.showLoader = false;
            ExceptionHandler.show(e);
          });
      })

    }

    function addAdmin() {
      $mdDialog.show({
        controller: 'adminDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/administration/administrators/dialog/admin.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          user: {},
          strongAdminPassword : vm.strongAdminPassword
        }
      })
        .then(function () {
          init();
          Toast.showAdd();
      })
    }

    function editAdmin(userA) {
      var curAdmin = {};

      angular.copy(userA, curAdmin);

      $mdDialog.show({
        controller: 'adminDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/restricted/administration/administrators/dialog/admin.dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        locals: {
          user: curAdmin,
          strongAdminPassword: vm.strongAdminPassword
        }
      })
        .then(function (user) {
        //angular.copy(user, userA);
          init();
         Toast.showUpdate();
      })

    }

  }
})();

(function () {
  'use strict';
  angular.module('app.restricted.activityLog', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.restricted.activityLog', {
      url: '/activityLog',
      views: {
        'content@app.restricted': {
          templateUrl: 'app/main/restricted/administration/activityLog/activityLog.html',
          controller: 'ActivityLogController as vm',
          resolve: {
            'Organizations': ['Organization', function (Organization) {
              return  Organization.getOrgAllList();
            }]

          }
        }
      },
      resolve: {
        isViewAllowed: function(Auth){
          Auth.ActionResolver('administration_resource','GET')
        }
      },
      bodyClass: 'profile'
    });

    //$translatePartialLoaderProvider.addPart('app/main/restricted/administration/roles');


    // Navigation
    msNavigationServiceProvider.saveItem('Administration.activityLog', {
      title: 'ActivityLog',
      icon: 'icon-account',
      state: 'app.restricted.activityLog',
      translate  : 'NAVIGATION_ACTIVITY_LOG',
      weight: 6
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.restricted.activityLog')
    .controller('ActivityLogController', ActivityLogController);



  /** @ngInject*/
  function ActivityLogController($q, ExceptionHandler, localStorageService, Auth, Security, $rootScope, Context, orderByFilter, $timeout, $filter, $translate, Toast, Organizations) {
    var vm = this;

    vm.recordsCount = localStorageService.get('recordsCount') ? localStorageService.get('recordsCount') : 25;

    vm.activityLogs = [];
    vm.search = '';
    vm.reverse = [];
    vm.showLoader = false;

    vm.sort = sort;
    vm.getSortingClass = getSortingClass;
    vm.setRecordsCount = setRecordsCount;
    vm.checkDate = checkDate;
    vm.getActivitiesByDates = getActivitiesByDates;
    vm.errMessage = "";
    vm.dates = {};

    vm.getExportActivityLog = getExportActivityLog;
    vm.exportTypeActivityLog = "excel";



    vm.OrganizationsList = Organizations;
    vm.resellerId = Context.getResellerId();
    vm.organizationId = Context.getOrganizationId()?Context.getOrganizationId():'NULL';
    vm.dates.startDate = new Date();
    vm.dates.endDate = new Date();
    vm.minDate = new Date('01/01/2000');
    // if (!Auth.isRootAdmin())
      getActivitiesByDates();
    vm.now = new Date();
    vm.isRootAdmin = Auth.isRootAdmin();


    $rootScope.$on('updatedOrganizationId', function () {
      vm.organizationId = Context.getOrganizationId();
      if (Auth.isRootAdmin()){
        getActivitiesByDates();
      }
    });
    
    /**
    * clear subscribers list when customer choose reseller on header menu
    */
   $rootScope.$on('updatedResellerId', function () {
    vm.organizationId = 'NULL';
    vm.resellerId = Context.getResellerId();
    if (Auth.isRootAdmin()){
      getActivitiesByDates();
    }
     // vm.filterChange(null);
   });

    
    /**
     * sort session list
     */
    function setRecordsCount() {
      localStorageService.set('recordsCount', vm.recordsCount);
    }

    /**
     * sort session list
     */
    function sort(param) {
      vm.reverse[param] ? vm.reverse[param] = false : vm.reverse[param] = true;
      vm.activityLogs = orderByFilter(vm.activityLogs, param, vm.reverse[param])
    }
    /**
     * gets css-class to show icon near column header
     */
    function getSortingClass(param) {
      return vm.reverse[param] ? "up" : "down";
    }

    function checkDate() {
      vm.errMessage = '';

      if (vm.dates && vm.dates.endDate && vm.dates.startDate && vm.dates.startDate > vm.dates.endDate) {
        vm.errMessage = $translate.instant("DATES_ERROR");//'End Date should be greater than start date';
        vm.activityLogs = [];
        return false;
      } else {
        vm.errMessage = '';
        getActivitiesByDates();
      }
    }

    function exportToExcel(xlsHeader, xlsRows, filename) {
      var createXLSLFormatObj = [];
  
      createXLSLFormatObj.push(xlsHeader);
      $.each(xlsRows, function(index, value) {
          var innerRowData = [];
          $.each(value, function(ind, val) {
  
              innerRowData.push(val);
          });
          createXLSLFormatObj.push(innerRowData);
      });

      var ws_name = "ExportSheet";
  
      var wb = XLSX.utils.book_new();
      var ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
  
      /* Add worksheet to workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);

      /* Write workbook and Download */
      XLSX.writeFile(wb, filename);
    }

    function getActivitiesByDates() {
      if(!vm.resellerId)
        vm.resellerId = Context.getLastResellerId();
      
      // console.log(vm.OrganizationsList)
      if (vm.dates && vm.dates.startDate && vm.dates.endDate) {
        if (vm.errMessage == '') {
          vm.showLoader = true;
          var startDate = $filter('date')(vm.dates.startDate, 'dd-MMM-yy');
          var endDate = $filter('date')(vm.dates.endDate, 'dd-MMM-yy');

          if (Auth.isRootAdmin()) {
            Security.getSecurityLogByOrg(vm.organizationId, startDate, endDate)
              .then(function (resp) {
                if(vm.resellerId == 2)
                {
                  vm.activityLogs = resp.results && resp.results.map(function (activity) {
                    activity.timestamp = new Date(activity.timestamp);
                    activity.org_node_name = vm.OrganizationsList[activity.org_node_id]? vm.OrganizationsList[activity.org_node_id].name: '-';
                    if (!activity.key1_type){
                      if((activity.new_value && activity.new_value.includes('Bulk')) || (activity.description && activity.description.includes('Bulk')) || (activity.key3 && activity.key3.includes('Reseller')))
                      {
                        activity.key1_type = "-";
                        activity.key1_type_deleted = true;
                      }
                      else{
                        activity.key1_type = "Deleted";
                        activity.key1_type_deleted = true;
                      }
                    }
                    if (!activity.key1_name){
                      if((activity.new_value && activity.new_value.includes('Bulk')) || (activity.description && activity.description.includes('Bulk')) || (activity.key3 && activity.key3.includes('Reseller')))
                      {
                        activity.key1_name = "-";
                        activity.key1_name_deleted = true;
                      }
                      else{
                        activity.key1_name = "Deleted";
                        activity.key1_name_deleted = true;
                      }
                    }
                    return activity;
                  });
                }
                else{
                  vm.activityLogs = resp.results && resp.results.map(function (activity) {
                    activity.timestamp = new Date(activity.timestamp);
                      activity.org_node_name = vm.OrganizationsList[activity.org_node_id]? vm.OrganizationsList[activity.org_node_id].name: 'Deleted';
                    if (!activity.key1_type){
                      if((activity.new_value && activity.new_value.includes('Bulk')) || (activity.description && activity.description.includes('Bulk')) || (activity.key3 && activity.key3.includes('Reseller')))
                      {
                        activity.key1_type = "-";
                        activity.key1_type_deleted = true;
                      }
                      else{
                        activity.key1_type = "Deleted";
                        activity.key1_type_deleted = true;
                      }
                    }
                    if (!activity.key1_name){
                      if((activity.new_value && activity.new_value.includes('Bulk')) || (activity.description && activity.description.includes('Bulk')) || (activity.key3 && activity.key3.includes('Reseller')))
                      {
                        activity.key1_name = "-";
                        activity.key1_name_deleted = true;
                      }
                      else{
                        activity.key1_name = "Deleted";
                        activity.key1_name_deleted = true;
                      }
                    }
                    if(vm.OrganizationsList[activity.org_node_id] && (vm.OrganizationsList[activity.org_node_id].resellerId == vm.resellerId))
                      return activity;
                  });
                  vm.activityLogs = vm.activityLogs.filter(function( element ) {
                    return element !== undefined;
                 });
                }

              })
              .catch(function (e) {
                if (e.status !== 404) {
                  ExceptionHandler.show(e);
                }
                else
                  vm.activityLogs = [];
              })
              .finally(function () {
                vm.showLoader = false;
              });
          }
          else {
            Security.getSecurityLogAdministrator(Auth.getUserName(), startDate, endDate)
              .then(function (resp) {
                vm.activityLogs = resp.results && resp.results.map(function (activity) {
                  activity.timestamp = new Date(activity.timestamp);
                  if (!activity.key1_type){
                    activity.key1_type = "Deleted";
                    activity.key1_type_deleted = true;
                  }
                  if (!activity.key1_name){
                    activity.key1_name = "Deleted";
                    activity.key1_name_deleted = true;
                  }
                  return activity;
                });
              })
              .catch(function (e) {
                if (e.status !== 404) {
                  ExceptionHandler.show(e);
                }
                else
                  vm.activityLogs = [];
              })
              .finally(function () {
                vm.showLoader = false;
              });
          }
        }
      } else {
        vm.errMessage = $translate.instant("DATES_BLANK_ERROR");//'Provide start date and end date';
      }

    }

    function formatForExportActivityLog(activities) {
      var deferred = $q.defer();
      vm.exportActivities = [];

      for (var i = 0; i < activities.length; i++) {
        var exportActivity = {
          timeStamp: $filter('date')(activities[i].timestamp, "dd/MMM/yyyy, HH:mm:ss"),
          user: activities[i].administrator_name,
          type: activities[i].key1_type,
          organization: activities[i].org_node_name,
          name: activities[i].key1_name,
          operation: activities[i].description,
          description: activities[i].new_value,
        };
        vm.exportActivities.push(exportActivity);
      }
      deferred.resolve(vm.exportActivities);
      return deferred.promise;

    }

    function getExportActivityLog() {
      var deferred = $q.defer();
      vm.showLoader = true;
      vm.timestamp = Date.now();
      formatForExportActivityLog(vm.activityLogs)
        .then(function (results) {
          if (vm.exportTypeActivityLog == "csv")
            deferred.resolve(results);
          else{
            var fileHeader = ['TimeStamp','User','Type','Organization','Name','Operation','Description'];
            var filename = $filter('date')(vm.timestamp, "dd-MMM-yyyy") + "-activityLog.xlsx";
            exportToExcel(fileHeader, results, filename);
          }
          vm.showLoader = false;
        })
        .catch(function (err) {
          console.log(err);
          deferred.reject(err);
          vm.showLoader = false;
        });

      return deferred.promise;
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors.error-500', {
            title : '500',
            state : 'app.pages_errors_error-500',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors', {
            title : 'Errors',
            icon  : 'icon-alert',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('pages.errors.error-404', {
            title : '404',
            state : 'app.pages_errors_error-404',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.change.password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_change_password', {
            url      : '/changePassword',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_change_password': {
                    templateUrl: 'app/main/auth/login/change-password/change.password.html',
                    controller : 'ChangePasswordController as vm'
                }
            },
            bodyClass: 'login-v2',
            params: {
                email: {
                    value: null
                },
                user_id: {
                    value: null
                }
            }
        });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/auth/login');

    }

})();

(function () {
  'use strict';

  angular
    .module('app.auth.change.password')
    .controller('ChangePasswordController', ChangePasswordController);

  /** @ngInject */
  function ChangePasswordController($state, $http, api, Auth, User, $location, localStorageService, ExceptionHandler, Toast, Config) {
    // Data
    var vm = this;
    vm.form = {};
    vm.form.email = $state.params.email;
    vm.form.user_id = $state.params.user_id;
    vm.strongPass = false;
    // Methods

    vm.changePassword = changePassword;
    vm.backToLogin = backToLogin;

    if (vm.form.email) getStrongPass()
    //////////

    function changePassword(){
      vm.showLoader = true;
      api.admins.changePassword.put({ }, {email: vm.form.email, password: vm.form.currentPassword, newPassword : vm.form.password}, function (user) {
        User.login(vm.form)
        .then(function (resp) {
          Auth.setAuthToken(resp.token);
          vm.showLoader = false;
          $state.go('app.restricted.homepage');
        }, function(resp){
          vm.form.errorMsg = resp.error;
          vm.showLoader = false;
        })
      }, function (resp) {
        vm.showLoader = false;
        vm.form.errorMsg = resp.data.error;
      });
    }

    function backToLogin(){
      $state.go('app.pages_auth_login')
    }

    function getStrongPass(){
      vm.showLoader = true;
      api.admins.strongPassword.get({email: vm.form.email},
        function (resp) {
          vm.strongPass = resp.strongPass;
          vm.showLoader = false;
        },
        function(e){
          vm.showLoader = false;
        });
    }
  }
})();

(function () {
  'use strict';

  angular.module('treeView', [])
    .component('treeView', {
      templateUrl: 'app/main/shared/treeview/treeview.html',
      controller: treeViewController,
      controllerAs: 'vm',
      bindings: {
        'treeData': '=',
        'leafSelect': '&'
      }
    });

  /** @ngInject*/
  function treeViewController() {

  }

})();

(function () {
  'use strict';

  angular.module('treeSelect', [])
    .component('treeSelect', {
      templateUrl: 'app/main/shared/tree-select/tree.select.html',
      controller: treeSelectController,
      controllerAs: 'vm',
      bindings: {
        treeData: '<',
        ngModel: '=',
        refreshFunction: '=',
        brootRefresh: '=',
        isOrgAdmin: '<',
        treeSelect: "&"
      }
    });

  /** @ngInject */
  function treeSelectController($scope, $timeout, $element,Context) {
    var vm = this;
    vm.searchTerm = "";
    this.preparedArray = [];

    $element.find('input').on('keydown', function(ev) {
      ev.stopPropagation();
    });

    this.showChildren = function (item, ev) {

      item.showChildren = !item.showChildren;
      // displayChildren(item);
      ev.stopPropagation();
    };

    vm.clearSearch = function(){
      vm.searchTerm = "";
    }

    /*
    *
    * parent - reseller item
    * */
//     function displayChildren(parent) {
//   for (var i = 0; i < vm.preparedArray.length; i++) {
//     var res = vm.preparedArray[i];
//     if (parent._id == res._id) {
//       res.children.forEach(function (child) {
//         // Control only visibility
//         child.open = parent.showChildren;

//         // If parent is collapsed, hide subtree
//         if (!parent.showChildren && child.children.length > 0) {
//           setRecursively(child, false);
//         }
//       });
//       break;
//     }
//   }
// }

// function setRecursively(node, openValue) {
//   node.open = openValue;
//   if (Array.isArray(node.children) && node.children.length > 0) {
//     node.children.forEach(function (child) {
//       setRecursively(child, openValue);
//     });
//   }
// }

    if (vm.refreshFunction) {
      vm.refreshFunction = refresh;
    }

    this.preventSearch = function (ev) {
      ev.stopPropagation();

    };

    this.triggerTreeSelect = triggerTreeSelect;

    if (vm.brootRefresh) {
      vm.brootRefresh = refresh;
    }


    refresh();

    $scope.$watchCollection(function () {
      return vm.treeData
    }, function (newValue, oldValue) {
      if(newValue !== oldValue){
        refresh();
      }

    });


    /*$scope.$watch(function () {
      return vm.ngModel;
    }, function (newValue, oldValue) {
      if (vm.changeParent && newValue !== oldValue) {
        vm.changeParent();
      }
    });*/

    function triggerTreeSelect() {
      $timeout(function () {
        vm.treeSelect();
      }, 100)
    }

    function refresh() {
      /*vm.preparedArray.map(function(el){
        el.open = true;
      });*/
      //vm.preparedArray.splice(0, vm.preparedArray.length);
      vm.preparedArray = [];
      prepareTreeValue(vm.treeData, vm.preparedArray, 1, null, {});
    }

    function prepareTreeValue(tree, preArr, lvl, parent, parentMap) {
      parent = parent || null;
      parentMap = parentMap || {};

      if (tree && tree.length) {
        angular.forEach(tree, function (item) {
          item.deepLvl = lvl;
          item.parent = parent;
          preArr.push(item);

          if (item._id) {
            parentMap[item._id] = parent;
          }

          if (lvl === 1) {
            item.showChildren = (item.showChildren !== false);
          } else {
            item.showChildren = !!item.showChildren;
          }

          var currentReseller = Context.getReseller();
          if (
            currentReseller &&
            item.parentReseller === currentReseller.parentReseller
          ) {
            openAllParents(item, parentMap);
          }

          if (item.children && item.children.length) {
            prepareTreeValue(item.children, preArr, lvl + 1, item, parentMap);
          }
        });
      }

      function openAllParents(node, parentMap) {
        var current = node;
        while (current && current._id && parentMap.hasOwnProperty(current._id)) {
          current.open = true;
          current.showChildren = true;

          if (node._id == current._id && current.deepLvl > 1) {
            current.showChildren = false;
          }

          current = parentMap[current._id];

          if (!current) break;
        }
      }
    }

    vm.isVisible = function (item) {
      var p = item.parent;
      while (p) {
        if (!p.showChildren) return false;
        p = p.parent;
      }
      return true;
    };
  }
})();

(function () {
  'use strict';

  angular.module('password-fields', [])
    .component('passwordFields', {
      templateUrl: 'app/main/shared/password-fields/password.fields.html',
      controller: passwordFields,
      controllerAs: 'vm',
      bindings: {
        "password": "=",
        "rePassword": "=",
        "formName": "=",
        "strongPass" : "<"
      }
    });


  /**ngInject*/
  function passwordFields(Config, Passwords) {
    var vm = this;

    vm.generatePass = generatePass;
    vm.typePassword = typePassword;
    vm.showPass = showPass;
    vm.showPassword = false;
    vm.showRePassword = false;

    getConfig();

    //==================================

    this.$onChanges = function(changes){
      if (changes.strongPass){
        vm.strongPassword = (!vm.usePasswordRules && !vm.strongPass) ? false : true;
        vm.pattern = Passwords.getPattern(vm.strongPassword);
      }
    };


    function getConfig(){
      Config.getFilterList().then(function(resp){
        vm.configs = resp;
        vm.usePasswordRules = vm.configs.filter(function(param){
          return param.name == "PROV_USE_PASSWORD_RULES";
        });
        if (!vm.usePasswordRules || !vm.usePasswordRules[0].value || vm.usePasswordRules[0].value == "0" || !vm.strongPass) {
          vm.usePasswordRules = false;
        }
        else{
          vm.usePasswordRules = true;
        }
        vm.strongPassword = (!vm.usePasswordRules && !vm.strongPass) ? false : true;

        vm.pattern = Passwords.getPattern(vm.strongPassword);
      });
    }

    function showPass(type, pass) {
      if (pass){
        vm.showPassword = !vm.showPassword
        var show = vm.showPassword;
      }
      else{
        vm.showRePassword = !vm.showRePassword;
        var show = vm.showRePassword;
      }  
      var passButton = document.getElementById(type);
      if (passButton.type === "password" && show) {
        passButton.type = "text";
      } else {
        passButton.type = "password";
      }

    }

    function generatePass() {
      var password = Passwords.getPassword(10);

      vm.password = password;
      vm.rePassword = password;
    }

    function typePassword() {
     // vm.rePassword = '';
      vm.formName.password.$setValidity('unequal', true);

      if(vm.password !== vm.rePassword){
        vm.formName.password.$setValidity('unequal', false);
      }

      var variations = {
        digits: /\d/.test(vm.password),
        lower: /[a-z]/.test(vm.password),
        upper: /[A-Z]/.test(vm.password),
        nonWords: /\W/.test(vm.password)
      };

      var variationCount = 0;

      for (var check in variations) {
        variationCount += (variations[check] == true) ? 1 : 0;
      }

     /* if(vm.password.length<6) vm.passwordStength = "too short";
      if(vm.password.length>=6) vm.passwordStength = "password ok";
      if(vm.password.length >=6 && variationCount > 1) vm.passwordStength = "password strong";
      console.log(vm.passwordStrength); */
    }


  }
})();

(function () {
  'use strict';

  angular.module('lefttreeSelect', [])
    .component('lefttreeSelect', {
      templateUrl: 'app/main/shared/left-tree-select/lefttree.select.html',
      controller: lefttreeSelectController,
      controllerAs: 'vm',
      bindings: {
        treeData: '<',
        ngModel: '=',
        refreshFunction: '=',
        brootRefresh: '=',
        isOrgAdmin: '<',
        treeSelect: "&"
      }
    });

  /** @ngInject */
  function lefttreeSelectController($scope, $timeout, $element,Context) {
    var vm = this;
    vm.searchTerm = "";
    this.preparedArray = [];

    $element.find('input').on('keydown', function(ev) {
      ev.stopPropagation();
    });

    this.showChildren = function (item, ev) {

      item.showChildren = !item.showChildren;
      displayChildren(item);
      ev.stopPropagation();
    };

    vm.clearSearch = function(){
      vm.searchTerm = "";
    }
    /*
    *
    * parent - reseller item
    * */
    function displayChildren(parent){
      for(var i=0; i<vm.preparedArray.length;i++){
        var res = vm.preparedArray[i];
        if (parent._id == res._id){
          res.children.map(function(child){
            child.open = parent.showChildren;
          });
          break;
        }
      }
    }

    if (vm.refreshFunction) {
      vm.refreshFunction = refresh;
    }

    this.preventSearch = function (ev) {
      ev.stopPropagation();

    };

    this.triggerTreeSelect = triggerTreeSelect;

    if (vm.brootRefresh) {
      vm.brootRefresh = refresh;
    }


    refresh();

    $scope.$watchCollection(function () {
      return vm.treeData
    }, function (newValue, oldValue) {
      if(newValue !== oldValue){
        refresh();
      }

    });


    /*$scope.$watch(function () {
      return vm.ngModel;
    }, function (newValue, oldValue) {
      if (vm.changeParent && newValue !== oldValue) {
        vm.changeParent();
      }
    });*/

    function triggerTreeSelect() {
      $timeout(function () {
        vm.treeSelect();
      }, 100)
    }

    function refresh() {
      /*vm.preparedArray.map(function(el){
        el.open = true;
      });*/
      //vm.preparedArray.splice(0, vm.preparedArray.length);
      vm.preparedArray = [];
      prepareTreeValue(vm.treeData, vm.preparedArray, 1);
    }

    //Prepare
    function prepareTreeValue(tree, preArr, lvl) {
      if (tree && tree.length) {
        angular.forEach(tree, function (item) {
          if(lvl == 1 || lvl == 2) item.open = true;
          if(item.parentReseller ==  Context.getReseller().parentReseller)
          {
            item.open = true;
          }
          item.deepLvl = lvl;
          preArr.push(item);
          if (item && item.children) {
            prepareTreeValue(item.children, preArr, lvl + 1);
          }
        });
      }
    }
  }
})();

(function () {
  'use strict';
  angular.module('choose-list-select-bind-muted', []);
})();

(function () {
  'use strict';

  angular.module('choose-list-select-bind-muted')
    .component('chooseListSelectBindMuted', {
      templateUrl: 'app/main/shared/choose-list-select-bind-muted/choose.list.select.bind.muted.html',
      controller: chooseListSelectBindMutedController,
      controllerAs: 'vm',
      bindings: {
        'selectedElements': '=',
        'notSelectedElements': '=',
        'selectedBindElements': '=',
        'notSelectedBindElements': '=',
        'paginationId': '<',
        'disallowUpdate': '<',
        'memberCountLimit': '<',
        'anotherLimit': '<',
        'interactive': '<',
        'defaultRadioGroup': '=',
        'user': '<',
        'dispatcher': '<',
        'error': '=',
        'dropDownElements': '<',
        'selectedDropDown': '<'
      }
    });

  function chooseListSelectBindMutedController(orderByFilter, Config, $mdToast, $translate) {
    var vm = this;

    this.selectItem = selectItem;
    this.unselectItem = unselectItem;
    this.selectAll = selectAll;
    this.unselectAll = unselectAll;
    this.sort = sort;

    this.$onChanges = function (changes) {
      if (changes.memberCountLimit && !changes.memberCountLimit.isFirstChange()) {
        this.memberCountLimit = changes.memberCountLimit.currentValue;
      }
      if (changes.selectedElements) {
        if (vm.selectedElements.length > vm.memberCountLimit)
          vm.error = true;
        else vm.error = false;
      }
    };

    this.$doCheck = function () {
        if (vm.selectedElements.length > vm.memberCountLimit)
          vm.error = true;
        else vm.error = false;
    };

    vm.selectedElements = [];
    vm.unselectedElements = [];
    vm.notSelectedBindElements = [];
    vm.selectedBindElements = [];
    vm.selectedReverse = false;
    vm.unselectedReverse = false;
    vm.selectedClass = "down";
    vm.unselectedClass = "down";
    vm.selectedPaginationId = vm.paginationId + "selectedBind";
    vm.unselectedPaginationId = vm.paginationId + "unselectedBind";
    vm.totalMembersCount = vm.selectedElements.length + vm.unselectedElements.length;

    if (!vm.membercountLimit && !vm.anotherLimit) getConfig();

    function getConfig() {
      Config.getFilterList().then(function (resp) {
        vm.configs = resp;
        if (vm.interactive)
          vm.memberCountLimit = "0"
        else if (vm.user) {
          vm.memberCountLimit = vm.configs.filter(function (param) {
            return param.name == "PROV_LIMIT_GR_CT_OF_USER";
          });
          vm.memberCountLimit = vm.memberCountLimit[0].value;
        }
        else {
          vm.memberCountLimit = vm.configs.filter(function (param) {
            return param.name == "PROV_LIMIT_ASSIGNMNT_GR_CT";
          });
          vm.memberCountLimit = vm.memberCountLimit[0].value;
        }

        vm.memberCountLimitDispatcher = vm.configs.filter(function (param) {
          return param.name == "PROV_LIMIT_ASSIGNMNT_PERSONAL_CONTACTS_TO_DISPATCHERS";
        });
        vm.memberCountLimitDispatcher = vm.memberCountLimitDispatcher[0].value;
      });
    }

    function sort(selected) {
      if (selected) {
        vm.selectedReverse = vm.selectedReverse ? !vm.selectedReverse : true;
        vm.selectedClass = vm.selectedReverse ? "up" : "down";
        vm.selectedElements = orderByFilter(vm.selectedElements, 'name', vm.selectedReverse);
      }
      else {
        vm.unselectedReverse = vm.unselectedReverse ? !vm.unselectedReverse : true;
        vm.unselectedClass = vm.unselectedClass ? "up" : "down";
        vm.notSelectedElements = orderByFilter(vm.notSelectedElements, 'name', vm.unselectedReverse);
      }
    }

    function selectAll() {
      var limit = vm.memberCountLimit;
      var tempuser = vm.notSelectedElements[vm.selectedDropDown].filter(function(u){ return u.isOffNet});
      var total = vm.selectedElements.length + tempuser.length;
      if (total <= parseInt(limit)) {
        vm.selectedElements = !vm.selectedElements ? [] : vm.selectedElements;
        vm.notSelectedBindElements = !vm.notSelectedBindElements ? [] : vm.notSelectedBindElements;
        vm.notSelectedElements[vm.selectedDropDown] = vm.notSelectedElements[vm.selectedDropDown].filter(function(element){
          if (element.offnet) {
            vm.selectedElements.push(element);
            if (!vm.notSelectedBindElements[element.organization_id]) vm.notSelectedBindElements[element.organization_id] = [];
            vm.notSelectedBindElements[element.organization_id].push(element);
          }
          else return element;
        })
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectAll() {
      vm.error = false;

      vm.selectedElements.map(function(element){
        if (!vm.notSelectedElements[element.organization_id]) vm.notSelectedElements[element.organization_id] = [];
        vm.notSelectedElements[element.organization_id].push(element);
      })
      vm.selectedElements = [];
      vm.notSelectedBindElements = [];
      vm.selectedBindElements = [];
    }

    function selectItem(item) {
      if (checkLimit()) {
        vm.selectedElements.push(item);
        if (!vm.notSelectedBindElements[item.organization_id]) vm.notSelectedBindElements[item.organization_id] = [];
        vm.notSelectedBindElements[item.organization_id].push(item);
        vm.notSelectedElements[vm.selectedDropDown] = vm.notSelectedElements[vm.selectedDropDown].filter(function (curItem) {
          return item._id !== curItem._id;
        });
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectItem(item) {
      if (vm.selectedElements.length-1 > vm.memberCountLimit)
        vm.error = true;
      else vm.error = false;

      if (!vm.notSelectedElements[item.organization_id]) vm.notSelectedElements[item.organization_id] = [];
      vm.notSelectedElements[item.organization_id].push(item);
      vm.selectedElements = vm.selectedElements.filter(function (curItem) {
        return item._id !== curItem._id;
      });
      vm.notSelectedBindElements[item.organization_id] = vm.notSelectedBindElements[item.organization_id].filter(function (curItem) {
        return item._id !== curItem._id;
      });
      vm.selectedBindElements = vm.selectedBindElements.filter(function (curItem) {
        return item._id !== curItem._id;
      });
    }

    function checkLimit() {
      var limit = vm.memberCountLimit
      return vm.selectedElements.length < parseInt(limit);
    }

  }
})();

(function () {
  'use strict';
  angular.module('choose-list-select', []);
})();

(function () {
  'use strict';

  angular.module('choose-list-select')
    .component('chooseListSelect', {
      templateUrl: 'app/main/shared/choose-list-select/choose.list.select.html',
      controller: chooseListSelectController,
      controllerAs: 'vm',
      bindings: {
        'selectedElements': '=',
        'notSelectedElements': '=',
        'paginationId': '<',
        'disallowUpdate': '<',
        'memberCountLimit': '<',
        'anotherLimit': '<',
        'interactive': '<',
        'defaultRadioGroup': '=',
        'user': '<',
        'dispatcher': '<',
        'error': '=',
        'dropDownElements': '<',
        'selectedDropDown': '<'
      }
    });

  function chooseListSelectController(orderByFilter, Config, $mdToast, $translate) {
    var vm = this;

    this.selectItem = selectItem;
    this.unselectItem = unselectItem;
    this.selectAll = selectAll;
    this.unselectAll = unselectAll;
    this.sort = sort;

    this.$onChanges = function (changes) {
      if (changes.memberCountLimit && !changes.memberCountLimit.isFirstChange()) {
        this.memberCountLimit = changes.memberCountLimit.currentValue;
      }
      if (changes.selectedElements) {
        if (vm.selectedElements.length > vm.memberCountLimit)
          vm.error = true;
        else vm.error = false;
      }
    };

    this.$doCheck = function () {
        if (vm.selectedElements.length > vm.memberCountLimit)
          vm.error = true;
        else vm.error = false;
    };

    vm.selectedElements = [];
    vm.unselectedElements = [];
    vm.selectedReverse = false;
    vm.unselectedReverse = false;
    vm.selectedClass = "down";
    vm.unselectedClass = "down";
    vm.selectedPaginationId = vm.paginationId + "selected";
    vm.unselectedPaginationId = vm.paginationId + "unselected";
    vm.totalMembersCount = vm.selectedElements.length + vm.unselectedElements.length;
    vm.pageCount = (vm.paginationId == 'templatesPagination'? 10:25)
    if (!vm.membercountLimit && !vm.anotherLimit) getConfig();

    function getConfig() {
      Config.getFilterList().then(function (resp) {
        vm.configs = resp;
        if (vm.interactive)
          vm.memberCountLimit = "0"
        else if (vm.user) {
          vm.memberCountLimit = vm.configs.filter(function (param) {
            return param.name == "PROV_LIMIT_GR_CT_OF_USER";
          });
          vm.memberCountLimit = vm.memberCountLimit[0].value;
        }
        else {
          vm.memberCountLimit = vm.configs.filter(function (param) {
            return param.name == "PROV_LIMIT_ASSIGNMNT_GR_CT";
          });
          vm.memberCountLimit = vm.memberCountLimit[0].value;
        }

        vm.memberCountLimitDispatcher = vm.configs.filter(function (param) {
          return param.name == "PROV_LIMIT_ASSIGNMNT_PERSONAL_CONTACTS_TO_DISPATCHERS";
        });
        vm.memberCountLimitDispatcher = vm.memberCountLimitDispatcher[0].value;
      });
    }

    function sort(selected) {
      if (selected) {
        vm.selectedReverse = vm.selectedReverse ? !vm.selectedReverse : true;
        vm.selectedClass = vm.selectedReverse ? "up" : "down";
        vm.selectedElements = orderByFilter(vm.selectedElements, 'name', vm.selectedReverse);
      }
      else {
        vm.unselectedReverse = vm.unselectedReverse ? !vm.unselectedReverse : true;
        vm.unselectedClass = vm.unselectedClass ? "up" : "down";
        vm.notSelectedElements = orderByFilter(vm.notSelectedElements, 'name', vm.unselectedReverse);
      }
    }

    function selectAll() {
      var limit = vm.memberCountLimit;
      var tempuser = vm.notSelectedElements[vm.selectedDropDown].filter(function(u){ return u.isOffNet});
      var total = vm.selectedElements.length + tempuser.length;
      if (total <= parseInt(limit)) {
        vm.selectedElements = !vm.selectedElements ? [] : vm.selectedElements;
        vm.notSelectedElements[vm.selectedDropDown] = vm.notSelectedElements[vm.selectedDropDown].filter(function(element){
          if (element && element.offnet) vm.selectedElements.push(element);
          else return element;
        })
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectAll() {
      vm.error = false;

      vm.selectedElements.map(function(element){
        if (!vm.notSelectedElements[element.organization_id]) vm.notSelectedElements[element.organization_id] = [];
        vm.notSelectedElements[element.organization_id].push(element);
      })
      vm.selectedElements = [];
    }

    function selectItem(item) {
      if (checkLimit()) {
        vm.selectedElements.push(item);
        vm.notSelectedElements[vm.selectedDropDown] = vm.notSelectedElements[vm.selectedDropDown].filter(function (curItem) {
          return (curItem && item._id !== curItem._id);
        });
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectItem(item) {

      if (vm.selectedElements.length-1 > vm.memberCountLimit)
        vm.error = true;
      else vm.error = false;

      if (!vm.notSelectedElements[item.organization_id]) vm.notSelectedElements[item.organization_id] = [];
      vm.notSelectedElements[item.organization_id].push(item);
      vm.selectedElements = vm.selectedElements.filter(function (curItem) {
        return item._id !== curItem._id;
      });
    }

    function checkLimit() {
      var limit = vm.memberCountLimit
      return vm.selectedElements.length < parseInt(limit);
    }

  }
})();

(function () {
  'use strict';
  angular.module('choose-list-mute', []);
})();

(function () {
  'use strict';

  angular.module('choose-list-mute')
    .component('chooseListMute', {
      templateUrl: 'app/main/shared/choose-list-mute/choose.list.mute.html',
      controller: chooseListMuteController,
      controllerAs: 'vm',
      bindings: {
        'selectedElements': '=',
        'notSelectedElements': '=',
        'paginationId': '<',
        'disallowUpdate': '<',
        'memberCountLimit': '<',
        'anotherLimit': '<',
        'interactive': '<',
        'defaultRadioGroup': '=',
        'user': '<',
        'dispatcher': '<',
        'error': '=',
        'subscriberGrpDetail':'<'
      }
    });

  function chooseListMuteController(orderByFilter, Config, $mdToast, $translate) {
    var vm = this;

    this.selectItem = selectItem;
    this.unselectItem = unselectItem;
    this.selectAll = selectAll;
    this.unselectAll = unselectAll;
    this.sort = sort;

    this.$onChanges = function (changes) {
      if (changes.memberCountLimit && !changes.memberCountLimit.isFirstChange()) {
        this.memberCountLimit = changes.memberCountLimit.currentValue;
      }
      if (changes.dispatcher || changes.selectedElements) {
        if ((vm.dispatcher && vm.selectedElements.length > vm.memberCountLimitDispatcher) || (!vm.dispatcher && vm.selectedElements.length > vm.memberCountLimit))
          vm.error = true;
        else vm.error = false;
      }
    };

    this.$doCheck = function () {
        if ((vm.dispatcher && vm.selectedElements.length > vm.memberCountLimitDispatcher) || (!vm.dispatcher && vm.selectedElements.length > vm.memberCountLimit))
          vm.error = true;
        else vm.error = false;
    };

    vm.selectedElements = [];
    vm.unselectedElements = [];
    vm.selectedReverse = false;
    vm.unselectedReverse = false;
    vm.selectedClass = "down";
    vm.unselectedClass = "down";
    vm.selectedPaginationId = vm.paginationId + "selected";
    vm.unselectedPaginationId = vm.paginationId + "unselected";
    vm.totalMembersCount = vm.selectedElements.length + vm.unselectedElements.length;

    if (!vm.membercountLimit && !vm.anotherLimit) getConfig();

    function getConfig() {
      Config.getFilterList().then(function (resp) {
        vm.configs = resp;
        if (vm.interactive)
          vm.memberCountLimit = "0"
        else if (vm.user) {
          vm.memberCountLimit = vm.configs.filter(function (param) {
            return param.name == "PROV_LIMIT_GR_CT_OF_USER";
          });
          vm.memberCountLimit = vm.memberCountLimit[0].value;
        }
        else {
          vm.memberCountLimit = vm.configs.filter(function (param) {
            return param.name == "PROV_LIMIT_ASSIGNMNT_GR_CT";
          });
          vm.memberCountLimit = vm.memberCountLimit[0].value;
        }

        vm.memberCountLimitDispatcher = vm.configs.filter(function (param) {
          return param.name == "PROV_LIMIT_ASSIGNMNT_PERSONAL_CONTACTS_TO_DISPATCHERS";
        });
        vm.memberCountLimitDispatcher = vm.memberCountLimitDispatcher[0].value;
      });
    }

    function sort(selected) {
      if (selected) {
        vm.selectedReverse = vm.selectedReverse ? !vm.selectedReverse : true;
        vm.selectedClass = vm.selectedReverse ? "up" : "down";
        vm.selectedElements = orderByFilter(vm.selectedElements, 'name', vm.selectedReverse);
      }
      else {
        vm.unselectedReverse = vm.unselectedReverse ? !vm.unselectedReverse : true;
        vm.unselectedClass = vm.unselectedClass ? "up" : "down";
        vm.notSelectedElements = orderByFilter(vm.notSelectedElements, 'name', vm.unselectedReverse);
      }
    }

    function selectAll() {
      var limit = (vm.dispatcher ? vm.memberCountLimitDispatcher : vm.memberCountLimit)
      var total = vm.selectedElements.length + vm.notSelectedElements.length;
      if (total <= parseInt(limit)) {
        vm.selectedElements = vm.selectedElements.concat(vm.notSelectedElements);
        vm.notSelectedElements = [];
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectAll() {
      vm.error = false;
      if (angular.isDefined(vm.defaultRadioGroup) && (vm.defaultRadioGroup != null)) {
        var defaultRG;
        var dfg;
        defaultRG = vm.selectedElements.filter(function (x) { return x._id === vm.defaultRadioGroup });
        dfg = defaultRG[0];
        var tempNon = vm.selectedElements.filter(function (ele) { return ele != dfg });
        vm.notSelectedElements = vm.notSelectedElements.concat(tempNon);
        vm.selectedElements = [];
        vm.selectedElements = vm.selectedElements.concat([dfg]);
      }
      else {
        var selected = vm.selectedElements;
        vm.selectedElements = [];
        selected.filter(function(element){
          if (element.no_icon) vm.selectedElements.push(element)
          else vm.notSelectedElements.push(element);
        })
      }
    }

    function selectItem(item) {
      console.log(vm.notSelectedElements)
      if (checkLimit()) {
        vm.selectedElements.push(item);
        vm.notSelectedElements = vm.notSelectedElements.filter(function (curItem) {
          return item._id !== curItem._id;
        });
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectItem(item) {

      if ((vm.dispatcher && vm.selectedElements.length-1 > vm.memberCountLimitDispatcher) || (!vm.dispatcher && vm.selectedElements.length-1 > vm.memberCountLimit))
        vm.error = true;
      else vm.error = false;

      vm.notSelectedElements.push(item);
      vm.selectedElements = vm.selectedElements.filter(function (curItem) {
        return item._id !== curItem._id;
      });
    }

    function checkLimit() {
      var limit = (vm.dispatcher ? vm.memberCountLimitDispatcher : vm.memberCountLimit)
      return vm.selectedElements.length < parseInt(limit);
    }

  }
})();

(function () {
  'use strict';
  angular.module('choose-list-bulk-license', []);
})();

(function () {
  'use strict';

  angular.module('choose-list-bulk-license')
    .component('chooseListBulkLicense', {
      templateUrl: 'app/main/shared/choose-list-bulk-license/choose.list.bulk.license.html',
      controller: chooseListControllerBulkLicense,
      controllerAs: 'vm',
      bindings: {
        'selectedElements': '=',
        'notSelectedElements': '=',
        'paginationId': '<',
        'disallowUpdate': '<',
        'memberCountLimit': '<',
        'anotherLimit': '<',
        'interactive': '<',
        'defaultRadioGroup': '=',
        'user': '<',
        'dispatcher': '<',
        'error': '='
      }
    });

  function chooseListControllerBulkLicense(orderByFilter, Config, $mdToast, $translate) {
    var vm = this;

    this.selectItem = selectItem;
    this.unselectItem = unselectItem;
    this.selectAll = selectAll;
    this.unselectAll = unselectAll;
    this.sort = sort;
    vm.membercountLimit =this.memberCountLimit
    this.$onChanges = function (changes) {
      if (changes.memberCountLimit && !changes.memberCountLimit.isFirstChange()) {
        this.memberCountLimit = changes.memberCountLimit.currentValue;
      }
      if (changes.dispatcher || changes.selectedElements) {
        if ((vm.dispatcher && vm.selectedElements.length > vm.memberCountLimitDispatcher) || (!vm.dispatcher && vm.selectedElements.length > vm.memberCountLimit))
          vm.error = true;
        else vm.error = false;
      }
    };

    this.$doCheck = function () {
        if ((vm.dispatcher && vm.selectedElements.length > vm.memberCountLimitDispatcher) || (!vm.dispatcher && vm.selectedElements.length > vm.memberCountLimit))
          vm.error = true;
        else vm.error = false;
    };

    vm.selectedElements = [];
    vm.unselectedElements = [];
    vm.selectedReverse = false;
    vm.unselectedReverse = false;
    vm.selectedClass = "down";
    vm.unselectedClass = "down";
    vm.selectedPaginationId = vm.paginationId + "selectedd";
    vm.unselectedPaginationId = vm.paginationId + "unselectedd";
    vm.totalMembersCount = vm.selectedElements.length + vm.unselectedElements.length;

    if(vm.notSelectedElements && !vm.membercountLimit){
      vm.membercountLimit = vm.notSelectedElements.length
    }


    function sort(selected) {
      if (selected) {
        vm.selectedReverse = vm.selectedReverse ? !vm.selectedReverse : true;
        vm.selectedClass = vm.selectedReverse ? "up" : "down";
        vm.selectedElements = orderByFilter(vm.selectedElements, 'name', vm.selectedReverse);
      }
      else {
        vm.unselectedReverse = vm.unselectedReverse ? !vm.unselectedReverse : true;
        vm.unselectedClass = vm.unselectedClass ? "up" : "down";
        vm.notSelectedElements = orderByFilter(vm.notSelectedElements, 'name', vm.unselectedReverse);
      }
    }

    function selectAll() {
      var limit = (vm.dispatcher ? vm.memberCountLimitDispatcher : vm.memberCountLimit)
      var total = vm.selectedElements.length + vm.notSelectedElements.length;
      if (total <= parseInt(limit)) {
        vm.selectedElements = vm.selectedElements.concat(vm.notSelectedElements);
        vm.notSelectedElements = [];
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectAll() {
      vm.error = false;
      if (angular.isDefined(vm.defaultRadioGroup) && (vm.defaultRadioGroup != null)) {
        var defaultRG;
        var dfg;
        defaultRG = vm.selectedElements.filter(function (x) { return x._id === vm.defaultRadioGroup });
        dfg = defaultRG[0];
        var tempNon = vm.selectedElements.filter(function (ele) { return ele != dfg });
        vm.notSelectedElements = vm.notSelectedElements.concat(tempNon);
        vm.selectedElements = [];
        vm.selectedElements = vm.selectedElements.concat([dfg]);
      }
      else {
        var selected = vm.selectedElements;
        vm.selectedElements = [];
        selected.filter(function(element){
          if (element.no_icon) vm.selectedElements.push(element)
          else vm.notSelectedElements.push(element);
        })
      }
    }

    function selectItem(item) {
      if (checkLimit()) {
        vm.selectedElements.push(item);
        vm.notSelectedElements = vm.notSelectedElements.filter(function (curItem) {
          return item._id !== curItem._id;
        });
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectItem(item) {

      if ((vm.dispatcher && vm.selectedElements.length-1 > vm.memberCountLimitDispatcher) || (!vm.dispatcher && vm.selectedElements.length-1 > vm.memberCountLimit))
        vm.error = true;
      else vm.error = false;

      vm.notSelectedElements.push(item);
      vm.selectedElements = vm.selectedElements.filter(function (curItem) {
        return item._id !== curItem._id;
      });
    }

    function checkLimit() {
      var limit = (vm.dispatcher ? vm.memberCountLimitDispatcher : vm.memberCountLimit)
      return vm.selectedElements.length < parseInt(limit);
    }

  }
})();

(function () {
  'use strict';
  angular.module('choose-list-bind-personal-group', []);
})();

(function(){
  'use strict';

  angular.module('choose-list-bind-personal-group')
    .component('chooseListBindPersonalGroup', {
      templateUrl: 'app/main/shared/choose-list-bind-personal-group/choose.list.bind.personal.group.html',
      controller: chooseListBindPersonalGroup,
      controllerAs: 'vm',
      bindings: {
        'selectedContacts' : '<',
        'unselectedContacts' : '<',
        'selectedElements': '=',
        'paginationId': '<',
        'disallowUpdate': '<',
        'memberCountLimit': '<'
      }
    });

  function chooseListBindPersonalGroup(orderByFilter, Config, $mdToast, $translate){
    var vm = this;

    this.selectItem = selectItem;
    this.unselectItem = unselectItem;
    this.selectAll = selectAll;
    this.unselectAll = unselectAll;
    this.sort = sort;
    this.onChange = onChange;
    

    this.$onChanges = function(changes){
      if (changes.selectedContacts || changes.unselectedContacts){
        onChange();
      }
      if (changes.memberCountLimit && !changes.memberCountLimit.isFirstChange()) {
        this.memberCountLimit = changes.memberCountLimit.currentValue;
      }
    };

    vm.selectedElements = [];
    vm.selectedContacts = [];
    vm.unselectedElements = [];
    vm.selectedReverse = false;
    vm.unselectedReverse = false;
    vm.selectedClass = "down";
    vm.unselectedClass = "down";
    vm.selectedPaginationId = vm.paginationId + "selectedPer";
    vm.unselectedPaginationId = vm.paginationId + "unselectedPer";
    vm.totalMembersCount = vm.selectedElements.length + vm.unselectedElements.length;

    if(!vm.membercountLimit)  getConfig();

    setPreData();

    function getConfig(){
      Config.getFilterList().then(function(resp){
        vm.configs = resp;
        vm.memberCountLimit = vm.configs.filter(function(param){
          return param.name == "PROV_LIMIT_ASSIGNMNT_GR_CT";
        });
        vm.memberCountLimit = vm.memberCountLimit[0].value;
      });
    }

    function setPreData(){
      var selectedElementsId = vm.selectedElements.map(function(element){
        return element.phone_number;
      });
      vm.selectedElements = vm.selectedContacts.filter(function (curItem){
        return selectedElementsId.indexOf(curItem.phone_number) >= 0;
      });
      vm.unselectedElements = vm.selectedContacts.filter(function (curItem){
        return selectedElementsId.indexOf(curItem.phone_number) === -1;
      });
    }

    function sort(selected){
      if(selected){
        vm.selectedReverse = vm.selectedReverse ? !vm.selectedReverse : true;
        vm.selectedClass = vm.selectedReverse ? "up" : "down";
        vm.selectedElements =  orderByFilter( vm.selectedElements,'name',vm.selectedReverse);
      }
      else{
        vm.unselectedReverse = vm.unselectedReverse ? !vm.unselectedReverse : true;
        vm.unselectedClass = vm.unselectedClass ? "up" : "down";
        vm.notSelectedElements =  orderByFilter( vm.notSelectedElements,'name',vm.unselectedReverse);
      }
    }

    function selectAll() {
      var total = vm.selectedElements.length + vm.unselectedElements.length;
      if(total <= parseInt(vm.memberCountLimit)){
        vm.selectedElements = vm.selectedElements.concat(vm.unselectedElements);
        vm.unselectedElements = [];
      }
      else{
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectAll() {
      vm.selectedElements = [];
      vm.unselectedElements = vm.selectedContacts;
    }

    function selectItem(item) {
      if(checkLimit()){
        vm.selectedElements.push(item);
        vm.unselectedElements = vm.unselectedElements.filter(function (curItem) {
          return item._id !== curItem._id;
        });
      }
      else{
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectItem(item) {
      vm.unselectedElements.push(item);
      vm.selectedElements = vm.selectedElements.filter(function (curItem) {
        return item._id !== curItem._id;
      });
    }

    function checkLimit(){
      return vm.selectedElements.length < parseInt(vm.memberCountLimit);
    }

    function onChange() {
      var selectedElementsId = vm.selectedElements.map(function(element){
        return element.phone_number;
      });
      vm.selectedElements = vm.selectedContacts.filter(function (curItem){
        return selectedElementsId.indexOf(curItem.phone_number) >= 0;
      });
      vm.unselectedElements = vm.selectedContacts.filter(function (curItem){
        return selectedElementsId.indexOf(curItem.phone_number) === -1;
      });
    }

    function onContactOrGroupChange() {
      var contactsPersonalGroupId = vm.selectedElements.map(function(contact){
        return contact.phoneNumber;
      });
      vm.selectedContacts = vm.selectedContacts.filter(function (curItem){
        return contactsPersonalGroupId.indexOf(curItem.phone_number) === -1;
      });

      var selectedContactsId = vm.selectedContacts.map(function(favorite){
        return favorite.phone_number;
      });

      var selectedFavoriteList_contacts = [];
      var selectedFavoriteList_groups = [];

      selectedFavoriteList_contacts = vm.selectedFavoriteList.filter(function (curItem){
        return selectedContactsId.indexOf(curItem.phone_number) !== -1;
      });
      selectedFavoriteList_groups = vm.selectedFavoriteList.filter(function (curItem){
        return selectedGroupsId.indexOf(curItem._id) !== -1;
      });

      vm.selectedFavoriteList = selectedFavoriteList_contacts.concat(selectedFavoriteList_groups);
    }
  }
})();

(function () {
  'use strict';
  angular.module('choose-list-bind-muted', []);
})();

(function () {
  'use strict';

  angular.module('choose-list-bind-muted')
    .component('chooseListBindMuted', {
      templateUrl: 'app/main/shared/choose-list-bind-muted/choose.list.bind.muted.html',
      controller: chooseListBindMutedController,
      controllerAs: 'vm',
      bindings: {
        'selectedElements': '=',
        'notSelectedElements': '=',
        'paginationId': '<',
        'disallowUpdate': '<',
        'memberCountLimit': '<',
        'anotherLimit': '<',
        'interactive': '<',
        'defaultRadioGroup': '=',
        'user': '<',
        'dispatcher': '<',
        'error': '=',
        'notSelectedBindElements': '=',
        'selectedBindElements': '='
      }
    });

  function chooseListBindMutedController(orderByFilter, Config, $mdToast, $translate) {
    var vm = this;

    this.selectItem = selectItem;
    this.unselectItem = unselectItem;
    this.selectAll = selectAll;
    this.unselectAll = unselectAll;
    this.sort = sort;

    this.$onChanges = function (changes) {
      if (changes.memberCountLimit ) {
        if(changes.memberCountLimit.currentValue != null)
          this.memberCountLimit = changes.memberCountLimit.currentValue;
        else
          getConfig();
      }
      if (changes.dispatcher || changes.selectedElements) {
        if ((vm.dispatcher && vm.selectedElements.length > vm.memberCountLimitDispatcher) || (!vm.dispatcher && vm.selectedElements.length > vm.memberCountLimit))
          vm.error = true;
        else vm.error = false;
      }
    };

    this.$doCheck = function () {
        if ((vm.dispatcher && vm.selectedElements.length > vm.memberCountLimitDispatcher) || (!vm.dispatcher && vm.selectedElements.length > vm.memberCountLimit))
          vm.error = true;
        else vm.error = false;
    };

    vm.selectedElements = [];
    vm.selectedBindElements = [];
    vm.notSelectedBindElements = [];
    vm.unselectedElements = [];
    vm.selectedReverse = false;
    vm.unselectedReverse = false;
    vm.selectedClass = "down";
    vm.unselectedClass = "down";
    vm.bindSelectedPaginationId = vm.paginationId + "selectedBind";
    vm.unBindselectedPaginationId = vm.paginationId + "unselectedBind";
    vm.totalMembersCount = vm.selectedElements.length + vm.unselectedElements.length;

    // if (!vm.membercountLimit && !vm.anotherLimit) getConfig();

    function getConfig() {
      Config.getFilterList().then(function (resp) {
        vm.configs = resp;
        if (vm.interactive)
          vm.memberCountLimit = "0"
        else if (vm.user) {
          vm.memberCountLimit = vm.configs.filter(function (param) {
            return param.name == "PROV_LIMIT_GR_CT_OF_USER";
          });
          vm.memberCountLimit = vm.memberCountLimit[0].value;
        }
        else {
          vm.memberCountLimit = vm.configs.filter(function (param) {
            return param.name == "PROV_LIMIT_ASSIGNMNT_GR_CT";
          });
          vm.memberCountLimit = vm.memberCountLimit[0].value;
        }

        vm.memberCountLimitDispatcher = vm.configs.filter(function (param) {
          return param.name == "PROV_LIMIT_ASSIGNMNT_PERSONAL_CONTACTS_TO_DISPATCHERS";
        });
        vm.memberCountLimitDispatcher = vm.memberCountLimitDispatcher[0].value;
      });
    }

    function sort(selected) {
      if (selected) {
        vm.selectedReverse = vm.selectedReverse ? !vm.selectedReverse : true;
        vm.selectedClass = vm.selectedReverse ? "up" : "down";
        vm.selectedElements = orderByFilter(vm.selectedElements, 'name', vm.selectedReverse);
        vm.selectedBindElements = orderByFilter(vm.selectedBindElements, 'name', vm.selectedReverse);
      }
      else {
        vm.unselectedReverse = vm.unselectedReverse ? !vm.unselectedReverse : true;
        vm.unselectedClass = vm.unselectedClass ? "up" : "down";
        vm.notSelectedElements = orderByFilter(vm.notSelectedElements, 'name', vm.unselectedReverse);
      }
    }

    function selectAll() {
      var limit = (vm.dispatcher ? vm.memberCountLimitDispatcher : vm.memberCountLimit)
      var total = vm.selectedElements.length + vm.notSelectedElements.length;
      if (total <= parseInt(limit)) {
        vm.selectedElements = vm.selectedElements.concat(vm.notSelectedElements);
        vm.selectedBindElements = vm.selectedBindElements.concat(vm.notSelectedElements);
        vm.notSelectedElements = [];
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectAll() {
      vm.error = false;
      if (angular.isDefined(vm.defaultRadioGroup) && (vm.defaultRadioGroup != null)) {
        var defaultRG;
        var dfg;
        defaultRG = vm.selectedElements.filter(function (x) { return x._id === vm.defaultRadioGroup });
        dfg = defaultRG[0];
        var tempNon = vm.notSelectedElements.filter(function (ele) { return ele != dfg });
        vm.notSelectedElements = vm.notSelectedElements.concat(tempNon);
        vm.selectedElements = [];
        vm.selectedBindElements = [];
        vm.notSelectedBindElements = [];
        vm.selectedElements = vm.selectedElements.concat([dfg]);
        vm.selectedBindElements = vm.selectedBindElements.concat([dfg]);
        vm.notSelectedBindElements = Object.assign({},vm.notSelectedElements);
      }
      else {
        var selected = vm.selectedElements;
        vm.selectedElements = [];
        vm.selectedBindElements = [];
        vm.notSelectedBindElements = [];
        selected.filter(function(element){
          if (element.no_icon){ vm.selectedElements.push(element);vm.selectedBindElements.push(element);}
          else vm.notSelectedElements.push(element);
        })
      }
    }

    function selectItem(item) {
      if (checkLimit()) {
        vm.selectedElements.push(item);
        vm.selectedBindElements.push(item);
        vm.notSelectedElements = vm.notSelectedElements.filter(function (curItem) {
          return item._id !== curItem._id;
        });
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectItem(item) {

      if ((vm.dispatcher && vm.selectedElements.length-1 > vm.memberCountLimitDispatcher) || (!vm.dispatcher && vm.selectedElements.length-1 > vm.memberCountLimit))
        vm.error = true;
      else vm.error = false;

      vm.notSelectedElements.push(item);
      vm.selectedElements = vm.selectedElements.filter(function (curItem) {
        return item._id !== curItem._id;
      });
      vm.selectedBindElements = vm.selectedBindElements.filter(function (curItem) {
        return item._id !== curItem._id;
      });
      vm.notSelectedBindElements = vm.notSelectedBindElements.filter(function (curItem) {
        return item._id !== curItem._id;
      });
    }

    function checkLimit() {
      var limit = (vm.dispatcher ? vm.memberCountLimitDispatcher : vm.memberCountLimit)
      return vm.selectedElements.length < parseInt(limit);
    }

  }
})();

(function () {
  'use strict';
  angular.module('choose-list-bind', []);
})();

(function () {
  'use strict';

  angular.module('choose-list-bind')
    .component('chooseListBind', {
      templateUrl: 'app/main/shared/choose-list-bind/choose.list.bind.html',
      controller: chooseListBindController,
      controllerAs: 'vm',
      bindings: {
        'selectedElements': '=',
        'notSelectedElements': '=',
        'selectedBindElements': '=',
        'notSelectedBindElements': '=',
        'organizationSubscriberList': '=',
        'currentId': '<',
        'paginationId': '<',
        'disallowUpdate': '<',
        'memberCountLimit': '<',
        'interactive': '<',
        'dispatcher': '<'
      }
    });

  function chooseListBindController(orderByFilter, Config, $mdToast, Subscriber, $q, $translate) {
    var vm = this;

    this.selectItem = selectItem;
    this.unselectItem = unselectItem;
    this.selectAll = selectAll;
    this.unselectAll = unselectAll;
    this.sort = sort;

    this.$onChanges = function (changes) {
      if (changes.memberCountLimit && !changes.memberCountLimit.isFirstChange()) {
        this.memberCountLimit = changes.memberCountLimit.currentValue;
      }
    };

    vm.selectedElements = [];
    vm.unselectedElements = [];
    vm.selectedReverse = false;
    vm.unselectedReverse = false;
    vm.selectedClass = "down";
    vm.unselectedClass = "down";
    vm.selectedPaginationId = vm.paginationId + "selected";
    vm.unselectedPaginationId = vm.paginationId + "unselected";
    vm.totalMembersCount = vm.selectedElements.length + vm.unselectedElements.length;

    if (!vm.membercountLimit) getConfig();

    function getConfig() {
      if (vm.interactive)
        vm.memberCountLimit = "0"
      else {
        Config.getFilterList().then(function (resp) {
          vm.configs = resp;

          vm.memberCountLimit = vm.configs.filter(function (param) {
            return param.name == "PROV_LIMIT_ASSIGNMNT_GR_CT";
          });
          vm.memberCountLimit = vm.memberCountLimit[0].value;

          vm.memberCountLimitDispatcher = vm.configs.filter(function (param) {
            return param.name == "PROV_LIMIT_ASSIGNMNT_PERSONAL_CONTACTS_TO_DISPATCHERS";
          });
          vm.memberCountLimitDispatcher = vm.memberCountLimitDispatcher[0].value;
        });
      }
    }

    function sort(selected) {
      if (selected) {
        vm.selectedReverse = vm.selectedReverse ? !vm.selectedReverse : true;
        vm.selectedClass = vm.selectedReverse ? "up" : "down";
        vm.selectedElements = orderByFilter(vm.selectedElements, 'name', vm.selectedReverse);
      }
      else {
        vm.unselectedReverse = vm.unselectedReverse ? !vm.unselectedReverse : true;
        vm.unselectedClass = vm.unselectedClass ? "up" : "down";
        vm.notSelectedElements = orderByFilter(vm.notSelectedElements, 'name', vm.unselectedReverse);
      }
    }

    function selectOneItem(item) {
      var deferred = $q.defer();
      if (checkLimit()) {
        var passLimit = false;
        var insertContacts = [];
        Subscriber.getListByGroup(item._id)
          .then(function (resp) {
            for (var i in resp) {
              if (vm.selectedBindElements.filter(function (e) { return e._id === resp[i]._id; }).length == 0) {
                if (resp[i]._id !== vm.currentId) {
                  var contact = vm.organizationSubscriberList.filter(function (c) {
                    return c._id === resp[i]._id;
                  });
                  if (contact[0]) {
                    if ((!vm.dispatcher && vm.selectedBindElements.length + insertContacts.length + 1 > parseInt(vm.memberCountLimit)) || (vm.dispatcher && vm.selectedBindElements.length + insertContacts.length + 1 > parseInt(vm.memberCountLimitDispatcher))) {
                      passLimit = true;
                      break;
                    }
                    else {
                      insertContacts.push(contact[0])
                    }
                  }
                }
              }
            }
            if (passLimit) {
              deferred.reject();
            }
            else {
              vm.selectedElements.push(item);
              vm.notSelectedElements = vm.notSelectedElements.filter(function (curItem) {
                return item._id !== curItem._id;
              });
              insertContacts.map(function (contact) {
                vm.selectedBindElements.push(contact)
                vm.notSelectedBindElements = vm.notSelectedBindElements.filter(function (curItem) {
                  return contact._id !== curItem._id;
                });
              })
              deferred.resolve();
            }
            // vm.selectedBindElements = vm.selectedBindElements.concat(resp);
          });
      }
      else deferred.reject();
      return deferred.promise;
    }

    function selectAll() {
      var total = vm.selectedElements.length + vm.notSelectedElements.length;
      if (total <= parseInt(vm.memberCountLimit)) {
        var flowFunctionsArrayGroups = [];
        vm.notSelectedElements.map(function (el) {
          flowFunctionsArrayGroups.push(selectOneItem(el));
        })
        $q.all(flowFunctionsArrayGroups)
          .then(function (a) {
          })
          .catch(function (err) {
            $mdToast.show(
              $mdToast.simple()
                .textContent($translate.instant("APP_OUT_OF_MEMBER"))
                .position("Top right")
                .hideDelay(3000)
            );
          });
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectAll() {
      vm.notSelectedElements = vm.notSelectedElements.concat(vm.selectedElements);
      vm.selectedElements = [];

      for (var el in vm.notSelectedElements) {
        Subscriber.getListByGroup(vm.notSelectedElements[el]._id)
          .then(function (resp) {
            for (var i in resp) {
              if (vm.notSelectedElements.filter(function (e) { return e._id === resp[i]._id; }).length == 0) {
                if (resp[i]._id !== vm.currentId) {
                  var contact = vm.organizationSubscriberList.filter(function (c) {
                    return c._id === resp[i]._id;
                  });
                  if (contact[0]) {
                    vm.notSelectedBindElements.push(contact[0])
                    vm.selectedBindElements = vm.selectedBindElements.filter(function (curItem) {
                      return resp[i]._id !== curItem._id;
                    });
                  }
                }
              }
            }
            // vm.selectedBindElements = vm.selectedBindElements.concat(resp);
          });
      }
    }

    function selectItem(item) {
      selectOneItem(item)
        .then(function () {
        })
        .catch(function (err) {
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant("APP_OUT_OF_MEMBER"))
              .position("Top right")
              .hideDelay(3000)
          );
        });
    }

    function unselectItem(item) {
      vm.notSelectedElements.push(item);
      vm.selectedElements = vm.selectedElements.filter(function (curItem) {
        return item._id !== curItem._id;
      });

      Subscriber.getListByGroup(item._id)
        .then(function (resp) {
          for (var i in resp) {
            if (vm.notSelectedElements.filter(function (e) { return e._id === resp[i]._id; }).length == 0) {
              if (resp[i]._id !== vm.currentId) {
                var contact = vm.organizationSubscriberList.filter(function (c) {
                  return c._id === resp[i]._id;
                });
                if (contact[0]) {
                  vm.notSelectedBindElements.push(contact[0])
                  vm.selectedBindElements = vm.selectedBindElements.filter(function (curItem) {
                    return resp[i]._id !== curItem._id;
                  });
                }
              }
            }
          }
          // vm.selectedBindElements = vm.selectedBindElements.concat(resp);
        });
    }

    function checkLimit() {
      return vm.selectedElements.length < parseInt(vm.memberCountLimit);
    }

  }
})();

(function () {
  'use strict';
  angular.module('choose-list', []);
})();

(function () {
  'use strict';

  angular.module('choose-list')
    .component('chooseList', {
      templateUrl: 'app/main/shared/choose-list/choose.list.html',
      controller: chooseListController,
      controllerAs: 'vm',
      bindings: {
        'selectedElements': '=',
        'notSelectedElements': '=',
        'paginationId': '<',
        'disallowUpdate': '<',
        'memberCountLimit': '<',
        'anotherLimit': '<',
        'interactive': '<',
        'defaultRadioGroup': '=',
        'user': '<',
        'dispatcher': '<',
        'error': '=',
        'subscriberGrpDetail':'<'
      }
    });

  function chooseListController(orderByFilter, Config, $mdToast, $translate) {
    var vm = this;

    this.selectItem = selectItem;
    this.unselectItem = unselectItem;
    this.selectAll = selectAll;
    this.unselectAll = unselectAll;
    this.sort = sort;

    this.$onChanges = function (changes) {
      if (changes.memberCountLimit && !changes.memberCountLimit.isFirstChange()) {
        this.memberCountLimit = changes.memberCountLimit.currentValue;
      }
      if (changes.dispatcher || changes.selectedElements) {
        if ((vm.dispatcher && vm.selectedElements.length > vm.memberCountLimitDispatcher) || (!vm.dispatcher && vm.selectedElements.length > vm.memberCountLimit))
          vm.error = true;
        else vm.error = false;
      }
    };

    this.$doCheck = function () {
        if ((vm.dispatcher && vm.selectedElements.length > vm.memberCountLimitDispatcher) || (!vm.dispatcher && vm.selectedElements.length > vm.memberCountLimit))
          vm.error = true;
        else vm.error = false;
    };

    vm.selectedElements = [];
    vm.unselectedElements = [];
    vm.selectedReverse = false;
    vm.unselectedReverse = false;
    vm.selectedClass = "down";
    vm.unselectedClass = "down";
    vm.selectedPaginationId = vm.paginationId + "selected";
    vm.unselectedPaginationId = vm.paginationId + "unselected";
    vm.totalMembersCount = vm.selectedElements.length + vm.unselectedElements.length;

    if (!(vm.paginationId == 'deletePagination' || vm.paginationId == 'passwordPagination' || vm.paginationId == 'smsPagination' || vm.paginationId == 'contactTemplatesPagination' || vm.paginationId == 'rolePagination') && (!vm.memberCountLimit)) getConfig();

    if((vm.paginationId == 'deletePagination' || vm.paginationId == 'passwordPagination' || vm.paginationId == 'smsPagination' || vm.paginationId == 'contactTemplatesPagination' || vm.paginationId == 'rolePagination') && vm.notSelectedElements && !vm.memberCountLimit)
     vm.memberCountLimit = vm.notSelectedElements.length

    function getConfig() {
      Config.getFilterList().then(function (resp) {
        vm.configs = resp;
        if (vm.interactive)
          vm.memberCountLimit = "0"
        else if (vm.user) {
          vm.memberCountLimit = vm.configs.filter(function (param) {
            return param.name == "PROV_LIMIT_GR_CT_OF_USER";
          });
          vm.memberCountLimit = vm.memberCountLimit[0].value;
        }
        else {
          vm.memberCountLimit = vm.configs.filter(function (param) {
            return param.name == "PROV_LIMIT_ASSIGNMNT_GR_CT";
          });
          vm.memberCountLimit = vm.memberCountLimit[0].value;
        }

        vm.memberCountLimitDispatcher = vm.configs.filter(function (param) {
          return param.name == "PROV_LIMIT_ASSIGNMNT_PERSONAL_CONTACTS_TO_DISPATCHERS";
        });
        vm.memberCountLimitDispatcher = vm.memberCountLimitDispatcher[0].value;
      });
    }

    function sort(selected) {
      if (selected) {
        vm.selectedReverse = vm.selectedReverse ? !vm.selectedReverse : true;
        vm.selectedClass = vm.selectedReverse ? "up" : "down";
        vm.selectedElements = orderByFilter(vm.selectedElements, 'name', vm.selectedReverse);
      }
      else {
        vm.unselectedReverse = vm.unselectedReverse ? !vm.unselectedReverse : true;
        vm.unselectedClass = vm.unselectedClass ? "up" : "down";
        vm.notSelectedElements = orderByFilter(vm.notSelectedElements, 'name', vm.unselectedReverse);
      }
    }

    function selectAll() {
      var limit = (vm.dispatcher ? vm.memberCountLimitDispatcher : vm.memberCountLimit)
      var total = vm.selectedElements.length + vm.notSelectedElements.length;
      if (total <= parseInt(limit)) {
        var tempNon = vm.notSelectedElements.filter(function (ele) { return !ele.no_icon });
        var tempSNon = vm.notSelectedElements.filter(function (ele) { return ele.no_icon });
        vm.selectedElements = vm.selectedElements.concat(tempNon);
        vm.notSelectedElements = Object.assign([],tempSNon);
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectAll() {
      vm.error = false;
      if (angular.isDefined(vm.defaultRadioGroup) && (vm.defaultRadioGroup != null)) {
        var defaultRG;
        var dfg;
        defaultRG = vm.selectedElements.filter(function (x) { return x._id === vm.defaultRadioGroup });
        dfg = defaultRG[0];
        var tempNon = vm.selectedElements.filter(function (ele) { return ele != dfg });
        vm.notSelectedElements = vm.notSelectedElements.concat(tempNon);
        vm.selectedElements = [];
        vm.selectedElements = vm.selectedElements.concat([dfg]);
      }
      else {
        var selected = vm.selectedElements;
        vm.selectedElements = [];
        selected.filter(function(element){
          if (element.no_icon) vm.selectedElements.push(element)
          else vm.notSelectedElements.push(element);
        })
      }
    }

    function selectItem(item) {
      if (checkLimit()) {
        vm.selectedElements.push(item);
        vm.notSelectedElements = vm.notSelectedElements.filter(function (curItem) {
          return item._id !== curItem._id;
        });
      }
      else {
        $mdToast.show(
          $mdToast.simple()
            .textContent($translate.instant("APP_OUT_OF_MEMBER"))
            .position("Top right")
            .hideDelay(3000)
        );
      }
    }

    function unselectItem(item) {

      if ((vm.dispatcher && vm.selectedElements.length-1 > vm.memberCountLimitDispatcher) || (!vm.dispatcher && vm.selectedElements.length-1 > vm.memberCountLimit))
        vm.error = true;
      else vm.error = false;

      vm.notSelectedElements.push(item);
      vm.selectedElements = vm.selectedElements.filter(function (curItem) {
        return item._id !== curItem._id;
      });
    }

    function checkLimit() {
      var limit = (vm.dispatcher ? vm.memberCountLimitDispatcher : vm.memberCountLimit)
      return vm.selectedElements.length < parseInt(limit);
    }

  }
})();

/*! angular-csv-import - v0.0.37 - 2017-05-19
* Copyright (c) 2017 ; Licensed  */
"use strict";var csvImport=angular.module("ngCsvImport",[]);csvImport.directive("ngCsvImport",function(){return{restrict:"E",transclude:!0,replace:!0,scope:{content:"=?",header:"=?",headerVisible:"=?",separator:"=?",separatorVisible:"=?",result:"=?",encoding:"=?",encodingVisible:"=?",accept:"=?",acceptSize:"=?",acceptSizeExceedCallback:"=?",callback:"=?",mdButtonClass:"@?",mdInputClass:"@?",mdButtonTitle:"@?",mdSvgIcon:"@?",uploadButtonLabel:"="},template:function(a,b){var c=angular.isDefined(b.material),d=angular.isDefined(b.multiple);return'<div class="ng-csv-import"><div ng-show="headerVisible"><div class="label">Header</div>'+(c?'<input type="checkbox" ng-model="header"></div>':'<md-switch class="ng-csv-import-header-switch" ng-model="header"></md-switch>')+'<div ng-show="encodingVisible"><div class="label">Encoding</div><span>{{encoding}}</span></div><div ng-show="separatorVisible"><div class="label">Seperator</div><span><input class="separator-input '+(c?"_md md-input":"")+' " type="text" ng-change="changeSeparator" ng-model="separator"><span></div><div><input class="btn cta gray" upload-button-label="{{uploadButtonLabel}}" type="file" '+(d?"multiple":"")+' accept="{{accept}}"/>'+(c?'<md-button ng-click="onClick($event)" class="_md md-button {{mdButtonClass}}"><md-icon md-svg-icon="{{mdSvgIcon}}"></md-icon> {{mdButtonTitle}}</md-button><md-input-container style="margin:0;"><input type="text" class="_md md-input-readable md-input {{mdInputClass}}" ng-click="onClick($event)" ng-model="filename"></md-input-container>':"")+"</div></div>"},link:function(a,b,c){if(a.separatorVisible=!!a.separatorVisible,a.headerVisible=!!a.headerVisible,a.acceptSize=a.acceptSize||Number.POSITIVE_INFINITY,a.material=angular.isDefined(c.material),a.multiple=angular.isDefined(c.multiple),a.multiple)throw new Error("Multiple attribute is not supported yet.");var d=angular.element(b[0].querySelector('input[type="file"]')),e=angular.element(b[0].querySelector("md-input-container"));if(a.material&&d){if(d.removeClass("ng-show"),d.addClass("ng-hide"),e){var f=angular.element(e[0].querySelector("div.md-errors-spacer"));f&&f.remove()}a.onClick=function(){d.click()}}angular.element(b[0].querySelector(".separator-input")).on("keyup",function(b){if(null!=a.content){var c={csv:a.content,header:a.header,separator:b.target.value,encoding:a.encoding};a.result=g(c),a.$apply(),"function"==typeof a.callback&&null!=a.callback&&a.callback(b)}}),b.on("change",function(b){if(b.target.files.length){if(b.target.files[0].size>a.acceptSize)return void("function"==typeof a.acceptSizeExceedCallback&&a.acceptSizeExceedCallback(b.target.files[0]));a.filename=b.target.files[0].name;var c=new FileReader;if(c.onload=function(c){a.$apply(function(){var d={csv:c.target.result.replace(/\r\n|\r/g,"\n"),header:a.header,separator:a.separator};a.content=d.csv,a.result=g(d),a.result.filename=a.filename,a.$$postDigest(function(){"function"==typeof a.callback&&null!=a.callback&&a.callback(b)})})},"file"!==b.target.type||null==b.target.files&&null==b.srcElement.files){if(null!=a.content){var d={csv:a.content,header:!a.header,separator:a.separator};a.result=g(d),a.$$postDigest(function(){"function"==typeof a.callback&&null!=a.callback&&a.callback(b)})}}else c.readAsText((b.srcElement||b.target).files[0],a.encoding)}});var g=function(a){var b=a.csv.split(new RegExp('\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)')),c=[],d=0,e=b[0].split(a.separator).length,f=[];a.header&&(f=b[0].split(a.separator),d=1);for(var g=d;g<b.length;g++){var i={},j=b[g].split(new RegExp(a.separator+'(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));if(j.length===e){if(a.header)for(var k=0;k<f.length;k++)i[f[k]]=h(j[k]);else for(var l=0;l<j.length;l++)i[l]=h(j[l]);c.push(i)}}return c},h=function(a){return a.replace(/^\s*|\s*$/g,"").replace(/^"|"$/g,"").replace(/""/g,'"')}}}});
/*! angular-csv-import - v0.0.37 - 2017-05-19
* Copyright (c) 2017 ; Licensed  */
'use strict';

var csvImport = angular.module('ngCsvImport', []);

csvImport.directive('ngCsvImport', function() {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    scope:{
      content:'=?',
      header: '=?',
      headerVisible: '=?',
      separator: '=?',
      separatorVisible: '=?',
      result: '=?',
      encoding: '=?',
      encodingVisible: '=?',
      accept: '=?',
      acceptSize: '=?',
      acceptSizeExceedCallback: '=?',
      callback: '=?',
      mdButtonClass: '@?',
      mdInputClass: '@?',
      mdButtonTitle: '@?',
      mdSvgIcon: '@?',
      uploadButtonLabel: '=',
      lockImportSameFile:'=?',
      disabled: '=?',
    },
    template: function(element, attrs) {
      var material = angular.isDefined(attrs.material);
      var multiple = angular.isDefined(attrs.multiple);
      return '<div class="ng-csv-import">'+
        '<div ng-show="headerVisible"><div class="label">Header</div>' +
        (material ? '<input type="checkbox" ng-model="header"></div>' :
          '<md-switch class="ng-csv-import-header-switch" ng-model="header"></md-switch>') +
        '<div ng-show="encodingVisible"><div class="label">Encoding</div><span>{{encoding}}</span></div>'+
        '<div ng-show="separatorVisible">'+
        '<div class="label">Seperator</div>'+
        '<span><input class="separator-input ' + (material ? '_md md-input' : '')  + ' " type="text" ng-change="changeSeparator" ng-model="separator"><span>'+
        '</div>'+
        '<div>' +
        '<input class="btn cta gray" upload-button-label="{{uploadButtonLabel}}" type="file" '+ (multiple ? 'multiple' : '') +' accept="{{accept}}"/>' +
        (material ? '<md-button ng-click="onClick($event)" class="_md md-button {{mdButtonClass}}" ng-disabled="{{disabled}}" translate="GENERIC_IMPORT"><md-icon md-svg-icon="{{mdSvgIcon}}"></md-icon> {{mdButtonTitle}}</md-button><md-input-container style="margin:0;"><input type="text" class="_md md-input-readable md-input {{mdInputClass}}" ng-click="onClick($event)" ng-model="filename"></md-input-container>' : '') +
        '</div>'+
        '</div>';
    },
    link: function(scope, element, attrs) {
      scope.separatorVisible = !!scope.separatorVisible;
      scope.headerVisible = !!scope.headerVisible;
      scope.acceptSize = scope.acceptSize || Number.POSITIVE_INFINITY;
      scope.material = angular.isDefined(attrs.material);
      scope.multiple = angular.isDefined(attrs.multiple);
      if (scope.multiple) {
        throw new Error("Multiple attribute is not supported yet.");
      }
      var input = angular.element(element[0].querySelector('input[type="file"]'));
      var inputContainer = angular.element(element[0].querySelector('md-input-container'));

      if (scope.material && input) {
        input.removeClass("ng-show");
        input.addClass("ng-hide");
        if (inputContainer) {
          var errorSpacer = angular.element(inputContainer[0].querySelector('div.md-errors-spacer'));
          if (errorSpacer) {
            errorSpacer.remove();
          }
        }
        scope.onClick = function() {
          input.click();
        };
      }

      angular.element(element[0].querySelector('.separator-input')).on('keyup', function(e) {
        if ( scope.content != null ) {
          var content = {
            csv: scope.content,
            header: scope.header,
            separator: e.target.value,
            encoding: scope.encoding
          };
          scope.result = csvToJSON(content);
          scope.$apply();
          if ( typeof scope.callback === 'function' ) {
            if ( scope.callback != null) {
              scope.callback(e);
            }
          }
        }
      });

      element.on('change', function(onChangeEvent) {
        if (!onChangeEvent.target.files.length){
          return;
        }

        if (onChangeEvent.target.files[0].size > scope.acceptSize){
          if ( typeof scope.acceptSizeExceedCallback === 'function' ) {
            scope.acceptSizeExceedCallback(onChangeEvent.target.files[0]);
          }
          return;
        }

        scope.filename = onChangeEvent.target.files[0].name;
        var reader = new FileReader();
        reader.onload = function(onLoadEvent) {
          scope.$apply(function() {
            if (scope.filename.substring(scope.filename.lastIndexOf('.')) == ".csv"){
              var content = {
                csv: onLoadEvent.target.result.replace(/\r\n|\r/g,'\n'),
                header: scope.header,
                separator: scope.separator
              };
              scope.content = content.csv;
              scope.result = csvToJSON(content);
              scope.result.filename = scope.filename;
            }
            else{
              var data = new Uint8Array(onLoadEvent.target.result);
              var workbook = XLSX.read(data, {type: 'array'});
              var firstSheet = workbook.SheetNames[0];
              var sheet = workbook.Sheets[firstSheet];
              var jsonData = XLSX.utils.sheet_to_json(sheet, {defval:""});
              scope.content = jsonData;
              scope.result = jsonData;
              scope.result.filename = scope.filename;
              scope.result.sheetname = firstSheet;
            }

            scope.$$postDigest(function(){
              if ( typeof scope.callback === 'function' ) {
                if ( scope.callback != null) {
                  scope.callback(onChangeEvent);
                }
              }
            });
          });
        };

        if ( (onChangeEvent.target.type === "file") && (onChangeEvent.target.files != null || onChangeEvent.srcElement.files != null) )  {
          var file = (onChangeEvent.srcElement || onChangeEvent.target).files[0];
          if (file.name.substring(file.name.lastIndexOf('.')) == ".csv")
            reader.readAsText(file, scope.encoding);
          else
            reader.readAsArrayBuffer(file);
          } else {
          if ( scope.content != null ) {
            var content = {
              csv: scope.content,
              header: !scope.header,
              separator: scope.separator
            };
            scope.result = csvToJSON(content);
            scope.$$postDigest(function(){
              if ( typeof scope.callback === 'function' ) {
                if ( scope.callback != null) {
                  scope.callback(onChangeEvent);
                }
              }
            });
          }
        }

        if(!scope.lockImportSameFile){
          angular.element(document).find('.ng-csv-import.ng-isolate-scope input[type="file"]')[0].value = null;
        }
      });

      var csvToJSON = function(content) {
        var lines=content.csv.split(new RegExp('\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
        var result = [];
        var start = 0;
        var columnCount = lines[0].split(content.separator).length;

        var headers = [];
        if (content.header) {
          headers=lines[0].split(content.separator);
          start = 1;
        }

        for (var i=start; i<lines.length; i++) {
          var obj = {};
          var currentline=lines[i].split(new RegExp(content.separator+'(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
          if ( currentline.length === columnCount ) {
            if (content.header) {
              for (var j=0; j<headers.length; j++) {
                obj[headers[j]] = cleanCsvValue(currentline[j]);
              }
            } else {
              for (var k=0; k<currentline.length; k++) {
                obj[k] = cleanCsvValue(currentline[k]);
              }
            }
            result.push(obj);
          }
        }
        return result;
      };

      var cleanCsvValue = function(value) {
        return value
          .replace(/^\s*|\s*$/g,"") // remove leading & trailing space
          .replace(/^"|"$/g,"") // remove " on the beginning and end
          .replace(/""/g,'"'); // replace "" with "
      };
    }
  };
});

(function () {
  'use strict';
  angular.module('app.wfm', [])
    .factory('Wfm', wfmFactory);

  /**ngInject*/
  function wfmFactory($resource, api, CONSTANT, $q) {

    var wfmApi = {
      list: $resource(api.restUri + '/WFMSubscriber/list'),
      addUser: $resource(api.restUri + '/WFMsubscriber/createWFMUser'),
      addUserWithOrgID: $resource(api.restUri + '/WFMsubscriber/addUserWithOrgID/:userID/:orgID'),
      updateUser: $resource(api.restUri + '/WFMsubscriber/updateUserByID/:id'),
      removeUserByID: $resource(api.restUri + '/WFMsubscriber/removeUserByID/:id'),
      wfmUsersByOrgID: $resource(api.restUri + '/WFMsubscriber/wfmUsersByOrgID/:org_id'),
      updateWfmList: $resource(api.restUri + '/WFMsubscriber/updateWfmList/:orgID', {}, {put: {method: 'PUT'}}),

      incidenceList: $resource(api.restUri + '/WFMIncidence/list/:organizationId', {}, {query: {method: 'GET'}, isArray:false}),
      updateWfmIncidenceTypes: $resource(api.restUri + '/WFMIncidence/update/:organizationId', {}, {put: {method: 'PUT'}}),
    };

    return {
      getList: getList,
      addUser: addUser,
      addUserWithOrgID: addUserWithOrgID,
      updateUser: updateUser,
      removeUserByID: removeUserByID,
      wfmUsersByOrgID: wfmUsersByOrgID,
      updateWfmList: updateWfmList,

      incidenceList: incidenceList,
      updateWfmIncidenceTypes: updateWfmIncidenceTypes,
      incidenceDefaultTypes: incidenceDefaultTypes
    };

  function getList() {
      var deferred = $q.defer();

      wfmApi.list.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }


    function addUser(user) {
      var deferred = $q.defer();

      wfmApi.addUser.save(user, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function addUserWithOrgID(userID, orgID) {
      var deferred = $q.defer();

      wfmApi.addUser.save(userID, orgID, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function updateUser(userID,userBODY) {
      var deferred = $q.defer();

      wfmApi.updateUser.save(userID, userBODY, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function removeUserByID(userID) {

      var deferred = $q.defer();

      wfmApi.removeUserByID.remove({id: userID},deferred.resolve, deferred.reject);
      
      return deferred.promise;
    }

    function wfmUsersByOrgID(orgID) {

      // console.log("wfmUsersByOrgID from wfm.service.js called...."+orgID)
      var deferred = $q.defer();

      wfmApi.wfmUsersByOrgID.query({ org_id: orgID },deferred.resolve, deferred.reject);
      
      return deferred.promise;
    }
    
    function updateWfmList(body) {

      var deferred = $q.defer();

      wfmApi.updateWfmList.put({ orgID: body.org_id }, body, deferred.resolve, deferred.reject);
      
      return deferred.promise;
    }

    function incidenceList(orgId) {

      var deferred = $q.defer();

      wfmApi.incidenceList.query({ organizationId: orgId }, deferred.resolve, deferred.reject);
      
      return deferred.promise;
    }

    function updateWfmIncidenceTypes(body){
      var deferred = $q.defer();

      wfmApi.updateWfmIncidenceTypes.put({ organizationId: body.org_id }, body, deferred.resolve, deferred.reject);
      
      return deferred.promise;
    }

    function incidenceDefaultTypes(){
      return ["SOS", "THEFT", "INTRUDER", "LOG"]
    }

  }
})();
(function () {
  'use strict';
  angular.module('app.user', [])
    .factory('User', userFactory);

  /*@ngInject*/
  function userFactory($q, api, Auth) {
    var logined = true;
    return {
      isLogin: isLogin,
      login: login,
      recoverPassword: recoverPassword,
      refreshToken: refreshToken
    };

    function isLogin() {
      return logined;
    }

    function login(user) {
      var deffered = $q.defer();

      api.auth.save(user, function (resp) {
        if(resp.success){
          deffered.resolve(resp);
        }else{
          deffered.reject(resp);
        }
      }, function (resp) {
        deffered.reject(resp);
      });

      return deffered.promise;
    }

    function recoverPassword(email){
      var deferred = $q.defer();

      api.recoverPassword.save(email, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function refreshToken(){
      var deferred = $q.defer();
      api.refreshToken.query( deferred.resolve, deferred.reject);
      return deferred.promise;
    }


  }
})();

(function () {
  'use strict';

  angular.module('app.toolbarModule',[])
    .factory('toolbarFactory', toolbarFactory);

  /**ngInject*/
  function toolbarFactory($rootScope) {

    var searchText  = '';

    return {
      setSearchText : setSearchText,
      getSearchText : getSearchText

    };
    function setSearchText(searchText) {
      this.searchText = searchText;
    }

    function getSearchText(){
      return this.searchText;
    }

  }

})();

(function () {
  'use strict';
  angular.module('app.toast-service', [])
    .factory('Toast', toastHandler);

  /** @ngInject*/
  function toastHandler($mdToast, $mdDialog, $translate) {
    return {
      showCustom: showToast,
      showAdd: showAddSuccess,
      colorError:colorErrorFail,
      imgError : imgUploadError,
      imgSizeError : imgUploadSizeError,
      imgFormatError : imgFormatError,
      showUpdate: showUpdateSuccess,
      showKeyFileUpdate: showKeyFileUpdateSuccess,
      showEmptyKeyFileUpdate: showEmptyKeyFileUpdateSuccess,
      showVersionFileUpdate: showVersionFileUpdate,
      showVersionFileEmpty: showVersionFileEmpty,
      showVersionFileDelete: showVersionFileDelete,
      showDelete:showDeleteSuccess,
      showDeleteFail:showDeleteFail,
      showDeleteFailed:showDeleteFailed,
      showRelease: showReleaseSuccess,
      showBlock: showBlockSuccess,
      showChange: showChangeSuccess,
      showRevoke: showRevokeSuccess,
      showFailedRevoke:showRevokeFailed,
      showAllocate: showAllocateSuccess,
      showAddApplicationError: showAddApplicationError,
      showAddApplicationSuccess: showAddApplicationSuccess,
      showAddApplicationUpdateSuccess: showAddApplicationUpdateSuccess,
      showApplicationRemove: showApplicationRemove,
      showAddApplicationReserverdError: showAddApplicationReserverdError,
      getDeleteDialog: getDeleteDialog,
      getDeleteApplicationListDialog: getDeleteApplicationListDialog,
      getMoveTabsWithoutSaveApplications: getMoveTabsWithoutSaveApplications,
      getReleaseDialog: getReleaseDialog,
      getBlockDialog: getBlockDialog,
      getEmtyErrorMsg : getEmtyErrorMsg,
      getDeleteWithMembersDialog: getDeleteWithMembersDialog,
      getEnableAllSubscribers: getEnableAllSubscribers,
      getDisableAllSubscribers: getDisableAllSubscribers,
      getLicenseAssignment: getLicenseAssignment,
      getSendBulkSms: getSendBulkSms,
      getSendSms : getSendSms,
      getRoleAssignment: getRoleAssignment,
      getApplicationListAssignment: getApplicationListAssignment,
      getEmergencyGroupAssignment: getEmergencyGroupAssignment,
      getContactTemplateAssignmentAdd: getContactTemplateAssignmentAdd,
      getContactTemplateAssignmentRemove: getContactTemplateAssignmentRemove,
      getChangePassword: getChangePassword,
      showSearchMsg : showSearchBlankMsg,
      showBatchImportedFileErrorMsg : showBatchImportFileErrorMsg,
      showInvalidFormatFile  : showInvalidFormatFileMsg,
      show404Error : showMsg404,
      getAddDispatcherUser: getAddDispatcherUser,
      getCleanAndHideCallLogSessionFilter: getCleanAndHideCallLogSessionFilter,
      getChargeRoles: getChargeRoles,
      getDemoOrganization: getDemoOrganization,
      getEncryptionKeysGenerationDialog: getEncryptionKeysGenerationDialog,
      showExpiredDayesDialog: showExpiredDayesDialog,
      showExpiredDialog: showExpiredDialog,
      getMobileAppDeleteDialog: getMobileAppDeleteDialog,
      regenerateQr: regenerateQr,
      disableQr: disableQr,
      showDispactherLicenseWarning: showDispactherLicenseWarning,
    };

    function showToast(message){
      $mdToast.show(
        $mdToast.simple()
          .textContent(message)
          .position("Top right")
          .hideDelay(3000)
      );
    }

    function showMsg404() {
      var message =  $translate.instant("APP_TOAST_404");
      showToast(message);
    }

    function showSearchBlankMsg() {
      var message =  $translate.instant("APP_TOAST_SEARCH_BLANK");
      showToast(message);
    }

    function showInvalidFormatFileMsg() {
      var message =  $translate.instant("INVALID_BULK_FILE_FORMAT");
      showToast(message);
    }

    function showBatchImportFileErrorMsg(){
      var message =  $translate.instant("BULK_IMPORT_FILE_FORMAT_MESSAGE");
      showToast(message);
    }

    function getEmtyErrorMsg(message){
      $mdToast.show(
        $mdToast.simple()
          .textContent(message)
          .position("Top right")
          .hideDelay(3000)
      );
    }

    function showAddSuccess() {
      var message =  $translate.instant("APP_TOAST_ADD_SUCCESS");
      showToast(message);
    }

    function showUpdateSuccess() {
      var message =  $translate.instant("APP_TOAST_UPDATE_SUCCESS");
      showToast(message);
    }

    function showKeyFileUpdateSuccess() {
      var message =  $translate.instant("APP_TOAST_UPDATE_KEY_FILE_SUCCESS");
      showToast(message);
    }

    function showEmptyKeyFileUpdateSuccess() {
      var message =  $translate.instant("APP_TOAST_UPDATE_EMPTY_KEY_FILE_SUCCESS");
      showToast(message);
    }

    function showVersionFileUpdate() {
      var message =  $translate.instant("APP_TOAST_UPLOAD_VERSION_FILE_SUCCESS");
      showToast(message);
    }

    function showVersionFileEmpty(){
      var message =  $translate.instant("APP_TOAST_UPLOAD_VERSION_FILE_EMPTY");
      showToast(message);
    }

    function showVersionFileDelete(){
      var message =  $translate.instant("APP_TOAST_DELETE_VERSION_FILE_SUCCESS");
      showToast(message);
    }

    function showDeleteSuccess() {
      var message =  $translate.instant("APP_TOAST_DELETE_SUCCESS");
      showToast(message);
    }

    function showDeleteFail() {
      var message =  $translate.instant("APP_TOAST_DELETE_FAIL");
      showToast(message);
    }

    function showDeleteFailed() {
      var message =  $translate.instant("APP_TOAST_DELETE_FAILED");
      showToast(message);
    }

    function showReleaseSuccess() {
      var message =  $translate.instant("APP_TOAST_RELEASE_SUCCESS");
      showToast(message);
    }

    function showBlockSuccess() {
      var message =  $translate.instant("APP_TOAST_BLOCK_SUCCESS");
      showToast(message);
    }

    function showChangeSuccess() {
      var message =  $translate.instant("APP_TOAST_CHANGE_SUCCESS");
      showToast(message);
    }

    function colorErrorFail() {
      var message =  $translate.instant("APP_TOAST_COLOR_ERROR");
      showToast(message);
    }
    function imgUploadError() {
      var message =  $translate.instant("APP_TOAST_SELECT_IMAGE");
      showToast(message);
    }
    function imgUploadSizeError() {
      var message =  $translate.instant("APP_TOAST_IMAGE_SIZE_ERROR");
      showToast(message);
    }

    function imgFormatError() {
      var message =  $translate.instant("APP_TOAST_IMAGE_FORMAT_ERROR");
      showToast(message);
    }
    function showAllocateSuccess() {
      var message =  $translate.instant("APP_TOAST_ALLOCATE_SUCCESS");
      showToast(message);
    }

    function showAddApplicationError(){
      var message =  $translate.instant("APP_TOAST_ADD_APPLICATION_ERROR");
      showToast(message);
    }

    function showAddApplicationSuccess(){
      var message =  $translate.instant("APP_TOAST_ADD_APPLICATION_SUCCESS");
      showToast(message);
    }

    function showAddApplicationUpdateSuccess(){
      var message =  $translate.instant("APP_TOAST_ADD_APPLICATION_UPDATE_SUCCESS");
      showToast(message);
    }

    function showApplicationRemove(){
      var message =  $translate.instant("APP_TOAST_REMOVE_APPLICATION");
      showToast(message);
    }

    function showAddApplicationReserverdError(){
      var message =  $translate.instant("APP_TOAST_ADD_APPLICATION_RESERVED_ERROR");
      showToast(message);
    }

    function showRevokeSuccess() {
      var message =  $translate.instant("APP_TOAST_REVOKE_SUCCESS");
      showToast(message);
    }

    function showRevokeFailed() {
      var message =  $translate.instant("APP_TOAST_REVOKE_FAILED");
      showToast(message);
    }

    function getDeleteDialog(){
      var deleteWarningTitle = $translate.instant("APP_DELETE_WARNING_TITLE");
      var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_REMOVE");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(deleteWarningTitle)
        .textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getDeleteApplicationListDialog(){
      var deleteWarningTitle = $translate.instant("APP_DELETE_APPLICATION_LIST_WARNING_TITLE");
      var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_REMOVE");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(deleteWarningTitle)
        .textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getMoveTabsWithoutSaveApplications(){
      var deleteWarningTitle = $translate.instant("APP_MOVE_TAB_APPLICATION_LIST_WARNING_TITLE");
      var deleteWarningText  = $translate.instant("APP_MOVE_TAB_APPLICATION_LIST_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_YES");
      var cancelButtonLabel  = $translate.instant("APP_NO");

      return $mdDialog.confirm()
        .title(deleteWarningTitle)
        .textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getDeleteWithMembersDialog(){
      var deleteWarningTitle = $translate.instant("APP_DELETE_WITH_MEMBERS_WARNING_TITLE");
      var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_REMOVE");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(deleteWarningTitle)
        .textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getReleaseDialog(){
      var deleteWarningTitle = $translate.instant("APP_RELEASE_WARNING_TITLE");
      var deleteWarningText  = $translate.instant("APP_RELEASE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(deleteWarningTitle)
        .textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getBlockDialog(){
      var deleteWarningTitle = $translate.instant("APP_BLOCK_WARNING_TITLE");
      var deleteWarningText  = $translate.instant("APP_BLOCK_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(deleteWarningTitle)
        .textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getEnableAllSubscribers(){
      var enableWarningTitle = $translate.instant("APP_ENABLE_WARNING_TITLE");
      //var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        //.textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getDisableAllSubscribers(){
      var enableWarningTitle = $translate.instant("APP_DISABLE_WARNING_TITLE");
      //var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        //.textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getLicenseAssignment(){
      var enableWarningTitle = $translate.instant("APP_LICENSE_INTERACTIVE_WARNING_TITLE");
      //var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        //.textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getSendBulkSms(message){
      var enableWarningTitle = $translate.instant("APP_SEND_BULK_SMS_WARNING_TITLE");
      //var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        .textContent("Content of SMS: "+message)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getSendSms(message){
      var enableWarningTitle = $translate.instant("APP_SEND_SMS_WARNING_TITLE");
      //var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        .multiple(true)
        .textContent("Content of SMS: "+message)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getRoleAssignment(){
      var enableWarningTitle = $translate.instant("APP_ROLE_INTERACTIVE_WARNING_TITLE");
      //var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        //.textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getApplicationListAssignment(){
      var enableWarningTitle = $translate.instant("APP_APPLICATION_LIST_INTERACTIVE_WARNING_TITLE");
      //var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        //.textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getEmergencyGroupAssignment(){
      var enableWarningTitle = $translate.instant("APP_EMERGENCY_GROUP_INTERACTIVE_WARNING_TITLE");
      //var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        //.textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getContactTemplateAssignmentAdd(type){
      if(type === 'Subscribers')
        var enableWarningTitle = $translate.instant("APP_CONTACT_TEMPLATE_INTERACTIVE_ADD_WARNING_TITLE");
      else
        var enableWarningTitle = $translate.instant("APP_CONTACT_TEMPLATE_INTERACTIVE_ADD_WARNING_GROUP_TITLE");
      //var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        //.textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getContactTemplateAssignmentRemove(type){
      if(type === 'Subscribers')
        var enableWarningTitle = $translate.instant("APP_CONTACT_TEMPLATE_INTERACTIVE_REMOVE_WARNING_TITLE");
      else
        var enableWarningTitle = $translate.instant("APP_CONTACT_TEMPLATE_INTERACTIVE_REMOVE_WARNING_GROUP_TITLE");
      //var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        //.textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getChangePassword(){
      var enableWarningTitle = $translate.instant("APP_CHANGE_PASSWORD_INTERACTIVE_WARNING_TITLE");
      //var deleteWarningText  = $translate.instant("APP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        //.textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getAddDispatcherUser(){
      var enableWarningTitle = $translate.instant("APP_DISPATCHER_USER_WARNING_TITLE");
      var enableWarningText1  = $translate.instant("APP_DISPATCHER_USER_WARNING_CONTENT1");
      var enableWarningText2  = $translate.instant("APP_DISPATCHER_USER_WARNING_CONTENT2");
      var submitButtonLabel  = $translate.instant("APP_YES");
      var cancelButtonLabel  = $translate.instant("APP_NO");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
       // .textContent(enableWarningText)
        .htmlContent("<span>"+enableWarningText1+"</span><br><span>"+enableWarningText2+"</span>")
        .multiple(true)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getCleanAndHideCallLogSessionFilter(){
      var hideAndClearWarningTitle = $translate.instant("CALL_LOG_SESSION_SHOW_FILTER_BY_DATES_WARNING_TITLE");
      var hideAndClearWarningText  = $translate.instant("CALL_LOG_SESSION_SHOW_FILTER_BY_DATES_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_YES");
      var cancelButtonLabel  = $translate.instant("APP_NO");

      return $mdDialog.confirm()
        .title(hideAndClearWarningTitle)
        .textContent(hideAndClearWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getChargeRoles(permissions){
      var enableWarningTitle = $translate.instant("APP_CHARGE_ROLE_WARNING_TITLE");
      var enableWarningText1  = $translate.instant("APP_CHARGE_ROLE_WARNING_CONTENT1") + permissions;
      var enableWarningText2  = $translate.instant("APP_CHARGE_ROLE_WARNING_CONTENT2");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
       // .textContent(enableWarningText)
        .htmlContent("<span>"+enableWarningText1+".</span><br><span>"+enableWarningText2+"</span>")
        .multiple(true)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function getDemoOrganization(days){
      var enableWarningTitle = $translate.instant("APP_DEMO_ORGANIZATION_WARNING_TITLE");
      var enableWarningText1 = $translate.instant("APP_DEMO_ORGANIZATION_WARNING_CONTENT1", {days: days});
      var enableWarningText2  = $translate.instant("APP_DEMO_ORGANIZATION_WARNING_CONTENT2");
      var enableWarningText3  = $translate.instant("APP_DEMO_ORGANIZATION_WARNING_CONTENT3");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        //.textContent(enableWarningText)
        .htmlContent("<span>"+enableWarningText1+"</span><br><span>"+enableWarningText2+"</span><br><span>"+enableWarningText3+"</span>")
        .multiple(true)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    
    function getEncryptionKeysGenerationDialog(){
      var enableWarningTitle = $translate.instant("APP_GENERATE_ENCRYPTION_KEYS_WARNING_TITLE");
      var enableWarningText1 = $translate.instant("APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT1");
      var enableWarningText2  = $translate.instant("APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT2");
      var enableWarningText3  = $translate.instant("APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT3");
      var enableWarningText4  = $translate.instant("APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT4");

      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        //.textContent(enableWarningText)
        .htmlContent("<span>"+enableWarningText1+"</span><br><span>"+enableWarningText2+"</span><br><br><span>"+enableWarningText3+"</span>"+"</span><br><br><span>"+enableWarningText4+"</span>")
        .multiple(true)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function showExpiredDayesDialog(days){
      var message =  $translate.instant("LOGIN_PASSWORD_EXPIRED_DAYS", {days: days});
      showToast(message);
    }
    
    function showExpiredDialog(){
      var message =  $translate.instant("LOGIN_PASSWORD_EXPIRED");
      showToast(message);
    }

    function getMobileAppDeleteDialog(){
      var deleteWarningTitle = $translate.instant("APP_DELETE_WARNING_TITLE");
      var deleteWarningText  = $translate.instant("MOBILEAPP_DELETE_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_REMOVE");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(deleteWarningTitle)
        .textContent(deleteWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function regenerateQr(){
      var enableWarningTitle = $translate.instant("APP_QR_WARNING_TITLE");
      var qrWarningText  = $translate.instant("APP_QR_WARNING_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        .multiple(true)
        .textContent(qrWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function disableQr(){
      var enableWarningTitle = $translate.instant("APP_QR_DISABLE_TITLE");
      var qrWarningText  = $translate.instant("APP_QR_DISABLE_CONTENT");
      var submitButtonLabel  = $translate.instant("APP_OK");
      var cancelButtonLabel  = $translate.instant("APP_CANCEL");

      return $mdDialog.confirm()
        .title(enableWarningTitle)
        .multiple(true)
        .textContent(qrWarningText)
        .ok(submitButtonLabel)
        .cancel(cancelButtonLabel);
    }

    function showDispactherLicenseWarning(days){
      var message =  $translate.instant("APP_DISPATCHER_PERMISSION_LICENSE_WARNING");
      showToast(message);
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.subscriber', [])
    .factory('Subscriber', subscriberFactory);


  /**ngInject*/
  function subscriberFactory($resource, api, CONSTANT, $q) {
    this.canceller = $q.defer();
    var subscriberApi = {
      list: $resource(api.restUri + '/subscriber/list/:id',  [], []),
      subscriberList: $resource(api.restUri + '/subscriber/subscriberList/:id',  [], []),
      subList: $resource(api.restUri + '/subscriber/subList'),
      // subList: $resource(api.restUri + '/subscriber/subList/:organizationId/:search/:licenseno/:pageNo/:pageSize',  [], {query: {method: 'GET'}, isArray:false}),
      subscriberData: $resource(api.restUri + '/subscriber/subscriberData/:id',  [], []),
      // list: $resource(api.restUri + '/subscriber/list/:id',  [], [], { cancellable: true }),
      listExport: $resource(api.restUri + '/subscriber/list/export/:id'),
      listExportRuntime: $resource(api.restUri + '/subscriber/list/exportRuntime/:id'),
      detailedList: $resource(api.restUri + '/subscriber/list/detailed/:id'),
      listByGroup:  $resource(api.restUri + '/subscriber/list/group/:groupId'),
      listByGroupFilter:  $resource(api.restUri + '/subscriber/userList/group/:groupId'),
      getById: $resource(api.restUri + '/subscriber/:id', {}, {query: {method: 'GET'}, isArray:false}),
      getByUserId: $resource(api.restUri + '/subscriber/list/userId/:userId'),
      getByBundleId: $resource(api.restUri + '/subscriber/list/bundle/:licenseBundleId/offset/:offset/limit/:limit'),
      getByAllocationId: $resource(api.restUri + '/subscriber/list/allocation/:licenseAllocationId/offset/:offset/limit/:limit'),

      newItem: $resource(api.restUri + '/subscriber'),
      update: $resource(api.restUri + '/subscriber/:id', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(api.restUri + '/subscriber/:id'),

      batchAdd: $resource(api.restUri + '/subscriber/batch/add'),
      batchUpdate: $resource(api.restUri + '/subscriber/batch/update', {}, {put: {method: 'PUT'}}),
      changeBulkPassword: $resource(api.restUri + '/subscriber/bulkPassword/updatePass'),
      changeBulkLicense: $resource(api.restUri + '/subscriber/bulkLicense'),
      changeBulkRolePermission: $resource(api.restUri + '/subscriber/bulkRolePermission'),
      bulkRemoveAss: $resource(api.restUri + '/subscriber/bulkRemoveAss'),
      batchDelete: $resource(api.restUri + '/subscriber/batch/delete/:organization_id'),

      batchEnable :  $resource(api.restUri + '/subscriber/batch/enableall/:organization_id', {}, {put: {method: 'PUT'}}),
      batchDisable: $resource(api.restUri + '/subscriber/batch/disableall/:organization_id', {}, {put: {method: 'PUT'}}),

      release: $resource(api.restUri + '/subscriber/release/:id', {}, {put: {method: 'PUT'}}),
      block: $resource(api.restUri + '/subscriber/block/:id', {}, {put: {method: 'PUT'}}),
      changeActiveState: $resource(api.restUri + '/subscriber/changeActiveState/:id/:state', {}, {put: {method: 'PUT'}}),
      licenseIsOffNet:$resource(api.restUri + '/subscriber/licenseIsOffNet/:licensemask', {}, {query: {method:'GET',isArray:false}}),
      isDispatcherUser:$resource(api.restUri + '/subscriber/isDispatcherUser/:licensemask', {}, {query: {method:'GET',isArray:false}}),
      bulkUpdateContactTemplate: $resource(api.restUri + '/subscriber/bulkUpdateContactTemplate'),
      enbleAuthentication: $resource(api.restUri + '/subscriber/twoFactorAuthentication/:flag/:id', {}, {put: {method: 'PUT'}}),
      isCheckUserFlag:$resource(api.restUri + '/subscriber/checkUserFlag/:userlength', {}, {query: {method: 'GET'}, isArray:false}),
      checkUserByOrg:$resource(api.restUri + '/subscriber/checkUserByOrg/:organizationId', {}, {query: {method: 'GET'}, isArray:false})
    };

    return {
      getById: getById,
      getByUserId: getByUserId,
      getByBundleId: getByBundleId,
      getByAllocationId: getByAllocationId,
      getListByOrganization: getListByOrganization,
      getSubscriberListByOrg: getSubscriberListByOrg,
      getSubscriberDataByOrg: getSubscriberDataByOrg,
      getSubDataByOrg: getSubDataByOrg,
      getListByOrganizationExport: getListByOrganizationExport,
      getListByOrganizationExportRuntime: getListByOrganizationExportRuntime,
      getListByOrganizationMultipleRequests: getListByOrganizationMultipleRequests,
      getDetailedListByOrganization: getDetailedListByOrganization,
      getListByGroup: getListByGroup,
      getListByFilterGroup: getListByFilterGroup,

      add: add,
      update: update,
      remove: remove,
      enable: enable,
      disable: disable,

      batchAdd: batchAdd,
      batchUpdate: batchUpdate,
      batchRemove: batchRemove,
      changeBulkPassword: changeBulkPassword,
      changeBulkLicense: changeBulkLicense,
      changeBulkRolePermission: changeBulkRolePermission,
      bulkRemoveAss: bulkRemoveAss,
      licenseIsOffNet:licenseIsOffNet,
      isDispatcherUser:isDispatcherUser,
      release: release,
      block: block,
      changeActiveState: changeActiveState,
      bulkUpdateContactTemplate: bulkUpdateContactTemplate,
      enbleAuthentication: enbleAuthentication,
      isCheckUserFlag:isCheckUserFlag,
      checkUserByOrg:checkUserByOrg
    };

    function getListByOrganization(organizationId) {
      var deferred = $q.defer();
      if (this.canceller && this.canceller.$cancelRequest) {
        this.canceller.$cancelRequest()
      }
      this.canceller = subscriberApi.list.query({id: organizationId},  deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getListByOrganizationExport(organizationId) {
      var deferred = $q.defer();

      subscriberApi.listExport.query({id: organizationId},  deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getListByOrganizationExportRuntime(organizationId) {
      var deferred = $q.defer();

      subscriberApi.listExportRuntime.query({id: organizationId},  deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getListByOrganizationMultipleRequests(organizationId) {
      var deferred = $q.defer();
      
      subscriberApi.list.query({id: organizationId},  deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getDetailedListByOrganization(organizationId) {
      var deferred = $q.defer();

      subscriberApi.detailedList.query({id: organizationId},  deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getListByGroup(groupId) {
      var deferred = $q.defer();

      subscriberApi.listByGroup.query({groupId: groupId}, function (resp) {
        deferred.resolve(resp);
      });

      return deferred.promise;
    }

    function getById(subscriberId) {
      var deferred = $q.defer();

      subscriberApi.getById.query({id: subscriberId}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function getByUserId(searchString) {
      var deferred = $q.defer();

      subscriberApi.getByUserId.query({userId: searchString}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function getByBundleId(licenseBundleId, offset, limit) {
      var deferred = $q.defer();

      subscriberApi.getByBundleId.query({licenseBundleId: licenseBundleId, offset: offset, limit: limit}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function getByAllocationId(licenseAllocationId, offset, limit) {
      var deferred = $q.defer();

      subscriberApi.getByAllocationId.query({licenseAllocationId: licenseAllocationId, offset: offset, limit: limit}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function add(subscriber) {
      var deferred = $q.defer();

      subscriberApi.newItem.save(subscriber, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function batchAdd(subscribers) {
      var deferred = $q.defer();

      subscriberApi.batchAdd.save(subscribers, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function update(subscriber) {
      var deferred = $q.defer();

      subscriberApi.update.put({id: subscriber._id}, subscriber, deferred.resolve,deferred.reject);

      return deferred.promise;
    }

    function batchUpdate(subscribers) {
      var deferred = $q.defer();

      subscriberApi.batchUpdate.put({subscribers: subscribers}, deferred.resolve,deferred.reject);

      return deferred.promise;
    }
    function changeBulkPassword(subscribers) {
      var deferred = $q.defer();
      subscriberApi.changeBulkPassword.save({subscribers: subscribers}, function (resp) {deferred.resolve(resp);}, deferred.reject);

      return deferred.promise;
    }
    function changeBulkLicense(subscribers) {
      var deferred = $q.defer();
      subscriberApi.changeBulkLicense.save({subscribers: subscribers}, function (resp) {deferred.resolve(resp);}, deferred.reject);

      return deferred.promise;
    }
    function changeBulkRolePermission(subscribers) {
      var deferred = $q.defer();
      subscriberApi.changeBulkRolePermission.save({subscribers: subscribers}, function (resp) {deferred.resolve(resp);}, deferred.reject);

      return deferred.promise;
    }
    function bulkRemoveAss(subscribers) {
      var deferred = $q.defer();
      subscriberApi.bulkRemoveAss.save({subscribers: subscribers}, function (resp) {deferred.resolve(resp);}, deferred.reject);
      return deferred.promise;
    }
    function remove(subscriberId) {
      var deferred = $q.defer();

      subscriberApi.deleteItem.remove({id: subscriberId}, deferred.resolve, deferred.reject);
      return deferred.promise;
    }

    function batchRemove(organization_id,subscribers) {
      var deferred = $q.defer();

      subscriberApi.batchDelete.delete({organization_id: organization_id}, deferred.resolve,deferred.reject);

      return deferred.promise;
    }

    function enable(organization_id) {
      var deferred = $q.defer();
      subscriberApi.batchEnable.put({organization_id: organization_id}, {}, deferred.resolve, deferred.reject);
      return deferred.promise;
    }

    function disable(organization_id) {
      var deferred = $q.defer();
      subscriberApi.batchDisable.put({organization_id: organization_id}, {}, deferred.resolve, deferred.reject);
      return deferred.promise;
    }

    function release(id) {
      var deferred = $q.defer();
      subscriberApi.release.put({id: id}, {}, deferred.resolve, deferred.reject);
      return deferred.promise;
    }

    function block(id) {
      var deferred = $q.defer();
      subscriberApi.block.put({id: id}, {}, deferred.resolve, deferred.reject);
      return deferred.promise;
    }
    function licenseIsOffNet(licensemask){
      var deferred = $q.defer();      
      subscriberApi.licenseIsOffNet.query({licensemask: licensemask},  deferred.resolve, deferred.reject);
      return deferred.promise;
    }
    function isDispatcherUser(licensemask){
      var deferred = $q.defer();      
      subscriberApi.isDispatcherUser.query({licensemask: licensemask},  deferred.resolve, deferred.reject);
      return deferred.promise;
    }
    function bulkUpdateContactTemplate(dataArray) {
      var deferred = $q.defer();
      subscriberApi.bulkUpdateContactTemplate.save({dataArray: dataArray}, function (resp) {deferred.resolve(resp);}, deferred.reject);
      return deferred.promise;
    }
    function getSubscriberListByOrg(organizationId) {
      var deferred = $q.defer();
      if (this.canceller && this.canceller.$cancelRequest) {
        this.canceller.$cancelRequest()
      }
      this.canceller = subscriberApi.subscriberList.query({id: organizationId},  deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    function getSubDataByOrg(dataArray) {
      
      var deferred = $q.defer();
      if (this.canceller && this.canceller.$cancelRequest) {
        this.canceller.$cancelRequest()
      }
      this.canceller = subscriberApi.subList.save({dataArray: dataArray}, function (resp) {deferred.resolve(resp);}, deferred.reject);
      return deferred.promise;
    }
    function getSubscriberDataByOrg(organizationId) {
      var deferred = $q.defer();
      if (this.canceller && this.canceller.$cancelRequest) {
        this.canceller.$cancelRequest()
      }
      this.canceller = subscriberApi.subscriberData.query({id: organizationId},  deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    function getListByFilterGroup(groupId) {
      var deferred = $q.defer();

      subscriberApi.listByGroupFilter.query({groupId: groupId}, function (resp) {
        deferred.resolve(resp);
      });

      return deferred.promise;
    }
    function changeActiveState(id,state) {
      var deferred = $q.defer();
      subscriberApi.changeActiveState.put({id: id,state: state}, {}, deferred.resolve, deferred.reject);
      return deferred.promise;
    }

    function enbleAuthentication(subscriberId,flag) {
      var deferred = $q.defer();
      subscriberApi.enbleAuthentication.put({id: subscriberId,flag:flag}, {}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);
      
      return deferred.promise;
    }
    function isCheckUserFlag(userLength){
      var deferred = $q.defer();      
      subscriberApi.isCheckUserFlag.query({userlength: userLength},  deferred.resolve, deferred.reject);
      return deferred.promise;
    }
    function checkUserByOrg(orgId){
      var deferred = $q.defer();      
      subscriberApi.checkUserByOrg.query({organizationId: orgId},  deferred.resolve, deferred.reject);
      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.sms', [])
    .factory('Sms', smsFactory);

  function smsFactory($resource, $q, api, CONSTANT) {

    var smsApi = {
      send: $resource(api.restUri + '/sms/send'),
      changeBulkSendSms: $resource(api.restUri + '/sms/bulkSendSms')
    };

    return {
      sendSms: sendSms,
      changeBulkSendSms: changeBulkSendSms
    };

    function sendSms(sms) {
      var deferred = $q.defer();

      smsApi.send.save(sms, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function changeBulkSendSms(subscribers,type) {
      var deferred = $q.defer();

      smsApi.changeBulkSendSms.save({subscribers: subscribers,type: type}, function (resp) {deferred.resolve(resp);}, deferred.reject);

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.site', [])
    .factory('Site', siteFactory);

  function siteFactory(CONSTANT, $resource, $q, api, $rootScope) {

    var sitesApi = {
      list: $resource(api.restUri + '/site/list'),
      new: $resource(api.restUri + '/site'),
      update: $resource(api.restUri + '/site/:siteId', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(api.restUri + '/site/:siteId'),
      update_secondary_site: $resource(api.restUri + '/site/:secondarySiteId', {}, {put: {method: 'PUT'}})
    };

    return {
      getList: getList,
      add: addSite,
      update: editSite,
      delete: deleteSite,
      getStateList: getStateList,
      UPDATE_SECONDARY_SITE: UPDATE_SECONDARY_SITE
    };

    function getList() {
      var deferred = $q.defer();

      sitesApi.list.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function addSite(site){
      var deferred = $q.defer();

      sitesApi.new.save(site, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function editSite(site){
      var deferred = $q.defer();

      sitesApi.update.put({siteId: site._id}, site, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function UPDATE_SECONDARY_SITE(site){
      var deferred = $q.defer(); 
      sitesApi.update_secondary_site.put({secondarySiteId: site},{}, deferred.resolve, deferred.reject);
      return deferred.promise;
    }

    function deleteSite(siteId){
      var deferred = $q.defer();

      sitesApi.deleteItem.delete({siteId: siteId}, function (resp) {
         deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;

    }

    function getStateList(){
      return [
        /*{
          "id":0,
          "value": "Unknown"
        }, */
        {
          "id":1,
          "value": "Up"
        },
        {
          "id":2,
          "value": "Down"
        },
        {
          "id":3,
          "value": "Maintenance"
        }
      ]
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.server', [])
    .factory('Server', serverFactory);

  function serverFactory($resource, $q, api) {

    var serverApi = {};

    serverApi.server = {
      list: $resource(api.restUri + '/server/list'),
      new: $resource(api.restUri + '/server'),
      update: $resource(api.restUri + '/server/:serverId', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(api.restUri + '/server/:serverId')
    };

    return {
      getList: getList,
      add: addServer,
      update: editServer,
      delete: deleteServer,
      getTypeList: getTypeList,
      getStateList: getStateList,
      getAdminStateList: getAdminStateList
    };

    function getList() {
      var deferred = $q.defer();

      serverApi.server.list.query(function (resp) {
        deferred.resolve(resp);
      });

      return deferred.promise;
    }

    function addServer(server){
      var deferred = $q.defer();

      serverApi.server.new.save(server, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function editServer(server){
      var deferred = $q.defer();

      serverApi.server.update.put({serverId: server._id}, server, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function deleteServer(serverId){
      var deferred = $q.defer();

      serverApi.server.deleteItem.delete({serverId: serverId}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;

    }

    function getTypeList(){
      return [
       /* {
          "id": 0,
          "value": "Undefined"
        }, */
        {
          "id": 1,
          "value": "IPRS"
        },
       /* {
          "id": 2,
          "value": "Mediation"
        },
        {
          "id": 3,
          "value": "MTView"
        },
        {
          "id": 4,
          "value": "XDMS"
        },
        {
          "id": 5,
          "value": "Motorola GW"
        },
        {
          "id": 6,
          "value": "Nokia GW"
        },
        {
          "id": 7,
          "value": "IMS GW"
        }, */
        {
          "id": 9,
          "value": "GPS"
        },
        {
          "id": 10,
          "value": "SOS"
        }
      ];
    }

    function getStateList() {
      return [
       /* {
          "id": 0,
          "value": "Undefined"
        }, */
        {
          "id": 1,
          "value": "Down"
        },
        {
          "id": 2,
          "value": "Crash"
        },
        {
          "id": 3,
          "value": "Failure"
        },
        {
          "id": 10,
          "value": "Init machine"
        },
        {
          "id": 20,
          "value": "Maintanance"
        },
        {
          "id": 30,
          "value": "Init Process"
        },
        {
          "id": 31,
          "value": "Init DB retrieval"
        },
        {
          "id": 32,
          "value": "Init network"
        },
        {
          "id": 40,
          "value": "Standby"
        },
        {
          "id": 41,
          "value": "Active"
        },
        {
          "id": 50,
          "value": "Marked Standby"
        },
        {
          "id": 51,
          "value": "Marked Active"
        }
      ]
    }

    function getAdminStateList() {
      return [
        {
          "id": 1,
          "value": "Up"
        },
        {
          "id": 2,
          "value": "Maintenance"
        }
      ]
    }
  }
})();


(function () {
  'use strict';

  angular.module('app.securityLog', [])
    .factory('Security', SecurityFactory);

  /**ngInject*/
  function SecurityFactory($resource, api, CONSTANT, $q) {
    var securityApi = {
      getSecurityLog: $resource(api.restUri + '/securityLog/all/start/:startTime/end/:endTime', {}, {query: {method: 'GET'}, isArray:false}),
      getSecurityLogByID: $resource(api.restUri + '/securityLog/id/:id/start/:startTime/end/:endTime', {}, {query: {method: 'GET'}, isArray:false}),
      getSecurityLogAdministrator: $resource(api.restUri + '/securityLog/administrator/:adminName/start/:startTime/end/:endTime', {}, {query: {method: 'GET'}, isArray:false}),
      getSecurityLogByOrg: $resource(api.restUri + '/securityLog/byOrg/:orgId/start/:startTime/end/:endTime', {}, {query: {method: 'GET'}, isArray:false})
    };
      return{
        getSecurityLog : getSecurityLog,
        getSecurityLogByID : getSecurityLogByID,
        getSecurityLogAdministrator : getSecurityLogAdministrator,
        getSecurityLogByOrg : getSecurityLogByOrg
      };

      function getSecurityLog(startTime, endTime){
        var deferred = $q.defer();

        securityApi.getSecurityLog.query({startTime: startTime, endTime: endTime}, deferred.resolve, deferred.reject);

        return deferred.promise;
      }

      function getSecurityLogByID(id, startTime, endTime){
        var deferred = $q.defer();

        securityApi.getSecurityLogByID.query({id: id, startTime: startTime, endTime: endTime}, deferred.resolve, deferred.reject);

        return deferred.promise;
      }

      function getSecurityLogAdministrator(adminName, startTime, endTime){
        var deferred = $q.defer();

        securityApi.getSecurityLogAdministrator.query({adminName: adminName, startTime: startTime, endTime: endTime}, deferred.resolve, deferred.reject);

        return deferred.promise;
      }

      function getSecurityLogByOrg(orgId, startTime, endTime){
        var deferred = $q.defer();

        securityApi.getSecurityLogByOrg.query({orgId: orgId, startTime: startTime, endTime: endTime}, deferred.resolve, deferred.reject);

        return deferred.promise;
      }


    }




  })();

(function () {
  'use strict';

  angular.module('app.role', [])
    .factory('Role', roleService);

  /** @ngInject*/
  function roleService($resource, $q, CONSTANT, api) {

    var RolesApi = {
      defaultRoles: $resource(api.restUri + '/role/default/:organizationId'),
      defaultRolesActivityLog: $resource(api.restUri + '/role/list/orgnodeAddActivityLog/:orgNodeId', {}, { query: { method: 'GET' }, isArray: false }),
      rolePermissions: $resource(api.restUri + '/role/permissions', {}, { query: { method: 'GET' }, isArray: false }),
    };

    return {
      addDefaultRoles: addDefaultRoles,
      defaultRolesActivityLog: defaultRolesActivityLog,
      getResellerAdminPermissions: getResellerAdminPermissions,

      getRolePermission: getRolePermission
    };

    function getRolePermission() {
      var deferred = $q.defer();

      RolesApi.rolePermissions.query(function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function addDefaultRoles(organizationId) {
      var deferred = $q.defer();

      RolesApi.defaultRoles.save({ organizationId: organizationId }, {}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function defaultRolesActivityLog(orgId) {
      var deferred = $q.defer();

      RolesApi.defaultRolesActivityLog.query({ orgNodeId: orgId }, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getResellerAdminPermissions() {
      return [
        {
          "resource_id": "administration_resource",
          "console_type": 2,
          "get_access": true,
          "post_access": true,
          "put_access": true,
          "delete_access": true,
          "batch_access": true,
          "himpact_access": true
        },
        {
          "resource_id": "reseller_resource",
          "console_type": 2,
          "get_access": true,
          "post_access": true,
          "put_access": true,
          "delete_access": true,
          "batch_access": true,
          "himpact_access": true
        },
        {
          "resource_id": "organization_resource",
          "console_type": 2,
          "get_access": true,
          "post_access": true,
          "put_access": true,
          "delete_access": true,
          "batch_access": true,
          "himpact_access": true
        },
        {
          "resource_id": "subscriber_resource",
          "console_type": 2,
          "get_access": true,
          "post_access": true,
          "put_access": true,
          "delete_access": true,
          "batch_access": true,
          "himpact_access": true
        },
        {
          "resource_id": "license_resource",
          "console_type": 2,
          "get_access": true,
          "post_access": true,
          "put_access": true,
          "delete_access": true,
          "batch_access": true,
          "himpact_access": true
        },
        {
          "resource_id": "group_resource",
          "console_type": 2,
          "get_access": true,
          "post_access": true,
          "put_access": true,
          "delete_access": true,
          "batch_access": true,
          "himpact_access": true
        }
      ]
    }
  }

})();

(function () {
  'use strict';

  angular.module('app.reseller', [])
    .factory('Reseller', resellerFactory);

  /** @ngInject */
  function resellerFactory(CONSTANT, $resource, $q, api, $rootScope) {

    var resellersApi = {
      list: $resource(api.restUri + '/reseller/list'),
      listByParent: $resource(api.restUri + '/reseller/list/:resellerId'),
      resellersListByParent: $resource(api.restUri + '/reseller/resellersList/:resellerId'),
      resellersDataByParent: $resource(api.restUri + '/reseller/resellersData/:resellerId/:search/:pageNo/:pageSize', {}, {query: {method: 'GET'}, isArray:false}),
      getById: $resource(api.restUri + '/reseller/:resellerId'),
      getResListById: $resource(api.restUri + '/reseller/resList/:resellerId'),
      new: $resource(api.restUri + '/reseller'),
      update: $resource(api.restUri + '/reseller/:id', {}, {put: {method: 'PUT'}}),
      allocation: $resource(api.restUri + '/reseller/allocate/:parentId/:resellerId/qty/:qty', {}, {put: {method: 'PUT'}}),
      deallocation: $resource(api.restUri + '/reseller/deallocate/:parentId/:resellerId/qty/:qty', {}, {put: {method: 'PUT'}}),
      allocation_dispatcher: $resource(api.restUri + '/reseller/allocate/dispatcher/:parentId/:resellerId/qty/:qty', {}, {put: {method: 'PUT'}}),
      deallocation_dispatcher: $resource(api.restUri + '/reseller/deallocate/dispatcher/:parentId/:resellerId/qty/:qty', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(api.restUri + '/reseller/:id'),
      getParentResellerById: $resource(api.restUri + '/reseller/getParentReseller/:resellerId', {}, {query: {method: 'GET'}, isArray:false})
    };

    return {
      getList: getList,
      getById: getOneById,
      getResListById: getResListOneById,
      add: add,
      update: update,
      allocation: allocation,
      deallocation: deallocation,
      allocation_dispatcher: allocation_dispatcher,
      deallocation_dispatcher: deallocation_dispatcher,
      remove: remove,
      getListById: getListById,
      getResellersListById: getResellersListById,
      getResellersDataById: getResellersDataById,
      getParentResellerById: getParentResellerById
    };

    function getList() {
      var deferred = $q.defer();

      resellersApi.list.query(function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function getListById(parentId) {
      var deferred = $q.defer();

      resellersApi.listByParent.query({resellerId: parentId}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function getOneById(resellerId){
      var deferred = $q.defer();

      resellersApi.getById.query({resellerId: resellerId}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function add(reseller) {
      var deferred = $q.defer();

      resellersApi.new.save(reseller, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function remove(resellerId) {
      var deferred = $q.defer();

      resellersApi.deleteItem.delete({id: resellerId}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function update(reseller) {
      var deferred = $q.defer();

      resellersApi.update.put({id: reseller._id}, reseller, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function allocation(reseller) {
      var deferred = $q.defer();

      resellersApi.allocation.put({resellerId: reseller.resellerId, parentId: reseller.parentId, qty:reseller.qty}, null, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function deallocation(reseller) {
      var deferred = $q.defer();

      resellersApi.deallocation.put({resellerId: reseller.resellerId, parentId: reseller.parentId, qty:reseller.qty}, null, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function allocation_dispatcher(reseller) {
      var deferred = $q.defer();

      resellersApi.allocation_dispatcher.put({resellerId: reseller.resellerId, parentId: reseller.parentId, qty:reseller.qty}, null, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function deallocation_dispatcher(reseller) {
      var deferred = $q.defer();

      resellersApi.deallocation_dispatcher.put({resellerId: reseller.resellerId, parentId: reseller.parentId, qty:reseller.qty}, null, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getResListOneById(resellerId){
      var deferred = $q.defer();

      resellersApi.getResListById.query({resellerId: resellerId}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function getResellersListById(parentId) {
      var deferred = $q.defer();

      resellersApi.resellersListByParent.query({resellerId: parentId}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function getResellersDataById(parentId,search,pageNo,pageSize) {
      var deferred = $q.defer();

      resellersApi.resellersDataByParent.query({resellerId: parentId,search: search,pageNo: pageNo,pageSize: pageSize}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function getParentResellerById(resellerId){
      var deferred = $q.defer();

      resellersApi.getParentResellerById.query({resellerId: resellerId}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    /** Need to use for optimization if needed
     function removeItemFromResellerTree(resList, id) {
      var index;

      if (resList && resList.children && resList.children.length) {
        angular.forEach(resList.children, function (item, key) {
          if (item._id === id) {
            index = key;
          } else {
            removeItemFromResellerTree(resList.child, id);
          }
        });

        if (typeof index !== undefined) {
          resList.children.splice(index, 1);
          vm.refreshResellerSelectList();
        }
      }

    }
     function addToResellerTree(resList, curRes) {
      angular.forEach(resList, function (item) {
        if (curRes.parentId === item._id) {
          if (!item.children) {
            item.children = []
          }
          item.children.push(curRes);
          vm.refreshResellerSelectList();
        } else if (item.children && item.children.length) {
          addToResellerTree(item.children, curRes)
        }

      });
    }
     */
  }
})();

(function () {
  'use strict';

  angular.module('app.report', [])
    .factory('Report', reportService);

  /** @ngInject*/
  function reportService($resource, $q, CONSTANT, api) {

    var ReportApi = {
      getOrgs: $resource(api.restUri + '/report/organizations'),
      getUsers: $resource(api.restUri + '/report/users'),
      getUsersRuntime: $resource(api.restUri + '/report/usersRuntime'),
      getUsersClientIndentifier: $resource(api.restUri + '/report/usersClientIndentifier'),
      getRoles: $resource(api.restUri + '/report/roles'),
      getWfmUsers: $resource(api.restUri + '/report/wfmUsers'),
      getLwUsers: $resource(api.restUri + '/report/lwUsers'),
      
    };



    return {
      getOrgsMap : getOrgsMap,
      getUsersMap : getUsersMap,
      getUsersRuntimeMap : getUsersRuntimeMap,
      getUsersClientIndentifierMap : getUsersClientIndentifierMap,
      getRolesMap : getRolesMap,
      getWfmUsersMap : getWfmUsersMap,
      getLwUsersMap : getLwUsersMap,
    };


    function getOrgsMap() {
      var deferred = $q.defer();

      ReportApi.getOrgs.get(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getUsersMap() {
      var deferred = $q.defer();

      ReportApi.getUsers.get(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getUsersRuntimeMap() {
      var deferred = $q.defer();

      ReportApi.getUsersRuntime.get(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getUsersClientIndentifierMap() {
      var deferred = $q.defer();

      ReportApi.getUsersClientIndentifier.get(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getRolesMap() {
      var deferred = $q.defer();

      ReportApi.getRoles.get(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getWfmUsersMap() {
      var deferred = $q.defer();

      ReportApi.getWfmUsers.get(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getLwUsersMap() {
      var deferred = $q.defer();

      ReportApi.getLwUsers.get(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

  }

})();

(function () {
  'use strict';

  angular.module('app.ptt-device', [])
    .factory('PttDevice', pttDeviceService);

  /**ngInject*/
  function pttDeviceService($resource, $q, api) {
    var deviceApi = {
      getList: $resource(api.restUri + '/pttdevice/list'),
      newItem: $resource(api.restUri + '/pttdevice'),
      update: $resource(api.restUri + '/pttdevice/:id', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(api.restUri + '/pttdevice/:id')
    };

    return {
      getList: getList,
      add: add,
      deleteItem: deleteItem,
      update: update
    };

    /**
     * Get ptt device list
     * @returns {Function}
     */
    function getList() {
      var deferred = $q.defer();

      deviceApi.getList.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Update ptt device by id
     * @param device
     * @returns {Function}
     */
    function update(device) {
      console.log(device);
      var deferred = $q.defer();

      deviceApi.update.put({id: device._id}, device, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Add new ptt device to list
     * @param device
     * @returns {Function}
     */
    function add(device) {
      var deferred = $q.defer();

      deviceApi.newItem.save(device, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Remove ptt device by id
     * @returns {Function}
     */
    function deleteItem(deviceId) {
      var deferred = $q.defer();

      deviceApi.deleteItem.remove({id: deviceId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }


  }
})();

(function () {
  'use strict';

  angular.module('app.record-white-list', [])
    .factory('RecordWhiteList', recordWhiteList);

  /** @ngInject*/
  function recordWhiteList($resource, $q, api) {
    var recordWhiteListApi = {
      orgList: $resource(api.restUri + '/recordWhiteList/:orgId'),
      updateList: $resource(api.restUri + '/recordWhiteList/:orgId', {}, {put: {method: 'PUT'}})
    };

    return {
      getByOrgId: getByOrgId,
      update: update
    };

    function update(record) {
      var deferred = $q.defer();

      recordWhiteListApi.updateList.put({orgId: record.orgId}, record, deferred.resolve, deferred.reject);

      return deferred.promise;

    }

    function getByOrgId(orgId) {
      var deferred = $q.defer();
      if (this.canceller && this.canceller.$cancelRequest) {
        this.canceller.$cancelRequest()
      }
      this.canceller = recordWhiteListApi.orgList.query({orgId: orgId},  deferred.resolve, deferred.reject);

      return deferred.promise;
    }

  }

})();

(function () {
  'use strict';
  angular.module('app.progress-circular', [])
    .controller('ProgressCircular', ['$rootScope', '$scope', '$interval','ProgressCircularSer',ProgressCircular])
    .service('ProgressCircularSer', ProgressCircularSer);

  /** @ngInject*/
  function ProgressCircular($scope, $rootScope, $interval,ProgressCircularSer) {   
    var vm = this,  j = 0, counter = 0;  
    vm.modes = [ ];  
    vm.determinateValue = 30;  
    var promise;
    $scope.activate= ProgressCircularSer;
    $scope.someFunction = function(data) {
        if(data == true){
          $scope.start();
        }
        else{
          $interval.cancel(promise);
        }
    }
    $scope.$on('eventFired', function(event, data) {
        $scope.someFunction(data.data);
    })
    $scope.stop = function() {
      $interval.cancel(promise);
    };
    $scope.start = function() {
      $scope.stop();
      // promise = $interval(function() {
      //     ProgressCircularSer.activated = false;
      //     $scope.activate= ProgressCircularSer;
      // }, 300000);
    };
  }
  function ProgressCircularSer($rootScope) {
    this.activated = false; 
    return {      
      showProgress: showProgress,
    }
    function showProgress(message){ 
      this.activated = message; 
      $rootScope.$broadcast('eventFired', {
          data: message
      });
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.personal-group', [])
    .factory('PersonalGroup', PersonalGroup);

  /** @ngInject*/
  function PersonalGroup($resource, $q, api, CONSTANT, $rootScope) {

    var personalGroupApi = {
      getPersonalGroup: $resource(api.restUri + '/personalgroup/emergency/:userId'),
      newPersonalGroup: $resource(api.restUri + '/personalgroup/emergency', {}, {put: {method: 'PUT'}}),
      deleteOPersonalGroup: $resource(api.restUri + '/personalgroup/emergency/:userPhoneNumber', {}, {put: {method: 'PUT'}}),
      changeBulkubEmerGrp: $resource(api.restUri + '/personalgroup/emergency/bulkbulkEmerGrp'),
    };

    return {
      getByUserId: getByUserId,
      add: add,
      deleteItem: deleteItem,
      getPersonalGroupName: getPersonalGroupName,
      getPersonalGroupID: getPersonalGroupID,
      changeBulkubEmerGrp: changeBulkubEmerGrp
    };

    function add(personalGroup) {
      var deferred = $q.defer();

      personalGroupApi.newPersonalGroup.put(personalGroup, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getByUserId(userId) {
      var deferred = $q.defer();

      personalGroupApi.getPersonalGroup.query({userId: userId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    
    function deleteItem(userPhoneNumber) {
      var deferred = $q.defer();

      personalGroupApi.deleteOPersonalGroup.put({userPhoneNumber: userPhoneNumber}, {}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getPersonalGroupName(){
      return CONSTANT.PERSONALGROUP_EMERGENCY_NAME;
    }

    function getPersonalGroupID(){
      return CONSTANT.PERSONALGROUP_EMERGENCY_ID;
    }
    function changeBulkubEmerGrp(subscribers) {
      var deferred = $q.defer();
      personalGroupApi.changeBulkubEmerGrp.save({subscribers: subscribers}, function (resp) {deferred.resolve(resp);}, deferred.reject);

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.personal-contacts', [])
    .factory('PersonalContacts', personalContacts);

  /** @ngInject*/
  function personalContacts($resource, $q, api) {
    var personalContactsApi = {
      getList: $resource(api.restUri + '/contacts/personal/list/:ownerUserId'),
      getPersonalList: $resource(api.restUri + '/contacts/personal/personalContactList/:ownerUserId'),
      addUpdateBatch: $resource(api.restUri + '/contacts/personal/batch/:permissionsMask/:ownerUserId', {}, {put: {method: 'PUT', isArray: true}})
    };

    return {
      getList: getList,
      getPersonalList: getPersonalList,
      addUpdateBatch: addUpdateBatch
    };

    function getList(ownerUserId) {
      var deferred = $q.defer();

      personalContactsApi.getList.query({ownerUserId: ownerUserId},deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function addUpdateBatch(ownerUserId, contacts, permissionsMask) {
      var deferred = $q.defer();

      personalContactsApi.addUpdateBatch.put({permissionsMask: permissionsMask, ownerUserId: ownerUserId}, contacts, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getPersonalList(ownerUserId) {
      var deferred = $q.defer();

      personalContactsApi.getPersonalList.query({ownerUserId: ownerUserId},deferred.resolve, deferred.reject);

      return deferred.promise;
    }
  }

})();

(function () {
    'use strict';
    angular.module('app.passwords', [])
      .factory('Passwords', Passwords);
  
    /** @ngInject*/
    function Passwords() {

        return {
            getPattern: getPattern,
            getPassword: getPassword
          };
      
          function getPattern(strong){
            if (strong)   
                var pattern = /^(?!.*(.)\1\1)^(?!.*(abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|ABC|BCD|CDE|DEF|EFG|FGH|GHI|HIG|IJK|JKL|KLM|LMN|MNO|NOP|OPQ|PQR|QRS|RST|STU|TUV|UVW|VWX|WXY|XYZ|012|123|234|345|456|567|678|789))^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_@.#$=!%^)(\]:\*;\?\/\,`~\\&quot;}{'\|<>\[&\+-])[a-zA-Z\d_@.#$=!%^)(\]:\*;\?\/\,`~\\&quot;}{'\|<>\[&\+-]{10,15}$/;
            else
                var pattern = /^\S*$/;

            return pattern
        }

          function getPassword(length) {
            var capitalSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            var lowerSet = 'abcdefghijklmnopqrstuvwxyz';
            var numbersSet = '123456789';
            var specialSet = '_@.#$=!%^)(]:*;?/,`~\\}{\'|<>[&-';

            var pass1 = capitalSet.charAt(Math.random() * capitalSet.length) + lowerSet.charAt(Math.random() * lowerSet.length) + numbersSet.charAt(Math.random() * numbersSet.length) + specialSet.charAt(Math.random() * specialSet.length);

            var charSet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_@.#$=!%^)(]:*;?/,`~\\}{\'|<>[&-';

            var pass2 = Array.apply(null, Array(length - 4 || 10)).map(function () {
                return charSet.charAt(Math.random() * charSet.length);
            }).join('');

            return pass1+pass2;
          }

    }
})();  
(function () {
  'use strict';

  angular.module('app.organization', [])
    .factory('Organization', organizationService);

  /** @ngInject */
  function organizationService($q, $resource, CONSTANT, api, $location, $http) {

    var organizationApi = {
      list: $resource(api.restUri + '/organization/list'),
      listByReseller: $resource(api.restUri + '/organization/list/:resellerId'),
      listOrgByReseller: $resource(api.restUri + '/organization/orgList/:resellerId'),
      getById:$resource(api.restUri + '/organization/:organizationId/reseller/:resellerId', {}, {query: {method: 'GET'}, isArray:false}),
      update: $resource(api.restUri + '/organization/:id', {}, {put: {method: 'PUT'}}),
      allocation: $resource(api.restUri + '/organization/allocate/:organizationId/:resellerId/qty/:qty', {}, {put: {method: 'PUT'}}),
      deallocation: $resource(api.restUri + '/organization/deallocate/:organizationId/:resellerId/qty/:qty', {}, {put: {method: 'PUT'}}),
      allocation_dispatcher: $resource(api.restUri + '/organization/allocate/dispatcher/:organizationId/:resellerId/qty/:qty', {}, {put: {method: 'PUT'}}),
      deallocation_dispatcher: $resource(api.restUri + '/organization/deallocate/dispatcher/:organizationId/:resellerId/qty/:qty', {}, {put: {method: 'PUT'}}),
      newItem: $resource(api.restUri + '/organization'),
      remove: $resource(api.restUri + '/organization/:id'),
      parentList: $resource(api.restUri + '/organization/list/:id'),

      setOrganizationEmptyKeyFile: $resource(api.restUri + '/encryption/setEmptyKeyFile/:orgId', {}, {put: {method: 'POST'}}),
      uploadOrganizarionKeyFile : $resource(api.restUri + '/encryption/setNewKeyFile/upload/:orgId', {}, {put: {method: 'POST'}}),
      setOrganizationKeyFile: $resource(api.restUri + '/encryption/setNewKeyFile/:isDefault/:orgId', {}, {put: {method: 'POST'}}),
      getOrganizationEncStatus: $resource(api.restUri + '/encryption/getEncStatus/:orgId', {},  {query: {method: 'GET'}, isArray:false}),


      uploadVersionFile: $resource(api.restUri + '/projectFile/setProjectFile/upload/:orgId/:project', {}, {put: {method: 'POST'}}),
      deleteVersionFile: $resource(api.restUri + '/projectFile/setProjectFile/delete/:orgId/:project', {}, {put: {method: 'POST'}}),
      getSentinel: $resource(api.restUri + '/organization/sentinel/:organizationId',  {}, {query: {method: 'GET'}, isArray:false}),
      setSentinel: $resource(api.restUri + '/organization/sentinel', {}, {put: {method: 'POST'}}),
      removeSentinel: $resource(api.restUri + '/organization/sentinel/:orgId', {}, {put: {method: 'POST'}}),
      orgAllList:$resource(api.restUri + '/organization/orgAllList', {},  {query: {method: 'GET'}, isArray:false}),
      getOrgDetailById:$resource(api.restUri + '/organization/orgDetail/:orgId', {},  {query: {method: 'GET'}, isArray:false}),
      transferResellerItem: $resource(api.restUri + '/organization/transferReseller'),
      transferOrganizationItem: $resource(api.restUri + '/organization/transferOrganization'),

    };

    return {
      getList: getList,
      getListByReseller: getListByReseller,
      getListOrgByReseller: getListOrgByReseller,
      getById: getById,
      add: add,
      update: update,
      allocation: allocation,
      deallocation: deallocation,
      allocation_dispatcher: allocation_dispatcher,
      deallocation_dispatcher: deallocation_dispatcher,
      remove: remove,
      getParentList: getParentList,
      setOrganizationKeyFile: setOrganizationKeyFile,
      setOrganizationEmptyKeyFile: setOrganizationEmptyKeyFile,
      uploadOrganizarionKeyFile: uploadOrganizarionKeyFile,
      uploadVersionFile: uploadVersionFile,
      deleteVersionFile: deleteVersionFile,
      getOrganizationEncStatus: getOrganizationEncStatus,
      getSentinel:getSentinel,
      setSentinel:setSentinel,
      removeSentinel:removeSentinel,
      getOrgAllList:getOrgAllList,
      getOrgDetailById: getOrgDetailById,
      transferReseller: transferReseller,
      transferOrganization: transferOrganization
    };


    function getList() {
      var deferred = $q.defer();

      organizationApi.list.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getListByReseller(resellerId) {
      var deferred = $q.defer();

      organizationApi.listByReseller.query({resellerId : resellerId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function add(organization) {
      var deferred = $q.defer();

      organizationApi.newItem.save(organization, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }


    function update(organization) {
      var deferred = $q.defer();

      organizationApi.update.put({id: organization._id}, organization, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function allocation(organization) {
      var deferred = $q.defer();

      organizationApi.allocation.put({resellerId: organization.resellerId, organizationId: organization.organizationId, qty:organization.qty}, null, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function deallocation(organization) {
      var deferred = $q.defer();

      organizationApi.deallocation.put({resellerId: organization.resellerId, organizationId: organization.organizationId, qty:organization.qty}, null, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function allocation_dispatcher(organization) {
      var deferred = $q.defer();

      organizationApi.allocation_dispatcher.put({resellerId: organization.resellerId, organizationId: organization.organizationId, qty:organization.qty}, null, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function deallocation_dispatcher(organization) {
      var deferred = $q.defer();

      organizationApi.deallocation_dispatcher.put({resellerId: organization.resellerId, organizationId: organization.organizationId, qty:organization.qty}, null, deferred.resolve, deferred.reject);

      return deferred.promise;
    }



    function remove(organizationId) {
      var deferred = $q.defer();

      organizationApi.remove.delete({id: organizationId}, function (resp) {
        deferred.resolve(resp);

      }, deferred.reject);


      return deferred.promise;
    }


    function getParentList(parentId) {
      var deferred = $q.defer();

      organizationApi.parentList.query({id: parentId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getById(orgId,resId) {
      var deferred = $q.defer();

      organizationApi.getById.query({organizationId: orgId, resellerId:resId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function setOrganizationKeyFile(isDefault, org_id) {
      var deferred = $q.defer();

      organizationApi.setOrganizationKeyFile.put({isDefault: isDefault, orgId: org_id}, null, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    
    function setOrganizationEmptyKeyFile(org_id) {
      var deferred = $q.defer();

      organizationApi.setOrganizationEmptyKeyFile.put({orgId: org_id}, null, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    
    function setOrganizationEmptyKeyFile(org_id) {
      var deferred = $q.defer();

      organizationApi.setOrganizationEmptyKeyFile.put({orgId: org_id}, null, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getOrganizationEncStatus(org_id) {
      var deferred = $q.defer();

      organizationApi.getOrganizationEncStatus.query({ orgId: org_id }, null, deferred.resolve, deferred.reject)
      
      return deferred.promise;
    }

    function uploadOrganizarionKeyFile(fd,orgId) {
      var deferred = $q.defer();

      var request = {
      method: 'POST',
      url: api.restUri + '/encryption/setNewKeyFile/upload/'+ orgId,
      data: fd,
      headers: {
        'Content-Type': undefined
      }
    };
    // SEND THE FILES.
    $http(request)
      .success(function (res) {
        deferred.resolve(res);
      })
      .error(function (e) {
        var err = {};
        err.data = e;
        deferred.reject(err);
      });

      return deferred.promise;
    }

    function uploadVersionFile(fd, orgId, project){
      var deferred = $q.defer();
      var request = {
        method: 'POST',
        url: api.restUri + '/projectFile/setProjectFile/upload/' + orgId + '/' + project,
        data: fd,
        headers: {
          'Content-Type': undefined
        }
      };
      $http(request)
      .success(function (res) {
        deferred.resolve(res);
      })
      .error(function (e) {
        if(Object.keys(e).length === 0)
          e = {message: "File upload issue occurred, Try Again!"}
        
        var err = {};
        err.data = e;
        deferred.reject(err);
      });

      return deferred.promise;
    }

    function deleteVersionFile(orgId, project) {
      var deferred = $q.defer();

      organizationApi.deleteVersionFile.delete({orgId: orgId, project: project}, function (resp) {
        deferred.resolve(resp);

      }, deferred.reject);


      return deferred.promise;
    }

    function getListOrgByReseller(resellerId) {
      var deferred = $q.defer();

      organizationApi.listOrgByReseller.query({resellerId : resellerId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getSentinel(orgId) {
      var deferred = $q.defer();

      organizationApi.getSentinel.query({organizationId : orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function setSentinel(data) {
      var deferred = $q.defer();
      organizationApi.setSentinel.save(data, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function removeSentinel(orgId) {
      var deferred = $q.defer();
      organizationApi.removeSentinel.delete({orgId: orgId}, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function getOrgAllList() {
      var deferred = $q.defer();

      organizationApi.orgAllList.query(function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function getOrgDetailById(orgId) {
      var deferred = $q.defer();

      organizationApi.getOrgDetailById.query({orgId : orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function transferReseller(resellerData) {
      var deferred = $q.defer();

      organizationApi.transferResellerItem.save(resellerData, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }

    function transferOrganization(organizationData) {
      var deferred = $q.defer();

      organizationApi.transferOrganizationItem.save(organizationData, function (resp) {
        deferred.resolve(resp);
      }, deferred.reject);

      return deferred.promise;
    }
  }
})
();

(function () {
  'use strict';
  angular.module('app.orgFriends', [])
    .factory('OrgFriends', orgFriendsFactory);

  /** @ngInject*/
  function orgFriendsFactory($resource, $q, api, CONSTANT) {

    var orgFriendsApi = {
      listByOrgId: $resource(api.restUri + '/orgFriend/list/:orgFriendId'),
      newItem: $resource(api.restUri + '/orgFriend/:friendOrgIdFirst/:friendOrgIdSecond'),
      update: $resource(api.restUri + '/orgFriend/batch/:orgId', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(api.restUri + '/orgFriend/:friendOrgIdFrist/:friendOrgIdSecond')
    };

    return {
      getByOrgId: getByOrgId,
      add: add,
      update: update,
      deleteItem: deleteItem
    };

    function update(org) {
      var deferred = $q.defer();

      orgFriendsApi.update.put({orgId: org._id}, org, deferred.resolve, deferred.reject);

      return deferred.promise;

    }

    function add(org1, org2) {
      var deferred = $q.defer();

      orgFriendsApi.newItem.save(org1, org2, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Get organization firends
     * @returns {Function}
     */
    function getByOrgId(orgId) {
      var deferred = $q.defer();

      orgFriendsApi.listByOrgId.query({orgFriendId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Remove org friend by id
     * @returns {Function}
     */
    function deleteItem(orgId) {
      var deferred = $q.defer();

      orgFriendsApi.deleteItem.remove({id: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.operator', [])
    .factory('Operator', operatorFactory);

  /** @ngInject*/
  function operatorFactory() {
    return {
      getList: getList
    };

    function getList() {
      return [{
        id: 1,
        name: 'Telus'
      }];
    }
  }


})();

(function () {
  'use strict';

  angular.module('app.manufacturer', [])
    .factory('Manufacturer', manufacturerService);


  /**ngInject*/
  function manufacturerService($q, $resource, api, CONSTANT) {
    var manufacturerApi = {
      softList: $resource(api.restUri + '/manufacturer/list/soft'),
      deviceList: $resource(api.restUri + '/manufacturer/list/device'),
      getById: $resource(api.restUri + '/manufacturer/:id'),
      newItem: $resource(api.restUri + '/manufacturer'),
      update: $resource(api.restUri + '/manufacturer/:id', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(api.restUri + '/manufacturer/:id'),
      deleteSoftwareItem: $resource(api.restUri + '/manufacturer/soft/:id')
    };

    return {
      getSoftList: getSoftList,
      getById: getById,
      add: add,
      update: update,
      remove: remove,
      removeSoft: removeSoft,
      getDeviceList: getDeviceList
    };

    /**
     * Remove item by id
     * @param itemId
     */
    function remove(itemId) {
      var deferred = $q.defer();

      manufacturerApi.deleteItem.remove({id: itemId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Remove software item by id
     * @param itemId
     */
    function removeSoft(itemId) {
      var deferred = $q.defer();

      manufacturerApi.deleteSoftwareItem.remove({id: itemId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Update item by id
     * @param item
     */
    function update(item) {
      var deferred = $q.defer();

      manufacturerApi.update.put({id: item._id}, item, deferred.resolve, deferred.reject);

      return deferred.promise;
    }


    /**
     * Return software manufacturer list
     * @returns promise
     */
    function getSoftList() {
      var deferred = $q.defer();

      manufacturerApi.softList.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Return device manufacturer list
     * @returns promise
     */
    function getDeviceList() {
      var deferred = $q.defer();

      manufacturerApi.deviceList.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Return  manufacturer item by id
     * @param id
     * @returns promise
     */
    function getById(id) {
      var deferred = $q.defer();

      manufacturerApi.getById.get({id: id}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Add new item manufacture
     * @param item
     */
    function add(item) {
      var deferred = $q.defer();

      manufacturerApi.newItem.save(item, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.location-history', [])
    .factory('locationHistory', locationHistorysService);

  /** @ngInject*/
  function locationHistorysService($resource, $q, CONSTANT, api) {
    this.canceller = $q.defer();
    var LocationHistoryApi = {
      getLocationbyOrg: $resource(api.restUri + '/locationHistory/getLocationbyOrg/:orgId/:startTime/:endTime'),
      getAllLocationbyOrg: $resource(api.restUri + '/locationHistory/getAllLocationbyOrg/:orgId/:startTime/:endTime'),
      getLocationbyUser: $resource(api.restUri + '/locationHistory/getLocationbyUser/:userId/:startTime/:endTime')
    };



    return {
      getLocationbyOrg : getLocationbyOrg,
      getLocationbyUser : getLocationbyUser,
      getAllLocationbyOrg : getAllLocationbyOrg
    };

    function getLocationbyOrg(orgId, start, end) {
      var deferred = $q.defer();

      LocationHistoryApi.getLocationbyOrg.query({orgId: orgId, startTime: start, endTime: end}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getAllLocationbyOrg(orgId, start, end) {
      var deferred = $q.defer();

      LocationHistoryApi.getAllLocationbyOrg.query({orgId: orgId, startTime: start, endTime: end}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }


    function getLocationbyUser(userId, start, end) {
      var deferred = $q.defer();

      LocationHistoryApi.getLocationbyUser.query({userId: userId, startTime: start, endTime: end}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }


  }

})();

(function () {
  'use strict';

  angular.module('app.jobs', [])
    .factory('Job', jobService);

  /** @ngInject*/
  function jobService($resource, $q, api, CONSTANT) {
    var jobsApi = {
      runJob: $resource(api.restUri + '/jobs/run/:id'),
      getLog: $resource(api.restUri + '/jobs/log/:id')
    };

    return {
      runJob: runJob,
      getLog: getLog,
      getLogsMapping: getLogsMapping
    };

    function runJob(id){
      var deferred = $q.defer();

      jobsApi.runJob.get({id: id}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getLog(id) {
      var deferred = $q.defer();

      jobsApi.getLog.get({id: id}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getLogsMapping() {
      return {
        "node": {
          "debug": 10,
          "node":  11
        },
        "provisioning": {
          "init": 1,
          "run" : 2,
          "license": 3,
          "dbInit":  4,
          "dbIntegrity": 5
        },
        "gpsArchiver": {
          "init": 6,
          "run":  7
        },
        "mongoHa":{
          "init" : 8,
          "run" :  9
        }
      }
    }
  }

})();

(function () {
  'use strict';
  angular.module('app.license', [])
    .factory('License', licenceFactory);

  /** @ngInject*/
  function licenceFactory(msApi, $q, $resource, api, CONSTANT) {

     var licenseAPI = {   //shahar- remove license
      getLicenseTemplates: $resource(api.restUri + '/license/templates'),
      licenseToMask: $resource(api.restUri + '/license/convert/to/permissionMask'),
      MaskToLicense: $resource(api.restUri + '/license/convert/to/license/:permissionMask', {}, {put: {method: 'PUT'}})
    //   list: $resource(api.restUri + '/license/list'),
    //   byId: $resource(api.restUri + '/license/:id'),
    //   new: $resource(api.restUri + '/license'),
    //   update: $resource(api.restUri + '/license/:id', {}, {put: {method: 'PUT'}}),
    //   delete: $resource(api.restUri + '/license/:id'),

    //   allocationList: $resource(api.restUri + '/license/allocation/:orgNodeId'),
    //   allocationAdd: $resource(api.restUri + '/license/allocation'),
    //   allocationRevoke: $resource(api.restUri + '/license/allocation/:allocationId'),
    //   allocationRevokeAtReseller: $resource(api.restUri + '/license/allocationAtReseller/:allocationId'),

    //   assignmentById: $resource(api.restUri + '/license/assignment/:subscriberId'),
    //   assignmentAdd: $resource(api.restUri + '/license/assignment'),
    //   assignmentAddAuto: $resource(api.restUri + '/license/assignment/auto'),
    //   assignmentRevoke: $resource(api.restUri + '/license/assignment/:assignmentId')
     };

    return {
      // getList: getBundleList,
      // getOptions: getOptions,
      // update: updateBundle,
      // add: addBundle,
      // deleteItem: deleteBundle,

      // getAllocationList: getAllocationList,
      // addAllocation: addAllocation,
      // revokeAllocation: revokeAllocation,
      // revokeAllocationAtReseller : revokeAllocationAtReseller,

      // getAssignmentById: getAssignmentById,
      // addAssignment: addAssignment,
      // addAutoAssignment: addAutoAssignment,
      // revokeAssignment: revokeAssignment

      getLicenseTemplates: getLicenseTemplates,
      getPermissionMask: getPermissionMask,
      getLicense: getLicense


    };

    // //Get list of all bundles
    // function getBundleList() {
    //   var deferred = $q.defer();

    //   licenseAPI.list.query(
    //     function(resp){
    //       deferred.resolve(resp)},
    //     function(err){
    //       deferred.reject(err)}
    //     );

    //   return deferred.promise;
    // }

    // //TODO: need to check if this is needed
    // function getOptions() {
    //   return msApi.resolve('service.options@get');
    // }

    // //Add new Bundle
    // function addBundle(license) {
    //   var deferred = $q.defer();

    //   licenseAPI.new.save(license, deferred.resolve, deferred.reject);

    //   return deferred.promise;
    // }

    // //Update an existing bundle
    // function updateBundle(license) {
    //   var deferred = $q.defer();

    //   licenseAPI.update.put({id: license._id}, license, function (resp) {
    //     deferred.resolve(resp);
    //   }, function (resp) {
    //     deferred.reject(resp);
    //   });

    //   return deferred.promise;
    // }

    // //Delete Bundle
    // function deleteBundle(licenseId) {
    //   var deferred = $q.defer();

    //   licenseAPI.delete.remove({id: licenseId}, function (resp) {
    //     deferred.resolve(resp);
    //   }, function (resp) {
    //     deferred.reject(resp);
    //   });

    //   return deferred.promise;
    // }


    // /*
    // *Allocations methods
    //  */

    // //Get allocation list by org node Id
    // function getAllocationList(orgNodeId) {
    //   var deferred = $q.defer();

    //   licenseAPI.allocationList.query({orgNodeId: orgNodeId}, deferred.resolve, deferred.reject);

    //   return deferred.promise;
    // }


    // //Add a new Allocation
    // function addAllocation(allocation) {
    //   var deferred = $q.defer();

    //   licenseAPI.allocationAdd.save(allocation, deferred.resolve, deferred.reject);

    //   return deferred.promise;
    // }

    // //Revoke Allocation
    // function revokeAllocation(allocationId) {
    //   var deferred = $q.defer();

    //   licenseAPI.allocationRevoke.remove({allocationId: allocationId}, deferred.resolve, deferred.reject);

    //   return deferred.promise;
    // }

    // //Revoke Allocation
    // function revokeAllocationAtReseller(allocationId) {
    //   var deferred = $q.defer();

    //   licenseAPI.allocationRevokeAtReseller.remove({allocationId: allocationId}, deferred.resolve, deferred.reject);

    //   return deferred.promise;
    // }

    // /*
    //  *Assignment methods
    //  */

    // //Get Assignment by Subscriber ID
    // function getAssignmentById(subscriberId) {
    //   var deferred = $q.defer();

    //   licenseAPI.assignmentById.query({subscriberId: subscriberId}, deferred.resolve, deferred.reject);

    //   return deferred.promise;
    // }

    // //Add new assignment
    // function addAssignment(assignment) {
    //   var deferred = $q.defer();

    //   licenseAPI.assignmentAdd.save(assignment, deferred.resolve, deferred.reject);

    //   return deferred.promise;
    // }

    // //Add new assignment basing on oracle permission mask
    // function addAutoAssignment(subscriberId) {
    //   var deferred = $q.defer();

    //   licenseAPI.assignmentAddAuto.save({subscriberId: subscriberId}, deferred.resolve, deferred.reject);

    //   return deferred.promise;
    // }

    // //Revoke assignment
    // function revokeAssignment(assignmentId) {
    //   var deferred = $q.defer();

    //   licenseAPI.assignmentRevoke.remove({assignmentId: assignmentId}, deferred.resolve, deferred.reject);

    //   return deferred.promise;
    // }

   //Get license templates
    function getLicenseTemplates() {
      var deferred = $q.defer();

      licenseAPI.getLicenseTemplates.query(
            function(resp){
              deferred.resolve(resp)},
            function(err){
              deferred.reject(err)}
            );

      return deferred.promise;
    }

    //convert license to permission mask
    function getPermissionMask(license) {
      var deferred = $q.defer();

      licenseAPI.licenseToMask.save(license, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    //convert permission mask to license
    function getLicense(mask) {
      var deferred = $q.defer();

      licenseAPI.MaskToLicense.save({permissionMask: mask}, {}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

  }

})();

(function () {
  'use strict';
  angular.module('app.interceptor', [])
    .factory('tokenRefresh', tokenRefresh);

  /** @ngInject*/
  function tokenRefresh($q, $injector,$rootScope,ProgressCircularSer) {
    return {
      request : function request (config) {
        $rootScope.loaderStateTotalCount= $rootScope.loaderStateTotalCount + 1;  
        $rootScope.loaderStateCount= $rootScope.loaderStateCount + 1;                      
        $rootScope.loaderState = true;
        ProgressCircularSer.showProgress(true);
        
        

        if($rootScope.loaderStateCount == 1 && $rootScope.loaderStatePercentage < 95)
          $rootScope.loaderStatePercentage = $rootScope.loaderStatePercentage + 5;

        // $rootScope.$emit('loaderUpdatedValue');
        $rootScope.$emit('loaderMainUpdatedValue');
        // $rootScope.$emit('loaderUpdatedValueMain');
        return config;
      },
      response: function(res) {
        var Auth = $injector.get('Auth');
        var User = $injector.get('User');

        if(res.config.url.indexOf("api") !== -1 && res.config.url.indexOf("authenticate") < 0){
          var refreshTokenHeader = res.headers("X-Refresh-Token");
          if(refreshTokenHeader && parseInt(refreshTokenHeader) !== 0){

            User.refreshToken()
              .then(function(resp){
                Auth.setAuthToken(resp.token);
                console.log("Token has been refreshed");
              })
              .catch(function(err){
                console.log("Error", err)
              });

          }
        }
        $rootScope.loaderStateCount= $rootScope.loaderStateCount - 1;   
        $rootScope.loaderStatePercentage= (100 - ((($rootScope.loaderStateCount/$rootScope.loaderStateTotalCount)*100))); 
        // console.log($rootScope.loaderStatePercentage +' ==='+ $rootScope.loaderStateCount  )
        if($rootScope.loaderStateCount == 0)  
        {
          $rootScope.loaderStatePercentage=100;
          setTimeout(function(){
            $rootScope.loaderStatePercentage=0;
            // $rootScope.$emit('loaderUpdatedValue');
            $rootScope.$emit('loaderMainUpdatedValue');
          }, 900);
          setTimeout(function(){
            ProgressCircularSer.showProgress(false);
          }, 500);
          $rootScope.loaderStateTotalCount = 0;
        }   
        // $rootScope.$emit('loaderUpdatedValue');
        $rootScope.$emit('loaderMainUpdatedValue');
        // $rootScope.$emit('loaderUpdatedValueMain');
        return res || $q.when(res);
      },
      responseError: function(err) {
        var Auth  = $injector.get('Auth');
        var state = $injector.get('$state');

        if(err.config && err.config.url.indexOf("api") !== -1){
          if(err.status === 401){
            Auth.closeMdPop();
            state.go('app.pages_auth_login');
            Auth.logout();
            location.reload();
          }
        }
        $rootScope.loaderStateCount= $rootScope.loaderStateCount - 1;   
        $rootScope.loaderStatePercentage= (100 - ((($rootScope.loaderStateCount/$rootScope.loaderStateTotalCount)*100))); 
        if($rootScope.loaderStateCount == 0)     
        {
          // $rootScope.loaderStatePercentage=100;
          // setTimeout(function(){$rootScope.loaderState = false;$rootScope.loaderStatePercentage=0;$rootScope.$emit('loaderUpdatedValue');}, 1800);          
          $rootScope.loaderStateTotalCount = 0;
          ProgressCircularSer.showProgress(false);
        }   
        // $rootScope.$emit('loaderUpdatedValue');
        $rootScope.$emit('loaderMainUpdatedValue');
        // $rootScope.$emit('loaderUpdatedValueMain');
        return $q.reject(err);
      }
    }
  }
})();

(function () {
  'use strict';
  angular.module('app.helper', [])
    .factory('Helper', helperFactory);

  /** @ngInject*/
  function helperFactory() {
    return {
      guid: guid
    };

    function guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }

      return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();

    }
  }
})();

(function () {
  'use strict';

  angular.module('app.handset-type', [])
    .factory('HandsetType', handsetTypeFactory);

  /** @ngInject*/
  function handsetTypeFactory() {
    return {
      getList: getList
    };

    function getList() {
      return [
        {
          id: 1,
          name: 'UNKNOWN'
        }
      ];
    }
  }


})();

(function () {
  'use strict';
  angular.module('app.group', [])
    .factory('Group', groupFactory);

  /** @ngInject*/
  function groupFactory($resource, $q, api, CONSTANT, $translate) {
    this.canceller = $q.defer();
    var groupApi = {
      getById: $resource(api.restUri + '/group/:groupId', {}, {query: {method: 'GET'}, isArray:false}),
      orgList: $resource(api.restUri + '/group/list/:organizationId'),
      // allGroupsList: $resource(api.restUri + '/group/allGroupsList/:organizationId',  [], [], { cancellable: true }),
      allGroupsList: $resource(api.restUri + '/group/allGroupsList/:organizationId'),
      allGroupList: $resource(api.restUri + '/group/allGroupList/:organizationId'),
      groupsListByType: $resource(api.restUri + '/group/groupsListByType/:organizationId/:typeId/:affiliatedFlag'),
      groupListByType: $resource(api.restUri + '/group/groupListByType/:organizationId/:typeId'),
      contactList: $resource(api.restUri + '/group/contactlist/:organizationId'),
      subscriberList: $resource(api.restUri + '/group/subscriberlist/:organizationId'),
      emergencyGroup: $resource(api.restUri + '/group/emergencyGroup/:organizationId'),
      listByMember: $resource(api.restUri + '/group/listbymember/:subscriberId'),
      listFilteredByMember: $resource(api.restUri + '/group/listFilteredByMember/:subscriberId'),
      contactListByMember: $resource(api.restUri + '/group/contactlistbymember/:subscriberId'),
      contactListFilteredByMember: $resource(api.restUri + '/group/contactListFilteredByMember/:subscriberId'),
      newItem: $resource(api.restUri + '/group'),
      update: $resource(api.restUri + '/group/:id', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(api.restUri + '/group/:id'),
      bulkRemoveAss: $resource(api.restUri + '/group/bulkRemoveGroup'),
    };

    return {
      getById: getById,
      getByOrgId: getByOrgId,
      getAllGroupsList: getAllGroupsList,
      getAllGroupList: getAllGroupList,
      groupsListByType: groupsListByType,
      groupListByType: groupListByType,
      getContactsByOrgId: getContactsByOrgId,
      getSubscriberListsByOrgId: getSubscriberListsByOrgId,
      getEmergencyGroupsByOrgId: getEmergencyGroupsByOrgId,
      getBySubscriberId: getBySubscriberId,
      getGrpFilteredBySubscriberId: getGrpFilteredBySubscriberId,
      getContactsBySubscriberId: getContactsBySubscriberId,
      getContactsFilteredBySubId: getContactsFilteredBySubId,
      getGroupTypes: getGroupTypes,
      getContactTypes: getContactTypes,
      getShortTypes: getShortTypes,
      add: add,
      update: update,
      deleteItem: deleteItem,
      bulkRemoveAss: bulkRemoveAss
    };

    function getById(groupId) {
      var deferred = $q.defer();

      groupApi.getById.query({groupId: groupId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function update(group) {
      var deferred = $q.defer();

      groupApi.update.put({id: group._id}, group, deferred.resolve, deferred.reject);

      return deferred.promise;

    }

    function add(group) {
      var deferred = $q.defer();

      groupApi.newItem.save(group, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Get organization Groups
     * @returns {Function}
     */
    function getByOrgId(orgId) {
      var deferred = $q.defer();

      groupApi.orgList.query({organizationId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    /**
     * Get all Subscriber's Groups
     * @returns {Function}
     */
    function getAllGroupsList(orgId) {
      var deferred = $q.defer();
      if (this.canceller && this.canceller.$cancelRequest) {
        this.canceller.$cancelRequest()
      }
      this.canceller = groupApi.allGroupsList.query({organizationId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    /**
     * Get all Subscriber's Groups
     * @returns {Function}
     */
    function getAllGroupList(orgId) {
      var deferred = $q.defer();
      if (this.canceller && this.canceller.$cancelRequest) {
        this.canceller.$cancelRequest()
      }
      this.canceller = groupApi.allGroupList.query({organizationId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    /**
     * Get all Subscriber's Groups
     * @returns {Function}
     */
    function groupsListByType(orgId,typeId,affiliatedFlag) {
      var deferred = $q.defer();
      if (this.canceller && this.canceller.$cancelRequest) {
        this.canceller.$cancelRequest()
      }
      this.canceller = groupApi.groupsListByType.query({organizationId: orgId,typeId:typeId,affiliatedFlag:affiliatedFlag}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    /**
     * Get all Subscriber's Groups
     * @returns {Function}
     */
    function groupListByType(orgId,typeId) {
      var deferred = $q.defer();
      if (this.canceller && this.canceller.$cancelRequest) {
        this.canceller.$cancelRequest()
      }
      this.canceller = groupApi.groupListByType.query({organizationId: orgId,typeId:typeId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    /**
     * Get organization Contacts
     * @returns {Function}
     */
    function getContactsByOrgId(orgId) {
      var deferred = $q.defer();

      groupApi.contactList.query({organizationId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Get organization SubscriberLists
     * @returns {Function}
     */
    function getSubscriberListsByOrgId(orgId) {
      var deferred = $q.defer();

      groupApi.subscriberList.query({organizationId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

     /**
     * Get organization emergency groups
     * @returns {Function}
     */
    function getEmergencyGroupsByOrgId(orgId) {
      var deferred = $q.defer();

      groupApi.emergencyGroup.query({organizationId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Returns list of Groups by subscriber Id
     * @returns {Function}
     */
    function getBySubscriberId(subscriberId) {
      var deferred = $q.defer();

      groupApi.listByMember.query({subscriberId: subscriberId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Returns list of Groups by subscriber Id
     * @returns {Function}
     */
    function getGrpFilteredBySubscriberId(subscriberId) {
      var deferred = $q.defer();

      groupApi.listFilteredByMember.query({subscriberId: subscriberId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Returns list of Contacts by subscriber Id
     * @returns {Function}
     */
    function getContactsBySubscriberId(subscriberId) {
      var deferred = $q.defer();

      groupApi.contactListByMember.query({subscriberId: subscriberId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Returns list of Contacts by subscriber Id
     * @returns {Function}
     */
    function getContactsFilteredBySubId(subscriberId) {
      var deferred = $q.defer();

      groupApi.contactListFilteredByMember.query({subscriberId: subscriberId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Remove group by id
     * @returns {Function}
     */
    function deleteItem(groupId) {
      var deferred = $q.defer();

      groupApi.deleteItem.remove({id: groupId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    function bulkRemoveAss(subscribers,deleteType) {
      var deferred = $q.defer();
      groupApi.bulkRemoveAss.save({subscribers: subscribers,type: deleteType}, function (resp) {deferred.resolve(resp);}, deferred.reject);
      return deferred.promise;
    }

    function getGroupTypes() {
        return [{
            id: "2",
            name: $translate.instant("RADIO_GROUP_CHAT")
        }, {
            id: "1",
            name: $translate.instant("CONFERENCE_GROUP_BROADCAST")
        }, {
            id: "9",
            name: $translate.instant("EMERGENCY_GROUP")
        }
        // , {
        //   id: "10",
        //   name: $translate.instant("FORWARD_GROUP")
        // }
        ]
    }

    function getContactTypes() {
        return [{
            id: "4",
            name: $translate.instant("ORGANIZATION_CONTACT_GROUP")
        }, {
            id: "8",
            name: $translate.instant("CONTACTS_TEMPLATE")
        }]
    }

    function getShortTypes() {
      return {'1': $translate.instant("CONFERENCE_GROUP_BROADCAST"), '2': $translate.instant("RADIO_GROUP_CHAT"),'4': $translate.instant("ORGANIZATION_CONTACT_GROUP"), '8': $translate.instant("CONTACTS_TEMPLATE") ,'9': $translate.instant("EMERGENCY_GROUP") ,'10': $translate.instant("FORWARD_GROUP")};
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.fwrdgroup', [])
    .factory('Fwrdgroup', FwrdgroupFactory);


  /** @ngInject **/
  function FwrdgroupFactory(msApi, $resource, $q, api, CONSTANT) {

    var apiUrl = api.restUri || CONSTANT.API_URL;

    var fwrdgroupApi = {
      update: $resource(apiUrl + '/fwrdgroup/:id', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(apiUrl + '/fwrdgroup/:id'),
      bulkRemoveAss: $resource(apiUrl + '/fwrdgroup/bulkRemoveAss'),
      getById: $resource(apiUrl + '/fwrdgroup/:id'),
      getUserById: $resource(apiUrl + '/fwrdgroup/user/:userid'),
      newItem: $resource(apiUrl + '/fwrdgroup')
    };

    return {
      getList: getList,
      add: add,
      update: update,
      deleteItem: deleteItem,
      getUserIds: getUserIds,
      getFwrdGroupBySubscriberId: getFwrdGroupBySubscriberId,
      bulkRemoveAss: bulkRemoveAss
    };

    function deleteItem(fwrdgroupId){
      var deferred = $q.defer();

      fwrdgroupApi.deleteItem.delete({id: fwrdgroupId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    function bulkRemoveAss(subscribers) {
      var deferred = $q.defer();
      subscriberApi.bulkRemoveAss.remove({subscribers: subscribers}, function (resp) {deferred.resolve(resp);}, deferred.reject);
      return deferred.promise;
    }
    
    function add(fwrdgroup) {
      var deferred = $q.defer();

      fwrdgroupApi.newItem.save(fwrdgroup, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function update(fwrdgroup) {
      var deferred = $q.defer();

      fwrdgroupApi.update.put({id: fwrdgroup._id}, fwrdgroup, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getUserIds(fwrdgroupId){      
      var deferred = $q.defer();

      fwrdgroupApi.getById.query({id: fwrdgroupId}, function (resp) {
        deferred.resolve(resp);
      });
      return deferred.promise;
    }
    
    function getFwrdGroupBySubscriberId(fwrdUserId){      
      var deferred = $q.defer();

      fwrdgroupApi.getUserById.query({userid: fwrdUserId}, function (resp) {
        deferred.resolve(resp);
      });
      return deferred.promise;
    }

    function getList() {
      return msApi.resolve('contact@get');
    }


  }
})();

(function () {
  'use strict';
  angular.module('app.exception-handler', [])
    .factory('ExceptionHandler', exceptionHandler);

  /** @ngInject*/
  function exceptionHandler($mdToast, $translate) {
    return {
      show: show,
      log: log,
      showError: showError,
      showInfo: showInfo
    };

    function show(err) {
      var message = "Error: ";
      if (err.data){
        if(err.data.error){
          if(err.data.error == 'UserLimitExceeded')
            message += $translate.instant(err.data.error);
          else
            message += err.data.error;
        } 
        if(err.data.message){
          if(err.data.message === "forbidden"){
            message += $translate.instant("API_FORBIDDEN_ERROR");
          }
          else{
            message += err.data.message;
          }
        }

        //if(err.data.exception) message += "   . Tech. info: " + err.data.exception;

        $mdToast.show(
          $mdToast.simple()
            .textContent(message)
            .position("Top right")
            .hideDelay(5000)
        );
      }
    }
    
    function showError(err) {
      var message = "Error: ";
      if (err){
        message = message + ' '+ err
        $mdToast.show(
          $mdToast.simple()
            .textContent(message)
            .position("Top right")
            .hideDelay(5000)
        );
      }
    }
    function showInfo(err) {
      var message = "";
      if (err){
        message = message + ' '+ err
        $mdToast.show(
          $mdToast.simple()
            .textContent(message)
            .position("Top right")
            .hideDelay(5000)
        );
      }
    }
    function log(err) {
      console.log("Error: ", err)
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.device', [])
    .factory('Device', deviceService);

  /**ngInject*/
  function deviceService($resource, $q, api, CONSTANT) {
    var deviceApi = {
      getList: $resource(api.restUri + '/device/list'),
      newItem: $resource(api.restUri + '/device'),
      update: $resource(api.restUri + '/device/:id', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(api.restUri + '/device/:id')
    };

    return {
      getList: getList,
      add: add,
      deleteItem: deleteItem,
      update: update
    };

    /**
     * Get device list
     * @returns {Function}
     */
    function getList() {
      var deferred = $q.defer();

      deviceApi.getList.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Update device by id
     * @param device
     * @returns {Function}
     */
    function update(device) {
      var deferred = $q.defer();

      deviceApi.update.put({id: device._id}, device, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Add new device to list
     * @param device
     * @returns {Function}
     */
    function add(device) {
      var deferred = $q.defer();

      deviceApi.newItem.save(device, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Remove device by id
     * @returns {Function}
     */
    function deleteItem(deviceId) {
      var deferred = $q.defer();

      deviceApi.deleteItem.remove({id: deviceId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }


  }
})();

(function () {
  'use strict';

  angular.module('app.country', [])
    .factory('Country', countryService);

  /** @ngInject*/
  function countryService($resource, $q, api, CONSTANT) {

    var countryApi = {
      getList: $resource(api.restUri + '/countries/list')
    };

    return {
      getList: getList
    };

    function getList() {
      var deferred = $q.defer();

      countryApi.getList.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }
  }

})();

/**
 *
 * Context service include next $emits:
 *  updatedOrganizationId,
 *  updatedResellerId,
 *  clearOrganizationId,
 *  clearResellerId
 *
 */

(function () {
  'use strict';

  angular.module('app.context', [])
    .factory('Context', contextService);

  /**ngInject*/
  function contextService($rootScope) {
    var state = '',
      resellerId = '',
      lastResellerId = '',
      organizationId = '',
      reseller = {},
      organization = {},
      organizationValueName = 'organization',
      resellerValueName = 'reseller';


    return {
      setState: setState,
      setResellerId: setResellerId,
      setOrganizationId: setOrganizationId,
      getOrganizationId: getOrganizationId,
      setOrganization: setOrganization,
      getOrganization: getOrganization,
      getResellerId: getResellerId,
      getState: getState,
      getLastResellerId: getLastResellerId,
      getReseller: getReseller,
      setReseller: setReseller,
      clear: clearResellerId
    };

    //====================================

    /**
     * Set state for context
     * @param stateName - name of State
     */
    function setState(stateName) {
      state = stateName;
    }

    /**
     *
     * @returns {string} - state of Context
     */
    function getState() {
      return state;
    }

    /**
     *  Set organizationId for context
     * @param id - organizationId
     */
    function setOrganizationId(id) {
      organizationId = id;

      changeStateStartEmit(organizationValueName, 'updatedOrganizationId');
      $rootScope.$emit('upadatebranding');
    }

    /**
     *  Get organizationId of context
     */
    function getOrganizationId() {
      return organizationId;
    }

    /**
     *
     * @param org
     */
    function setOrganization(org){
      organization = org;
    }

    /**
     *
     * @returns organization
     */
    function getOrganization(){
      return organization;
    }

	  /**
     *
     * @param res
     */
    function setReseller(res){
      reseller = res;
    }

	  /**
     *
     * @returns reseller
     */
    function getReseller(){
      return reseller;
    }

    /**
     * Set resellerId for context
     * @param id - resellerId
     */
    function setResellerId(id) {
      resellerId = id;
      lastResellerId = id;

      changeStateStartEmit(resellerValueName, 'updatedResellerId');
      $rootScope.$emit('upadatebranding');
    }

    /**
     * get resellerId of context
     */
    function getResellerId() {
      return resellerId;
    }

    function getLastResellerId() {
      return lastResellerId;
    }

    /**
     *
     * @param state - can be "reseller" or "organization"
     * @param emitName - can be "updatedOrganizationId" or "updatedResellerId"
     */
    function changeStateStartEmit(state, emitName) {
      setState(state);
      clearStateId();
      $rootScope.$emit(emitName);
    }

    /**
     *  Clear organizationId and emit event for that "clearOrganizationId"
     */
    function clearStateId() {
      if (state === organizationValueName) {
        resellerId = '';
        reseller = {};
        $rootScope.$emit('clearResellerId');
      } else {
        organizationId = '';
        $rootScope.$emit('clearOrganizationId');
      }
    }

    /**
     *  Clear resellerId and emit event for that "clearResellerId"
     */
    function clearResellerId() {
      resellerId = '';
      $rootScope.$emit('clearResellerId');
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.contact', [])
    .factory('Contact', contactFactory);


  /** @ngInject **/
  function contactFactory(msApi, $resource, $q, api, CONSTANT, $rootScope) {

    var apiUrl = api.restUri || CONSTANT.API_URL;

    var contactApi = {
      byOrgId: $resource(apiUrl + '/contact/list/:id'),
      update: $resource(apiUrl + '/contact/:id', {}, {put: {method: 'PUT'}}),
      removeItem: $resource(apiUrl + '/contact/:id'),
      newItem: $resource(apiUrl + '/contact')
    };

    return {
      getList: getList,
      add: add,
      update: update,
      removeItem: removeItem,
      getByOrganizationId: getByOrganizationId
    };

    function removeItem(contactId){
      var deferred = $q.defer();

      contactApi.removeItem.delete({id: contactId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function add(contact) {
      var deferred = $q.defer();

      contactApi.newItem.save(contact, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function update(contact) {
      var deferred = $q.defer();

      contactApi.update.put({id: contact._id}, contact, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getList() {
      return msApi.resolve('contact@get');
    }

    function getByOrganizationId(orgId) {
      var deferred = $q.defer();

      contactApi.byOrgId.query({id: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.server-config', [])
    .factory('Config', configService);

  /**ngInject*/
  function configService($resource, $q, api, CONSTANT, $rootScope) {

    var apiUrl = api.restUri || CONSTANT.API_URL;

    var configApi = {
      getList: $resource(apiUrl + '/config/list'),
      getFilterList: $resource(apiUrl + '/config/configList'),
      addItem: $resource(apiUrl + '/config'),
      getEnvConfig: $resource(apiUrl + '/config/getEnvConfig', {}, { query: { method: 'GET' }, isArray: false }),
      setItem: $resource(apiUrl + '/config/:id', {}, { put: { method: 'PUT' } }),
      deleteItem: $resource(apiUrl + '/config/:id')
    };

    return {
      getList: getList,
      getFilterList: getFilterList,
      add: addItem,
      delete: deleteItem,
      update: updateItem,
      getEnvConfig: getEnvConfig
    };

    /**
     * Get config constants list
     * @returns {Function}
     */
    function getList() {
      var deferred = $q.defer();

      configApi.getList.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Set constant value by id
     * @param param
     * @returns {Function}
     */
    function updateItem(param) {
      var deferred = $q.defer();

      configApi.setItem.put({ id: param.parameter_id }, param, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Add new parameter to list
     * @param param
     * @returns {Function}
     */
    function addItem(param) {
      var deferred = $q.defer();

      configApi.addItem.save(param, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Remove parameter by id
     * @returns {Function}
     */
    function deleteItem(paramId) {
      var deferred = $q.defer();

      configApi.deleteItem.remove({ id: paramId }, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Get config constants list
     * @returns {Function}
     */
    function getFilterList() {
      var deferred = $q.defer();

      configApi.getFilterList.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    function getEnvConfig() {
      var deferred = $q.defer();

      configApi.getEnvConfig.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.client-version', [])
    .factory('ClientVersion', clientVersionService);

  /** @ngInject*/
  /**ngInject*/
  function clientVersionService($resource, $q, api, CONSTANT, $rootScope) {

    var apiUrl = api.restUri || CONSTANT.API_URL;

    var clientVersionApi = {
      getList: $resource(apiUrl + '/clientversion/list'),
      getByStoreId: $resource(apiUrl + '/clientversion/list/:storeId'),
      newItem: $resource(apiUrl + '/clientversion'),
      update: $resource(apiUrl + '/clientversion/:id', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(apiUrl + '/clientversion/:id')
    };

    return {
      getList: getList,
      getByStoreId: getByStoreId,
      add: add,
      delete: deleteItem,
      update: update
    };

    /**
     * Get client versions list
     * @returns {Function}
     */
    function getList() {
      var deferred = $q.defer();

      clientVersionApi.getList.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Get client versions by Store ID
     * @returns {Function}
     */
    function getByStoreId(storeId) {
      var deferred = $q.defer();

      clientVersionApi.getByStoreId.query({storeId: storeId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Update client version by id
     * @param clientVersion
     * @returns {Function}
     */
    function update(clientVersion) {
      var deferred = $q.defer();

      clientVersionApi.update.put({id: clientVersion._id}, clientVersion, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Add new client version to list
     * @param clientVersion
     * @returns {Function}
     */
    function add(clientVersion) {
      var deferred = $q.defer();

      clientVersionApi.newItem.save(clientVersion, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Remove client version by id
     * @returns {Function}
     */
    function deleteItem(storeId) {
      var deferred = $q.defer();

      clientVersionApi.deleteItem.remove({id: storeId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }


  }

})();

(function () {
  'use strict';

  angular.module('app.client-type', [])
    .factory('ClientType', clientTypeFactory);

  /** @ngInject*/
  function clientTypeFactory() {
    return {
      getList: getList
    };

    function getList() {
      return [
        {
          id: 1,
          name: 'Mobile'
        },
        {
          id: 2,
          name: 'PC'
        }
      ];
    }
  }


})();

(function () {
  'use strict';

  angular.module('app.client-store', [])
    .factory('ClientStore', clientStoreService);

  /** @ngInject*/
  /**ngInject*/
  function clientStoreService($resource, $q, api, CONSTANT, $rootScope) {

    var apiUrl = api.restUri || CONSTANT.API_URL;

    var deviceApi = {
      getList: $resource(apiUrl + '/clientstore/list'),
      newItem: $resource(apiUrl + '/clientstore'),
      update: $resource(apiUrl + '/clientstore/:id', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(apiUrl + '/clientstore/:id')
    };

    return {
      getList: getList,
      add: add,
      delete: deleteItem,
      update: update
    };

    /**
     * Get client stores list
     * @returns {Function}
     */
    function getList() {
      var deferred = $q.defer();

      deviceApi.getList.query(deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Update client store by id
     * @param store
     * @returns {Function}
     */
    function update(store) {
      var deferred = $q.defer();

      deviceApi.update.put({id: store._id}, store, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Add new store to list
     * @param store
     * @returns {Function}
     */
    function add(store) {
      var deferred = $q.defer();

      deviceApi.newItem.save(store, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Remove ptt device by id
     * @returns {Function}
     */
    function deleteItem(storeId) {
      var deferred = $q.defer();

      deviceApi.deleteItem.remove({id: storeId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }


  }

})();

(function () {
  'use strict';

  angular.module('app.call-logs', [])
    .factory('CallLogs', callLogsService);

  /** @ngInject*/
  function callLogsService($resource, $q, CONSTANT, api) {
    this.canceller = $q.defer();
    var CallLogsApi = {
      getCallLogsByOrgID: $resource(api.restUri + '/callLogs/organization/:orgId'),
      getSessionsByOrgID: $resource(api.restUri + '/callLogs/organization/session/:orgId'),
      getBurstsObjectId: $resource(api.restUri + '/callLogs/session/:objectId'),
      getBurstsByObjectIdAndTimes: $resource(api.restUri + '/callLogs/bursts/:objectId/start/:startTime/end/:endTime'),
      getSessionsByDates: $resource(api.restUri + '/callLogs/session/:orgId/start/:startTime/end/:endTime/affiOrgId/:affiOrgId/:searchVal/:startIndex/:lastIndex/:withburst/:timezonediff', [], [], { cancellable: true }),
    };



    return {
      getCallLogsByOrgID : getCallLogsByOrgID,
      getSessionsByOrgID : getSessionsByOrgID,
      getBurstsObjectId : getBurstsObjectId,
      getBurstsByObjectIdAndTimes : getBurstsByObjectIdAndTimes,
      getSessionsByDates: getSessionsByDates
    };

    function getCallLogsByOrgID(orgId) {
      var deferred = $q.defer();

      CallLogsApi.getCallLogsByOrgID.query({orgId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }


    function getSessionsByOrgID(orgId) {
      var deferred = $q.defer();

      CallLogsApi.getSessionsByOrgID.query({orgId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getBurstsObjectId(objectId) {
      var deferred = $q.defer();

      CallLogsApi.getBurstsObjectId.query({objectId: objectId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getBurstsByObjectIdAndTimes(objectId, startTime, endTime) {
      var deferred = $q.defer();

      CallLogsApi.getBurstsByObjectIdAndTimes.query({objectId: objectId, startTime: startTime.toJSON(), endTime: endTime.toJSON()}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }


    function getSessionsByDates(orgId, startTime, endTime, affiOrgId, searchVal ,startIndex, lastIndex,withburst,timezonediff) {
      var deferred = $q.defer();
      if (this.canceller && this.canceller.$cancelRequest) {
        this.canceller.$cancelRequest()
      }
      this.canceller = CallLogsApi.getSessionsByDates.query({orgId: orgId, startTime: startTime, endTime: endTime, affiOrgId: affiOrgId,searchVal: searchVal, startIndex: startIndex, lastIndex: lastIndex,withburst:withburst,timezonediff:timezonediff}, deferred.resolve, deferred.reject);
      //CallLogsApi.getSessionsByDates.query({orgId: orgId, startTime: startTime.toJSON(), endTime: endTime.toJSON()}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

  }

})();

(function () {
  'use strict';
  angular.module('app.branding', ['ngFileUpload'])
    .factory('Branding', brandingFactory);

  /** @ngInject*/
  function brandingFactory($resource, $q, api, CONSTANT, $location, $http) {

    //var url = api.restUri.replace('8002', '8003');

    var brandingApi = {
      getBrandingInfo: $resource( api.restUri + '/branding/getBrandingInfo/:orgId', {}, {query: {method: 'GET'}, isArray:false}),
      setBrandingInfo: $resource( api.restUri + '/branding/setBrandingInfo/:orgId', {}, {put: {method: 'POST'}}),
      getBrandingImage: $resource( api.restUri + '/branding/getBrandingImage/:orgId', {}, {query: {method: 'GET'}, isArray:false}),
      setBrandingImage: $resource( api.restUri + '/branding/setBrandingImage/:orgId', {}, {put: {method: 'POST'}}),
      getBrandingExtraImage: $resource( api.restUri + '/branding/getBrandingExtraImage/:orgId/:type', {}, {query: {method: 'GET'}, isArray:false}),
      setBrandingExtraImage: $resource( api.restUri + '/branding/setBrandingExtraImage/:orgId/:type', {}, {put: {method: 'POST'}}),
    };

    return {
      getBrandingInfo: getBrandingInfo,
      setBrandingInfo: setBrandingInfo,
      getBrandingImage: getBrandingImage,
      setBrandingImage: setBrandingImage,
      getBrandingExtraImage: getBrandingExtraImage,
      setBrandingExtraImage: setBrandingExtraImage
    };

    function getBrandingInfo(orgId) {
      var deferred = $q.defer();

      brandingApi.getBrandingInfo.query({orgId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function setBrandingInfo(branding,org_id) {
      var deferred = $q.defer();

      brandingApi.setBrandingInfo.save({orgId: org_id}, branding, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getBrandingImage(orgId) {
      var deferred = $q.defer();

      brandingApi.getBrandingImage.query({orgId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function setBrandingImage(fd,orgId) {
      var deferred = $q.defer();

      var request = {
        method: 'POST',
        url: api.restUri + '/branding/setBrandingImage/' + orgId,
        data: fd,
        headers: {
          'Content-Type': undefined
        }
      };
      $http(request)
      .success(function (res) {
        deferred.resolve(res);
      })
      .error(function (e) {
        var err = {};
        err.data = e;
        deferred.reject(err);
      });

      return deferred.promise;
    }

    function getBrandingExtraImage(orgId, type){
      var deferred = $q.defer();

      brandingApi.getBrandingExtraImage.query({orgId: orgId, type: type}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function setBrandingExtraImage(fd,orgId, type) {
      var deferred = $q.defer();

      var request = {
        method: 'POST',
        url: api.restUri + '/branding/setBrandingExtraImage/' + orgId + '/' + type,
        data: fd,
        headers: {
          'Content-Type': undefined
        }
      };
      $http(request)
      .success(function (res) {
        deferred.resolve(res);
      })
      .error(function (e) {
        var err = {};
        err.data = e;
        deferred.reject(err);
      });

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.auth', [])
    .factory('Auth', authService);


  /**ngInject*/
  function authService($http, localStorageService, jwtHelper,$q,$state,$timeout, Context,$mdDialog,CONSTANT) {
    var authenticated = false;

    return {
      setAuthToken: setAuthToken,
      isAuth: isAuth,
      isRootAdmin: isRootAdmin,
      isOrgAdmin: isOrgAdmin,
      getUserName: getUserName,
      getUserResellerId: getUserResellerId,
      getUserOrgId: getUserOrgId,
      logout: logout,
      getDecodedToken: getDecodedToken,
      isResourceAllowed: isResourceAllowed,
      isActionAllowed: isActionAllowed,
      ActionResolver: ActionResolver,
      isAdministrator: isAdministrator,
      expiredDays: expiredDays,
      closeMdPop:closeMdPop,
      isMigrationAllowed: isMigrationAllowed,

    };


    function ActionResolver(resource,action) {
      var deferred = $q.defer();

      if (isActionAllowed(resource,action)) {
        deferred.resolve();
      } else {
        $timeout(function () {
          $state.go('app.restricted.homepage')
        });
        deferred.reject();
      }

      return deferred.promise;
    }
    function getDecodedToken() {
      return jwtHelper.decodeToken(localStorageService.get('token'));
    }

    function isRootAdmin(){
      var decodedToken = getDecodedToken();
      return decodedToken.isRootAdmin;
    }

    function isOrgAdmin(){
      var decodedToken = getDecodedToken();
      return decodedToken.isOrgAdmin;
    }

    function getUserResellerId(){
      var decodedToken = getDecodedToken();

      return isOrgAdmin() ? decodedToken.parentReseller : decodedToken.ctxResId;
    }

    function getUserOrgId(){
      var decodedToken = getDecodedToken();
      return decodedToken.ctxOrgId;
    }

    function getUserName(){
      var decodedToken = getDecodedToken();
      return decodedToken.name;
    }


    function isResourceAllowed(resourceId) {
      var decodedToken = getDecodedToken();
      var result = false;

      if (decodedToken && decodedToken.perms) {
        for (var i=0; i < decodedToken.perms.length; i++) {
          var currPerm = decodedToken.perms[i];
          if (currPerm._id == resourceId) {
            result = true;
            break;
          }
        }
      }

      return result;
    }

    function isActionAllowed(resourceId, actionId) {
      if (!isResourceAllowed(resourceId)) {
        return false;
      }

      var decodedToken = getDecodedToken(),
        result = false;

      if (decodedToken && decodedToken.perms) {
        for (var i = 0; i < decodedToken.perms.length; i++) {
          var currPerm = decodedToken.perms[i];
          if (currPerm._id == resourceId) {
            var actionsArr = currPerm.r_type.split(',');
            for (var a = 0; a < actionsArr.length; a++) {
              var currAction = actionsArr[a];
              if (actionId == currAction) {
                result = true;
                break;
              }
            }
          }
        }
      }

      return result;
    }

    function setAuthToken(token) {
      localStorageService.set('token', token);
      $http.defaults.headers.common['api_key'] = localStorageService.get('token');
      authenticated = true;
    }

    function logout() {
      localStorageService.set('token', '');
      $http.defaults.headers.common['api_key'] = '';
      Context.clear();
      authenticated = false;
    }

    function isAuth() {
      var token;

      if (authenticated) {
        return authenticated;
      }

      token = localStorageService.get('token');

      if (token) {
        authenticated = true;
        $http.defaults.headers.common['api_key'] = token;
      }

      return authenticated;
    }

    function isAdministrator(){
      var decodedToken = getDecodedToken();
      return decodedToken.isAdministrator;
    }

    function expiredDays(){
      var decodedToken = getDecodedToken();
      return decodedToken.expiredDays;
    }

    function closeMdPop(){
      $mdDialog.hide();
    }

    function isMigrationAllowed() {
      var deferred = $q.defer();

      if (CONSTANT.REQUIRED_MIGRATION == 'Yes') {
        deferred.resolve();
      } else {
        $timeout(function () {
          $state.go('app.restricted.homepage')
        });
        deferred.reject();
      }

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.audio-backup-path', [])
    .factory('AudioBackupPath', audioBackupPath);

  /** @ngInject*/
  function audioBackupPath($resource, $q, api) {
    var audioBackupPathApi = {
      orgList: $resource(api.restUri + '/audioBackupPath/organization/:orgId'),
      newItem: $resource(api.restUri + '/audioBackupPath'),
      //update: $resource(api.restUri + '/recordAdmin/:id', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(api.restUri + '/audioBackupPath/:id')
    };

    return {
      getByOrgId: getByOrgId,
      add: add,
      //update: update,
      deleteItem: deleteItem
    };

    // function update(admin) {
    //   var deferred = $q.defer();

    //   recordAdminApi.update.put({id: admin.admin_id}, admin, deferred.resolve, deferred.reject);

    //   return deferred.promise;
    // }

    function add(path) {
      var deferred = $q.defer();

      audioBackupPathApi.newItem.save(path, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Get admin by org id
     * @returns {Function}
     */
    function getByOrgId(orgId) {
      var deferred = $q.defer();

      audioBackupPathApi.orgList.query({orgId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Remove admin by id
     * @returns {Function}
     */
    function deleteItem(id) {
      var deferred = $q.defer();

      audioBackupPathApi.deleteItem.remove({id: id}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

  }

})();

(function () {
  'use strict';
  angular.module('app.application-list', [])
    .factory('ApplicationList', applicationList);

  /** @ngInject*/
  function applicationList($resource, $q, api, CONSTANT, $location, $http) {

    //var url = api.restUri.replace('8002', '8003');

    var applicationsApi = {
      getApplications: $resource(api.restUri + '/applicationList/getApplications/:orgId', {}, {query: {method: 'GET'}, isArray:false}),
      getApplicationLists: $resource(api.restUri + '/applicationList/getApplicationListsByOrg/:orgId'),
      getApplicationList: $resource(api.restUri + '/applicationList/getApplicationListByID/:id'),

      addUpdateApplications: $resource(api.restUri + '/applicationList/addUpdateApplications/:orgId', {}, {put: {method: 'POST'}}),
      addApplicationList: $resource(api.restUri + '/applicationList/addApplicationList', {}, {put: {method: 'POST'}}),
      updateApplicationList: $resource(api.restUri + '/applicationList/updateApplicationList/:id', {}, {put: {method: 'PUT'}}),
      
      deleteApplicationList: $resource(api.restUri + '/applicationList/deleteApplicationList/:id'),
      addUpdateApplicationListToSubscriber: $resource(api.restUri + '/applicationList/addUpdateApplicationListToSubscriber/:orgId/:subscriberPhone/:listId'),
      deleteApplicationListFromSubscriber: $resource(api.restUri + '/applicationList/deleteApplicationListFromSubscriber/:orgId/:subscriberPhone'),
      getSubscriberApplicationList: $resource(api.restUri + '/applicationList/getSubscriberApplicationList/:orgId/:subscriberPhone', {}, {query: {method: 'GET'}, isArray:false}),
      getApkPackage: $resource(api.restUri + '/applicationList/getApkPackage/upload'),
      uploadApplication : $resource(api.restUri + '/applicationList/addApplication/upload', {}, {put: {method: 'POST'}}),
      changeBulkApplicationListToSubscriber: $resource(api.restUri + '/applicationList/bulkAppList'),
      deleteBulkApplicationListToSubscriber: $resource(api.restUri + '/applicationList/bulkRemoveAppList'),
    };

    return {
      getApplicationsByOrg: getApplicationsByOrg,
      getApplicationListsByOrg: getApplicationListsByOrg,
      getApplicationList: getApplicationList,
      addUpdateApplications: addUpdateApplications,
      addApplicationList: addApplicationList,
      updateApplicationList: updateApplicationList,
      deleteApplicationList: deleteApplicationList,
      addUpdateApplicationListToSubscriber: addUpdateApplicationListToSubscriber,
      deleteApplicationListFromSubscriber : deleteApplicationListFromSubscriber,
      getSubscriberApplicationList: getSubscriberApplicationList,
      getApkPackage: getApkPackage,
      uploadApplication: uploadApplication,
      getDefaultList: getDefaultList,
      changeBulkApplicationListToSubscriber: changeBulkApplicationListToSubscriber,
      deleteBulkApplicationListToSubscriber: deleteBulkApplicationListToSubscriber
    };

    function getApplicationsByOrg(orgId) {
      var deferred = $q.defer();

      applicationsApi.getApplications.query({orgId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getApplicationListsByOrg(orgId) {
      var deferred = $q.defer();

      applicationsApi.getApplicationLists.query({orgId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getApplicationList(id){
      var deferred = $q.defer();

      applicationsApi.getApplicationList.query({id: id}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function addUpdateApplications(org_id, body) {
      var deferred = $q.defer();

      applicationsApi.addUpdateApplications.save({orgId: org_id}, body, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    
    function addApplicationList(body) {
      var deferred = $q.defer();

      applicationsApi.addApplicationList.save(body, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function updateApplicationList(id, body) {
      var deferred = $q.defer();

      applicationsApi.updateApplicationList.put({id: id}, body, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function deleteApplicationList(id) {
      var deferred = $q.defer();

      applicationsApi.deleteApplicationList.remove({id: id}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function addUpdateApplicationListToSubscriber(organizationId, subscriberPhone, listId){
      var deferred = $q.defer();

      applicationsApi.addUpdateApplicationListToSubscriber.save({orgId: organizationId, subscriberPhone: subscriberPhone, listId: listId}, {}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    function changeBulkApplicationListToSubscriber(organizationId,subscribers) {
      var deferred = $q.defer();
      applicationsApi.changeBulkApplicationListToSubscriber.save({orgId: organizationId,subscribers: subscribers}, function (resp) {deferred.resolve(resp);}, deferred.reject);

      return deferred.promise;
    }
    function deleteBulkApplicationListToSubscriber(organizationId,subscribers) {
      var deferred = $q.defer();
      applicationsApi.deleteBulkApplicationListToSubscriber.save({orgId: organizationId,subscribers: subscribers}, function (resp) {deferred.resolve(resp);}, deferred.reject);

      return deferred.promise;
    }
    function deleteApplicationListFromSubscriber(organizationId, subscriberPhone) {
      var deferred = $q.defer();

      applicationsApi.deleteApplicationListFromSubscriber.remove({orgId: organizationId, subscriberPhone: subscriberPhone}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getSubscriberApplicationList(orgId, subscriberPhone){
      var deferred = $q.defer();

      applicationsApi.getSubscriberApplicationList.query({orgId: orgId, subscriberPhone: subscriberPhone}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function getApkPackage(fd){
      var deferred = $q.defer();

      var request = {
        method: 'POST',
        url: api.restUri + '/applicationList/getApkPackage/upload/',
        data: fd,
        headers: {
          'Content-Type': undefined
        }
      };
      $http(request)
      .success(function (res) {
        deferred.resolve(res);
      })
      .error(function (e) {
        var err = {};
        err.data = e;
        deferred.reject(err);
      });

      return deferred.promise;
    }

    function uploadApplication(fd){
      var deferred = $q.defer();
      var request = {
        method: 'POST',
        url: api.restUri + '/applicationList/addApplication/upload/',
        data: fd,
        headers: {
          'Content-Type': undefined
        }
      };
      $http(request)
      .success(function (res) {
        deferred.resolve(res);
      })
      .error(function (e) {
        var err = {};
        err.data = e;
        deferred.reject(err);
      });

      return deferred.promise;
    }


    function getDefaultList(){
      return [{name: "Wi-Fi", package: "DEFAULT"}]
      // [
      //   "Dialer",
      //   "Contacts",
      //   "Messages",
      //   "Camera",
      //   "Gallery",
      //   "Settings",
      //   "Browser",
      //   "Calculator",
      //   "Calender",
      //   "Email",
      //   "Maps",
      // ]
    }
    
  }
})();

(function () {
  'use strict';

  angular.module('app.admin-record', [])
    .factory('AdminRecord', adminRecord);

  /** @ngInject*/
  function adminRecord($resource, $q, api) {
    var recordAdminApi = {
      allList: $resource(api.restUri + '/recordAdmin/all'),
      orgList: $resource(api.restUri + '/recordAdmin/organization/:orgId'),
      adminList: $resource(api.restUri + '/recordAdmin/admin/:adminId'),
      usernameList: $resource(api.restUri + '/recordAdmin/username/:username'),
      newItem: $resource(api.restUri + '/recordAdmin'),
      update: $resource(api.restUri + '/recordAdmin/:id', {}, {put: {method: 'PUT'}}),
      deleteItem: $resource(api.restUri + '/recordAdmin/:id'),
      blockAdmin: $resource(api.restUri + '/recordAdmin/blockRecordAdmin/:id', {}, {put: {method: 'PUT'}}),
      releaseAdmin: $resource(api.restUri + '/recordAdmin/releaseRecordAdmin/:id', {}, {put: {method: 'PUT'}}),
    };

    return {
      getAll: getAll,
      getByOrgId: getByOrgId,
      getByAdminId: getByAdminId,
      getByUsername: getByUsername,
      add: add,
      update: update,
      deleteItem: deleteItem,
      blockAdmin: blockAdmin,
      releaseAdmin: releaseAdmin
    };

    function update(admin) {
      var deferred = $q.defer();

      recordAdminApi.update.put({id: admin.admin_id}, admin, deferred.resolve, deferred.reject);

      return deferred.promise;

    }

    function add(admin) {
      var deferred = $q.defer();

      recordAdminApi.newItem.save(admin, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    
    function getAll() {
      var deferred = $q.defer();

      recordAdminApi.allList.query({}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Get admin by org id
     * @returns {Function}
     */
    function getByOrgId(orgId) {
      var deferred = $q.defer();

      recordAdminApi.orgList.query({orgId: orgId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    /**
     * Get admin by admin id
     * @returns {Function}
     */
    function getByAdminId(adminId) {
      var deferred = $q.defer();

      recordAdminApi.adminList.get({adminId: adminId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }
    /**
     * Get admin by username
     * @returns {Function}
     */
    function getByUsername(username) {
      var deferred = $q.defer();

      recordAdminApi.usernameList.query({username: username}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    /**
     * Remove admin by id
     * @returns {Function}
     */
    function deleteItem(adminId) {
      var deferred = $q.defer();

      recordAdminApi.deleteItem.remove({id: adminId}, deferred.resolve, deferred.reject);

      return deferred.promise;
    }

    function blockAdmin(adminId) {
      var deferred = $q.defer();

      recordAdminApi.blockAdmin.put({id: adminId}, {}, deferred.resolve, deferred.reject);

      return deferred.promise;

    }

    function releaseAdmin(adminId) {
      var deferred = $q.defer();

      recordAdminApi.releaseAdmin.put({id: adminId}, {}, deferred.resolve, deferred.reject);

      return deferred.promise;

    }

  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.reseller', [
    'app.restricted.reseller-details',
    'app.restricted.reseller-manager',
    'app.restricted.organization-manager'
  ]).config(config);

  /** @ngInject */
  function config(msNavigationServiceProvider) {

    // Navigation
    msNavigationServiceProvider.saveItem('Reseller', {
      title: 'Reseller',
      icon: '',
      state: '',
      translate: 'NAVIGATION_RESELLER',
      weight: 2
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.restricted.reseller')
    .factory('RM', resellerManager);

  /**ngInject*/
  function resellerManager() {
    return {
      setLicense: setLicense,
      setLicenseFromParent: setLicenseFromParent
    };


    //------------------------

    function setLicenseFromParent(licenseList, reseller) {
      return licenseList.map(function (license) {
        setQtyStatus(license, false, 0);
        reseller.licenses && mapCurResellerLicense(license, reseller);
        license.name = license.license.name;
        return license;
      });
    }

    function setLicense(licenseList, reseller) {
      return licenseList.map(function (license) {
        setQtyStatus(license, false, 0);
        setAvailQty(license, 999);
        reseller.licenses && mapCurResellerLicense(license, reseller);
        return license;
      });
    }

    function mapCurResellerLicense(license, reseller) {

      angular.forEach(reseller.licenses, function (resLicense) {
        if (
          license.license && (resLicense.license === license.license._id) || //when has parent
          resLicense.license === license._id
        ) {
          setQtyStatus(license, true, resLicense.qty);
        }
      });

    }

    function setAvailQty(license, qty) {
      license.available_qty = qty;
    }

    function setQtyStatus(license, status, qty) {
      license.status = status;
      license.qty = qty;
    }


  }
})();

(function () {

  angular.module('app.homepage', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
    // State
    $stateProvider
      .state('app.restricted.homepage', {
        url: '/',
        views: {
          'content@app.restricted': {
            templateUrl: 'app/main/restricted/homepage/homepage.html',
            controller: 'homepageController as vm'
          }
        },
        resolve: {
          SampleData: function (msApi) {
            //return msApi.resolve('sample@get');
          }
        }
      });

    // Api
    msApiProvider.register('homepage', ['app/data/sample/sample.json']);

  }
})();


(function(){
  'use strict';

  angular.module('app.homepage')
    .controller('homepageController', homepageController);

  /** @ngInject */
  function homepageController(api, ExceptionHandler, $state){
      var vm = this;

      api.version.query(function(response){
          vm.apiVersion = response.api;
          vm.dbVersion = response.mongo;
          vm.oracleVersion = response.oracle;
          vm.webAppVersion = response.frontEnd;
        },
        function(error){
          ExceptionHandler.show(error);
        });

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_timeline', {
                url      : '/pages/timeline',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline'
            })
            .state('app.pages_timeline_left', {
                url      : '/pages/timeline-left',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-left.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-left'
            })
            .state('app.pages_timeline_right', {
                url      : '/pages/timeline-right',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-right.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-right'
            });

        // API
        msApiProvider.register('timeline.page1', ['app/data/timeline/page-1.json']);
        msApiProvider.register('timeline.page2', ['app/data/timeline/page-2.json']);
        msApiProvider.register('timeline.page3', ['app/data/timeline/page-3.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.timeline', {
            title : 'Timeline',
            icon  : 'icon-view-stream',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('pages.timeline.default', {
            title: 'Default',
            state: 'app.pages_timeline'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.left-aligned', {
            title: 'Left Aligned',
            state: 'app.pages_timeline_left'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.right-aligned', {
            title: 'Right Aligned',
            state: 'app.pages_timeline_right'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline')
        .controller('TimelineController', TimelineController);

    /** @ngInject */
    function TimelineController($q, msApi, Timeline)
    {
        var vm = this;

        // Data
        vm.timeline = Timeline.data;
        vm.timelineOptions = {
            scrollEl: '#content'
        };
        vm.currentPage = 1;
        vm.totalPages = 3;
        vm.pauseScroll = false;

        // Methods
        vm.loadNextPage = loadNextPage;

        //////////

        /**
         * Load next page
         * @returns promise
         */
        function loadNextPage()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Increase the current page number
            vm.currentPage = vm.currentPage + 1;

            // Check if we still have pages that we can load
            if ( vm.currentPage > vm.totalPages )
            {
                // Reject the promise
                deferred.reject('No more pages');
            }
            else
            {
                // Emulate the api call and load new timeline items in
                var pageName = 'timeline.page' + vm.currentPage + '@get';

                msApi.request(pageName, {},

                    // SUCCESS
                    function (response)
                    {
                        for ( var i = 0; i < response.data.length; i++ )
                        {
                            vm.timeline.push(response.data[i]);
                        }

                        // Resolve the promise
                        deferred.resolve(response);
                    },

                    // ERROR
                    function (response)
                    {
                        // Reject the promise
                        deferred.reject(response);
                    }
                );
            }

            return deferred.promise;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.search', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_search', {
            url      : '/pages/search',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/search/search.html',
                    controller : 'SearchController as vm'
                }
            },
            resolve  : {
                Classic : function (msApi)
                {
                    return msApi.resolve('search.classic@get');
                },
                Mails   : function (msApi)
                {
                    return msApi.resolve('search.mails@get');
                },
                Users   : function (msApi)
                {
                    return msApi.resolve('search.users@get');
                },
                Contacts: function (msApi)
                {
                    return msApi.resolve('search.contacts@get');
                }
            },
            bodyClass: 'search'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/search');

        // Api
        msApiProvider.register('search.classic', ['app/data/search/classic.json']);
        msApiProvider.register('search.mails', ['app/data/search/mails.json']);
        msApiProvider.register('search.users', ['app/data/search/users.json']);
        msApiProvider.register('search.contacts', ['app/data/search/contacts.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.search', {
            title : 'Search',
            icon  : 'icon-magnify',
            state : 'app.pages_search',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController(Classic, Mails, Users, Contacts)
    {
        var vm = this;

        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.classic = Classic.data;
        vm.mails = Mails.data;
        vm.users = Users.data;
        vm.contacts = Contacts.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.pages_profile', {
            url      : '/pages/profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            resolve  : {
                Timeline    : function (msApi)
                {
                    return msApi.resolve('profile.timeline@get');
                },
                About       : function (msApi)
                {
                    return msApi.resolve('profile.about@get');
                },
                PhotosVideos: function (msApi)
                {
                    return msApi.resolve('profile.photosVideos@get');
                }
            },
            bodyClass: 'profile'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/profile');

        // Api
        msApiProvider.register('profile.timeline', ['app/data/profile/timeline.json']);
        msApiProvider.register('profile.about', ['app/data/profile/about.json']);
        msApiProvider.register('profile.photosVideos', ['app/data/profile/photos-videos.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.profile', {
            title : 'Profile',
            icon  : 'icon-account',
            state : 'app.pages_profile',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController(Timeline, About, PhotosVideos)
    {
        var vm = this;

        // Data
        vm.posts = Timeline.posts;
        vm.activities = Timeline.activities;
        vm.about = About.data;
        vm.photosVideos = PhotosVideos.data;

        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_maintenance', {
            url      : '/pages/maintenance',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_maintenance': {
                    templateUrl: 'app/main/pages/maintenance/maintenance.html',
                    controller : 'MaintenanceController as vm'
                }
            },
            bodyClass: 'maintenance'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/maintenance');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.maintenance', {
            title : 'Maintenance',
            icon  : 'icon-oil',
            state : 'app.pages_maintenance',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance')
        .controller('MaintenanceController', MaintenanceController);

    /** @ngInject */
    function MaintenanceController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_invoice_modern', {
                url      : '/pages/invoice/modern',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/modern/modern.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            })
            .state('app.pages_invoice_compact', {
                url      : '/pages/invoice/compact',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/compact/compact.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/invoice');

        // Api
        msApiProvider.register('invoice', ['app/data/invoice/invoice.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.invoice', {
            title : 'Invoice',
            icon  : 'icon-receipt',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('pages.invoice.modern', {
            title : 'Modern',
            state : 'app.pages_invoice_modern'
        });

        msNavigationServiceProvider.saveItem('pages.invoice.compact', {
            title : 'Compact',
            state : 'app.pages_invoice_compact'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice')
        .controller('InvoiceController', InvoiceController);

    /** @ngInject */
    function InvoiceController(Invoice)
    {
        var vm = this;

        // Data
        vm.invoice = Invoice.data;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon',
            [
                // 3rd Party Dependencies
                'timer'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_coming-soon', {
            url      : '/pages/coming-soon',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_coming-soon': {
                    templateUrl: 'app/main/pages/coming-soon/coming-soon.html',
                    controller : 'ComingSoonController as vm'
                }
            },
            bodyClass: 'coming-soon'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/coming-soon');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.coming-soon', {
            title : 'Coming Soon',
            icon  : 'icon-alarm-check',
            state : 'app.pages_coming-soon',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon')
        .controller('ComingSoonController', ComingSoonController);

    /** @ngInject */
    function ComingSoonController()
    {
        var vm = this;

        // Data
        vm.endTime = 1499995790000;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/login',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login-v2'
        });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/auth/login');

    }

})();

(function () {
  'use strict';

  angular
    .module('app.auth.login')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($state, $http, User, Auth, $translate, $location, localStorageService, ExceptionHandler, Toast, Config, CONSTANT) {
    // Data
    var vm = this;


    // Methods
    vm.currentDomain = $location.host();
    vm.LogoImg = getLogoPath();
    vm.login = login;
    vm.forgotPassword = forgotPassword;
    vm.moveToChangePassword = moveToChangePassword;
    checkLanguage();

    //////////
    function login() {
      vm.showLoader = true;

      if (vm.form.password && vm.form.email) {
        User.login(vm.form)
          .then(function (resp) {
            Auth.setAuthToken(resp.token);
            vm.showLoader = false;
            var expiredDays = Auth.expiredDays();
            if (expiredDays) Toast.showExpiredDayesDialog(expiredDays);
            $state.go('app.restricted.homepage');
          }, function(resp){
            if (resp.error.includes("expired")){
              Toast.showExpiredDialog();
              $state.go('app.pages_auth_change_password', {email : vm.form.email, user_id: resp.user_id})
            }
            else vm.form.errorMsg = resp.error + ".\n" + resp.attemptMessage;
            vm.showLoader = false;
          })
      }
    }

    function forgotPassword(){
      if(vm.form.email) {
        User.recoverPassword(vm.form)
          .then(function(resp){
            var message = $translate.instant("RECOVER_PASSWORD_SUCCESS");
            Toast.showCustom(message);
          })
          .catch(function(err){
            ExceptionHandler.show(err);
          })
      }
    }

    function checkLanguage() {

      // Get the selected language directly from angular-translate module setting
      var urlParamsLang = $location.search().lang;
      //Init language config constants
      Config.getFilterList().then(function (resp) {
        vm.configs = resp;
        vm.localizationConfig = vm.configs.filter(function (param) {
          return param.name == "PROV_LOCALIZATION_CONFIG";
        });

        if (vm.localizationConfig[0]) {
          vm.localizationConfig = vm.localizationConfig[0];
          vm.languages = JSON.parse(vm.localizationConfig.value);
        }

        vm.defaultLanguage = vm.configs.filter(function (param) {
          return param.name == "PROV_DEFAULT_LANGUAGE";
        });
        if (vm.defaultLanguage[0]) vm.defaultLanguage = vm.defaultLanguage[0].value;


        if (urlParamsLang) {
          vm.selectedLanguage = vm.languages[urlParamsLang];
          $translate.use(vm.selectedLanguage.code);
          $http.defaults.headers.common['Accept-Language'] = vm.selectedLanguage.code;
        }
        else if (localStorageService.get('lang')) {
          vm.selectedLanguage = vm.languages[localStorageService.get('lang')];
          $translate.use(vm.selectedLanguage.code);
          $http.defaults.headers.common['Accept-Language'] = vm.selectedLanguage.code;
        }
        else if (vm.defaultLanguage) {
          vm.selectedLanguage = vm.languages[vm.defaultLanguage];
          if (vm.selectedLanguage) {
            $translate.use(vm.defaultLanguage);
            $http.defaults.headers.common['Accept-Language'] = vm.selectedLanguage.code;
          }
          else {
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            $translate.use(vm.selectedLanguage.code);
            $http.defaults.headers.common['Accept-Language'] = vm.selectedLanguage.code;
          }
        }
        else {
          vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
          $translate.use(vm.selectedLanguage.code);
          $http.defaults.headers.common['Accept-Language'] = vm.selectedLanguage.code;
        }
      })
    }

    function moveToChangePassword(){
      $state.go('app.pages_auth_change_password', {email : vm.form.email, user_id: resp.user_id});
    }

    function getLogoPath() {
      var fqdn = (vm.currentDomain.split('.').length > 2) ? vm.currentDomain.split('.')[1] + '.' + vm.currentDomain.split('.')[2]: vm.currentDomain.split('.')[0] + '.' + vm.currentDomain.split('.')[1];
      if(CONSTANT.SSL == 'true')
      {
        const domain = CONSTANT.sslCertificates.find(function(config){
          if(config && (config.fqdn_path == fqdn))
            return config.logo_path
        }); 
        return domain?domain.logo_path.replace(CONSTANT.sslPath, '/assets/ssl/'):'../assets/images/logos/mt_logo.png';      
      } 
      else
        return '../assets/images/logos/mt_logo.png';      
    };

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'color.picker'
            ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html?v=1.0',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        //$translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController($rootScope, $http, $q, $state,Toast, $location, $timeout, $mdSidenav, $translate, msNavigationService, ExceptionHandler, Auth, Organization, Reseller, Context, localStorageService, Config, $filter,toolbarFactory, CONSTANT) {
    var vm = this;

    /*vm.showLoader = true;*/  $rootScope.loadingProgress =  true ;
    vm.organizationId = '';
    vm.resellerId = '';
    vm.organizations = [];
    vm.resellersList = [];
    vm.resellers = [];
    vm.isOrgAdmin = Auth.isOrgAdmin();
    vm.userResId = Auth.getUserResellerId();
    vm.userOrgId = Auth.getUserOrgId();
    vm.userName = Auth.getUserName();
    vm.getHelpFile = getHelpFile;
    vm.openDashboard = openDashboard;
    vm.openStatistics = openStatistics;
    vm.openDualRecorder = openDualRecorder;


    $rootScope.$$listeners.updatedOrganizationId =[];
    $rootScope.$$listeners.updatedResellerId =[];
    $rootScope.$$listeners.updatedResellerIdfromSearch =[];

    // Data
    $rootScope.global = {
      search: ''
    };

    vm.bodyEl = angular.element('body');
    /*vm.languages = {
      en: {
        'title': 'English',
        'translation': 'TOOLBAR.ENGLISH',
        'code': 'en',
        'flag': 'us'
      },
      il: {
        'title': 'Hebrew',
        'translation': 'TOOLBAR.HEBREW',
        'code': 'il',
        'flag': 'il'
      },
      fr: {
        'title': 'France',
        'translation': 'TOOLBAR.FRANCE',
        'code': 'fr',
        'flag': 'fr'
      }
    };
    */

    vm.breadcrumbs = [];

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.changeLanguage = changeLanguage;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.search = search;
    vm.searchResultClick = searchResultClick;
    vm.chooseReseller = chooseReseller;
    vm.chooseOrganization = chooseOrganization;
    vm.setContext = setContext;
    vm.switchToResellerContext = switchToResellerContext;
    vm.searchPlatform = searchPlatform;
    vm.hostName='';
    $rootScope.$on('updatedResellerIdFromSearch', function () {
     vm.resellerId = Context.getResellerId();
     chooseReseller();
    });

    $rootScope.$on('updatedOrganizationIdFromSearch', function () {
      vm.organiationId = Context.getOrganizationId();
      //chooseReseller();
      setOrganizationFromSearch();
      //chooseOrganization();
    });


    //////////
   // vm.showLoader = false;
    init();
    /**
     * Initialize
     */
    function init() {
      // Get the selected language directly from angular-translate module setting
      var urlParamsLang = $location.search().lang;
      vm.hostName = $location.$$protocol +'://'+ $location.$$host;
      //vm.showLoader = false;
      //Init language config constants
      Config.getFilterList().then(function(resp) {
        vm.configs = resp;
        vm.localizationConfig = vm.configs.filter(function (param) {
          return param.name == "PROV_LOCALIZATION_CONFIG";
        });

        if(vm.localizationConfig[0]){
          vm.localizationConfig = vm.localizationConfig[0];
          vm.languages = JSON.parse(vm.localizationConfig.value);
        }

        vm.showITODashboard = resp.filter(function(param){
          return param.name == "PROV_SHOW_DASHBOARD";
        });
        
        if (!vm.showITODashboard || !vm.showITODashboard[0] || vm.showITODashboard[0].value == "0")
          vm.showITODashboard = false;
        else{
          vm.showITODashboard = true;
        }

        vm.showStatistics = resp.filter(function(param){
          return param.name == "PROV_SHOW_STATISTICS";
        });
        
        if (!vm.showStatistics || !vm.showStatistics[0] || vm.showStatistics[0].value == "0")
          vm.showStatistics = false;
        else{
          vm.showStatistics = true;
        }
        
        vm.showRecorderStatistics = resp.filter(function(param){
          return param.name == "PROV_SHOW_RECORDER_STATISTICS";
        });
        
        if (!vm.showRecorderStatistics || !vm.showRecorderStatistics[0] || vm.showRecorderStatistics[0].value == "0")
          vm.showRecorderStatistics = false;
        else{
          vm.showRecorderStatistics = true;
        }

        vm.defaultLanguage = vm.configs.filter(function (param) {
          return param.name == "PROV_DEFAULT_LANGUAGE";
        });
        if(vm.defaultLanguage[0]) vm.defaultLanguage = vm.defaultLanguage[0].value;


        if(urlParamsLang){
          vm.selectedLanguage = vm.languages[urlParamsLang];
          $translate.use(vm.selectedLanguage.code);
          $http.defaults.headers.common['Accept-Language'] = vm.selectedLanguage.code;
        }
        else if(localStorageService.get('lang')){
          vm.selectedLanguage = vm.languages[localStorageService.get('lang')];
          $translate.use(vm.selectedLanguage.code);
          $http.defaults.headers.common['Accept-Language'] = vm.selectedLanguage.code;
        }
        else if(vm.defaultLanguage){
          vm.selectedLanguage = vm.languages[vm.defaultLanguage];
            if(vm.selectedLanguage){
              $translate.use(vm.defaultLanguage);
              $http.defaults.headers.common['Accept-Language'] = vm.selectedLanguage.code;
            }
            else{
              vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
              $translate.use(vm.selectedLanguage.code);
              $http.defaults.headers.common['Accept-Language'] = vm.selectedLanguage.code;
            }
        }
        else{
         vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
          $translate.use(vm.selectedLanguage.code);
          $http.defaults.headers.common['Accept-Language'] = vm.selectedLanguage.code;
        }

        /*Init DB IDs info*/
        vm.showIdsConfig = vm.configs.filter(function (param) {
          return param.name == "PROV_SHOW_ID";
        });

        if(vm.showIdsConfig[0]){
          vm.showIdsConfig = vm.showIdsConfig[0];
          vm.showIdsConfig.value == 1 ? localStorageService.set('showId', 'showIdsConfig.value') : localStorageService.set('showId', '');
        }

      });

      localStorageService.set('resellerId', '');

      watchOnResellerChanges();
      watchOnOrganizationChanges();

      if(vm.isOrgAdmin){
       setOrganization();
      }
      else{
        fillResellerList();
      }
      //vm.showLoader = false;
    }

    function setContext(context) {
      if (context.hasOwnProperty("children")) {
        vm.resellerId = context._id;
        chooseReseller();

      } else {
        vm.organizationId = context._id;
        chooseOrganization();
      }
    }

    function fillResellerList() {
      Reseller.getList()
        .then(function (resp) {
          angular.copy(resp, vm.resellersList);
          if(!vm.resellerId) vm.resellerId = vm.userResId;
          chooseReseller();
         })
        .catch(function(e){
         ExceptionHandler.show(e);
        });
    }


    function watchOnResellerChanges() {
      $rootScope.$on('resellerListUpdated', function () {
        fillResellerList();
      })
    }

    function watchOnOrganizationChanges() {
      $rootScope.$on('organizationListUpdated', function () {
        chooseOrganization();
      })
    }

    function switchToResellerContext(){
      chooseReseller();
    }

    function chooseOrganization() {

      Context.setOrganizationId(vm.organizationId);
      buildBreadcrumbs();
    }

    function setOrganization() {
      Context.setResellerId(vm.userResId);
      Context.setOrganizationId(vm.userOrgId);
      vm.organizationId = vm.userOrgId;

      vm.organizationId && Organization.getById(vm.userOrgId, vm.userResId)
        .then(function(resp){
          vm.organizations[0] = resp;
        })
        .catch(function(e){
          ExceptionHandler.show(e);
        });

    }

    function setOrganizationFromSearch() {
      vm.organizationId = Context.getOrganizationId();
      vm.resellerId = Context.getLastResellerId();

      if (vm.organizationId) {
        return Organization.getById(vm.organizationId, vm.resellerId)
          .then(function(resp) {
            vm.organizations[0] = resp;

            Context.setOrganization(vm.organizations[0]);
            Context.setOrganizationId(vm.organizationId);
            buildBreadcrumbs();
          })
          .catch(function(e) {
            ExceptionHandler.show(e);
          });
      }

    }

    function chooseReseller() {
      /*vm.showLoader = true;*/  $rootScope.loadingProgress =  true ;
      var flatResellers = [];
      getChildren(vm.resellersList, flatResellers);

      function getChildren(resList, flatResellers){
        resList.map(function(res){
          flatResellers.push(res);
          if(res && res.children) getChildren(res.children, flatResellers);
        });
        return flatResellers;
      }

      var curReseller = flatResellers.filter(function (reseller) {
        return reseller._id == vm.resellerId;
      })[0];

      clearData();
      Context.setReseller(curReseller);
      Context.setResellerId(vm.resellerId);

      buildBreadcrumbs();
      localStorageService.set('resellerId', vm.resellerId);

      vm.resellerId && Organization.getParentList(vm.resellerId)
        .then(function (resp) {
          angular.copy(resp, vm.organizations);
          vm.organizations = $filter('orderBy')(vm.organizations,'name');
          if(vm.isOrgAdmin){
            vm.organizationId = vm.userOrgId;
            chooseOrganization();
          }
        })
        .catch(function(e){
          console.log(e.data.error);
          console.log(e.status);
          console.log(e.statusText);
        });
      /*vm.showLoader = false;*/  $rootScope.loadingProgress =  false ;
    }

    function clearData() {
      vm.organizationId = '';
      vm.organizations = [];
    }

    function buildBreadcrumbs() {
      var context = Context.getState();

      if (context === 'reseller') {
        vm.breadcrumbs = [];
        var reseller = Context.getReseller();
        if(reseller){
          buildResellerPath(vm.resellersList, reseller.parentReseller, vm.breadcrumbs);
        }

      } else {
        var organization = vm.organizations.filter(function (org) {
          return org._id === parseInt(vm.organizationId);
        })[0];
        vm.breadcrumbs = [organization];
        buildResellerPath(vm.resellersList, organization.parentReseller, vm.breadcrumbs);
      }
    }

    function buildResellerPath(resellerList, id, path) {

      if (resellerList) {
        for (var i = 0; i < resellerList.length; i++) {
          if (
            resellerList[i]._id === id ||
            (resellerList[i].children && buildResellerPath(resellerList[i].children, id, path))
          ) {
            path.unshift(resellerList[i]);
            return true;
          }
        }
      }
      return false;
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Logout Function
     */
    function logout() {
      Auth.logout();
      Context.clear();
      toolbarFactory.setSearchText('');
      localStorageService.set('showId', '');
      $state.go('app.pages_auth_login');
      window.location.reload();
    }

    /**
     * Change Language
     */
    function changeLanguage(lang) {
      vm.selectedLanguage = lang;
      localStorageService.set("lang",lang.code);
      $http.defaults.headers.common['Accept-Language'] = lang.code;

      /**
       * Show temporary message if user selects a language other than English
       *
       * angular-translate module will try to load language specific json files
       * as soon as you change the language. And because we don't have them, there
       * will be a lot of errors in the page potentially breaking couple functions
       * of the template.
       *
       * To prevent that from happening, we added a simple "return;" statement at the
       * end of this if block. If you have all the translation files, remove this if
       * block and the translations should work without any problems.
       */
      /*    if ( lang.code !== 'en' )
       {
       var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

       $mdToast.show({
       template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
       hideDelay: 7000,
       position : 'top right',
       parent   : '#content'
       });

       return;
       }*/

      // Change the language
      $translate.use(lang.code);
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }


    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }

    function searchPlatform() {
      if(vm.searchText !== undefined && vm.searchText.length > 0){
        toolbarFactory.setSearchText(vm.searchText);
        vm.searchText = '';
        if(!$state.is('app.restricted.searchResult')){
          $state.go('app.restricted.searchResult');
        }
        else{
          $rootScope.$emit('searchPlatformInit');
        }
      }else{
        Toast.showSearchMsg();

      }

    }
    /**
     * Search action
     *
     * @param query
     * @returns {Promise}
     */
    function search(query) {
      var navigation = [],
        flatNavigation = msNavigationService.getFlatNavigation(),
        deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          navigation.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the navigation;
      // otherwise we will return the entire navigation
      // list. Not exactly a good thing to do but it's
      // for demo purposes.
      if (query) {
        navigation = navigation.filter(function (item) {
          if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
            return true;
          }
        });
      }

      // Fake service delay
      $timeout(function () {
        deferred.resolve(navigation);
      }, 1000);

      return deferred.promise;
    }

    /**
     * Search result click action
     *
     * @param item
     */
    function searchResultClick(item) {
      // If item has a link
      if (item.uisref) {
        // If there are state params,
        // use them...
        if (item.stateParams) {
          $state.go(item.state, item.stateParams);
        }
        else {
          $state.go(item.state);
        }
      }
    }

    function getHelpFile(){
      var currentState= $state.current.url;
      switch(currentState) {
        case "/":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/index', 'help');
          break;

        case "/organization":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/organization/details', 'help');
          break;
        case "/groups":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/organization/groups', 'help');
          break;
        case "/subscribers":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/organization/subscribers', 'help');
          break;
        case "/contacts":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/organization/contacts', 'help');
          break;
        case "/batch":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/organization/bulk', 'help');
          break;
        case "/recording":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/organization/recordingPlanner', 'help');
          break;
        case "/wfm":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/organization/workForceManagement', 'help');
          break;
        case "/callLogs":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/organization/callLog', 'help');
          break;
        case "/applicationLists":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/organization/mobileAppsPlanning', 'help');
          break;
        case "/locationHistory":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/organization/locationHistory', 'help');
          break;

        case "/reseller-details":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/reseller/resellerDetails', 'help');
          break;
        case "/reseller-manager?rootId":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/reseller/resellerManager', 'help');
          break;
        case "/organization-manager?rootId":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/reseller/organizationManager', 'help');
          break;

        case "/licenses":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/platform/licenses', 'help');
          break;
        case "/config":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/platform/SystemConfiguration', 'help');
          break;
        case "/localization":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/platform/localization', 'help');
          break;
        case "/report":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/platform/reports', 'help');
          break;

        case "/admins":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/administration/admins', 'help');
          break;
        case "/roles":
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/administration/roles', 'help');
          break;
        case "/activityLog":
        window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/administration/activityLog', 'help');
        break;

        default:
          window.open($location.protocol() + "://" + $location.host() + ":" + $location.port() + '/help/index', 'help');
      }
    }

    function openDashboard(){
      window.open('//'+ $location.host() +':'+CONSTANT.DASHBOARD_URL + '/?api_key=' + localStorageService.get('token'),'dashboard');
    }

    function openStatistics(){
      window.open('//'+ $location.host() +':'+CONSTANT.STATISTICS_URL + '/NavigationMenu/' + localStorageService.get('token'),'statistics');
    }
    function openDualRecorder(){
      window.open(vm.hostName + ':8900/#/auth/login/?api_key=' + localStorageService.get('token'),'recorder');
    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, Auth, msNavigationService, $rootScope, Config, Branding, Context, Organization, $q, Reseller, CONSTANT, $location)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        vm.currentDomain = $location.host();
        var navItems = msNavigationService.getNavigation();
        var isRootAdmin = Auth.isRootAdmin();
        var isOrgAdmin = Auth.isOrgAdmin();
        vm.LogoImg = getLogoPath();
        $rootScope.$on('clearResellerId', function () {
          //getBrandLogo();
        });
    
        $rootScope.$on('clearOrganizationId', function () {
          //getBrandLogo();
        });
    
        function getLogoPath() {          
          var fqdn = (vm.currentDomain.split('.').length > 2) ? vm.currentDomain.split('.')[1] + '.' + vm.currentDomain.split('.')[2]: vm.currentDomain.split('.')[0] + '.' + vm.currentDomain.split('.')[1];
          if(CONSTANT.SSL == 'true')
          {
            const domain = CONSTANT.sslCertificates.find(function(config){
              if(config && (config.fqdn_path == fqdn))
                return config.logo_path
            });   
            return domain?domain.logo_path.replace(CONSTANT.sslPath, '/assets/ssl/'):'../assets/images/logos/mt_logo.png'; 
          } 
          else
            return '../assets/images/logos/mt_logo.png';     
        };

        $rootScope.$on('upadatebranding', function () {
          getBrandLogo();
        });
        $rootScope.$on('upadateLocationMenu', function () {
          for (var a=0; a < navItems.length; a++) {
            var currNavItem = navItems[a];
    
            if(!isRootAdmin && currNavItem._id == "Platform") {
              console.log(currNavItem._id + " hidden");
              angular.extend(currNavItem, { hidden: function () { return false; } });
              msNavigationService.saveItem(currNavItem._path, currNavItem);
            }
            else if(!Auth.isActionAllowed(getResIdByMenuId(currNavItem._id), 'GET') && !isRootAdmin){
              console.log(currNavItem._id + " hidden");
              angular.extend(currNavItem, { hidden: function () { return true; } });
              msNavigationService.saveItem(currNavItem._path, currNavItem);
            }
            else if(isOrgAdmin && currNavItem._id == "Reseller"){
              angular.extend(currNavItem, { hidden: function () { return true; } });
              msNavigationService.saveItem(currNavItem._path, currNavItem);
            }
            else{
                angular.extend(currNavItem, { hidden: function () { return false; } });
                msNavigationService.saveItem(currNavItem._path, currNavItem);
             }
    
    
            checkNavChildren(currNavItem);
          }
        });

        function getBrandLogo(){
          var getResellerId = Context.getResellerId();
          var getUserOrgId = Context.getOrganizationId();

          function findBrandLogoByReseller(resellerId) {
            return getBrandImagePath(resellerId).then(function (img) {
              if (img) {
                return img;
              }
              // If not found, check parentReseller
              return Reseller.getParentResellerById(resellerId)
                .then(function (data) {
                  var reseller = Array.isArray(data) ? data[0] : data;
                  if (reseller && reseller.parentReseller) {
                    return findBrandLogoByReseller(reseller.parentReseller);
                  } else {
                    // No parent reseller, fallback to supportRole or default
                    return getBrandImagePath(reseller.supportRole).then(function (img2) {
                      return img2 || getLogoPath();
                    });
                  }
                })
                .catch(function (e) {
                  return getBrandImagePath(2).then(function (img2) {
                    return img2 || getLogoPath();
                  });
                });
            });
          }

          function findBrandLogoByOrganization(orgId) {
            return getBrandImagePath(orgId).then(function (img) {
              if (img) {
                return img;
              }
              return Organization.getOrgDetailById(orgId)
                .then(function (orgData) {
                  if (orgData.parentReseller) {
                    return findBrandLogoByReseller(orgData.parentReseller);
                  } else {
                    return getBrandImagePath(2).then(function (img2) {
                      return img2 || getLogoPath();
                    });
                  }
                })
                .catch(function (e) {
                  return getBrandImagePath(2).then(function (img2) {
                    return img2 || getLogoPath();
                  });
                });
            });
          }

          if(getResellerId && !isOrgAdmin) {
            findBrandLogoByReseller(getResellerId).then(function (img) {
              vm.LogoImg = img;
            });
          } else if (getUserOrgId) {
            findBrandLogoByOrganization(getUserOrgId).then(function (img) {
              vm.LogoImg = img;
            });
          }
          else
          {
            var img = getBrandImagePath(2);
            if(img)
              vm.LogoImg = img;
            else
              vm.LogoImg = getLogoPath();
          }
        }

        function getBrandImagePath(id){
          var deferred = $q.defer();
          if(id)
          {
            Branding.getBrandingInfo(id)
            .then(function (respBrand) {
              if(respBrand.override_management_portal_image)
              {
                Branding.getBrandingExtraImage(id, "ManagementPortal")
                  .then(function (respBrandImg) {
                    if (typeof respBrandImg.image !== 'undefined') {
                      var filepath = 'data:image/*;base64,'+respBrandImg.image;
                      deferred.resolve(filepath);
                    }
                    else
                    {
                      deferred.resolve('');
                    }
                  })
                  .catch(function (e) {
                    deferred.resolve('');
                  });
              }
              else
              {
                deferred.resolve('');
              }
            })
            .catch(function (e) {
              deferred.resolve('');
            });
          }
          else
          {            
            deferred.resolve('');
          }
          return deferred.promise;
        }

      for (var a=0; a < navItems.length; a++) {
        var currNavItem = navItems[a];

        if(!isRootAdmin && currNavItem._id == "Platform") {
          console.log(currNavItem._id + " hidden");
          angular.extend(currNavItem, { hidden: function () { return false; } });
          msNavigationService.saveItem(currNavItem._path, currNavItem);
        }
        else if(!Auth.isActionAllowed(getResIdByMenuId(currNavItem._id), 'GET') && !isRootAdmin){
          console.log(currNavItem._id + " hidden");
          angular.extend(currNavItem, { hidden: function () { return true; } });
          msNavigationService.saveItem(currNavItem._path, currNavItem);
        }
        else if(isOrgAdmin && currNavItem._id == "Reseller"){
          angular.extend(currNavItem, { hidden: function () { return true; } });
          msNavigationService.saveItem(currNavItem._path, currNavItem);
        }
        else{
            angular.extend(currNavItem, { hidden: function () { return false; } });
            msNavigationService.saveItem(currNavItem._path, currNavItem);
         }


        checkNavChildren(currNavItem);
      }

        //////////
        function rootAccess(navItem){
          if(!isRootAdmin) return false;

          var rootPages = [ 'Platform', 'devices','ptt-devices','ptt-client-store','client-version','devices-manufacturers', 'software-manufacturers', 'licenses','server-config', 'localization', 'report', 'move-organization','job','batch'];
          var match = false;
          for(var i=0;i<rootPages.length;i++){
            if (navItem._id == rootPages[i]){
              if(navItem._id == 'move-organization')
              {
                if(CONSTANT.REQUIRED_MIGRATION == 'Yes')
                  match = true;
                else
                  match = false;
              }
              else
                match = true;
            }
          }
          return  match;
        }

        function orgAccess(navItem){
          return  navItem._id != "Reseller";
        }

        function checkNavChildren(currParentNavItem){
          if (currParentNavItem.children.length > 0) {
            for (var i=0; i <= currParentNavItem.children.length-1; i++) {
              var currNavItem = currParentNavItem.children[i];
              if (!Auth.isActionAllowed(getResIdByMenuId(currNavItem._id), 'GET') && !rootAccess(currNavItem)) {
                angular.extend(currNavItem, { hidden:  function () { return true; } });
                msNavigationService.saveItem(currNavItem._path, currNavItem);
              }
              else{
                angular.extend(currNavItem, { hidden:  function () { return false; } });
                msNavigationService.saveItem(currNavItem._path, currNavItem);
              }
              //hide batch operations with a specific topic condition
              if(currNavItem._id == "batch"  && !rootAccess(currNavItem) &&  !Auth.isActionAllowed('subscriber_resource','BATCH')) {
                angular.extend(currNavItem, { hidden:  function () { return true; } });
                msNavigationService.saveItem(currNavItem._path, currNavItem);
              }
              else if(currNavItem._id == "organization-friends"){
                checkShowParameter_orgFriend(currNavItem); 
              }
              else if(currNavItem._id == "recording"){
                checkShowParameter_recording(currNavItem); 
              }
              else if(currNavItem._id == "wfm"){
                checkShowParameter_wfm(currNavItem); 
              }
              else if(currNavItem._id == "callLogs"){
                checkShowParameter_callLog(currNavItem); 
              }
              // else if(currNavItem._id == "emergencyGroups"){
              //   checkShowParameter_emergencyGroup(currNavItem);
              // }
              else if(currNavItem._id == "applicationLists"){
                checkShowParameter_applicationLists(currNavItem); 
              }
              // else if(currNavItem._id == "contacts"){
              //   checkShowParameter_ocl(currNavItem);
              // }
              else if(currNavItem._id == "locationHistory"){
                checkShowParameter_LocationLists(currNavItem); 
              }
            }
          }
        }

        function checkShowParameter_orgFriend(currNavItem){
            Config.getFilterList().then(function(resp){
              vm.configs = resp;
              var showOrganizationFriends = vm.configs.filter(function(param){
                return param.name == "PROV_SHOW_ORGANIZATION_FRIENDS";
              });
              if (!showOrganizationFriends || !showOrganizationFriends[0].value || showOrganizationFriends[0].value == "0"){
                angular.extend(currNavItem, { hidden:  function () { return true; } });
                msNavigationService.saveItem(currNavItem._path, currNavItem);
              }
            });
        }
        function checkShowParameter_recording(currNavItem){
          Config.getFilterList().then(function(resp){
            vm.configs = resp;
            var showAdminRecord = vm.configs.filter(function(param){
              return param.name == "PROV_SHOW_RECORDING";
            });
            if (!showAdminRecord || !showAdminRecord[0].value || showAdminRecord[0].value == "0"){
              angular.extend(currNavItem, { hidden:  function () { return true; } });
              msNavigationService.saveItem(currNavItem._path, currNavItem);
            }
          });
        }


        function checkShowParameter_wfm(currNavItem){
          Config.getFilterList().then(function(resp){
            vm.configs = resp;
            var showWFM = vm.configs.filter(function(param){
              return param.name == "PROV_SHOW_WFM";
            });
            if (!showWFM || !showWFM[0].value || showWFM[0].value == "0"){
              angular.extend(currNavItem, { hidden:  function () { return true; } });
              msNavigationService.saveItem(currNavItem._path, currNavItem);
            }
          });
        }



        function checkShowParameter_callLog(currNavItem){
          Config.getFilterList().then(function(resp){
            vm.configs = resp;
            var showCallLog = vm.configs.filter(function(param){
              return param.name == "PROV_SHOW_CALL_LOG";
            });
            if (!showCallLog || !showCallLog[0].value || showCallLog[0].value == "0"){
              angular.extend(currNavItem, { hidden:  function () { return true; } });
              msNavigationService.saveItem(currNavItem._path, currNavItem);
            }
          });
        }
        function checkShowParameter_emergencyGroup(currNavItem){
          Config.getFilterList().then(function(resp){
            vm.configs = resp;
            var showEmergencyGroup= vm.configs.filter(function(param){
              return param.name == "PROV_SHOW_PERSONAL_GROUP";
            });
            if (!showEmergencyGroup || !showEmergencyGroup[0].value || showEmergencyGroup[0].value == "0"){
              angular.extend(currNavItem, { hidden:  function () { return true; } });
              msNavigationService.saveItem(currNavItem._path, currNavItem);
            }
          });
        }
        function checkShowParameter_applicationLists(currNavItem){
          Config.getFilterList().then(function(resp){
            vm.configs = resp;
            var showApplicationLists = vm.configs.filter(function(param){
              return param.name == "PROV_SHOW_APPLICATION_LIST";
            });
            if (!showApplicationLists || !showApplicationLists[0].value || showApplicationLists[0].value == "0"){
              angular.extend(currNavItem, { hidden:  function () { return true; } });
              msNavigationService.saveItem(currNavItem._path, currNavItem);
            }
          });
        }
        function checkShowParameter_LocationLists(currNavItem){
          Config.getFilterList().then(function(resp){
            vm.configs = resp;
            var showLocationLists = vm.configs.filter(function(param){
              return param.name == "PROV_SHOW_LOCATION_LIST";
            });
            if (!showLocationLists || !showLocationLists[0].value || showLocationLists[0].value == "0"){
              angular.extend(currNavItem, { hidden:  function () { return true; } });
              msNavigationService.saveItem(currNavItem._path, currNavItem);
            }
          });
        }
        function checkShowParameter_ocl(currNavItem){
          Config.getFilterList().then(function(resp){
            vm.configs = resp;
            var showOcl = vm.configs.filter(function(param){
              return param.name == "PROV_SHOW_OCL";
            });
            if (!showOcl || !showOcl[0].value || showOcl[0].value == "0"){
              angular.extend(currNavItem, { hidden:  function () { return true; } });
              msNavigationService.saveItem(currNavItem._path, currNavItem);
            }
          });
        }

        function getResIdByMenuId(menuItemId) {
          var idsMapping = {
              'groups':'group_resource',
              'subscribers': 'subscriber_resource',
              'contacts': 'group_resource',
              'subscriberLists': 'group_resource',
              'emergencyGroups': 'group_resource',
              'organization-manager': 'organization_resource',
              'organization-details': 'organization_resource',
              'organization-friends': 'organization_resource',
              'batch': 'subscriber_resource',
              'wfm':'organization_resource',
              'recording': 'administration_resource',
              'callLogs': 'organization_resource',
              'applicationLists': 'organization_resource',
              'locationHistory': 'organization_resource',
              'reseller-details': 'reseller_resource',
              'reseller-manager': 'reseller_resource',
              'administrators': 'administration_resource',
              'roles': 'administration_resource',
              'activityLog': 'administration_resource',
              'Administration':'administration_resource',
              'Organization': 'organization_resource',
              'Reseller': 'reseller_resource',
              'licenses': 'license_resource'

            },
            result = menuItemId;

          if (idsMapping.hasOwnProperty(menuItemId)) {
            result = idsMapping[menuItemId];
          }
          return result;
        }


        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();

(function () {
  'use strict';

  /**
   * Main module of the Fuse
   */
  angular
    .module('fuse', [

      // Core
      'app.core',

      // Navigation
      'app.navigation',

      // Toolbar
      'app.toolbar',

      // Quick Panel


      // Sample
     // 'app.restricted.general',
      'app.restricted.organisation',
      'app.restricted.reseller',
      'app.restricted.platform',
      'app.restricted.administration',
      'app.restricted',
      'app.auth.login',
      'app.auth.change.password',
      'app.services',
      'app.homepage',
      'app.restricted.searchResult',
      'shared',
      'app.help',
      //external
      'LocalStorageModule',
      'angular-jwt',
      'angularUtils.directives.dirPagination',
      'ngCsv'
    ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $translate, $timeout)
    {
        var vm = this;
        // var timer;
        // var hideTimer;
        // $scope.loaderCount = 0;
        // $rootScope.$$listeners.loaderUpdatedValueMain =[];
        // $rootScope.$$listeners.loaderUpdatedValue =[];
        //$translate.refresh();
        // Data

        //////////
        // $rootScope.$on('loaderUpdatedValueMain', function () {
        //     vm.loaderCount = parseInt($rootScope.loaderStatePercentage);
        //     vm.shLodr = $rootScope.loaderState;
        //     console.log(vm.loaderCount)
        // });
        // $rootScope.$on('loaderUpdatedValue', function () {
        //     $scope.loaderCount = parseInt($rootScope.loaderStatePercentage);
        //     $scope.shLodr = $rootScope.loaderState;
        //     // console.log($scope.shLodr)
        //     if($scope.loaderCount == 100 || $scope.loaderCount == 0)
        //         hideLoader();

        //     if($scope.loaderCount > 95 )
        //         stopCounter();
        //     if($scope.loaderCount < 10 && $scope.loaderCount != 0)
        //         updateCounter();
        //     // console.log()
        // });
        // var updateCounter = function() {
        //     $scope.loaderCount++;
        //     timer = $timeout(function(){
        //         if($scope.loaderCount > 95 )
        //             stopCounter();
        //         if($scope.loaderCount < 95 && $scope.loaderCount != 0)
        //             updateCounter();
        //     }, 1000);
        // };
        // var hideLoader = function() {
        //     hideTimer = $timeout(function(){
        //         // console.log('=========STOP===========');
        //         // console.log($scope.shLodr)
        //         $scope.shLodr = false;
        //     }, 1000);
        // };
        // // updateCounter();
        // var stopCounter = function() {
        //     $timeout.cancel(timer);
        //     timer = null;
        // };
        // $scope.$on('loaderUpdated', function() {
    //   vm.loaderCount = parseInt($rootScope.loaderStatePercentage);
    //   console.log(vm.loaderCount);
    //   vm.shLodr = $rootScope.loaderState;
    //   if(vm.loaderCount > 95 )
    //     clearInterval(vm.myInterval);
    //   if(vm.loaderCount < 10)
    //       vm.myInterval = setInterval(function () {startInterval()}, 2000);
    // });
        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config)
        .config(function($provide) {
        $provide.decorator('ColorPickerOptions', function($delegate) {
          var options = angular.copy($delegate);
          options.round = false;
          options.alpha = false;
          options.format = 'hexString';
          options.pos = 'top right';
          options.inline = true;
          options.horizontal = true;
          options.close = {
            show: true,
            label: 'Close',
            class: '',
          };
          options.swatchOnly = true;
          options.hue = true;
          options.show = {
            swatch: true,
            focus: true,
          };
          options.hide = {
            blur: true,
            escape: true,
            click: true,
          };
          return options;
        });
      });

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, DTDefaultOptions)
    {
        $rootScope.loaderStateCount = 0;
        $rootScope.loaderStateTotalCount = 0;
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        //Set default row count for data tables
        DTDefaultOptions.setDisplayLength(25);

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts.verticalNavigation.main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts.verticalNavigation.toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts.verticalNavigation.navigation,
                        controller : 'NavigationController as vm'
                    }
                }
            });
    }

})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .provider('index', indexProvider);

  /** @ngInject*/
  function indexProvider($stateProvider) {
    var vm = this;

    vm.get_en = get_en;
    vm.get_es = get_es;
    vm.get_he = get_he;
    vm.get_ru = get_ru;

    this.$get = function () {
      return {};
    }

    //english
    function get_en() {
      return {
        "version": "2.26",
        "revised_by": "Hardik shah",
        "revision_date": "17-09-2025",
        "APPLICATIONS": "APPLICATIONS",
        "API_MONGO_DB_TIMEOUT": "MongoDb unavailable. Connection timeout",
        "API_REQUEST_TIMEOUT": "Node request timeout",
        "API_MONGO_DB_ERROR": "Lost connection to the Database. Please try again later",
        "API_GET_LIST_ERROR": "Unable to retrieve the %s list",
        "API_GET_ERROR": "Unable to retrieve %s",
        "API_ADD_ERROR": "Unable to add %s",
        "API_UPDATE_ERROR": "Unable to update %s",
        "API_DELETE_ERROR": "Unable to delete %s",
        "API_NOT_FOUND_ERROR": "%s not found",
        "API_FORBIDDEN_ERROR": "Access forbidden",
        "APP_GENERAL": "General",
        "APP_IS_MUTED": "Muted Subscribers",
        "APP_CUSTOM": "Custom",
        "APP_DESCRIPTION": "Description",
        "APP_SEARCH": "Search",
        "APP_FILTER": "License Filter",
        "APP_NO_FILTER": "All",
        "APP_NAME": "Name",
        "APP_REMOVE": "Remove",
        "APP_CLONE": "Clone",
        "APP_SAVE": "Save",
        "APP_CANCEL": "Cancel",
        "APP_ADD": "Add",
        "APP_UPDATE": "Update",
        "APP_OK": "OK",
        "APP_REFRESH": "Refresh",
        "APP_RECORDS_COUNT": "Records",
        "APP_NO_RECORDS": "Data not available",
        "APP_DELETE_WARNING_TITLE": "Are you sure you want to delete this item?",
        "APP_DELETE_WITH_MEMBERS_WARNING_TITLE": "This item has members. Are you sure you want to delete it?",
        "APP_DELETE_WARNING_CONTENT": "All data will be removed.",
        "APP_ENABLE_WARNING_TITLE": "Are you sure you want to Enable all subscribers?",
        "APP_DISABLE_WARNING_TITLE": "Are you sure you want to Disable all subscribers?",
        "APP_SEND_SMS": "Send SMS",
        "APP_SEND_SMS_WARNING_TITLE": "Sure you want to send an SMS to this subscriber?",
        "APP_SEND_BULK_SMS_WARNING_TITLE": "Sure you want to send an SMS to these subscribers?",
        "APP_LICENSE_INTERACTIVE_WARNING_TITLE": "Are you sure you want to assign the license to all subscribers?",
        "APP_ROLE_INTERACTIVE_WARNING_TITLE": "Are you sure you want to assign the role to all subscribers?",
        "APP_PASSWORD_MISMATCH": "The Password doesn’t match",
        "APP_SHOW_PASSWORD": "Show Password",
        "APP_CHANGE_PASSWORD": "Change Password",
        "APP_GENERATE_PASSWORD": "Generate Password",
        "APP_VALIDATION_REQUIRED": "This field is required.",
        "APP_VALIDATION_MAX_LENGTH": "This field is too long.",
        "APP_VALIDATION_MIN_LENGTH": "This field is too short.",
        "APP_VALIDATION_EMAIL": "Email must be a valid e-mail address.",
        "APP_VALIDATION_IP": "It should be a valid IP address.",
        "APP_VALIDATION_URL": "It should be a valid URL.",
        "APP_VALIDATION_SPECIAL_CHARS": "This field can not contain special characters.",
        "APP_VALIDATION_REGULAR_PASSWORD": "This field can not contain the following character: '\\' or spaces.",
        "APP_VALIDATION_PASSWORD": "A password must contain 10 to 15 characters, with at least 1 numeric, 1 uppercase, 1 lowercase, and 1 special character. It should not contain identical and consecutive characters or numbers.",
        "APP_ERROR_VALIDATION_PASSWORD": "The Password is not according to the rules.",
        "APP_TOAST_ADD_SUCCESS": "Added successfully.",
        "APP_TOAST_UPDATE_SUCCESS": "Updated successfully.",
        "APP_TOAST_DELETE_SUCCESS": "Removed successfully.",
        "APP_TOAST_ALLOCATE_SUCCESS": "Allocated successfully.",
        "APP_TOAST_REVOKE_SUCCESS": "Revoked successfully.",
        "APP_TOAST_CHANGE_SUCCESS": "State changed successfully.",
        "APP_TOAST_DELETE_FAILED": "Unable to delete the role. It is assigned to at least one user.",
        "APP_TOAST_DELETE_FAIL": "Unable to delete the organization. All its Administrators should be deleted first.",
        "APP_TOAST_SEARCH_BLANK": "Please provide Phone number or Email Address or ID or IMSI of the user",
        "APP_TOAST_REVOKE_FAILED": "Revocation Failed. This license is already assigned to subscribers",
        "APP_TOAST_404": "File does not exist",
        "APP_UNSELECTED": "Unselected",
        "APP_UNSELECTED_OFFNET": "Off-net subscribers",
        "APP_SELECTED": "Selected",
        "APP_ADD_ALL": "Select All",
        "APP_REMOVE_ALL": "Remove All",
        "APP_DISPATCHER_USER_WARNING_TITLE": "Consider the following:",
        "APP_DISPATCHER_USER_WARNING_CONTENT1": "You are about to create a user with Dispatcher license but the selected Role is not suitable for a Dispatcher.",
        "APP_DISPATCHER_USER_WARNING_CONTENT2": "Return to select another role or continue and change the role later from the roles screen. Do you want to continue?",
        "APP_CHARGE_ROLE_WARNING_TITLE": "Please note:",
        "APP_CHARGE_ROLE_WARNING_CONTENT1": "The following features might apply additional costs: ",
        "APP_CHARGE_ROLE_WARNING_CONTENT2": "For more information, please contact your Mobile Tornado representative.",
        "APP_YES": "Yes",
        "APP_NO": "No",
        "APP_DEMO_ORGANIZATION_WARNING_TITLE": "Please note:",
        "APP_DEMO_ORGANIZATION_WARNING_CONTENT1": "This organization will be defined as a Demo for {{days}} days.",
        "APP_DEMO_ORGANIZATION_WARNING_CONTENT2": "When trial period will be expired, the organization will become a production and you will be billed accordingly.",
        "APP_DEMO_ORGANIZATION_WARNING_CONTENT3": "Ok to accept, Cancel to create/update this organization as production.",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS": "Current Encryption Status: ",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_NO_KEYS": "No Encryption Keys In Use",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_DEFAULT_KEYS": "Default Encryption Keys In Use",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_RANDOM_KEYS": "Random Encryption Keys In Use",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_UPLOAD_KEYS_FILE": "Private File Of Encryption Keys Is In Use",
        "APP_ENCRYPTION_KEYS_VERSION": "Encryption keys version",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_TITLE": "Warning!",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT1": "Please, make sure all users have the latest Android application installed (currently iOS is not supported). ",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT2": "When allowing encryption keys generation, users with an old version will not be able to communicate with the rest.",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT3": "Do not use the keys generator if this organization has 'affiliated organizations'.",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT4": "To generate encryption keys click OK, otherwise Cancel",
        "APP_OUT_OF_MEMBER": "Error. Out of member limit",
        "LOGIN_INTRO_TITLE": "Welcome to the Administration portal!",
        "LOGIN_TITLE": "Sign in to your account",
        "LOGIN_EMAIL": "Email",
        "LOGIN_PASSWORD": "Password",
        "LOGIN_REMEMBER_ME": "Remember Me",
        "LOGIN_FORGOT_PASSWORD": "Forgot Password?",
        "LOGIN_LOG_IN": "LOG IN",
        "LOGIN_ERRORS_EMAIL_REQUIRED": "Email field is required",
        "LOGIN_ERRORS_EMAIL_MUST_VALID": "Email must be a valid e-mail address",
        "LOGIN_ERRORS_PASSWORD_REQUIRED": "Password field is required",
        "LOGIN_API_ERROR": "Auth failed. Username or Password is incorrect",
        "LOGIN_API_PERMISSION_ERROR": "Auth failed. Missing credentials to access the site",
        "LOGIN_API_TOKEN_ERROR": "The session expired. Please try to Sign in again",
        "LOGIN_API_DB_ERROR": "Authentication failed. Probable database error. Please contact the administrator",
        "LOGIN_CONTACT_ADMIN": "Forget your password? Please contact your service administrator",
        "LOGIN_API_ATTEMPTS_LEFT": "%s attempts left",
        "LOGIN_PASSWORD_EXPIRED_DAYS": "Your password will expire in {{days}} days. Therefore, please change your password as soon as possible.",
        "LOGIN_PASSWORD_EXPIRED": "Your password has expired and must be changed.",
        "BACK_TO_LOGIN": "Back",
        "CHANGE_PASSWORD_TITLE": "Change a Password",
        "CHANGE_PASSWORD_CURRENT": "Current Password",
        "CHANGE_PASSWORD_NEW": "New Password",
        "CHANGE_PASSWORD_WRONG": "Password is incorrect",
        "CHANGE_PASSWORD_SAME": "Your new password must be different from your previous password",
        "RECOVER_PASSWORD_SUCCESS": "A recovery message has been sent to the user's email",
        "HOMEPAGE_HEADING": "Administration Portal",
        "HOMEPAGE_TITLE": null,
        "HOMEPAGE_APPLICATION": "Front-end",
        "HOMEPAGE_API_VERSION": "API & MongoDB",
        "HOMEPAGE_DB_VERSION": "Main DB",
        "HELP_HEADING": "Administration Portal Help",
        "DASHBOARD_HEADING": "Dashboard",
        "STATISTICS_HEADING": "PTT Statistics",
        "DUAL_RECORDER_HEADING": "Recorder Statistics",
        "TOOLBAR_RESELLERS": "Resellers",
        "TOOLBAR_ORGANIZATIONS": "Organizations",
        "TOOLBAR_LOGOUT": "Sign Out",
        "TOOLBAR_SEARCHTEXT": "Phone/Email/ID/IMSI",
        "NAVIGATION_ADMIN_RECORD": "Recordings Reviewers",
        "NAVIGATION_ORGANIZATION": "Organization",
        "NAVIGATION_GROUPS": "Groups",
        "NAVIGATION_SUBSCRIBERS": "Subscribers",
        "NAVIGATION_CONTACTS": "Contacts",
        "NAVIGATION_CONTACTS_TEMPLATES": "Contacts Templates",
        "NAVIGATION_ORG_DETAILS": "Organization Details",
        "NAVIGATION_RESELLER": "Reseller",
        "NAVIGATION_ORG_MANAGER": "Organization Manager",
        "NAVIGATION_RESELLER_DETAILS": "Reseller Details",
        "NAVIGATION_RESELLER_MANAGER": "Reseller Manager",
        "NAVIGATION_PLATFORM": "Platform",
        "NAVIGATION_DEVICES": "Devices",
        "NAVIGATION_DEV_MANUFACTURERS": "Device Manufacturers",
        "NAVIGATION_LICENSES": "Licenses",
        "NAVIGATION_SOFT_MANUFACTURERS": "Software Manufacturers",
        "NAVIGATION_PTT_CLIENT_STORE": "PTT Application Store",
        "NAVIGATION_PTT_DEVICES": "PTT Devices",
        "NAVIGATION_ITO_CONFIG": "System Configuration",
        "NAVIGATION_LOCALIZATION": "Localization",
        "NAVIGATION_ADMINISTRATION": "Administration",
        "NAVIGATION_ROLES": "Roles",
        "NAVIGATION_JOB": "Jobs",
        "NAVIGATION_BATCH": "Bulk Operations",
        "NAVIGATION_ACTIVITY_LOG": "Activity Log",
        "ADMINISTRATOR": "administrators",
        "ADMINISTRATORS": "Administrators",
        "ADMINISTRATION_TITLE": "Administrators",
        "ADMINISTRATION_DIALOG_TITLE": "Administrators",
        "ADMINISTRATION_EMAIL": "Email",
        "ADMINISTRATION_NAME": "User name",
        "ADMINISTRATION_FIRST_NAME": "First name",
        "ADMINISTRATION_LAST_NAME": "Last name",
        "ADMINISTRATION_ROLE": "Role name",
        "ADMINISTRATION_ACTIONS": "Remove",
        "ADMINISTRATION_DELETE": "Delete",
        "ADMINISTRATION_SELECT_ROLE": "Select role",
        "ADMINISTRATION_PASSWORD": "Password",
        "ADMINISTRATION_RE_PASSWORD": "Retype Password",
        "ADMINISTRATOR_NAME_UQ_ERROR": "A user with the same name already exists!",
        "ADMINISTRATOR_EMAIL_UQ_ERROR": "A user with the same Email already exists!",
        "ROLE": "role",
        "ROLES": "roles",
        "ROLE_TITLE": "Roles",
        "ROLE_DIALOG_TITLE": "Role Permissions",
        "ROLE_SHOW": "Role Permissions",
        "ROLE_NAME": "Role name",
        "ROLE_RESOURCE_PATH": "Permissions",
        "ROLE_GET": "View",
        "ROLE_POST": "Add",
        "ROLE_PUT": "Modify",
        "ROLE_DELETE": "Delete",
        "ROLE_BATCH": "Batch Operations",
        "ROLE_HIMPACT": "High Impact",
        "ROLE_ACTIVE": "Active",
        "ROLE_TABS_WEB": "Provisioning",
        "ROLE_TABS_DISPATCHER": "Dispatcher",
        "ROLE_TABS_MOBILE": "Client",
        "ROLE_API_ADD_NAME_UQ_ERROR": "Unable to add the role. A role with the same name already exists",
        "ROLE_API_UPDATE_NAME_UQ_ERROR": "Unable to update the role. A role with the same name already exists",
        "ROLE_API_DELETE_USED_ERROR": "Unable to delete the role. It is assigned to at least one user",
        "ROLE_RESOURCE_PATH_MOBILE": "Permissions and Settings",
        "ROLE_NAME_ROOT_ADMIN": "The chosen role name is reserved and cannot be used",
        "CONTACT": "Contact list",
        "CONTACTS": "Contacts",
        "CONTACTS_TITLE": "Contacts",
        "CONTACTS_DIALOG_TITLE": "Contacts Group Details",
        "CONTACTS_TEMPLATE_NAME": "Template name",
        "CONTACTS_LIST_NAME": "Group name",
        "CONTACTS_CONTACT_LISTS": "Members List",
        "CONTACTS_MEMBER_COUNT": "Member count",
        "CONTACTS_CROSS_FLEET": "Affiliated Contact",
        "CONTACTS_NAME": "Name",
        "CONTACTS_MEMBERS": "Members Details",
        "CONTACT_MEMBERS_NOTE": "Only show offnet license members",
        "CONTACTS_GENERAL": "General",
        "CONTACTS_MEMBER_DETAILS": "Member Details",
        "SUBSCRIBER_LIST": "Subscriber list",
        "SUBSCRIBER_LISTS": "Subscriber Lists",
        "SUBSCRIBER_LISTS_TITLE": "Subscriber Lists",
        "SUBSCRIBER_LIST_DIALOG_TITLE": "Subscriber List Details",
        "SUBSCRIBER_LIST_NAME": "List name",
        "SUBSCRIBER_LISTS_MEMBERS": "Members List",
        "SUBSCRIBER_LISTS_MEMBER_COUNT": "Member count",
        "SUBSCRIBER_LISTS_NAME": "Name",
        "SUBSCRIBER_LISTS_MEMBERS_DETAILS": "Members Details",
        "SUBSCRIBER_LISTS_GENERAL": "General",
        "SUBSCRIBER_LIST_MEMBER_DETAILS": "Member Details",
        "PERSONAL_CONTACT": "personal contact",
        "PERSONAL_CONTACTS": "personal contacts",
        "PERSONAL_CONTACTS_TEMPLATES": "contacts templates",
        "SUBSCRIBER_LIST_NOTE": "Affiliated contact list can be assign to user without offnet license user, but only own organization contacts will be assign to user",
        "PERSONAL_CONTACTS_TEMPLATES_DETAILS": "Contacts Template Details",
        "GROUP": "group",
        "GROUPS": "groups",
        "GROUPS_TITLE": "Groups",
        "GROUPS_DIALOG_TITLE": "Group Details",
        "GROUPS_SITE": "Site",
        "GROUPS_NAME": "Group name",
        "GROUPS_MEMBER_COUNT": "Member count",
        "GROUPS_EXPIRATION_DATE": "Expiration Date",
        "GROUPS_CROSS_FLEET": "Affiliated Group",
        "GROUPS_PHONE": "Phone number",
        "GROUPS_ACTIONS": "Remove",
        "GROUPS_TYPE": "Group type",
        "GROUPS_GROUP_LISTS": "Subscribers List",
        "GROUPS_DELETE_WARNING": "Unable to delete group - Delete members first",
        "GROUPS_API_GET_LIMIT_ERROR": "Unable to get group's member limit",
        "GROUPS_API_LIMIT_ERROR": "Unable to update because the limit of %s members has reached. Try to increase the limit first",
        "GROUPS_API_ADD_SUBSCRIBER_ERROR": "Unable to add the subscriber to the group",
        "GROUPS_API_UPDATE_SUBSCRIBER_ERROR": "Unable to update the subscriber to the group",
        "GROUPS_API_REMOVE_SUBSCRIBER_ERROR": "Unable to remove the subscriber from the group",
        "GROUPS_API_UPDATE_MUTED_SUBSCRIBER_ERROR": "Unable to update the listener-subscriber in the group.",
        "GROUPS_API_SET_DEFAULT_ERROR": "Unable to set the default group",
        "GROUP_API_NAME_UQ_ERROR": "Group with the same name already exists",
        "SUBSCRIBER": "subscriber",
        "SUBSCRIBERS": "subscribers",
        "SUBSCRIBERS_TITLE": "Subscribers",
        "SUBSCRIBERS_DIALOG_TITLE": "Subscriber Details",
        "SUBSCRIBERS_DIALOG_ADD_TITLE": "Add subscriber",
        "SUBSCRIBERS_ORGANIZATION": "Choose organization",
        "SUBSCRIBERS_SMS_DIALOG_TITLE": "Send SMS",
        "SUBSCRIBERS_GENERAL": "General",
        "SUBSCRIBERS_LICENSE": "License",
        "SUBSCRIBERS_RUNTIME": "Runtime",
        "SUBSCRIBERS_GROUP_DETAILS": "Group Details",
        "SUBSCRIBERS_GROUP_SUBSCRIBERS": "Groups",
        "SUBSCRIBERS_CONTACT_SUBSCRIBERS": "Contacts Groups(Org)",
        "SUBSCRIBERS_ACTIVITY_LOG": "Activity Log",
        "SUBSCRIBERS_ADD_SUBSCRIBERS": "Add subscribers",
        "SUBSCRIBERS_LIST": "Subscribers",
        "SUBSCRIBERS_NAME": "User Name",
        "SUBSCRIBERS_DISPLAY_NAME": "Display name",
        "SUBSCRIBERS_USER_NAME": "Username/Phone",
        "SUBSCRIBERS_USER_NAME_SIP": "email/SIP",
        "SUBSCRIBERS_DOMAIN": "Domain",
        "SUBSCRIBERS_ACTIVE": "Active",
        "SUBSCRIBERS_PHONE_NUMBER": "Phone number",
        "SUBSCRIBERS_CREATION_TIME": "Creation time",
        "SUBSCRIBERS_CHANGE_STATE_TIME": "State change time",
        "SUBSCRIBERS_COUNTRY": "Country",
        "SUBSCRIBERS_ADDRESS": "Address",
        "SUBSCRIBERS_PASSWORD": "Password",
        "SUBSCRIBERS_RE_PASSWORD": "Retype password",
        "SUBSCRIBERS_CLIENT_TYPE": "Client type",
        "SUBSCRIBERS_HANDSET_TYPE": "Handset type",
        "SUBSCRIBERS_SITE": "Site",
        "SUBSCRIBERS_EMAIL": "Email",
        "SUBSCRIBERS_SIP": "SIP",
        "SUBSCRIBERS_IMSI": "IMSI",
        "SUBSCRIBER_IMSI": "IMSI",
        "SUBSCRIBERS_IMSI2": "IMSI2",
        "SUBSCRIBERS_ROLE": "Role",
        "SUBSCRIBERS_REVOKE_LICENSE_WARNING": "Do you really want to revoke the license?",
        "SUBSCRIBERS_DEFAULT_RADIO_GROUP": "Default Radio Group",
        "SUBSCRIBERS_DEFAULT_SOS_MSG": "This group may also serve for Emergency Alerts",
        "SUBSCRIBERS_CURRENT_LICENSE": "Current License",
        "SUBSCRIBERS_LICENSE_NAME": "Name",
        "SUBSCRIBERS_LICENSE_TYPE": "Type",
        "SUBSCRIBERS_LICENSE_RENEWAL": "Renewal",
        "SUBSCRIBERS_LICENSE_EXPIRE": "Expires",
        "SUBSCRIBERS_LICENSE_QTY": "Available",
        "SUBSCRIBERS_LICENSE_REVOKE": "Revoke",
        "SUBSCRIBERS_LICENSE_ASSIGN": "Assign",
        "SUBSCRIBERS_LICENSE_ASSIGN_NEW": "Assign a new license",
        "SUBSCRIBERS_NO_AVAILBLE_QTY": "No assignable licenses remain",
        "SUBSCRIBERS_RUNTIME_LAST_REGISTRATION_TIME": "Last registration time",
        "SUBSCRIBERS_RUNTIME_STATE": "State",
        "SUBSCRIBERS_RUNTIME_APP_UPDATE": "Device/App update",
        "SUBSCRIBERS_RUNTIME_DEVICE_MODEL": "Device Model",
        "SUBSCRIBERS_RUNTIME_APP_VERSION": "App Version",
        "SUBSCRIBERS_RUNTIME_OS_VERSION": "API Level",
        "SUBSCRIBERS_RUNTIME_MODEL_NAME": "Device model",
        "SUBSCRIBERS_RUNTIME_OS_TYPE": "OS Type",
        "SUBSCRIBERS_RUNTIME_BRAND": "Mobile client brand",
        "SUBSCRIBERS_RUNTIME_MANUFACTURE": "Manufacturer",
        "SUBSCRIBERS_RUNTIME_MEMORY": "Device total memory",
        "SUBSCRIBERS_RUNTIME_FW_VERSION": "FW version",
        "SUBSCRIBERS_RUNTIME_BUILD": "App build type",
        "SUBSCRIBERS_RUNTIME_FCM": "FCM",
        "SUBSCRIBERS_VALIDATION_SPECIAL_CHARS_ERROR": "Display name can not contain special characters",
        "SUBSCRIBERS_VALIDATION_USERNAME_ORG_DOMAIN_ERROR": "Username can not contain the organization domain",
        "SUBSCRIBERS_VALIDATION_AT_ERROR": "Username can not contain the @ symbol",
        "SUBSCRIBERS_VALIDATION_DEFAULT_GROUP_ERROR": "Please select a default group in the Groups tab.",
        "SUBSCRIBERS_VALIDATION_CREATE_ROLE_ERROR": "Please create role for this organization",
        "SUBSCRIBERS_VALIDATION_SELECT_ROLE_ERROR": "Please select role",
        "SUBSCRIBERS_VALIDATION_SIP_ERROR": "Invalid SIP",
        "SUBSCRIBERS_VALIDATION_SIP_FORMAT_ERROR": "Invalid SIP format",
        "SUBSCRIBERS_VALIDATION_SIP_PHONE_ERROR": "SIP phone number doesn't match",
        "SUBSCRIBERS_VALIDATION_ORG_DOMAIN_ERROR": "Invalid SIP organization domain. Valid:",
        "SUBSCRIBERS_VALIDATION_LICENSE_ASSIGNMENT_ERROR": "Note: Please set permissions for the user in the License tab",
        "SUBSCRIBERS_VALIDATION_STRONG_DISPATCH_PASS": "Note: Strong password is required for a dispatcher user.",
        "SUBSCRIBERS_GROUPS_LIMIT_ERROR": "Too many groups, please reduce accordingly",
        "SUBSCRIBERS_PERSONAL_GROUPS_LIMIT_ERROR": "Too many personal contacts, please reduce accordingly",
        "SUBSCRIBERS_OCL_LIMIT_ERROR": "Too many contacts groups(org), please reduce accordingl",
        "SUBSCRIBERS_VALIDATION_ADD_ERROR": "Unable to add subscriber",
        "SUBSCRIBERS_VALIDATION_ONLY_NUMBERS_ERROR": "This field should only contain digits",
        "SUBSCRIBERS_API_VALIDATION_IMSI_FORMAT_ERROR": "Incorrect format - This field must contain between 14 and 20 digits",
        "SUBSCRIBERS_API_ADD_IDENTIFIERS_UQ_ERROR": "The Subscriber's identifier should be unique",
        "SUBSCRIBERS_API_ADD_IDENTIFIERS_ERROR": "The Subscriber was added but it was not possible to add the identifier",
        "SUBSCRIBERS_API_ADD_DUPLICATE_ID_ERROR": "The Subscriber could not be added since the identifier already exists",
        "SUBSCRIBERS_API_UPDATE_DUPLICATE_ID_ERROR": "The Subscriber could not be updated since the identifier already exists",
        "SUBSCRIBERS_API_UPDATE_DUPLICATE_IMSI_ERROR": "The Subscriber could not be updated since the IMSI already exists",
        "SUBSCRIBERS_API_ADD_NO_GROUP_ERROR": "Unable to add the subscriber because no groups exist in the organization",
        "SUBSCRIBERS_API_ADD_GROUP_EXCEPTION_ERROR": "Unable to add the subscriber because of exception during retrieval of the group names for this organization",
        "SUBSCRIBERS_API_GROUPS_ERROR": "Unable to retrieve the subscriber's group names",
        "SUBSCRIBERS_API_CONTACTS_ERROR": "Unable to retrieve the subscriber's contact names",
        "SUBSCRIBERS_API_PHONE_UQ_ERROR": "Unable to add subscriber. Phone number should be unique",
        "SUBSCRIBERS_API_NAME_UQ_ERROR": "A subscriber with the same name already exists in this organization",
        "SUBSCRIBERS_API_NAME_SPACE_ERROR": "The display name or SIP can not contain spaces",
        "SUBSCRIBERS_API_PASSWORD_SPACE_ERROR": "The Password can not contain spaces",
        "SUBSCRIBERS_API_ADD_NO_LICENSE": "Unable to add a subscriber without license",
        "SUBSCRIBERS_API_UPDATE_NO_LICENSE": "Unable to update a subscriber without license",
        "SUBSCRIBERS_API_PHONE_ZERO_ERROR": "Unable to add the subscriber since the phone number cannot start with 0",
        "SUBSCRIBERS_API_ADD_NOT_ENOUGH_LICENSE": "Unable to add the subscriber(s) since all licenses are in use",
        "SUBSCRIBERS_API_NUMBER_USERS_EXCEEDS_LICENSE_QTY": "Users cannot be added beyond the specified limit in the server's license",
        "SUBSCRIBERS_API_PASSWORD_LENGTH_ERROR": "The subscriber cannot be created since the password should be shorter than 18 characters",
        "SUBSCRIBERS_TIME_STAMP": "Time-stamp (in GMT)",
        "SUBSCRIBERS_ADMINISTRATOR": "Administrator",
        "SUBSCRIBERS_DESCRIPTION": "Description",
        "SUBSCRIBERS_GET_ACTIVITY": "get Activities",
        "SUBSCRIBERS_SERIAL_NUMBER": "Serial Number",
        "SUBSCRIBER_BULK_PHONE_15_DIGIT_ERROR": "Phone number can not be longer than 15 digits",
        "SUBSCRIBER_BULK_INVALID_PHONE_ERROR": "Invalid Phone number",
        "ORGANIZATION": "organization",
        "ORGANIZATIONS": "organizations",
        "ORGANIZATION_TITLE": "Organizations",
        "ORGANIZATION_DETAILS": "Organization Details",
        "ORGANIZATION_CONTEXT_WARNING": "Please choose an organization first",
        "ORGANIZATION_CRMID": "CRMID",
        "ORGANIZATION_NAME": "Organization Name",
        "ORGANIZATION_DOMAIN": "Domain Name",
        "ORGANIZATION_SITE": "Site",
        "ORGANIZATION_ADDRESS": "Address",
        "ORGANIZATION_MANAGER": "Organization Manager",
        "ORGANIZATION_AUDIO_RECORDER": "Record all organization conversations",
        "ORGANIZATION_GENERAL": "General",
        "ORGANIZATION_CONTACT": "Contact Details",
        "ORGANIZATION_SECURITY_AND_DOWNLOAD": "Security and Download",
        "ORGANIZATION_LICENSE": "License Details",
        "ORGANIZATION_LICENSE_ADD": "Add License",
        "ORGANIZATION_INSERT": "Insert",
        "ORGANIZATION_SUPPORT_FIRST_NAME": "Support first name",
        "ORGANIZATION_SUPPORT_LAST_NAME": "Support last name",
        "ORGANIZATION_SUPPORT_EMAIL": "Support email",
        "ORGANIZATION_SUPPORT_PHONE": "Support phone number",
        "ORGANIZATION_DEMO": "Demo",
        "ORGANIZATION_CREATION_TIME": "Creation Time",
        "ORGANIZATION_DEMO_EXPIRATION": "Demo Expiration",
        "ORGANIZATION_API_GET_CONTACTS_ERROR": "Unable to retrieve the organization's contact info",
        "ORGANIZATION_API_ADD_CONTACTS_ERROR": "The organization was created but it was not possible to set its contact info",
        "ORGANIZATION_API_ADD_NAME_UQ_ERROR": "Unable to add the organization. Name should be unique",
        "ORGANIZATION_API_ADD_CRM_ID_UQ_ERROR": "Unable to add the organization. CRM ID should be unique",
        "ORGANIZATION_API_UPDATE_NAME_UQ_ERROR": "Unable to update the organization. Name should be unique",
        "ORGANIZATION_API_UPDATE_CRM_ID_UQ_ERROR": "Unable to update the organization. CRM ID should be unique",
        "ORGANIZATION_API_UPDATE_CONTACTS_ERROR": "The organization was updated but it was not possible to set its contact info",
        "ORGANIZATION_API_UPDATE_SITE_ERROR": "The organization was updated but it was not possible to update its site",
        "ORGANIZATION_API_UPDATE_GROUPS_SITE_ERROR": "The organization was updated but it was not possible to update the sites of the groups",
        "ORGANIZATION_API_UPDATE_SUBSCRIBER_SITE_ERROR": "The reseller was updated but it was not possible to update the sites of the subscribers",
        "ORGANIZATION_API_UPDATE_CHILDREN_SITE_ERROR": "The reseller was updated but it was not possible to update the sites of the groups and of the subscribers",
        "ORGANIZATION_API_DELETE_CHILD_ERROR": "Unable to delete the organization. An associated child record was found",
        "ORGANIZATION_CALL_LOG": "Keep log of all calls",
        "ORGANIZATION_FORCE_STRONG_DISPATCH_PASS": "Force strong password for Dispatchers",
        "RECORDING_FORCE_STRONG_RECORDING_REVIEWERS_PASS": "Force strong password for Recording Reviewers",
        "RESELLER": "reseller",
        "RESELLERS": "resellers",
        "RESELLER_TITLE": "Reseller Manager",
        "RESELLER_DETAILS": "Reseller Details",
        "RESELLER_ADDRESS": "Address",
        "RESELLER_ADDRESS_NAME": "Address NAME",
        "RESELLER_CRMID": "CRM ID",
        "RESELLER_NAME": "Reseller name",
        "RESELLER_CONTACT_DETAILS": "Contact Details",
        "RESELLER_ADMINISTRATOR_DOMAIN": "Administrator Domain",
        "RESELLER_WEBSERVICE_URL": "Web Service URL",
        "RESELLER_LICENSE": "License Details",
        "RESELLER_LICENSE_ALLOCATION": "Add License",
        "RESELLER_LICENSE_BUNDLE_GENERATION": "License bundle generation",
        "RESELLER_AGGREGATE_END_USER": "Aggregate End User",
        "RESELLER_AEU_EMAIL": "AEU billing report email",
        "RESELLER_PORTAL_URL": "Domain URL",
        "RESELLER_SITE": "Site",
        "RESELLER_LICENSE_NAME": "License name",
        "RESELLER_ADMIN_FIRST_NAME": "Admin Contact First Name",
        "RESELLER_ADMIN_LAST_NAME": "Admin Contact Last Name",
        "RESELLER_ADMIN_EMAIL": "Contact email address",
        "RESELLER_ADMIN_PHONE": "Contact telephone number",
        "RESELLER_SUPPORT_FIRST_NAME": "Support Contact First Name",
        "RESELLER_SUPPORT_LAST_NAME": "Support Contact Last Name",
        "RESELLER_SUPPORT_EMAIL": "Support email address",
        "RESELLER_SUPPORT_PHONE": "Support telephone number",
        "RESELLER_CONTEXT_WARNING": "Please switch to reseller context",
        "RESELLER_API_GET_SITE_ERROR": "Unable to retrieve the site of the reseller",
        "RESELLER_API_GET_CONTACTS_ERROR": "Unable to retrieve the contact info of the reseller",
        "RESELLER_API_ADD_SITE_ERROR": "Reseller created but it was not possible to set its site",
        "RESELLER_API_ADD_CONTACTS_ERROR": "Reseller created but it was not possible to set its contact info",
        "RESELLER_API_ADD_NAME_UQ_ERROR": "Unable to add reseller. Reseller name should be unique",
        "RESELLER_API_ADD_CRM_ID_UQ_ERROR": "Unable to add reseller. CRM ID should be unique",
        "RESELLER_API_ADD_PORTAL_URL_UQ_ERROR": "Unable to add the reseller. The Domain URL should be unique",
        "RESELLER_API_ADD_WEBSERVICE_URL_UQ_ERROR": "Unable to add the reseller. The Web Service URL should be unique",
        "RESELLER_API_UPDATE_SITE_ERROR": "The reseller was updated but it was not possible to set its site",
        "RESELLER_API_UPDATE_CONTACTS_ERROR": "The reseller was updated but it was not possible to set its contact info",
        "RESELLER_API_UPDATE_NAME_UQ_ERROR": "Unable to update reseller. Reseller name should be unique",
        "RESELLER_API_UPDATE_CRM_ID_UQ_ERROR": "Unable to update reseller. CRM ID should be unique",
        "RESELLER_API_UPDATE_PORTAL_URL_UQ_ERROR": "Unable to update the reseller. The Domain URL should be unique",
        "RESELLER_API_UPDATE_WEBSERVICE_URL_UQ_ERROR": "Unable to update the reseller. The Web Service URL should be unique",
        "RESELLER_API_DELETE_SITE_ERROR": "Unable to delete the reseller's site record",
        "CONFIG": "configuration parameter",
        "CONFIGS": "configuration parameters",
        "CONFIG_ADD_PARAM": "Add a parameter",
        "CONFIG_SET_PARAM": "Set the parameter's value",
        "CONFIG_WARNING": "An invalid value may affect the server's stability!",
        "CONFIG_DEFAULT": "Default parameter",
        "CONFIG_VALUE_TYPE": "Value Type",
        "CONFIG_NAME": "Name",
        "CONFIG_VALUE": "Value",
        "CONFIG_ACTIONS": "Actions",
        "CONFIG_ADD_CONFIG": "Add config",
        "CONFIG_SERVER_ID": "Server Id",
        "CONFIG_SITE": "Site",
        "CONFIG_SERVER": "Server",
        "CONFIG_SYSTEM": "System",
        "SITE": "site",
        "SITES": "sites",
        "SITE_TITLE": "Sites",
        "SITE_DIALOG_TITLE": "Site Details",
        "SITE_NAME": "Name",
        "SITE_HOST": "Host",
        "SITE_PUBLIC_IP": "Public IP",
        "SITE_TYPE": "Type",
        "SITE_CONTROL_PORT": "Control Port",
        "SITE_AUDIO_PORT": "Audio Port",
        "SITE_STATE": "Operation State",
        "SITE_SERVER_1": "First Server",
        "SITE_SERVER_2": "Second Server",
        "SITE_ACTIVE_SERVER": "Active Server",
        "SITE_SWITCH_COMMAND": "Switch command",
        "SITE_API_ADD_IP_USED_ERROR": "Unable to add the site. The IP address is used by another server not affiliated with this site",
        "SITE_API_UPDATE_IP_USED_ERROR": "Unable to update the site. The IP address is used by another server not affiliated with this site",
        "SITE_API_DELETE_GROUP_ERROR": "Unable to delete the site. This site is used by a group. Change the site for the group first",
        "SERVER": "server",
        "SERVERS": "servers",
        "SERVER_TITLE": "Servers",
        "ITO_CONFIG": "ITO Config",
        "SERVER_NAME": "Name",
        "SERVER_HOST": "IP address",
        "SERVER_TYPE": "Type",
        "SERVER_STATE": "Operation State",
        "SERVER_ADMIN_STATE": "Admin State",
        "SERVER_API_ADD_IP_ERROR": "Unable to add the server. This IP address is used by another server of the same type",
        "SERVER_API_UPDATE_IP_ERROR": "Unable to update the server. This IP address is used by another server with the same type",
        "SERVER_API_DELETE_SITE_ERROR": "Unable to delete the server. It is used by one of the sites",
        "DEVICE": "device",
        "DEVICES": "devices",
        "DEVICE_TITLE": "Devices",
        "DEVICE_DETAILS": "Device Details",
        "DEVICE_MODEL": "Device model",
        "DEVICE_CAT_NAME": "Category name",
        "DEVICE_TYPE": "Device type",
        "DEVICE_ACTIONS": "Actions",
        "DEVICE_ADD": "Add device",
        "DEVICE_MANUFACTURER": "Select manufacturer",
        "DEVICE_NAME": "Device name",
        "DEVICE_API_NAME_UQ_ERROR": "Device with the same name already exists",
        "PTT_DEVICE": "PTT device",
        "PTT_DEVICES": "PTT devices",
        "PTT_DEVICE_DETAILS": "PTT Device Details",
        "PTT_DEVICE_TITLE": "PTT Devices",
        "PTT_DEVICE_MODEL": "Device model",
        "PTT_DEVICE_CAT_NAME": "Category name",
        "PTT_DEVICE_TYPE": "Device type",
        "PTT_DEVICE_NAME": "Device name",
        "PTT_DEVICE_API_NAME_UQ_ERROR": "A PTT Device with the same name already exists for this store",
        "MANUFACTURER": "device manufacturer",
        "MANUFACTURERS": "device manufacturers",
        "MANUFACTURER_TITLE": "Manufacturers of Devices",
        "MANUFACTURER_DETAILS": "Device Manufacturer Details",
        "MANUFACTURER_API_DELETE_CHILD_RECORD_ERROR": "Unable to delete the manufacturer. A child record was found",
        "SOFTWARE_MANUFACTURER": "software manufacturer",
        "SOFTWARE_MANUFACTURERS": "software manufacturers",
        "SOFTWARE_MANUFACTURERS_TITLE": "Software Manufacturers",
        "SOFTWARE_MANUFACTURERS_DETAILS": "Software Manufacturer Details",
        "LICENSE_BUNDLE": "Bundle",
        "LICENSE_BUNDLES": "license bundles",
        "LICENSE_ALLOCATION": "license allocation",
        "LICENSE_ALLOCATIONS": "license allocations",
        "LICENSE_ASSIGNMENT": "license assignment",
        "LICENSE_ASSIGNMENTS": "license assignments",
        "LICENSE_TITLE": "Licenses",
        "LICENSE_DETAILS": "License Details",
        "LICENSE_NAME": "License Name",
        "LICENSE_DESCRIPTION": "License description",
        "LICENSE_PERMISSIONS": "Permissions",
        "LICENSE_TYPE": "License Type",
        "LICENSE_ALLOCATION_DATE": "Allocation Date",
        "LICENSE_EXPIRATION_TYPE": "Expiration Type",
        "LICENSE_EXPIRATION_DATE": "Expiration Date",
        "LICENSE_AVAILABLE_QTY": "Available",
        "LICENSE_QUANTITY": "Quantity",
        "LICENSE_ALLOCATE": "Allocate",
        "LICENSE_TEMPLATES": "License Templates",
        "CONVERT_TO_LICENSE": "Show License Template",
        "LICENSE_MASK": "License Code",
        "CONVERT_TO_MASK": "Show License Code",
        "LICENSE_CODE": "License Code",
        "APP_CONVERT": "License Code Generation",
        "UNDO_LICENSE": "Undo",
        "LICENSE_REVOKE": "Revoke",
        "LICENSE_API_ALLOCATION_GET_PARENT_LIST_ERROR": "Unable to retrieve parent license allocations",
        "LICENSE_API_ASSIGNMENT_REVOKE_ERROR": "Unable to revoke license assignment",
        "ILLEGAL_LICENSE": "Fields must all be of boolean type",
        "LICENSE_TOAST_ALLOCATION_SUCCESS": "Allocated successfully",
        "LICENSE_ALLOCATION_QTY_ERROR": "License quantity is insufficient",
        "LICENSE_ALLOCATION_ORG_ACTIVE_ERROR": "There are no active license allocations in the organization",
        "LICENSE_MAX_ORDINARY_SUBSCRIBERS": "Max quantity of ordinary Subscribers",
        "LICENSE_MAX_DISPATCH_CONSOLE_SUBSCRIBERS": "Max quantity of Dispatchers",
        "LICENSE_MAX_SUBSCRIBERS": "Max Total Subscribers",
        "LICENSE_IN_USE": "In use",
        "LICENSE_EXPIRATION_DATE_SERVER": "Server License expiration date",
        "RESELLER_QTY": "PTT license Qty",
        "RESELLER_DISPATCHER_QTY": "Dispatcher license Qty",
        "ORGANIZATION_QTY": "PTT license Qty",
        "ORGANIZATION_DISPATCHER_QTY": "Dispatcher license Qty",
        "LICENSE_DISPATCHER_ALLOCATE": "Allocate",
        "LICENSE_ALLOCATE_BUTTON": "Apply",
        "PARENT_RESELLER_QTY": "Parent license Qty: PTT",
        "PARENT_RESELLER_DISPATCHER_QTY": "Dispatcher",
        "LICENSE_QTY_TOOLTIP": "Number of licenses in use out of allocated licenses of this type",
        "CLIENT_VERSION": "client version",
        "CLIENT_VERSIONS": "client versions",
        "CLIENT_VERSION_TITLE": "Client Version",
        "CLIENT_VERSION_DIALOG_TITLE": "Client Version Details",
        "CLIENT_VERSION_STORE_NAME": "Client Version Store Name",
        "CLIENT_VERSION_VERSION": "Version",
        "CLIENT_VERSION_SELECT_STORE": "Select PTT Store",
        "CLIENT_VERSION_PATH": "Local file path",
        "CLIENT_VERSION_DESCRIPTION": "Description",
        "STORE": "PTT client store",
        "STORES": "PTT client stores",
        "STORE_TITLE": "PTT Client Store",
        "STORE_DETAILS_TILE": "PTT Client Store Details",
        "STORE_MODEL": "Device model",
        "STORE_CAT_NAME": "Category name",
        "STORE_TYPE": "Device type",
        "STORE_ACTIONS": "Actions",
        "STORE_ADD_DEVICE": "Add device",
        "STORE_DEVICE": "Select device",
        "STORE_CLIENT_STORE": "Client store",
        "STORE_MANUFACTURER": "Select manufacturer",
        "STORE_DEVICE_NAME": "Device name",
        "STORE_LICENSABLE_TYPE": "Licensable Type",
        "STORE_DESCRIPTION": "Description",
        "STORE_MANUFACTURER_NAME": "Manufacturer name",
        "STORE_CLIENT_VERSION": "Client Version",
        "STORE_API_NAME_UQ_ERROR": "Client Store with the same name already exists for this manufacturer",
        "LOCALIZATION_TITLE": "Localization",
        "LOCALIZATION_DETAILS": "details",
        "LOCALIZATION_FLAG": "Flag",
        "LOCALIZATION_ACTIVE": "Active",
        "LOCALIZATION_DEFAULT": "Default",
        "LOCALIZATION_NAME": "Label",
        "LOCALIZATION_TRANSLATION": "Translation key",
        "LOCALIZATION_CODE": "Language Code",
        "LOCALIZATION_IMPORT": "Import translation table",
        "LOCALIZATION_EXPORT": "Export translation table",
        "LOCALIZATION_REMOVE_DEFAULT_ERROR": "Unable to delete default language. Please set another as default and try again",
        "LOCALIZATION_ADD_DUPLICATE_ERROR": "Error: Translation with such key already exists",
        "JOB_TITLE": "Process",
        "JOB_RUN_INTEGRITY": "Run a DB Integrity process",
        "JOB_RUN_EXPIRATION": "Run License Expiration process",
        "JOB_PROVISIONING": "Provisioning",
        "JOB_GPS": "GPS archiver",
        "JOB_MONGO_HA": "Mongo DB High Availability",
        "JOB_INIT_LOG": "Initialize the Log",
        "JOB_RUN_LOG": "Run the Log",
        "JOB_PROV_LICENSE_LOG": "License Expiration Job",
        "JOB_PROV_DB_INIT_LOG": "Database Initialization Log",
        "JOB_PROV_DB_INTEGRITY_LOG": "DB integrity Log",
        "BULK_TITLE": "Bulk Operations",
        "BULK_OPERATIONS": "Bulk Operations",
        "BULK_INTERACTIVE_DELETE": "Deletion",
        "DELETE_INTERACTIVE_SUBSCRIBERS": "Subscribers",
        "DELETE_INTERACTIVE_GROUPS": "Groups",
        "DELETE_INTERACTIVE_OCL": "Contact Groups",
        "DELETE_INTERACTIVE_EMERGENCY_GROUP": "Emergency Groups",
        "DELETE_INTERACTIVE_CONTACT_TEMPLATE": "Contacts Templates",
        "DELETE_INTERACTIVE_FORWARD_GROUP": "Forward Groups",
        "DELETE_INTERACTIVE_TYPE": "Deletion Type",
        "DELETE_GROUPS": "Groups",
        "DELETE_SUBSCRIBERS": "Subscribers",
        "DELETE_OCL": "Contact Groups",
        "DELETE_EMERGENCY_GROUP": "Emergency Groups",
        "DELETE_FORWARD_GROUP": "Forward Groups",
        "DELETE_CONTACT_TEMPLATE": "Contacts Templates",
        "BULK_DELETE_COUNT": "Deletion Count",
        "BULK_INTERACTIVE_LICENSE": "License",
        "BULK_INTERACTIVE_ROLE": "Role",
        "BULK_SUBSCRIBERS_COUNT": "Subscribers Count",
        "DOWNLOAD_SAMPLE_FILE": "Download Sample File",
        "BULK_RESULT_LOG": "Result Log",
        "BULK_IMPORT_NOTE": "While importing subscribers, the affiliated group will be applied to subscribers with off-net licenses.",
        "AFFILLIATED_ORG_SUB_NOT_ADDED_MESSAGE": "affiliated organization subscribers have not been added",
        "GROUP_LIMIT_SIZE": "Group name size limit exceeded",
        "SUBSCRIBERS_API_NAME_LIMIT_SIZE": "Subscriber name size limit exceeded",
        "BULK_EXPORT": "Export Subscribers",
        "BULK_IMPORT": "Import Subscribers",
        "BULK_EXPORT_REPORT": "Reports",
        "BULK_EXPORT_CALL_LOG": "Call Log Report",
        "BULK_EXPORT_RUNTIME": "Subscribers Status Report",
        "BULK_ENABLE_ALL": "Enable All Subscribers",
        "BULK_SUSPEND_ALL": "Disable All Subscribers",
        "BULK_DELETE_ALL": "Delete All Subscribers",
        "BULK_DELETE_APPLY": "Execute Deletion",
        "BULK_SELECT_ALLOCATION": "Select Allocation",
        "BULK_SELECT_ROLE": "Select Role",
        "BULK_SELECT_LICENSE": "Select License",
        "BULK_ALLOCATION_APPLY": "Apply Allocation",
        "BULK_IMPORT_FILE_FORMAT_MESSAGE": "Please upload CSV or XLSX file only",
        "BULK_INTERACTIVE_SMS": "SMS Provisioning",
        "BULK_INTERACTIVE_CHANGE_PASSWORD": "Password Modification",
        "BULK_CHANGE_PASSWORD_APPLY": "Set new Password",
        "APP_CHANGE_PASSWORD_INTERACTIVE_WARNING_TITLE": "Are you sure you want to set this Password for the selected users?",
        "SUBSCRIBERS_NEW_PASSWORD": "New Password",
        "INVALID_BULK_FILE_FORMAT": "The format of the file is invalid",
        "BULK_INTERACTIVE_EMERGENCY_GROUP": "Emergency Groups",
        "BULK_INTERACTIVE_FORWARD_GROUP": "Forward Groups",
        "BULK_SELECT_EMERGENCY_GROUP": "Select Emergency Group",
        "BULK_SELECT_FORWARD_GROUP": "Select Forward Group",
        "APP_EMERGENCY_GROUP_INTERACTIVE_WARNING_TITLE": "Are you sure you want to assign this Emergency Group to the selected users?",
        "BULK_INTERACTIVE_CONTACT_TEMPLATE": "Contacts Templates",
        "BULK_CONTACT_TEMPLATE_SUBSCRIBERS": "Template to Subscriber",
        "BULK_CONTACT_TEMPLATE_TEMPLATES": "Template to Template",
        "CONTACT_TEMPLATE_TYPE": "Type",
        "BULK_SELECT_CONTACT_TEMPLATE": "Select Contacts Template",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_ADD_WARNING_TITLE": "Are you sure you want to assign this Contacts Templates to the selected users?",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_ADD_WARNING_GROUP_TITLE": "Are you sure you want to assign this Contacts Templates to the selected group users?",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_REMOVE_WARNING_TITLE": "Are you sure you want to remove this Contacts Template from the selected users?",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_REMOVE_WARNING_GROUP_TITLE": "Are you sure you want to remove this Contacts Template from the selected group users?",
        "BULK_CONTACT_TEMPLATE_ADD": "Add Contact Template Users",
        "BULK_CONTACT_TEMPLATE_REMOVE": "Remove Contact Template Users",
        "RESELLER_SMS_CONFIGURATION": "SMS Provider Configuration",
        "SMS_API_KEY": "API Key",
        "SMS_API_SECRET": "API Secret",
        "SMS_IP": "SMSC IP address",
        "SMS_PORT": "SMSC Port",
        "SMS_SEND_CREDENTIAL": "Credentials",
        "SMS_SEND_CREDENTIALS_WITH_SERVER": "Credentials & Server URL",
        "SMS_SEND_MESSAGE": "Customized Message",
        "SMS_SEND_CREDENTIALS_AND_DOWNLOAD_LINK": "Credentials with link",
        "SMS_SEND_DOWNLOAD_LINK": "Download link",
        "SMS_DOWNLOAD_LINK": "Enter a customized Download Link",
        "SMS_MESSAGE": "Enter a customized Message",
        "SMS_MISSING_KEYS": "Credentials to access the SMS provider are not configured by the reseller",
        "SMS_API_VALIDATION_PHONE_ERROR": "SMS API error: Phone number not provided",
        "SMS_API_VALIDATION_CREDENTIALS_ERROR": "SMS API error: credentials not provided",
        "USER_VALIDATION_EMAIL_FORMAT_ERROR": "Invalid email format",
        "USER_ID": "User Id",
        "TEXT_SEARCHBTN": "Search",
        "SEARCH_RESULT": "Search Results",
        "START_DATE": "Start Date",
        "END_DATE": "End Date",
        "ENTER_DATE": "Select the Date",
        "ADMIN_RECORD_TITLE": "Recordings Reviewers",
        "ADMIN_RECORD_EMAIL_ID": "Email ID",
        "ADMIN_RECORD_LAST_LOGIN_TIME": "Recent Login Time",
        "ADMIN_RECORD_LAST_ACTIVITY_TIME": "Recent Activity Time",
        "USER_LAST_PASSWORD_CHANGE_TIME": "Last password modification",
        "ADMIN_RECORD_DIALOG_TITLE": "Recordings Reviewer Details",
        "ADMIN_RECORD_DETAILS": "Reviewer Details",
        "ADMIN_RECORD_ACTIVITY": "Activity Details",
        "ADMIN_RECORD_ACTIVITY_COMMAND": "Operation",
        "ADMIN_RECORD_ACTIVITY_SESSION_NAME": "Recorded Session Name",
        "ADMIN_RECORD_ACTIVITY_USER_NAME": "User Name",
        "ADMIN_RECORD_ACTIVITY_TIME": "Activity Time",
        "ADMIN_RECORD_ACTIVITY_IP": "Source IP",
        "AUDIO_BACKUP_PATH_TITLE": "Storage Management",
        "AUDIO_BACKUP_FOLDER_DATE": "Month & Year",
        "AUDIO_BACKUP_PATH": "Path",
        "AUDIO_BACKUP_PATH_DIALOG_TITLE": "Storage Management",
        "FOLDER_DATE": "Month & Year",
        "BRANDING_TITLE": "Branding",
        "BRANDING_TITLE_IMAGE": "Branding image",
        "BRANDING_NAME": "Application Name",
        "COLOR1": "Color 1",
        "COLOR2": "Color 2",
        "BRANDING_IMAGE": "Mobile App Splash Image",
        "BRANDING_MDC_LOGO_IMAGE": "Dispatch Console Logo Image",
        "BRANDING_MDC_SPALSH_IMAGE": "Dispatch Console Splash Image",
        "BRANDING_MDC_COMPANYNAME_IMAGE": "Dispatch Console Company Name Image",
        "LOGO_IMAGE_ERROR_FILE_TYPE": "Wrong image format. Only ico format and file extension is supported",
        "APP_WRONG_FILE_EXTENTION": "Wrong image format",
        "BRANDING_ERROR_COLOR": "Invalid color value format",
        "BRANDING_ERROR_NAME_LENGTH": "Application Name is limited to 20 characters only",
        "BUTTON_SAVE_BRAND_INFO": "SAVE BRANDING CONFIGURATION",
        "BUTTON_SAVE_BRAND_IMG": "SAVE BRANDING IMAGE",
        "BUTTON_RESET_BRAND_INFO": "Revert all to Default Branding",
        "FLAG_BRAND_ACTIVATION": "Override Default Branding",
        "BRANDING_RESET_WARNING": "Cancel the overriding. The application will use the default branding values set by the developers.",
        "BRANDING_MAP_SERVER": "Maps Server Address",
        "BRANDING_ORGANIZATION_OVERRIDE_RESELLER": "Override Reseller Branding",
        "BRANDING_RESELLER_OVERRIDE_RESELLER": "Set Branding for sub-Resellers and sub-Organizations",
        "APP_TOAST_SELECT_IMAGE": "Please select an image",
        "BRANDING_ERROR_FILE_TYPE": "Wrong image format. Only png jpg and jpeg formats and file extensions are supported",
        "BRANDING_ERROR_IMAGE_SIZE": "The image file cannot be larger than 200 KBytes",
        "BRANDING_TITLE_MESSAGE": "Branding settings may immediately affect all users in this organization!",
        "NAVIGATION_ORG_FRIENDS": "Affiliation Manager",
        "ORG_FRIEND_API_GET_LIMIT_ERROR": "Unable to retrieve the affiliate list",
        "ORG_FRIEND": "Affiliated organizations",
        "ORG_AFFILIATED_GROUPS": "Affiliated groups",
        "ORG_AFFILIATED_CONTACTS": "Affiliated contacts",
        "ORG_FRIENDS_API_LIMIT_ERROR": "Unable to update because the limit of %s affiliates has been reached. Check with the service provider if the limit can be increased.",
        "APP_SAVE_ORG_FRIEND": "Save affiliated organizations",
        "ORG_AFFILIATED_AFFECT_WARNING": "Any change in affiliate organizations will affect organizational affiliated group members.",
        "ORG_AFFILIATED_OFFNET_WARNING": "Assign Off-Net License to all relevant members BEFORE creating an affiliated group!",
        "ORG_AFFILIATED_CONTACTS_OFFNET_WARNING": "Assign Off-Net License to all relevant members BEFORE creating an affiliated contacts!",
        "PERSONAL_GROUP": "Private Emergency Group",
        "PERSONAL_GROUP_API_ADD_CONTACT_ERROR": "Unable to insert the contact to the Emergency group",
        "PERSONAL_GROUP_API_NAME_UQ_ERROR": "An Emergency group with the same name already exists",
        "PERSONAL_GROUP_API_REMOVE_CONTACT_ERROR": "Unable to remove the contact from the Emergency group",
        "SUBSCRIBERS_PERSONAL_GROUP_SUBSCRIBERS": "Private Emergency Group",
        "SUBSCRIBERS_EMERGENCY_GROUP": "Emergency Group (receiving alarms)",
        "NAVIGATION_EMERGENCY_GROUPS": "Emergency Groups",
        "EMERGENCY_GROUP_DETAILS": "Emergency Group Details",
        "PERSONAL_GROUP_NAME": "Group name",
        "PERSONAL_GROUP_NOTE": "Please make sure that you have the permission of Personal Group in your Role",
        "BUTTON_OPEN_APPLICATION_LIST": "List of Applications",
        "APPLICATIONS_DIALOG_TITLE": "List of Applications",
        "APPLICATION_ICON": "App Icon",
        "APPLICATION_NAME": "App Name",
        "APPLICATION_VERSION": "App Version",
        "APPLICATION_ID": "App ID",
        "APP_ADD_APPLICATION": "Add Application",
        "RECORDING_PLAN": "Recording Plan",
        "RECORDING_PLAN_NONE": "No recording",
        "RECORDING_PLAN_ALL_CALLS": "Record all calls",
        "RECORDING_PLAN_SELECTIVE": "Selective recording",
        "NAVIGATION_RECORDING": "Recording Planner",
        "RECORDING_TITLE": "Recording Planner",
        "RECORD_WHITE_LIST_SUBSCRIBERS_TITLE": "Recorded Users",
        "RECORD_WHITE_LIST_GROUPS_TITLE": "Recorded Groups",
        "BUTTON_SAVE_RECORDED_SUBSCRIBERS": "Save plan for Users",
        "BUTTON_SAVE_RECORDED_GROUPS": "Save plan for Groups",
        "ENCRYPTION_PLAN": "Encryption Plan",
        "BUTTON_UPLOAD_KEY_FILE": "Upload custom keys",
        "BUTTON_SET_EMPTY_KEY_FILE": "Remove all keys",
        "BUTTON_SET_KEY_FILE": "Generate random encryption keys",
        "BUTTON_SET_DEFAULT_KEY_FILE": "Use Default Keys",
        "APP_TOAST_UPDATE_KEY_FILE_SUCCESS": "The Encryption Keys were loaded successfully",
        "APP_TOAST_UPDATE_EMPTY_KEY_FILE_SUCCESS": "The Encryption Keys were removed successfully",
        "ENCRYPTION_ERROR_FILE_SIZE": "The size of the Encryption Keys file must be a multiplication of 32",
        "ENCRYPTION_ERROR_FILE_TYPE": "The Encryption Keys file should be of binary type",
        "ENCRYPTION_ERROR_PERMISSION": "No permission to upload or save the Encryption Keys file",
        "VERSIONS_PLAN": "Applications versions Plan",
        "BRANDING_LATEST_VERSION_ANDROID": "Latest version of Android application",
        "BRANDING_LATEST_VERSION_MDC": "Latest MDC2000 version",
        "BUTTON_UPLOAD_ANDROID_VERSION_FILE": "Load Android APK file",
        "BUTTON_UPLOAD_MDC_VERSION_FILE": "Load MDC2000 EXE file",
        "APP_TOAST_UPLOAD_VERSION_FILE_SUCCESS": "The new application file was loaded successfully",
        "APP_TOAST_UPLOAD_VERSION_FILE_EMPTY": "No file selected. Please select a file to load.",
        "BUTTON_DELETE_ANDROID_VERSION_FILE": "Remove Android APK file",
        "BUTTON_DELETE_MDC_VERSION_FILE": "Remove MDC2000 EXE file",
        "APP_TOAST_DELETE_VERSION_FILE_SUCCESS": "File has been removed successfully",
        "UPLOAD_VERSION_ERROR_FILE_TYPE": "File type error. Only EXE or APK are supported",
        "UPLOAD_VERSION_SIGN_ERROR": "The signature of the uploaded file is wrong",
        "STRONG_PASSWORD_PLAN": "Strong Password Plan",
        "MAX_LOGIN_RETRIES_PLAN": "Block Users Plan",
        "MAX_LOGIN_RETRIES": "Maximum login retries",
        "CHANGE_PASSWORD_PLAN": "Password Expiration Plan",
        "PASSWORD_EXPIRATION_DAYS": "Password expiration days",
        "GENERIC_IMPORT": "Import",
        "GENERIC_EXPORT": "Export",
        "NAVIGATION_REPORT": "Reports",
        "REPORT_TITLE": "Reports",
        "BILLING_REPORT_EXPORT": "Export License usage Report",
        "SYSTEM_USERS_REPORT_EXPORT": "Export List of Subscribers",
        "BULK_EXPORT_ADMIN_RECORDS": "Export Recording Reviewers Activity Report",
        "WFM_TITLE": "Workforce Management",
        "NAVIGATION_WFM": "Workforce Management",
        "WFM_USERS_MANAGEMENT": "Users Management",
        "WFM_INCIDENCES": "User report headers",
        "WFM_APPLY": "Apply changes",
        "WFM_USER": "Workforce Management User",
        "WFM_USERS": "Workforce Management Users",
        "WFM_API_ADD_WFMUSER_ERROR": "Unable to add the users to Workforce Management",
        "WFM_API_REMOVE_WFMUSER_ERROR": "Unable to remove the users from Workforce Management",
        "WFM_API_DUPLICATE_WFMUSER_ERROR": "User already exists in the Workforce Management.",
        "WFM_INCIDENCE_DEFAULT": "Default",
        "WFM_ADD_TYPE": "Add new report type",
        "NAVIGATION_CALL_LOGS": "Call Log",
        "CALL_LOGS_TITLE": "CALL LOG",
        "CALL_LOGS_SESSION_NAME": "Channel Name",
        "CALL_LOGS_SESSION_ID": "Channel ID",
        "CALL_LOGS_SENDER_NAME": "Sender Name",
        "CALL_LOGS_RECIPIENT_NAME": "Recipient Name",
        "CALL_LOGS_SESSION_TYPE": "Channel Type",
        "CALL_LOGS_SESSION_START_TIME": "Start Time",
        "CALL_LOGS_SESSION_END_TIME": "End Time",
        "CALL_LOGS_DIALOG_TITLE": "CHANNEL ACTIVITY",
        "CALL_LOG_SESSION_BY_DATE_BUTTON": "Filter by Date",
        "CALL_LOG_SESSION_CLEAR_DATE_BUTTON": "Clear Filter",
        "CALL_LOG_SESSION_SHOW_FILTER_BY_DATES": "Show Filters",
        "CALL_LOG_SESSION_SHOW_FILTER_BY_DATES_WARNING_TITLE": "Close Filters Pane",
        "CALL_LOG_SESSION_SHOW_FILTER_BY_DATES_WARNING_CONTENT": "Closing this pane will also clear the filters. Continue?",
        "DATES_BLANK_ERROR": "Start Date or End Date were not chosen",
        "DATES_ERROR": "End Date cannot be before the Start Date",
        "CALL_LOGS_BURST_TALKER_NAME": "Speaker Name",
        "CALL_LOGS_BURST_TALKER_ID": "Speaker ID",
        "CALL_LOGS_BURST_TALKER_START_TIME": "Start Time",
        "CALL_LOGS_BURST_TALKER_END_TIME": "End Time",
        "CALL_LOGS_BURST_DURATION": "Duration",
        "CALL_LOG_DATES_CONTEXT_WARNING": "Please choose dates",
        "APP_RELEASE": "Lock State",
        "APP_RELEASE_WARNING_TITLE": "Unlocking Account",
        "APP_RELEASE_WARNING_CONTENT": "You are about to unlock the account of this user. First it is advised to change the password of the user. Continue?",
        "APP_TOAST_RELEASE_SUCCESS": "Account has been unlocked successfully",
        "APP_BLOCK_WARNING_TITLE": "Locking Account",
        "APP_BLOCK_WARNING_CONTENT": "You are about to lock the account of this user. Continue?",
        "APP_BLOCK_USER": "Your account has been temporarily blocked. Contact your administrator for assistance.",
        "APP_TOAST_BLOCK_SUCCESS": "Account has been blocked successfully",
        "NAVIGATION_APPLICATION_LISTS": "Mobile Apps Planning",
        "APPLICATION_LISTS": "Mobile Applications Lists",
        "APPLICATION_PACKAGE": "App Package",
        "APPLICATION_GET_DETAILS": "Extract App package details",
        "APPLICATION_DESCRIPTION": "App Description",
        "APPLICATION_DEFAULT_LIST": "Default app list",
        "APPLICATION_ADD_DIALOG": "Add application",
        "APPLICATION_PROFILES": "Application profiles",
        "APPLICATION_LIST_ID": "App list ID",
        "APPLICATION_LIST_NAME": "App list name",
        "APPLICATION_LIST_DIALOG": "Application list",
        "APPLICATION_LIST_MIC": "Apps using microphone",
        "APPLICATION_LIST_KIOSK": "Apps allowed in Kiosk mode",
        "APPLICATION_UPDATE_PACKAGE_ERROR": "The uploaded application package is different from the existing one.",
        "APPLICATION_UPDATE_VERSION_ERROR": "The version of the uploaded application is lower than the existing one.",
        "SUBSCRIBERS_APPLICATION_LIST": "Application lists",
        "BULK_INTERACTIVE_APPLICATION_LIST": "App List Assign",
        "BULK_SELECT_APPLICATION_LIST": "Select App List",
        "APP_APPLICATION_LIST_INTERACTIVE_WARNING_TITLE": "Are you sure you want to apply the change?",
        "APP_DELETE_APPLICATION_LIST_WARNING_TITLE": "Are you sure you want to delete the App List?",
        "APPLICATION_LIST_ERROR_DUPLICATE_NAME": "the App List name is not unique",
        "APP_TOAST_ADD_APPLICATION_ERROR": "An app with same Package already exist or it appears in the App List",
        "APP_TOAST_ADD_APPLICATION_SUCCESS": "Application Added Successfully.",
        "APP_TOAST_ADD_APPLICATION_UPDATE_SUCCESS": "Application Updated Successfully.",
        "APP_TOAST_REMOVE_APPLICATION": "Application Removed Successfully.",
        "APP_TOAST_ADD_APPLICATION_RESERVED_ERROR": "The name of the package cannot contain reserved words or symbols",
        "APP_MOVE_TAB_APPLICATION_LIST_WARNING_TITLE": "Save changes warning",
        "APP_MOVE_TAB_APPLICATION_LIST_WARNING_CONTENT": "If you do not save the changes now they will be discarded. Do you want to switch to another tab without saving?",
        "APPLICATION_LIST_WARNING_TITLE": "Effect warning",
        "APPLICATION_LIST_WARNING_CONTENT": "Warning: Changes applied in this area will immediately affect all users of your organization",
        "NAVIGATION_REACH_ME": "Reach All reports",
        "REACH_ME_TITLE": "Reach All Reports",
        "REACH_ME_USERS": "Reach All Users",
        "REACH_ME_GROUPS": "Reach All Groups",
        "REACH_ME_USER_NAME": "User name",
        "REACH_ME_USER_ID": "User ID",
        "REACH_ME_USER_PHONE": "Phone number",
        "REACH_ME_USER_IMEI": "IMEI",
        "REACH_ME_GROUP_NAME": "Group name",
        "REACH_ME_GROUP_ID": "Group ID",
        "REACH_ME_GROUP_ADMIN_ID": "Owner ID",
        "REACH_ME_GROUP_ADMIN_NAME": "Owner Name",
        "REACH_ME_GROUP_DIALOG_TITLE": "Reach All Group Details",
        "REACH_ME_GROUP_MEMBER_NAME": "Member name",
        "REACH_ME_GROUP_MEMBER_ID": "Member ID",
        "REACH_ME_GROUP_USER": "Could not retrieve the information from the repository. Check the configuration of the system.",
        "REACH_ME_USER_LAST_SEEN": "Last seen",
        "REACH_ME_USER_LAST_REGISTERED": "Last registered",
        "REACH_ME_USER_ACTIVITY_DIALOG_TITLE": "User Activity Report",
        "REACH_ME_USER_ACTION": "Action",
        "REACH_ME_USER_ACTION_TIME": "Timestamp",
        "SUBSCRIBERS_SUBSCRIBER_LIST": null,
        "LOCALIZATION_FlAG": null,
        "SMS_SERVICE": "Service",
        "SMS_SEND_CREDENTIAL_WITHOUT_SERVER": null,
        "APP_TOAST_COLOR_ERROR": null,
        "APP_TOAST_IMAGE_FORMAT_ERROR": null,
        "APP_TOAST_IMAGE_SIZE_ERROR": null,
        "ACTIVITY_LOG_TITLE": "Activity Log",
        "ACTIVITY_LOG_TIMESTAMP": "Timestamp",
        "ACTIVITY_LOG_USER": "Administrator",
        "ACTIVITY_LOG_TYPE": "Type",
        "ACTIVITY_LOG_NAME": "Name",
        "ACTIVITY_LOG_OPERATION": "Operation",
        "ACTIVITY_LOG_DESCRIPTION": "Description",
        "BULK_EXPORT_ACTIVITY_LOG": "Activity Log Report",
        "RADIO_GROUP_CHAT": "Radio",
        "EMERGENCY_GROUP": "Emergency",
        "FORWARD_GROUP": "Support Group",
        "FORWARD_GROUP_NAME": "Support Group Name",
        "CONFERENCE_GROUP_BROADCAST": "Conference",
        "ORGANIZATION_CONTACT_GROUP": "Organization contact group",
        "CONTACTS_TEMPLATE": "Contacts Template",
        "OWN": "Own",
        "GENERATE_COMMON_PASSWORD": "Selected Password",
        "GENERATE_UNIQUE_PASSWORD": "Generate Unique Passwords",
        "ORGANIZATION_STRONG_ADMINISTRATOR_PASS": "Force strong password for Administrators",
        "PLAYER_CLIENT_VERSION": "Player Client Version",
        "UNABLE_TO_ADD_MULTIPLE_EMERGENCY_GROUP": "Unable to add Multiple Private Emergency Group",
        "SECONDARY_SITE_TITLE": "Assign secondary site",
        "APP_SENTINEL": "Sentinel Configurations",
        "APP_PORT": "Port",
        "PATH_NOTE": "Please Add '/' before path",
        "PATH_NOT_SET": "Path not set",
        "ORGANIZATION_API_ADD_PORTAL_URL_UQ_ERROR": "Unable to add the organization. Domain URL should be unique",
        "APP_LIST_SHOW": "APP LIST",
        "APP_LIVE_SENTINEL_EVENTS": "Live Sentinel Events",
        "APP_INFO": "Information",
        "SENTINEL_INFO_TEXT": "To test the functionality, please use the following test endpoint",
        "URL_NOTE": "Please Enter URL with 'HTTP/S'",
        "APP_ROLE_FILTER": "Filter by Role",
        "CONFIG_IPRS_WARNING": "Please keep same value for this configuration at server!",
        "MOBILE_PORTAL_LOGO_IMAGE": "Management Portal Logo Image",
        "NAVIGATION_LOCATION_HISTORY": "Location History",
        "LOCATION_LATITUDE": "Latitude",
        "LOCATION_LONGITUDE": "Longitude",
        "LOCATION_ACCURANCY": "Accuracy",
        "LOCATION_DATE_TIME": "Date Time",
        "LOCATION_ACTIVITY": "Location Activity",
        "LOCATION_COUNT": "Location Count",
        "BULK_EXPORT_LOCATION_HISTORY": "Export Location History",
        "LOCATION_LAST_UPDATE_TIME": "Last Updated Time",
        "BULK_CONTACT_TEMPLATE_SUB_TO_SUB": "Subscriber to Subscriber",
        "BULK_EXPORT_APPLICATIONS": "Export Applications",
        "BULK_EXPORT_ROLES": "Export Roles",
        "NAVIGATION_MOVEORGANIZATION": "Migration",
        "TRANSFER_RESELLER": "Transfer Reseller",
        "TRANSFER_ORGANIZATION": "Transfer Organization",
        "TRANSFER_RESFORYOU": "Select Source Reseller",
        "TRANSFER_PARENTRES": "Select Destination Parent Reseller",
        "TRANSFER_ORGLIST": "Organization List",
        "TRANSFER_ORGFORYOU": "Select Source Organization",
        "TRANSFER_SELECTRES": "Select Reseller",
        "TRANSFER_ORGANIZATION": "Transfer Organization",
        "NOT_SUPPORTED": "We are unable to fetch the app details. Please manually add the other required details",
        "CONTACT_LIMIT_EXCEEDED": "Contact limit exceeded. Cannot add more than the configured limit",
        "API_RESELLER_DELETE_ERROR": "Unable to delete reseller. Please delete associated organizations first.",
        "BULK_EXPORT_SUBSCRIBER_QR_CODE": "Export Subscriber QR Codes",
        "MOBILEAPP_DELETE_WARNING_CONTENT": "If you delete this app, it will be automatically removed from all assigned Application Profiles, and users will no longer have access to it.",
        "DISABLE_REMEMBER_ME": "Disable Remember Last User",
        "APP_QR_WARNING_TITLE": "Re-generate Authentication",
        "APP_QR_WARNING_CONTENT": "Are you sure want to Re-generate Authentication QR Code?",
        "APP_QR_ENABLE_AUTHENTICATION": "Enable Authentication",
        "APP_QR_DISABLE_AUTHENTICATION": "Disable Authentication",
        "APP_QR_REGENERATE_AUTHENTICATION": "Re-generate Authentication",
        "APP_QR_TWO_FACTOR": "Two Factor",
        "APP_QR_DISABLE_TITLE": "Disbale Authentication",
        "APP_QR_DISABLE_CONTENT": "Are you sure want to Disable Authenticator QR Code?",
        "APP_QR_ENABLE_SUCCESS": "QR Code Authenticator Enabled Successfully",
        "APP_QR_REGENERATE_SUCCESS": "QR Code Authenticator Regenerated Successfully",
        "APP_QR_DISABLE_SUCCESS": "Authenticator QR Code Disabled Successfully",
        "APP_DISPATCHER_PERMISSION_LICENSE_WARNING": "Either Dispatcher or Web-Dispatcher Permission is allowed at once.",
        "UserLimitExceeded":"Action could not be completed because the maximum number of allowed users has been reached. Please upgrade your plan.",
        "LICENSE_VIEW": "License Information",
        "LICENSE_VIEW_NAME": "Name",
        "LICENSE_VIEW_VALUE": "Value",
        "BulkUserLimitExceeded":"Action could not be completed because the maximum number of allowed users has been reached. Please upgrade your plan.",
        "SESSION_NAME": "Session Name", 
        "MISSED_CALL": "Missed Call",
        "SESSION_ID": "Session ID",
        "SENDER_NAME": "Sender Name",
        "SENDER_ID": "Sender ID",
        "RECIPIENT_NAME": "Recipient Name",
        "RECIPIENT_ID": "Recipient ID",
        "SESSION_TYPE": "Session Type",
        "SESSION_START_TIME": "Session Start Time",
        "SESSION_END_TIME": "Session End Time",
        "BURST_TALKER_NAME": "Burst Talker Name",
        "BURST_TALKER_ID": "Burst Talker ID", 
        "BURST_START_TIME": "Burst Start Time",
        "BURST_END_TIME": "Burst End Time",
        "DURATION": "Duration"
      };
    };


    // spanish
    function get_es() {
      return {
        "version": "2.26",
        "revised_by": "Hardik shah",
        "revision_date": "17-09-2025",
        "APPLICATIONS": "aplicaciones",
        "API_MONGO_DB_TIMEOUT": "MongoDb no disponible. Agotado el tiempo de espera en un intento de conexión.",
        "API_REQUEST_TIMEOUT": "Node request timeout",
        "API_MONGO_DB_ERROR": "Se perdió la conexión a la base de datos. Inténtelo de nuevo más tarde.",
        "API_GET_LIST_ERROR": "No se puede recuperar la lista de %s",
        "API_GET_ERROR": "No se puede recuperar %s",
        "API_ADD_ERROR": "No se puede agregar %s",
        "API_UPDATE_ERROR": "No se puede actualizar %s",
        "API_DELETE_ERROR": "No se puede eliminar %s",
        "API_NOT_FOUND_ERROR": "%s no se encuentra",
        "API_FORBIDDEN_ERROR": "Acceso Prohibido",
        "APP_GENERAL": "General",
        "APP_CUSTOM": "Personalizado",
        "APP_DESCRIPTION": "Descripción",
        "APP_SEARCH": "Buscar",
        "APP_FILTER": "Filtrar por licencia",
        "APP_NO_FILTER": "Todo",
        "APP_NAME": "Nombre",
        "APP_REMOVE": "Retirar",
        "APP_CLONE": "Clonar",
        "APP_SAVE": "Guardar",
        "APP_CANCEL": "Cancelar",
        "APP_ADD": "Añadir",
        "APP_UPDATE": "Actualizar",
        "APP_OK": "OK",
        "APP_REFRESH": "Actualizar",
        "APP_RECORDS_COUNT": "Registros",
        "APP_NO_RECORDS": "Datos no disponibles",
        "APP_DELETE_WARNING_TITLE": "¿Estás seguro que quieres eliminar este elemento?",
        "APP_DELETE_WITH_MEMBERS_WARNING_TITLE": "Este elemento tiene miembros. ¿Seguro de que lo quiere eliminar?",
        "APP_DELETE_WARNING_CONTENT": "Todos los datos serán eliminados.",
        "APP_ENABLE_WARNING_TITLE": "¿Seguro de que quiere Habilitar a todos los suscriptores?",
        "APP_DISABLE_WARNING_TITLE": "¿Seguro de que quiere Deshabilitar todos los suscriptores?",
        "APP_SEND_SMS": "Enviar SMS",
        "APP_SEND_SMS_WARNING_TITLE": "¿Seguro que quieres enviar un SMS a este suscriptor?",
        "APP_SEND_BULK_SMS_WARNING_TITLE": "¿Seguro que quieres enviar un SMS a estos suscriptores?",
        "APP_LICENSE_INTERACTIVE_WARNING_TITLE": "¿Seguro de que desea asignar la licencia a todos los suscriptores?",
        "APP_ROLE_INTERACTIVE_WARNING_TITLE": "¿Seguro de que desea asignar el rol a todos los suscriptores?",
        "APP_PASSWORD_MISMATCH": "La Contraseña no coincide.",
        "APP_SHOW_PASSWORD": "Mostrar Contraseña",
        "APP_CHANGE_PASSWORD": "Cambia la Contraseña",
        "APP_GENERATE_PASSWORD": "Generar una Contraseña",
        "APP_VALIDATION_REQUIRED": "Este campo es requerido.",
        "APP_VALIDATION_MAX_LENGTH": "Este campo es demasiado largo.",
        "APP_VALIDATION_MIN_LENGTH": "Este campo es muy corto.",
        "APP_VALIDATION_EMAIL": "Email debe ser una dirección de correo electrónico válida.",
        "APP_VALIDATION_IP": "Debe ser una dirección IP válida.",
        "APP_VALIDATION_URL": "Debe ser una URL válida",
        "APP_VALIDATION_SPECIAL_CHARS": "Este campo no puede contener caracteres especiales.",
        "APP_VALIDATION_REGULAR_PASSWORD": "En este campo no se permite el siguiente caracter: '\\' ni espacios.",
        "APP_VALIDATION_PASSWORD": "Debe tener entre 10 y 15 caracteres y un mínimo de: 1 carácter numérico, 1 letra mayúscula, 1 letra minúscula , 1 carácter especial, No debe contener caracteres idénticos y Caracteres o números consecutivos.",
        "APP_ERROR_VALIDATION_PASSWORD": "La contraseña no está de acuerdo con las reglas.",
        "APP_TOAST_ADD_SUCCESS": "Agregado con éxito.",
        "APP_TOAST_UPDATE_SUCCESS": "Actualizado con éxito.",
        "APP_TOAST_DELETE_SUCCESS": "Eliminado con éxito.",
        "APP_TOAST_ALLOCATE_SUCCESS": "Asignado con éxito.",
        "APP_TOAST_REVOKE_SUCCESS": "Revocado con éxito.",
        "APP_TOAST_CHANGE_SUCCESS": "Estado cambiado con éxito.",
        "APP_TOAST_DELETE_FAILED": "No se puede eliminar el rol ya que está asignado a al menos un usuario.",
        "APP_TOAST_DELETE_FAIL": "La organización no puede ser eliminada. Primero todos sus administradores deben ser eliminados.",
        "APP_TOAST_SEARCH_BLANK": "Ingresa teléfono o email o ID o IMSI del usuario",
        "APP_TOAST_REVOKE_FAILED": "La revocación falló porque esta licencia ya está asignada a suscriptores.",
        "APP_TOAST_404": "El archivo no existe",
        "APP_UNSELECTED": "No seleccionado",
        "APP_UNSELECTED_OFFNET": "Suscriptores Off-net",
        "APP_SELECTED": "Seleccionado",
        "APP_ADD_ALL": "Seleccionar todo",
        "APP_REMOVE_ALL": "Eliminar todo",
        "APP_DISPATCHER_USER_WARNING_TITLE": "Tenga en cuenta:",
        "APP_DISPATCHER_USER_WARNING_CONTENT1": "Está a punto de crear un usuario con licencia de Dispatchador pero el Rol seleccionado no es adecuado para un Despachador.",
        "APP_DISPATCHER_USER_WARNING_CONTENT2": "Vuelva para seleccionar otro rol o continúe y cambie el rol más adelante desde la pantalla de roles. ¿Quieres continuar?",
        "APP_CHARGE_ROLE_WARNING_TITLE": "Tenga en cuenta:",
        "APP_CHARGE_ROLE_WARNING_CONTENT1": "Las siguientes características pueden aplicar costos adicionales: ",
        "APP_CHARGE_ROLE_WARNING_CONTENT2": "para obtener más información, comuníquese con su representante de Mobile Tornado.",
        "APP_YES": "Sí",
        "APP_NO": "No",
        "APP_DEMO_ORGANIZATION_WARNING_TITLE": "Tenga en cuenta:",
        "APP_DEMO_ORGANIZATION_WARNING_CONTENT1": "Esta organización se definirá como Demo durante {{days}} días.",
        "APP_DEMO_ORGANIZATION_WARNING_CONTENT2": "Cuando expire el período de prueba, las organizaciones se convertirán en una producción y se le facturará en consecuencia.",
        "APP_DEMO_ORGANIZATION_WARNING_CONTENT3": "Ok para aceptar, Cancelar para crear/actualizar esta organización como producción.",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS": "Estado actual de encriptado: ",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_NO_KEYS": "LLaves de encriptado no en uso",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_DEFAULT_KEYS": "Llaves de encriptado predeterminadas en uso",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_RANDOM_KEYS": "Llaves de encriptado aleatorias en uso",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_UPLOAD_KEYS_FILE": "Archivo de llaves privadas en uso",
        "APP_ENCRYPTION_KEYS_VERSION": "Versión de llaves de encriptado",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_TITLE": "¡Advertencia!",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT1": "Por favor, asegúrese de que todos los usuarios tengan instalada la última aplicación de Android (actualmente, iOS no es compatible).",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT2": "Al permitir la generación de llaves de encriptado, los usuarios con una versión anterior no podrán comunicarse con el resto.",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT3": "No utilice el generador de llaves si esta organización tiene 'organizaciones afiliadas'.",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT4": "Para generar llaves de encriptado, haga clic en Aceptar, de lo contrario Cancelar",
        "APP_OUT_OF_MEMBER": "ERROR. Existe un limite en la cantidad de miembros",
        "LOGIN_INTRO_TITLE": "¡Bienvenido al portal de Administración!",
        "LOGIN_TITLE": "Iniciar sesión en su cuenta",
        "LOGIN_EMAIL": "Email",
        "LOGIN_PASSWORD": "Contraseña",
        "LOGIN_REMEMBER_ME": "Recuérdame",
        "LOGIN_FORGOT_PASSWORD": "¿Has olvidado tu contraseña?",
        "LOGIN_LOG_IN": "Iniciar Sesión",
        "LOGIN_ERRORS_EMAIL_REQUIRED": "Email es campo requerido.",
        "LOGIN_ERRORS_EMAIL_MUST_VALID": "Email debe ser una dirección de correo electrónico válida.",
        "LOGIN_ERRORS_PASSWORD_REQUIRED": "Contraseña es campo requerido.",
        "LOGIN_API_ERROR": "Falló la autenticación. Nombre de usuario o contraseña son incorrectos.",
        "LOGIN_API_PERMISSION_ERROR": "Falló la autenticación. Faltan credenciales para acceder al sitio.",
        "LOGIN_API_TOKEN_ERROR": "La sesión expiró. Intente iniciar sesión de nuevo por favor",
        "LOGIN_API_DB_ERROR": "Falló la autenticación. Tenga en cuenta: Error probable en la base de datos. Contacte al administrador por favor.",
        "LOGIN_CONTACT_ADMIN": "¿Has olvidado tu contraseña? Contacte al administrador por favor",
        "LOGIN_API_ATTEMPTS_LEFT": "Quedan %s Intentos",
        "LOGIN_PASSWORD_EXPIRED_DAYS": "La contraseña se vencerá en {{days}} días. Por favor cambia la contraseña lo mas pronto posible.",
        "LOGIN_PASSWORD_EXPIRED": "la contraseña ha expirado, Por favor cambia la contraseña.",
        "BACK_TO_LOGIN": "Volver",
        "CHANGE_PASSWORD_TITLE": "Cambio de Contraseña",
        "CHANGE_PASSWORD_CURRENT": "Contraseña actual",
        "CHANGE_PASSWORD_NEW": "Nueva Contraseña",
        "CHANGE_PASSWORD_WRONG": "Contraseña incorrecta",
        "CHANGE_PASSWORD_SAME": "Su nueva contraseña debe ser diferente a su contraseña anterior",
        "RECOVER_PASSWORD_SUCCESS": "Se ha enviado un mensaje de recuperación al correo electrónico del usuario.",
        "HOMEPAGE_HEADING": "Portal de Administración",
        "HOMEPAGE_TITLE": null,
        "HOMEPAGE_APPLICATION": "Interfaz",
        "HOMEPAGE_API_VERSION": "API & Base de datos Mongo",
        "HOMEPAGE_DB_VERSION": "Base de Datos principal",
        "HELP_HEADING": "ayuda del portal de administracion",
        "DASHBOARD_HEADING": "Tablero",
        "STATISTICS_HEADING": "Estadísticas de PTT",
        "DUAL_RECORDER_HEADING": "Estadísticas del registrador",
        "TOOLBAR_RESELLERS": "Revendedores",
        "TOOLBAR_ORGANIZATIONS": "Organizaciones",
        "TOOLBAR_LOGOUT": "Cerrar Sesión",
        "TOOLBAR_SEARCHTEXT": "Teléfono/email/ID/IMSI",
        "NAVIGATION_ADMIN_RECORD": "Revisores de Grabaciones",
        "NAVIGATION_ORGANIZATION": "Organización",
        "NAVIGATION_GROUPS": "Grupos",
        "NAVIGATION_SUBSCRIBERS": "Suscriptores",
        "NAVIGATION_CONTACTS": "Contactos",
        "NAVIGATION_CONTACTS_TEMPLATES": "Plantillas de contactos",
        "NAVIGATION_ORG_DETAILS": "Detalles del organización",
        "NAVIGATION_RESELLER": "Revendedor",
        "NAVIGATION_ORG_MANAGER": "Gestión de Organizaciones",
        "NAVIGATION_RESELLER_DETAILS": "Detalles del Revendedor",
        "NAVIGATION_RESELLER_MANAGER": "Gestión de Revendedores",
        "NAVIGATION_PLATFORM": "Plataforma",
        "NAVIGATION_DEVICES": "Dispositivos",
        "NAVIGATION_DEV_MANUFACTURERS": "Fabricantes de dispositivos",
        "NAVIGATION_LICENSES": "Licencias",
        "NAVIGATION_SOFT_MANUFACTURERS": "Fabricantes de Software",
        "NAVIGATION_PTT_CLIENT_STORE": "Tienda de aplicación de PTT",
        "NAVIGATION_PTT_DEVICES": "Dispositivos de PTT",
        "NAVIGATION_ITO_CONFIG": "Configuración de sistema",
        "NAVIGATION_LOCALIZATION": "Localización",
        "NAVIGATION_ADMINISTRATION": "administración",
        "NAVIGATION_ROLES": "Roles",
        "NAVIGATION_JOB": "Tareas",
        "NAVIGATION_BATCH": "Operaciones Masivas",
        "NAVIGATION_ACTIVITY_LOG": "Registro de Actividades",
        "ADMINISTRATOR": "Administrador",
        "ADMINISTRATORS": "Administradores",
        "ADMINISTRATION_TITLE": "Administradores",
        "ADMINISTRATION_DIALOG_TITLE": "Administradores",
        "ADMINISTRATION_EMAIL": "Email",
        "ADMINISTRATION_NAME": "Nombre de Usuario",
        "ADMINISTRATION_FIRST_NAME": "Nombre",
        "ADMINISTRATION_LAST_NAME": "Apellido",
        "ADMINISTRATION_ROLE": "Nombre de Rol",
        "ADMINISTRATION_ACTIONS": "Retirar",
        "ADMINISTRATION_DELETE": "Eliminar",
        "ADMINISTRATION_SELECT_ROLE": "Seleccionar rol",
        "ADMINISTRATION_PASSWORD": "Contraseña",
        "ADMINISTRATION_RE_PASSWORD": "Vuelva a escribir la contraseña",
        "ADMINISTRATOR_NAME_UQ_ERROR": "¡Ya existe un usuario con el mismo nombre!",
        "ADMINISTRATOR_EMAIL_UQ_ERROR": "¡Ya existe un usuario con el mismo Email!",
        "ROLE": "rol",
        "ROLES": "roles",
        "ROLE_TITLE": "Roles",
        "ROLE_DIALOG_TITLE": "Permisos del Rol",
        "ROLE_SHOW": "Permisos del Rol",
        "ROLE_NAME": "Nombre del Rol",
        "ROLE_RESOURCE_PATH": "Asunto",
        "ROLE_GET": "Ver",
        "ROLE_POST": "Agregar",
        "ROLE_PUT": "Modificar",
        "ROLE_DELETE": "Eliminar",
        "ROLE_BATCH": "Operaciones Masivas",
        "ROLE_HIMPACT": "Alto Impacto",
        "ROLE_ACTIVE": "Activo",
        "ROLE_TABS_WEB": "Aprovisionamiento",
        "ROLE_TABS_DISPATCHER": "Despacho",
        "ROLE_TABS_MOBILE": "Móvil",
        "ROLE_API_ADD_NAME_UQ_ERROR": "No se puede agregar el rol. Ya existe un rol con el mismo nombre.",
        "ROLE_API_UPDATE_NAME_UQ_ERROR": "No se puede actualizar el rol. Ya existe un rol con el mismo nombre.",
        "ROLE_API_DELETE_USED_ERROR": "No se puede eliminar el rol. Se asigna a al menos un usuario.",
        "ROLE_RESOURCE_PATH_MOBILE": "Permisos y Configuraciones",
        "ROLE_NAME_ROOT_ADMIN": "El nombre de rol elegido está reservado y no se puede usar",
        "CONTACT": "Lista de Contactos",
        "CONTACTS": "Contactos",
        "CONTACTS_TITLE": "Contactos",
        "CONTACTS_DIALOG_TITLE": "Detalles del Grupo de Contactos",
        "CONTACTS_TEMPLATE_NAME": "Nombre de Plantilla",
        "CONTACTS_LIST_NAME": "Nombre de Grupo",
        "CONTACTS_CONTACT_LISTS": "Lista de Miembros",
        "CONTACTS_MEMBER_COUNT": "Número de miembros",
        "CONTACTS_CROSS_FLEET": "contactos afiliados",
        "CONTACTS_NAME": "Nombre",
        "CONTACTS_MEMBERS": "Detalles de Miembros",
        "CONTACT_MEMBERS_NOTE": "Mostrar solo miembros con licencia offnet",
        "CONTACTS_GENERAL": "General",
        "CONTACTS_MEMBER_DETAILS": "Detalles del Miembro",
        "SUBSCRIBER_LIST": "Lista del Suscriptor",
        "SUBSCRIBER_LISTS": "Listas del Suscriptor",
        "SUBSCRIBER_LISTS_TITLE": "Listas del Suscriptor",
        "SUBSCRIBER_LIST_DIALOG_TITLE": "Detalles de la lista del Suscriptor",
        "SUBSCRIBER_LIST_NAME": "Nombre de la Lista",
        "SUBSCRIBER_LISTS_MEMBERS": "Lista de Miembros",
        "SUBSCRIBER_LISTS_MEMBER_COUNT": "Número de miembros",
        "SUBSCRIBER_LISTS_NAME": "Nombre",
        "SUBSCRIBER_LISTS_MEMBERS_DETAILS": "Detalles de Miembros",
        "SUBSCRIBER_LISTS_GENERAL": "General",
        "SUBSCRIBER_LIST_MEMBER_DETAILS": "Detalles de Miembro",
        "PERSONAL_CONTACT": "Contacto Personal",
        "PERSONAL_CONTACTS": "Contactos Personal",
        "PERSONAL_CONTACTS_TEMPLATES": "Plantillas de Contactos",
        "SUBSCRIBER_LIST_NOTE": "La lista de contactos afiliados se puede asignar a un usuario sin licencia de usuario offnet, pero solo los contactos de la propia organización se asignarán al usuario",
        "PERSONAL_CONTACTS_TEMPLATES_DETAILS": "Detalles del Plantilla de Contactos",
        "GROUP": "Grupo",
        "GROUPS": "Grupos",
        "GROUPS_TITLE": "Grupos",
        "GROUPS_DIALOG_TITLE": "Detalles del Grupo",
        "GROUPS_SITE": "Sitio",
        "GROUPS_NAME": "Nombre del Grupo",
        "GROUPS_MEMBER_COUNT": "Número de miembros",
        "GROUPS_CROSS_FLEET": "Grupos afiliados",
        "GROUPS_EXPIRATION_DATE": "Fecha de expiración",
        "GROUPS_PHONE": "Número de teléfono",
        "GROUPS_ACTIONS": "Eliminar",
        "GROUPS_TYPE": "Tipo de Grupo",
        "GROUPS_GROUP_LISTS": "Lista de suscriptores",
        "GROUPS_DELETE_WARNING": "No se puede eliminar el grupo - Primero elimina los miembros.",
        "GROUPS_API_GET_LIMIT_ERROR": "No se puede obtener el límite de miembros del grupo.",
        "GROUPS_API_LIMIT_ERROR": "No se puede actualizar porque se ha alcanzado el límite de %s miembros. Primero intenta aumentar el límite.",
        "GROUPS_API_ADD_SUBSCRIBER_ERROR": "No se puede agregar el suscriptor al grupo.",
        "GROUPS_API_UPDATE_SUBSCRIBER_ERROR": "No se puede actualizar el suscriptor al grupo.",
        "GROUPS_API_REMOVE_SUBSCRIBER_ERROR": "No se puede eliminar el suscriptor del grupo.",
        "GROUPS_API_UPDATE_MUTED_SUBSCRIBER_ERROR": "No se puede actualizar el suscriptor-oyente en el grupo.",
        "GROUPS_API_SET_DEFAULT_ERROR": "No se puede establecer el grupo predeterminado.",
        "GROUP_API_NAME_UQ_ERROR": "Ya existe un grupo con el mismo nombre.",
        "SUBSCRIBER": "suscriptor",
        "SUBSCRIBERS": "suscriptores",
        "SUBSCRIBERS_TITLE": "Suscriptores",
        "SUBSCRIBERS_DIALOG_TITLE": "Detalles del Suscriptor",
        "SUBSCRIBERS_DIALOG_ADD_TITLE": "Agregar un suscriptor",
        "SUBSCRIBERS_ORGANIZATION": "Elige una organización",
        "SUBSCRIBERS_SMS_DIALOG_TITLE": "Enviar SMS",
        "SUBSCRIBERS_GENERAL": "General",
        "SUBSCRIBERS_LICENSE": "Licencia",
        "SUBSCRIBERS_RUNTIME": "Actual",
        "SUBSCRIBERS_GROUP_DETAILS": "Detalles del Grupo",
        "SUBSCRIBERS_GROUP_SUBSCRIBERS": "Grupos",
        "SUBSCRIBERS_CONTACT_SUBSCRIBERS": "Grupos de Contactos(org)",
        "SUBSCRIBERS_ACTIVITY_LOG": "Registro de Actividades",
        "SUBSCRIBERS_ADD_SUBSCRIBERS": "Agregar suscriptores",
        "SUBSCRIBERS_LIST": "Suscriptores",
        "SUBSCRIBERS_NAME": "Nobre del Usuario",
        "SUBSCRIBERS_DISPLAY_NAME": "Nombre para mostrar",
        "SUBSCRIBERS_USER_NAME": "Nombre de usuario/Teléfono",
        "SUBSCRIBERS_USER_NAME_SIP": "email/SIP",
        "SUBSCRIBERS_DOMAIN": "Dominio",
        "SUBSCRIBERS_ACTIVE": "Activo",
        "SUBSCRIBERS_PHONE_NUMBER": "Número de teléfono",
        "SUBSCRIBERS_CREATION_TIME": "Tiempo de creación",
        "SUBSCRIBERS_CHANGE_STATE_TIME": "Tiempo de cambio de Estado",
        "SUBSCRIBERS_COUNTRY": "País",
        "SUBSCRIBERS_ADDRESS": "Dirección",
        "SUBSCRIBERS_PASSWORD": "Contraseña",
        "SUBSCRIBERS_RE_PASSWORD": "Vuelva a escribir la contraseña",
        "SUBSCRIBERS_CLIENT_TYPE": "Tipo de aplicación",
        "SUBSCRIBERS_HANDSET_TYPE": "Tipo de dispositivo",
        "SUBSCRIBERS_SITE": "Sitio",
        "SUBSCRIBERS_EMAIL": "Email",
        "SUBSCRIBERS_SIP": "SIP",
        "SUBSCRIBERS_IMSI": "IMSI",
        "SUBSCRIBER_IMSI": "IMSI",
        "SUBSCRIBERS_IMSI2": "IMSI2",
        "SUBSCRIBERS_ROLE": "Rol",
        "SUBSCRIBERS_REVOKE_LICENSE_WARNING": "¿Seguro de que desea revocar la licencia?",
        "SUBSCRIBERS_DEFAULT_RADIO_GROUP": "Grupo de Radio Predeterminado",
        "SUBSCRIBERS_DEFAULT_SOS_MSG": "Este grupo también puede servir para alertas de emergencia.",
        "SUBSCRIBERS_CURRENT_LICENSE": "Licencia actual",
        "SUBSCRIBERS_LICENSE_NAME": "Nobre",
        "SUBSCRIBERS_LICENSE_TYPE": "Tipo",
        "SUBSCRIBERS_LICENSE_RENEWAL": "Renovación",
        "SUBSCRIBERS_LICENSE_EXPIRE": "Expira",
        "SUBSCRIBERS_LICENSE_QTY": "Disponible",
        "SUBSCRIBERS_LICENSE_REVOKE": "Revocar",
        "SUBSCRIBERS_LICENSE_ASSIGN": "Asignar",
        "SUBSCRIBERS_LICENSE_ASSIGN_NEW": "Asignar una nueva licencia",
        "SUBSCRIBERS_NO_AVAILBLE_QTY": "No quedan licencias asignables",
        "SUBSCRIBERS_RUNTIME_LAST_REGISTRATION_TIME": "Última hora de registro",
        "SUBSCRIBERS_RUNTIME_STATE": "Estado",
        "SUBSCRIBERS_RUNTIME_APP_UPDATE": "Actualización de Dispositivo/Aplicación",
        "SUBSCRIBERS_RUNTIME_DEVICE_MODEL": "Modelo de Dispositivo",
        "SUBSCRIBERS_RUNTIME_APP_VERSION": "Versión de Aplicación",
        "SUBSCRIBERS_RUNTIME_OS_VERSION": "versión de Sistema Operativo",
        "SUBSCRIBERS_RUNTIME_MODEL_NAME": "Modelo del dispositivo",
        "SUBSCRIBERS_RUNTIME_OS_TYPE": "Tipo de OS",
        "SUBSCRIBERS_RUNTIME_BRAND": "Marca del cliente movil",
        "SUBSCRIBERS_RUNTIME_MANUFACTURE": "Fabricante",
        "SUBSCRIBERS_RUNTIME_MEMORY": "Memoria libre en el dispositivo",
        "SUBSCRIBERS_RUNTIME_FW_VERSION": "Version de FW",
        "SUBSCRIBERS_RUNTIME_BUILD": "Tipo de compilacion de la aplicacion",
        "SUBSCRIBERS_RUNTIME_FCM": "FCM",
        "SUBSCRIBERS_VALIDATION_SPECIAL_CHARS_ERROR": "El Nombre para Mostrar no puede contener caracteres especiales.",
        "SUBSCRIBERS_VALIDATION_USERNAME_ORG_DOMAIN_ERROR": "El Nombre de Usuario no puede contener el dominio de la organización.",
        "SUBSCRIBERS_VALIDATION_AT_ERROR": "El Nombre de Usuario no puede contener el símbolo @.",
        "SUBSCRIBERS_VALIDATION_DEFAULT_GROUP_ERROR": "Tenga en cuenta: seleccione un grupo predeterminado en la pestaña Grupos.",
        "SUBSCRIBERS_VALIDATION_CREATE_ROLE_ERROR": "Tenga en cuenta: crea un rol para esta organización.",
        "SUBSCRIBERS_VALIDATION_SELECT_ROLE_ERROR": "Seleccione el Rol por favor.",
        "SUBSCRIBERS_VALIDATION_SIP_ERROR": "ID de SIP no válida",
        "SUBSCRIBERS_VALIDATION_SIP_FORMAT_ERROR": "Formato SIP no válido",
        "SUBSCRIBERS_VALIDATION_SIP_PHONE_ERROR": "El SIP y el número de teléfono no coinciden",
        "SUBSCRIBERS_VALIDATION_ORG_DOMAIN_ERROR": "Dominio de organización en el SIP no válido. Válido:",
        "SUBSCRIBERS_VALIDATION_LICENSE_ASSIGNMENT_ERROR": "Atención: Por favor establezca permisos para el usuario en la pestaña de Licencia",
        "SUBSCRIBERS_VALIDATION_STRONG_DISPATCH_PASS": "Atención: Se requiere una contraseña compleja para Usuarios de tipo Dispatcher.",
        "SUBSCRIBERS_GROUPS_LIMIT_ERROR": "Demasiados grupos, Por favor mantengase dentro de los limites establecidos",
        "SUBSCRIBERS_PERSONAL_GROUPS_LIMIT_ERROR": "Demasiados Contactos Personales, por favor mantengase dentro de los limites establecidos",
        "SUBSCRIBERS_OCL_LIMIT_ERROR": "Demasiados grupos de contactos de (Org), Por favor mantengase dentro de los limites establecidos",
        "SUBSCRIBERS_VALIDATION_ADD_ERROR": "No se puede agregar el suscriptor.",
        "SUBSCRIBERS_VALIDATION_ONLY_NUMBERS_ERROR": "Este campo solo debe contener dígitos",
        "SUBSCRIBERS_API_VALIDATION_IMSI_FORMAT_ERROR": "Formato incorrecto: este campo debe contener entre 14 y 20 dígitos",
        "SUBSCRIBERS_API_ADD_IDENTIFIERS_UQ_ERROR": "El identificador del suscriptor debe ser único.",
        "SUBSCRIBERS_API_ADD_IDENTIFIERS_ERROR": "Se agregó el suscriptor pero no fue posible agregar el identificador.",
        "SUBSCRIBERS_API_ADD_DUPLICATE_ID_ERROR": "No se puede agregar el suscriptor porque ya existe el identificador",
        "SUBSCRIBERS_API_UPDATE_DUPLICATE_ID_ERROR": "No se puede actualizar el suscriptor porque ya existe el identificador",
        "SUBSCRIBERS_API_UPDATE_DUPLICATE_IMSI_ERROR": "No se puede actualizar el suscriptor porque ya existe el IMSI",
        "SUBSCRIBERS_API_ADD_NO_GROUP_ERROR": "No se puede agregar el suscriptor porque no existe ningún grupo en la organización.",
        "SUBSCRIBERS_API_ADD_GROUP_EXCEPTION_ERROR": "No se puede agregar el suscriptor debido a una excepción durante la recuperación de los nombres de grupos para esta organización.",
        "SUBSCRIBERS_API_GROUPS_ERROR": "No se pueden recuperar los nombres de grupos del suscriptor.",
        "SUBSCRIBERS_API_CONTACTS_ERROR": "No se pueden recuperar los nombres de contactos del suscriptor.",
        "SUBSCRIBERS_API_PHONE_UQ_ERROR": "No se puede agregar el suscriptor. El número de teléfono debe ser único.",
        "SUBSCRIBERS_API_NAME_UQ_ERROR": "Un suscriptor con el mismo nombre ya existe en esta organización.",
        "SUBSCRIBERS_API_NAME_SPACE_ERROR": "Nombre para Mostrar o SIP no pueden contener espacios.",
        "SUBSCRIBERS_API_PASSWORD_SPACE_ERROR": "La Contraseña no puede contener espacios.",
        "SUBSCRIBERS_API_ADD_NO_LICENSE": "No se puede agregar un suscriptor sin licencia",
        "SUBSCRIBERS_API_UPDATE_NO_LICENSE": "No se puede actualizar un suscriptor sin licencia",
        "SUBSCRIBERS_API_PHONE_ZERO_ERROR": "No se puede agregar el suscriptor ya que el número de teléfono no puede comenzar con 0",
        "SUBSCRIBERS_API_ADD_NOT_ENOUGH_LICENSES": "No se puede agregar el (los) suscriptor(es) porque todas las licencias están en uso",
        "SUBSCRIBERS_API_NUMBER_USERS_EXCEEDS_LICENSE_QTY": "No se pueden agregar usuarios más allá del límite especificado en la licencia del servidor",
        "SUBSCRIBERS_API_PASSWORD_LENGTH_ERROR": "No se puede crear el suscriptor ya que la contraseña debe tener menos de 18 caracteres",
        "SUBSCRIBERS_TIME_STAMP": "Sellado de tiempo(en GMT)",
        "SUBSCRIBERS_ADMINISTRATOR": "Administrador",
        "SUBSCRIBERS_DESCRIPTION": "Descripción",
        "SUBSCRIBERS_GET_ACTIVITY": "obtener Actividades",
        "SUBSCRIBERS_SERIAL_NUMBER": "Número de serie",
        "SUBSCRIBER_BULK_PHONE_15_DIGIT_ERROR": "El número de teléfono no puede tener más de 15 dígitos",
        "SUBSCRIBER_BULK_INVALID_PHONE_ERROR": "Número de teléfono inválido",
        "ORGANIZATION": "organización",
        "ORGANIZATIONS": "organizaciones",
        "ORGANIZATION_TITLE": "Organizaciones",
        "ORGANIZATION_DETAILS": "Detalles de la Organización",
        "ORGANIZATION_CONTEXT_WARNING": "Tenga en cuenta: Primero elija una organización.",
        "ORGANIZATION_CRMID": "CRMID",
        "ORGANIZATION_NAME": "Nombre de la Organización",
        "ORGANIZATION_DOMAIN": "Nombre de dominio",
        "ORGANIZATION_SITE": "Sitio",
        "ORGANIZATION_ADDRESS": "Dirección",
        "ORGANIZATION_MANAGER": "Gestión de Organizaciones",
        "ORGANIZATION_AUDIO_RECORDER": "Grabar todas las conversaciones de la organización",
        "ORGANIZATION_GENERAL": "General",
        "ORGANIZATION_CONTACT": "Detalles de Contacto",
        "ORGANIZATION_SECURITY_AND_DOWNLOAD": "Administración de Versiones Y Encriptado",
        "ORGANIZATION_LICENSE": "Detalles de Licencias",
        "ORGANIZATION_LICENSE_ADD": "Agregar una Licencia",
        "ORGANIZATION_INSERT": "Insertar",
        "ORGANIZATION_SUPPORT_FIRST_NAME": "Nombre del Soporte",
        "ORGANIZATION_SUPPORT_LAST_NAME": "Apellido del Soporte",
        "ORGANIZATION_SUPPORT_EMAIL": "Email del Soporte",
        "ORGANIZATION_SUPPORT_PHONE": "Número de teléfono del Soporte",
        "ORGANIZATION_DEMO": "Demo",
        "ORGANIZATION_CREATION_TIME": "Tiempo de creación",
        "ORGANIZATION_DEMO_EXPIRATION": "Vencimiento del Demo",
        "ORGANIZATION_API_GET_CONTACTS_ERROR": "No se puede recuperar la información de contacto de la organización.",
        "ORGANIZATION_API_ADD_CONTACTS_ERROR": "La organización fue creada pero no fue posible establecer su información de contacto.",
        "ORGANIZATION_API_ADD_NAME_UQ_ERROR": "No se puede actualizar la organización. El nombre debe ser único.",
        "ORGANIZATION_API_ADD_CRM_ID_UQ_ERROR": "No se puede actualizar la organización. El ID de CRM debe ser único.",
        "ORGANIZATION_API_UPDATE_NAME_UQ_ERROR": "No se puede actualizar la organización. El nombre debe ser único.",
        "ORGANIZATION_API_UPDATE_CRM_ID_UQ_ERROR": "No se puede actualizar la organización. El ID de CRM debe ser único.",
        "ORGANIZATION_API_UPDATE_CONTACTS_ERROR": "La organización fue actualizada pero no fue posible establecer su información de contacto.",
        "ORGANIZATION_API_UPDATE_SITE_ERROR": "La organización fue actualizada pero no fue posible actualizar su sitio.",
        "ORGANIZATION_API_UPDATE_GROUPS_SITE_ERROR": "La organización fue actualizada pero no fue posible actualizar los sitios de los grupos.",
        "ORGANIZATION_API_UPDATE_SUBSCRIBER_SITE_ERROR": "El Revendedor fue actualizado pero no fue posible actualizar los sitios de los suscriptores.",
        "ORGANIZATION_API_UPDATE_CHILDREN_SITE_ERROR": "El Revendedor se actualizó pero no fue posible actualizar los sitios de los grupos y de los suscriptores.",
        "ORGANIZATION_API_DELETE_CHILD_ERROR": "No se puede eliminar la organización. Se encontró un sub registro asociado.",
        "ORGANIZATION_CALL_LOG": "Mantener registros de todas las llamadas",
        "ORGANIZATION_FORCE_STRONG_DISPATCH_PASS": "Forzar el uso de contraseñas complejas para usuarios de tipo Dispatcher",
        "RECORDING_FORCE_STRONG_RECORDING_REVIEWERS_PASS": "Forzar contraseña compleja para revisores de grabaciones",
        "RESELLER": "revendedor",
        "RESELLERS": "revendedores",
        "RESELLER_TITLE": "Gestión de Revendedores",
        "RESELLER_DETAILS": "Detalles del Revendedor",
        "RESELLER_ADDRESS": "Dirección",
        "RESELLER_ADDRESS_NAME": "Nombre de Dirección",
        "RESELLER_CRMID": "CRM ID",
        "RESELLER_NAME": "Nombre del Revendedor",
        "RESELLER_CONTACT_DETAILS": "Detalles de Contacto",
        "RESELLER_ADMINISTRATOR_DOMAIN": "Dominio del Administrador",
        "RESELLER_WEBSERVICE_URL": "URL del servicio web",
        "RESELLER_LICENSE": "Detalles de la licencia",
        "RESELLER_LICENSE_ALLOCATION": "Agregar una licencia",
        "RESELLER_LICENSE_BUNDLE_GENERATION": "Generación de Paquete de Licencia",
        "RESELLER_AGGREGATE_END_USER": "Agregue usuarios finales",
        "RESELLER_AEU_EMAIL": "Informe de facturación de AEU por EMAIL",
        "RESELLER_PORTAL_URL": "URL de dominio",
        "RESELLER_SITE": "Sitio",
        "RESELLER_LICENSE_NAME": "Nombre de la licencia",
        "RESELLER_ADMIN_FIRST_NAME": "Nombre de contacto del administrador",
        "RESELLER_ADMIN_LAST_NAME": "Apellido del contactio del administrador",
        "RESELLER_ADMIN_EMAIL": "Email del contacto",
        "RESELLER_ADMIN_PHONE": "Número de teléfono del contacto",
        "RESELLER_SUPPORT_FIRST_NAME": "Nombre del contacto de soporte",
        "RESELLER_SUPPORT_LAST_NAME": "Apellido del contacto de soporte",
        "RESELLER_SUPPORT_EMAIL": "Email del contacto de soporte",
        "RESELLER_SUPPORT_PHONE": "Número de teléfono del contacto de soporte",
        "RESELLER_CONTEXT_WARNING": "Tenga en cuenta: Cambie al contexto de Revendedor",
        "RESELLER_API_GET_SITE_ERROR": "No se puede recuperar el sitio del revendedor.",
        "RESELLER_API_GET_CONTACTS_ERROR": "No se puede recuperar la información de contacto del revendedor.",
        "RESELLER_API_ADD_SITE_ERROR": "El revendedor creó pero no fue posible configurar su sitio.",
        "RESELLER_API_ADD_CONTACTS_ERROR": "El revendedor creó pero no fue posible establecer información de su contacto.",
        "RESELLER_API_ADD_NAME_UQ_ERROR": "No se puede agregar el revendedor. El nombre del revendedor debe ser único.",
        "RESELLER_API_ADD_CRM_ID_UQ_ERROR": "No se puede agregar el revendedor. La ID de CRM debe ser única.",
        "RESELLER_API_ADD_PORTAL_URL_UQ_ERROR": "No se puede agregar el revendedor. La URL del dominio debe ser única.",
        "RESELLER_API_ADD_WEBSERVICE_URL_UQ_ERROR": "No se puede agregar el revendedor. La URL del servicio web debe ser única.",
        "RESELLER_API_UPDATE_SITE_ERROR": "El revendedor fue actualizado pero no fue posible configurar su sitio.",
        "RESELLER_API_UPDATE_CONTACTS_ERROR": "El revendedor fue actualizado pero no fue posible establecer ls información de su contacto.",
        "RESELLER_API_UPDATE_NAME_UQ_ERROR": "No se puede actualizar el revendedor. El nombre del revendedor debe ser único.",
        "RESELLER_API_UPDATE_CRM_ID_UQ_ERROR": "No se puede actualizar el revendedor. La ID de CRM debe ser única.",
        "RESELLER_API_UPDATE_PORTAL_URL_UQ_ERROR": "No se puede actualizar el revendedor. La URL del dominio debe ser única.",
        "RESELLER_API_UPDATE_WEBSERVICE_URL_UQ_ERROR": "No se puede actualizar el revendedor. La URL del servicio web debe ser única.",
        "RESELLER_API_DELETE_SITE_ERROR": "No se puede eliminar el registro del sitio del revendedor.",
        "CONFIG": "parámetro de configuración",
        "CONFIGS": "parámetros de configuración",
        "CONFIG_ADD_PARAM": "Agregar un parámetro",
        "CONFIG_SET_PARAM": "Establecer el valor del parámetro",
        "CONFIG_WARNING": "Un valor inválido puede afectar la estabilidad del servidor!",
        "CONFIG_DEFAULT": "Parámetro Predeterminado",
        "CONFIG_VALUE_TYPE": "Tipo de valor",
        "CONFIG_NAME": "Indicador",
        "CONFIG_VALUE": "Valor",
        "CONFIG_ACTIONS": "Acciónes",
        "CONFIG_ADD_CONFIG": "Agregar config.",
        "CONFIG_SERVER_ID": "ID del servidor",
        "CONFIG_SITE": "Sitio",
        "CONFIG_SERVER": "Servidor",
        "CONFIG_SYSTEM": "Sistema",
        "SITE": "Sitio",
        "SITES": "Sitios",
        "SITE_TITLE": "Sitios",
        "SITE_DIALOG_TITLE": "Detalles del Sitio",
        "SITE_NAME": "Nombre",
        "SITE_HOST": "Huésped",
        "SITE_PUBLIC_IP": "IP Publica",
        "SITE_TYPE": "Tipo",
        "SITE_CONTROL_PORT": "Puerto de Control",
        "SITE_AUDIO_PORT": "Puerto de Audio",
        "SITE_STATE": "Estado de Operación",
        "SITE_SERVER_1": "Primer servidor",
        "SITE_SERVER_2": "Segundo servidor",
        "SITE_ACTIVE_SERVER": "Servidor Activo",
        "SITE_SWITCH_COMMAND": "Comando de Cambio",
        "SITE_API_ADD_IP_USED_ERROR": "No se puede agregar el sitio. La dirección IP es utilizada por otro servidor no afiliado a este sitio.",
        "SITE_API_UPDATE_IP_USED_ERROR": "No se puede actualizar el sitio. La dirección IP es utilizada por otro servidor no afiliado a este sitio.",
        "SITE_API_DELETE_GROUP_ERROR": "No se puede eliminar el sitio. Este sitio es utilizado por un grupo. Primero cambia el sitio para el grupo.",
        "SERVER": "servidor",
        "SERVERS": "servidores",
        "SERVER_TITLE": "Servidores",
        "ITO_CONFIG": "Configuración de ITO",
        "SERVER_NAME": "Nombre",
        "SERVER_HOST": "Dirección IP",
        "SERVER_TYPE": "Tipo",
        "SERVER_STATE": "Estado de operación",
        "SERVER_ADMIN_STATE": "Estado de administración",
        "SERVER_API_ADD_IP_ERROR": "No se puede agregar el servidor. Esta dirección IP es utilizada por otro servidor de mismo tipo.",
        "SERVER_API_UPDATE_IP_ERROR": "No se puede agregar el servidor. Esta dirección IP es utilizada por otro servidor de mismo tipo.",
        "SERVER_API_DELETE_SITE_ERROR": "No se puede eliminar el servidor. Es utilizado por uno de los sitios.",
        "DEVICE": "dispositivo",
        "DEVICES": "dispositivos",
        "DEVICE_TITLE": "Dispositivos",
        "DEVICE_DETAILS": "Detalles del Dispositivo",
        "DEVICE_MODEL": "Modelo del Dispositivo",
        "DEVICE_CAT_NAME": "Nombre de la categoría",
        "DEVICE_TYPE": "Tipo del Dispositivo",
        "DEVICE_ACTIONS": "Acciónes",
        "DEVICE_ADD": "Agregar un Dispositivo",
        "DEVICE_MANUFACTURER": "Seleccionar fabricante",
        "DEVICE_NAME": "Nombre del Dispositivo",
        "DEVICE_API_NAME_UQ_ERROR": "Ya existe un Dispositivo con el mismo nombre.",
        "PTT_DEVICE": "Dispositivo de PTT",
        "PTT_DEVICES": "Dispositivos de PTT",
        "PTT_DEVICE_DETAILS": "Detalles del Dispositivo de PTT",
        "PTT_DEVICE_TITLE": "Dispositivos de PTT",
        "PTT_DEVICE_MODEL": "Modelo del Dispositivo",
        "PTT_DEVICE_CAT_NAME": "Nombre de Categoría",
        "PTT_DEVICE_TYPE": "Tipo de Dispositivo",
        "PTT_DEVICE_NAME": "Nombre de Dispositivo",
        "PTT_DEVICE_API_NAME_UQ_ERROR": "Ya existe un dispositivo PTT con el mismo nombre para esta tienda",
        "MANUFACTURER": "Fabricante del Dispositivo",
        "MANUFACTURERS": "Fabricantes de Dispositivos",
        "MANUFACTURER_TITLE": "Fabricantes de Dispositivos",
        "MANUFACTURER_DETAILS": "Detalles de Fabricante del Dispositivo",
        "MANUFACTURER_API_DELETE_CHILD_RECORD_ERROR": "No se puede eliminar el fabricante. Se encontró un sub registro asociado.",
        "SOFTWARE_MANUFACTURER": "fabricante de Software",
        "SOFTWARE_MANUFACTURERS": "fabricantes de Software",
        "SOFTWARE_MANUFACTURERS_TITLE": "Fabricantes de Software",
        "SOFTWARE_MANUFACTURERS_DETAILS": "Detalles del Fabricantes de Software",
        "LICENSE_BUNDLE": "Paquete",
        "LICENSE_BUNDLES": "Paquete de licencias",
        "LICENSE_ALLOCATION": "asignación de licencias",
        "LICENSE_ALLOCATIONS": "asignaciónes de licencias",
        "LICENSE_ASSIGNMENT": "asignación de licencia",
        "LICENSE_ASSIGNMENTS": "asignaciónes de licencias",
        "LICENSE_TITLE": "Licencias",
        "LICENSE_DETAILS": "Detalles de la licencia",
        "LICENSE_NAME": "Nombre de la licencia",
        "LICENSE_DESCRIPTION": "Descripción de la licencia",
        "LICENSE_PERMISSIONS": "Permisos",
        "LICENSE_TYPE": "Tipo de Licencia",
        "LICENSE_ALLOCATION_DATE": "Fecha de asignación",
        "LICENSE_EXPIRATION_TYPE": "Tipo de expiración",
        "LICENSE_EXPIRATION_DATE": "Fecha de expiración",
        "LICENSE_AVAILABLE_QTY": "Disponible",
        "LICENSE_QUANTITY": "Cantidad",
        "LICENSE_ALLOCATE": "Asignar",
        "LICENSE_TEMPLATES": "Plantillas de licencias",
        "CONVERT_TO_LICENSE": "Mostrar Plantilla de Licencia",
        "LICENSE_MASK": "Código de licencia",
        "CONVERT_TO_MASK": "Mostrar Código de Licencia",
        "LICENSE_CODE": "Código de Licencia",
        "APP_CONVERT": "Generación de Código de Licencia",
        "UNDO_LICENSE": "Deshacer",
        "LICENSE_REVOKE": "Revocar",
        "LICENSE_API_ALLOCATION_GET_PARENT_LIST_ERROR": "No se pueden recuperar las asignaciones de licencias principales",
        "LICENSE_API_ASSIGNMENT_REVOKE_ERROR": "No se puede revocar la asignación de licencia",
        "ILLEGAL_LICENSE": "Todos los campos deben ser de tipo booleano",
        "LICENSE_TOAST_ALLOCATION_SUCCESS": "Asignado con éxito",
        "LICENSE_ALLOCATION_QTY_ERROR": "La cantidad de licencias es insuficiente",
        "LICENSE_ALLOCATION_ORG_ACTIVE_ERROR": "No hay asignaciones de licencias activas en la organización.",
        "LICENSE_MAX_ORDINARY_SUBSCRIBERS": "Cantidad máxima de Suscriptores Ordinarios",
        "LICENSE_MAX_DISPATCH_CONSOLE_SUBSCRIBERS": "Cantidad máxima de Despachadores",
        "LICENSE_MAX_SUBSCRIBERS": "Cantidad máxima de Suscriptores total",
        "LICENSE_IN_USE": "En uso",
        "LICENSE_EXPIRATION_DATE_SERVER": "Fecha de vencimiento de la licencia del Servidor",
        "RESELLER_QTY": "Cant. Licencia PTT",
        "RESELLER_DISPATCHER_QTY": "Cant. Licencia Despacho",
        "ORGANIZATION_QTY": "Cant. Licencia PTT",
        "ORGANIZATION_DISPATCHER_QTY": "Cant. Licencia Despacho",
        "LICENSE_DISPATCHER_ALLOCATE": "Asignar",
        "LICENSE_ALLOCATE_BUTTON": "Aplica",
        "PARENT_RESELLER_QTY": "Licencias de Revendedor matriz: PTT",
        "PARENT_RESELLER_DISPATCHER_QTY": "Despacho",
        "LICENSE_QTY_TOOLTIP": "Número de licencias en uso de las licencias asignadas de este tipo",
        "CLIENT_VERSION": "versión de cliente",
        "CLIENT_VERSIONS": "versiónes de clientes",
        "CLIENT_VERSION_TITLE": "Versión de Cliente",
        "CLIENT_VERSION_DIALOG_TITLE": "Detalles de versión del cliente",
        "CLIENT_VERSION_STORE_NAME": "Nombre de tienda del Cliente",
        "CLIENT_VERSION_VERSION": "Versión",
        "CLIENT_VERSION_SELECT_STORE": "Seleccione una tienda de app PTT",
        "CLIENT_VERSION_PATH": "Ruta del archivo local",
        "CLIENT_VERSION_DESCRIPTION": "Descripción",
        "STORE": "Tienda de app PTT",
        "STORES": "Tiendas de app PTT",
        "STORE_TITLE": "Tienda de app PTT",
        "STORE_DETAILS_TILE": "Detalles de Tienda de app PTT",
        "STORE_MODEL": "Modelo de Dispositivo",
        "STORE_CAT_NAME": "Nombre de la categoría",
        "STORE_TYPE": "Tipo del Dispositivo",
        "STORE_ACTIONS": "Acciones",
        "STORE_ADD_DEVICE": "Agregar un device",
        "STORE_DEVICE": "Seleccione un dispositivo",
        "STORE_CLIENT_STORE": "Tienda de app PTT",
        "STORE_MANUFACTURER": "Seleccionar fabricante",
        "STORE_DEVICE_NAME": "Nombre de dispositivo",
        "STORE_LICENSABLE_TYPE": "Tipo de Licenciable",
        "STORE_DESCRIPTION": "Descripción",
        "STORE_MANUFACTURER_NAME": "Nombre del Fabricante",
        "STORE_CLIENT_VERSION": "Versión de la aplicación",
        "STORE_API_NAME_UQ_ERROR": "Ya existe tienda de aplicaciónes con el mismo nombre para este fabricante",
        "LOCALIZATION_TITLE": "Localización",
        "LOCALIZATION_DETAILS": "detalles",
        "LOCALIZATION_FlAG": "Bandera",
        "LOCALIZATION_ACTIVE": "Activo",
        "LOCALIZATION_DEFAULT": "Predeterminado",
        "LOCALIZATION_NAME": "Etiqueta",
        "LOCALIZATION_TRANSLATION": "Clave de traducción",
        "LOCALIZATION_CODE": "Código de lenguaje",
        "LOCALIZATION_IMPORT": "Importar la tabla de traducción",
        "LOCALIZATION_EXPORT": "Exportar la tabla de traducción",
        "LOCALIZATION_REMOVE_DEFAULT_ERROR": "Tenga en cuenta: No se puede eliminar el idioma predeterminado. Configura otro como predeterminado e inténtalo de nuevo.",
        "LOCALIZATION_ADD_DUPLICATE_ERROR": "Error: la traducción con dicha clave ya existe.",
        "JOB_TITLE": "Proceso",
        "JOB_RUN_INTEGRITY": "Ejecutar un proceso de integridad de base de datos",
        "JOB_RUN_EXPIRATION": "Ejecutar el proceso de expiración de las licencias",
        "JOB_PROVISIONING": "Aprovisionamiento",
        "JOB_GPS": "Archivador GPS",
        "JOB_MONGO_HA": "Alta disponibilidad de Mongo DB",
        "JOB_INIT_LOG": "Inicializar el registro",
        "JOB_RUN_LOG": "Ejecutar el registro",
        "JOB_PROV_LICENSE_LOG": "Proceso de expiración de las licencias",
        "JOB_PROV_DB_INIT_LOG": "Registro del inicialización de la base de datos",
        "JOB_PROV_DB_INTEGRITY_LOG": "Registro del integridad de DB",
        "BULK_TITLE": "Operaciones Masivas",
        "BULK_OPERATIONS": "Operaciones Masivas",
        "BULK_INTERACTIVE_DELETE": "Eliminación",
        "DELETE_INTERACTIVE_SUBSCRIBERS": "Suscriptores",
        "DELETE_INTERACTIVE_GROUPS": "Grupos",
        "DELETE_INTERACTIVE_OCL": "Grupos de contactos",
        "DELETE_INTERACTIVE_EMERGENCY_GROUP": "Grupos de Emergencia",
        "DELETE_INTERACTIVE_CONTACT_TEMPLATE": "Plantillas de contactos",
        "DELETE_INTERACTIVE_TYPE": "Tipo de eliminación",
        "DELETE_GROUPS": "Grupos",
        "DELETE_SUBSCRIBERS": "Suscriptores",
        "DELETE_OCL": "Grupos de contactos",
        "DELETE_EMERGENCY_GROUP": "Grupos de Emergencia",
        "DELETE_CONTACT_TEMPLATE": "Plantillas de contactos",
        "BULK_DELETE_COUNT": "Recuento de Eliminaciónes",
        "BULK_INTERACTIVE_LICENSE": "Licencias",
        "BULK_INTERACTIVE_ROLE": "Roles",
        "BULK_SUBSCRIBERS_COUNT": "Número de suscriptores",
        "DOWNLOAD_SAMPLE_FILE": "Descargar archivo de muestra",
        "BULK_RESULT_LOG": "Registro de resultados",
        "BULK_IMPORT_NOTE": "Durante la importación de Subscriptores, Los grupos afiliados se aplicaran sobre lo subscriptores que tienen licencia off-net.",
        "AFFILLIATED_ORG_SUB_NOT_ADDED_MESSAGE": "no se han agregado suscriptores de organizaciones afiliadas",
        "GROUP_LIMIT_SIZE": "Se ha excedido el límite de longitud del nombre del grupo",
        "SUBSCRIBERS_API_NAME_LIMIT_SIZE": "Se ha excedido el límite de longitud del nombre de suscripción",
        "BULK_EXPORT": "Exportar",
        "BULK_IMPORT": "Importar",
        "BULK_EXPORT_REPORT": "Informes",
        "BULK_EXPORT_CALL_LOG": "Informe de Registro de Llamadas",
        "BULK_EXPORT_RUNTIME": "Informe de Estado de los Suscriptores",
        "BULK_ENABLE_ALL": "Habilitar todos los suscriptores",
        "BULK_SUSPEND_ALL": "Deshabilitar todos los suscriptores",
        "BULK_DELETE_ALL": "Eliminar todos los suscriptores",
        "BULK_DELETE_APPLY": "Ejecute la Eliminación",
        "BULK_SELECT_ALLOCATION": "Seleccionar Asignación",
        "BULK_SELECT_ROLE": "Seleccionar Rol",
        "BULK_SELECT_LICENSE": "Seleccionar Licencia",
        "BULK_ALLOCATION_APPLY": "Aplicar Asignación",
        "BULK_IMPORT_FILE_FORMAT_MESSAGE": "Por favor Subir solo Archivos CSV o XLSX",
        "BULK_INTERACTIVE_SMS": "Aprovisionamiento por SMS",
        "BULK_INTERACTIVE_CHANGE_PASSWORD": "Modificación de Contraseña",
        "BULK_CHANGE_PASSWORD_APPLY": "Establecer nueva Contraseña",
        "APP_CHANGE_PASSWORD_INTERACTIVE_WARNING_TITLE": "¿Seguro que quieres establecer esta contraseña para los usuarios seleccionados?",
        "SUBSCRIBERS_NEW_PASSWORD": "Nueva Contraseña",
        "INVALID_BULK_FILE_FORMAT": "El formato del archivo no es válido",
        "BULK_INTERACTIVE_EMERGENCY_GROUP": "Grupos de Emergencia",
        "BULK_SELECT_EMERGENCY_GROUP": "Seleccionar Grupo de Emergencia",
        "APP_EMERGENCY_GROUP_INTERACTIVE_WARNING_TITLE": "¿Seguro que quieres asignar este Grupo de Emergencia a los usuarios seleccionados?",
        "BULK_INTERACTIVE_CONTACT_TEMPLATE": "Plantillas de contactos",
        "BULK_CONTACT_TEMPLATE_SUBSCRIBERS": "Plantilla para suscriptor",
        "BULK_CONTACT_TEMPLATE_TEMPLATES": "Plantilla a plantilla",
        "CONTACT_TEMPLATE_TYPE": "Tipo",
        "BULK_SELECT_CONTACT_TEMPLATE": "Seleccionar Plantillas de contactos",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_ADD_WARNING_TITLE": "¿Seguro que quieres asignar este Plantillas de contactos a los usuarios seleccionados?",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_ADD_WARNING_GROUP_TITLE": "¿Desea asignar estas plantillas de contactos a los usuarios del grupo seleccionado?",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_REMOVE_WARNING_TITLE": "¿Estas seguro de querer eliminar esta plantilla de contactos de los usuarios sleccionados?",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_REMOVE_WARNING_GROUP_TITLE": "¿Desea eliminar esta plantilla de contactos del grupo de usuarios seleccionado?",
        "BULK_CONTACT_TEMPLATE_ADD": "Añadir usuarios a la plantilla de contactos",
        "BULK_CONTACT_TEMPLATE_REMOVE": "Eliminar usuarios de la plantilla de contactos",
        "RESELLER_SMS_CONFIGURATION": "Configuración de acceso al proveedor de SMS",
        "SMS_API_KEY": "Clave del API - \"API Key",
        "SMS_API_SECRET": "Secreto del API - \"API Secret",
        "SMS_IP": "IP del SMSC",
        "SMS_PORT": "Port del SMSC",
        "SMS_SEND_CREDENTIAL": "Datos de acceso",
        "SMS_SEND_CREDENTIALS_WITH_SERVER": "Datos de acceso y URL(servicio)",
        "SMS_SEND_MESSAGE": "Mensaje personalizado",
        "SMS_SEND_CREDENTIALS_AND_DOWNLOAD_LINK": "Datos de acceso con enlace",
        "SMS_SEND_DOWNLOAD_LINK": "Enlace de descarga",
        "SMS_DOWNLOAD_LINK": "Ingrese un Enlace de Descarga personalizado",
        "SMS_MESSAGE": "Ingrese un Mensaje personalizado",
        "SMS_MISSING_KEYS": "El acceso al proveedor de SMS no está configurado por el revendedor",
        "SMS_API_VALIDATION_PHONE_ERROR": "Error de SMS API: Número de teléfono no proporcionado",
        "SMS_API_VALIDATION_CREDENTIALS_ERROR": "Error del API de SMS: Datos de acceso no proporcionados",
        "USER_VALIDATION_EMAIL_FORMAT_ERROR": "Formato de correo inválido",
        "USER_ID": "ID de usuario",
        "TEXT_SEARCHBTN": "Buscar",
        "SEARCH_RESULT": "Resultado de búsqueda",
        "START_DATE": "Fecha de Inicio",
        "END_DATE": "Fecha de Finalización",
        "ENTER_DATE": "Selecciona la fecha",
        "ADMIN_RECORD_TITLE": "Revisores de Grabaciones",
        "ADMIN_RECORD_EMAIL_ID": "ID de Email",
        "ADMIN_RECORD_LAST_LOGIN_TIME": "Inicio de sesión reciente",
        "ADMIN_RECORD_LAST_ACTIVITY_TIME": "Tiempo de actividad reciente",
        "USER_LAST_PASSWORD_CHANGE_TIME": "Última modificación de contraseña",
        "ADMIN_RECORD_DIALOG_TITLE": "Detalles del Revisor de Grabaciones",
        "ADMIN_RECORD_DETAILS": "Detalles del Revisor",
        "ADMIN_RECORD_ACTIVITY": "Detalles de actividad",
        "ADMIN_RECORD_ACTIVITY_COMMAND": "Actividad",
        "ADMIN_RECORD_ACTIVITY_SESSION_NAME": "Nombre de sesión grabada",
        "ADMIN_RECORD_ACTIVITY_USER_NAME": "Nombre de usuario",
        "ADMIN_RECORD_ACTIVITY_TIME": "Tiempo de actividad",
        "ADMIN_RECORD_ACTIVITY_IP": "IP del Revisor",
        "AUDIO_BACKUP_PATH_TITLE": "Administración de almacenamiento",
        "AUDIO_BACKUP_FOLDER_DATE": "Mes y año",
        "AUDIO_BACKUP_PATH": "Ruta al archivo",
        "AUDIO_BACKUP_PATH_DIALOG_TITLE": "Administración de almacenamiento",
        "FOLDER_DATE": "Mes y año",
        "BRANDING_TITLE": "Marca",
        "BRANDING_TITLE_IMAGE": "Imagen de marca",
        "BRANDING_NAME": "Nombre de la aplicación",
        "COLOR1": "Color 1",
        "COLOR2": "Color 2",
        "BRANDING_IMAGE": "Imagen de bienvenida",
        "BRANDING_MDC_LOGO_IMAGE": "Imagen del logotipo de la consola de despacho",
        "BRANDING_MDC_SPALSH_IMAGE": "Imagen de bienvenida de la consola de despacho",
        "BRANDING_MDC_COMPANYNAME_IMAGE": "Imagen de nombre de empresa de la consola de despacho",
        "LOGO_IMAGE_ERROR_FILE_TYPE": "Formato de imagen no válido. Solo se admiten el formato ico y la extensión de archivo ico",
        "APP_WRONG_FILE_EXTENTION": "Formato de imagen no válido",
        "BRANDING_ERROR_COLOR": "Formato de valor de color no válido",
        "BRANDING_ERROR_NAME_LENGTH": "El nombre de la aplicación está limitado a 20 caracteres solamente",
        "BUTTON_SAVE_BRAND_INFO": "Guardar Información de Marca",
        "BUTTON_SAVE_BRAND_IMG": "Guardar la Imagen de Marca",
        "BUTTON_RESET_BRAND_INFO": "Revertir todo a la marca predeterminada",
        "FLAG_BRAND_ACTIVATION": "Cambiar marca predeterminada",
        "BRANDING_RESET_WARNING": "Cancelar la anulación. La aplicación utilizará los valores de marca predeterminados por los desarrolladores.",
        "BRANDING_MAP_SERVER": "Dirección del servidor de Mapas",
        "BRANDING_ORGANIZATION_OVERRIDE_RESELLER": "Ignorar Marca del Revendedor",
        "BRANDING_RESELLER_OVERRIDE_RESELLER": "Establecer Marca para Sub-Revendedores y Sub-Organizaciones",
        "APP_TOAST_SELECT_IMAGE": "Por favor seleccione una imagen",
        "BRANDING_ERROR_FILE_TYPE": "Formato de imagen no válido. Solo se admiten los formatos y las extensiones de archivos de png jpg y jpeg",
        "BRANDING_ERROR_IMAGE_SIZE": "El tamaño del archivo de imagen no puede ser grande de 200 KBytes",
        "BRANDING_TITLE_MESSAGE": "¡La configuración de marca puede afectar inmediatamente a todos los usuarios de esta organización!",
        "NAVIGATION_ORG_FRIENDS": "Gestión de afiliación",
        "ORG_FRIEND_API_GET_LIMIT_ERROR": "No se puede recuperar la lista de afiliados",
        "ORG_FRIEND": "Organizaciones afiliadas",
        "ORG_AFFILIATED_GROUPS": "Grupos afiliados",
        "ORG_AFFILIATED_CONTACTS": "contactos afiliados",
        "ORG_FRIENDS_API_LIMIT_ERROR": "No se puede actualizar porque se ha alcanzado el límite de %s afiliados. Verifique con el proveedor de servicios si se puede aumentar el límite.",
        "APP_SAVE_ORG_FRIEND": "Guarda organizaciones afiliadas",
        "ORG_AFFILIATED_AFFECT_WARNING": "Cualquier cambio en las organizaciones afiliadas afectará a los miembros de los grupos afiliados de la organización",
        "ORG_AFFILIATED_OFFNET_WARNING": "¡Asigne una licencia Off-Net a todos los miembros relevantes antes de crear un grupo afiliado!",
        "ORG_AFFILIATED_CONTACTS_OFFNET_WARNING": "Asigne una licencia Off-Net a todos los miembros relevantes para poder verlos y agregarlos aquí.",
        "PERSONAL_GROUP": "Grupo privado de Emergencia",
        "PERSONAL_GROUP_API_ADD_CONTACT_ERROR": "No se puede agregar el contacto en el Grupo de Emergencia",
        "PERSONAL_GROUP_API_NAME_UQ_ERROR": "Ya existe un Grupo de Emergencia con el mismo nombre",
        "PERSONAL_GROUP_API_REMOVE_CONTACT_ERROR": "No se puede eliminar el contacto del Grupo de Emergencia",
        "SUBSCRIBERS_PERSONAL_GROUP_SUBSCRIBERS": "Grupo privado de Emergencia",
        "SUBSCRIBERS_EMERGENCY_GROUP": "Grupo de Emergencia (recepción de alarmas)",
        "NAVIGATION_EMERGENCY_GROUPS": "Grupos de Emergencia",
        "EMERGENCY_GROUP_DETAILS": "Detalles del Grupo de Emergencia",
        "PERSONAL_GROUP_NAME": "Nombre del grupo",
        "PERSONAL_GROUP_NOTE": "Por favor",
        "BUTTON_OPEN_APPLICATION_LIST": "Lista de aplicaciones",
        "APPLICATIONS_DIALOG_TITLE": "Lista de aplicaciones",
        "APPLICATION_ICON": "icono de la aplicación",
        "APPLICATION_NAME": "Nombre de la aplicación",
        "APPLICATION_VERSION": "version de la aplicacion",
        "APPLICATION_ID": "ID de la aplicación",
        "APP_ADD_APPLICATION": "Agregar aplicación",
        "RECORDING_PLAN": "Plan de grabacion",
        "RECORDING_PLAN_NONE": "Sin grabacion",
        "RECORDING_PLAN_ALL_CALLS": "Grabar todas las llamadas",
        "RECORDING_PLAN_SELECTIVE": "Grabación selectiva",
        "NAVIGATION_RECORDING": "Planificador de Grabación",
        "RECORDING_TITLE": "Planificador de Grabación",
        "RECORD_WHITE_LIST_SUBSCRIBERS_TITLE": "Usuarios grabados",
        "RECORD_WHITE_LIST_GROUPS_TITLE": "Grupos grabados",
        "BUTTON_SAVE_RECORDED_SUBSCRIBERS": "Guarda plan para Usuarios",
        "BUTTON_SAVE_RECORDED_GROUPS": "Guarda plan para Grupos",
        "ENCRYPTION_PLAN": "Plan de Encriptado",
        "BUTTON_UPLOAD_KEY_FILE": "Subir llaves personalizadas",
        "BUTTON_SET_EMPTY_KEY_FILE": "Quitar todas las llaves",
        "BUTTON_SET_KEY_FILE": "Genere llaves de encriptado aleatorias",
        "BUTTON_SET_DEFAULT_KEY_FILE": "llaves predeterminadas",
        "APP_TOAST_UPDATE_KEY_FILE_SUCCESS": "llaves de Encriptado cargadas con éxito",
        "APP_TOAST_UPDATE_EMPTY_KEY_FILE_SUCCESS": "llaves de Encriptado se eliminaron con éxito",
        "ENCRYPTION_ERROR_FILE_SIZE": "El tamaño del archivo de llaves de encriptado debe ser una multiplicación de 32",
        "ENCRYPTION_ERROR_FILE_TYPE": "El archivo de llaves de encriptado debe ser de tipo binario",
        "ENCRYPTION_ERROR_PERMISSION": "Sin permiso para cargar o guardar el archivo de llaves de encriptado",
        "VERSIONS_PLAN": "Plan de versiones de aplicaciónes",
        "BRANDING_LATEST_VERSION_ANDROID": "Última versión de la aplicación de Android",
        "BRANDING_LATEST_VERSION_MDC": "Última versión de MDC2000",
        "BUTTON_UPLOAD_ANDROID_VERSION_FILE": "Cargar archivo APK de Android",
        "BUTTON_UPLOAD_MDC_VERSION_FILE": "Cargar archivo EXE del MDC2000",
        "APP_TOAST_UPLOAD_VERSION_FILE_SUCCESS": "El nuevo archivo de la aplicación se cargó con éxitoe.",
        "APP_TOAST_UPLOAD_VERSION_FILE_EMPTY": "Ningún archivo seleccionado. Por favor seleccione un archivo para cargar.",
        "BUTTON_DELETE_ANDROID_VERSION_FILE": "Eliminar el archivo Android APK",
        "BUTTON_DELETE_MDC_VERSION_FILE": "Eliminar el archivo MDC2000 EXE",
        "APP_TOAST_DELETE_VERSION_FILE_SUCCESS": "El archivo ha sido eliminado exitosamente",
        "UPLOAD_VERSION_ERROR_FILE_TYPE": "Error de tipo de archivo. Solo se admiten EXE o APK",
        "UPLOAD_VERSION_SIGN_ERROR": "La firma del archivo cargado es incorrecta",
        "STRONG_PASSWORD_PLAN": "Plan de contraseñas complejas",
        "MAX_LOGIN_RETRIES_PLAN": "Plan de intentos para bloqueo de usuarios",
        "MAX_LOGIN_RETRIES": "Cantidad máxima de intentos",
        "CHANGE_PASSWORD_PLAN": "Plan de Vencimiento de contraseña",
        "PASSWORD_EXPIRATION_DAYS": "Días para vencimiento de contraseña",
        "GENERIC_IMPORT": "Importar",
        "GENERIC_EXPORT": "Exportar",
        "NAVIGATION_REPORT": "Informes",
        "REPORT_TITLE": "Informes",
        "BILLING_REPORT_EXPORT": "Exportar Informe de uso de Licencia",
        "SYSTEM_USERS_REPORT_EXPORT": "Exportar Lista de Suscriptores",
        "BULK_EXPORT_ADMIN_RECORDS": "Exportar Informe de Actividad de los Revisores de Grabación",
        "WFM_TITLE": "administración de personal",
        "NAVIGATION_WFM": "WFM",
        "WFM_USERS_MANAGEMENT": "Administración de Usuarios",
        "WFM_INCIDENCES": "Incidence type",
        "WFM_APPLY": "Aplicar",
        "WFMUSER": "Usuario de Work Force Management",
        "WFMUSERS": "Usuarios de Work Force Management",
        "WFM_API_ADD_WFMUSER_ERROR": "No se pueden agregar los usuarios de Administración de personal",
        "WFM_API_REMOVE_WFMUSER_ERROR": "No se pueden remover los usuarios de Administración de personal",
        "WFM_INCIDENCE_DEFAULT": "Predeterminado",
        "WFM_ADD_TYPE": "Add new type",
        "NAVIGATION_CALL_LOGS": "Historial de llamadas",
        "CALL_LOGS_TITLE": "HISTORIAL DE LLAMADAS",
        "CALL_LOGS_SESSION_NAME": "Nombre de Canal",
        "CALL_LOGS_SESSION_ID": "ID de Canal",
        "CALL_LOGS_SENDER_NAME": "Nombre del remitente",
        "CALL_LOGS_RECIPIENT_NAME": "Destinatario",
        "CALL_LOGS_SESSION_TYPE": "Tipo de Canal",
        "CALL_LOGS_SESSION_START_TIME": "Hora de inicio",
        "CALL_LOGS_SESSION_END_TIME": "Hora final",
        "CALL_LOGS_DIALOG_TITLE": "ACTIVIDAD DEL CANAL",
        "CALL_LOG_SESSION_BY_DATE_BUTTON": "Filtrar por fecha",
        "CALL_LOG_SESSION_CLEAR_DATE_BUTTON": "Borrar el filtro",
        "CALL_LOG_SESSION_SHOW_FILTER_BY_DATES": "Mostrar Filtros",
        "CALL_LOG_SESSION_SHOW_FILTER_BY_DATES_WARNING_TITLE": "Cerrar panel de Filtros",
        "CALL_LOG_SESSION_SHOW_FILTER_BY_DATES_WARNING_CONTENT": "Cerrar este panel también borrará los filtros. ¿Continuar?",
        "DATES_BLANK_ERROR": "La fecha de inicio o la fecha de finalización no se eligieron",
        "DATES_ERROR": "La fecha de finalización no puede ser anterior a la fecha de inicio",
        "CALL_LOGS_BURST_TALKER_NAME": "Nombre de Hablante",
        "CALL_LOGS_BURST_TALKER_ID": "ID de Hablante",
        "CALL_LOGS_BURST_TALKER_START_TIME": "Hora de inicio",
        "CALL_LOGS_BURST_TALKER_END_TIME": "Hora final",
        "CALL_LOGS_BURST_DURATION": "Duración",
        "CALL_LOG_DATES_CONTEXT_WARNING": "Por favor elija fechas",
        "APP_RELEASE": "Estado de Bloqueo",
        "APP_RELEASE_WARNING_TITLE": "Desbloqueo de Cuenta",
        "APP_RELEASE_WARNING_CONTENT": "Está a punto de desbloquear la cuenta de este usuario. Primero se recomienda cambiar la contraseña del usuario. ¿Continuar?",
        "APP_TOAST_RELEASE_SUCCESS": "La cuenta ha sido desbloqueada con éxito",
        "APP_BLOCK_WARNING_TITLE": "Bloqueo de cuenta",
        "APP_BLOCK_WARNING_CONTENT": "Está a punto de bloquear la cuenta de este usuario.¿Continuar?",
        "APP_BLOCK_USER": "Su cuenta ha sido bloqueada de forma temporal. Póngase en contacto con su administrador para obtener ayuda.",
        "APP_TOAST_BLOCK_SUCCESS": "La cuenta ha sido bloqueada con éxito",
        "NAVIGATION_APPLICATION_LISTS": "Plan de aplicaciones móviles",
        "APPLICATION_LISTS": "Listas de aplicaciones móviles",
        "APPLICATION_PACKAGE": "Paquete de la app",
        "APPLICATION_GET_DETAILS": "Extraer detalles del paquete de la app",
        "APPLICATION_DESCRIPTION": "Descripción de la app",
        "APPLICATION_DEFAULT_LIST": "Lista de apps predeterminada",
        "APPLICATION_ADD_DIALOG": "Agregar app",
        "APPLICATION_PROFILES": "Perfiles de app",
        "APPLICATION_LIST_ID": "ID de la lista de apps",
        "APPLICATION_LIST_NAME": "Nombre de la lista de apps",
        "APPLICATION_LIST_DIALOG": "Lista de apps",
        "APPLICATION_LIST_MIC": "Apps que usan micrófono",
        "APPLICATION_LIST_KIOSK": "Apps permitidas en modo Kiosco",
        "APPLICATION_UPDATE_PACKAGE_ERROR": "El archivo de la aplicación cargado es diferente del existente.",
        "APPLICATION_UPDATE_VERSION_ERROR": "La versión de la aplicación cargada es inferior a la existente.",
        "SUBSCRIBERS_APPLICATION_LIST": "Listas de aplicaciones",
        "BULK_INTERACTIVE_APPLICATION_LIST": "Asignación de lista de apps",
        "BULK_SELECT_APPLICATION_LIST": "Seleccionar lista de apps",
        "APP_APPLICATION_LIST_INTERACTIVE_WARNING_TITLE": "¿Estás seguro de que quieres aplicar el cambio?",
        "APP_DELETE_APPLICATION_LIST_WARNING_TITLE": "¿Seguro que quieres eliminar la lista de apps?",
        "APPLICATION_LIST_ERROR_DUPLICATE_NAME": "el nombre de la lista de apps no es único",
        "APP_TOAST_ADD_APPLICATION_ERROR": "Ya existe una applicacion con el mismo paquete o aparece en la lista de aplicacion",
        "APP_TOAST_ADD_APPLICATION_SUCCESS": "Aplicación agregada con éxito.",
        "APP_TOAST_ADD_APPLICATION_UPDATE_SUCCESS": "Aplicación actualizada correctamente.",
        "APP_TOAST_REMOVE_APPLICATION": "Aplicación eliminada con éxito.",
        "APP_TOAST_ADD_APPLICATION_RESERVED_ERROR": "El nombre del paquete no puede contener palabras o simbolos reservados",
        "APP_MOVE_TAB_APPLICATION_LIST_WARNING_TITLE": "Aviso de guarda cambios",
        "APP_MOVE_TAB_APPLICATION_LIST_WARNING_CONTENT": "Si no guarda los cambios ahora",
        "APPLICATION_LIST_WARNING_TITLE": "Aviso de efecto",
        "APPLICATION_LIST_WARNING_CONTENT": "Aviso: los cambios aplicados en esta área afectarán inmediatamente a todos los usuarios de su organización",
        "NAVIGATION_REACH_ME": "Informes de Reach All",
        "REACH_ME_TITLE": "Informes de Reach All",
        "REACH_ME_USERS": "Usuarios de Reach All",
        "REACH_ME_GROUPS": "Grupos de Reach All",
        "REACH_ME_USER_NAME": "Nombre",
        "REACH_ME_USER_ID": "ID",
        "REACH_ME_USER_PHONE": "Número de teléfono",
        "REACH_ME_USER_IMEI": "IMEI",
        "REACH_ME_GROUP_NAME": "Nombre de Grupo",
        "REACH_ME_GROUP_ID": "ID de Grupo",
        "REACH_ME_GROUP_ADMIN_ID": "ID de Controlador",
        "REACH_ME_GROUP_ADMIN_NAME": "Nombre de Controlador",
        "REACH_ME_GROUP_DIALOG_TITLE": "Reach All detalles del grupo",
        "REACH_ME_GROUP_MEMBER_NAME": "Nombre de Miembro",
        "REACH_ME_GROUP_MEMBER_ID": "ID de Miembro",
        "REACH_ME_GROUP_USER": "No se pudo recuperar la información desde el repositorio. Verifique la configuración del sistema.",
        "REACH_ME_USER_LAST_SEEN": "Visto por última",
        "REACH_ME_USER_LAST_REGISTERED": "Registrado por última",
        "REACH_ME_USER_ACTIVITY_DIALOG_TITLE": "Informe de Actividad del Usuario",
        "REACH_ME_USER_ACTION": "Acción",
        "REACH_ME_USER_ACTION_TIME": "Marca de tiempo",
        "SUBSCRIBERS_SUBSCRIBER_LIST": null,
        "LOCALIZATION_FLAG": null,
        "SMS_SERVICE": "Servicio",
        "SMS_SEND_CREDENTIAL_WITHOUT_SERVER": null,
        "APP_TOAST_COLOR_ERROR": null,
        "APP_TOAST_IMAGE_FORMAT_ERROR": null,
        "APP_TOAST_IMAGE_SIZE_ERROR": null,
        "ACTIVITY_LOG_TITLE": "Registro de Actividades",
        "ACTIVITY_LOG_TIMESTAMP": "Marca de tiempo",
        "ACTIVITY_LOG_USER": "Administrador",
        "ACTIVITY_LOG_TYPE": "Tipo",
        "ACTIVITY_LOG_NAME": "Nombre",
        "ACTIVITY_LOG_OPERATION": "Actividad",
        "ACTIVITY_LOG_DESCRIPTION": "Descripción",
        "BULK_EXPORT_ACTIVITY_LOG": "Informe de Registro de Actividades",
        "RADIO_GROUP_CHAT": "Radio",
        "EMERGENCY_GROUP": "Emergencia",
        "FORWARD_GROUP": "Grupo de apoyo",
        "FORWARD_GROUP_NAME": "",
        "CONFERENCE_GROUP_BROADCAST": "Conferencia",
        "ORGANIZATION_CONTACT_GROUP": "Grupo de contactos en la organización",
        "CONTACTS_TEMPLATE": "Planilla de contactos",
        "OWN": "Me pertenece",
        "GENERATE_COMMON_PASSWORD": "Elegir Contraseña",
        "GENERATE_UNIQUE_PASSWORD": "Generar contraseña única para cada usuario",
        "ORGANIZATION_STRONG_ADMINISTRATOR_PASS": "Forzar contraseña compleja para Administradores",
        "PLAYER_CLIENT_VERSION": "Versión del cliente de reproducción",
        "UNABLE_TO_ADD_MULTIPLE_EMERGENCY_GROUP": "No se puede agregar un grupo de emergencia privado múltiple",
        "SECONDARY_SITE_TITLE": "Asignar sitio secundario",
        "APP_SENTINEL": "Configuraciones centinela",
        "APP_PORT": "Puerto",
        "PATH_NOTE": "Por favor agregue '/' antes de la ruta",
        "PATH_NOT_SET": "Ruta no establecida",
        "ORGANIZATION_API_ADD_PORTAL_URL_UQ_ERROR": "No se puede agregar la organización. La URL del dominio debe ser única",
        "APP_LIST_SHOW": "LISTA DE APLICACIONES",
        "APP_LIVE_SENTINEL_EVENTS": "Eventos centinela en vivo",
        "APP_INFO": "Información",
        "SENTINEL_INFO_TEXT": "Para probar la funcionalidad, utilice el siguiente punto final de prueba:",
        "URL_NOTE": "Por favor ingrese la URL con 'HTTP/S'",
        "APP_ROLE_FILTER": "Filtrar por rol",
        "CONFIG_IPRS_WARNING": "¡Mantenga el mismo valor para esta configuración en el servidor!",
        "MOBILE_PORTAL_LOGO_IMAGE": "Imagen del logotipo del portal de gestión",
        "NAVIGATION_LOCATION_HISTORY": "Historial de ubicación",
        "LOCATION_LATITUDE": "Latitud",
        "LOCATION_LONGITUDE": "Longitud",
        "LOCATION_ACCURANCY": "Exactitud",
        "LOCATION_DATE_TIME": "Fecha Hora",
        "LOCATION_ACTIVITY": "Ubicación Actividad",
        "LOCATION_COUNT": "Recuento de ubicaciones",
        "BULK_EXPORT_LOCATION_HISTORY": "Exportar historial de ubicaciones",
        "LOCATION_LAST_UPDATE_TIME": "Hora de la última actualización",
        "BULK_CONTACT_TEMPLATE_SUB_TO_SUB": "Suscriptor a suscriptor",
        "BULK_EXPORT_APPLICATIONS": "Aplicaciones de exportación",
        "BULK_EXPORT_ROLES": "Funciones de exportación",
        "NAVIGATION_MOVEORGANIZATION": "Migración",
        "TRANSFER_RESELLER": "Transferir revendedor",
        "TRANSFER_ORGANIZATION": "Organización de transferencia",
        "TRANSFER_RESFORYOU": "Seleccionar revendedor de origen",
        "TRANSFER_PARENTRES": "Seleccione el revendedor principal de destino",
        "TRANSFER_ORGFORYOU": "Seleccionar organización de origen",
        "TRANSFER_ORGLIST": "Lista de organizaciones",
        "TRANSFER_SELECTRES": "Seleccionar revendedor",
        "TRANSFER_ORGANIZATION": "Organización de transferencia",
        "NOT_SUPPORTED": "No podemos recuperar los detalles de la aplicación. Agregue manualmente los demás detalles requeridos",
        "CONTACT_LIMIT_EXCEEDED": "Se superó el límite de contactos. No se puede agregar más del límite configurado.",
        "API_RESELLER_DELETE_ERROR": "No se puede eliminar el revendedor. Primero, elimine las organizaciones asociadas.",
        "BULK_EXPORT_SUBSCRIBER_QR_CODE": "Exportar códigos QR de suscriptores",
        "MOBILEAPP_DELETE_WARNING_CONTENT": "Si elimina esta aplicación, se eliminará automáticamente de todos los perfiles de aplicación asignados y los usuarios ya no tendrán acceso a ella.",
        "DISABLE_REMEMBER_ME": "Desactivar Recordar al último usuario",
        "APP_QR_WARNING_TITLE": "Regenerar la autenticación",
        "APP_QR_WARNING_CONTENT": "¿Está seguro de que desea volver a generar el código QR de autenticación?",
        "APP_QR_ENABLE_AUTHENTICATION": "Habilitar autenticación",
        "APP_QR_DISABLE_AUTHENTICATION": "Deshabilitar la autenticación",
        "APP_QR_REGENERATE_AUTHENTICATION": "Regenerar la autenticación",
        "APP_QR_TWO_FACTOR": "Dos factores",
        "APP_QR_DISABLE_TITLE": "Deshabilitar la autenticación",
        "APP_QR_DISABLE_CONTENT": "¿Estás seguro de que deseas desactivar el código QR del autenticador?",
        "APP_QR_ENABLE_SUCCESS": "El autenticador de código QR se ha habilitado correctamente",
        "APP_QR_REGENERATE_SUCCESS": "El autenticador de código QR se regeneró correctamente",
        "APP_QR_DISABLE_SUCCESS": "Código QR del autenticador deshabilitado correctamente",
        "APP_DISPATCHER_PERMISSION_LICENSE_WARNING": "Se permite el permiso de Despachador o Despachador Web a la vez.",
        "UserLimitExceeded":"No se pudo completar la acción porque se alcanzó el número máximo de usuarios permitidos. Por favor, actualice su plan.",
        "BulkUserLimitExceeded":"No se pudo completar la acción porque se alcanzó el número máximo de usuarios permitidos. Por favor, actualice su plan.",
        "SESSION_NAME": "Nombre de la sesión",
        "MISSED_CALL": "Llamada perdida",
        "SESSION_ID": "ID de sesión",
        "SENDER_NAME": "Nombre del remitente",
        "SENDER_ID": "ID del remitente",
        "RECIPIENT_NAME": "Nombre del destinatario",
        "RECIPIENT_ID": "ID del destinatario",
        "SESSION_TYPE": "Tipo de sesión",
        "SESSION_START_TIME": "Hora de inicio",
        "SESSION_END_TIME": "Hora de fin",
        "BURST_TALKER_NAME": "Nombre del hablante",
        "BURST_TALKER_ID": "ID del hablante",
        "BURST_START_TIME": "Inicio del burst",
        "BURST_END_TIME": "Fin del burst",
        "DURATION": "Duración"
      };
    };

    // hebrew
    function get_he() {
      return {
        "version": "2.26",
        "revised_by": "Hardik shah",
        "revision_date": "17-09-2025",
        "APPLICATIONS": "יישומים",
        "API_MONGO_DB_TIMEOUT": "מסד הנתונים מונגו לא נגיש. ההתחברות הופסקה עקב אי מענה",
        "API_REQUEST_TIMEOUT": "Node request timeout",
        "API_MONGO_DB_ERROR": "אבד החיבור למסד הנתונים. אנא נסה להתחבר שוב מאוחר יותר",
        "API_GET_LIST_ERROR": "%s לא ניתן לאחזר את הרשימה",
        "API_GET_ERROR": "%s לא ניתן לאחזר את",
        "API_ADD_ERROR": "%s לא ניתןן להוסיף את",
        "API_UPDATE_ERROR": "%s לא ניתן לעדכן את",
        "API_DELETE_ERROR": "%s לא ניתן למחוק את",
        "API_NOT_FOUND_ERROR": "%s לא ניתן למצוא את",
        "API_FORBIDDEN_ERROR": "הגישה אסורה",
        "APP_GENERAL": "כללי",
        "APP_CUSTOM": "מותאם",
        "APP_DESCRIPTION": "תאור",
        "APP_SEARCH": "חיפוש",
        "APP_FILTER": "סנן לפי רישוי",
        "APP_NO_FILTER": "כֹּל",
        "APP_NAME": "שם",
        "APP_REMOVE": "מחק",
        "APP_CLONE": "שכפל",
        "APP_SAVE": "שמור",
        "APP_CANCEL": "ביטול",
        "APP_ADD": "הוסף",
        "APP_UPDATE": "עדכן",
        "APP_OK": "אישור",
        "APP_REFRESH": "עדכן",
        "APP_RECORDS_COUNT": "רשומות",
        "APP_NO_RECORDS": "המידע איננו זמין",
        "APP_DELETE_WARNING_TITLE": "האם אתה בטוח שצריך למחוק את הפריט הזה?",
        "APP_DELETE_WITH_MEMBERS_WARNING_TITLE": "לפריט זה יש פריטי משנה. האם אתה בטוח שצריך למחוק אותו?",
        "APP_DELETE_WARNING_CONTENT": "כל המידע ימחק",
        "APP_ENABLE_WARNING_TITLE": "האם אתה בטוח שכל המשתמשים צריכים להיות פעילים?",
        "APP_DISABLE_WARNING_TITLE": "האם אתה בטוח שצריך להשבית את כל המשתמשים?",
        "APP_SEND_SMS": "SMS שליחת",
        "APP_SEND_SMS_WARNING_TITLE": "האם אתה בטוח שיש לשלוח את ההודעה למנוי זה?",
        "APP_SEND_BULK_SMS_WARNING_TITLE": "האם אתה בטוח שיש לשלוח את ההודעה למנויים אלו?",
        "APP_LICENSE_INTERACTIVE_WARNING_TITLE": "האם אתה בטוח שצריך להקצות את הרישיון הזה לכל המשתמשים?",
        "APP_ROLE_INTERACTIVE_WARNING_TITLE": "האם אתה בטוח שכל המשתמשים צריכים להיות בתפקיד הזה?",
        "APP_PASSWORD_MISMATCH": "הסיסמאות אינן זהות",
        "APP_SHOW_PASSWORD": "הצג סיסמה",
        "APP_CHANGE_PASSWORD": "שנה סיסמה",
        "APP_GENERATE_PASSWORD": "חולל סיסמה",
        "APP_VALIDATION_REQUIRED": "זהו שדה חובה",
        "APP_VALIDATION_MAX_LENGTH": "שדה זה ארוך מדי",
        "APP_VALIDATION_MIN_LENGTH": "שדה זה קצר מדי",
        "APP_VALIDATION_EMAIL": "אנא הקלד כתובת אימייל חוקית",
        "APP_VALIDATION_IP": "אנא הקלד כתובת שרת חוקית",
        "APP_VALIDATION_URL": "אנא הקלד כתובת אתר חוקית",
        "APP_VALIDATION_SPECIAL_CHARS": "אין להקליד תוים מיוחדים בשדה זה",
        "APP_VALIDATION_REGULAR_PASSWORD": "אין להקליד רווחים או תו '\\' בשדה זה",
        "APP_VALIDATION_PASSWORD": "הסיסמה חייבת להיות בין 10 ל15 תווים וחייבת להכיל לפחות- ספרה אחת, אות גדולה אחת, אות קטנה אחת ותו מיוחד אחד. הסיסמה לא תכיל סדרה של אותיות/ספרות זהות או עוקבות.",
        "APP_ERROR_VALIDATION_PASSWORD": "הסיסמה איננה מתאימה לכללים",
        "APP_TOAST_ADD_SUCCESS": "עודכן בהצלחה",
        "APP_TOAST_UPDATE_SUCCESS": "עודכן בהצלחה",
        "APP_TOAST_DELETE_SUCCESS": "נמחק בהצלחה",
        "APP_TOAST_ALLOCATE_SUCCESS": "הוקצא בהצלחה",
        "APP_TOAST_REVOKE_SUCCESS": "בוטל בהצלחה",
        "APP_TOAST_CHANGE_SUCCESS": "שונה בהצלחה",
        "APP_TOAST_DELETE_FAILED": "לא ניתן למחוק את התפקיד מפני שהוא מוקצה למשתמש אחד לפחות",
        "APP_TOAST_DELETE_FAIL": "לא ניתן למחוק את הארגון. ראשית יש למחוק את כל המנהלים שלו",
        "APP_TOAST_SEARCH_BLANK": "הקלד מספר טלפון או כתובת אימייל או מספר מזהה או מספר IMSI של המשתמש",
        "APP_TOAST_REVOKE_FAILED": "לא ניתן לשלול את הרישיון מפני שהוא כבר הוקצה למשתמשים",
        "APP_TOAST_404": "הקובץ לא קיים",
        "APP_UNSELECTED": "לא נבחרו",
        "APP_UNSELECTED_OFFNET": "Off-net יוזרים",
        "APP_SELECTED": "נבחרו",
        "APP_ADD_ALL": "בחר הכל",
        "APP_REMOVE_ALL": "הסר הכל",
        "APP_DISPATCHER_USER_WARNING_TITLE": "שימו לב:",
        "APP_DISPATCHER_USER_WARNING_CONTENT1": "אתם עומדים ליצור משתמש עם רישיון מסוג מוקדן אך התפקיד שנבחר איננו מתאים לפעילות מוקדן",
        "APP_DISPATCHER_USER_WARNING_CONTENT2": "?חיזרו להגדרת תפקיד מתאימה או המשיכו ותוכלו לשנות את הגדרת התפקיד ממסך התפקידים בהמשך. האם להמשיך",
        "APP_CHARGE_ROLE_WARNING_TITLE": "שימו לב:",
        "APP_CHARGE_ROLE_WARNING_CONTENT1": "התכונות הבאות עלולות לגבות חיוב נוסף: ",
        "APP_CHARGE_ROLE_WARNING_CONTENT2": "למידע נוסף, בבקשה צור קשר עם נציג השירות שלך.",
        "APP_YES": "כן",
        "APP_NO": "לא",
        "APP_DEMO_ORGANIZATION_WARNING_TITLE": "שימו לב:",
        "APP_DEMO_ORGANIZATION_WARNING_CONTENT1": "ארגון זה יהיה מוגדר לצורכי הדגמה (Demo) לתקופה של {{days}} ימי ניסיון.",
        "APP_DEMO_ORGANIZATION_WARNING_CONTENT2": "בתום תקופת הניסיון, הארגון יעבור למתכונת שגרתית (Production) ותחויב בהתאם.",
        "APP_DEMO_ORGANIZATION_WARNING_CONTENT3": "לחץ לאישור להמשך או לביטול ליצירת/עדכון הארגון במתכונת שגרתית.",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS": ":סטטוס הצפנה נוכחי",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_NO_KEYS": "אין שימוש במפתחות הצפנה",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_DEFAULT_KEYS": "שימוש במפתחות הצפנה המוגדרים כברירת מחדל",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_RANDOM_KEYS": "שימוש במפתחות הצפנה שנוצרו באופן אקראי",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_UPLOAD_KEYS_FILE": "שימוש בפתחות הצפנה שהועלו על ידי קובץ",
        "APP_ENCRYPTION_KEYS_VERSION": "גרסת מפתחות הצפנה",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_TITLE": "אזהרה!",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT1": "(iOS יש לוודא שגרסת הלקוח העדכנית ביותר מותקנת (כרגע איננו תומכים ב",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT2": "במידה ותאשר את יצירת המפתחות, משתמשים עם גרסה ישנה לא יוכלו לתקשר עם השאר",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT3": "'אין להשתמש ביצירת המפתחות האקראיים במידה ולארגון זה יש 'ארגונים שותפים",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT4": "ליצירת המפתחות לחץ אישור, אחרת לחץ על ביטול",
        "APP_OUT_OF_MEMBER": "שגיאה: קיימת מגבלה למספר חברים בקבוצה",
        "LOGIN_INTRO_TITLE": "!ברוכים הבאים לאתר הניהול",
        "LOGIN_TITLE": "הכנס/י לחשבונך",
        "LOGIN_EMAIL": "שם משתמש",
        "LOGIN_PASSWORD": "סיסמה",
        "LOGIN_REMEMBER_ME": "שמור את פרטי המשתמש",
        "LOGIN_FORGOT_PASSWORD": "?שכחת את הסיסמה",
        "LOGIN_LOG_IN": "כניסה לשרות",
        "LOGIN_ERRORS_EMAIL_REQUIRED": "אנא הקלד כתובת אימייל",
        "LOGIN_ERRORS_EMAIL_MUST_VALID": "כתובת האימייל חייבת להיות חוקית",
        "LOGIN_ERRORS_PASSWORD_REQUIRED": "אנא הקלד סיסמה",
        "LOGIN_API_ERROR": "ההזדהות נכשלה. אחד או יותר מהפרטים שמסרת שגוי",
        "LOGIN_API_PERMISSION_ERROR": "ההזדהות נכשלה. לא נמסרו פרטי זיהוי",
        "LOGIN_API_TOKEN_ERROR": "פג תוקפו של החיבור לשירות. אנא התחבר/י שוב",
        "LOGIN_API_DB_ERROR": "ההזדהות נכשלה. ככל הנראה בשל בעיה במסד הנתונים. אנא צור קשר עם מפעיל השרות",
        "LOGIN_CONTACT_ADMIN": "!אינך זוכר את הסיסמה או את שם המשתמש? צור קשר עם ספק השרות",
        "LOGIN_API_ATTEMPTS_LEFT": "%s נסיונות נשארו",
        "LOGIN_PASSWORD_EXPIRED_DAYS": ".הסיסמה שלך תפוג בעוד {{days}} ימים, בבקשה החלף סיסמה בהקדם האפשרי",
        "LOGIN_PASSWORD_EXPIRED": "הסיסמה שלך פגה, בבקשה החלף סיסמה",
        "BACK_TO_LOGIN": "חזרה",
        "CHANGE_PASSWORD_TITLE": "שינוי סיסמה",
        "CHANGE_PASSWORD_CURRENT": "סיסמה נוכחית",
        "CHANGE_PASSWORD_NEW": "סיסמה חדשה",
        "CHANGE_PASSWORD_WRONG": "סיסמה שגויה",
        "CHANGE_PASSWORD_SAME": "הסיסמה החדשה חייבת להיות שונה מהסיסמה הנוכחית",
        "RECOVER_PASSWORD_SUCCESS": "נשלח אימייל למשתמש עם הנחיות לשחזור פרטי ההתחברות לשרות",
        "HOMEPAGE_HEADING": "אתר הניהול",
        "HOMEPAGE_TITLE": null,
        "HOMEPAGE_APPLICATION": "גירסת ממשק המשתמש",
        "HOMEPAGE_API_VERSION": "גירסת התשתית ומסד המונגו",
        "HOMEPAGE_DB_VERSION": "גירסת מסד הנתונים המרכזי",
        "HELP_HEADING": "עזרה בממשק המשתמש",
        "DASHBOARD_HEADING": "דשבורד",
        "STATISTICS_HEADING": "סטטיסטיקות PTT",
        "DUAL_RECORDER_HEADING": "סטטיסטיקת מקליט",
        "TOOLBAR_RESELLERS": "מפיצים",
        "TOOLBAR_ORGANIZATIONS": "ארגונים",
        "TOOLBAR_LOGOUT": "התנתקות",
        "TOOLBAR_SEARCHTEXT": "טלפון/אימייל/מזהה/IMSI",
        "NAVIGATION_ADMIN_RECORD": "בודקי הקלטות",
        "NAVIGATION_ORGANIZATION": "ארגון",
        "NAVIGATION_GROUPS": "קבוצות",
        "NAVIGATION_SUBSCRIBERS": "משתמשים",
        "NAVIGATION_CONTACTS": "קבוצות אנשי קשר",
        "NAVIGATION_CONTACTS_TEMPLATES": "תבניות אנשי קשר",
        "NAVIGATION_ORG_DETAILS": "פרטי הארגון",
        "NAVIGATION_RESELLER": "מפיץ",
        "NAVIGATION_ORG_MANAGER": "ניהול הארגונים",
        "NAVIGATION_RESELLER_DETAILS": "פרטי המפיץ",
        "NAVIGATION_RESELLER_MANAGER": "ניהול המפיצים",
        "NAVIGATION_PLATFORM": "מערכת",
        "NAVIGATION_DEVICES": "מכשירים",
        "NAVIGATION_DEV_MANUFACTURERS": "יצרני מכשירים",
        "NAVIGATION_LICENSES": "רשיונות",
        "NAVIGATION_SOFT_MANUFACTURERS": "יצרני יישומים",
        "NAVIGATION_PTT_CLIENT_STORE": "PTT חנות ליישומי",
        "NAVIGATION_PTT_DEVICES": "PTT מכשירי",
        "NAVIGATION_ITO_CONFIG": "תצורת המערכת",
        "NAVIGATION_LOCALIZATION": "שפות",
        "NAVIGATION_ADMINISTRATION": "מנהלים",
        "NAVIGATION_ROLES": "תפקידים",
        "NAVIGATION_JOB": "תהליכים",
        "NAVIGATION_BATCH": "פעולות אצווה",
        "NAVIGATION_ACTIVITY_LOG": "יומן פעילות",
        "ADMINISTRATOR": "מנהל",
        "ADMINISTRATORS": "מנהלי השרות",
        "ADMINISTRATION_TITLE": "מנהלי השרות",
        "ADMINISTRATION_DIALOG_TITLE": "פרטי המנהל",
        "ADMINISTRATION_EMAIL": "אימייל",
        "ADMINISTRATION_NAME": "שם משתמש",
        "ADMINISTRATION_FIRST_NAME": "שם פרטי",
        "ADMINISTRATION_LAST_NAME": "שם משפחה",
        "ADMINISTRATION_ROLE": "תפקיד",
        "ADMINISTRATION_ACTIONS": "הסר",
        "ADMINISTRATION_DELETE": "מחיקה",
        "ADMINISTRATION_SELECT_ROLE": "בחר תפקיד",
        "ADMINISTRATION_PASSWORD": "סיסמה",
        "ADMINISTRATION_RE_PASSWORD": "הקלד שוב את הסיסמה",
        "ADMINISTRATOR_NAME_UQ_ERROR": "כבר קיים משתמש בשם דומה!",
        "ADMINISTRATOR_EMAIL_UQ_ERROR": "משתמש עם אותו אימייל כבר קיים!",
        "ROLE": "תפקיד",
        "ROLES": "תפקידים",
        "ROLE_TITLE": "תפקידים",
        "ROLE_DIALOG_TITLE": "הרשאות התפקיד",
        "ROLE_SHOW": "הרשאות התפקיד",
        "ROLE_NAME": "שם התפקיד",
        "ROLE_RESOURCE_PATH": "הרשאות",
        "ROLE_GET": "צפיה",
        "ROLE_POST": "הוספה",
        "ROLE_PUT": "שינוי",
        "ROLE_DELETE": "מחיקה",
        "ROLE_BATCH": "פעולות אצווה",
        "ROLE_HIMPACT": "השפעה גבוהה",
        "ROLE_ACTIVE": "מאופשר",
        "ROLE_TABS_WEB": "הרשאות ניהול משתמשים",
        "ROLE_TABS_DISPATCHER": "הרשאות מוקדן",
        "ROLE_TABS_MOBILE": "PTT הרשאות יישום",
        "ROLE_API_ADD_NAME_UQ_ERROR": "לא ניתן להוסיף את התפקיד מפני שתפקיד בשם דומה כבר קיים",
        "ROLE_API_UPDATE_NAME_UQ_ERROR": "לא ניתן לעדכן את התפקיד מפני שתפקיד בשם דומה כבר קיים",
        "ROLE_API_DELETE_USED_ERROR": "לא ניתן למחוק את הפתקיד מפני שהוא נמצא בשימוש על ידי משתמש אחד או יותר",
        "ROLE_RESOURCE_PATH_MOBILE": "תצורה והרשאות",
        "ROLE_NAME_ROOT_ADMIN": "שם התפקיד שנבחר הינו שמור ולא ניתן להשתמש בו",
        "CONTACT": "אנשי קשר",
        "CONTACTS": "קבוצות אנשי קשר",
        "CONTACTS_TITLE": "קבוצות אנשי קשר",
        "CONTACTS_DIALOG_TITLE": "פרטי קבוצת אנשי קשר",
        "CONTACTS_TEMPLATE_NAME": "שם התבנית",
        "CONTACTS_LIST_NAME": "שם הקבוצה",
        "CONTACTS_CONTACT_LISTS": "החברים ברשימה",
        "CONTACTS_MEMBER_COUNT": "מספר החברים",
        "CONTACTS_CROSS_FLEET": "איש קשר משותף",
        "CONTACTS_NAME": "שם",
        "CONTACTS_MEMBERS": "פרטי החברים",
        "CONTACT_MEMBERS_NOTE": "הצג רק חברי רישיון Offnet",
        "CONTACTS_GENERAL": "כללי",
        "CONTACTS_MEMBER_DETAILS": "פרטי החבר",
        "SUBSCRIBER_LIST": "רשימת המשתמש",
        "SUBSCRIBER_LISTS": "רשימות המשתמש",
        "SUBSCRIBER_LISTS_TITLE": "רשימות המשתמש",
        "SUBSCRIBER_LIST_DIALOG_TITLE": "פרטי רשימות המשתמש",
        "SUBSCRIBER_LIST_NAME": "שם הרשימה",
        "SUBSCRIBER_LISTS_MEMBERS": "רשימת החברים",
        "SUBSCRIBER_LISTS_MEMBER_COUNT": "מספר החברים",
        "SUBSCRIBER_LISTS_NAME": "שם",
        "SUBSCRIBER_LISTS_MEMBERS_DETAILS": "פרטי החבר",
        "SUBSCRIBER_LISTS_GENERAL": "כללי",
        "SUBSCRIBER_LIST_MEMBER_DETAILS": "פרטי החבר",
        "PERSONAL_CONTACT": "איש קשר פרטי",
        "PERSONAL_CONTACTS": "אנשי קשר פרטיים",
        "PERSONAL_CONTACTS_TEMPLATES": "תבניות אנשי קשר",
        "SUBSCRIBER_LIST_NOTE": "ניתן להקצות רשימת אנשי קשר קשורה למשתמש ללא רישיון offnet, אך רק אנשי קשר בארגון משלו יוקצו למשתמש",
        "PERSONAL_CONTACTS_TEMPLATES_DETAILS": "פרטי תבנית אנשי קשר",
        "GROUP": "קבוצה",
        "GROUPS": "קבוצות",
        "GROUPS_TITLE": "קבוצות דבור",
        "GROUPS_DIALOG_TITLE": "פרטי קבוצת הדיבור",
        "GROUPS_SITE": "אתר",
        "GROUPS_NAME": "שם הקבוצה",
        "GROUPS_MEMBER_COUNT": "מספר החברים",
        "GROUPS_CROSS_FLEET": "קבוצה משותפת",
        "GROUPS_EXPIRATION_DATE": "תאריך תפוגה",
        "GROUPS_PHONE": "מספר טלפון",
        "GROUPS_ACTIONS": "הסר",
        "GROUPS_TYPE": "סוג הקבוצה",
        "GROUPS_GROUP_LISTS": "רשימות המשתמשים",
        "GROUPS_DELETE_WARNING": "לא ניתן למחוק את הקבוצה כל עוד יש בה חברים",
        "GROUPS_API_GET_LIMIT_ERROR": "לא ניתן לאחזר את מגבלת מספר חברי הקבוצה",
        "GROUPS_API_LIMIT_ERROR": "לא ניתן לעדכן את הקבוצה בגלל שהיא הגיעה למגבלת מספר החברים %s. נסה להגדיל את המגבלה או להקטין את מספר החברים בקבוצה",
        "GROUPS_API_ADD_SUBSCRIBER_ERROR": "לא ניתן להוסיף את המשתמש לקבוצה",
        "GROUPS_API_UPDATE_SUBSCRIBER_ERROR": "לא ניתן לעדכן את המנוי לקבוצה.",
        "GROUPS_API_REMOVE_SUBSCRIBER_ERROR": "לא ניתן להסיר את המשתמש מהקבוצה",
        "GROUPS_API_UPDATE_MUTED_SUBSCRIBER_ERROR": "לא ניתן לעדכן את מנוי המאזין בקבוצה.",
        "GROUPS_API_SET_DEFAULT_ERROR": "לא ניתן לקבוע את קבוצת ברירת המחדל",
        "GROUP_API_NAME_UQ_ERROR": "קבוצה בשם זה כבר קיימת",
        "SUBSCRIBER": "משתמש",
        "SUBSCRIBERS": "משתמשים",
        "SUBSCRIBERS_TITLE": "משתמשים",
        "SUBSCRIBERS_DIALOG_TITLE": "פרטי המשתמש",
        "SUBSCRIBERS_DIALOG_ADD_TITLE": "הוספת משתמש",
        "SUBSCRIBERS_ORGANIZATION": "בחר ארגון",
        "SUBSCRIBERS_SMS_DIALOG_TITLE": "שליחת SMS",
        "SUBSCRIBERS_GENERAL": "כללי",
        "SUBSCRIBERS_LICENSE": "רישוי",
        "SUBSCRIBERS_RUNTIME": "זמן ריצה",
        "SUBSCRIBERS_GROUP_DETAILS": "פרטי הקבוצה",
        "SUBSCRIBERS_GROUP_SUBSCRIBERS": "קבוצות דיבור",
        "SUBSCRIBERS_CONTACT_SUBSCRIBERS": "קבוצות קשר-ארגון",
        "SUBSCRIBERS_ACTIVITY_LOG": "יומן פעילות",
        "SUBSCRIBERS_ADD_SUBSCRIBERS": "הוסף משתמשים",
        "SUBSCRIBERS_LIST": "משתמשים",
        "SUBSCRIBERS_NAME": "שם משתמש",
        "SUBSCRIBERS_DISPLAY_NAME": "שם לתצוגה",
        "SUBSCRIBERS_USER_NAME": "שם משתמש/מספר טלפון",
        "SUBSCRIBERS_USER_NAME_SIP": "אימייל/SIP",
        "SUBSCRIBERS_DOMAIN": "שם המתחם",
        "SUBSCRIBERS_ACTIVE": "פעיל",
        "SUBSCRIBERS_PHONE_NUMBER": "מספר טלפון",
        "SUBSCRIBERS_CREATION_TIME": "זמן יצירה",
        "SUBSCRIBERS_CHANGE_STATE_TIME": "זמן שינוי הסטטוס",
        "SUBSCRIBERS_COUNTRY": "מדינה",
        "SUBSCRIBERS_ADDRESS": "כתובת",
        "SUBSCRIBERS_PASSWORD": "סיסמה",
        "SUBSCRIBERS_RE_PASSWORD": "הקלד שוב את הסיסמה",
        "SUBSCRIBERS_CLIENT_TYPE": "סוג היישום",
        "SUBSCRIBERS_HANDSET_TYPE": "סוג המכשיר",
        "SUBSCRIBERS_SITE": "אתר",
        "SUBSCRIBERS_EMAIL": "אימייל",
        "SUBSCRIBERS_SIP": "SIP",
        "SUBSCRIBERS_IMSI": "IMSI",
        "SUBSCRIBER_IMSI": "IMSI",
        "SUBSCRIBERS_IMSI2": "IMSI2",
        "SUBSCRIBERS_ROLE": "תפקיד",
        "SUBSCRIBERS_REVOKE_LICENSE_WARNING": "?האם אתה מאשר לבטל את הרישוי",
        "SUBSCRIBERS_DEFAULT_RADIO_GROUP": "קבוצת רדיו ברירת מחדל",
        "SUBSCRIBERS_DEFAULT_SOS_MSG": "קבוצה זו יכולה לשמש גם להתראות חירום",
        "SUBSCRIBERS_CURRENT_LICENSE": "הרישיון הנוכחי",
        "SUBSCRIBERS_LICENSE_NAME": "שם הרשיון",
        "SUBSCRIBERS_LICENSE_TYPE": "סוג",
        "SUBSCRIBERS_LICENSE_RENEWAL": "חידוש",
        "SUBSCRIBERS_LICENSE_EXPIRE": "תפוגה",
        "SUBSCRIBERS_LICENSE_QTY": "זמינים להקצאה",
        "SUBSCRIBERS_LICENSE_REVOKE": "שלילה",
        "SUBSCRIBERS_LICENSE_ASSIGN": "הקצאה",
        "SUBSCRIBERS_LICENSE_ASSIGN_NEW": "הקצאת רישיון חדש",
        "SUBSCRIBERS_NO_AVAILBLE_QTY": "לא נותרו רשיונות זמינים להקצאה",
        "SUBSCRIBERS_RUNTIME_LAST_REGISTRATION_TIME": "זמן ההתחברות האחרונה לשרות",
        "SUBSCRIBERS_RUNTIME_STATE": "זמינות",
        "SUBSCRIBERS_RUNTIME_APP_UPDATE": "עדכון מכשיר/יישום",
        "SUBSCRIBERS_RUNTIME_DEVICE_MODEL": "מודל המכשיר",
        "SUBSCRIBERS_RUNTIME_APP_VERSION": "PTT-גרסת יישום ה",
        "SUBSCRIBERS_RUNTIME_OS_VERSION": "גרסת מערכת ההפעלה",
        "SUBSCRIBERS_RUNTIME_MODEL_NAME": "Device model",
        "SUBSCRIBERS_RUNTIME_OS_TYPE": "OS Type",
        "SUBSCRIBERS_RUNTIME_BRAND": "Mobile client brand",
        "SUBSCRIBERS_RUNTIME_MANUFACTURE": "Manufacture",
        "SUBSCRIBERS_RUNTIME_MEMORY": "Device total memory",
        "SUBSCRIBERS_RUNTIME_FW_VERSION": "FW version",
        "SUBSCRIBERS_RUNTIME_BUILD": "App build type",
        "SUBSCRIBERS_RUNTIME_FCM": "FCM",
        "SUBSCRIBERS_VALIDATION_SPECIAL_CHARS_ERROR": "השם לתצוגה לא יכול להכיל תוים מיוחדים",
        "SUBSCRIBERS_VALIDATION_USERNAME_ORG_DOMAIN_ERROR": "שם המשתמש לא יכול להכיל את שם המתחם של הארגון",
        "SUBSCRIBERS_VALIDATION_AT_ERROR": "שם המשתמש לא יכול להכיל את סימן הכרוכית @",
        "SUBSCRIBERS_VALIDATION_DEFAULT_GROUP_ERROR": "אנא בחר קבוצת ברירת מחדל בלשונית הקבוצות",
        "SUBSCRIBERS_VALIDATION_CREATE_ROLE_ERROR": "אנא צור תפקידים עבור ארגון זה",
        "SUBSCRIBERS_VALIDATION_SELECT_ROLE_ERROR": "אנא בחר תפקיד",
        "SUBSCRIBERS_VALIDATION_SIP_ERROR": "SIP איננו תקין",
        "SUBSCRIBERS_VALIDATION_SIP_FORMAT_ERROR": "פורמט הSIP איננו תקין",
        "SUBSCRIBERS_VALIDATION_SIP_PHONE_ERROR": "SIP אין תאימות בין מספר הטלפון ומספר ה",
        "SUBSCRIBERS_VALIDATION_ORG_DOMAIN_ERROR": "שם מתחם הארגון בSIP  איננו תקין. התקין הוא:",
        "SUBSCRIBERS_VALIDATION_LICENSE_ASSIGNMENT_ERROR": "אנא קבע הרשאות למשתמש בלשונית הרישוי",
        "SUBSCRIBERS_VALIDATION_STRONG_DISPATCH_PASS": "שימו לב: נדרשת סיסמה חזקה למשתמש מסוג דיספצ'ר.",
        "SUBSCRIBERS_GROUPS_LIMIT_ERROR": "יותר מידי קבוצות, בבקשה צמצם בהתאם",
        "SUBSCRIBERS_PERSONAL_GROUPS_LIMIT_ERROR": "יותר מידי אנשי קשר, בבקשה צמצם בהתאם",
        "SUBSCRIBERS_OCL_LIMIT_ERROR": "יותר מידי רשימות קשר, בבקשה צמצם בהתאם",
        "SUBSCRIBERS_VALIDATION_ADD_ERROR": "לא ניתן להוסיף את המשתמש",
        "SUBSCRIBERS_VALIDATION_ONLY_NUMBERS_ERROR": "שדה זה יכול להכיל ספרות בלבד",
        "SUBSCRIBERS_API_VALIDATION_IMSI_FORMAT_ERROR": "פורמט שגוי - שדה זה חייב להכיל בין 14 ל20 ספרות",
        "SUBSCRIBERS_API_ADD_IDENTIFIERS_UQ_ERROR": "המזהה של המשתמש חייב להיות ייחודי",
        "SUBSCRIBERS_API_ADD_IDENTIFIERS_ERROR": "המשתמש התווסף אבל לא ניתן היה להוסיף את המזהה שלו",
        "SUBSCRIBERS_API_ADD_DUPLICATE_ID_ERROR": "לא ניתן להוסיף את המשתמש מפני שהמזהה שלו כבר קיים",
        "SUBSCRIBERS_API_UPDATE_DUPLICATE_ID_ERROR": "לא ניתן לעדכן את המשתמש מפני שהמזהה שלו כבר קיים",
        "SUBSCRIBERS_API_UPDATE_DUPLICATE_IMSI_ERROR": "לא ניתן לעדכן את המשתמש מפני שIMSI זה כבר קיים",
        "SUBSCRIBERS_API_ADD_NO_GROUP_ERROR": "לא ניתן להוסיף את המשתמש מפני שאף קבוצה מוגדרת בארגון",
        "SUBSCRIBERS_API_ADD_GROUP_EXCEPTION_ERROR": "המשתמש לא התווסף מפני שלא ניתן לאחזר את שמות הקבוצות בארגון",
        "SUBSCRIBERS_API_GROUPS_ERROR": "לא ניתן לאחזר את שמות הקבוצות שהמשתמש חבר בהן",
        "SUBSCRIBERS_API_CONTACTS_ERROR": "לא ניתןן לאחזר את שמות אנשי הקשר של המשתמש",
        "SUBSCRIBERS_API_PHONE_UQ_ERROR": "לא ניתן להוסיף את המשתמש מפני שמספר הטלפון שלו איננו ייחודי במערכת",
        "SUBSCRIBERS_API_NAME_UQ_ERROR": "משתמש בשם זה כבר קיים במערכת",
        "SUBSCRIBERS_API_NAME_SPACE_ERROR": "השם לתצוגה או ה-SIP לא יכול להכיל תוים מיוחדים",
        "SUBSCRIBERS_API_PASSWORD_SPACE_ERROR": "הסיסמה לא יכולה להכיל רווחים",
        "SUBSCRIBERS_API_ADD_NO_LICENSE": "לא ניתן להוסיף משתמש ללא רישוי",
        "SUBSCRIBERS_API_UPDATE_NO_LICENSE": "לא ניתן לעדכן משתמש ללא רישוי",
        "SUBSCRIBERS_API_PHONE_ZERO_ERROR": "לא ניתן להוסיף את המשתמש מפני שמספר הטלפון לא יכול להתחיל בספרה 0",
        "SUBSCRIBERS_API_ADD_NOT_ENOUGH_LICENSES": "לא ניתן להוסיף את המשתמש(ים) מפני שכל הרישיונות בשימוש",
        "SUBSCRIBERS_API_NUMBER_USERS_EXCEEDS_LICENSE_QTY": "לא ניתן להוסיף משתמשים מעבר למגבלה שצוינה ברישיון השרת",
        "SUBSCRIBERS_API_PASSWORD_LENGTH_ERROR": "לא ניתן ליצור את המנוי מכיוון שהסיסמה צריכה להיות קצרה מ- 18 תווים",
        "SUBSCRIBERS_TIME_STAMP": "GMT חותמת זמן",
        "SUBSCRIBERS_ADMINISTRATOR": "מבצע",
        "SUBSCRIBERS_DESCRIPTION": "תאור",
        "SUBSCRIBERS_GET_ACTIVITY": "אחזר פעילויות",
        "SUBSCRIBERS_SERIAL_NUMBER": "מספר סידורי",
        "SUBSCRIBER_BULK_PHONE_15_DIGIT_ERROR": "מספר הטלפון איננו יכול להיות ארוך מחמש עשרה ספרות",
        "SUBSCRIBER_BULK_INVALID_PHONE_ERROR": "מספר טלפון לא חוקי",
        "ORGANIZATION": "ארגון",
        "ORGANIZATIONS": "ארגונים",
        "ORGANIZATION_TITLE": "ארגונים",
        "ORGANIZATION_DETAILS": "פרטי הארגון",
        "ORGANIZATION_CONTEXT_WARNING": "בחר ארגון כדי להמשיך",
        "ORGANIZATION_CRMID": "CRMID",
        "ORGANIZATION_NAME": "שם הארגון",
        "ORGANIZATION_DOMAIN": "שם המתחם",
        "ORGANIZATION_SITE": "אתר",
        "ORGANIZATION_ADDRESS": "כתובת",
        "ORGANIZATION_MANAGER": "ניהול הארגון",
        "ORGANIZATION_AUDIO_RECORDER": "הקלט את כל השיחות בארגון",
        "ORGANIZATION_GENERAL": "כללי",
        "ORGANIZATION_CONTACT": "פרטי איש הקשר",
        "ORGANIZATION_SECURITY_AND_DOWNLOAD": "הצפנה וניהול גרסאות",
        "ORGANIZATION_LICENSE": "רישוי",
        "ORGANIZATION_LICENSE_ADD": "הוסף רישיון",
        "ORGANIZATION_INSERT": "הכנס",
        "ORGANIZATION_SUPPORT_FIRST_NAME": "תמיכה - שם פרטי",
        "ORGANIZATION_SUPPORT_LAST_NAME": "תמיכה - שם משפחה",
        "ORGANIZATION_SUPPORT_EMAIL": "תמיכה - אימייל",
        "ORGANIZATION_SUPPORT_PHONE": "תמיכה - מספר טלפון",
        "ORGANIZATION_DEMO": "תקופת ניסיון",
        "ORGANIZATION_CREATION_TIME": "זמן יצירה",
        "ORGANIZATION_DEMO_EXPIRATION": "תום תקופת ניסיון",
        "ORGANIZATION_API_GET_CONTACTS_ERROR": "לא ניתן לאחזר את פרטי איש הקשר של הארגון",
        "ORGANIZATION_API_ADD_CONTACTS_ERROR": "הארגון נוצר אבל לא ניתן היה להוסיף את פרטי איש הקשר שלו",
        "ORGANIZATION_API_ADD_NAME_UQ_ERROR": "לא ניתן להוסיף את הארגון. השם חייב להיות יחודי",
        "ORGANIZATION_API_ADD_CRM_ID_UQ_ERROR": "לא ניתן להוסיף את הארגון. ה-CRMID חייב להיות ייחודי",
        "ORGANIZATION_API_UPDATE_NAME_UQ_ERROR": "לא ניתן לעדכן את הארגון. השם חייב להיות ייחודי",
        "ORGANIZATION_API_UPDATE_CRM_ID_UQ_ERROR": "לא ניתן לעדכן את הארגון. ה-CRMID חייב להיות ייחודי",
        "ORGANIZATION_API_UPDATE_CONTACTS_ERROR": "העדכון בוצע אך לא ניתן לעדכן את שם איש הקשר של הארגון",
        "ORGANIZATION_API_UPDATE_SITE_ERROR": "העדכון בוצע אך לא ניתן לעדכן את שם האתר של הארגון",
        "ORGANIZATION_API_UPDATE_GROUPS_SITE_ERROR": "העדכון בוצע אך לא ניתן לעדכן את שמות האתרים של הקבוצות בארגון",
        "ORGANIZATION_API_UPDATE_SUBSCRIBER_SITE_ERROR": "העדכון בוצע אך לא ניתן לעדכן את שמות האתרים של המשתמשים השייכים למפיץ",
        "ORGANIZATION_API_UPDATE_CHILDREN_SITE_ERROR": "העדכון בוצע אך לא ניתן לעדכן את שמות האתרים של הקבוצות אליהן שייכים המשתמשים של המפיץ",
        "ORGANIZATION_API_DELETE_CHILD_ERROR": "לא ניתן למחוק את הארגון מפני שקיימת רשומה המשתייכת אליו",
        "ORGANIZATION_CALL_LOG": "שמור יומן שיחות",
        "ORGANIZATION_FORCE_STRONG_DISPATCH_PASS": "אלץ סיסמה חזקה למשתמשים מסוג דיספצ'ר",
        "RECORDING_FORCE_STRONG_RECORDING_REVIEWERS_PASS": "'אלץ סיסמה חזקה עבור 'בודקי הקלטות",
        "RESELLER": "מפיץ",
        "RESELLERS": "מפיצים",
        "RESELLER_TITLE": "ניהול המפיץ",
        "RESELLER_DETAILS": "פרטי המפיץ",
        "RESELLER_ADDRESS": "כתובת",
        "RESELLER_ADDRESS_NAME": "שם הכתובת",
        "RESELLER_CRMID": "CRM ID",
        "RESELLER_NAME": "שם המפיץ",
        "RESELLER_CONTACT_DETAILS": "איש הקשר",
        "RESELLER_ADMINISTRATOR_DOMAIN": "שם המתחם של המנהל",
        "RESELLER_WEBSERVICE_URL": "לינק לאתר השרות",
        "RESELLER_LICENSE": "רישוי",
        "RESELLER_LICENSE_ALLOCATION": "הוסף רישיון",
        "RESELLER_LICENSE_BUNDLE_GENERATION": "יצירת חבילת רישוי",
        "RESELLER_AGGREGATE_END_USER": "הצטברות משתמשי קצה",
        "RESELLER_AEU_EMAIL": "אימייל למשלוח חשבונות",
        "RESELLER_PORTAL_URL": "כתובת הדומיין",
        "RESELLER_SITE": "אתר",
        "RESELLER_LICENSE_NAME": "שם הרישיון",
        "RESELLER_ADMIN_FIRST_NAME": "מנהל - שם פרטי",
        "RESELLER_ADMIN_LAST_NAME": "מנהל - שם משפחה",
        "RESELLER_ADMIN_EMAIL": "מנהל - כתובת אימייל",
        "RESELLER_ADMIN_PHONE": "מנהל - מספר טלפון",
        "RESELLER_SUPPORT_FIRST_NAME": "תמיכה - שם פרטי",
        "RESELLER_SUPPORT_LAST_NAME": "תמיכה - שם משפחה",
        "RESELLER_SUPPORT_EMAIL": "תמיכה - כתובת אימייל",
        "RESELLER_SUPPORT_PHONE": "תמיכה - מספר טלפון",
        "RESELLER_CONTEXT_WARNING": "בחר מפיץ כדי להמשיך",
        "RESELLER_API_GET_SITE_ERROR": "לא ניתן לאחזר את שם האתר של המפיץ",
        "RESELLER_API_GET_CONTACTS_ERROR": "לא ניתן לאחזר את פרטי אנשי הקשר של המפיץ",
        "RESELLER_API_ADD_SITE_ERROR": "המפיץ התווסף אך לא ניתן להגדיר את האתר שלו",
        "RESELLER_API_ADD_CONTACTS_ERROR": "המפיץ התווסף אך לא ניתן להגדיר את שמות אנשי הקשר שלו",
        "RESELLER_API_ADD_NAME_UQ_ERROR": "לא ניתן להוסיף את המפיץ מפני ששמו חייב להיות ייחודי",
        "RESELLER_API_ADD_CRM_ID_UQ_ERROR": "לא ניתן להוסיף את המפיץ מפני שה-CRMID שלו חייב להיות ייחודי",
        "RESELLER_API_ADD_PORTAL_URL_UQ_ERROR": "לא ניתן להוסיף את המפיץ. כתובת הדומיין צריכה להיות ייחודית",
        "RESELLER_API_ADD_WEBSERVICE_URL_UQ_ERROR": "לא ניתן להוסיף את המפיץ מפני שלינק לאתר השרות שלו חייב להיות ייחודי",
        "RESELLER_API_UPDATE_SITE_ERROR": "העדכון הצליח אך לא ניתן לעדכן את האתר של המפיץ",
        "RESELLER_API_UPDATE_CONTACTS_ERROR": "העדכון הצליח אך לא ניתן לעדכן את אנשי הקשר של המפיץ",
        "RESELLER_API_UPDATE_NAME_UQ_ERROR": "לאל ניתן לעדכן את המפיץ מפני ששמו חייב להיות ייחודי",
        "RESELLER_API_UPDATE_CRM_ID_UQ_ERROR": "לא ניתן לעדכן את המפיץ מפני שה-CRMID שלו חייב להיות ייחודי",
        "RESELLER_API_UPDATE_PORTAL_URL_UQ_ERROR": "לא ניתן לעדכן את המשווק. כתובת הדומיין צריכה להיות ייחודית",
        "RESELLER_API_UPDATE_WEBSERVICE_URL_UQ_ERROR": "לא ניתן לעדכן את המפיץ מפני שהלינק לאתר השרות שלו חייב להיות ייחודי",
        "RESELLER_API_DELETE_SITE_ERROR": "לא ניתן למחוק את הרשומה של אתר המפיץ",
        "CONFIG": "פרמטר תצורה",
        "CONFIGS": "פרמטרי תצורה",
        "CONFIG_ADD_PARAM": "הוסף פרמטר",
        "CONFIG_SET_PARAM": "קבע ערך לפרמטר",
        "CONFIG_WARNING": "זהירות. ערך לא תקין עלול לפגוע בביצועי השרות",
        "CONFIG_DEFAULT": "פרמטר ברירת מחדל",
        "CONFIG_VALUE_TYPE": "סוג הערך",
        "CONFIG_NAME": "שם הפרמטר",
        "CONFIG_VALUE": "ערך",
        "CONFIG_ACTIONS": "פעולות",
        "CONFIG_ADD_CONFIG": "הוספת תצורה",
        "CONFIG_SERVER_ID": "מזהה השרת",
        "CONFIG_SITE": "אתר",
        "CONFIG_SERVER": "שרת",
        "CONFIG_SYSTEM": "מערכת",
        "SITE": "אתר",
        "SITES": "אתרים",
        "SITE_TITLE": "אתרים",
        "SITE_DIALOG_TITLE": "פרטי האתר",
        "SITE_NAME": "שם",
        "SITE_HOST": "שרת",
        "SITE_PUBLIC_IP": "כתובת חיצונית",
        "SITE_TYPE": "סוג",
        "SITE_CONTROL_PORT": "מוצא בקרה",
        "SITE_AUDIO_PORT": "מוצא קול",
        "SITE_STATE": "מצב פעולה",
        "SITE_SERVER_1": "שרת ראשון",
        "SITE_SERVER_2": "שרת שני",
        "SITE_ACTIVE_SERVER": "שרת אקטיבי",
        "SITE_SWITCH_COMMAND": "פקודת החלפה",
        "SITE_API_ADD_IP_USED_ERROR": "לא ניתן להוסיף את האתר מפני שכתובת ה-IP שלו בשימוש על ידי שרת אחר שלא שייך לשרות",
        "SITE_API_UPDATE_IP_USED_ERROR": "לא ניתן לעדכן את האתר מפני שכתובת ה-IP שלו בשימוש על ידי שרת אתר שלא שייך לשרות",
        "SITE_API_DELETE_GROUP_ERROR": "לא ניתן למחוק את האתר מפני שהוא בשימוש על ידי קבוצה אחת או יותר",
        "SERVER": "שרת",
        "SERVERS": "שרתים",
        "SERVER_TITLE": "שרתים",
        "ITO_CONFIG": "ITO-תצורת ה",
        "SERVER_NAME": "שם",
        "SERVER_HOST": "כתובת IP",
        "SERVER_TYPE": "סוג",
        "SERVER_STATE": "מצב פעולה",
        "SERVER_ADMIN_STATE": "מצב ניהולי",
        "SERVER_API_ADD_IP_ERROR": "לא ניתן להוסיף את השרת מפני שכתובת ה-IP שלו בשימוש על ידי שרת אחר מאותו סוג",
        "SERVER_API_UPDATE_IP_ERROR": "לא ניתן לעדכן את השרת מפני שכתובת ה-IP שלו בשימוש על ידי שרת אחר מאותו סוג",
        "SERVER_API_DELETE_SITE_ERROR": "לא ניתן למחוק את השרת מפני שהוא בשימוש על ידי אחד האתרים",
        "DEVICE": "מכשיר",
        "DEVICES": "מכשירים",
        "DEVICE_TITLE": "מכשירים",
        "DEVICE_DETAILS": "פרטי המכשיר",
        "DEVICE_MODEL": "מודל המכשיר",
        "DEVICE_CAT_NAME": "קטגוריות",
        "DEVICE_TYPE": "סוג המכשיר",
        "DEVICE_ACTIONS": "פעולות",
        "DEVICE_ADD": "הוספת מכשיר",
        "DEVICE_MANUFACTURER": "בחר יצרן",
        "DEVICE_NAME": "שם המכשיר",
        "DEVICE_API_NAME_UQ_ERROR": "מכשיר בשם זה כבר קיים",
        "PTT_DEVICE": "PTT מכשיר",
        "PTT_DEVICES": "PTT מכשירי",
        "PTT_DEVICE_DETAILS": "PTT-פרטי מכשיר ה",
        "PTT_DEVICE_TITLE": "PTT מכשירי",
        "PTT_DEVICE_MODEL": "מודל המכשיר",
        "PTT_DEVICE_CAT_NAME": "קטגוריית המכשיר",
        "PTT_DEVICE_TYPE": "סוג המכשיר",
        "PTT_DEVICE_NAME": "שם המכשיר",
        "PTT_DEVICE_API_NAME_UQ_ERROR": "כבר קיים מכשיר בשם זה בחנות זו",
        "MANUFACTURER": "יצרן המכשיר",
        "MANUFACTURERS": "יצרני מכשירים",
        "MANUFACTURER_TITLE": "יצרני המכשירים",
        "MANUFACTURER_DETAILS": "פרטי יצרן המכשיר",
        "MANUFACTURER_API_DELETE_CHILD_RECORD_ERROR": "לא ניתן למחוק את היצרן מפני שקיימת רשומה המשתייכת אליו",
        "SOFTWARE_MANUFACTURER": "יצרן תוכנה",
        "SOFTWARE_MANUFACTURERS": "יצרני תוכנה",
        "SOFTWARE_MANUFACTURERS_TITLE": "יצרני תוכנה",
        "SOFTWARE_MANUFACTURERS_DETAILS": "פרטי יצרן התוכנה",
        "LICENSE_BUNDLE": "חבילה",
        "LICENSE_BUNDLES": "חבילות רישוי",
        "LICENSE_ALLOCATION": "הקצבת רישיון",
        "LICENSE_ALLOCATIONS": "הקצבות של רישיונות",
        "LICENSE_ASSIGNMENT": "הקצאת רישיון",
        "LICENSE_ASSIGNMENTS": "הקצאות של רישיונות",
        "LICENSE_TITLE": "רישיונות",
        "LICENSE_DETAILS": "פרטי רישיון",
        "LICENSE_NAME": "שם הרישיון",
        "LICENSE_DESCRIPTION": "תאור הרישיון",
        "LICENSE_PERMISSIONS": "הרשאות",
        "LICENSE_TYPE": "סוג הרישיון",
        "LICENSE_ALLOCATION_DATE": "תאריך ההקצבה",
        "LICENSE_EXPIRATION_TYPE": "סוג התפוגה",
        "LICENSE_EXPIRATION_DATE": "תאריך תפוגה",
        "LICENSE_AVAILABLE_QTY": "זמין להקצאה",
        "LICENSE_QUANTITY": "כמות",
        "LICENSE_ALLOCATE": "הקצאה",
        "LICENSE_TEMPLATES": "תבניות רישוי",
        "CONVERT_TO_LICENSE": "הצג תבנית רישוי",
        "LICENSE_MASK": "קוד רישוי",
        "CONVERT_TO_MASK": "הצג קוד רישוי",
        "LICENSE_CODE": "קוד הרישוי",
        "APP_CONVERT": "יצירת קוד רישוי",
        "UNDO_LICENSE": "ביטול הפעולה",
        "LICENSE_REVOKE": "שלול",
        "LICENSE_API_ALLOCATION_GET_PARENT_LIST_ERROR": "לא ניתן לאחזר הקצאות רישוי מהרמה שמעל",
        "LICENSE_API_ASSIGNMENT_REVOKE_ERROR": "לא ניתן לשלול הקצאות הרישוי",
        "ILLEGAL_LICENSE": "כל השדות חייבים להיות מסוג בוליאני",
        "LICENSE_TOAST_ALLOCATION_SUCCESS": "הוקצב בהצלחה",
        "LICENSE_ALLOCATION_QTY_ERROR": "כמות הרישיונות איננה מספקת",
        "LICENSE_ALLOCATION_ORG_ACTIVE_ERROR": "אין הקצאות רישוי אקטיביות בארגון",
        "LICENSE_MAX_ORDINARY_SUBSCRIBERS": "כמות מקסימלית של משתמשים רגילים",
        "LICENSE_MAX_DISPATCH_CONSOLE_SUBSCRIBERS": "כמות מקסימלית של מוקדנים",
        "LICENSE_MAX_SUBSCRIBERS": "כמות מקסימלית של כלל המשתמשים",
        "LICENSE_IN_USE": "בשימוש",
        "LICENSE_EXPIRATION_DATE_SERVER": "תאריך תפוגת רישיון השרת",
        "RESELLER_QTY": "PTT רישיונות",
        "RESELLER_DISPATCHER_QTY": "רישיונות מוקדן",
        "ORGANIZATION_QTY": "PTT רישיונות",
        "ORGANIZATION_DISPATCHER_QTY": "רישיונות מוקדן",
        "LICENSE_DISPATCHER_ALLOCATE": "הקצה",
        "LICENSE_ALLOCATE_BUTTON": "בצע",
        "PARENT_RESELLER_QTY": "PTT רמת על: רישיונות",
        "PARENT_RESELLER_DISPATCHER_QTY": "רישיונות מוקדן",
        "LICENSE_QTY_TOOLTIP": "כמות רישיונות בשימוש מתוך הכמות שהוקצתה",
        "CLIENT_VERSION": "גירסת יישום",
        "CLIENT_VERSIONS": "גירסאות יישום",
        "CLIENT_VERSION_TITLE": "גירסת היישום",
        "CLIENT_VERSION_DIALOG_TITLE": "פרטי גירסת היישום",
        "CLIENT_VERSION_STORE_NAME": "שם חנות היישומים",
        "CLIENT_VERSION_VERSION": "גירסה",
        "CLIENT_VERSION_SELECT_STORE": "בחר חנות יישומים",
        "CLIENT_VERSION_PATH": "נתיב לקובץ מקומי",
        "CLIENT_VERSION_DESCRIPTION": "תאור",
        "STORE": "PTT חנות ליישומי",
        "STORES": "PTT חנויות ליישומי",
        "STORE_TITLE": "PTT חנות ליישומי",
        "STORE_DETAILS_TILE": "פרטי החנות",
        "STORE_MODEL": "מודל המכשיר",
        "STORE_CAT_NAME": "שם הקטגוריה",
        "STORE_TYPE": "סוג המכשיר",
        "STORE_ACTIONS": "פעולות",
        "STORE_ADD_DEVICE": "הוסף מכשיר",
        "STORE_DEVICE": "בחר מכשיר",
        "STORE_CLIENT_STORE": "חנות יישומים",
        "STORE_MANUFACTURER": "בחר יצרן",
        "STORE_DEVICE_NAME": "שם המכשיר",
        "STORE_LICENSABLE_TYPE": "סוג הרישוי",
        "STORE_DESCRIPTION": "תאור",
        "STORE_MANUFACTURER_NAME": "שם יצרן",
        "STORE_CLIENT_VERSION": "גרסת היישום",
        "STORE_API_NAME_UQ_ERROR": "כבר קיימת חנות בשם זה עבור היצרן הזה",
        "LOCALIZATION_TITLE": "שפות",
        "LOCALIZATION_DETAILS": "פרטים",
        "LOCALIZATION_FLAG": "דגל",
        "LOCALIZATION_ACTIVE": "מאופשר",
        "LOCALIZATION_DEFAULT": "ברירת מחדל",
        "LOCALIZATION_NAME": "שם השפה",
        "LOCALIZATION_TRANSLATION": "מפתח תרגום",
        "LOCALIZATION_CODE": "קוד התרגום",
        "LOCALIZATION_IMPORT": "יבוא של טבלת התרגום",
        "LOCALIZATION_EXPORT": "יצוא של טבלת התרגום",
        "LOCALIZATION_REMOVE_DEFAULT_ERROR": "לא ניתן למחוק את שפת ברירת המחדל. בחר שפה אחרת כברירת מחדל ונסה שוב",
        "LOCALIZATION_ADD_DUPLICATE_ERROR": "שגיאה: תרגום עם מפתח זהה כבר קיים",
        "JOB_TITLE": "תהליכים",
        "JOB_RUN_INTEGRITY": "הרץ בדיקת התאמת תכנים של מסדי הנתונים",
        "JOB_RUN_EXPIRATION": "הרץ תהליך בדיקת תפוגת רישיונות",
        "JOB_PROVISIONING": "ניהול משתמשים",
        "JOB_GPS": "GPS ארכיב מיקומים",
        "JOB_MONGO_HA": "מסד נתונים מונגו - זמינות גבוהה",
        "JOB_INIT_LOG": "אתחל את הלוג",
        "JOB_RUN_LOG": "הרץ את הלוג",
        "JOB_PROV_LICENSE_LOG": "תהליך קביעת תפוגת רישיונות",
        "JOB_PROV_DB_INIT_LOG": "תהליך אתחול מסד הנתונים",
        "JOB_PROV_DB_INTEGRITY_LOG": "לוג של התאמת מסדי הנתונים",
        "BULK_TITLE": "דוחות ופעולות אצווה",
        "BULK_OPERATIONS": "דוחות ופעולות אצווה",
        "BULK_INTERACTIVE_DELETE": "מחיקה",
        "DELETE_INTERACTIVE_SUBSCRIBERS": "משתמשים",
        "DELETE_INTERACTIVE_GROUPS": "קבוצות",
        "DELETE_INTERACTIVE_OCL": "רשימות קשר",
        "DELETE_INTERACTIVE_EMERGENCY_GROUP": "קבוצות חירום",
        "DELETE_INTERACTIVE_CONTACT_TEMPLATE": "תבניות אנשי קשר",
        "DELETE_INTERACTIVE_TYPE": "סוג המחיקה",
        "DELETE_GROUPS": "קבוצות",
        "DELETE_SUBSCRIBERS": "משתמשים",
        "DELETE_OCL": "רשימות קשר",
        "DELETE_EMERGENCY_GROUP": "קבוצות חירום",
        "DELETE_CONTACT_TEMPLATE": "תבניות אנשי קשר",
        "BULK_DELETE_COUNT": "מונה מחיקות",
        "BULK_INTERACTIVE_LICENSE": "רישוי",
        "BULK_INTERACTIVE_ROLE": "תפקידים",
        "BULK_SUBSCRIBERS_COUNT": "מספר המשתמשים",
        "DOWNLOAD_SAMPLE_FILE": "הורד קובץ לדוגמה",
        "BULK_RESULT_LOG": "תוצאת ההרצה",
        "BULK_IMPORT_NOTE": "בעת ייבוא מנויים, הקבוצה המסונפת תחול על מנויים בעלי רישיונות מחוץ לרשת.",
        "AFFILLIATED_ORG_SUB_NOT_ADDED_MESSAGE": "מנויים של ארגון קשור לא נוספו.",
        "GROUP_LIMIT_SIZE": "חריגה מהאורך המירבי של שם הקבוצה",
        "SUBSCRIBERS_API_NAME_LIMIT_SIZE": "חריגה מהאורך המירבי של שם המשתמש",
        "BULK_EXPORT": "יצוא משתמשים",
        "BULK_IMPORT": "יבוא משתמשים",
        "BULK_EXPORT_REPORT": "דוחות",
        "BULK_EXPORT_CALL_LOG": "דוח יומן שיחות",
        "BULK_EXPORT_RUNTIME": "דוח סטטוס משתמשים",
        "BULK_ENABLE_ALL": "בטל השעיה לכל המשתמשים",
        "BULK_SUSPEND_ALL": "השעה את כל המשתמשים",
        "BULK_DELETE_ALL": "מחק את כל המשתמשים",
        "BULK_DELETE_APPLY": "בצע מחיקה",
        "BULK_SELECT_ALLOCATION": "הקצה רישוי",
        "BULK_SELECT_ROLE": "בחר תפקיד",
        "BULK_SELECT_LICENSE": "בחר רישוי",
        "BULK_ALLOCATION_APPLY": "יישם את ההקצאה",
        "BULK_IMPORT_FILE_FORMAT_MESSAGE": "XLSX או CSV אנא טען אך ורק קובץ בפורמט",
        "BULK_INTERACTIVE_SMS": "SMS הגדרות בעזרת",
        "BULK_INTERACTIVE_CHANGE_PASSWORD": "החלפת סיסמה",
        "BULK_CHANGE_PASSWORD_APPLY": "בצע החלפת הסיסמה",
        "APP_CHANGE_PASSWORD_INTERACTIVE_WARNING_TITLE": "האם לקבוע את הסיסמה החדשה לכל המשתמשים שנבחרו?",
        "SUBSCRIBERS_NEW_PASSWORD": "סיסמה חדשה",
        "INVALID_BULK_FILE_FORMAT": "הפורמט של קובץ הקלט איננו תקין",
        "BULK_INTERACTIVE_EMERGENCY_GROUP": "קבוצות חרום",
        "BULK_SELECT_EMERGENCY_GROUP": "בחר קבוצת חרום",
        "APP_EMERGENCY_GROUP_INTERACTIVE_WARNING_TITLE": "האם להקצות קבוצת חרום זו למשתמשים אלו?",
        "BULK_INTERACTIVE_CONTACT_TEMPLATE": "תבניות אנשי קשר",
        "BULK_CONTACT_TEMPLATE_SUBSCRIBERS": "תבנית למנוי",
        "BULK_CONTACT_TEMPLATE_TEMPLATES": "תבנית לתבנית",
        "CONTACT_TEMPLATE_TYPE": "סוג",
        "BULK_SELECT_CONTACT_TEMPLATE": "בחר תבנית אנשי קשר",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_ADD_WARNING_TITLE": "האם להקצות תבנית אנשי קשר זו למשתמשים אלו?",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_ADD_WARNING_GROUP_TITLE": "האם ברצונך להקצות את תבניות אנשי הקשר הללו למשתמשי הקבוצה שנבחרה?",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_REMOVE_WARNING_TITLE": "האם להסיר תבנית אנשי קשר זו ממשתמשים אלו?",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_REMOVE_WARNING_GROUP_TITLE": "האם ברצונך להסיר את תבנית אנשי הקשר הזו ממשתמשי הקבוצה שנבחרה?",
        "BULK_CONTACT_TEMPLATE_ADD": "הוספת משתמשי תבנית אנשי הקשר",
        "BULK_CONTACT_TEMPLATE_REMOVE": "הסרת משתמשי תבנית אנשי הקשר",
        "RESELLER_SMS_CONFIGURATION": "SMS-פרטי ההתחברות לספק שרות ה",
        "SMS_API_KEY": "מפתח הממשק - API Key",
        "SMS_API_SECRET": "סוד הממשק - API Secret",
        "SMS_IP": "כתובת IP של שרת הSMSC",
        "SMS_PORT": "פורט שרת הSMSC",
        "SMS_SEND_CREDENTIAL": "נתוני התחברות",
        "SMS_SEND_CREDENTIALS_WITH_SERVER": "נתוני התחברות וכתובת שרת",
        "SMS_SEND_MESSAGE": "הודעה מותאמת אישית",
        "SMS_SEND_CREDENTIALS_AND_DOWNLOAD_LINK": "קישור להורדה ופרטי התחברות",
        "SMS_SEND_DOWNLOAD_LINK": "קישור להורדה",
        "SMS_DOWNLOAD_LINK": "הקלד את הקישור להורדת היישום",
        "SMS_MESSAGE": "הקלד הודעה מותאמת אישית",
        "SMS_MISSING_KEYS": "פרטי ההתחברות לספק שרות ההודעות לא הוגדרו על ידי המפיץ",
        "SMS_API_VALIDATION_PHONE_ERROR": "שגיאת ממשק הודעות: לא סופק מספר טלפון",
        "SMS_API_VALIDATION_CREDENTIALS_ERROR": "שגיאת ממשק הודעות: לא סופקו נתוני התחברות לשרות",
        "USER_VALIDATION_EMAIL_FORMAT_ERROR": "פורמט כתובת האימייל לא מתאים",
        "USER_ID": "מזהה המשתמש",
        "TEXT_SEARCHBTN": "חיפוש",
        "SEARCH_RESULT": "תוצאת החיפוש",
        "START_DATE": "תאריך התחלה",
        "END_DATE": "תאריך סיום",
        "ENTER_DATE": "בחר תאריך",
        "ADMIN_RECORD_TITLE": "בודקי הקלטות",
        "ADMIN_RECORD_EMAIL_ID": "מזהה אימייל",
        "ADMIN_RECORD_LAST_LOGIN_TIME": "זמן כניסה אחרונה",
        "ADMIN_RECORD_LAST_ACTIVITY_TIME": "זמן פעולה אחרונה",
        "USER_LAST_PASSWORD_CHANGE_TIME": "זמן שינוי סיסמה",
        "ADMIN_RECORD_DIALOG_TITLE": "פרטי בודק הקלטות",
        "ADMIN_RECORD_DETAILS": "פרטי הבודק",
        "ADMIN_RECORD_ACTIVITY": "פרטי הפעילות",
        "ADMIN_RECORD_ACTIVITY_COMMAND": "פעולה",
        "ADMIN_RECORD_ACTIVITY_SESSION_NAME": "שם השיחה",
        "ADMIN_RECORD_ACTIVITY_USER_NAME": "שם המוקלט",
        "ADMIN_RECORD_ACTIVITY_TIME": "זמן הפעולה",
        "ADMIN_RECORD_ACTIVITY_IP": "כתובת הבודק",
        "AUDIO_BACKUP_PATH_TITLE": "ניהול האחסון",
        "AUDIO_BACKUP_FOLDER_DATE": "חודש ושנה",
        "AUDIO_BACKUP_PATH": "נתיב",
        "AUDIO_BACKUP_PATH_DIALOG_TITLE": "ניהול האחסון",
        "FOLDER_DATE": "חודש ושנה",
        "BRANDING_TITLE": "מיתוג",
        "BRANDING_TITLE_IMAGE": "מיתוג תמונה",
        "BRANDING_NAME": "שם היישום",
        "COLOR1": "צבע 1",
        "COLOR2": "צבע 2",
        "BRANDING_IMAGE": "תמונת מסך פתיחה",
        "BRANDING_MDC_LOGO_IMAGE": "תמונת לוגו לעמדת השיגור",
        "BRANDING_MDC_SPALSH_IMAGE": "תמונת מסך פתיחה לעמדת השיגור",
        "BRANDING_MDC_COMPANYNAME_IMAGE": "תמונת שם הארגון לעמדת השיגור",
        "LOGO_IMAGE_ERROR_FILE_TYPE": "פורמט הקובץ שגוי. רק קבצים בפורמט ובסיומת ICO נתמכים",
        "APP_WRONG_FILE_EXTENTION": "קובץ תמונה שגוי",
        "BRANDING_ERROR_COLOR": "פורמט ערך הצבע שגוי",
        "BRANDING_ERROR_NAME_LENGTH": "שם היישום מוגבל ל20 תוים בלבד",
        "BUTTON_SAVE_BRAND_INFO": "שמור תצורת המיתוג",
        "BUTTON_SAVE_BRAND_IMG": "שמור תמונת המיתוג",
        "BUTTON_RESET_BRAND_INFO": "החזר הכל למיתוג ברירת מחדל",
        "FLAG_BRAND_ACTIVATION": "עקוף מיתוג ברירת המחדל",
        "BRANDING_RESET_WARNING": "בטל את המעקפים. היישום ישתמש בערכי ברירת מחדל שנקבעו על ידי המפתחים.",
        "BRANDING_MAP_SERVER": "כתובת שרת המפות",
        "BRANDING_ORGANIZATION_OVERRIDE_RESELLER": "עקוף מיתוג המפיץ",
        "BRANDING_RESELLER_OVERRIDE_RESELLER": "עדכן מיתוג לתת-מפיצים ותת-ארגונים",
        "APP_TOAST_SELECT_IMAGE": "אנא בחר תמונה",
        "BRANDING_ERROR_FILE_TYPE": "קובץ תמונה שגוי. נתמכים רק קבצים עם הסיומות והפורמטים הבאים: png jpg jpeg",
        "BRANDING_ERROR_IMAGE_SIZE": "קובץ התמונה לא יכול להיות גדול מ-200 קילובייט",
        "BRANDING_TITLE_MESSAGE": "שינוי המיתוג יכול להשפיע באופן מיידי על כל המשתמשים בארגון!",
        "NAVIGATION_ORG_FRIENDS": "ניהול ארגונים שותפים",
        "ORG_FRIEND_API_GET_LIMIT_ERROR": "לא ניתן לאחזר את רשימת הארגונים השותפים",
        "ORG_FRIEND": "ארגונים שותפים",
        "ORG_AFFILIATED_GROUPS": "קבוצות שותפות",
        "ORG_AFFILIATED_CONTACTS": "אנשי קשר שותפים",
        "ORG_FRIENDS_API_LIMIT_ERROR": "לא ניתן לעדכן מפני שהגעת למגבלת מספר הארגונים השותפים (%s). אנא בדוק עם מנהל השרות האם ניתן להגדיל את המכסה.",
        "APP_SAVE_ORG_FRIEND": "שמור ארגונים שותפים",
        "ORG_AFFILIATED_AFFECT_WARNING": "כל שינוי בארגונים השותפים ישפיע על חברי הקבוצות השותפות",
        "ORG_AFFILIATED_OFFNET_WARNING": "לכל המשתמשים המבוקשים לפני הוספתם לקבוצות המשותפות OffNet הצמד רישיון",
        "ORG_AFFILIATED_CONTACTS_OFFNET_WARNING": "לכל המשתמשים המבוקשים לפני הוספתם לאנשי הקשר המשותפים OffNet הצמד רישיון",
        "PERSONAL_GROUP": "קבוצת חרום פרטית",
        "PERSONAL_GROUP_API_ADD_CONTACT_ERROR": "לא ניתן להוסיף את איש הקשר לקבוצת החרום",
        "PERSONAL_GROUP_API_NAME_UQ_ERROR": "קבוצת חרום בשם זה כבר קיימת",
        "PERSONAL_GROUP_API_REMOVE_CONTACT_ERROR": "לא ניתן להסיר את איש הקשר מקבוצת החרום",
        "SUBSCRIBERS_PERSONAL_GROUP_SUBSCRIBERS": "קבוצת חרום פרטית",
        "SUBSCRIBERS_EMERGENCY_GROUP": "קבוצת חירום (קבלת אזעקות)",
        "NAVIGATION_EMERGENCY_GROUPS": "קבוצות חרום",
        "EMERGENCY_GROUP_DETAILS": "פרטי קבוצת החרום",
        "PERSONAL_GROUP_NAME": "שם הקבוצה",
        "PERSONAL_GROUP_NOTE": "עליך לוודא שיש הרשאה לקבוצה פרטית בהגדרת התפקיד שלך",
        "BUTTON_OPEN_APPLICATION_LIST": "רשימת יישומים",
        "APPLICATIONS_DIALOG_TITLE": "רשימת יישומים",
        "APPLICATION_ICON": "סמל היישום",
        "APPLICATION_NAME": "שם היישום",
        "APPLICATION_VERSION": "גרסת היישום",
        "APPLICATION_ID": "מזהה היישום",
        "APP_ADD_APPLICATION": "הוסף יישום",
        "RECORDING_PLAN": "תוכנית ההקלטות",
        "RECORDING_PLAN_NONE": "ההקלטה מבוטלת",
        "RECORDING_PLAN_ALL_CALLS": "כל השיחות מוקלטות",
        "RECORDING_PLAN_SELECTIVE": "הקלטה סלקטיבית",
        "NAVIGATION_RECORDING": "תכנון הקלטות",
        "RECORDING_TITLE": "תכנון הקלטות",
        "RECORD_WHITE_LIST_SUBSCRIBERS_TITLE": "משתמשים מוקלטים",
        "RECORD_WHITE_LIST_GROUPS_TITLE": "קבוצות מוקלטות",
        "BUTTON_SAVE_RECORDED_SUBSCRIBERS": "שמור התוכנית למשתמשים",
        "BUTTON_SAVE_RECORDED_GROUPS": "שמור התוכנית לקבוצות",
        "ENCRYPTION_PLAN": "תוכנית הצפנה",
        "BUTTON_UPLOAD_KEY_FILE": "העלאת מפתחות פרטיים",
        "BUTTON_SET_EMPTY_KEY_FILE": "הסרת כל המפתחות",
        "BUTTON_SET_KEY_FILE": "צור מפתחות הצפנה אקראיים",
        "BUTTON_SET_DEFAULT_KEY_FILE": "שימוש במפתחות ברירת מחדל",
        "APP_TOAST_UPDATE_KEY_FILE_SUCCESS": "מפתחות ההצפנה נטענו בהצלחה",
        "APP_TOAST_UPDATE_EMPTY_KEY_FILE_SUCCESS": "מפתחות ההצפנה הוסרו בהצלחה",
        "ENCRYPTION_ERROR_FILE_SIZE": "גודלו של קובץ מפתחות ההצפנה צריך להיות כפולה של 32",
        "ENCRYPTION_ERROR_FILE_TYPE": "קובץ מפתחות ההצפנה צריך להיות מסוג בינרי",
        "ENCRYPTION_ERROR_PERMISSION": "אין הרשאה להעלות או לשמור את קובץ מפתחות ההצפנה",
        "VERSIONS_PLAN": "ניהול גרסאות היישומים",
        "BRANDING_LATEST_VERSION_ANDROID": "גרסת היישום האחרונה לאנדרואיד",
        "BRANDING_LATEST_VERSION_MDC": "הגרסה האחרונה של MDC2000",
        "BUTTON_UPLOAD_ANDROID_VERSION_FILE": "העלאת קובץ apk עבור אנדרואיד",
        "BUTTON_UPLOAD_MDC_VERSION_FILE": "העלאת קובץ exe עבור MDC2000",
        "APP_TOAST_UPLOAD_VERSION_FILE_SUCCESS": "קובץ היישום נטען בהצלחנ",
        "APP_TOAST_UPLOAD_VERSION_FILE_EMPTY": "לא נבחר קובץ. אנא בחר קובץ להטענה.",
        "BUTTON_DELETE_ANDROID_VERSION_FILE": "מחק קובץ היישום לאנדרואיד",
        "BUTTON_DELETE_MDC_VERSION_FILE": "מחק קובץ התקנת MDC2000",
        "APP_TOAST_DELETE_VERSION_FILE_SUCCESS": "מחיקת הקובץ הסתיימה בהצלחה",
        "UPLOAD_VERSION_ERROR_FILE_TYPE": "שגיאה בסוג קובץ היישום. רק קבצי APK וEXE נתמכים",
        "UPLOAD_VERSION_SIGN_ERROR": "חתימת הקובץ שהועלה שגויה",
        "STRONG_PASSWORD_PLAN": "ניהול סיסמאות חזקות",
        "MAX_LOGIN_RETRIES_PLAN": "ניהול נעילת משתמשים",
        "MAX_LOGIN_RETRIES": "מקסימום נסיונות התחברות",
        "CHANGE_PASSWORD_PLAN": "ניהול תוקף סיסמאות",
        "PASSWORD_EXPIRATION_DAYS": "תוקף סיסמאות (ימים)",
        "GENERIC_IMPORT": "יבוא",
        "GENERIC_EXPORT": "יצוא",
        "NAVIGATION_REPORT": "דוחות",
        "REPORT_TITLE": "דוחות",
        "BILLING_REPORT_EXPORT": "יצוא דוח שימוש ברישוי",
        "SYSTEM_USERS_REPORT_EXPORT": "יצוא רשימת משתמשים",
        "BULK_EXPORT_ADMIN_RECORDS": "יצוא דוח פעילות של בודקי ההקלטות",
        "WFM_TITLE": "ניהול עובדים",
        "NAVIGATION_WFM": "ניהול עובדים",
        "WFM_USERS_MANAGEMENT": "ניהול משתמשים",
        "WFM_INCIDENCES": "סוגי דיווח משתמש",
        "WFM_APPLY": "יישם שינויים",
        "WFMUSER": "Пользователи модуля управления персоналом",
        "WFMUSERS": "Пользователи модуля управления персоналом",
        "WFM_API_ADD_WFMUSER_ERROR": "הוספת המשתמשים למערכת 'ניהול עובדים' כשלה",
        "WFM_API_REMOVE_WFMUSER_ERROR": "הסרת המשתמשים ממערכת ניהול עובדים' כשלה",
        "WFM_INCIDENCE_DEFAULT": "ברירת מחדל",
        "WFM_ADD_TYPE": "הוספת סוג דיווח חדש",
        "NAVIGATION_CALL_LOGS": "יומן שיחות",
        "CALL_LOGS_TITLE": "יומן שיחות",
        "CALL_LOGS_SESSION_NAME": "שם הערוץ",
        "CALL_LOGS_SESSION_ID": "מזהה ערוץ",
        "CALL_LOGS_SENDER_NAME": "שם היוזם",
        "CALL_LOGS_RECIPIENT_NAME": "שם הנמען",
        "CALL_LOGS_SESSION_TYPE": "סוג ערוץ",
        "CALL_LOGS_SESSION_START_TIME": "זמן התחלה",
        "CALL_LOGS_SESSION_END_TIME": "זמן סיום",
        "CALL_LOGS_DIALOG_TITLE": "פעילות בערוץ",
        "CALL_LOG_SESSION_BY_DATE_BUTTON": "סינון לפי תאריך",
        "CALL_LOG_SESSION_CLEAR_DATE_BUTTON": "נקה סינון",
        "CALL_LOG_SESSION_SHOW_FILTER_BY_DATES": "הצג חלונית סינון",
        "CALL_LOG_SESSION_SHOW_FILTER_BY_DATES_WARNING_TITLE": "סגירת חלונית סינון",
        "CALL_LOG_SESSION_SHOW_FILTER_BY_DATES_WARNING_CONTENT": "סגירת חלונית זו גם תנקה את הסינון. האם להמשיך?",
        "DATES_BLANK_ERROR": "תאריך התחלה או תאריך סיום לא נבחרו",
        "DATES_ERROR": "תאריך הסיום לא יכול להיות לפני תאריך ההתחלה",
        "CALL_LOGS_BURST_TALKER_NAME": "שם הדובר",
        "CALL_LOGS_BURST_TALKER_ID": "מזהה דובר",
        "CALL_LOGS_BURST_TALKER_START_TIME": "זמן התחלה",
        "CALL_LOGS_BURST_TALKER_END_TIME": "זמן סיום",
        "CALL_LOGS_BURST_DURATION": "משך",
        "CALL_LOG_DATES_CONTEXT_WARNING": " אנא בחר תאריכים",
        "APP_RELEASE": "מצב הנעילה",
        "APP_RELEASE_WARNING_TITLE": "שחרור נעילת החשבון",
        "APP_RELEASE_WARNING_CONTENT": "אתה עומד לשחרר את נעילת חשבון המשתמש. מומלץ להחליף את הססמה קודם לכן. ללהמשיך?",
        "APP_TOAST_RELEASE_SUCCESS": "נעילת החשבון שוחררה בהצלחה",
        "APP_BLOCK_WARNING_TITLE": "נעילת החשבון",
        "APP_BLOCK_WARNING_CONTENT": "אתה עומד לנעול את חשבון המשתמש. להמשיך?",
        "APP_BLOCK_USER": "חשבונך ננעל זמנית. צור קשר עם מנהלת השרות כדי לקבל תמיכה.",
        "APP_TOAST_BLOCK_SUCCESS": "החשבון ננעל בהצלחה",
        "NAVIGATION_APPLICATION_LISTS": "תכנון יישומים לנייד",
        "APPLICATION_LISTS": "רשימות יישומים מורשים לנייד",
        "APPLICATION_PACKAGE": "מזהה היישום",
        "APPLICATION_GET_DETAILS": "חלץ את מזהה היישום מהקובץ",
        "APPLICATION_DESCRIPTION": "תאור היישום",
        "APPLICATION_DEFAULT_LIST": "רשימת יישומים ברירת מחדל",
        "APPLICATION_ADD_DIALOG": "הוספת יישומים",
        "APPLICATION_PROFILES": "פרופילי יישומים",
        "APPLICATION_LIST_ID": "מזהה הרשימה",
        "APPLICATION_LIST_NAME": "שם הרשימה",
        "APPLICATION_LIST_DIALOG": "רשימות יישומים",
        "APPLICATION_LIST_MIC": "יישומים המשתמשים במיקרופון",
        "APPLICATION_LIST_KIOSK": "יישומים מורשים במצב קיוסק",
        "APPLICATION_UPDATE_PACKAGE_ERROR": "מזהה היישום שהועלה שונה ממזהה היישום הקיים",
        "APPLICATION_UPDATE_VERSION_ERROR": "גרסת היישום שהועלתה נמוכה מגרסת היישום הקיימת",
        "SUBSCRIBERS_APPLICATION_LIST": "רשימות יישומים",
        "BULK_INTERACTIVE_APPLICATION_LIST": "הקצאת רשימוות יישומים",
        "BULK_SELECT_APPLICATION_LIST": "בחר רשימת יישומים",
        "APP_APPLICATION_LIST_INTERACTIVE_WARNING_TITLE": "האם אתה בטוח שברצונך להצע את השינוי?",
        "APP_DELETE_APPLICATION_LIST_WARNING_TITLE": "האם אתה בטוח שברצונך למחוק את הרשימה?",
        "APPLICATION_LIST_ERROR_DUPLICATE_NAME": "שם הרשימה כבר בשימוש",
        "APP_TOAST_ADD_APPLICATION_ERROR": "יישום עם מזהה זה כבר קיים או שהוא מופיע ברשימת היישומים",
        "APP_TOAST_ADD_APPLICATION_SUCCESS": "היישום נוסף בהצלחה.",
        "APP_TOAST_ADD_APPLICATION_UPDATE_SUCCESS": "היישום עודכן בהצלחה.",
        "APP_TOAST_REMOVE_APPLICATION": "היישום הוסר בהצלחה.",
        "APP_TOAST_ADD_APPLICATION_RESERVED_ERROR": "שם החבילה אינו יכול להכיל מילים או סמלים שמורים",
        "APP_MOVE_TAB_APPLICATION_LIST_WARNING_TITLE": "אזהרת שמירת שינויים",
        "APP_MOVE_TAB_APPLICATION_LIST_WARNING_CONTENT": "אם לא תשמור את השינויים כעת הם יימחקו. האם ברצונך לעבור ללשונית אחרת מבלי לשמור?",
        "APPLICATION_LIST_WARNING_TITLE": "אזהרת השפעה",
        "APPLICATION_LIST_WARNING_CONTENT": "אזהרה: כל שינוי ישפיע מיד על כל המשתמשים בארגון!",
        "NAVIGATION_REACH_ME": "Reach All דוחות",
        "REACH_ME_TITLE": "Reach All דוחות",
        "REACH_ME_USERS": "Reach All משתמשים",
        "REACH_ME_GROUPS": "Reach All קבוצות",
        "REACH_ME_USER_NAME": "שם מתשמש",
        "REACH_ME_USER_ID": "מזהה משתמש",
        "REACH_ME_USER_PHONE": "מספר טלפון",
        "REACH_ME_USER_IMEI": "IMEI",
        "REACH_ME_GROUP_NAME": "שם קבוצה",
        "REACH_ME_GROUP_ID": "מזהה קבוצה",
        "REACH_ME_GROUP_ADMIN_ID": "מזהה מנהל הקבוצה",
        "REACH_ME_GROUP_ADMIN_NAME": "שם מנהל הקבוצה",
        "REACH_ME_GROUP_DIALOG_TITLE": "Reach All פרטי קבוצה",
        "REACH_ME_GROUP_MEMBER_NAME": "שם חבר קבוצה",
        "REACH_ME_GROUP_MEMBER_ID": "מזהה חבר",
        "REACH_ME_GROUP_USER": "לא ניתן לאחזר את הנתונים. אנא בדוק את קונפיגורצית המערכת.",
        "REACH_ME_USER_LAST_SEEN": "נראה לאחרונה",
        "REACH_ME_USER_LAST_REGISTERED": "נרשם לאחרונה",
        "REACH_ME_USER_ACTIVITY_DIALOG_TITLE": "דוח פעילות המשתמש",
        "REACH_ME_USER_ACTION": "פעולה",
        "REACH_ME_USER_ACTION_TIME": "חתימת זמן",
        "SUBSCRIBERS_SUBSCRIBER_LIST": null,
        "LOCALIZATION_FlAG": null,
        "SMS_SERVICE": "שרות",
        "SMS_SEND_CREDENTIAL_WITHOUT_SERVER": null,
        "APP_TOAST_COLOR_ERROR": null,
        "APP_TOAST_IMAGE_FORMAT_ERROR": null,
        "APP_TOAST_IMAGE_SIZE_ERROR": null,
        "ACTIVITY_LOG_TITLE": "יומן פעילות",
        "ACTIVITY_LOG_TIMESTAMP": "חתימת זמן",
        "ACTIVITY_LOG_USER": "מבצע",
        "ACTIVITY_LOG_TYPE": "סוג",
        "ACTIVITY_LOG_NAME": "שם",
        "ACTIVITY_LOG_OPERATION": "פעולה",
        "ACTIVITY_LOG_DESCRIPTION": "תאור",
        "BULK_EXPORT_ACTIVITY_LOG": "דוח יומן פעילות",
        "RADIO_GROUP_CHAT": "רדיו",
        "EMERGENCY_GROUP": "חירום",
        "FORWARD_GROUP": "קבוצת תמיכה",
        "FORWARD_GROUP_NAME": "",
        "CONFERENCE_GROUP_BROADCAST": "ועידה",
        "ORGANIZATION_CONTACT_GROUP": " רשימת קשר ארגונית",
        "CONTACTS_TEMPLATE": "תבנית קשר פרטית",
        "OWN": "נוכחי",
        "GENERATE_COMMON_PASSWORD": "סיסמה שנבחרה",
        "GENERATE_UNIQUE_PASSWORD": "חולל סיסמאות ייחודיות",
        "ORGANIZATION_STRONG_ADMINISTRATOR_PASS": "אלץ סיסמה חזקה עבור מנהלים",
        "PLAYER_CLIENT_VERSION": "גרסת יישום ההקלטות",
        "UNABLE_TO_ADD_MULTIPLE_EMERGENCY_GROUP": "לא ניתן להוסיף מספר קבוצות חירום פרטיות",
        "SECONDARY_SITE_TITLE": "הקצה אתר משני",
        "APP_SENTINEL": "תצורות סנטינל",
        "APP_PORT": "נמל",
        "PATH_NOTE": "נא הוסף '/' לפני הנתיב",
        "PATH_NOT_SET": "נתיב לא מוגדר",
        "ORGANIZATION_API_ADD_PORTAL_URL_UQ_ERROR": "לא ניתן להוסיף את הארגון. כתובת הדומיין צריכה להיות ייחודית",
        "APP_LIST_SHOW": "רשימת אפליקציות",
        "APP_LIVE_SENTINEL_EVENTS": "אירועי Sentinel בשידור חי",
        "APP_INFO": "מֵידָע",
        "SENTINEL_INFO_TEXT": "כדי לבדוק את הפונקציונליות, אנא השתמש בנקודת הקצה הבאה לבדיקה:",
        "URL_NOTE": "נא להזין כתובת URL עם 'HTTP/S'",
        "APP_ROLE_FILTER": "סנן לפי תפקיד",
        "CONFIG_IPRS_WARNING": "נא לשמור על אותו ערך עבור תצורה זו בשרת!",
        "MOBILE_PORTAL_LOGO_IMAGE": "תמונת לוגו של פורטל ניהול",
        "NAVIGATION_LOCATION_HISTORY": "היסטוריית מיקומים",
        "LOCATION_LATITUDE": "רוֹחַב",
        "LOCATION_LONGITUDE": "קו אורך",
        "LOCATION_ACCURANCY": "דִיוּק",
        "LOCATION_DATE_TIME": "תאריך שעה",
        "LOCATION_ACTIVITY": "פעילות מיקום",
        "LOCATION_COUNT": "ספירת מיקומים",
        "BULK_EXPORT_LOCATION_HISTORY": "ייצא היסטוריית מיקומים",
        "LOCATION_LAST_UPDATE_TIME": "זמן עדכון אחרון",
        "BULK_CONTACT_TEMPLATE_SUB_TO_SUB": "מנוי למנוי",
        "BULK_EXPORT_APPLICATIONS": "ייצוא יישומים",
        "BULK_EXPORT_ROLES": "ייצוא תפקידים",
        "NAVIGATION_MOVEORGANIZATION": "הֲגִירָה",
        "TRANSFER_RESELLER": "מפיץ העברה",
        "TRANSFER_ORGANIZATION": "ארגון העברה",
        "TRANSFER_RESFORYOU": "בחר מפיץ מקור",
        "TRANSFER_PARENTRES": "בחר מפיץ אב יעד",
        "TRANSFER_ORGFORYOU": "בחר ארגון מקור",
        "TRANSFER_ORGLIST": "רשימת ארגונים",
        "TRANSFER_SELECTRES": "בחר מפיץ",
        "TRANSFER_ORGANIZATION": "ארגון העברה",
        "NOT_SUPPORTED": "אין באפשרותנו להביא את פרטי האפליקציה. אנא הוסף ידנית את שאר הפרטים הנדרשים",
        "CONTACT_LIMIT_EXCEEDED": "חרגת ממגבלת אנשי הקשר. לא ניתן להוסיף יותר מהמגבלה שהוגדרה",
        "API_RESELLER_DELETE_ERROR": "לא ניתן למחוק את המפיץ. אנא מחק תחילה ארגונים משויכים.",
        "BULK_EXPORT_SUBSCRIBER_QR_CODE": "ייצא קודי QR של מנוי",
        "MOBILEAPP_DELETE_WARNING_CONTENT": "אם תמחק את האפליקציה הזו, היא תוסר אוטומטית מכל פרופילי האפליקציה שהוקצו, ולמשתמשים לא תהיה יותר גישה אליה.",
        "DISABLE_REMEMBER_ME": "השבת זכור משתמש אחרון",
        "APP_QR_WARNING_TITLE": "צור מחדש אימות",
        "APP_QR_WARNING_CONTENT": "האם אתה בטוח שברצונך ליצור מחדש את קוד ה-QR לאימות?",
        "APP_QR_ENABLE_AUTHENTICATION": "הפעל אימות",
        "APP_QR_DISABLE_AUTHENTICATION": "השבת את האימות",
        "APP_QR_REGENERATE_AUTHENTICATION": "צור מחדש אימות",
        "APP_QR_TWO_FACTOR": "שני גורמים",
        "APP_QR_DISABLE_TITLE": "בטל אימות",
        "APP_QR_DISABLE_CONTENT": "האם אתה בטוח שברצונך להשבית את קוד ה-QR של המאמת?",
        "APP_QR_ENABLE_SUCCESS": "אימות קוד QR הופעל בהצלחה",
        "APP_QR_REGENERATE_SUCCESS": "מאמת קוד QR נוצר מחדש בהצלחהн",
        "APP_QR_DISABLE_SUCCESS": "קוד ה-QR של המאמת הושבת בהצלחה",
        "APP_DISPATCHER_PERMISSION_LICENSE_WARNING": "הרשאת מוקדן או הרשאת מוקדן אינטרנט מותרת בו זמנית.",
        "UserLimitExceeded":"לא ניתן היה להשלים את הפעולה מכיוון שהגעת למספר המרבי של משתמשים המותרים. אנא שדרג את התוכנית שלך.",
        "BulkUserLimitExceeded":"לא ניתן היה להשלים את הפעולה מכיוון שהגעת למספר המרבי של משתמשים המותרים. אנא שדרג את התוכנית שלך.",
        "SESSION_NAME": "שם הסשן",
        "MISSED_CALL": "שיחה שלא נענתה",
        "SESSION_ID": "מזהה סשן",
        "SENDER_NAME": "שם השולח",
        "SENDER_ID": "מזהה השולח",
        "RECIPIENT_NAME": "שם הנמען",
        "RECIPIENT_ID": "מזהה הנמען",
        "SESSION_TYPE": "סוג הסשן",
        "SESSION_START_TIME": "זמן תחילת הסשן",
        "SESSION_END_TIME": "זמן סיום הסשן",
        "BURST_TALKER_NAME": "שם הדובר ברצף",
        "BURST_TALKER_ID": "מזהה הדובר ברצף",
        "BURST_START_TIME": "זמן התחלת הרצף",
        "BURST_END_TIME": "זמן סיום הרצף",
        "DURATION": "משך"
      };
    }


    // Russian
    function get_ru() {
      return {
        "version": "2.26",
        "revised_by": "Hardik shah",
        "revision_date": "17-09-2025",
        "APPLICATIONS": "Приложения",
        "API_MONGO_DB_TIMEOUT": "БД Mongo недоступна. Тайм-аут соединения.",
        "API_REQUEST_TIMEOUT": "Тайм-аут запроса узла",
        "API_MONGO_DB_ERROR": "Утеряно соединение с базой данных. Повторите попытку позже",
        "API_GET_LIST_ERROR": "Не удалось получить список %",
        "API_GET_ERROR": "Не удалось получить %s",
        "API_ADD_ERROR": "Невозможно добавить %s",
        "API_UPDATE_ERROR": "Не удалось обновить на %S",
        "API_DELETE_ERROR": "Не удалось удалить %s",
        "API_NOT_FOUND_ERROR": "%s не найден",
        "API_FORBIDDEN_ERROR": "Доступ запрещен",
        "APP_GENERAL": "Общее",
        "APP_CUSTOM": "Custom",
        "APP_DESCRIPTION": "Описание",
        "APP_SEARCH": "Поиск",
        "APP_FILTER": "Фильтр лцензий",
        "APP_NO_FILTER": "Все",
        "APP_NAME": "Название",
        "APP_REMOVE": "Удалить",
        "APP_CLONE": "Клонировать",
        "APP_SAVE": "Сохранить",
        "APP_CANCEL": "Отмена",
        "APP_ADD": "Добавить",
        "APP_UPDATE": "Обновить",
        "APP_OK": "ОК",
        "APP_REFRESH": "Обновить",
        "APP_RECORDS_COUNT": "Записи",
        "APP_NO_RECORDS": "Данные отсутствуют",
        "APP_DELETE_WARNING_TITLE": "Вы уверены, что хотите удалить этот элемент?",
        "APP_DELETE_WITH_MEMBERS_WARNING_TITLE": "У этого элемента есть составляющие. Вы уверены, что хотите его  удалить?",
        "APP_DELETE_WARNING_CONTENT": "Все данные будут удалены.",
        "APP_ENABLE_WARNING_TITLE": "Вы уверены, что хотите подключить всех абонентов?",
        "APP_DISABLE_WARNING_TITLE": "Вы уверены, что хотите отключить всех абонентов?",
        "APP_SEND_SMS": "Отправить СМС",
        "APP_SEND_SMS_WARNING_TITLE": "Вы уверены, что хотите отправить SMS-сообщение на этот абонент?",
        "APP_SEND_BULK_SMS_WARNING_TITLE": "Вы уверены, что хотите отправить SMS-сообщение этим абонентам?",
        "APP_LICENSE_INTERACTIVE_WARNING_TITLE": "Вы уверены, что хотите назначить лицензии для всех абонентов?",
        "APP_ROLE_INTERACTIVE_WARNING_TITLE": "Вы уверены, что хотите назначить роль для всех абонентов?",
        "APP_PASSWORD_MISMATCH": "Пароль не совпадает",
        "APP_SHOW_PASSWORD": "Показать пароль",
        "APP_CHANGE_PASSWORD": "Смена пароля",
        "APP_GENERATE_PASSWORD": "Создать пароль",
        "APP_VALIDATION_REQUIRED": "Это поле обязательно для заполнения.",
        "APP_VALIDATION_MAX_LENGTH": "Это поле слишком длинное.",
        "APP_VALIDATION_MIN_LENGTH": "Это поле слишком короткое.",
        "APP_VALIDATION_EMAIL": "Адрес электронной почты должен быть действующим.",
        "APP_VALIDATION_IP": "Это должен быть действительный IP-адрес.",
        "APP_VALIDATION_URL": "Это должен быть действительный URL-адрес.",
        "APP_VALIDATION_SPECIAL_CHARS": "Это поле не может содержать специальных символов.",
        "APP_VALIDATION_REGULAR_PASSWORD": "Это поле не может содержать следующие символы: '\\' или пробелы.",
        "APP_VALIDATION_PASSWORD": "Должен содержать от 10 до 15 латинских символов, как минимум: 1 цифру, 1 заглавную букву, 1 строчную букву и 1 специальный символ. Не должен содержать одинаковых и последовательных символов или цифр.",
        "APP_ERROR_VALIDATION_PASSWORD": "Пароль не соответствует правилам.",
        "APP_TOAST_ADD_SUCCESS": "Успешно добавлены.",
        "APP_TOAST_UPDATE_SUCCESS": "Успешно обновлены.",
        "APP_TOAST_DELETE_SUCCESS": "Успешно удален.",
        "APP_TOAST_ALLOCATE_SUCCESS": "Успешно распределены.",
        "APP_TOAST_REVOKE_SUCCESS": "Успешно аннулирован.",
        "APP_TOAST_CHANGE_SUCCESS": "Состояние успешно изменено.",
        "APP_TOAST_DELETE_FAILED": "Не удалось удалить роль. Она назначена как минимум, одному пользователю.",
        "APP_TOAST_DELETE_FAIL": "Невозможно удалить организацию. Сначала необходимо удалить всех ее администраторов.",
        "APP_TOAST_SEARCH_BLANK": "Пожалуйста, укажите телефон, адрес электронной почты, ID или IMSI пользователя",
        "APP_TOAST_REVOKE_FAILED": "Не удалось отозвать. Эта лицензия уже назначена абонентам",
        "APP_TOAST_404": "Файл не существует",
        "APP_UNSELECTED": "Невыбранные абоненты",
        "APP_UNSELECTED_OFFNET": "Aбоненты Off- Net",
        "APP_SELECTED": "Отобранные",
        "APP_ADD_ALL": "Выбрать все",
        "APP_REMOVE_ALL": "Удалить все",
        "APP_DISPATCHER_USER_WARNING_TITLE": "Учтите следующее:",
        "APP_DISPATCHER_USER_WARNING_CONTENT1": "Вы собираетесь создать пользователя с лицензией диспетчера , но выбранная роль ему не соответствует.",
        "APP_DISPATCHER_USER_WARNING_CONTENT2": "Вернитесь, чтобы выбрать другую роль, или продолжайте и измените роль позже на экране ролей. Вы хотите продолжить?",
        "APP_CHARGE_ROLE_WARNING_TITLE": "Пожалуйста, обратите внимание",
        "APP_CHARGE_ROLE_WARNING_CONTENT1": "Следующие функции могут потребовать дополнительных затрат:",
        "APP_CHARGE_ROLE_WARNING_CONTENT2": "Для получения дополнительной информации, пожалуйста, свяжитесь с представителем Mobile Tornado.",
        "APP_DEMO_ORGANIZATION_WARNING_TITLE": "Пожалуйста, обратите внимание",
        "APP_DEMO_ORGANIZATION_WARNING_CONTENT1": "Эта организация будет определена в качестве демо на {{days}} дней.",
        "APP_DEMO_ORGANIZATION_WARNING_CONTENT2": "Когда демонстрационный период истечет, вам будет выставлен счет соответственно.",
        "APP_DEMO_ORGANIZATION_WARNING_CONTENT3": "Ok - чтобы принять, Отменить - чтобы зарегистрировать эту организацию как стандартную за оплату.",
        "APP_YES": "Да",
        "APP_NO": "Нет",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS": "Текущий статус шифрования",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_NO_KEYS": "Ключи шифрования не используются",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_DEFAULT_KEYS": "Используются ключи шифрования по умолчанию",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_RANDOM_KEYS": "Используются случайные ключи шифрования",
        "APP_ENCRYPTION_KEYS_CURRENT_STATUS_UPLOAD_KEYS_FILE": "Используется частный файл ключей шифрования",
        "APP_ENCRYPTION_KEYS_VERSION": "Версия ключей шифрования",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_TITLE": "Внимание!",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT1": "пожалуйста убедитесь что у абонентов установлено последняя версия приложения на базе ОС Android",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT2": "(в настоящее время iOS не поддерживается). ",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT3": "Не используйте генератор ключей, если у этой организации есть «аффилированные организации».",
        "APP_GENERATE_ENCRYPTION_KEYS_WARNING_CONTENT4": "Для генерации ключей шифрования, нажмите OK, в противном случае - Отмена",
        "APP_OUT_OF_MEMBER": "Ошибка! Превышен лимит кол-ва участников",
        "LOGIN_INTRO_TITLE": "Добро пожаловать на административный портал!",
        "LOGIN_TITLE": "Войдите в аккаунт",
        "LOGIN_EMAIL": "Электронная почта",
        "LOGIN_PASSWORD": "Пароль",
        "LOGIN_REMEMBER_ME": "Запомнить Меня",
        "LOGIN_FORGOT_PASSWORD": "Забыли Пароль?",
        "LOGIN_LOG_IN": "ВОЙТИ",
        "LOGIN_ERRORS_EMAIL_REQUIRED": "Обязательное поле «электронная почта»",
        "LOGIN_ERRORS_EMAIL_MUST_VALID": "Адрес электронной почты должен быть действующим",
        "LOGIN_ERRORS_PASSWORD_REQUIRED": "Обязательное поле «Пароль»",
        "LOGIN_API_ERROR": "Аутентификация не удалась. Неверное имя пользователя или пароль",
        "LOGIN_API_PERMISSION_ERROR": "Аутентификация не удалась. Отсутствуют полномочия для доступа",
        "LOGIN_API_TOKEN_ERROR": "Срок действия сеанса истек. Пожалуйста, попробуйте снова войти в систему",
        "LOGIN_API_DB_ERROR": "Аутентификация не удалась. Вероятная ошибка с базой данных. Пожалуйста, обратитесь к администратору",
        "LOGIN_CONTACT_ADMIN": "Забыли пароль? Пожалуйста, обратитесь к администратору сервиса",
        "LOGIN_API_ATTEMPTS_LEFT": "Осталось %S попыток",
        "LOGIN_PASSWORD_EXPIRED_DAYS": "Срок действия вашего пароля истекает через {{days}} дней. Поэтому, измените его как можно скорее.",
        "LOGIN_PASSWORD_EXPIRED": "Срок действия вашего пароля истек, и его необходимо изменить.",
        "BACK_TO_LOGIN": "назад",
        "CHANGE_PASSWORD_TITLE": "Изменение пароля",
        "CHANGE_PASSWORD_CURRENT": "Текущий пароль",
        "CHANGE_PASSWORD_NEW": "Новый пароль",
        "CHANGE_PASSWORD_WRONG": "Неверный пароль",
        "CHANGE_PASSWORD_SAME": "Ваш новый пароль должен отличаться от предыдущего.",
        "RECOVER_PASSWORD_SUCCESS": "Сообщениедля восстановления пароля отправлено на адрес электронной почты пользователя",
        "HOMEPAGE_HEADING": "Административный портал",
        "HOMEPAGE_TITLE": "Административный портал",
        "HOMEPAGE_APPLICATION": "Внешний интерфейс",
        "HOMEPAGE_API_VERSION": "API и БД Mongo",
        "HOMEPAGE_DB_VERSION": "Основная БД",
        "HELP_HEADING": "Справка портала",
        "DASHBOARD_HEADING": "Приборная панель",
        "STATISTICS_HEADING": "Статистика РТТ",
        "DUAL_RECORDER_HEADING": "Статистика рекордера",
        "TOOLBAR_RESELLERS": "Реселлеры",
        "TOOLBAR_ORGANIZATIONS": "Организации",
        "TOOLBAR_LOGOUT": "Выход",
        "TOOLBAR_SEARCHTEXT": "Тел/E-mail/ID/IMSI",
        "NAVIGATION_ADMIN_RECORD": "Администраторы звукозаписи",
        "NAVIGATION_ORGANIZATION": "Организация",
        "NAVIGATION_GROUPS": "Группы",
        "NAVIGATION_SUBSCRIBERS": "Абоненты",
        "NAVIGATION_CONTACTS": "Контакты",
        "NAVIGATION_CONTACTS_TEMPLATES": "Шаблоны контактов",
        "NAVIGATION_ORG_DETAILS": "Детали организации",
        "NAVIGATION_RESELLER": "Реселлер",
        "NAVIGATION_ORG_MANAGER": "Управл. организациями",
        "NAVIGATION_RESELLER_DETAILS": "Данные реселлера",
        "NAVIGATION_RESELLER_MANAGER": "Управление реселлерами",
        "NAVIGATION_PLATFORM": "Платформа",
        "NAVIGATION_DEVICES": "Устройства",
        "NAVIGATION_DEV_MANUFACTURERS": "Производители Устройств",
        "NAVIGATION_LICENSES": "Лицензии",
        "NAVIGATION_SOFT_MANUFACTURERS": "Производители ПО",
        "NAVIGATION_PTT_CLIENT_STORE": "Магазин приложения PTT",
        "NAVIGATION_PTT_DEVICES": "Устройства РТТ",
        "NAVIGATION_ITO_CONFIG": "Конфигурация системы",
        "NAVIGATION_LOCALIZATION": "Локализация",
        "NAVIGATION_ADMINISTRATION": "Администрация",
        "NAVIGATION_ROLES": "Роли",
        "NAVIGATION_JOB": "Задания",
        "NAVIGATION_BATCH": "Массовые операции",
        "NAVIGATION_ACTIVITY_LOG": "Журнал изменений",
        "ADMINISTRATOR": "администратор",
        "ADMINISTRATORS": "Администраторы",
        "ADMINISTRATION_TITLE": "Администраторы",
        "ADMINISTRATION_DIALOG_TITLE": "Администраторы",
        "ADMINISTRATION_EMAIL": "Электронная почта",
        "ADMINISTRATION_NAME": "Имя пользователя",
        "ADMINISTRATION_FIRST_NAME": "Имя",
        "ADMINISTRATION_LAST_NAME": "Фамилия",
        "ADMINISTRATION_ROLE": "Название роли",
        "ADMINISTRATION_ACTIONS": "Удалить",
        "ADMINISTRATION_DELETE": "Удалить",
        "ADMINISTRATION_SELECT_ROLE": "Выберите роль",
        "ADMINISTRATION_PASSWORD": "Пароль",
        "ADMINISTRATION_RE_PASSWORD": "Повторите пароль",
        "ADMINISTRATOR_NAME_UQ_ERROR": "Пользователь с таким именем уже существует!",
        "ADMINISTRATOR_EMAIL_UQ_ERROR": "Пользователь с таким адресом электронной почты уже существует!",
        "ROLE": "роль",
        "ROLES": "роли",
        "ROLE_TITLE": "Роли",
        "ROLE_DIALOG_TITLE": "Разрешения Роли",
        "ROLE_SHOW": "Разрешения Роли",
        "ROLE_NAME": "Название роли",
        "ROLE_RESOURCE_PATH": "Разрешения",
        "ROLE_GET": "Просмотр",
        "ROLE_POST": "Добавление",
        "ROLE_PUT": "Изменение",
        "ROLE_DELETE": "Удаление",
        "ROLE_BATCH": "Пакетные операции",
        "ROLE_HIMPACT": "Сильное воздействие",
        "ROLE_ACTIVE": "Активный параметр",
        "ROLE_TABS_WEB": "Администрирование",
        "ROLE_TABS_DISPATCHER": "Диспетчер",
        "ROLE_TABS_MOBILE": "Мобильный клиент",
        "ROLE_API_ADD_NAME_UQ_ERROR": "Невозможно добавить роль. Роль с таким названием уже существует",
        "ROLE_API_UPDATE_NAME_UQ_ERROR": "Не удалось обновить роль. Роль с таким названием уже существует",
        "ROLE_API_DELETE_USED_ERROR": "Не удалось удалить роль. Она назначена по крайней мере одному пользователю",
        "ROLE_RESOURCE_PATH_MOBILE": "Разрешения и настройки",
        "ROLE_NAME_ROOT_ADMIN": "Выбранное название роли уже зарезервировано, и более не может быть использовано",
        "CONTACT": "Список контактов",
        "CONTACTS": "Контакты",
        "CONTACTS_TITLE": "Контакты",
        "CONTACTS_DIALOG_TITLE": "Детали группы контактов",
        "CONTACTS_TEMPLATE_NAME": "Название шаблона",
        "CONTACTS_LIST_NAME": "Название группы",
        "CONTACTS_CONTACT_LISTS": "Список абонентов",
        "CONTACTS_MEMBER_COUNT": "Количество абонентов",
        "CONTACTS_CROSS_FLEET": "Аффилированный контакт",
        "CONTACTS_NAME": "Имя",
        "CONTACTS_MEMBERS": "Данные абонентов",
        "CONTACT_MEMBERS_NOTE": "Показывать только участников с оффнетовой лицензией",
        "CONTACTS_GENERAL": "Общее",
        "CONTACTS_MEMBER_DETAILS": "Сведения об участнике",
        "SUBSCRIBER_LIST": "Список Абонентов",
        "SUBSCRIBER_LISTS": "Списки Абонентов",
        "SUBSCRIBER_LISTS_TITLE": "Списки абонентов",
        "SUBSCRIBER_LIST_DIALOG_TITLE": "Перечень данных абонента",
        "SUBSCRIBER_LIST_NAME": "Название списка",
        "SUBSCRIBER_LISTS_MEMBERS": "Список абонентов",
        "SUBSCRIBER_LISTS_MEMBER_COUNT": "Количество абонентов",
        "SUBSCRIBER_LISTS_NAME": "Название",
        "SUBSCRIBER_LISTS_MEMBERS_DETAILS": "Данные абонентов",
        "SUBSCRIBER_LISTS_GENERAL": "Общее",
        "SUBSCRIBER_LIST_MEMBER_DETAILS": "Данные абонентов",
        "PERSONAL_CONTACT": "личный контакт",
        "PERSONAL_CONTACTS": "личные контакты",
        "PERSONAL_CONTACTS_TEMPLATES": "шаблоны контактов",
        "SUBSCRIBER_LIST_NOTE": "Аффилированный список контактов может быть назначен пользователю без лицензии пользователя вне сети, но пользователю будут назначены только контакты собственной организации",
        "PERSONAL_CONTACTS_TEMPLATES_DETAILS": "Детали шаблона контактов",
        "GROUP": "группа",
        "GROUPS": "группы",
        "GROUPS_TITLE": "Группы",
        "GROUPS_DIALOG_TITLE": "Сведения о группе",
        "GROUPS_SITE": "Сайт",
        "GROUPS_NAME": "Название группы",
        "GROUPS_MEMBER_COUNT": "Количество абонентов",
        "GROUPS_CROSS_FLEET": "Аффилированная группа",
        "GROUPS_EXPIRATION_DATE": "Дата окончания срока",
        "GROUPS_PHONE": "Номер телефона",
        "GROUPS_ACTIONS": "Удалить",
        "GROUPS_TYPE": "Тип группы",
        "GROUPS_GROUP_LISTS": "Список абонентов",
        "GROUPS_DELETE_WARNING": "Не удалось удалить группу. Удалите абонентов в первую очередь.",
        "GROUPS_API_GET_LIMIT_ERROR": "Не удалось получить лимит количества абонентов группы",
        "GROUPS_API_LIMIT_ERROR": "Не удалось обновить. Попробуйте повысить предел",
        "GROUPS_API_ADD_SUBSCRIBER_ERROR": "Не удалось добавить абонентов в группу",
        "GROUPS_API_UPDATE_SUBSCRIBER_ERROR": "Не удается обновить подписчика до группы.",
        "GROUPS_API_REMOVE_SUBSCRIBER_ERROR": "Можете удалить абонента из группы",
        "GROUPS_API_UPDATE_MUTED_SUBSCRIBER_ERROR": "Пользователь-слушатель в группе не может быть обновлен.",
        "GROUPS_API_SET_DEFAULT_ERROR": "Невозможно установить группу по умолчанию.",
        "GROUP_API_NAME_UQ_ERROR": "Группа с таким названием уже существует",
        "SUBSCRIBER": "абонент",
        "SUBSCRIBERS": "абоненты",
        "SUBSCRIBERS_TITLE": "Абоненты",
        "SUBSCRIBERS_DIALOG_TITLE": "Сведения об абоненте",
        "SUBSCRIBERS_DIALOG_ADD_TITLE": "Добавить абонента",
        "SUBSCRIBERS_ORGANIZATION": "Выберете организацию",
        "SUBSCRIBERS_SMS_DIALOG_TITLE": "Отправить SMS",
        "SUBSCRIBERS_GENERAL": "Общее",
        "SUBSCRIBERS_LICENSE": "Лицензии",
        "SUBSCRIBERS_RUNTIME": "Сведения Runtime",
        "SUBSCRIBERS_GROUP_DETAILS": "Сведения о группе",
        "SUBSCRIBERS_GROUP_SUBSCRIBERS": "Группы",
        "SUBSCRIBERS_CONTACT_SUBSCRIBERS": "Группы контактов",
        "SUBSCRIBERS_ACTIVITY_LOG": "История изменений",
        "SUBSCRIBERS_ADD_SUBSCRIBERS": "Добавление абонентов",
        "SUBSCRIBERS_LIST": "Абоненты",
        "SUBSCRIBERS_NAME": "Имя пользователя",
        "SUBSCRIBERS_DISPLAY_NAME": "Отображаемое имя",
        "SUBSCRIBERS_USER_NAME": "Логин / Телефон",
        "SUBSCRIBERS_USER_NAME_SIP": "Адрес электронной почты/SIP",
        "SUBSCRIBERS_DOMAIN": "Домен",
        "SUBSCRIBERS_ACTIVE": "Активный",
        "SUBSCRIBERS_PHONE_NUMBER": "Номер телефона",
        "SUBSCRIBERS_CREATION_TIME": "Время создания",
        "SUBSCRIBERS_CHANGE_STATE_TIME": "Время смены состояния",
        "SUBSCRIBERS_COUNTRY": "Страна",
        "SUBSCRIBERS_ADDRESS": "Адрес",
        "SUBSCRIBERS_PASSWORD": "Пароль",
        "SUBSCRIBERS_RE_PASSWORD": "Повторите пароль",
        "SUBSCRIBERS_CLIENT_TYPE": "Тип клиента",
        "SUBSCRIBERS_HANDSET_TYPE": "Тип мобильного устройства",
        "SUBSCRIBERS_SITE": "Сайт",
        "SUBSCRIBERS_EMAIL": "Электронная почта",
        "SUBSCRIBERS_SIP": "SIP",
        "SUBSCRIBERS_IMSI": "IMSI",
        "SUBSCRIBER_IMSI": "IMSI",
        "SUBSCRIBERS_IMSI2": "IMSI2",
        "SUBSCRIBERS_ROLE": "Роль",
        "SUBSCRIBERS_REVOKE_LICENSE_WARNING": "Вы действительно хотите отозвать лицензию?",
        "SUBSCRIBERS_DEFAULT_RADIO_GROUP": "Радио группа по умолчанию",
        "SUBSCRIBERS_DEFAULT_SOS_MSG": "Эта группа также может служить для аварийного оповещения",
        "SUBSCRIBERS_CURRENT_LICENSE": "Действующая лицензия",
        "SUBSCRIBERS_LICENSE_NAME": "Название",
        "SUBSCRIBERS_LICENSE_TYPE": "Тип",
        "SUBSCRIBERS_LICENSE_RENEWAL": "Обновление",
        "SUBSCRIBERS_LICENSE_EXPIRE": "Истекает",
        "SUBSCRIBERS_LICENSE_QTY": "Имеется в наличии",
        "SUBSCRIBERS_LICENSE_REVOKE": "Отменить",
        "SUBSCRIBERS_LICENSE_ASSIGN": "Назначить",
        "SUBSCRIBERS_LICENSE_ASSIGN_NEW": "Назначить новую лицензию",
        "SUBSCRIBERS_NO_AVAILBLE_QTY": "Не осталось лицензий",
        "SUBSCRIBERS_RUNTIME_LAST_REGISTRATION_TIME": "Время последней регистрации",
        "SUBSCRIBERS_RUNTIME_STATE": "Состояние",
        "SUBSCRIBERS_RUNTIME_APP_UPDATE": "Device/App update",
        "SUBSCRIBERS_RUNTIME_DEVICE_MODEL": "Модель устройства",
        "SUBSCRIBERS_RUNTIME_APP_VERSION": "Версия приложения",
        "SUBSCRIBERS_RUNTIME_OS_VERSION": "Уровень API",
        "SUBSCRIBERS_RUNTIME_MODEL_NAME": "Модель устройства",
        "SUBSCRIBERS_RUNTIME_OS_TYPE": "Тип ОС",
        "SUBSCRIBERS_RUNTIME_BRAND": "Бренд мобильного клиента",
        "SUBSCRIBERS_RUNTIME_MANUFACTURE": "Производитель",
        "SUBSCRIBERS_RUNTIME_MEMORY": "Общая память устройства",
        "SUBSCRIBERS_RUNTIME_FW_VERSION": "Версия прошивки",
        "SUBSCRIBERS_RUNTIME_BUILD": "Тип сборки",
        "SUBSCRIBERS_RUNTIME_FCM": "FCM",
        "SUBSCRIBERS_VALIDATION_SPECIAL_CHARS_ERROR": "Отображаемое имя не может содержать специальные символы",
        "SUBSCRIBERS_VALIDATION_USERNAME_ORG_DOMAIN_ERROR": "Имя пользователя не может содержать домен",
        "SUBSCRIBERS_VALIDATION_AT_ERROR": "Имя пользователя не может содержать символ '@'",
        "SUBSCRIBERS_VALIDATION_DEFAULT_GROUP_ERROR": "Пожалуйста, выберите группу по умолчанию в разделе групп",
        "SUBSCRIBERS_VALIDATION_CREATE_ROLE_ERROR": "Пожалуйста, создайте роль в этой организации",
        "SUBSCRIBERS_VALIDATION_SELECT_ROLE_ERROR": "Пожалуйста, выберите роль",
        "SUBSCRIBERS_VALIDATION_SIP_ERROR": "Неверный формат SIP",
        "SUBSCRIBERS_VALIDATION_SIP_FORMAT_ERROR": "Неверный формат SIM",
        "SUBSCRIBERS_VALIDATION_SIP_PHONE_ERROR": "номер телефона не совпадает",
        "SUBSCRIBERS_VALIDATION_ORG_DOMAIN_ERROR": "Неверный SIP домен организации .  Действителен:",
        "SUBSCRIBERS_VALIDATION_LICENSE_ASSIGNMENT_ERROR": "Примечание: пожалуйста, задайте разрешения для данного пользователя в разделе лицензий",
        "SUBSCRIBERS_VALIDATION_STRONG_DISPATCH_PASS": "Примечание. Для пользователя-диспетчера требуется надежный пароль.",
        "SUBSCRIBERS_GROUPS_LIMIT_ERROR": "Слишком много групп. Пожалуйста, уменьшить соответствующим образом",
        "SUBSCRIBERS_PERSONAL_GROUPS_LIMIT_ERROR": "Слишком много личных контактов, пожалуйста, соответствующим образом уменьшить",
        "SUBSCRIBERS_OCL_LIMIT_ERROR": "Слишком много групп контактов",
        "SUBSCRIBERS_VALIDATION_ADD_ERROR": "Невозможно добавить абонента",
        "SUBSCRIBERS_VALIDATION_ONLY_NUMBERS_ERROR": "Это поле должно содержать только цифры",
        "SUBSCRIBERS_API_VALIDATION_IMSI_FORMAT_ERROR": "Неверный формат: это поле должно содержать от 14 до 20 цифр",
        "SUBSCRIBERS_API_ADD_IDENTIFIERS_UQ_ERROR": "Идентификатор абонента должен быть уникальным",
        "SUBSCRIBERS_API_ADD_IDENTIFIERS_ERROR": "Абонент был добавлен, но не удалось добавить идентификатор",
        "SUBSCRIBERS_API_ADD_DUPLICATE_ID_ERROR": "Абонент не может быть добавлен, так как идентификатор уже существует.",
        "SUBSCRIBERS_API_UPDATE_DUPLICATE_ID_ERROR": "Абонент не может быть обновлен, так как идентификатор уже существует.",
        "SUBSCRIBERS_API_UPDATE_DUPLICATE_IMSI_ERROR": "Абонент не может быть обновлен, так как IMSIуже существует.",
        "SUBSCRIBERS_API_ADD_NO_GROUP_ERROR": "Невозможно добавить Абонента, поскольку в организации нет групп.",
        "SUBSCRIBERS_API_ADD_GROUP_EXCEPTION_ERROR": "Невозможно добавить Абонента из-за ошибки во время получения имен групп для этой организации",
        "SUBSCRIBERS_API_GROUPS_ERROR": "Не удается получить имена групп Абонента",
        "SUBSCRIBERS_API_CONTACTS_ERROR": "Не удается получить имена контактов Абонента",
        "SUBSCRIBERS_API_PHONE_UQ_ERROR": "Невозможно добавить Абонента. Номер телефона должен быть уникальным",
        "SUBSCRIBERS_API_NAME_UQ_ERROR": "Абонент с таким же именем уже существует в этой организации",
        "SUBSCRIBERS_API_NAME_SPACE_ERROR": "Отображаемое имя или SIP не могут содержать пробелы",
        "SUBSCRIBERS_API_PASSWORD_SPACE_ERROR": "Пароль не может содержать пробелы",
        "SUBSCRIBERS_API_ADD_NO_LICENSE": "Невозможно добавить Абонента без лицензии",
        "SUBSCRIBERS_API_UPDATE_NO_LICENSE": "Не удалось обновить Абонента без лицензии",
        "SUBSCRIBERS_API_PHONE_ZERO_ERROR": "Невозможно добавить Абонента, так как номер телефона не может начинаться с нуля",
        "SUBSCRIBERS_API_ADD_NOT_ENOUGH_LICENSE": "Невозможно добавить Абонента, так как все лицензии используются",
        "SUBSCRIBERS_API_NUMBER_USERS_EXCEEDS_LICENSE_QTY": "Пользователи не могут быть добавлены сверх указанного предела в лицензии сервера",
        "SUBSCRIBERS_API_PASSWORD_LENGTH_ERROR": "Абонент не может быть создан, поскольку пароль должен быть короче 18 символов",
        "SUBSCRIBERS_TIME_STAMP": "Штамп времени (по Гринвичу)",
        "SUBSCRIBERS_ADMINISTRATOR": "Администратор",
        "SUBSCRIBERS_DESCRIPTION": "Описание",
        "SUBSCRIBERS_GET_ACTIVITY": "Получить Activities",
        "SUBSCRIBERS_SERIAL_NUMBER": "Серийный Номер",
        "SUBSCRIBER_BULK_PHONE_15_DIGIT_ERROR": "Номер телефона не может быть длиннее 15 цифр.",
        "SUBSCRIBER_BULK_INVALID_PHONE_ERROR": "Неверный номер телефона",
        "ORGANIZATION": "организация",
        "ORGANIZATIONS": "организации",
        "ORGANIZATION_TITLE": "Организации",
        "ORGANIZATION_DETAILS": "Информация об организации.",
        "ORGANIZATION_CONTEXT_WARNING": "Пожалуйста, сначала выберите организацию",
        "ORGANIZATION_CRMID": "CRMID",
        "ORGANIZATION_NAME": "Название организации",
        "ORGANIZATION_DOMAIN": "Доменное имя",
        "ORGANIZATION_SITE": "Сайт IPRS",
        "ORGANIZATION_ADDRESS": "Адрес",
        "ORGANIZATION_MANAGER": "Управление организациями",
        "ORGANIZATION_AUDIO_RECORDER": "Записывать все разговоры в организации",
        "ORGANIZATION_GENERAL": "Общие",
        "ORGANIZATION_CONTACT": "Контактные Данные",
        "ORGANIZATION_SECURITY_AND_DOWNLOAD": "Безопасность и загрузка",
        "ORGANIZATION_LICENSE": "Сведения о Лицензии",
        "ORGANIZATION_LICENSE_ADD": "Добавить лицензию",
        "ORGANIZATION_INSERT": "Вставка",
        "ORGANIZATION_SUPPORT_FIRST_NAME": "Имя специалиста службы поддержки",
        "ORGANIZATION_SUPPORT_LAST_NAME": "Фамилия специалиста службы поддержки",
        "ORGANIZATION_SUPPORT_EMAIL": "Фамилия специалиста службы поддержки",
        "ORGANIZATION_SUPPORT_PHONE": "Адрес электронной почты специалиста службы поддержки",
        "ORGANIZATION_DEMO": "Демо",
        "ORGANIZATION_CREATION_TIME": "Время Создания",
        "ORGANIZATION_DEMO_EXPIRATION": "Срок действия демо",
        "ORGANIZATION_API_GET_CONTACTS_ERROR": "Не удалось получить контактную информацию организации",
        "ORGANIZATION_API_ADD_CONTACTS_ERROR": "Организация была создана, но не удалось указать ее контактную информацию.",
        "ORGANIZATION_API_ADD_NAME_UQ_ERROR": "Невозможно добавить организацию. Название должно быть уникальным",
        "ORGANIZATION_API_ADD_CRM_ID_UQ_ERROR": "Невозможно добавить организацию. CRM ID должен быть уникальным",
        "ORGANIZATION_API_UPDATE_NAME_UQ_ERROR": "Не удалось обновить организации. Название должно быть уникальным",
        "ORGANIZATION_API_UPDATE_CRM_ID_UQ_ERROR": "Не удалось обновить организации. Идентификатор CRM должен быть уникальным",
        "ORGANIZATION_API_UPDATE_CONTACTS_ERROR": "Организация была обновлена, но не удалось указать контактную информацию",
        "ORGANIZATION_API_UPDATE_SITE_ERROR": "Организация была обновлена, но обновить ее сайт не удалось.",
        "ORGANIZATION_API_UPDATE_GROUPS_SITE_ERROR": "Организация обновилась, но не удалось обновить сайты групп",
        "ORGANIZATION_API_UPDATE_SUBSCRIBER_SITE_ERROR": "Реселлер обновился, но не удалось обновить сайты Абонентов",
        "ORGANIZATION_API_UPDATE_CHILDREN_SITE_ERROR": "Реселлер был обновлен, но не удалось обновить сайты групп и абонентов.",
        "ORGANIZATION_API_DELETE_CHILD_ERROR": "Невозможно удалить организацию. Обнаружена связанная дочерняя запись",
        "ORGANIZATION_CALL_LOG": "Вести журнал всех звонков",
        "ORGANIZATION_FORCE_STRONG_DISPATCH_PASS": "Установить надежный пароль для диспетчеров",
        "RECORDING_FORCE_STRONG_RECORDING_REVIEWERS_PASS": "Установить надежный пароль для администраторов звукозаписи",
        "RESELLER": "реселлер",
        "RESELLERS": "реселлеры",
        "RESELLER_TITLE": "Управление Реселлером",
        "RESELLER_DETAILS": "Информация о реселлере",
        "RESELLER_ADDRESS": "Адрес",
        "RESELLER_ADDRESS_NAME": "Название адреса",
        "RESELLER_CRMID": "Идентификатор в CRM",
        "RESELLER_NAME": "Имя реселлера",
        "RESELLER_CONTACT_DETAILS": "Контактные Данные",
        "RESELLER_ADMINISTRATOR_DOMAIN": "Администратор Домена",
        "RESELLER_WEBSERVICE_URL": "URL веб-сервиса",
        "RESELLER_LICENSE": "Сведения о Лицензии",
        "RESELLER_LICENSE_ALLOCATION": "Добавить лицензию",
        "RESELLER_LICENSE_BUNDLE_GENERATION": "Создание пакета лицензий",
        "RESELLER_AGGREGATE_END_USER": "Агрегация конечных пользователей",
        "RESELLER_AEU_EMAIL": "Электронная почта для выставлении счетов AEU",
        "RESELLER_PORTAL_URL": "URL-адрес домена",
        "RESELLER_SITE": "Сайт IPRS",
        "RESELLER_LICENSE_NAME": "Наименование лицензии",
        "RESELLER_ADMIN_FIRST_NAME": "Имя администратора",
        "RESELLER_ADMIN_LAST_NAME": "Фамилия администратора",
        "RESELLER_ADMIN_EMAIL": "Адрес электронной почты контактного лица",
        "RESELLER_ADMIN_PHONE": "Контактный телефон",
        "RESELLER_SUPPORT_FIRST_NAME": "Имя контактного лица службы поддержки",
        "RESELLER_SUPPORT_LAST_NAME": "Фамилия контактного лица службы поддержки",
        "RESELLER_SUPPORT_EMAIL": "Адрес электронной почты службы поддержки",
        "RESELLER_SUPPORT_PHONE": "Телефон службы поддержки",
        "RESELLER_CONTEXT_WARNING": "Пожалуйста, перейдите на уровень реселлера",
        "RESELLER_API_GET_SITE_ERROR": "Невозможно получить сайт реселлера",
        "RESELLER_API_GET_CONTACTS_ERROR": "Не удалось получить контактные данные реселлера",
        "RESELLER_API_ADD_SITE_ERROR": "Реселлер создан, но не было возможности указать его сайт",
        "RESELLER_API_ADD_CONTACTS_ERROR": "Реселлер создан, но не удалось указать его контактную информацию",
        "RESELLER_API_ADD_NAME_UQ_ERROR": "Невозможно добавить реселлера. Имя реселлера должно быть уникальным",
        "RESELLER_API_ADD_CRM_ID_UQ_ERROR": "Невозможно добавить реселлера. CRM ID должен быть уникальным",
        "RESELLER_API_ADD_PORTAL_URL_UQ_ERROR": "Невозможно добавить реселлера. URL-адрес домена должен быть уникальным.",
        "RESELLER_API_ADD_WEBSERVICE_URL_UQ_ERROR": "Невозможно добавить реселлера. URL-адрес веб-службы должен быть уникальным.",
        "RESELLER_API_UPDATE_SITE_ERROR": "Реселлер был обновлен, но не было возможности  указать его сайт",
        "RESELLER_API_UPDATE_CONTACTS_ERROR": "Реселлер был обновлен, но не удалось указать его контактную информацию.",
        "RESELLER_API_UPDATE_NAME_UQ_ERROR": "Невозможно обновить реселлера. Имя реселлера должно быть уникальным",
        "RESELLER_API_UPDATE_CRM_ID_UQ_ERROR": "Невозможно обновить реселлера. CRM идентификатор должен быть уникальным",
        "RESELLER_API_UPDATE_PORTAL_URL_UQ_ERROR": "Не удалось обновить информацию о реселлере. URL-адрес домена должен быть уникальным.",
        "RESELLER_API_UPDATE_WEBSERVICE_URL_UQ_ERROR": "Невозможно обновить реселлера. URL веб-сервис должен быть уникальным",
        "RESELLER_API_DELETE_SITE_ERROR": "Не удалось удалить запись о сайте реселлера",
        "CONFIG": "параметр конфигурации",
        "CONFIGS": "параметры конфигурации",
        "CONFIG_ADD_PARAM": "Добавить параметр",
        "CONFIG_SET_PARAM": "Значение параметра",
        "CONFIG_WARNING": "Недопустимое значение может повлиять на стабильность сервера!",
        "CONFIG_DEFAULT": "Параметр по умолчанию",
        "CONFIG_VALUE_TYPE": "Тип Значения",
        "CONFIG_NAME": "Название",
        "CONFIG_VALUE": "Значение",
        "CONFIG_ACTIONS": "Действия",
        "CONFIG_ADD_CONFIG": "Добавить конфигурацию",
        "CONFIG_SERVER_ID": "ID Сервера",
        "CONFIG_SITE": "Сайт",
        "CONFIG_SERVER": "Сервер",
        "CONFIG_SYSTEM": "Система",
        "SITE": "сайт",
        "SITES": "сайты",
        "SITE_TITLE": "Сайты",
        "SITE_DIALOG_TITLE": "Информация о сайте",
        "SITE_NAME": "Название",
        "SITE_HOST": "Хост",
        "SITE_PUBLIC_IP": "Общедоступный IP",
        "SITE_TYPE": "Тип",
        "SITE_CONTROL_PORT": "Порт Управления",
        "SITE_AUDIO_PORT": "Аудио Порт",
        "SITE_STATE": "Состояние работы",
        "SITE_SERVER_1": "Первый Сервер",
        "SITE_SERVER_2": "Второй Сервер",
        "SITE_ACTIVE_SERVER": "Активный Сервер",
        "SITE_SWITCH_COMMAND": "Команда переключения",
        "SITE_API_ADD_IP_USED_ERROR": "Невозможно добавить сайт. IP-адрес используется другим сервером, не связанным с этим сайтом.",
        "SITE_API_UPDATE_IP_USED_ERROR": "Невозможно обновить сайт. IP-адрес используется другим сервером, не связанным с этим сайтом.",
        "SITE_API_DELETE_GROUP_ERROR": "Невозможно удалить сайт. Этот сайт используется группой. Сначала измените сайт группы.",
        "SERVER": "сервер",
        "SERVERS": "сервера",
        "SERVER_TITLE": "Сервера",
        "ITO_CONFIG": "Конфигурация ITO",
        "SERVER_NAME": "Название",
        "SERVER_HOST": "IP-адрес",
        "SERVER_TYPE": "Тип",
        "SERVER_STATE": "Состояние",
        "SERVER_ADMIN_STATE": "Состояние администрации",
        "SERVER_API_ADD_IP_ERROR": "Невозможно добавить сервер. Этот IP-адрес используется другим сервером того же типа",
        "SERVER_API_UPDATE_IP_ERROR": "Невозможно обновить сервер. Этот IP-адрес используется другим сервером того же типа",
        "SERVER_API_DELETE_SITE_ERROR": "Невозможно удалить сервер. Используется одним из сайтов",
        "DEVICE": "устройство",
        "DEVICES": "устройства",
        "DEVICE_TITLE": "Устройства",
        "DEVICE_DETAILS": "Детали устройства",
        "DEVICE_MODEL": "Модель устройства",
        "DEVICE_CAT_NAME": "Название категории",
        "DEVICE_TYPE": "Тип устройства",
        "DEVICE_ACTIONS": "Действия",
        "DEVICE_ADD": "Добавить устройство",
        "DEVICE_MANUFACTURER": "Выберите производителя",
        "DEVICE_NAME": "Название устройства",
        "DEVICE_API_NAME_UQ_ERROR": "Устройство с таким же названием уже существует",
        "PTT_DEVICE": "Устройство PTT",
        "PTT_DEVICES": "Устройства РТТ",
        "PTT_DEVICE_DETAILS": "Подробная информация об устройстве PTT",
        "PTT_DEVICE_TITLE": "Устройства РТТ",
        "PTT_DEVICE_MODEL": "Модель устройства",
        "PTT_DEVICE_CAT_NAME": "Название категория",
        "PTT_DEVICE_TYPE": "Тип устройства",
        "PTT_DEVICE_NAME": "Название устройства",
        "PTT_DEVICE_API_NAME_UQ_ERROR": "Устройство РТТ с таким же именем уже существует в этом магазине",
        "MANUFACTURER": "производитель устройства",
        "MANUFACTURERS": "производители устройств",
        "MANUFACTURER_TITLE": "Производители устройств",
        "MANUFACTURER_DETAILS": "Сведения о производителе устройства",
        "MANUFACTURER_API_DELETE_CHILD_RECORD_ERROR": "Не удалось удалить производителя. Обнаружена дочерняя запись",
        "SOFTWARE_MANUFACTURER": "производитель программного обеспечения",
        "SOFTWARE_MANUFACTURERS": "производители программного обеспечения",
        "SOFTWARE_MANUFACTURERS_TITLE": "Производители Программного Обеспечения",
        "SOFTWARE_MANUFACTURERS_DETAILS": "Сведения о производителе программного обеспечения",
        "LICENSE_BUNDLE": "Пакет",
        "LICENSE_BUNDLES": "пакеты лицензий",
        "LICENSE_ALLOCATION": "выделение лицензий",
        "LICENSE_ALLOCATIONS": "выделение лицензий",
        "LICENSE_ASSIGNMENT": "присвоение лицензий",
        "LICENSE_ASSIGNMENTS": "присвоение лицензий",
        "LICENSE_TITLE": "Лицензии",
        "LICENSE_DETAILS": "Сведения о Лицензии",
        "LICENSE_NAME": "Наименование Лицензии",
        "LICENSE_DESCRIPTION": "Описание лицензии",
        "LICENSE_PERMISSIONS": "Разрешения",
        "LICENSE_TYPE": "Тип Лицензии",
        "LICENSE_ALLOCATION_DATE": "Дата выделения лицензий",
        "LICENSE_EXPIRATION_TYPE": "Тип срока годности",
        "LICENSE_EXPIRATION_DATE": "Срок годности",
        "LICENSE_AVAILABLE_QTY": "Доступено",
        "LICENSE_QUANTITY": "Количество",
        "LICENSE_ALLOCATE": "Назначить",
        "LICENSE_TEMPLATES": "Шаблоны лицензий",
        "CONVERT_TO_LICENSE": "Показать шаблон лицензии",
        "LICENSE_MASK": "Код Лицензии",
        "CONVERT_TO_MASK": "Показать код лицензии",
        "LICENSE_CODE": "Код Лицензии",
        "APP_CONVERT": "Создание лицензионного кода",
        "UNDO_LICENSE": "Отменить",
        "LICENSE_REVOKE": "Отозвать",
        "LICENSE_API_ALLOCATION_GET_PARENT_LIST_ERROR": "Невозможно получить распределение родительских лицензий",
        "LICENSE_API_ASSIGNMENT_REVOKE_ERROR": "Невозможно отозвать назначение лицензии",
        "ILLEGAL_LICENSE": "Поля должны иметь тип boolean",
        "LICENSE_TOAST_ALLOCATION_SUCCESS": "Распределено успешно",
        "LICENSE_ALLOCATION_QTY_ERROR": "Недостаточное количество лицензий",
        "LICENSE_ALLOCATION_ORG_ACTIVE_ERROR": "Нет активных лицензий в организации",
        "LICENSE_MAX_ORDINARY_SUBSCRIBERS": "Предельное количество обыкновенных Абонентов",
        "LICENSE_MAX_DISPATCH_CONSOLE_SUBSCRIBERS": "Предельное количество диспетчеров",
        "LICENSE_MAX_SUBSCRIBERS": "Максимальное количество Абонентов",
        "LICENSE_IN_USE": "В использовании",
        "LICENSE_EXPIRATION_DATE_SERVER": "Дата окончания срока действия лицензии сервера",
        "RESELLER_QTY": "Кол-во лицензий PTT",
        "RESELLER_DISPATCHER_QTY": "Кол-во диспетчерских лицензий",
        "ORGANIZATION_QTY": "Кол-во лицензий PTT",
        "ORGANIZATION_DISPATCHER_QTY": "Кол-во диспетчерских лицензий",
        "LICENSE_DISPATCHER_ALLOCATE": "Назначить",
        "LICENSE_ALLOCATE_BUTTON": "Применить",
        "PARENT_RESELLER_QTY": "Количество «родительских» лицензий: PTT",
        "PARENT_RESELLER_DISPATCHER_QTY": "Диспетчер",
        "LICENSE_QTY_TOOLTIP": "Количество используемых лицензий из выделенных лицензий этого типа",
        "CLIENT_VERSION": "версия клиента",
        "CLIENT_VERSIONS": "версии клиента",
        "CLIENT_VERSION_TITLE": "Версия Клиента",
        "CLIENT_VERSION_DIALOG_TITLE": "Сведения о версии клиента",
        "CLIENT_VERSION_STORE_NAME": "Название магазина версии клиента",
        "CLIENT_VERSION_VERSION": "Версия",
        "CLIENT_VERSION_SELECT_STORE": "Выберите магазин РТТ",
        "CLIENT_VERSION_PATH": "Локальный путь к файлу",
        "CLIENT_VERSION_DESCRIPTION": "Описание",
        "STORE": "Магазин клиентов PTT",
        "STORES": "Клиентские магазины PTT",
        "STORE_TITLE": "Магазин клиентов PTT",
        "STORE_DETAILS_TILE": "Сведения о магазине клиента PTT",
        "STORE_MODEL": "Модель устройства",
        "STORE_CAT_NAME": "Название категории",
        "STORE_TYPE": "Тип устройства",
        "STORE_ACTIONS": "Действия",
        "STORE_ADD_DEVICE": "Добавить устройство",
        "STORE_DEVICE": "Выберите устройство",
        "STORE_CLIENT_STORE": "Клиентский магазин",
        "STORE_MANUFACTURER": "Выберите производителя",
        "STORE_DEVICE_NAME": "Название устройства",
        "STORE_LICENSABLE_TYPE": "Лицензируемый тип",
        "STORE_DESCRIPTION": "Описание",
        "STORE_MANUFACTURER_NAME": "Название производителя",
        "STORE_CLIENT_VERSION": "Версия Клиента",
        "STORE_API_NAME_UQ_ERROR": "Клиентский магазин с таким названием уже существует для этого производителя.",
        "LOCALIZATION_TITLE": "Локализация",
        "LOCALIZATION_DETAILS": "Детали",
        "LOCALIZATION_FLAG": "Флаг",
        "LOCALIZATION_ACTIVE": "Активный",
        "LOCALIZATION_DEFAULT": "По умолчанию",
        "LOCALIZATION_NAME": "Метки",
        "LOCALIZATION_TRANSLATION": "Ключ перевода",
        "LOCALIZATION_CODE": "Код Языка",
        "LOCALIZATION_IMPORT": "Импортировать таблицу перевода",
        "LOCALIZATION_EXPORT": "Экспорт таблицы перевода",
        "LOCALIZATION_REMOVE_DEFAULT_ERROR": "Невозможно удалить язык по умолчанию. Пожалуйста, установите другой по умолчанию и попробуйте еще раз",
        "LOCALIZATION_ADD_DUPLICATE_ERROR": "Ошибка: перевод с таким ключом уже существует",
        "JOB_TITLE": "Процесс",
        "JOB_RUN_INTEGRITY": "Запустить процесс целостности БД",
        "JOB_RUN_EXPIRATION": "Запустить процесс истечения срока действия лицензии",
        "JOB_PROVISIONING": "Провизионирование",
        "JOB_GPS": "Архиватор GPS",
        "JOB_MONGO_HA": "Высокая доступность Mongodb",
        "JOB_INIT_LOG": "Инициализировать журнал",
        "JOB_RUN_LOG": "Запустить журнал",
        "JOB_PROV_LICENSE_LOG": "Job Срока действия лицензии",
        "JOB_PROV_DB_INIT_LOG": "Инициализация БД Журнала",
        "JOB_PROV_DB_INTEGRITY_LOG": "Журнал целостности БД",
        "BULK_TITLE": "Массовые Операции",
        "BULK_OPERATIONS": "Массовые Операции",
        "BULK_INTERACTIVE_DELETE": "Удаление",
        "DELETE_INTERACTIVE_SUBSCRIBERS": "Абоненты",
        "DELETE_INTERACTIVE_GROUPS": "Группы",
        "DELETE_INTERACTIVE_OCL": "Списоки контактов организации",
        "DELETE_INTERACTIVE_EMERGENCY_GROUP": "Группы экстренной помощи",
        "DELETE_INTERACTIVE_CONTACT_TEMPLATE": "Шаблоны контактов",
        "DELETE_INTERACTIVE_TYPE": "Тип удаления",
        "DELETE_GROUPS": "Группы",
        "DELETE_SUBSCRIBERS": "Абоненты",
        "DELETE_OCL": "Списоки контактов организации",
        "DELETE_EMERGENCY_GROUP": "Группы экстренной помощи",
        "DELETE_CONTACT_TEMPLATE": "Шаблоны контактов",
        "BULK_DELETE_COUNT": "Количество абонентов для удаления",
        "BULK_INTERACTIVE_LICENSE": "Лицензии",
        "BULK_INTERACTIVE_ROLE": "Роль",
        "BULK_SUBSCRIBERS_COUNT": "Количество абонентов",
        "DOWNLOAD_SAMPLE_FILE": "Скачать образец файла",
        "BULK_RESULT_LOG": "Журнал",
        "BULK_IMPORT_NOTE": "При импорте абонентов аффилированная группа будет применяться к абонентам с внесетевыми лицензиями.",
        "AFFILLIATED_ORG_SUB_NOT_ADDED_MESSAGE": "из подписчиков аффилированных организаций не добавлены",
        "GROUP_LIMIT_SIZE": "Превышена предельная длина названия группы",
        "SUBSCRIBERS_API_NAME_LIMIT_SIZE": "Превышена предельная длина имени подписчика",
        "BULK_EXPORT": "Экспорт абонентов",
        "BULK_IMPORT": "Импорт абонентов",
        "BULK_EXPORT_REPORT": "Отчеты",
        "BULK_EXPORT_CALL_LOG": "Отчет журнала вызовов",
        "BULK_EXPORT_RUNTIME": "Отчет о статусе абонентов",
        "BULK_ENABLE_ALL": "Подключить всех Абонентов",
        "BULK_SUSPEND_ALL": "Отключение всех абонентов",
        "BULK_DELETE_ALL": "Удаление всех абонентов",
        "BULK_DELETE_APPLY": "Выполнить удаление",
        "BULK_SELECT_ALLOCATION": "Выберите распределения",
        "BULK_SELECT_ROLE": "Выберите роль",
        "BULK_SELECT_LICENSE": "Выбрать лицензию",
        "BULK_ALLOCATION_APPLY": "Применить распределение",
        "BULK_IMPORT_FILE_FORMAT_MESSAGE": "Загрузите файл CSV или XLSX",
        "BULK_INTERACTIVE_SMS": "SMS провизирование",
        "BULK_INTERACTIVE_CHANGE_PASSWORD": "Изменение пароля",
        "BULK_CHANGE_PASSWORD_APPLY": "Установить новый пароль",
        "APP_CHANGE_PASSWORD_INTERACTIVE_WARNING_TITLE": "Вы уверены, что хотите установить этот пароль для выбранных пользователей?",
        "SUBSCRIBERS_NEW_PASSWORD": "Новый Пароль",
        "INVALID_BULK_FILE_FORMAT": "Формат файла недействителен",
        "BULK_INTERACTIVE_EMERGENCY_GROUP": "Группы экстренной помощи",
        "BULK_SELECT_EMERGENCY_GROUP": "Выберите группу экстренной помощи",
        "APP_EMERGENCY_GROUP_INTERACTIVE_WARNING_TITLE": "Вы Вы уверены, что хотите назначить эту группу экстренной помощи для выбранных пользователей?",
        "BULK_INTERACTIVE_CONTACT_TEMPLATE": "Шаблоны Контактов",
        "BULK_CONTACT_TEMPLATE_SUBSCRIBERS": "Шаблон для подписчика",
        "BULK_CONTACT_TEMPLATE_TEMPLATES": "Шаблон к шаблону",
        "CONTACT_TEMPLATE_TYPE": "Тип",
        "BULK_SELECT_CONTACT_TEMPLATE": "Выберите Шаблоны контактов",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_ADD_WARNING_TITLE": "Вы действительно хотите назначить эти шаблоны контактов выбранным пользователям?",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_ADD_WARNING_GROUP_TITLE": "Вы хотите назначить эти шаблоны контактов выбранным пользователям группы?",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_REMOVE_WARNING_TITLE": "Вы Вы уверены, что хотите удалить этот шаблон для выбранных пользователей?",
        "APP_CONTACT_TEMPLATE_INTERACTIVE_REMOVE_WARNING_GROUP_TITLE": "Вы хотите удалить этот шаблон контактов из выбранной группы пользователей?",
        "BULK_CONTACT_TEMPLATE_ADD": "Добавить пользователей шаблона контактов",
        "BULK_CONTACT_TEMPLATE_REMOVE": "Удалить пользователей шаблона контактов",
        "RESELLER_SMS_CONFIGURATION": "Конфигурация SMS",
        "SMS_API_KEY": "Ключ API",
        "SMS_API_SECRET": "IPI секрет",
        "SMS_IP": "IP-адрес SMS-центра",
        "SMS_PORT": "СМС порт",
        "SMS_SEND_CREDENTIAL": "Учетные данные",
        "SMS_SEND_CREDENTIALS_WITH_SERVER": "Учетные данные & URL-адрес сервера",
        "SMS_SEND_MESSAGE": "Адаптированное сообщение",
        "SMS_SEND_CREDENTIALS_AND_DOWNLOAD_LINK": "Учетные данные со ссылкой",
        "SMS_SEND_DOWNLOAD_LINK": "Ссылка для скачивания",
        "SMS_DOWNLOAD_LINK": "Введите ссылку для скачивания",
        "SMS_MESSAGE": "Введите адаптированное сообщение",
        "SMS_MISSING_KEYS": "Учетные данные для доступа к провайдеру SMS не настроены для этого Реселлера",
        "SMS_API_VALIDATION_PHONE_ERROR": "Ошибка API: номер телефона не предоставлен",
        "SMS_API_VALIDATION_CREDENTIALS_ERROR": "Ошибка SMS API: учетные данные не предоставлены",
        "USER_VALIDATION_EMAIL_FORMAT_ERROR": "Неверный формат электронной почты",
        "USER_ID": "ID Пользователя",
        "TEXT_SEARCHBTN": "Поиск",
        "SEARCH_RESULT": "Результаты Поиска",
        "START_DATE": "Начало",
        "END_DATE": "Окончание",
        "ENTER_DATE": "Выберите дату",
        "ADMIN_RECORD_TITLE": "Администраторы звукозаписи",
        "ADMIN_RECORD_EMAIL_ID": "e-mail",
        "ADMIN_RECORD_LAST_LOGIN_TIME": "Время последнего входа в систему",
        "ADMIN_RECORD_LAST_ACTIVITY_TIME": "Последнее время активности",
        "USER_LAST_PASSWORD_CHANGE_TIME": "Последнее изменение пароля",
        "ADMIN_RECORD_DIALOG_TITLE": "Сведения об анализаторе записей",
        "ADMIN_RECORD_DETAILS": "Сведения об анализаторе",
        "ADMIN_RECORD_ACTIVITY": "Последние действия",
        "ADMIN_RECORD_ACTIVITY_COMMAND": "Действие",
        "ADMIN_RECORD_ACTIVITY_SESSION_NAME": "Название сеанса",
        "ADMIN_RECORD_ACTIVITY_USER_NAME": "Имя пользователя ",
        "ADMIN_RECORD_ACTIVITY_TIME": "Время действия",
        "ADMIN_RECORD_ACTIVITY_IP": "Исходный IP",
        "AUDIO_BACKUP_PATH_TITLE": "Управление хранилищем",
        "AUDIO_BACKUP_FOLDER_DATE": "Месяц и год",
        "AUDIO_BACKUP_PATH": "Путь",
        "AUDIO_BACKUP_PATH_DIALOG_TITLE": "Управление хранилищем",
        "FOLDER_DATE": "Месяц и год",
        "BRANDING_TITLE": "Брендинг",
        "BRANDING_TITLE_IMAGE": "Изображение для брендинга",
        "BRANDING_NAME": "Название приложения",
        "COLOR1": "Цвет 1",
        "COLOR2": "Цвет 2",
        "BRANDING_IMAGE": "Изображение-заставка мобильного приложения",
        "BRANDING_MDC_LOGO_IMAGE": "Изображение логотипа диспетчерской консоли",
        "BRANDING_MDC_SPALSH_IMAGE": "Изображение-заставка  диспетчерской консоли",
        "BRANDING_MDC_COMPANYNAME_IMAGE": "Название компании в диспетчерской консоли (Изображение)",
        "LOGO_IMAGE_ERROR_FILE_TYPE": "Неверный формат изображения. Поддерживается только ICO",
        "APP_WRONG_FILE_EXTENTION": "Неверный формат изображения",
        "BRANDING_ERROR_COLOR": "Неверный формат значения цвета",
        "BRANDING_ERROR_NAME_LENGTH": "Название приложения ограничивается 20 буквами",
        "BUTTON_SAVE_BRAND_INFO": "СОХРАНИТЬ НАСТРОЙКИ БРЕНДИНГА",
        "BUTTON_SAVE_BRAND_IMG": "СОХРАНИТЬ БРЕНДИНГОВОЕ ИЗОБРАЖЕНИЕ",
        "BUTTON_RESET_BRAND_INFO": "Вернуть все к значениям по умолчанию",
        "FLAG_BRAND_ACTIVATION": "Переопределить брендинг по умолчанию",
        "BRANDING_RESET_WARNING": "Отменить переопределение. Приложение будет использовать значения брендинга по умолчанию установленные разработчиками.",
        "BRANDING_MAP_SERVER": "Адрес сервера картографии",
        "BRANDING_ORGANIZATION_OVERRIDE_RESELLER": "Переопределить брендинг реселлера",
        "BRANDING_RESELLER_OVERRIDE_RESELLER": "Установка брендинга для суб-реселлеров и суборганизаций",
        "APP_TOAST_SELECT_IMAGE": "Пожалуйста, выберите изображение",
        "BRANDING_ERROR_FILE_TYPE": "Неверный формат изображения. Поддерживаются только PNG, JPG и JPEG",
        "BRANDING_ERROR_IMAGE_SIZE": "Файл изображения не должен превышать 200 Кбайт",
        "BRANDING_TITLE_MESSAGE": "Настройки брендинга могут сразу повлиять на всех пользователей в этой организации!",
        "NAVIGATION_ORG_FRIENDS": "Управление аффилированными организациями",
        "ORG_FRIEND_API_GET_LIMIT_ERROR": "Не удалось получить список аффилированных организаций",
        "ORG_FRIEND": "Аффилированные организации",
        "ORG_AFFILIATED_GROUPS": "Аффилированные группы",
        "ORG_AFFILIATED_CONTACTS": "Аффилированные Контакты",
        "ORG_FRIENDS_API_LIMIT_ERROR": "Невозможно обновить, потому что предел кол-ва аффилированных организаций %s был достигнут. Обратитесь к поставщику услуг для увеличения лимита.",
        "APP_SAVE_ORG_FRIEND": "Сохранить аффилированные организации",
        "ORG_AFFILIATED_AFFECT_WARNING": "Любое изменение в партнерской организации будет влиять на членов организации аффилированной группы.",
        "ORG_AFFILIATED_OFFNET_WARNING": "Назначьте Off-Net Лицензию всем соответствующим участникам ПЕРЕД созданием аффилированной группы!",
        "ORG_AFFILIATED_CONTACTS_OFFNET_WARNING": "Назначьте Off-Net Лицензию всем соответствующим участникам ПЕРЕД созданием группы контактов!",
        "PERSONAL_GROUP": "Частная группа экстренной помощи",
        "PERSONAL_GROUP_API_ADD_CONTACT_ERROR": "Невозможно добавить контакт в группу экстренной помощи",
        "PERSONAL_GROUP_API_NAME_UQ_ERROR": "Группа экстренной помощи с таким названием уже существует.",
        "PERSONAL_GROUP_API_REMOVE_CONTACT_ERROR": "Не удалось удалить контакт из экстренной группы",
        "SUBSCRIBERS_PERSONAL_GROUP_SUBSCRIBERS": "Частная группа экстренной помощи",
        "SUBSCRIBERS_EMERGENCY_GROUP": "Частная группа экстренной помощи (Чтобы получать оповещения)",
        "NAVIGATION_EMERGENCY_GROUPS": "Группы экстренной помощи",
        "EMERGENCY_GROUP_DETAILS": "Сведения о группе экстренной помощи",
        "PERSONAL_GROUP_NAME": "Название группы",
        "PERSONAL_GROUP_NOTE": "Пожалуйста, убедитесь, что у вас есть разрешение для личной группы в роли",
        "BUTTON_OPEN_APPLICATION_LIST": "Список приложений",
        "APPLICATIONS_DIALOG_TITLE": "Список приложений",
        "APPLICATION_ICON": "Значок",
        "APPLICATION_NAME": "Название",
        "APPLICATION_VERSION": "Версия",
        "APPLICATION_ID": "ID приложения",
        "APP_ADD_APPLICATION": "Добавить приложение",
        "RECORDING_PLAN": "Конфигурация записи",
        "RECORDING_PLAN_NONE": "Без записи",
        "RECORDING_PLAN_ALL_CALLS": "Запись всех вызовов",
        "RECORDING_PLAN_SELECTIVE": "Выборочные записи",
        "NAVIGATION_RECORDING": "Настройка звукозаписи",
        "RECORDING_TITLE": "Запись вызовов",
        "RECORD_WHITE_LIST_SUBSCRIBERS_TITLE": "Записанные абоненты",
        "RECORD_WHITE_LIST_GROUPS_TITLE": "Записанные группы",
        "BUTTON_SAVE_RECORDED_SUBSCRIBERS": "Сохранить конфигурацию для пользователей",
        "BUTTON_SAVE_RECORDED_GROUPS": "Сохранить конфигурацию для для групп",
        "ENCRYPTION_PLAN": "Конфигурация шифрования",
        "BUTTON_UPLOAD_KEY_FILE": "Загрузить собственные ключи",
        "BUTTON_SET_EMPTY_KEY_FILE": "Удалить все ключи",
        "BUTTON_SET_KEY_FILE": "Генерация случайных ключей шифрования",
        "BUTTON_SET_DEFAULT_KEY_FILE": "Использовать ключи по-умолчанию",
        "APP_TOAST_UPDATE_KEY_FILE_SUCCESS": "Ключи шифрования были успешно загружены",
        "APP_TOAST_UPDATE_EMPTY_KEY_FILE_SUCCESS": "Ключи шифрования были успешно удалены",
        "ENCRYPTION_ERROR_FILE_SIZE": "Размер файла ключей шифрования должен быть кратным 32.",
        "ENCRYPTION_ERROR_FILE_TYPE": "Файл ключей шифрования должен быть бинарного типа",
        "ENCRYPTION_ERROR_PERMISSION": "Нет разрешения, чтобы загрузить или сохранить файла ключей шифрования",
        "VERSIONS_PLAN": "Версии приложений",
        "BRANDING_LATEST_VERSION_ANDROID": "Актуальная версия приложения для Android",
        "BRANDING_LATEST_VERSION_MDC": "Актуальная версия приложения для Windows",
        "BUTTON_UPLOAD_ANDROID_VERSION_FILE": "Загрузить файл APK для OS Android",
        "BUTTON_UPLOAD_MDC_VERSION_FILE": "Загрузить exe-файл MDC2000",
        "APP_TOAST_UPLOAD_VERSION_FILE_SUCCESS": "Новый файл приложения был успешно загружен",
        "APP_TOAST_UPLOAD_VERSION_FILE_EMPTY": "Файл не выбран. Пожалуйста, выберите файл для загрузки.",
        "BUTTON_DELETE_ANDROID_VERSION_FILE": "Удалить APK файл для Android",
        "BUTTON_DELETE_MDC_VERSION_FILE": "Удалить exe-файл MDC2000",
        "APP_TOAST_DELETE_VERSION_FILE_SUCCESS": "Файл был успешно удален",
        "UPLOAD_VERSION_ERROR_FILE_TYPE": "Ошибка типа файл. Поддерживаются только EXE-файл или APK",
        "UPLOAD_VERSION_SIGN_ERROR": "Цифровая подпись загруженного файла неверна",
        "STRONG_PASSWORD_PLAN": "Политика надежных паролей",
        "MAX_LOGIN_RETRIES_PLAN": "Политика блокировки пользователей",
        "MAX_LOGIN_RETRIES": "Максимальное количество попыток входа в систему",
        "CHANGE_PASSWORD_PLAN": "Политика истечения срока действия пароля",
        "PASSWORD_EXPIRATION_DAYS": "Срок действия пароля (дни)",
        "GENERIC_IMPORT": "Импорт",
        "GENERIC_EXPORT": "Экспорт",
        "NAVIGATION_REPORT": "Отчеты",
        "REPORT_TITLE": "Отчеты",
        "BILLING_REPORT_EXPORT": "Отчёт об использовании лицензий",
        "SYSTEM_USERS_REPORT_EXPORT": "Экспорт списка абонентов",
        "BULK_EXPORT_ADMIN_RECORDS": "Отчёт о действиях администраторов  записей",
        "WFM_TITLE": "Управление персоналом",
        "NAVIGATION_WFM": "Управление персоналом",
        "WFM_USERS_MANAGEMENT": "Пользователи модуля управления персоналом",
        "WFM_INCIDENCES": "Заголовки пользовательских отчетов",
        "WFM_APPLY": "Применить",
        "WFMUSER": "Usuario de Work Force Management",
        "WFMUSERS": "Usuarios de Work Force Management",
        "WFM_API_ADD_WFMUSER_ERROR": "No se pueden agregar los usuarios de Administración de personal",
        "WFM_API_REMOVE_WFMUSER_ERROR": "No se pueden remover los usuarios de Administración de personal",
        "WFM_INCIDENCE_DEFAULT": "По умолчанию",
        "WFM_ADD_TYPE": "Добавить новый тип отчета",
        "NAVIGATION_CALL_LOGS": "Журнал вызовов",
        "CALL_LOGS_TITLE": "ЖУРНАЛ ВЫЗОВОВ",
        "CALL_LOGS_SESSION_NAME": "Название канала",
        "CALL_LOGS_SESSION_ID": "ID канала",
        "CALL_LOGS_SENDER_NAME": "Инициатор",
        "CALL_LOGS_RECIPIENT_NAME": "Получатель",
        "CALL_LOGS_SESSION_TYPE": "Тип канала",
        "CALL_LOGS_SESSION_START_TIME": "Начало",
        "CALL_LOGS_SESSION_END_TIME": "Окончание",
        "CALL_LOGS_DIALOG_TITLE": "Вызовы на канале",
        "CALL_LOG_SESSION_BY_DATE_BUTTON": "Фильтровать по дате",
        "CALL_LOG_SESSION_CLEAR_DATE_BUTTON": "Очистить фильтр",
        "CALL_LOG_SESSION_SHOW_FILTER_BY_DATES": "Показать фильтр",
        "CALL_LOG_SESSION_SHOW_FILTER_BY_DATES_WARNING_TITLE": "Закрыть панель фильтров",
        "CALL_LOG_SESSION_SHOW_FILTER_BY_DATES_WARNING_CONTENT": "Закрытия этой панели также очистит фильтры. Продолжать?",
        "DATES_BLANK_ERROR": "Дата начала и окончания не были выбраны",
        "DATES_ERROR": "Дата окончания не может быть раньше даты начала",
        "CALL_LOGS_BURST_TALKER_NAME": "Имя спикера",
        "CALL_LOGS_BURST_TALKER_ID": "ID спикера",
        "CALL_LOGS_BURST_TALKER_START_TIME": "Начало",
        "CALL_LOGS_BURST_TALKER_END_TIME": "Окончание",
        "CALL_LOGS_BURST_DURATION": "Продолжительность",
        "CALL_LOG_DATES_CONTEXT_WARNING": "Пожалуйста, выберите даты",
        "APP_RELEASE": "Состояние блокировки",
        "APP_RELEASE_WARNING_TITLE": "Разблокировка аккаунта",
        "APP_RELEASE_WARNING_CONTENT": "Вы собираетесь разблокировать учетную запись этого пользователя. Сначала рекомендуется изменить его пароль. Продолжать?",
        "APP_TOAST_RELEASE_SUCCESS": "Учетная запись была успешно разблокирована",
        "APP_BLOCK_WARNING_TITLE": "Блокировка учетной записи",
        "APP_BLOCK_WARNING_CONTENT": "Вы собираетесь заблокировать учетную запись этого пользователя. Продолжать?",
        "APP_BLOCK_USER": "Ваша учетная запись была временно заблокирована. Обратитесь к администратору за помощью.",
        "APP_TOAST_BLOCK_SUCCESS": "Учетная запись успешно заблокирована",
        "NAVIGATION_APPLICATION_LISTS": "Контроль  приложений",
        "APPLICATION_LISTS": "Список мобильных приложений",
        "APPLICATION_PACKAGE": "Пакет",
        "APPLICATION_GET_DETAILS": "Извлечь сведения о пакете приложения",
        "APPLICATION_DESCRIPTION": "Описание приложения",
        "APPLICATION_DEFAULT_LIST": "Список приложений по умолчанию",
        "APPLICATION_ADD_DIALOG": "Добавить приложение",
        "APPLICATION_PROFILES": "Профили приложений",
        "APPLICATION_LIST_ID": "ID приложений",
        "APPLICATION_LIST_NAME": "Название приложений",
        "APPLICATION_LIST_DIALOG": "Список приложений",
        "APPLICATION_LIST_MIC": "Приложения, использующие микрофон",
        "APPLICATION_LIST_KIOSK": "Приложения, разрешенные в режиме киоска",
        "APPLICATION_UPDATE_PACKAGE_ERROR": "Загруженный пакет приложений отличается от существующего.",
        "APPLICATION_UPDATE_VERSION_ERROR": "Версия загруженного приложения ниже, чем существующего.",
        "SUBSCRIBERS_APPLICATION_LIST": "Списки приложений",
        "BULK_INTERACTIVE_APPLICATION_LIST": "Списки приложений",
        "BULK_SELECT_APPLICATION_LIST": "Выберите список приложений",
        "APP_APPLICATION_LIST_INTERACTIVE_WARNING_TITLE": "Вы точно хотите сохранить изменения?",
        "APP_DELETE_APPLICATION_LIST_WARNING_TITLE": "Вы точно хотите удалить список приложений?",
        "APPLICATION_LIST_ERROR_DUPLICATE_NAME": "название списке приложений не является уникальным",
        "APP_TOAST_ADD_APPLICATION_ERROR": "Приложение с таким же пакетом уже существует или отображается в списке приложений.",
        "APP_TOAST_ADD_APPLICATION_SUCCESS": "Приложение успешно добавлено.",
        "APP_TOAST_ADD_APPLICATION_UPDATE_SUCCESS": "Приложение успешно обновлено.",
        "APP_TOAST_REMOVE_APPLICATION": "Приложение успешно удалено.",
        "APP_TOAST_ADD_APPLICATION_RESERVED_ERROR": "Название пакета не может содержать зарезервированные слова или символы",
        "APP_MOVE_TAB_APPLICATION_LIST_WARNING_TITLE": "Предупреждение о сохранении изменений",
        "APP_MOVE_TAB_APPLICATION_LIST_WARNING_CONTENT": "Если вы не  сохраните изменения сейчас, они будут потеряны. Вы действительно хотите переключиться на другой раздел без сохранения?",
        "APPLICATION_LIST_WARNING_TITLE": "Предупреждения",
        "APPLICATION_LIST_WARNING_CONTENT": "Предупреждение: изменения, внесенные в эту область, немедленно повлияют на всех пользователей вашей организации.",
        "NAVIGATION_REACH_ME": "Отчеты Reach All",
        "REACH_ME_TITLE": "Отчеты Reach All",
        "REACH_ME_USERS": "Пользователи Reach All",
        "REACH_ME_GROUPS": "Группы Reach All",
        "REACH_ME_USER_NAME": "Имя пользователя",
        "REACH_ME_USER_ID": "ID пользователя",
        "REACH_ME_USER_PHONE": "Номер телефона",
        "REACH_ME_USER_IMEI": "IMEI",
        "REACH_ME_GROUP_NAME": "Название группы",
        "REACH_ME_GROUP_ID": "ID группы",
        "REACH_ME_GROUP_ADMIN_ID": "ID владельца",
        "REACH_ME_GROUP_ADMIN_NAME": "Имя владельца",
        "REACH_ME_GROUP_DIALOG_TITLE": "Детали группы Reach All",
        "REACH_ME_GROUP_MEMBER_NAME": "Имя участника",
        "REACH_ME_GROUP_MEMBER_ID": "Id участника",
        "REACH_ME_GROUP_USER": "Не удалось получить информацию из хранилища. Проверьте конфигурацию системы.",
        "REACH_ME_USER_LAST_SEEN": "Последнее посещение",
        "REACH_ME_USER_LAST_REGISTERED": "Последняя регистрация",
        "REACH_ME_USER_ACTIVITY_DIALOG_TITLE": "Отчет об активности пользователей",
        "REACH_ME_USER_ACTION": "Действие",
        "REACH_ME_USER_ACTION_TIME": "Время",
        "SUBSCRIBERS_SUBSCRIBER_LIST": "Список абонентов",
        "LOCALIZATION_FlAG": "Флаг локализации",
        "SMS_SERVICE": "СМС-СЕРВИС",
        "SMS_SEND_CREDENTIAL_WITHOUT_SERVER": "",
        "APP_TOAST_COLOR_ERROR": "",
        "APP_TOAST_IMAGE_FORMAT_ERROR": "",
        "APP_TOAST_IMAGE_SIZE_ERROR": "",
        "ACTIVITY_LOG_TITLE": "Журнал учета действий",
        "ACTIVITY_LOG_TIMESTAMP": "Время",
        "ACTIVITY_LOG_USER": "Администратор",
        "ACTIVITY_LOG_TYPE": "Тип",
        "ACTIVITY_LOG_NAME": "Название",
        "ACTIVITY_LOG_OPERATION": "Деятельность",
        "ACTIVITY_LOG_DESCRIPTION": "Описание",
        "BULK_EXPORT_ACTIVITY_LOG": "Отчет изменений",
        "RADIO_GROUP_CHAT": "Радио",
        "EMERGENCY_GROUP": "Группа экстренной помощи",
        "FORWARD_GROUP": "Группа поддержки",
        "FORWARD_GROUP_NAME": "",
        "CONFERENCE_GROUP_BROADCAST": "Конференция",
        "ORGANIZATION_CONTACT_GROUP": "Список контактов организации",
        "CONTACTS_TEMPLATE": "Шаблон контактов",
        "GENERATE_COMMON_PASSWORD": "Введённый пароль",
        "GENERATE_UNIQUE_PASSWORD": "Генерировать уникальные пароли",
        "ORGANIZATION_STRONG_ADMINISTRATOR_PASS": "Установить надежный пароль для администратора",
        "PLAYER_CLIENT_VERSION": "ВЕРСИЯ КЛИЕНТА ПРОИГРЫВАТЕЛЯ",
        "UNABLE_TO_ADD_MULTIPLE_EMERGENCY_GROUP": "Невозможно добавить несколько частных групп экстренного вызова",
        "SECONDARY_SITE_TITLE": "Назначить дополнительный сайт",
        "APP_SENTINEL": "Конфигурации Sentinel",
        "APP_PORT": "Порт",
        "PATH_NOTE": "Пожалуйста, добавьте '/' перед путем",
        "PATH_NOT_SET": "Путь не задан",
        "ORGANIZATION_API_ADD_PORTAL_URL_UQ_ERROR": "Не удалось добавить организацию. URL-адрес домена должен быть уникальным.",
        "APP_LIST_SHOW": "СПИСОК ПРИЛОЖЕНИЙ",
        "APP_LIVE_SENTINEL_EVENTS": "Живые события Sentinel",
        "APP_INFO": "Информация",
        "SENTINEL_INFO_TEXT": "Чтобы протестировать функциональность, используйте следующую конечную точку теста:",
        "URL_NOTE": "Пожалуйста, введите URL-адрес с «HTTP/S»",
        "APP_ROLE_FILTER": "Фильтровать по роли",
        "CONFIG_IPRS_WARNING": "Пожалуйста, сохраните то же значение для этой конфигурации на сервере!",
        "MOBILE_PORTAL_LOGO_IMAGE": "Изображение логотипа портала управления",
        "NAVIGATION_LOCATION_HISTORY": "История местоположений",
        "LOCATION_LATITUDE": "Широта",
        "LOCATION_LONGITUDE": "Долгота",
        "LOCATION_ACCURANCY": "Точность",
        "LOCATION_DATE_TIME": "Дата Время",
        "LOCATION_ACTIVITY": "Местоположение активности",
        "LOCATION_COUNT": "Количество местоположений",
        "BULK_EXPORT_LOCATION_HISTORY": "Экспортировать историю местоположений",
        "LOCATION_LAST_UPDATE_TIME": "Время последнего обновления",
        "BULK_CONTACT_TEMPLATE_SUB_TO_SUB": "Подписчик к подписчику",
        "BULK_EXPORT_APPLICATIONS": "Экспорт приложений",
        "BULK_EXPORT_ROLES": "Экспорт ролей",
        "NAVIGATION_MOVEORGANIZATION": "Миграция",
        "TRANSFER_RESELLER": "Передача реселлера",
        "TRANSFER_ORGANIZATION": "Организация трансфера",
        "TRANSFER_RESFORYOU": "Выберите исходного реселлера",
        "TRANSFER_PARENTRES": "Выберите целевого родительского реселлера",
        "TRANSFER_ORGFORYOU": "Выберите исходную организацию",
        "TRANSFER_ORGLIST": "Список организаций",
        "TRANSFER_SELECTRES": "Выберите реселлера",
        "TRANSFER_ORGANIZATION": "Организация трансфера",
        "NOT_SUPPORTED": "Нам не удалось получить сведения о приложении. Пожалуйста, вручную добавьте другие необходимые данные.",
        "CONTACT_LIMIT_EXCEEDED": "Превышен лимит контактов. Невозможно добавить больше, чем настроенный лимит",
        "API_RESELLER_DELETE_ERROR": "Невозможно удалить реселлера. Сначала удалите связанные организации.",
        "BULK_EXPORT_SUBSCRIBER_QR_CODE": "Экспортировать QR-коды подписчиков",
        "MOBILEAPP_DELETE_WARNING_CONTENT": "Если вы удалите это приложение, оно будет автоматически удалено из всех назначенных профилей приложений, и пользователи больше не будут иметь к нему доступа.",
        "DISABLE_REMEMBER_ME": "Отключить функцию «Запомнить последнего пользователя»",
        "APP_QR_WARNING_TITLE": "Повторная генерация аутентификации",
        "APP_QR_WARNING_CONTENT": "Вы уверены, что хотите повторно сгенерировать QR-код аутентификации?",
        "APP_QR_ENABLE_AUTHENTICATION": "Включить аутентификацию",
        "APP_QR_DISABLE_AUTHENTICATION": "Отключить аутентификацию",
        "APP_QR_REGENERATE_AUTHENTICATION": "Повторная генерация аутентификации",
        "APP_QR_TWO_FACTOR": "Два фактора",
        "APP_QR_DISABLE_TITLE": "Отключить аутентификацию",
        "APP_QR_DISABLE_CONTENT": "Вы уверены, что хотите отключить QR-код аутентификатора?",
        "APP_QR_ENABLE_SUCCESS": "Аутентификатор QR-кода успешно включен",
        "APP_QR_REGENERATE_SUCCESS": "Аутентификатор QR-кода успешно регенерирован",
        "APP_QR_DISABLE_SUCCESS": "QR-код аутентификатора успешно отключен",
        "APP_DISPATCHER_PERMISSION_LICENSE_WARNING": "Разрешение Dispatcher или Web-Dispatcher предоставляется одновременно..",
        "UserLimitExceeded":"Не удалось выполнить действие, так как достигнуто максимально допустимое количество пользователей. Пожалуйста, обновите свой тарифный план.",
        "BulkUserLimitExceeded":"Не удалось выполнить действие, так как достигнуто максимально допустимое количество пользователей. Пожалуйста, обновите свой тарифный план.",
        "SESSION_NAME": "Название сеанса",
        "MISSED_CALL": "Пропущенный звонок",
        "SESSION_ID": "ID сеанса",
        "SENDER_NAME": "Имя отправителя",
        "SENDER_ID": "ID отправителя",
        "RECIPIENT_NAME": "Имя получателя",
        "RECIPIENT_ID": "ID получателя",
        "SESSION_TYPE": "Тип сеанса",
        "SESSION_START_TIME": "Время начала сеанса",
        "SESSION_END_TIME": "Время окончания сеанса",
        "BURST_TALKER_NAME": "Имя активного говорящего",
        "BURST_TALKER_ID": "ID активного говорящего",
        "BURST_START_TIME": "Время начала активности",
        "BURST_END_TIME": "Время окончания активности",
        "DURATION": "Длительность"
      };
    }


  }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, $scope,$rootScope,$timeout)
    {
        var vm = this;
        $scope.loaderCounts = 1;
        $scope.shLodr = false;
        var timer;
        var hideTimer;
        // Data
        vm.themes = fuseTheming.themes;
        $rootScope.$$listeners.loaderMainUpdatedValue =[];
        $rootScope.$on('loaderMainUpdatedValue', function () {
            $scope.loaderCounts = parseInt($rootScope.loaderStatePercentage);
            $scope.shLodr = $rootScope.loaderState;
            // console.log($scope.shLodr)
            if($scope.loaderCounts == 100 || $scope.loaderCounts == 0)
                hideLoader();

            if($scope.loaderCounts > 95 )
                stopCounter();
            if($scope.loaderCounts < 10 && $scope.loaderCounts != 0)
                updateCounter();
            // console.log()
        });
        var updateCounter = function() {
            if($scope.loaderCounts < 100)
                $scope.loaderCounts++;
            timer = $timeout(function(){
                if($scope.loaderCounts > 95 )
                    stopCounter();
                if($scope.loaderCounts < 95 && $scope.loaderCounts != 0)
                    updateCounter();
            }, 1000);
        };
        var hideLoader = function() {
            hideTimer = $timeout(function(){
                // console.log('=========STOP===========');
                // console.log($scope.shLodr)
                $scope.shLodr = false;
            }, 1000);
        };
        // updateCounter();
        var stopCounter = function() {
            $timeout.cancel(timer);
            timer = null;
        };
        //////////
    }
})();
(function (){
    'use strict';

    angular
        .module('fuse')
      .constant('CONSTANT',  window.__CONFIG__);


    // function CONSTANT($rootScope, $http, $q){   
    //   var config = {};
    //   var deferred = $q.defer();
    //   $http.get("../assets/env.json").then(function(response) {
    //       $rootScope.envData = response.data;
    //       config = response.data;
    //       deferred.resolve(config);
    //   });   
    //   return {
    //     getConfig: function() {
    //       return deferred.promise;
    //     }
    //   }
    // }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config)
        // .factory('translations', function($q, $timeout, $resource, api, $http){
        //     return function (options) {
        //         var deferred = $q.defer();

        //         var key = "en";
        //         if (options && options.key)
        //             key = options.key;
        //         else if ($http.defaults.headers.common['Accept-Language'])
        //             key = $http.defaults.headers.common['Accept-Language'];

        //         if (!$http.defaults.headers.common['api_key'] || $http.defaults.headers.common['api_key'] == ''){
        //             if (key === 'es') {
        //                 var translations = {
        //                     "LOGIN_INTRO_TITLE": "¡Bienvenido al portal de Administración!",
        //                     "LOGIN_TITLE": "Iniciar sesión en su cuenta",
        //                     "LOGIN_EMAIL": "Email",
        //                     "LOGIN_PASSWORD": "Contraseña",
        //                     "LOGIN_REMEMBER_ME": "Recuérdame",
        //                     "LOGIN_FORGOT_PASSWORD": "¿Has olvidado tu contraseña?",
        //                     "LOGIN_LOG_IN": "Iniciar Sesión",
        //                     "LOGIN_ERRORS_EMAIL_REQUIRED": "Email es campo requerido.",
        //                     "LOGIN_ERRORS_EMAIL_MUST_VALID": "Email debe ser una dirección de correo electrónico válida.",
        //                     "LOGIN_ERRORS_PASSWORD_REQUIRED": "Contraseña es campo requerido.",
        //                     "LOGIN_CONTACT_ADMIN":"¿Has olvidado tu contraseña? Contacte al administrador por favor"
        //                 };
        //               }
        //               else if (key === 'he'){
        //                 var translations = {
        //                     "LOGIN_INTRO_TITLE": "!ברוכים הבאים לאתר הניהול",
        //                     "LOGIN_TITLE": "הכנס/י לחשבונך",
        //                     "LOGIN_EMAIL": "שם משתמש",
        //                     "LOGIN_PASSWORD": "סיסמה",
        //                     "LOGIN_REMEMBER_ME": "שמור את פרטי המשתמש",
        //                     "LOGIN_FORGOT_PASSWORD": "?שכחת את הסיסמה",
        //                     "LOGIN_LOG_IN": "כניסה לשרות",
        //                     "LOGIN_ERRORS_EMAIL_REQUIRED": "אנא הקלד כתובת אימייל",
        //                     "LOGIN_ERRORS_EMAIL_MUST_VALID": "כתובת האימייל חייבת להיות חוקית",
        //                     "LOGIN_ERRORS_PASSWORD_REQUIRED": "אנא הקלד סיסמה",
        //                     "LOGIN_CONTACT_ADMIN":"!אינך זוכר את הסיסמה או את שם המשתמש? צור קשר עם ספק השרות"
        //                 };
        //               }
        //               else{  //english
        //                 var translations = {
        //                     "LOGIN_INTRO_TITLE": "Welcome to the Administration portal!",
        //                     "LOGIN_TITLE": "Sign in to your account",
        //                     "LOGIN_EMAIL": "Email",
        //                     "LOGIN_PASSWORD": "Password",
        //                     "LOGIN_REMEMBER_ME": "Remember Me",
        //                     "LOGIN_FORGOT_PASSWORD": "Forgot Password?",
        //                     "LOGIN_LOG_IN": "LOG IN",
        //                     "LOGIN_ERRORS_EMAIL_REQUIRED": "Email field is required",
        //                     "LOGIN_ERRORS_EMAIL_MUST_VALID": "Email must be a valid e-mail address",
        //                     "LOGIN_ERRORS_PASSWORD_REQUIRED": "Password field is required",
        //                     "LOGIN_CONTACT_ADMIN":"Forget your password? Please contact your service administrator"
        //                 };
        //               }
        //               deferred.resolve(translations);
        //         }
        //         else{
        //             $http.get('http://localhost:8002/api/localization/' + key).then(function(translations){
        //                 deferred.resolve(translations.data);
        //             });
        //             api.translation.get.query({translationCode: key},
        //             function(translations) {
        //                 deferred.resolve(translations);

        //             }, function (err) {
        //                 deferred.reject(err);
        //             });
        //     }
        //         return deferred.promise;
        //     }

        //     });

    /** @ngInject */
    function config($translateProvider, $translatePartialLoaderProvider, $httpProvider, indexProvider)
    {
        // Put your common app configurations here
        $httpProvider.interceptors.push('tokenRefresh');


        //$translateProvider.useLoader('translations');

        $translateProvider.translations('en', indexProvider.get_en());

        $translateProvider.translations('es', indexProvider.get_es());

        $translateProvider.translations('he', indexProvider.get_he());

        $translateProvider.translations('ru', indexProvider.get_ru());

        $translateProvider
    // .useStaticFilesLoader({
    //     prefix: '/translations/locale-',
    //     suffix: '.json'
    // })
    .preferredLanguage('en')
    .useLocalStorage()
    .useSanitizeValueStrategy('escape');

        //$translateProvider.preferredLanguage('en');
        // $translateProvider.fallbackLanguage('en');
        // $translateProvider.useSanitizeValueStrategy('escape');
        // $translateProvider.useLocalStorage();

      // Translation
      //$translatePartialLoaderProvider.addPart('./app');

    }

})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .factory('api', apiService);

  /** @ngInject */
  function apiService($resource, $location, CONSTANT, $http, $rootScope) {
    /**
     * You can use this service to define your API urls. The "api" service
     * is designed to work in parallel with "apiResolver" service which you can
     * find in the "app/core/services/api-resolver.service.js" file.
     *
     * You can structure your API urls whatever the way you want to structure them.
     * You can either use very simple definitions, or you can use multi-dimensional
     * objects.
     *
     * Here's a very simple API url definition example:
     *
     *      api.getBlogList = $resource('http://api.example.com/getBlogList');
     *
     * While this is a perfectly valid $resource definition, most of the time you will
     * find yourself in a more complex situation where you want url parameters:
     *
     *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
     *
     * You can also define your custom methods. Custom method definitions allow you to
     * add hardcoded parameters to your API calls that you want to sent every time you
     * make that API call:
     *
     *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
     *
     * In addition to these definitions, you can also create multi-dimensional objects.
     * They are nothing to do with the $resource object, it's just a more convenient
     * way that we have created for you to packing your related API urls together:
     *
     *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
     *
     * If you look at the last example from above, we overrode the 'get' method to put a
     * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
     * object will also be sent along with whatever data we are sending.
     *
     * All the above methods are using standard $resource service. You can learn more about
     * it at: https://docs.angularjs.org/api/ngResource/service/$resource
     *
     * -----
     *
     * After you defined your API urls, you can use them in Controllers, Services and even
     * in the UIRouter state definitions.
     *
     * If we use the last example from above, you can do an API call in your Controllers and
     * Services like this:
     *
     *      function MyController (api)
     *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
     *
     * Because we are directly using $resource service, all your API calls will return a
     * $promise object.
     *
     * --
     *
     * If you want to do the same calls in your UI Router state definitions, you need to use
     * "apiResolver" service we have prepared for you:
     *
     *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
     *
     *  You can even use parameters with apiResolver service:
     *
     *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

    var api = {};
    // Base Url
    var host = $location.host();
    api.baseUrl = 'app/data/';
    // api.restUri =  CONSTANT.API_URL || "//" + host + ":8002/api";
    api.restUri = "//" + host + ":8002/api" || CONSTANT.API_URL;
    //api.restUri2 = "//" + host + ":8003/api" || CONSTANT.API_URL;

    // api.sample = $resource(api.baseUrl + 'sample/sample.json');

    api.roles = {
      list: $resource(api.restUri + '/role/list'),
      listByOrg: $resource(api.restUri + '/role/list/orgnode/new/:nodeId'),
      list_resources: $resource(api.restUri + '/role/list_resources'),
      newRole: $resource(api.restUri + '/role'),
      defaultRoles: $resource(api.restUri + '/role/default/:organizationId'),
      updateRole: $resource(api.restUri + '/role/:id', {}, {put: {method: 'PUT'}}),
      deleteRoleByNode: $resource(api.restUri + '/role/:id/orgnode/:nodeId')
    };

    api.admins = {
      list: $resource(api.restUri + '/user/list'),
      listByOrg: $resource(api.restUri + '/user/list/orgnode/:nodeId'),
      strongPassword: $resource(api.restUri + '/user/strongPassword/:email'),
      newUser: $resource(api.restUri + '/user'),
      updateUser: $resource(api.restUri + '/user/:id', {}, {put: {method: 'PUT'}}),
      deleteUser: $resource(api.restUri + '/user/:id'),
      releaseUser: $resource(api.restUri + '/user/release/:id', {}, {put: {method: 'PUT'}}),
      blockUser: $resource(api.restUri + '/user/block/:id', {}, {put: {method: 'PUT'}}),
      changePassword: $resource(api.restUri + '/user/update/password', {}, {put: {method: 'PUT'}}),
    };

    api.auth = $resource(api.restUri + '/authenticate');
    api.recoverPassword = $resource(api.restUri + '/recoverpassword');
    api.refreshToken = $resource(api.restUri + '/authenticate/refreshtoken',  {}, {query: {method: 'GET'}, isArray:false});

    api.version = $resource(api.restUri + '/version', {}, {query: {method: 'GET'}, isArray:false});
    api.translation =  {
      import: $resource(api.restUri + '/localization/import/:translationCode',{}, {put: {method: 'PUT'}}),
      get: $resource(api.restUri + '/localization/:translationCode',  {}, {query: {method: 'GET'}, isArray:false}),
    }

    return api;
  }

})();

(function () {
  'use strict';
  angular.module('app.restricted.platform', [
    //'app.restricted.devices',
    //'app.restricted.deviceManufacturers',
    'app.restricted.licenses',
    //'app.restricted.softwareManufacturers',
    //'app.restricted.client-version',
    //'app.restricted.ptt-client-store',
    //'app.restricted.ptt-devices',
    'app.restricted.server-config',
    //'app.restricted.localization',    //removed translations because we changed the location of json (from client to server) and need to fix localiztion accordingly 
    'app.restricted.report',
    'app.restricted.move-organization'
    //'app.restricted.job'
  ]).config(config);

  /** @ngInject */
  function config(msNavigationServiceProvider) {

    // Navigation
    msNavigationServiceProvider.saveItem('Platform', {
      title: 'Platform',
      icon: '',
      state: '',
      translate: 'NAVIGATION_PLATFORM',
      weight: 2
    });
  }
})();

angular.module('app.restricted.organisation', [
  'app.restricted.organization-details',
  'app.restricted.subscribers',
  'app.restricted.groups',
  'app.restricted.contacts',
  // 'app.restricted.organization-friends',
  //'app.restricted.subscriberLists',
  //'app.restricted.emergencyGroups',
  'app.restricted.batch',
  'app.restricted.recording',
  'app.restricted.wfm',
  'app.restricted.callLogs',
  'app.restricted.applicationLists',
  'app.restricted.locationHistory'
]).config(config);

/** @ngInject */
function config(msNavigationServiceProvider) {

  // Navigation
  msNavigationServiceProvider.saveItem('Organization', {
    title: 'Organization',
    icon: '',
    state: '',
    translate: 'NAVIGATION_ORGANIZATION',
    weight: 1
  });
}

(function ()
{
  'use strict';

  angular
    .module('app.restricted.general', [
      'app.restricted.customer',
      'app.restricted.dashboard'
    ]);
})();

(function ()
{
  'use strict';

  angular
    .module('app.restricted.administration', [
      'app.restricted.administrators', 'app.restricted.roles', 'app.restricted.activityLog'
    ]).config(config);

  /** @ngInject */
  function config(msNavigationServiceProvider) {

    // Navigation
    msNavigationServiceProvider.saveItem('Administration', {
      title: 'Administration',
      icon: '',
      state: '',
      translate: 'NAVIGATION_ADMINISTRATION',
      weight: 4
    });
  }
})();

angular.module('shared', [
  'treeView',
  'choose-list',
  'choose-list-mute',
  'choose-list-bind',
  'choose-list-bind-personal-group',
  'treeSelect',
  'password-fields',
  'ngCsvImport',
  'choose-list-select',
  'choose-list-bulk-license',
  'choose-list-bind-muted',
  'choose-list-select-bind-muted',
  'lefttreeSelect'
]);

(function () {
  'use strict';

  angular.module('app.services', [
    'app.user',
    'app.organization',
    'app.orgFriends',
    'app.auth',
    'app.license',
    'app.manufacturer',
    'app.device',
    'app.ptt-device',
    'app.client-store',
    'app.contact',
    'app.helper',
    'app.group',
    'app.fwrdgroup',
    'app.site',
    'app.handset-type',
    'app.client-type',
    'app.country',
    'app.reseller',
    'app.operator',
    'app.subscriber',
    'app.context',
    'app.server-config',
    'app.server',
    'app.exception-handler',
    'app.client-version',
    'app.interceptor',
    'app.jobs',
    'app.toast-service',
    'app.personal-contacts',
    'app.personal-group',
    'app.role',
    'app.securityLog',
    'app.sms',
    'app.toolbarModule',
    'app.admin-record',
    'app.audio-backup-path',
    'app.branding',
    'app.record-white-list',
    'app.report',
    'app.call-logs',
    'app.application-list',
    'app.wfm',
    'app.passwords',
    'app.progress-circular',
    'app.location-history'
  ]);
})();

(function () {
  'use strict';

  angular.module('app.restricted', [])
    .config(restrictedConfig)
    .filter('searchByName', function () {
      return function (items, phrase) {
        var filtered = [];
        if (phrase == "") return items;

        if(items){
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var searchString = phrase.toLowerCase().trim();
            if (item.name){
              if (item.name.toLowerCase().indexOf(searchString) !== -1) {
                filtered.push(item);
              }
            }
          }
          return filtered;
        }
      };
    })
    .filter('searchByUsername', function () {
      return function (items, phrase) {
        var filtered = [];
        if (phrase == "") return items;
        if(items){
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var searchString = phrase.toLowerCase().trim();
            if (item.username){
              if (item.username.toLowerCase().indexOf(searchString) !== -1) {
                filtered.push(item);
              }
            }
          }
          return filtered;
        }
      };
    })
    .filter('searchSubscribers', function () {
      return function (items, phrase, showIMSI2) {
        var filtered = [];
        if (phrase == "") return items;

        if(items){
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var searchString = phrase.toLowerCase().trim();
            if (item){
              if (item.name && item.name.toLowerCase().indexOf(searchString) !== -1) {
                filtered.push(item);
              }
              else if (item._id && item._id.toLowerCase().indexOf(searchString) !== -1) {
                filtered.push(item);
              }
              else if (item.sip && item.sip.toLowerCase().indexOf(searchString) !== -1) {
                filtered.push(item);
              }
              else if (item.imsi && item.imsi.toLowerCase().indexOf(searchString) !== -1) {
                filtered.push(item);
              }
              else if (showIMSI2 == true && item.imsi2 && item.imsi2.toLowerCase().indexOf(searchString) !== -1) {
                filtered.push(item);
              }
            }
          }
          return filtered;
        }
      };
    })
    .filter('searchCallLog', function () {
      return function (items, phrase) {
        var filtered = [];
        if (phrase == "") return items;
        if(items){
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var searchString = phrase.toLowerCase().trim();
            if (item.session_name && item.session_name.toString().toLowerCase().indexOf(searchString) !== -1) {
              filtered.push(item);
            }
            else if (item.session_id && item.session_id.toString().toLowerCase().indexOf(searchString) !== -1) {
              filtered.push(item);
            }
          }
          return filtered;
        }
      };
    })
    .filter('searchByTalkerName', function () {
      return function (items, phrase) {
        var filtered = [];
        if (phrase == "") return items;
        if(items){
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var searchString = phrase.toLowerCase().trim();
            if (item.talker_name){
              if (item.talker_name.toLowerCase().indexOf(searchString) !== -1) {
                filtered.push(item);
              }
            }
          }
          return filtered;
        }
      };
    })
    .filter('searchByTitle', function () {
      return function (items, phrase) {
        var filtered = [];
        if (phrase == "") return items;

        if(items){
          for (var i in items) {
            var item = items[i];
            var searchString = phrase.toLowerCase().trim();
            if (item.title){
              if (item.title.toLowerCase().indexOf(searchString) !== -1) {
                filtered.push(item);
              }
            }
          }
          return filtered;
        }
      };
    })
    .filter('searchActivityLog', function () {
      return function (items, phrase) {
        var filtered = [];
        if (phrase == "") return items;
        if(items && phrase){
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var searchString = phrase.toLowerCase().trim();
            if (item.timestamp && item.timestamp.toString().toLowerCase().indexOf(searchString) !== -1) {
              filtered.push(item);
            }
            if (item.administrator_name && item.administrator_name.toLowerCase().indexOf(searchString) !== -1) {
              filtered.push(item);
            }
            else if (item.key1_type && item.key1_type.toString().toLowerCase().indexOf(searchString) !== -1) {
              filtered.push(item);
            }
            else if (item.org_node_id && item.org_node_id.toString().toLowerCase().indexOf(searchString) !== -1) {
              filtered.push(item);
            }
            else if (item.key1_name && item.key1_name.toString().toLowerCase().indexOf(searchString) !== -1) {
              filtered.push(item);
            }
            else if (item.description && item.description.toString().toLowerCase().indexOf(searchString) !== -1) {
              filtered.push(item);
            }
            else if (item.new_value && item.new_value.toString().toLowerCase().indexOf(searchString) !== -1) {
              filtered.push(item);
            }
          }
          return filtered;
        }
      };
    })
    .filter('getOffNetUsers', function () {
      return function (items) {
        var filtered = [];

        if(items){
          for (var i in items) {
            var item = items[i];
            if (item != undefined && item.offnet){
              if (item.offnet) {
                filtered.push(item);
              }
            }
          }
          return filtered;
        }
      };
    })
    .filter('searchByApp', function () {
      return function(dataArray, searchTerm) {
        if (!dataArray) {
            return;
        }
        else if (!searchTerm) {
            return dataArray;
        }
        else {
             var term = searchTerm.toLowerCase().trim();
             return dataArray.filter(function(item){
                var termInName = item.name.toLowerCase().indexOf(term) > -1;
                var termInPackage = item.package.toLowerCase().indexOf(term) > -1;
                return termInName || termInPackage;
             });
        }
      };
    })
    .filter('searchLocationHistory', function () {
      return function (items, phrase) {
        var filtered = [];
        if (phrase == "") return items;
        if(items){
          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var searchString = phrase.toLowerCase().trim();
            if (item.display_name && item.display_name.toString().toLowerCase().indexOf(searchString) !== -1) {
              filtered.push(item);
            }
            else if (item.user_id && item.user_id.toString().toLowerCase().indexOf(searchString) !== -1) {
              filtered.push(item);
            }
          }
          return filtered;
        }
      };
    });

  /** @ngInject */
  function restrictedConfig($stateProvider) {
    var layouts = {
      verticalNavigation: {
        main: 'app/core/layouts/vertical-navigation.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      }
    };

    $stateProvider
      .state('app.restricted', {
        abstract: true,
        views: {
          'main@': {
            templateUrl: layouts.verticalNavigation.main,
            controller: 'MainController as vm'
          },
          'toolbar@app.restricted': {
            templateUrl: layouts.verticalNavigation.toolbar,
            controller: 'ToolbarController as vm'
          },
          'navigation@app.restricted': {
            templateUrl: layouts.verticalNavigation.navigation,
            controller: 'NavigationController as vm'
          }
        },
        resolve: {
          isAuth: function ($q, $state, $timeout, Auth) {
            var deferred = $q.defer();

            if (Auth.isAuth()) {
              deferred.resolve();
            } else {
              $timeout(function () {
                $state.go('app.pages_auth_login')
              });
              deferred.reject();
            }

            return deferred.promise;
          }
        }
      });
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
            'app.pages.auth.login-v2',
            'app.pages.auth.change.password',
            'app.pages.auth.register',
            'app.pages.auth.register-v2',
            'app.pages.auth.forgot-password',
            'app.pages.auth.reset-password',
            'app.pages.auth.lock',
            'app.pages.coming-soon',
            'app.pages.error-404',
            'app.pages.error-500',
            'app.pages.invoice',
            'app.pages.maintenance',
            'app.pages.profile',
            'app.pages.search',
            'app.pages.timeline'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('pages', {
            title : 'PAGES',
            group : true,
            weight: 2
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.help', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider
        .state('app.help_index', {
            url      : '/help/index',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_index': {
                    templateUrl: 'app/help-files/Index.html'
                }
            }
        })
        .state('app.help_organization', {
            url      : '/help/organization',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization': {
                    templateUrl: 'app/help-files/Organization.html'
                }
            }
        })
        .state('app.help_reseller', {
            url      : '/help/reseller',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_reseller': {
                    templateUrl: 'app/help-files/Reseller.html'
                }
            }
        })
        .state('app.help_platform', {
            url      : '/help/platform',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_platform': {
                    templateUrl: 'app/help-files/Platform.html'
                }
            }
        })
        .state('app.help_administration', {
            url      : '/help/administration',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_administration': {
                    templateUrl: 'app/help-files/MainAdministrators.html'
                }
            }
        })


        //organization
        .state('app.help_organization_details', {
            url      : '/help/organization/details',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_details': {
                    templateUrl: 'app/help-files/OrganizationDetails.html'
                }
            }
        })
        .state('app.help_organization_groups', {
            url      : '/help/organization/groups',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_groups': {
                    templateUrl: 'app/help-files/Groups.html'
                }
            }
        })
        .state('app.help_organization_subscribers', {
            url      : '/help/organization/subscribers',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_subscribers': {
                    templateUrl: 'app/help-files/Subscribers.html'
                }
            }
        })
        .state('app.help_organization_contacts', {
            url      : '/help/organization/contacts',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_contacts': {
                    templateUrl: 'app/help-files/Contacts.html'
                }
            }
        })
        .state('app.help_organization_mainBulkOperations', {
            url      : '/help/organization/bulk',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_mainBulkOperations': {
                    templateUrl: 'app/help-files/MainBulkOperations.html'
                }
            }
        })
        .state('app.help_organization_recordingPlanner', {
            url      : '/help/organization/recordingPlanner',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_recordingPlanner': {
                    templateUrl: 'app/help-files/RecordingPlanner.html'
                }
            }
        })
        .state('app.help_organization_workforceManagement', {
            url      : '/help/organization/workForceManagement',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_workforceManagement': {
                    templateUrl: 'app/help-files/WorkforceManagement.html'
                }
            }
        })
        .state('app.help_organization_callLog', {
            url      : '/help/organization/callLog',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_callLog': {
                    templateUrl: 'app/help-files/CallLog.html'
                }
            }
        })
        .state('app.help_organization_applicationLists', {
            url      : '/help/organization/mobileAppsPlanning',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_applicationLists': {
                    templateUrl: 'app/help-files/MobileAppsPlanning.html'
                }
            }
        })

         //bulk operation
         .state('app.help_organization_bulk_operation', {
            url      : '/help/organization/bulk/operations',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_bulk_operation': {
                    templateUrl: 'app/help-files/BulkOperations.html'
                }
            }
        })
        .state('app.help_organization_bulk_delete', {
            url      : '/help/organization/bulk/delete',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_bulk_delete': {
                    templateUrl: 'app/help-files/Deletion.html'
                }
            }
        })
        .state('app.help_organization_bulk_password', {
            url      : '/help/organization/bulk/password',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_bulk_password': {
                    templateUrl: 'app/help-files/PasswordModification.html'
                }
            }
        })
        .state('app.help_organization_bulk_license', {
            url      : '/help/organization/bulk/license',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_bulk_license': {
                    templateUrl: 'app/help-files/BulkLicense.html'
                }
            }
        })
        .state('app.help_organization_bulk_role', {
            url      : '/help/organization/bulk/role',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_bulk_role': {
                    templateUrl: 'app/help-files/BulkRole.html'
                }
            }
        })
        .state('app.help_organization_bulk_applist', {
            url      : '/help/organization/bulk/applist',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_bulk_applist': {
                    templateUrl: 'app/help-files/BulkAppListAssign.html'
                }
            }
        })
        .state('app.help_organization_bulk_emergency', {
            url      : '/help/organization/bulk/emergency',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_bulk_emergency': {
                    templateUrl: 'app/help-files/BulkEmergencyGroups.html'
                }
            }
        })
        .state('app.help_organization_bulk_sms', {
            url      : '/help/organization/bulk/sms',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_bulk_sms': {
                    templateUrl: 'app/help-files/SMSProvisioning.html'
                }
            }
        })
        .state('app.help_organization_bulk_reports', {
            url      : '/help/organization/bulk/reports',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_bulk_reports': {
                    templateUrl: 'app/help-files/BulkReports.html'
                }
            }
        })

        //recording
        .state('app.help_organization_recordingPlanner_reviewers', {
            url      : '/help/organization/recordingPlanner/reviewers',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_recordingPlanner_reviewers': {
                    templateUrl: 'app/help-files/RecordingsReviewers.html'
                }
            }
        })
        .state('app.help_organization_recordingPlanner_storagemanagement', {
            url      : '/help/organization/recordingPlanner/storagemanagement',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_recordingPlanner_storagemanagement': {
                    templateUrl: 'app/help-files/StorageManagement.html'
                }
            }
        })
        .state('app.help_organization_recordingPlanner_users', {
            url      : '/help/organization/recordingPlanner/users',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_recordingPlanner_users': {
                    templateUrl: 'app/help-files/RecordedUsers.html'
                }
            }
        })
        .state('app.help_organization_recordingPlanner_groups', {
            url      : '/help/organization/recordingPlanner/groups',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_recordingPlanner_groups': {
                    templateUrl: 'app/help-files/RecordedGroups.html'
                }
            }
        })

        //applicationLists
        .state('app.help_organization_applicationLists_applications', {
            url      : '/help/organization/mobileAppsPlanning/applications',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_applicationLists_applications': {
                    templateUrl: 'app/help-files/Applications.html'
                }
            }
        })
        .state('app.help_organization_applicationLists_applicationProfiles', {
            url      : '/help/organization/mobileAppsPlanning/applicationProfiles',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_organization_applicationLists_applicationProfiles': {
                    templateUrl: 'app/help-files/ApplicationProfiles.html'
                }
            }
        })

        //reseller
        .state('app.help_reseller_resellerDetails', {
            url      : '/help/reseller/resellerDetails',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_reseller_resellerDetails': {
                    templateUrl: 'app/help-files/ResellerDetails.html'
                }
            }
        })
        .state('app.help_reseller_resellerManager', {
            url      : '/help/reseller/resellerManager',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_reseller_resellerManager': {
                    templateUrl: 'app/help-files/ResellerManager.html'
                }
            }
        })
        .state('app.help_reseller_organizationManager', {
            url      : '/help/reseller/organizationManager',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_reseller_organizationManager': {
                    templateUrl: 'app/help-files/OrganizationManager.html'
                }
            }
        })

        //platform
        .state('app.help_platform_licenses', {
            url      : '/help/platform/licenses',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_platform_licenses': {
                    templateUrl: 'app/help-files/Licenses.html'
                }
            }
        })
        .state('app.help_platform_SystemConfiguration', {
            url      : '/help/platform/SystemConfiguration',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_platform_SystemConfiguration': {
                    templateUrl: 'app/help-files/SystemConfiguration.html'
                }
            }
        })
        .state('app.help_platform_localization', {
            url      : '/help/platform/localization',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_platform_localization': {
                    templateUrl: 'app/help-files/Localization.html'
                }
            }
        })
        .state('app.help_platform_preports', {
            url      : '/help/platform/reports',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_platform_preports': {
                    templateUrl: 'app/help-files/PReports.html'
                }
            }
        })

        //platform license
        .state('app.help_platform_licenses_templates', {
            url      : '/help/platform/licenses/templates',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_platform_licenses_templates': {
                    templateUrl: 'app/help-files/LicenseTemplates.html'
                }
            }
        })
        .state('app.help_platform_licenses_code', {
            url      : '/help/platform/licenses/codeGeneration',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_platform_licenses_code': {
                    templateUrl: 'app/help-files/LicenseCodeGeneration.html'
                }
            }
        })

        //administration
        .state('app.help_administration_admins', {
            url      : '/help/administration/admins',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_administration_admins': {
                    templateUrl: 'app/help-files/Administrators.html'
                }
            }
        })
        .state('app.help_administration_roles', {
            url      : '/help/administration/roles',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_administration_roles': {
                    templateUrl: 'app/help-files/Roles.html'
                }
            }
        })
        .state('app.help_administration_activitylog', {
            url      : '/help/administration/activityLog',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.help_administration_activitylog': {
                    templateUrl: 'app/help-files/ActivityLog.html'
                }
            }
        })


        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/auth/login');

    }

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/help-files/ActivityLog.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Activity Log</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>The \n<b>Activity Log</b>\n sub-menu displays activities performed by the administrator. If the administrator possesses the root admin rights, the page will display the activities of all the administrators in the system. Else, the page will display the activities of the active signed-in administrator only, along with the details like timestamp, administrator, type, name, operation, and description.\n</p><p>\nBy default, it displays the activity details of the current day. To view the details of the desired date, select the start date and end date using the calendar icons, and the data will be displayed in the table.\n<br></p><p>Click the <b>Refresh</b>\n icon to refresh the data. You can also export the data to CSV or Excel format by clicking the <b>Activity Log Report\n</b> button.</p>If required you can sort the records list in ascending or descending order.<br><br><br><br><b><a \nhref=\"help/platform\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/Administrators.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Administrators</h1></div><span id=\"search\"></span> \n<span id=\"add\"></span><div class=\"content\"><p>\nAdministrators sub-menu allows managing the administrators. You can create role-based administrators from this page.\n<br><br>To view the administrators\' page, on the left pane navigate to <b>Administrators > Administrators</b>.<br><br>\nFrom this page, you can <a href=\"help/administration/admins#search\">search<a>, <a \nhref=\"help/administration/admins#add\">add</a>, <a href=\"help/administration/admins#edit\">edit</a>, <a \nhref=\"help/administration/admins#delete\">delete</a>\n, and lock an administrator account from the portal. You can also sort the records in ascending or descending order of the respective fields. Moreover, you can define the number of records getting displayed in the table using the \n<b>Records</b> dropdown list located below the table.</a></a></p><br><h3 id=\"search\" style=\"font-weight: bold\">Search\n</h3><p>To search a required administrator from the list,</p><ul><li>Type a few characters in the <b>Search</b>\n field and a list of administrators containing those characters will be displayed.</li></ul><br><br><h3 id=\"lock\" \nstyle=\"font-weight: bold\">Lock/Unlock Administrator Account</h3><p>\nWhen an administrator tries to sign-in to the provisioning portal with wrong credentials and exceeds the maximum number of retries, the account gets locked. The administrators can lock or unlock the account from the Administrators main page.\n</p><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThis feature is available if the value of the parameter <b>PROV_SHOW_BLOCK_RELEASE_ADMINISTRATORS</b> is set as <b>1\n</b> in the Platform System Configuration Custom page. (Root Admins only).</li><br><li>\nThe maximum number of sign-in retries can be defined in the parameter <b>PROV_MAX_LOGIN_RETRIES</b>\n from the Platform System Configuration Custom page. <b>The default value is 3</b>.</li><br></ul><p>\nTo lock an account, click the <b>lock</b> icon next to any administrator’s email id and a dialog appears.<br><br>Click \n<b>OK</b> and a confirmation message <b>&#34Account has been blocked successfully.&#34</b>\n appears on the screen. Also, the selected administrator\'s entry changes to a red color.<br><br>\nSimilarly, on clicking the <b>red lock</b> icon the locked account gets unlocked.</p><br><h3 id=\"add\" \nstyle=\"font-weight: bold\">Adding or Editing an Administrator</h3><p>\nTo add or edit an administrator, follow the steps below:</p><ol><li>\nSelect a high-level Reseller from the Resellers dropdown list.</li><br><li>On the left pane navigate to <b>\nAdministrators > Administrators</b> sub-menu.</li><br><li>Click the <b>Add</b> button and the <b>Adminsitrators</b>\n pop-up window appears.</li><br><li>Provide the following details:</li><br><table class=\"a\" align=\"center\" \ncellpadding=\"10\"><col width=\"30%\"><col width=\"70%\"><tr style=\"background-color: #3492DD\" height=\"40px\"><th \nstyle=\"font-size:20px\">Parameters</th><th style=\"font-size:20px\">Description</th></tr><tr><td>Select Role</td><td>\nSelect the role to be assigned to the administrator. These roles are created from the <a \nhref=\"help/administration/roles\">Roles</a> page.</td></tr><tr><td>Email</td><td>\nThe email address of the administrator to be created. This email address will be used for signing-in the portal.</td>\n</tr><tr><td>Password</td><td>A secured password for the administrator.<br><br><ul style=\"background-color: lightgrey\">\n<b><i><u>Notes</u></i></b>:<br><br><li>\nA strong password must contain 10 to 15 characters with at least 1 numeric, 1 lowercase, 1 uppercase, and 1 special character _@.#$=!%^)(:*;?/,`~&;}{\'|>[&+-].\n</li><br><li>A password should not contain identical and consecutive characters or numbers.</li><br></ul>\nIf required click the <b>Generate Password</b>\n icon to generate a strong password for you. On clicking, a system-generated password will be available and used for signing in the Administration portal.\n<br><br>To view the hidden password, click the <b>View Password</b> icon.</td></tr><tr><td>Retype Password</td><td>\nRetype the password for confirmation.</td></tr><tr><td>Generate Password</td><td>An optional password generation.</td>\n</tr><tr><td>Show Password</td><td>Click to view the hidden password.</td></tr></table><br><br><li>Click <b>Save</b>\n and the newly added administrator gets displayed in the table.</li><br><li id=\"edit\">To <b>edit</b>\n, click on the required <b>administrator</b> to be edited and the Administrators pop-up window appears.</li><br><li>\nEdit the role and email address of the administrator.</li><br><li>You can change the password using the <b>\nchange password</b> option.</li><br><li>Enter a <b>new password</b>\n in the password and retype password fields or use the <b>generate password</b>\n button to generate a strong password. You can also view the entered password using the <b>view password</b> icon.</li>\n<br><li>Once done, click <b>Save</b> and a confirmation message stating <b>&#34Updated Successfully&#34</b>\n appears on the screen.</li><br><li id=\"delete\">To <b>delete</b> an administrator, click the <b>remove</b>\n icon next. A dialog box appears. Click the <b>Remove</b> button to delete the selected administrator.</li><br></ol>\n<br><br><b><a href=\"help/administration/admins#top\" target=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"help/administration\" align=\"left\">Back</a></b><br><br><br><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/ApplicationProfiles.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Application Profiles</h1></div><span id=\"S1\">\n</span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe administrator can assign application profiles to the relevant users.</p><p>\nTo manage the application profiles, navigate to <b>Organization > Mobile Apps Planning > Application Profiles</b>\n and the dialog appears.</p>From this page, you can <a \nhref=\"help/organization/mobileAppsPlanning/applicationProfiles#search\">search</a>, <a \nhref=\"help/organization/mobileAppsPlanning/applicationProfiles#add\">add</a>, <a \nhref=\"help/organization/mobileAppsPlanning/applicationProfiles#edit\">edit</a>, <a \nhref=\"help/organization/mobileAppsPlanning/applicationProfiles#delete\">delete</a>, and <a \nhref=\"help/organization/mobileAppsPlanning/applicationProfiles#clone\">clone</a>\n an application profile for the selected organization. You can also define the number of records getting displayed in the table using the \n<b>Records</b> dropdown list located below the table.<p></p><br><h3 id=\"search\" style=\"font-weight: bold\">Search</h3>\n<p>To search a required application profile from the list,</p><ul><li>Type a few characters in the <b>Search</b>\n field near the magnifying glass and a list of application profiles containing the typed letters will be displayed.\n</li></ul><br><h3 id=\"add\" style=\"font-weight: bold\">Adding or Editing an Application List</h3><p>\nTo add or edit an application list, follow the steps below:</p><ol><li>Click the <b>Add</b> button and the <b>\nApplication List</b> pop-up window appears.</li><br><li>Enter the <b>App List</b> name</li><br><li><b>Select the Apps\n</b> (default or added) that can use the <b>microphone</b> or are allowed in <b>Kiosk mode</b>.<br><p \nstyle=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: The applications added in the Applications tab are displayed in this table to be added in the list.</p></li><li>\nOnce done, click <b>Save</b> and the app list gets displayed in the table.</li><br><li>To <b>edit</b>\n, click on the required list name and the <b>Application List</b> pop-up window appears. Make the changes, click <b>\nSave</b>, and a confirmation message <b>&#34Updated Successfully&#34</b> appears.</li><br><li id=\"delete\">To <b>delete\n</b> an app list, click the <b>remove</b> icon.</li></ol><br><br><h3 id=\"clone\" style=\"font-weight: bold\">\nCloning an Application List</h3><p>\nCloning functionality allows you to create an application list with the same settings but different and unique app list name.\n</p>To clone an app list, follow the steps below:<p></p><ol><li>Click the <b>Clone</b>\n button next to the required app list and the <b>Application List</b> pop-up window appears.</li><br><li>\nEnter a unique <b>name</b> for the App list.</li><br><li>\nEnable or disable the required permissions for the various applications.</li><br><li>Once done, click <b>Save</b>\n and the cloned App list gets displayed.</li><br></ol><br><br><b><a \nhref=\"/help/organization/mobileAppsPlanning/applicationProfiles#top\" target=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"/help/organization/mobileAppsPlanning\" align=\"left\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/Applications.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Applications</h1></div><span id=\"S1\"></span> <span \nid=\"S2\"></span><div class=\"content\"><p>To add an application, follow the steps below:</p><ol><li>Click the <b>Add</b>\n button and the <b>Add Application</b> pop-up window appears.</li><br><li>Enter the following details:<br><br><ul><li>\n<b>App Name</b>: Enter the application name.</li><br><li><b>App Package</b>: Enter the application package name by:<br>\n<br><ul><li>Typing the exact name, ex.: com.android.chrome.</li><br><li>\nPasting the URL from the Google Play with the required application, ex:<br><br>\nhttps://play.google.com/store/apps/details?id=com.android.chrome&hl=en<br></li><br><li>\nDragging and dropping or selecting your APK file to the <b>Choose file</b>\n field of the window. The file gets uploaded and the application with its icon will appear.</li></ul></li><br><li><b>\nApp Description</b>: Enter a description for the application.</li><br><li><b>App Version</b>\n: Displays the app version once it is uploaded.</li></ul></li><br><li>Once done, click <b>Add</b>\n and the application along with its icon appears in the table. Also, the the message “<b>Application Added Successfully\n</b>” appears.</li><br><li>Click <b>Save</b>\n. If you move to another tab without saving, the added application(s) will get deleted automatically.</li><br><ul \nstyle=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThe changes applied to this page will immediately affect all the users of the organization.</li><br><li>\nThe usage of the applications can be controlled from the application profile list.</li><br></ul><br><li id=\"delete\">To \n<b>delete</b> an application, click the <b>remove</b> icon.</li><br><li>\nTo edit an application name and description, tap the required application.</li><br><li>If required change the <b>name\n</b> and <b>description</b>.</li><br><li>Once done, click the <b>Update</b> button.</li></ol><br><br><b><a \nhref=\"/help/organization/mobileAppsPlanning/applications#top\" target=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"/help/organization/mobileAppsPlanning\" align=\"left\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/BulkAppListAssign.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>App List Assign</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe App List Assign tab enables to allocate <b>applications lists</b>\n to multiple subscribers of an organization in just one go. This saves an ample amount of time in allocating applications to individual subscribers one by one.\n</p><br><p>To view or allocate an application list to multiple subscribers, follow the steps below:</p><ol><li>\nOn the left panel navigate to <b>Organization > Bulk Operations > App List Assign</b> tab.</li><br><li>\nSelect the subscriber(s) or ALL from the left pane by clicking the + icon or clicking the <b>Select All</b>\n button. The previously unselected subscribers will move to the <b>&#34Selected&#34</b> list.</li><br><li>From the <b>\nSelect App List</b> dropdown list, select the app list to be allocated.</li><br><li>Click <b>Apply Allocation</b>\n and a dialog box appears. Click <b>OK</b>\n if the selected app list is to be assigned to all the subscribers. A message stating <b>\n&#34Allocated Successfully.&#34 </b>will be displayed.</li><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i>\n</b>: By default, the <b>Apply Allocation</b>\n button remains disabled. It gets enabled only after selecting subscribers for allocation.</p></ol><br><br><b><a \nhref=\"help/organization/bulk\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/BulkContactsTemplates.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Contacts Templates</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe Contacts Templates tab enables to add or remove contact template users from the personal contacts of the selected subscribers.\n</p><p>To do so, follow the steps below:</p><ol><li>On the left panel navigate to <b>\nOrganization > Bulk Operations > Contacts Templates</b> tab.</li><br><li>Select the <b>Subscribers</b>\n option, to assign or remove contacts templates from the personal contacts of the subscribers.</li><br><li>\nSelect the subscriber(s) or ALL from the left pane by clicking the + icon or clicking the <b>Select All</b>\n button. The previously unselected subscribers will move to the <b>&#34Selected&#34</b> list.</li><br><li>From the <b>\nSelect Contacts Template</b> dropdown list, select the template.</li><br><li>Click the <b>\n&#34ADD CONTACT TEMPLATE USERS&#34</b> or <b>&#34REMOVE CONTACT TEMPLATE USERS&#34</b>\n button to add or remove the users of the selected contact template to the personal contacts of the selected subscribers.\n</li><br><li>Select the <b>Contacts Templates</b>\n option to assign or remove the subscribers from the contact templates.</li><br><li>\nSelect the contacts template(s) or ALL from the left pane by clicking the + icon or clicking the <b>Select All</b>\n button. The previously unselected templates will move to the <b>&#34Selected&#34</b> list.</li><br><li>From the <b>\nSelect Contacts Template</b> dropdown list, select the template.</li><br><li>Click the <b>\n&#34ADD CONTACT TEMPLATE USERS&#34</b> or <b>&#34REMOVE CONTACT TEMPLATE USERS&#34</b>\n button to add or remove the users of the contact template selected from the dropdown list to the subscribers of the selected templates.\n</li><br><li>Once clicked, a dialog appears. Click OK to continue the operation and a message <b>\n&#34Allocated Successfully&#34</b> will be displayed.</li></ol><br><br><b><a href=\"help/organization/bulk\" \nalign=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>Copyright &copy 2022 Mobile Tornado Group plc.</p></div>\n</div>");
$templateCache.put("app/help-files/BulkEmergencyGroups.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Emergency Groups</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe Emergency Groups tab enables to allocate an emergency group to multiple subscribers of an organization in just one go. This saves an ample amount of time in associating a group to individual subscribers one by one.\n</p><p>To view or allocate an emergency group to multiple subscribers, follow the steps below:</p><ol><li>\nOn the left panel navigate to <b>Organization > Bulk Operations > Emergency Groups</b> tab.</li><br><li>\nSelect the subscriber(s) or ALL from the left pane by clicking the + icon or clicking the <b>Select All</b>\n button. The previously unselected subscribers will move to the <b>&#34Selected&#34</b> list.</li><br><li>From the <b>\nSelect Emergency Group</b> dropdown list, select the group to be allocated.</li><br><li>Click <b>Apply Allocation</b>\n and a dialog box appears. Click <b>OK</b> if the selected group is to be assigned to all the subscribers. A message \n<b>&#34Allocated Successfully.&#34</b> will be displayed.</li><p style=\"background-color: lightgrey\"><b><i><u>Note</u>\n</i></b>: By default, the <b>Apply Allocation</b>\n button remains disabled. It gets enabled only after selecting the subscribers for group allocation.</p></ol><br><br>\n<b><a href=\"help/organization/bulk\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/BulkLicense.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>License</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe License tab enables you to allocate a pre-defined license bundle to multiple selected subscribers of an organization in just one go. This saves an ample amount of time in allocating licenses to individual subscribers one by one.\n</p><p>To view or allocate a license bundle to multiple subscribers, follow the steps below:</p><ol><li>\nOn the left panel navigate to <b>Organization > Bulk Operations > License</b> tab.</li><br><li>\nSelect the subscriber(s) or ALL from the left pane by clicking the + icon or clicking the <b>Select All</b>\n button. The previously unselected subscribers will move to the <b>&#34Selected&#34</b> list.</li><br><li>From the <b>\nSelect License</b> dropdown list, select the license to be allocated.</li><br><li>Click <b>Allocation Apply</b>\n and a dialog box appears. Click <b>OK</b> if the selected license is to be applied. A message <b>\n&#34Successfully Allocated&#34</b> will be displayed.</li><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i>\n</b>: By default, the <b>Apply Allocation</b>\n button remains disabled. It gets enabled only after selecting the subscribers for license allocation.</p></ol><br><br>\n<b><a href=\"help/organization/bulk\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/BulkOperations.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Bulk Operations</h1></div><span id=\"import\"></span>\n <span id=\"export\"></span><div class=\"content\"><p>This tab enables you to perform bulk operations like <a \nhref=\"#import\">import</a>, <a href=\"#export\">export</a>, <a href=\"#enable\">enable</a>, <a href=\"#disable\">disable</a>\n, and <a href=\"#delete\">delete</a> subscribers.</p><br><h3 id=\"import\" style=\"font-weight: bold\">Import</h3><p>\nTo import the subscribers, on the left panel navigate to <b>Organization > Bulk Operations</b> page. Click <b>Import\n</b>\n to browse, select the required CSV (Comma Separated Values) or Excel file containing the subscribers to be imported and click \n<b>Open</b>.</p><p>\nAs soon as the file is selected, the system checks, and verifies the details of the subscribers and imports only those subscribers which do not exist in the database.\n</p><p>The result of the operation is displayed in the <b>Result Log</b>\n box. If there is an issue while importing, the number of errors is displayed next to the <b>\n&#34Not processed subscribers:&#34 </b>\nlabel. Also, the error log gets displayed in the box. If the subscribers are imported successfully, <b>Done</b>\n will be displayed and the <b>Subscribers Count</b>\n gets incremented accordingly. If the imported groups do not exist, they will get automatically created.</p><p \nstyle=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: To learn about the format of the CSV or Excel file for import (columns/fields and their type), it is recommended to perform first the export of users from any organization and use the result as a template for importing.\n</p><br><br><h3 id=\"export\" style=\"font-weight: bold\">Export</h3><ol><li>Navigate to the relevant Organization.</li>\n<br><li>On the left panel navigate to the <b>Organization > Bulk Operations > Bulk Operations</b> page.</li><br><li>\nSelect the format as <b>CSV or Excel</b>.</li><br><li>Click <b>Export</b>\n, and the file containing all the details of the subscribers gets downloaded in your workstation. Now, you can use this file for importing subscribers in some other organization.\n</li><br></ol><br><h3 id=\"enable\" style=\"font-weight: bold\">Enable All Subscribers</h3><p>Click <b>\nEnable All Subscribers</b>\n to change the status of all the subscribers from inactive to active. You can inspect the status of the subscribers (Activer or Disabled) in the \n<b>Subscribers</b> page.</p><br><h3 id=\"disable\" style=\"font-weight: bold\">Disable All Subscribers</h3><p>Click <b>\nDisable All Subscribers</b>\n to change the status of all the subscribers from active to inactive. You can inspect the results in the <b>Subscribers\n</b> page.</p><br><h3 id=\"delete\" style=\"font-weight: bold\">Delete All Subscribers</h3>Click <b>Delete All Subscribers\n</b> to delete all the subscribers. A confirmation message <b>&#34Are you sure want to delete this item&#63&#34</b>\n appears on the screen. Click <b>Remove</b> button and all the subscribers will get deleted.<p \nstyle=\"background-color: lightgrey\"><b><i><u>Caution</u></i></b>: There is no way to undo the <b>DELETE ALL</b>\n operation. It is advised to perform the bulk EXPORT operation prior to deleting all the users of an organization.</p>\n<br><br><br><br><b><a href=\"help/organization/bulk/operations#top\" target=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"help/organization/bulk\" align=\"left\">Back</a></b></div><br><br><br><br><br><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/BulkReports.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Reports</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nReports can be generated and exported for subscribers&#39 status, call log, and recording reviewers activity report.\n</p><p>To view the Reports tab, navigate to <b>Organization > Bulk Operations > Reports</b>.<br><br>\nThe page displays the following items:</p><ul><li><b>Result Log</b> displays the status of the report being generated.\n</li><br><li><b>Subscribers Status Report</b>\n: Exports a report based on subscribers’ status (e.g. Active or Disabled). This generates the report and is exported in .CSV or Excel format. This report contains details like Display Name, Protocol Version, App Version, State, Creation Time, Last Registration Time and Last User Client Update Time.\n</li><br><li><b>Call Log Report</b>\n: Exports a report based on the call log. This report displays details like session name, session id, session type, session start time, session end time, burst talker name, burst talker id, burst start time and burst end time.\n</li><br><li><b>Export Recording Reviewers Activity Report</b>\n: Exports a report based on the activities of the recording reviewers. This report displays details like email ID, last login time, last activity time, activity command, activity session name, activity username, activity time and activity IP.\n</li><br></ul><br><br><b><a href=\"help/organization/bulk\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\">\n<p>Copyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/BulkRole.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Role</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe Role tab enables to allocate a certain <b>role</b>\n to multiple subscribers of an organization in just one go. This saves an ample amount of time in assigning a role to individual subscribers one by one.\n</p><p>To view or allocate a role to multiple subscribers, follow the steps below:</p><ol><li>\nOn the left panel navigate to <b>Organization > Bulk Operations > Role</b> tab.</li><br><li>\nSelect the subscriber(s) or ALL from the left pane by clicking the + icon or clicking the <b>Select All</b>\n button. The previously unselected subscribers will move to the <b>&#34Selected&#34</b> list.</li><br><li>From the <b>\nSelect Role</b> dropdown list, select the role to be allocated.</li><br><li>Click <b>Apply Allocation</b>\n and a dialog box appears. Click <b>OK</b> if the selected role is to be assigned to all the subscribers. A message <b>\n&#34Allocated Successfully.&#34 </b>will be displayed.</li><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i>\n</b>: By default, the <b>Apply Allocation</b>\n button remains disabled. It gets enabled only after selecting subscribers for role allocation.</p></ol><br><br><b><a \nhref=\"help/organization/bulk\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/CallLog.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Call Log</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThis tab enables you to search, view, sort, and export the call log details of all the users of the organization.</p>\n<ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThis feature is available only if the value of the parameter <b>PROV_SHOW_CALL_LOG</b> is set as <b>1</b>\n in the Platform System Configuration Custom page. (Root Admins only)</li><br><li>\nTo get the Call Log details, first enable the option <b>Keep a log of all calls</b> from the Organization Details page.\n</li><br></ul><p>Select the <b>start</b> and <b>end date</b> and the details will appear in the table.<br><br>\nThe table displays the details like Channel Name, Sender Name, Recipient Name, Channel Type (a type of call), the Start and End Time of call.\n<br><br>\nYou can also search the required details based on the channel name (the call initiator or group name) or sort the details in ascending or descending order.\n<br><br>To export the data, <b>select the format as </b>CSV or Excel and click the <b>Call Log Report</b>\n button. The data will get exported to the respective type of file. To load the new entries, you can click the <b>\nRefresh</b> button.</p>To view the activity details for a specific channel, click on any channel name, and the <b>\nChannel Activity</b> pop-up window appears.<br><br>The <b>Channel Activity</b>\n pop-up window displays the details of the channel like Speaker Name, Speaker ID, Start Time, and Duration.<p></p><br>\n<br><b><a href=\"help/organization\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/Contacts.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Contacts</h1></div><span id=\"search\"></span> <span \nid=\"add\"></span><div class=\"content\"><p>\nThe Contacts sub-menu enables the administrator to manage organization contact groups and contact templates.</p><p>\nOrganization Contact Groups contains contacts used by the subscribers in the IPRS™ client for 1-1 or Adhoc communication. Mostly these contacts are maintained by the administrators or supervisors of the organization. The main benefits of managing contacts in ITO are:\n<br><ul><li>The efficient population of contact lists of subscribers.</li><br><li>\nSubscribers cannot delete a contact that originated from Organization Contact Group (OCG).</li></ul></p><p>\nAll users that are added to a contact group get automatically associated with that list, i.e., the other users in the list appear in their Private Address Book (PAB) when they login to the client.\n<br><br>The <b>Team Organizer</b>\n also enables management of contact associations for individual subscribers – add, edit, and delete contacts.</p><p \nstyle=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: Organization Contacts can only contain users (contacts) that belong to the same organization. Users from other organizations cannot be included in the Contacts.\n<br></p><br>To view the Contacts page, follow the steps below:<p></p><ol><li>\nNavigate to the relevant Organization using the tree.</li><br><li>On the left panel navigate to <b>\nOrganization > Contacts</b>.<p>From this page, you can <a href=\"help/organization/contacts#search\">search</a>, <a \nhref=\"help/organization/contacts#add\">add</a>, <a href=\"help/organization/contacts#edit\">edit</a>, and <a \nhref=\"help/organization/contacts#delete\">delete</a>\n a contact group for the selected organization. You can also sort the group name and member count fields in ascending or descending order. Moreover, you can define the number of records getting displayed in the table using the \n<b>Records</b> dropdown list located below the table.</p></li></ol><br><h3 id=\"search\" style=\"font-weight: bold\">Search\n</h3><p>To search a required contact group from the list,</p><ul><li>Type a few characters in the <b>Search</b>\n field and a list of contact groups containing the typed letters will be displayed.</li></ul><p \nstyle=\"background-color: lightgrey\"><b><i><u>Limitation</u></i></b>: The search field is limited to 50 characters.</p>\n<br><h3 id=\"add\" style=\"font-weight: bold\">Adding/Editing/Deleting a Contacts Group</h3><p>\nTo add or edit a contacts group, follow the steps below:</p><ol><li>Click the <b>Add</b> button and the <b>\nContacts Group Details</b> pop-up window appears.</li><br><li>In the <b>General</b> tab, enter the <b>Group Name</b>.\n</li><p style=\"background-color: lightgrey\"><b><i><u>Limitation</u></i></b>\n: The contacts group name is limited to 12 characters.</p><li>Select the <b>Group Type</b>:<br><br><ul><li><b>\nContacts Template</b>: Select to create contacts template consisting of contacts.</li><br><li><b>\nOrganization Contact Group</b>\n: Select to create a contacts group. This group contains a list of subscribers that appear in the private address book of the users with whom the group is associated.\n</li><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: The Organization Contact Group option is available only if the value of the parameter <b>PROV_SHOW_OCL</b>\n is set as 1 in the Platform System Configuration Custom page.</p></ul></li><li>In the <b>Members List</b> tab, <b>\nadd subscribers</b> to the list.</li><br><li>Click <b>Save</b> and a confirmation message <b>&#34Added Successfully&#34\n</b> is displayed on the screen. The newly created contacts group appears in the table.</li><br><li id=\"edit\">To <b>\nedit</b>\n a group, click on the required group to be edited. Once the changes are done, click Save, and a confirmatory message \n<b>&#34Updated Successfully&#34</b> appears on the screen.</li><br><li id=\"delete\">To <b>delete</b> a group, click the \n<b>remove</b> icon. A dialog box appears. Click the <b>Remove</b> button and a confirmatory message <b>\n&#34Removed Successfully&#34</b> appears on the screen.</li></ol><br><br><b><a href=\"help/organization/contacts#top\" \ntarget=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"help/organization\" align=\"left\">Back</a></b><br><br><br><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/Deletion.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Deletion</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe Deletion tab enables you to delete only the selected subscribers, groups, contact groups, emergency groups, and contacts templates in one go.\n</p><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>: This tab is visible only if the user holds <b>\nDelete Subscribers</b> permission from the <b>Provisioning Role Permissions</b> page.</p><p>\nTo perform the deletion operation,</p><ol><li>Navigate to <b>Organization > Bulk Operations > Deletion</b> tab.</li>\n<br><li>Select the <b>Subscribers</b> option.</li><br><li>\nSelect the subscriber(s) or ALL from the left pane by clicking the + icon or clicking the <b>Select All</b>\n button. The previously unselected subscribers will move to the <b>&#34Selected&#34</b> list.</li><br><li>\nOnce the subscribers are selected, click <b>Execute Deletion</b> to delete them in a single run.</li><p \nstyle=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>: By default, the <b>Execute Deletion</b>\n button remains disabled. It gets enabled only after selecting the items for deletion.</p><li>\nSimilarly, the groups, contact groups, emergency groups, and contacts templates can also be deleted.</li></ol><br><br>\n<b><a href=\"help/organization/bulk\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/Groups.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Groups</h1></div><span id=\"search\"></span> <span \nid=\"add\"></span><div class=\"content\"><p>Three types of groups are supported: <b>Radio Groups, Broadcast Groups</b>\n, and <b>Emergency Groups</b>\n. These groups are managed by the service provider or by the Organizations administrators, whereas these Groups including Private can be created by the end-user using the PTT client with &#34Groups Creation and Management&#34 Roles privileges.\n<br><br>Before making any changes, select a relevant <b>reseller</b> and an <b>organization</b>.<br><br>\nTo manage groups, select an organization and navigate to <b>Organization > Groups</b>\n. If no organization is selected yet, the message <b>&#34Please choose an organization first&#34</b> appears.<br><br>\nFrom this page, you can <a href=\"help/organization/groups#search\">search</a>, <a href=\"help/organization/groups#add\">\nadd</a>, <a href=\"help/organization/groups#edit\">edit</a>\n, and delete a group for the selected organization. You can also view and edit the affiliated organizations created from the \n<b>Affiliated Groups</b> tab of the Organization Details page.</p><p></p><br><h3 id=\"search\" style=\"font-weight: bold\">\nSearch</h3><p>To search a required group from the list,</p><ul><li>Type a <b>name</b> in the <b>Search</b>\n field and a list of groups containing the specified text will be displayed.</li></ul><br><h3 id=\"add\" \nstyle=\"font-weight: bold\">Adding a Group to the Organization</h3><p>\nTo add a group to the organization, follow the steps below:</p><ol><li>Navigate to the relevant Organization.</li><br>\n<li>On the left panel navigate to <b>Organization > Groups</b>.</li><br><li>Click the <b>Add</b> button and the <b>\nGroup Details</b> pop-up window appears.</li><br><li>In the <b>General</b> tab, enter a unique <b>Group Name</b>\n and select the <b>Group Type</b> from the dropdown list. You can select either <b>Radio Group</b> (Chat), <b>\nConference Group</b> (Broadcast), or <b>Emergency Group</b>. The <b>Site</b>\n field displays the site selected while creating an organization. This value is defined during the installation of the system and cannot be modified. Select the \n<b>End date</b> (expiry date) using the <b>Calendar</b>\n icon based on which the group will get deleted automatically. The group will get deleted at 12:00 AM of the set time. You can set the end date for Radio and Conference groups. Click the \n<b>cross</b> icon to remove the date.</li><br><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br>\n<br><li>The maximum limit for a Group name is 12 characters.</li><br><li>\nSpecial characters are not supported within the Group name.</li><br></ul><p></p><li>Click <b>Save</b> or click <b>\nCancel</b> to stop the operation. You can add subscribers to the group from the <b>Subscribers List</b> tab.</li><br>\n<li>Select the <b>Subscribers List</b> tab to add subscribers to the group.</li><p style=\"background-color: lightgrey\" \n;><b><i><u>Note</u></i></b>: We suggest creating Subscribers before Groups to add them now as Group Members.</p><li>\nTo add subscribers to the newly created group do the following:<ul><br><li>\nClick the + or - icon for the subscribers to associate with or remove from the group. The previously unselected subscriber moves to the \n<b>&#34Selected&#34</b> list box.</li><br><li>Click <b>Select All</b> or <b>Remove All</b>\n to assign or remove all the subscribers.</li><br><li>You can use the <b>Search</b> field to look up the subscriber.\n</li><br><li>\nNext to the search field is a number displaying the number of assigned subscribers. The second part of the number displays the \n<b>maximum limit of subscribers</b>. .</li><br></ul></li><li>Once done, click <b>Save</b>\n. The newly created group gets displayed in the table.</li></ol><br><h3 id=\"edit\" style=\"font-weight: bold\">\nEditing/Deleting an Existing Group</h3><p>To edit an existing group, follow the steps below.</p><ol><li>Navigate to <b>\nOrganization > Groups</b>.</li><br><li>To delete a group, click the <b>remove</b>\n icon. A dialog box appears. Click the <b>Remove</b> button and the group gets deleted. Also, a message stating <b>\n&#34Removed successfully&#34</b> appears on the screen.<br></li><br><li>\nTo edit, click on the required group to be edited. <b>Group Details</b> pop-up window appears.</li><br><li>In the <b>\nGeneral</b> tab, you can edit the <b>Group Name</b> and <b>end date</b> only.</li><br><li>You can select the <b>\nSubscribers List</b> tab to change the subscribers that are associated with this group and click the <b>Save</b>\n button.</li><br></ol><br><br><b><a href=\"help/organization/groups#top\" target=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"help/organization\" align=\"left\">Back</a></b><br><br><br><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/Index.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Introduction</h1></div><span id=\"S1\"></span> <span \nid=\"S2\"></span><div class=\"content\"><p>The <b>IPRS™ Team Organizer (Team Organizer)</b>\n is a management portal, providing you the facility for adding and managing <b>\nResellers, Organizations, Administrators, Users (Subscribers)</b>, and <b>Groups</b> to the IPRS™ service.<br><br>\nThis portal is intended to be used by system managers, dealers, resellers, and administrators of organizations, each with their own privileges and rights.\n<br><br>Adding and managing <b>Languages</b> for localizing the portal as per the region is supported as well.</p><br>\n<h3 style=\"font-weight: bold\">Terminology</h3><table class=\"a\" align=\"center\" cellpadding=\"7\"><col width=\"30%\"><col \nwidth=\"70%\"><tr style=\"background-color: #3492DD\" height=\"20px\"><th style=\"font-size:20px\">Acronym</th><th \nstyle=\"font-size:20px\">Description</th></tr><tr><td>DRC</td><td>Default Radio Channel</td></tr><tr><td>IPRS<sup>™</sup>\n</td><td>IP Radio System of Mobile Tornado.</td></tr><tr><td>IPRS<sup>™</sup>Client</td><td>\nA mobile or PC application that enables the user to connect to the IPRS™ service.</td></tr><tr><td>IPRS<sup>™</sup>\n Team Organizer</td><td>Provisioning Portal or ITO (acronym)</td></tr><tr><td>ITO</td><td>IPRS<sup>™</sup>\n Team Organizer</td></tr><tr><td>PTT Groups</td><td>\nA provisioned set of users authorized to join a certain IPRS PTT session.</td></tr><tr><td>Users/Subscribers</td><td>\nPersons using a PTT mobile device or a PC with a dedicated application to connect to the IPRS<sup>™</sup> service.</td>\n</tr><tr><td>IMSI</td><td>International Mobile Subscriber Identity number that may be used for identifying the user.\n</td></tr><tr><td>OSM</td><td>Open Street Map</td></tr><tr><td>OCG</td><td>Organization Contact Group</td></tr><tr><td>\nCRM</td><td>Customer Relationships Management</td></tr></table><br><br><h3 style=\"font-weight: bold\">Overview</h3><p>\nOnce the user sign-ins the portal with correct credentials, the <b>Home page</b> appears.<br><br>\nThe home page displays the following items:<br><ol><li><b>Software Versions</b>\n: This displays the information related to the <b>Front-end version</b>, <b>API & MongoDB version</b>, and <b>\nMain DB version</b>.</li><br><li><b>Menu</b>: Enables navigating through various sections of the portal.</li><br><li>\n<b>Resellers and Organizations dropdown lists</b>\n: Enables selecting the reseller and organization based on which operations can be performed at the respective level. Also, you can search the required reseller and organization from their respective dropdown lists.\n</li><br><li><b>Search button</b>\n: Enables to search a user based on the phone number, Email address, ID, and IMSI number.</li><br><li><b>Username</b>\n: Displays the name of the active signed-in user.</li><br><li><b>Language dropdown list</b>\n: Displays the active language by default. You can change the <b>language</b> using the dropdown list.</li><br><li><b>\nHelp button</b>: Displays the help content related to the active screen.</li><br><li><b>Dashboard</b>\n: Displays the administration portal dashboard.<br><p style=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note	\n</u></i></b>: This button is available only if the value of the parameter <b>PROV_SHOW_DASHBOARD</b> is set as <b>1</b>\n in the Platform System Configuration Custom page.</p>\nThis dashboard provides an overview of the entire portal in a graphical format. It displays the details like the number of resellers, organizations, subscribers, groups, licenses used, creation date, state, subscribers state, call history, client OS, clients protocol version, android client version, IOS client version, MS Windows client version, android clients OS, IOS Clients OS, devices model, devices vendor, wake-up services, and mobile client brand. You can also filter the data as per your requirement using the Sort option.\n<br><br>You can also change the theme of the dashboard using the <b>theme</b>\n dropdown list and selecting the required option. Once the theme is selected, the dashboard color will get changed the very next moment.\n<br><br></li><li><b>PTT Statistics</b>\n: Displays the total number of calls placed and failed in a particular duration and date. This helps the reseller to analyze the statistical data and check the reliability of the PTT service.\n<br><br><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThis button is available only if the value of the parameter <b>PROV_SHOW_STATISTICS</b> is set as <b>1</b>\n in the Platform System Configuration Custom page. (Root Admins only)</li><br><li>\nOnly Reseller Admins can view this button.</li><br></ul></li></ol>\nAbove the resellers and the organizations dropdown lists a navigation path is displayed. The path indicates the <b>\nhighest level reseller</b>, the sub-<b>Reseller</b> name, and the <b>Organization</b> name.</p><p \nstyle=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note	</u></i></b>\n: The database of the service is based on a hierarchical structure containing parent and child nodes. Hence, to delete any of the parent nodes, its child nodes must be deleted first. Likewise, all users associated with a group should be deleted before removing the group and so on.\n</p>In the <b>Resellers</b> dropdown list, the <b>house</b>\n icon displayed beside the reseller name depicts that there are organizations present in it. If there are no organizations under a reseller then only the name is displayed.\n<br><br>To search a subscriber, enter the phone number, Email Address, ID, or IMSI in the search field and click the \n<b>Search</b> button.<br><br>To sign out from the portal, select <b>Sign Out</b> from the <b>Current User</b>\n dropdown list.<br><br><br><br><h3 style=\"font-weight: bold\">Menus</h3><p>\nThe left pane of the window consists of the main menu: <a href=\"/help/organization\">Organization</a>, <a \nhref=\"/help/reseller\">Reseller</a>, <a href=\"/help/platform\">Platform</a>, and <a href=\"/help/administration\">\nAdministration</a>.</p><p style=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: Certain menus may be disabled or not appear at all, depending on your role and administration rights. If you only have Organization administration rights, the menu items related to Platform and Reseller administration may not appear.\n</p><br><br><b><a href=\"/help/index#top\" target=\"_top\" align=\"right\">Top</a></b><br><br><br><br><br></div><div \nclass=\"footer\"><p>Copyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/LicenseCodeGeneration.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>License Code Generation</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div \nclass=\"content\"><p>\nThis tab enables you to display the code and template of the license as per the selected permissions.</p><p>\nTo view the license code, select the permissions and click the <b>Show License Code</b>\n button. The code gets displayed in the <b>License Code</b> field.<br><br>Click the <b>Show License Template</b>\n button to view the original template, if any changes are made in the permissions after code generation. On clicking, the permissions will get updated automatically as per the generated code.\n</p><br><br><br><b><a href=\"/help/platform/licenses\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/LicenseTemplates.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>License Templates</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThis tab enables you to search and view the permissions of the license templates. These license templates are predefined and non-editable. You can only view them.\n</p><p>To view the License Templates page, on the left pane navigate to <b>Platform > Licenses > License Templates</b>\n and the dialog appears.<br><br>\nThe page displays a list of license templates along with their respective codes. One can only view the details of the selected license template. To view the details, click the required license and the License Details pop-up window appears.\n</p><br><b>Search</b><br><br>To search a required license from the list,<ul><li>Type a few characters in the <b>Search\n</b> field and a list of licenses containing the letters will be displayed in the table.</li></ul><br><br><b><a \nhref=\"/help/platform/licenses\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/Licenses.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Licenses</h1></div><span id=\"S1\"></span> <span \nid=\"S2\"></span><div class=\"content\"><p>\nThis page enables the administrators to view the license templates as well as their codes (permission masks). These license templates can then be used for allocating to the concerned subscribers. The licenses contain permissions for using the various functionalities of the PTT application. These licenses can be directly allocated at the subscriber level.\n<br><br>Mobile Tornado provides 20 types of pre-defined licenses which are described in the below table.</p><p \nstyle=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: Only a user with root admin rights can access the licenses sub-menu.</p><h3 style=\"font-weight: bold\">\nTypes of License Templates</h3><table class=\"a\" align=\"center\" cellpadding=\"7\"><col width=\"30%\"><col width=\"30%\"><col \nwidth=\"30\"><tr style=\"background-color: #3492DD\" height=\"40px\"><th style=\"font-size:20px\">License Templates</th><th \nstyle=\"font-size:20px\">Abbreviation</th><th style=\"font-size:20px\">Description</th></tr><tr><td>PTT (Push To Talk)</td>\n<td>PTT</td><td>\nPTT license includes permissions for Conference call, Radio call, Ad-Hoc call, and Private call only within the same organization.\n</td></tr><tr><td>PTT (Offnet)</td><td>PTT + Off-Net</td><td>\nPTT Off-Net includes all the permissions of PTT along with the permission to make calls to the users belonging to a different organization.\n</td></tr><tr><td>PTT (Disable AdHoc Origination)</td><td>PTT + Disable AdHoc Origination</td><td>\nPTT includes all the PTT permissions along with the permission to disable AdHoc origination.</td></tr><tr><td>\nPTT (Offnet, Disable AdHoc Origination)</td><td>PTT + OffNet + Disable AdHoc Origination</td><td>\nPTT includes all the PTT permissions along with the permission to disable AdHoc origination and make calls to the users belonging to a different organization.\n</td></tr><tr><td>PTM (Push To Message)</td><td>PTT + IM</td><td>\nPTM includes all the PTT permissions in addition to the permission for sending and receiving IMs.</td></tr><tr><td>\nPTM (Offnet)</td><td>PTT + IM + Offnet</td><td>\nPTM Off-Net includes all the permissions of PTM along with the permission to send messages to the users belonging to a different organization.\n</td></tr><tr><td>PTA (Push To Alert)</td><td>PTT + IM + SOS</td><td>\nPTA includes all the PTM permissions in addition to the permission for sending SOS to the dispatcher of the same organization.\n</td></tr><tr><td>PTA (Off-Net)</td><td>PTT + IM + SOS + Off-Net</td><td>\nPTA Off-Net includes all the permissions of PTA along with the permission to make calls to the users belonging to a different organization.\n</td></tr><tr><td>PTL (Push To Locate)</td><td>PTT + IM + GPS</td><td>\nPTL includes all the PTM permissions in addition to the permission for sending location to the dispatcher via GPS.</td>\n</tr><tr><td>PTL (Off-Net)</td><td>PPTT + IM + GPS + OffNet</td><td>\nPTL Off-Net includes all the permissions of PTL along with the permission to make calls to the users belonging to a different organization.\n</td></tr><tr><td>All</td><td>PTT + IM + SOS + GPS</td><td>\nAll includes all the PTT, IM, SOS and GPS permissions for users of the same organization.</td></tr><tr><td>All (Offnet)\n</td><td>PTT + IM + SOS + GPS + Offnet</td><td>\nAll (Off-Net) includes all the permissions of All license along with the permission to make calls to the users belonging to a different organization.\n</td></tr><tr><td>All (Disable Private Origination)</td><td>PTT + IM + SOS + GPS + Disable Private Origination</td><td>\nAll includes all the PTT, IM, SOS, and GPS permissions for users of the same organization along with the permission to disable private call origination.\n</td></tr><tr><td>All (Disable AdHoc Origination)</td><td>PTT + IM + SOS + GPS + Disable AdHoc Origination</td><td>\nAll includes all the PTT, IM, SOS, and GPS permissions for users of the same organization along with the permission to disable AdHoc call Origination.\n</td></tr><tr><td>All (Disable Private and AdHoc Origination)</td><td>\nPTT + IM + SOS + GPS + Disable Private and AdHoc Origination</td><td>\nAll includes all the PTT, IM, SOS, and GPS permissions for users of the same organization along with the permission to disable AdHoc call and private call origination.\n</td></tr><tr><td>Dispatcher</td><td>PTT + IM + SOS + GPS + Dispatcher</td><td>\nDispatcher license includes permissions for PTT, IM, SOS, GPS, dispatcher, and priority call. A user holding this license can make a priority call to other user who is already in a conversation.\n</td></tr><tr><td>Dispatcher (Offnet)</td><td>PTT + IM + SOS + GPS + Dispatcher + Offnet</td><td>\nDispatcher (Off-Net) includes all the permissions of Dispatcher license along with the permission to make calls to the users belonging to a different organization. Also, location of users belonging to a different organization can be viewed from the Dispatcher Console.\n</td></tr><tr><td>Dispatcher (Disable GPS)</td><td>PTT + IM + SOS + GPS + Dispatcher + Disable GPS</td><td>\nDispatcher license includes permissions for PTT, IM, SOS, GPS, disable GPS, dispatcher, and priority call. A user holding this license can make a priority call to other user who is already in a conversation.\n</td></tr><tr><td>Dispatcher (OffNet, Disable GPS)</td><td>PTT + IM + SOS + GPS + Dispatcher + OffNet + Disable GPS\n</td><td>\nDispatcher (Off-Net) includes all the permissions of Dispatcher license along with the permission to make calls to the users belonging to a different organization. This also includes the permission to disable GPS.\n</td></tr><tr><td>Lite Dispatcher</td><td>PTT + IM + Dispatcher</td><td>\nLite Dispatcher includes permissions for PTT, IM, and dispatcher.</td></tr></table><br><p \nstyle=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: Currently SOS permission in Off-Net licenses are supported for the same organization only.</p><p>\nThe Licenses page displays two tabs namely:</p><ul><li><b><a href=\"help/platform/licenses/templates\">License Templates\n</a></b></li><br><li><b><a href=\"help/platform/licenses/codeGeneration\">License Code Generation</a></b></li></ul><br>\n<br><br><br><b><a href=\"/help/platform/licenses#top\" target=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"/help/platform\" align=\"left\">Back</a></b><br><br><br><br><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/Localization.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Localization</h1></div><span id=\"search\"></span> \n<span id=\"add\"></span><div class=\"content\"><p>\nThe Localization page enables you to configure regional languages. Depending on the region one can easily convert the language of the portal to the desired language.\n<br><br>To view the Localization page, navigate to <b>Platform > Localization</b> and the page appears.<br><br>\nFrom this page, you can <a href=\"/help/platform/localization#search\">search</a>, <a \nhref=\"/help/platform/localization#add\">add</a>, <a href=\"/help/platform/localization#edit\">edit</a>, and <a \nhref=\"/help/platform/localization#delete\">delete</a>\n a language from the portal. You can also sort all the fields in respective ascending or descending order. Moreover, you can define the number of records getting displayed in the table using the \n<b>Records</b> dropdown list located below the table.<br><br>Additionally, using the <b>&#34Active&#34</b>\n field you can change the status of the languages from active to inactive and vice-versa. The active languages will be displayed for all users in the language selection dropdown list located at the top right corner of the window.\n<br><br>To set a default language for all users, in the <b>Default</b>\n field enable the checkbox next to the required language. Now refresh the URL and you can see the text in the portal appearing as per the set default language.\n</p><p style=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: At a time only one language can be set as default.</p><br><h3 id=\"search\" style=\"font-weight: bold\">Search</h3><p>\nTo search a required language from the list,</p><ul><li>Type a few characters in the <b>Search</b>\n field and a list of languages containing the letter will be displayed in the table.</li></ul><br><br><h3 id=\"add\" \nstyle=\"font-weight: bold\">Adding or Editing a Language</h3><p>To add or edit a language, follow the steps below:</p>\n<ol><li>Click the <b>Add</b> button and the <b>Details</b> pop-up window appears.</li><br><li>\nProvide the following details:</li><br><table class=\"a\" align=\"center\" cellpadding=\"7\"><col width=\"30%\"><col \nwidth=\"70%\"><tr style=\"background-color: #3492DD\" height=\"40px\"><th style=\"font-size:20px\">Parameters</th><th \nstyle=\"font-size:20px\">Description</th></tr><tr><td>Localization</td><td>\nEnter the language name to be added in the portal.</td></tr><tr><td>Translation Key</td><td>\nEnter the translation key for the file which is to be imported.<br><br>E.g.: TRANSLATION_IL for Israel.</td></tr><tr>\n<td>Language Code</td><td>Enter code for language. Duplicate values cannot be entered.</td></tr><tr><td>Flag</td><td>\nFlag of the country.</td></tr><tr><td>Import</td><td>\nBrowse to select the required .csv file which is to be imported for adding the language.</td></tr><tr><td>Export</td>\n<td>Click to export the .csv file containing the translation parameters for the language.</td></tr></table><br><br><li>\nOnce done, click <b>Save</b> and the newly added language gets displayed in the table.</li><br><li>\nOnce the language is added, you need to activate it by enabling the checkbox from the <b>&#34Active&#34</b>\n field of the table.</li><br><li>On activating the language, <b>Refresh</b>\n the page and it gets reflected in the Language selection dropdown list.</li><br><li id=\"edit\">To <b>edit</b>\n, click on the required <b>language</b> and the <b>Details</b> pop-up window appears.</li><br><li>\nMake the required changes.</li><br><li>Once done, click <b>Save</b> and a confirmatory message stating <b>\n&#34Updated Successfully&#34</b> appears on the screen.</li><br><li id=\"delete\">To <b>delete</b> a language, click the \n<b>remove</b> icon. A dialog box appears. Click the <b>Remove</b> button and a confirmatory message stating <b>\n&#34Removed Successfully&#34</b> appears on the screen.</li><br></ol><br><b><a href=\"/help/platform/localization#top\" \ntarget=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"/help/platform\" align=\"left\">Back</a></b><br><br><br><br><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/MainAdministrators.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Administrators</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe system allows you to add a new administrator for an organization, assign a specific role to the administrator, assign access rights to the role as well as modify any rights assigned to you (existing admin). You can also add more than one administrator for any organization with different roles and rights.\n<br><br>The <b>Administrator</b>\n menu enables the root admin to create, view the administrators of the selected customer (Reseller or Organization), their roles, rights, as well as view their activity details.\n<br><br>The menu has the following three sub-menus:</p><li><b><a href=\"help/administration/admins\">Administrators</a>\n</b></li><br><li><b><a href=\"help/administration/roles\">Roles</a></b></li><br><li><b><a \nhref=\"help/administration/activitylog\">Activity Log</a></b></li><br><br><br><br><br><br><b><a href=\"help/index\" \nalign=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>Copyright &copy 2022 Mobile Tornado Group plc.</p></div>\n</div>");
$templateCache.put("app/help-files/MainBulkOperations.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Main Bulk Operations</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\">\n<p>The bulk operations page allows us to perform operations on many subscribers in batch.</p><p>\nTo view Bulk Operations page, follow the steps below:</p><ol><li>Navigate to the relevant Organization.</li><br><li>\nOn the left panel navigate to <b>Organization > Bulk Operations</b>. The following tabs will be displayed:<br><br><ul>\n<li><a href=\"/help/organization/bulk/operations\"><b>Bulk Operations</b></a>\n: To import, export, enable, disable, and delete subscribers in bulk.</li><br><li><a \nhref=\"/help/organization/bulk/delete\"><b>Deletion</b></a>: To delete multiple subscribers on the fly.</li><br><li><a \nhref=\"/help/organization/bulk/password\"><b>Password Modification</b></a>\n: To assign a new password for multiple subscribers on the fly.</li><br><li><a href=\"/help/organization/bulk/license\">\n<b>License</b></a>: To assign a license to multiple subscribers on the fly.</li><br><li><a \nhref=\"/help/organization/bulk/role\"><b>Role</b></a>: To assign a role to multiple subscribers on the fly.</li><br><li>\n<a href=\"/help/organization/bulk/applist\"><b>App List Assign</b></a>\n: To assign an application list to multiple subscribers on the fly.</li><br><li><a href=\"/help/organization/bulk/sms\">\n<b>SMS Provisioning</b></a>\n: To send provisioning SMS containing credentials and the download link to multiple subscribers on the fly.</li><br>\n<li><a href=\"/help/organization/bulk/emergency\"><b>Emergency Groups</b></a>\n: To assign an emergency group to multiple subscribers on the fly.</li><br><li><a \nhref=\"/help/organization/bulk/contactstemplates\"><b>Contacts Templates</b></a>\n: To assign contacts templates to multiple subscribers on the fly.</li><br><li><a \nhref=\"/help/organization/bulk/reports\"><b>Reports</b></a>: To generate and export reports.</li><br></ul></li><br></ol>\n<b><a href=\"help/organization\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/MobileAppsPlanning.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Mobile Apps Planning</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\">\n<p>\nTo enable whitelisted applications on a user device, you have to create an application list for the whole organization, create specific Applications profiles, and assign them to required users.\n</p><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: This is a billable option. A special client is required.</p><p>\nTo view the Mobile Apps Planning page, follow the steps below:</p><ol><li>\nNavigate in the tree of reseller and organizations to a relevant Organization.</li><br><li>\nOn the left panel navigate to <b>Organization > Mobile Apps Planning</b>.<br><br>\nThe following two tabs will be displayed:<br><br><ul><li><a href=\"help/organization/mobileAppsPlanning/applications\">\n<b>Applications</b></a>: This tab enables to manage the third-party applications.</li><br><li><a \nhref=\"help/organization/mobileAppsPlanning/applicationProfiles\"><b>Application Profiles</b></a>\n: This tab enables to manage the application lists.</li><br></ul></li></ol><b><a href=\"/help/organization\" \nalign=\"left\">Back</a></b><br><br></div><div class=\"footer\"><p>Copyright &copy 2022 Mobile Tornado Group plc.</p></div>\n</div>");
$templateCache.put("app/help-files/Organization.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Organization</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe organization menu enables to manage the subscribers, groups, contacts, bulk operations, recording planners, workforce management users, call log, mobile apps planning, and the organization details. First you need to select the relevant reseller and the organization.\n</p>To view the sub-menus of the organization menu, go to the left pane and click <b>Organization</b>.<br><br>\nThe sub-menu consists of:<br><br><li><b><a href=\"/help/organization/details\">Organization Details</a></b></li><br><li>\n<b><a href=\"/help/organization/subscribers\">Subscribers</a></b></li><br><li><b><a href=\"/help/organization/groups\">\nGroups</a></b></li><br><li><b><a href=\"/help/organization/contacts\">Contacts</a></b></li><br><li><b><a \nhref=\"/help/organization/bulk\">Bulk Operations</a></b></li><br><li><b><a href=\"/help/organization/recordingPlanner\">\nRecording Planner</a></b></li><br><li><b><a href=\"/help/organization/workForceManagement\">Workforce Management</a></b>\n</li><br><li><b><a href=\"/help/organization/callLog\">Call Log</a></b></li><br><li><b><a \nhref=\"/help/organization/mobileAppsPlanning\">Mobile Apps Planning</a></b></li><br><br><br><br><b><a href=\"/help/index\" \nalign=\"left\">Back</a></b><br><br></div><div class=\"footer\"><p>Copyright &copy 2022 Mobile Tornado Group plc.</p></div>\n</div>");
$templateCache.put("app/help-files/OrganizationDetails.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Organization Details</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\">\n<p>This page allows viewing and editing the details of the selected organization.<br><br>\nTo view or update the organization details, follow the steps below:</p><ol><li>\nNavigate to the relevant Organization using the tree.</li><br><li>On the left panel navigate to <b>\nOrganization > Organization Details</b> sub-menu and the Organization Details page appears.</li><br><li>The <b>General\n</b> tab displays the details of the selected Organization. If required, edit the <b>\nOrganization Name, Domain Name, Support First Name, Support Last Name, Creation Time, Site, activate Demo, Demo Expiration, activate &#34Keep a log of all calls&#34\n</b>, activate <b>Strong Password Plan</b>, set <b>Block Users Plan</b>, set <b>Password Expiration Plan</b>, and <b>\nRecording Plan</b> details. Once the changes are done, click <b>Save</b>.</li><br><li>The <b>Security and Download</b>\n tab displays the Encryption Plan and Application Versions plan.</li><br><li>The <b>Branding</b>\n tab displays an application name to be shown on the mobile client, offline maps server address, colors of the mobile application, uploaded mobile app splash image, console logo, splash image, and company name image.\n</li><p style=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: This tab is available only if the value of the parameter <b>PROV_SHOW_BRANDING</b> is set as <b>1</b>\n in the Platform System Configuration Custom page.</p>\nYou can view or change the required configurations, override the default configurations, or override the configurations set at the Reseller level using the \n<b>Override Reseller Branding</b> option.<br><p style=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: To override the default images set, first upload the image, save the changes, and then enable the option &#34Override Default Branding&#34.\n</p>Once done, click the <b>Save Branding Configuration</b> button. To restore an original configuration, click the <b>\nRevert all to the Default Branding</b> button and then click <b>Save</b>.<br></ol><br><br><br><b><a \nhref=\"/help/organization\" align=\"left\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/OrganizationManager.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\" id><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Organization Manager</h1></div><span id=\"search\">\n</span> <span id=\"add\"></span><div class=\"content\"><p>\nThe system enables one to define multiple organizations that will have their own users, groups, and subscribers enabling their autonomous management by the Organization&#39s administrators.\n</p><p style=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: To manage the organizations, you must have the organizational level access rights such as to View, Add, Modify, and Delete Organizations.\n</p><p>To manage an organization, on the left panel navigate to <b>Reseller > Organization Manager</b>\n and the Organization Manager page appears.<br><br>Before making any changes, select a relevant <b>reseller</b>\n. A reseller can be selected from the <b>Resellers</b> dropdown list located at the top of the window.<br><br>\nFrom this page, you can <a href=\"help/reseller/organizationManager#search\">search</a>, <a \nhref=\"help/reseller/organizationManager#add\">add, <a href=\"help/reseller/organizationManager#view\">edit</a>, and <a \nhref=\"help/reseller/organizationManager#view\">delete</a>\n an organization for the selected reseller as well as allocate a quantity of PTT or Dispatcher licenses to the organization. You can also sort the Organization name and CRMID in ascending or descending order. Moreover, you can define the number of records getting displayed in the table using the \n<b>Records</b> dropdown list located below the table.</a></p><br><h3 id=\"search\" style=\"font-weight: bold\">Search</h3>\n<p>To search a required organization from the list,</p><ul><li>Type a few characters in the <b>Search</b>\n field and a list of organizations containing the text will be displayed.</li></ul><br><h3 id=\"add\" \nstyle=\"font-weight: bold\">Adding an Organization</h3><p>To add an organization, follow the steps below:</p><ol><li>\nSelect a relevant reseller.</li><br><li>On the left pane navigate to <b>Reseller > Organization Manager</b>.</li><br>\n<li>Click the <b>Add</b> button and the <b>Organization Details</b> pop-up window appears.</li><br><li>In the <b>\nGeneral</b> tab, provide the following details:</li><br><table class=\"a\" align=\"center\" cellpadding=\"7\"><col \nwidth=\"30%\"><col width=\"70%\"><tr style=\"background-color: #3492DD\" height=\"40px\"><th style=\"font-size:20px\">Parameters\n</th><th style=\"font-size:20px\">Description</th></tr><tr><td>CRMID</td><td>\nProvide a unique CRM ID for the Organization. Any alpha-numeric number is allowed.</td></tr><tr><td>Organization Name\n</td><td>Name of the organization. A maximum of 40 characters is allowed.</td></tr><tr><td>Domain Name</td><td>\nThe domain name of the organization. A maximum of 50 characters is allowed.</td></tr><tr><td>Support First Name</td>\n<td>First name of the organizational contact person for support issues.</td></tr><tr><td>Support Last Name</td><td>\nLast name of the organizational contact person.</td></tr><tr><td>Creation Time</td><td>\nDisplays the creation time of an organization.</td></tr><tr><td>Site</td><td>Select the site for the organization.<p \nstyle=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: The default site should not be changed unless told so by the service provider.</p></td></tr><tr><td>Demo</td><td>\nEnable if an organization is to be created as a demo. Once enabled, you need to set its expiration date.<br><ul \nstyle=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThis feature is available only if the value of the parameter <b>PROV_SHOW_DEMO_ORGANIZATION</b>\n is set as 1 in the Platform System Configuration Custom page. (Root Admins only)</li><br><li>\nOnce disabled, only Root Admins can activate this feature as well as change the expiration date.</li><br></ul></td>\n</tr><tr><td>Keep a log of all calls</td><td>\nEnable logging the calls of all users in the organization. On enabling this, the data of PTT sessions are stored and can be displayed on the Call Log page.\n<p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: This option is available only if the value of the parameter <b>PROV_SHOW_CALL_LOG</b> is set as <b>1</b>\n in the Platform System Configuration Custom page.</p></td></tr><tr><td>Strong Password Plan</td><td>\nSelect a strong password plan for any of the following options:<br><br><ul><li><b>\nForce strong password for Dispatchers*</b>\n: Force subscribers with a Dispatcher license to use a strong password. If the password is weak, created or updated subscriber will not be saved, and the Save button remains disabled.\n<p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: This feature is available only if the value of the parameter <b>PROV_SHOW_STRONG_DISPATCH_PASS</b> is set as <b>1</b>\n in the Platform System Configuration Custom page. (Root Admins only)</p></li><li><b>\nForce strong password for Recording Reviewers*</b>\n: Force administrators to use a strong password for Recording Reviewers. If the password is weak, created or updated Recording Reviewer will not be saved and the Save button remains disabled.\n<p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: This feature is available only if the value of the parameter <b>PROV_SHOW_STRONG_RECORDING_REVIEWERS_PASS</b>\n is set as <b>1</b> in the Platform System Configuration Custom page. (Root Admins only)</p></li><li><b>\nForce strong password for Administrators*</b>\n: Force subscribers to use a strong password for administrators. If the password is weak, created or updated administrator will not be saved and the Save button remains disabled.\n<p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: This feature is available only if the value of the parameter <b>PROV_SHOW_STRONG_ADMINISTRATOR_PASS</b> is set as <b>\n1</b> in the Platform System Configuration Custom page. (Root Admins only)</p></li></ul></td></tr><tr><td>\nBlock Users Plan</td><td><b>Maximum login retries</b>\n: Activate and enter the maximum number of allowed login retries after which the users\' account will get locked.</td>\n</tr><tr><td>Password Expiration Plan</td><td><b>Password Expiration Days</b>\n: Activate and enter the number of days after which the password will get expired.</td></tr><tr><td>Recording Plan</td>\n<td>\nSelect if and which of the PTT sessions are to be recorded for the organization. These sessions can then be played using the IPRS Recordings Player™. \n<b>The default value is No Recording</b>.<br><br><b>Available Options:</b><br><br><ul><li><b>No Recording</b>\n: Select if no sessions are to be recorded.</li><br><li><b>Record All Calls</b>\n: Select if all the sessions within the organization are to be recorded.</li><br><li><b>Selective Recording</b>\n: Select if the PTT session of only specific users/groups are to be recorded. On selecting this option, the tabs: <b><a\n href=\"help/organization/recordingPlanner/users\">Recorded Users</a></b> and <b><a \nhref=\"help/organization/recordingPlanner/groups\">Recorded Groups</a></b>\n, get enabled in the Recording Planner sub-menu.</li></ul><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i>\n</b>: You need to have Reseller rights to enable session recording for an organization.</p></td></tr></table><br><br>\n<ul style=\"background-color: lightgrey\"><b>*<i><u>Notes</u></i></b>:<br><br><li>\nA strong password must contain 10 to 15 characters with at least 1 lowercase, 1 uppercase, 1 special character _@.#$=!%^)(]:*;?/,`~&;}{\'|>[&+-], and 1 numeric.\n</li><br><li>A password should not contain identical and consecutive characters or numbers.</li><br></ul><li>Click <b>\nSave</b> and the newly created organization gets displayed in the table.</li><br><li>\nOnce an organization gets created in the portal, by default eleven roles get automatically assigned to this organization. You can verify this from the \n<b>Roles</b> sub-menu under the <b>Administrator</b> menu.</li><br></ol><br><h3 id=\"view\" style=\"font-weight: bold\">\nViewing, Editing, and Deleting an Organization</h3><p>\nOnce the organization gets created, you can view or update the organization and add branding configurations to it. To do so, follow the steps below:\n</p><ol><li>To view or edit an organization, click on the required organization name, and the <b>Organization Details\n</b> pop-up window appears.</li><br><li>The <b>General</b>\n tab displays the details of the selected organization. You can edit the required details.<br><br>Set the <b>\nDemo Expiration</b>\n date, if an organization is enabled as a demo. Once set, when the period is expired, the organization will get converted from demo to production. Also, from that very moment, the organization\'s licenses are billable.\n<br><br></li><li>The <b>Security and Download</b>\n tab enables you to view and select an appropriate encryption or application version plan.<br><br><ul><li><b>\nEncryption Plan:</b><br><br>This enables you to set the security keys for encrypting calls using the below options.<br>\n<br><ol type=\"a\"><li><b>Remove All Keys</b>\n: Click to remove the set encryption keys for all the clients of the selected organization.</li><br><li><b>\nGenerate Random Encryption Keys</b>\n: Click to generate and set a file of random encryption keys for encrypting call of all the newest Android OS clients of the organization. The old clients are not supporting this feature.\n<br><p style=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: This button is available only if the value of the parameter <b>PROV_SHOW_RANDOM_ENCRYPTION_KYES_BUTTON</b> is set as \n<b>1</b> in the Platform System Configuration Custom page.</p><p style=\"background-color: lightgrey\" ;><b><i><u>Warning\n</u></i></b>: Do not generate random encryption keys if Affiliated organizations are defined.</p></li><li><b>\nUse Default Keys</b>\n: Click to set a file of the default built-in security keys used with older versions of the mobile clients to all the subscribers of the organization.\n</li><br></ol></li><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nTo use an uploaded Default key by an older mobile application, assign a proper Role with the <b>Encryption</b>\n value enabled from the <b>Call Features</b> section.</li><br><li>The user is required to hold <b>\nHigh Impact Organization</b> permission from the <b>Organization Admin role permissions</b> page.</li><br><li>\nThis encryption key feature is available only if the value of the parameter <b>PROV_SHOW_ENCRYPTION</b> is set as <b>1\n</b> in the Platform System Configuration Custom page.</li><br></ul><br>Once the option is selected, the <b>\nCurrent Encryption Status</b> row will display a selected option along with the <b>Encryption keys version</b>\n. The setting will get implemented in the PTT application soon and all the calls will get encrypted henceforth.</ul>\n</li><br><ul><li><b>Applications Versions Plan:</b><br><br>\nThis enables you to upload the latest versions as well as remove the older versions of Android APK and Dispatch Console application files respectively. Once uploaded, the application of all the active users of the organization who possess an older version will get updated to the latest one (as pushed by the provisioning portal).\n<br><br>Click the <b>Choose File</b>\n button to browse and select the required application file. Once selected, click the <b>Load Android APK File</b>\n button or <b>Load MDC2000 Exe File</b> button to load the respective files. Once the files are uploaded, the rows <b>\nLatest version of Android application</b> and <b>Latest MDC2000 version</b> will display them.<br><br>\nYou can also click the <b>Remove Android APK File</b> button or <b>Remove MDC2000 Exe File</b>\n button to remove any of the required files.<p style=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: This feature is available only if the value of the parameter <b>PROV_SHOW_UPLOAD_VERSION</b> is set as <b>1</b>\n in the Platform System Configuration Custom page.</p></li></ul><li>The <b>Branding</b>\n tab enables to set the different color themes for different organizations. It displays the branding configurations like application name, color pickers for selecting colors as per the organization’s favorite theme, Mobile App Splash image, Dispatch Console Logo, and Company name image.\n<br><p style=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: This tab is available only if the value of the parameter <b>PROV_SHOW_BRANDING</b> is set as <b>1</b>\n in the Platform System Configuration Custom page.</p><ul><li>Enter the <b>Application name</b>.</li><br><li>Enter the \n<b>Maps Server</b> IP <b>Address</b>\n of the offline map server. If entered, the MDC2000 application stops using the online OSM maps. It will use this server IP address for getting map tiles and display the map accordingly. If the server address is not provided, the MDC2000 application continues to use the same online OSM maps.\n</li><br><li>Select the <b>color</b> using the color pickers or enter the color code in the hexadecimal digit. <b>\nColor 1</b> is the primary color and depicts the header color of the application. <b>Color 2</b>\n refers to the secondary color and depicts the color of the tabs on the home screen.<br><br><ul \nstyle=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThe branding configurations and image differ from organization to organization.</li><br><li>\nThe color code should be in a hexadecimal format.</li><br></ul></li><br><li>If required, <b>upload</b> a <b>\nMobile App Splash Image, Dispatch Console Logo, Splash Image</b>, and <b>Company Name Image</b> of the application.<br>\n<br><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nFor logo image only .ico file format is supported.</li><br><li>Maximum image file size is 200 KB.</li><br><li>\nThe supported image file formats are PNG, JPG, and JPEG.</li><br></ul></li><br><li>If required, enable the option <b>\nOverride Default Branding</b>\n next to the configuration(s) whose value is to be overridden. If disabled, the default values will be visible in the PTT or Dispatch Console application.\n</li><br><li>If required, enable the option <b>Override Reseller Branding</b>\n to override the branding set at the reseller level by the branding set at the organization level.</li></ul><p>\nOnce done, click the <b>Save Branding Configuration</b>\n button. To revert all the configurations to its default value, click the <b>Revert all to Default Branding</b>\n button and then click Save. This will clear all the set configurations and revert to the default values.</p></li><li>\n<b>Affiliated Organizations</b>\n are those that are associated with other organizations to enable off-net communication among their subscribers. In the \n<b>Affiliated Organizations</b>\n tab select the organizations to enable cross-fleet, off-net communication with the current organization. This enables the subscribers (having Off-net License) to add subscribers (with Off-net License) of the associated organization(s) as contacts as well as establish a PTT call or send an IM to those contacts.\n<br><br><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThis tab is available only if the value of the parameter <b>PROV_SHOW_ORGANIZATION_FRIENDS</b> is set as <b>1</b>\n in the Platform System Configuration Custom page.</li><br><li>\nThis feature is supported only for private and ad-hoc group calls. Inter-organizational server groups (radio and conference) will be supported in a future release.\n</li><br><li>\nThe subscribers can call each other, only if the participants hold Off-net License and the organizations of both the participants are affiliated with each other.\n</li><br><li>Only ITO users with reseller permissions can set the affiliations for an organization.</li><br></ul><p>\nSelect the organization(s) or ALL from the left pane by clicking the + icon or clicking the <b>Select All</b>\n button. The previosly unselected organizations will move to the <b>&#34Selected&#34</b> list.</p></li><li>\nOnce the modifications are done, click <b>Save Affiliated Organizations</b>.</li><br><li>The <b>Affiliated Groups</b>\n enables off-net communication through Radio or Conference among subscribers with Off-net licenses from multiple organizations under the same Reseller. A new respective tab is added on the Organization Details page of the Reseller Organization Manager.\n<br><br>\nTo do so, the Reseller administrator needs to create a group with subscribers from various affiliated organizations. The groups created from here will be displayed on the Group\'s main page of the originating organization and will be available from the PTT application as a regular group. Once the groups are created, the subscribers can then establish a group call or send an IM.\n</li><br><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThese groups can be created from the Affiliated Groups tab only.</li><br><li>\nOnly ITO users with reseller permissions can set the affiliations for a group.</li><br></ul><br>\nTo create an affiliated group:<br><br><ol type=\"A\"><li>Click the <b>Add</b> button and the <b>Group Details</b>\n page appears.</li><br><li>In the <b>General tab</b>, provide the following details:<br><br><ul><li>Enter the <b>\nGroup name</b>.</li><br><li>Select the <b>Group type</b>: Radio or Conference.</li><br><li>If required, select the <b>\nEnd date</b>\n(expiry date) using the calendar icon based on which the group will get deleted automatically. The group will get deleted at 12:00 AM of the set time. Click the \n<b>cross</b> icon to remove the date.</li><br></ul></li><li>Select the <b>Subscribers List</b> tab.</li><br><li><b>\nSelect the Organization</b> from which the subscribers are to be added using the Organizations\' dropdown list.<p \nstyle=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: Only affiliated organizations will be available in the organizations dropdown list.</p></li><li>\nSelect the subscribers or ALL from the left pane by clicking the + icon or clicking the Select All button. The previously unselected organizations will move to the &#34Selected&#34 list.\n</li><br><li>Once done, click Save</li><br><li>\nThe newly created group will be displayed in the table as shown below. Also, this group will be displayed in the main groups page.\n</li><br></ol><li>The <b>Affiliated Contacts</b>\n tab is used to add contacts from other affiliated organizations to the personal contacts list of a particular user. These contacts will then be available in the personal contact list of the subscribers. You can affiliate only those contacts that hold an off-net license and belong to the affiliated organizations.\n<br><br>\nTo do so, click on the subscriber for which the personal contacts are to be added, and the personal contacts window appears.\n</li><br><ol type=\"A\"><li><b>Select the Organization</b>\n from which the subscribers are to be added using the Organizations\' dropdown list.<p \nstyle=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: Only affiliated organizations will be available in the organizations\' dropdown list.</p></li><li>\nSelect the subscribers or ALL from the left pane by clicking the + icon or clicking the Select All button. The previously unselected organizations will move to the &#34Selected&#34 list.\n<br><p style=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: Subscribers holding off-net licenses only are available in the list.</p></li><li>Once done, click <b>Save</b>\n, and the selected contacts get added to the personal contact list of the subscriber.</li><br></ol><li>\nClick Save and the organization gets updated displaying a message &#34Updated successfully&#34.</li><br><li>To <b>\ndelete</b> an organization, click the <b>remove</b> icon. A dialog box appears. Click the <b>Remove</b>\n button to delete the selected organization and a confirmatory message stating <b>&#34Removed Successfully&#34</b>\n appears on the screen.<p style=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: All the subscribers should be deleted from the organization first, before attempting to delete an organization. You may delete the subscribers one by one or use a dedicated bulk operation to delete them all at once.\n</p></li><br></ol><br><b><a href=\"help/reseller/organizationManager#top\" target=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"help/reseller\" align=\"left\">Back</a></b><br><br><br><br><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/PReports.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Reports</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe page enables to generate and export reports.</p><p>To view the Reports page, navigate to <b>Platform > Reports</b>\n and the dialog appears.<br><br>The page displays the following items:</p><ul><li><b>Result Log</b>\n: Displays the status of the report being generated.</li><br><li><b>Export License Usage Report</b>\n: Click to export the report based on the license usage in CSV or Excel format.</li><br><li><b>\nExport List of Subscribers</b>: Click to export the report based on the subscribers list in CSV or Excel format.</li>\n<br><li><b>Export Recording Reviewer</b>: Click to export the report of the recorded reviewers in CSV or Excel format.\n</li></ul><br><br><b><a href=\"help/platform\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/PasswordModification.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Password Modification</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\">\n<p>\nThe Password Modification tab enables you to assign a password for selected or all the subscribers in one go. Following this operation, all the affected subscribers\n<u>will have the same password</u>.</p><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: This feature is available only if the user holds the <b>Modify Subscribers</b> and <b>Batch Operations</b>\n permission from the <b>Provisioning Role Permissions</b> page.</p><br><p>To do so,</p><ol><li>\nOn the left panel navigate to <b>Organization > Bulk Operations > Password Modification</b> tab.<br><br></li><li>\nSelect the subscriber(s) or ALL from the left pane by clicking the + icon or clicking the <b>Select All</b>\n button. The previously unselected subscribers will move to the <b>&#34Selected&#34</b> list.</li><br><li>\nSelect any of the below options to set new password:<ul><br><li><b>Selected Password</b>\n: Select to set a common password for all the selected subscribers. Once selected, enter Enter the password and confirm the password. You can also generate the password using the \n<b>Generate Password</b> icon. To view the hidden password, click the <b>View Password </b>icon.<br><br>OR</li><br><li>\n<b>Generate Unique Password</b>: Select to generate a unique password for all the selected subscribers.</li><br></ul>\n</li><li>Once done, click the <b>Set New Password</b> button and a dialog box appears. Click <b>OK</b>\n if the password is to be modified. A message stating <b>&#34Updated Successfully.&#34</b> will be displayed.</li><p \nstyle=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>: By default, the <b>Set New Password </b>\nbutton remains disabled. It gets enabled only after typing the password and confirming it.</p></ol><br><br><b><a \nhref=\"help/organization/bulk\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/Platform.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Platform</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe Platform menu enables the administrators of the service to view the licenses, system configurations, and generate reports.\n<br><br>To view the sub-menus of the platform menu, navigate to the left pane, and click <b>Platform</b>.</p><p \nstyle=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: Only an ITO user with root admin rights can access the Platform menu and its sub-menus.</p>The sub-menu consists of:\n<br><br><li><b><a href=\"help/platform/licenses\">Licenses</a></b></li><br><li><b><a \nhref=\"help/platform/SystemConfiguration\">System Configuration</a></b></li><br><li><b><a href=\"help/platform/reports\">\nReports</a></b></li><br><br><br><br><b><a href=\"/help/index\" align=\"left\">Back</a></b><br><br></div><div \nclass=\"footer\"><p>Copyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/RecordedGroups.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Recorded Groups</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThis tab enables to select the groups whose PTT sessions are to be recorded.</p><p style=\"background-color: lightgrey\">\n<b><i><u>Note</u></i></b>: By default, this tab is disabled. To enable it, select the <b>Recording Plan</b> as <b>\nSelective Recording</b> from the Organization Details page.</p><p>To select the server groups to be recorded,</p><ol>\n<li>Navigate in the tree of resellers and organizations to the relevant Organization.</li><br><li>\nOn the left panel navigate to <b>Organization > Recording Planner > Recorded Groups</b> tab.</li><br><li>\nSelect the group(s) or ALL from the left pane by clicking the + icon or clicking the <b>Select All</b>\n button. The previously unselected groups will move to the <b>&#34Selected&#34</b> list.</li><br><li>Click the <b>\nSave Plan for Groups </b>and a message stating <b>&#34Updated Successfully&#34</b> appears.</li></ol><br><br><b><a \nhref=\"/help/organization/recordingPlanner\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/RecordedUsers.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Recorded Users</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThis tab enables to select the users whose PTT sessions are to be recorded.</p><p style=\"background-color: lightgrey\">\n<b><i><u>Note</u></i></b>: By default, this tab is disabled. To enable it, select the <b>Recording Plan</b> as <b>\nSelective Recording</b> from the Organization Details page.</p><p>To select the users to be recorded,</p><ol><li>\nNavigate in the tree of resellers and organizations to the relevant Organization.</li><br><li>\nOn the left panel navigate to <b>Organization > Recording Planner > Recorded Users</b> tab.</li><br><li>\nSelect an individual subscriber(s) or ALL from the left pane by clicking the + icon or clicking the <b>Select All</b>\n button. The previously unselected subscribers will move to the <b>&#34Selected&#34</b> list.</li><br><li>Click <b>\nSave Plan for Users </b>and a message stating <b>&#34Updated Successfully&#34</b> appears.</li></ol><br><br><b><a \nhref=\"/help/organization/recordingPlanner\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/RecordingPlanner.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Recording Planner</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nRecording Planner sub-menu enables to manage the recordings reviewers, store the backup of recordings data, and select the users or groups whose PTT sessions are to be recorded. You need Reseller rights to enable recording.\n</p><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: This feature is available only if the value of the parameter <b>PROV_SHOW_RECORDING</b> is set as <b>1</b>\n in the Platform System Configuration Custom page.</p><p>To view the Recording Planner page, follow the steps below:\n</p><ol><li>Navigate in the tree of resellers and organizations to the relevant Organization.</li><br><li>\nOn the left panel navigate to <b>Organization > Recording Planner</b>.<br><br>\nThe following three tabs will be displayed:<br><br><ul><li><a href=\"help/organization/recordingPlanner/reviewers\"><b>\nRecordings Reviewers</b></a>: To manage the recordings reviewers who can use the IPRS Recordings Player™.</li><br><li>\n<a href=\"help/organization/recordingPlanner/storagemanagement\"><b>Storage Management</b></a>\n: To store the location path of the backup of recordings taken from the IPRS Recordings Player™.</li><br><li><a \nhref=\"help/organization/recordingPlanner/users\"><b>Recorded Users</b></a>\n: To select the users whose PTT sessions are to be recorded.</li><br><li><a \nhref=\"help/organization/recordingPlanner/groups\"><b>Recorded Groups</b></a>\n: To select the server groups whose PTT sessions are to be recorded.</li><br></ul></li></ol><p \nstyle=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>: <b>Recorded Users</b> and <b>Recorded Groups</b>\n tabs are enabled only if the <b>Recording Plan</b> is set as <b>Selective Recording</b> from the <b>\nOrganization Details</b> page. By default, they are disabled.</p><b><a href=\"/help/organization\" align=\"left\">Back</a>\n</b><br><br></div><div class=\"footer\"><p>Copyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/RecordingsReviewers.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Recordings Reviewers</h1></div><span id=\"S1\">\n</span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe reviewer accounts created here can then be used to sign-in to the IPRS Recordings Player™ and retrieve as well as play the recordings.\n</p><p>To manage the reviewers, navigate to <b>Organization > Recording Planner > Recordings Reviewers</b>.<br><br>\nFrom this page, you can <a href=\"help/organization/recordingPlanner/reviewers#search\">search</a>, <a \nhref=\"help/organization/recordingPlanner/reviewers#add\">add</a>, <a \nhref=\"help/organization/recordingPlanner/reviewers#add\">edit</a>, and <a \nhref=\"help/organization/recordingPlanner/reviewers#add\">delete</a>\n a reviewer for an organization. You can also sort the email addresses used as username for signing-in to the playback service, recent login time, recent activity time, and last password modification columns in ascending or descending order. Moreover, you can define the number of records getting displayed in the table using the \n<b>Records</b> dropdown list located below the table.</p><br><h3 id=\"search\" style=\"font-weight: bold\">Search</h3><p>\nTo search a required reviewer from the list,</p><ul><li>Type a few characters in the <b>Search</b>\n field and a list of reviewers containing the typed letters will be displayed.</li><br></ul><h3 id=\"lock\" \nstyle=\"font-weight: bold\">Lock/Unlock Recording Reviewer\'s Account</h3><p>\nWhen a reviewer tries to sign-in to the IPRS Recording Player™ with wrong credentials and exceeds the maximum number of retries, the account gets locked. The administrators can lock or unlock a reviewer’s account from the Recordings Reviewers main page.\n</p><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThis feature is available if the value of the parameter <b>PROV_SHOW_BLOCK_RELEASE</b>\n is set as 1 in the Platform System Configuration Custom page. (Root Admins only).</li><br><li>\nThe maximum number of sign-in retries can be defined in the parameter <b>PROV_RECORDER_MAX_LOGIN_RETRIES</b>\n from the Platform System Configuration Custom page. <b>The default value is 3.</b></li><br></ul><p>\nTo lock an account, click the <b>lock</b> icon next to any recording reviewer’s email id and a dialog appears.<br><br>\nClick <b>OK</b> and a confirmation message <b>&#34Account has been blocked successfully.&#34</b>\n appears on the screen. Also, the selected reviewer’s lock state changes to a red color.<br><br>\nSimilarly, on clicking the <b>red lock</b> icon the locked account gets unlocked.</p><br><h3 id=\"add\" \nstyle=\"font-weight: bold\">Adding or Editing a Recordings Reviewer</h3><p>\nTo add or edit a Recordings Reviewer, follow the steps below:</p><ol><li>Click the <b>Add</b> button and the <b>\nRecordings Reviewer Details</b> pop-up window appears.</li><br><li>Enter the following details:<br><br><ul><li>\nEnter the login email address: <b>Email address</b> maximum of up to 50 characters.</li><br><li>Enter a <b>password</b>\n maximum up to 15 characters.<br><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nA strong password must contain 10 to 15 characters with at least 1 lowercase, 1 uppercase, 1 special character _@.#$=!%^)(:*;?/,`~&;}{\'|>[&+-], and 1 numeric.\n</li><br><li>It should not contain identical and consecutive characters or numbers.</li><br></ul></li><li><b>Retype</b>\n the <b>password</b> for confirmation.</li><br><li>Click the <b>Generate Password</b>\n icon to generate a strong password for you. On clicking, a system-generated password will be available and used for signing-in the IPRS Recording Player™.\n</li><br><li>Click the <b>View Password</b> icon to view the hidden password.</li><br></ul></li><li>Click <b>Save</b>\n and the newly created reviewer appears in the table.</li><br><li>To <b>edit</b>\n an existing Reviewer, click on the required email address to be edited and the <b>Recordings Reviewer Details</b>\n pop-up window appears.<br><br>The window displays two tabs namely: <b>Reviewer Details</b> and <b>Activity Details</b>\n.<br><br><ul><li>The <b>Reviewer Details</b>\n tab displays an email address and the password. Edit the required details and click <b>Save</b>.</li><br><li>The <b>\nActivity Details</b>\n tab displays the activities of the reviewer performed after signing-in to the IPRS Recording Player.<br><p \nstyle=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: The reviewer’s activities are displayed for 24hrs only. Entries older than 24hrs will get deleted automatically.</p>\nYou can click the <b>Refresh</b>\n button to view the activities of the reviewer performed in the Recording Player at run time.</li><br></ul></li><li>To \n<b>delete</b> a recording reviewer, click the <b>remove</b> icon. A dialog box appears. Click the <b>Remove</b>\n button and a confirmatory message <b>&#34Removed Successfully&#34</b> appears.</li><br></ol><br><br><b><a \nhref=\"help/organization/recordingPlanner/reviewers#top\" target=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"help/organization/recordingPlanner\" align=\"left\">Back</a></b><br><br><br><br></div><br><br><br><div \nclass=\"footer\"><p>Copyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/Reseller.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Reseller</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe reseller menu enables us to view the reseller details and manage the organizations and the resellers. First select a relevant reseller from the \n<b>Resellers</b> dropdown list and then click on any of the three sub-menus.<br><br>\nThe menu contains the following three sub-menus:</p><br><li><b><a href=\"help/reseller/resellerDetails\">Reseller Details\n</a></b></li><br><li><b><a href=\"help/reseller/resellerManager\">Reseller Manager</a></b></li><br><li><b><a \nhref=\"help/reseller/organizationManager\">Organization Manager</a></b></li><br><br><br><br><b><a href=\"/help/index\" \nalign=\"left\">Back</a></b><br><br></div><div class=\"footer\"><p>Copyright &copy 2022 Mobile Tornado Group plc.</p></div>\n</div>");
$templateCache.put("app/help-files/ResellerDetails.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Reseller Details</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\"><p>\nThe reseller details page displays the general details, the SMS Provider Configuration, and the branding of the reseller.\n</p><ul><li>To view the Reseller Details, first select a relevant reseller from the <b>Resellers</b> dropdown list.\n</li><br><li>On the left panel navigate to <b>Reseller > Reseller Details</b>.</li><br><li>The <b>General</b>\n tab displays the details of the selected reseller. Here, you can edit the required details and click <b>Save</b>.</li>\n<br><li>The <b>SMS Provider Configuration</b> tab displays the <b>API Key, API secret</b>, and <b>SMS Service</b>\n of the reseller. You can edit all if required.</li><br><li>The <b>Branding</b>\n tab enables to set the different color themes for different organizations. It displays the branding configurations like application name, color pickers for selecting colors as per the organization’s favorite theme, Mobile App Splash image, Dispatch Console Logo, and Company name image. To set the branding for sub-resellers and sub-organizations, and to override the configurations at the organization level, enable the option \n<b>Set Branding for sub-Resellers and sub-Organizations</b>.<p style=\"background-color: lightgrey\" ;><b><i><u>Note</u>\n</i></b>: This tab is available only if the value of the parameter <b>PROV_SHOW_BRANDING</b> is set as <b>1</b>\n in the Platform System Configuration Custom page.</p></li><li>Once done, click <b>Save</b>\n and the Reseller Details get saved.</li><br></ul><br><br><b><a href=\"help/reseller\" align=\"right\">Back</a></b><br><br>\n<br></div><div class=\"footer\"><p>Copyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/ResellerManager.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\" id><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Reseller Manager</h1></div><span id=\"search\">\n</span> <span id=\"add\"></span><div class=\"content\"><p>\nThe Reseller Manager page enables the management of all resellers.<br><br>\nTo view the Reseller Manager page, select a relevant reseller from the <b>Resellers</b> dropdown list.<br><br>\nOn the left panel navigate to <b>Reseller > Reseller Manager</b>.<br><br>From this page, you can <a \nhref=\"help/reseller/resellerManager#search\">search</a>, <a href=\"help/reseller/resellerManager#add\">add</a>, <a \nhref=\"help/reseller/resellerManager#edit\">edit</a>, <a href=\"help/reseller/resellerManager#delete\">delete</a>\n a reseller, as well as allocate a quantity of PTT and Dispatcher licenses to the required reseller. You can also sort the Reseller name, Address, and Portal URL fields in ascending or descending order. Moreover, you can define the number of records getting displayed in the table using the \n<b>Records</b> dropdown list located below the table.</p><br><h3 id=\"search\" style=\"font-weight: bold\">Search</h3><p>\nTo search a required reseller from the list,</p><ul><li>Type a few characters in the <b>Search</b>\n field and the reseller names containing those characters will be displayed in the table.</li></ul><br><h3 id=\"add\" \nstyle=\"font-weight: bold\">Adding or Editing a Reseller</h3><p>To add a reseller, follow the steps below:</p><ol><li>\nClick the <b>Add</b> button and the <b>Reseller Details</b> pop-up window appears.</li><br><li>In the <b>General</b>\n tab provide the following details:</li><br><table class=\"a\" align=\"center\" cellpadding=\"7\"><col width=\"30%\"><col \nwidth=\"70%\"><tr style=\"background-color: #3492DD\" height=\"40px\"><th style=\"font-size:20px\">Parameters</th><th \nstyle=\"font-size:20px\">Description</th></tr><tr><td>CRM ID</td><td>Provide a unique CRM ID to the reseller.</td></tr>\n<tr><td>Reseller Name</td><td>Name of the reseller. A maximum of 40 characters is allowed.</td></tr><tr><td>Address\n</td><td>Address of the reseller.</td></tr><tr><td>Site</td><td>Select the site for the reseller.</td></tr><tr><td>\nPortal URL</td><td>Portal URL of the reseller.</td></tr><tr><td>Web Service URL</td><td>URL of web service.</td></tr>\n<tr><td>Force strong password for Administrator</td><td>\nForce subscribers to use a strong password for administrators. If the password is weak, created or updated administrator will not be saved and the Save button remains disabled.\n<ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nA strong password must contain 10 to 15 characters with at least 1 lowercase, 1 uppercase, 1 special character _@.#$=!%^)(]:*;?/,`~&;}{\'|>[&+-], and 1 numeric.\n</li><br><li>A password should not contain identical and consecutive characters or numbers.</li><br><li>\nThis feature is available only if the value of the parameter <b>PROV_SHOW_STRONG_ADMINISTRATOR_PASS</b> is set as <b>1\n</b> in the Platform System Configuration Custom page. (Root Admins only)</li><br></ul></td></tr></table><br><br><li>\nIn the <b>SMS Provider Configuration</b> tab enter the <b>API key, API secret</b> of the reseller and select the<b>\nservice provider</b>. This is used to send the provisioning SMS to the subscribers in bulk or individually.<p></p></li>\n<li>In the <b>Branding</b>\n tab, set the different color themes for different sub-resellers and sub-organizations. It displays the branding configurations like application name, color pickers for selecting colors as per the reseller’s favorite theme, Mobile App Splash image, Dispatch Console Logo, and Company name image.\n</li><br><ul><li>Enter the <b>Application name</b>.</li><br><li>Enter the <b>Maps Server</b> IP <b>Address</b>\n of the offline map server. If entered, the MDC2000 application stops using the online OSM maps. It will use this server IP address for getting map tiles and display the map accordingly. If the server address is not provided, the MDC2000 application continues to use the same online OSM maps.\n</li><br><li>Select the <b>color</b> using the color pickers or enter the color code in the hexadecimal digit. <b>\nColor 1</b> is the primary color and depicts the header color of the application. <b>Color 2</b>\n refers to the secondary color and depicts the color of the tabs on the home screen.<br><br><ul \nstyle=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThe branding configurations and image differ from reseller to reseller.</li><br><li>\nThe color code should be in a hexadecimal format.</li><br></ul></li><br><li>If required, <b>upload</b> a <b>\nMobile App Splash Image, Dispatch Console Logo, Splash Image</b>, and <b>Company Name Image</b> of the application.<br>\n<br><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nFor a logo image, only the &#34.ico&#34 file format is supported.</li><br><li>The maximum image file size is 200 KB.\n</li><br><li>The supported image file formats are PNG, JPG, and JPEG.</li><br></ul></li><br><li>\nIf required, enable the option <b>Override Default Branding</b>\n next to the configuration(s) whose value is to be overridden. If disabled, the default values will be visible in the PTT or Dispatch Console application.\n</li><br><li>Enable the option <b>Set Branding for sub-Resellers and sub-Organizations</b>\n to set branding for the lower level resellers and organizations. Once enabled, the branding set at the individual lower levels will get overridden and the one that is set at the highest reseller level will get applied to all the users.\n</li><br><li>Once done, click the <b>Save Branding Configuration</b>\n button. To restore an original configuration, click the <b>Revert all to Default Branding</b> button and then click \n<b>Save</b>. This will clear all the set configurations and revert to the default values.</li><br></ul><li>\nOnce done, click <b>Save</b> and the newly created reseller gets displayed.</li><br><li>\nNow, you can allocate a quantity of PTT or Dispatcher licenses to the required reseller by entering the number in the \n<b>Allocate</b> column and clicking <b>Apply</b>.<br><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: This facility is available only if the value of the parameter <b>PROV_SHOW_LICENSE_ALLOCATION</b>\n is set as 1 in the Platform System Configuration Custom page.</p>\nThe total number of licenses will get updated accordingly.</li><br><li id=\"edit\">To <b>edit</b>\n a reseller, click on the required reseller name to be edited and the <b>Reseller Details</b> pop-up window appears.\n</li><br><li>Edit the required details in the <b>General</b>, <b>SMS Configuration</b>, and <b>Branding</b> tabs.</li>\n<br><li>Once done, click <b>Save</b>.</li><br><li id=\"delete\">To <b>delete</b> a reseller, click the <b>remove</b>\n icon. A dialog box appears. Click the <b>Remove</b> button and a confirmatory message stating <b>\n&#34Removed Successfully&#34</b> appears.</li><br></ol><br><b><a href=\"help/reseller/resellerManager#top\" \ntarget=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"help/reseller\" align=\"left\">Back</a></b><br><br><br><br><br><br><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/Roles.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Roles</h1></div><span id=\"search\"></span> <span \nid=\"add\"></span><div class=\"content\"><p>\nAn administrator’s ability to perform actions in the system is determined by the role to which the administrator is assigned. A role is an encapsulation of the rights. An administrator of high-level does the assignment of the Role. The assigned role defines the topics (rights) that may be viewed, modified, added and/or deleted by the Administrator.\n<br><br>To view the Roles page, navigate to <b>Administrators > Roles</b> and the dialog appears.<br><br>\nFrom this page, you can <a href=\"help/administration/roles#search\">search</a>, <a href=\"help/administration/roles#add\">\nadd</a>, <a href=\"help/administration/roles#edit\">edit</a>, <a href=\"help/administration/roles#delete\">delete</a>, and \n<a href=\"help/administration/roles#clone\">clone</a>\n a role from the portal. You can also sort the role names in ascending or descending order. Moreover, you can define the number of records getting displayed in the table using the \n<b>Records</b> dropdown list located below the table.<br><br>\nA root admin can create roles based on the reseller level or organization level from this page itself.<br><ul \nstyle=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li style=\"background-color: lightgrey\" ;>\nRoles will be displayed based on the level selected.</li><li style=\"background-color: lightgrey\" ;>\nAt the organization level, by default eleven roles are created.</li><li style=\"background-color: lightgrey\" ;>\nAt the reseller level, by default one role i.e. Reseller Admin Role is created.</li></ul></p><br><br><h3 id=\"search\" \nstyle=\"font-weight: bold\">Search</h3><p>To search a required role from the list,</p><ul><li>\nType a few characters in the <b>Search</b>\n field and a list of roles containing those characters will be displayed in the table.</li></ul><br><br><h3 id=\"add\" \nstyle=\"font-weight: bold\">Adding or Edting a Role</h3><p>\nRoles can be created at the reseller level as well as the organization level. To add or edit a role, follow the steps below:\n</p><ol><li>\nTo create a role at the reseller level, select a relevant reseller from the Resellers dropdown list located at the top of the screen and then follow the steps from step3.\n</li><br><li>\nTo create a role at the organization level, first select a relevant reseller and organization from the respective dropdown lists. Then follow the steps from step3.\n</li><br><li>On the left panel navigate to <b>Administrators > Roles</b> sub-menu.</li><br><li>Click the <b>Add</b>\n button and the <b>Role Permissions</b> pop-up window appears.</li><br><li>Enter the <b>name</b> of the role.<br><p \nstyle=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: The Add button is disabled at first. As you enter the name it gets enabled automatically.</p></li><li>\nSelect any of the permission tabs for which access rights are to be granted to the role.</li><br><li>If the <b>\nProvisioning</b> tab is selected, click <b>add</b> and the permissions appear.</li><br><li>Select the <b>Permissions\n</b> for which you want to give access rights. From the Provisioning tab you can assign rights for items like <b>\nAdministration, Resellers, Organizations, Subscribers, Licenses, and Group</b>.</li><br><li>\nEnable the checkboxes next for which you want to assign rights. You can assign rights like <b>\nview, add, modify, delete, batch operation</b>, and <b>high impact</b> for the selected permission.</li><br><li>\nYou can remove any permission from the list by clicking the <b>remove</b> icon.</li><br><li>Similarly, in the <b>\nDispatcher</b> tab, you can add, view, and modify access rights for the various permissions.<br><br>\nThe list of dispatcher permissions and their descriptions:<br><table class=\"a\" align=\"center\" cellpadding=\"7\"><col \nwidth=\"30%\"><col width=\"70%\"><tr style=\"background-color: #3492DD\" height=\"40px\"><th style=\"font-size:20px\">Parameters\n</th><th style=\"font-size:20px\">Description</th></tr><tr><td>Dispatcher priority in Radio Groups</td><td>\nSet the value of pre-defined priority assigned to the users in PTT sessions. Users with higher priority can take the floor from users with lower priority. Priority can be set from 0 to 15.\n</td></tr><tr><td>Broadcast Capabilities</td><td>\nWhether the user can broadcast at the organization level, groups level, and total. If enabled, the Emergency Broadcast button becomes visible in the Emergency Alarms panel of the Dispatcher Console.\n</td></tr><tr><td>Branding</td><td>Whether the user should be allowed to brand the client and Dispatch Console.</td>\n</tr><tr><td>Ambient Listening</td><td>\nThe Controller will be able to activate the ambient listening (opening the microphone in a remote device of a user) feature.\n</td></tr><tr><td>Show Map</td><td>The map will be displayed in the Dispatch console.</td></tr><tr><td>\nSystem Administrator</td><td>\nThe Controller will be able to view the details of contact from the manage contact window. If disabled, the Manage button and few tabs of the Manage contact window in the Dispatcher Console will not be available.\n</td></tr><tr><td>Manage Device Info</td><td>The option <b>PTT Block Timeout</b> will be available in the <b>\nDevice Info</b>\n tab of Manage Contact in the Dispatch Console. This enables the controller to set parameters on the device from remote from the Dispatch Console, for example to block the PTT of the client application for a few minutes.\n</td></tr><tr><td>View Device Info</td><td>\nThe Device Info tab will be available in the Manage Contact pop-up window of Dispatch Console. This enables the controller to view the configurations of the device in which the PTT client is installed.\n</td></tr><tr><td>Disable settings modification</td><td>The Controller will not be allowed to change any settings.</td>\n</tr><tr><td>Recording</td><td>Select the option based on which the PTT sessions are to be recorded:<br><br><ul><li><b>\nDefault</b>: The PTT sessions can be recorded as per one’s choice.</li><br><li><b>Always</b>\n: All the PTT sessions will be recorded. If selected, the option <b>Auto start recording</b>\n will be unavailable in the Dispatcher Console’s Session tab of Settings pop-window.</li><br><li><b>Never</b>\n: None of the PTT sessions will be recorded. If this option is selected, all the Recording options in the Dispatcher Console will be unavailable.\n</li></ul></td></tr><tr><td>Max TX duration for sticky PTT</td><td>\nSet the maximum transmission time for the space key or mouse left button which is programmed as a sticky PTT by the MDC2000 operator. You can set the following values:\n<br><br><ul><li><b>No limit (limited by the server)</b></li><br><li>30 seconds</li><br><li>60 seconds</li><br><li>\n120 seconds</li><br></ul></td></tr><tr><td>WFM</td><td>\nIf enabled, the Admin, WFM Dispatch, and Reports menu will be available in the Dispatcher Console.</td></tr><tr><td>\nRadio Sessions</td><td>\nThe Controller will be able to use multiple radio sessions simultaneously according to the chosen amount of channels. This is a billable feature.\n</td></tr><tr><td>Fences Limit</td><td>\nSet the number of fences, which can be created in the Map of Dispatcher Console. You can set the value from 20-250.\n</td></tr><tr><td>Idle Time</td><td>\nIf enabled, the user will get a sign out automatically from the Dispatcher Console after 20 minutes of inactivity.</td>\n</tr></table><p style=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: On saving the permissions, the status of isAdmin permission will be the same as provisioning permissions, i.e. if provisioning permissions are enabled, isAdmin Dispatcher permission will be enabled. If provisioning permissions are disabled, isAdmin Dispatcher permission will also be disabled.\n</p></li><li>Similarly, in the <b>Client</b>\n tab, you can add access rights for the various permissions as well as configure the settings listed in the dropdown list. \n<b>E.g.</b>\n: For Max. group size you can set the maximum limit of members in a group as 10, 20, or 50. The value set for any of the parameters is reflected in the client at the time of the next sign-in or after reconnecting the application.\n</li><br>The list of client permissions and settings along with their descriptions:<br><br><table class=\"a\" \nalign=\"center\" cellpadding=\"7\"><col width=\"30%\"><col width=\"70%\"><tr style=\"background-color: #3492DD\" height=\"40px\">\n<th style=\"font-size:20px\">Parameters</th><th style=\"font-size:20px\">Description</th></tr><tr><td colspan=\"2\"><b>\nPriority</b></td></tr><tr><td>Incoming Call Priority</td><td>Whether PTT or Phone calls should be given preference.<br>\n<br><ul><li>\nIf PTT Priority is selected, the PTT call will continue, and the user will be able to hear both audio streams (PTT and Phone) simultaneously. If there is any new incoming PTT call apart from the Radio, the user will receive a pop-up asking to select a Phone or PTT call.\n</li><br><li>\nIf Phone priority is selected, when the user is in a PTT call and a phone call is received following is the behavior:\n<br><br><ul><li>\nA PTT radio call will continue but the user will not hear any audio. But, if the user presses the PTT button, the phone call will end.\n</li><br><li>\nNew incoming PTT calls like one-to-one, AdHoc, and Conference will be rejected automatically when the phone call is ongoing.\n</li><br><li>\nIf the user initiates any call apart from joining a radio group or press the PTT button during an ongoing phone call, the phone call will end.\n</li><br><li>The user does not receive an incoming call alert anymore when a phone call is ongoing.</li><br></ul></li>\n</ul></td></tr><tr><td>Priority in a group call</td><td>\nSet the priority assigned to the users in group sessions. Users with higher priority can hijack the floor from users with lower priority. In case of the same priority, the users still will be able to override each other by pressing the small microphone button on the mobile device screen before the PTT. Priority can be set from 0 to 15.\n<br></td></tr><tr><td colspan=\"2\"><b>Availability</b></td></tr><tr><td>Log OFF and Exit</td><td>\nWhether the user can logout and exit from the application. If any option is selected, it becomes visible in the Main Menu of the client application.\n</td></tr><tr><td>Presence control</td><td>Whether the user can set the presence.</td></tr><tr><td colspan=\"2\"><b>\nLocation and Emergency</b></td></tr><tr><td>Location Reporting control</td><td>\nWhether the user\'s location reporting is enabled or not.</td></tr><tr><td>Emergency Origination</td><td>\nWhether the user can enter in Emergency State.</td></tr><tr><td>More Accurate Location</td><td>\nAll the available sources to get location will be used: Satellite, WIFI, Bluetooth, and Cellular Network. If disabled, only the Network will be in use.\n</td></tr><tr><td>Man Down</td><td>Whether a man down feature is to be enabled or not. This is a billable feature.</td>\n</tr><tr><td>Disable AdHoc for Emergency group</td><td>If enabled, an emergency will get initiated in legacy mode.</td>\n</tr><tr><td>MD Pre-Warning Time</td><td>\nSelect the duration till which the pre-warning tone will be played, once the \"Man Down\" state is initiated. The default value is 30 seconds.\n<br><p style=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: This parameter is available only if the <b>Man Down</b> privilege is enabled.</p></td></tr><tr><td>MD Sensitivity\n</td><td>\nSince different mobile devices are equipped with a different set of sensors with a different sensibility, select the best suitable sensitivity for triggering the Man Down alert from the below options:\n<br><br><ul><li>Default</li><br><li>Low</li><br><li>High</li></ul><p style=\"background-color: lightgrey\" height=\"30px\">\n<b><i><u>Note</u></i></b>: This parameter is available only if the <b>Man Down</b> privilege is enabled.</p></td></tr>\n<tr><td colspan=\"2\"><b>Call Features</b></td></tr><tr><td>Private Group call Origination</td><td>\nIf enabled, the user can originate a private group call from the PTT application.</td></tr><tr><td>\nAdhoc Group call Origination</td><td>If enabled, the user can initiate the Adhoc group call.</td></tr><tr><td>\nRadio Group calls</td><td>If enabled, the user can fully participate in a radio group call.</td></tr><tr><td>\n1-to-1 call Origination</td><td>If enabled the user can initiate one-to-one calls.</td></tr><tr><td>\nCall Alert initiation</td><td>If enabled the user can send an alert to the recipient.</td></tr><tr><td>\nMax private group size</td><td>Controls the maximum size of private groups.<br><p style=\"background-color: lightgrey\" \nheight=\"30px\"><b><i><u>Note</u></i></b>: This parameter is available only if the <b>Private Group call Origination</b>\n privilege is enabled.</p></td></tr><tr><td>Manage Address book</td><td>\nIf enabled the user can add, edit, and delete contacts from the address book.</td></tr><tr><td>Broadcast Origination\n</td><td>\nWhether the user can broadcast at the organization level and groups. If enabled this option becomes visible in the main menu of the mobile app.\n</td></tr><td>Encryption</td><td>\nIf enabled, the client encrypts the audio while transmitting it. Also, a lock symbol is displayed in the one-to-one call or group selector button while a session is ongoing.\n</td><tr><td>Multi-Channel Mode</td><td>If enabled, the user can join up to 4 PTT radio sessions at the same time.<br>\n<p style=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: This parameter is available only if the <b>Radio Group call</b> privilege is enabled.</p></td></tr><tr><td>\nVoice Recording</td><td>\nIf enabled, the user can record the last incoming audio burst for 30 seconds. (Currently available on iOS only)</td>\n</tr><tr><td>Groups Creation & Management</td><td>\nIf enabled, the user can create and manage groups from the PTT application.</td></tr><tr><td>Session To Repeat<br>\n*Cancelled when Radio channels are defined for a user</td><td>\nSelect the option based on which last PTT session is to be repeated in the PTT application.<br><br><ul><li><b>\nLast Radio Channel</b>: The user joins the last DRC immediately after the call ends.</li><br><li><b>Last Incoming</b>\n: The user can repeat the last call received (one-to-one/group). Accordingly, the focus remains on the respective one-to-one/group call selector button.\n</li><br><li><b>Last Outgoing</b>\n: The user can repeat the last call initiated (contact/group). Accordingly, the focus remains on the respective one-to-one/group call selector button.\n</li><br><li><b>Last any call</b>\n: The user can repeat any last call (incoming/outgoing). Accordingly, the focus remains on the respective one-to-one/group call selector button.\n</li><br><li><b>None or user-defined</b>\n: The user can set a contact/group as a default PTT. If this mode is selected and no contact/group is set as default, then on pressing the dedicated PTT button the application comes in the foreground without establishing the call. On selecting this mode, the Set as Default PTT option becomes available in the context menu for each contact/group.\n<br><br></li><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li \nstyle=\"background-color: lightgrey\" ;>\nIf Radio groups are present, the PTT application overrides the ITO setting and the value last Radio channel is applied.\n</li><br><li style=\"background-color: lightgrey\" ;>\nIf there are no Radio groups, then the value set as per ITO will be applicable.</li><br><li \nstyle=\"background-color: lightgrey\" ;>\nA session can be repeated, irrespective of the person ending the call. Also, once the call ends, if audio is received in the DRC the focus moves to the DRC.\n</li><br></ul><p></p></ul></td></tr><tr><td colspan=\"2\"><b>Messaging Features</b></td></tr><tr><td>\nInstant Messaging Origination</td><td>\nControls the ability of the user to send instant text messages. No IM means that the user is to be restricted from sending IM.\n</td></tr><tr><td>Multimedia messaging</td><td>\nWhether media (videos and images) is to be allowed to be sent. If disabled, only send text messages can be sent.<br><p \nstyle=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>: This parameter is available only if the \n<b>Instant Messaging Origination</b> privilege is enabled.</p></td></tr><tr><td>IM Delivery</td><td>\nSelect the option using which you want to deliver an IM. You can broadcast IM to your Own Organization, Affiliated Organization, and Total.\n<br><p style=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: This parameter is available only if the <b>Instant Messaging Origination</b> privilege is enabled.</p></td></tr><tr>\n<td colspan=\"2\"><b>Look and Feel</b></td></tr><tr><td>Soft PTT-button control</td><td>\nWhether the soft PTT button control is visible on the application.</td></tr><tr><td>Pop-up on Any call</td><td>\nWhether to bring the app in the foreground on any call.</td></tr><tr><td>Always on Top</td><td>\nIf enabled, the PTT application is to be kept in the foreground.</td></tr><tr><td>PTT Button Mapping</td><td>\nHard PTT button simulation setup to choose an alternative PTT button (Volume and Picture keys). This option is available in the Advanced Settings menu, protected by a password.\n</td></tr><tr><td>Quick Dial screen is Default</td><td>\nWhether a quick dial screen is the default tab. If enabled, the user is navigated to the Quick dial screen on tapping the Back button from any page.\n</td></tr><tr><td>Block Radio Group Pop-up</td><td>\nWhether to leave the app in the background on Radio group calls when <b>Pop-up on Any call</b> privilege is selected.\n</td></tr><tr><td>\'Waiting-for-response\' alert on private calls</td><td>\nWhether to display an alert on initiating a private call. By default, it is disabled.</td></tr><tr><td>PTT Block</td>\n<td>Whether to block the PTT in the client application.</td></tr><tr><td colspan=\"2\"><b>Audio Settings</b></td></tr>\n<tr><td>Vibrate On Personal Call</td><td>The device will vibrate on receiving private PTT calls.</td></tr><tr><td>\nTone on Connect</td><td>Whether to play a PTT tone on connecting to the server.</td></tr><tr><td>Tone on Transmit</td>\n<td>Whether to play a tone on pressing the PTT button to transmit audio.</td></tr><tr><td>Tone on Receive</td><td>\nWhether to play a tone on receiving audio.</td></tr><tr><td>Tone on Join</td><td>\nWhether to play PTT tone while joining any call.</td></tr><tr><td>Speakers switching</td><td>\nWhen enabled, allows the user to switch between the loudspeaker and earpiece of the mobile device and control the audio level.\n</td></tr><tr><td>Disconnection Notifications</td><td>Whether to play PTT tone after disconnection from the server.\n</td></tr><tr><td>Mute Incoming Emergency Tone</td><td>\nWhether to mute the PTT tone of an incoming emergency call. By default, it is enabled.</td></tr><tr><td>\nEmergency initialization self-tones</td><td>Whether to play the emergency mode tone. By default, it is enabled.<br><p \nstyle=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>: This parameter is available only if the \n<b>Emergency Origination</b> privilege is enabled.</p></td></tr><tr><td>\nDuration for Emergency confirmation tone and pop-up</td><td>\nSelect the duration till which the emergency tone should be played, and a pop-up appears. You can select 3 or 10 seconds. The default value is 3 seconds.\n<br><p style=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: This parameter is available only if the <b>Emergency Origination</b> privilege is enabled.</p></td></tr><tr><td>\nSend Emergency Alerts By:</td><td>\nA long or short press of the Emergency button or bell icon on the main screen of the mobile app. The default value is the Long press.\n<br><p style=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: This parameter is available only if the <b>Emergency Origination</b> privilege is enabled.</p></td></tr><tr><td>\nDisable Incoming Emergency Sound</td><td>\nWhether to disable the sound of an incoming emergency call. By default, it is enabled.</td></tr><tr><td>\nSmart Vibrate On Group Call</td><td>The device vibrates after every 10 seconds on receiving audio in a group call.<br>\n<p style=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: This parameter is available only if the <b>Radio Group call</b> privilege is enabled. Otherwise, it remains disabled.\n</p></td></tr><tr><td>Speaker Boost</td><td>\nControls the volume amplification of the speaker. Speaker boost value can be set from 0 to 7.</td></tr><tr><td \ncolspan=\"2\"><b>Security Monitoring</b></td></tr><tr><td>Monitoring of microphone usage*</td><td>\nWhether to monitor the usage of the microphone.</td></tr><tr><td>Monitoring of microphone usage on Transmit*</td><td>\nWhether to monitor the microphone when the PTT button is pressed.</td></tr><tr><td>Enable Microphone For Selected Apps*\n</td><td>Whether to enable the microphone for selected applications.</td></tr><tr><td colspan=\"2\"><b>App Maintenance\n</b></td></tr><tr><td>Auto Recovery</td><td>\nWhether to enable auto-recovery of the service by switching to a secondary server location.</td></tr><tr><td>Debug Log\n</td><td>\nIf enabled, this option is visible in the Advanced settings page. If not enabled this option remains hidden. This enables you to save the application’s logs in the mobile device.\n</td></tr><tr><td>Wake-up services</td><td>\nSelect the service to be used for maintaining the device’s optimized active network connection. The options are:<br>\n<ul><li>Autodetection (recommended)</li><li>FCM (for Android smartphones) Firebase Cloud Messaging</li><li>\nMT Waker (for Rugged devices) Mobile Tornado Waker</li></ul></td></tr><tr><td>Jitter Handling Level</td><td>\nSelect the level based on which the first audio burst will be buffered to solve the “chopped” audio phenomenon when connected to an unstable network.\n</td></tr><tr><td>Connection with IMSI</td><td>\nSelect the connection to be used for signing in to the PTT service. The options are:<br><ul><li>Autodetection</li><li>\nIMSI1</li><li>IMSI2</li></ul></td></tr></table><p>*Not available yet for public use.</p><li>\nOnce all the rights are assigned to a role, click <b>Save</b> and the newly created role gets displayed in the table.\n</li><p style=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: You must logout and login again to the mobile client to load the system with the new assignment or changes of the rights.\n</p><li id=\"edit\">To <b>edit</b>, click on the required role to be edited and the <b>Role Permissions</b>\n pop-up window appears.</li><br><li>Make the required changes in any of the permissions.</li><br><li>Once done, click \n<b>Save</b> and a confirmatory message stating <b>&#34Updated Successfully&#34</b> appears on the screen.</li><br><li>\nThe <b>Activity Log</b>\n tab displays the activities performed on the existing role, i.e., the details of any provisioning/dispatcher/client permission changes done by the administrators along with the time stamp and description. You can select the period based on which the data is to be retrieved from the database.\n<br><p style=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: The details in the Activity Log tab can be fetched only for the existing role.<br></p>\nTo retrieve the details of the activities performed during this period, select the start and the end date using the respective calendar icons and click the \n<b>Get Activities</b> button. On clicking, the details of the role activities will get displayed in the table</li><br>\n<li id=\"delete\">To <b>delete</b> a role, click the <b>remove</b> icon. A dialog box appears. Click the <b>Remove</b>\n button to delete the selected role and a confirmatory message stating <b>&#34Removed Successfully&#34</b>\n appears on the screen.</li><br></ol><br><h3 id=\"clone\" style=\"font-weight: bold\">Cloning a Role</h3><p>\nThe cloning functionality allows you to create a role with the same permissions but different and unique role name.</p>\nTo clone a role, follow the steps below:<p></p><ol><li>\nNavigate in the tree of resellers and organizations to a relevant Organization.</li><br><li>\nOn the left panel navigate to <b>Administrators > Roles</b>.</li><br><li>Click the <b>Clone</b> button and the <b>\nRole Permissions</b> pop-up window appears.</li><br><li>Enter a unique <b>name</b> for the role.</li><br><li>\nFrom the role permission tabs, edit or add the required access rights for the selected permissions.</li><br><li>\nOnce done, click <b>Save</b> and the cloned Role gets displayed in the table.</li><br></ol><br><b><a \nhref=\"help/administration/roles#top\" target=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"help/administration\" align=\"left\">Back</a></b><br><br><br><br><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/SMSProvisioning.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>SMS Provisioning</h1></div><span id=\"S1\"></span> \n<span id=\"S2\"></span><div class=\"content\"><p>\nThe SMS Provisioning tab enables to send the provisioning SMS containing credentials and download link to the multiple PTT subscribers on the fly. This saves an ample amount of time in sending the SMS to individual subscribers one by one.\n</p><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nTo send the porvisioning SMS from the Subscribers page, the user is required to hold the <b>High Impact</b> permission.\n</li><br><li>To send the porvisioning SMS in bulk, the user is required to hold the <b>Batch Operations</b> permission.\n</li><br><li>While sending the credentials the value of the parameter <b>PROV_IPRS_SERVER</b>\n is also sent along with the SMS.</li><br></ul><p></p><p>\nTo send a provisioning SMS to multiple subscribers, follow the steps below:</p><ol><li>On the left panel navigate to \n<b>Organization > Bulk Operations > SMS Provisioning</b> tab.</li><br><ul style=\"background-color: lightgrey\"><b><i><u>\nNotes</u></i></b>:<br><br><li>\nTo use the Provisioning SMS, first, the credentials for accessing the SMS provider are required to be configured by the reseller from the \n<b>Reseller Details</b> page.</li><br><li>All the buttons are disabled initially.</li><br><li><b>Credentials</b> and \n<b>Credentials & Server URL</b> buttons get enabled only after selecting the subscribers.</li><br><li><b>Link</b> and \n<b>Credentials with Link</b> buttons get enabled only if the subscribers are selected and a link is entered in the <b>\nEnter Custom Download Link</b> field.</li><br><li>The <b>custom</b>\n button gets enabled only if the subscribers are selected and a custom message is entered in the <b>\nEnter Custom Message</b> field.</li><br></ul><p></p><li>\nSelect one subscriber or all from the left pane by clicking the + icon or clicking the Select All button. The previously unselected subscribers will move to the \n<b>&#34Selected&#34</b> list.</li><br><li>\nIf only the credentials are to be sent, then after selecting the subscribers click the <b>Credentials</b>\n button and a dialog box appears. Click <b>OK</b>\n if the provisioning SMS is to be sent and a confirmation message stating <b>&#34Successfully sent&#34 </b>\nwill be displayed.</li><br><li>\nIf the credentials and the server URL is to be sent, then after selecting the subscribers click the <b>\nCredentials & Server URL</b> button and a dialog box appears. Click <b>OK</b>\n if the SMS is to be sent and a confirmation message stating <b>&#34Successfully sent&#34 </b>will be displayed.</li>\n<br><li>Similarly, if only the download link is to be sent, first select the subscribers, enter the link in the <b>\nEnter a Customized Download Link</b> field and click the <b>Download Link</b> button. A dialog box appears. Click <b>OK\n</b> if the SMS is to be sent and a confirmation message, stating <b>&#34Successfully sent&#34 </b>will be displayed.\n</li><br><li>If the credentials along with the link is to be sent, first select the subscribers, enter the link in the \n<b>Enter a Customized Download</b> Link field and click the <b>Credentials with Link</b>\n button. A dialog box appears. Click <b>OK</b> if the SMS is to be sent and a confirmation message, stating <b>\n&#34Successfully sent&#34 </b>will be displayed.</li><br><li>\nIf a customized message is to be sent, first select the subscribers, enter the message in the <b>\nEnter a Customized Message</b> field and click the <b>Customized Message</b> button. A dialog box appears. Click <b>OK\n</b> if the SMS is to be sent and a confirmation message, stating <b>&#34Successfully sent&#34 </b>will be displayed.\n</li><br></ol><br><b><b><a href=\"help/organization/bulk/sms#top\" target=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp \n<a href=\"help/organization/bulk\" align=\"right\">Back</a></b></div><br><br><br><br><br><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/StorageManagement.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\"><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Storage Management</h1></div><span id=\"S1\"></span> \n<span id=\"S2\"></span><div class=\"content\"><p>\nThis tab enables to store the location path of the backup of recordings taken from the IPRS Recordings Player™.</p><ul \nstyle=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThis feature is available only if the value of the parameter <b>PROV_SHOW_AUDIO_BACKUP_PATHS</b>\n is set as 1 in the Platform System Configuration Custom page.</li><br><li>\nOnly a user with root admin rights can access this tab.</li><br></ul><p></p><p>\nTo store the path, follow the steps below:</p><ol><li>\nNavigate in the tree of resellers and organizations to the relevant Organization.</li><br><li>\nOn the left panel navigate to <b>Organization > Recording Planner > Storage Management</b> tab.</li><br><li>Click the \n<b>Add</b> button and the <b>Storage Management</b> pop-up window appears.</li><br><li>Select the <b>month</b> and <b>\nyear</b> using the <b>Calendar</b> icon.</li><br><li>Enter the <b>path</b> where the backup is stored.</li><br><li>\nOnce done, click <b>Save</b>, and the newly added path will be displayed in the table.</li><br><li>\nTo delete a path, click the <b>remove</b> icon . A dialog box appears. Click the <b>Remove</b>\n button and a confirmatory message “Removed Successfully” appears on the screen.</li><br><br><br><b><a \nhref=\"help/organization/recordingPlanner/storagemanagement#top\" target=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"help/organization/recordingPlanner\" align=\"left\">Back</a></b><br><br><br><br></ol></div><br><br><br><div \nclass=\"footer\"><p>Copyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/Subscribers.html","<div id=\"help-files\"><a name=\"top\"></a><div class=\"header-image\" id><img alt=\"Mobile Tornado\" \nsrc=\"app/help-files/IMAGE/mt_logo.png\"></div><div class=\"title\"><h1>Subscribers</h1></div><span id=\"search\"></span> \n<span id=\"add\"></span><div class=\"content\"><p>The Subscribers sub-menu allows you to manage, <a \nhref=\"help/organization/subscribers#enabledisable\">enable/disable</a>\n, send provisioning SMS, and clone the subscribers. You can also get the activity logs of the administrators who modified the subscriber’s record.\n<br><br>To manage the subscribers, navigate to <b>Organization > Subscribers</b>.<br></p><p>\nBefore adding a subscriber, first select a relevant <b>reseller</b> and an <b>organization</b>\n. Reseller and Organization can be selected from the respective dropdown lists located at the top of the window.<br>\n<br>From this page, you can <a href=\"help/organization/subscribers#search\">search</a>, <a \nhref=\"help/organization/subscribers#add\">add</a>, <a href=\"help/organization/subscribers#edit\">edit</a>, <a \nhref=\"help/organization/subscribers#delete\">delete</a>, <a href=\"help/organization/subscribers#send_sms\">\nsend provisioning SMS</a>, <a href=\"help/organization/subscribers#lock\">lock subscriber account</a>, <a \nhref=\"help/organization/subscribers#clone\">clone</a>\n a subscriber, change the status of any subscriber, as well as view the quantity of PTT, and Dispatcher licenses. You can also sort the display names and status fields in ascending or descending order. Moreover, you can define the number of records getting displayed in the table using the \n<b>Records</b> dropdown list located below the table.</p><p></p><br><h3 id=\"search\" style=\"font-weight: bold\">Search\n</h3><p>To search a required subscriber from the list,</p><ul><li>Type a few characters in the <b>Search</b>\n field near the magnifying glass and a list of subscribers containing the typed letters will be displayed.</li></ul><p>\nA user list can be filtered based on license type:</p><ul><li>In the <b>License Filter</b>\n dropdown list, select the required license template name and a list of subscribers holding the selected license will be displayed.\n</li></ul><br><h3 id=\"send_sms\" style=\"font-weight: bold\">Send SMS</h3><p>\nProvisioning SMS, containing credentials and download link can be sent to the selected subscribers from the main page of subscribers.\n</p><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>SMS can be sent to <b>Mobile client\n</b> type users only with a valid phone number.</li><br><li>\nTo send SMS from the Subscribers page, the user is required to hold the <b>High Impact</b> permission.</li><br><li>\nTo send SMS in bulk, the user is required to hold the <b>Batch Operations</b> permission.</li><br><li>\nWhile sending credentials the value of the server address parameter <b>PROV_IPRS_SERVER</b>\n is also sent along with the SMS.</li><br><li>This feature is available only if the value of the parameter <b>\nPROV_SHOW_SMS</b> is set as 1 in the Platform System Configuration Custom page.</li><br><li>\nCredentials to access the SMS provider must be configured from the <b>Reseller Details</b> page.</li><br></ul><p>\nClick the <b>Send SMS</b> button next to any subscriber’s display name.</p><ul><li>\nYou can perform the following operations:</li><br><ul><li><b>Enter a Customized Download Link</b>\n: The link to the mobile application.</li><br><li><b>Optional Enter a Customized message</b>\n: Any text to be sent to the subscribers.</li><br></ul><li>Once done, you can click any of the following buttons:</li>\n<br><ul><li><b>Credentials</b>: Sends the subscriber credentials only.</li><br><li><b>Credentials &amp Server URL</b>\n: Sends the credentials along with the server URL.</li><br><li><b>Download Link</b>: Sends the download link.</li><br>\n<li><b>Credentials with Link</b>: Sends the link and the credentials.</li><br><li><b>Customized Message</b>\n: Sends the entered text message.</li><br></ul><li>On clicking any of the buttons a confirmation dialog appears. Click \n<b>Yes</b> and the message will be sent on the subscriber’s registered phone number.</li><br></ul><br><h3 id=\"lock\" \nstyle=\"font-weight: bold\">Lock/Unlock Subscriber\'s Account</h3><p>\nWhen a user tries to sign-in to the provisioning portal with wrong credentials and exceeds the maximum number of retries, the account gets locked. The administrators can lock or unlock a subscriber’s account from the Subscribers main page.\n</p><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThis feature is available if the value of the parameter <b>PROV_SHOW_BLOCK_RELEASE</b>\n is set as 1 in the Platform System Configuration Custom page. (Root Admins only).</li><br><li>\nThe maximum number of sign-in retries can be defined in the parameter <b>PROV_MAX_LOGIN_RETRIES</b>\n from the Platform System Configuration Custom page. <b>The default value is 3.</b></li><br></ul><p>\nTo lock an account, click the <b>lock</b> icon next to any subscriber’s display name and a dialog appears.<br><br>\nClick <b>OK</b> and a confirmation message <b>&#34Account has been blocked successfully.&#34</b>\n appears on the screen. Also, the selected subscriber’s name changes to a red color.<br><br>Similarly, on clicking the \n<b>red lock</b> icon the locked account gets unlocked.</p><br><h3 id=\"add\" style=\"font-weight: bold\">\nAdding a Subscriber</h3><p>A mobile phone number in the MSISDN format is required. An example: <b>441423511900</b></p>\n<table class=\"a\" align=\"center\" cellpadding=\"7\"><col width=\"30%\"><col width=\"70%\"><tr \nstyle=\"background-color: #3492DD\" height=\"40px\"><th style=\"font-size:20px\">Code Type</th><th style=\"font-size:20px\">\nDescription</th><th style=\"font-size:20px\">Code</th></tr><tr><td>Country Code</td><td>United Kingdom</td><td>44</td>\n</tr><tr><td>National Destination Code</td><td>Boroughbridge/Harrogate</td><td>1423</td></tr><tr><td>Subscriber Code\n</td><td>Mobile Tornado Sales</td><td>511900</td></tr></table><br><br><p>To add a subscriber, follow the steps below:\n</p><ol><li>Navigate to the relevant Organization using the tree.</li><br><li>On the left panel navigate to <b>\nOrganization > Subscribers</b> and the Subscribers page appears.</li><br><li>Click the <b>Add</b> button and the <b>\nSubscriber Details</b> pop-up window appears.</li><br><li>The <b>General</b>\n tab provides for specifying the following parameters for the new subscriber:</li><br><table class=\"a\" align=\"center\" \ncellpadding=\"7\"><col width=\"30%\"><col width=\"70%\"><tr style=\"background-color: #3492DD\" height=\"40px\"><th \nstyle=\"font-size:20px\">Parameters</th><th style=\"font-size:20px\">Description</th></tr><tr><td>Display Name</td><td>\nThe name of the subscriber to be displayed in the contact list of other subscribers.</td></tr><tr><td>Username/Phone\n</td><td>Unique username. Name for Dispatch Console or phone number for Mobile clients.</td></tr><tr><td>Domain</td>\n<td>The domain of the organization. This field is pre-defined on the Reseller level.</td></tr><tr><td>IMSI</td><td>\nA unique number that uniquely identifies every user of a cellular network. It should be a maximum of up to 20 digits. It is optional but secure and useful.\n</td></tr><tr><td>IMSI2</td><td>Enter the second IMSI number if required.</td></tr><tr><td>Role</td><td>\nThis role (user profile) is created from the Administrators <a href=\"help/administration/roles\">Roles</a> page.</td>\n</tr><tr><td>Role Permissions</td><td>View the permissions of the selected role.</td></tr><tr><td>Application Lists\n</td><td>The subscriber with Kiosk mode will be allowed to run whitelist applications. This list is created from the <a\n href=\"help/organization/mobileAppsPlanning/applicationProfiles\">Application Profiles</a> tab of Mobile Apps Planning.\n</td></tr><tr><td>Password</td><td>A secured password for the subscriber.<ul style=\"background-color: lightgrey\"><b><i>\n<u>Notes</u></i></b>:<br><br><li>\nA strong password must contain 10 to 15 characters with at least 1 lowercase, 1 uppercase, 1 special character _@.#$=!%^)(:*;?/,`~&;}{\'|>[&+-], and 1 numeric.\n</li><br><li>It should not contain identical and consecutive characters or numbers.</li><br></ul>\nYou can also click the <b>Generate Password</b> icon to generate a strong password or click the <b>View Password</b>\n icon to view the hidden password.</td></tr><tr><td>Retype Password</td><td>Re-entered password for confirmation.</td>\n</tr></table><br><ul style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: A subscriber can be successfully created only if a license is assigned to the subscriber.</ul><p></p><li>In the <b>\nLicense</b> tab, select the license to be associated with the subscriber from the pre-defined <b>License Templates</b>\n dropdown list. If the user requires some additional permissions combination, a <b>Custom</b>\n license template can be used.<br><br><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nThe permissions in the predefined license templates are read-only.</li><br><li>If the permissions selected in the <b>\nCustom</b> template matches to any of the predefined license templates, then the <b>license name</b>\n gets changed from Custom to that license template name automatically.</li><br></ul><p></p></li><li><a \nname=\"groupslist\"></a>In the <b>Groups</b> tab, associate the subscriber with groups. You can set a group as the <b>\nDefault Radio Group</b> and an <b>Emergency group</b> that will receive alarms from the user in the PTT application.\n<br><br>To associate the subscriber with a group, follow the steps below:<br><br><ol type=\"a\"><li>Click the <b>Groups\n</b> tab.</li><br><li>\nClick + or - icon for the groups to associate with or remove from the subscriber. The previously unselected group moves to the \n<b>&#34Selected&#34</b> list box.</li><br><li>Click <b>Select All</b> or <b>Remove All</b>\n to assign or remove all groups.<br><br></li><li>You can use the <b>Search</b> field to look up the groups.</li><br>\n<li>\nNext to the search field is a number displaying the number of assigned groups. The second part of the number displays the \n<b>maximum limit of groups</b>.</li><br></ol></li><li><a id=\"contactgroup\" name=\"contactgroup\"></a>In the <b>\nContact Groups (Org)</b>\n tab you can associate the subscriber with a Contact Group. A contact group is a list of subscribers that have each other in their contact list.\n<br><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: Organization Contact List (OCL) is a different term for the same Org. Contact Groups.<br></p>\nTo associate the subscriber with a Contact Group, follow the steps below:<br><br><ol type=\"a\"><li>Select the <b>\nContacts Groups (Org)</b> tab.</li><br><li>\nSelect one group or all from the left pane and associate them with the subscriber by clicking the + icon or clicking the Select All button.\n</li><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: The subscriber cannot delete contacts that were added by the administrator using the Contacts Groups mechanism.</p>\n</ol></li><li><a name=\"contactstemplates\"></a>In the <b>Contacts Templates</b>\n tab you can add contacts templates along with their members to the Personal Address Book (PAB) of an individual user, as a bulk.\n<br><br>To associate the subscriber with a Contacts Template, follow the steps below:<br><br><ol type=\"a\"><li>\nSelect the <b>Contacts Templates</b> tab.</li><br><li>\nSelect one group or all from the left pane and associate them with the subscriber by clicking the + icon or clicking the Select All button. By doing so, the members of the selected contact template get automatically added to the selected list of the Personal Contacts of the subscriber.\n</li><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: A contact template remains in the unselected panel of the Subscriber Details Contacts Templates tab, even though it is saved after assigning it to an individual user.\n</p></ol></li><li>Using the <b>Personal Contacts</b>\n tab you can assign contacts to the subscriber. Unlike the Contacts Groups mechanism described in the Contacts Groups section, these contacts will be available only to this subscriber when signing-in with the client, and the subscriber will be able to delete them if needed.\n<br><br>To assign a contact, follow the steps below:<br><br><ol type=\"a\"><li>Click the <b>Personal Contacts</b>\n tab. The right pane shows the subscribers that are already listed as contacts in the personal address book (PAB) of the subscriber.\n</li><br><li>To add or remove contacts click on the + or - icons or on the Select All button in the left pane.<br><p \nstyle=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: The limit of personal contacts to be assigned to the Dispatcher subscriber can be defined using the parameter <b>\nPROV_LIMIT_ASSIGNMENT_PERSONAL_CONTACTS_TO_DISPATCHERS</b> from the Platform System Configuration Custom page.</p></li>\n</ol></li><li>Click <b>Save</b> and the newly created subscriber gets displayed in the table.</li><p \nstyle=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: A subscriber with a Dispatcher license should be created with appropriate Dispatcher Role, else a warning message will be displayed.\n</p></ol><br><h3 id=\"edit\" style=\"font-weight: bold\">Editing an Existing Subscriber</h3><p>\nTo edit an existing subscriber, follow the steps below.</p><ol><li>Navigate to <b>Organization > Subscribers</b>\n and the Subscriber page appears.</li><br><li>Click on the required subscriber to be edited and <b>Subscriber Details\n</b> pop-up window appears.</li><br><li>Edit the required details under the <b>General</b> tab. The <b>\nemail/SIP, Country</b>, and <b>Phone number</b> fields will be read-only.<br><br>You can change the password using the \n<b>Change Password</b> button. Moreover, the provisioning SMS can be sent to the subscriber by clicking on the <b>\nSend SMS</b> button.<br><p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: The SMS button is available only if the value of the parameter <b>PROV_SHOW_SMS</b> is set as <b>1</b>\n in the Platform System Configuration Custom page.</p></li><br><li>In the <b>Runtime</b>\n tab you can view details about the subscriber PTT client. The information is collected from the client on sign-in time and then periodically, every time the client application checks for updates with the service. If the subscriber never signed-in to the service, the fields in this tab will be empty.\n<br><br>The page displays the client details like <b>\nSite, Creation Time, Last Registration Time, Last password modification, State Change Time, State, Client Type, App Version, Device model, OS Type, API Level, Mobile client brand, Manufacturer, Device total memory, FW Version, App build type, and FCM.\n</b><br><br></li><li>To change the license template assigned to the subscriber, navigate to the <b>License</b>\n tab. Modify the license by choosing from the License Template dropdown list.</li><br><li>\nTo manage the groups this subscriber is associated with, navigate to the <b>Groups</b> tab.</li><br><li>\nTo make changes for the associated contacts, use the <b>Contact Groups</b> or the <b>Contacts Templates</b> or the <b>\nPersonal Contacts</b> tabs.</li><br><li>The <b>Activity Log</b>\n tab displays activities performed on the existing subscriber, i.e., details of any provisioning changes done by you or other administrators along with the time stamp and description. You can select the time within which the records are to be fetched.\n<br><br>Select the <b>start</b> and the <b>end date</b> using the respective calendar icons and click the <b>\nGet Activities</b> button to get the details.</li><br><li>Once all the modifications are done, click the <b>Save</b>\n button.</li><br><li id=\"delete\">To <b>delete</b> a subscriber, click the <b>remove</b>\n icon. A dialog box appears. Click the <b>Remove</b> button and the subscriber gets deleted. Also, a message stating \n<b>&#34Removed successfully&#34</b> appears on the screen.</li><br></ol><br><h3 id=\"clone\" style=\"font-weight: bold\">\nCloning a Subscriber</h3><p>\nCloning allows us to create a subscriber with the same configurations except for the display name, username, and phone number.\n<br><br>To clone a subscriber, follow the steps below:<br><ol><li>Navigate to <b>Organization > Subscribers</b>\n and the Subscribers page appears.</li><br><li>Click the <b>Clone</b> button and the Subscriber pop-up window appears.\n</li><br><li>Edit the required fields from the <b>General, License, Groups, Contact Groups (Org), Contacts Templates\n</b> and <b>Personal Contacts</b> tabs respectively.<p style=\"background-color: lightgrey\"><b><i><u>Note</u></i></b>\n: Editing the display name and username or phone number fields from the General tab is mandatory for a cloned subscriber. A password is required to be changed or confirmed.\n<br></p></li><li>Click <b>Save</b> and the cloned subscriber gets displayed.</li><br></ol><br></p><h3 \nid=\"enabledisable\" style=\"font-weight: bold\">Enable/Disable a Subscriber</h3><p>\nA subscriber can be enabled or disabled individually from the Subscribers main page.<br><br>\nTo enable/disable a subscriber, follow the steps below:</p><ol><li>In the <b>Active</b>\n column, click on the checkbox(es) next to the subscriber(s) to be enabled/disabled. Ones the checkbox is clicked, the subscriber&#39s disabled state (red color) turns to enabled (green color) and vice versa.\n</li><br><li>As soon as the state is changed a confirmation message stating, <b>&#34State changed successfully.&#34</b>\n appears on the screen.</li><br><ul style=\"background-color: lightgrey\"><b><i><u>Notes</u></i></b>:<br><br><li>\nA subscriber that is disabled will not be able to sign-in to the service.</li><br><li>\nA subscriber that is already signed-in to the service may get signed-out automatically by the system if the administrator disables the subscriber.\n</li><br><li>You can enable/disable a subscriber based on the value of the parameter <b>\nPROV_CHANGE_STATE_WITH_HIGH_IMPACT</b>. If the value is 0 the user is required to hold only the <b>Modify Subscriber\n</b> permission. If the value is 1 the user is required to hold the <b>Modify Subscriber</b> as well as <b>\nHigh Impact Organization</b> permissions.</li></ul><p></p></ol><p></p><br><b><a \nhref=\"help/organization/subscribers#top\" target=\"_top\" align=\"right\">Top</a></b>\n&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp\n<b><a href=\"help/organization\" align=\"left\">Back</a></b><br><br><br><br><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/SystemConfiguration.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>System Configuration</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\">\n<p>\nThe System Configuration page enables the administrators of the service to view and edit the custom configurations and view the sites and servers.\n<br></p><p style=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: Only a user with root admin rights can access the System Configuration sub-menu.</p><p>\nTo view the System Configuration sub-menu, on the left pane navigate to <b>Platform > System Configuration</b>.</p><p \nstyle=\"background-color: lightgrey\" height=\"30px\"><b><i><u>Note</u></i></b>\n: You can only view and edit the default configurations. It is not advised to change the default parameters as they can affect the functionality or the performance of the service.\n</p><br>The following three tabs are displayed on the page:<ul><li><b>Custom</b>\n: Enables to view and edit the custom configurations. To edit, click on the required parameter name, change the value in the \n<b>Set the Parameter’s Value</b> pop-up window, and save it.<br><p style=\"background-color: lightgrey\" height=\"30px\">\n<b><i><u>Caution</u></i></b>: Make the changes cautiously, as an invalid value may affect the server’s stability.</p>\n</li><li><b>Sites</b>: Displays the various sites of the organization. They are read-only.</li><br><li><b>Servers</b>\n: Displays the servers configured in the portal. They are read-only.</li><br></ul><br><b><a href=\"/help/platform\" \nalign=\"left\">Back</a></b><br><br><br><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/help-files/WorkforceManagement.html","<div id=\"help-files\"><div class=\"header-image\"><img alt=\"Mobile Tornado\" src=\"app/help-files/IMAGE/mt_logo.png\"></div>\n<div class=\"title\"><h1>Workforce Management</h1></div><span id=\"S1\"></span> <span id=\"S2\"></span><div class=\"content\">\n<p>\nWorkforce Management (WFM) is an application, managing the users, shifts, tasks, and report types from the Administration portal.\n</p><p style=\"background-color: lightgrey\" ;><b><i><u>Note</u></i></b>\n: This menu is available only if the value of the parameter <b>PROV_SHOW_WFM</b> is set as <b>1</b>\n in the Platform System Configuration Custom page. (Root Admins only)</p><p>\nTo view the Workforce Management page, follow the steps below:<br><ol><li>\nNavigate in the tree of resellers and organizations to the relevant Organization.</li><br><li>\nOn the left panel navigate to <b>Organization > Workforce Management</b>. The page displays the following two tabs:<br>\n<br><ul><li><a href=\"help/organization/workForceManagement#UM\">Users Management</a></li><br><li><a \nhref=\"help/organization/workForceManagement#UR\">User Report Headers</a></li></ul></li></ol><br></p><h2 id=\"UM\">\nUsers Management</h2><p>\nThe Users Management tab enables selected subscribers to use the workforce management application.</p><p>\nTo do so, follow the steps below:</p><ol><li>On the left panel navigate to <b>\nOrganization > Workforce Management > Users Management</b> tab.</li><br><li>\nClick + or - icon for the users to allow or restrict from using the WFM. The previously unselected user moves to the \n<b>&#34Selected&#34</b> list box.</li><br><li>Click <b>Select All</b> or <b>Remove All</b>\n to allow or restrict all the users.<br><br></li><li>You can use the <b>Search</b> field to look up the users.</li><br>\n<li>\nNext to the search field is a number displaying the number of users allowed. The second part of the number displays the \n<b>total number of users</b> in the organization.</li><br><li>Once selected, click <b>Apply Changes</b> and a message \n<b>&#34Updated Successfully.&#34 </b>\nappears. Now, only the selected users can use the WFM application, while unselected users will continue using the PTT application.\n</li></ol><br><h2 id=\"UR\">User Report Headers</h2><p>\nThe User Report Headers tab displays and enables the management of users Ad-Hoc report types.</p><p>\nTo add a new report type,</p><ol><li>On the left panel navigate to <b>\nOrganization > Workforce Management > User Report Headers</b> tab.</li><br><li>Enter the Report name in the <b>\nAdd new report type</b> field and click <b>Add</b>.</li><br><li>The report appears in the table.</li><br><li>\nTo set this report appearing first on user device, click on <b>Default</b> checkbox.</li><br><li>Click <b>Save</b>\n and a message <b>&#34Updated Successfully.&#34</b>\n appears. The report types added will then be available in the WFM application. Similarly, you can add other types of reports.\n</li><br></ol><br><br><b><a href=\"help/organization\" align=\"right\">Back</a></b><br><br></div><div class=\"footer\"><p>\nCopyright &copy 2022 Mobile Tornado Group plc.</p></div></div>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/auth/login/login.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div class=\"logo\">\n<img width=\"60%\" src=\"{{vm.LogoImg}}\"></div><div class=\"title\" style=\"text-align:center\" translate=\"LOGIN_INTRO_TITLE\">\nMobile Tornado ITO portal</div><div class=\"description\"></div></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div class=\"logo\" hide-gt-sm><img \nwidth=\"60%\" src=\"{{vm.LogoImg}}\"></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">\n<md-progress-circular ng-if=\"vm.showLoader\" class=\"md-accent md-hue-1\" md-diameter=\"60\" style=\"margin-top: -90pt\">\n</md-progress-circular></div><div class=\"title\" translate=\"LOGIN_TITLE\">Log in to your account</div><form \nname=\"loginForm\" novalidate ng-submit=\"vm.login()\" autocomplete=\"off\"><md-input-container class=\"md-block\" md-no-float>\n<input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN_EMAIL\" autocomplete=\"off\" required><div ng-messages=\"loginForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN_ERRORS_EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"email\"><span translate=\"LOGIN_ERRORS_EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN_PASSWORD\" autocomplete=\"off\" onfocus=\"this.removeAttribute(\'readonly\')\" required><div\n ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN_ERRORS_PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-button\n type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN_LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN_LOG_IN\">LOG IN</md-button><div class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN_CONTACT_ADMIN\">\"Forget your password? Please contact your service administrator.</div>\n<md-input-container class=\"md-block\" md-no-float><div class=\"error-msg\" ng-model=\"vm.form.errorMsg\">\n{{vm.form.errorMsg}}</div></md-input-container></form></div></div></div>");
$templateCache.put("app/main/pages/coming-soon/coming-soon.html","<div id=\"coming-soon\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"coming-soon-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"coming-soon-form\" class=\"md-whiteframe-8dp\"><div class=\"top\"><div\n class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"COMINGSOON.TITLE\">\nHey! Thank you for checking out our app.</div><div class=\"subtitle\" translate=\"COMINGSOON.SUBTITLE\">\nIt’s not quite ready yet, but we are working hard and it will be ready in approximately:</div><timer \nend-time=\"vm.endTime\" layout=\"row\" layout-align=\"center center\" layout-wrap><div flex-xs=\"50\"><div class=\"value\">\n{{days}}</div><div class=\"type\" translate=\"COMINGSOON.DAYS\">days</div></div><div flex-xs=\"50\"><div class=\"value\">\n{{hours}}</div><div class=\"type\" translate=\"COMINGSOON.HOURS\">hours</div></div><div flex-xs=\"50\"><div class=\"value\">\n{{minutes}}</div><div class=\"type\" translate=\"COMINGSOON.MINUTES\">minutes</div></div><div flex-xs=\"50\"><div \nclass=\"value\">{{seconds}}</div><div class=\"type\" translate=\"COMINGSOON.SECONDS\">seconds</div></div></timer></div><form>\n<div class=\"message\" translate=\"COMINGSOON.MESSAGE\">\nIf you would like to be notified when the app is ready, you can subscribe to our e-mail list.</div><md-input-container \nflex md-no-float><input type=\"email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"COMINGSOON.EMAIL_ADRESS\"></md-input-container><md-button class=\"md-raised md-accent\" \naria-label=\"SUBSCRIBE\" translate=\"COMINGSOON.SUBSCRIBE\" translate-attr-aria-label=\"COMINGSOON.SUBSCRIBE\">SUBSCRIBE\n</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/maintenance/maintenance.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"MAINTENANCE.TITLE\">\nClosed for scheduled maintenance!</div><div class=\"subtitle\" translate=\"MAINTENANCE.SUBTITLE\">\nWe\'re sorry for the inconvenience.<br>Please check back later.</div></div></div></div>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"><div class=\"name\">Katherine Wilson</div>\n</div><div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" \naria-label=\"Follow\" translate=\"PROFILE.FOLLOW\" translate-attr-aria-label=\"PROFILE.FOLLOW\">Follow</md-button><md-button \nclass=\"md-raised md-primary\" translate=\"PROFILE.SEND_MESSAGE\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">\nSend Message</md-button></div></div><div class=\"content\" flex><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"PROFILE.TIMELINE\">Timeline</span></md-tab-label><md-tab-body><md-content class=\"timeline-tab\" \nng-include=\"\'app/main/pages/profile/tabs/timeline/timeline.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"PROFILE.ABOUT\">About</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/profile/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label>\n<span translate=\"PROFILE.PHOTOS_VIDEOS\">Photos & Videos</span></md-tab-label><md-tab-body><md-content \nclass=\"photos-videos-tab\" ng-include=\"\'app/main/pages/profile/tabs/photos-videos/photos-videos.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/search/search.html","<div id=\"search\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.search\" \ntype=\"text\" placeholder=\"Search..\" translate translate-attr-placeholder=\"SEARCH.SEARCH\" flex></div><md-menu \nclass=\"search-settings\" md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Search settings\" translate translate-attr-aria-label=\"SEARCH.SEARCH_SETTINGS\">\n<md-icon md-menu-origin md-menu-align-target md-font-icon=\"icon-cog\" class=\"icon s16\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\">\n</md-icon><span translate=\"SEARCH.SETTINGS_1\">Settings 1</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\"></md-icon><span translate=\"SEARCH.SETTINGS_2\">Settings 2\n</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"content\" flex><md-tabs \nmd-dynamic-height><md-tab label=\"Classic\"><md-content class=\"classic-tab\" \nng-include=\"\'app/main/pages/search/tabs/classic/classic.html\'\"></md-content></md-tab><md-tab label=\"Emails\"><md-content\n class=\"emails-tab\" ng-include=\"\'app/main/pages/search/tabs/emails/emails.html\'\"></md-content></md-tab><md-tab \nlabel=\"Users\"><md-content class=\"users-tab\" ng-include=\"\'app/main/pages/search/tabs/users/users.html\'\"></md-content>\n</md-tab><md-tab label=\"Contacts\"><md-content class=\"contacts-tab\" \nng-include=\"\'app/main/pages/search/tabs/contacts/contacts.html\'\"></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-left.html","<div id=\"timeline\" class=\"timeline-left\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\">\n<div ms-timeline-item layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div \nclass=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div>\n<div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">\n{{timelineItem.event}}</div></div><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card \ntemplate=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-right.html","<div id=\"timeline\" class=\"timeline-right\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\">\n<div ms-timeline-item layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div \nclass=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div>\n<div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">\n{{timelineItem.event}}</div></div><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card \ntemplate=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline.html","<div id=\"timeline\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item \nlayout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" \nng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon \nmd-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">\n{{timelineItem.time}}</div><div class=\"event\">{{timelineItem.event}}</div></div><div class=\"timeline-card\" \nlayout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div>\n</div></div>");
$templateCache.put("app/main/restricted/homepage/homepage.html","<div class=\"page-layout carded fullwidth single-scroll ng-scope layout-row\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center flex\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\" \ntranslate=\"HOMEPAGE_HEADING\" translate-default=\"Mobile Tornado Provisioning Portal\"></span></div><div \nclass=\"content-card\"><md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\" \nms-scroll=\"\" data-ps-id=\"2a743a66-3a5a-665b-1b0d-fd85817bfce7\"><div class=\"ng-scope\"><div \nclass=\"demo-content ng-scope\"><h3><b translate=\"HOMEPAGE_APPLICATION\" translate-default=\"Front-End: \">Front-end</b>\n: v.{{vm.webAppVersion}}</h3><h3><b translate=\"HOMEPAGE_API_VERSION\" translate-default=\"API & MongoDB\">API & MongoDB\n</b>: v.{{vm.apiVersion}}</h3><h3><b translate=\"HOMEPAGE_DB_VERSION\" translate-default=\"Oracle DB\">Oracle DB</b>\n: v.{{vm.oracleVersion}}</h3></div></div><div class=\"ps-scrollbar-x-rail\" style=\"left: 0px; bottom: 3px\"><div \nclass=\"ps-scrollbar-x\" tabindex=\"0\" style=\"left: 0px; width: 0px\"></div></div><div class=\"ps-scrollbar-y-rail\" \nstyle=\"top: 0px; right: 3px\"><div class=\"ps-scrollbar-y\" tabindex=\"0\" style=\"top: 0px; height: 0px\"></div></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/shared/choose-list/choose.list.html","<div layout=\"row\"><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container><label \ntranslate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchUnselected.name\" type=\"text\"></md-input-container></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(false)\"><md-subheader \nclass=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.unselectedClass\" layout=\"row\" translate=\"APP_UNSELECTED\">\nUnselected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" \ntranslate=\"APP_ADD_ALL\" ng-click=\"vm.selectAll()\" ng-hide=\"vm.disallowUpdate\">Add all</md-button></div></div>\n<md-list-item dir-paginate=\"item in vm.notSelectedElements|filter :vm.searchUnselected|itemsPerPage:25\" \npagination-id=\"vm.unselectedPaginationId\"><p ng-if=\"!item.affiliated\">{{item.name}}</p><p ng-if=\"item.affiliated\" \nstyle=\"color: blue\" title=\"{{item.org_name}}\">{{item.name}}</p><md-button class=\"md-icon-button\" ng-if=\"!item.no_icon\" \nng-click=\"vm.selectItem(item)\" ng-hide=\"vm.disallowUpdate\" aria-label=\"Add item\" translate \ntranslate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-list-item><div \nlayout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.unselectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</md-list><md-divider></md-divider><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container\n flex><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchSelected.name\" type=\"text\"></md-input-container><div flex layout=\"column\" layout-align=\"end center\">\n<span ng-if=\"!vm.dispatcher\">{{vm.selectedElements.length}}/{{vm.memberCountLimit}}</span> <span ng-if=\"vm.dispatcher\">\n{{vm.selectedElements.length}}/{{vm.memberCountLimitDispatcher}}</span></div></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div flex layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.subscriberGrpDetail == true\"><md-subheader class=\"md-no-sticky\" style=\"font-weight: bold\" layout=\"row\">\nMic Muted</md-subheader></div><div flex layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(true)\"><md-subheader\n class=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.selectedClass\" layout=\"row\" translate=\"APP_SELECTED\">\nSelected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" \ntranslate=\"APP_REMOVE_ALL\" ng-hide=\"vm.disallowUpdate\" ng-click=\"vm.unselectAll()\">Remove all</md-button></div></div>\n<md-list-item dir-paginate=\"item in vm.selectedElements|filter :vm.searchSelected|itemsPerPage:25\" \npagination-id=\"vm.selectedPaginationId\"><md-checkbox ng-if=\"item.type === \'radio\'\" ng-model=\"message.selected\">\n</md-checkbox><md-checkbox ng-if=\"(item.type === 2 || item.type === 1) && vm.subscriberGrpDetail == true\" \nng-model=\"item.client_is_muted\"></md-checkbox><p ng-if=\"!item.affiliated\">{{item.name}}</p><p ng-if=\"item.affiliated\" \nstyle=\"color: blue\" title=\"{{item.org_name}}\">{{item.name}}</p><p ng-if=\"item.organization_name\" \nstyle=\"color: blue; text-align: center\">{{item.organization_name}}</p><md-button class=\"md-icon-button\" \nng-if=\"(!vm.defaultRadioGroup || vm.defaultRadioGroup != item._id) && !item.no_icon\" ng-click=\"vm.unselectItem(item)\" \nng-hide=\"vm.disallowUpdate\" aria-label=\"Add event\" translate translate-attr-aria-label=\"APP_ADD\"><md-icon \nmd-font-icon=\"icon-minus\" aria-label=\"Remove item\" translate translate-attr-aria-label=\"APP_REMOVE\"></md-icon>\n</md-button></md-list-item><div layout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.selectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</md-list></div>");
$templateCache.put("app/main/shared/choose-list-bind/choose.list.bind.html","<div layout=\"row\"><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container><label \ntranslate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchUnselected.name\" type=\"text\"></md-input-container></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(false)\"><md-subheader \nclass=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.unselectedClass\" layout=\"row\" translate=\"APP_UNSELECTED\">\nUnselected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" \ntranslate=\"APP_ADD_ALL\" ng-click=\"vm.selectAll()\" ng-hide=\"vm.disallowUpdate\">Add all</md-button></div></div>\n<md-list-item dir-paginate=\"item in vm.notSelectedElements|filter :vm.searchUnselected|itemsPerPage:25\" \npagination-id=\"vm.unselectedPaginationId\"><p>{{ item.name }}</p><md-button class=\"md-icon-button\" \nng-click=\"vm.selectItem(item)\" ng-hide=\"vm.disallowUpdate\" aria-label=\"Add item\" translate \ntranslate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-list-item><div \nlayout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.unselectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</md-list><md-divider></md-divider><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container\n flex><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchSelected.name\" type=\"text\"></md-input-container><div flex layout=\"column\" layout-align=\"end center\">\n<span>{{vm.selectedElements.length}}/{{vm.memberCountLimit}}</span></div></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div flex layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(true)\">\n<md-subheader class=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.selectedClass\" layout=\"row\" \ntranslate=\"APP_SELECTED\">Selected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised\" translate=\"APP_REMOVE_ALL\" ng-hide=\"vm.disallowUpdate\" ng-click=\"vm.unselectAll()\">Remove all\n</md-button></div></div><md-list-item \ndir-paginate=\"item in vm.selectedElements|filter :vm.searchSelected|itemsPerPage:25\" \npagination-id=\"vm.selectedPaginationId\"><md-checkbox ng-if=\"item.type === \'radio\'\" ng-model=\"message.selected\">\n</md-checkbox><p>{{ item.name }}</p><md-button class=\"md-icon-button\" ng-click=\"vm.unselectItem(item)\" \nng-hide=\"vm.disallowUpdate\" aria-label=\"Add event\" translate translate-attr-aria-label=\"APP_ADD\"><md-icon \nmd-font-icon=\"icon-minus\" aria-label=\"Remove item\" translate translate-attr-aria-label=\"APP_REMOVE\"></md-icon>\n</md-button></md-list-item><div layout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.selectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</md-list></div>");
$templateCache.put("app/main/shared/choose-list-bind-muted/choose.list.bind.muted.html","<div layout=\"row\"><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container><label \ntranslate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchUnselected.name\" type=\"text\"></md-input-container></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(false)\"><md-subheader \nclass=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.unselectedClass\" layout=\"row\" translate=\"APP_UNSELECTED\">\nUnselected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" \ntranslate=\"APP_ADD_ALL\" ng-click=\"vm.selectAll()\" ng-hide=\"vm.disallowUpdate\">Add all</md-button></div></div>\n<md-list-item dir-paginate=\"item in vm.notSelectedElements|filter :vm.searchUnselected|itemsPerPage:25\" \npagination-id=\"vm.unBindselectedPaginationId\"><p ng-if=\"!item.affiliated\">{{item.name}}</p><p ng-if=\"item.affiliated\" \nstyle=\"color: blue\" title=\"{{item.org_name}}\">{{item.name}}</p><md-button class=\"md-icon-button\" \nng-click=\"vm.selectItem(item)\" ng-hide=\"vm.disallowUpdate\" aria-label=\"Add item\" translate \ntranslate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-list-item><div \nlayout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.unBindselectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls>\n</div></md-list><md-divider></md-divider><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<input ng-model=\"vm.searchSelected.name\" type=\"text\"></md-input-container><div flex layout=\"column\" \nlayout-align=\"end center\"><span ng-if=\"!vm.dispatcher\">{{vm.selectedElements.length}}/{{vm.memberCountLimit}}</span> \n<span ng-if=\"vm.dispatcher\">{{vm.selectedElements.length}}/{{vm.memberCountLimitDispatcher}}</span></div></div><div \nlayout=\"row\" style=\"min-width: max-content\"><div flex layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.sort(true)\"><md-subheader class=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.selectedClass\" \nlayout=\"row\" translate=\"APP_SELECTED\">Selected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-raised\" translate=\"APP_REMOVE_ALL\" ng-hide=\"vm.disallowUpdate\" ng-click=\"vm.unselectAll()\">\nRemove all</md-button></div></div><md-list-item \ndir-paginate=\"item in vm.selectedElements|filter :vm.searchSelected|itemsPerPage:25\" \npagination-id=\"vm.bindSelectedPaginationId\"><md-checkbox ng-if=\"item.type === \'radio\'\" ng-model=\"message.selected\">\n</md-checkbox><p ng-if=\"!item.affiliated\">{{item.name}}</p><p ng-if=\"item.affiliated\" style=\"color: blue\" \ntitle=\"{{item.org_name}}\">{{item.name}}</p><p ng-if=\"item.organization_name\" style=\"color: blue; text-align: center\">\n{{item.organization_name}}</p><md-button class=\"md-icon-button\" \nng-if=\"(!vm.defaultRadioGroup || vm.defaultRadioGroup != item._id) && !item.no_icon\" ng-click=\"vm.unselectItem(item)\" \nng-hide=\"vm.disallowUpdate\" aria-label=\"Add event\" translate translate-attr-aria-label=\"APP_ADD\"><md-icon \nmd-font-icon=\"icon-minus\" aria-label=\"Remove item\" translate translate-attr-aria-label=\"APP_REMOVE\"></md-icon>\n</md-button></md-list-item><div layout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.bindSelectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls>\n</div></md-list></div>");
$templateCache.put("app/main/shared/choose-list-bind-personal-group/choose.list.bind.personal.group.html","<div layout=\"row\"><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container><label \ntranslate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchUnselected.name\" type=\"text\"></md-input-container></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(false)\"><md-subheader \nclass=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.unselectedClass\" layout=\"row\" translate=\"APP_UNSELECTED\">\nUnselected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" \ntranslate=\"APP_ADD_ALL\" ng-click=\"vm.selectAll()\" ng-hide=\"vm.disallowUpdate\">Add all</md-button></div></div>\n<md-list-item dir-paginate=\"item in vm.unselectedElements|filter :vm.searchUnselected|itemsPerPage:25\" \npagination-id=\"vm.unselectedPaginationId\"><p>{{ item.name }}</p><md-button class=\"md-icon-button\" \nng-click=\"vm.selectItem(item)\" ng-hide=\"vm.disallowUpdate\" aria-label=\"Add item\" translate \ntranslate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-list-item><div \nlayout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.unselectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</md-list><md-divider></md-divider><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container\n flex><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchSelected.name\" type=\"text\"></md-input-container><div flex layout=\"column\" layout-align=\"end center\">\n<span>{{vm.selectedElements.length}}/{{vm.memberCountLimit}}</span></div></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div flex layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(true)\">\n<md-subheader class=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.selectedClass\" layout=\"row\" \ntranslate=\"APP_SELECTED\">Selected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised\" translate=\"APP_REMOVE_ALL\" ng-hide=\"vm.disallowUpdate\" ng-click=\"vm.unselectAll()\">Remove all\n</md-button></div></div><md-list-item \ndir-paginate=\"item in vm.selectedElements|filter :vm.searchSelected|itemsPerPage:25\" \npagination-id=\"vm.selectedPaginationId\"><p>{{ item.name }}</p><md-button class=\"md-icon-button\" \nng-click=\"vm.unselectItem(item)\" ng-hide=\"vm.disallowUpdate\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-minus\" aria-label=\"Remove item\" translate \ntranslate-attr-aria-label=\"APP_REMOVE\"></md-icon></md-button></md-list-item><div layout=\"row\" \nlayout-align=\"start center\"><dir-pagination-controls max-size=\"1\" pagination-id=\"vm.selectedPaginationId\" \ndirection-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></md-list></div>");
$templateCache.put("app/main/shared/choose-list-bulk-license/choose.list.bulk.license.html","<div layout=\"row\"><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container><label \ntranslate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchUnselected.name\" type=\"text\"></md-input-container></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(false)\"><md-subheader \nclass=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.unselectedClass\" layout=\"row\" translate=\"APP_UNSELECTED\">\nUnselected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" \ntranslate=\"APP_ADD_ALL\" ng-click=\"vm.selectAll()\" ng-hide=\"vm.disallowUpdate\">Add all</md-button></div></div>\n<md-list-item dir-paginate=\"item in vm.notSelectedElements|filter :vm.searchUnselected|itemsPerPage:25\" \npagination-id=\"vm.unselectedPaginationId\"><p ng-if=\"!item.affiliated\">{{item.name}}</p><p ng-if=\"item.affiliated\" \nstyle=\"color: blue\" title=\"{{item.org_name}}\">{{item.name}}</p><md-button class=\"md-icon-button\" \nng-click=\"vm.selectItem(item)\" ng-hide=\"vm.disallowUpdate\" aria-label=\"Add item\" translate \ntranslate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-list-item><div \nlayout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.unselectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</md-list><md-divider></md-divider><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container\n flex><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchSelected.name\" type=\"text\"></md-input-container><div flex layout=\"column\" layout-align=\"end center\">\n<span ng-if=\"!vm.dispatcher\">{{vm.selectedElements.length}}/{{vm.memberCountLimit}}</span> <span ng-if=\"vm.dispatcher\">\n{{vm.selectedElements.length}}/{{vm.memberCountLimitDispatcher}}</span></div></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div flex layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(true)\">\n<md-subheader class=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.selectedClass\" layout=\"row\" \ntranslate=\"APP_SELECTED\">Selected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised\" translate=\"APP_REMOVE_ALL\" ng-hide=\"vm.disallowUpdate\" ng-click=\"vm.unselectAll()\">Remove all\n</md-button></div></div><md-list-item \ndir-paginate=\"item in vm.selectedElements|filter :vm.searchSelected|itemsPerPage:25\" \npagination-id=\"vm.selectedPaginationId\"><md-checkbox ng-if=\"item.type === \'radio\'\" ng-model=\"message.selected\">\n</md-checkbox><p ng-if=\"!item.affiliated\">{{item.name}}</p><p ng-if=\"item.affiliated\" style=\"color: blue\" \ntitle=\"{{item.org_name}}\">{{item.name}}</p><p ng-if=\"item.organization_name\" style=\"color: blue; text-align: center\">\n{{item.organization_name}}</p><md-button class=\"md-icon-button\" \nng-if=\"(!vm.defaultRadioGroup || vm.defaultRadioGroup != item._id) && !item.no_icon\" ng-click=\"vm.unselectItem(item)\" \nng-hide=\"vm.disallowUpdate\" aria-label=\"Add event\" translate translate-attr-aria-label=\"APP_ADD\"><md-icon \nmd-font-icon=\"icon-minus\" aria-label=\"Remove item\" translate translate-attr-aria-label=\"APP_REMOVE\"></md-icon>\n</md-button></md-list-item><div layout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.selectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</md-list></div>");
$templateCache.put("app/main/shared/choose-list-mute/choose.list.mute.html","<div layout=\"row\"><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container><label \ntranslate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchUnselected.name\" type=\"text\"></md-input-container></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(false)\"><md-subheader \nclass=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.unselectedClass\" layout=\"row\" translate=\"APP_UNSELECTED\">\nUnselected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" \ntranslate=\"APP_ADD_ALL\" ng-click=\"vm.selectAll()\" ng-hide=\"vm.disallowUpdate\">Add all</md-button></div></div>\n<md-list-item dir-paginate=\"item in vm.notSelectedElements|filter :vm.searchUnselected|itemsPerPage:25\" \npagination-id=\"vm.unselectedPaginationId\"><p ng-if=\"!item.affiliated\">{{item.name}}</p><p ng-if=\"item.affiliated\" \nstyle=\"color: blue\" title=\"{{item.org_name}}\">{{item.name}}</p><md-button class=\"md-icon-button\" \nng-click=\"vm.selectItem(item)\" ng-hide=\"vm.disallowUpdate\" aria-label=\"Add item\" translate \ntranslate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-list-item><div \nlayout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.unselectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</md-list><md-divider></md-divider><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container\n flex><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchSelected.name\" type=\"text\"></md-input-container><div flex layout=\"column\" layout-align=\"end center\">\n<span ng-if=\"!vm.dispatcher\">{{vm.selectedElements.length}}/{{vm.memberCountLimit}}</span> <span ng-if=\"vm.dispatcher\">\n{{vm.selectedElements.length}}/{{vm.memberCountLimitDispatcher}}</span></div></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div flex layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.subscriberGrpDetail == true\"><md-subheader class=\"md-no-sticky\" style=\"font-weight: bold\" layout=\"row\">\nMic Muted</md-subheader></div><div flex layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(true)\"><md-subheader\n class=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.selectedClass\" layout=\"row\" translate=\"APP_SELECTED\">\nSelected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" \ntranslate=\"APP_REMOVE_ALL\" ng-hide=\"vm.disallowUpdate\" ng-click=\"vm.unselectAll()\">Remove all</md-button></div></div>\n<md-list-item dir-paginate=\"item in vm.selectedElements|filter :vm.searchSelected|itemsPerPage:25\" \npagination-id=\"vm.selectedPaginationId\"><md-checkbox ng-if=\"item.type === \'radio\'\" ng-model=\"message.selected\">\n</md-checkbox><md-checkbox ng-if=\"(item.type === 2 || item.type === 1) && vm.subscriberGrpDetail == true\" \nng-model=\"item.client_is_muted\"></md-checkbox><p ng-if=\"!item.affiliated\">{{item.name}}</p><p ng-if=\"item.affiliated\" \nstyle=\"color: blue\" title=\"{{item.org_name}}\">{{item.name}}</p><p ng-if=\"item.organization_name\" \nstyle=\"color: blue; text-align: center\">{{item.organization_name}}</p><md-button class=\"md-icon-button\" \nng-if=\"(!vm.defaultRadioGroup || vm.defaultRadioGroup != item._id) && !item.no_icon\" ng-click=\"vm.unselectItem(item)\" \nng-hide=\"vm.disallowUpdate\" aria-label=\"Add event\" translate translate-attr-aria-label=\"APP_ADD\"><md-icon \nmd-font-icon=\"icon-minus\" aria-label=\"Remove item\" translate translate-attr-aria-label=\"APP_REMOVE\"></md-icon>\n</md-button></md-list-item><div layout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.selectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</md-list></div>");
$templateCache.put("app/main/shared/choose-list-select/choose.list.select.html","<div layout=\"row\"><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container \nstyle=\"width: 50%\"><label translate=\"ORGANIZATIONS\">Organizations</label><md-select name=\"select\" \nng-model=\"vm.selectedDropDown\"><md-option ng-repeat=\"item in ::vm.dropDownElements\" ng-value=\"item._id\">{{item.name}}\n</md-option></md-select></md-input-container><md-input-container style=\"width: 50%\"><label translate=\"APP_SEARCH\">\nSearch</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.searchUnselected.name\" type=\"text\">\n</md-input-container></div><div layout=\"row\" style=\"min-width: max-content\"><div layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.sort(false)\"><md-subheader class=\"md-no-sticky\" style=\"font-weight: bold\" \nng-class=\"vm.unselectedClass\" layout=\"row\" translate=\"APP_UNSELECTED_OFFNET\">Off-net subscribers</md-subheader></div>\n<div flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" translate=\"APP_ADD_ALL\" \nng-click=\"vm.selectAll()\" ng-hide=\"vm.disallowUpdate\">Add all</md-button></div></div><md-list-item \ndir-paginate=\"item in vm.notSelectedElements[vm.selectedDropDown]|filter :vm.searchUnselected|getOffNetUsers: true|itemsPerPage:vm.pageCount\" \npagination-id=\"vm.unselectedPaginationId\"><p>{{ item.name }}</p><md-button class=\"md-icon-button\" \nng-click=\"vm.selectItem(item)\" ng-hide=\"vm.disallowUpdate\" aria-label=\"Add item\" translate \ntranslate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-list-item><div \nlayout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.unselectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</md-list><md-divider></md-divider><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container\n flex><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchSelected.name\" type=\"text\"></md-input-container><div flex layout=\"column\" layout-align=\"end center\">\n<span ng-if=\"!vm.dispatcher\">{{vm.selectedElements.length}}/{{vm.memberCountLimit}}</span> <span ng-if=\"vm.dispatcher\">\n{{vm.selectedElements.length}}/{{vm.memberCountLimitDispatcher}}</span></div></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div flex layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(true)\">\n<md-subheader class=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.selectedClass\" layout=\"row\" \ntranslate=\"APP_SELECTED\">Selected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised\" translate=\"APP_REMOVE_ALL\" ng-hide=\"vm.disallowUpdate\" ng-click=\"vm.unselectAll()\">Remove all\n</md-button></div></div><md-list-item \ndir-paginate=\"item in vm.selectedElements|filter :vm.searchSelected|itemsPerPage:vm.pageCount\" \npagination-id=\"vm.selectedPaginationId\"><md-checkbox ng-if=\"item.type === \'radio\'\" ng-model=\"message.selected\">\n</md-checkbox><span>{{item.name}}</span><p style=\"color: blue; text-align: center\">{{ item.organization_name }}</p>\n<md-button class=\"md-icon-button\" ng-if=\"!vm.defaultRadioGroup || vm.defaultRadioGroup != item._id\" \nng-click=\"vm.unselectItem(item)\" ng-hide=\"vm.disallowUpdate\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-minus\" aria-label=\"Remove item\" translate \ntranslate-attr-aria-label=\"APP_REMOVE\"></md-icon></md-button></md-list-item><div layout=\"row\" \nlayout-align=\"start center\"><dir-pagination-controls max-size=\"1\" pagination-id=\"vm.selectedPaginationId\" \ndirection-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></md-list></div>");
$templateCache.put("app/main/shared/choose-list-select-bind-muted/choose.list.select.bind.muted.html","<div layout=\"row\"><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container \nstyle=\"width: 50%\"><label translate=\"ORGANIZATIONS\">Organizations</label><md-select name=\"select\" \nng-model=\"vm.selectedDropDown\"><md-option ng-repeat=\"item in ::vm.dropDownElements\" ng-value=\"item._id\">{{item.name}}\n</md-option></md-select></md-input-container><md-input-container style=\"width: 50%\"><label translate=\"APP_SEARCH\">\nSearch</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.searchUnselected.name\" type=\"text\">\n</md-input-container></div><div layout=\"row\" style=\"min-width: max-content\"><div layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.sort(false)\"><md-subheader class=\"md-no-sticky\" style=\"font-weight: bold\" \nng-class=\"vm.unselectedClass\" layout=\"row\" translate=\"APP_UNSELECTED_OFFNET\">Off-net subscribers</md-subheader></div>\n<div flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" translate=\"APP_ADD_ALL\" \nng-click=\"vm.selectAll()\" ng-hide=\"vm.disallowUpdate\">Add all</md-button></div></div><md-list-item \ndir-paginate=\"item in vm.notSelectedElements[vm.selectedDropDown]|filter :vm.searchUnselected|getOffNetUsers: true|itemsPerPage:25\" \npagination-id=\"vm.unselectedPaginationId\"><p>{{ item.name }}</p><md-button class=\"md-icon-button\" \nng-click=\"vm.selectItem(item)\" ng-hide=\"vm.disallowUpdate\" aria-label=\"Add item\" translate \ntranslate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></md-list-item><div \nlayout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"1\" \npagination-id=\"vm.unselectedPaginationId\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</md-list><md-divider></md-divider><md-list flex=\"45\"><div layout=\"row\" layout-align=\"start center\"><md-input-container\n flex><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.searchSelected.name\" type=\"text\"></md-input-container><div flex layout=\"column\" layout-align=\"end center\">\n<span ng-if=\"!vm.dispatcher\">{{vm.selectedElements.length}}/{{vm.memberCountLimit}}</span> <span ng-if=\"vm.dispatcher\">\n{{vm.selectedElements.length}}/{{vm.memberCountLimitDispatcher}}</span></div></div><div layout=\"row\" \nstyle=\"min-width: max-content\"><div flex layout=\"row\" layout-align=\"start center\" ng-click=\"vm.sort(true)\">\n<md-subheader class=\"md-no-sticky\" style=\"font-weight: bold\" ng-class=\"vm.selectedClass\" layout=\"row\" \ntranslate=\"APP_SELECTED\">Selected</md-subheader></div><div flex layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised\" translate=\"APP_REMOVE_ALL\" ng-hide=\"vm.disallowUpdate\" ng-click=\"vm.unselectAll()\">Remove all\n</md-button></div></div><md-list-item \ndir-paginate=\"item in vm.selectedElements|filter :vm.searchSelected|itemsPerPage:25\" \npagination-id=\"vm.selectedPaginationId\"><md-checkbox ng-if=\"item.type === \'radio\'\" ng-model=\"message.selected\">\n</md-checkbox><span>{{item.name}}</span><p style=\"color: blue; text-align: center\">{{ item.organization_name }}</p>\n<md-button class=\"md-icon-button\" ng-if=\"!vm.defaultRadioGroup || vm.defaultRadioGroup != item._id\" \nng-click=\"vm.unselectItem(item)\" ng-hide=\"vm.disallowUpdate\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-minus\" aria-label=\"Remove item\" translate \ntranslate-attr-aria-label=\"APP_REMOVE\"></md-icon></md-button></md-list-item><div layout=\"row\" \nlayout-align=\"start center\"><dir-pagination-controls max-size=\"1\" pagination-id=\"vm.selectedPaginationId\" \ndirection-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></md-list></div>");
$templateCache.put("app/main/shared/left-tree-select/lefttree.select.html","<md-select ng-model=\"vm.ngModel\" ng-change=\"vm.triggerTreeSelect()\" \nng-disabled=\"vm.isOrgAdmin || vm.preparedArray.length == 0\" md-on-close=\"vm.clearSearch()\"><md-select-header \nlayout=\"column\" style=\"align-items: center\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"{{ \'APP_SEARCH\' | translate  }}\"></md-select-header><md-optgroup><md-option \nng-if=\"item.open && (item._id != 2)\" \nng-repeat=\"item in vm.preparedArray | filter: {name: vm.searchTerm} track by item._id\" \nclass=\"deep-lvl-{{item.deepLvl}}\" ng-value=\"item._id\" style=\"height:24px\"><md-icon \nng-click=\"vm.showChildren(item, $event)\" ng-if=\"item.children.length>0 && !item.showChildren\" \nmd-font-icon=\"s16 icon-plus\"></md-icon><md-icon ng-click=\"vm.showChildren(item, $event)\" \nng-if=\"item.children.length>0 && item.showChildren\" md-font-icon=\"s16 icon-minus\"></md-icon><span \nng-class=\"{\'reseller-type\': item.type === \'reseller\'}\"><md-icon ng-if=\"item.children.length==0\" md-font-icon=\"s16 \">\n</md-icon>{{item.name}}<md-icon class=\"icon-right\" ng-if=\"item.organizationCount>0\" md-font-icon=\"s16 icon-bank\">\n</md-icon></span></md-option></md-optgroup></md-select>");
$templateCache.put("app/main/shared/password-fields/password.fields.html","<div layout=\"column\"><div layout=\"row\" flex><md-input-container flex=\"100\"><label translate=\"SUBSCRIBERS_PASSWORD\">\nPassword</label><input id=\"password\" type=\"password\" name=\"password\" ng-model=\"vm.password\" \nng-change=\"vm.typePassword()\" translate aria-invalid=\"true\" ng-pattern=\"vm.pattern\" md-maxlength=\"15\" \nautocomplete=\"off\" required><md-tooltip ng-if=\"vm.strongPassword\"><span translate=\"APP_VALIDATION_PASSWORD\">\nPassword should conatin- ..</span></md-tooltip><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"icon-button md-icon-button\" style=\"margin-left: -55px\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"APP_GENERATE_PASSWORD\"><md-tooltip md-direction=\"bottom\"><span \ntranslate=\"APP_GENERATE_PASSWORD\">Generate Password</span></md-tooltip><md-icon class=\"eye-icon\" \nmd-font-icon=\"icon-sync\" ng-click=\"vm.generatePass()\"></md-icon></md-button><md-button \nclass=\"icon-button md-icon-button\" style=\"margin-left: -30px\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"HELP\"><md-icon ng-if=\"!vm.showPassword\" class=\"eye-icon\" md-font-icon=\"icon-eye-off\" \nng-click=\"vm.showPass(\'password\', true)\"></md-icon><md-icon ng-if=\"vm.showPassword\" class=\"eye-icon\" \nmd-font-icon=\"icon-eye\" ng-click=\"vm.showPass(\'password\', true)\"></md-icon></md-button></div><div \nng-messages=\"vm.formName.password.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"pattern\"><span \nng-if=\"!vm.strongPassword\" translate=\"APP_VALIDATION_SPACE\">Password can not contain space</span> <span \nng-if=\"vm.strongPassword\" translate=\"APP_VALIDATION_PASSWORD\">Password format is invalid</span></div></div>\n</md-input-container></div></div><div layout=\"column\"><div layout=\"row\"><md-input-container flex=\"100\" \nmd-is-error=\"vm.rePassword !== vm.password\"><label translate=\"SUBSCRIBERS_RE_PASSWORD\" class=\"not-match\" \nng-class=\"{\'not-match\': vm.rePassword !== vm.password}\">Retype password</label><input id=\"repassword\" type=\"password\" \nname=\"rePassword\" ng-model=\"vm.rePassword\" ng-change=\"vm.typePassword()\" translate aria-invalid=\"true\" \nng-pattern=\"vm.pattern\" md-maxlength=\"15\" autocomplete=\"new-password\" required autocomplete=\"off\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"icon-button md-icon-button\" style=\"margin-left: -30px\" \naria-label=\"Add event\" translate translate-attr-aria-label=\"HELP\"><md-icon ng-if=\"!vm.showRePassword\" class=\"eye-icon\" \nmd-font-icon=\"icon-eye-off\" ng-click=\"vm.showPass(\'repassword\', false)\"></md-icon><md-icon ng-if=\"vm.showRePassword\" \nclass=\"eye-icon\" md-font-icon=\"icon-eye\" ng-click=\"vm.showPass(\'repassword\', false)\"></md-icon></md-button></div><div \nng-messages=\" vm.formName.password.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"unequal\"><span \ntranslate=\"APP_PASSWORD_MISMATCH\">Password doesn’t match</span></div><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/shared/tree-select/tree.select.html","<md-select ng-model=\"vm.ngModel\" ng-change=\"vm.triggerTreeSelect()\" \nng-disabled=\"vm.isOrgAdmin || vm.preparedArray.length == 0\" md-on-close=\"vm.clearSearch()\"><md-select-header \nlayout=\"column\" style=\"align-items: center\"><input ng-model=\"vm.searchTerm\" type=\"search\" \nplaceholder=\"{{ \'APP_SEARCH\' | translate  }}\"></md-select-header><md-optgroup><md-option ng-show=\"vm.isVisible(item)\" \nng-repeat=\"item in vm.preparedArray | filter: {name: vm.searchTerm} track by item._id\" \nclass=\"deep-lvl-{{item.deepLvl}}\" ng-value=\"item._id\" style=\"height:24px\"><md-icon \nng-click=\"vm.showChildren(item, $event)\" ng-show=\"item.children.length>0 && !item.showChildren\" \nmd-font-icon=\"s16 icon-plus\"></md-icon><md-icon ng-click=\"vm.showChildren(item, $event)\" \nng-show=\"item.children.length>0 && item.showChildren\" md-font-icon=\"s16 icon-minus\"></md-icon><span \nng-class=\"{\'reseller-type\': item.type === \'reseller\'}\"><md-icon ng-if=\"item.children.length==0\" md-font-icon=\"s16 \">\n</md-icon>{{item.name}}<md-icon class=\"icon-right\" ng-if=\"item.organizationCount>0\" md-font-icon=\"s16 icon-bank\">\n</md-icon></span></md-option></md-optgroup></md-select>");
$templateCache.put("app/main/shared/treeview/treeview.html","<ul><li ng-repeat=\"leaf in vm.treeData\"><ng-include src=\"\'app/main/shared/treeview/treeview.leaf.html\'\" \nonload=\"childLeaf=leaf\"></ng-include></li></ul>");
$templateCache.put("app/main/shared/treeview/treeview.leaf.html","<md-icon ng-if=\"childLeaf.children && childLeaf.children.length\" ng-hide=\"childLeaf.open\" \nng-click=\"childLeaf.open = true;\">+</md-icon><md-icon ng-if=\"childLeaf.children && childLeaf.children.length\" \nng-show=\"childLeaf.open\" ng-click=\"childLeaf.open = false;\">-</md-icon><span class=\"leaf-name\" \nng-click=\"vm.leafSelect({leaf: childLeaf})\">{{childLeaf.name}}</span><ul ng-if=\"childLeaf.children\" \nng-show=\"childLeaf.open\"><li ng-repeat=\"leaf in childLeaf.children\" ng-click=\"vm.leafSelect(leaf)\"><ng-include \nsrc=\"\'app/main/shared/treeview/treeview.leaf.html\'\" onload=\"childLeaf=leaf\"></ng-include></li></ul>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\" \nui-sref=\"app.restricted.homepage\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">\n<img data-ng-src=\"{{vm.LogoImg}}\" style=\"height: 30px; object-fit: contain\"></span></div></md-toolbar><ms-navigation \nclass=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex=\"7\"><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"column\" flex=\"85\"><div layout=\"row\" layout-align=\"start center\" flex=\"100\"><ul class=\"breadcrumb\"><li \nng-repeat=\"item in vm.breadcrumbs\" ng-click=\"vm.setContext(item)\"><a>{{item.name}}</a></li></ul></div><div \nclass=\"choose-tree\" layout=\"row\" layout-align=\"center center\" flex><md-input-container class=\"customer-select\" flex>\n<label translate=\"TOOLBAR_RESELLERS\">Resellers</label><tree-select is-org-admin=\"vm.isOrgAdmin\" \nng-model=\"vm.resellerId\" tree-data=\"vm.resellersList\" tree-select=\"vm.chooseReseller()\"></tree-select>\n</md-input-container><md-input-container flex><label translate=\"TOOLBAR_ORGANIZATIONS\">Organization</label><tree-select\n is-org-admin=\"vm.isOrgAdmin\" ng-model=\"vm.organizationId\" tree-data=\"vm.organizations\" \ntree-select=\"vm.chooseOrganization()\"></tree-select></md-input-container><md-icon-button \nng-click=\"vm.switchToResellerContext()\" ng-if=\"vm.organizationId && !vm.isOrgAdmin\"><md-icon md-font-icon=\"icon-close\" \nclass=\"icon s24\" hide-xs></md-icon></md-icon-button><form ng-submit=\"vm.searchPlatform()\" name=\"vm.search\">\n<md-input-container style=\"height: 47px\"><label style=\"bottom: 60px\" translate=\"TOOLBAR_SEARCHTEXT\">phone</label><input\n type=\"text\" ng-model=\"vm.searchText\" translate aria-invalid=\"true\" minlength=\"3\" md-maxlength=\"30\" maxlength=\"30\">\n</md-input-container><md-button ng-click=\"vm.searchPlatform()\" ng-disabled=\"vm.search.$invalid\" \ntranslate=\"TEXT_SEARCHBTN\" style=\"background-color: #2A9CDB;color: white;margin-left: 10px\">Search</md-button></form>\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide show-gt-sm>{{vm.userName}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\" translate=\"TOOLBAR_LOGOUT\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.svg\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\" ng-if=\"lang.active\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\">\n<span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.svg\"> <span>\n{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" \nng-click=\"vm.getHelpFile()\" aria-label=\"Add event\" translate translate-attr-aria-label=\"HELP\"><md-tooltip><span \ntranslate=\"HELP_HEADING\">Administration Portal Help</span></md-tooltip><md-icon md-font-icon=\"icon-help-circle\" \nstyle=\"color: #2A9CDB\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-if=\"vm.showITODashboard\" \nng-click=\"vm.openDashboard()\" aria-label=\"Add event\" translate translate-attr-aria-label=\"HELP\"><md-tooltip><span \ntranslate=\"DASHBOARD_HEADING\">Dashborad</span></md-tooltip><md-icon md-font-icon=\"icon-chart-bar\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-if=\"vm.showStatistics && !vm.isOrgAdmin\" \nng-click=\"vm.openStatistics()\" aria-label=\"Add event\" translate translate-attr-aria-label=\"HELP\"><md-tooltip><span \ntranslate=\"STATISTICS_HEADING\">Statistics</span></md-tooltip><md-icon md-font-icon=\"icon-chart-line\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-if=\"vm.showRecorderStatistics && !vm.isOrgAdmin\" \nng-click=\"vm.openDualRecorder()\" aria-label=\"Add event\" translate translate-attr-aria-label=\"HELP\"><md-tooltip><span \ntranslate=\"DUAL_RECORDER_HEADING\">Recorder Statistics</span></md-tooltip><md-icon md-font-icon=\"icon-chart-areaspline\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/auth/login/change-password/change.password.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div class=\"logo\">\n<img width=\"60%\" src=\"../assets/images/logos/mt_logo.png\"></div><div class=\"title\" style=\"text-align:center\" \ntranslate=\"LOGIN_INTRO_TITLE\">Mobile Tornado ITO portal</div><div class=\"description\"></div></div><div \nid=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><md-button class=\"md-icon-button\" \nng-click=\"vm.backToLogin()\" aria-label=\"Add event\" translate translate-attr-aria-label=\"HELP\" style=\"float: right\">\n<md-tooltip><span translate=\"BACK_TO_LOGIN\">Back to login</span></md-tooltip><md-icon md-font-icon=\"icon-login\">\n</md-icon></md-button><div id=\"login-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm><span>T</span></div><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular ng-if=\"vm.showLoader\" \nclass=\"md-accent md-hue-1\" md-diameter=\"60\" style=\"margin-top: -90pt\"></md-progress-circular></div><form \nname=\"changePasswordForm\" novalidate ng-submit=\"vm.changePassword()\" autocomplete=\"off\"><div class=\"account-icon\">\n<md-icon class=\"account-icon\" md-font-icon=\"icon-account-circle\"></md-icon></div><div class=\"title\" \ntranslate=\"CHANGE_PASSWORD_TITLE\">Change Password</div><md-input-container class=\"md-block\" md-no-float><input \ntype=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" ng-disabled=\"vm.form.email\" translate \ntranslate-attr-placeholder=\"LOGIN_EMAIL\" autocomplete=\"off\" onfocus=\"this.removeAttribute(\'readonly\')\" required>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.currentPassword\" placeholder=\"Current Password\" translate \ntranslate-attr-placeholder=\"CHANGE_PASSWORD_CURRENT\" autocomplete=\"off\" onfocus=\"this.removeAttribute(\'readonly\')\" \nrequired><div ng-messages=\"changePasswordForm.currentPassword.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN_ERRORS_PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"title-new\" translate=\"CHANGE_PASSWORD_NEW\">New Password</div><password-fields password=\"vm.form.password\" \nre-password=\"vm.form.rePassword\" form-name=\"changePasswordForm\" strong-pass=\"vm.strongPass\"></password-fields>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"changePasswordForm.$invalid || changePasswordForm.$pristine\" translate=\"APP_SAVE\" \ntranslate-attr-aria-label=\"APP_SAVE\">LOG IN</md-button><md-input-container class=\"md-block\" md-no-float><div \nclass=\"error-msg\" ng-model=\"vm.form.errorMsg\">{{vm.form.errorMsg}}</div></md-input-container></form></div></div></div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" \ntranslate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div \nclass=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for anything\" translate \ntranslate-attr-placeholder=\"ERROR404.SEARCH\" flex></div><a class=\"back-link md-accent-color\" href=\"/\" \ntranslate=\"ERROR404.GO_BACK\">Go back to dashboard</a></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" \ntranslate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" \ntranslate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/main/restricted/administration/activityLog/activityLog.html","<div class=\"page-layout carded fullwidth single-scroll subscriber\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\"><div class=\"header\"></div><md-content \nclass=\"content-card ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\">\n</md-input-container><div layout=\"row\" class=\"layout-align-start-left layout-row\" flex><h1 class=\"h2\" \nlayout-align=\"left\" translate=\"ACTIVITY_LOG_TITLE\">Activity Log</h1></div></div><span \nstyle=\"align-self: right;color:red\">{{vm.errMessage}}</span><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"margin-right\"><md-input-container md-no-float><md-datepicker ng-model=\"vm.dates.startDate\" \nng-change=\"vm.checkDate()\" md-min-date=\"vm.minDate\" md-max-date=\"vm.now\" name=\"startDate\" \nmd-placeholder=\"{{ \'START_DATE\' | translate  }}\" required onkeydown=\"return false\"></md-datepicker>\n</md-input-container><md-input-container md-no-float><md-datepicker ng-model=\"vm.dates.endDate\" \nng-change=\"vm.checkDate()\" md-max-date=\"vm.now\" md-min-date=\"vm.dates.startDate\" name=\"endDate\" \nmd-placeholder=\"{{ \'END_DATE\' | translate  }}\" onkeydown=\"return false\"></md-datepicker></md-input-container><md-button\n ng-click=\"vm.getActivitiesByDates()\" aria-label=\"Add event\" translate translate-attr-aria-label=\"REFRESH\"><md-tooltip>\n<span translate=\"APP_REFRESH\">Refresh</span></md-tooltip><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button>\n</div></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"row\" layout-align=\"margin-right\" flex=\"30\" \nstyle=\"margin-inline-start: auto\"><label><input type=\"radio\" ng-model=\"vm.exportTypeActivityLog\" \nid=\"vm.exportTypeActivityLog\" value=\"csv\" ng-disabled=\"vm.showLoader || !vm.activityLogs || !vm.activityLogs.length\">\nCSV</label><label><input type=\"radio\" ng-model=\"vm.exportTypeActivityLog\" id=\"vm.exportTypeActivityLog\" value=\"excel\" \nng-disabled=\"vm.showLoader || !vm.activityLogs || !vm.activityLogs.length\">Excel</label><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.showLoader || !vm.activityLogs || !vm.activityLogs.length\" \nng-csv=\"vm.getExportActivityLog()\" lazy-load=\"true\" add-bom=\"true\" \ncsv-header=\"[\'TimeStamp\',\'User\',\'Type\',\'Organization\',\'Name\',\'Operation\',\'Description\']\" \nfilename=\"{{vm.timestamp| date:\'dd-MMM-yyyy\'}}-activityLog.csv\" \nstyle=\"min-width: min-content; width: -webkit-fill-available\"><label translate=\"BULK_EXPORT_ACTIVITY_LOG\">\nExport Call Log</label></md-button></div><table class=\"dataTable row-border stripe hover\"><thead><tr><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'timestamp\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'timestamp\')\" translate=\"ACTIVITY_LOG_TIMESTAMP\">Time stamp</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'administrator_name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'administrator_name\')\" translate=\"ACTIVITY_LOG_USER\">User</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'key1_type\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'key1_type\')\" translate=\"ACTIVITY_LOG_TYPE\">Type</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'org_node_id\')\" ng-if=\"vm.isRootAdmin\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-class=\"vm.getSortingClass(\'org_node_id\')\" translate=\"ORGANIZATION\">Name</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'key1_name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'key1_name\')\" translate=\"ACTIVITY_LOG_NAME\">Name</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'description\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'description\')\" translate=\"ACTIVITY_LOG_OPERATION\">Operation</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ACTIVITY_LOG_DESCRIPTION\">\nDescription</span></div></th></tr></thead><tbody><tr style=\"height: 30px\" \ndir-paginate=\"activity in vm.activityLogs |searchActivityLog:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\" pagination-id=\"activityLogRecords\"><td width=\"15%\" class=\"table-name-label\">\n{{ activity.timestamp | date:\'dd/MMM/yyyy HH:mm:ss\'}}</td><td width=\"10%\" class=\"table-name-label\">\n{{ activity.administrator_name }}</td><td width=\"10%\" class=\"table-name-label\" ng-if=\"!activity.key1_type_deleted\">\n{{ activity.key1_type }}</td><td width=\"10%\" class=\"table-name-label\" ng-if=\"activity.key1_type_deleted\" \nstyle=\"color: darkblue\">{{ activity.key1_type }}</td><td width=\"15%\" class=\"table-name-label\" ng-if=\"vm.isRootAdmin\">\n{{activity.org_node_name}}</td><td width=\"10%\" class=\"table-name-label\" title=\"{{activity.key1}}\" \nng-if=\"!activity.key1_name_deleted\">{{ activity.key1_name }}</td><td width=\"10%\" class=\"table-name-label\" \ntitle=\"{{activity.key1}}\" ng-if=\"activity.key1_name_deleted\" style=\"color: darkblue\">{{ activity.key1_name }}</td><td \nwidth=\"15%\" class=\"table-name-label\">{{activity.description}}</td><td width=\"40%\" class=\"table-name-label\">\n{{activity.new_value}}</td></tr></tbody></table><md-content ng-if=\"!vm.activityLogs.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\" \nng-if=\"!vm.dates || (!vm.dates.startDate && !vm.dates.endDate)\"><div \nclass=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" translate=\"CALL_LOG_DATES_CONTEXT_WARNING\">\nPlease choose dates</p></div></div><div class=\"content-card\"><p class=\"pd-2\" \nng-if=\"!vm.showLoader && vm.dates && vm.dates.startDate && vm.dates.endDate\" translate=\"APP_NO_RECORDS\" \ntranslate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" \nflex layout-align=\"flex-start center\"><md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label>\n<md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \npagination-id=\"activityLogRecords\" max-size=\"1\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls>\n</div></div></div></md-content></div></div>");
$templateCache.put("app/main/restricted/administration/administrators/list.html","<div class=\"page-layout carded fullwidth single-scroll\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\" flex=\"\"><div class=\"header\"><md-button class=\"add-button md-fab md-warn\" ng-click=\"vm.addAdmin()\" \nng-disabled=\"!vm.allowCreate\" aria-label=\"Add\" translate><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n<div class=\"content-card\"><div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div><span class=\"h2 new\" \ntranslate=\"ADMINISTRATION_TITLE\" flex layout-align=\"center\">Administrators</span></div><table \nclass=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'name\')\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" translate=\"ADMINISTRATION_EMAIL\">\nEmail</span></div></th><th class=\"secondary-text\" ng-click=\"vm.sort(\'roleName\')\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-class=\"vm.getSortingClass(\'roleName\')\" translate=\"ADMINISTRATION_ROLE\">Role</span></div></th>\n<th class=\"secondary-text\" ng-click=\"vm.sort(\'lastPasswordChangeTimestamp\')\" ng-if=\"vm.showChangePassword\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'lastPasswordChangeTimestamp\')\" \ntranslate=\"USER_LAST_PASSWORD_CHANGE_TIME\">Last password change time</span></div></th><th \nclass=\"end-column secondary-text\" ng-if=\"vm.showBlockRelease && vm.maxLoginRetries != 0\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"APP_RELEASE\">Release</span></div></th><th class=\"end-column secondary-text\" \nng-if=\"vm.allowDelete\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div>\n</th></tr></thead><tbody><tr title=\"{{vm.showId ? admin._id : \'\'}}\" \ndir-paginate=\"admin in vm.adminsList |searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td ng-if=\"vm.showBlockRelease && admin.isLock && vm.maxLoginRetries != 0\" style=\"color: red\" \nwidth=\"40%\" class=\"table-name-label\" ng-click=\"vm.editAdmin(admin)\">{{admin.name}}</td><td \nng-if=\"!vm.showBlockRelease || !admin.isLock || vm.maxLoginRetries == 0\" width=\"40%\" class=\"table-name-label\" \nng-click=\"vm.editAdmin(admin)\">{{admin.name}}</td><td width=\"40%\" class=\"table-name-label\" \nng-click=\"vm.editAdmin(admin)\">{{admin.roleName}}</td><td width=\"20%\" class=\"table-name-label\" \nng-if=\"vm.showChangePassword\">{{admin.lastPasswordChangeTimestamp}}</td><td class=\"end-column\" \nng-if=\"vm.showBlockRelease && !admin.isLock && vm.maxLoginRetries != 0\"><md-button class=\"md-icon-button\" \nng-click=\"vm.blockUser(admin)\" translate translate-attr-aria-label=\"APP_RELEASE\"><md-icon \nmd-font-icon=\"icon-lock-unlocked-outline\"></md-icon></md-button></td><td class=\"end-column\" \nng-if=\"vm.showBlockRelease && admin.isLock && vm.maxLoginRetries != 0\"><md-button class=\"md-icon-button\" \nng-click=\"vm.releaseUser(admin)\" translate translate-attr-aria-label=\"APP_RELEASE\"><md-icon \nmd-font-icon=\"icon-lock-outline\" style=\"color: red\"></md-icon></md-button></td><td class=\"end-column\" \nng-if=\"vm.allowDelete\"><md-button class=\"edit-button md-icon-button\" aria-label=\"organisation details\" translate \ntranslate-attr-aria-label=\"APP_DELETE\" ng-click=\"vm.deleteUser(admin._id)\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content ng-if=\"!vm.adminsList.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex \nclass=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"><md-input-container><label \ntranslate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" \nplaceholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option \nng-value=\"100\">100</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\">\n<dir-pagination-controls max-size=\"1\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</div></div></div></div>");
$templateCache.put("app/main/restricted/administration/roles/addRole.tmpl.html","<md-dialog aria-label=\"Add new role\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Add new role</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>Name</label><input md-maxlength=\"30\" required name=\"name\" ng-model=\"currentRole.name\">\n</md-input-container></div><div flex=\"5\" hide-xs hide-sm></div><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"AR.RESOURCE_PATH\">Resource path</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"AR.GET\">GET access</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"AR.POST\">POST access</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"AR.PATCH\">\nPATCH access</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"AR.DELETE\">DELETE access</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"AR.ACTIONS\">Actions</span></div></th></tr></thead><tbody><tr><td><md-input-container \nmd-no-float flex=\"100\"><label for=\"resource-path\" translate=\"AR.RESOURCE_PATH\">Resource path</label><input type=\"text\" \nname=\"resource_path\" ng-model=\"vm.resource_path\" required=\"\" id=\"resource-path\" translate></md-input-container></td>\n<td><input type=\"checkbox\" name=\"get_access\" ng-model=\"vm.get_access\" required=\"\" id=\"get-access\" translate></td><td>\n<input type=\"checkbox\" name=\"post_access\" ng-model=\"vm.post_access\" required=\"\" id=\"post-access\" translate></td><td>\n<input type=\"checkbox\" name=\"put_access\" ng-model=\"vm.put_access\" required=\"\" id=\"put-access\" translate></td><td><input\n type=\"checkbox\" name=\"delete_access\" ng-model=\"vm.delete_access\" required=\"\" id=\"delete-access\" translate></td><td>\n<md-button class=\"edit-button md-icon-button\" aria-label=\"organisation details\" translate \ntranslate-attr-aria-label=\"AR.DELETE\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td>\n</tr></tbody></table><div class=\"row\" flex ng-if=\"vm.error\"><div class=\"error-msg\" ng-model=\"vm.error\">{{vm.error}}\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-disabled=\"!vm.flagSave\" \nng-click=\"save()\" translate=\"APP_SAVE\">Save</md-button><md-button ng-click=\"cancel()\" translate=\"APP_CANCEL\">Cancel\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/restricted/administration/roles/list.html","<div class=\"page-layout carded fullwidth single-scroll\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\" flex=\"\"><div class=\"header\"><md-button class=\"add-button md-fab md-warn\" \nng-click=\"vm.openPermissionsDialog($event, null, 0)\" ng-disabled=\"!vm.allowCreate\" aria-label=\"Add\" translate><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content-card\"><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\">\n</md-input-container></div><span class=\"h2 new\" flex layout-align=\"center\" style=\"margin-left: -35%\" \ntranslate=\"ROLE_TITLE\">Roles</span><md-button ng-click=\"vm.downloadDeleteSampleFile()\" \nclass=\"md-raised md-accent downloadFile\" style=\"width: fit-content; margin-right: 60px\" \ntranslate=\"DOWNLOAD_SAMPLE_FILE\">Download Sample File</md-button><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.showLoader || !vm.nodeId || !vm.rolesList || !vm.rolesList.length\" ng-click=\"vm.getExportRoles()\" \nlazy-load=\"true\" add-bom=\"true\" style=\"min-width: min-content; width: fit-content; right: 55px\"><label \ntranslate=\"BULK_EXPORT_ROLES\">Export Roles</label></md-button><ng-csv-import content=\"vm.content\" material \nmd-button-class=\"md-raised md-accent\" md-button-title=\"Import\" header=\"false\" separator=\"\',\'\" result=\"vm.resultData\" \naccept=\"\'.xlsx\'\" callback=\"vm.streamingRoleCall\"></ng-csv-import></div><table \nclass=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th><th class=\"secondary-text\" ng-click=\"vm.sort(\'name\')\"><div class=\"table-header\">\n<span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" translate=\"ROLE_NAME\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APP_CLONE\" \nng-if=\"vm.allowCreate\">Clone</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"BULK_EXPORT_ROLES\">Clone</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.allowDelete\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Remove</span></div>\n</th></tr></thead><tbody><tr title=\"{{vm.showId ? role._id : \'\'}}\" \ndir-paginate=\"role in vm.rolesList |searchByName: vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td width=\"10%\"><input type=\"checkbox\" ng-model=\"role.selected\" \nng-change=\"vm.updateSelectedRow(role)\"></td><td width=\"90%\" class=\"table-name-label\" \nng-click=\"vm.openPermissionsDialog($event, role, 0)\">{{role.name}}</td><td width=\"10%\"><md-button \nclass=\"md-icon-button\" ng-if=\"vm.allowCreate\" aria-label=\"organisation details\" \nng-click=\"vm.openPermissionsDialog($event, role, 1)\" translate translate-attr-aria-label=\"APP_CLONE\"><i \nclass=\"icon-content-copy s16 content-copy\"></i></md-button></td><td width=\"10%\"><md-button class=\"md-icon-button\" \naria-label=\"organisation details\" ng-click=\"vm.getExportRoleById(role)\" lazy-load=\"true\" add-bom=\"true\" translate \ntranslate-attr-aria-label=\"APP_CLONE\"><i class=\"icon-download s16 content-copy\"></i></md-button></td><td \nng-if=\"vm.allowDelete\"><md-button ng-if=\"vm.allowDelete\" class=\"edit-button md-icon-button\" \naria-label=\"organisation details\" translate translate-attr-aria-label=\"AR.DELETE\" ng-click=\"vm.deleteRole(role._id)\">\n<md-icon md-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content \nng-if=\"!vm.rolesList.length\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\"><p class=\"pd-2\" translate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div>\n</md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option \nng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"end center\"><dir-pagination-controls max-size=\"1\" direction-links=\"true\" \nboundary-links=\"true\"></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/main/restricted/general/customer/customer.html","<div class=\"page-layout carded fullwidth single-scroll ng-scope layout-row\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center flex\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\">\nSelect customer</span></div><div class=\"content-card\"><div class=\"toolbar layout-align-start-center layout-row\" \nlayout=\"row\" layout-align=\"start center\"><span>Treeview</span></div><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\" ms-scroll=\"\" \ndata-ps-id=\"2a743a66-3a5a-665b-1b0d-fd85817bfce7\"><div class=\"ng-scope\"><div class=\"demo-content ng-scope\"><tree-view \ntree-data=\"roleList1\" leaf-select=\"vm.click(leaf)\"></tree-view></div></div></md-content></div><div \nclass=\"ps-scrollbar-x-rail\" style=\"left: 0px; bottom: 3px\"><div class=\"ps-scrollbar-x\" tabindex=\"0\" \nstyle=\"left: 0px; width: 0px\"></div></div><div class=\"ps-scrollbar-y-rail\" style=\"top: 0px; right: 3px\"><div \nclass=\"ps-scrollbar-y\" tabindex=\"0\" style=\"top: 0px; height: 0px\"></div></div></div></div>");
$templateCache.put("app/main/restricted/general/dashboard/dashboard.html","<div class=\"page-layout carded fullwidth single-scroll ng-scope layout-row\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center flex\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\">\nDashboard</span></div><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"row\"><h4 \nng-if=\"!vm.showResellerItems && !vm.showOrganizationItems\" flex>Please choose main reseller or organization</h4></div>\n<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget ng-if=\"vm.showResellerItems\" flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"pl-8 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Resellers</div></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">98</div><div \nclass=\"h3 secondary-text font-weight-500\"></div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Resellers</span></div></ms-widget-front>\n</ms-widget><ms-widget ng-if=\"vm.showResellerItems\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Organizations</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">77</div><div \nclass=\"h3 secondary-text font-weight-500\"></div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Organizations</span></div></ms-widget-front>\n</ms-widget><ms-widget ng-if=\"vm.showOrganizationItems\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Subscribers</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">929</div><div \nclass=\"h3 secondary-text font-weight-500\"></div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Subsribers</span></div></ms-widget-front>\n</ms-widget><ms-widget ng-if=\"vm.showOrganizationItems\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Groups</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">72</div><div \nclass=\"h3 secondary-text font-weight-500\"></div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Groups</span></div></ms-widget-front>\n</ms-widget></div></div><div class=\"ps-scrollbar-x-rail\" style=\"left: 0px; bottom: 3px\"><div class=\"ps-scrollbar-x\" \ntabindex=\"0\" style=\"left: 0px; width: 0px\"></div></div><div class=\"ps-scrollbar-y-rail\" style=\"top: 0px; right: 3px\">\n<div class=\"ps-scrollbar-y\" tabindex=\"0\" style=\"top: 0px; height: 0px\"></div></div></md-content></div></div></div>");
$templateCache.put("app/main/restricted/general/platform/platform.html","");
$templateCache.put("app/main/restricted/general/searchPlatform/search.html","<div class=\"page-layout carded fullwidth single-scroll subscriber\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\"><md-content class=\"content-card ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\"><div class=\"popup-wrapper\" ng-class=\"vm.popupOverlayClass\"></div><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" style=\"margin-top: 3%\">\n<div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label \ntranslate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" \ntype=\"text\" md-maxlength=\"30\" maxlength=\"30\"></md-input-container></div><span class=\"h2 new\" translate=\"SEARCH_RESULT\" \nflex layout-align=\"center\">Search Result</span></div><table class=\"dataTable row-border stripe hover\"><thead><tr><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'official_first_name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'official_first_name\')\" translate=\"SUBSCRIBERS_DISPLAY_NAME\">Display name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"USER_ID\">User Id</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_SIP\">\nSip</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SUBSCRIBERS_IMSI\">Imsi</span></div></th><th class=\"secondary-text\" ng-if=\"vm.showIMSI2\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_IMSI2\">Imsi2</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"RESELLER\">Reseller</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ORGANIZATION\">\nOrganization</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SUBSCRIBERS_ACTIVE\">Active</span></div></th></tr></thead><tbody ng-if=\"vm.loadTab\"><tr \ndir-paginate=\"subscriber in vm.subscribers |searchByName:vm.search:vm.showIMSI2 |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td width=\"15%\" class=\"table-name-label\" \nng-click=\"vm.editSubscriber(subscriber._id, subscriber.resellerId, subscriber.organization_id)\">{{::subscriber.name}}\n</td><td width=\"15%\" class=\"table-name-label\" \nng-click=\"vm.editSubscriber(subscriber._id, subscriber.resellerId, subscriber.organization_id)\">{{::subscriber._id}}\n</td><td width=\"15%\" class=\"table-name-label\" \nng-click=\"vm.editSubscriber(subscriber._id, subscriber.resellerId, subscriber.organization_id)\">{{::subscriber.sip}}\n</td><td width=\"15%\" class=\"table-name-label\" \nng-click=\"vm.editSubscriber(subscriber._id, subscriber.resellerId, subscriber.organization_id)\">{{::subscriber.imsi}}\n</td><td width=\"15%\" class=\"table-name-label\" ng-if=\"vm.showIMSI2\" \nng-click=\"vm.editSubscriber(subscriber._id, subscriber.resellerId, subscriber.organization_id)\">{{::subscriber.imsi2}}\n</td><td width=\"15%\" class=\"table-name-label\" ng-click=\"vm.editReseller(subscriber.resellerId)\">\n{{::subscriber.resellerName}}</td><td class=\"table-name-label\" \nng-click=\"vm.editOrganization(subscriber.resellerId, subscriber.organization_id)\">{{::subscriber.organizationName}}\n</td><td><md-checkbox class=\"green-or-red\" aria-label=\"checkbox\" ng-model=\"subscriber.admin_state\" ng-true-value=\"0\" \nng-false-value=\"1\" ng-disabled=\"!vm.allowChangeState\" ng-change=\"vm.changeActiveState(subscriber)\"></md-checkbox></td>\n</tr></tbody></table><md-content ng-if=\"!vm.subscribers.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex \nclass=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"><md-input-container><label \ntranslate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" \nplaceholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option \nng-value=\"100\">100</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\">\n<dir-pagination-controls max-size=\"1\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</div></div></md-content></div></div>");
$templateCache.put("app/main/restricted/organization/application-lists/application.lists.html","<div class=\"page-layout carded fullwidth single-scroll reseller-details\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center center flex\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\" translate=\"APPLICATION_LISTS\">\nApplication Lists</span></div><md-content \nclass=\"content-card ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\" \nng-if=\"!vm.showLoader && !vm.organizationId\"><div class=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" \ntranslate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div></md-content><md-tabs \nmd-dynamic-height md-border-bottom ng-if=\"vm.organizationId\" md-selected=\"vm.activeTab\"><md-tab \nmd-on-select=\"vm.onTabChanges()\"><md-tab-label><span translate=\"APPLICATIONS\">List Of Apps</span></md-tab-label>\n<md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/application-lists/tabs/applications.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges()\"><md-tab-label><span translate=\"APPLICATION_PROFILES\">Profiles</span>\n</md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/application-lists/tabs/application.profiles.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/restricted/organization/batch/batch.html","<div class=\"page-layout carded fullwidth single-scroll tabbed reseller-details\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center content flex\" flex><div class=\"header\"><span class=\"h2 white-fg\" translate=\"BULK_TITLE\">\nBulk Operations</span></div><md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\">\n<div class=\"content-card\" ng-if=\"!vm.organizationId\"><div class=\"reseller-manager page-layout simple\"><p class=\"pd-2\" \ntranslate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div></md-content><md-tabs \nmd-dynamic-height md-border-bottom ng-if=\"vm.organizationId\"><md-tab md-on-select=\"vm.onTabChanges(0)\"><md-tab-label>\n<span translate=\"BULK_OPERATIONS\">Bulk Operations</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/batch/tabs/batch.html\'\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.allowDelete\" md-on-select=\"vm.onTabChanges(1)\"><md-tab-label><span translate=\"BULK_INTERACTIVE_DELETE\">\nInteractive Delete</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/batch/tabs/interactive.delete.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab ng-if=\"vm.allowUpdateSubscriber\" md-on-select=\"vm.onTabChanges(2)\"><md-tab-label><span \ntranslate=\"BULK_INTERACTIVE_CHANGE_PASSWORD\">Interactive Change Password</span></md-tab-label><md-tab-body><md-content \nclass=\"pd-2\" ng-include=\"\'app/main/restricted/organization/batch/tabs/interactive.change.password.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.allowUpdateSubscriber\" md-on-select=\"vm.onTabChanges(3)\"><md-tab-label><span \ntranslate=\"BULK_INTERACTIVE_LICENSE\">Interactive License</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/batch/tabs/interactive.license.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.allowUpdateSubscriber\" md-on-select=\"vm.onTabChanges(4)\"><md-tab-label><span \ntranslate=\"BULK_INTERACTIVE_ROLE\">Interactive Role</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/batch/tabs/interactive.role.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab ng-if=\"vm.showApplicationList && vm.allowUpdateSubscriber\" md-on-select=\"vm.onTabChanges(5)\"><md-tab-label>\n<span translate=\"BULK_INTERACTIVE_APPLICATION_LIST\">Interactive Application List</span></md-tab-label><md-tab-body>\n<md-content class=\"pd-2\" ng-include=\"\'app/main/restricted/organization/batch/tabs/interactive.application.list.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-if=\"vm.showSms && vm.allowSms\" md-on-select=\"vm.onTabChanges(6)\">\n<md-tab-label><span translate=\"BULK_INTERACTIVE_SMS\">interactive Sms</span></md-tab-label><md-tab-body><md-content \nclass=\"pd-2\" ng-include=\"\'app/main/restricted/organization/batch/tabs/interactive.sms.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.showEmergencyGroup && vm.allowModifyEmergencyGroup\" \nmd-on-select=\"vm.onTabChanges(7)\"><md-tab-label><span translate=\"BULK_INTERACTIVE_EMERGENCY_GROUP\">\nInteractive Emergency Group</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/batch/tabs/interactive.emergency.group.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.allowModifyContactTemplate && vm.allowUpdateSubscriber\" md-on-select=\"vm.onTabChanges(8)\">\n<md-tab-label><span translate=\"BULK_INTERACTIVE_CONTACT_TEMPLATE\">Interactive Contact Template</span></md-tab-label>\n<md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/batch/tabs/interactive.subscriber.list.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges(9)\"><md-tab-label><span translate=\"BULK_EXPORT_REPORT\">Report</span>\n</md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/batch/tabs/report.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</div></div>");
$templateCache.put("app/main/restricted/organization/callLogs/callLogs.html","<div class=\"page-layout carded fullwidth single-scroll subscriber\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\"><div class=\"header\"></div><md-content \nclass=\"content-card ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\">\n</md-input-container><div layout=\"row\" class=\"layout-align-start-left layout-row\" flex><h1 class=\"h2\" \nlayout-align=\"left\" translate=\"CALL_LOGS_TITLE\">Organization Manager</h1></div></div><span \nstyle=\"align-self: right;color:red\">{{vm.errMessage}}</span><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"margin-right\"><md-input-container md-no-float><md-datepicker class=\"calllogs\" \nng-disabled=\"!vm.organizationId\" ng-model=\"vm.dates.startDate\" md-min-date=\"vm.minDate\" md-max-date=\"vm.dates.now\" \nng-change=\"vm.checkDate(0)\" name=\"startDate\" md-placeholder=\"{{ \'START_DATE\' | translate  }}\" required \nonkeydown=\"return false\"></md-datepicker></md-input-container><md-input-container md-no-float><md-datepicker \nclass=\"calllogs\" ng-disabled=\"!vm.dates.startDate || !vm.organizationId\" ng-model=\"vm.dates.endDate\" \nmd-min-date=\"vm.dates.startDate\" md-max-date=\"vm.maxEndDate\" ng-change=\"vm.checkDate(1)\" name=\"endDate\" \nmd-placeholder=\"{{ \'END_DATE\' | translate  }}\" onkeydown=\"return false\"></md-datepicker></md-input-container><md-button\n ng-disabled=\"!vm.organizationId || vm.showLoader  || !vm.dates.startDate || !vm.dates.endDate\" \nng-click=\"vm.refreshCallLogs()\" aria-label=\"Add event\" translate translate-attr-aria-label=\"REFRESH\"><md-tooltip><span \ntranslate=\"APP_REFRESH\">Refresh</span></md-tooltip><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"row\" layout-align=\"margin-right\" flex=\"30\" \nstyle=\"margin-inline-start: auto\"><label><input type=\"radio\" ng-model=\"vm.exportTypeCallLog\" id=\"vm.exportTypeCallLog\" \nvalue=\"csv\" ng-disabled=\"vm.showLoader || !vm.organizationId || !vm.sessions || !vm.sessions.length\">CSV</label><label>\n<input type=\"radio\" ng-model=\"vm.exportTypeCallLog\" id=\"vm.exportTypeCallLog\" value=\"excel\" \nng-disabled=\"vm.showLoader || !vm.organizationId || !vm.sessions || !vm.sessions.length\">Excel</label><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.showLoader || !vm.organizationId || !vm.sessions || !vm.sessions.length\" \nng-csv=\"vm.getExportCallLogs()\" lazy-load=\"true\" add-bom=\"true\" csv-header=\"csvHeaders\" \nfilename=\"{{vm.timestamp| date:\'dd-MMM-yyyy\'}}-{{vm.organizationId}}-callLog.csv\" \nstyle=\"min-width: min-content; width: -webkit-fill-available\"><label translate=\"BULK_EXPORT_CALL_LOG\">Export Call Log\n</label></md-button></div><table class=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sort(\'session_name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'session_name\')\" translate=\"CALL_LOGS_SESSION_NAME\">Name</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'sender_name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'sender_name\')\" translate=\"CALL_LOGS_SENDER_NAME\">sender</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'recipient_name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'recipient_name\')\" translate=\"CALL_LOGS_RECIPIENT_NAME\">recipient</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'session_type_name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'session_type_name\')\" translate=\"CALL_LOGS_SESSION_TYPE\">Type</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'time_start\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'time_start\')\" translate=\"CALL_LOGS_SESSION_START_TIME\">Start time</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'time_end\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'time_end\')\" translate=\"CALL_LOGS_SESSION_END_TIME\">End time</span></div></th></tr>\n</thead><tbody><tr style=\"height: 30px\" \ndir-paginate=\"session in vm.sessions |searchCallLog:vm.search |itemsPerPage:vm.recordsCount track by session._id\" \nng-class-odd=\"\'odd\'\" pagination-id=\"sessionsRecords\"><td ng-if=\"session.bursts && session.bursts.length > 0\" \ntitle=\"{{vm.showId ? session.session_id : \'\'}}\" width=\"15%\" class=\"table-name-label\" \nng-click=\"vm.showSession(session)\">{{::session.session_name}}</td><td \nng-if=\"!session.bursts || session.bursts.length == 0\" title=\"{{vm.showId ? session.session_id : \'\'}}\" width=\"15%\" \nclass=\"table-name-label\" style=\"color: red\">{{::session.session_name }}<md-icon md-font-icon=\"icon-phone-missed\">\n</md-icon></td><td title=\"{{session.sender_id}}\" width=\"15%\" class=\"table-name-label\">{{::session.sender_name}}</td><td\n title=\"{{session.recipient_id}}\" width=\"15%\" class=\"table-name-label\">{{::session.recipient_name}}</td><td \nwidth=\"15%\" class=\"table-name-label\">{{::session.session_type_name}}</td><td width=\"20%\" class=\"table-name-label\">\n{{::session.format_start_time}}</td><td width=\"20%\" class=\"table-name-label\">{{::session.format_end_time}}</td></tr>\n</tbody></table><md-content ng-if=\"!vm.sessions.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\" \nng-if=\"!vm.organizationId\"><div class=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" \ntranslate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div><div class=\"content-card\" \nng-if=\"vm.organizationId && (!vm.dates || (!vm.dates.startDate && !vm.dates.endDate))\"><div \nclass=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" translate=\"CALL_LOG_DATES_CONTEXT_WARNING\">\nPlease choose dates</p></div></div><div class=\"content-card\"><p class=\"pd-2\" \nng-if=\"!vm.showLoader && vm.organizationId && vm.dates && vm.dates.startDate && vm.dates.endDate\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex \nclass=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"></div><div layout=\"row\" layout-align=\"end center\">\n<dir-pagination-controls ng-model=\"vm.currentPage\" pagination-id=\"sessionsRecords\" max-size=\"1\" direction-links=\"true\" \nboundary-links=\"false\"></dir-pagination-controls></div></div></div></md-content></div></div>");
$templateCache.put("app/main/restricted/organization/contacts/contacts.html","<div class=\"page-layout carded fullwidth single-scroll ng-scope tabbed\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\" flex=\"\"><div class=\"header\" layout-align=\"space-between center\" layout-xs=\"column\"><md-button \nng-disabled=\"!vm.organizationId || !vm.allowCreate\" class=\"add-button md-fab md-warn\" ng-click=\"vm.addContact()\" \naria-label=\"Add event\" translate translate-attr-aria-label=\"CONTACTS_ADD_CONTACT\" \nng-hide=\"::vm.isActionAllowed(\'group_resource\', \'POST\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\">\n</md-input-container></div><span class=\"h2 new\" translate=\"CONTACTS_TITLE\" flex layout-align=\"center\">Contacts</span>\n</div><table class=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sort(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" \ntranslate=\"CONTACTS_LIST_NAME\">List name</span></div></th><th class=\"secondary-text\" ng-click=\"vm.sort(\'type\')\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'type\')\" translate=\"GROUPS_TYPE\">Type\n</span></div></th><th class=\"secondary-text\" ng-click=\"vm.sort(\'count\')\" style=\"text-align: center\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'count\')\" \ntranslate=\"CONTACTS_MEMBER_COUNT\">Member count</span></div></th><th class=\"secondary-text\" style=\"text-align: center\" \nng-click=\"vm.sort(\'cross_fleet\')\" ng-if=\"vm.showAffiliatedContacts\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-class=\"vm.getSortingClass(\'cross_fleet\')\" translate=\"CONTACTS_CROSS_FLEET\">Affiliated Contact\n</span></div></th><th class=\"secondary-text\" ng-if=\"vm.allowDelete\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div></th></tr></thead><tbody><tr \ntitle=\"{{vm.showId ? contact._id : \'\'}}\" \ndir-paginate=\"contact in vm.contacts |searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td width=\"35%\" class=\"table-name-label\" ng-click=\"vm.editContact(contact)\">{{contact.name}}</td>\n<td class=\"table-name-label\" ng-click=\"vm.editContact(contact)\" width=\"20%\">{{vm.types[contact.type]}}</td><td \nwidth=\"20%\" class=\"table-name-label align-center\">{{contact.count}}</td><td class=\"table-name-label align-center\" \nng-click=\"vm.editContact(contact)\" width=\"25%\" ng-if=\"vm.showAffiliatedContacts\"><md-icon md-font-icon=\"icon-check\" \nclass=\"s16\" ng-if=\"contact.cross_fleet\"></md-icon></td><td><md-button class=\"remove-button md-icon-button\" \naria-label=\"remove button\" ng-click=\"vm.removeContact(contact._id)\" translate \ntranslate-attr-aria-label=\"CONTACTS_DELETE\" ng-if=\"vm.allowDelete && !contact.cross_fleet\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content \nng-if=\"!vm.contacts.length\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\" ng-if=\"!vm.organizationId\"><div class=\"reseller-manager page-layout simple tabbed\"><p \nclass=\"pd-2\" translate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div><div \nclass=\"content-card\"><p class=\"pd-2\" ng-if=\"!vm.showLoader && vm.organizationId\" translate=\"APP_NO_RECORDS\" \ntranslate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" \nflex layout-align=\"flex-start center\"><md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label>\n<md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \nmax-size=\"1\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></div></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/restricted/organization/emergency-group/emergency.group.html","<div class=\"page-layout carded fullwidth single-scroll ng-scope tabbed\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\" flex=\"\"><div class=\"header\" layout-align=\"space-between center\" layout-xs=\"column\"><md-button \nng-disabled=\"!vm.organizationId || !vm.allowCreate\" class=\"add-button md-fab md-warn\" \nng-click=\"vm.addEmergencyGroup()\" aria-label=\"Add event\" translate translate-attr-aria-label=\"CONTACTS_ADD_CONTACT\" \nng-hide=\"::vm.isActionAllowed(\'group_resource\', \'POST\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label>Search</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container>\n</div><span class=\"h2 new\" translate=\"NAVIGATION_EMERGENCY_GROUPS\" flex layout-align=\"center\">Contacts Templates</span>\n</div><table class=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sort(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" \ntranslate=\"GROUPS_NAME\">List name</span></div></th><th class=\"secondary-text\" ng-click=\"vm.sort(\'count\')\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'count\')\" translate=\"GROUPS_MEMBER_COUNT\">\nMember count</span></div></th><th class=\"secondary-text\" ng-click=\"vm.sort(\'\')\" ng-if=\"vm.allowDelete\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div></th></tr></thead><tbody><tr\n title=\"{{vm.showId ? emergencyGroup._id : \'\'}}\" \ndir-paginate=\"emergencyGroup in vm.emergencyGroups |searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td style=\"width: 30%\" class=\"table-name-label\" ng-click=\"vm.editEmergencyGroup(emergencyGroup)\">\n{{emergencyGroup.name}}</td><td style=\"width: 100%\">{{emergencyGroup.count}}</td><td><md-button \nclass=\"remove-button md-icon-button\" aria-label=\"remove button\" ng-click=\"vm.removeEmergencyGroup(emergencyGroup._id)\" \ntranslate translate-attr-aria-label=\"CONTACTS_DELETE\" ng-if=\"vm.allowDelete\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content ng-if=\"!vm.emergencyGroups.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\" \nng-if=\"!vm.organizationId\"><div class=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" \ntranslate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div><div class=\"content-card\"><p \nclass=\"pd-2\" ng-if=\"!vm.showLoader && vm.organizationId\" translate=\"APP_NO_RECORDS\" \ntranslate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" \nflex layout-align=\"flex-start center\"><md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label>\n<md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \nmax-size=\"1\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></div></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/restricted/organization/groups/groups.html","<div class=\"page-layout carded fullwidth single-scroll ng-scope layout-row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center flex\" flex=\"\"><div class=\"header\"><md-button class=\"add-button md-fab md-warn\" \nng-disabled=\"!vm.organizationId || !vm.allowCreate\" ng-click=\"vm.addGroup()\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content-card\"><div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div><span class=\"h2 new\" \ntranslate=\"GROUPS_TITLE\" flex layout-align=\"center\">Groups</span></div><table \nclass=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'name\')\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" translate=\"GROUPS_NAME\">Name\n</span></div></th><th class=\"secondary-text\" ng-click=\"vm.sort(\'type\')\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-class=\"vm.getSortingClass(\'type\')\" translate=\"GROUPS_TYPE\">Type</span></div></th><th \nclass=\"secondary-text\" style=\"text-align: center\" ng-click=\"vm.sort(\'count\')\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-class=\"vm.getSortingClass(\'count\')\" translate=\"GROUPS_MEMBER_COUNT\">Member count</span></div>\n</th><th class=\"secondary-text\" style=\"text-align: center\" ng-click=\"vm.sort(\'cross_fleet\')\" \nng-if=\"vm.showAffiliatedGroup\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'cross_fleet\')\" translate=\"GROUPS_CROSS_FLEET\">Cross Fleet</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'expiry_date\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'expiry_date\')\" translate=\"GROUPS_EXPIRATION_DATE\">Expiration date</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.allowDelete\" style=\"text-align: center\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"APP_REMOVE\">Remove</span></div></th></tr></thead><tbody><tr \ntitle=\"{{vm.showId ? group._id : \'\'}}\" \ndir-paginate=\"group in vm.groups |searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td class=\"table-name-label\" ng-click=\"vm.editGroup(group)\" width=\"20%\">{{group.name}}</td><td \nclass=\"table-name-label\" ng-click=\"vm.editGroup(group)\" width=\"15%\">{{vm.types[group.type]}}</td><td \nclass=\"table-name-label align-center\" ng-click=\"vm.editGroup(group)\" width=\"20%\">{{group.count}}</td><td \nclass=\"table-name-label align-center\" ng-click=\"vm.editGroup(group)\" width=\"25%\" ng-if=\"vm.showAffiliatedGroup\">\n<md-icon md-font-icon=\"icon-check\" class=\"s16\" ng-if=\"group.cross_fleet\"></md-icon></td><td class=\"table-name-label\" \nng-click=\"vm.editGroup(group)\" width=\"100%\">{{group.expiry_date | date:\'dd-MMM-yyyy\'}}</td><td \nclass=\"table-name-label align-center\"><md-button class=\"remove-button md-icon-button\" aria-label=\"remove group\" \nng-click=\"vm.removeGroup(group)\" translate translate-attr-aria-label=\"GROUPS_DELETE\" \nng-if=\"vm.allowDelete && !group.cross_fleet\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table><md-content ng-if=\"!vm.groups.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\" \nng-if=\"!vm.organizationId\"><div class=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" \ntranslate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div><div class=\"content-card\"><p \nclass=\"pd-2\" ng-if=\"!vm.showLoader && vm.organizationId\" translate=\"APP_NO_RECORDS\" \ntranslate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" \nflex layout-align=\"flex-start center\"><md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label>\n<md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \nmax-size=\"1\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/main/restricted/organization/locationHistory/locationHistory.html","<div class=\"page-layout carded fullwidth single-scroll subscriber\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\"><div class=\"header\"></div><md-content \nclass=\"content-card ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\">\n</md-input-container><div layout=\"row\" class=\"layout-align-start-left layout-row\" flex><h1 class=\"h2\" \nlayout-align=\"left\" translate=\"NAVIGATION_LOCATION_HISTORY\">Location History</h1></div></div><span \nstyle=\"align-self: right;color:red\">{{vm.errMessage}}</span><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"margin-right\"><md-input-container md-no-float><md-datepicker class=\"calllogs\" \nng-disabled=\"!vm.organizationId\" ng-model=\"vm.dates.startDate\" md-min-date=\"vm.minDate\" md-max-date=\"vm.dates.now\" \nng-change=\"vm.checkDate(0)\" name=\"startDate\" md-placeholder=\"{{ \'START_DATE\' | translate  }}\" required \nonkeydown=\"return false\"></md-datepicker></md-input-container><md-input-container md-no-float><md-datepicker \nclass=\"calllogs\" ng-disabled=\"!vm.dates.startDate || !vm.organizationId\" ng-model=\"vm.dates.endDate\" \nmd-min-date=\"vm.dates.startDate\" md-max-date=\"vm.maxEndDate\" ng-change=\"vm.checkDate(1)\" name=\"endDate\" \nmd-placeholder=\"{{ \'END_DATE\' | translate  }}\" onkeydown=\"return false\"></md-datepicker></md-input-container><md-button\n ng-disabled=\"!vm.organizationId || vm.showLoader  || !vm.dates.startDate || !vm.dates.endDate\" \nng-click=\"vm.refreshCallLogs()\" aria-label=\"Add event\" translate translate-attr-aria-label=\"REFRESH\"><md-tooltip><span \ntranslate=\"APP_REFRESH\">Refresh</span></md-tooltip><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"row\" layout-align=\"margin-right\" flex=\"30\" \nstyle=\"margin-inline-start: auto\"><label><input type=\"radio\" ng-model=\"vm.exportTypeCallLog\" id=\"vm.exportTypeCallLog\" \nvalue=\"csv\" ng-disabled=\"vm.showLoader || !vm.organizationId || !vm.sessions || !vm.sessions.length\">CSV</label><label>\n<input type=\"radio\" ng-model=\"vm.exportTypeCallLog\" id=\"vm.exportTypeCallLog\" value=\"excel\" \nng-disabled=\"vm.showLoader || !vm.organizationId || !vm.sessions || !vm.sessions.length\">Excel</label><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.showLoader || !vm.organizationId || !vm.sessions || !vm.sessions.length\" \nng-csv=\"vm.getExportCallLogs()\" lazy-load=\"true\" add-bom=\"true\" \ncsv-header=\"[\'UserName\',\'UserId\',\'Latitude\',\'Longitude\', \'Accuracy\', \'CreatedAt\']\" \nfilename=\"{{vm.timestamp| date:\'dd-MMM-yyyy\'}}-{{vm.organizationId}}-LocationHistory.csv\" \nstyle=\"min-width: min-content; width: -webkit-fill-available\"><label translate=\"BULK_EXPORT_LOCATION_HISTORY\">\nExport Location History</label></md-button></div><table class=\"dataTable row-border stripe hover\"><thead><tr><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'display_name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'display_name\')\" translate=\"ADMINISTRATION_NAME\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LOCATION_COUNT\">Location</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LOCATION_LAST_UPDATE_TIME\">Last Updated Date & Time</span></div></th></tr></thead><tbody><tr \nstyle=\"height: 30px\" \ndir-paginate=\"session in vm.sessions |searchLocationHistory:vm.search |itemsPerPage:vm.recordsCount track by session.user_id\" \nng-class-odd=\"\'odd\'\" pagination-id=\"sessionsRecords\"><td title=\"{{vm.showId ? session.user_id : \'\'}}\" \nclass=\"table-name-label\" ng-click=\"vm.showSession(session)\">{{::session.display_name }}</td><td \ntitle=\"{{session.user_id}}\" class=\"table-name-label\" ng-click=\"vm.showSession(session)\">{{::session.locations}}</td><td\n title=\"{{session.user_id}}\" class=\"table-name-label\" ng-click=\"vm.showSession(session)\">{{::session.lastUpdateDate}}\n</td></tr></tbody></table><md-content ng-if=\"!vm.sessions.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\" \nng-if=\"!vm.organizationId\"><div class=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" \ntranslate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div><div class=\"content-card\" \nng-if=\"vm.organizationId && (!vm.dates || (!vm.dates.startDate && !vm.dates.endDate))\"><div \nclass=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" translate=\"CALL_LOG_DATES_CONTEXT_WARNING\">\nPlease choose dates</p></div></div><div class=\"content-card\"><p class=\"pd-2\" \nng-if=\"!vm.showLoader && vm.organizationId && vm.dates && vm.dates.startDate && vm.dates.endDate\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex \nclass=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"></div><div layout=\"row\" layout-align=\"end center\">\n<dir-pagination-controls ng-model=\"vm.currentPage\" pagination-id=\"sessionsRecords\" max-size=\"1\" direction-links=\"true\" \nboundary-links=\"false\"></dir-pagination-controls></div></div></div></md-content></div></div>");
$templateCache.put("app/main/restricted/organization/organization-details/organization.details.html","<div class=\"page-layout carded fullwidth single-scroll reseller-details\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center center flex\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\" translate=\"ORGANIZATION_DETAILS\">\nOrganization Details</span></div><md-content \nclass=\"content-card ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\" \nng-if=\"!vm.showLoader && !vm.organization._id\"><div class=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" \ntranslate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div></md-content><md-tabs \nmd-dynamic-height md-border-bottom ng-if=\"vm.organization._id\"><md-tab md-on-select=\"vm.onTabChanges(0)\"><md-tab-label>\n<span translate=\"APP_GENERAL\">General</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/general.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges(1)\" \nng-if=\"vm.organization._id && ((vm.showEncryption && vm.allowSetEncryption) || vm.showUploadVersion)\"><md-tab-label>\n<span translate=\"ORGANIZATION_SECURITY_AND_DOWNLOAD\">Security and Download</span></md-tab-label><md-tab-body>\n<md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/security.and.download.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(2)\" ng-if=\"vm.showBranding\"><md-tab-label><span \ntranslate=\"BRANDING_TITLE\">Branding</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/branding.details.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(2)\" \nng-if=\"vm.isRootAdmin || !vm.allowModifyAudioRecorder || vm.isAdministrator\"><md-tab-label><span \ntranslate=\"APP_SENTINEL\">Sentinel Configurations</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/sentinel.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges(3)\" \nng-if=\"(vm.isRootAdmin || !vm.allowModifyAudioRecorder || vm.isAdministrator) && vm.showLiveSentinel\"><md-tab-label>\n<span translate=\"APP_LIVE_SENTINEL_EVENTS\">Live Sentinel Events</span></md-tab-label><md-tab-body><md-content \nclass=\"pd-2\" ng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/live_sentinel.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs><md-dialog-actions layout=\"row\"><span flex></span><md-button md-no-ink \nclass=\"md-primary\" ng-click=\"vm.saveOrganization()\" ng-disabled=\"!vm.organization._id || vm.orgForm.$invalid\" \nid=\"vm.orgBtn\" ng-if=\"vm.activeTab !=1 && vm.organization._id && vm.allowModify && vm.activeTab!=2 && vm.activeTab!=3\" \naria-label=\"\" translate=\"APP_SAVE\">Save</md-button></md-dialog-actions></div></div>");
$templateCache.put("app/main/restricted/organization/organization-friends/organization.friends.html","<div class=\"page-layout carded fullwidth single-scroll reseller-details\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center center flex\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\" translate=\"ORG_FRIEND\">\nOrganization Friends</span></div><md-content \nclass=\"content-card ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\" \nng-if=\"!vm.showLoader && !vm.org\"><div class=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" \ntranslate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div></md-content><md-content \nclass=\"content group-details\" ng-if=\"vm.org\"><choose-list selected-elements=\"vm.selectedOrgs\" \nnot-selected-elements=\"vm.unselectedOrgs\" member-count-limit=\"vm.limitOrgFriends\" another-limit=\"true\" error=\"false\">\n</choose-list></md-content><md-content ng-if=\"vm.org\"><span flex></span><md-button md-no-ink class=\"md-primary\" \nng-click=\"vm.saveOrgFriends()\" aria-label=\"\">Save</md-button></md-content></div></div>");
$templateCache.put("app/main/restricted/organization/recording/recording.html","<div class=\"page-layout carded fullwidth single-scroll reseller-details\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center center flex\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\" translate=\"RECORDING_TITLE\">Recording\n</span></div><md-content class=\"content-card ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\" ng-if=\"!vm.showLoader && !vm.organizationId\"><div \nclass=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" translate=\"ORGANIZATION_CONTEXT_WARNING\">\nPlease choose organization</p></div></div></md-content><md-tabs md-dynamic-height md-border-bottom \nng-if=\"vm.organizationId\"><md-tab md-on-select=\"vm.onTabChanges(0)\"><md-tab-label><span translate=\"ADMIN_RECORD_TITLE\">\nRecordings Reviewers</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/recording/tabs/admin.record.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab md-on-select=\"vm.onTabChanges(1)\" ng-if=\"vm.showAudioBackupPath\"><md-tab-label><span \ntranslate=\"AUDIO_BACKUP_PATH_TITLE\">Audio Backup Paths</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/recording/tabs/audio.backup.path.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges(2)\" ng-disabled=\"!vm.showWhiteListTabs\"><md-tab-label><span \ntranslate=\"RECORD_WHITE_LIST_SUBSCRIBERS_TITLE\">Recorded users</span></md-tab-label><md-tab-body><md-content \nclass=\"pd-2\" ng-include=\"\'app/main/restricted/organization/recording/tabs/white.list.subscribers.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(3)\" ng-disabled=\"!vm.showWhiteListTabs\"><md-tab-label>\n<span translate=\"RECORD_WHITE_LIST_GROUPS_TITLE\">Recorded groups</span></md-tab-label><md-tab-body><md-content \nclass=\"pd-2\" ng-include=\"\'app/main/restricted/organization/recording/tabs/white.list.groups.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/restricted/organization/subscriberLists/subscriberLists.html","<div class=\"page-layout carded fullwidth single-scroll ng-scope tabbed\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\" flex=\"\"><div class=\"header\" layout-align=\"space-between center\" layout-xs=\"column\"><md-button \nng-disabled=\"!vm.organizationId || !vm.allowCreate\" class=\"add-button md-fab md-warn\" \nng-click=\"vm.addSubscriberList()\" aria-label=\"Add event\" translate translate-attr-aria-label=\"CONTACTS_ADD_CONTACT\" \nng-hide=\"::vm.isActionAllowed(\'group_resource\', \'POST\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label>Search</label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container>\n</div><span class=\"h2 new\" translate=\"NAVIGATION_CONTACTS_TEMPLATES\" flex layout-align=\"center\">Contacts Templates\n</span></div><table class=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sort(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" \ntranslate=\"CONTACTS_TEMPLATE_NAME\">List name</span></div></th><th class=\"secondary-text\" ng-click=\"vm.sort(\'count\')\">\n<div class=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'count\')\" \ntranslate=\"CONTACTS_MEMBER_COUNT\">Member count</span></div></th><th class=\"secondary-text\" ng-click=\"vm.sort(\'\')\" \nng-if=\"vm.allowDelete\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div>\n</th></tr></thead><tbody><tr title=\"{{vm.showId ? subscriberList._id : \'\'}}\" \ndir-paginate=\"subscriberList in vm.subscriberLists |searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td style=\"width: 30%\" class=\"table-name-label\" ng-click=\"vm.editSubscriberList(subscriberList)\">\n{{subscriberList.name}}</td><td style=\"width: 100%\">{{subscriberList.count}}</td><td><md-button \nclass=\"remove-button md-icon-button\" aria-label=\"remove button\" ng-click=\"vm.removeSubscriberList(subscriberList._id)\" \ntranslate translate-attr-aria-label=\"CONTACTS_DELETE\" ng-if=\"vm.allowDelete\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content ng-if=\"!vm.subscriberLists.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\" \nng-if=\"!vm.organizationId\"><div class=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" \ntranslate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div><div class=\"content-card\"><p \nclass=\"pd-2\" ng-if=\"!vm.showLoader && vm.organizationId\" translate=\"APP_NO_RECORDS\" \ntranslate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" \nflex layout-align=\"flex-start center\"><md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label>\n<md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \nmax-size=\"1\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></div></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/restricted/organization/subscribers/subscribers.html","<div class=\"page-layout carded fullwidth single-scroll subscriber\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\"><div class=\"header\"><md-button class=\"add-button md-fab md-warn\" \nng-disabled=\"!vm.organizationId || !vm.allowCreate || !vm.allowCreateLimit\" ng-click=\"vm.addSubscriber()\" \naria-label=\"Add event\" translate translate-attr-aria-label=\"SUBSCRIBERS_ADD_SUBSCRIBERS\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content \nclass=\"content-card ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container style=\"width: 25%\" \nng-if=\"vm.showLicenseAllocation && vm.organization.availble_qty > 0\"><label translate=\"ORGANIZATION_QTY\">qty</label>\n<input type=\"text\" name=\"qty\" ng-model=\"vm.qty\" id=\"qty\" ng-disabled=\"true\" translate></md-input-container>\n<md-input-container style=\"width: 25%\" ng-if=\"vm.showLicenseAllocation && vm.organization.availble_qty <= 0\"><label \ntranslate=\"ORGANIZATION_QTY\" style=\"color: red\">qty</label><input type=\"text\" style=\"color: red\" name=\"qty\" \nng-model=\"vm.qty\" id=\"qty\" ng-disabled=\"true\" translate></md-input-container><md-input-container style=\"width: 25%\" \nng-if=\"vm.showLicenseAllocation && vm.organization.dispatcher_availble_qty > 0\"><label \ntranslate=\"ORGANIZATION_DISPATCHER_QTY\">qty</label><input type=\"text\" name=\"qty\" ng-model=\"vm.dispatcherqty\" \nid=\"dispatcher_qty\" ng-disabled=\"true\" translate></md-input-container><md-input-container style=\"width: 25%\" \nng-if=\"vm.showLicenseAllocation && vm.organization.dispatcher_availble_qty <= 0\"><label \ntranslate=\"ORGANIZATION_DISPATCHER_QTY\" style=\"color: red\">qty</label><input type=\"text\" style=\"color: red\" name=\"qty\" \nng-model=\"vm.dispatcherqty\" id=\"dispatcher_qty\" ng-disabled=\"true\" translate></md-input-container></div><div \nclass=\"popup-wrapper\" ng-class=\"vm.popupOverlayClass\"></div><div class=\"toolbar layout-align-start-center layout-row\" \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"start center\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"30\" maxlength=\"30\" ng-keyup=\"vm.seachDataBox()\"></md-input-container>\n</div><div style=\"width: 15%\"><span class=\"h2 new\" translate=\"SUBSCRIBERS_TITLE\" flex layout-align=\"center\" \nng-if=\"vm.showLicenseAllocation\">Subscribers</span></div><div style=\"width: 25%\"><span class=\"h2 new\" \ntranslate=\"SUBSCRIBERS_TITLE\" flex layout-align=\"center\" ng-if=\"!vm.showLicenseAllocation\">Subscribers</span></div><div\n class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"right\" style=\"margin-right: 1%\">\n<md-input-container><label translate=\"APP_ROLE_FILTER\">filter:</label><md-select ng-model=\"vm.filterRoleTemplate\">\n<md-option ng-selected=\"true\" ng-value=\"null\" ng-click=\"vm.filterRoleChange(null)\" translate=\"APP_NO_FILTER\">\n{{\'no filter\'}}</md-option><md-option ng-repeat=\"item in vm.roleListData\" ng-value=\"item._id\" \nng-click=\"vm.filterRoleChange(item)\">{{item.name}}</md-option></md-select></md-input-container><md-input-container>\n<label translate=\"APP_FILTER\">filter:</label><md-select ng-model=\"vm.filterTemplate\"><md-option ng-selected=\"true\" \nng-value=\"null\" ng-click=\"vm.filterChange(null)\" translate=\"APP_NO_FILTER\">{{\'no filter\'}}</md-option><md-option \nng-value=\"0\" ng-click=\"vm.filterChange(0)\">{{\'CUSTOM\'}}</md-option><md-option ng-repeat=\"item in vm.licenseTemplates\" \nng-value=\"item.name\" ng-click=\"vm.filterChange(item)\">{{item.name}}</md-option></md-select></md-input-container></div>\n</div><div class=\"table-responsive\"><table class=\"dataTable row-border stripe hover\"><thead><tr><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'name\')\" translate=\"SUBSCRIBERS_DISPLAY_NAME\">Display name</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.showId\"><div class=\"table-header\"><span class=\"column-title\">Id</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_SIP\">SIP</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SUBSCRIBERS_IMSI\">IMSI</span></div></th><th class=\"secondary-text\" ng-if=\"vm.showIMSI2\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_IMSI2\">IMSI2</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'admin_state\')\" style=\"text-align: center\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-class=\"vm.getSortingClass(\'admin_state\')\" translate=\"SUBSCRIBERS_ACTIVE\">Active</span></div>\n</th><th class=\"secondary-text\" style=\"text-align: center\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"APP_CLONE\">Clone</span></div></th><th class=\"secondary-text\" style=\"text-align: center\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"APP_SEND_SMS\" ng-if=\"vm.showSms\">Send SMS</span></div></th>\n<th class=\"secondary-text\" ng-if=\"vm.showBlockRelease && vm.maxLoginRetries != 0\" style=\"text-align: center\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"APP_RELEASE\">Release</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.allowDelete\" style=\"text-align: center\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"APP_REMOVE\">Delete</span></div></th></tr></thead><tbody><tr \ntitle=\"{{vm.showId ? subscriber._id : \'\'}}\" \ndir-paginate=\"subscriber in vm.subData.items |itemsPerPage:vm.recordsCount track by subscriber._id\" \ntotal-items=\"vm.subData.totalItems\" ng-class-odd=\"\'odd\'\"><td \nng-if=\"!vm.showBlockRelease || !subscriber.isLock || vm.maxLoginRetries == 0\" width=\"15%\" class=\"table-name-label\" \nng-click=\"vm.editSubscriber(subscriber._id)\">{{::subscriber.name}}</td><td \nng-if=\"vm.showBlockRelease && subscriber.isLock && vm.maxLoginRetries != 0\" style=\"color: red\" width=\"15%\" \nclass=\"table-name-label\" ng-click=\"vm.editSubscriber(subscriber._id)\">{{::subscriber.name}}</td><td width=\"20%\" \nclass=\"table-name-label\" ng-if=\"vm.showId\" ng-click=\"vm.editSubscriber(subscriber._id)\">{{::subscriber._id}}</td><td \nwidth=\"20%\" class=\"table-name-label\" ng-click=\"vm.editSubscriber(subscriber._id)\">{{::subscriber.sip}}</td><td \nwidth=\"15%\" class=\"table-name-label\" ng-click=\"vm.editSubscriber(subscriber._id)\">{{::subscriber.imsi}}</td><td \nwidth=\"15%\" class=\"table-name-label\" ng-if=\"vm.showIMSI2\" ng-click=\"vm.editSubscriber(subscriber._id)\">\n{{::subscriber.imsi2}}</td><td width=\"10%\" class=\"align-center\"><md-checkbox class=\"green-or-red\" \naria-label=\"checkbox\" ng-model=\"subscriber.admin_state\" ng-true-value=\"0\" ng-false-value=\"1\" \nng-disabled=\"!vm.allowChangeState\" ng-change=\"vm.changeActiveState(subscriber)\"></md-checkbox></td><td width=\"10%\" \nclass=\"align-center\"><md-button class=\"md-icon-button\" aria-label=\"organisation details\" ng-if=\"vm.allowCreate\" \nng-click=\"vm.cloneSubscriber(subscriber._id)\" translate translate-attr-aria-label=\"APP_CLONE\"><i \nclass=\"icon-content-copy s16 content-copy\"></i></md-button></td><td width=\"10%\" class=\"align-center\"><md-button \nclass=\"md-icon-button\" aria-label=\"organisation details\" ng-click=\"vm.openSMSdialog(subscriber)\" \nng-if=\"vm.allowSms && vm.isMobileUser(subscriber._id, subscriber.phone_number) && vm.showSms\" translate \ntranslate-attr-aria-label=\"APP_SEND_SMS\"><md-icon md-font-icon=\"icon-message-text-outline\" class=\"fas fa-message\">\n</md-icon></md-button></td><td width=\"10%\" \nng-if=\"vm.showBlockRelease && !subscriber.isLock && vm.maxLoginRetries != 0\" class=\"align-center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.blockSubscriber(subscriber)\" translate translate-attr-aria-label=\"APP_RELEASE\">\n<md-icon md-font-icon=\"icon-lock-unlocked-outline\"></md-icon></md-button></td><td width=\"10%\" \nng-if=\"vm.showBlockRelease && subscriber.isLock && vm.maxLoginRetries != 0\" class=\"align-center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.releaseSubscriber(subscriber)\" translate translate-attr-aria-label=\"APP_RELEASE\">\n<md-icon md-font-icon=\"icon-lock-outline\" style=\"color: red\"></md-icon></md-button></td><td class=\"align-center\">\n<md-button class=\"remove-button md-icon-button\" aria-label=\"organisation details\" ng-if=\"vm.allowDelete\" \nng-click=\"vm.removeSubscriber(subscriber._id)\" translate translate-attr-aria-label=\"APP_REMOVE\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table></div><md-content \nng-if=\"!vm.subData.items.length\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\" ng-if=\"!vm.organizationId\"><div class=\"reseller-manager page-layout simple tabbed\"><p \nclass=\"pd-2\" translate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div><div \nclass=\"content-card\"><p class=\"pd-2\" ng-if=\"!vm.showLoader && vm.organizationId\" translate=\"APP_NO_RECORDS\" \ntranslate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" \nflex layout-align=\"flex-start center\"><md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label>\n<md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \nmax-size=\"8\" direction-links=\"true\" boundary-links=\"true\" on-page-change=\"vm.getData(newPageNumber)\">\n</dir-pagination-controls></div></div></div></md-content></div></div>");
$templateCache.put("app/main/restricted/organization/wfm/wfm.html","<div class=\"page-layout carded fullwidth single-scroll reseller-details\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center center flex\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\" translate=\"WFM_TITLE\">WFM</span></div>\n<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\" \nng-if=\"!vm.organizationId\"><div class=\"reseller-manager page-layout simple\"><p class=\"pd-2\" \ntranslate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div></md-content><md-tabs \nmd-dynamic-height md-border-bottom md-selected=\"vm.activeTab\" ng-if=\"vm.organizationId\"><md-tab><md-tab-label><span \ntranslate=\"WFM_USERS_MANAGEMENT\">WFM Users</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/wfm/tabs/wfm-users.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"WFM_INCIDENCES\">WFM Incidenses</span></md-tab-label><md-tab-body><md-content \nclass=\"pd-2\" ng-include=\"\'app/main/restricted/organization/wfm/tabs/incidence-types.html\'\"></md-content></md-tab-body>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/restricted/platform/client-version/list.html","<div class=\"page-layout carded fullwidth single-scroll ng-scope layout-row\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center flex\" flex=\"\"><div class=\"header\"><md-button \nclass=\"add-button md-fab md-warn\" ng-click=\"vm.addClientVersion()\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CLIENT_VERSION_ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content-card\"><div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div><span class=\"h2 new\" \ntranslate=\"CLIENT_VERSION_TITLE\" translate-default=\"Client Version\" flex layout-align=\"center\"></span></div><table \nclass=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'name\')\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" \ntranslate=\"CLIENT_VERSION_STORE_NAME\" translate-default=\"Store Name\"></span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sort(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'version\')\" translate=\"CLIENT_VERSION_VERSION\" translate-default=\"Version\"></span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Remove\n</span></div></th></tr></thead><tbody><tr title=\"{{vm.showId ? clientVersion._id : \'\'}}\" \ndir-paginate=\"clientVersion in vm.clientVersions|searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td width=\"30%\" class=\"table-name-label\" ng-click=\"vm.editClientVersion(clientVersion)\">\n{{clientVersion.name}}</td><td width=\"100%\" class=\"table-name-label\" ng-click=\"vm.editClientVersion(clientVersion)\">\n{{clientVersion.version}}</td><td><md-button class=\"edit-button md-icon-button\" aria-label=\"organisation details\" \ntranslate translate-attr-aria-label=\"APP_REMOVE\" ng-click=\"vm.deleteClientVersion(clientVersion._id)\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content \nng-if=\"!vm.clientVersions.length\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\"><p class=\"pd-2\" translate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div>\n</md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option \nng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"end center\"><dir-pagination-controls max-size=\"1\" direction-links=\"true\" \nboundary-links=\"true\"></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/main/restricted/platform/config/list.html","<div class=\"page-layout carded fullwidth single-scroll reseller-details\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center center flex\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\" translate=\"NAVIGATION_ITO_CONFIG\">\nITO Config</span></div><md-tabs md-dynamic-height md-border-bottom><md-tab><md-tab-label><span translate=\"APP_CUSTOM\">\nCustom</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/platform/config/tabs/custom/custom.list.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"SITE_TITLE\">Sites</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/platform/config/tabs/site/site.list.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"SERVER_TITLE\">Servers</span></md-tab-label><md-tab-body><md-content \nclass=\"pd-2\" ng-include=\"\'app/main/restricted/platform/config/tabs/server/server.list.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.isRootAdmin && vm.showSecondarySite\"><md-tab-label><span \ntranslate=\"SECONDARY_SITE_TITLE\">Secondary Site Configuration</span></md-tab-label><md-tab-body><md-content \nclass=\"pd-2\" ng-include=\"\'app/main/restricted/platform/config/tabs/secondary_site/secondary_site.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"LICENSE_VIEW\">License Information</span></md-tab-label>\n<md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/platform/config/tabs/license_view/license.view.html\'\"></md-content></md-tab-body>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/restricted/platform/devices/list.html","<div class=\"page-layout carded fullwidth single-scroll ng-scope layout-row\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center flex\" flex=\"\"><div class=\"header\"><md-button \nclass=\"add-button md-fab md-warn\" ng-click=\"vm.addDevice()\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"DEVICE_ADD\" ng-hide=\"::vm.isActionNotAllowed(\'device_resource\', \'POST\')\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content-card\"><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\">\n</md-input-container></div><span class=\"h2 new\" translate=\"DEVICE_TITLE\" flex layout-align=\"center\">Devices</span>\n</div><table class=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sort(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" \ntranslate=\"DEVICE_MODEL\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div></th></tr></thead><tbody><tr \ntitle=\"{{vm.showId ? device._id : \'\'}}\" \ndir-paginate=\"device in vm.devicesList|searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td width=\"100%\" class=\"table-name-label\" ng-click=\"vm.editDevice(device)\">{{device.name}}</td>\n<td><md-button class=\"edit-button md-icon-button\" aria-label=\"organisation details\" translate \ntranslate-attr-aria-label=\"APP_REMOVE\" ng-click=\"vm.deleteDevice(device._id)\" \nng-hide=\"::vm.isActionNotAllowed(\'device_resource\', \'DELETE\')\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\">\n</md-icon></md-button></td></tr></tbody></table><md-content ng-if=\"!vm.devicesList.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex \nclass=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"><md-input-container><label \ntranslate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" \nplaceholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option \nng-value=\"100\">100</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\">\n<dir-pagination-controls max-size=\"1\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</div></div></div></div>");
$templateCache.put("app/main/restricted/platform/devices-manufacturers/devices.manufacturers.html","<div class=\"page-layout carded fullwidth single-scroll\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\" flex=\"\"><div class=\"header\"><md-button class=\"add-button md-fab md-warn\" \nng-click=\"vm.addDeviceM()\" aria-label=\"Add event\" translate translate-attr-aria-label=\"DM.ADD_ORGANIZATION\" \nng-hide=\"::vm.isActionNotAllowed(\'manufacturer_resource\', \'POST\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><div class=\"content-card\" flex><div class=\"toolbar layout-align-start-center layout-row\" \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div><span class=\"h2 new\" flex \nlayout-align=\"center\" translate=\"MANUFACTURER_TITLE\">Device Manufacturers</span></div><table \nclass=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'name\')\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" transalte=\"APP_NAME\">Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">\nRemove</span></div></th></tr></thead><tbody><tr title=\"{{vm.showId ? deviceM._id : \'\'}}\" \ndir-paginate=\"deviceM in vm.deviceMs|searchByName :vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td width=\"100%\" class=\"table-name-label\" ng-click=\"vm.editDeviceM(deviceM)\">{{deviceM.name}}</td>\n<td><md-button class=\"delete-button md-icon-button\" aria-label=\"remove button\" translate \ntranslate-attr-aria-label=\"APP_REMOVE\" ng-click=\"vm.deleteDeviceM(deviceM._id)\" \nng-hide=\"::vm.isActionNotAllowed(\'manufacturer_resource\', \'DELETE\')\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content ng-if=\"!vm.deviceMs.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex \nclass=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"><md-input-container><label \ntranslate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" \nplaceholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option \nng-value=\"100\">100</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\">\n<dir-pagination-controls max-size=\"1\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</div></div></div></div>");
$templateCache.put("app/main/restricted/platform/job/job.html","<div class=\"page-layout carded fullwidth single-scroll tabbed job-manager\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center content flex\" flex><div class=\"header\"><span class=\"h2 white-fg\" translate=\"JOB_TITLE\">Jobs</span></div>\n<md-content class=\"content _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><div \nclass=\"page-layout simple layout-row\" flex=\"97\" layout=\"row\" layout-align=\"end center\"><md-button md-no-ink \nclass=\"md-primary\" ng-click=\"vm.runJob(1)\" aria-label=\"\" translate=\"JOB_RUN_INTEGRITY\">Run DB Integrity Job</md-button>\n<md-button md-no-ink class=\"md-primary\" ng-click=\"vm.runJob(2)\" aria-label=\"\" translate=\"JOB_RUN_EXPIRATION\">\nRun License Expiration Job</md-button></div></div></md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nmd-on-select=\"vm.getProvisioningLogs()\"><md-tab-label><span translate=\"JOB_PROVISIONING\">Provisioning</span>\n</md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/platform/job/tabs/provisioning.html\'\"></md-content></md-tab-body></md-tab><md-tab \nmd-on-select=\"vm.getGpsLogs()\"><md-tab-label><span translate=\"JOB_GPS\">GPS archiver</span></md-tab-label><md-tab-body>\n<md-content class=\"pd-2\" ng-include=\"\'app/main/restricted/platform/job/tabs/gps.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.getMongoLogs()\"><md-tab-label><span translate=\"JOB_MONGO_HA\">Mongo High Availability\n</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/platform/job/tabs/mongo.html\'\"></md-content></md-tab-body></md-tab></md-tabs></div>\n</div>");
$templateCache.put("app/main/restricted/platform/licenses/license.html","<div class=\"page-layout carded fullwidth single-scroll tabbed reseller-details\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center content flex\" flex><div class=\"header\"><span class=\"h2 white-fg\" translate=\"LICENSE_TITLE\">License\n</span></div><md-tabs md-dynamic-height md-border-bottom><md-tab><md-tab-label><span translate=\"LICENSE_TEMPLATES\">\nLicense templates</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/platform/licenses/tabs/templates/licenses.templates.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab><md-tab-label><span translate=\"APP_CONVERT\">License convert</span></md-tab-label><md-tab-body>\n<md-content class=\"pd-2\" ng-include=\"\'app/main/restricted/platform/licenses/tabs/convert/license.convert.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/restricted/platform/localization/localization.html","<div class=\"page-layout carded fullwidth single-scroll\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\" flex=\"\"><div class=\"header\"><md-button class=\"add-button md-fab md-warn\" \nng-click=\"vm.addTranslation()\" aria-label=\"Add event\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n<div class=\"content-card\" flex><div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div><span class=\"h2 new\" flex \nlayout-align=\"center\" translate=\"LOCALIZATION_TITLE\">Localization</span></div><table \nclass=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'title\')\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'title\')\" translate=\"LOCALIZATION_NAME\">\nName</span></div></th><th class=\"secondary-text\" ng-click=\"vm.sort(\'code\')\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-class=\"vm.getSortingClass(\'code\')\" translate=\"LOCALIZATION_CODE\">Code</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'active\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'active\')\" translate=\"LOCALIZATION_ACTIVE\">Active</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'active\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'active\')\" translate=\"LOCALIZATION_DEFAULT\">Default</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Remove</span></div>\n</th></tr></thead><tbody><tr \ndir-paginate=\"language in vm.languages |searchByTitle:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td width=\"20%\" ng-click=\"vm.editTranslation(language)\" class=\"table-name-label\" ng-click=\"\">\n{{language.title}}</td><td width=\"20%\" ng-click=\"vm.editTranslation(language)\">{{language.code}}</td><td width=\"20%\" \nclass=\"table-name-label\"><md-checkbox aria-label=\"checkbox\" ng-model=\"language.active\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-change=\"vm.changeActiveState(language)\"></md-checkbox></td><td width=\"100%\" \nclass=\"table-name-label\"><md-checkbox aria-label=\"checkbox\" ng-model=\"language.default\" \nng-change=\"vm.changeDefault(language)\"></md-checkbox></td><td><md-button class=\"delete-button md-icon-button\" \ntranslate translate-attr-aria-label=\"LICENSE.DELETE\" ng-click=\"vm.deleteTranslation(language)\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content \nng-if=\"!vm.languages\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\"><p class=\"pd-2\" translate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div>\n</md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option \nng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"end center\"><dir-pagination-controls max-size=\"1\" direction-links=\"true\" \nboundary-links=\"true\"></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/main/restricted/platform/move-organization/move.organization.html","<div class=\"page-layout carded fullwidth single-scroll tabbed reseller-details\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center content flex\" flex><div class=\"header\"><span class=\"h2 white-fg\" \ntranslate=\"NAVIGATION_MOVEORGANIZATION\">Migration</span></div><md-tabs md-dynamic-height md-border-bottom><md-tab>\n<md-tab-label><span translate=\"TRANSFER_RESELLER\">Transfer Reseller</span></md-tab-label><md-tab-body><md-content \nclass=\"pd-2\" ng-include=\"\'app/main/restricted/platform/move-organization/tabs/resellerMove/resellermove.html\'\">\n</md-content></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"TRANSFER_ORGANIZATION\">Transfer Organization\n</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/platform/move-organization/tabs/organizationMove/organizationmove.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/restricted/platform/ptt-client-store/list.html","<div class=\"page-layout carded fullwidth single-scroll ng-scope layout-row\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center flex\" flex=\"\"><div class=\"header\"><md-button \nclass=\"add-button md-fab md-warn\" ng-click=\"vm.addStore()\" aria-label=\"Add event\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><div class=\"content-card\"><div class=\"toolbar layout-align-start-center layout-row\" \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div><span class=\"h2 new\" flex \nlayout-align=\"center\" translate=\"STORE_TITLE\">PTT client store</span></div><table \nclass=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'name\')\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" translate=\"DEVICE_MODEL\">Name\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"APP_REMOVE\">Actions</span></div></th></tr></thead><tbody><tr title=\"{{vm.showId ? store._id : \'\'}}\" \ndir-paginate=\"store in vm.storeList|searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td width=\"100%\" class=\"table-name-label\" ng-click=\"vm.editStore(store)\">{{store.name}}</td><td>\n<md-button class=\"edit-button md-icon-button\" aria-label=\"organisation details\" translate \ntranslate-attr-aria-label=\"AR.DELETE\" ng-click=\"vm.deleteStore(store._id)\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content ng-if=\"!vm.storeList.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular ng-if=\"vm.showLoader\" class=\"md-accent md-hue-1\" md-diameter=\"40\">\n</md-progress-circular></div></md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex \nlayout-align=\"flex-start center\"><md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select \nng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option ng-value=\"25\">25\n</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls max-size=\"1\" \ndirection-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/main/restricted/platform/ptt-devices/list.html","<div class=\"page-layout carded fullwidth single-scroll ng-scope layout-row\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center flex\" flex=\"\"><div class=\"header\"><md-button \nclass=\"add-button md-fab md-warn\" ng-click=\"vm.addDevice()\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"DEVICE_ADD\" ng-hide=\"::vm.isActionNotAllowed(\'device_resource\', \'POST\')\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content-card\"><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\">\n</md-input-container></div><span class=\"h2 new\" flex layout-align=\"center\" translate=\"PTT_DEVICE_TITLE\">PTT Devices\n</span></div><table class=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sort(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" \ntranslate=\"PTT_DEVICE_NAME\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div></th></tr></thead><tbody><tr \ntitle=\"{{vm.showId ? device._id : \'\'}}\" \ndir-paginate=\"device in vm.devicesList |searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td width=\"100%\" class=\"table-name-label\" ng-click=\"vm.editDevice(device)\">{{device.name}}</td>\n<td><md-button class=\"edit-button md-icon-button\" aria-label=\"organisation details\" translate \ntranslate-attr-aria-label=\"AR.DELETE\" ng-click=\"vm.deleteDevice(device._id)\" \nng-hide=\"::vm.isActionNotAllowed(\'device_resource\', \'DELETE\')\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\">\n</md-icon></md-button></td></tr></tbody></table><md-content ng-if=\"!vm.devicesList.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular ng-if=\"vm.showLoader\" class=\"md-accent md-hue-1\" md-diameter=\"40\">\n</md-progress-circular></div></md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex \nlayout-align=\"flex-start center\"><md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select \nng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option ng-value=\"25\">25\n</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls max-size=\"1\" \ndirection-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/main/restricted/platform/report/report.html","<div class=\"page-layout carded fullwidth single-scroll tabbed reseller-details\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center content flex\" flex><div class=\"header\"><span class=\"h2 white-fg\" translate=\"REPORT_TITLE\">Report\n</span></div><md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><md-card style=\"width: 700px\">\n<md-card-header><md-card-header-text><span class=\"md-title\" translate=\"BULK_RESULT_LOG\">Result Log</span>\n</md-card-header-text></md-card-header><md-content-card style=\"max-height: 200px; overflow-y: auto\"><p>{{vm.resultLog}}\n</p><p ng-repeat=\"error in vm.errorLog track by $index\">{{error}}</p></md-content-card></md-card><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"row\" layout-align=\"margin-right\" flex=\"30\"><label><input type=\"radio\" \nng-model=\"vm.exportTypeBillingReport\" id=\"vm.exportTypeBillingReport\" value=\"csv\" ng-disabled=\"vm.loading\">CSV</label>\n<label><input type=\"radio\" ng-model=\"vm.exportTypeBillingReport\" id=\"vm.exportTypeBillingReport\" value=\"excel\" \nng-disabled=\"vm.loading\">Excel</label><md-button class=\"md-raised md-accent\" \nstyle=\"min-width: min-content; width: -webkit-fill-available\" ng-disabled=\"vm.loading\" ng-csv=\"vm.getBillingReport()\" \nlazy-load=\"true\" add-bom=\"true\" \ncsv-header=\"[\'Phone#\',\'License\',\'ConcurrentChannels\',\'Recording\',\'Encryption\',\'IsWFMUSER\',\'IsLWUser\',\'VideoEnable\',\'DebriefCenterCapability\',\'ManDown\',\'Kiosk\',\'AdminState\',\'Demo\',\'DemoExpirationDate(YYYY/MM/DD)\',\'CreationTime(YYYY/MM/DD HH:MI:SS)\',\'OrgCRMID\',\'OrgName\',\'Reseller\',\'LastRegistration(YYYY/MM/DD)\', \'ChangeStateTime(YYYY/MM/DD HH:MI:SS)\']\" \nfilename=\"{{vm.timestamp| date:\'dd-MMM-yyyy_HH-mm-ss\'}}-BillingReport.csv\"><label translate=\"BILLING_REPORT_EXPORT\">\nExport Billing Report</label></md-button></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"row\" \nlayout-align=\"margin-right\" flex=\"30\"><label><input type=\"radio\" ng-model=\"vm.exportTypeUsersReport\" \nid=\"vm.exportTypeUsersReport\" value=\"csv\" ng-disabled=\"vm.loading\">CSV</label><label><input type=\"radio\" \nng-model=\"vm.exportTypeUsersReport\" id=\"vm.exportTypeUsersReport\" value=\"excel\" ng-disabled=\"vm.loading\">Excel</label>\n<md-button class=\"md-raised md-accent\" style=\"min-width: min-content; width: -webkit-fill-available\" \nng-disabled=\"vm.loading\" ng-csv=\"vm.getSystemUsersReport()\" lazy-load=\"true\" add-bom=\"true\" \ncsv-header=\"[\'Phone#\',\'Name\',\'OrgCRMID\',\'OrgName\',\'Reseller\',\'License\',\'ConcurrentChannels\',\'Recording\',\'AdminState\',\'ProtocolVersion\',\'AppVersion\',\'State\',\'ClientType\',\'DeviceModel\',\'APILevel\',\'FWversion\',\'CreationTime(YYYY/MM/DD HH:MI:SS)\',\'LastRegistration(YYYY/MM/DD)\', \'ChangeStateTime(YYYY/MM/DD HH:MI:SS)\']\" \nfilename=\"{{vm.timestamp| date:\'dd-MMM-yyyy\'}}-SystemUsersReport.csv\"><label translate=\"SYSTEM_USERS_REPORT_EXPORT\">\nExport System Users Report</label></md-button></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"row\" \nlayout-align=\"margin-right\" flex=\"30\"><label><input type=\"radio\" ng-model=\"vm.exportTypeRecordingAdminReport\" \nid=\"vm.exportTypeRecordingAdminReport\" value=\"csv\" ng-disabled=\"vm.loading\">CSV</label><label><input type=\"radio\" \nng-model=\"vm.exportTypeRecordingAdminReport\" id=\"vm.exportTypeRecordingAdminReport\" value=\"excel\" \nng-disabled=\"vm.loading\">Excel</label><md-button class=\"md-raised md-accent\" \nstyle=\"min-width: min-content; width: -webkit-fill-available\" ng-disabled=\"vm.loading\" \nng-csv=\"vm.getRecordingAdminReport()\" lazy-load=\"true\" add-bom=\"true\" \ncsv-header=\"[\'RecordingAdmin\', \'OrganizationName\', \'OrganizationID\', \'Reseller\']\" \nfilename=\"{{vm.timestamp| date:\'dd-MMM-yyyy_HH-mm-ss\'}}-RecordingAdminsReport.csv\"><label \ntranslate=\"BULK_EXPORT_ADMIN_RECORDS\">Export Recording Admins Report</label></md-button></div></md-content></div></div>\n</md-content></div></div>");
$templateCache.put("app/main/restricted/platform/software-manufacturers/software.manufacturers.html","<div class=\"page-layout carded fullwidth single-scroll\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\" flex=\"\"><div class=\"header\"><md-button class=\"add-button md-fab md-warn\" \nng-click=\"vm.addSoftwareM()\" aria-label=\"Add event\" ng-hide=\"::vm.isActionNotAllowed(\'manufacturer_resource\', \'POST\')\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content-card\" flex><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\">\n</md-input-container></div><span class=\"h2 new\" flex layout-align=\"center\" translate=\"SOFTWARE_MANUFACTURERS_TITLE\">\nSoftware Manufacturers</span></div><table class=\"dataTable row-border stripe hover\"><thead><tr><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'name\')\" translate=\"APP_NAME\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">REMOVE</span></div></th></tr></thead><tbody><tr \ntitle=\"{{vm.showId ? softwareM._id : \'\'}}\" \ndir-paginate=\"softwareM in vm.softwareMs|searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td width=\"100%\" class=\"table-name-label\" ng-click=\"vm.editSoftwareM(softwareM)\">\n{{softwareM.name}}</td><td><md-button class=\"delete-button md-icon-button\" aria-label=\"delete item\" translate \ntranslate-attr-aria-label=\"SM.DELETE\" ng-click=\"vm.deleteSoftwareM(softwareM._id)\" \nng-hide=\"::vm.isActionNotAllowed(\'manufacturer_resource\', \'DELETE\')\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content ng-if=\"!vm.softwareMs.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular ng-if=\"vm.showLoader\" class=\"md-accent md-hue-1\" md-diameter=\"40\">\n</md-progress-circular></div></md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex \nlayout-align=\"flex-start center\"><md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select \nng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option ng-value=\"25\">25\n</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls max-size=\"1\" \ndirection-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/main/restricted/reseller/organization-manager/organization.manager.html","<div class=\"page-layout carded fullwidth single-scroll\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\" flex=\"\"><div class=\"header\"><md-button \nng-hide=\"::vm.isActionNotAllowed(\'organization_resource\', \'POST\')\" class=\"add-button md-fab md-warn\" \nng-disabled=\"!vm.checkResellerContext() || !vm.allowCreate\" ng-click=\"vm.addOrganization()\" aria-label=\"Add event\" \ntranslate translate-attr-aria-label=\"OM.ADD_ORGANIZATION\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><div class=\"content-card\" flex><div class=\"popup-wrapper\" ng-class=\"vm.popupOverlayClass\"></div><md-content \nng-if=\"!vm.showLoader && !vm.checkResellerContext()\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><div \nclass=\"page-layout\"><p class=\"pd-2\" style=\"margin-left:20px\" translate=\"RESELLER_CONTEXT_WARNING\">\nPlease switch to reseller context</p></div></div></md-content><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.showLicenseAllocation\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div><span class=\"h2 new\" \ntranslate=\"ORGANIZATION_MANAGER\" flex layout-align=\"center\">Organization Manager</span></div><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.showLicenseAllocation\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container><div layout=\"row\" \nclass=\"layout-align-start-left layout-row\" flex><h1 class=\"h2\" layout-align=\"left\" translate=\"ORGANIZATION_MANAGER\">\nOrganization Manager</h1></div></div><div layout=\"row\" layout-align=\"margin-right\"><md-input-container \nng-if=\"vm.showLicenseAllocation && vm.reseller.availble_qty > 0\"><label translate=\"RESELLER_QTY\">qty</label><input \ntype=\"text\" name=\"qty\" ng-model=\"vm.qty\" id=\"qty\" ng-disabled=\"true\" translate><md-tooltip><span \ntranslate=\"LICENSE_QTY_TOOLTIP\">Number of licenses in use out of allocated licenses of this type</span></md-tooltip>\n</md-input-container><md-input-container ng-if=\"vm.showLicenseAllocation && !(vm.reseller.availble_qty > 0)\"><label \ntranslate=\"RESELLER_QTY\" style=\"color: red\">qty</label><input type=\"text\" style=\"color: red\" name=\"qty\" \nng-model=\"vm.qty\" id=\"qty\" ng-disabled=\"true\" translate><md-tooltip><span translate=\"LICENSE_QTY_TOOLTIP\">\nNumber of licenses in use out of allocated licenses of this type</span></md-tooltip></md-input-container>\n<md-input-container ng-if=\"vm.showLicenseAllocation && vm.reseller.dispatcher_availble_qty > 0\"><label \ntranslate=\"RESELLER_DISPATCHER_QTY\">Dispatcher qty</label><input type=\"text\" name=\"qty\" ng-model=\"vm.dispatcherqty\" \nid=\"qty\" ng-disabled=\"true\" translate><md-tooltip><span translate=\"LICENSE_QTY_TOOLTIP\">\nNumber of licenses in use out of allocated licenses of this type</span></md-tooltip></md-input-container>\n<md-input-container ng-if=\"vm.showLicenseAllocation && !(vm.reseller.dispatcher_availble_qty > 0)\"><label \ntranslate=\"RESELLER_DISPATCHER_QTY\" style=\"color: red\">Dispatcher qty</label><input type=\"text\" style=\"color: red\" \nname=\"qty\" ng-model=\"vm.dispatcherqty\" id=\"qty\" ng-disabled=\"true\" translate><md-tooltip><span \ntranslate=\"LICENSE_QTY_TOOLTIP\">Number of licenses in use out of allocated licenses of this type</span></md-tooltip>\n</md-input-container></div></div><table ng-show=\"vm.checkResellerContext()\" class=\"dataTable row-border stripe hover\">\n<thead><tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'name\')\" translate=\"ORGANIZATION_NAME\">Organization name</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'crmId\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'crmId\')\" translate=\"ORGANIZATION_CRMID\">CRMID</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'type\')\" ng-if=\"vm.showDemoOrganization\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-class=\"vm.getSortingClass(\'type\')\" translate=\"ORGANIZATION_DEMO\">Demo</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'creation_time\')\" ng-if=\"vm.showDemoOrganization\"><div class=\"table-header\">\n<span class=\"column-title\" ng-class=\"vm.getSortingClass(\'creation_time\')\" translate=\"ORGANIZATION_CREATION_TIME\">\nCreation Time</span></div></th><th class=\"secondary-text\" ng-click=\"vm.sort(\'demo_expiration\')\" \nng-if=\"vm.showDemoOrganization\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'demo_expiration\')\" translate=\"ORGANIZATION_DEMO_EXPIRATION\">Demo Expiration</span></div>\n</th><th class=\"secondary-text\" ng-if=\"vm.showLicenseAllocation\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORGANIZATION_QTY\">QTY</span></div></th><th class=\"secondary-text\" ng-if=\"vm.showLicenseAllocation\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_ALLOCATE\">Allocate</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.showLicenseAllocation\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ORGANIZATION_DISPATCHER_QTY\">DISPATCHER QTY</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.showLicenseAllocation\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LICENSE_DISPATCHER_ALLOCATE\">Allocate</span></div></th><th class=\"secondary-text\" ng-if=\"vm.allowDelete\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div></th></tr></thead>\n<tbody><tr \ndir-paginate=\"organisation in vm.organisations|searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\" pagination-id=\"organizationManager\"><td title=\"{{vm.showId ? organisation._id : \'\'}}\" \nclass=\"table-name-label\" ng-click=\"vm.editOrganization(organisation._id)\" \nng-if=\"vm.showLicenseAllocation || vm.showDemoOrganization\">{{organisation.name}}</td><td \ntitle=\"{{vm.showId ? organisation._id : \'\'}}\" class=\"table-name-label\" \nng-click=\"vm.editOrganization(organisation._id)\" ng-if=\"vm.showLicenseAllocation || vm.showDemoOrganization\">\n{{organisation.crmId}}</td><td title=\"{{vm.showId ? organisation._id : \'\'}}\" width=\"25%\" class=\"table-name-label\" \nng-click=\"vm.editOrganization(organisation._id)\" ng-if=\"!vm.showLicenseAllocation && !vm.showDemoOrganization\">\n{{organisation.name}}</td><td title=\"{{vm.showId ? organisation._id : \'\'}}\" width=\"100%\" class=\"table-name-label\" \nng-click=\"vm.editOrganization(organisation._id)\" ng-if=\"!vm.showLicenseAllocation && !vm.showDemoOrganization\">\n{{organisation.crmId}}</td><td class=\"table-name-label\" ng-if=\"vm.showDemoOrganization\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s16\" ng-if=\"organisation.type == 1\"></md-icon></td><td class=\"table-name-label\" \nng-if=\"vm.showDemoOrganization\">{{organisation.creation_time | date:\'dd-MMM-yyyy HH:mm:ss\'}}</td><td \nclass=\"table-name-label\" ng-if=\"vm.showDemoOrganization\">{{organisation.demo_expiration | date:\'dd-MMM-yyyy\'}}</td><td \nclass=\"table-name-label\" ng-if=\"vm.showLicenseAllocation\"><md-tooltip><span translate=\"LICENSE_QTY_TOOLTIP\">\nNumber of licenses in use out of allocated licenses of this type</span></md-tooltip>\n{{organisation.qty - organisation.availble_qty}}/{{organisation.qty}}</td><td ng-if=\"vm.showLicenseAllocation\">\n<md-input-container><input aria-label=\"license qty\" ng-change=\"vm.checkAvailableQuantity()\" \nng-model=\"organisation.setQty\" type=\"number\" name=\"quantity\" ng-min=\"-organisation.availble_qty\" \nng-max=\"vm.allocateLimit\" ng-pattern=\"/^-?[0-9][^\\.]*$/\"></md-input-container><md-button class=\"allocation-button\" \nng-click=\"vm.applyAllocation(organisation)\" ng-disabled=\"!organisation.setQty || organisation.disableUserButton\" \ntranslate=\"LICENSE_ALLOCATE_BUTTON\">Allocate</md-button></td><td class=\"table-name-label\" \nng-if=\"vm.showLicenseAllocation\"><md-tooltip><span translate=\"LICENSE_QTY_TOOLTIP\">\nNumber of licenses in use out of allocated licenses of this type</span></md-tooltip>\n{{organisation.dispatcher_qty - organisation.dispatcher_availble_qty}}/{{organisation.dispatcher_qty}}</td><td \nng-if=\"vm.showLicenseAllocation\"><md-input-container><input aria-label=\"license qty\" \nng-change=\"vm.checkDispatcherAvailableQuantity()\" ng-model=\"organisation.setDispatcherQty\" type=\"number\" \nname=\"quantity\" ng-min=\"-organisation.dispatcher_availble_qty\" ng-max=\"vm.allocateDispatcherLimit\" \nng-pattern=\"/^-?[0-9][^\\.]*$/\"></md-input-container><md-button class=\"allocation-button\" \nng-click=\"vm.applyDispatcherAllocation(organisation)\" \nng-disabled=\"!organisation.setDispatcherQty || organisation.disableDispatcherButton\" \ntranslate=\"LICENSE_ALLOCATE_BUTTON\">Allocate</md-button></td><td ng-if=\"vm.allowDelete\"><md-button \nclass=\"delete-button md-icon-button\" translate translate-attr-aria-label=\"ORGANIZATION_DETAILS\" aria-label=\"delete\" \nng-click=\"vm.deleteOrganization(organisation._id)\" \nng-hide=\"::vm.isActionNotAllowed(\'organization_resource\', \'DELETE\')\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content \nng-if=\"vm.checkResellerContext() && !vm.organisations.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex \nclass=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"><md-input-container><label \ntranslate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" \npagination-id=\"organizationManager\" placeholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option \nng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"end center\"><dir-pagination-controls pagination-id=\"organizationManager\" max-size=\"1\" \ndirection-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/main/restricted/reseller/reseller-details/reseller.details.html","<div class=\"page-layout carded fullwidth single-scroll tabbed reseller-details\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center content flex\" flex><div class=\"header\"><span class=\"h2 white-fg\" translate=\"RESELLER_DETAILS\">\nReseller Details</span></div><md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\">\n<div class=\"content-card\" ng-if=\"!vm.reseller._id\"><div class=\"reseller-manager page-layout simple\"><p class=\"pd-2\" \ntranslate=\"RESELLER_CONTEXT_WARNING\">Please choose reseller</p></div></div></md-content><md-tabs md-dynamic-height \nmd-border-bottom ng-if=\"vm.reseller._id\"><md-tab md-on-select=\"vm.onTabChanges(0)\"><md-tab-label><span \ntranslate=\"APP_GENERAL\">General</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/reseller/reseller-manager/details/tabs/general.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.showSms\" md-on-select=\"vm.onTabChanges(3)\"><md-tab-label><span \ntranslate=\"RESELLER_SMS_CONFIGURATION\">Sms Configuration</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/reseller/reseller-manager/details/tabs/sms.configuration.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.showBranding\" md-on-select=\"vm.onTabChanges(2)\"><md-tab-label><span \ntranslate=\"BRANDING_TITLE\">Branding</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/reseller/reseller-manager/details/tabs/branding.details.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs><md-dialog-actions layout=\"row\"><span flex></span><md-button md-no-ink \nclass=\"md-primary\" ng-click=\"vm.saveReseller()\" ng-if=\"!vm.checkTabIndex(2) && vm.reseller._id && vm.allowModify\" \nng-disabled=\"vm.resellerForm.$invalid || vm.resellerContactForm.$invalid || !vm.flagSave\" aria-label=\"\" \ntranslate=\"APP_SAVE\">Save</md-button></md-dialog-actions></div></div>");
$templateCache.put("app/main/restricted/reseller/reseller-details/reseller.details.license.html","<div class=\"content fullpage-datatable\" layout=\"column\" flex><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"add-button md-fab md-warn\" ng-if=\"vm.isRootReseller()\" ng-click=\"vm.addAllocation()\" aria-label=\"Add event\" \ntranslate translate-attr-aria-label=\"SUBSCRIBERS.ADD_SUBSCRIBERS\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sort(\'licenseBundle.name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'licenseBundle.name\')\" translate=\"LICENSE_BUNDLE\">Bundle</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'licenseType\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'licenseType\')\" translate=\"LICENSE_TYPE\">License Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_ALLOCATION_DATE\">\nAllocation Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LICENSE_EXPIRATION_TYPE\">Expiration Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_EXPIRATION_DATE\">Expiration Date</span></div></th>\n<th class=\"secondary-text\" ng-click=\"vm.sort(\'qty\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'qty\')\" translate=\"LICENSE_QUANTITY\">Quantity</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sort(\'availableQty\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'availableQty\')\" translate=\"LICENSE_AVAILABLE_QTY\">Available</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_REVOKE\">Revoke</span>\n</div></th></tr></thead><tbody><tr title=\"{{vm.showId ? item._id : \'\'}}\" \ndir-paginate=\"item in vm.licenses|itemsPerPage:vm.recordsCount track by $index\"><td width=\"20%\" \nclass=\"table-name-label\" ng-click=\"vm.editLicense(item, item._id)\"><b>{{item.licenseBundle.name}}</b></td><td \nwidth=\"20%\">{{item.licenseType}}</td><td width=\"20%\">{{item.allocationDate | date: medium}}</td><td width=\"20%\">\n{{item.expirationType}}</td><td width=\"20%\">{{item.expirationDate | date: medium}}</td><td width=\"10%\">{{item.qty}}\n</td><td width=\"10%\">{{item.availableQty}}</td><td><md-button class=\"remove-button md-icon-button\" \naria-label=\"remove button\" ng-if=\" vm.allowModify\" ng-click=\"vm.revokeAllocation(item._id)\" translate \ntranslate-attr-aria-label=\"APP_REMOVE\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button>\n</td></tr></tbody></table><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option \nng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"end center\"><dir-pagination-controls max-size=\"1\" direction-links=\"true\" \nboundary-links=\"true\"></dir-pagination-controls></div></div></div>");
$templateCache.put("app/main/restricted/reseller/reseller-details/reseller.details.sms.configuration.html","<md-content class=\"content\"><form name=\"vm.resellerForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate=\"\"><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"SMS_SERVICE\">Service</label><md-select name=\"service\" ng-model=\"vm.reseller.sms.service\"><md-option \nng-repeat=\"item in ::vm.services\" ng-value=\"item\">{{item}}</md-option></md-select></md-input-container></div><span>\n</span><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float \nflex=\"100\"><label translate=\"SMS_API_KEY\">Api key</label><input type=\"text\" name=\"apiKey\" \nng-model=\"vm.reseller.sms.apiKey\" aria-invalid=\"true\" md-maxlength=\"40\"></md-input-container></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular ng-if=\"vm.loading\" class=\"md-accent md-hue-1\" \nmd-diameter=\"40\"></md-progress-circular></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label translate=\"SMS_API_SECRET\">\nApi secret</label><input type=\"text\" name=\"name\" ng-model=\"vm.reseller.sms.apiSecret\" aria-invalid=\"true\" \nmd-maxlength=\"20\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\" ng-if=\"vm.reseller.sms.service == \'SMPP3.4\'\"><md-input-container md-no-float \nflex=\"100\"><label translate=\"SMS_IP\">IP</label><input type=\"text\" name=\"apiKey\" ng-model=\"vm.reseller.sms.ip\" \naria-invalid=\"true\" md-maxlength=\"40\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\" ng-if=\"vm.reseller.sms.service == \'SMPP3.4\'\"><md-input-container md-no-float \nflex=\"100\"><label translate=\"SMS_PORT\">Port</label><input type=\"text\" name=\"name\" ng-model=\"vm.reseller.sms.port\" \naria-invalid=\"true\" md-maxlength=\"40\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"SMS_SERVICE\">Service</label><md-select name=\"service\" \nng-model=\"vm.reseller.sms.service\"><md-option ng-repeat=\"item in ::vm.services\" ng-value=\"item\">{{item}}</md-option>\n</md-select></md-input-container></div></form></md-content>");
$templateCache.put("app/main/restricted/reseller/reseller-manager/reseller.manager.html","<div class=\"page-layout carded fullwidth single-scroll\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center flex\" flex=\"\"><div class=\"header\"><md-button class=\"add-button md-fab md-warn\" \nng-click=\"vm.addReseller()\" ng-disabled=\"!vm.checkResellerContext() || !vm.allowCreate\" aria-label=\"Add event\" \ntranslate ng-hide=\"::vm.isActionNotAllowed(\'reseller_resource\', \'POST\')\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><div class=\"content-card\" layout=\"column\" flex><md-content ng-if=\"!vm.checkResellerContext()\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\" \nng-if=\"!vm.checkResellerContext()\"><div class=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" \nstyle=\"margin-left:25px\" translate=\"RESELLER_CONTEXT_WARNING\">Please switch to reseller context</p></div></div>\n</md-content><div class=\"popup-wrapper\" ng-class=\"vm.popupOverlayClass\"></div><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-if=\"!vm.showLicenseAllocation\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div><span class=\"h2 new\" \ntranslate=\"RESELLER_TITLE\" flex layout-align=\"center\">Reseller Manager</span></div><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.showLicenseAllocation\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container><div layout=\"row\" \nclass=\"layout-align-start-left layout-row\" flex><h1 class=\"h2\" layout-align=\"left\" translate=\"RESELLER_TITLE\">\nReseller Manager</h1></div></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\">\n<md-input-container style=\"width: 45%\" ng-if=\"vm.reseller.availble_qty > 0\"><label translate=\"RESELLER_QTY\">qty</label>\n<input type=\"text\" name=\"qty\" ng-model=\"vm.qty\" id=\"qty\" ng-disabled=\"true\" translate><md-tooltip><span \ntranslate=\"LICENSE_QTY_TOOLTIP\">Number of licenses in use out of allocated licenses of this type</span></md-tooltip>\n</md-input-container><md-input-container style=\"width: 45%\" ng-if=\"!(vm.reseller.availble_qty > 0)\"><label \ntranslate=\"RESELLER_QTY\" style=\"color: red\">qty</label><input type=\"text\" style=\"color: red\" name=\"qty\" \nng-model=\"vm.qty\" id=\"qty\" ng-disabled=\"true\" translate><md-tooltip><span translate=\"LICENSE_QTY_TOOLTIP\">\nNumber of licenses in use out of allocated licenses of this type</span></md-tooltip></md-input-container>\n<md-input-container style=\"width: 45%\" ng-if=\"vm.reseller.dispatcher_availble_qty > 0\"><label \ntranslate=\"RESELLER_DISPATCHER_QTY\">Dispatcher qty</label><input type=\"text\" name=\"dispatcher_qty\" \nng-model=\"vm.dispatcherqty\" id=\"dispatcher_qty\" ng-disabled=\"true\" translate><md-tooltip><span \ntranslate=\"LICENSE_QTY_TOOLTIP\">Number of licenses in use out of allocated licenses of this type</span></md-tooltip>\n</md-input-container><md-input-container style=\"width: 45%\" ng-if=\"!(vm.reseller.dispatcher_availble_qty > 0)\"><label \ntranslate=\"RESELLER_DISPATCHER_QTY\" style=\"color: red\">Dispatcher qty</label><input type=\"text\" style=\"color: red\" \nname=\"dispatcher_qty\" ng-model=\"vm.dispatcherqty\" id=\"dispatcher_qty\" ng-disabled=\"true\" translate><md-tooltip><span \ntranslate=\"LICENSE_QTY_TOOLTIP\">Number of licenses in use out of allocated licenses of this type</span></md-tooltip>\n</md-input-container></div></div><table ng-hide=\"!vm.checkResellerContext()\" class=\"dataTable row-border hover stripe\">\n<thead><tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'name\')\" translate=\"RESELLER_NAME\">Name</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sort(\'crmId\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'crmId\')\" translate=\"RESELLER_CRMID\">CRMID</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.showLicenseAllocation\"><div class=\"table-header\"><span class=\"column-title\" translate=\"RESELLER_QTY\">QTY\n</span></div></th><th class=\"secondary-text\" ng-if=\"vm.showLicenseAllocation\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"LICENSE_ALLOCATE\">Allocate</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.showLicenseAllocation\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"RESELLER_DISPATCHER_QTY\">DISPATCHER QTY</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.showLicenseAllocation\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LICENSE_DISPATCHER_ALLOCATE\">Dispatcher Allocate</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.allowDelete\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div>\n</th></tr></thead><tbody><tr \ndir-paginate=\"reseller in vm.resellers|searchByName :vm.search |itemsPerPage:vm.recordsCount track by $index\" \npagination-id=\"resellerManager\" ng-class-odd=\"\'odd\'\"><td title=\"{{vm.showId ? reseller._id : \'\'}}\" \nclass=\"table-name-label\" ng-click=\"vm.editReseller(reseller._id)\" ng-if=\"vm.showLicenseAllocation\">{{reseller.name}}\n</td><td title=\"{{vm.showId ? reseller._id : \'\'}}\" class=\"table-name-label\" ng-click=\"vm.editReseller(reseller._id)\" \nng-if=\"vm.showLicenseAllocation\">{{reseller.crmId}}</td><td title=\"{{vm.showId ? reseller._id : \'\'}}\" width=\"25%\" \nclass=\"table-name-label\" ng-click=\"vm.editReseller(reseller._id)\" ng-if=\"!vm.showLicenseAllocation\">{{reseller.name}}\n</td><td title=\"{{vm.showId ? reseller._id : \'\'}}\" width=\"100%\" class=\"table-name-label\" \nng-click=\"vm.editReseller(reseller._id)\" ng-if=\"!vm.showLicenseAllocation\">{{reseller.crmId}}</td><td \nclass=\"table-name-label\" ng-if=\"vm.showLicenseAllocation\"><md-tooltip><span translate=\"LICENSE_QTY_TOOLTIP\">\nNumber of licenses in use out of allocated licenses of this type</span></md-tooltip>\n{{reseller.qty - reseller.availble_qty}} / {{reseller.qty}}</td><td ng-if=\"vm.showLicenseAllocation\">\n<md-input-container><input aria-label=\"license qty\" ng-change=\"vm.checkAvailableQuantity()\" ng-model=\"reseller.setQty\" \ntype=\"number\" name=\"quantity\" ng-min=\"-reseller.availble_qty\" ng-max=\"vm.allocateLimit\" ng-pattern=\"/^-?[0-9][^\\.]*$/\">\n</md-input-container><md-button class=\"allocation-button\" ng-click=\"vm.applyAllocation(reseller)\" \nng-disabled=\"!reseller.setQty || reseller.disableUserButton\" translate=\"LICENSE_ALLOCATE_BUTTON\">Allocate</md-button>\n</td><td class=\"table-name-label\" ng-if=\"vm.showLicenseAllocation\"><md-tooltip><span translate=\"LICENSE_QTY_TOOLTIP\">\nNumber of licenses in use out of allocated licenses of this type</span></md-tooltip>\n{{reseller.dispatcher_qty - reseller.dispatcher_availble_qty}} / {{reseller.dispatcher_qty}}</td><td \nng-if=\"vm.showLicenseAllocation\"><md-input-container><input aria-label=\"license qty\" \nng-change=\"vm.checkDispatcherAvailableQuantity()\" ng-model=\"reseller.setDispatcherQty\" type=\"number\" name=\"quantity\" \nng-min=\"-reseller.dispatcher_availble_qty\" ng-max=\"vm.allocateDispatcherLimit\" ng-pattern=\"/^-?[0-9][^\\.]*$/\">\n</md-input-container><md-button class=\"allocation-button\" ng-click=\"vm.applyDispatcherAllocation(reseller)\" \nng-disabled=\"!reseller.setDispatcherQty || reseller.disableDispatcherButton\" translate=\"LICENSE_ALLOCATE_BUTTON\">\nAllocate</md-button></td><td ng-if=\"vm.allowDelete\"><md-button class=\"delete-button md-icon-button\" \naria-label=\"delete\" translate translate-attr-aria-label=\"APP_REMOVE\" ng-click=\"vm.deleteReseller(reseller._id)\" \nng-hide=\"::vm.isActionNotAllowed(\'reseller_resource\', \'DELETE\')\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\">\n</md-icon></md-button></td></tr></tbody></table><md-content ng-if=\"vm.checkResellerContext() && !vm.resellers.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex \nclass=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"><md-input-container><label \ntranslate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" \npagination-id=\"resellerManager\" placeholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option \nng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"end center\"><dir-pagination-controls pagination-id=\"resellerManager\" max-size=\"1\" \ndirection-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/pages/invoice/views/compact/compact.html","<div id=\"invoice\" class=\"compact page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\"><div class=\"invoice-date\">{{vm.invoice.date}}</div><div \nlayout=\"row\" layout-align=\"space-between stretch\"><div class=\"client\"><div class=\"invoice-number\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\" translate=\"INVOICE.INVOICE\">INVOICE</span> <span class=\"number\">\n{{vm.invoice.number}}</span></div><div class=\"due-date\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"INVOICE.DUE_DATE\">DUE DATE</span> <span class=\"date\">{{vm.invoice.dueDate}}</span></div><div class=\"info\">\n<div class=\"title\">{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">\n{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\">{{vm.invoice.client.phone}}</div>\n<div ng-if=\"vm.invoice.client.email\" class=\"email\">{{vm.invoice.client.email}}</div><div \nng-if=\"vm.invoice.client.website\" class=\"website\">{{vm.invoice.client.website}}</div></div></div><div \nclass=\"issuer md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><span>F</span></div><div class=\"info\"><div class=\"title\">{{vm.invoice.from.title}}</div>\n<div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div \nng-if=\"vm.invoice.from.phone\" class=\"phone\">{{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" \nclass=\"email\">{{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\">\n{{vm.invoice.from.website}}</div></div></div></div></div><div class=\"content\"><table class=\"simple invoice-table\">\n<thead><th translate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">\n{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">\n{{service.total | currency}}</td></tr><tr ng-repeat=\"service in vm.invoice.services\"><td><div class=\"title\">\n{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td \nclass=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">{{service.total | currency}}</td></tr></tbody>\n</table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">\nSUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td></tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>\n{{vm.invoice.tax | currency}}</td></tr><tr class=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>\n-{{vm.invoice.discount | currency}}</td></tr><tr class=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>\n{{vm.invoice.total | currency}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\" \ntranslate=\"INVOICE.NOTE\">Please pay within 15 days. Thank you for your business.</div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div>\n<div class=\"small-note\" translate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/invoice/views/modern/modern.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" \nlayout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"start center\"><div class=\"logo md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"divider\"></div><div class=\"detail\"><div \nclass=\"title\">{{vm.invoice.from.title}}</div><div ng-if=\"vm.invoice.from.address\" class=\"address\">\n{{vm.invoice.from.address}}</div><div ng-if=\"vm.invoice.from.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone\n</span>: {{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" class=\"email\"><span \ntranslate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" \nclass=\"website\"><span translate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.from.website}}</div></div></div><div \nlayout=\"row\" class=\"client\" layout-align=\"start center\"><div class=\"label\" layout=\"row\" layout-align=\"end center\"><div \ntranslate=\"INVOICE.CLIENT\">CLIENT</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">\n{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">{{vm.invoice.client.address}}\n</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone</span>\n: {{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">\nEmail</span>: {{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\"><span \ntranslate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.client.website}}</div></div></div></div><table class=\"summary\"><tr \nclass=\"code\"><td class=\"label\" translate=\"INVOICE.INVOICE\">INVOICE</td><td class=\"value\">{{vm.invoice.number}}</td>\n</tr><tr><td class=\"label\" translate=\"INVOICE.INVOICE_DATE\">INVOICE DATE</td><td class=\"value\">{{vm.invoice.date}}</td>\n</tr><tr><td class=\"label\" translate=\"INVOICE.DUE_DATE\">DUE DATE</td><td class=\"value\">{{vm.invoice.dueDate}}</td></tr>\n<tr><td class=\"label\" translate=\"INVOICE.TOTAL_DUE\">TOTAL DUE</td><td class=\"value\">{{vm.invoice.total | currency}}\n</td></tr></table></div><div class=\"content\"><table class=\"simple invoice-table\"><thead><th \ntranslate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div><div class=\"detail\">{{service.detail}}</div></td><td>{{service.unit}}\n</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td \nclass=\"text-right\">{{service.total | currency}}</td></tr></tbody></table><table class=\"simple invoice-table-footer\">\n<tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">SUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td>\n</tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>{{vm.invoice.tax | currency}}</td></tr><tr \nclass=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>-{{vm.invoice.discount | currency}}</td></tr><tr \nclass=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>{{vm.invoice.total | currency}}</td></tr></tbody></table>\n</div><div class=\"footer\"><div class=\"note\" translate=\"INVOICE.NOTE\">\nPlease pay within 15 days. Thank you for your business.</div><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"small-note\" \ntranslate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div class=\"content\"><div class=\"info-line\">\n<div class=\"title\" translate=\"PROFILE.GENDER\">Gender</div><div class=\"info\">{{vm.about.general.gender}}</div></div><div\n class=\"info-line\"><div class=\"title\" translate=\"PROFILE.BIRTHDAY\">Birthday</div><div class=\"info\">\n{{vm.about.general.birthday}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.LOCATIONS\">\nLocations</div><div class=\"info location\" ng-repeat=\"location in vm.about.general.locations\"><span>{{location}}</span>\n<md-icon md-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon></div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.ABOUT_ME\">About Me</div><div class=\"info\">{{vm.about.general.about}}</div></div></div></div><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.WORK\">Work</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.OCCUPATION\">Occupation</div><div class=\"info\">{{vm.about.work.occupation}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.SKILLS\">Skills</div><div class=\"info\">{{vm.about.work.skills}}\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.JOBS\">Jobs</div><table class=\"info jobs\"><tr \nclass=\"job\" ng-repeat=\"job in vm.about.work.jobs\"><td class=\"company\">{{job.company}}</td><td class=\"date\">{{job.date}}\n</td></tr></table></div></div></div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><header\n class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.CONTACT\">Contact</div></header><div class=\"content\"><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\">\n{{vm.about.contact.address}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.TEL\">Tel.</div>\n<div class=\"info\" ng-repeat=\"tel in vm.about.contact.tel\"><span>{{tel}}</span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.WEBSITE\">Website</div><div class=\"info\" \nng-repeat=\"website in vm.about.contact.websites\"><span>{{website}}</span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.EMAILS\">Emails</div><div class=\"info\" ng-repeat=\"email in vm.about.contact.emails\">\n<span>{{email}}</span></div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"35\"><div class=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.FRIENDS\">\nFriends</div><div class=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>454</span> <span \ntranslate=\"PROFILE.MORE\">More</span></div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"friend\" \nflex=\"20\" ng-repeat=\"friend in vm.about.friends\"><img ng-src=\"{{friend.avatar}}\"></div></div></div><div \nclass=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.JOINED_GROUPS\">Joined Groups</div><div \nclass=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>6</span> <span translate=\"PROFILE.MORE\">More\n</span></div></header><div class=\"content\"><div class=\"group\" ng-repeat=\"group in vm.about.groups\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{group.logo}}\" \nclass=\"logo\" alt=\"{{group.name}}\"><div><div class=\"name\">{{group.name}}</div><div class=\"category\">{{group.category}}\n</div><div class=\"members\">{{group.members}} people</div></div></div><md-button class=\"md-icon-button\" \naria-label=\"more\" translate translate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><div class=\"period\" data-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\">\n<span class=\"name\">{{period.name}}</span> <span class=\"info\">{{period.info}}</span></div><div class=\"period-media\" \nlayout=\"row\" layout-wrap><div class=\"media\" ng-repeat=\"media in period.media\"><img class=\"preview\" \nng-src=\"{{media.preview}}\" title=\"{{media.title}}\"><div class=\"title\">{{media.title}}</div></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/timeline/timeline.html","<div layout=\"row\" layout-wrap><div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" flex-gt-md=\"65\" \nflex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box add-post md-whiteframe-1dp\"><div class=\"form\" flex>\n<textarea placeholder=\"Write something..\" translate translate-attr-placeholder=\"PROFILE.WRITE_SOMETHING\"></textarea>\n<footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" aria-label=\"insert photo\" translate translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon \nmd-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PROFILE.INSERT_PHOTO\">insert photo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add person\" translate \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip><span \ntranslate=\"PROFILE.ADD_PERSON\">add person</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"add location\" translate translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><md-tooltip><span translate=\"PROFILE.LOCATION\">add location</span>\n</md-tooltip></md-button></div><md-button ng-click=\"\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" \ntranslate=\"PROFILE.POST\" translate-attr-aria-label=\"PROFILE.POST\">POST</md-button></footer></div></div><md-divider>\n</md-divider><div class=\"timeline-item md-whiteframe-1dp\" ng-repeat=\"post in vm.posts\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" \nng-src=\"{{post.user.avatar}}\"><div layout=\"column\"><div class=\"title\"><span class=\"username md-accent-color\">\n{{post.user.name}}</span> <span ng-if=\"post.type == \'post\'\" translate=\"PROFILE.TYPE_POST\">posted on your timeline\n</span> <span ng-if=\"post.type == \'something\'\" translate=\"PROFILE.TYPE_SOMETHING\">shared something with you</span> \n<span ng-if=\"post.type == \'video\'\" translate=\"PROFILE.TYPE_VIDEO\">shared a video with you</span> <span \nng-if=\"post.type == \'article\'\" translate=\"PROFILE.TYPE_ARTICLE\">shared an article with you</span></div><div \nclass=\"time\">{{post.time}}</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate \ntranslate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></header><div\n class=\"content\"><div ng-if=\"post.message\" class=\"message\">{{post.message}}</div><div ng-if=\"post.media\" class=\"media\">\n<img ng-if=\"post.media.type === \'image\'\" ng-src=\"{{post.media.preview}}\"><div ng-if=\"post.media.type === \'video\'\" \nng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div \nclass=\"media\"><img ng-src=\"{{post.article.media.preview}}\"></div><div class=\"title\">{{post.article.title}}</div><div \nclass=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-heart-outline\" class=\"s16\"></md-icon><span translate=\"PROFILE.LIKE\">Like</span>&nbsp;<span>\n({{post.like}})</span></div></md-button><md-button class=\"share-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-share\" class=\"s16\"></md-icon><span translate=\"PROFILE.SHARE\">Share</span>&nbsp;<span>\n({{post.share}})</span></div></md-button></div></div><footer class=\"\" layout=\"column\" layout-align=\"start start\"><div \nng-if=\"post.comments\" class=\"comment-count\">{{post.comments.length}} comments<md-icon \nmd-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" layout=\"row\" layout-fill \nng-repeat=\"comment in post.comments\"><img ng-src=\"{{comment.user.avatar}}\" class=\"avatar\"><div flex layout=\"column\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"username\">{{comment.user.name}}</span> <span class=\"time\">\n{{comment.time}}</span></div><div class=\"message\">{{comment.message}}</div><div class=\"actions\" layout=\"row\" \nlayout-align=\"space-between center\"><a href=\"#\" class=\"reply-button md-accent-color\" translate=\"PROFILE.REPLY\">Reply\n</a><md-icon flex md-font-icon=\"icon-flag\" class=\"report-button s16\"></md-icon></div></div></div><div class=\"reply\" \nlayout=\"row\" layout-fill><img src=\"assets/images/avatars/profile.jpg\" class=\"avatar\"><form flex><textarea \nplaceholder=\"Add a comment...\" translate translate-attr-placeholder=\"PROFILE.ADD_COMMENT\"></textarea><md-button \nng-click=\"\" class=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PROFILE.POST_COMMENT\" \ntranslate-aria-label=\"PROFILE.POST_COMMENT\">Post Comment</md-button></form></div></footer></div></div><div \nclass=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" \nflex-order-gt-sm=\"2\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PROFILE.LATEST_ACTIVITY\">Latest Activity</div><div class=\"more secondary-text\" translate=\"PROFILE.SEE_ALL\">\nSee All</div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"activities\"><div class=\"activity\" \nlayout=\"row\" layout-align=\"start start\" ng-repeat=\"activity in vm.activities\"><img ng-src=\"{{activity.user.avatar}}\" \nclass=\"avatar\" alt=\"{{activity.user.name}}\"><div layout=\"column\"><div><span class=\"username md-accent-color\">\n{{activity.user.name}}</span> <span class=\"message\">{{activity.message}}</span></div><span class=\"time secondary-text\">\n{{activity.time}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/search/tabs/classic/classic.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><span class=\"result-count h3 secondary-text\"><span>54</span> <span \ntranslate=\"SEARCH.RESULTS\">Results</span></span><div class=\"pager\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span> </span><span class=\"page-info\">\n<span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button \nclass=\"md-icon-button\" aria-label=\"previous page\" translate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" \ntranslate translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></div></div><div class=\"results\"><div class=\"result-item\" ng-repeat=\"item in vm.classic\"><div \nclass=\"title\">{{item.title}}</div><div class=\"url\">{{item.url}}</div><div class=\"excerpt\">{{item.excerpt}}</div></div>\n</div><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/contacts/contacts.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.CONTACTS\">Contacts</span> <span \nclass=\"secondary-text\"><span>13</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th></th><th translate=\"SEARCH.NAME\">Name\n</th><th translate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.PHONE\">Phone</th><th translate=\"SEARCH.EMAIL\">\nEmail</th></tr></thead><tbody><tr class=\"result-item\" ng-repeat=\"contact in vm.contacts\"><td \nclass=\"text-left avatar-cell\" ng-if=\"contact.avatar\"><img class=\"avatar\" alt=\"{{contact.name}}\" \nng-src=\"{{contact.avatar}}\"></td><td class=\"text-left avatar-cell\" ng-if=\"!contact.avatar\"><div class=\"avatar\" \nms-random-class=\"vm.colors\">{{contact.name[0]}}</div></td><td class=\"name\">{{contact.name}}</td><td class=\"position\">\n{{contact.position}}</td><td class=\"phone\">{{contact.phone}}</td><td class=\"email\">{{contact.email}}</td></tr></tbody>\n</table><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/emails/emails.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.EMAILS\">E-Mails</span> <span \nclass=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><div class=\"results\"><div class=\"result-item {{mail.status}}\" ng-repeat=\"mail in vm.mails | filter: vm.search\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-if=\"mail.from.avatar\" \nalt=\"{{mail.from.name}}\" ng-src=\"{{mail.from.avatar}}\"><div class=\"avatar\" ng-if=\"!mail.from.avatar\" \nms-random-class=\"vm.colors\">{{mail.from.name[0]}}</div><div class=\"info\" flex layout=\"column\"><div \nclass=\"name text-truncate\">{{mail.from.name}}</div><div class=\"subject secondary-text text-truncate\">{{mail.subject}}\n</div><div class=\"message secondary-text text-truncate\">{{mail.message | htmlToPlaintext}}</div></div><div \nlayout=\"column\" layout-align=\"center end\"><div class=\"time secondary-text\">{{mail.time}}</div></div></div></div></div>\n<div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/users/users.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.USERS\">Users</span> <span \nclass=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th translate=\"SEARCH.NAME\">Name</th><th \ntranslate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.OFFICE\">Office</th><th class=\"text-right\" \ntranslate=\"SEARCH.AGE\">Age</th><th class=\"text-right\" translate=\"SEARCH.START_DATE\">Start Date</th><th \nclass=\"text-right\" translate=\"SEARCH.SALARY\">Salary</th><th class=\"text-left\" translate=\"SEARCH.EMAIL\">Email</th></tr>\n</thead><tbody><tr class=\"result-item user\" ng-repeat=\"user in vm.users\"><td class=\"name\">{{user.name}}</td><td \nclass=\"position\">{{user.position}}</td><td class=\"office\">{{user.office}}</td><td class=\"age text-right\">{{user.age}}\n</td><td class=\"start-date text-right\">{{user.startDate}}</td><td class=\"salary text-right\">{{user.salary | currency}}\n</td><td class=\"email text-left\">{{user.email}}</td></tr></tbody></table><div class=\"simple-pagination\"><md-button \nclass=\"pagination-item disabled\" md-no-ink ng-href=\"#\" aria-label=\"Go to previous page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button>\n<md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/restricted/administration/administrators/dialog/admin.dialog.html","<md-dialog aria-label=\"Administrators\" class=\"md-dialog-wide\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ADMINISTRATION_DIALOG_TITLE\">Administrators</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><form name=\"vm.adminForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label translate=\"ADMINISTRATION_SELECT_ROLE\">Select role\n</label><md-select name=\"role\" required ng-model=\"vm.user.role\"><md-option ng-repeat=\"item in ::vm.adminRoles\" \nng-value=\"item._id\">{{item.name}}</md-option></md-select><div ng-messages=\"vm.adminForm.role.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"ADMINISTRATION_EMAIL\">Email address</label><input type=\"email\" name=\"email\" ng-model=\"vm.user.name\" \ntranslate aria-invalid=\"true\" md-maxlength=\"50\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{1,}$/\" required \nautocomplete=\"off\"><div ng-messages=\"vm.adminForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div \nng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div \nng-message=\"pattern\"><span translate=\"APP_VALIDATION_EMAIL\">Email must be a valid e-mail address</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-if=\"vm.user._id\" \naria-label=\"permission-item\" class=\"md-secondary\" ng-model=\"vm.user.changePassword\" ng-change=\"vm.showPassword()\" \ntranslate=\"APP_CHANGE_PASSWORD\">Change Password</md-checkbox></div><password-fields \nng-if=\"((vm.user._id && vm.user.changePassword) || !vm.user._id)\" password=\"vm.user.password\" \nre-password=\"vm.user.rePassword\" form-name=\"vm.adminForm\" strong-pass=\"vm.strongAdminPassword\"></password-fields>\n</form></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \ntranslate=\"APP_CANCEL\" ng-click=\"vm.close()\" ng-disabled=\"!vm.flagSave\">Cancel</md-button><md-button \ntranslate=\"APP_SAVE\" \nng-disabled=\"!vm.validate() ||( !vm.allowCreate && !vm.user._id) || (!vm.allowModify && vm.user._id) || !vm.flagSave\" \nng-click=\"vm.ok()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/restricted/administration/roles/dialog/permList.tmpl.html","<md-dialog aria-label=\"{{vm.currentRole.name}}\'s permissions list\"><form name=\"rolesForm\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>{{currentRole.name}} <span translate=\"ROLE_DIALOG_TITLE\">permissions list</span></h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"with-tabs\"><div class=\"md-dialog-content\"><md-input-container \nflex-gt-sm><label translate=\"ROLE_NAME\">Name</label><input md-maxlength=\"31\" required name=\"name\" \nng-model=\"vm.currentRole.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' ng-disabled=\"!vm.edit\" autocomplete=\"off\"><div \nng-messages=\"rolesForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">\nThis field is required</span></div><div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">\nThis field is too long</span></div><div ng-message=\"pattern\"><span translate=\"APP_VALIDATION_SPECIAL_CHARS\">\nThis field can not contain special characters</span></div></div></md-input-container><md-button \nng-click=\"vm.addNewPerm()\" ng-if=\"vm.edit\" \nng-disabled=\"!vm.currentRole.name || vm.deactivateAddButton() || !vm.addButtonDisableFlag || vm.LoginUserRoleId == vm.currentRole._id\" \nclass=\"add-role-button md-fab md-warn\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><md-tabs \nmd-dynamic-height><md-tab md-on-select=\"vm.onTabChanges(2)\"><md-tab-label><span translate=\"ROLE_TABS_WEB\">Provisioning\n</span></md-tab-label><md-tab-body><md-content class=\"timeline-tab padding-tab\" \nng-include=\"\'app/main/restricted/administration/roles/dialog/tabs/webPermissions.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges(3)\"><md-tab-label><span translate=\"ROLE_TABS_DISPATCHER\">Dispathcer\n</span></md-tab-label><md-tab-body><md-content class=\"photos-videos-tab padding-tab\" \nng-include=\"\'app/main/restricted/administration/roles/dialog/tabs/dispatcherPermissions.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(4)\"><md-tab-label><span translate=\"ROLE_TABS_MOBILE\">\nClient</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/restricted/administration/roles/dialog/tabs/mobilePermissions.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges(5)\"><md-tab-label><span translate=\"SUBSCRIBERS_ACTIVITY_LOG\">\nActivity Log</span></md-tab-label><md-tab-body><md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/administration/roles/dialog/tabs/activity.html\'\"></md-content></md-tab-body></md-tab>\n</md-tabs><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.cancel()\" translate=\"APP_CANCEL\" \nng-disabled=\"!vm.flagSave\">Cancel</md-button><md-button \nng-disabled=\"!vm.currentRole.name || !vm.edit || vm.LoginUserRoleId == vm.currentRole._id || !vm.flagSave\" \nng-click=\"vm.save()\" translate=\"APP_SAVE\">Save</md-button></md-dialog-actions></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/restricted/organization/application-lists/tabs/application.profiles.html","<div class=\"content-card\"><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" \nng-if=\"vm.organizationId\" style=\"margin-top: 1%\"><label style=\"margin-left: 2%\" \ntranslate=\"APPLICATION_LIST_WARNING_CONTENT\">all changes will affect immidietlly on the clients</label></div><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\">\n</md-input-container></div><md-button class=\"add-button md-fab md-warn\" \nng-click=\"vm.openApplicationListDialog(null, false, true)\" ng-disabled=\"!vm.organizationId || !vm.allowCreate\" \naria-label=\"Add\" translate><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content \nng-if=\"vm.organizationId\"><table class=\"dataTable row-border stripe hover\" ng-if=\"vm.organizationId\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APPLICATION_LIST_ID\">ID</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"APPLICATION_LIST_NAME\">Name</span></div></th><th class=\"secondary-text\" ng-if=\"vm.allowCreate\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"APP_CLONE\">Clone</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.allowDelete\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"APP_REMOVE\">Actions</span></div></th></tr></thead><tbody><tr \ndir-paginate=\"(index, applicationList) in vm.applicationLists |searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\" , pagination-id=\"vm.applicationListsPaginationClass\"><td width=\"20%\" \nng-click=\"vm.openApplicationListDialog(applicationList, false, false)\" class=\"table-name-label\">{{index}}</td><td \nwidth=\"60%\" ng-click=\"vm.openApplicationListDialog(applicationList, false, false)\" class=\"table-name-label\">\n{{applicationList.name}}</td><td width=\"20%\" ng-if=\"vm.allowCreate\"><md-button class=\"md-icon-button\" \naria-label=\"application list\" ng-click=\"vm.openApplicationListDialog(applicationList, true, true)\" translate \ntranslate-attr-aria-label=\"APP_CLONE\"><i class=\"icon-content-copy s16 content-copy\"></i></md-button></td><td \nwidth=\"100%\" ng-if=\"vm.allowDelete\"><md-button class=\"edit-button md-icon-button\" aria-label=\"organisation details\" \ntranslate translate-attr-aria-label=\"APP_DELETE\" ng-click=\"vm.deleteApplicationList(applicationList._id)\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content \nng-if=\"!vm.applicationLists.length\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\"><p class=\"pd-2\" translate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nng-if=\"vm.showLoaderApplicationLists\" class=\"md-accent md-hue-1\" md-diameter=\"40\"></md-progress-circular></div>\n</md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\" pagination-id=\"vm.applicationListsPaginationClass\">\n<md-option ng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \nmax-size=\"1\" direction-links=\"true\" boundary-links=\"true\" pagination-id=\"vm.applicationListsPaginationClass\">\n</dir-pagination-controls></div></div></md-content></div>");
$templateCache.put("app/main/restricted/organization/application-lists/tabs/applications.html","<div class=\"content-card\"><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" \nng-if=\"vm.organizationId\" style=\"margin-top: 1%\"><label style=\"margin-left: 2%\" \ntranslate=\"APPLICATION_LIST_WARNING_CONTENT\">all changes will affect immidietlly on the clients</label></div><div \nclass=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"row\" \nlayout-align=\"margin-right\" flex=\"28\" style=\"margin-inline-start: auto; align-items: center\"><label><input \ntype=\"radio\" ng-model=\"vm.exportType\" id=\"vm.exportType\" value=\"csv\" \nng-disabled=\"vm.showLoader || !vm.organizationId || !vm.applications.newList || !vm.applications.newList.length\">CSV\n</label><label><input type=\"radio\" ng-model=\"vm.exportType\" id=\"vm.exportType\" value=\"excel\" \nng-disabled=\"vm.showLoader || !vm.organizationId || !vm.applications.newList || !vm.applications.newList.length\">Excel\n</label><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.showLoader || !vm.organizationId || !vm.applications.newList || !vm.applications.newList.length\" \nng-csv=\"vm.getExportApplications()\" lazy-load=\"true\" add-bom=\"true\" \ncsv-header=\"[\'AppId\',\'AppName\',\'AppPackage\',\'AppVersion\',\'AppDescription\']\" \nfilename=\"{{vm.timestamp| date:\'dd-MMM-yyyy\'}}-{{vm.organizationId}}-applications.csv\" \nstyle=\"min-width: min-content; width: fit-content\"><label translate=\"BULK_EXPORT_APPLICATIONS\">Export Applications\n</label></md-button></div><md-button ng-click=\"vm.downloadAppSampleFile()\" class=\"md-raised md-accent downloadFile\" \nstyle=\"width: fit-content; margin-right: 15px\" translate=\"DOWNLOAD_SAMPLE_FILE\">Download Sample File</md-button>\n<ng-csv-import content=\"vm.content\" material md-button-class=\"md-raised md-accent\" md-button-title=\"Import\" \nheader=\"false\" separator=\"\',\'\" result=\"vm.resultData\" accept=\"\'.xlsx, .csv\'\" callback=\"vm.streamingApplicationCall\">\n</ng-csv-import><md-button class=\"add-button md-fab md-warn\" ng-click=\"vm.addApplicationDialog()\" \nng-disabled=\"!vm.organizationId || !vm.allowCreate\" aria-label=\"Add\" translate><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><md-content ng-if=\"vm.organizationId\"><table class=\"dataTable row-border stripe hover\" \nng-if=\"vm.organizationId\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"APPLICATION_ID\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"APPLICATION_ICON\">Icon</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortApp(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortAppClass(\'name\')\" translate=\"APPLICATION_NAME\">App Name</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sortApp(\'package\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortAppClass(\'package\')\" translate=\"APPLICATION_PACKAGE\">Package name</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sortApp(\'apk.versionCode\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortAppClass(\'apk.versionCode\')\" translate=\"APPLICATION_VERSION\">App Version</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APPLICATION_DESCRIPTION\">\nDescription</span></div></th><th class=\"secondary-text\" ng-if=\"vm.allowDelete\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div></th></tr></thead><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular ng-if=\"vm.showLoaderApplications\" class=\"md-accent md-hue-1\" \nmd-diameter=\"40\"></md-progress-circular></div><tbody><tr \ndir-paginate=\"(index, application) in vm.applications.newList |searchByApp:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\" , pagination-id=\"vm.applicationsPaginationClass\"><td width=\"5%\" class=\"table-name-label\" \nng-click=\"vm.editApplicationDialog(application)\">{{index}}</td><td width=\"10%\" class=\"table-name-label\" \nng-click=\"vm.editApplicationDialog(application)\"><img style=\"max-height: 60%\" ng-hide=\"!application.apk.stringIcon\" \ndata-ng-src=\"data:image/*;base64,{{application.apk.stringIcon}}\" ng-if=\"application.apk.stringIcon\"><md-icon \nmd-font-icon=\"{{vm.icons[application.name]}}\" ng-if=\"!application.apk.stringIcon && application.package == \'DEFAULT\'\">\n</md-icon><md-icon md-font-icon=\"icon-apps\" ng-if=\"!application.apk.stringIcon && application.package != \'DEFAULT\'\">\n</md-icon></td><td width=\"10%\" class=\"table-name-label\" ng-click=\"vm.editApplicationDialog(application)\">\n{{application.name}}</td><td width=\"20%\" class=\"table-name-label\" ng-click=\"vm.editApplicationDialog(application)\">\n{{application.package}}</td><td width=\"20%\" class=\"table-name-label\" ng-click=\"vm.editApplicationDialog(application)\">\n{{application.apk.versionCode}}</td><td width=\"25%\" class=\"table-name-label\" \nng-click=\"vm.editApplicationDialog(application)\">{{application.description}}</td><td width=\"100%\" \nng-if=\"vm.allowDelete\"><md-button class=\"edit-button md-icon-button\" aria-label=\"organisation details\" translate \ntranslate-attr-aria-label=\"APP_DELETE\" ng-click=\"vm.deleteApplication(application)\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content \nng-if=\"!vm.applications.newList.length\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\">\n<div class=\"content-card\"><p class=\"pd-2\" translate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div>\n</md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\" pagination-id=\"vm.applicationsPaginationClass\"><md-option\n ng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \nmax-size=\"1\" direction-links=\"true\" boundary-links=\"true\" pagination-id=\"vm.applicationsPaginationClass\">\n</dir-pagination-controls></div></div><div layout=\"row\" style=\"float: right\"><md-button md-no-ink class=\"md-primary\" \nng-click=\"vm.cancelApplicationChanges()\" aria-label=\"\" translate=\"APP_CANCEL\" \nng-disabled=\"!vm.applications.appChanged\">Cancel</md-button><md-button md-no-ink class=\"md-primary\" \nng-click=\"vm.saveApplications()\" aria-label=\"\" translate=\"APP_SAVE\" \nng-disabled=\"!vm.applications.appChanged || !vm.allowCreate\">Save</md-button></div></md-content></div>");
$templateCache.put("app/main/restricted/organization/batch/tabs/batch.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align=\"center center\" layout-gt-md=\"row\"><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"40\"><p><span \ntranslate=\"BULK_SUBSCRIBERS_COUNT\">Subscribers Count</span> : {{vm.subscribers.length}}</p></div><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"60\"><md-button ng-click=\"vm.downloadSampleFile()\" \nclass=\"md-raised md-accent downloadFile\" style=\"width: fit-content\" translate=\"DOWNLOAD_SAMPLE_FILE\">\nDownload Sample File</md-button></div></div><md-card style=\"width: 700px\"><md-card-header><md-card-header-text><p \nstyle=\"color: red\" translate=\"BULK_IMPORT_NOTE\">\nwhile importing subscribers, affiliated group will be applied on the subscribers who has off-net license.</p><span \nclass=\"md-title\" translate=\"BULK_RESULT_LOG\">Result Log</span></md-card-header-text></md-card-header><md-content-card \nstyle=\"max-height: 200px; overflow-y: auto\"><p>{{vm.resultLog}}</p><p ng-repeat=\"error in vm.errorLog track by $index\">\n{{error}}</p></md-content-card></md-card><div layout=\"column\" layout-gt-sm=\"row\"><ng-csv-import content=\"vm.content\" \nmaterial disabled=\"!vm.allowAddSubscriber\" md-button-class=\"md-raised md-accent\" md-button-title=\"Import\" \nheader=\"false\" separator=\"\',\'\" result=\"vm.result\" accept=\"\'.csv, .xlsx\'\" callback=\"vm.streamingCallback\">\n</ng-csv-import></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"row\" flex=\"30\"><label><input \ntype=\"radio\" ng-model=\"vm.exportType\" id=\"vm.exportType\" value=\"csv\" \nng-disabled=\"vm.loading || vm.subscribers.length < 1 || !vm.allowViewSubscriber\">CSV</label><label><input type=\"radio\" \nng-model=\"vm.exportType\" id=\"vm.exportType\" value=\"excel\" \nng-disabled=\"vm.loading || vm.subscribers.length < 1 || !vm.allowViewSubscriber\">Excel</label><md-button \nclass=\"md-raised md-accent\" style=\"min-width: min-content; width: -webkit-fill-available\" \nng-disabled=\"vm.loading || vm.subscribers.length < 1 || !vm.allowViewSubscriber\" \nng-csv=\"vm.getDetailedSubscribersList()\" lazy-load=\"true\" add-bom=\"true\" csv-header=\"vm.exportFields\" \nfilename=\"{{vm.timestamp| date:\'dd-MMM-yyyy\'}}-{{vm.organization.name}}.csv\"><label translate=\"GENERIC_EXPORT\">Export\n</label></md-button></div><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"30\"><md-button \nclass=\"md-raised md-accent\" style=\"min-width: min-content\" \nng-disabled=\"vm.loading || vm.subscribers.length < 1 ||  !vm.allowChangeState\" ng-click=\"vm.enableAllSubscribers()\" \ntranslate=\"BULK_ENABLE_ALL\">Enable All Subscribers</md-button></div><div layout=\"column\" layout-align-gt-sm=\"row\" \nflex=\"30\"><md-button class=\"md-raised md-accent\" style=\"min-width: min-content\" \nng-disabled=\"vm.loading || vm.subscribers.length < 1 ||  !vm.allowChangeState\" ng-click=\"vm.disableAllSubscribers()\" \ntranslate=\"BULK_SUSPEND_ALL\">Disable All Subscribers</md-button></div><div layout=\"column\" layout-align-gt-sm=\"row\" \nflex=\"30\"><md-button class=\"md-raised md-accent\" style=\"min-width: min-content\" \nng-disabled=\"vm.loading || vm.subscribers.length < 1 || !vm.allowDeleteSubscribers\" \nng-click=\"vm.deleteAllSubscribers()\" translate=\"BULK_DELETE_ALL\">Delete All Subscribers</md-button></div><div \nlayout=\"column\" layout-align-gt-sm=\"row\" flex=\"30\" ng-if=\"vm.isEnableQrLogin\"><md-button class=\"md-raised md-accent\" \nstyle=\"min-width: min-content\" ng-disabled=\"vm.loading || vm.subscribers.length < 1\" ng-click=\"vm.exportQrCodes()\" \ntranslate=\"BULK_EXPORT_SUBSCRIBER_QR_CODE\">Export Subscriber QR Codes</md-button></div><div id=\"pdf-content\" \nstyle=\"display: none\"><div ng-repeat=\"user in vm.rqUsers\" class=\"qrBox\" style=\"margin-bottom: 20px\"><p><strong>\n{{ user.name }}</strong> - {{ user._id }}</p><div id=\"qrcode-{{user._id}}\"></div></div></div></md-content></div></div>\n</md-content>");
$templateCache.put("app/main/restricted/organization/batch/tabs/interactive.application.list.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><p><span translate=\"BULK_SUBSCRIBERS_COUNT\">Subscribers Count</span>\n : {{vm.notSelectedSubscriberApplicationList.length}}</p></div><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"40\">\n<p>{{vm.resultApplicationListLog}}</p></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float \nflex><label><span translate=\"BULK_SELECT_APPLICATION_LIST\">Select Application List</span></label><md-select \nname=\"applicationList\" ng-model=\"vm.selectedApplicationListId\" ng-change=\"vm.onApplicationListChange()\" required>\n<md-option ng-value=\"null\">{{\'None\'}}</md-option><md-option ng-repeat=\"item in vm.applicationLists\" \nng-value=\"item._id\">{{item.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.loading\"><md-progress-circular ng-disabled=\"!vm.loading\" \nclass=\"md-accent\" md-diameter=\"40\"></md-progress-circular></div><div layout=\"column\" layout-align-gt-sm=\"row\" \nflex=\"30\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.loading || vm.selectedSubscribersApplicationList.length < 1 || !vm.selectedApplicationList\" \nng-click=\"vm.batchApplicationListAssignment()\" translate=\"BULK_ALLOCATION_APPLY\">Apply</md-button></div><choose-list \nselected-elements=\"vm.selectedSubscribersApplicationList\" \nnot-selected-elements=\"vm.notSelectedSubscriberApplicationList\" pagination-id=\"vm.applicationListPaginationClass\" \nmember-count-limit=\"vm.subscriberLength\" error=\"false\"></choose-list></md-content></div></div></md-content>");
$templateCache.put("app/main/restricted/organization/batch/tabs/interactive.change.password.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><p><span translate=\"BULK_SUBSCRIBERS_COUNT\">Subscribers Count</span>\n : {{vm.notSelectedSubscriberPassword.length}}</p></div><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"40\"><p>\n{{vm.resultPasswordLog}}</p><p ng-repeat=\"error in vm.passwordErrorLog track by $index\">{{error}}</p></div><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"row\" flex=\"100\"><label><input type=\"radio\" \nng-model=\"vm.passType\" id=\"vm.passType\" value=\"Show Div\" \nng-disabled=\"vm.loading || vm.subscribers.length < 1 || !vm.allowViewSubscriber\" checked=\"checked\"><label \ntranslate=\"GENERATE_COMMON_PASSWORD\">Generate Same Password</label></label><label><input type=\"radio\" \nng-model=\"vm.passType\" id=\"vm.passType\" value=\"Hide Div\" \nng-disabled=\"vm.loading || vm.subscribers.length < 1 || !vm.allowViewSubscriber\"><label \ntranslate=\"GENERATE_UNIQUE_PASSWORD\">Generate Unique Passwords</label></label></div><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.loading || vm.selectedSubscriberPassword.length < 1 || (vm.passType == \'Show Div\' && (vm.passwordForm.$invalid || !vm.password))\" \nng-click=\"vm.batchChangePasswordAssignment()\" translate=\"BULK_CHANGE_PASSWORD_APPLY\">Apply</md-button></div><div \nng-show=\"vm.passType == \'Show Div\'\"><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"40\"><form \nname=\"vm.passwordForm\" novalidate><password-fields password=\"vm.password\" re-password=\"vm.rePassword\" \nform-name=\"vm.passwordForm\" strong-pass=\"vm.organization.strongDispatchPass\"></password-fields></form></div></div><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.loading\"><md-progress-circular \nng-disabled=\"!vm.loading\" class=\"md-accent\" md-diameter=\"40\"></md-progress-circular></div><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"100\"><choose-list selected-elements=\"vm.selectedSubscriberPassword\" \nnot-selected-elements=\"vm.notSelectedSubscriberPassword\" pagination-id=\"vm.passwordPaginationClass\" \nmember-count-limit=\"vm.subscriberLength\" error=\"false\"></choose-list></div></md-content></div></div></md-content>");
$templateCache.put("app/main/restricted/organization/batch/tabs/interactive.delete.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><label><input type=\"radio\" ng-model=\"vm.deleteType\" id=\"vm.deleteType\" value=\"Subscribers\" \nng-click=\"vm.changeDeleteInteractiveList()\" ng-disabled=\"!vm.allowDeleteSubscribers\" checked=\"checked\"><label \ntranslate=\"DELETE_INTERACTIVE_SUBSCRIBERS\"></label></label><label><input type=\"radio\" ng-model=\"vm.deleteType\" \nid=\"vm.deleteType\" value=\"Groups\" ng-click=\"vm.changeDeleteInteractiveList()\" ng-disabled=\"!vm.allowDeleteGroups\">\n<label translate=\"DELETE_INTERACTIVE_GROUPS\"></label></label><label ng-if=\"vm.showOcl\"><input type=\"radio\" \nng-model=\"vm.deleteType\" id=\"vm.deleteType\" value=\"OCL\" ng-click=\"vm.changeDeleteInteractiveList()\" \nng-disabled=\"!vm.allowDeleteGroups\"><label translate=\"DELETE_INTERACTIVE_OCL\"></label></label><label \nng-if=\"vm.showEmergencyGroup\"><input type=\"radio\" ng-model=\"vm.deleteType\" id=\"vm.deleteType\" value=\"EmergencyGroup\" \nng-click=\"vm.changeDeleteInteractiveList()\" ng-disabled=\"!vm.allowDeleteGroups\"><label \ntranslate=\"DELETE_INTERACTIVE_EMERGENCY_GROUP\"></label></label><label><input type=\"radio\" ng-model=\"vm.deleteType\" \nid=\"vm.deleteType\" value=\"ContactTemplate\" ng-click=\"vm.changeDeleteInteractiveList()\" \nng-disabled=\"!vm.allowDeleteGroups\"><label translate=\"DELETE_INTERACTIVE_CONTACT_TEMPLATE\"></label></label></div><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.deleteType == \'Subscribers\'\"><label><input type=\"radio\" \nng-model=\"vm.deleteMethod\" id=\"vm.deleteMethod\" value=\"byFile\" ng-disabled=\"!vm.allowDeleteSubscribers\" \nchecked=\"checked\"><label>By File</label></label><label><input type=\"radio\" ng-model=\"vm.deleteMethod\" \nid=\"vm.deleteMethod\" value=\"byUsers\" ng-disabled=\"!vm.allowDeleteGroups\"><label>By Users</label></label></div>\n<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><p><span translate=\"BULK_DELETE_COUNT\">Count</span>\n : {{vm.notSelectedDelete.length}}</p></div><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"40\"><p>\n{{vm.resultDeleteLog}}</p></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.loading\">\n<md-progress-circular ng-disabled=\"!vm.loading\" class=\"md-accent\" md-diameter=\"40\"></md-progress-circular></div><div \nlayout=\"column\" layout-align-gt-sm=\"row\" flex=\"30\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.loading || vm.selectedDelete.length < 1\" ng-click=\"vm.batchDeleteAssignment()\" \ntranslate=\"BULK_DELETE_APPLY\">Apply</md-button></div><choose-list selected-elements=\"vm.selectedDelete\" \nnot-selected-elements=\"vm.notSelectedDelete\" pagination-id=\"vm.deletePaginationClass\" \nmember-count-limit=\"vm.deleteLength\" error=\"false\" ng-if=\"vm.deleteMethod == \'byUsers\'\"></choose-list><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.deleteMethod == \'byFile\'\"><md-button \nng-click=\"vm.downloadDeleteSampleFile()\" class=\"md-raised md-accent downloadFile\" style=\"width: fit-content\" \ntranslate=\"DOWNLOAD_SAMPLE_FILE\">Download Sample File</md-button><ng-csv-import content=\"vm.content\" material \ndisabled=\"!vm.allowAddSubscriber\" md-button-class=\"md-raised md-accent\" md-button-title=\"Import\" header=\"false\" \nseparator=\"\',\'\" result=\"vm.resultData\" accept=\"\'.csv, .xlsx\'\" callback=\"vm.streamingDeleteCall\"></ng-csv-import></div>\n</md-content></div></div></md-content>");
$templateCache.put("app/main/restricted/organization/batch/tabs/interactive.emergency.group.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><p><span translate=\"BULK_SUBSCRIBERS_COUNT\">Subscribers Count</span>\n : {{vm.notSelectedSubscriberEmergencyGroup.length}}</p></div><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"40\">\n<p>{{vm.resultEmergencyGroupLog}}</p></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float \nflex><label><span translate=\"BULK_SELECT_EMERGENCY_GROUP\">Select Emergency Group</span></label><md-select \nname=\"emergencyGroup\" ng-model=\"vm.selectedEmergencyGroupId\" ng-change=\"vm.onEmergencyGroupChange()\" required>\n<md-option ng-value=\"null\">{{\'None\'}}</md-option><md-option ng-repeat=\"item in vm.emergencyGroups\" ng-value=\"item._id\">\n{{item.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" ng-if=\"vm.loading\"><md-progress-circular ng-disabled=\"!vm.loading\" class=\"md-accent\" \nmd-diameter=\"40\"></md-progress-circular></div><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"30\"><md-button \nclass=\"md-raised md-accent\" \nng-disabled=\"vm.loading || vm.selectedSubscribersEmergencyGroup.length < 1 || !vm.EmergencyGroupVal \" \nng-click=\"vm.batchEmergencyGroupAssignment()\" translate=\"BULK_ALLOCATION_APPLY\">Apply</md-button></div><choose-list \nselected-elements=\"vm.selectedSubscribersEmergencyGroup\" \nnot-selected-elements=\"vm.notSelectedSubscriberEmergencyGroup\" pagination-id=\"vm.emergencyGroupPaginationClass\" \nmember-count-limit=\"vm.subscriberLength\" error=\"false\"></choose-list></md-content></div></div></md-content>");
$templateCache.put("app/main/restricted/organization/batch/tabs/interactive.forward.group.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><p><span translate=\"BULK_SUBSCRIBERS_COUNT\">Subscribers Count</span>\n : {{vm.notSelectedSubscriberEmergencyGroup.length}}</p></div><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"40\">\n<p>{{vm.resultEmergencyGroupLog}}</p></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float \nflex><label><span translate=\"BULK_SELECT_FORWARD_GROUP\">Select Forward Group</span></label><md-select \nname=\"forwardGroup\" ng-model=\"vm.selectedForwardGroupId\" ng-change=\"vm.onForwardGroupChange()\" required><md-option \nng-value=\"null\">{{\'None\'}}</md-option><md-option ng-repeat=\"item in vm.forwardGroups\" ng-value=\"item._id\">{{item.name}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"vm.loading\"><md-progress-circular ng-disabled=\"!vm.loading\" class=\"md-accent\" md-diameter=\"40\">\n</md-progress-circular></div><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"30\"><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.loading || vm.selectedSubscribersForwardGroup.length < 1\" \nng-click=\"vm.batchForwardGroupAssignment()\" translate=\"BULK_ALLOCATION_APPLY\">Apply</md-button></div><choose-list \nselected-elements=\"vm.selectedSubscribersForwardGroup\" not-selected-elements=\"vm.notSelectedSubscriberForwardGroup\" \npagination-id=\"vm.forwardGroupPaginationClass\" member-count-limit=\"vm.subscriberLength\" error=\"false\"></choose-list>\n</md-content></div></div></md-content>");
$templateCache.put("app/main/restricted/organization/batch/tabs/interactive.license.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><p><span translate=\"BULK_SUBSCRIBERS_COUNT\">Subscribers Count</span>\n : {{vm.notSelectedSubscriberLicense.length}}</p></div><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"40\"><p>\n{{vm.resultLicensesLog}}</p></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex><label>\n<span translate=\"BULK_SELECT_LICENSE\">Select License</span></label><md-select name=\"defaultGroup\" \nng-model=\"vm.selectedLicense\" required><md-option ng-value=\"CUSTOM\">{{\'CUSTOM\'}}</md-option><md-option \nng-repeat=\"item in vm.licenseTemplates\" ng-value=\"item\" ng-click=\"vm.chooseTemplateIterative(item.name)\">{{item.name}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-list flex><md-subheader \nclass=\"md-no-sticky\" translate=\"LICENSE_PERMISSIONS\">Permissions</md-subheader><subscriber-permission-item \npermission-name=\"\'Conference\'\" permission-sub-item-name=\"\'Disable Conference Origination\'\" \npermission-sub-item=\"vm.license.conference.originate\" permission-visible=\"vm.license.conference.terminate\" \npermission-item=\"vm.license.conference.terminate\" show-sub-item=\"true\" is-edit=\"vm.selectedLicense != null\">\n</subscriber-permission-item><subscriber-permission-item permission-name=\"\'Radio\'\" \npermission-visible=\"vm.license.radio\" permission-item=\"vm.license.radio\" show-sub-item=\"false\" \nis-edit=\"vm.selectedLicense != null\"></subscriber-permission-item><subscriber-permission-item \npermission-name=\"\'Ad Hoc\'\" permission-sub-item-name=\"\'Disable Ad Hoc Origination\'\" \npermission-sub-item=\"vm.license.adHoc.originate\" permission-visible=\"vm.license.adHoc.terminate\" \npermission-item=\"vm.license.adHoc.terminate\" show-sub-item=\"true\" is-edit=\"vm.selectedLicense != null\">\n</subscriber-permission-item><subscriber-permission-item permission-name=\"\'Private\'\" \npermission-sub-item-name=\"\'Disable Private Origination\'\" permission-sub-item=\"vm.license.private.originate\" \npermission-visible=\"vm.license.private.terminate\" permission-item=\"vm.license.private.terminate\" show-sub-item=\"true\" \nis-edit=\"vm.selectedLicense != null\"></subscriber-permission-item><subscriber-permission-item \npermission-name=\"\'Smart Off-Net\'\" permission-visible=\"vm.license.startOffNet\" permission-item=\"vm.license.startOffNet\" \nshow-sub-item=\"false\" is-edit=\"vm.selectedLicense != null\"></subscriber-permission-item><subscriber-permission-item \npermission-name=\"\'IM\'\" permission-sub-item-name=\"\'Disable IM Origination\'\" \npermission-sub-item=\"vm.license.im.originate\" permission-visible=\"vm.license.im.terminate\" \npermission-item=\"vm.license.im.terminate\" show-sub-item=\"true\" is-edit=\"vm.selectedLicense != null\">\n</subscriber-permission-item><subscriber-permission-item permission-name=\"\'GPS\'\" permission-visible=\"vm.license.gps\" \npermission-item=\"vm.license.gps\" show-sub-item=\"false\" is-edit=\"vm.selectedLicense != null\">\n</subscriber-permission-item><subscriber-permission-item permission-name=\"\'Emergency\'\" \npermission-visible=\"vm.license.sos\" permission-item=\"vm.license.sos\" show-sub-item=\"false\" \nis-edit=\"vm.selectedLicense != null\"></subscriber-permission-item><subscriber-permission-item \npermission-name=\"\'Dispatcher\'\" permission-visible=\"vm.license.dispatcher\" permission-item=\"vm.license.dispatcher\" \npermission-parent-item=\"vm.license.webDispatcher\" show-sub-item=\"false\" is-edit=\"vm.selectedLicense != null\">\n</subscriber-permission-item><subscriber-permission-item permission-name=\"\'Web Dispatcher\'\" \npermission-visible=\"vm.license.webDispatcher\" permission-item=\"vm.license.webDispatcher\" \npermission-parent-item=\"vm.license.dispatcher\" show-sub-item=\"false\" is-edit=\"vm.selectedLicense != null\">\n</subscriber-permission-item><subscriber-permission-item permission-name=\"\'Priority Call\'\" \npermission-visible=\"vm.license.priorityCall\" permission-item=\"vm.license.priorityCall\" show-sub-item=\"false\" \nis-edit=\"vm.selectedLicense != null\"></subscriber-permission-item></md-list></div><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"30\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.loading || vm.selectedSubscribersLicense.length < 1 || (!vm.selectedLicense && !vm.customLicense)\" \nng-click=\"vm.batchLicenseAssignment()\" translate=\"BULK_ALLOCATION_APPLY\">Apply</md-button></div>\n<choose-list-bulk-license selected-elements=\"vm.selectedSubscribersLicense\" \nnot-selected-elements=\"vm.notSelectedSubscriberLicense\" pagination-id=\"vm.LicensePaginationClass\" \nmember-count-limit=\"vm.subscriberLength\" error=\"false\"></choose-list-bulk-license></md-content></div></div>\n</md-content>");
$templateCache.put("app/main/restricted/organization/batch/tabs/interactive.role.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><p><span translate=\"BULK_SUBSCRIBERS_COUNT\">Subscribers Count</span>\n : {{vm.notSelectedSubscriberRole.length}}</p></div><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"40\"><p>\n{{vm.resultRolesLog}}</p></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex><label>\n<span translate=\"BULK_SELECT_ROLE\">Select Role</span></label><md-select name=\"defaultGroup\" \nng-model=\"vm.selectedRoleId\" ng-change=\"vm.onRoleChange()\" required><md-option ng-repeat=\"item in vm.roles\" \nng-value=\"item._id\">{{item.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.loading\"><md-progress-circular ng-disabled=\"!vm.loading\" \nclass=\"md-accent\" md-diameter=\"40\"></md-progress-circular></div><div layout=\"column\" layout-align-gt-sm=\"row\" \nflex=\"30\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.loading || vm.selectedSubscribersRole.length < 1 || !vm.selectedRole\" \nng-click=\"vm.batchRoleAssignment()\" translate=\"BULK_ALLOCATION_APPLY\">Apply</md-button></div><choose-list \nselected-elements=\"vm.selectedSubscribersRole\" not-selected-elements=\"vm.notSelectedSubscriberRole\" \npagination-id=\"vm.rolePaginationClass\" member-count-limit=\"vm.subscriberLength\" error=\"false\"></choose-list>\n</md-content></div></div></md-content>");
$templateCache.put("app/main/restricted/organization/batch/tabs/interactive.sms.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"!vm.keys\"><md-input-container flex><span translate=\"SMS_MISSING_KEYS\" class=\"error-msg\">\nThis Organization doesn\'t have saved keys to send SMS</span></md-input-container></div><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><p><span translate=\"BULK_SUBSCRIBERS_COUNT\">Subscribers Count</span>\n : {{vm.notSelectedMobile.length}}</p></div><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"40\"><p>{{vm.resultLog}}\n</p></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.loading\"><md-progress-circular \nng-disabled=\"!vm.loading\" class=\"md-accent\" md-diameter=\"40\"></md-progress-circular></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex><label translate=\"SMS_DOWNLOAD_LINK\">Download Link</label>\n<input type=\"text\" name=\"downloadLink\" ng-model=\"vm.sms.downloadLink\" aria-invalid=\"true\"></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex><label translate=\"SMS_MESSAGE\">message\n</label><input type=\"text\" name=\"message\" ng-model=\"vm.sms.msg\" aria-invalid=\"true\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-button class=\"md-raised md-accent\" item-width=\"500px\" \nng-disabled=\"vm.loading || vm.selectedSubscribersSms.length < 1 || !vm.keys\" ng-click=\"vm.batchSms(\'Credentials\')\" \ntranslate=\"SMS_SEND_CREDENTIAL\">Send SMS with Subsciber Credentials</md-button><md-button class=\"md-raised md-accent\" \nitem-width=\"500px\" ng-disabled=\"vm.loading || vm.selectedSubscribersSms.length < 1 || !vm.keys\" \nng-click=\"vm.batchSms(\'CredentialsWithServer\')\" translate=\"SMS_SEND_CREDENTIALS_WITH_SERVER\">\nSend SMS Credentials with server</md-button><md-button class=\"md-raised md-accent\" item-width=\"500px\" \nng-disabled=\"vm.loading || vm.selectedSubscribersSms.length < 1 || !vm.sms.downloadLink || !vm.keys\" \nng-click=\"vm.batchSms(\'DownloadLink\')\" translate=\"SMS_SEND_DOWNLOAD_LINK\">Send SMS with Download Link</md-button>\n<md-button class=\"md-raised md-accent\" item-width=\"500px\" \nng-disabled=\"vm.loading || vm.selectedSubscribersSms.length < 1 || !vm.sms.downloadLink || !vm.keys\" \nng-click=\"vm.batchSms(\'Both\')\" translate=\"SMS_SEND_CREDENTIALS_AND_DOWNLOAD_LINK\">\nSend SMS with Credentials and Download Link</md-button><md-button class=\"md-raised md-accent\" item-width=\"20px\" \nng-disabled=\"vm.loading || vm.selectedSubscribersSms.length < 1 || !vm.sms.msg || !vm.keys\" \nng-click=\"vm.batchSms(\'Message\')\" translate=\"SMS_SEND_MESSAGE\">send SMS with current message</md-button></div>\n<choose-list selected-elements=\"vm.selectedSubscribersSms\" not-selected-elements=\"vm.notSelectedMobile\" \npagination-id=\"vm.smsPaginationClass\" member-count-limit=\"vm.notSelectedMobile.length\" error=\"false\"></choose-list>\n</md-content></div></div></md-content>");
$templateCache.put("app/main/restricted/organization/batch/tabs/interactive.subscriber.list.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><label><input type=\"radio\" ng-model=\"vm.templateType\" id=\"vm.templateType\" value=\"Subscribers\" \nng-click=\"vm.changeContactTemplateList()\" checked=\"checked\"><label translate=\"BULK_CONTACT_TEMPLATE_SUBSCRIBERS\">\n</label></label><label><input type=\"radio\" ng-model=\"vm.templateType\" id=\"vm.templateType\" value=\"ContactTemplate\" \nng-click=\"vm.changeContactTemplateList()\"><label translate=\"BULK_CONTACT_TEMPLATE_TEMPLATES\"></label></label></div>\n<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><p><span translate=\"BULK_SUBSCRIBERS_COUNT\">Subscribers Count</span>\n : {{vm.notSelectedAssignContactTemplate.length}}</p></div><div layout=\"column\" layout-align-gt-sm=\"row\" flex=\"100\"><p>\n{{vm.resultContactTemplateLog}}</p></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex>\n<label><span translate=\"BULK_SELECT_CONTACT_TEMPLATE\">Select Contact Template</span></label><md-select \nname=\"contactTemplate\" ng-model=\"vm.selectedContactTemplateId\" required><md-option \nng-repeat=\"item in vm.contactTemplates\" ng-value=\"item._id\">{{item.name}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.loading || vm.selectedAssignContactTemplate.length < 1 || !vm.selectedContactTemplateId\" \nng-click=\"vm.batchContactTemplateAssignment(\'Add\')\" translate=\"BULK_CONTACT_TEMPLATE_ADD\">Apply</md-button><md-button \nclass=\"md-raised md-accent\" \nng-disabled=\"vm.loading || vm.selectedAssignContactTemplate.length < 1 || !vm.selectedContactTemplateId\" \nng-click=\"vm.batchContactTemplateAssignment(\'Remove\')\" translate=\"BULK_CONTACT_TEMPLATE_REMOVE\">Apply</md-button></div>\n<choose-list selected-elements=\"vm.selectedAssignContactTemplate\" \nnot-selected-elements=\"vm.notSelectedAssignContactTemplate\" pagination-id=\"vm.contactTemplatePaginationClass\" \nmember-count-limit=\"vm.assignLength\" error=\"false\"></choose-list></md-content></div></div></md-content>");
$templateCache.put("app/main/restricted/organization/batch/tabs/report.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><p><span translate=\"BULK_SUBSCRIBERS_COUNT\">Subscribers Count</span>\n : {{vm.subscribers.length}}</p></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nng-if=\"vm.loading\"><md-progress-circular ng-disabled=\"!vm.loading\" class=\"md-accent\" md-diameter=\"40\">\n</md-progress-circular></div><md-card style=\"width: 700px\"><md-card-header><md-card-header-text><span class=\"md-title\" \ntranslate=\"BULK_RESULT_LOG\">Result Log</span></md-card-header-text></md-card-header><md-content-card \nstyle=\"max-height: 200px; overflow-y: auto\"><p>{{vm.resultLog}}</p><p ng-repeat=\"error in vm.errorLog track by $index\">\n{{error}}</p></md-content-card></md-card><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"row\" flex=\"30\">\n<label><input type=\"radio\" ng-model=\"vm.exportTypeRuntime\" id=\"vm.exportTypeRuntime\" value=\"csv\" \nng-disabled=\"vm.loading\">CSV</label><label style=\"margin-left: 3%\"><input type=\"radio\" ng-model=\"vm.exportTypeRuntime\" \nid=\"vm.exportTypeRuntime\" value=\"excel\" ng-disabled=\"vm.loading\">Excel</label><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.loading || vm.subscribers.length < 1\" ng-csv=\"vm.getDetailedSubscribersList_runtime()\" \nlazy-load=\"true\" add-bom=\"true\" csv-header=\"vm.subscriberRuntimeFields\" \nfilename=\"{{vm.timestamp| date:\'dd-MMM-yyyy\'}}-{{vm.organization.name}}-runtime.csv\" \nstyle=\"min-width: min-content; width: -webkit-fill-available\"><label translate=\"BULK_EXPORT_RUNTIME\">Export Runtime\n</label></md-button></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"row\" flex=\"30\" \nng-if=\"vm.showAdminRecord\"><label><input type=\"radio\" ng-model=\"vm.exportTypeAdminRecord\" \nid=\"vm.exportTypeAdminRecord\" value=\"csv\" ng-disabled=\"vm.loading\">CSV</label><label style=\"margin-left: 3%\"><input \ntype=\"radio\" ng-model=\"vm.exportTypeAdminRecord\" id=\"vm.exportTypeAdminRecord\" value=\"excel\" ng-disabled=\"vm.loading\">\nExcel</label><md-button class=\"md-raised md-accent\" ng-disabled=\"vm.loading\" ng-csv=\"vm.getDetailedAdminRecord()\" \nlazy-load=\"true\" add-bom=\"true\" csv-header=\"vm.adminRecordFields\" \nfilename=\"{{vm.timestamp| date:\'dd-MMM-yyyy\'}}-{{vm.organization.name}}-adminRecords.csv\" \nstyle=\"min-width: min-content; width: -webkit-fill-available\"><label translate=\"BULK_EXPORT_ADMIN_RECORDS\">\nExport Admin Records</label></md-button></div></md-content></div></div></md-content>");
$templateCache.put("app/main/restricted/organization/callLogs/details/callLogs.dialog.html","<md-dialog aria-label=\"Bursts\" class=\"md-dialog-wide\"><md-toolbar><div class=\"md-toolbar-tools\"><h1 \ntranslate=\"CALL_LOGS_DIALOG_TITLE\">Bursts</h1><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content>\n<table class=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sort(\'talker_name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'talker_name\')\" translate=\"CALL_LOGS_BURST_TALKER_NAME\">Talker Name</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.showId\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CALL_LOGS_BURST_TALKER_ID\">Talker Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"CALL_LOGS_BURST_TALKER_START_TIME\">Start time</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CALL_LOGS_BURST_DURATION\">\nDuration</span></div></th></tr></thead><tbody><tr title=\"{{vm.showId ? burst.talker_id : \'\'}}\" style=\"height: 30px\" \ndir-paginate=\"burst in vm.session |searchByTalkerName:vm.search |itemsPerPage:vm.recordsCountDialog track by burst._id\" \nng-class-odd=\"\'odd\'\" pagination-id=\"burstsRecords\"><td width=\"25%\" class=\"table-name-label\">{{::burst.talker_name}}\n</td><td width=\"25%\" class=\"table-name-label\" ng-if=\"vm.showId\">{{::burst.talker_id}}</td><td width=\"25%\" \nclass=\"table-name-label\">{{::burst.format_start_time}}</td><td width=\"25%\" class=\"table-name-label\">\n{{::burst.duration}}</td></tr></tbody></table><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex \nlayout-align=\"flex-start center\"><md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select \nng-model=\"vm.recordsCountDialog\" ng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \npagination-id=\"burstsRecords\" max-size=\"1\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls>\n</div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/restricted/organization/contacts/details/contact.dialog.html","<md-dialog aria-label=\"Subscriber\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"CONTACTS_DIALOG_TITLE\">\nContacts details</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \naria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"with-tabs\"><md-tabs \nmd-dynamic-height><md-tab><md-tab-label><span translate=\"APP_GENERAL\">General2</span></md-tab-label><md-tab-body>\n<md-content class=\"timeline-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/contacts/details/tabs/general.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab ng-disabled=\"!vm.contact.name || !vm.allowReadSubscribers\" ng-if=\"vm.contact.memberType != 2\"><md-tab-label>\n<span translate=\"CONTACTS_CONTACT_LISTS\">Contact Lists</span></md-tab-label><md-tab-body><md-content \nclass=\"photos-videos-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/contacts/details/tabs/members.details.html\'\"></md-content></md-tab-body>\n</md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.cancel()\" translate=\"APP_CANCEL\" ng-disabled=\"!vm.flagSave\">Cancel</md-button><md-button \nng-disabled=\"!vm.contact.name || vm.readyToSave || ( !vm.allowCreate && !vm.contact._id) || (!vm.allowModify && vm.contact._id) || !vm.flagSave\" \nng-click=\"vm.ok()\" translate=\"APP_SAVE\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/restricted/organization/emergency-group/details/emergency.group.dialog.html","<md-dialog aria-label=\"Subscriber\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"EMERGENCY_GROUP_DETAILS\">\nContacts Template Details</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \naria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"with-tabs\"><md-tabs \nmd-dynamic-height><md-tab><md-tab-label><span translate=\"APP_GENERAL\">General</span></md-tab-label><md-tab-body>\n<md-content class=\"timeline-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/emergency-group/details/tabs/general.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-disabled=\"!vm.emergencyGroup.name || !vm.allowReadSubscribers\"><md-tab-label><span \ntranslate=\"GROUPS_GROUP_LISTS\">group Lists</span></md-tab-label><md-tab-body><md-content \nclass=\"photos-videos-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/emergency-group/details/tabs/members.details.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.cancel()\" translate=\"APP_CANCEL\" ng-disabled=\"!vm.flagSave\">Cancel</md-button><md-button \nng-disabled=\"!vm.emergencyGroup.name || ( !vm.allowCreate && !vm.emergencyGroup._id) || (!vm.allowModify && vm.emergencyGroup._id) || !vm.flagSave\" \nng-click=\"vm.ok()\" translate=\"APP_SAVE\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/restricted/organization/groups/details/groups.details.html","<md-dialog aria-label=\"Subscriber\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"GROUPS_DIALOG_TITLE\">\nGroup details</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \naria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"with-tabs\"><md-tabs \nmd-dynamic-height><md-tab><md-tab-label><span translate=\"APP_GENERAL\">General</span></md-tab-label><md-tab-body>\n<md-content class=\"padding-tab timeline-tab\" \nng-include=\"\'app/main/restricted/organization/groups/details/tabs/general.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab ng-disabled=\"!vm.group.name || !vm.group.type || !vm.group.site || !vm.allowReadSubscribers || vm.loading\" \nng-if=\"!vm.crossFleet && (vm.group.memberType != 2)\" ng-click=\"vm.changeDropValue()\"><md-tab-label><span \ntranslate=\"GROUPS_GROUP_LISTS\">Details</span></md-tab-label><md-tab-body><md-content class=\"padding-tab about-tab\" \nng-include=\"\'app/main/restricted/organization/groups/details/tabs/subscribers.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab \nng-disabled=\"!vm.group.name || !vm.group.type || !vm.group.site || !vm.allowReadSubscribers || vm.loading\" \nng-if=\"vm.crossFleet && (vm.group.memberType != 2)\" ng-click=\"vm.changeDropValue()\"><md-tab-label><span \ntranslate=\"GROUPS_GROUP_LISTS\">Details</span></md-tab-label><md-tab-body><md-content class=\"padding-tab about-tab\" \nng-include=\"\'app/main/restricted/organization/groups/details/tabs/subscribers.select.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab \nng-disabled=\"!vm.group.name || !vm.group.type || !vm.group.site || !vm.allowReadSubscribers || vm.loading\" \nng-if=\"vm.group.type == 10 && !vm.crossFleet\" ng-click=\"vm.changeDropValue()\"><md-tab-label><span translate=\"\">\nRegister User</span></md-tab-label><md-tab-body><md-content class=\"padding-tab about-tab\" \nng-include=\"\'app/main/restricted/organization/groups/details/tabs/register_users.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab \nng-disabled=\"!vm.group.name || !vm.group.type || !vm.group.site || !vm.allowReadSubscribers || vm.loading\" \nng-if=\"vm.group.type == 10 && vm.crossFleet\" ng-click=\"vm.changeDropValue()\"><md-tab-label><span translate=\"\">\nRegister User</span></md-tab-label><md-tab-body><md-content class=\"padding-tab about-tab\" \nng-include=\"\'app/main/restricted/organization/groups/details/tabs/register_users.select.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab \nng-disabled=\"!vm.group.name || !vm.group.type || !vm.group.site || !vm.allowReadSubscribers || vm.loading\" \nng-if=\"(vm.group.type == 1 || vm.group.type == 2) && !vm.crossFleet && vm.showMutedSubscriberGrp && (vm.group.memberType != 2)\">\n<md-tab-label><span translate=\"APP_IS_MUTED\">Is Muted</span></md-tab-label><md-tab-body><md-content \nclass=\"padding-tab timeline-tab\" \nng-include=\"\'app/main/restricted/organization/groups/details/tabs/mutedsubscribers.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab \nng-disabled=\"!vm.group.name || !vm.group.type || !vm.group.site || !vm.allowReadSubscribers || vm.loading\" \nng-if=\"(vm.group.type == 1 || vm.group.type == 2) && vm.crossFleet && vm.showMutedSubscriberGrp && (vm.group.memberType != 2)\">\n<md-tab-label><span translate=\"APP_IS_MUTED\">Is Muted</span></md-tab-label><md-tab-body><md-content \nclass=\"padding-tab timeline-tab\" \nng-include=\"\'app/main/restricted/organization/groups/details/tabs/mutedsubscribers.select.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" ng-disabled=\"vm.loading\"><span \nflex></span><md-button ng-click=\"vm.cancel()\" translate=\"APP_CANCEL\" ng-disabled=\"!vm.flagSave\">Cancel</md-button>\n<md-button translate=\"APP_SAVE\" \nng-disabled=\"!vm.group.name || !vm.group.type || !vm.group.site || vm.readyToSave || ( !vm.allowCreate && !vm.group._id) || (!vm.allowModify && vm.group._id) || !vm.flagSave || vm.loading\" \nng-click=\"vm.ok()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/restricted/organization/locationHistory/details/locationHistory.dialog.html","<md-dialog aria-label=\"Bursts\" class=\"md-dialog-wide\"><md-toolbar><div class=\"md-toolbar-tools\"><h1 \ntranslate=\"LOCATION_ACTIVITY\">Location History</h1><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content>\n<table class=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sort(\'talker_name\')\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LOCATION_LATITUDE\">\nLatitude</span></div></th><th class=\"secondary-text\" ng-if=\"vm.showId\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"LOCATION_LONGITUDE\">Longitude</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LOCATION_ACCURANCY\">Accuracy</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LOCATION_DATE_TIME\">Date Time\n</span></div></th></tr></thead><tbody><tr style=\"height: 30px\" \ndir-paginate=\"location in vm.sessionData |itemsPerPage:vm.recordsCountDialog track by location._id\" \nng-class-odd=\"\'odd\'\" pagination-id=\"burstsRecords\"><td width=\"25%\" class=\"table-name-label\">{{::location.lat}}</td><td \nwidth=\"25%\" class=\"table-name-label\">{{::location.lon}}</td><td width=\"25%\" class=\"table-name-label\">\n{{::location.accuracy}}</td><td width=\"25%\" class=\"table-name-label\">{{::location.format_created_at}}</td></tr></tbody>\n</table><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCountDialog\" \nng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option \nng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"end center\"><dir-pagination-controls pagination-id=\"burstsRecords\" max-size=\"1\" \ndirection-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/restricted/organization/organization-details/tabs/organization.general.html","<form name=\"vm.orgForm\" class=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" \nnovalidate=\"\"><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container \nmd-no-float flex=\"100\"><label translate=\"ORGANIZATION_CRMID\">CRMID</label><input type=\"text\" name=\"crmId\" \nng-model=\"vm.organization.crmId\" aria-invalid=\"true\" md-maxlength=\"40\" required><div \nng-messages=\"vm.orgForm.crmId.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\">\n<label for=\"oname\" translate=\"ORGANIZATION_ONAME\">Organization name</label><input type=\"text\" name=\"name\" \nng-model=\"vm.organization.name\" id=\"oname\" translate aria-invalid=\"true\" md-maxlength=\"40\" required><div \nng-messages=\"vm.orgForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">\nThis field is required</span></div><div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">\nThis field is too long</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label for=\"domain\" \ntranslate=\"ORGANIZATION_DOMAIN\">Domain name</label><input type=\"text\" name=\"domainName\" \nng-model=\"vm.organization.domain\" id=\"domain\" translate aria-invalid=\"true\" md-maxlength=\"50\" readonly=\"readonly\" \nrequired><div ng-messages=\"vm.orgForm.domainName.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" ng-if=\"false\"><md-input-container \nmd-no-float flex=\"100\"><label for=\"domain\" translate=\"ORGANIZATION_ADDRESS\">Address</label><input type=\"text\" \nname=\"address\" ng-model=\"vm.organization.address\" id=\"address\" translate aria-invalid=\"true\"><div \nng-messages=\"vm.orgForm.address.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label translate=\"ORGANIZATION_SITE\">Site\n</label><md-select name=\"site\" ng-model=\"vm.organization.site\" required><md-option ng-repeat=\"site in vm.sites\" \nvalue=\"{{site._id}}\">{{site.name}}</md-option></md-select><div ng-messages=\"vm.orgForm.site.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><label><input type=\"radio\" ng-model=\"recorder\" \nvalue=\"none\"> None</label><br><label><input type=\"radio\" ng-model=\"recorder\" ng-value=\"selective\"> Selective</label>\n<br><label><input type=\"radio\" ng-model=\"recorder\" value=\"noneSelective\"> None Selective</label><br><tt>\nrecorder = {{recorder | json}}</tt><br></div></form>");
$templateCache.put("app/main/restricted/organization/organization-details/tabs/organization.license.html","<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'licenseBundle.name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'licenseBundle.name\')\" translate=\"LICENSE_BUNDLE\">Bundle</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'licenseType\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'licenseType\')\" translate=\"LICENSE_TYPE\">License Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_ALLOCATION_DATE\">\nAllocation Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LICENSE_EXPIRATION_TYPE\">Expiration Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_EXPIRATION_DATE\">Expiration Date</span></div></th>\n<th class=\"secondary-text\" ng-click=\"vm.sort(\'qty\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'qty\')\" translate=\"LICENSE_QUANTITY\">Quantity</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_QUANTITY\">Quantity</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.licenses\"><td class=\"table-name-label\" ng-click=\"vm.editLicense(item)\"><b>\n{{item.name}}</b></td><td>{{item.type}}</td><td>{{item.allocated | date: medium}}</td><td>{{item.expType}}</td><td>\n{{item.expire | date: medium}}</td><td>{{item.qty}}</td></tr></tbody></table></div>");
$templateCache.put("app/main/restricted/organization/recording/tabs/admin.record.html","<div class=\"content-card\"><div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div><md-button \nclass=\"add-button md-fab md-warn\" ng-click=\"vm.addAdmin()\" ng-disabled=\"!vm.allowCreate || !vm.organizationId\" \naria-label=\"Add\" translate><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content \nng-if=\"vm.organizationId\"><table class=\"dataTable row-border stripe hover\" ng-if=\"vm.organizationId\"><thead><tr><th \nclass=\"secondary-text\" ng-click=\"vm.sortAdmin(\'username\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'username\')\" translate=\"ADMIN_RECORD_EMAIL_ID\">Email</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sortAdmin(\'last_login_time\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'last_login_time\')\" translate=\"ADMIN_RECORD_LAST_LOGIN_TIME\">Last login time</span></div>\n</th><th class=\"secondary-text\" ng-click=\"vm.sortAdmin(\'last_activity_time\')\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-class=\"vm.getSortingClass(\'last_activity_time\')\" translate=\"ADMIN_RECORD_LAST_ACTIVITY_TIME\">\nLast activity time</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortAdmin(\'last_password_change_timestamp\')\" ng-if=\"vm.showChangePassword\"><div class=\"table-header\"><span\n class=\"column-title\" ng-class=\"vm.getSortingClass(\'last_password_change_timestamp\')\" \ntranslate=\"USER_LAST_PASSWORD_CHANGE_TIME\">Last password change time</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.showBlockRelease && vm.maxLoginRetries != 0\" style=\"text-align: center\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"APP_RELEASE\">Release</span></div></th><th class=\"end-column secondary-text\" \nng-if=\"vm.allowDelete\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div>\n</th></tr></thead><tbody><tr title=\"{{vm.showId ? admin.admin_id : \'\'}}\" \ndir-paginate=\"admin in vm.adminsList |searchByUsername:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\" , pagination-id=\"vm.adminsPaginationClass\"><td width=\"20%\" \nng-if=\"!vm.showBlockRelease || !admin.isLock || vm.maxLoginRetries == 0\" class=\"table-name-label\" \nng-click=\"vm.editAdmin(admin)\">{{admin.username}}</td><td width=\"20%\" \nng-if=\"vm.showBlockRelease && admin.isLock && vm.maxLoginRetries != 0\" style=\"color: red\" class=\"table-name-label\" \nng-click=\"vm.editAdmin(admin)\">{{admin.username}}</td><td width=\"20%\" class=\"table-name-label\">\n{{admin.last_login_time}}</td><td width=\"20%\" class=\"table-name-label\">{{admin.last_activity_time}}</td><td \nwidth=\"20%\" class=\"table-name-label\" ng-if=\"vm.showChangePassword\">{{admin.last_password_change_timestamp}}</td><td \nwidth=\"20%\" ng-if=\"vm.showBlockRelease && !admin.isLock && vm.maxLoginRetries != 0\" class=\"align-center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.blockAdmin(admin)\" translate translate-attr-aria-label=\"APP_RELEASE\"><md-icon \nmd-font-icon=\"icon-lock-unlocked-outline\"></md-icon></md-button></td><td width=\"20%\" \nng-if=\"vm.showBlockRelease && admin.isLock && vm.maxLoginRetries != 0\" class=\"align-center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.releaseAdmin(admin)\" translate translate-attr-aria-label=\"APP_RELEASE\"><md-icon \nmd-font-icon=\"icon-lock-outline\" style=\"color: red\"></md-icon></md-button></td><td class=\"end-column\" \nng-if=\"vm.allowDelete\"><md-button class=\"edit-button md-icon-button\" aria-label=\"organisation details\" translate \ntranslate-attr-aria-label=\"APP_DELETE\" ng-click=\"vm.deleteUser(admin.admin_id)\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content \nng-if=\"!vm.adminsList.length\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\"><p class=\"pd-2\" translate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div>\n</md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\" pagination-id=\"vm.adminsPaginationClass\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \nmax-size=\"1\" direction-links=\"true\" boundary-links=\"true\" pagination-id=\"vm.adminsPaginationClass\">\n</dir-pagination-controls></div></div></md-content></div>");
$templateCache.put("app/main/restricted/organization/recording/tabs/audio.backup.path.html","<div class=\"content-card\"><div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\"></div><md-button \nclass=\"add-button md-fab md-warn\" ng-click=\"vm.addPath()\" ng-disabled=\"!vm.organizationId\" aria-label=\"Add\" translate>\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content ng-if=\"vm.organizationId\"><table \nclass=\"dataTable row-border stripe hover\" ng-if=\"vm.organizationId\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sortPath(\'folder_date\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'folder_date\')\" translate=\"AUDIO_BACKUP_FOLDER_DATE\">Date</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sortPath(\'path\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'path\')\" translate=\"AUDIO_BACKUP_PATH\">path</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.allowDelete\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div>\n</th></tr></thead><tbody><tr title=\"{{vm.showId ? record._id : \'\'}}\" \ndir-paginate=\"record in vm.pathsList |itemsPerPage:vm.recordsCount track by $index\" ng-class-odd=\"\'odd\'\" , \npagination-id=\"vm.pathsPaginationClass\"><td width=\"30%\" class=\"table-name-label\">\n{{record.folder_date | date:\'MMM-yyyy\'}}</td><td width=\"60%\" class=\"table-name-label\">{{record.path}}</td><td \nwidth=\"10%\" ng-if=\"vm.allowDelete\"><md-button class=\"edit-button md-icon-button\" aria-label=\"organisation details\" \ntranslate translate-attr-aria-label=\"APP_DELETE\" ng-click=\"vm.deletePath(record._id)\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content \nng-if=\"!vm.pathsList.length\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\"><p class=\"pd-2\" translate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div>\n</md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\" pagination-id=\"vm.pathsPaginationClass\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \nmax-size=\"1\" direction-links=\"true\" boundary-links=\"true\" pagination-id=\"vm.pathsPaginationClass\">\n</dir-pagination-controls></div></div></md-content></div>");
$templateCache.put("app/main/restricted/organization/recording/tabs/white.list.groups.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><choose-list \nselected-elements=\"vm.selectedGroups\" not-selected-elements=\"vm.notSelectedGroups\" \npagination-id=\"vm.groupsPaginationClass\" member-count-limit=\"vm.groups.length\" another-limit=\"true\" error=\"false\">\n</choose-list></md-content><md-button md-no-ink class=\"md-primary\" ng-click=\"vm.saveWhiteList(\'groups\')\" aria-label=\"\" \ntranslate=\"BUTTON_SAVE_RECORDED_GROUPS\">Save Recorded Groups</md-button></div></div></md-content>");
$templateCache.put("app/main/restricted/organization/recording/tabs/white.list.subscribers.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><choose-list \nselected-elements=\"vm.selectedSubscribers\" not-selected-elements=\"vm.notSelectedSubscribers\" \npagination-id=\"vm.subscribersPaginationClass\" member-count-limit=\"vm.subscribers.length\" another-limit=\"true\" \nerror=\"false\"></choose-list></md-content><md-button md-no-ink class=\"md-primary\" \nng-click=\"vm.saveWhiteList(\'subscribers\')\" aria-label=\"\" translate=\"BUTTON_SAVE_RECORDED_SUBSCRIBERS\">\nSave Recorded Subscribers</md-button></div></div></md-content>");
$templateCache.put("app/main/restricted/organization/subscriberLists/details/subscriberList.dialog.html","<md-dialog aria-label=\"Subscriber\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"PERSONAL_CONTACTS_TEMPLATES_DETAILS\">Contacts Template Details</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"with-tabs\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"APP_GENERAL\">General</span></md-tab-label><md-tab-body><md-content class=\"timeline-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscriberLists/details/tabs/general.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-disabled=\"!vm.subscriberList.name || !vm.allowReadSubscribers\"><md-tab-label><span \ntranslate=\"CONTACTS_CONTACT_LISTS\">Contact Lists</span></md-tab-label><md-tab-body><md-content \nclass=\"photos-videos-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscriberLists/details/tabs/members.details.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.cancel()\" translate=\"APP_CANCEL\" ng-disabled=\"!vm.flagSave\">Cancel</md-button><md-button \nng-disabled=\"!vm.subscriberList.name || ( !vm.allowCreate && !vm.subscriberList._id) || (!vm.allowModify && vm.subscriberList._id) || !vm.flagSave\" \nng-click=\"vm.ok()\" translate=\"APP_SAVE\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/restricted/organization/subscribers/details/add.subscriber.dialog.html","<md-dialog aria-label=\"Subscriber\" class=\"md-dialog-wide\"><md-toolbar><div class=\"md-toolbar-tools\"><h1 \ntranslate=\"SUBSCRIBERS_DIALOG_TITLE\">Subscriber</h1><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"with-tabs\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"SUBSCRIBERS_GENERAL\">General</span>\n</md-tab-label><md-tab-body><md-content class=\"timeline-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/add.general.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges(1)\" ng-if=\"::vm.isActionAllowed(\'license_resource\',\'GET\')\">\n<md-tab-label><span translate=\"SUBSCRIBERS_LICENSE\">License Details</span></md-tab-label><md-tab-body><md-content \nclass=\"photos-videos-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/license.permissions.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"SUBSCRIBERS_GROUP_SUBSCRIBERS\">Group Details</span>\n</md-tab-label><md-tab-body><md-content class=\"about-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/group.details.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.showOcl\"><md-tab-label><span translate=\"SUBSCRIBERS_CONTACT_SUBSCRIBERS\">Contacts Details\n</span></md-tab-label><md-tab-body><md-content class=\"about-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/contact.details.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(1)\" ng-if=\"::vm.isActionAllowed(\'group_resource\',\'GET\')\">\n<md-tab-label><span translate=\"PERSONAL_CONTACTS_TEMPLATES\">subscriber lists</span></md-tab-label><md-tab-body>\n<md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/subscriber.list.details.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(1)\" \nng-if=\"::vm.isActionAllowed(\'subscriber_resource\',\'GET\')\"><md-tab-label><span translate=\"PERSONAL_CONTACTS\">\nPersonal Contacts</span></md-tab-label><md-tab-body><md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/personal.contacts.details.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span ng-if=\"!vm.checkErrors()\" \nflex></span> <span ng-if=\"vm.checkErrors()\" style=\"color: red\" flex>{{vm.errorMsg}}</span><md-button \nng-click=\"vm.cancel()\" translate=\"APP_CANCEL\" ng-disabled=\"!vm.flagSave\">Cancel</md-button><md-button \nng-model=\"vm.saveButton\" ng-click=\"vm.ok()\" translate=\"APP_SAVE\" \nng-disabled=\"vm.addSubscriberForm.$invalid || vm.addSubscriberForm.$pristine || vm.subscriberGroupForm.$invalid ||  !vm.subscriber.license || !vm.flagSave \">\nSave</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/restricted/organization/subscribers/details/revoke.license.dialog.html","<md-dialog aria-label=\"Revoke assignment?\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"SUBSCRIBERS_REVOKE_LICENSE_WARNING\">Do you really want to revoke the license?</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"cancel()\">Cancel\n</md-button><md-button ng-click=\"revoke()\">Revoke</md-button></md-dialog-actions></md-dialog-content></form>\n</md-dialog>");
$templateCache.put("app/main/restricted/organization/subscribers/details/subscriber.dialog.html","<md-dialog aria-label=\"Subscriber\" class=\"md-dialog-wide\"><md-toolbar><div class=\"md-toolbar-tools\"><h1 \ntranslate=\"SUBSCRIBERS_DIALOG_TITLE\">Subscriber</h1><h2>-</h2><h3>{{vm.subscriber.name}}</h3><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button>\n</div></md-toolbar><md-dialog-content class=\"with-tabs\"><md-tabs md-dynamic-height md-selected=\"vm.activeTab\"><md-tab \nmd-on-select=\"vm.onTabChanges(0)\" ng-disabled=\"vm.loading\"><md-tab-label><span translate=\"SUBSCRIBERS_GENERAL\">General\n</span></md-tab-label><md-tab-body><md-content class=\"timeline-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/general.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges(1)\" ng-if=\"::vm.isActionAllowed(\'subscriber_resource\',\'GET\')\" \nng-disabled=\"vm.loading\"><md-tab-label><span translate=\"SUBSCRIBERS_RUNTIME\">Runtime</span></md-tab-label><md-tab-body>\n<md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/runtime.details.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(2)\" \nng-if=\"::vm.isActionAllowed(\'license_resource\',\'GET\')\" ng-disabled=\"vm.loading\"><md-tab-label><span \ntranslate=\"SUBSCRIBERS_LICENSE\">License Details</span></md-tab-label><md-tab-body><md-content \nclass=\"photos-videos-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/license.permissions.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(3)\" ng-if=\"::vm.isActionAllowed(\'group_resource\',\'GET\')\" \nng-disabled=\"vm.loading\"><md-tab-label><span translate=\"SUBSCRIBERS_GROUP_SUBSCRIBERS\">Group Details</span>\n</md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/group.details.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges(4)\" ng-if=\"::vm.isActionAllowed(\'group_resource\',\'GET\') && vm.showOcl\" \nng-disabled=\"vm.loading\"><md-tab-label><span translate=\"SUBSCRIBERS_CONTACT_SUBSCRIBERS\">Contacts Details</span>\n</md-tab-label><md-tab-body><md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/contact.details.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(5)\" ng-if=\"::vm.isActionAllowed(\'group_resource\',\'GET\')\" \nng-disabled=\"vm.loading\"><md-tab-label><span translate=\"PERSONAL_CONTACTS_TEMPLATES\">subscriber lists</span>\n</md-tab-label><md-tab-body><md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/subscriber.list.details.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(6)\" ng-if=\"::vm.isActionAllowed(\'group_resource\',\'GET\')\" \nng-disabled=\"vm.loading\"><md-tab-label><span translate=\"PERSONAL_CONTACTS\">Personal Contacts</span></md-tab-label>\n<md-tab-body><md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/personal.contacts.details.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(7)\" \nng-if=\"::vm.isActionAllowed(\'subscriber_resource\',\'GET\')\" ng-disabled=\"vm.loading\"><md-tab-label><span \ntranslate=\"APP_QR_TWO_FACTOR\">Two Factor</span></md-tab-label><md-tab-body><md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/totp.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab md-on-select=\"vm.onTabChanges(8)\" ng-if=\"::vm.isActionAllowed(\'subscriber_resource\',\'GET\')\" \nng-disabled=\"vm.loading\"><md-tab-label><span translate=\"SUBSCRIBERS_ACTIVITY_LOG\">Activity Log</span></md-tab-label>\n<md-tab-body><md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/organization/subscribers/details/tabs/activity.html\'\"></md-content></md-tab-body>\n</md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span ng-if=\"!vm.checkErrors()\" flex></span> \n<span ng-if=\"vm.checkErrors()\" style=\"color: red\" flex>{{vm.errorMsg}}</span><md-button ng-click=\"vm.cancel()\" \ntranslate=\"APP_CANCEL\" ng-if=\"vm.addButtonDisableFlag\" ng-disabled=\"!vm.flagSave\">Cancel</md-button><md-button \nng-disabled=\"vm.loading || vm.editSubscriberForm.$invalid || vm.subscriberGroupForm.$invalid || (vm.subscriber.adminrole_id ==1 ) || !vm.subscriber.license ||(!vm.subscriber.license && !vm.subscriber.permissions_mask) || !vm.allowModify || !vm.flagSave || vm.checkErrors()\" \nng-click=\"vm.ok()\" ng-if=\"vm.addButtonDisableFlag\" translate=\"APP_SAVE\">Save</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/restricted/organization/subscribers/sms/subscriber.send.sms.dialog.html","<md-dialog aria-label=\"Subscriber\" class=\"md-dialog-wide\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"SUBSCRIBERS_SMS_DIALOG_TITLE\">Send SMS</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-sms \nclass=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"!vm.keys\"><md-input-container flex><span translate=\"SMS_MISSING_KEYS\" class=\"error-msg\">\nThis Organization doesn\'t have saved keys to send SMS</span></md-input-container></div><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><p>{{vm.resultLog}}</p></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container md-no-float flex><label translate=\"SMS_DOWNLOAD_LINK\">Download Link</label><input type=\"text\" \nname=\"downloadLink\" ng-model=\"vm.sms.downloadLink\" aria-invalid=\"true\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex><label translate=\"SMS_MESSAGE\">message</label><input \ntype=\"text\" name=\"message\" ng-model=\"vm.sms.msg\" aria-invalid=\"true\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-button class=\"md-raised md-accent\" item-width=\"500px\" ng-disabled=\"vm.loading || !vm.keys\" \nng-click=\"vm.sendSMS(\'Credentials\')\" translate=\"SMS_SEND_CREDENTIAL\">Send SMS with Subsciber Credentials</md-button>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-button class=\"md-raised md-accent\" item-width=\"500px\" \nng-disabled=\"vm.loading || !vm.keys\" ng-click=\"vm.sendSMS(\'CredentialsWithServer\')\" \ntranslate=\"SMS_SEND_CREDENTIALS_WITH_SERVER\">Send SMS Credentials with server</md-button><md-button \nclass=\"md-raised md-accent\" item-width=\"500px\" ng-disabled=\"vm.loading || !vm.sms.downloadLink || !vm.keys\" \nng-click=\"vm.sendSMS(\'DownloadLink\')\" translate=\"SMS_SEND_DOWNLOAD_LINK\">Send SMS with Download Link</md-button>\n<md-button class=\"md-raised md-accent\" item-width=\"500px\" ng-disabled=\"vm.loading || !vm.sms.downloadLink || !vm.keys\" \nng-click=\"vm.sendSMS(\'Both\')\" translate=\"SMS_SEND_CREDENTIALS_AND_DOWNLOAD_LINK\">\nSend SMS with Credentials and Download Link</md-button><md-button class=\"md-raised md-accent\" item-width=\"20px\" \nng-disabled=\"vm.loading || !vm.sms.msg || !vm.keys\" ng-click=\"vm.sendSMS(\'Message\')\" translate=\"SMS_SEND_MESSAGE\">\nsend SMS with current message</md-button></div></div></md-content></div></div></md-dialog-sms></md-dialog>");
$templateCache.put("app/main/restricted/organization/subscribers/tabs/contact.details.html","<md-content class=\"content group-details\"><choose-list selected-elements=\"vm.unselectedContacts\" \nnot-selected-elements=\"vm.selectedContacts\" pagination-id=\"1111\" error=\"false\"></choose-list></md-content>");
$templateCache.put("app/main/restricted/organization/subscribers/tabs/group.details.html","<md-content class=\"content group-details\"><choose-list selected-elements=\"vm.unselectedGroups\" \nnot-selected-elements=\"vm.selectedGroups\" pagination-id=\"vm.groupPagination\" error=\"false\"></choose-list></md-content>");
$templateCache.put("app/main/restricted/organization/wfm/addNewWFMUserDialog/addNewWFMUser.dialog.html","<md-dialog aria-label=\"Subscriber\" class=\"md-dialog-wide\"><md-toolbar><div class=\"md-toolbar-tools\"><h1 translate=\"\">\nWFM USER</h1><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \naria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"with-tabs\"><md-tabs \nmd-dynamic-height><md-tab md-on-select=\"vm.onTabChanges(0)\" ng-disabled=\"vm.loading\"><md-tab-label><span translate=\"\">\nAdd User</span></md-tab-label><md-tab-body><md-content class=\"photos-videos-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/wfm/addNewWFMUserDialog/general.html\'\"></md-content></md-tab-body>\n</md-tab></md-tabs><md-tab md-on-select=\"vm.onTabChanges(1)\" ng-disabled=\"vm.loading\"><md-tab-label><span translate=\"\">\nLicense Details</span></md-tab-label><md-tab-body><md-content class=\"photos-videos-tab padding-tab\" \nng-include=\"\'app/main/restricted/organization/wfm/addNewWFMUserDialog/license.permissions.html\'\"></md-content>\n</md-tab-body></md-tab></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.cancel()\" \ntranslate=\"APP_CANCEL\">Cancel</md-button><md-button ng-click=\"vm.ok()\" translate=\"APP_SAVE\">Save</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/restricted/organization/wfm/addNewWFMUserDialog/general.html","<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><span>Hi there</span>\n</md-content>");
$templateCache.put("app/main/restricted/organization/wfm/addNewWFMUserDialog/license.permissions.html","<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><span>Hi License there</span>\n</md-content>");
$templateCache.put("app/main/restricted/organization/wfm/tabs/incidence-types.html","<div class=\"content-card\"><div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div><div layout=\"row\" class=\"add-button\" \nflex style=\"place-content: end\"><span ng-if=\"vm.err\" style=\"place-self: flex-end; color: red\">{{vm.err}}</span>\n<md-input-container><label translate=\"WFM_ADD_TYPE\">Name</label><input ng-model=\"vm.incidense_name\" type=\"text\" \nmd-maxlength=\"50\"></md-input-container><div layout=\"column\" layout-align-gt-sm=\"row\" layout-align=\"margin-right\" \nstyle=\"margin-block: auto\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.addIncidenseType(vm.incidense_name)\" \nng-disabled=\"!vm.organizationId || !vm.incidense_name || !vm.allowCreate\" aria-label=\"Add\" translate><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div></div><md-content ng-if=\"vm.organizationId\"><table \nclass=\"dataTable row-border stripe hover\" ng-if=\"vm.organizationId\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"APPLICATION_ID\">ID</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sortIncidence(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'name\')\" translate=\"APP_NAME\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WFM_INCIDENCE_DEFAULT\">Default</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.allowDelete\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"APP_REMOVE\">Actions</span></div></th></tr></thead><tbody id=\"incidence-tbody\"><tr \ndir-paginate=\"(index, incidense) in vm.WFMIncidences.types |searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\" , pagination-id=\"vm.incidencesPaginationClass\"><td width=\"10%\" class=\"table-name-label\">{{index}}\n</td><td width=\"80%\" class=\"table-name-label\">{{incidense.name}}</td><td width=\"10%\" class=\"table-name-label\"><input \ntype=\"checkbox\" ng-model=\"incidense.isDefault\" ng-change=\"vm.defaultChange(incidense.name, incidense.isDefault)\"></td>\n<td width=\"100%\" ng-if=\"vm.allowDelete\"><md-button class=\"edit-button md-icon-button\" \naria-label=\"organisation details\" translate translate-attr-aria-label=\"APP_DELETE\" \nng-if=\"!incidense.default_type && !incidense.isDefault\" ng-click=\"vm.deleteIncidenseType(incidense.name)\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content \nng-if=\"!vm.WFMIncidences.types.length\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\">\n<div class=\"content-card\"><p class=\"pd-2\" translate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div>\n</md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\" pagination-id=\"vm.incidencesPaginationClass\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \nmax-size=\"1\" direction-links=\"true\" boundary-links=\"true\" pagination-id=\"vm.incidencesPaginationClass\">\n</dir-pagination-controls></div></div><div layout=\"row\" style=\"float: right\"><md-button md-no-ink class=\"md-primary\" \nng-click=\"vm.cancelIncidenceTypeChanges()\" aria-label=\"\" translate=\"APP_CANCEL\">Cancel</md-button><md-button md-no-ink \nclass=\"md-primary\" ng-click=\"vm.saveIncidenceTypes()\" aria-label=\"\" translate=\"APP_SAVE\" \nng-disabled=\"!vm.organizationId || !vm.allowCreate\">Save</md-button></div></md-content></div>");
$templateCache.put("app/main/restricted/organization/wfm/tabs/wfm-permission.html","");
$templateCache.put("app/main/restricted/organization/wfm/tabs/wfm-userList.html","<div class=\"page-layout carded fullwidth single-scroll\"><div class=\"content-card\" style=\"width: 100%; float: left\"><div\n class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\">\n</md-input-container></div><span class=\"h2 new\" flex layout-align=\"center\" translate=\"\">WFM Users List</span><md-button\n class=\"add-button md-fab md-warn\" ng-click=\"vm.addNewWFMUser()\" ng-disabled=\"!vm.organizationId\" \naria-label=\"Add event\" translate><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div><table \nclass=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"\">User ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"\">User Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title\" translate=\"\">Organization ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"\">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"WFMSubscriber in vm.WFMSubscribers |searchSubscribers:vm.search  track by WFMSubscriber._id\"><td \nwidth=\"20%\" class=\"table-name-label\">{{::WFMSubscriber.user_id}}</td><td width=\"20%\" class=\"table-name-label\">\n{{::WFMSubscriber.user_name}}</td><td width=\"15%\" class=\"table-name-label\">{{::WFMSubscriber.org_id}}</td><td>\n<md-button ng-click=\"vm.removeUserByID(WFMSubscriber._id)\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/restricted/organization/wfm/tabs/wfm-users.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" layout-align=\"margin-right\" flex=\"30\" style=\"margin-inline-start: auto\"><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.showLoader || !vm.allowCreate || !vm.organizationId\" \nng-click=\"vm.AttachWFMusers()\" translate=\"WFM_APPLY\">Apply</md-button></div><choose-list \nselected-elements=\"vm.selectedWFMusers\" not-selected-elements=\"vm.notSelectedWFMusers\" \npagination-id=\"vm.WFMusersPaginationClass\" member-count-limit=\"vm.WFMusersLength\" error=\"false\"></choose-list>\n</md-content></div></div></md-content>");
$templateCache.put("app/main/restricted/platform/client-version/details/details.dialog.html","<md-dialog aria-label=\"Device\"><form name=\"versionForm\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"CLIENT_VERSION_DIALOG_TITLE\" translate-default=\"Client Version\"></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex><label \ntranslate=\"CLIENT_VERSION_SELECT_STORE\" translate-default=\"Select PTT Store\"></label><md-select name=\"software\" \nng-model=\"vm.version.clientSoftwareCategoryId\" required><md-option ng-repeat=\"item in vm.storeList\" \nng-value=\"item._id\">{{item.name}}</md-option></md-select><div ng-messages=\"versionForm.software.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex><label \ntranslate=\"CLIENT_VERSION_VERSION\" translate-default=\"Version\"></label><input type=\"text\" name=\"version\" \nng-model=\"vm.version.version\" md-maxlength=\"100\" translate aria-invalid=\"true\" required><div \nng-messages=\"versionForm.version.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex><label \ntranslate=\"CLIENT_VERSION_PATH\" translate-default=\"Local file path\"></label><input type=\"text\" \nng-model=\"vm.version.localFilePath\" md-maxlength=\"100\" translate aria-invalid=\"true\" required><div \nng-messages=\"versionForm.version.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex><label \ntranslate=\"CLIENT_VERSION_DESCRIPTION\" translate-default=\"Description\"></label><textarea type=\"text\" \nname=\"description\" ng-model=\"vm.version.description\" translate required></textarea><div \nng-messages=\"versionForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters</span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.cancel()\" translate=\"APP_CANCEL\">Cancel</md-button><md-button ng-click=\"vm.save()\" translate=\"APP_SAVE\" \nng-disabled=\"versionForm.$invalid\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/restricted/platform/devices/details/details.dialog.html","<md-dialog aria-label=\"Device\"><form name=\"deviceForm\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"DEVICE_DETAILS\">Device</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label translate=\"DEVICE_NAME\">Name</label><input \ntype=\"text\" ng-model=\"vm.device.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' name=\"name\" md-maxlength=\"40\" required \naria-invalid=\"true\"><div ng-messages=\"deviceForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"DEVICE_MANUFACTURER\">Select manufacturer</label><md-select name=\"manufacturer\" \nng-model=\"vm.device.device_manufacturer_id\" required><md-option ng-repeat=\"item in ::vm.categoryTypes\" \nng-value=\"item._id\">{{item.name}}</md-option></md-select><div ng-messages=\"deviceForm.manufacturer.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div>\n</div></md-input-container></div><div class=\"row\" flex ng-if=\"vm.error\"><div class=\"error-msg\" ng-model=\"vm.error\">\n{{vm.error}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.cancel()\" translate=\"APP_CANCEL\">Cancel</md-button><md-button translate=\"APP_SAVE\" ng-click=\"vm.save()\" \nng-disabled=\"deviceForm.$invalid\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/restricted/platform/devices-manufacturers/details/details.html","<md-dialog aria-label=\"Manufacturer\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 translate=\"MANUFACTURER_DETAILS\">\nDevice manufacturers details</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \naria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"manForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\"><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"APP_NAME\">Name</label><input type=\"text\" name=\"name\" required md-maxlength=\"40\" ng-model=\"vm.deviceM.name\" \nng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' aria-invalid=\"true\"><div ng-messages=\"manForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Name field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters</span></div></div>\n</md-input-container></div></form></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.cancel()\" translate=\"APP_CANCEL\">Cancel</md-button><md-button ng-disabled=\"manForm.$invalid\" \ntranslate=\"APP_SAVE\" ng-click=\"vm.ok()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/restricted/platform/job/tabs/gps.html","<md-card class=\"logs-card\"><md-card-header><md-card-header-text><span class=\"md-title\" translate=\"JOB_INIT_LOG\">\nInit Log</span></md-card-header-text></md-card-header><md-content-card><pre ng-bind-html=\"vm.logs.gps.init\">\n    </pre>\n</md-content-card></md-card><md-card class=\"logs-card\"><md-card-header><md-card-header-text><span class=\"md-title\" \ntranslate=\"JOB_RUN_LOG\">Run Log</span></md-card-header-text></md-card-header><md-content-card><pre \nng-bind-html=\"vm.logs.gps.run\">\n    </pre></md-content-card></md-card>");
$templateCache.put("app/main/restricted/platform/job/tabs/mongo.html","<md-card class=\"logs-card\"><md-card-header><md-card-header-text><span class=\"md-title\" translate=\"JOB_INIT_LOG\">\nInit Log</span></md-card-header-text></md-card-header><md-content-card><pre ng-bind-html=\"vm.logs.mongo.init\">\n    \n</pre></md-content-card></md-card><md-card class=\"logs-card\"><md-card-header><md-card-header-text><span \nclass=\"md-title\" translate=\"JOB_RUN_LOG\">Run Log</span></md-card-header-text></md-card-header><md-content-card><pre \nng-bind-html=\"vm.logs.mongo.run\">\n    </pre></md-content-card></md-card>");
$templateCache.put("app/main/restricted/platform/job/tabs/provisioning.html","<md-card class=\"logs-card\"><md-card-header><md-card-header-text><span class=\"md-title\" translate=\"JOB_INIT_LOG\">\nInit Log</span></md-card-header-text></md-card-header><md-content-card><pre ng-bind-html=\"vm.logs.provisioning.init\">\n    </pre></md-content-card></md-card><md-card class=\"logs-card\"><md-card-header><md-card-header-text><span \nclass=\"md-title\" translate=\"JOB_RUN_LOG\">Run Log</span></md-card-header-text></md-card-header><md-content-card><pre \nng-bind-html=\"vm.logs.provisioning.run\">\n    </pre></md-content-card></md-card><md-card class=\"logs-card\">\n<md-card-header><md-card-header-text><span class=\"md-title\" translate=\"JOB_PROV_LICENSE_LOG\">License Job Log</span>\n</md-card-header-text></md-card-header><md-content-card><pre ng-bind-html=\"vm.logs.provisioning.license\">\n    </pre>\n</md-content-card></md-card><md-card class=\"logs-card\"><md-card-header><md-card-header-text><span class=\"md-title\" \ntranslate=\"JOB_PROV_DB_INIT_LOG\">Db Init Log</span></md-card-header-text></md-card-header><md-content-card><pre \nng-bind-html=\"vm.logs.provisioning.dbInit\">\n    </pre></md-content-card></md-card><md-card class=\"logs-card\">\n<md-card-header><md-card-header-text><span class=\"md-title\" translate=\"JOB_PROV_DB_INTEGRITY_LOG\">Db Integrity Log\n</span></md-card-header-text></md-card-header><md-content-card><pre ng-bind-html=\"vm.logs.provisioning.dbIntegrity\">\n\n    </pre></md-content-card></md-card>");
$templateCache.put("app/main/restricted/platform/localization/details/localization.details.html","<md-dialog aria-label=\"Device\"><form name=\"localizationForm\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"LOCALIZATION_DETAILS\">Translation</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"LOCALIZATION_TITLE\">Title</label><input type=\"text\" ng-model=\"vm.translation.title\" name=\"name\" required \naria-invalid=\"true\"><div ng-messages=\"deviceForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nName field is required</span></div></div></md-input-container></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\"><md-progress-circular ng-if=\"vm.loading\" class=\"md-accent md-hue-1\" md-diameter=\"40\">\n</md-progress-circular></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"LOCALIZATION_TRANSLATION\">Translation</label><input type=\"text\" ng-model=\"vm.translation.translation\" \nname=\"translation\" required aria-invalid=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"LOCALIZATION_CODE\">Code</label><input type=\"text\" \nng-model=\"vm.translation.code\" name=\"code\" required aria-invalid=\"true\"></md-input-container></div><div \nlayout=\"column\"><label translate=\"LOCALIZATION_FLAG\">Flag</label><md-select ng-model=\"vm.translation.flag\"><md-option \nng-repeat=\"flag in vm.flags track by $index\" value=\"{{flag}}\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{flag}}.svg\"> {{flag}}</md-option></md-select></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><ng-csv-import content=\"vm.content\" material md-button-class=\"md-raised md-accent\" \nmd-button-title=\"Import\" header=\"false\" separator=\"\" result=\"vm.result\" accept=\"\'.csv\'\" \ncallback=\"vm.streamingCallback\"></ng-csv-import></div><div layout=\"column\" layout-align-gt-sm=\"row\"><md-button \nclass=\"md-raised md-accent\" ng-csv=\"vm.toExport\" filename=\"{{vm.translation.code}}.csv\"><label \ntranslate=\"GENERIC_EXPORT\">Export</label></md-button></div></md-dialog-content><md-dialog-actions layout=\"row\"><span \nflex></span><md-button ng-click=\"vm.cancel()\" translate=\"APP_CANCEL\">Cancel</md-button><md-button translate=\"APP_SAVE\" \nng-click=\"vm.save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/restricted/platform/ptt-client-store/details/details.dialog.html","<md-dialog aria-label=\"Device\"><form name=\"clientStoreForm\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"STORE_TITLE\">Client store</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label translate=\"APP_NAME\">Name</label><input \ntype=\"text\" name=\"name\" md-maxlength=\"50\" ng-model=\"vm.store.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' translate \naria-invalid=\"true\" required><div ng-messages=\"clientStoreForm.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Name field is required</span></div><div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">\nThis field is too long</span></div><div ng-message=\"pattern\"><span translate=\"APP_VALIDATION_SPECIAL_CHARS\">\nThis field can not contain special characters</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular ng-if=\"vm.loading\" class=\"md-accent md-hue-1\" \nmd-diameter=\"40\"></md-progress-circular></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float \nflex=\"100\"><label translate=\"STORE_LICENSABLE_TYPE\">Licensable Type</label><md-select name=\"licenseType\" \nng-model=\"vm.store.licenseType\" required><md-option ng-repeat=\"item in vm.licenseTypes\" ng-value=\"item._id\">\n{{item.name}}</md-option></md-select><div ng-messages=\"clientStoreForm.licenseType.$error\" role=\"alert\"><div \nng-message=\"required\"><span>This field is required</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label translate=\"STORE_DESCRIPTION\">Description</label>\n<textarea name=\"description\" required ng-model=\"vm.store.description\">\n          </textarea><div \nng-messages=\"clientStoreForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>This field is required\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float \nflex=\"100\"><label translate=\"STORE_MANUFACTURER_NAME\">Manufacturer Name</label><md-select name=\"manufacturer\" \nng-model=\"vm.store.softwareManufacturerId\" required><md-option ng-repeat=\"item in ::vm.softwareMs\" ng-value=\"item._id\">\n{{item.name}}</md-option></md-select><div ng-messages=\"clientStoreForm.manufacturer.$error\" role=\"alert\"><div \nng-message=\"required\"><span>This field is required</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"vm.store._id\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"STORE_CLIENT_VERSION\">Client version</label><md-select ng-model=\"vm.store.latestClientSoftwareId\"><md-option\n ng-repeat=\"item in ::vm.versions\" ng-value=\"item._id\">{{item.version}}</md-option></md-select></md-input-container>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vm.cancel()\" \ntranslate=\"APP_CANCEL\">Cancel</md-button><md-button translate=\"APP_SAVE\" ng-disabled=\"clientStoreForm.$invalid\" \nng-click=\"vm.save()\">Save</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/restricted/platform/ptt-devices/details/details.dialog.html","<md-dialog aria-label=\"Device\"><form name=\"pttForm\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"PTT_DEVICE_DETAILS\">Ptt device</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label translate=\"STORE_DEVICE\">\nSelect device</label><md-select ng-change=\"vm.deviceName()\" required ng-model=\"vm.device.device_id\"><md-option \nng-repeat=\"item in vm.deviceList\" ng-value=\"item._id\">{{item.name}}</md-option></md-select></md-input-container></div>\n<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular ng-if=\"vm.loading\" \nclass=\"md-accent md-hue-1\" md-diameter=\"40\"></md-progress-circular></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"STORE_CLIENT_STORE\">Client store</label><md-select \nrequired ng-model=\"vm.device.client_software_category_id\"><md-option ng-repeat=\"item in ::vm.storeList\" \nng-value=\"item._id\">{{item.name}}</md-option></md-select></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vm.cancel()\" translate=\"APP_CANCEL\">Cancel\n</md-button><md-button translate=\"APP_SAVE\" ng-disabled=\"pttForm.$invalid\" ng-click=\"vm.save()\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/restricted/platform/software-manufacturers/details/details.html","<md-dialog aria-label=\"Subscriber\"><form name=\"SM\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"SOFTWARE_MANUFACTURERS_TITLE\">Software manufacturer details</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"APP_NAME\">Name</label><input type=\"text\" name=\"name\" \nmd-maxlength=\"40\" required ng-model=\"vm.softwareM.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' aria-invalid=\"true\"><div \nng-messages=\"SM.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name field is required</span></div><div \nng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div \nng-message=\"pattern\"><span translate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters\n</span></div></div></md-input-container></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\">\n<md-progress-circular ng-if=\"vm.loading\" class=\"md-accent md-hue-1\" md-diameter=\"40\"></md-progress-circular></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vm.cancel()\" \ntranslate=\"APP_CANCEL\">Cancel</md-button><md-button translate=\"APP_SAVE\" ng-click=\"vm.ok()\" ng-disabled=\"SM.$invalid\">\nSave</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/organization.details.dialog.html","<md-dialog aria-label=\"Subscriber\" style=\"width: 50%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ORGANIZATION_DETAILS\">Organization</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"with-tabs\"><md-tabs md-dynamic-height md-border-bottom md-selected=\"vm.selectedTabIndex\"><md-tab \nmd-on-select=\"vm.onTabChanges(0)\"><md-tab-label><span translate=\"ORGANIZATION_GENERAL\">General</span></md-tab-label>\n<md-tab-body><md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/general.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges(1)\" \nng-if=\"vm.organization._id && ((vm.showEncryption && vm.allowSetEncryption) || vm.showUploadVersion)\"><md-tab-label>\n<span translate=\"ORGANIZATION_SECURITY_AND_DOWNLOAD\">Security and Download</span></md-tab-label><md-tab-body>\n<md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/security.and.download.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(2)\" ng-if=\"vm.organization.id  && vm.showBranding\">\n<md-tab-label><span translate=\"BRANDING_TITLE\">Branding</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/branding.details.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(2)\" \nng-if=\"vm.isRootAdmin || !vm.allowModifyAudioRecorder || vm.isAdministrator\"><md-tab-label><span \ntranslate=\"APP_SENTINEL\">Sentinel Configurations</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/sentinel.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges(3)\" \nng-if=\"(vm.isRootAdmin || !vm.allowModifyAudioRecorder || vm.isAdministrator) && vm.showLiveSentinel\"><md-tab-label>\n<span translate=\"APP_LIVE_SENTINEL_EVENTS\">Live Sentinel Events</span></md-tab-label><md-tab-body><md-content \nclass=\"pd-2\" ng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/live_sentinel.html\'\">\n</md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(4)\" \nng-if=\"vm.showOrgFriends && vm.organization.id\"><md-tab-label><span translate=\"ORG_FRIEND\">Organization friends</span>\n</md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/organization.friends.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(5)\" ng-if=\"vm.organization.id && vm.showAffiliatedGroup\">\n<md-tab-label><span translate=\"ORG_AFFILIATED_GROUPS\">Affiliated Groups</span></md-tab-label><md-tab-body><md-content \nclass=\"pd-2\" ng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/affiliated.groups.html\'\">\n</md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(6)\" \nng-if=\"vm.organization.id && vm.showAffiliatedGroup\"><md-tab-label><span translate=\"ORG_AFFILIATED_CONTACTS\">\nAffiliated Contacts</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/affiliated.contacts.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \ntranslate=\"APP_CANCEL\" ng-if=\"vm.activeTab == 0\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" ng-disabled=\"!vm.flagSave\">\nCancel</md-button><md-button ng-click=\"vm.ok()\" \nng-disabled=\"vm.orgForm.$invalid || (!vm.allowCreate && !vm.organization._id) || (!vm.allowModify && vm.organization._id) || !vm.flagSave\" \nng-if=\"vm.activeTab == 0\" aria-label=\"ok\" translate=\"APP_SAVE\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/restricted/reseller/organization-manager/tabs/contact.details.html","<md-content class=\"content\"><form name=\"basicForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate=\"\"><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label \nfor=\"crmid-input\" translate=\"OM.SUPPORT.FIRST_NAME\">Support Contact First Name</label><input type=\"text\" name=\"crmid\" \nng-model=\"vm.organization.contact_first_name\" required=\"\" id=\"crmid-input\" translate aria-invalid=\"true\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\">\n<md-input-container md-no-float flex=\"100\"><label for=\"olastname\" translate=\"OM.SUPPORT.LAST_NAME\">\nSupport Contact Last Name</label><input type=\"text\" name=\"organization_name\" \nng-model=\"vm.organization.contact_last_name\" required=\"\" id=\"olastname\" translate aria-invalid=\"true\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"OM.SUPPORT.EMAIL\">Support email address</label><input \ntype=\"text\" name=\"domain_name\" ng-model=\"vm.organization.contact_email\" required=\"\" translate aria-invalid=\"true\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"OM.SUPPORT.PHONE\">Support telephone number</label><input \ntype=\"text\" name=\"address\" required=\"\" ng-model=\"vm.organization.contact_phone\" translate aria-invalid=\"true\">\n</md-input-container></div></form></md-content>");
$templateCache.put("app/main/restricted/reseller/organization-manager/tabs/general.html","<md-content class=\"content\"><form name=\"basicForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate=\"\"><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label \nfor=\"crmid-input\" translate=\"OM.CRMID\">CRMID</label><input type=\"text\" name=\"crmid\" ng-model=\"vm.organization.crmid\" \nrequired=\"\" id=\"crmid-input\" translate aria-invalid=\"true\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label \nfor=\"oname\" translate=\"OM.ONAME\">Organization name</label><input type=\"text\" name=\"organization_name\" \nng-model=\"vm.organization.name\" required=\"\" id=\"oname\" translate aria-invalid=\"true\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\">\n<label for=\"domain\" translate=\"OM.DOMAIN\">Domain name</label><input type=\"text\" name=\"domain_name\" \nng-model=\"vm.organization.damain_name\" required=\"\" id=\"domain\" translate aria-invalid=\"true\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float \nflex=\"100\"><label for=\"domain\" translate=\"OM.ADDRESS\">Address</label><input type=\"text\" name=\"address\" \nng-model=\"vm.organization.address\" required=\"\" id=\"address\" translate aria-invalid=\"true\"></md-input-container></div>\n</form></md-content>");
$templateCache.put("app/main/restricted/reseller/reseller-details/allocation/reseller.allocation.html","<md-dialog aria-label=\"License Allocation\" class=\"md-dialog-wide\"><form ng-cloak name=\"resellerForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2 translate=\"RESELLER_LICENSE_BUNDLE_GENERATION\">Reseller License Allocation</h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"\"><md-icon aria-label=\"Close dialog\">X\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"content\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_BUNDLE\">Bundle</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_TYPE\">License Type\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LICENSE_EXPIRATION_TYPE\">Expiration Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_EXPIRATION_DATE\">Expiration Date</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_QUANTITY\">Quantity\n</span></div></th></tr></thead><tbody><tr><td><md-select aria-label=\"license bundle\" flex=\"80\" \nng-model=\"vm.allocation.licenseBundle\" required><md-option ng-repeat=\"item in vm.bundles\" ng-value=\"item._id\">\n{{item.name}}</md-option></md-select></td><td><md-select aria-label=\"license bundle\" flex=\"80\" \nng-model=\"vm.allocation.licenseType\" required><md-option ng-repeat=\"item in vm.lType\" ng-value=\"item.name\">\n{{item.name}}</md-option></md-select></td><td><md-select aria-label=\"license bundle\" flex=\"80\" \nng-model=\"vm.allocation.expirationType\" required><md-option ng-repeat=\"item in vm.rType\" ng-value=\"item.name\">\n{{item.name}}</md-option></md-select></td><td><md-datepicker ng-model=\"vm.allocation.expirationDate\" \nmd-placeholder=\"{{ \'ENTER_DATE\' | translate  }}\" md-open-on-focus required></md-datepicker></td><td><md-input-container\n flex=\"50\"><input ng-model=\"vm.allocation.qty\" type=\"number\" min=\"0\" ng-pattern=\"/^-?[0-9][^\\.]*$/\" required>\n</md-input-container></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button ng-click=\"vm.cancel()\" aria-label=\"\" translate=\"APP_CANCEL\">Cancel</md-button><md-button \nng-click=\"vm.ok()\" aria-label=\"\" translate=\"APP_SAVE\" \nng-disabled=\"!vm.allocation.licenseBundle || !vm.allocation.licenseType || !vm.allocation.expirationType || !vm.allocation.qty || !vm.allocation.expirationDate\">\nSave</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/restricted/reseller/reseller-manager/details/reseller.allocation.dialog.html","<md-dialog aria-label=\"Subscriber\" class=\"md-dialog-wide\"><form ng-cloak name=\"resellerForm\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Reseller manager</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"with-tabs\"><md-tabs md-dynamic-height md-border-bottom><md-tab \nmd-on-select=\"vm.onTabChanges(0)\"><md-tab-label><span translate=\"APP.GENERAL\">General</span></md-tab-label>\n<md-tab-body><md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/reseller/reseller-manager/details/tabs/general.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.onTabChanges(1)\"><md-tab-label><span translate=\"RM.CONTACT_DETAILS\">Contact details\n</span></md-tab-label><md-tab-body><md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/reseller/reseller-manager/details/tabs/contact.details.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(2)\"><md-tab-label><span translate=\"RM.LICENSE_DETAILS\">\nLicense RM</span></md-tab-label><md-tab-body><md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/reseller/reseller-manager/details/tabs/license.details.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.cancel()\" aria-label=\"\">Cancel</md-button><md-button ng-click=\"vm.ok()\" aria-label=\"\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/restricted/reseller/reseller-manager/details/reseller.details.dialog.html","<md-dialog aria-label=\"Subscriber\" class=\"md-dialog-wide\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"RESELLER_DETAILS\">Reseller manager</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"with-tabs\"><md-tabs md-dynamic-height md-border-bottom md-selected=\"vm.selectedTabIndex\">\n<md-tab md-on-select=\"vm.onTabChanges(0)\"><md-tab-label><span translate=\"APP_GENERAL\">General</span></md-tab-label>\n<md-tab-body><md-content class=\"timeline-tab\" \nng-include=\"\'app/main/restricted/reseller/reseller-manager/details/tabs/general.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.showSms\" md-on-select=\"vm.onTabChanges(1)\"><md-tab-label><span \ntranslate=\"RESELLER_SMS_CONFIGURATION\">Sms Configuration</span></md-tab-label><md-tab-body><md-content \nclass=\"timeline-tab\" ng-include=\"\'app/main/restricted/reseller/reseller-manager/details/tabs/sms.configuration.html\'\">\n</md-content></md-tab-body></md-tab><md-tab ng-if=\"vm.reseller._id && vm.showBranding\" \nmd-on-select=\"vm.onTabChanges(2)\"><md-tab-label><span translate=\"BRANDING_TITLE\">Branding</span></md-tab-label>\n<md-tab-body><md-content class=\"timeline-tab\" \nng-include=\"\'app/main/restricted/reseller/reseller-manager/details/tabs/branding.details.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \ntranslate=\"APP_CANCEL\" ng-click=\"vm.cancel()\" aria-label=\"\" ng-disabled=\"!vm.flagSave\">Cancel</md-button><md-button \ntranslate=\"APP_SAVE\" ng-click=\"vm.ok()\" \nng-disabled=\"vm.resellerForm.$invalid || vm.resellerContactForm.$invalid || (!vm.allowCreate && !vm.reseller._id) || (!vm.allowModify && vm.reseller._id) || !vm.flagSave \" \naria-label=\"save\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/restricted/administration/roles/dialog/tabs/activity.html","<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex=\"10\" style=\"margin-right: -35%\"><md-datepicker \nng-model=\"vm.roles.startDate\" ng-change=\"vm.checkErrForStartDate()\" md-max-date=\"vm.now\" name=\"startDate\" \nmd-placeholder=\"{{ \'START_DATE\' | translate  }}\" required onkeydown=\"return false\"></md-datepicker>\n</md-input-container><md-input-container md-no-float flex=\"10\"><md-datepicker ng-model=\"vm.roles.endDate\" \nng-change=\"vm.checkErrForStartDate()\" md-max-date=\"vm.now\" name=\"endDate\" \nmd-placeholder=\"{{ \'END_DATE\' | translate  }}\" onkeydown=\"return false\"></md-datepicker></md-input-container></div>\n<span style=\"color:red\">{{vm.roles.errMessage}}</span><div layout=\"row\"><table class=\"dataTable row-border hover\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SUBSCRIBERS_SERIAL_NUMBER\">Serial Number</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_ADMINISTRATOR\">Administrator</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_TIME_STAMP\">\nTime-stamp (in GMT)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SUBSCRIBERS_DESCRIPTION\">Description</span></div></th></tr></thead><tbody><tr style=\"cursor:pointer\" \nng-repeat=\"security in vm.securityList\"><td>{{$index + 1}}</td><td>{{security.administrator_name }}</td><td>\n{{security.timestamp | date:\'MMM/dd/yyyy h:mm:ss a\'}}</td><td>{{ security.description }} {{ security.new_value }}</td>\n</tr></tbody></table></div><md-content ng-if=\"!vm.securityList.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \nstyle=\"text-align: center\" translate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content>\n</md-content>");
$templateCache.put("app/main/restricted/administration/roles/dialog/tabs/dispatcherPermissions.html","<div layout=\"row\" class=\"context-search\" flex layout-align=\"start center\"><md-input-container><label \ntranslate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.searchDisp\" \ntype=\"text\" md-maxlength=\"50\"></md-input-container></div><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ROLE_RESOURCE_PATH\">\nResource path</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ROLE_ACTIVE\">GET access</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div></th></tr></thead><tbody \nng-repeat=\"group in vm.GROUPS_ORDER\"><tr height=\"30\" ng-if=\"group!=\'\' &&  group.count != 0\"><td><span \nstyle=\"font-weight:bold\">{{group.name}}</span></td></tr><tr \nng-repeat=\"perm in vm.currentRole.permissions | filter: {console_type: 3} | searchByName:vm.searchDisp\" \nng-if=\"perm.group == group.name\" ng-disabled=\"vm.LoginUserRoleId == vm.currentRole._id\"><td ng-if=\"!perm.remove\"><p \nng-model=\"perm.resource_id\">{{perm.name}}</p></td><td ng-if=\"!perm.remove\"><input type=\"checkbox\" \nng-change=\"vm.permissionChanged(perm)\" name=\"get_access\" ng-model=\"perm.get_access\" \nng-disabled=\"!perm.resource_id || !vm.edit  || vm.LoginUserRoleId == vm.currentRole._id || (!vm.editIsAdmin) \" \nng-if=\"perm.type !== vm.DISPLAY_AS_SELECT && perm.type !== vm.DISPLAY_AS_MULTISELECT\"> <span \nng-if=\"perm.type === vm.DISPLAY_AS_CHECKBOX\">Enable</span><md-select ng-model=\"perm.selected\" \nng-change=\"vm.permissionChanged(perm)\" \nng-if=\"perm.type === vm.DISPLAY_AS_SELECT && perm.resource_id != \'dis_audio_codec\'\" \nng-disabled=\"!vm.edit  || vm.LoginUserRoleId == vm.currentRole._id\"><md-option \nng-repeat=\"(index,item) in perm.options\" value=\"{{item.id}}\" \nng-selected=\"{{ perm.selected == index ? \'true\' : index == \'bit0\' }}\">{{item.name}}</md-option></md-select><md-select \nng-model=\"perm.selected\" ng-change=\"vm.permissionChanged(perm)\" \nng-if=\"perm.type === vm.DISPLAY_AS_SELECT && perm.resource_id === \'dis_audio_codec\'\" \nng-disabled=\"!vm.edit  || vm.LoginUserRoleId == vm.currentRole._id || vm.disable_disp_audio_codec\"><md-container \nng-repeat=\"(index,item) in perm.options\"><md-option ng-if=\"$index < vm.audioCodec\" value=\"{{item.id}}\" \nng-selected=\"{{ perm.selected == index ? \'true\' : index == \'bit0\' }}\">{{item.name}}</md-option></md-container>\n</md-select><md-select ng-model=\"perm.selectedOptions\" ng-change=\"vm.permissionChanged(perm)\" multiple=\"multiple\" \nplaceholder=\"Select...\" ng-if=\"perm.type === vm.DISPLAY_AS_MULTISELECT\" \nng-disabled=\"!vm.edit  || vm.LoginUserRoleId == vm.currentRole._id\"><md-option \nng-repeat=\"(index,item) in perm.options\" value=\"{{item.id}}\" ng-disabled=\"vm.checkDisabledOptionDispatcherValue(item)\" \nng-selected=\"{{ perm.selectedOptions ? perm.selectedOptions.indexOf(index) !== -1 ? \'true\' : \'\' : index == \'bit1\' }}\">\n{{item.name}}</md-option></md-select></td><td ng-if=\"!perm.remove\"><md-button class=\"edit-button md-icon-button\" \nng-disabled=\"!vm.edit || vm.LoginUserRoleId == vm.currentRole._id\" translate translate-attr-aria-label=\"AR.DELETE\" \nng-click=\"vm.deletePermission(perm)\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td>\n</tr></tbody></table>");
$templateCache.put("app/main/restricted/administration/roles/dialog/tabs/mobilePermissions.html","<div layout=\"row\" class=\"context-search\" flex layout-align=\"start center\"><md-input-container><label \ntranslate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.searchMob\" \ntype=\"text\" md-maxlength=\"50\"></md-input-container></div><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ROLE_RESOURCE_PATH_MOBILE\">\nPermissions and Settings</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"ROLE_ACTIVE\">GET access</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div></th></tr></thead><tbody \nng-repeat=\"group in vm.GROUPS_ORDER\"><tr height=\"30\" ng-if=\"group.name!=\'\' &&  group.count != 0\"><td><span \nstyle=\"font-weight:bold\">{{group.name}}</span></td></tr><tr \nng-repeat=\"perm in vm.currentRole.permissions | filter: {console_type: 4} | searchByName:vm.searchMob\" \nng-if=\"perm.group == group.name\" ng-disabled=\"vm.LoginUserRoleId == vm.currentRole._id\"><td ng-if=\"!perm.remove\"><p \nng-model=\"perm.resource_id\">{{perm.name}}<br></p><div style=\"color:red; font-size: 80%\">{{perm.message}}</div><p></p>\n</td><td ng-if=\"!perm.remove\"><md-select ng-model=\"perm.selectedOptions\" ng-change=\"vm.permissionChanged(perm)\" \nmultiple=\"multiple\" placeholder=\"Select...\" ng-if=\"perm.type === vm.DISPLAY_AS_MULTISELECT\" \nng-disabled=\"perm.hide || !vm.edit  || vm.LoginUserRoleId == vm.currentRole._id\"><md-option \nng-repeat=\"(index,item) in perm.options\" value=\"{{item.id}}\" ng-click=\"vm.clickcheckBox(perm,item)\" \nng-disabled=\"vm.checkDisabledOptionMobileValue(item)\" \nng-selected=\"{{ perm.selectedOptions ? perm.selectedOptions.indexOf(index) !== -1 ? \'true\' : \'\' : perm.resource_id === \'bottom_bar\'? index == \'bit1\' || index == \'bit2\' || index == \'bit3\' : index == \'bit1\' }}\">\n{{item.name}}</md-option></md-select><md-select ng-model=\"perm.selected\" ng-change=\"vm.permissionChanged(perm)\" \nng-if=\'perm.type === vm.DISPLAY_AS_SELECT && perm.resource_id != \"audio_codec\"\' \nng-disabled=\"perm.hide || !vm.edit  || vm.LoginUserRoleId == vm.currentRole._id || vm.dependenciesTopicsDisable[perm.resource_id] || (vm.disable_view_group_members && perm._id==50)\">\n<md-option ng-repeat=\"(index,item) in perm.options track by item.name\" value=\"{{item.id}}\" ng-disabled=\"item.disabled\" \nng-selected=\"{{ perm.selected == index ? \'true\' : index == \'bit0\' }}\">{{item.name}}</md-option></md-select><md-select \nng-model=\"perm.selected\" ng-change=\"vm.permissionChanged(perm)\" \nng-if=\'perm.type === vm.DISPLAY_AS_SELECT && perm.resource_id == \"audio_codec\"\' \nng-disabled=\"perm.hide || !vm.edit  || vm.LoginUserRoleId == vm.currentRole._id || vm.dependenciesTopicsDisable[perm.resource_id] || (vm.disable_view_group_members && perm._id==50) || vm.disable_audio_codec \">\n<md-container ng-repeat=\"(index,item) in perm.options track by item.name\"><md-option ng-if=\"$index < vm.audioCodec\" \nvalue=\"{{item.id}}\" ng-disabled=\"item.disabled\" ng-selected=\"{{ perm.selected == index ? \'true\' : index == \'bit0\' }}\">\n{{item.name}}</md-option></md-container></md-select><input ng-change=\"vm.permissionChanged(perm)\" type=\"checkbox\" \nname=\"get_access\" ng-model=\"perm.options.bit1.active\" \nng-if=\'perm.type === vm.DISPLAY_AS_CHECKBOX && perm.resource_id != \"enable_edit_group_resource\" && perm.resource_id != \"allow_view_group_members\" && perm.resource_id != \"audio_codec\" && perm.resource_id != \"audio_codec_automatic\" \' \nng-disabled=\"perm.hide || !vm.edit || vm.LoginUserRoleId == vm.currentRole._id || vm.dependenciesTopicsDisable[perm.resource_id] || (vm.disable_view_group_members && perm._id==50)\">\n <input ng-change=\"vm.permissionChanged(perm)\" type=\"checkbox\" name=\"get_access\" ng-model=\"perm.options.bit1.active\" \nng-if=\'perm.type === vm.DISPLAY_AS_CHECKBOX && perm.resource_id == \"enable_edit_group_resource\"\' \nng-disabled=\"perm.hide || !vm.edit || vm.LoginUserRoleId == vm.currentRole._id || vm.dependenciesTopicsDisable[perm.resource_id] || vm.disable_view_group_members \">\n <input ng-change=\"vm.permissionChanged(perm)\" type=\"checkbox\" name=\"get_access\" ng-model=\"perm.options.bit1.active\" \nng-if=\'perm.type === vm.DISPLAY_AS_CHECKBOX && perm.resource_id == \"allow_view_group_members\" \' \nng-disabled=\"perm.hide || !vm.edit || vm.LoginUserRoleId == vm.currentRole._id || vm.dependenciesTopicsDisable[perm.resource_id]\">\n <input ng-change=\"vm.permissionChanged(perm)\" type=\"checkbox\" name=\"get_access\" ng-model=\"perm.options.bit1.active\" \nng-if=\'perm.type === vm.DISPLAY_AS_CHECKBOX && perm.resource_id == \"audio_codec_automatic\" \' \nng-disabled=\"perm.hide || !vm.edit || vm.LoginUserRoleId == vm.currentRole._id || vm.dependenciesTopicsDisable[perm.resource_id]\">\n</td><td ng-if=\"!perm.remove\"><md-button class=\"edit-button md-icon-button\" \nng-disabled=\"!vm.edit || vm.LoginUserRoleId == vm.currentRole._id\" translate translate-attr-aria-label=\"AR.DELETE\" \nng-click=\"vm.deletePermission(perm)\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td>\n</tr></tbody></table>");
$templateCache.put("app/main/restricted/administration/roles/dialog/tabs/webPermissions.html","<div layout=\"row\" class=\"context-search\" flex layout-align=\"start center\"><md-input-container><label \ntranslate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.searchWeb\" \ntype=\"text\" md-maxlength=\"50\"></md-input-container></div><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ROLE_RESOURCE_PATH\">\nResource path</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ROLE_GET\">GET access</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"ROLE_POST\">POST access</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"ROLE_PUT\">PUT access</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"ROLE_DELETE\">DELETE access\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"ROLE_BATCH\">BATCH access</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"ROLE_HIMPACT\">HIGH IMPACT access</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div></th></tr></thead><tbody><tr\n ng-repeat=\"(indx, perm) in vm.currentRole.permissions | filter: {console_type: 2} | searchByName:vm.searchWeb\" \nng-disabled=\"vm.LoginUserRoleId == vm.currentRole._id\"><td ng-if=\"!perm.remove\"><p ng-model=\"perm.resource_id\">\n{{perm.name}}</p></td><td ng-if=\"!perm.remove\"><input type=\"checkbox\" name=\"get_access\" ng-model=\"perm.get_access\" \nng-disabled=\"!perm.resource_id || !vm.currentProvPerm[perm.resource_id].get_access || vm.LoginUserRoleId == vm.currentRole._id || !vm.edit\">\n</td><td ng-if=\"!perm.remove\"><input type=\"checkbox\" name=\"post_access\" ng-model=\"perm.post_access\" \nng-disabled=\"!perm.resource_id || !vm.currentProvPerm[perm.resource_id].post_access|| vm.LoginUserRoleId == vm.currentRole._id || !vm.edit\">\n</td><td ng-if=\"!perm.remove\"><input type=\"checkbox\" name=\"put_access\" ng-model=\"perm.put_access\" \nng-disabled=\"!perm.resource_id || !vm.currentProvPerm[perm.resource_id].put_access|| vm.LoginUserRoleId == vm.currentRole._id || !vm.edit\">\n</td><td ng-if=\"!perm.remove\"><input type=\"checkbox\" name=\"delete_access\" ng-model=\"perm.delete_access\" \nng-disabled=\"!perm.resource_id || !vm.currentProvPerm[perm.resource_id].delete_access|| vm.LoginUserRoleId == vm.currentRole._id || !vm.edit\">\n</td><td ng-if=\"!perm.remove\"><input type=\"checkbox\" name=\"batch_access\" ng-model=\"perm.batch_access\" \nng-disabled=\"!perm.resource_id || !vm.currentProvPerm[perm.resource_id].batch_access|| vm.LoginUserRoleId == vm.currentRole._id || !vm.edit\">\n</td><td ng-if=\"!perm.remove\"><input type=\"checkbox\" name=\"himpact_access\" ng-model=\"perm.himpact_access\" \nng-disabled=\"!perm.resource_id || !vm.currentProvPerm[perm.resource_id].himpact_access|| vm.LoginUserRoleId == vm.currentRole._id || !vm.edit\">\n</td><td ng-if=\"!perm.remove\"><md-button class=\"edit-button md-icon-button\" translate \ntranslate-attr-aria-label=\"AR.DELETE\" ng-click=\"vm.deletePermission(perm)\" \nng-disabled=\"vm.LoginUserRoleId == vm.currentRole._id || !vm.edit\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s16\"></md-icon></md-button></td></tr></tbody></table>");
$templateCache.put("app/main/restricted/organization/application-lists/tabs/dialogs/application.lists.dialog.html","<md-dialog aria-label=\"Application List\"><form name=\"vm.applicationListForm\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><span translate=\"APPLICATION_LIST_DIALOG\">application list</span> <span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"with-tabs\"><div class=\"md-dialog-content\" layout=\"row\" layout-sm=\"column\">\n<md-input-container><label translate=\"APPLICATION_LIST_NAME\">Name</label><input md-maxlength=\"40\" required name=\"name\" \nng-model=\"vm.applicationList.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' ng-disabled=\"!vm.editData || !vm.allowModify\"><div \nng-messages=\"vm.applicationListForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters</span></div></div>\n</md-input-container></div><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"APPLICATION_ICON\">Icon</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APPLICATION_NAME\">Name</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"APPLICATION_PACKAGE\">Package</span></div></th><th class=\"secondary-text\" ng-if=\"vm.showUsingMicrophone\"><div\n class=\"table-header\"><span class=\"column-title\" translate=\"APPLICATION_LIST_MIC\">Mic Ignore List</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APPLICATION_LIST_KIOSK\">\nKiosk white list</span></div></th></tr></thead><tbody><tr style=\"height: 35px\"><td class=\"table-name-label\" \ntranslate=\"APP_ADD_ALL\">Select all</td><td class=\"table-name-label\"></td><td class=\"table-name-label\"></td><td \nng-if=\"vm.showUsingMicrophone\"><input ng-disabled=\"!vm.editData || !vm.allowModify\" type=\"checkbox\" \nng-model=\"vm.select_all_io\" ng-change=\"vm.selectAll_io(vm.select_all_io)\"></td><td><input type=\"checkbox\" \nng-disabled=\"!vm.editData || !vm.allowModify\" ng-model=\"vm.select_all_kiosk\" \nng-change=\"vm.selectAll_kiosk(vm.select_all_kiosk)\"></td></tr><tr \nng-repeat=\"(indx, application) in vm.curApplications |searchByName:vm.search\" style=\"height: 35px\"><td width=\"5%\" \nclass=\"table-name-label\"><img style=\"max-height: 60%\" ng-hide=\"!application.apk.stringIcon\" \ndata-ng-src=\"data:image/*;base64,{{application.apk.stringIcon}}\" ng-if=\"application.apk.stringIcon\"><md-icon \nmd-font-icon=\"{{vm.icons[application.name]}}\" ng-if=\"!application.apk.stringIcon && application.package == \'DEFAULT\'\">\n</md-icon><md-icon md-font-icon=\"icon-apps\" ng-if=\"!application.apk.stringIcon && application.package != \'DEFAULT\'\">\n</md-icon></td><td class=\"table-name-label\">{{application.name}}</td><td class=\"table-name-label\">\n{{application.package}}</td><td ng-if=\"vm.showUsingMicrophone\"><input ng-disabled=\"!vm.editData || !vm.allowModify\" \ntype=\"checkbox\" ng-disabled=\"application.package == \'DEFAULT\'\" name=\"io\" ng-model=\"application.io\" \nng-change=\"vm.checkSelectAll(\'io\')\"></td><td><input ng-disabled=\"!vm.editData || !vm.allowModify\" type=\"checkbox\" \nname=\"kiosk\" ng-model=\"application.kiosk\" ng-change=\"vm.checkSelectAll(\'kiosk\')\"></td></tr></tbody></table><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular ng-if=\"vm.loading\" \nclass=\"md-accent md-hue-1\" md-diameter=\"40\"></md-progress-circular></div><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.cancel()\" translate=\"APP_CANCEL\">Cancel</md-button><md-button ng-if=\"vm.action\" \nng-click=\"vm.saveApplicationList()\" ng-disabled=\"vm.applicationListForm.$invalid || !vm.editData\" translate=\"APP_SAVE\">\nSave</md-button><md-button ng-if=\"!vm.action\" ng-click=\"vm.saveApplicationList()\" \nng-disabled=\"vm.applicationListForm.$invalid || !vm.editData || !vm.allowModify\" translate=\"APP_SAVE\">Save</md-button>\n</md-dialog-actions></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/restricted/organization/application-lists/tabs/dialogs/applications.add.dialog.html","<md-dialog aria-label=\"Application\" class=\"md-dialog-wide\"><form name=\"vm.applicationAddForm\" ng-cloak><md-toolbar><div\n class=\"md-toolbar-tools\"><h2 translate=\"APPLICATION_ADD_DIALOG\">Add Application</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"content-card\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nmd-no-float flex><label translate=\"APPLICATION_NAME\">Name</label><input type=\"text\" name=\"applicationName\" \nng-model=\"vm.application.name\" aria-invalid=\"true\" required ng-disabled=\"vm.appLoading || !vm.allowModify\" \nautocomplete=\"off\"><div ng-messages=\"vm.applicationAddForm.applicationName.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div></div>\n</md-input-container></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular \nng-if=\"vm.appLoading\" class=\"md-accent md-hue-1\" md-diameter=\"40\"></md-progress-circular></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex><label translate=\"APPLICATION_PACKAGE\">Package</label><input \ntype=\"text\" name=\"applicationPackage\" ng-model=\"vm.application.package\" aria-invalid=\"true\" \nng-disabled=\"vm.packageDisable || vm.appLoading || vm.edit\" required autocomplete=\"off\"><div \nng-messages=\"vm.applicationAddForm.applicationPackage.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex><label \ntranslate=\"APPLICATION_DESCRIPTION\">Description</label><input type=\"text\" name=\"applicationDescription\" \nng-model=\"vm.application.description\" aria-invalid=\"true\" ng-disabled=\"vm.appLoading || !vm.allowModify\" \nautocomplete=\"off\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float \nflex><label><span translate=\"APPLICATION_VERSION\">Version</span> <span ng-if=\"!vm.packageversionDisable\">Ex.: 0001\n</span></label><input type=\"text\" name=\"applicationVersion\" ng-model=\"vm.application.apk.versionCode\" \naria-invalid=\"true\" ng-disabled=\"vm.packageversionDisable\" autocomplete=\"off\" ng-pattern=\"/^[0-9]*\\.?[0-9]*$/\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container><input content=\"file\" \ntype=\"file\" name=\"application_file\" ng-model=\"application_file\" id=\"application_file\" accept=\".apk\" \nonchange=\"angular.element(this).scope().getApplicationDetails()\" ng-disabled=\"vm.appLoading || !vm.allowModify\">\n</md-input-container><div layout=\"row\"><md-input-container md-no-float flex=\"50\"><img \nstyle=\"max-width: 200px;margin-left: -51%;max-height: 60%\" ng-hide=\"!vm.icon\" \ndata-ng-src=\"data:image/*;base64,{{vm.icon}}\"></md-input-container></div><div layout=\"row\" ng-if=\"vm.errorMessage\" \nstyle=\"align-items: center; color: red\"><label>{{vm.errorMessage}}</label></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vm.cancel()\" translate=\"APP_CANCEL\">Cancel\n</md-button><md-button ng-if=\"!vm.edit\" ng-click=\"vm.addApplication(vm.application)\" translate=\"APP_ADD\" \nng-disabled=\"vm.applicationAddForm.$invalid || vm.appLoading\">Save</md-button><md-button ng-if=\"vm.edit\" \nng-click=\"vm.addApplication(vm.application)\" translate=\"APP_UPDATE\" \nng-disabled=\"vm.applicationAddForm.$invalid || vm.appLoading || vm.errorMessage || !vm.allowModify\">Save</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/restricted/organization/contacts/details/tabs/general.html","<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><form name=\"contactForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate=\"\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"CONTACTS_NAME\">Name</label><input type=\"text\" \nng-model=\"vm.contact.name\" ng-pattern=\'/^[^\\\\:*?\"<>|!@#$%^&;]+$/\' name=\"name\" translate aria-invalid=\"true\" \nmd-maxlength=\"{{vm.groupNameLimit}}\" required autocomplete=\"off\"><div ng-messages=\"contactForm.name.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">\nThis field is required</span></div><div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">\nThis field is too long</span></div><div ng-message=\"pattern\"><span translate=\"APP_VALIDATION_SPECIAL_CHARS\">\nThis field can not contain special characters</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label translate=\"GROUPS_TYPE\">Contacts type</label>\n<md-select name=\"type\" ng-model=\"vm.contact.type\" ng-disabled=\"vm.contact._id\"><md-option \nng-repeat=\"item in vm.contactTypes\" value=\"{{item.id}}\" ng-if=\"!(!vm.showOCL &&  item.id == 4)\">{{item.name}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.contact.memberType == 2\"><md-input-container md-no-float flex=\"100\"><label>Member Add Via</label><md-select \nng-disabled=\"!vm.contact.name || !vm.allowReadSubscribers\" name=\"groupId\" ng-model=\"vm.contact.groupId\"><md-option \nng-repeat=\"item in vm.grpList\" value=\"{{item._id}}\" ng-if=\"item.cross_fleet == 0\">{{item.name}}</md-option></md-select>\n</md-input-container></div></form></md-content>");
$templateCache.put("app/main/restricted/organization/contacts/details/tabs/members.details.html","<md-content class=\"content group-details\"><span translate=\"CONTACT_MEMBERS_NOTE\" flex style=\"color: red\" \nng-if=\"vm.showAffiliatedGroup\">Only show offnet license Members</span><choose-list \nselected-elements=\"vm.selectedMembers\" not-selected-elements=\"vm.unselectedMembers\" error=\"false\"></choose-list>\n</md-content>");
$templateCache.put("app/main/restricted/organization/emergency-group/details/tabs/general.html","<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><form \nname=\"emergencyGroupForm\" class=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" \nnovalidate=\"\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"GROUPS_NAME\">Name\n</label><input type=\"text\" ng-model=\"vm.emergencyGroup.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|!@#$%^&;]+$/\' \nname=\"display-name\" translate aria-invalid=\"true\" md-maxlength=\"12\" required><div \nng-messages=\"emergencyGroupForm.name.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters</span></div></div>\n</md-input-container></div></form></md-content>");
$templateCache.put("app/main/restricted/organization/emergency-group/details/tabs/members.details.html","<md-content class=\"content group-details\"><choose-list selected-elements=\"vm.selectedMembers\" \nnot-selected-elements=\"vm.unselectedMembers\"></choose-list></md-content>");
$templateCache.put("app/main/restricted/organization/groups/details/tabs/general.html","<md-content class=\"content\"><form name=\"groupForm\" ng-cloak><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container\n flex><label translate=\"GROUPS_NAME\">Group name</label><input type=\"text\" ng-model=\"vm.group.name\" \nng-pattern=\'/^[^\\\\/:*?\"<>|!@#$%^&;]+$/\' name=\"name\" md-maxlength=\"{{vm.groupNameLimit}}\" translate aria-invalid=\"true\" \nrequired autocomplete=\"off\"><div ng-messages=\"groupForm.name.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div \nng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div \nng-message=\"pattern\"><span translate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float \nflex=\"100\"><label translate=\"GROUPS_TYPE\">Group type</label><md-select name=\"type\" ng-model=\"vm.group.type\" \nng-change=\"vm.checkGroupType()\" ng-disabled=\"vm.group._id\"><md-option ng-repeat=\"item in vm.groupTypes\" \nng-disabled=\"item.id == 9 && vm.group.expiry_date\" value=\"{{item.id}}\" \nng-if=\"!(!vm.showEmergencyGroup && item.id == 9)\">{{item.name}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"!vm.crossFleet && vm.group.memberType == 2\"><md-input-container md-no-float \nflex=\"100\"><label>Member Add Via</label><md-select \nng-disabled=\"!vm.group.name || !vm.group.type || !vm.group.site || !vm.allowReadSubscribers || vm.loading\" \nname=\"groupId\" ng-model=\"vm.group.groupId\"><md-option ng-repeat=\"item in vm.grpList\" value=\"{{item._id}}\" \nng-if=\"item.cross_fleet == 0\">{{item.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"vm.crossFleet && vm.group.memberType == 2\"><md-input-container md-no-float flex=\"100\"><label>\nMember Add Via</label><md-select \nng-disabled=\"!vm.group.name || !vm.group.type || !vm.group.site || !vm.allowReadSubscribers || vm.loading\" \nname=\"groupId\" ng-model=\"vm.group.groupId\"><md-option ng-repeat=\"item in vm.grpList\" value=\"{{item._id}}\">{{item.name}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nmd-no-float flex=\"100\"><label translate=\"GROUPS_SITE\">Group site</label><md-select name=\"type\" \nng-model=\"vm.group.site\" ng-disabled=\"true\" required><md-option ng-repeat=\"item in vm.sites\" value=\"{{item._id}}\">\n{{item.name}}</md-option></md-select><div ng-messages=\"groupForm.type.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-datepicker class=\"groupDate\" ng-hide=\"vm.group.type == 9\" \nng-model=\"vm.group.expiry_date\" ng-disabled=\"vm.group.type == 8\" md-min-date=\"vm.now\" name=\"endDate\" \nmd-placeholder=\"{{ \'END_DATE\' | translate  }}\" onkeydown=\"return false\"></md-datepicker><md-button \nclass=\"md-icon-button\" ng-hide=\"vm.group.type == 9\" ng-click=\"vm.resetDate()\" ng-disabled=\"!vm.group.expiry_date\">\n<md-icon aria-label=\"Reset\">X</md-icon></md-button></div></form></md-content>");
$templateCache.put("app/main/restricted/organization/groups/details/tabs/mutedsubscribers.html","<md-content class=\"content group-details\"><choose-list selected-elements=\"vm.selectedMutedMembers\" \nnot-selected-elements=\"vm.unselectedMutedMembers\" error=\"false\"></choose-list></md-content>");
$templateCache.put("app/main/restricted/organization/groups/details/tabs/mutedsubscribers.select.html","<md-content class=\"content group-details\"><choose-list-select pagination-id=\"vm.affiliatedGroupSubscribersPagination\" \nselected-elements=\"vm.selectedMutedMembers\" not-selected-elements=\"vm.unselectedMutedMembers\" error=\"false\" \ndrop-down-elements=\"vm.orgsFriends\" selected-drop-down=\"vm.selectedDropDown\"></choose-list-select></md-content>");
$templateCache.put("app/main/restricted/organization/groups/details/tabs/register_users.html","<md-content class=\"content group-details\"><choose-list selected-elements=\"vm.selectedRegisterMembers\" \nnot-selected-elements=\"vm.unselectedMembers\" error=\"false\"></choose-list></md-content>");
$templateCache.put("app/main/restricted/organization/groups/details/tabs/register_users.select.html","<md-content class=\"content group-details\"><choose-list-select pagination-id=\"vm.affiliatedGroupSubscribersPagination\" \nselected-elements=\"vm.selectedRegisterMembers\" not-selected-elements=\"vm.unselectedMembers\" error=\"false\" \ndrop-down-elements=\"vm.orgsFriends\" selected-drop-down=\"vm.selectedDropDown\"></choose-list-select></md-content>");
$templateCache.put("app/main/restricted/organization/groups/details/tabs/subscribers.html","<md-content class=\"content group-details\"><choose-list-bind-muted selected-elements=\"vm.selectedMembers\" \nselected-bind-elements=\"vm.unselectedMutedMembers\" not-selected-bind-elements=\"vm.selectedMutedMembers\" \nnot-selected-elements=\"vm.unselectedMembers\" error=\"false\" member-count-limit=\"vm.emergencyMember\">\n</choose-list-bind-muted></md-content>");
$templateCache.put("app/main/restricted/organization/groups/details/tabs/subscribers.select.html","<md-content class=\"content group-details\"><choose-list-select-bind-muted \npagination-id=\"vm.affiliatedGroupSubscribersPagination\" selected-elements=\"vm.selectedMembers\" \nnot-selected-elements=\"vm.unselectedMembers\" selected-bind-elements=\"vm.selectedMutedMembers\" \nnot-selected-bind-elements=\"vm.unselectedMutedMembers\" error=\"false\" drop-down-elements=\"vm.orgsFriends\" \nselected-drop-down=\"vm.selectedDropDown\"></choose-list-select-bind-muted></md-content>");
$templateCache.put("app/main/restricted/organization/subscriberLists/details/tabs/general.html","<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><form \nname=\"subscriberListForm\" class=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" \nnovalidate=\"\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"CONTACTS_TEMPLATE_NAME\">Name</label><input type=\"text\" ng-model=\"vm.subscriberList.name\" \nng-pattern=\'/^[^\\\\/:*?\"<>|!@#$%^&;]+$/\' name=\"display-name\" translate aria-invalid=\"true\" md-maxlength=\"12\" required>\n<div ng-messages=\"subscriberListForm.name.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters</span></div></div>\n</md-input-container></div></form></md-content>");
$templateCache.put("app/main/restricted/organization/subscriberLists/details/tabs/members.details.html","<md-content class=\"content group-details\"><choose-list selected-elements=\"vm.selectedMembers\" \nnot-selected-elements=\"vm.unselectedMembers\" error=\"false\"></choose-list></md-content>");
$templateCache.put("app/main/restricted/organization/subscribers/details/permission-component/permission.component.html","<md-list-item><p>{{vm.permissionName}}</p><md-checkbox aria-label=\"permission-item\" class=\"md-secondary\" \nng-class=\"vm.getCheckboxClass()\" ng-model=\"vm.permissionItem\" ng-change=\"vm.changeParentItem()\" \nng-disabled=\"vm.isEdit\"></md-checkbox></md-list-item><md-list-item class=\"sub-permission\" ng-if=\"vm.isSubItem()\" \nng-show=\"vm.showSubItem\"><p>{{vm.permissionSubItemName}}</p><md-select ng-if=\"vm.multiSession\" \nng-disabled=\"!vm.permissionItem || vm.isEdit\" class=\"md-secondary\" ng-model=\"vm.permissionSubItem\"><md-option \nng-value=\"1\">4</md-option><md-option ng-value=\"2\">1</md-option><md-option ng-value=\"3\">8</md-option><md-option \nng-value=\"4\">16</md-option></md-select><md-checkbox ng-if=\"!vm.multiSession\" aria-label=\"permission-sub-item\" \nng-disabled=\"!vm.permissionItem || vm.isEdit\" class=\"md-secondary\" ng-model=\"vm.permissionSubItem\" \nng-true-value=\"false\" ng-false-value=\"true\"></md-checkbox></md-list-item>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/activity.html","<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><form \nname=\"vm.editSubscriberForm\" class=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" \nnovalidate=\"\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float><md-datepicker \nng-model=\"vm.subscriber.startDate\" ng-change=\"vm.checkDate()\" md-max-date=\"vm.now\" name=\"startDate\" \nmd-placeholder=\"{{ \'START_DATE\' | translate  }}\" required onkeydown=\"return false\"></md-datepicker>\n</md-input-container><md-input-container md-no-float><md-datepicker ng-model=\"vm.subscriber.endDate\" \nng-change=\"vm.checkDate()\" md-max-date=\"vm.now\" name=\"endDate\" md-placeholder=\"{{ \'END_DATE\' | translate  }}\" \nonkeydown=\"return false\"></md-datepicker></md-input-container><md-button ng-click=\"vm.getSecurityLog()\" \nng-disabled=\"vm.subscriber.errMessage\" aria-label=\"Add event\" translate translate-attr-aria-label=\"REFRESH\">\n<md-tooltip><span translate=\"APP_REFRESH\">Refresh</span></md-tooltip><md-icon md-font-icon=\"icon-refresh\"></md-icon>\n</md-button><span style=\"color:red;align-self: center\">{{vm.subscriber.errMessage}}</span></div><div layout=\"row\">\n<table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SUBSCRIBERS_SERIAL_NUMBER\">Serial Number</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_ADMINISTRATOR\">Administrator</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SUBSCRIBERS_TIME_STAMP\">Time-stamp (in GMT)</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_DESCRIPTION\">Description</span></div></th></tr>\n</thead><tbody><tr style=\"cursor:pointer\" ng-repeat=\"security in vm.securityList\"><td>{{$index + 1}}</td><td>\n{{security.administrator_name}}</td><td>{{security.timestamp | date:\'dd/MMM/yyyy h:mm:ss a\'}}</td><td>\n{{ security.description }} {{ security.new_value }}</td></tr></tbody></table></div><md-content \nng-if=\"!vm.securityList.length\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\"><p class=\"pd-2\" style=\"text-align: center\" translate=\"APP_NO_RECORDS\" \ntranslate-default=\"No data available\"></p></div></md-content></form></md-content>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/add.general.html","<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><form \nname=\"vm.addSubscriberForm\" class=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" \nnovalidate=\"\" ng-cloak ng-disabled=\"vm.loading\"><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.subscriberNameLimit\">\n<md-input-container flex><label translate=\"SUBSCRIBERS_DISPLAY_NAME\">Display name</label><input type=\"text\" \nng-model=\"vm.subscriber.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' name=\"displayName\" translate aria-invalid=\"true\" \nrequired md-maxlength=\"{{vm.subscriberNameLimit}}\" autocomplete=\"off\"><div \nng-messages=\"vm.addSubscriberForm.displayName.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span\n translate=\"APP_VALIDATION_REQUIRED\">Display Name field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">Display Name is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"SUBSCRIBERS_VALIDATION_SPECIAL_CHARS_ERROR\">Display name can not contain special characters</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"65\"><label \ntranslate=\"SUBSCRIBERS_USER_NAME\">Username (Phone Number)</label><input type=\"text\" name=\"name\" \nng-model=\"vm.subscriber.username\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' translate aria-invalid=\"true\" \nng-change=\"vm.generateSip()\" required md-maxlength=\"15\" autocomplete=\"off\"><div \nng-messages=\"vm.addSubscriberForm.name.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"domain\"><span \ntranslate=\"SUBSCRIBERS_VALIDATION_USERNAME_ORG_DOMAIN_ERROR\">Username can not contain org domain</span></div><div \nng-message=\"atMark\"><span translate=\"SUBSCRIBERS_VALIDATION_AT_ERROR\">Username can not contain \"@\" symbol</span></div>\n<div ng-message=\"pattern\"><span translate=\"APP_VALIDATION_SPECIAL_CHARS\">\nDisplay name can not contain special characters</span></div></div></md-input-container><md-input-container flex=\"30\">\n<label>Domain</label><input type=\"text\" ng-model=\"vm.organization.domain\" ng-disabled=\"true\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"SUBSCRIBERS_IMSI\">IMSI</label>\n<input type=\"text\" ng-model=\"vm.subscriber.imsi\" ng-pattern=\"/^[0-9]*$/\" name=\"imsi\" translate aria-invalid=\"true\" \nmd-maxlength=\"20\" minlength=\"14\"><div ng-messages=\"vm.addSubscriberForm.imsi.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">IMSI is too long</span></div><div \nng-message=\"minlength\"><span translate=\"APP_VALIDATION_MIN_LENGTH\">IMSI is too short</span></div><div \nng-message=\"pattern\"><span translate=\"SUBSCRIBERS_VALIDATION_ONLY_NUMBERS_ERROR\">IMSI can not contain characters</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SUBSCRIBERS_IMSI2\">IMSI2</label><input type=\"text\" ng-model=\"vm.subscriber.imsi2\" ng-pattern=\"/^[0-9]*$/\" \nname=\"imsi2\" translate aria-invalid=\"true\" md-maxlength=\"20\" minlength=\"14\"><div \nng-messages=\"vm.addSubscriberForm.imsi2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">IMSI2 is too long</span></div><div ng-message=\"minlength\"><span \ntranslate=\"APP_VALIDATION_MIN_LENGTH\">IMSI2 is too short</span></div><div ng-message=\"pattern\"><span \ntranslate=\"SUBSCRIBERS_VALIDATION_ONLY_NUMBERS_ERROR\">IMSI2 can not contain characters</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"SUBSCRIBERS_ROLE\">Role</label><md-select name=\"adminrole\" ng-model=\"vm.subscriber.adminrole_id\" required>\n<md-option ng-repeat=\"item in ::vm.rolesList\" ng-value=\"item._id\">{{item.name}}</md-option></md-select>\n</md-input-container><md-button class=\"content role-button\" \nng-disabled=\"!vm.subscriber.adminrole_id || vm.subscriber.adminrole_id == \'0\'\" \nng-click=\"vm.showRole(vm.subscriber.adminrole_id)\" translate=\"ROLE_SHOW\">Role Permissions</md-button></div><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showApplicationList\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"SUBSCRIBERS_APPLICATION_LIST\">Application Profile</label><md-select name=\"applicationList\" \nng-model=\"vm.subscriber.application_id\"><md-option ng-repeat=\"item in ::vm.applicationLists\" ng-value=\"item._id\">\n{{item.name}}</md-option></md-select></md-input-container><md-button class=\"content role-button\" \nng-disabled=\"!vm.subscriber.application_id || vm.subscriber.application_id == \'0\'\" \nng-click=\"vm.showApplication(vm.subscriber.application_id)\" translate=\"APP_LIST_SHOW\">Role Permissions</md-button>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.subscriber.phone\"><md-input-container flex><label \ntranslate=\"SUBSCRIBERS_PHONE_NUMBER\">Phone number</label><input type=\"text\" name=\"phone\" \nng-model=\"vm.subscriber.phone_number\" translate md-maxlength=\"15\" aria-invalid=\"true\"></md-input-container></div>\n<md-button ng-if=\"vm.subscriber._id && !vm.changePassword\" ng-click=\"vm.showPassword()\">Change password</md-button>\n<password-fields ng-if=\"(vm.subscriber._id && vm.changePassword) || !vm.subscriber._id\" \npassword=\"vm.subscriber.password\" re-password=\"vm.subscriber.rePassword\" form-name=\"vm.addSubscriberForm\" \nstrong-pass=\"vm.subscriber.strongDispatchPass\"></password-fields></form></md-content>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/contact.details.html","<md-content class=\"content group-details\"><choose-list selected-elements=\"vm.selectedContacts\" \nnot-selected-elements=\"vm.unselectedContacts\" pagination-id=\"vm.contactPaginationClass\" user=\"true\" \nerror=\"vm.errorOCLLimit\"></choose-list></md-content>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/forward.group.details.html","<div class=\"content-card\"><div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div></div><table \nclass=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'name\')\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" translate=\"FORWARD_GROUP_NAME\">\nSupport Group Name</span></div></th></tr></thead><tbody><tr title=\"{{vm.showId ? FwrdGroup._id : \'\'}}\" \ndir-paginate=\"FwrdGroup in vm.selectedFwrdGroup |searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td class=\"table-name-label\" width=\"25%\">{{FwrdGroup.name}}</td></tr></tbody></table><div \nlayout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"><md-input-container><label \ntranslate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" \nplaceholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option \nng-value=\"100\">100</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\">\n<dir-pagination-controls max-size=\"1\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div>\n</div></div>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/general.html","<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><form \nname=\"vm.editSubscriberForm\" class=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" \nnovalidate=\"\" ng-disabled=\"vm.loading\"><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.subscriberNameLimit\">\n<md-input-container flex><label translate=\"SUBSCRIBERS_DISPLAY_NAME\">Display name</label><input type=\"text\" \nng-model=\"vm.subscriber.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' name=\"displayName\" translate required \naria-invalid=\"true\" md-maxlength=\"{{vm.subscriberNameLimit}}\" autocomplete=\"off\"><div \nng-messages=\"vm.editSubscriberForm.displayName.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span translate=\"APP_VALIDATION_REQUIRED\">Display Name field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">Display Name is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"SUBSCRIBERS_VALIDATION_SPECIAL_CHARS_ERROR\">Display name can not contain special characters</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SUBSCRIBERS_USER_NAME_SIP\">User Name</label><input type=\"text\" name=\"name\" ng-model=\"vm.subscriber.sip\" \nng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\" ng-change=\"vm.checkDomain()\" translate aria-invalid=\"true\" \nng-disabled=\"true\" required md-maxlength=\"66\"><div ng-messages=\"vm.editSubscriberForm.name.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span>\n</div><div ng-message=\"pattern\"><span translate=\"SUBSCRIBERS_VALIDATION_SIP_FORMAT_ERROR\">Invalid SIP format</span>\n</div><div ng-message=\"domain\"><span><span translate=\"SUBSCRIBERS_VALIDATION_ORG_DOMAIN_ERROR\">\nInvalid org domain. Valid: </span>{{vm.organization.domain}}</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"SUBSCRIBERS_IMSI\">IMSI</label><input \ntype=\"text\" name=\"imsi\" ng-model=\"vm.subscriber.imsi\" ng-pattern=\"/^[0-9]*$/\" translate aria-invalid=\"true\" \nmd-maxlength=\"20\" minlength=\"14\"><div ng-messages=\"vm.editSubscriberForm.imsi.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"pattern\"><span translate=\"SUBSCRIBERS_VALIDATION_ONLY_NUMBERS_ERROR\">Invalid IMSI format</span></div>\n<div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">IMSI is too long</span></div><div \nng-message=\"minlength\"><span translate=\"APP_VALIDATION_MIN_LENGTH\">IMSI is too short</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showIMSI2\"><md-input-container flex><label\n translate=\"SUBSCRIBERS_IMSI2\">IMSI2</label><input type=\"text\" name=\"imsi2\" ng-model=\"vm.subscriber.imsi2\" \nng-pattern=\"/^[0-9]*$/\" translate aria-invalid=\"true\" md-maxlength=\"20\" minlength=\"14\"><div \nng-messages=\"vm.editSubscriberForm.imsi2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span \ntranslate=\"SUBSCRIBERS_VALIDATION_ONLY_NUMBERS_ERROR\">Invalid IMSI2 format</span></div><div ng-message=\"maxlength\">\n<span translate=\"APP_VALIDATION_MAX_LENGTH\">IMSI2 is too long</span></div><div ng-message=\"minlength\"><span \ntranslate=\"APP_VALIDATION_MIN_LENGTH\">IMSI2 is too short</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label translate=\"SUBSCRIBERS_ROLE\">Role\n</label><md-select name=\"adminrole\" ng-model=\"vm.subscriber.adminrole_id\" \nng-required=\"!vm.subscriber.adminrole_id || vm.subscriber.adminrole_id == \'0\'\"><md-option \nng-repeat=\"item in ::vm.rolesList\" ng-value=\"item._id\">{{item.name}}</md-option></md-select></md-input-container>\n<md-button class=\"content role-button\" ng-disabled=\"!vm.subscriber.adminrole_id || vm.subscriber.adminrole_id == \'0\'\" \nng-click=\"vm.showRole(vm.subscriber.adminrole_id)\" translate=\"ROLE_SHOW\">Role Permissions</md-button></div><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showApplicationList\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"SUBSCRIBERS_APPLICATION_LIST\">Application Profile</label><md-select name=\"applicationList\" \nng-model=\"vm.subscriber.application_id\"><md-option ng-repeat=\"item in ::vm.applicationLists\" ng-value=\"item._id\">\n{{item.name}}</md-option></md-select></md-input-container><md-button class=\"content role-button\" \nng-disabled=\"!vm.subscriber.application_id || vm.subscriber.application_id == \'0\'\" \nng-click=\"vm.showApplication(vm.subscriber.application_id)\" translate=\"APP_LIST_SHOW\">Role Permissions</md-button>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.mobileUser && vm.subscriber.username\"><md-input-container flex>\n<label translate=\"SUBSCRIBERS_PHONE_NUMBER\">Phone number</label><input ng-disabled=\"true\" type=\"text\" \nname=\"display-name\" ng-model=\"vm.subscriber.phone_number\" translate aria-invalid=\"true\" md-maxlength=\"19\">\n</md-input-container></div><md-button ng-if=\"vm.subscriber._id && !vm.changePassword\" ng-click=\"vm.showPassword()\" \ntranslate=\"APP_CHANGE_PASSWORD\">Change password</md-button><password-fields \nng-if=\"(vm.subscriber._id && vm.changePassword) || !vm.subscriber._id\" password=\"vm.subscriber.password\" \nre-password=\"vm.subscriber.rePassword\" form-name=\"vm.editSubscriberForm\" \nstrong-pass=\"vm.subscriber.strongDispatchPass\"></password-fields><md-button ng-click=\"vm.openSMSdialog(vm.subscriber)\" \nng-if=\"vm.allowSms && vm.mobileUser && vm.showSms\" translate=\"APP_SEND_SMS\">Send SMS</md-button></form></md-content>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/group.details.html","<md-content class=\"content group-details\"><choose-list selected-elements=\"vm.selectedGroups\" \nnot-selected-elements=\"vm.unselectedGroups\" pagination-id=\"vm.groupPaginationClass\" \ndisallow-update=\"!vm.allowUpdateGroups\" default-radio-group=\"vm.subscriber.default_group_id\" user=\"true\" \nerror=\"vm.errorGroupsLimit\" subscriber-grp-detail=\"vm.showMutedSubscriberGrp\"></choose-list></md-content><md-content \nclass=\"default-group\" ng-disabled=\"!vm.allowUpdateGroups\"><div layout=\"column\" layout-gt-sm=\"row\" \nname=\"vm.subscriberGroupForm\" ng-if=\"vm.mobileUser || vm.mobileUser\"><md-input-container md-no-float flex><label><span \ntranslate=\"SUBSCRIBERS_DEFAULT_RADIO_GROUP\">Default Radio Group </span>(<span translate=\"SUBSCRIBERS_DEFAULT_SOS_MSG\" \nstyle=\"color:red\">This will be default SOS!</span>)</label><md-select name=\"defaultGroup\" \nng-model=\"vm.subscriber.default_group_id\" ng-change=\"vm.chooseDefaultRadioGroup()\"><md-option ng-value=\"null\">\n{{\'None\'}}</md-option><md-option ng-repeat=\"item in vm.radioGroups\" ng-value=\"item._id\">{{item.name}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showPersonalGroup\">\n<md-input-container md-no-float flex><label><span translate=\"SUBSCRIBERS_EMERGENCY_GROUP\">Emergency Group </span>\n</label><md-select name=\"emergencyGroup\" ng-model=\"vm.subscriber.emergencyGroup._id\"><md-option ng-value=\"null\">\n{{\'None\'}}</md-option><md-option ng-repeat=\"item in vm.emergencyGroups\" ng-value=\"item._id\">{{item.name}}</md-option>\n</md-select></md-input-container></div></md-content>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/license.details.html","<md-content class=\"content group-details\"><form name=\"basicForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate=\"\"><div layout=\"row\"><p \ntranslate=\"SUBSCRIBERS_CURRENT_LICENSE\"><b>Current License</b></p></div><div layout=\"row\" \nclass=\"subscriber-license-label\"><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_LICENSE_NAME\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_LICENSE_TYPE\">Type\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SUBSCRIBERS_LICENSE_RENEWAL\">Renewal</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"SUBSCRIBERS_LICENSE_EXPIRE\">Expires</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_LICENSE_REVOKE\">Revoke</span></div></th>\n</tr></thead><tbody><tr><td class=\"table-name-label\" ng-click=\"vm.editLicense(vm.subscriber.license.licenseBundle)\">\n{{vm.subscriber.license.licenseBundle.name}}</td><td>{{vm.subscriber.license.licenseType}}</td><td>\n{{vm.subscriber.license.expirationType}}</td><td>{{vm.subscriber.license.expirationDate | date: medium}}</td><td>\n<md-button class=\"remove-button md-icon-button\" aria-label=\"Revoke license\" \nng-if=\"vm.subscriber.license.licenseType && vm.allowModify\" ng-click=\"vm.selectForRevokation()\" translate \ntranslate-attr-aria-label=\"SUBSCRIBERS.DELETE\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></div><div layout=\"row\" layout-align=\"end center\"></div><div layout=\"row\"><p \ntranslate=\"SUBSCRIBERS_LICENSE_ASSIGN_NEW\"><b>Assign new license</b></p></div><div layout=\"row\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SUBSCRIBERS_LICENSE_NAME\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_LICENSE_TYPE\">Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_LICENSE_RENEWAL\">\nRenewal</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SUBSCRIBERS_LICENSE_EXPIRE\">Expires</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"SUBSCRIBERS_LICENSE_QTY\">Available</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"SUBSCRIBERS_LICENSE_ASSIGN\">Assign</span></div></th>\n</tr></thead><tbody><tr style=\"cursor:pointer\" ng-mouseover=\"vm.showAllocationButton(license._id)\" \nng-repeat=\"license in vm.allocationsList track by $index\"><td class=\"table-name-label\" \nng-click=\"vm.editLicense(license.licenseBundle)\">{{license.licenseBundle.name}}</td><td>{{license.licenseType}}</td>\n<td>{{license.expirationType}}</td><td>{{license.expirationDate | date: medium}}</td><td>{{license.availableQty}}</td>\n<td><md-button class=\"remove-button md-icon-button\" aria-label=\"Assign\" \nng-if=\"vm.checkActiveAllocation(license._id) && vm.allowModify\" ng-click=\"vm.selectAllocation(license) \" translate \ntranslate-attr-aria-label=\"SUBSCRIBERS.ADD\"><md-icon md-font-icon=\"icon-plus\" class=\"s16\"></md-icon></md-button></td>\n</tr></tbody></table></div></form></md-content>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/license.permissions.html","<form name=\"licenseForm\" class=\"license-template\" ng-cloak><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nmd-no-float flex><label><span translate=\"LICENSE_TEMPLATES\">License templates </span></label><md-select \nname=\"licenseTemplate\" ng-model=\"vm.selectedTemplate\"><md-option ng-value=\"null\">{{\'CUSTOM\'}}</md-option><md-option \nng-repeat=\"item in vm.licenseTemplates\" ng-value=\"item.name\" ng-click=\"vm.chooseTemplate(item.name)\" \nng-keyup=\"$event.keyCode == 13 ? vm.chooseTemplate(item.name) : null\">{{item.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-list \nflex><md-subheader class=\"md-no-sticky\" translate=\"LICENSE_PERMISSIONS\">Permissions</md-subheader>\n<subscriber-permission-item permission-name=\"\'Conference\'\" permission-sub-item-name=\"\'Disable Conference Origination\'\" \npermission-sub-item=\"vm.subscriber.license.conference.originate\" \npermission-visible=\"vm.subscriber.license.conference.terminate\" \npermission-item=\"vm.subscriber.license.conference.terminate\" show-sub-item=\"true\" \nis-edit=\"vm.selectedTemplate != null\"></subscriber-permission-item><subscriber-permission-item \npermission-name=\"\'Radio\'\" permission-visible=\"vm.subscriber.license.radio\" \npermission-item=\"vm.subscriber.license.radio\" show-sub-item=\"false\" is-edit=\"vm.selectedTemplate != null\">\n</subscriber-permission-item><subscriber-permission-item permission-name=\"\'Ad Hoc\'\" \npermission-sub-item-name=\"\'Disable Ad Hoc Origination\'\" permission-sub-item=\"vm.subscriber.license.adHoc.originate\" \npermission-visible=\"vm.subscriber.license.adHoc.terminate\" permission-item=\"vm.subscriber.license.adHoc.terminate\" \nshow-sub-item=\"true\" is-edit=\"vm.selectedTemplate != null\"></subscriber-permission-item><subscriber-permission-item \npermission-name=\"\'Private\'\" permission-sub-item-name=\"\'Disable Private Origination\'\" \npermission-sub-item=\"vm.subscriber.license.private.originate\" \npermission-visible=\"vm.subscriber.license.private.terminate\" permission-item=\"vm.subscriber.license.private.terminate\" \nshow-sub-item=\"true\" is-edit=\"vm.selectedTemplate != null\"></subscriber-permission-item><subscriber-permission-item \npermission-name=\"\'Smart Off-Net\'\" permission-visible=\"vm.subscriber.license.startOffNet\" \npermission-item=\"vm.subscriber.license.startOffNet\" show-sub-item=\"false\" is-edit=\"vm.selectedTemplate != null\">\n</subscriber-permission-item><subscriber-permission-item permission-name=\"\'IM\'\" \npermission-sub-item-name=\"\'Disable IM Origination\'\" permission-sub-item=\"vm.subscriber.license.im.originate\" \npermission-visible=\"vm.subscriber.license.im.terminate\" permission-item=\"vm.subscriber.license.im.terminate\" \nshow-sub-item=\"true\" is-edit=\"vm.selectedTemplate != null\"></subscriber-permission-item><subscriber-permission-item \npermission-name=\"\'GPS\'\" permission-visible=\"vm.subscriber.license.gps\" permission-item=\"vm.subscriber.license.gps\" \nshow-sub-item=\"false\" is-edit=\"vm.selectedTemplate != null\"></subscriber-permission-item><subscriber-permission-item \npermission-name=\"\'Emergency\'\" permission-visible=\"vm.subscriber.license.sos\" \npermission-item=\"vm.subscriber.license.sos\" show-sub-item=\"false\" is-edit=\"vm.selectedTemplate != null\">\n</subscriber-permission-item><subscriber-permission-item permission-name=\"\'Dispatcher\'\" \npermission-visible=\"vm.subscriber.license.dispatcher\" permission-item=\"vm.subscriber.license.dispatcher\" \npermission-parent-item=\"vm.subscriber.license.webDispatcher\" show-sub-item=\"false\" \nis-edit=\"vm.selectedTemplate != null\"></subscriber-permission-item><subscriber-permission-item \npermission-name=\"\'Web Dispatcher\'\" permission-visible=\"vm.subscriber.license.webDispatcher\" \npermission-item=\"vm.subscriber.license.webDispatcher\" permission-parent-item=\"vm.subscriber.license.dispatcher\" \nshow-sub-item=\"false\" is-edit=\"vm.selectedTemplate != null\"></subscriber-permission-item><subscriber-permission-item \npermission-name=\"\'Priority Call\'\" permission-visible=\"vm.subscriber.license.priorityCall\" \npermission-item=\"vm.subscriber.license.priorityCall\" show-sub-item=\"false\" is-edit=\"vm.selectedTemplate != null\">\n</subscriber-permission-item></md-list></div></form><div class=\"row\" flex ng-if=\"vm.error\"><div class=\"error-msg\" \nng-model=\"vm.error\">{{vm.error}}</div></div>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/personal.contacts.details.html","<md-content class=\"content group-details\"><choose-list selected-elements=\"vm.selectedPersonalContacts\" \nnot-selected-elements=\"vm.unselectedPersonalContacts\" pagination-id=\"vm.personalContactsPaginationClass\" \ndispatcher=\"vm.subscriber.license.dispatcher\" error=\"vm.errorPersonalContactLimit\"></choose-list></md-content>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/personal.group.details.html","<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"PERSONAL_GROUP_NAME\">Name</label>\n<input style=\"font-size:20px\" type=\"text\" ng-model=\"vm.personalGroupName\" required aria-invalid=\"true\" \nng-disabled=\"true\"></md-input-container></div><md-content class=\"content group-details\">\n<choose-list-bind-personal-group selected-contacts=\"vm.selectedPersonalContacts\" \nunselected-contacts=\"vm.unselectedPersonalContacts\" selected-elements=\"vm.selectedPersonalGroupContacts\" \npagination-id=\"vm.personalGroupsPaginationClass\"></choose-list-bind-personal-group><span \ntranslate=\"PERSONAL_GROUP_NOTE\" style=\"font-weight:bold\">\nPlease make sure that you have permission of Personal group in your role</span></md-content>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/runtime.details.html","<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label translate=\"SUBSCRIBERS_SITE\">Site</label>\n<md-select name=\"site\" ng-model=\"vm.subscriber.site\" ng-change=\"vm.generateSip()\" ng-required=\"!vm.subscriber.site\" \nng-disabled=\"true\"><md-option ng-repeat=\"item in ::vm.sites\" ng-value=\"item._id\">{{item.name}} {{item.iprs_public}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label translate=\"SUBSCRIBERS_CREATION_TIME\">Creation time</label><input type=\"datetime\" ng-disabled=\"true\" \nname=\"display-time\" ng-model=\"vm.subscriber.creation_time\" translate aria-invalid=\"true\"></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SUBSCRIBERS_RUNTIME_LAST_REGISTRATION_TIME\">Last Registration Time</label><input type=\"datetime\" \nng-model=\"vm.subscriber.runtime.lastRegistrationTime\" translate disabled=\"disabled\" aria-invalid=\"true\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showChangePassword\"><md-input-container \nflex><label translate=\"USER_LAST_PASSWORD_CHANGE_TIME\">Last Password Time</label><input type=\"datetime\" \nng-model=\"vm.subscriber.last_password_change_timestamp\" translate disabled=\"disabled\" aria-invalid=\"true\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SUBSCRIBERS_CHANGE_STATE_TIME\">Change state time</label><input type=\"datetime\" ng-disabled=\"true\" \nname=\"display-time\" ng-model=\"vm.subscriber.change_state_time\" translate aria-invalid=\"true\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.subscriber.runtime.state\"><md-input-container flex><label \ntranslate=\"SUBSCRIBERS_RUNTIME_STATE\">State</label><input type=\"text\" ng-model=\"vm.subscriber.runtime.state\" translate \ndisabled=\"disabled\" aria-invalid=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.subscriber.runtime.clientType\"><md-input-container flex><label translate=\"SUBSCRIBERS_CLIENT_TYPE\">\nClient Type</label><input type=\"text\" ng-model=\"vm.subscriber.runtime.clientType\" translate disabled=\"disabled\" \naria-invalid=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.subscriber.runtime.clientVersion\"><md-input-container flex><label \ntranslate=\"SUBSCRIBERS_RUNTIME_APP_VERSION\">App Version</label><input type=\"text\" \nng-model=\"vm.subscriber.runtime.clientVersion\" translate disabled=\"disabled\" aria-invalid=\"true\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.subscriber.runtime.model_name\"><md-input-container flex><label \ntranslate=\"SUBSCRIBERS_RUNTIME_MODEL_NAME\">Model name</label><input type=\"text\" \nng-model=\"vm.subscriber.runtime.model_name\" translate disabled=\"disabled\" aria-invalid=\"true\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.subscriber.runtime.os_type\"><md-input-container flex><label \ntranslate=\"SUBSCRIBERS_RUNTIME_OS_TYPE\">OS type</label><input type=\"text\" ng-model=\"vm.subscriber.runtime.os_type\" \ntranslate disabled=\"disabled\" aria-invalid=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.subscriber.runtime.os_version\"><md-input-container flex><label translate=\"SUBSCRIBERS_RUNTIME_OS_VERSION\">\nOS version</label><input type=\"text\" ng-model=\"vm.subscriber.runtime.os_version\" translate disabled=\"disabled\" \naria-invalid=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.subscriber.runtime.brand\"><md-input-container flex><label translate=\"SUBSCRIBERS_RUNTIME_BRAND\">Brand</label>\n<input type=\"text\" ng-model=\"vm.subscriber.runtime.brand\" translate disabled=\"disabled\" aria-invalid=\"true\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.subscriber.runtime.manufacture\">\n<md-input-container flex><label translate=\"SUBSCRIBERS_RUNTIME_MANUFACTURE\">manufacture</label><input type=\"text\" \nng-model=\"vm.subscriber.runtime.manufacture\" translate disabled=\"disabled\" aria-invalid=\"true\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.subscriber.runtime.memory\"><md-input-container flex><label \ntranslate=\"SUBSCRIBERS_RUNTIME_MEMORY\">Memory</label><input type=\"text\" ng-model=\"vm.subscriber.runtime.memory\" \ntranslate disabled=\"disabled\" aria-invalid=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.subscriber.runtime.fw_version\"><md-input-container flex><label translate=\"SUBSCRIBERS_RUNTIME_FW_VERSION\">\nfw version</label><input type=\"text\" ng-model=\"vm.subscriber.runtime.fw_version\" translate disabled=\"disabled\" \naria-invalid=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.subscriber.runtime.build_type\"><md-input-container flex><label translate=\"SUBSCRIBERS_RUNTIME_BUILD\">Build\n</label><input type=\"text\" ng-model=\"vm.subscriber.runtime.build_type\" translate disabled=\"disabled\" \naria-invalid=\"true\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.subscriber.runtime.fcm\"><md-input-container flex><label translate=\"SUBSCRIBERS_RUNTIME_FCM\">FCM</label><input\n type=\"text\" ng-model=\"vm.subscriber.runtime.fcm\" translate disabled=\"disabled\" aria-invalid=\"true\">\n</md-input-container></div></md-content>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/subscriber.list.details.html","<span translate=\"SUBSCRIBER_LIST_NOTE\" flex style=\"color: red\">\nAffiliated contact list can be assign to user without offnet license user, but only own organization contacts will be assign to user\n</span><md-content class=\"content group-details\"><choose-list selected-elements=\"vm.selectedSubscriberLists\" \nnot-selected-elements=\"vm.unselectedSubscriberLists\" selected-bind-elements=\"vm.selectedPersonalContacts\" \nnot-selected-bind-elements=\"vm.unselectedPersonalContacts\" organization-subscriber-list=\"vm.orgSubscribersList\" \npagination-id=\"vm.subscriberListsPaginationClass\" current-id=\"vm.subscriber._id\" \ndispatcher=\"vm.subscriber.license.dispatcher\" default-radio-group=\"vm.subscriber.default_group_id\" user=\"true\" \nerror=\"vm.errorCGroupsLimit\"></choose-list></md-content>");
$templateCache.put("app/main/restricted/organization/subscribers/details/tabs/totp.html","<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default totpData\"><md-button \nng-if=\"!vm.subscriber.two_factor_secret\" class=\"md-raised md-accent\" ng-click=\"vm.enableTwoFactor(1)\" \nstyle=\"min-width: min-content; width: -webkit-fill-available\" lazy-load=\"true\"><label \ntranslate=\"APP_QR_ENABLE_AUTHENTICATION\">Enable Authentication</label></md-button><div class=\"qrCodeImg\" \nid=\"authQrCode\" ng-if=\"vm.subscriber.two_factor_secret\"></div><div class=\"btnGroup\"><md-button \nclass=\"md-raised md-accent\" ng-if=\"vm.subscriber.two_factor_secret\" \nstyle=\"min-width: min-content; width: -webkit-fill-available\" lazy-load=\"true\" ng-click=\"vm.generateQrCode(2)\"><label \ntranslate=\"APP_QR_REGENERATE_AUTHENTICATION\">Re-generate Authentication</label></md-button><md-button \nclass=\"md-raised md-danger\" ng-if=\"vm.subscriber.two_factor_secret\" ng-click=\"vm.generateQrCode(0)\" \nstyle=\"min-width: min-content; width: -webkit-fill-available\" lazy-load=\"true\"><label \ntranslate=\"APP_QR_DISABLE_AUTHENTICATION\">Disable Authentication</label></md-button></div></md-content></md-content>");
$templateCache.put("app/main/restricted/platform/config/tabs/custom/custom.list.html","<div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.searchConfig\" type=\"text\" md-maxlength=\"50\">\n</md-input-container></div></div><table class=\"dataTable row-border stripe hover\"><thead><tr><th \nclass=\"secondary-text\" ng-click=\"vm.sortConfig(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getConfigSortingClass(\'name\')\" translate=\"CONFIG_NAME\">Name</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortConfig(\'value\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getConfigSortingClass(\'value\')\" translate=\"CONFIG_VALUE\">Value</span></div></th></tr></thead><tbody><tr \ntitle=\"{{vm.showId ? param.parameter_id : \'\'}}\" \ndir-paginate=\"param in vm.customParameters|searchByName:vm.searchConfig |itemsPerPage:vm.recordsCount track by $index\" \npagination-id=\"configPagination\" ng-class-odd=\"\'odd\'\"><td width=\"40%\" class=\"table-name-label\" \nng-click=\"vm.editConfig(param)\">{{param.name}}</td><td width=\"100%\" class=\"table-name-label\" \nng-click=\"vm.editConfig(param)\">{{param.value}}</td></tr></tbody></table><md-content \nng-if=\"!vm.customParameters.length\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\"><p class=\"pd-2\" translate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div>\n</md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option \nng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"end center\"><dir-pagination-controls pagination-id=\"configPagination\" max-size=\"1\" \ndirection-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></div>");
$templateCache.put("app/main/restricted/platform/config/tabs/general/general.list.html","<div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.searchConfig\" type=\"text\" md-maxlength=\"50\">\n</md-input-container></div><md-button class=\"add-button md-fab md-warn\" ng-click=\"vm.addConfig()\" \naria-label=\"Add event\" translate translate-attr-aria-label=\"CONFIG_ADD_PARAMETER\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><table class=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sortConfig(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getConfigSortingClass(\'name\')\" translate=\"CONFIG_NAME\">Name</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortConfig(\'value\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getConfigSortingClass(\'value\')\" translate=\"CONFIG_VALUE\">Value</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"APP_REMOVE\">Actions</span></div>\n</th></tr></thead><tbody><tr title=\"{{vm.showId ? param.parameter_id : \'\'}}\" \ndir-paginate=\"param in vm.parameters|searchByName:vm.searchConfig |itemsPerPage:vm.recordsCount track by $index\" \npagination-id=\"configPagination\" ng-class-odd=\"\'odd\'\"><td width=\"40%\" class=\"table-name-label\" \nng-click=\"vm.editConfig(param)\">{{param.name}}</td><td width=\"100%\" class=\"table-name-label\" \nng-click=\"vm.editConfig(param)\">{{param.value}}</td><td><md-button class=\"edit-button md-icon-button\" \naria-label=\"organisation details\" translate translate-attr-aria-label=\"AR.DELETE\" \nng-click=\"vm.deleteConfig(param.parameter_id)\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table><md-content ng-if=\"!vm.parameters.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex \nclass=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"><md-input-container><label \ntranslate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" \nplaceholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option \nng-value=\"100\">100</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\">\n<dir-pagination-controls pagination-id=\"configPagination\" max-size=\"1\" direction-links=\"true\" boundary-links=\"true\">\n</dir-pagination-controls></div></div>");
$templateCache.put("app/main/restricted/platform/config/tabs/license_view/license.view.html","<table class=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"CONFIG_NAME\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CONFIG_VALUE\">Value</span></div></th></tr></thead><tbody><tr\n ng-class-odd=\"\'odd\'\"><td class=\"table-name-label\">License Issue Date</td><td class=\"table-name-label\">\n{{vm.license.issueDate}}</td></tr><tr><td width=\"40%\" class=\"table-name-label\">License Expiry Date</td><td \nwidth=\"100%\" class=\"table-name-label\">{{vm.license.expires}}</td></tr><tr ng-class-odd=\"\'odd\'\"><td \nclass=\"table-name-label\">Allowed Host IDs</td><td class=\"table-name-label\">\n{{vm.license.hostIDs?vm.license.hostIDs.join(\', \'):\'\'}}</td></tr><tr><td class=\"table-name-label\">\nLicensed Subscribers count</td><td class=\"table-name-label\">{{vm.license.subscriberCount}}</td></tr><tr \nng-class-odd=\"\'odd\'\"><td class=\"table-name-label\">Current Active Subscribers count</td><td class=\"table-name-label\">\n{{vm.license.activeSubscriber}}</td></tr><tr><td class=\"table-name-label\">Tolerance percentage</td><td \nclass=\"table-name-label\">{{vm.license.tolerancePercentage}}</td></tr><tr ng-class-odd=\"\'odd\'\"><td \nclass=\"table-name-label\">Treat Suspended / Disabled</td><td class=\"table-name-label\">\n{{(vm.license.treatSuspended == \'1\')?\'Yes\':\'No\'}}</td></tr></tbody></table><md-content ng-if=\"!vm.license\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content>");
$templateCache.put("app/main/restricted/platform/config/tabs/secondary_site/secondary_site.html","<md-content class=\"content\"><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"\">Site2</label><md-select \nng-model=\"vm.SecondarySite.site\"><md-option ng-repeat=\"site in vm.sites\" value=\"{{site._id}}\" \nng-selected=\"{{ site._id === vm.secondarySiteId ? \'true\' : \'false\' }}\">{{site.name}} {{site.iprs_public}}</md-option>\n</md-select><div ng-messages=\"vm.orgForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div></div></md-input-container></div></md-content>\n<div layout=\"row\" style=\"float: left\"><md-button ng-click=\"vm.save()\" aria-label=\"\" translate=\"APP_SAVE\">Save\n</md-button></div>");
$templateCache.put("app/main/restricted/platform/config/tabs/server/server.list.html","<div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.searchServer\" type=\"text\" md-maxlength=\"50\">\n</md-input-container></div></div><table class=\"dataTable row-border stripe hover\"><thead><tr><th \nclass=\"secondary-text\" ng-click=\"vm.sortServers(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getServerSortingClass(\'name\')\" translate=\"SERVER_NAME\">Name</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortServers(\'host\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getServerSortingClass(\'host\')\" translate=\"SERVER_HOST\">Host</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortServers(\'type\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getServerSortingClass(\'type\')\" translate=\"SERVER_TYPE\">Type</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortServers(\'adminState\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getServerSortingClass(\'adminState\')\" translate=\"SERVER_ADMIN_STATE\">Administration</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sortServers(\'state\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getServerSortingClass(\'state\')\" translate=\"SERVER_STATE\">State</span></div></th></tr></thead><tbody><tr \ntitle=\"{{vm.showId ? server._id : \'\'}}\" \ndir-paginate=\"server in vm.servers|searchByName:vm.searchServer |itemsPerPage:vm.recordsCount track by $index\" \npagination-id=\"serverPagination\" ng-class-odd=\"\'odd\'\"><td width=\"20%\" class=\"table-name-label\">{{server.name}}</td><td \nwidth=\"20%\" class=\"table-name-label\">{{server.host}}</td><td width=\"20%\" class=\"table-name-label\">\n{{vm.getServerTypeById(server.type)}}</td><td width=\"20%\" class=\"table-name-label\">\n{{vm.getServerAdminStateById(server.adminState)}}</td><td width=\"20%\" class=\"table-name-label\">\n{{vm.getServerStateById(server.state)}}</td></tr></tbody></table><md-content ng-if=\"!vm.servers.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex \nclass=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"><md-input-container><label \ntranslate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" \nplaceholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option \nng-value=\"100\">100</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\">\n<dir-pagination-controls pagination-id=\"serverPagination\" max-size=\"1\" direction-links=\"true\" boundary-links=\"true\">\n</dir-pagination-controls></div></div>");
$templateCache.put("app/main/restricted/platform/config/tabs/site/site.list.html","<div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nclass=\"context-search\" flex layout-align=\"flex-start\"><md-input-container><label translate=\"APP_SEARCH\">Search</label>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input ng-model=\"vm.searchSite\" type=\"text\" md-maxlength=\"50\">\n</md-input-container></div></div><table class=\"dataTable row-border stripe hover\"><thead><tr><th \nclass=\"secondary-text\" ng-click=\"vm.sortSites(\'name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSiteSortingClass(\'name\')\" translate=\"SITE_NAME\">Name</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortSites(\'type\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSiteSortingClass(\'type\')\" translate=\"SITE_TYPE\">Type</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortSites(\'host\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSiteSortingClass(\'host\')\" translate=\"SITE_HOST\">Host</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortSites(\'server1\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSiteSortingClass(\'server1\')\" translate=\"SITE_SERVER_1\">Server</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sortSites(\'server2\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSiteSortingClass(\'server2\')\" translate=\"SITE_SERVER_2\">Server 2</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sortSites(\'state\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSiteSortingClass(\'state\')\" translate=\"SITE_STATE\">Host</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortSites(\'iprs_public\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSiteSortingClass(\'iprs_public\')\" translate=\"SITE_PUBLIC_IP\">Host</span></div></th></tr></thead><tbody>\n<tr title=\"{{vm.showId ? site._id : \'\'}}\" \ndir-paginate=\"site in vm.sites|searchByName:vm.searchSite |itemsPerPage:vm.recordsCount track by $index\" \npagination-id=\"sitesPagination\" ng-class-odd=\"\'odd\'\"><td width=\"12%\" class=\"table-name-label\">{{site.name}}</td><td \nwidth=\"12%\" class=\"table-name-label\">{{vm.getServerTypeById(site.type)}}</td><td width=\"12%\" class=\"table-name-label\">\n{{site.host}}</td><td width=\"12%\" class=\"table-name-label\">{{vm.getServerNameById(site.server1)}}</td><td width=\"12%\" \nclass=\"table-name-label\">{{vm.getServerNameById(site.server2)}}</td><td width=\"12%\" class=\"table-name-label\">\n{{vm.getSiteStateById(site.state)}}</td><td width=\"28%\" class=\"table-name-label\">{{site.iprs_public}}</td></tr></tbody>\n</table><md-content ng-if=\"!vm.sites.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex \nclass=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"><md-input-container><label \ntranslate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" \nplaceholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option \nng-value=\"100\">100</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\">\n<dir-pagination-controls pagination-id=\"sitesPagination\" max-size=\"1\" direction-links=\"true\" boundary-links=\"true\">\n</dir-pagination-controls></div></div>");
$templateCache.put("app/main/restricted/platform/licenses/tabs/convert/license.convert.html","<form name=\"licenseForm\" ng-cloak><div><md-button class=\"md-raised\" ng-click=\"vm.convertToMask(vm.license)\" \ntranslate=\"CONVERT_TO_MASK\">Convert to mask</md-button><md-button class=\"md-raised\" \nng-click=\"vm.convertToLicense(vm.mask)\" translate=\"CONVERT_TO_LICENSE\" \nng-disabled=\"vm.licenseForm.$invalid || !vm.mask\">Convert to license</md-button></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"LICENSE_MASK\">License Mask</label><input type=\"text\" \nng-model=\"vm.mask\" ng-pattern=\"/^-?(0|[1-9]\\d*)?$/\" name=\"licenseMask\" translate required aria-invalid=\"true\" \nmd-maxlength=\"12\"><div ng-messages=\"vm.licenseForm.licenseMask.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span translate=\"LICENSE_MASK_VALIDATION_SPECIAL_CHARS_ERROR\">\nLicense maks can contain only numbers</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column license-template\"><md-list flex><md-subheader \nclass=\"md-no-sticky\" translate=\"LICENSE_PERMISSIONS\">Permissions</md-subheader><permission-list-convert \npermission-name=\"\'Conference\'\" permission-sub-item-name=\"\'Disable Conference Origination\'\" \npermission-sub-item=\"vm.licenseConvert.conference.originate\" \npermission-visible=\"vm.licenseConvert.conference.terminate\" permission-item=\"vm.licenseConvert.conference.terminate\" \nshow-sub-item=\"true\" is-edit=\"false\"></permission-list-convert><permission-list-convert permission-name=\"\'Radio\'\" \npermission-visible=\"vm.licenseConvert.radio\" permission-item=\"vm.licenseConvert.radio\" show-sub-item=\"false\" \nis-edit=\"false\"></permission-list-convert><permission-list-convert permission-name=\"\'Ad Hoc\'\" \npermission-sub-item-name=\"\'Disable Ad Hoc Origination\'\" permission-sub-item=\"vm.licenseConvert.adHoc.originate\" \npermission-visible=\"vm.licenseConvert.adHoc.terminate\" permission-item=\"vm.licenseConvert.adHoc.terminate\" \nshow-sub-item=\"true\" is-edit=\"false\"></permission-list-convert><permission-list-convert permission-name=\"\'Private\'\" \npermission-sub-item-name=\"\'Disable Private Origination\'\" permission-sub-item=\"vm.licenseConvert.private.originate\" \npermission-visible=\"vm.licenseConvert.private.terminate\" permission-item=\"vm.licenseConvert.private.terminate\" \nshow-sub-item=\"true\" is-edit=\"false\"></permission-list-convert><permission-list-convert \npermission-name=\"\'Smart Off-Net\'\" permission-visible=\"vm.licenseConvert.startOffNet\" \npermission-item=\"vm.licenseConvert.startOffNet\" show-sub-item=\"false\" is-edit=\"false\"></permission-list-convert>\n<permission-list-convert permission-name=\"\'IM\'\" permission-sub-item-name=\"\'Disable IM Origination\'\" \npermission-sub-item=\"vm.licenseConvert.im.originate\" permission-visible=\"vm.licenseConvert.im.terminate\" \npermission-item=\"vm.licenseConvert.im.terminate\" show-sub-item=\"true\" is-edit=\"false\"></permission-list-convert>\n<permission-list-convert permission-name=\"\'GPS\'\" permission-visible=\"vm.licenseConvert.gps\" \npermission-item=\"vm.licenseConvert.gps\" show-sub-item=\"false\" is-edit=\"false\"></permission-list-convert>\n<permission-list-convert permission-name=\"\'Emergency\'\" permission-visible=\"vm.licenseConvert.sos\" \npermission-item=\"vm.licenseConvert.sos\" show-sub-item=\"false\" is-edit=\"false\"></permission-list-convert>\n<permission-list-convert permission-name=\"\'Dispatcher\'\" permission-visible=\"vm.licenseConvert.dispatcher\" \npermission-item=\"vm.licenseConvert.dispatcher\" permission-parent-item=\"vm.licenseConvert.webDispatcher\" \nshow-sub-item=\"false\" is-edit=\"false\"></permission-list-convert><permission-list-convert \npermission-name=\"\'Web Dispatcher\'\" permission-visible=\"vm.licenseConvert.webDispatcher\" \npermission-item=\"vm.licenseConvert.webDispatcher\" permission-parent-item=\"vm.licenseConvert.dispatcher\" \nshow-sub-item=\"false\" is-edit=\"false\"></permission-list-convert><permission-list-convert \npermission-name=\"\'Priority Call\'\" permission-visible=\"vm.licenseConvert.priorityCall\" \npermission-item=\"vm.licenseConvert.priorityCall\" show-sub-item=\"false\" is-edit=\"false\"></permission-list-convert>\n</md-list></div></form><div class=\"row\" flex ng-if=\"vm.error\"><div class=\"error-msg\" ng-model=\"vm.error\">{{vm.error}}\n</div></div>");
$templateCache.put("app/main/restricted/platform/licenses/tabs/templates/licenses.templates.html","<div class=\"content-card\" flex><div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div></div><table \nclass=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"APP_NAME\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"LICENSE_CODE\">License code</span></div></th></tr></thead><tbody><tr \ntitle=\"{{vm.showId ? license._id : \'\'}}\" \ndir-paginate=\"license in vm.licensesTemplate|searchByName :vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td width=\"20%\" class=\"table-name-label\" ng-click=\"vm.editLicense(license)\">{{license.name}}</td>\n<td width=\"20%\" class=\"table-name-label\">{{license.mask}}</td></tr></tbody></table><md-content \nng-if=\"!vm.licensesTemplate.length\" class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div \nclass=\"content-card\"><p class=\"pd-2\" translate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div>\n</md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option ng-value=\"25\">25</md-option><md-option \nng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"end center\"><dir-pagination-controls max-size=\"1\" direction-links=\"true\" \nboundary-links=\"true\"></dir-pagination-controls></div></div></div>");
$templateCache.put("app/main/restricted/platform/move-organization/tabs/organizationMove/organizationmove.html","<div layout=\"row\" class=\"migrationClass\"><div flex=\"45\"><span class=\"\" translate=\"TRANSFER_ORGFORYOU\">\nSelect Organization for Move</span><lefttree-select is-org-admin=\"vm.isOrgAdmin\" ng-model=\"vm.moveOrgResellerId\" \ntree-data=\"vm.resellersList\" tree-select=\"vm.chooseMoveReseller()\"></lefttree-select><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label translate=\"TRANSFER_ORGLIST\">Organization List\n</label><md-select name=\"type\" ng-model=\"vm.moveOrgId\"><md-option ng-repeat=\"item in vm.organizations\" \nvalue=\"{{item._id}}\">{{item.name}}</md-option></md-select></md-input-container></div></div><md-divider></md-divider>\n<div flex=\"45\"><span class=\"\" translate=\"TRANSFER_PARENTRES\">Select Reseller</span><tree-select \nis-org-admin=\"vm.isOrgAdmin\" ng-model=\"vm.moveOrgParentResellerId\" tree-data=\"vm.resellersList\"></tree-select></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"row\" layout-align=\"margin-right\" flex=\"30\"><md-button\n class=\"md-raised md-accent\" style=\"min-width: min-content; width: -webkit-fill-available\" ng-disabled=\"vm.loading\" \nlazy-load=\"true\" add-bom=\"true\" ng-click=\"vm.transferOrganization()\"><label translate=\"TRANSFER_ORGANIZATION\">\nTransfer Organization</label></md-button></div>");
$templateCache.put("app/main/restricted/platform/move-organization/tabs/resellerMove/resellermove.html","<div layout=\"row\" class=\"migrationClass\"><div flex=\"45\"><span class=\"\" translate=\"TRANSFER_RESFORYOU\">\nSelect Source Reseller</span><lefttree-select is-org-admin=\"vm.isOrgAdmin\" ng-model=\"vm.moveResellerId\" \ntree-data=\"vm.resellersList\" tree-select=\"vm.chooseParentReseller()\"></lefttree-select></div><md-divider></md-divider>\n<div flex=\"45\"><span class=\"\" translate=\"TRANSFER_PARENTRES\">Select Destination Parent Reseller</span><tree-select \nis-org-admin=\"vm.isOrgAdmin\" ng-model=\"vm.parentPesellerId\" tree-data=\"vm.resellersList\"></tree-select></div></div><div\n layout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"row\" layout-align=\"margin-right\" flex=\"30\"><md-button \nclass=\"md-raised md-accent\" style=\"min-width: min-content; width: -webkit-fill-available\" ng-disabled=\"vm.loading\" \nlazy-load=\"true\" add-bom=\"true\" ng-click=\"vm.transferReseller()\"><label translate=\"TRANSFER_RESELLER\">Transfer Reseller\n</label></md-button></div>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/affiliatedcontact/bulk-affiliated-contact.html","<md-dialog aria-label=\"Subscriber\" style=\"width: 57%\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"BULK_INTERACTIVE_CONTACT_TEMPLATE\">Interactive Contact Template</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-content class=\"content-card padding-tab\"><div class=\"ng-scope\"><div \nclass=\"content-card\"><div layout=\"column\" layout-gt-sm=\"row\"><label><input type=\"radio\" ng-model=\"vm.templateType\" \nid=\"vm.templateType\" value=\"Subscribers\" ng-click=\"vm.changeContactTemplateList()\" checked=\"checked\"><label \ntranslate=\"BULK_CONTACT_TEMPLATE_SUBSCRIBERS\"></label></label><label><input type=\"radio\" ng-model=\"vm.templateType\" \nid=\"vm.templateType\" value=\"ContactTemplate\" ng-click=\"vm.changeContactTemplateList()\"><label \ntranslate=\"BULK_CONTACT_TEMPLATE_TEMPLATES\"></label></label></div><md-content \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"40\"><p>{{vm.resultContactTemplateLog}}</p></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container md-no-float flex><label><span translate=\"BULK_SELECT_CONTACT_TEMPLATE\">Select Contact Template\n</span></label><md-select name=\"contactTemplate\" ng-model=\"vm.selectedContactTemplateId\" required><md-option \nng-repeat=\"item in vm.contactTemplatesDrop\" ng-value=\"item._id\">{{item.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.selectedAssignContactTemplate.length < 1 || !vm.selectedContactTemplateId\" \nng-click=\"vm.batchContactTemplateAssignment(\'Add\')\" translate=\"BULK_CONTACT_TEMPLATE_ADD\">Apply</md-button><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"vm.selectedAssignContactTemplate.length < 1 || !vm.selectedContactTemplateId\" \nng-click=\"vm.batchContactTemplateAssignment(\'Remove\')\" translate=\"BULK_CONTACT_TEMPLATE_REMOVE\">Apply</md-button></div>\n<choose-list-select pagination-id=\"vm.contactTemplatePaginationClass\" \nselected-elements=\"vm.selectedAssignContactTemplate\" not-selected-elements=\"vm.notSelectedAssignContactTemplate\" \nerror=\"false\" member-count-limit=\"vm.assignLength\" drop-down-elements=\"vm.orgsFriends\" \nselected-drop-down=\"vm.selectedDropDown\"></choose-list-select></md-content></div></div></md-content>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/affiliated.contacts.html","<md-content class=\"content-card\"><div class=\"ng-scope\"><div class=\"content-card\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><label><input type=\"radio\" ng-model=\"vm.templateType\" id=\"vm.templateType\" value=\"Subscribers\" \nng-click=\"vm.changeContactTemplateList()\" checked=\"checked\"><label translate=\"BULK_CONTACT_TEMPLATE_SUBSCRIBERS\">\n</label></label><label><input type=\"radio\" ng-model=\"vm.templateType\" id=\"vm.templateType\" value=\"ContactTemplate\" \nng-click=\"vm.changeContactTemplateList()\"><label translate=\"BULK_CONTACT_TEMPLATE_TEMPLATES\"></label></label><label>\n<input type=\"radio\" ng-model=\"vm.templateType\" id=\"vm.templateType\" value=\"SubscriberToSub\" \nng-click=\"vm.changeContactTemplateList()\"><label translate=\"BULK_CONTACT_TEMPLATE_SUB_TO_SUB\"></label></label></div>\n<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div layout=\"column\" \nlayout-align-gt-sm=\"row\" flex=\"90\"><p>{{vm.resultContactTemplateLog}}</p><p ng-if=\"vm.resultContactTempErrLog !=\'\'\">\n{{vm.resultContactTempErrLog}} <span translate=\"CONTACT_LIMIT_EXCEEDED\"></span></p></div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"vm.templateType != \'SubscriberToSub\'\"><md-input-container md-no-float flex><label><span \ntranslate=\"BULK_SELECT_CONTACT_TEMPLATE\">Select Contact Template</span></label><md-select name=\"contactTemplate\" \nng-model=\"vm.selectedContactTemplateId\" required><md-option ng-repeat=\"item in vm.contactTemplatesDrop\" \nng-value=\"item._id\">{{item.name}}</md-option></md-select></md-input-container></div><choose-list-select \nng-if=\"vm.templateType === \'SubscriberToSub\'\" pagination-id=\"vm.TemplatePaginationClass\" \nselected-elements=\"vm.selectedContactTemplateUser\" not-selected-elements=\"vm.ContactTemplateUser\" error=\"false\" \ndrop-down-elements=\"vm.bulkAffOrgsFriends\" selected-drop-down=\"vm.selectedDropDown\"></choose-list-select><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"vm.loading || vm.selectedAssignContactTemplate.length < 1 || !(vm.selectedContactTemplateId || vm.selectedContactTemplateUser)\" \nng-click=\"vm.batchContactTemplateAssignment(\'Add\')\" translate=\"BULK_CONTACT_TEMPLATE_ADD\">Apply</md-button><md-button \nclass=\"md-raised md-accent\" \nng-disabled=\"vm.loading || vm.selectedAssignContactTemplate.length < 1 || !(vm.selectedContactTemplateId || vm.selectedContactTemplateUser)\" \nng-click=\"vm.batchContactTemplateAssignment(\'Remove\')\" translate=\"BULK_CONTACT_TEMPLATE_REMOVE\">Apply</md-button></div>\n<choose-list-select pagination-id=\"vm.contactTemplatePaginationClass\" \nselected-elements=\"vm.selectedAssignContactTemplate\" not-selected-elements=\"vm.notSelectedAssignContactTemplate\" \nerror=\"false\" drop-down-elements=\"vm.bulkAffOrgsFriends\" selected-drop-down=\"vm.selectedDropDown\"></choose-list-select>\n</md-content></div></div></md-content>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/affiliated.groups.html","<div class=\"header\"><p style=\"color: red\" translate=\"ORG_AFFILIATED_OFFNET_WARNING\">\nAssign Off-Net License to all relevant members BEFORE creating an affiliated group!</p><md-button \nclass=\"add-button md-fab md-warn\" ng-disabled=\"!vm.organization.id || !vm.allowCreateGroups\" ng-click=\"vm.addGroup()\" \naria-label=\"Add event\" translate translate-attr-aria-label=\"APP_ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div><div class=\"content-card\"><div class=\"toolbar layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" class=\"context-search\" flex layout-align=\"flex-start\">\n<md-input-container><label translate=\"APP_SEARCH\">Search</label><md-icon md-font-icon=\"icon-magnify\"></md-icon><input \nng-model=\"vm.search\" type=\"text\" md-maxlength=\"50\"></md-input-container></div></div><table \nclass=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'name\')\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'name\')\" translate=\"GROUPS_NAME\">Name\n</span></div></th><th class=\"secondary-text\" ng-click=\"vm.sort(\'type\')\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-class=\"vm.getSortingClass(\'type\')\" translate=\"GROUPS_TYPE\">Type</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'count\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'count\')\" translate=\"GROUPS_MEMBER_COUNT\">Member count</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'expiry_date\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'expiry_date\')\" translate=\"GROUPS_EXPIRATION_DATE\">Expiration date</span></div></th><th \nclass=\"secondary-text\" ng-if=\"vm.allowDeleteGroups\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"APP_REMOVE\">Remove</span></div></th></tr></thead><tbody><tr title=\"{{vm.showId ? group._id : \'\'}}\" \ndir-paginate=\"group in vm.affiliatedGroups |searchByName:vm.search |itemsPerPage:vm.recordsCount track by $index\" \nng-class-odd=\"\'odd\'\"><td class=\"table-name-label\" ng-click=\"vm.editGroup(group)\" width=\"25%\">{{group.name}}</td><td \nclass=\"table-name-label\" ng-click=\"vm.editGroup(group)\" width=\"25%\">{{vm.types[group.type]}}</td><td \nclass=\"table-name-label\" ng-click=\"vm.editGroup(group)\" width=\"25%\">{{group.count}}</td><td class=\"table-name-label\" \nng-click=\"vm.editGroup(group)\" width=\"25%\">{{group.expiry_date | date:\'dd-MM-yyyy\'}}</td><td><md-button \nclass=\"remove-button md-icon-button\" aria-label=\"remove group\" ng-click=\"vm.removeGroup(group)\" translate \ntranslate-attr-aria-label=\"GROUPS_DELETE\" ng-if=\"vm.allowDeleteGroups\"><md-icon md-font-icon=\"icon-window-close\" \nclass=\"s16\"></md-icon></md-button></td></tr></tbody></table><md-content ng-if=\"!vm.affiliatedGroups.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\" \nng-if=\"!vm.organization.id\"><div class=\"reseller-manager page-layout simple tabbed\"><p class=\"pd-2\" \ntranslate=\"ORGANIZATION_CONTEXT_WARNING\">Please choose organization</p></div></div><div class=\"content-card\"><p \nclass=\"pd-2\" ng-if=\"!vm.loading && vm.organization.id\" translate=\"APP_NO_RECORDS\" \ntranslate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" \nflex layout-align=\"flex-start center\"><md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label>\n<md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" placeholder=\"Record to show\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \nmax-size=\"1\" direction-links=\"true\" boundary-links=\"true\"></dir-pagination-controls></div></div></div>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/branding.details.html","<md-content class=\"content\"><form name=\"vm.organizationFormBranding\" class=\"md-inline-form ng-pristine ng-invalid\" \nnovalidate=\"\"><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" \nstyle=\"margin-bottom: 10px\"><label translate=\"BRANDING_TITLE_MESSAGE\">\nThe branding settings may affect all the client applications in this organization.</label></div><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"BRANDING_NAME\">Application Name</label><input type=\"text\" name=\"name\" ng-model=\"vm.brand.name\" \nng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' aria-invalid=\"true\" md-maxlength=\"20\" maxlength=\"20\"></md-input-container><div \nlayout=\"column\"><md-checkbox aria-label=\"checkbox\" ng-model=\"vm.brand.override_branding_name\" ng-true-value=\"true\" \nng-false-value=\"false\" ng-disabled=\"!vm.organization._id  || !vm.brand.name\" \nng-if=\"vm.organization._id && vm.allowModify \"><md-tooltip><span translate=\"BRANDING_RESET_WARNING\">\nThe client application will use the default values set by the developer</span></md-tooltip><span \ntranslate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div><md-divider vertical></md-divider><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" style=\"margin-top: 25px\"><md-input-container \nmd-no-float flex=\"100\"><label translate=\"BRANDING_MAP_SERVER\">Map server</label><input type=\"text\" name=\"name\" \nng-model=\"vm.brand.map_server\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' aria-invalid=\"true\" md-maxlength=\"20\" maxlength=\"20\">\n</md-input-container></div><md-divider vertical></md-divider><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\" style=\"margin-top: 25px\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"COLOR1\">Color1</label><color-picker name=\"color\" ng-model=\"vm.brand.color\" aria-invalid=\"true\" \nmaxlength=\"7\" required options=\"options\"></color-picker><div layout=\"row\"><md-input-container md-no-float flex=\"100\">\n<input type=\"text\" name=\"color\" ng-model=\"vm.brand.color\" aria-invalid=\"true\" maxlength=\"7\" id=\"color\" \nplaceholder=\"#F05A47\"></md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox aria-label=\"checkbox\" \nng-model=\"vm.brand.override_branding_color1\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"!vm.organization._id || !vm.brand.color\" ng-if=\"vm.organization._id && vm.allowModify \"><md-tooltip><span \ntranslate=\"BRANDING_RESET_WARNING\">The client application will use the default values set by the developer</span>\n</md-tooltip><span translate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></md-input-container></div>\n<md-divider vertical></md-divider><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" \nstyle=\"margin-top: 25px\"><md-input-container md-no-float flex=\"100\"><label translate=\"COLOR2\">Color2</label>\n<color-picker name=\"sec_color\" ng-model=\"vm.brand.sec_color\" aria-invalid=\"true\" maxlength=\"7\" ng-readonly required \noptions=\"options\"></color-picker><div layout=\"row\"><md-input-container md-no-float flex=\"100\"><input type=\"text\" \nname=\"sec_color\" ng-model=\"vm.brand.sec_color\" aria-invalid=\"true\" maxlength=\"7\" id=\"sec_color\" placeholder=\"#F05A47\">\n</md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox aria-label=\"checkbox\" \nng-model=\"vm.brand.override_branding_color2\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"!vm.organization._id || !vm.brand.sec_color\" ng-if=\"vm.organization._id && vm.allowModify \"><md-tooltip>\n<span translate=\"BRANDING_RESET_WARNING\">The client application will use the default values set by the developer</span>\n</md-tooltip><span translate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></md-input-container></div>\n<md-divider vertical></md-divider><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" \nstyle=\"margin-top: 25px\"><span translate=\"MOBILE_PORTAL_LOGO_IMAGE\">Mobile Portal Logo Image</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"30\" \nstyle=\"margin-right: -17%\"><input content=\"management_portal_logo\" type=\"file\" name=\"management_portal_logo\" \nng-model=\"management_portal_logo\" id=\"management_portal_logo\" style=\"width: 332px\" \naccept=\".png, .jpg, .jpeg,.PNG, .JPG, .JPEG\" onchange=\"angular.element(this).scope().onUploadFile(this)\"><div \nng-messages=\"vm.organizationFormBranding.management_portal_logo.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"validationError\"><span translate=\"APP_WRONG_FILE_EXTENTION\">Wrong file extention</span></div></div>\n</md-input-container><div layout=\"row\"><md-input-container md-no-float flex=\"50\"><img \nstyle=\"max-width: 200px;margin-left: -51%;max-height: 60%\" ng-hide=\"!vm.management_portal_image\" \ndata-ng-src=\"data:image/*;base64,{{vm.management_portal_image}}\"></md-input-container><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"width: 212%\"><md-checkbox aria-label=\"checkbox\" \nng-model=\"vm.brand.override_management_portal_image\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"!vm.organization._id  || !vm.management_portal_image\" ng-if=\"vm.organization._id && vm.allowModify \">\n<md-tooltip><span translate=\"BRANDING_RESET_WARNING\">\nThe client application will use the default values set by the developer</span></md-tooltip><span \ntranslate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></div><md-divider vertical></md-divider><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" style=\"margin-top: 25px\"><span \ntranslate=\"BRANDING_IMAGE\">Image</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"30\" style=\"margin-right: -17%\"><input \ncontent=\"file\" type=\"file\" name=\"file\" ng-model=\"file\" id=\"file\" style=\"width: 332px\" \naccept=\".png, .jpg, .jpeg,.PNG, .JPG, .JPEG\" onchange=\"angular.element(this).scope().onUploadFile(this)\"><div \nng-messages=\"vm.organizationFormBranding.file.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"validationError\"><span translate=\"APP_WRONG_FILE_EXTENTION\">Wrong file extention</span></div></div>\n</md-input-container><div layout=\"row\"><md-input-container md-no-float flex=\"50\"><img \nstyle=\"max-width: 200px;margin-left: -51%;max-height: 60%\" ng-hide=\"!vm.image\" \ndata-ng-src=\"data:image/*;base64,{{vm.image}}\"></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"width: 212%\"><md-checkbox aria-label=\"checkbox\" ng-model=\"vm.brand.override_branding_image\" \nng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"!vm.organization._id  || !vm.image\" \nng-if=\"vm.organization._id && vm.allowModify \"><md-tooltip><span translate=\"BRANDING_RESET_WARNING\">\nThe client application will use the default values set by the developer</span></md-tooltip><span \ntranslate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></div><md-divider vertical></md-divider><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" style=\"margin-top: 25px\"><span \ntranslate=\"BRANDING_MDC_LOGO_IMAGE\">MDC Logo Image</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"30\" style=\"margin-right: -17%\"><input \ncontent=\"file\" type=\"file\" name=\"file_mdc_logo\" ng-model=\"file_mdc_logo\" aria-invalid=\"true\" id=\"file_mdc_logo\" \nstyle=\"width: 332px\" accept=\".ico\" onchange=\"angular.element(this).scope().onUploadFile(this)\"><div \nng-messages=\"vm.organizationFormBranding.file_mdc_logo.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"validationError\"><span translate=\"APP_WRONG_FILE_EXTENTION\">Wrong file extention</span></div></div>\n</md-input-container><div layout=\"row\"><md-input-container md-no-float flex=\"50\"><img \nstyle=\"max-width: 200px;margin-left: -51%;max-height: 60%\" ng-hide=\"!vm.image_mdc_logo\" \ndata-ng-src=\"data:image/*;base64,{{vm.image_mdc_logo}}\"></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"width: 212%\"><md-checkbox aria-label=\"checkbox\" ng-model=\"vm.brand.override_mdc_logo_image\" \nng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"!vm.organization._id  || !vm.image_mdc_logo\" \nng-if=\"vm.organization._id && vm.allowModify \"><md-tooltip><span translate=\"BRANDING_RESET_WARNING\">\nThe client application will use the default values set by the developer</span></md-tooltip><span \ntranslate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></div><md-divider vertical></md-divider><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" style=\"margin-top: 25px\"><label \ntranslate=\"BRANDING_MDC_SPALSH_IMAGE\">MDC Splash Image</label></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"30\" style=\"margin-right: -17%\"><input \ncontent=\"file_mdc_splash\" type=\"file\" name=\"file_mdc_splash\" ng-model=\"file_mdc_splash\" id=\"file_mdc_splash\" \nstyle=\"width: 332px\" accept=\".png, .jpg, .jpeg,.PNG, .JPG, .JPEG\" \nonchange=\"angular.element(this).scope().onUploadFile(this)\"><div \nng-messages=\"vm.organizationFormBranding.file_mdc_splash.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"validationError\"><span translate=\"APP_WRONG_FILE_EXTENTION\">Wrong file extention</span></div></div>\n</md-input-container><div layout=\"row\"><md-input-container md-no-float flex=\"50\"><img \nstyle=\"max-width: 200px;margin-left: -51%;max-height: 60%\" ng-hide=\"!vm.image_mdc_splash\" \ndata-ng-src=\"data:image/*;base64,{{vm.image_mdc_splash}}\"></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"width: 212%\"><md-checkbox aria-label=\"checkbox\" ng-model=\"vm.brand.override_mdc_splash_image\" \nng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"!vm.organization._id  || !vm.image_mdc_splash\" \nng-if=\"vm.organization._id && vm.allowModify \"><md-tooltip><span translate=\"BRANDING_RESET_WARNING\">\nThe client application will use the default values set by the developer</span></md-tooltip><span \ntranslate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></div><md-divider vertical></md-divider><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" style=\"margin-top: 25px\"><span \ntranslate=\"BRANDING_MDC_COMPANYNAME_IMAGE\">MDC Company Name Image</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"30\" style=\"margin-right: -17%\"><input \ncontent=\"file_mdc_companyName\" type=\"file\" name=\"file_mdc_companyName\" ng-model=\"file_mdc_companyName\" \nid=\"file_mdc_companyName\" style=\"width: 332px\" accept=\".png, .jpg, .jpeg, .PNG, .JPG, .JPEG\" \nonchange=\"angular.element(this).scope().onUploadFile(this)\"><div \nng-messages=\"vm.organizationFormBranding.file_mdc_companyName.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"validationError\"><span translate=\"APP_WRONG_FILE_EXTENTION\">Wrong file extention</span></div></div>\n</md-input-container><div layout=\"row\"><md-input-container md-no-float flex=\"50\"><img \nstyle=\"max-width: 200px;margin-left: -51%;max-height: 60%\" ng-hide=\"!vm.image_mdc_companyName\" \ndata-ng-src=\"data:image/*;base64,{{vm.image_mdc_companyName}}\"></md-input-container><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"width: 212%\"><md-checkbox aria-label=\"checkbox\" \nng-model=\"vm.brand.override_mdc_companyName_image\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"!vm.organization._id  || !vm.image_mdc_companyName\" ng-if=\"vm.organization._id && vm.allowModify \">\n<md-tooltip><span translate=\"BRANDING_RESET_WARNING\">\nThe client application will use the default values set by the developer</span></md-tooltip><span \ntranslate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></div><md-divider vertical></md-divider><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-checkbox aria-label=\"checkbox\" ng-model=\"vm.brand.override_reseller\" \nng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"!vm.organization._id\" \nng-if=\"vm.organization._id && vm.allowModify \"><span translate=\"BRANDING_ORGANIZATION_OVERRIDE_RESELLER\">\nOverride Reseller</span></md-checkbox></div><div layout=\"row\" style=\"margin-top: 25px\"><md-button md-no-ink \nclass=\"md-primary\" ng-click=\"vm.resetAllOverrideValues()\" ng-disabled=\"!vm.organization._id\" \nng-if=\"vm.organization._id && vm.allowModify \" aria-label=\"\" translate=\"BUTTON_RESET_BRAND_INFO\">Reset</md-button>\n<md-button md-no-ink class=\"md-primary\" ng-click=\"vm.saveOBrandingInfo()\" \nng-disabled=\"!vm.organization._id || vm.organizationFormBranding.file.$invalid || vm.organizationFormBranding.file_mdc_logo.$invalid || vm.organizationFormBranding.file_mdc_splash.$invalid || vm.organizationFormBranding.file_mdc_companyName.$invalid\" \nng-if=\"vm.organization._id && vm.allowModify \" aria-label=\"\" translate=\"BUTTON_SAVE_BRAND_INFO\">Submit</md-button>\n</div></form></md-content>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/general.html","<md-content class=\"content\"><form name=\"vm.orgForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate=\"\"><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"ORGANIZATION_CRMID\">CRMID</label><input type=\"text\" name=\"crmId\" ng-model=\"vm.organization.crmId\" \nng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' aria-invalid=\"true\" md-maxlength=\"40\" required autocomplete=\"off\"><div \nng-messages=\"vm.orgForm.crmId.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\">\n<md-input-container md-no-float flex=\"100\"><label for=\"oname\" translate=\"ORGANIZATION_NAME\">Organization name</label>\n<input type=\"text\" name=\"name\" ng-model=\"vm.organization.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' id=\"oname\" translate \naria-invalid=\"true\" md-maxlength=\"40\" required autocomplete=\"off\"><div ng-messages=\"vm.orgForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div>\n<div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div \nng-message=\"pattern\"><span translate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label for=\"domain\" \ntranslate=\"ORGANIZATION_DOMAIN\">Domain name</label><input type=\"text\" name=\"domainName\" \nng-model=\"vm.organization.domain\" ng-readonly=\"vm.organization._id\" id=\"domain\" translate aria-invalid=\"true\" \nmd-maxlength=\"50\" required \nng-pattern=\"/^[a-zA-Z0-9]{1,61}([a-zA-Z0-9-][a-zA-Z0-9]){0,61}\\.[a-zA-Z]{1,}(\\.[a-zA-Z]{1,}){0,}$/\" autocomplete=\"off\">\n<div ng-messages=\"vm.orgForm.domainName.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_URL\">Domain field is incorrect</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" ng-if=\"false\"><md-input-container \nmd-no-float flex=\"100\"><label for=\"domain\" translate=\"ORGANIZATION_ADDRESS\">Address</label><input type=\"text\" \nname=\"address\" ng-model=\"vm.organization.address\" id=\"address\" translate autocomplete=\"off\"><div \nng-messages=\"vm.orgForm.address.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"minlength\"><span \ntranslate=\"APP_VALIDATION_MIN_LENGTH\">This field is too short</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\">\n<label for=\"crmid-input\" translate=\"ORGANIZATION_SUPPORT_FIRST_NAME\">Support Contact First Name</label><input \ntype=\"text\" name=\"supportFirstName\" ng-model=\"vm.organization.supportContactFirst\" id=\"crmid-input\" translate \naria-invalid=\"true\" md-maxlength=\"200\" autocomplete=\"off\" ng-required=\"vm.Firstreq\" \nng-change=\"vm.supportContactname()\"><div ng-messages=\"vm.orgForm.supportFirstName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>This field is required</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label \nfor=\"last-name\" translate=\"ORGANIZATION_SUPPORT_LAST_NAME\">Support Contact Last Name</label><input type=\"text\" \nname=\"supportLastName\" ng-model=\"vm.organization.supportContactLast\" id=\"last-name\" translate aria-invalid=\"true\" \nmd-maxlength=\"200\" autocomplete=\"off\" ng-required=\"vm.lastrequired\" ng-change=\"vm.supportContactname()\"><div \nng-messages=\"vm.orgForm.supportLastName.$error\" role=\"alert\"><div ng-message=\"required\"><span>This field is required\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\" ng-disabled=\"true\" ng-if=\"vm.organization._id\"><md-input-container md-no-float \nflex=\"100\"><label for=\"domain\" translate=\"ORGANIZATION_CREATION_TIME\">Creation Time</label><input type=\"text\" \nname=\"creation time\" ng-model=\"vm.organization.creation_time\" id=\"creation_time\" translate ng-disabled=\"true\" \nautocomplete=\"off\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label translate=\"ORGANIZATION_SITE\">\nSite</label><md-select ng-model=\"vm.organization.site\"><md-option ng-repeat=\"site in vm.sites\" value=\"{{site._id}}\">\n{{site.name}} {{site.iprs_public}}</md-option></md-select><div ng-messages=\"vm.orgForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div></div>\n</md-input-container></div><md-input-container md-no-float flex=\"100\"></md-input-container><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\" \nng-if=\"vm.showLicenseAllocation\"><label translate=\"ORGANIZATION_QTY\">qty</label><input type=\"text\" name=\"qty\" \nng-model=\"vm.qty\" id=\"qty\" ng-disabled=\"true\" translate autocomplete=\"off\"></md-input-container><md-input-container \nmd-no-float flex=\"100\" ng-if=\"vm.showLicenseAllocation\"><label translate=\"ORGANIZATION_DISPATCHER_QTY\">Dispatcher qty\n</label><input type=\"text\" name=\"qty\" ng-model=\"vm.dispatcherqty\" id=\"dispatcher_qty\" ng-disabled=\"true\" translate \nautocomplete=\"off\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox \naria-label=\"checkbox\" ng-model=\"vm.organization.disable_remember_me\" ng-true-value=\"1\" ng-false-value=\"0\"><span \ntranslate=\"DISABLE_REMEMBER_ME\">Remember Me</span></md-checkbox></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.showDemoOrganization\"><md-checkbox aria-label=\"checkbox\" ng-model=\"vm.organization.type\" ng-true-value=\"1\" \nng-false-value=\"0\" ng-disabled=\"vm.organization.type == 0 && !vm.isRootAdmin\" ng-change=\"vm.demoChecked()\"><span \ntranslate=\"ORGANIZATION_DEMO\">Demo</span></md-checkbox></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.showDemoOrganization && vm.organization._id\" style=\"align-items: baseline\"><label \ntranslate=\"ORGANIZATION_DEMO_EXPIRATION\">Demo Expiration</label><md-datepicker class=\"demoExpiration\" \nng-disabled=\"!vm.isRootAdmin || !vm.organization.type == 1\" ng-model=\"vm.organization.demo_expiration\" \nmd-min-date=\"vm.now\" name=\"endDate\" md-placeholder=\"{{ \'END_DATE\' | translate  }}\" onkeydown=\"return false\">\n</md-datepicker></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showCallLog\"><md-checkbox \naria-label=\"checkbox\" ng-model=\"vm.organization.isEncrypted\" ng-true-value=\"1\" ng-false-value=\"0\" \nng-disabled=\"!vm.allowModifyCallLog\"><span translate=\"ORGANIZATION_CALL_LOG\">Organization Call Log</span></md-checkbox>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showRecording\" style=\"margin-top: 3%; font-weight: bold\"><span \ntranslate=\"RECORDING_PLAN\">Recording Plan</span></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showRecording\">\n<label><input type=\"radio\" ng-model=\"vm.recorder\" id=\"vm.recorder\" value=\"noRecord\" \nng-disabled=\"!vm.allowModifyAudioRecorder\"><label translate=\"RECORDING_PLAN_NONE\"></label></label><br><label><input \ntype=\"radio\" ng-model=\"vm.recorder\" id=\"vm.recorder\" value=\"allCalls\" ng-disabled=\"!vm.allowModifyAudioRecorder\"><label\n translate=\"RECORDING_PLAN_ALL_CALLS\"></label></label><br><label><input type=\"radio\" ng-model=\"vm.recorder\" \nid=\"vm.recorder\" value=\"selective\" ng-disabled=\"!vm.allowModifyAudioRecorder\"><label \ntranslate=\"RECORDING_PLAN_SELECTIVE\"></label></label><br></div></form></md-content>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/license.allocate.html","<md-content class=\"reseller-license-details content\" flex-offset=\"0\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sortAllocate(\'licenseBundle.name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'licenseBundle.name\')\" translate=\"LICENSE_BUNDLE\">Bundle</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sortAllocate(\'licenseType\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'licenseType\')\" translate=\"LICENSE_TYPE\">License Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_ALLOCATION_DATE\">\nAllocation Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LICENSE_EXPIRATION_TYPE\">Expiration Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_EXPIRATION_DATE\">Expiration Date</span></div></th>\n<th class=\"secondary-text\" ng-click=\"vm.sortAllocate(\'qty\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'qty\')\" translate=\"LICENSE_QUANTITY\">Quantity</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortAllocate(\'availableQty\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'availableQty\')\" translate=\"LICENSE_AVAILABLE_QTY\">Available</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_ALLOCATE\">Allocate\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"UNDO_LICENSE\">Undo</span></div></th></tr></thead><tbody><tr title=\"{{vm.showId ? item._id : \'\'}}\" \nid=\"{{item._id}}\" dir-paginate=\"item in vm.parentLicenses|itemsPerPage:vm.recordsCount track by $index\" \npagination-id=\"organizationLicenseAllocation\"><td width=\"15%\" class=\"table-name-label\" \nng-click=\"vm.editLicense(item.licenseBundle)\"><b>{{item.licenseBundle.name}}</b></td><td>{{item.licenseType}}</td><td>\n{{item.allocationDate | date: medium}}</td><td>{{item.expirationType}}</td><td>{{item.expirationDate | date: medium}}\n</td><td align=\"center\" ng-click=\"vm.setActiveAllocation(item._id)\">{{item.qty}}</td><td align=\"center\" \nng-click=\"vm.setActiveAllocation(item._id)\">{{item.availableQty}}</td><td ng-click=\"vm.setActiveAllocation(item._id)\">\n<md-input-container flex=\"20\" ng-show=\"vm.checkActiveAllocation(item._id)\"><input aria-label=\"license qty\" \nng-change=\"vm.checkAvailableQuantity(item.availableQty, item.setQty)\" ng-model=\"item.setQty\" type=\"number\" \nname=\"quantity\" ng-min=\"0\" ng-max=\"item.availableQty\" ng-pattern=\"/^-?[0-9][^\\.]*$/\"></md-input-container><md-button \nclass=\"allocation-button\" ng-show=\"vm.checkActiveAllocation(item._id)\" ng-click=\"vm.addDraftAllocation(item)\" \nng-disabled=\"!vm.checkAvailableQuantity(item.availableQty, item.setQty)\" translate=\"LICENSE_ALLOCATE\">Allocate\n</md-button></td><td><md-button class=\"remove-button md-icon-button\" \nng-if=\"vm.saveAllocate[vm.getParentAllocationIndex(item)].isAllocate\" ng-click=\"vm.undoAllocate(item)\" translate \ntranslate-attr-aria-label=\"UNDO_LICENSE\"><md-icon md-font-icon=\"icon-undo\" class=\"fas fa-undo\"></md-icon></md-button>\n</td></tr></tbody></table><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" pagination-id=\"organizationLicenseAllocation\" placeholder=\"Record to show\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \npagination-id=\"organizationLicenseAllocation\" max-size=\"1\" direction-links=\"true\" boundary-links=\"true\">\n</dir-pagination-controls></div></div></div></md-content>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/license.details.html","<md-content class=\"reseller-license-details content\" flex-offset=\"0\"><div layout=\"row\" layout-align=\"end center\">\n<md-button class=\"add-button md-fab md-warn\" layout-align=\"end center\" ng-disabled=\"!vm.allowModify\" \nng-click=\"vm.switchToAllocationTab()\" aria-label=\"Add event\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\"><thead>\n<tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'licenseBundle.name\')\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-class=\"vm.getSortingClass(\'licenseBundle.name\')\" translate=\"LICENSE_BUNDLE\">Bundle</span></div>\n</th><th class=\"secondary-text\" ng-click=\"vm.sort(\'licenseType\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'licenseType\')\" translate=\"LICENSE_TYPE\">License Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_ALLOCATION_DATE\">\nAllocation Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LICENSE_EXPIRATION_TYPE\">Expiration Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_EXPIRATION_DATE\">Expiration Date</span></div></th>\n<th class=\"secondary-text\" ng-click=\"vm.sort(\'qty\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'qty\')\" translate=\"LICENSE_QUANTITY\">Quantity</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.allowLicenseDelete\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_REVOKE\">Revoke\n</span></div></th></tr></thead><tbody><tr title=\"{{vm.showId ? item._id : \'\'}}\" \nng-repeat=\"item in vm.organization.licenses\"><td width=\"15%\" class=\"table-name-label\" \nng-click=\"vm.editLicense(item.licenseBundle, item._id)\"><b>{{item.licenseBundle.name}}</b></td><td>{{item.licenseType}}\n</td><td>{{item.allocationDate | date: medium}}</td><td>{{item.expirationType}}</td><td>\n{{item.expirationDate | date: medium}}</td><td align=\"center\">{{item.qty}}</td><td><md-button \nclass=\"remove-button md-icon-button\" aria-label=\"organisation details\" ng-if=\"vm.allowLicenseDelete\" \nng-click=\"vm.revokeAllocation(item._id)\" translate translate-attr-aria-label=\"APP_REMOVE\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td></tr><tr style=\"color:#ccc\" \nng-repeat=\"item in vm.organization.draftLicenses track by $index\"><td width=\"15%\"><b>{{item.licenseBundle.name}}</b>\n</td><td>{{item.licenseType}}</td><td>{{item.allocationDate | date: medium}}</td><td>{{item.expirationType}}</td><td>\n{{item.expirationDate | date: medium}}</td><td align=\"center\">{{item.setQty}}</td><td><md-button \nclass=\"remove-button md-icon-button\" aria-label=\"organisation details\" ng-if=\"vm.allowLicenseDelete\" \nng-click=\"vm.removeDraftAllocation(item)\" translate translate-attr-aria-label=\"APP_REMOVE\"><md-icon \nmd-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button></td></tr></tbody></table></div></md-content>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/live_sentinel.html","<md-content class=\"content\" ng-if=\"vm.iframeUrl\"><iframe src=\"{{vm.iframeUrl  | trustAsResourceUrl }}\" \nclass=\"iframBox\"></iframe></md-content>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/organization.friends.html","<md-content class=\"content group-details\"><choose-list pagination-id=\"vm.affiliatedOrgsPagination\" \nselected-elements=\"vm.selectedOrgs\" not-selected-elements=\"vm.unselectedOrgs\" member-count-limit=\"vm.limitOrgFriends\" \nanother-limit=\"true\" error=\"false\"></choose-list></md-content><md-content><div><span flex style=\"color: red\" \nng-if=\"vm.showAffiliatedGroup\" translate=\"ORG_AFFILIATED_AFFECT_WARNING\">\nAny change in affiliate organizations will affect organizational affiliated group members.</span></div><div \nlayout=\"row\" style=\"float: right\"><md-button md-no-ink class=\"md-primary\" ng-click=\"vm.saveOrgFriends()\" aria-label=\"\" \ntranslate=\"APP_SAVE_ORG_FRIEND\" ng-disabled=\"!vm.allowModifyAffiliatedOrgs\">Save</md-button></div></md-content>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/security.and.download.html","<md-content class=\"content\"><form name=\"vm.orgSecurityAndDownloadForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate=\"\"><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top: 3%; font-weight: bold\" \nng-if=\"vm.organization._id && vm.showEncryption && vm.allowSetEncryption\"><span translate=\"ENCRYPTION_PLAN\">\nEncryption Plan</span></div><br><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.organization._id && vm.showEncryption && vm.allowSetEncryption\"><md-input-container md-no-float flex><label \ntranslate=\"APP_ENCRYPTION_KEYS_CURRENT_STATUS\">Current Encryption Status:</label><input type=\"text\" name=\"type\" \nng-disabled=\"true\" translate placeholder=\"Regular Placeholder\" \ntranslate-attr-placeholder=\"{{vm.currentEncStatus.encFormat}}\" \ntranslate-value-browser=\"{{vm.currentEncStatus.encFormat}}\"></md-input-container><md-input-container md-no-float flex>\n<label translate=\"APP_ENCRYPTION_KEYS_VERSION\">Encryption keys version</label><input type=\"text\" name=\"version\" \nng-model=\"vm.currentEncStatus.encVersion\" ng-disabled=\"true\" translate></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" ng-if=\"vm.showEncryption && vm.allowSetEncryption\" ng-hide=\"true\"><md-input-container><input \ncontent=\"file\" type=\"file\" name=\"file1\" ng-model=\"file1\" id=\"file1\" style=\"width: auto\" accept=\".bin\" \nng-if=\"vm.organization._id\" ng-disabled=\"!vm.organization._id || vm.disablebutton\"></md-input-container><md-button \nmd-no-ink class=\"md-primary\" ng-click=\"vm.uploadEncryptionFile()\" \nng-disabled=\"!vm.organization._id || vm.disablebutton\" ng-if=\"vm.organization._id\" aria-label=\"\" \ntranslate=\"BUTTON_UPLOAD_KEY_FILE\">Upload Key File</md-button></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.showEncryption && vm.allowSetEncryption\" style=\"margin-top: 1%\"><md-container md-no-float flex><div>\n<md-button md-no-ink class=\"md-primary\" ng-click=\"vm.setEmptyEncryptionFile()\" \nng-disabled=\"!vm.organization._id || vm.disablebutton\" ng-if=\"vm.organization._id\" aria-label=\"\" \ntranslate=\"BUTTON_SET_EMPTY_KEY_FILE\">Set Empty Key File</md-button><md-button md-no-ink class=\"md-primary\" \nng-click=\"vm.setEncryptionFile()\" ng-disabled=\"!vm.organization._id || vm.disablebutton\" \nng-if=\"vm.organization._id && vm.showRandomEncryptionKeysButton\" aria-label=\"\" translate=\"BUTTON_SET_KEY_FILE\">\nSet Key File</md-button><md-button md-no-ink class=\"md-primary\" ng-click=\"vm.setDefaultEncryptionFile()\" \nng-disabled=\"!vm.organization._id || vm.disablebutton\" ng-if=\"vm.organization._id\" aria-label=\"\" \ntranslate=\"BUTTON_SET_DEFAULT_KEY_FILE\">Set Default Key File</md-button></div></md-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 3%; font-weight: bold\" \nng-if=\"vm.showStrongDispatchPass || showStrongRecordingReviewersPass || showStrongAdministratorPass\"><span \ntranslate=\"STRONG_PASSWORD_PLAN\">Strong Password Plan</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.showStrongDispatchPass\"><md-checkbox aria-label=\"checkbox\" ng-model=\"vm.organization.strongDispatchPass\" \nng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"!vm.allowModify\"><span \ntranslate=\"ORGANIZATION_FORCE_STRONG_DISPATCH_PASS\">Force Strong Password For A Dispatcher User</span></md-checkbox>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showStrongRecordingReviewersPass\"><md-checkbox \naria-label=\"checkbox\" ng-model=\"vm.strongRecordingReviewersPass\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"!vm.allowModify\"><span translate=\"RECORDING_FORCE_STRONG_RECORDING_REVIEWERS_PASS\">\nForce Strong Password For Recording Reviewers Users</span></md-checkbox></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.showStrongAdministratorPass\"><md-checkbox aria-label=\"checkbox\" \nng-model=\"vm.organization.strongAdministratorPass\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"!vm.allowModify\">\n<span translate=\"ORGANIZATION_STRONG_ADMINISTRATOR_PASS\">Force Strong Password For Administrator Users</span>\n</md-checkbox></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: 3%; margin-bottom: 1%; font-weight: bold\" ng-if=\"vm.showMaxRetries\"><span \ntranslate=\"MAX_LOGIN_RETRIES_PLAN\">Max Login Retries Plan</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.showMaxRetries\"><md-switch ng-model=\"vm.enable_max_login_retries\"></md-switch><md-input-container \nmd-no-float flex><label translate=\"MAX_LOGIN_RETRIES\">Max login retries</label><input type=\"text\" \nng-pattern=\"/^(?:[3-9]|[12][0-9])[0-9]*$/\" md-maxlength=\"4\" name=\"max_login_retries\" \nng-model=\"vm.organization.max_login_retries\" id=\"max_login_retries\" ng-disabled=\"!vm.enable_max_login_retries\" \ntranslate></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: 3%; margin-bottom: 1%; font-weight: bold\" ng-if=\"vm.showPasswordExpiration\"><span \ntranslate=\"CHANGE_PASSWORD_PLAN\">Change Password Plan</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.showPasswordExpiration\"><md-switch ng-model=\"vm.enable_password_expiration_days\"></md-switch>\n<md-input-container md-no-float flex><label translate=\"PASSWORD_EXPIRATION_DAYS\">Password expiration days</label><input\n type=\"text\" ng-pattern=\"/^(?:[3-9]|[12][0-9])[0-9]*$/\" md-maxlength=\"4\" name=\"password_expiration_days\" \nng-model=\"vm.organization.password_expiration_days\" id=\"password_expiration_days\" \nng-disabled=\"!vm.enable_password_expiration_days\" translate></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"margin-top: 3%; margin-bottom: 1%; font-weight: bold\" \nng-if=\"vm.organization._id && vm.showUploadVersion\"><span translate=\"VERSIONS_PLAN\">Versions Plan</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.organization._id && vm.showUploadVersion\"><md-input-container md-no-float \nflex><label translate=\"BRANDING_LATEST_VERSION_ANDROID\">Latest Android Version</label><input type=\"text\" \nname=\"latest_android_version\" ng-model=\"vm.brand.latest_android_version\" id=\"latest_android_version\" \nng-disabled=\"true\" translate></md-input-container><md-input-container md-no-float flex><label \ntranslate=\"BRANDING_LATEST_VERSION_MDC\">Latest MDC2000 Version</label><input type=\"text\" name=\"latest_mdc_version\" \nng-model=\"vm.brand.latest_mdc_version\" id=\"latest_mdc_version\" ng-disabled=\"true\" translate></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showUploadVersion\"><md-input-container><input content=\"file\" \ntype=\"file\" name=\"fileAndroid\" ng-model=\"fileAndroid\" id=\"fileAndroid\" style=\"width: auto\" accept=\".apk\" \nng-if=\"vm.organization._id\" ng-disabled=\"!vm.organization._id || vm.disablebutton\"></md-input-container><md-button \nstyle=\"font-size: 10px\" md-no-ink class=\"md-primary\" ng-click=\"vm.uploadAndroidVersionFile()\" \nng-disabled=\"!vm.organization._id || vm.disablebutton\" ng-if=\"vm.organization._id\" aria-label=\"\" \ntranslate=\"BUTTON_UPLOAD_ANDROID_VERSION_FILE\">Upload Android Version File</md-button><md-button \nstyle=\"font-size: 10px\" md-no-ink class=\"md-primary\" ng-click=\"vm.deleteAndroidVersionFile()\" \nng-disabled=\"!vm.organization._id || vm.disablebutton || !vm.brand.latest_android_version\" ng-if=\"vm.organization._id\" \naria-label=\"\" translate=\"BUTTON_DELETE_ANDROID_VERSION_FILE\">Delete Android Version File</md-button></div><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showUploadVersion\"><md-input-container><input content=\"file\" type=\"file\" \nname=\"fileMDC\" ng-model=\"fileMDC\" id=\"fileMDC\" style=\"width: auto\" accept=\".exe\" ng-if=\"vm.organization._id\" \nng-disabled=\"!vm.organization._id || vm.disablebutton\"></md-input-container><md-button style=\"font-size: 10px\" \nmd-no-ink class=\"md-primary\" ng-click=\"vm.uploadMDCVersionFile()\" \nng-disabled=\"!vm.organization._id || vm.disablebutton\" ng-if=\"vm.organization._id\" aria-label=\"\" \ntranslate=\"BUTTON_UPLOAD_MDC_VERSION_FILE\">Upload MDC Version File</md-button><md-button style=\"font-size: 10px\" \nmd-no-ink class=\"md-primary\" ng-click=\"vm.deleteMDCVersionFile()\" \nng-disabled=\"!vm.organization._id || vm.disablebutton || !vm.brand.latest_mdc_version\" ng-if=\"vm.organization._id\" \naria-label=\"\" translate=\"BUTTON_DELETE_MDC_VERSION_FILE\">Delete MDC Version File</md-button></div><md-button md-no-ink \nclass=\"md-primary\" ng-click=\"vm.saveOrganization()\" id=\"vm.orgBtn\" aria-label=\"\" translate=\"APP_SAVE\">Save</md-button>\n</form></md-content>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/sentinel.html","<md-content class=\"content\"><form name=\"vm.orgSenForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate=\"\"><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"SITE_HOST\">Host</label><input type=\"text\" name=\"host\" ng-model=\"vm.sentinel.host\" \npattern=\"^(?:https?:\\/\\/)?(?:[^@\\n]+@)?(?:www\\.)?([^:\\/\\n?]+)\" aria-invalid=\"true\" md-maxlength=\"200\" required \nmaxlength=\"200\" autocomplete=\"off\"><div ng-messages=\"vm.orgSenForm.host.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div \nng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div \nng-message=\"pattern\"><span translate=\"APP_VALIDATION_URL\">Domain field is incorrect</span></div></div>\n</md-input-container></div><p \nstyle=\"color: #898989;margin-top: -24px;font-size: 12px;position: relative;margin-right: 60px;text-align: right\" \ntranslate=\"URL_NOTE\">Please Enter URL with \"HTTP/S\"</p><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label translate=\"APP_PORT\">Port\n</label><input type=\"text\" name=\"port\" ng-model=\"vm.sentinel.port\" pattern=\"^\\d+$\" aria-invalid=\"true\" required \nmaxlength=\"5\" autocomplete=\"off\"><div ng-messages=\"vm.orgSenForm.port.$error\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\">\n<md-input-container md-no-float flex=\"100\"><label for=\"path\" translate=\"AUDIO_BACKUP_PATH\">Path</label><input \ntype=\"text\" name=\"path\" ng-model=\"vm.sentinel.path\" id=\"path\" aria-invalid=\"true\" md-maxlength=\"200\" \npattern=\"^\\/[a-zA-Z][a-zA-Z0-9+_\\-.\\/]*\" required maxlength=\"200\" autocomplete=\"off\"><div \nng-messages=\"vm.orgSenForm.path.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_URL\">Domain field is incorrect</span></div></div></md-input-container></div><p \nstyle=\"color: #898989;margin-top: -24px;font-size: 12px;position: relative;margin-right: 50px;text-align: right\" \ntranslate=\"PATH_NOTE\">Please Add \"/\" before path</p><md-button \nng-disabled=\"vm.orgSenForm.$invalid || !(vm.allowCreate || vm.allowModify)\" md-no-ink class=\"md-primary\" \nng-click=\"vm.saveSentinel()\" id=\"vm.orgBtn\" aria-label=\"\" translate=\"APP_SAVE\">Save</md-button><md-button \nng-disabled=\"vm.orgSenForm.$invalid || !vm.allowDelete\" md-no-ink class=\"md-primary\" ng-click=\"vm.clearSentinel()\" \nid=\"vm.orgBtn\" aria-label=\"\" translate=\"APP_REMOVE_ALL\">Save</md-button></form><div class=\"informationBox\"><h4 \ntranslate=\"APP_INFO\">Info:</h4><p class=\"infortext\" translate=\"SENTINEL_INFO_TEXT\">\nTo test the functionality, please use the following test endpoint:</p><p>{{vm.consturl.hostname}}</p><p><b \ntranslate=\"APP_PORT\">Port:</b> {{vm.consturl.port}}</p><p><b translate=\"AUDIO_BACKUP_PATH\">Path:</b>\n {{vm.consturl.pathname}}</p></div></md-content>");
$templateCache.put("app/main/restricted/reseller/reseller-manager/details/tabs/branding.details.html","<md-content class=\"content\"><form name=\"vm.resellerFormBranding\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate=\"\"><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" style=\"margin-bottom: 10px\"><label \ntranslate=\"BRANDING_TITLE_MESSAGE\">The branding settings may affect all the client applications in this organization.\n</label></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container \nmd-no-float flex=\"100\"><label translate=\"BRANDING_NAME\">Application Name</label><input type=\"text\" name=\"name\" \nng-model=\"vm.brand.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' aria-invalid=\"true\" md-maxlength=\"20\" maxlength=\"20\" \nautocomplete=\"off\"></md-input-container><div layout=\"column\"><md-checkbox aria-label=\"checkbox\" \nng-model=\"vm.brand.override_branding_name\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"!vm.reseller._id  || !vm.brand.name\" ng-if=\"vm.reseller._id && vm.allowModify \"><md-tooltip><span \ntranslate=\"BRANDING_RESET_WARNING\">The client application will use the default values set by the developer</span>\n</md-tooltip><span translate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div><md-divider vertical>\n</md-divider><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" style=\"margin-top: 25px\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"BRANDING_MAP_SERVER\">Map server</label><input type=\"text\" \nname=\"name\" ng-model=\"vm.brand.map_server\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' aria-invalid=\"true\" md-maxlength=\"20\" \nmaxlength=\"20\" autocomplete=\"off\"></md-input-container></div><md-divider vertical></md-divider><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" style=\"margin-top: 25px\"><md-input-container md-no-float \nflex=\"100\"><label translate=\"COLOR1\">Color1</label><color-picker name=\"color\" ng-model=\"vm.brand.color\" \naria-invalid=\"true\" maxlength=\"7\" required options=\"options\"></color-picker><div layout=\"row\"><md-input-container \nmd-no-float flex=\"100\"><input type=\"text\" name=\"color\" ng-model=\"vm.brand.color\" aria-invalid=\"true\" maxlength=\"7\" \nid=\"color\" placeholder=\"#F05A47\"></md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox \naria-label=\"checkbox\" ng-model=\"vm.brand.override_branding_color1\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"!vm.reseller._id || !vm.brand.color\" ng-if=\"vm.reseller._id && vm.allowModify \"><md-tooltip><span \ntranslate=\"BRANDING_RESET_WARNING\">The client application will use the default values set by the developer</span>\n</md-tooltip><span translate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></md-input-container></div>\n<md-divider vertical></md-divider><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" \nstyle=\"margin-top: 25px\"><md-input-container md-no-float flex=\"100\"><label translate=\"COLOR2\">Color2</label>\n<color-picker name=\"sec_color\" ng-model=\"vm.brand.sec_color\" aria-invalid=\"true\" maxlength=\"7\" ng-readonly required \noptions=\"options\"></color-picker><div layout=\"row\"><md-input-container md-no-float flex=\"100\"><input type=\"text\" \nname=\"sec_color\" ng-model=\"vm.brand.sec_color\" aria-invalid=\"true\" maxlength=\"7\" id=\"sec_color\" placeholder=\"#F05A47\">\n</md-input-container><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox aria-label=\"checkbox\" \nng-model=\"vm.brand.override_branding_color2\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"!vm.reseller._id || !vm.brand.sec_color\" ng-if=\"vm.reseller._id && vm.allowModify \"><md-tooltip><span \ntranslate=\"BRANDING_RESET_WARNING\">The client application will use the default values set by the developer</span>\n</md-tooltip><span translate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></md-input-container></div>\n<md-divider vertical></md-divider><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" \nstyle=\"margin-top: 25px\"><span translate=\"MOBILE_PORTAL_LOGO_IMAGE\">Management Portal Logo Image</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"30\" \nstyle=\"margin-right: -17%\"><input content=\"management_portal_logo\" type=\"file\" name=\"management_portal_logo\" \nng-model=\"management_portal_logo\" id=\"management_portal_logo\" style=\"width: 332px\" \naccept=\".png, .jpg, .jpeg,.PNG, .JPG, .JPEG\" onchange=\"angular.element(this).scope().onUploadFile(this)\"><div \nng-messages=\"vm.resellerFormBranding.management_portal_logo.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"validationError\"><span translate=\"APP_WRONG_FILE_EXTENTION\">Wrong file extention</span></div></div>\n</md-input-container><div layout=\"row\"><md-input-container md-no-float flex=\"50\"><img \nstyle=\"max-width: 200px;margin-left: -51%;max-height: 60%\" ng-hide=\"!vm.management_portal_image\" \ndata-ng-src=\"data:image/*;base64,{{vm.management_portal_image}}\"></md-input-container><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"width: 212%\"><md-checkbox aria-label=\"checkbox\" \nng-model=\"vm.brand.override_management_portal_image\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"!vm.reseller._id  || !vm.management_portal_image\" ng-if=\"vm.reseller._id && vm.allowModify \"><md-tooltip>\n<span translate=\"BRANDING_RESET_WARNING\">The client application will use the default values set by the developer</span>\n</md-tooltip><span translate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></div><md-divider vertical>\n</md-divider><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" style=\"margin-top: 25px\">\n<span translate=\"BRANDING_IMAGE\">Image</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"30\" style=\"margin-right: -17%\"><input \ncontent=\"file\" type=\"file\" name=\"file\" ng-model=\"file\" id=\"file\" style=\"width: 332px\" \naccept=\".png, .jpg, .jpeg,.PNG, .JPG, .JPEG\" onchange=\"angular.element(this).scope().onUploadFile(this)\"><div \nng-messages=\"vm.resellerFormBranding.file.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"validationError\">\n<span translate=\"APP_WRONG_FILE_EXTENTION\">Wrong file extention</span></div></div></md-input-container><div \nlayout=\"row\"><md-input-container md-no-float flex=\"50\"><img style=\"max-width: 200px;margin-left: -51%;max-height: 60%\" \nng-hide=\"!vm.image\" data-ng-src=\"data:image/*;base64,{{vm.image}}\"></md-input-container><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"width: 212%\"><md-checkbox aria-label=\"checkbox\" ng-model=\"vm.brand.override_branding_image\" \nng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"!vm.reseller._id  || !vm.image\" \nng-if=\"vm.reseller._id && vm.allowModify \"><md-tooltip><span translate=\"BRANDING_RESET_WARNING\">\nThe client application will use the default values set by the developer</span></md-tooltip><span \ntranslate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></div><md-divider vertical></md-divider><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" style=\"margin-top: 25px\"><span \ntranslate=\"BRANDING_MDC_LOGO_IMAGE\">MDC Logo Image</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"30\" style=\"margin-right: -17%\"><input \ncontent=\"file\" type=\"file\" name=\"file_mdc_logo\" ng-model=\"file_mdc_logo\" aria-invalid=\"true\" id=\"file_mdc_logo\" \nstyle=\"width: 332px\" accept=\".ico\" onchange=\"angular.element(this).scope().onUploadFile(this)\"><div \nng-messages=\"vm.resellerFormBranding.file_mdc_logo.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"validationError\"><span translate=\"APP_WRONG_FILE_EXTENTION\">Wrong file extention</span></div></div>\n</md-input-container><div layout=\"row\"><md-input-container md-no-float flex=\"50\"><img \nstyle=\"max-width: 200px;margin-left: -51%;max-height: 60%\" ng-hide=\"!vm.image_mdc_logo\" \ndata-ng-src=\"data:image/*;base64,{{vm.image_mdc_logo}}\"></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"width: 212%\"><md-checkbox aria-label=\"checkbox\" ng-model=\"vm.brand.override_mdc_logo_image\" \nng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"!vm.reseller._id  || !vm.image_mdc_logo\" \nng-if=\"vm.reseller._id && vm.allowModify \"><md-tooltip><span translate=\"BRANDING_RESET_WARNING\">\nThe client application will use the default values set by the developer</span></md-tooltip><span \ntranslate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></div><md-divider vertical></md-divider><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" style=\"margin-top: 25px\"><label \ntranslate=\"BRANDING_MDC_SPALSH_IMAGE\">MDC Splash Image</label></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"30\" style=\"margin-right: -17%\"><input \ncontent=\"file_mdc_splash\" type=\"file\" name=\"file_mdc_splash\" ng-model=\"file_mdc_splash\" id=\"file_mdc_splash\" \nstyle=\"width: 332px\" accept=\".png, .jpg, .jpeg,.PNG, .JPG, .JPEG\" \nonchange=\"angular.element(this).scope().onUploadFile(this)\"><div \nng-messages=\"vm.resellerFormBranding.file_mdc_splash.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"validationError\"><span translate=\"APP_WRONG_FILE_EXTENTION\">Wrong file extention</span></div></div>\n</md-input-container><div layout=\"row\"><md-input-container md-no-float flex=\"50\"><img \nstyle=\"max-width: 200px;margin-left: -51%;max-height: 60%\" ng-hide=\"!vm.image_mdc_splash\" \ndata-ng-src=\"data:image/*;base64,{{vm.image_mdc_splash}}\"></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"width: 212%\"><md-checkbox aria-label=\"checkbox\" ng-model=\"vm.brand.override_mdc_splash_image\" \nng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"!vm.reseller._id  || !vm.image_mdc_splash\" \nng-if=\"vm.reseller._id && vm.allowModify \"><md-tooltip><span translate=\"BRANDING_RESET_WARNING\">\nThe client application will use the default values set by the developer</span></md-tooltip><span \ntranslate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></div><md-divider vertical></md-divider><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\" style=\"margin-top: 25px\"><span \ntranslate=\"BRANDING_MDC_COMPANYNAME_IMAGE\">MDC Company Name Image</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"30\" style=\"margin-right: -17%\"><input \ncontent=\"file_mdc_companyName\" type=\"file\" name=\"file_mdc_companyName\" ng-model=\"file_mdc_companyName\" \nid=\"file_mdc_companyName\" style=\"width: 332px\" accept=\".png, .jpg, .jpeg, .PNG, .JPG, .JPEG\" \nonchange=\"angular.element(this).scope().onUploadFile(this)\"><div \nng-messages=\"vm.resellerFormBranding.file_mdc_companyName.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"validationError\"><span translate=\"APP_WRONG_FILE_EXTENTION\">Wrong file extention</span></div></div>\n</md-input-container><div layout=\"row\"><md-input-container md-no-float flex=\"50\"><img \nstyle=\"max-width: 200px;margin-left: -51%;max-height: 60%\" ng-hide=\"!vm.image_mdc_companyName\" \ndata-ng-src=\"data:image/*;base64,{{vm.image_mdc_companyName}}\"></md-input-container><div layout=\"column\" \nlayout-gt-sm=\"row\" style=\"width: 212%\"><md-checkbox aria-label=\"checkbox\" \nng-model=\"vm.brand.override_mdc_companyName_image\" ng-true-value=\"true\" ng-false-value=\"false\" \nng-disabled=\"!vm.reseller._id  || !vm.image_mdc_companyName\" ng-if=\"vm.reseller._id && vm.allowModify \"><md-tooltip>\n<span translate=\"BRANDING_RESET_WARNING\">The client application will use the default values set by the developer</span>\n</md-tooltip><span translate=\"FLAG_BRAND_ACTIVATION\">Reset</span></md-checkbox></div></div></div><md-divider vertical>\n</md-divider><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox aria-label=\"checkbox\" \nng-model=\"vm.brand.override_reseller\" ng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"!vm.reseller._id\" \nng-if=\"vm.reseller._id && vm.allowModify \"><span translate=\"BRANDING_RESELLER_OVERRIDE_RESELLER\">Override Reseller\n</span></md-checkbox></div><div layout=\"row\" style=\"margin-top: 25px\"><md-button md-no-ink class=\"md-primary\" \nng-click=\"vm.resetAllOverrideValues()\" ng-disabled=\"!vm.reseller._id\" ng-if=\"vm.reseller._id && vm.allowModify\" \naria-label=\"\" translate=\"BUTTON_RESET_BRAND_INFO\">Reset</md-button><md-button md-no-ink class=\"md-primary\" \nng-click=\"vm.saveOBrandingInfo()\" \nng-disabled=\"!vm.reseller._id || vm.resellerFormBranding.file.$invalid || vm.resellerFormBranding.file_mdc_logo.$invalid || vm.resellerFormBranding.file_mdc_splash.$invalid || vm.resellerFormBranding.file_mdc_companyName.$invalid\" \nng-if=\"vm.reseller._id && vm.allowModify\" aria-label=\"\" translate=\"BUTTON_SAVE_BRAND_INFO\">Submit</md-button></div>\n</form></md-content>");
$templateCache.put("app/main/restricted/reseller/reseller-manager/details/tabs/contact.details.html","<md-content class=\"content contact-details\"><form name=\"vm.resellerContactForm\"><div layout=\"column\" \nclass=\"layout-block\"><div layout=\"column\" layout-gt-xs=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container\n flex=\"40\"><label translate=\"RESELLER_ADMIN_FIRST_NAME\">Admin Contact First Name</label><input type=\"text\" \nname=\"adminFirstName\" md-maxlength=\"200\" ng-model=\"vm.reseller.adminContactFirst\" aria-invalid=\"true\">\n</md-input-container><md-input-container flex=\"40\" flex-offset=\"5\"><label translate=\"RESELLER_ADMIN_LAST_NAME\">\nAdmin Contact Last Name</label><input type=\"text\" name=\"adminLastName\" md-maxlength=\"200\" \nng-model=\"vm.reseller.adminContactLast\" aria-invalid=\"true\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"40\"><label translate=\"RESELLER_ADMIN_EMAIL\">Contact email address</label>\n<input type=\"text\" name=\"adminEmail\" md-maxlength=\"200\" ng-model=\"vm.reseller.adminContactEmail\" aria-invalid=\"true\">\n</md-input-container><md-input-container flex-offset=\"5\" flex=\"40\"><label translate=\"RESELLER_ADMIN_PHONE\">\nContact telephone number</label><input type=\"text\" name=\"adminPhone\" md-maxlength=\"20\" \nng-model=\"vm.reseller.adminContactPhone\" aria-invalid=\"true\"></md-input-container></div></div><md-divider></md-divider>\n<div layout=\"column\" class=\"layout-block\"><div layout=\"column\" layout-gt-xs=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container flex=\"40\"><label translate=\"RESELLER_SUPPORT_FIRST_NAME\">\nAdmin Contact First Name</label><input type=\"text\" name=\"supportFirstName\" md-maxlength=\"200\" \nng-model=\"vm.reseller.supportContactFirst\" aria-invalid=\"true\"></md-input-container><md-input-container \nflex-offset=\"5\" flex=\"40\"><label translate=\"RESELLER_SUPPORT_LAST_NAME\">Admin Contact Last Name</label><input \ntype=\"text\" name=\"supportLastName\" md-maxlength=\"200\" ng-model=\"vm.reseller.supportContactLast\" aria-invalid=\"true\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"40\"><label \ntranslate=\"RESELLER_SUPPORT_EMAIL\">Contact email address</label><input type=\"text\" name=\"supportEmail\" \nmd-maxlength=\"200\" ng-model=\"vm.reseller.supportContactEmail\" aria-invalid=\"true\"></md-input-container>\n<md-input-container flex-offset=\"5\" flex=\"40\"><label translate=\"RESELLER_SUPPORT_PHONE\">Contact telephone number\n</label><input type=\"text\" name=\"supportPhone\" md-maxlength=\"20\" ng-model=\"vm.reseller.supportContactPhone\" \naria-invalid=\"true\"></md-input-container></div></div></form></md-content>");
$templateCache.put("app/main/restricted/reseller/reseller-manager/details/tabs/general.html","<md-content class=\"content\"><form name=\"vm.resellerForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate=\"\"><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"RESELLER_CRMID\">CRM ID</label><input type=\"text\" name=\"crmId\" ng-model=\"vm.reseller.crmId\" \nng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' aria-invalid=\"true\" md-maxlength=\"40\" required autocomplete=\"off\"><div \nng-messages=\"vm.resellerForm.crmId.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div ng-message=\"pattern\"><span \ntranslate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"RESELLER_NAME\">Reseller name</label><input type=\"text\" \nname=\"name\" ng-model=\"vm.reseller.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' aria-invalid=\"true\" md-maxlength=\"20\" required \nautocomplete=\"off\"><div ng-messages=\"vm.resellerForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\">\n<label translate=\"RESELLER_ADDRESS\">Address</label><input type=\"text\" name=\"address\" ng-model=\"vm.reseller.address\" \naria-invalid=\"true\" ng-minlength=\"3\" required autocomplete=\"off\"><div ng-messages=\"vm.resellerForm.address.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div>\n<div ng-message=\"minlength\"><span translate=\"APP_VALIDATION_MIN_LENGTH\">This field is too short</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"RESELLER_SITE\">Site</label><md-select ng-model=\"vm.reseller.site\" required><md-option \nng-repeat=\"site in vm.sites\" value=\"{{site._id}}\">{{site.name}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\">\n<label translate=\"RESELLER_PORTAL_URL\">Portal url</label><input type=\"text\" name=\"portal\" \nng-model=\"vm.reseller.portalUri\" \nng-pattern=\"/^(((([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(%[\\da-f]{2})|[!\\$&\'\\(\\)\\*\\+,;=]|:)*@)?(((\\d|[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d|[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d|[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d|[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5]))|((([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.?)(:\\d*)?)(\\/((([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(%[\\da-f]{2})|[!\\$&\'\\(\\)\\*\\+,;=]|:|@)+(\\/(([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(%[\\da-f]{2})|[!\\$&\'\\(\\)\\*\\+,;=]|:|@)*)*)?)?(\\?((([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(%[\\da-f]{2})|[!\\$&\'\\(\\)\\*\\+,;=]|:|@)|[\\uE000-\\uF8FF]|\\/|\\?)*)?(\\#((([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(%[\\da-f]{2})|[!\\$&\'\\(\\)\\*\\+,;=]|:|@)|\\/|\\?)*)?$/i\" \naria-invalid=\"true\" md-maxlength=\"200\" required autocomplete=\"off\"><div ng-messages=\"vm.resellerForm.portal.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div>\n<div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div \nng-message=\"pattern\"><span translate=\"APP_VALIDATION_URL\">Domain field is incorrect</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"RESELLER_WEBSERVICE_URL\">Webservice url</label><input \ntype=\"text\" name=\"webservice\" ng-model=\"vm.reseller.notificationsTarget\" \nng-pattern=\"/^(((([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(%[\\da-f]{2})|[!\\$&\'\\(\\)\\*\\+,;=]|:)*@)?(((\\d|[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d|[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d|[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])\\.(\\d|[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5]))|((([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.?)(:\\d*)?)(\\/((([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(%[\\da-f]{2})|[!\\$&\'\\(\\)\\*\\+,;=]|:|@)+(\\/(([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(%[\\da-f]{2})|[!\\$&\'\\(\\)\\*\\+,;=]|:|@)*)*)?)?(\\?((([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(%[\\da-f]{2})|[!\\$&\'\\(\\)\\*\\+,;=]|:|@)|[\\uE000-\\uF8FF]|\\/|\\?)*)?(\\#((([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(%[\\da-f]{2})|[!\\$&\'\\(\\)\\*\\+,;=]|:|@)|\\/|\\?)*)?$/i\" \naria-invalid=\"true\" md-maxlength=\"200\" autocomplete=\"off\"><div ng-messages=\"vm.resellerForm.webservice.$error\" \nrole=\"alert\"><div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span>\n</div><div ng-message=\"pattern\"><span translate=\"APP_VALIDATION_URL\">Domain field is incorrect</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 3%; font-weight: bold\" \nng-if=\"vm.showStrongAdministratorPass\"><span translate=\"STRONG_PASSWORD_PLAN\">Strong Password Plan</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showStrongAdministratorPass\"><md-checkbox aria-label=\"checkbox\" \nng-model=\"vm.reseller.strongAdministratorPass\" ng-true-value=\"1\" ng-false-value=\"0\" ng-disabled=\"!vm.allowModify\"><span\n translate=\"ORGANIZATION_STRONG_ADMINISTRATOR_PASS\">Force Strong Password For Administrator Users</span></md-checkbox>\n</div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top: 3%; margin-bottom: 1%; font-weight: bold\" \nng-if=\"vm.showMaxRetries\"><span translate=\"MAX_LOGIN_RETRIES_PLAN\">Max Login Retries Plan</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.showMaxRetries\"><md-switch ng-model=\"vm.enable_max_login_retries\">\n</md-switch><md-input-container md-no-float flex><label translate=\"MAX_LOGIN_RETRIES\">Latest Android Version</label>\n<input type=\"text\" ng-pattern=\"/^(?:[3-9]|[12][0-9])[0-9]*$/\" md-maxlength=\"4\" name=\"max_login_retries\" \nng-model=\"vm.reseller.max_login_retries\" id=\"max_login_retries\" ng-disabled=\"!vm.enable_max_login_retries\" translate>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-top: 3%; margin-bottom: 1%; font-weight: bold\" ng-if=\"vm.showPasswordExpiration\"><span \ntranslate=\"CHANGE_PASSWORD_PLAN\">Change Password Plan</span></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.showPasswordExpiration\"><md-switch ng-model=\"vm.enable_password_expiration_days\"></md-switch>\n<md-input-container md-no-float flex><label translate=\"PASSWORD_EXPIRATION_DAYS\">Password expiuration days</label>\n<input type=\"text\" ng-pattern=\"/^(?:[3-9]|[12][0-9])[0-9]*$/\" md-maxlength=\"4\" name=\"password_expiration_days\" \nng-model=\"vm.reseller.password_expiration_days\" id=\"password_expiration_days\" \nng-disabled=\"!vm.enable_password_expiration_days\" translate></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\" \nng-if=\"vm.showLicenseAllocation\"><label translate=\"RESELLER_QTY\">qty</label><input type=\"text\" name=\"qty\" \nng-model=\"vm.qty\" id=\"qty\" ng-disabled=\"true\" translate></md-input-container><md-input-container md-no-float \nflex=\"100\" ng-if=\"vm.showLicenseAllocation\"><label translate=\"RESELLER_DISPATCHER_QTY\">Dispatcher qty</label><input \ntype=\"text\" name=\"qty\" ng-model=\"vm.dispatcherqty\" id=\"dispatcher_qty\" ng-disabled=\"true\" translate>\n</md-input-container></div></form></md-content>");
$templateCache.put("app/main/restricted/reseller/reseller-manager/details/tabs/license.allocate.html","<md-content class=\"reseller-license-details content\" flex-offset=\"0\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\" \nng-click=\"vm.sortAllocate(\'licenseBundle.name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'licenseBundle.name\')\" translate=\"LICENSE_BUNDLE\">Bundle</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sortAllocate(\'licenseType\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'licenseType\')\" translate=\"LICENSE_TYPE\">License Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_ALLOCATION_DATE\">\nAllocation Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LICENSE_EXPIRATION_TYPE\">Expiration Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_EXPIRATION_DATE\">Expiration Date</span></div></th>\n<th class=\"secondary-text\" ng-click=\"vm.sortAllocate(\'qty\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'qty\')\" translate=\"LICENSE_QUANTITY\">Quantity</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sortAllocate(\'availableQty\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'availableQty\')\" translate=\"LICENSE_AVAILABLE_QTY\">Available</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_ALLOCATE\">Allocate\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"UNDO_LICENSE\">Undo</span></div></th></tr></thead><tbody><tr title=\"{{vm.showId ? item._id : \'\'}}\" \nid=\"{{item._id}}\" dir-paginate=\"item in vm.parentLicenses|itemsPerPage:vm.recordsCount track by $index\" \npagination-id=\"resellerLicenseAllocation\"><td width=\"15%\" class=\"table-name-label\" \nng-click=\"vm.editLicense(item.licenseBundle, item._id)\"><b>{{item.licenseBundle.name}}</b></td><td>{{item.licenseType}}\n</td><td>{{item.allocationDate | date: medium}}</td><td>{{item.expirationType}}</td><td>\n{{item.expirationDate | date: medium}}</td><td align=\"center\" ng-click=\"vm.setActiveAllocation(item._id)\">{{item.qty}}\n</td><td align=\"center\" ng-click=\"vm.setActiveAllocation(item._id)\">{{item.availableQty}}</td><td \nng-click=\"vm.setActiveAllocation(item._id)\"><md-input-container flex=\"20\" ng-show=\"vm.checkActiveAllocation(item._id)\">\n<input ng-change=\"vm.checkAvailableQuantity(item.availableQty, item.setQty)\" aria-label=\"license qty\" \nng-model=\"item.setQty\" type=\"number\" name=\"quantity\" ng-min=\"0\" ng-max=\"item.availableQty\" \nng-pattern=\"/^-?[0-9][^\\.]*$/\"></md-input-container><md-button ng-show=\"vm.checkActiveAllocation(item._id)\" \nng-click=\"vm.addDraftAllocation(item)\" ng-disabled=\"!vm.checkAvailableQuantity(item.availableQty, item.setQty)\">\nAllocate</md-button></td><td><md-button class=\"remove-button md-icon-button\" \nng-if=\"vm.saveAllocate[vm.getParentAllocationIndex(item)].isAllocate\" ng-click=\"vm.undoAllocate(item)\" translate \ntranslate-attr-aria-label=\"UNDO_LICENSE\"><md-icon md-font-icon=\"icon-undo\" class=\"fas fa-undo\"></md-icon></md-button>\n</td></tr></tbody></table><div layout=\"row\" flex class=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\">\n<md-input-container><label translate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" \nng-change=\"vm.setRecordsCount()\" pagination-id=\"resellerLicenseAllocation\" placeholder=\"Record to show\"><md-option \nng-value=\"25\">25</md-option><md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls \npagination-id=\"resellerLicenseAllocation\" max-size=\"1\" direction-links=\"true\" boundary-links=\"true\">\n</dir-pagination-controls></div></div></div></md-content>");
$templateCache.put("app/main/restricted/reseller/reseller-manager/details/tabs/license.details.html","<md-content class=\"reseller-license-details content\" flex-offset=\"0\"><div layout=\"row\" layout-align=\"end center\">\n<md-button class=\"add-button md-fab md-warn\" layout-align=\"end center\" ng-disabled=\"!vm.allowModify \" \nng-click=\"vm.switchToAllocationTab()\" aria-label=\"Add event\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\"><thead>\n<tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'licenseBundle.name\')\"><div class=\"table-header\"><span \nclass=\"column-title\" ng-class=\"vm.getSortingClass(\'licenseBundle.name\')\" translate=\"LICENSE_BUNDLE\">Bundle</span></div>\n</th><th class=\"secondary-text\" ng-click=\"vm.sort(\'licenseType\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'licenseType\')\" translate=\"LICENSE_TYPE\">License Type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_ALLOCATION_DATE\">\nAllocation Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LICENSE_EXPIRATION_TYPE\">Expiration Type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_EXPIRATION_DATE\">Expiration Date</span></div></th>\n<th class=\"secondary-text\" ng-click=\"vm.sort(\'qty\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'qty\')\" translate=\"LICENSE_QUANTITY\">Quantity</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"LICENSE_REVOKE\">Revoke</span></div></th></tr></thead>\n<tbody><tr title=\"{{vm.showId ? item._id : \'\'}}\" ng-repeat=\"item in vm.licenses\"><td width=\"15%\" \nclass=\"table-name-label\" ng-click=\"vm.editLicense(item.licenseBundle)\"><b>{{item.licenseBundle.name}}</b></td><td>\n{{item.licenseType}}</td><td>{{item.allocationDate | date: medium}}</td><td>{{item.expirationType}}</td><td>\n{{item.expirationDate | date: medium}}</td><td align=\"center\">{{item.qty}}</td><td><md-button \nclass=\"remove-button md-icon-button\" aria-label=\"remove button\" ng-click=\"vm.revokeAllocation(item._id)\" translate \ntranslate-attr-aria-label=\"APP_REMOVE\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\"></md-icon></md-button>\n</td></tr><tr style=\"color: #ccc\" ng-repeat=\"item in vm.draftLicenses track by $index\"><td width=\"15%\"><b>\n{{item.licenseBundle.name}}</b></td><td>{{item.licenseType}}</td><td>{{item.allocationDate | date: medium}}</td><td>\n{{item.expirationType}}</td><td>{{item.expirationDate | date: medium}}</td><td align=\"center\">{{item.setQty}}</td><td>\n<md-button class=\"remove-button md-icon-button\" aria-label=\"remove button\" ng-click=\"vm.removeDraftAllocation(item)\" \ntranslate translate-attr-aria-label=\"APP_REMOVE\"><md-icon md-font-icon=\"icon-window-close\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table></div></md-content>");
$templateCache.put("app/main/restricted/reseller/reseller-manager/details/tabs/sms.configuration.html","<md-content class=\"content\"><form name=\"vm.resellerSmsForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate=\"\"><span></span><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\">\n<label translate=\"SMS_SERVICE\">Service</label><md-select name=\"service\" ng-model=\"vm.reseller.sms.service\"><md-option \nng-repeat=\"item in ::vm.services\" ng-value=\"item\">{{item}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\">\n<label translate=\"SMS_API_KEY\">Api key</label><input type=\"text\" name=\"apiKey\" ng-model=\"vm.reseller.sms.apiKey\" \naria-invalid=\"true\" autocomplete=\"off\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-input-container md-no-float flex=\"100\"><label translate=\"SMS_API_SECRET\">\nApi secret</label><input type=\"text\" name=\"name\" ng-model=\"vm.reseller.sms.apiSecret\" aria-invalid=\"true\" \nautocomplete=\"off\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\" ng-if=\"vm.reseller.sms.service == \'SMPP3.4\'\"><md-input-container md-no-float \nflex=\"100\"><label translate=\"SMS_IP\">IP</label><input type=\"text\" name=\"apiKey\" ng-model=\"vm.reseller.sms.ip\" \naria-invalid=\"true\" md-maxlength=\"40\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\" ng-if=\"vm.reseller.sms.service == \'SMPP3.4\'\"><md-input-container md-no-float \nflex=\"100\"><label translate=\"SMS_PORT\">Port</label><input type=\"text\" name=\"name\" ng-model=\"vm.reseller.sms.port\" \naria-invalid=\"true\" md-maxlength=\"40\"></md-input-container></div></form></md-content>");
$templateCache.put("app/main/restricted/organization/recording/tabs/admin-record/dialog/admin.dialog.add.html","<md-dialog aria-label=\"Administrators\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ADMIN_RECORD_DIALOG_TITLE\">Admin Record</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><form name=\"vm.adminForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"ADMIN_RECORD_EMAIL_ID\">Email address</label><input \ntype=\"email\" name=\"email\" ng-model=\"vm.user.username\" translate aria-invalid=\"true\" md-maxlength=\"50\" \nng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{1,}$/\" required autocomplete=\"off\"><div ng-messages=\"vm.adminForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">\nThis field is required</span></div><div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">\nThis field is too long</span></div><div ng-message=\"pattern\"><span translate=\"APP_VALIDATION_EMAIL\">\nEmail must be a valid e-mail address</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-checkbox ng-if=\"vm.user.admin_id\" aria-label=\"permission-item\" class=\"md-secondary\" \nng-model=\"vm.user.changePassword\" ng-change=\"vm.showPassword()\" translate=\"APP_CHANGE_PASSWORD\">Change Password\n</md-checkbox></div><password-fields ng-if=\"((vm.user.admin_id && vm.user.changePassword) || !vm.user.admin_id)\" \npassword=\"vm.user.password\" re-password=\"vm.user.rePassword\" form-name=\"vm.adminForm\" \nstrong-pass=\"vm.strongPassForReviewers\" ? 1 : 0></password-fields></form></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button translate=\"APP_CANCEL\" ng-click=\"vm.close()\" \nng-disabled=\"!vm.flagSave\">Cancel</md-button><md-button translate=\"APP_SAVE\" \nng-disabled=\"( !vm.allowCreate && !vm.user.admin_id) || (!vm.allowModify && vm.user.admin_id) || !vm.flagSave || vm.adminForm.$invalid\" \nng-click=\"vm.ok()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/restricted/organization/recording/tabs/admin-record/dialog/admin.dialog.tabs.html","<md-dialog aria-label=\"Administrators\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"ADMIN_RECORD_DIALOG_TITLE\">Admin Record</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><md-tabs md-dynamic-height \nmd-border-bottom><md-tab md-on-select=\"vm.onTabChanges(0)\"><md-tab-label><span translate=\"ADMIN_RECORD_DETAILS\">\nRecordings Reviewers Details</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/recording/tabs/admin-record/dialog/tabs/admin.dialog.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(2)\"><md-tab-label><span translate=\"ADMIN_RECORD_ACTIVITY\">\nRecordings Reviewers Activities</span></md-tab-label><md-tab-body><md-content class=\"pd-2\" \nng-include=\"\'app/main/restricted/organization/recording/tabs/admin-record/dialog/tabs/admin.record.activity.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/restricted/organization/recording/tabs/audio-backup-path/dialog/audio.backup.path.dialog.add.html","<md-dialog aria-label=\"Administrators\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"AUDIO_BACKUP_PATH_DIALOG_TITLE\">Audio Backup path</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content>\n<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><form name=\"vm.pathForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><md-datepicker md-mode=\"month\" ng-model=\"vm.record.folder_date\" \nmd-min-date=\"vm.minDate\" md-date-locale=\"vm.monthFormat\" md-placeholder=\"{{ \'FOLDER_DATE\' | translate  }}\" required>\n</md-datepicker></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"AUDIO_BACKUP_PATH\">Path</label><input type=\"path\" name=\"path\" ng-model=\"vm.record.path\" translate \naria-invalid=\"true\" md-maxlength=\"50\" required><div ng-messages=\"vm.pathForm.path.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span>\n</div><div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div></div>\n</md-input-container></div></form></md-content></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button translate=\"APP_CANCEL\" ng-click=\"vm.close()\" ng-disabled=\"!vm.flagSave\">Cancel</md-button><md-button \ntranslate=\"APP_SAVE\" ng-disabled=\"!vm.record.folder_date || !vm.record.path || !vm.flagSave || vm.pathForm.$invalid\" \nng-click=\"vm.ok()\">Save</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/restricted/platform/config/tabs/general/details/add.details.dialog.html","<md-dialog aria-label=\"Device\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"CONFIG_ADD_PARAM\">Add new parameter</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content>\n<div layout=\"column\"><label translate=\"CONFIG_DEFAULT\">Default parameter</label><md-select \nng-model=\"vm.defaultParameterId\" ng-change=\"vm.selectDefaultParameter()\"><md-option ng-repeat=\"item in vm.paramsList\" \nvalue=\"{{item.parameter_id}}\">{{item.name}}</md-option></md-select></div><div layout=\"column\"><label \ntranslate=\"CONFIG_VALUE_TYPE\">Value Type</label><md-select ng-model=\"vm.param.format\" \nng-disabled=\"vm.defaultParameterId != 0\"><md-option ng-repeat=\"item in vm.valueTypes\" value=\"{{item._id}}\">\n{{item.name}}</md-option></md-select></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float \nflex=\"100\"><label translate=\"CONFIG_NAME\">Name</label><input type=\"text\" ng-model=\"vm.param.name\" translate \naria-invalid=\"true\" ng-disabled=\"vm.defaultParameterId != 0\" required></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label translate=\"CONFIG_VALUE\">Value</label><input \ntype=\"text\" ng-model=\"vm.param.value\" translate aria-invalid=\"true\" required></md-input-container></div><div \nlayout=\"column\"><label translate=\"CONFIG_SERVER_ID\">Server Id</label><md-select ng-model=\"vm.param.server_id\">\n<md-option ng-repeat=\"server in vm.servers\" value=\"{{server._id}}\">{{server.name}} ({{server._id}})</md-option>\n</md-select></div><div layout=\"row\"><md-input-container md-no-float flex><label translate=\"CONFIG_SYSTEM\">System\n</label><input type=\"checkbox\" ng-model=\"vm.param.scope.system\" translate aria-invalid=\"true\" \nng-disabled=\"vm.defaultParameterId != 0\"></md-input-container><md-input-container md-no-float flex><label \ntranslate=\"CONFIG_SERVER\">Server</label><input type=\"checkbox\" ng-model=\"vm.param.scope.server\" translate \naria-invalid=\"true\" ng-disabled=\"vm.defaultParameterId != 0\"></md-input-container><md-input-container md-no-float flex>\n<label translate=\"CONFIG_SITE\">Site</label><input type=\"checkbox\" ng-model=\"vm.param.scope.site\" translate \naria-invalid=\"true\" ng-disabled=\"vm.defaultParameterId != 0\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vm.cancel()\" translate=\"APP_CANCEL\">Cancel\n</md-button><md-button translate=\"APP_SAVE\" ng-click=\"vm.save()\" ng-disabled=\"!vm.param.name || !vm.param.value\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/restricted/platform/config/tabs/general/details/details.dialog.html","<md-dialog aria-label=\"Device\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2 \ntranslate=\"CONFIG_SET_PARAM\">Set parameter value</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content>\n<div layout=\"column\" layout-gt-sm=\"row\"><p style=\"color:red\" translate=\"CONFIG_WARNING\">\nInvalid value may affect on server stability!</p></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"vm.param.parameter_id == 9085 || vm.param.parameter_id == 9086 || vm.param.parameter_id == 9087 || vm.param.parameter_id == 9088\">\n<p style=\"color:red; margin-top: 0\" translate=\"CONFIG_IPRS_WARNING\">\nPlease keep same value for this configuration at server!</p></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"CONFIG_NAME\">Name</label><input ng-disabled=\"true\" \ntype=\"text\" ng-model=\"vm.param.name\" translate aria-invalid=\"true\" required></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label translate=\"CONFIG_VALUE\">Value\n</label><input type=\"text\" ng-model=\"vm.param.value\" translate aria-invalid=\"true\" ng-pattern=\"vm.pattern\" required>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"vm.cancel()\" translate=\"APP_CANCEL\" ng-disabled=\"!vm.flagSave\">Cancel</md-button><md-button \ntranslate=\"APP_SAVE\" ng-click=\"vm.save()\" ng-disabled=\"!vm.param.name || !vm.param.value || !vm.flagSave\">Save\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/restricted/platform/config/tabs/server/details/server.dialog.html","<md-dialog aria-label=\"Device\"><form name=\"serverForm\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\n{{vm.server.name}} <span translate=\"SERVER_CONFIG\">server parameters</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\"><label translate=\"SERVER_TYPE\">Type</label><md-select \nng-model=\"vm.server.type\"><md-option ng-repeat=\"option in vm.serverType\" value=\"{{option.id}}\">{{option.value}}\n</md-option></md-select></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label\n translate=\"SERVER_NAME\">Name</label><input type=\"text\" ng-model=\"vm.server.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' \nmd-maxlength=\"40\" name=\"name\" aria-invalid=\"true\" required><div ng-messages=\"serverForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div \nng-message=\"maxLength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div \nng-message=\"pattern\"><span translate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float \nflex=\"100\"><label translate=\"SERVER_HOST\">Host</label><input type=\"text\" name=\"host\" ng-model=\"vm.server.host\" \ntranslate aria-invalid=\"true\" \nng-pattern=\"/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/\" \nplaceholder=\"0.0.0.0\" required><div ng-messages=\"serverForm.host.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div \nng-message=\"pattern\"><span translate=\"APP_VALIDATION_IP\">Should be a valid IP address</span></div></div>\n</md-input-container></div><div layout=\"column\"><label translate=\"SERVER_ADMIN_STATE\">Admin State</label><md-select \nng-model=\"vm.server.adminState\" ng-change=\"vm.syncServerState()\"><md-option ng-repeat=\"option in vm.serverAdminState\" \nvalue=\"{{option.id}}\">{{option.value}}</md-option></md-select></div><div layout=\"column\"><label \ntranslate=\"SERVER_STATE\">State</label><md-select ng-model=\"vm.server.state\" ng-disabled=\"true\"><md-option \nng-repeat=\"option in vm.serverState\" value=\"{{option.id}}\">{{option.value}}</md-option></md-select></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vm.cancel()\" \ntranslate=\"APP_CANCEL\">Cancel</md-button><md-button translate=\"APP_SAVE\" ng-click=\"vm.save()\" \nng-disabled=\"!vm.server.name || !vm.server.host || siteForm.$invalid\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/restricted/platform/config/tabs/site/details/site.dialog.html","<md-dialog aria-label=\"Device\"><form name=\"siteForm\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\n{{vm.site.name}} <span translate=\"SITE_DIALOG_TITLE\">Details</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\">\n<label translate=\"SITE_NAME\">Name</label><input type=\"text\" ng-model=\"vm.site.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' \nmd-maxlength=\"40\" name=\"name\" translate aria-invalid=\"true\" required><div ng-messages=\"siteForm.name.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">\nThis field is required</span></div><div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">\nThis field is too long</span></div><div ng-message=\"pattern\"><span translate=\"APP_VALIDATION_SPECIAL_CHARS\">\nThis field can not contain special characters</span></div></div></md-input-container></div><div layout=\"column\"><label \ntranslate=\"SITE_SERVER_1\">Server 1</label><md-select ng-model=\"vm.site.server1\" ng-change=\"vm.fillServerData()\">\n<md-option ng-repeat=\"server in vm.servers\" value=\"{{server._id}}\">{{server.name}}</md-option></md-select></div><div \nlayout=\"column\"><label translate=\"SITE_SERVER_2\">Server 2</label><md-select ng-model=\"vm.site.server2\" \nng-disabled=\"!vm.site.server1\"><md-option ng-repeat=\"server in vm.secondServerList\" value=\"{{server._id}}\">\n{{server.name}}</md-option></md-select></div><div layout=\"column\"><label translate=\"SITE_TYPE\">Type</label><md-select \nng-model=\"vm.site.type\" ng-disabled=\"true\"><md-option ng-repeat=\"option in vm.siteType\" value=\"{{option.id}}\">\n{{option.value}}</md-option></md-select></div><div layout=\"column\"><label translate=\"SITE_STATE\">State</label>\n<md-select ng-model=\"vm.site.state\" ng-disabled=\"true\"><md-option ng-repeat=\"option in vm.siteState\" \nvalue=\"{{option.id}}\">{{option.value}}</md-option></md-select></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"SITE_HOST\">Host</label><input type=\"text\" \nng-model=\"vm.site.host\" name=\"host\" translate aria-invalid=\"true\" \nng-pattern=\"/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/\" \nplaceholder=\"0.0.0.0\" required><div ng-messages=\"siteForm.host.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span></div><div \nng-message=\"pattern\"><span translate=\"APP_VALIDATION_IP\">SHould be a valid IP address</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float flex=\"100\"><label \ntranslate=\"SITE_CONTROL_PORT\">Control Port</label><input type=\"number\" min=\"1\" ng-model=\"vm.site.controlPort\" \ntranslate aria-invalid=\"true\" required></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container md-no-float flex=\"100\"><label translate=\"SITE_AUDIO_PORT\">Audio Port</label><input type=\"number\" \nmin=\"1\" ng-model=\"vm.site.audioPort\" translate aria-invalid=\"true\" required></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button ng-click=\"vm.cancel()\" \ntranslate=\"APP_CANCEL\">Cancel</md-button><md-button ng-click=\"vm.save()\" translate=\"APP_SAVE\" \nng-disabled=\"!vm.site.name || !vm.site.host || siteForm.$invalid\">Save</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/restricted/platform/licenses/tabs/convert/permission-component/permission.component.html","<md-list-item><p>{{vm.permissionName}}</p><md-checkbox aria-label=\"permission-item\" class=\"md-secondary\" \nng-class=\"vm.getCheckboxClass()\" ng-model=\"vm.permissionItem\" ng-change=\"vm.changeParentItem()\" \nng-disabled=\"vm.isEdit\"></md-checkbox></md-list-item><md-list-item class=\"sub-permission\" ng-if=\"vm.isSubItem()\" \nng-show=\"vm.showSubItem\"><p>{{vm.permissionSubItemName}}</p><md-select ng-if=\"vm.multiSession\" \nng-disabled=\"!vm.permissionItem || vm.isEdit\" class=\"md-secondary\" ng-model=\"vm.permissionSubItem\"><md-option \nng-value=\"1\">4</md-option><md-option ng-value=\"2\">1</md-option><md-option ng-value=\"3\">8</md-option><md-option \nng-value=\"4\">16</md-option></md-select><md-checkbox ng-if=\"!vm.multiSession\" aria-label=\"permission-sub-item\" \nng-disabled=\"!vm.permissionItem || vm.isEdit\" class=\"md-secondary\" ng-model=\"vm.permissionSubItem\" \nng-true-value=\"false\" ng-false-value=\"true\"></md-checkbox></md-list-item>");
$templateCache.put("app/main/restricted/platform/licenses/tabs/templates/details/details.dialog.html","<md-dialog aria-label=\"Subscriber\" class=\"license-template\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nLicense details</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \naria-label=\"Close dialog\">X</md-icon></md-button></div></md-toolbar><md-dialog-content><form name=\"licenseForm\" \nng-cloak><div layout=\"column\" layout-gt-sm=\"row\" class=\"layout-gt-sm-row layout-column\"><md-input-container \nmd-no-float flex=\"100\"><label translate=\"LICENSE_NAME\">License name</label><input type=\"text\" name=\"name\" \nng-model=\"vm.license.name\" ng-pattern=\'/^[^\\\\/:*?\"<>|]+$/\' aria-invalid=\"true\" ng-disabled=\"true\"><div \nng-messages=\"licenseForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name field is required</span></div>\n<div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div \nng-message=\"pattern\"><span translate=\"APP_VALIDATION_SPECIAL_CHARS\">This field can not contain special characters\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"layout-gt-sm-row layout-column\"><md-list flex><md-subheader class=\"md-no-sticky\" \ntranslate=\"LICENSE_PERMISSIONS\">Permissions</md-subheader><permission-list-template permission-name=\"\'Conference\'\" \npermission-sub-item-name=\"\'Disable Conference Origination\'\" permission-sub-item=\"vm.license.conference.originate\" \npermission-visible=\"vm.license.conference.terminate\" permission-item=\"vm.license.conference.terminate\" \nshow-sub-item=\"true\" is-edit=\"true\"></permission-list-template><permission-list-template permission-name=\"\'Radio\'\" \npermission-visible=\"vm.license.radio\" permission-item=\"vm.license.radio\" show-sub-item=\"false\" is-edit=\"true\">\n</permission-list-template><permission-list-template permission-name=\"\'Ad Hoc\'\" \npermission-sub-item-name=\"\'Disable Ad Hoc Origination\'\" permission-sub-item=\"vm.license.adHoc.originate\" \npermission-visible=\"vm.license.adHoc.terminate\" permission-item=\"vm.license.adHoc.terminate\" show-sub-item=\"true\" \nis-edit=\"true\"></permission-list-template><permission-list-template permission-name=\"\'Private\'\" \npermission-sub-item-name=\"\'Disable Private Origination\'\" permission-sub-item=\"vm.license.private.originate\" \npermission-visible=\"vm.license.private.terminate\" permission-item=\"vm.license.private.terminate\" show-sub-item=\"true\" \nis-edit=\"true\"></permission-list-template><permission-list-template permission-name=\"\'Smart Off-Net\'\" \npermission-visible=\"vm.license.startOffNet\" permission-item=\"vm.license.startOffNet\" show-sub-item=\"false\" \nis-edit=\"true\"></permission-list-template><permission-list-template permission-name=\"\'IM\'\" \npermission-sub-item-name=\"\'Disable IM Origination\'\" permission-sub-item=\"vm.license.im.originate\" \npermission-visible=\"vm.license.im.terminate\" permission-item=\"vm.license.im.terminate\" show-sub-item=\"true\" \nis-edit=\"true\"></permission-list-template><permission-list-template permission-name=\"\'GPS\'\" \npermission-visible=\"vm.license.gps\" permission-item=\"vm.license.gps\" show-sub-item=\"false\" is-edit=\"true\">\n</permission-list-template><permission-list-template permission-name=\"\'Emergency\'\" permission-visible=\"vm.license.sos\" \npermission-item=\"vm.license.sos\" show-sub-item=\"false\" is-edit=\"true\"></permission-list-template>\n<permission-list-template permission-name=\"\'Dispatcher\'\" permission-visible=\"vm.license.dispatcher\" \npermission-item=\"vm.license.dispatcher\" show-sub-item=\"false\" is-edit=\"true\"></permission-list-template>\n<permission-list-template permission-name=\"\'Web Dispatcher\'\" permission-visible=\"vm.license.webDispatcher\" \npermission-item=\"vm.license.webDispatcher\" show-sub-item=\"false\" is-edit=\"true\"></permission-list-template>\n<permission-list-template permission-name=\"\'Priority Call\'\" permission-visible=\"vm.license.priorityCall\" \npermission-item=\"vm.license.priorityCall\" show-sub-item=\"false\" is-edit=\"true\"></permission-list-template></md-list>\n</div></form></md-dialog-content></md-dialog><div class=\"row\" flex ng-if=\"vm.error\"><div class=\"error-msg\" \nng-model=\"vm.error\">{{vm.error}}</div></div>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/affiliated-contacts/affiliated.contacts.main.dialog.html","<md-dialog aria-label=\"Subscriber\" style=\"width: 50%\"><md-toolbar><div class=\"md-toolbar-tools\"><h1 \ntranslate=\"PERSONAL_CONTACTS\">Personal contacts</h1><h2>-</h2><h3>{{vm.subscriber.name}}</h3><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon aria-label=\"Close dialog\">X</md-icon></md-button>\n</div></md-toolbar><md-dialog-content class=\"with-tabs\"><md-tabs md-dynamic-height md-border-bottom \nmd-selected=\"vm.selectedTabIndex\"><md-tab md-on-select=\"vm.onTabChanges(0)\"><md-tab-label><span \ntranslate=\"PERSONAL_CONTACTS_TEMPLATES\">Contact Template</span></md-tab-label><md-tab-body><md-content \nclass=\"padding-tab\" \nng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/affiliated-contacts/tabs/affiliated.templates.dialog.html\'\">\n</md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.onTabChanges(1)\"><md-tab-label><span \ntranslate=\"PERSONAL_CONTACTS\">Personal contacts</span></md-tab-label><md-tab-body><md-content class=\"padding-tab\" \nng-include=\"\'app/main/restricted/reseller/organization-manager/details/tabs/affiliated-contacts/tabs/affiliated.contacts.dialog.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" \nng-disabled=\"vm.loading\"><span flex></span><md-button ng-click=\"vm.cancel()\" translate=\"APP_CANCEL\">Cancel</md-button>\n<md-button translate=\"APP_SAVE\" ng-disabled=\"vm.loading\" ng-click=\"vm.ok()\">Save</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/restricted/organization/recording/tabs/admin-record/dialog/tabs/admin.dialog.html","<md-content class=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><form name=\"vm.adminForm\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required ng-valid-pattern\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"ADMIN_RECORD_EMAIL_ID\">Email address</label><input \ntype=\"email\" name=\"email\" ng-model=\"vm.user.username\" translate aria-invalid=\"true\" md-maxlength=\"50\" \nng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{1,}$/\" required><div ng-messages=\"vm.adminForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"APP_VALIDATION_REQUIRED\">This field is required</span>\n</div><div ng-message=\"maxlength\"><span translate=\"APP_VALIDATION_MAX_LENGTH\">This field is too long</span></div><div \nng-message=\"pattern\"><span translate=\"APP_VALIDATION_EMAIL\">Email must be a valid e-mail address</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.user.player_client_version\">\n<md-input-container flex><label translate=\"PLAYER_CLIENT_VERSION\">Player Client Version:</label><input type=\"text\" \nng-disabled=\"true\" name=\"player-client-version\" ng-model=\"vm.user.player_client_version\" translate aria-invalid=\"true\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox \nng-if=\"vm.user.admin_id  && !vm.user.changePassword\" aria-label=\"permission-item\" class=\"md-secondary\" \nng-model=\"vm.user.changePassword\" ng-change=\"vm.showPassword()\" translate=\"APP_CHANGE_PASSWORD\">Change Password\n</md-checkbox></div><password-fields ng-if=\"((vm.user.admin_id && vm.user.changePassword) || !vm.user.admin_id)\" \npassword=\"vm.user.password\" re-password=\"vm.user.rePassword\" form-name=\"vm.adminForm\" \nstrong-pass=\"vm.strongPassForReviewers\" ? 1 : 0></password-fields></form><div layout=\"row\" style=\"float: right\">\n<md-button translate=\"APP_CANCEL\" ng-click=\"vm.close()\" ng-disabled=\"!vm.flagSave\">Cancel</md-button><md-button \ntranslate=\"APP_SAVE\" \nng-disabled=\"( !vm.allowCreate && !vm.user.admin_id) || (!vm.allowModify && vm.user.admin_id) || !vm.flagSave || vm.adminForm.$invalid\" \nng-click=\"vm.ok()\">Save</md-button></div></md-content>");
$templateCache.put("app/main/restricted/organization/recording/tabs/admin-record/dialog/tabs/admin.record.activity.html","<div class=\"content-card\"><md-content><div style=\"float: right\"><md-button class=\"md-raised\" translate=\"APP_REFRESH\" \nng-click=\"vm.refreshActivities()\" aria-label=\"ok\">Refresh</md-button></div><table \nclass=\"dataTable row-border stripe hover\"><thead><tr><th class=\"secondary-text\" ng-click=\"vm.sort(\'command\')\"><div \nclass=\"table-header\"><span class=\"column-title\" ng-class=\"vm.getSortingClass(\'command\')\" \ntranslate=\"ADMIN_RECORD_ACTIVITY_COMMAND\">Command</span></div></th><th class=\"secondary-text\" \nng-click=\"vm.sort(\'session_name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'session_name\')\" translate=\"ADMIN_RECORD_ACTIVITY_SESSION_NAME\">Session name</span></div>\n</th><th class=\"secondary-text\" ng-click=\"vm.sort(\'user_name\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'user_name\')\" translate=\"ADMIN_RECORD_ACTIVITY_USER_NAME\">User name</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'time\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'time\')\" translate=\"ADMIN_RECORD_ACTIVITY_TIME\">Time</span></div></th><th \nclass=\"secondary-text\" ng-click=\"vm.sort(\'ip\')\"><div class=\"table-header\"><span class=\"column-title\" \nng-class=\"vm.getSortingClass(\'ip\')\" translate=\"ADMIN_RECORD_ACTIVITY_IP\">IP</span></div></th></tr></thead><tbody><tr \ndir-paginate=\"activity in vm.user.activities |itemsPerPage:vm.recordsCount track by $index\" ng-class-odd=\"\'odd\'\" \npagination-id=\"vm.adminActivitiesPaginationClass\"><td width=\"30%\" class=\"table-name-label\">{{activity.command}}</td><td\n title=\"{{vm.showId ? activity.session_id : \'\'}}\" width=\"30%\" class=\"table-name-label\">{{activity.session_name}}</td>\n<td title=\"{{vm.showId ? activity.user_id : \'\'}}\" width=\"30%\" class=\"table-name-label\">{{activity.user_name}}</td><td \nwidth=\"30%\" class=\"table-name-label\">{{activity.time}}</td><td width=\"30%\" class=\"table-name-label\">{{activity.ip}}\n</td></tr></tbody></table><md-content ng-if=\"!vm.user.activities.length\" \nclass=\"content ms-scroll _md md-default-theme ps-container ps-theme-default\"><div class=\"content-card\"><p class=\"pd-2\" \ntranslate=\"APP_NO_RECORDS\" translate-default=\"No data available\"></p></div></md-content><div layout=\"row\" flex \nclass=\"pd-2\"><div layout=\"row\" flex layout-align=\"flex-start center\"><md-input-container><label \ntranslate=\"APP_RECORDS_COUNT\">Records:</label><md-select ng-model=\"vm.recordsCount\" ng-change=\"vm.setRecordsCount()\" \nplaceholder=\"Record to show\" pagination-id=\"vm.adminActivitiesPaginationClass\"><md-option ng-value=\"25\">25</md-option>\n<md-option ng-value=\"50\">50</md-option><md-option ng-value=\"100\">100</md-option></md-select></md-input-container></div>\n<div layout=\"row\" layout-align=\"end center\"><dir-pagination-controls max-size=\"1\" direction-links=\"true\" \nboundary-links=\"true\" pagination-id=\"vm.adminActivitiesPaginationClass\"></dir-pagination-controls></div></div>\n</md-content></div>");
$templateCache.put("app/main/restricted/platform/licenses/tabs/templates/details/permission-component/permission.component.html","<md-list-item><p>{{vm.permissionName}}</p><md-checkbox aria-label=\"permission-item\" class=\"md-secondary\" \nng-model=\"vm.permissionItem\" ng-change=\"vm.changeParentItem()\" ng-disabled=\"vm.isEdit\"></md-checkbox></md-list-item>\n<md-list-item class=\"sub-permission\" ng-if=\"vm.isSubItem()\" ng-show=\"vm.showSubItem\"><p>{{vm.permissionSubItemName}}\n</p><md-select ng-if=\"vm.multiSession\" ng-disabled=\"!vm.permissionItem || vm.isEdit\" class=\"md-secondary\" \nng-model=\"vm.permissionSubItem\"><md-option ng-value=\"1\">4</md-option><md-option ng-value=\"2\">1</md-option><md-option \nng-value=\"3\">8</md-option><md-option ng-value=\"4\">16</md-option></md-select><md-checkbox ng-if=\"!vm.multiSession\" \naria-label=\"permission-sub-item\" ng-disabled=\"!vm.permissionItem || vm.isEdit\" class=\"md-secondary\" \nng-model=\"vm.permissionSubItem\" ng-true-value=\"false\" ng-false-value=\"true\"></md-checkbox></md-list-item>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/affiliated-contacts/tabs/affiliated.contacts.dialog.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.loading\"><md-progress-circular \nng-disabled=\"!vm.loading\" class=\"md-accent\" md-diameter=\"40\"></md-progress-circular></div><md-content \nclass=\"content group-details\"><choose-list-select pagination-id=\"vm.affiliatedContactsPagination\" \nselected-elements=\"vm.selectedContacts\" not-selected-elements=\"vm.unselectedContacts\" \ndispatcher=\"vm.subscriber.dispathcer\" error=\"false\" drop-down-elements=\"vm.orgsFriends\" \nselected-drop-down=\"vm.selectedDropDown\"></choose-list-select></md-content>");
$templateCache.put("app/main/restricted/reseller/organization-manager/details/tabs/affiliated-contacts/tabs/affiliated.templates.dialog.html","<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.loading\"><md-progress-circular \nng-disabled=\"!vm.loading\" class=\"md-accent\" md-diameter=\"40\"></md-progress-circular></div><md-content \nclass=\"content group-details\"><choose-list-bind selected-elements=\"vm.selectedTemplates\" \nnot-selected-elements=\"vm.unselectedTemplates\" selected-bind-elements=\"vm.selectedContacts\" \nnot-selected-bind-elements=\"vm.unselectedContacts\" organization-subscriber-list=\"vm.allSubscribers\" \npagination-id=\"vm.affiliatedTemplatesPagination\" current-id=\"vm.subscriber._id\" dispatcher=\"vm.subscriber.dispathcer\">\n</choose-list-bind></md-content>");}]);